/*! jQuery v3.3.1 | (c) JS Foundation and other contributors | jquery.org/license */
!function(e,t){"use strict";"object"==typeof module&&"object"==typeof module.exports?module.exports=e.document?t(e,!0):function(e){if(!e.document)throw new Error("jQuery requires a window with a document");return t(e)}:t(e)}("undefined"!=typeof window?window:this,function(e,t){"use strict";var n=[],r=e.document,i=Object.getPrototypeOf,o=n.slice,a=n.concat,s=n.push,u=n.indexOf,l={},c=l.toString,f=l.hasOwnProperty,p=f.toString,d=p.call(Object),h={},g=function e(t){return"function"==typeof t&&"number"!=typeof t.nodeType},y=function e(t){return null!=t&&t===t.window},v={type:!0,src:!0,noModule:!0};function m(e,t,n){var i,o=(t=t||r).createElement("script");if(o.text=e,n)for(i in v)n[i]&&(o[i]=n[i]);t.head.appendChild(o).parentNode.removeChild(o)}function x(e){return null==e?e+"":"object"==typeof e||"function"==typeof e?l[c.call(e)]||"object":typeof e}var b="3.3.1",w=function(e,t){return new w.fn.init(e,t)},T=/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;w.fn=w.prototype={jquery:"3.3.1",constructor:w,length:0,toArray:function(){return o.call(this)},get:function(e){return null==e?o.call(this):e<0?this[e+this.length]:this[e]},pushStack:function(e){var t=w.merge(this.constructor(),e);return t.prevObject=this,t},each:function(e){return w.each(this,e)},map:function(e){return this.pushStack(w.map(this,function(t,n){return e.call(t,n,t)}))},slice:function(){return this.pushStack(o.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},eq:function(e){var t=this.length,n=+e+(e<0?t:0);return this.pushStack(n>=0&&n<t?[this[n]]:[])},end:function(){return this.prevObject||this.constructor()},push:s,sort:n.sort,splice:n.splice},w.extend=w.fn.extend=function(){var e,t,n,r,i,o,a=arguments[0]||{},s=1,u=arguments.length,l=!1;for("boolean"==typeof a&&(l=a,a=arguments[s]||{},s++),"object"==typeof a||g(a)||(a={}),s===u&&(a=this,s--);s<u;s++)if(null!=(e=arguments[s]))for(t in e)n=a[t],a!==(r=e[t])&&(l&&r&&(w.isPlainObject(r)||(i=Array.isArray(r)))?(i?(i=!1,o=n&&Array.isArray(n)?n:[]):o=n&&w.isPlainObject(n)?n:{},a[t]=w.extend(l,o,r)):void 0!==r&&(a[t]=r));return a},w.extend({expando:"jQuery"+("3.3.1"+Math.random()).replace(/\D/g,""),isReady:!0,error:function(e){throw new Error(e)},noop:function(){},isPlainObject:function(e){var t,n;return!(!e||"[object Object]"!==c.call(e))&&(!(t=i(e))||"function"==typeof(n=f.call(t,"constructor")&&t.constructor)&&p.call(n)===d)},isEmptyObject:function(e){var t;for(t in e)return!1;return!0},globalEval:function(e){m(e)},each:function(e,t){var n,r=0;if(C(e)){for(n=e.length;r<n;r++)if(!1===t.call(e[r],r,e[r]))break}else for(r in e)if(!1===t.call(e[r],r,e[r]))break;return e},trim:function(e){return null==e?"":(e+"").replace(T,"")},makeArray:function(e,t){var n=t||[];return null!=e&&(C(Object(e))?w.merge(n,"string"==typeof e?[e]:e):s.call(n,e)),n},inArray:function(e,t,n){return null==t?-1:u.call(t,e,n)},merge:function(e,t){for(var n=+t.length,r=0,i=e.length;r<n;r++)e[i++]=t[r];return e.length=i,e},grep:function(e,t,n){for(var r,i=[],o=0,a=e.length,s=!n;o<a;o++)(r=!t(e[o],o))!==s&&i.push(e[o]);return i},map:function(e,t,n){var r,i,o=0,s=[];if(C(e))for(r=e.length;o<r;o++)null!=(i=t(e[o],o,n))&&s.push(i);else for(o in e)null!=(i=t(e[o],o,n))&&s.push(i);return a.apply([],s)},guid:1,support:h}),"function"==typeof Symbol&&(w.fn[Symbol.iterator]=n[Symbol.iterator]),w.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),function(e,t){l["[object "+t+"]"]=t.toLowerCase()});function C(e){var t=!!e&&"length"in e&&e.length,n=x(e);return!g(e)&&!y(e)&&("array"===n||0===t||"number"==typeof t&&t>0&&t-1 in e)}var E=function(e){var t,n,r,i,o,a,s,u,l,c,f,p,d,h,g,y,v,m,x,b="sizzle"+1*new Date,w=e.document,T=0,C=0,E=ae(),k=ae(),S=ae(),D=function(e,t){return e===t&&(f=!0),0},N={}.hasOwnProperty,A=[],j=A.pop,q=A.push,L=A.push,H=A.slice,O=function(e,t){for(var n=0,r=e.length;n<r;n++)if(e[n]===t)return n;return-1},P="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",M="[\\x20\\t\\r\\n\\f]",R="(?:\\\\.|[\\w-]|[^\0-\\xa0])+",I="\\["+M+"*("+R+")(?:"+M+"*([*^$|!~]?=)"+M+"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|("+R+"))|)"+M+"*\\]",W=":("+R+")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|"+I+")*)|.*)\\)|)",$=new RegExp(M+"+","g"),B=new RegExp("^"+M+"+|((?:^|[^\\\\])(?:\\\\.)*)"+M+"+$","g"),F=new RegExp("^"+M+"*,"+M+"*"),_=new RegExp("^"+M+"*([>+~]|"+M+")"+M+"*"),z=new RegExp("="+M+"*([^\\]'\"]*?)"+M+"*\\]","g"),X=new RegExp(W),U=new RegExp("^"+R+"$"),V={ID:new RegExp("^#("+R+")"),CLASS:new RegExp("^\\.("+R+")"),TAG:new RegExp("^("+R+"|[*])"),ATTR:new RegExp("^"+I),PSEUDO:new RegExp("^"+W),CHILD:new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+M+"*(even|odd|(([+-]|)(\\d*)n|)"+M+"*(?:([+-]|)"+M+"*(\\d+)|))"+M+"*\\)|)","i"),bool:new RegExp("^(?:"+P+")$","i"),needsContext:new RegExp("^"+M+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+M+"*((?:-\\d)?\\d*)"+M+"*\\)|)(?=[^-]|$)","i")},G=/^(?:input|select|textarea|button)$/i,Y=/^h\d$/i,Q=/^[^{]+\{\s*\[native \w/,J=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,K=/[+~]/,Z=new RegExp("\\\\([\\da-f]{1,6}"+M+"?|("+M+")|.)","ig"),ee=function(e,t,n){var r="0x"+t-65536;return r!==r||n?t:r<0?String.fromCharCode(r+65536):String.fromCharCode(r>>10|55296,1023&r|56320)},te=/([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,ne=function(e,t){return t?"\0"===e?"\ufffd":e.slice(0,-1)+"\\"+e.charCodeAt(e.length-1).toString(16)+" ":"\\"+e},re=function(){p()},ie=me(function(e){return!0===e.disabled&&("form"in e||"label"in e)},{dir:"parentNode",next:"legend"});try{L.apply(A=H.call(w.childNodes),w.childNodes),A[w.childNodes.length].nodeType}catch(e){L={apply:A.length?function(e,t){q.apply(e,H.call(t))}:function(e,t){var n=e.length,r=0;while(e[n++]=t[r++]);e.length=n-1}}}function oe(e,t,r,i){var o,s,l,c,f,h,v,m=t&&t.ownerDocument,T=t?t.nodeType:9;if(r=r||[],"string"!=typeof e||!e||1!==T&&9!==T&&11!==T)return r;if(!i&&((t?t.ownerDocument||t:w)!==d&&p(t),t=t||d,g)){if(11!==T&&(f=J.exec(e)))if(o=f[1]){if(9===T){if(!(l=t.getElementById(o)))return r;if(l.id===o)return r.push(l),r}else if(m&&(l=m.getElementById(o))&&x(t,l)&&l.id===o)return r.push(l),r}else{if(f[2])return L.apply(r,t.getElementsByTagName(e)),r;if((o=f[3])&&n.getElementsByClassName&&t.getElementsByClassName)return L.apply(r,t.getElementsByClassName(o)),r}if(n.qsa&&!S[e+" "]&&(!y||!y.test(e))){if(1!==T)m=t,v=e;else if("object"!==t.nodeName.toLowerCase()){(c=t.getAttribute("id"))?c=c.replace(te,ne):t.setAttribute("id",c=b),s=(h=a(e)).length;while(s--)h[s]="#"+c+" "+ve(h[s]);v=h.join(","),m=K.test(e)&&ge(t.parentNode)||t}if(v)try{return L.apply(r,m.querySelectorAll(v)),r}catch(e){}finally{c===b&&t.removeAttribute("id")}}}return u(e.replace(B,"$1"),t,r,i)}function ae(){var e=[];function t(n,i){return e.push(n+" ")>r.cacheLength&&delete t[e.shift()],t[n+" "]=i}return t}function se(e){return e[b]=!0,e}function ue(e){var t=d.createElement("fieldset");try{return!!e(t)}catch(e){return!1}finally{t.parentNode&&t.parentNode.removeChild(t),t=null}}function le(e,t){var n=e.split("|"),i=n.length;while(i--)r.attrHandle[n[i]]=t}function ce(e,t){var n=t&&e,r=n&&1===e.nodeType&&1===t.nodeType&&e.sourceIndex-t.sourceIndex;if(r)return r;if(n)while(n=n.nextSibling)if(n===t)return-1;return e?1:-1}function fe(e){return function(t){return"input"===t.nodeName.toLowerCase()&&t.type===e}}function pe(e){return function(t){var n=t.nodeName.toLowerCase();return("input"===n||"button"===n)&&t.type===e}}function de(e){return function(t){return"form"in t?t.parentNode&&!1===t.disabled?"label"in t?"label"in t.parentNode?t.parentNode.disabled===e:t.disabled===e:t.isDisabled===e||t.isDisabled!==!e&&ie(t)===e:t.disabled===e:"label"in t&&t.disabled===e}}function he(e){return se(function(t){return t=+t,se(function(n,r){var i,o=e([],n.length,t),a=o.length;while(a--)n[i=o[a]]&&(n[i]=!(r[i]=n[i]))})})}function ge(e){return e&&"undefined"!=typeof e.getElementsByTagName&&e}n=oe.support={},o=oe.isXML=function(e){var t=e&&(e.ownerDocument||e).documentElement;return!!t&&"HTML"!==t.nodeName},p=oe.setDocument=function(e){var t,i,a=e?e.ownerDocument||e:w;return a!==d&&9===a.nodeType&&a.documentElement?(d=a,h=d.documentElement,g=!o(d),w!==d&&(i=d.defaultView)&&i.top!==i&&(i.addEventListener?i.addEventListener("unload",re,!1):i.attachEvent&&i.attachEvent("onunload",re)),n.attributes=ue(function(e){return e.className="i",!e.getAttribute("className")}),n.getElementsByTagName=ue(function(e){return e.appendChild(d.createComment("")),!e.getElementsByTagName("*").length}),n.getElementsByClassName=Q.test(d.getElementsByClassName),n.getById=ue(function(e){return h.appendChild(e).id=b,!d.getElementsByName||!d.getElementsByName(b).length}),n.getById?(r.filter.ID=function(e){var t=e.replace(Z,ee);return function(e){return e.getAttribute("id")===t}},r.find.ID=function(e,t){if("undefined"!=typeof t.getElementById&&g){var n=t.getElementById(e);return n?[n]:[]}}):(r.filter.ID=function(e){var t=e.replace(Z,ee);return function(e){var n="undefined"!=typeof e.getAttributeNode&&e.getAttributeNode("id");return n&&n.value===t}},r.find.ID=function(e,t){if("undefined"!=typeof t.getElementById&&g){var n,r,i,o=t.getElementById(e);if(o){if((n=o.getAttributeNode("id"))&&n.value===e)return[o];i=t.getElementsByName(e),r=0;while(o=i[r++])if((n=o.getAttributeNode("id"))&&n.value===e)return[o]}return[]}}),r.find.TAG=n.getElementsByTagName?function(e,t){return"undefined"!=typeof t.getElementsByTagName?t.getElementsByTagName(e):n.qsa?t.querySelectorAll(e):void 0}:function(e,t){var n,r=[],i=0,o=t.getElementsByTagName(e);if("*"===e){while(n=o[i++])1===n.nodeType&&r.push(n);return r}return o},r.find.CLASS=n.getElementsByClassName&&function(e,t){if("undefined"!=typeof t.getElementsByClassName&&g)return t.getElementsByClassName(e)},v=[],y=[],(n.qsa=Q.test(d.querySelectorAll))&&(ue(function(e){h.appendChild(e).innerHTML="<a id='"+b+"'></a><select id='"+b+"-\r\\' msallowcapture=''><option selected=''></option></select>",e.querySelectorAll("[msallowcapture^='']").length&&y.push("[*^$]="+M+"*(?:''|\"\")"),e.querySelectorAll("[selected]").length||y.push("\\["+M+"*(?:value|"+P+")"),e.querySelectorAll("[id~="+b+"-]").length||y.push("~="),e.querySelectorAll(":checked").length||y.push(":checked"),e.querySelectorAll("a#"+b+"+*").length||y.push(".#.+[+~]")}),ue(function(e){e.innerHTML="<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";var t=d.createElement("input");t.setAttribute("type","hidden"),e.appendChild(t).setAttribute("name","D"),e.querySelectorAll("[name=d]").length&&y.push("name"+M+"*[*^$|!~]?="),2!==e.querySelectorAll(":enabled").length&&y.push(":enabled",":disabled"),h.appendChild(e).disabled=!0,2!==e.querySelectorAll(":disabled").length&&y.push(":enabled",":disabled"),e.querySelectorAll("*,:x"),y.push(",.*:")})),(n.matchesSelector=Q.test(m=h.matches||h.webkitMatchesSelector||h.mozMatchesSelector||h.oMatchesSelector||h.msMatchesSelector))&&ue(function(e){n.disconnectedMatch=m.call(e,"*"),m.call(e,"[s!='']:x"),v.push("!=",W)}),y=y.length&&new RegExp(y.join("|")),v=v.length&&new RegExp(v.join("|")),t=Q.test(h.compareDocumentPosition),x=t||Q.test(h.contains)?function(e,t){var n=9===e.nodeType?e.documentElement:e,r=t&&t.parentNode;return e===r||!(!r||1!==r.nodeType||!(n.contains?n.contains(r):e.compareDocumentPosition&&16&e.compareDocumentPosition(r)))}:function(e,t){if(t)while(t=t.parentNode)if(t===e)return!0;return!1},D=t?function(e,t){if(e===t)return f=!0,0;var r=!e.compareDocumentPosition-!t.compareDocumentPosition;return r||(1&(r=(e.ownerDocument||e)===(t.ownerDocument||t)?e.compareDocumentPosition(t):1)||!n.sortDetached&&t.compareDocumentPosition(e)===r?e===d||e.ownerDocument===w&&x(w,e)?-1:t===d||t.ownerDocument===w&&x(w,t)?1:c?O(c,e)-O(c,t):0:4&r?-1:1)}:function(e,t){if(e===t)return f=!0,0;var n,r=0,i=e.parentNode,o=t.parentNode,a=[e],s=[t];if(!i||!o)return e===d?-1:t===d?1:i?-1:o?1:c?O(c,e)-O(c,t):0;if(i===o)return ce(e,t);n=e;while(n=n.parentNode)a.unshift(n);n=t;while(n=n.parentNode)s.unshift(n);while(a[r]===s[r])r++;return r?ce(a[r],s[r]):a[r]===w?-1:s[r]===w?1:0},d):d},oe.matches=function(e,t){return oe(e,null,null,t)},oe.matchesSelector=function(e,t){if((e.ownerDocument||e)!==d&&p(e),t=t.replace(z,"='$1']"),n.matchesSelector&&g&&!S[t+" "]&&(!v||!v.test(t))&&(!y||!y.test(t)))try{var r=m.call(e,t);if(r||n.disconnectedMatch||e.document&&11!==e.document.nodeType)return r}catch(e){}return oe(t,d,null,[e]).length>0},oe.contains=function(e,t){return(e.ownerDocument||e)!==d&&p(e),x(e,t)},oe.attr=function(e,t){(e.ownerDocument||e)!==d&&p(e);var i=r.attrHandle[t.toLowerCase()],o=i&&N.call(r.attrHandle,t.toLowerCase())?i(e,t,!g):void 0;return void 0!==o?o:n.attributes||!g?e.getAttribute(t):(o=e.getAttributeNode(t))&&o.specified?o.value:null},oe.escape=function(e){return(e+"").replace(te,ne)},oe.error=function(e){throw new Error("Syntax error, unrecognized expression: "+e)},oe.uniqueSort=function(e){var t,r=[],i=0,o=0;if(f=!n.detectDuplicates,c=!n.sortStable&&e.slice(0),e.sort(D),f){while(t=e[o++])t===e[o]&&(i=r.push(o));while(i--)e.splice(r[i],1)}return c=null,e},i=oe.getText=function(e){var t,n="",r=0,o=e.nodeType;if(o){if(1===o||9===o||11===o){if("string"==typeof e.textContent)return e.textContent;for(e=e.firstChild;e;e=e.nextSibling)n+=i(e)}else if(3===o||4===o)return e.nodeValue}else while(t=e[r++])n+=i(t);return n},(r=oe.selectors={cacheLength:50,createPseudo:se,match:V,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(e){return e[1]=e[1].replace(Z,ee),e[3]=(e[3]||e[4]||e[5]||"").replace(Z,ee),"~="===e[2]&&(e[3]=" "+e[3]+" "),e.slice(0,4)},CHILD:function(e){return e[1]=e[1].toLowerCase(),"nth"===e[1].slice(0,3)?(e[3]||oe.error(e[0]),e[4]=+(e[4]?e[5]+(e[6]||1):2*("even"===e[3]||"odd"===e[3])),e[5]=+(e[7]+e[8]||"odd"===e[3])):e[3]&&oe.error(e[0]),e},PSEUDO:function(e){var t,n=!e[6]&&e[2];return V.CHILD.test(e[0])?null:(e[3]?e[2]=e[4]||e[5]||"":n&&X.test(n)&&(t=a(n,!0))&&(t=n.indexOf(")",n.length-t)-n.length)&&(e[0]=e[0].slice(0,t),e[2]=n.slice(0,t)),e.slice(0,3))}},filter:{TAG:function(e){var t=e.replace(Z,ee).toLowerCase();return"*"===e?function(){return!0}:function(e){return e.nodeName&&e.nodeName.toLowerCase()===t}},CLASS:function(e){var t=E[e+" "];return t||(t=new RegExp("(^|"+M+")"+e+"("+M+"|$)"))&&E(e,function(e){return t.test("string"==typeof e.className&&e.className||"undefined"!=typeof e.getAttribute&&e.getAttribute("class")||"")})},ATTR:function(e,t,n){return function(r){var i=oe.attr(r,e);return null==i?"!="===t:!t||(i+="","="===t?i===n:"!="===t?i!==n:"^="===t?n&&0===i.indexOf(n):"*="===t?n&&i.indexOf(n)>-1:"$="===t?n&&i.slice(-n.length)===n:"~="===t?(" "+i.replace($," ")+" ").indexOf(n)>-1:"|="===t&&(i===n||i.slice(0,n.length+1)===n+"-"))}},CHILD:function(e,t,n,r,i){var o="nth"!==e.slice(0,3),a="last"!==e.slice(-4),s="of-type"===t;return 1===r&&0===i?function(e){return!!e.parentNode}:function(t,n,u){var l,c,f,p,d,h,g=o!==a?"nextSibling":"previousSibling",y=t.parentNode,v=s&&t.nodeName.toLowerCase(),m=!u&&!s,x=!1;if(y){if(o){while(g){p=t;while(p=p[g])if(s?p.nodeName.toLowerCase()===v:1===p.nodeType)return!1;h=g="only"===e&&!h&&"nextSibling"}return!0}if(h=[a?y.firstChild:y.lastChild],a&&m){x=(d=(l=(c=(f=(p=y)[b]||(p[b]={}))[p.uniqueID]||(f[p.uniqueID]={}))[e]||[])[0]===T&&l[1])&&l[2],p=d&&y.childNodes[d];while(p=++d&&p&&p[g]||(x=d=0)||h.pop())if(1===p.nodeType&&++x&&p===t){c[e]=[T,d,x];break}}else if(m&&(x=d=(l=(c=(f=(p=t)[b]||(p[b]={}))[p.uniqueID]||(f[p.uniqueID]={}))[e]||[])[0]===T&&l[1]),!1===x)while(p=++d&&p&&p[g]||(x=d=0)||h.pop())if((s?p.nodeName.toLowerCase()===v:1===p.nodeType)&&++x&&(m&&((c=(f=p[b]||(p[b]={}))[p.uniqueID]||(f[p.uniqueID]={}))[e]=[T,x]),p===t))break;return(x-=i)===r||x%r==0&&x/r>=0}}},PSEUDO:function(e,t){var n,i=r.pseudos[e]||r.setFilters[e.toLowerCase()]||oe.error("unsupported pseudo: "+e);return i[b]?i(t):i.length>1?(n=[e,e,"",t],r.setFilters.hasOwnProperty(e.toLowerCase())?se(function(e,n){var r,o=i(e,t),a=o.length;while(a--)e[r=O(e,o[a])]=!(n[r]=o[a])}):function(e){return i(e,0,n)}):i}},pseudos:{not:se(function(e){var t=[],n=[],r=s(e.replace(B,"$1"));return r[b]?se(function(e,t,n,i){var o,a=r(e,null,i,[]),s=e.length;while(s--)(o=a[s])&&(e[s]=!(t[s]=o))}):function(e,i,o){return t[0]=e,r(t,null,o,n),t[0]=null,!n.pop()}}),has:se(function(e){return function(t){return oe(e,t).length>0}}),contains:se(function(e){return e=e.replace(Z,ee),function(t){return(t.textContent||t.innerText||i(t)).indexOf(e)>-1}}),lang:se(function(e){return U.test(e||"")||oe.error("unsupported lang: "+e),e=e.replace(Z,ee).toLowerCase(),function(t){var n;do{if(n=g?t.lang:t.getAttribute("xml:lang")||t.getAttribute("lang"))return(n=n.toLowerCase())===e||0===n.indexOf(e+"-")}while((t=t.parentNode)&&1===t.nodeType);return!1}}),target:function(t){var n=e.location&&e.location.hash;return n&&n.slice(1)===t.id},root:function(e){return e===h},focus:function(e){return e===d.activeElement&&(!d.hasFocus||d.hasFocus())&&!!(e.type||e.href||~e.tabIndex)},enabled:de(!1),disabled:de(!0),checked:function(e){var t=e.nodeName.toLowerCase();return"input"===t&&!!e.checked||"option"===t&&!!e.selected},selected:function(e){return e.parentNode&&e.parentNode.selectedIndex,!0===e.selected},empty:function(e){for(e=e.firstChild;e;e=e.nextSibling)if(e.nodeType<6)return!1;return!0},parent:function(e){return!r.pseudos.empty(e)},header:function(e){return Y.test(e.nodeName)},input:function(e){return G.test(e.nodeName)},button:function(e){var t=e.nodeName.toLowerCase();return"input"===t&&"button"===e.type||"button"===t},text:function(e){var t;return"input"===e.nodeName.toLowerCase()&&"text"===e.type&&(null==(t=e.getAttribute("type"))||"text"===t.toLowerCase())},first:he(function(){return[0]}),last:he(function(e,t){return[t-1]}),eq:he(function(e,t,n){return[n<0?n+t:n]}),even:he(function(e,t){for(var n=0;n<t;n+=2)e.push(n);return e}),odd:he(function(e,t){for(var n=1;n<t;n+=2)e.push(n);return e}),lt:he(function(e,t,n){for(var r=n<0?n+t:n;--r>=0;)e.push(r);return e}),gt:he(function(e,t,n){for(var r=n<0?n+t:n;++r<t;)e.push(r);return e})}}).pseudos.nth=r.pseudos.eq;for(t in{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})r.pseudos[t]=fe(t);for(t in{submit:!0,reset:!0})r.pseudos[t]=pe(t);function ye(){}ye.prototype=r.filters=r.pseudos,r.setFilters=new ye,a=oe.tokenize=function(e,t){var n,i,o,a,s,u,l,c=k[e+" "];if(c)return t?0:c.slice(0);s=e,u=[],l=r.preFilter;while(s){n&&!(i=F.exec(s))||(i&&(s=s.slice(i[0].length)||s),u.push(o=[])),n=!1,(i=_.exec(s))&&(n=i.shift(),o.push({value:n,type:i[0].replace(B," ")}),s=s.slice(n.length));for(a in r.filter)!(i=V[a].exec(s))||l[a]&&!(i=l[a](i))||(n=i.shift(),o.push({value:n,type:a,matches:i}),s=s.slice(n.length));if(!n)break}return t?s.length:s?oe.error(e):k(e,u).slice(0)};function ve(e){for(var t=0,n=e.length,r="";t<n;t++)r+=e[t].value;return r}function me(e,t,n){var r=t.dir,i=t.next,o=i||r,a=n&&"parentNode"===o,s=C++;return t.first?function(t,n,i){while(t=t[r])if(1===t.nodeType||a)return e(t,n,i);return!1}:function(t,n,u){var l,c,f,p=[T,s];if(u){while(t=t[r])if((1===t.nodeType||a)&&e(t,n,u))return!0}else while(t=t[r])if(1===t.nodeType||a)if(f=t[b]||(t[b]={}),c=f[t.uniqueID]||(f[t.uniqueID]={}),i&&i===t.nodeName.toLowerCase())t=t[r]||t;else{if((l=c[o])&&l[0]===T&&l[1]===s)return p[2]=l[2];if(c[o]=p,p[2]=e(t,n,u))return!0}return!1}}function xe(e){return e.length>1?function(t,n,r){var i=e.length;while(i--)if(!e[i](t,n,r))return!1;return!0}:e[0]}function be(e,t,n){for(var r=0,i=t.length;r<i;r++)oe(e,t[r],n);return n}function we(e,t,n,r,i){for(var o,a=[],s=0,u=e.length,l=null!=t;s<u;s++)(o=e[s])&&(n&&!n(o,r,i)||(a.push(o),l&&t.push(s)));return a}function Te(e,t,n,r,i,o){return r&&!r[b]&&(r=Te(r)),i&&!i[b]&&(i=Te(i,o)),se(function(o,a,s,u){var l,c,f,p=[],d=[],h=a.length,g=o||be(t||"*",s.nodeType?[s]:s,[]),y=!e||!o&&t?g:we(g,p,e,s,u),v=n?i||(o?e:h||r)?[]:a:y;if(n&&n(y,v,s,u),r){l=we(v,d),r(l,[],s,u),c=l.length;while(c--)(f=l[c])&&(v[d[c]]=!(y[d[c]]=f))}if(o){if(i||e){if(i){l=[],c=v.length;while(c--)(f=v[c])&&l.push(y[c]=f);i(null,v=[],l,u)}c=v.length;while(c--)(f=v[c])&&(l=i?O(o,f):p[c])>-1&&(o[l]=!(a[l]=f))}}else v=we(v===a?v.splice(h,v.length):v),i?i(null,a,v,u):L.apply(a,v)})}function Ce(e){for(var t,n,i,o=e.length,a=r.relative[e[0].type],s=a||r.relative[" "],u=a?1:0,c=me(function(e){return e===t},s,!0),f=me(function(e){return O(t,e)>-1},s,!0),p=[function(e,n,r){var i=!a&&(r||n!==l)||((t=n).nodeType?c(e,n,r):f(e,n,r));return t=null,i}];u<o;u++)if(n=r.relative[e[u].type])p=[me(xe(p),n)];else{if((n=r.filter[e[u].type].apply(null,e[u].matches))[b]){for(i=++u;i<o;i++)if(r.relative[e[i].type])break;return Te(u>1&&xe(p),u>1&&ve(e.slice(0,u-1).concat({value:" "===e[u-2].type?"*":""})).replace(B,"$1"),n,u<i&&Ce(e.slice(u,i)),i<o&&Ce(e=e.slice(i)),i<o&&ve(e))}p.push(n)}return xe(p)}function Ee(e,t){var n=t.length>0,i=e.length>0,o=function(o,a,s,u,c){var f,h,y,v=0,m="0",x=o&&[],b=[],w=l,C=o||i&&r.find.TAG("*",c),E=T+=null==w?1:Math.random()||.1,k=C.length;for(c&&(l=a===d||a||c);m!==k&&null!=(f=C[m]);m++){if(i&&f){h=0,a||f.ownerDocument===d||(p(f),s=!g);while(y=e[h++])if(y(f,a||d,s)){u.push(f);break}c&&(T=E)}n&&((f=!y&&f)&&v--,o&&x.push(f))}if(v+=m,n&&m!==v){h=0;while(y=t[h++])y(x,b,a,s);if(o){if(v>0)while(m--)x[m]||b[m]||(b[m]=j.call(u));b=we(b)}L.apply(u,b),c&&!o&&b.length>0&&v+t.length>1&&oe.uniqueSort(u)}return c&&(T=E,l=w),x};return n?se(o):o}return s=oe.compile=function(e,t){var n,r=[],i=[],o=S[e+" "];if(!o){t||(t=a(e)),n=t.length;while(n--)(o=Ce(t[n]))[b]?r.push(o):i.push(o);(o=S(e,Ee(i,r))).selector=e}return o},u=oe.select=function(e,t,n,i){var o,u,l,c,f,p="function"==typeof e&&e,d=!i&&a(e=p.selector||e);if(n=n||[],1===d.length){if((u=d[0]=d[0].slice(0)).length>2&&"ID"===(l=u[0]).type&&9===t.nodeType&&g&&r.relative[u[1].type]){if(!(t=(r.find.ID(l.matches[0].replace(Z,ee),t)||[])[0]))return n;p&&(t=t.parentNode),e=e.slice(u.shift().value.length)}o=V.needsContext.test(e)?0:u.length;while(o--){if(l=u[o],r.relative[c=l.type])break;if((f=r.find[c])&&(i=f(l.matches[0].replace(Z,ee),K.test(u[0].type)&&ge(t.parentNode)||t))){if(u.splice(o,1),!(e=i.length&&ve(u)))return L.apply(n,i),n;break}}}return(p||s(e,d))(i,t,!g,n,!t||K.test(e)&&ge(t.parentNode)||t),n},n.sortStable=b.split("").sort(D).join("")===b,n.detectDuplicates=!!f,p(),n.sortDetached=ue(function(e){return 1&e.compareDocumentPosition(d.createElement("fieldset"))}),ue(function(e){return e.innerHTML="<a href='#'></a>","#"===e.firstChild.getAttribute("href")})||le("type|href|height|width",function(e,t,n){if(!n)return e.getAttribute(t,"type"===t.toLowerCase()?1:2)}),n.attributes&&ue(function(e){return e.innerHTML="<input/>",e.firstChild.setAttribute("value",""),""===e.firstChild.getAttribute("value")})||le("value",function(e,t,n){if(!n&&"input"===e.nodeName.toLowerCase())return e.defaultValue}),ue(function(e){return null==e.getAttribute("disabled")})||le(P,function(e,t,n){var r;if(!n)return!0===e[t]?t.toLowerCase():(r=e.getAttributeNode(t))&&r.specified?r.value:null}),oe}(e);w.find=E,w.expr=E.selectors,w.expr[":"]=w.expr.pseudos,w.uniqueSort=w.unique=E.uniqueSort,w.text=E.getText,w.isXMLDoc=E.isXML,w.contains=E.contains,w.escapeSelector=E.escape;var k=function(e,t,n){var r=[],i=void 0!==n;while((e=e[t])&&9!==e.nodeType)if(1===e.nodeType){if(i&&w(e).is(n))break;r.push(e)}return r},S=function(e,t){for(var n=[];e;e=e.nextSibling)1===e.nodeType&&e!==t&&n.push(e);return n},D=w.expr.match.needsContext;function N(e,t){return e.nodeName&&e.nodeName.toLowerCase()===t.toLowerCase()}var A=/^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;function j(e,t,n){return g(t)?w.grep(e,function(e,r){return!!t.call(e,r,e)!==n}):t.nodeType?w.grep(e,function(e){return e===t!==n}):"string"!=typeof t?w.grep(e,function(e){return u.call(t,e)>-1!==n}):w.filter(t,e,n)}w.filter=function(e,t,n){var r=t[0];return n&&(e=":not("+e+")"),1===t.length&&1===r.nodeType?w.find.matchesSelector(r,e)?[r]:[]:w.find.matches(e,w.grep(t,function(e){return 1===e.nodeType}))},w.fn.extend({find:function(e){var t,n,r=this.length,i=this;if("string"!=typeof e)return this.pushStack(w(e).filter(function(){for(t=0;t<r;t++)if(w.contains(i[t],this))return!0}));for(n=this.pushStack([]),t=0;t<r;t++)w.find(e,i[t],n);return r>1?w.uniqueSort(n):n},filter:function(e){return this.pushStack(j(this,e||[],!1))},not:function(e){return this.pushStack(j(this,e||[],!0))},is:function(e){return!!j(this,"string"==typeof e&&D.test(e)?w(e):e||[],!1).length}});var q,L=/^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;(w.fn.init=function(e,t,n){var i,o;if(!e)return this;if(n=n||q,"string"==typeof e){if(!(i="<"===e[0]&&">"===e[e.length-1]&&e.length>=3?[null,e,null]:L.exec(e))||!i[1]&&t)return!t||t.jquery?(t||n).find(e):this.constructor(t).find(e);if(i[1]){if(t=t instanceof w?t[0]:t,w.merge(this,w.parseHTML(i[1],t&&t.nodeType?t.ownerDocument||t:r,!0)),A.test(i[1])&&w.isPlainObject(t))for(i in t)g(this[i])?this[i](t[i]):this.attr(i,t[i]);return this}return(o=r.getElementById(i[2]))&&(this[0]=o,this.length=1),this}return e.nodeType?(this[0]=e,this.length=1,this):g(e)?void 0!==n.ready?n.ready(e):e(w):w.makeArray(e,this)}).prototype=w.fn,q=w(r);var H=/^(?:parents|prev(?:Until|All))/,O={children:!0,contents:!0,next:!0,prev:!0};w.fn.extend({has:function(e){var t=w(e,this),n=t.length;return this.filter(function(){for(var e=0;e<n;e++)if(w.contains(this,t[e]))return!0})},closest:function(e,t){var n,r=0,i=this.length,o=[],a="string"!=typeof e&&w(e);if(!D.test(e))for(;r<i;r++)for(n=this[r];n&&n!==t;n=n.parentNode)if(n.nodeType<11&&(a?a.index(n)>-1:1===n.nodeType&&w.find.matchesSelector(n,e))){o.push(n);break}return this.pushStack(o.length>1?w.uniqueSort(o):o)},index:function(e){return e?"string"==typeof e?u.call(w(e),this[0]):u.call(this,e.jquery?e[0]:e):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(e,t){return this.pushStack(w.uniqueSort(w.merge(this.get(),w(e,t))))},addBack:function(e){return this.add(null==e?this.prevObject:this.prevObject.filter(e))}});function P(e,t){while((e=e[t])&&1!==e.nodeType);return e}w.each({parent:function(e){var t=e.parentNode;return t&&11!==t.nodeType?t:null},parents:function(e){return k(e,"parentNode")},parentsUntil:function(e,t,n){return k(e,"parentNode",n)},next:function(e){return P(e,"nextSibling")},prev:function(e){return P(e,"previousSibling")},nextAll:function(e){return k(e,"nextSibling")},prevAll:function(e){return k(e,"previousSibling")},nextUntil:function(e,t,n){return k(e,"nextSibling",n)},prevUntil:function(e,t,n){return k(e,"previousSibling",n)},siblings:function(e){return S((e.parentNode||{}).firstChild,e)},children:function(e){return S(e.firstChild)},contents:function(e){return N(e,"iframe")?e.contentDocument:(N(e,"template")&&(e=e.content||e),w.merge([],e.childNodes))}},function(e,t){w.fn[e]=function(n,r){var i=w.map(this,t,n);return"Until"!==e.slice(-5)&&(r=n),r&&"string"==typeof r&&(i=w.filter(r,i)),this.length>1&&(O[e]||w.uniqueSort(i),H.test(e)&&i.reverse()),this.pushStack(i)}});var M=/[^\x20\t\r\n\f]+/g;function R(e){var t={};return w.each(e.match(M)||[],function(e,n){t[n]=!0}),t}w.Callbacks=function(e){e="string"==typeof e?R(e):w.extend({},e);var t,n,r,i,o=[],a=[],s=-1,u=function(){for(i=i||e.once,r=t=!0;a.length;s=-1){n=a.shift();while(++s<o.length)!1===o[s].apply(n[0],n[1])&&e.stopOnFalse&&(s=o.length,n=!1)}e.memory||(n=!1),t=!1,i&&(o=n?[]:"")},l={add:function(){return o&&(n&&!t&&(s=o.length-1,a.push(n)),function t(n){w.each(n,function(n,r){g(r)?e.unique&&l.has(r)||o.push(r):r&&r.length&&"string"!==x(r)&&t(r)})}(arguments),n&&!t&&u()),this},remove:function(){return w.each(arguments,function(e,t){var n;while((n=w.inArray(t,o,n))>-1)o.splice(n,1),n<=s&&s--}),this},has:function(e){return e?w.inArray(e,o)>-1:o.length>0},empty:function(){return o&&(o=[]),this},disable:function(){return i=a=[],o=n="",this},disabled:function(){return!o},lock:function(){return i=a=[],n||t||(o=n=""),this},locked:function(){return!!i},fireWith:function(e,n){return i||(n=[e,(n=n||[]).slice?n.slice():n],a.push(n),t||u()),this},fire:function(){return l.fireWith(this,arguments),this},fired:function(){return!!r}};return l};function I(e){return e}function W(e){throw e}function $(e,t,n,r){var i;try{e&&g(i=e.promise)?i.call(e).done(t).fail(n):e&&g(i=e.then)?i.call(e,t,n):t.apply(void 0,[e].slice(r))}catch(e){n.apply(void 0,[e])}}w.extend({Deferred:function(t){var n=[["notify","progress",w.Callbacks("memory"),w.Callbacks("memory"),2],["resolve","done",w.Callbacks("once memory"),w.Callbacks("once memory"),0,"resolved"],["reject","fail",w.Callbacks("once memory"),w.Callbacks("once memory"),1,"rejected"]],r="pending",i={state:function(){return r},always:function(){return o.done(arguments).fail(arguments),this},"catch":function(e){return i.then(null,e)},pipe:function(){var e=arguments;return w.Deferred(function(t){w.each(n,function(n,r){var i=g(e[r[4]])&&e[r[4]];o[r[1]](function(){var e=i&&i.apply(this,arguments);e&&g(e.promise)?e.promise().progress(t.notify).done(t.resolve).fail(t.reject):t[r[0]+"With"](this,i?[e]:arguments)})}),e=null}).promise()},then:function(t,r,i){var o=0;function a(t,n,r,i){return function(){var s=this,u=arguments,l=function(){var e,l;if(!(t<o)){if((e=r.apply(s,u))===n.promise())throw new TypeError("Thenable self-resolution");l=e&&("object"==typeof e||"function"==typeof e)&&e.then,g(l)?i?l.call(e,a(o,n,I,i),a(o,n,W,i)):(o++,l.call(e,a(o,n,I,i),a(o,n,W,i),a(o,n,I,n.notifyWith))):(r!==I&&(s=void 0,u=[e]),(i||n.resolveWith)(s,u))}},c=i?l:function(){try{l()}catch(e){w.Deferred.exceptionHook&&w.Deferred.exceptionHook(e,c.stackTrace),t+1>=o&&(r!==W&&(s=void 0,u=[e]),n.rejectWith(s,u))}};t?c():(w.Deferred.getStackHook&&(c.stackTrace=w.Deferred.getStackHook()),e.setTimeout(c))}}return w.Deferred(function(e){n[0][3].add(a(0,e,g(i)?i:I,e.notifyWith)),n[1][3].add(a(0,e,g(t)?t:I)),n[2][3].add(a(0,e,g(r)?r:W))}).promise()},promise:function(e){return null!=e?w.extend(e,i):i}},o={};return w.each(n,function(e,t){var a=t[2],s=t[5];i[t[1]]=a.add,s&&a.add(function(){r=s},n[3-e][2].disable,n[3-e][3].disable,n[0][2].lock,n[0][3].lock),a.add(t[3].fire),o[t[0]]=function(){return o[t[0]+"With"](this===o?void 0:this,arguments),this},o[t[0]+"With"]=a.fireWith}),i.promise(o),t&&t.call(o,o),o},when:function(e){var t=arguments.length,n=t,r=Array(n),i=o.call(arguments),a=w.Deferred(),s=function(e){return function(n){r[e]=this,i[e]=arguments.length>1?o.call(arguments):n,--t||a.resolveWith(r,i)}};if(t<=1&&($(e,a.done(s(n)).resolve,a.reject,!t),"pending"===a.state()||g(i[n]&&i[n].then)))return a.then();while(n--)$(i[n],s(n),a.reject);return a.promise()}});var B=/^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;w.Deferred.exceptionHook=function(t,n){e.console&&e.console.warn&&t&&B.test(t.name)&&e.console.warn("jQuery.Deferred exception: "+t.message,t.stack,n)},w.readyException=function(t){e.setTimeout(function(){throw t})};var F=w.Deferred();w.fn.ready=function(e){return F.then(e)["catch"](function(e){w.readyException(e)}),this},w.extend({isReady:!1,readyWait:1,ready:function(e){(!0===e?--w.readyWait:w.isReady)||(w.isReady=!0,!0!==e&&--w.readyWait>0||F.resolveWith(r,[w]))}}),w.ready.then=F.then;function _(){r.removeEventListener("DOMContentLoaded",_),e.removeEventListener("load",_),w.ready()}"complete"===r.readyState||"loading"!==r.readyState&&!r.documentElement.doScroll?e.setTimeout(w.ready):(r.addEventListener("DOMContentLoaded",_),e.addEventListener("load",_));var z=function(e,t,n,r,i,o,a){var s=0,u=e.length,l=null==n;if("object"===x(n)){i=!0;for(s in n)z(e,t,s,n[s],!0,o,a)}else if(void 0!==r&&(i=!0,g(r)||(a=!0),l&&(a?(t.call(e,r),t=null):(l=t,t=function(e,t,n){return l.call(w(e),n)})),t))for(;s<u;s++)t(e[s],n,a?r:r.call(e[s],s,t(e[s],n)));return i?e:l?t.call(e):u?t(e[0],n):o},X=/^-ms-/,U=/-([a-z])/g;function V(e,t){return t.toUpperCase()}function G(e){return e.replace(X,"ms-").replace(U,V)}var Y=function(e){return 1===e.nodeType||9===e.nodeType||!+e.nodeType};function Q(){this.expando=w.expando+Q.uid++}Q.uid=1,Q.prototype={cache:function(e){var t=e[this.expando];return t||(t={},Y(e)&&(e.nodeType?e[this.expando]=t:Object.defineProperty(e,this.expando,{value:t,configurable:!0}))),t},set:function(e,t,n){var r,i=this.cache(e);if("string"==typeof t)i[G(t)]=n;else for(r in t)i[G(r)]=t[r];return i},get:function(e,t){return void 0===t?this.cache(e):e[this.expando]&&e[this.expando][G(t)]},access:function(e,t,n){return void 0===t||t&&"string"==typeof t&&void 0===n?this.get(e,t):(this.set(e,t,n),void 0!==n?n:t)},remove:function(e,t){var n,r=e[this.expando];if(void 0!==r){if(void 0!==t){n=(t=Array.isArray(t)?t.map(G):(t=G(t))in r?[t]:t.match(M)||[]).length;while(n--)delete r[t[n]]}(void 0===t||w.isEmptyObject(r))&&(e.nodeType?e[this.expando]=void 0:delete e[this.expando])}},hasData:function(e){var t=e[this.expando];return void 0!==t&&!w.isEmptyObject(t)}};var J=new Q,K=new Q,Z=/^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,ee=/[A-Z]/g;function te(e){return"true"===e||"false"!==e&&("null"===e?null:e===+e+""?+e:Z.test(e)?JSON.parse(e):e)}function ne(e,t,n){var r;if(void 0===n&&1===e.nodeType)if(r="data-"+t.replace(ee,"-$&").toLowerCase(),"string"==typeof(n=e.getAttribute(r))){try{n=te(n)}catch(e){}K.set(e,t,n)}else n=void 0;return n}w.extend({hasData:function(e){return K.hasData(e)||J.hasData(e)},data:function(e,t,n){return K.access(e,t,n)},removeData:function(e,t){K.remove(e,t)},_data:function(e,t,n){return J.access(e,t,n)},_removeData:function(e,t){J.remove(e,t)}}),w.fn.extend({data:function(e,t){var n,r,i,o=this[0],a=o&&o.attributes;if(void 0===e){if(this.length&&(i=K.get(o),1===o.nodeType&&!J.get(o,"hasDataAttrs"))){n=a.length;while(n--)a[n]&&0===(r=a[n].name).indexOf("data-")&&(r=G(r.slice(5)),ne(o,r,i[r]));J.set(o,"hasDataAttrs",!0)}return i}return"object"==typeof e?this.each(function(){K.set(this,e)}):z(this,function(t){var n;if(o&&void 0===t){if(void 0!==(n=K.get(o,e)))return n;if(void 0!==(n=ne(o,e)))return n}else this.each(function(){K.set(this,e,t)})},null,t,arguments.length>1,null,!0)},removeData:function(e){return this.each(function(){K.remove(this,e)})}}),w.extend({queue:function(e,t,n){var r;if(e)return t=(t||"fx")+"queue",r=J.get(e,t),n&&(!r||Array.isArray(n)?r=J.access(e,t,w.makeArray(n)):r.push(n)),r||[]},dequeue:function(e,t){t=t||"fx";var n=w.queue(e,t),r=n.length,i=n.shift(),o=w._queueHooks(e,t),a=function(){w.dequeue(e,t)};"inprogress"===i&&(i=n.shift(),r--),i&&("fx"===t&&n.unshift("inprogress"),delete o.stop,i.call(e,a,o)),!r&&o&&o.empty.fire()},_queueHooks:function(e,t){var n=t+"queueHooks";return J.get(e,n)||J.access(e,n,{empty:w.Callbacks("once memory").add(function(){J.remove(e,[t+"queue",n])})})}}),w.fn.extend({queue:function(e,t){var n=2;return"string"!=typeof e&&(t=e,e="fx",n--),arguments.length<n?w.queue(this[0],e):void 0===t?this:this.each(function(){var n=w.queue(this,e,t);w._queueHooks(this,e),"fx"===e&&"inprogress"!==n[0]&&w.dequeue(this,e)})},dequeue:function(e){return this.each(function(){w.dequeue(this,e)})},clearQueue:function(e){return this.queue(e||"fx",[])},promise:function(e,t){var n,r=1,i=w.Deferred(),o=this,a=this.length,s=function(){--r||i.resolveWith(o,[o])};"string"!=typeof e&&(t=e,e=void 0),e=e||"fx";while(a--)(n=J.get(o[a],e+"queueHooks"))&&n.empty&&(r++,n.empty.add(s));return s(),i.promise(t)}});var re=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,ie=new RegExp("^(?:([+-])=|)("+re+")([a-z%]*)$","i"),oe=["Top","Right","Bottom","Left"],ae=function(e,t){return"none"===(e=t||e).style.display||""===e.style.display&&w.contains(e.ownerDocument,e)&&"none"===w.css(e,"display")},se=function(e,t,n,r){var i,o,a={};for(o in t)a[o]=e.style[o],e.style[o]=t[o];i=n.apply(e,r||[]);for(o in t)e.style[o]=a[o];return i};function ue(e,t,n,r){var i,o,a=20,s=r?function(){return r.cur()}:function(){return w.css(e,t,"")},u=s(),l=n&&n[3]||(w.cssNumber[t]?"":"px"),c=(w.cssNumber[t]||"px"!==l&&+u)&&ie.exec(w.css(e,t));if(c&&c[3]!==l){u/=2,l=l||c[3],c=+u||1;while(a--)w.style(e,t,c+l),(1-o)*(1-(o=s()/u||.5))<=0&&(a=0),c/=o;c*=2,w.style(e,t,c+l),n=n||[]}return n&&(c=+c||+u||0,i=n[1]?c+(n[1]+1)*n[2]:+n[2],r&&(r.unit=l,r.start=c,r.end=i)),i}var le={};function ce(e){var t,n=e.ownerDocument,r=e.nodeName,i=le[r];return i||(t=n.body.appendChild(n.createElement(r)),i=w.css(t,"display"),t.parentNode.removeChild(t),"none"===i&&(i="block"),le[r]=i,i)}function fe(e,t){for(var n,r,i=[],o=0,a=e.length;o<a;o++)(r=e[o]).style&&(n=r.style.display,t?("none"===n&&(i[o]=J.get(r,"display")||null,i[o]||(r.style.display="")),""===r.style.display&&ae(r)&&(i[o]=ce(r))):"none"!==n&&(i[o]="none",J.set(r,"display",n)));for(o=0;o<a;o++)null!=i[o]&&(e[o].style.display=i[o]);return e}w.fn.extend({show:function(){return fe(this,!0)},hide:function(){return fe(this)},toggle:function(e){return"boolean"==typeof e?e?this.show():this.hide():this.each(function(){ae(this)?w(this).show():w(this).hide()})}});var pe=/^(?:checkbox|radio)$/i,de=/<([a-z][^\/\0>\x20\t\r\n\f]+)/i,he=/^$|^module$|\/(?:java|ecma)script/i,ge={option:[1,"<select multiple='multiple'>","</select>"],thead:[1,"<table>","</table>"],col:[2,"<table><colgroup>","</colgroup></table>"],tr:[2,"<table><tbody>","</tbody></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:[0,"",""]};ge.optgroup=ge.option,ge.tbody=ge.tfoot=ge.colgroup=ge.caption=ge.thead,ge.th=ge.td;function ye(e,t){var n;return n="undefined"!=typeof e.getElementsByTagName?e.getElementsByTagName(t||"*"):"undefined"!=typeof e.querySelectorAll?e.querySelectorAll(t||"*"):[],void 0===t||t&&N(e,t)?w.merge([e],n):n}function ve(e,t){for(var n=0,r=e.length;n<r;n++)J.set(e[n],"globalEval",!t||J.get(t[n],"globalEval"))}var me=/<|&#?\w+;/;function xe(e,t,n,r,i){for(var o,a,s,u,l,c,f=t.createDocumentFragment(),p=[],d=0,h=e.length;d<h;d++)if((o=e[d])||0===o)if("object"===x(o))w.merge(p,o.nodeType?[o]:o);else if(me.test(o)){a=a||f.appendChild(t.createElement("div")),s=(de.exec(o)||["",""])[1].toLowerCase(),u=ge[s]||ge._default,a.innerHTML=u[1]+w.htmlPrefilter(o)+u[2],c=u[0];while(c--)a=a.lastChild;w.merge(p,a.childNodes),(a=f.firstChild).textContent=""}else p.push(t.createTextNode(o));f.textContent="",d=0;while(o=p[d++])if(r&&w.inArray(o,r)>-1)i&&i.push(o);else if(l=w.contains(o.ownerDocument,o),a=ye(f.appendChild(o),"script"),l&&ve(a),n){c=0;while(o=a[c++])he.test(o.type||"")&&n.push(o)}return f}!function(){var e=r.createDocumentFragment().appendChild(r.createElement("div")),t=r.createElement("input");t.setAttribute("type","radio"),t.setAttribute("checked","checked"),t.setAttribute("name","t"),e.appendChild(t),h.checkClone=e.cloneNode(!0).cloneNode(!0).lastChild.checked,e.innerHTML="<textarea>x</textarea>",h.noCloneChecked=!!e.cloneNode(!0).lastChild.defaultValue}();var be=r.documentElement,we=/^key/,Te=/^(?:mouse|pointer|contextmenu|drag|drop)|click/,Ce=/^([^.]*)(?:\.(.+)|)/;function Ee(){return!0}function ke(){return!1}function Se(){try{return r.activeElement}catch(e){}}function De(e,t,n,r,i,o){var a,s;if("object"==typeof t){"string"!=typeof n&&(r=r||n,n=void 0);for(s in t)De(e,s,n,r,t[s],o);return e}if(null==r&&null==i?(i=n,r=n=void 0):null==i&&("string"==typeof n?(i=r,r=void 0):(i=r,r=n,n=void 0)),!1===i)i=ke;else if(!i)return e;return 1===o&&(a=i,(i=function(e){return w().off(e),a.apply(this,arguments)}).guid=a.guid||(a.guid=w.guid++)),e.each(function(){w.event.add(this,t,i,r,n)})}w.event={global:{},add:function(e,t,n,r,i){var o,a,s,u,l,c,f,p,d,h,g,y=J.get(e);if(y){n.handler&&(n=(o=n).handler,i=o.selector),i&&w.find.matchesSelector(be,i),n.guid||(n.guid=w.guid++),(u=y.events)||(u=y.events={}),(a=y.handle)||(a=y.handle=function(t){return"undefined"!=typeof w&&w.event.triggered!==t.type?w.event.dispatch.apply(e,arguments):void 0}),l=(t=(t||"").match(M)||[""]).length;while(l--)d=g=(s=Ce.exec(t[l])||[])[1],h=(s[2]||"").split(".").sort(),d&&(f=w.event.special[d]||{},d=(i?f.delegateType:f.bindType)||d,f=w.event.special[d]||{},c=w.extend({type:d,origType:g,data:r,handler:n,guid:n.guid,selector:i,needsContext:i&&w.expr.match.needsContext.test(i),namespace:h.join(".")},o),(p=u[d])||((p=u[d]=[]).delegateCount=0,f.setup&&!1!==f.setup.call(e,r,h,a)||e.addEventListener&&e.addEventListener(d,a)),f.add&&(f.add.call(e,c),c.handler.guid||(c.handler.guid=n.guid)),i?p.splice(p.delegateCount++,0,c):p.push(c),w.event.global[d]=!0)}},remove:function(e,t,n,r,i){var o,a,s,u,l,c,f,p,d,h,g,y=J.hasData(e)&&J.get(e);if(y&&(u=y.events)){l=(t=(t||"").match(M)||[""]).length;while(l--)if(s=Ce.exec(t[l])||[],d=g=s[1],h=(s[2]||"").split(".").sort(),d){f=w.event.special[d]||{},p=u[d=(r?f.delegateType:f.bindType)||d]||[],s=s[2]&&new RegExp("(^|\\.)"+h.join("\\.(?:.*\\.|)")+"(\\.|$)"),a=o=p.length;while(o--)c=p[o],!i&&g!==c.origType||n&&n.guid!==c.guid||s&&!s.test(c.namespace)||r&&r!==c.selector&&("**"!==r||!c.selector)||(p.splice(o,1),c.selector&&p.delegateCount--,f.remove&&f.remove.call(e,c));a&&!p.length&&(f.teardown&&!1!==f.teardown.call(e,h,y.handle)||w.removeEvent(e,d,y.handle),delete u[d])}else for(d in u)w.event.remove(e,d+t[l],n,r,!0);w.isEmptyObject(u)&&J.remove(e,"handle events")}},dispatch:function(e){var t=w.event.fix(e),n,r,i,o,a,s,u=new Array(arguments.length),l=(J.get(this,"events")||{})[t.type]||[],c=w.event.special[t.type]||{};for(u[0]=t,n=1;n<arguments.length;n++)u[n]=arguments[n];if(t.delegateTarget=this,!c.preDispatch||!1!==c.preDispatch.call(this,t)){s=w.event.handlers.call(this,t,l),n=0;while((o=s[n++])&&!t.isPropagationStopped()){t.currentTarget=o.elem,r=0;while((a=o.handlers[r++])&&!t.isImmediatePropagationStopped())t.rnamespace&&!t.rnamespace.test(a.namespace)||(t.handleObj=a,t.data=a.data,void 0!==(i=((w.event.special[a.origType]||{}).handle||a.handler).apply(o.elem,u))&&!1===(t.result=i)&&(t.preventDefault(),t.stopPropagation()))}return c.postDispatch&&c.postDispatch.call(this,t),t.result}},handlers:function(e,t){var n,r,i,o,a,s=[],u=t.delegateCount,l=e.target;if(u&&l.nodeType&&!("click"===e.type&&e.button>=1))for(;l!==this;l=l.parentNode||this)if(1===l.nodeType&&("click"!==e.type||!0!==l.disabled)){for(o=[],a={},n=0;n<u;n++)void 0===a[i=(r=t[n]).selector+" "]&&(a[i]=r.needsContext?w(i,this).index(l)>-1:w.find(i,this,null,[l]).length),a[i]&&o.push(r);o.length&&s.push({elem:l,handlers:o})}return l=this,u<t.length&&s.push({elem:l,handlers:t.slice(u)}),s},addProp:function(e,t){Object.defineProperty(w.Event.prototype,e,{enumerable:!0,configurable:!0,get:g(t)?function(){if(this.originalEvent)return t(this.originalEvent)}:function(){if(this.originalEvent)return this.originalEvent[e]},set:function(t){Object.defineProperty(this,e,{enumerable:!0,configurable:!0,writable:!0,value:t})}})},fix:function(e){return e[w.expando]?e:new w.Event(e)},special:{load:{noBubble:!0},focus:{trigger:function(){if(this!==Se()&&this.focus)return this.focus(),!1},delegateType:"focusin"},blur:{trigger:function(){if(this===Se()&&this.blur)return this.blur(),!1},delegateType:"focusout"},click:{trigger:function(){if("checkbox"===this.type&&this.click&&N(this,"input"))return this.click(),!1},_default:function(e){return N(e.target,"a")}},beforeunload:{postDispatch:function(e){void 0!==e.result&&e.originalEvent&&(e.originalEvent.returnValue=e.result)}}}},w.removeEvent=function(e,t,n){e.removeEventListener&&e.removeEventListener(t,n)},w.Event=function(e,t){if(!(this instanceof w.Event))return new w.Event(e,t);e&&e.type?(this.originalEvent=e,this.type=e.type,this.isDefaultPrevented=e.defaultPrevented||void 0===e.defaultPrevented&&!1===e.returnValue?Ee:ke,this.target=e.target&&3===e.target.nodeType?e.target.parentNode:e.target,this.currentTarget=e.currentTarget,this.relatedTarget=e.relatedTarget):this.type=e,t&&w.extend(this,t),this.timeStamp=e&&e.timeStamp||Date.now(),this[w.expando]=!0},w.Event.prototype={constructor:w.Event,isDefaultPrevented:ke,isPropagationStopped:ke,isImmediatePropagationStopped:ke,isSimulated:!1,preventDefault:function(){var e=this.originalEvent;this.isDefaultPrevented=Ee,e&&!this.isSimulated&&e.preventDefault()},stopPropagation:function(){var e=this.originalEvent;this.isPropagationStopped=Ee,e&&!this.isSimulated&&e.stopPropagation()},stopImmediatePropagation:function(){var e=this.originalEvent;this.isImmediatePropagationStopped=Ee,e&&!this.isSimulated&&e.stopImmediatePropagation(),this.stopPropagation()}},w.each({altKey:!0,bubbles:!0,cancelable:!0,changedTouches:!0,ctrlKey:!0,detail:!0,eventPhase:!0,metaKey:!0,pageX:!0,pageY:!0,shiftKey:!0,view:!0,"char":!0,charCode:!0,key:!0,keyCode:!0,button:!0,buttons:!0,clientX:!0,clientY:!0,offsetX:!0,offsetY:!0,pointerId:!0,pointerType:!0,screenX:!0,screenY:!0,targetTouches:!0,toElement:!0,touches:!0,which:function(e){var t=e.button;return null==e.which&&we.test(e.type)?null!=e.charCode?e.charCode:e.keyCode:!e.which&&void 0!==t&&Te.test(e.type)?1&t?1:2&t?3:4&t?2:0:e.which}},w.event.addProp),w.each({mouseenter:"mouseover",mouseleave:"mouseout",pointerenter:"pointerover",pointerleave:"pointerout"},function(e,t){w.event.special[e]={delegateType:t,bindType:t,handle:function(e){var n,r=this,i=e.relatedTarget,o=e.handleObj;return i&&(i===r||w.contains(r,i))||(e.type=o.origType,n=o.handler.apply(this,arguments),e.type=t),n}}}),w.fn.extend({on:function(e,t,n,r){return De(this,e,t,n,r)},one:function(e,t,n,r){return De(this,e,t,n,r,1)},off:function(e,t,n){var r,i;if(e&&e.preventDefault&&e.handleObj)return r=e.handleObj,w(e.delegateTarget).off(r.namespace?r.origType+"."+r.namespace:r.origType,r.selector,r.handler),this;if("object"==typeof e){for(i in e)this.off(i,t,e[i]);return this}return!1!==t&&"function"!=typeof t||(n=t,t=void 0),!1===n&&(n=ke),this.each(function(){w.event.remove(this,e,n,t)})}});var Ne=/<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,Ae=/<script|<style|<link/i,je=/checked\s*(?:[^=]|=\s*.checked.)/i,qe=/^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;function Le(e,t){return N(e,"table")&&N(11!==t.nodeType?t:t.firstChild,"tr")?w(e).children("tbody")[0]||e:e}function He(e){return e.type=(null!==e.getAttribute("type"))+"/"+e.type,e}function Oe(e){return"true/"===(e.type||"").slice(0,5)?e.type=e.type.slice(5):e.removeAttribute("type"),e}function Pe(e,t){var n,r,i,o,a,s,u,l;if(1===t.nodeType){if(J.hasData(e)&&(o=J.access(e),a=J.set(t,o),l=o.events)){delete a.handle,a.events={};for(i in l)for(n=0,r=l[i].length;n<r;n++)w.event.add(t,i,l[i][n])}K.hasData(e)&&(s=K.access(e),u=w.extend({},s),K.set(t,u))}}function Me(e,t){var n=t.nodeName.toLowerCase();"input"===n&&pe.test(e.type)?t.checked=e.checked:"input"!==n&&"textarea"!==n||(t.defaultValue=e.defaultValue)}function Re(e,t,n,r){t=a.apply([],t);var i,o,s,u,l,c,f=0,p=e.length,d=p-1,y=t[0],v=g(y);if(v||p>1&&"string"==typeof y&&!h.checkClone&&je.test(y))return e.each(function(i){var o=e.eq(i);v&&(t[0]=y.call(this,i,o.html())),Re(o,t,n,r)});if(p&&(i=xe(t,e[0].ownerDocument,!1,e,r),o=i.firstChild,1===i.childNodes.length&&(i=o),o||r)){for(u=(s=w.map(ye(i,"script"),He)).length;f<p;f++)l=i,f!==d&&(l=w.clone(l,!0,!0),u&&w.merge(s,ye(l,"script"))),n.call(e[f],l,f);if(u)for(c=s[s.length-1].ownerDocument,w.map(s,Oe),f=0;f<u;f++)l=s[f],he.test(l.type||"")&&!J.access(l,"globalEval")&&w.contains(c,l)&&(l.src&&"module"!==(l.type||"").toLowerCase()?w._evalUrl&&w._evalUrl(l.src):m(l.textContent.replace(qe,""),c,l))}return e}function Ie(e,t,n){for(var r,i=t?w.filter(t,e):e,o=0;null!=(r=i[o]);o++)n||1!==r.nodeType||w.cleanData(ye(r)),r.parentNode&&(n&&w.contains(r.ownerDocument,r)&&ve(ye(r,"script")),r.parentNode.removeChild(r));return e}w.extend({htmlPrefilter:function(e){return e.replace(Ne,"<$1></$2>")},clone:function(e,t,n){var r,i,o,a,s=e.cloneNode(!0),u=w.contains(e.ownerDocument,e);if(!(h.noCloneChecked||1!==e.nodeType&&11!==e.nodeType||w.isXMLDoc(e)))for(a=ye(s),r=0,i=(o=ye(e)).length;r<i;r++)Me(o[r],a[r]);if(t)if(n)for(o=o||ye(e),a=a||ye(s),r=0,i=o.length;r<i;r++)Pe(o[r],a[r]);else Pe(e,s);return(a=ye(s,"script")).length>0&&ve(a,!u&&ye(e,"script")),s},cleanData:function(e){for(var t,n,r,i=w.event.special,o=0;void 0!==(n=e[o]);o++)if(Y(n)){if(t=n[J.expando]){if(t.events)for(r in t.events)i[r]?w.event.remove(n,r):w.removeEvent(n,r,t.handle);n[J.expando]=void 0}n[K.expando]&&(n[K.expando]=void 0)}}}),w.fn.extend({detach:function(e){return Ie(this,e,!0)},remove:function(e){return Ie(this,e)},text:function(e){return z(this,function(e){return void 0===e?w.text(this):this.empty().each(function(){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||(this.textContent=e)})},null,e,arguments.length)},append:function(){return Re(this,arguments,function(e){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||Le(this,e).appendChild(e)})},prepend:function(){return Re(this,arguments,function(e){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var t=Le(this,e);t.insertBefore(e,t.firstChild)}})},before:function(){return Re(this,arguments,function(e){this.parentNode&&this.parentNode.insertBefore(e,this)})},after:function(){return Re(this,arguments,function(e){this.parentNode&&this.parentNode.insertBefore(e,this.nextSibling)})},empty:function(){for(var e,t=0;null!=(e=this[t]);t++)1===e.nodeType&&(w.cleanData(ye(e,!1)),e.textContent="");return this},clone:function(e,t){return e=null!=e&&e,t=null==t?e:t,this.map(function(){return w.clone(this,e,t)})},html:function(e){return z(this,function(e){var t=this[0]||{},n=0,r=this.length;if(void 0===e&&1===t.nodeType)return t.innerHTML;if("string"==typeof e&&!Ae.test(e)&&!ge[(de.exec(e)||["",""])[1].toLowerCase()]){e=w.htmlPrefilter(e);try{for(;n<r;n++)1===(t=this[n]||{}).nodeType&&(w.cleanData(ye(t,!1)),t.innerHTML=e);t=0}catch(e){}}t&&this.empty().append(e)},null,e,arguments.length)},replaceWith:function(){var e=[];return Re(this,arguments,function(t){var n=this.parentNode;w.inArray(this,e)<0&&(w.cleanData(ye(this)),n&&n.replaceChild(t,this))},e)}}),w.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(e,t){w.fn[e]=function(e){for(var n,r=[],i=w(e),o=i.length-1,a=0;a<=o;a++)n=a===o?this:this.clone(!0),w(i[a])[t](n),s.apply(r,n.get());return this.pushStack(r)}});var We=new RegExp("^("+re+")(?!px)[a-z%]+$","i"),$e=function(t){var n=t.ownerDocument.defaultView;return n&&n.opener||(n=e),n.getComputedStyle(t)},Be=new RegExp(oe.join("|"),"i");!function(){function t(){if(c){l.style.cssText="position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0",c.style.cssText="position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%",be.appendChild(l).appendChild(c);var t=e.getComputedStyle(c);i="1%"!==t.top,u=12===n(t.marginLeft),c.style.right="60%",s=36===n(t.right),o=36===n(t.width),c.style.position="absolute",a=36===c.offsetWidth||"absolute",be.removeChild(l),c=null}}function n(e){return Math.round(parseFloat(e))}var i,o,a,s,u,l=r.createElement("div"),c=r.createElement("div");c.style&&(c.style.backgroundClip="content-box",c.cloneNode(!0).style.backgroundClip="",h.clearCloneStyle="content-box"===c.style.backgroundClip,w.extend(h,{boxSizingReliable:function(){return t(),o},pixelBoxStyles:function(){return t(),s},pixelPosition:function(){return t(),i},reliableMarginLeft:function(){return t(),u},scrollboxSize:function(){return t(),a}}))}();function Fe(e,t,n){var r,i,o,a,s=e.style;return(n=n||$e(e))&&(""!==(a=n.getPropertyValue(t)||n[t])||w.contains(e.ownerDocument,e)||(a=w.style(e,t)),!h.pixelBoxStyles()&&We.test(a)&&Be.test(t)&&(r=s.width,i=s.minWidth,o=s.maxWidth,s.minWidth=s.maxWidth=s.width=a,a=n.width,s.width=r,s.minWidth=i,s.maxWidth=o)),void 0!==a?a+"":a}function _e(e,t){return{get:function(){if(!e())return(this.get=t).apply(this,arguments);delete this.get}}}var ze=/^(none|table(?!-c[ea]).+)/,Xe=/^--/,Ue={position:"absolute",visibility:"hidden",display:"block"},Ve={letterSpacing:"0",fontWeight:"400"},Ge=["Webkit","Moz","ms"],Ye=r.createElement("div").style;function Qe(e){if(e in Ye)return e;var t=e[0].toUpperCase()+e.slice(1),n=Ge.length;while(n--)if((e=Ge[n]+t)in Ye)return e}function Je(e){var t=w.cssProps[e];return t||(t=w.cssProps[e]=Qe(e)||e),t}function Ke(e,t,n){var r=ie.exec(t);return r?Math.max(0,r[2]-(n||0))+(r[3]||"px"):t}function Ze(e,t,n,r,i,o){var a="width"===t?1:0,s=0,u=0;if(n===(r?"border":"content"))return 0;for(;a<4;a+=2)"margin"===n&&(u+=w.css(e,n+oe[a],!0,i)),r?("content"===n&&(u-=w.css(e,"padding"+oe[a],!0,i)),"margin"!==n&&(u-=w.css(e,"border"+oe[a]+"Width",!0,i))):(u+=w.css(e,"padding"+oe[a],!0,i),"padding"!==n?u+=w.css(e,"border"+oe[a]+"Width",!0,i):s+=w.css(e,"border"+oe[a]+"Width",!0,i));return!r&&o>=0&&(u+=Math.max(0,Math.ceil(e["offset"+t[0].toUpperCase()+t.slice(1)]-o-u-s-.5))),u}function et(e,t,n){var r=$e(e),i=Fe(e,t,r),o="border-box"===w.css(e,"boxSizing",!1,r),a=o;if(We.test(i)){if(!n)return i;i="auto"}return a=a&&(h.boxSizingReliable()||i===e.style[t]),("auto"===i||!parseFloat(i)&&"inline"===w.css(e,"display",!1,r))&&(i=e["offset"+t[0].toUpperCase()+t.slice(1)],a=!0),(i=parseFloat(i)||0)+Ze(e,t,n||(o?"border":"content"),a,r,i)+"px"}w.extend({cssHooks:{opacity:{get:function(e,t){if(t){var n=Fe(e,"opacity");return""===n?"1":n}}}},cssNumber:{animationIterationCount:!0,columnCount:!0,fillOpacity:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,widows:!0,zIndex:!0,zoom:!0},cssProps:{},style:function(e,t,n,r){if(e&&3!==e.nodeType&&8!==e.nodeType&&e.style){var i,o,a,s=G(t),u=Xe.test(t),l=e.style;if(u||(t=Je(s)),a=w.cssHooks[t]||w.cssHooks[s],void 0===n)return a&&"get"in a&&void 0!==(i=a.get(e,!1,r))?i:l[t];"string"==(o=typeof n)&&(i=ie.exec(n))&&i[1]&&(n=ue(e,t,i),o="number"),null!=n&&n===n&&("number"===o&&(n+=i&&i[3]||(w.cssNumber[s]?"":"px")),h.clearCloneStyle||""!==n||0!==t.indexOf("background")||(l[t]="inherit"),a&&"set"in a&&void 0===(n=a.set(e,n,r))||(u?l.setProperty(t,n):l[t]=n))}},css:function(e,t,n,r){var i,o,a,s=G(t);return Xe.test(t)||(t=Je(s)),(a=w.cssHooks[t]||w.cssHooks[s])&&"get"in a&&(i=a.get(e,!0,n)),void 0===i&&(i=Fe(e,t,r)),"normal"===i&&t in Ve&&(i=Ve[t]),""===n||n?(o=parseFloat(i),!0===n||isFinite(o)?o||0:i):i}}),w.each(["height","width"],function(e,t){w.cssHooks[t]={get:function(e,n,r){if(n)return!ze.test(w.css(e,"display"))||e.getClientRects().length&&e.getBoundingClientRect().width?et(e,t,r):se(e,Ue,function(){return et(e,t,r)})},set:function(e,n,r){var i,o=$e(e),a="border-box"===w.css(e,"boxSizing",!1,o),s=r&&Ze(e,t,r,a,o);return a&&h.scrollboxSize()===o.position&&(s-=Math.ceil(e["offset"+t[0].toUpperCase()+t.slice(1)]-parseFloat(o[t])-Ze(e,t,"border",!1,o)-.5)),s&&(i=ie.exec(n))&&"px"!==(i[3]||"px")&&(e.style[t]=n,n=w.css(e,t)),Ke(e,n,s)}}}),w.cssHooks.marginLeft=_e(h.reliableMarginLeft,function(e,t){if(t)return(parseFloat(Fe(e,"marginLeft"))||e.getBoundingClientRect().left-se(e,{marginLeft:0},function(){return e.getBoundingClientRect().left}))+"px"}),w.each({margin:"",padding:"",border:"Width"},function(e,t){w.cssHooks[e+t]={expand:function(n){for(var r=0,i={},o="string"==typeof n?n.split(" "):[n];r<4;r++)i[e+oe[r]+t]=o[r]||o[r-2]||o[0];return i}},"margin"!==e&&(w.cssHooks[e+t].set=Ke)}),w.fn.extend({css:function(e,t){return z(this,function(e,t,n){var r,i,o={},a=0;if(Array.isArray(t)){for(r=$e(e),i=t.length;a<i;a++)o[t[a]]=w.css(e,t[a],!1,r);return o}return void 0!==n?w.style(e,t,n):w.css(e,t)},e,t,arguments.length>1)}});function tt(e,t,n,r,i){return new tt.prototype.init(e,t,n,r,i)}w.Tween=tt,tt.prototype={constructor:tt,init:function(e,t,n,r,i,o){this.elem=e,this.prop=n,this.easing=i||w.easing._default,this.options=t,this.start=this.now=this.cur(),this.end=r,this.unit=o||(w.cssNumber[n]?"":"px")},cur:function(){var e=tt.propHooks[this.prop];return e&&e.get?e.get(this):tt.propHooks._default.get(this)},run:function(e){var t,n=tt.propHooks[this.prop];return this.options.duration?this.pos=t=w.easing[this.easing](e,this.options.duration*e,0,1,this.options.duration):this.pos=t=e,this.now=(this.end-this.start)*t+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),n&&n.set?n.set(this):tt.propHooks._default.set(this),this}},tt.prototype.init.prototype=tt.prototype,tt.propHooks={_default:{get:function(e){var t;return 1!==e.elem.nodeType||null!=e.elem[e.prop]&&null==e.elem.style[e.prop]?e.elem[e.prop]:(t=w.css(e.elem,e.prop,""))&&"auto"!==t?t:0},set:function(e){w.fx.step[e.prop]?w.fx.step[e.prop](e):1!==e.elem.nodeType||null==e.elem.style[w.cssProps[e.prop]]&&!w.cssHooks[e.prop]?e.elem[e.prop]=e.now:w.style(e.elem,e.prop,e.now+e.unit)}}},tt.propHooks.scrollTop=tt.propHooks.scrollLeft={set:function(e){e.elem.nodeType&&e.elem.parentNode&&(e.elem[e.prop]=e.now)}},w.easing={linear:function(e){return e},swing:function(e){return.5-Math.cos(e*Math.PI)/2},_default:"swing"},w.fx=tt.prototype.init,w.fx.step={};var nt,rt,it=/^(?:toggle|show|hide)$/,ot=/queueHooks$/;function at(){rt&&(!1===r.hidden&&e.requestAnimationFrame?e.requestAnimationFrame(at):e.setTimeout(at,w.fx.interval),w.fx.tick())}function st(){return e.setTimeout(function(){nt=void 0}),nt=Date.now()}function ut(e,t){var n,r=0,i={height:e};for(t=t?1:0;r<4;r+=2-t)i["margin"+(n=oe[r])]=i["padding"+n]=e;return t&&(i.opacity=i.width=e),i}function lt(e,t,n){for(var r,i=(pt.tweeners[t]||[]).concat(pt.tweeners["*"]),o=0,a=i.length;o<a;o++)if(r=i[o].call(n,t,e))return r}function ct(e,t,n){var r,i,o,a,s,u,l,c,f="width"in t||"height"in t,p=this,d={},h=e.style,g=e.nodeType&&ae(e),y=J.get(e,"fxshow");n.queue||(null==(a=w._queueHooks(e,"fx")).unqueued&&(a.unqueued=0,s=a.empty.fire,a.empty.fire=function(){a.unqueued||s()}),a.unqueued++,p.always(function(){p.always(function(){a.unqueued--,w.queue(e,"fx").length||a.empty.fire()})}));for(r in t)if(i=t[r],it.test(i)){if(delete t[r],o=o||"toggle"===i,i===(g?"hide":"show")){if("show"!==i||!y||void 0===y[r])continue;g=!0}d[r]=y&&y[r]||w.style(e,r)}if((u=!w.isEmptyObject(t))||!w.isEmptyObject(d)){f&&1===e.nodeType&&(n.overflow=[h.overflow,h.overflowX,h.overflowY],null==(l=y&&y.display)&&(l=J.get(e,"display")),"none"===(c=w.css(e,"display"))&&(l?c=l:(fe([e],!0),l=e.style.display||l,c=w.css(e,"display"),fe([e]))),("inline"===c||"inline-block"===c&&null!=l)&&"none"===w.css(e,"float")&&(u||(p.done(function(){h.display=l}),null==l&&(c=h.display,l="none"===c?"":c)),h.display="inline-block")),n.overflow&&(h.overflow="hidden",p.always(function(){h.overflow=n.overflow[0],h.overflowX=n.overflow[1],h.overflowY=n.overflow[2]})),u=!1;for(r in d)u||(y?"hidden"in y&&(g=y.hidden):y=J.access(e,"fxshow",{display:l}),o&&(y.hidden=!g),g&&fe([e],!0),p.done(function(){g||fe([e]),J.remove(e,"fxshow");for(r in d)w.style(e,r,d[r])})),u=lt(g?y[r]:0,r,p),r in y||(y[r]=u.start,g&&(u.end=u.start,u.start=0))}}function ft(e,t){var n,r,i,o,a;for(n in e)if(r=G(n),i=t[r],o=e[n],Array.isArray(o)&&(i=o[1],o=e[n]=o[0]),n!==r&&(e[r]=o,delete e[n]),(a=w.cssHooks[r])&&"expand"in a){o=a.expand(o),delete e[r];for(n in o)n in e||(e[n]=o[n],t[n]=i)}else t[r]=i}function pt(e,t,n){var r,i,o=0,a=pt.prefilters.length,s=w.Deferred().always(function(){delete u.elem}),u=function(){if(i)return!1;for(var t=nt||st(),n=Math.max(0,l.startTime+l.duration-t),r=1-(n/l.duration||0),o=0,a=l.tweens.length;o<a;o++)l.tweens[o].run(r);return s.notifyWith(e,[l,r,n]),r<1&&a?n:(a||s.notifyWith(e,[l,1,0]),s.resolveWith(e,[l]),!1)},l=s.promise({elem:e,props:w.extend({},t),opts:w.extend(!0,{specialEasing:{},easing:w.easing._default},n),originalProperties:t,originalOptions:n,startTime:nt||st(),duration:n.duration,tweens:[],createTween:function(t,n){var r=w.Tween(e,l.opts,t,n,l.opts.specialEasing[t]||l.opts.easing);return l.tweens.push(r),r},stop:function(t){var n=0,r=t?l.tweens.length:0;if(i)return this;for(i=!0;n<r;n++)l.tweens[n].run(1);return t?(s.notifyWith(e,[l,1,0]),s.resolveWith(e,[l,t])):s.rejectWith(e,[l,t]),this}}),c=l.props;for(ft(c,l.opts.specialEasing);o<a;o++)if(r=pt.prefilters[o].call(l,e,c,l.opts))return g(r.stop)&&(w._queueHooks(l.elem,l.opts.queue).stop=r.stop.bind(r)),r;return w.map(c,lt,l),g(l.opts.start)&&l.opts.start.call(e,l),l.progress(l.opts.progress).done(l.opts.done,l.opts.complete).fail(l.opts.fail).always(l.opts.always),w.fx.timer(w.extend(u,{elem:e,anim:l,queue:l.opts.queue})),l}w.Animation=w.extend(pt,{tweeners:{"*":[function(e,t){var n=this.createTween(e,t);return ue(n.elem,e,ie.exec(t),n),n}]},tweener:function(e,t){g(e)?(t=e,e=["*"]):e=e.match(M);for(var n,r=0,i=e.length;r<i;r++)n=e[r],pt.tweeners[n]=pt.tweeners[n]||[],pt.tweeners[n].unshift(t)},prefilters:[ct],prefilter:function(e,t){t?pt.prefilters.unshift(e):pt.prefilters.push(e)}}),w.speed=function(e,t,n){var r=e&&"object"==typeof e?w.extend({},e):{complete:n||!n&&t||g(e)&&e,duration:e,easing:n&&t||t&&!g(t)&&t};return w.fx.off?r.duration=0:"number"!=typeof r.duration&&(r.duration in w.fx.speeds?r.duration=w.fx.speeds[r.duration]:r.duration=w.fx.speeds._default),null!=r.queue&&!0!==r.queue||(r.queue="fx"),r.old=r.complete,r.complete=function(){g(r.old)&&r.old.call(this),r.queue&&w.dequeue(this,r.queue)},r},w.fn.extend({fadeTo:function(e,t,n,r){return this.filter(ae).css("opacity",0).show().end().animate({opacity:t},e,n,r)},animate:function(e,t,n,r){var i=w.isEmptyObject(e),o=w.speed(t,n,r),a=function(){var t=pt(this,w.extend({},e),o);(i||J.get(this,"finish"))&&t.stop(!0)};return a.finish=a,i||!1===o.queue?this.each(a):this.queue(o.queue,a)},stop:function(e,t,n){var r=function(e){var t=e.stop;delete e.stop,t(n)};return"string"!=typeof e&&(n=t,t=e,e=void 0),t&&!1!==e&&this.queue(e||"fx",[]),this.each(function(){var t=!0,i=null!=e&&e+"queueHooks",o=w.timers,a=J.get(this);if(i)a[i]&&a[i].stop&&r(a[i]);else for(i in a)a[i]&&a[i].stop&&ot.test(i)&&r(a[i]);for(i=o.length;i--;)o[i].elem!==this||null!=e&&o[i].queue!==e||(o[i].anim.stop(n),t=!1,o.splice(i,1));!t&&n||w.dequeue(this,e)})},finish:function(e){return!1!==e&&(e=e||"fx"),this.each(function(){var t,n=J.get(this),r=n[e+"queue"],i=n[e+"queueHooks"],o=w.timers,a=r?r.length:0;for(n.finish=!0,w.queue(this,e,[]),i&&i.stop&&i.stop.call(this,!0),t=o.length;t--;)o[t].elem===this&&o[t].queue===e&&(o[t].anim.stop(!0),o.splice(t,1));for(t=0;t<a;t++)r[t]&&r[t].finish&&r[t].finish.call(this);delete n.finish})}}),w.each(["toggle","show","hide"],function(e,t){var n=w.fn[t];w.fn[t]=function(e,r,i){return null==e||"boolean"==typeof e?n.apply(this,arguments):this.animate(ut(t,!0),e,r,i)}}),w.each({slideDown:ut("show"),slideUp:ut("hide"),slideToggle:ut("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(e,t){w.fn[e]=function(e,n,r){return this.animate(t,e,n,r)}}),w.timers=[],w.fx.tick=function(){var e,t=0,n=w.timers;for(nt=Date.now();t<n.length;t++)(e=n[t])()||n[t]!==e||n.splice(t--,1);n.length||w.fx.stop(),nt=void 0},w.fx.timer=function(e){w.timers.push(e),w.fx.start()},w.fx.interval=13,w.fx.start=function(){rt||(rt=!0,at())},w.fx.stop=function(){rt=null},w.fx.speeds={slow:600,fast:200,_default:400},w.fn.delay=function(t,n){return t=w.fx?w.fx.speeds[t]||t:t,n=n||"fx",this.queue(n,function(n,r){var i=e.setTimeout(n,t);r.stop=function(){e.clearTimeout(i)}})},function(){var e=r.createElement("input"),t=r.createElement("select").appendChild(r.createElement("option"));e.type="checkbox",h.checkOn=""!==e.value,h.optSelected=t.selected,(e=r.createElement("input")).value="t",e.type="radio",h.radioValue="t"===e.value}();var dt,ht=w.expr.attrHandle;w.fn.extend({attr:function(e,t){return z(this,w.attr,e,t,arguments.length>1)},removeAttr:function(e){return this.each(function(){w.removeAttr(this,e)})}}),w.extend({attr:function(e,t,n){var r,i,o=e.nodeType;if(3!==o&&8!==o&&2!==o)return"undefined"==typeof e.getAttribute?w.prop(e,t,n):(1===o&&w.isXMLDoc(e)||(i=w.attrHooks[t.toLowerCase()]||(w.expr.match.bool.test(t)?dt:void 0)),void 0!==n?null===n?void w.removeAttr(e,t):i&&"set"in i&&void 0!==(r=i.set(e,n,t))?r:(e.setAttribute(t,n+""),n):i&&"get"in i&&null!==(r=i.get(e,t))?r:null==(r=w.find.attr(e,t))?void 0:r)},attrHooks:{type:{set:function(e,t){if(!h.radioValue&&"radio"===t&&N(e,"input")){var n=e.value;return e.setAttribute("type",t),n&&(e.value=n),t}}}},removeAttr:function(e,t){var n,r=0,i=t&&t.match(M);if(i&&1===e.nodeType)while(n=i[r++])e.removeAttribute(n)}}),dt={set:function(e,t,n){return!1===t?w.removeAttr(e,n):e.setAttribute(n,n),n}},w.each(w.expr.match.bool.source.match(/\w+/g),function(e,t){var n=ht[t]||w.find.attr;ht[t]=function(e,t,r){var i,o,a=t.toLowerCase();return r||(o=ht[a],ht[a]=i,i=null!=n(e,t,r)?a:null,ht[a]=o),i}});var gt=/^(?:input|select|textarea|button)$/i,yt=/^(?:a|area)$/i;w.fn.extend({prop:function(e,t){return z(this,w.prop,e,t,arguments.length>1)},removeProp:function(e){return this.each(function(){delete this[w.propFix[e]||e]})}}),w.extend({prop:function(e,t,n){var r,i,o=e.nodeType;if(3!==o&&8!==o&&2!==o)return 1===o&&w.isXMLDoc(e)||(t=w.propFix[t]||t,i=w.propHooks[t]),void 0!==n?i&&"set"in i&&void 0!==(r=i.set(e,n,t))?r:e[t]=n:i&&"get"in i&&null!==(r=i.get(e,t))?r:e[t]},propHooks:{tabIndex:{get:function(e){var t=w.find.attr(e,"tabindex");return t?parseInt(t,10):gt.test(e.nodeName)||yt.test(e.nodeName)&&e.href?0:-1}}},propFix:{"for":"htmlFor","class":"className"}}),h.optSelected||(w.propHooks.selected={get:function(e){var t=e.parentNode;return t&&t.parentNode&&t.parentNode.selectedIndex,null},set:function(e){var t=e.parentNode;t&&(t.selectedIndex,t.parentNode&&t.parentNode.selectedIndex)}}),w.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],function(){w.propFix[this.toLowerCase()]=this});function vt(e){return(e.match(M)||[]).join(" ")}function mt(e){return e.getAttribute&&e.getAttribute("class")||""}function xt(e){return Array.isArray(e)?e:"string"==typeof e?e.match(M)||[]:[]}w.fn.extend({addClass:function(e){var t,n,r,i,o,a,s,u=0;if(g(e))return this.each(function(t){w(this).addClass(e.call(this,t,mt(this)))});if((t=xt(e)).length)while(n=this[u++])if(i=mt(n),r=1===n.nodeType&&" "+vt(i)+" "){a=0;while(o=t[a++])r.indexOf(" "+o+" ")<0&&(r+=o+" ");i!==(s=vt(r))&&n.setAttribute("class",s)}return this},removeClass:function(e){var t,n,r,i,o,a,s,u=0;if(g(e))return this.each(function(t){w(this).removeClass(e.call(this,t,mt(this)))});if(!arguments.length)return this.attr("class","");if((t=xt(e)).length)while(n=this[u++])if(i=mt(n),r=1===n.nodeType&&" "+vt(i)+" "){a=0;while(o=t[a++])while(r.indexOf(" "+o+" ")>-1)r=r.replace(" "+o+" "," ");i!==(s=vt(r))&&n.setAttribute("class",s)}return this},toggleClass:function(e,t){var n=typeof e,r="string"===n||Array.isArray(e);return"boolean"==typeof t&&r?t?this.addClass(e):this.removeClass(e):g(e)?this.each(function(n){w(this).toggleClass(e.call(this,n,mt(this),t),t)}):this.each(function(){var t,i,o,a;if(r){i=0,o=w(this),a=xt(e);while(t=a[i++])o.hasClass(t)?o.removeClass(t):o.addClass(t)}else void 0!==e&&"boolean"!==n||((t=mt(this))&&J.set(this,"__className__",t),this.setAttribute&&this.setAttribute("class",t||!1===e?"":J.get(this,"__className__")||""))})},hasClass:function(e){var t,n,r=0;t=" "+e+" ";while(n=this[r++])if(1===n.nodeType&&(" "+vt(mt(n))+" ").indexOf(t)>-1)return!0;return!1}});var bt=/\r/g;w.fn.extend({val:function(e){var t,n,r,i=this[0];{if(arguments.length)return r=g(e),this.each(function(n){var i;1===this.nodeType&&(null==(i=r?e.call(this,n,w(this).val()):e)?i="":"number"==typeof i?i+="":Array.isArray(i)&&(i=w.map(i,function(e){return null==e?"":e+""})),(t=w.valHooks[this.type]||w.valHooks[this.nodeName.toLowerCase()])&&"set"in t&&void 0!==t.set(this,i,"value")||(this.value=i))});if(i)return(t=w.valHooks[i.type]||w.valHooks[i.nodeName.toLowerCase()])&&"get"in t&&void 0!==(n=t.get(i,"value"))?n:"string"==typeof(n=i.value)?n.replace(bt,""):null==n?"":n}}}),w.extend({valHooks:{option:{get:function(e){var t=w.find.attr(e,"value");return null!=t?t:vt(w.text(e))}},select:{get:function(e){var t,n,r,i=e.options,o=e.selectedIndex,a="select-one"===e.type,s=a?null:[],u=a?o+1:i.length;for(r=o<0?u:a?o:0;r<u;r++)if(((n=i[r]).selected||r===o)&&!n.disabled&&(!n.parentNode.disabled||!N(n.parentNode,"optgroup"))){if(t=w(n).val(),a)return t;s.push(t)}return s},set:function(e,t){var n,r,i=e.options,o=w.makeArray(t),a=i.length;while(a--)((r=i[a]).selected=w.inArray(w.valHooks.option.get(r),o)>-1)&&(n=!0);return n||(e.selectedIndex=-1),o}}}}),w.each(["radio","checkbox"],function(){w.valHooks[this]={set:function(e,t){if(Array.isArray(t))return e.checked=w.inArray(w(e).val(),t)>-1}},h.checkOn||(w.valHooks[this].get=function(e){return null===e.getAttribute("value")?"on":e.value})}),h.focusin="onfocusin"in e;var wt=/^(?:focusinfocus|focusoutblur)$/,Tt=function(e){e.stopPropagation()};w.extend(w.event,{trigger:function(t,n,i,o){var a,s,u,l,c,p,d,h,v=[i||r],m=f.call(t,"type")?t.type:t,x=f.call(t,"namespace")?t.namespace.split("."):[];if(s=h=u=i=i||r,3!==i.nodeType&&8!==i.nodeType&&!wt.test(m+w.event.triggered)&&(m.indexOf(".")>-1&&(m=(x=m.split(".")).shift(),x.sort()),c=m.indexOf(":")<0&&"on"+m,t=t[w.expando]?t:new w.Event(m,"object"==typeof t&&t),t.isTrigger=o?2:3,t.namespace=x.join("."),t.rnamespace=t.namespace?new RegExp("(^|\\.)"+x.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,t.result=void 0,t.target||(t.target=i),n=null==n?[t]:w.makeArray(n,[t]),d=w.event.special[m]||{},o||!d.trigger||!1!==d.trigger.apply(i,n))){if(!o&&!d.noBubble&&!y(i)){for(l=d.delegateType||m,wt.test(l+m)||(s=s.parentNode);s;s=s.parentNode)v.push(s),u=s;u===(i.ownerDocument||r)&&v.push(u.defaultView||u.parentWindow||e)}a=0;while((s=v[a++])&&!t.isPropagationStopped())h=s,t.type=a>1?l:d.bindType||m,(p=(J.get(s,"events")||{})[t.type]&&J.get(s,"handle"))&&p.apply(s,n),(p=c&&s[c])&&p.apply&&Y(s)&&(t.result=p.apply(s,n),!1===t.result&&t.preventDefault());return t.type=m,o||t.isDefaultPrevented()||d._default&&!1!==d._default.apply(v.pop(),n)||!Y(i)||c&&g(i[m])&&!y(i)&&((u=i[c])&&(i[c]=null),w.event.triggered=m,t.isPropagationStopped()&&h.addEventListener(m,Tt),i[m](),t.isPropagationStopped()&&h.removeEventListener(m,Tt),w.event.triggered=void 0,u&&(i[c]=u)),t.result}},simulate:function(e,t,n){var r=w.extend(new w.Event,n,{type:e,isSimulated:!0});w.event.trigger(r,null,t)}}),w.fn.extend({trigger:function(e,t){return this.each(function(){w.event.trigger(e,t,this)})},triggerHandler:function(e,t){var n=this[0];if(n)return w.event.trigger(e,t,n,!0)}}),h.focusin||w.each({focus:"focusin",blur:"focusout"},function(e,t){var n=function(e){w.event.simulate(t,e.target,w.event.fix(e))};w.event.special[t]={setup:function(){var r=this.ownerDocument||this,i=J.access(r,t);i||r.addEventListener(e,n,!0),J.access(r,t,(i||0)+1)},teardown:function(){var r=this.ownerDocument||this,i=J.access(r,t)-1;i?J.access(r,t,i):(r.removeEventListener(e,n,!0),J.remove(r,t))}}});var Ct=e.location,Et=Date.now(),kt=/\?/;w.parseXML=function(t){var n;if(!t||"string"!=typeof t)return null;try{n=(new e.DOMParser).parseFromString(t,"text/xml")}catch(e){n=void 0}return n&&!n.getElementsByTagName("parsererror").length||w.error("Invalid XML: "+t),n};var St=/\[\]$/,Dt=/\r?\n/g,Nt=/^(?:submit|button|image|reset|file)$/i,At=/^(?:input|select|textarea|keygen)/i;function jt(e,t,n,r){var i;if(Array.isArray(t))w.each(t,function(t,i){n||St.test(e)?r(e,i):jt(e+"["+("object"==typeof i&&null!=i?t:"")+"]",i,n,r)});else if(n||"object"!==x(t))r(e,t);else for(i in t)jt(e+"["+i+"]",t[i],n,r)}w.param=function(e,t){var n,r=[],i=function(e,t){var n=g(t)?t():t;r[r.length]=encodeURIComponent(e)+"="+encodeURIComponent(null==n?"":n)};if(Array.isArray(e)||e.jquery&&!w.isPlainObject(e))w.each(e,function(){i(this.name,this.value)});else for(n in e)jt(n,e[n],t,i);return r.join("&")},w.fn.extend({serialize:function(){return w.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var e=w.prop(this,"elements");return e?w.makeArray(e):this}).filter(function(){var e=this.type;return this.name&&!w(this).is(":disabled")&&At.test(this.nodeName)&&!Nt.test(e)&&(this.checked||!pe.test(e))}).map(function(e,t){var n=w(this).val();return null==n?null:Array.isArray(n)?w.map(n,function(e){return{name:t.name,value:e.replace(Dt,"\r\n")}}):{name:t.name,value:n.replace(Dt,"\r\n")}}).get()}});var qt=/%20/g,Lt=/#.*$/,Ht=/([?&])_=[^&]*/,Ot=/^(.*?):[ \t]*([^\r\n]*)$/gm,Pt=/^(?:about|app|app-storage|.+-extension|file|res|widget):$/,Mt=/^(?:GET|HEAD)$/,Rt=/^\/\//,It={},Wt={},$t="*/".concat("*"),Bt=r.createElement("a");Bt.href=Ct.href;function Ft(e){return function(t,n){"string"!=typeof t&&(n=t,t="*");var r,i=0,o=t.toLowerCase().match(M)||[];if(g(n))while(r=o[i++])"+"===r[0]?(r=r.slice(1)||"*",(e[r]=e[r]||[]).unshift(n)):(e[r]=e[r]||[]).push(n)}}function _t(e,t,n,r){var i={},o=e===Wt;function a(s){var u;return i[s]=!0,w.each(e[s]||[],function(e,s){var l=s(t,n,r);return"string"!=typeof l||o||i[l]?o?!(u=l):void 0:(t.dataTypes.unshift(l),a(l),!1)}),u}return a(t.dataTypes[0])||!i["*"]&&a("*")}function zt(e,t){var n,r,i=w.ajaxSettings.flatOptions||{};for(n in t)void 0!==t[n]&&((i[n]?e:r||(r={}))[n]=t[n]);return r&&w.extend(!0,e,r),e}function Xt(e,t,n){var r,i,o,a,s=e.contents,u=e.dataTypes;while("*"===u[0])u.shift(),void 0===r&&(r=e.mimeType||t.getResponseHeader("Content-Type"));if(r)for(i in s)if(s[i]&&s[i].test(r)){u.unshift(i);break}if(u[0]in n)o=u[0];else{for(i in n){if(!u[0]||e.converters[i+" "+u[0]]){o=i;break}a||(a=i)}o=o||a}if(o)return o!==u[0]&&u.unshift(o),n[o]}function Ut(e,t,n,r){var i,o,a,s,u,l={},c=e.dataTypes.slice();if(c[1])for(a in e.converters)l[a.toLowerCase()]=e.converters[a];o=c.shift();while(o)if(e.responseFields[o]&&(n[e.responseFields[o]]=t),!u&&r&&e.dataFilter&&(t=e.dataFilter(t,e.dataType)),u=o,o=c.shift())if("*"===o)o=u;else if("*"!==u&&u!==o){if(!(a=l[u+" "+o]||l["* "+o]))for(i in l)if((s=i.split(" "))[1]===o&&(a=l[u+" "+s[0]]||l["* "+s[0]])){!0===a?a=l[i]:!0!==l[i]&&(o=s[0],c.unshift(s[1]));break}if(!0!==a)if(a&&e["throws"])t=a(t);else try{t=a(t)}catch(e){return{state:"parsererror",error:a?e:"No conversion from "+u+" to "+o}}}return{state:"success",data:t}}w.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:Ct.href,type:"GET",isLocal:Pt.test(Ct.protocol),global:!0,processData:!0,async:!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":$t,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/\bxml\b/,html:/\bhtml/,json:/\bjson\b/},responseFields:{xml:"responseXML",text:"responseText",json:"responseJSON"},converters:{"* text":String,"text html":!0,"text json":JSON.parse,"text xml":w.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(e,t){return t?zt(zt(e,w.ajaxSettings),t):zt(w.ajaxSettings,e)},ajaxPrefilter:Ft(It),ajaxTransport:Ft(Wt),ajax:function(t,n){"object"==typeof t&&(n=t,t=void 0),n=n||{};var i,o,a,s,u,l,c,f,p,d,h=w.ajaxSetup({},n),g=h.context||h,y=h.context&&(g.nodeType||g.jquery)?w(g):w.event,v=w.Deferred(),m=w.Callbacks("once memory"),x=h.statusCode||{},b={},T={},C="canceled",E={readyState:0,getResponseHeader:function(e){var t;if(c){if(!s){s={};while(t=Ot.exec(a))s[t[1].toLowerCase()]=t[2]}t=s[e.toLowerCase()]}return null==t?null:t},getAllResponseHeaders:function(){return c?a:null},setRequestHeader:function(e,t){return null==c&&(e=T[e.toLowerCase()]=T[e.toLowerCase()]||e,b[e]=t),this},overrideMimeType:function(e){return null==c&&(h.mimeType=e),this},statusCode:function(e){var t;if(e)if(c)E.always(e[E.status]);else for(t in e)x[t]=[x[t],e[t]];return this},abort:function(e){var t=e||C;return i&&i.abort(t),k(0,t),this}};if(v.promise(E),h.url=((t||h.url||Ct.href)+"").replace(Rt,Ct.protocol+"//"),h.type=n.method||n.type||h.method||h.type,h.dataTypes=(h.dataType||"*").toLowerCase().match(M)||[""],null==h.crossDomain){l=r.createElement("a");try{l.href=h.url,l.href=l.href,h.crossDomain=Bt.protocol+"//"+Bt.host!=l.protocol+"//"+l.host}catch(e){h.crossDomain=!0}}if(h.data&&h.processData&&"string"!=typeof h.data&&(h.data=w.param(h.data,h.traditional)),_t(It,h,n,E),c)return E;(f=w.event&&h.global)&&0==w.active++&&w.event.trigger("ajaxStart"),h.type=h.type.toUpperCase(),h.hasContent=!Mt.test(h.type),o=h.url.replace(Lt,""),h.hasContent?h.data&&h.processData&&0===(h.contentType||"").indexOf("application/x-www-form-urlencoded")&&(h.data=h.data.replace(qt,"+")):(d=h.url.slice(o.length),h.data&&(h.processData||"string"==typeof h.data)&&(o+=(kt.test(o)?"&":"?")+h.data,delete h.data),!1===h.cache&&(o=o.replace(Ht,"$1"),d=(kt.test(o)?"&":"?")+"_="+Et+++d),h.url=o+d),h.ifModified&&(w.lastModified[o]&&E.setRequestHeader("If-Modified-Since",w.lastModified[o]),w.etag[o]&&E.setRequestHeader("If-None-Match",w.etag[o])),(h.data&&h.hasContent&&!1!==h.contentType||n.contentType)&&E.setRequestHeader("Content-Type",h.contentType),E.setRequestHeader("Accept",h.dataTypes[0]&&h.accepts[h.dataTypes[0]]?h.accepts[h.dataTypes[0]]+("*"!==h.dataTypes[0]?", "+$t+"; q=0.01":""):h.accepts["*"]);for(p in h.headers)E.setRequestHeader(p,h.headers[p]);if(h.beforeSend&&(!1===h.beforeSend.call(g,E,h)||c))return E.abort();if(C="abort",m.add(h.complete),E.done(h.success),E.fail(h.error),i=_t(Wt,h,n,E)){if(E.readyState=1,f&&y.trigger("ajaxSend",[E,h]),c)return E;h.async&&h.timeout>0&&(u=e.setTimeout(function(){E.abort("timeout")},h.timeout));try{c=!1,i.send(b,k)}catch(e){if(c)throw e;k(-1,e)}}else k(-1,"No Transport");function k(t,n,r,s){var l,p,d,b,T,C=n;c||(c=!0,u&&e.clearTimeout(u),i=void 0,a=s||"",E.readyState=t>0?4:0,l=t>=200&&t<300||304===t,r&&(b=Xt(h,E,r)),b=Ut(h,b,E,l),l?(h.ifModified&&((T=E.getResponseHeader("Last-Modified"))&&(w.lastModified[o]=T),(T=E.getResponseHeader("etag"))&&(w.etag[o]=T)),204===t||"HEAD"===h.type?C="nocontent":304===t?C="notmodified":(C=b.state,p=b.data,l=!(d=b.error))):(d=C,!t&&C||(C="error",t<0&&(t=0))),E.status=t,E.statusText=(n||C)+"",l?v.resolveWith(g,[p,C,E]):v.rejectWith(g,[E,C,d]),E.statusCode(x),x=void 0,f&&y.trigger(l?"ajaxSuccess":"ajaxError",[E,h,l?p:d]),m.fireWith(g,[E,C]),f&&(y.trigger("ajaxComplete",[E,h]),--w.active||w.event.trigger("ajaxStop")))}return E},getJSON:function(e,t,n){return w.get(e,t,n,"json")},getScript:function(e,t){return w.get(e,void 0,t,"script")}}),w.each(["get","post"],function(e,t){w[t]=function(e,n,r,i){return g(n)&&(i=i||r,r=n,n=void 0),w.ajax(w.extend({url:e,type:t,dataType:i,data:n,success:r},w.isPlainObject(e)&&e))}}),w._evalUrl=function(e){return w.ajax({url:e,type:"GET",dataType:"script",cache:!0,async:!1,global:!1,"throws":!0})},w.fn.extend({wrapAll:function(e){var t;return this[0]&&(g(e)&&(e=e.call(this[0])),t=w(e,this[0].ownerDocument).eq(0).clone(!0),this[0].parentNode&&t.insertBefore(this[0]),t.map(function(){var e=this;while(e.firstElementChild)e=e.firstElementChild;return e}).append(this)),this},wrapInner:function(e){return g(e)?this.each(function(t){w(this).wrapInner(e.call(this,t))}):this.each(function(){var t=w(this),n=t.contents();n.length?n.wrapAll(e):t.append(e)})},wrap:function(e){var t=g(e);return this.each(function(n){w(this).wrapAll(t?e.call(this,n):e)})},unwrap:function(e){return this.parent(e).not("body").each(function(){w(this).replaceWith(this.childNodes)}),this}}),w.expr.pseudos.hidden=function(e){return!w.expr.pseudos.visible(e)},w.expr.pseudos.visible=function(e){return!!(e.offsetWidth||e.offsetHeight||e.getClientRects().length)},w.ajaxSettings.xhr=function(){try{return new e.XMLHttpRequest}catch(e){}};var Vt={0:200,1223:204},Gt=w.ajaxSettings.xhr();h.cors=!!Gt&&"withCredentials"in Gt,h.ajax=Gt=!!Gt,w.ajaxTransport(function(t){var n,r;if(h.cors||Gt&&!t.crossDomain)return{send:function(i,o){var a,s=t.xhr();if(s.open(t.type,t.url,t.async,t.username,t.password),t.xhrFields)for(a in t.xhrFields)s[a]=t.xhrFields[a];t.mimeType&&s.overrideMimeType&&s.overrideMimeType(t.mimeType),t.crossDomain||i["X-Requested-With"]||(i["X-Requested-With"]="XMLHttpRequest");for(a in i)s.setRequestHeader(a,i[a]);n=function(e){return function(){n&&(n=r=s.onload=s.onerror=s.onabort=s.ontimeout=s.onreadystatechange=null,"abort"===e?s.abort():"error"===e?"number"!=typeof s.status?o(0,"error"):o(s.status,s.statusText):o(Vt[s.status]||s.status,s.statusText,"text"!==(s.responseType||"text")||"string"!=typeof s.responseText?{binary:s.response}:{text:s.responseText},s.getAllResponseHeaders()))}},s.onload=n(),r=s.onerror=s.ontimeout=n("error"),void 0!==s.onabort?s.onabort=r:s.onreadystatechange=function(){4===s.readyState&&e.setTimeout(function(){n&&r()})},n=n("abort");try{s.send(t.hasContent&&t.data||null)}catch(e){if(n)throw e}},abort:function(){n&&n()}}}),w.ajaxPrefilter(function(e){e.crossDomain&&(e.contents.script=!1)}),w.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/\b(?:java|ecma)script\b/},converters:{"text script":function(e){return w.globalEval(e),e}}}),w.ajaxPrefilter("script",function(e){void 0===e.cache&&(e.cache=!1),e.crossDomain&&(e.type="GET")}),w.ajaxTransport("script",function(e){if(e.crossDomain){var t,n;return{send:function(i,o){t=w("<script>").prop({charset:e.scriptCharset,src:e.url}).on("load error",n=function(e){t.remove(),n=null,e&&o("error"===e.type?404:200,e.type)}),r.head.appendChild(t[0])},abort:function(){n&&n()}}}});var Yt=[],Qt=/(=)\?(?=&|$)|\?\?/;w.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var e=Yt.pop()||w.expando+"_"+Et++;return this[e]=!0,e}}),w.ajaxPrefilter("json jsonp",function(t,n,r){var i,o,a,s=!1!==t.jsonp&&(Qt.test(t.url)?"url":"string"==typeof t.data&&0===(t.contentType||"").indexOf("application/x-www-form-urlencoded")&&Qt.test(t.data)&&"data");if(s||"jsonp"===t.dataTypes[0])return i=t.jsonpCallback=g(t.jsonpCallback)?t.jsonpCallback():t.jsonpCallback,s?t[s]=t[s].replace(Qt,"$1"+i):!1!==t.jsonp&&(t.url+=(kt.test(t.url)?"&":"?")+t.jsonp+"="+i),t.converters["script json"]=function(){return a||w.error(i+" was not called"),a[0]},t.dataTypes[0]="json",o=e[i],e[i]=function(){a=arguments},r.always(function(){void 0===o?w(e).removeProp(i):e[i]=o,t[i]&&(t.jsonpCallback=n.jsonpCallback,Yt.push(i)),a&&g(o)&&o(a[0]),a=o=void 0}),"script"}),h.createHTMLDocument=function(){var e=r.implementation.createHTMLDocument("").body;return e.innerHTML="<form></form><form></form>",2===e.childNodes.length}(),w.parseHTML=function(e,t,n){if("string"!=typeof e)return[];"boolean"==typeof t&&(n=t,t=!1);var i,o,a;return t||(h.createHTMLDocument?((i=(t=r.implementation.createHTMLDocument("")).createElement("base")).href=r.location.href,t.head.appendChild(i)):t=r),o=A.exec(e),a=!n&&[],o?[t.createElement(o[1])]:(o=xe([e],t,a),a&&a.length&&w(a).remove(),w.merge([],o.childNodes))},w.fn.load=function(e,t,n){var r,i,o,a=this,s=e.indexOf(" ");return s>-1&&(r=vt(e.slice(s)),e=e.slice(0,s)),g(t)?(n=t,t=void 0):t&&"object"==typeof t&&(i="POST"),a.length>0&&w.ajax({url:e,type:i||"GET",dataType:"html",data:t}).done(function(e){o=arguments,a.html(r?w("<div>").append(w.parseHTML(e)).find(r):e)}).always(n&&function(e,t){a.each(function(){n.apply(this,o||[e.responseText,t,e])})}),this},w.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],function(e,t){w.fn[t]=function(e){return this.on(t,e)}}),w.expr.pseudos.animated=function(e){return w.grep(w.timers,function(t){return e===t.elem}).length},w.offset={setOffset:function(e,t,n){var r,i,o,a,s,u,l,c=w.css(e,"position"),f=w(e),p={};"static"===c&&(e.style.position="relative"),s=f.offset(),o=w.css(e,"top"),u=w.css(e,"left"),(l=("absolute"===c||"fixed"===c)&&(o+u).indexOf("auto")>-1)?(a=(r=f.position()).top,i=r.left):(a=parseFloat(o)||0,i=parseFloat(u)||0),g(t)&&(t=t.call(e,n,w.extend({},s))),null!=t.top&&(p.top=t.top-s.top+a),null!=t.left&&(p.left=t.left-s.left+i),"using"in t?t.using.call(e,p):f.css(p)}},w.fn.extend({offset:function(e){if(arguments.length)return void 0===e?this:this.each(function(t){w.offset.setOffset(this,e,t)});var t,n,r=this[0];if(r)return r.getClientRects().length?(t=r.getBoundingClientRect(),n=r.ownerDocument.defaultView,{top:t.top+n.pageYOffset,left:t.left+n.pageXOffset}):{top:0,left:0}},position:function(){if(this[0]){var e,t,n,r=this[0],i={top:0,left:0};if("fixed"===w.css(r,"position"))t=r.getBoundingClientRect();else{t=this.offset(),n=r.ownerDocument,e=r.offsetParent||n.documentElement;while(e&&(e===n.body||e===n.documentElement)&&"static"===w.css(e,"position"))e=e.parentNode;e&&e!==r&&1===e.nodeType&&((i=w(e).offset()).top+=w.css(e,"borderTopWidth",!0),i.left+=w.css(e,"borderLeftWidth",!0))}return{top:t.top-i.top-w.css(r,"marginTop",!0),left:t.left-i.left-w.css(r,"marginLeft",!0)}}},offsetParent:function(){return this.map(function(){var e=this.offsetParent;while(e&&"static"===w.css(e,"position"))e=e.offsetParent;return e||be})}}),w.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(e,t){var n="pageYOffset"===t;w.fn[e]=function(r){return z(this,function(e,r,i){var o;if(y(e)?o=e:9===e.nodeType&&(o=e.defaultView),void 0===i)return o?o[t]:e[r];o?o.scrollTo(n?o.pageXOffset:i,n?i:o.pageYOffset):e[r]=i},e,r,arguments.length)}}),w.each(["top","left"],function(e,t){w.cssHooks[t]=_e(h.pixelPosition,function(e,n){if(n)return n=Fe(e,t),We.test(n)?w(e).position()[t]+"px":n})}),w.each({Height:"height",Width:"width"},function(e,t){w.each({padding:"inner"+e,content:t,"":"outer"+e},function(n,r){w.fn[r]=function(i,o){var a=arguments.length&&(n||"boolean"!=typeof i),s=n||(!0===i||!0===o?"margin":"border");return z(this,function(t,n,i){var o;return y(t)?0===r.indexOf("outer")?t["inner"+e]:t.document.documentElement["client"+e]:9===t.nodeType?(o=t.documentElement,Math.max(t.body["scroll"+e],o["scroll"+e],t.body["offset"+e],o["offset"+e],o["client"+e])):void 0===i?w.css(t,n,s):w.style(t,n,i,s)},t,a?i:void 0,a)}})}),w.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "),function(e,t){w.fn[t]=function(e,n){return arguments.length>0?this.on(t,null,e,n):this.trigger(t)}}),w.fn.extend({hover:function(e,t){return this.mouseenter(e).mouseleave(t||e)}}),w.fn.extend({bind:function(e,t,n){return this.on(e,null,t,n)},unbind:function(e,t){return this.off(e,null,t)},delegate:function(e,t,n,r){return this.on(t,e,n,r)},undelegate:function(e,t,n){return 1===arguments.length?this.off(e,"**"):this.off(t,e||"**",n)}}),w.proxy=function(e,t){var n,r,i;if("string"==typeof t&&(n=e[t],t=e,e=n),g(e))return r=o.call(arguments,2),i=function(){return e.apply(t||this,r.concat(o.call(arguments)))},i.guid=e.guid=e.guid||w.guid++,i},w.holdReady=function(e){e?w.readyWait++:w.ready(!0)},w.isArray=Array.isArray,w.parseJSON=JSON.parse,w.nodeName=N,w.isFunction=g,w.isWindow=y,w.camelCase=G,w.type=x,w.now=Date.now,w.isNumeric=function(e){var t=w.type(e);return("number"===t||"string"===t)&&!isNaN(e-parseFloat(e))},"function"==typeof define&&define.amd&&define("jquery",[],function(){return w});var Jt=e.jQuery,Kt=e.$;return w.noConflict=function(t){return e.$===w&&(e.$=Kt),t&&e.jQuery===w&&(e.jQuery=Jt),w},t||(e.jQuery=e.$=w),w});

/*! jQuery UI - v1.12.1 - 2019-01-20
* http://jqueryui.com
* Includes: data.js, disable-selection.js, effect.js, effects/effect-blind.js, effects/effect-bounce.js, effects/effect-clip.js, effects/effect-drop.js, effects/effect-explode.js, effects/effect-fade.js, effects/effect-fold.js, effects/effect-highlight.js, effects/effect-puff.js, effects/effect-pulsate.js, effects/effect-scale.js, effects/effect-shake.js, effects/effect-size.js, effects/effect-slide.js, effects/effect-transfer.js, focusable.js, form-reset-mixin.js, jquery-1-7.js, keycode.js, labels.js, position.js, scroll-parent.js, tabbable.js, unique-id.js, widget.js, widgets/accordion.js, widgets/autocomplete.js, widgets/button.js, widgets/checkboxradio.js, widgets/controlgroup.js, widgets/datepicker.js, widgets/dialog.js, widgets/draggable.js, widgets/droppable.js, widgets/menu.js, widgets/mouse.js, widgets/progressbar.js, widgets/resizable.js, widgets/selectable.js, widgets/selectmenu.js, widgets/slider.js, widgets/sortable.js, widgets/spinner.js, widgets/tabs.js, widgets/tooltip.js
* Copyright jQuery Foundation and other contributors; Licensed MIT */

(function(t){"function"==typeof define&&define.amd?define(["jquery"],t):t(jQuery)})(function(t){function e(t){for(var e=t.css("visibility");"inherit"===e;)t=t.parent(),e=t.css("visibility");return"hidden"!==e}function i(t){for(var e,i;t.length&&t[0]!==document;){if(e=t.css("position"),("absolute"===e||"relative"===e||"fixed"===e)&&(i=parseInt(t.css("zIndex"),10),!isNaN(i)&&0!==i))return i;t=t.parent()}return 0}function s(){this._curInst=null,this._keyEvent=!1,this._disabledInputs=[],this._datepickerShowing=!1,this._inDialog=!1,this._mainDivId="ui-datepicker-div",this._inlineClass="ui-datepicker-inline",this._appendClass="ui-datepicker-append",this._triggerClass="ui-datepicker-trigger",this._dialogClass="ui-datepicker-dialog",this._disableClass="ui-datepicker-disabled",this._unselectableClass="ui-datepicker-unselectable",this._currentClass="ui-datepicker-current-day",this._dayOverClass="ui-datepicker-days-cell-over",this.regional=[],this.regional[""]={closeText:"Done",prevText:"Prev",nextText:"Next",currentText:"Today",monthNames:["January","February","March","April","May","June","July","August","September","October","November","December"],monthNamesShort:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],dayNames:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],dayNamesShort:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],dayNamesMin:["Su","Mo","Tu","We","Th","Fr","Sa"],weekHeader:"Wk",dateFormat:"mm/dd/yy",firstDay:0,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""},this._defaults={showOn:"focus",showAnim:"fadeIn",showOptions:{},defaultDate:null,appendText:"",buttonText:"...",buttonImage:"",buttonImageOnly:!1,hideIfNoPrevNext:!1,navigationAsDateFormat:!1,gotoCurrent:!1,changeMonth:!1,changeYear:!1,yearRange:"c-10:c+10",showOtherMonths:!1,selectOtherMonths:!1,showWeek:!1,calculateWeek:this.iso8601Week,shortYearCutoff:"+10",minDate:null,maxDate:null,duration:"fast",beforeShowDay:null,beforeShow:null,onSelect:null,onChangeMonthYear:null,onClose:null,numberOfMonths:1,showCurrentAtPos:0,stepMonths:1,stepBigMonths:12,altField:"",altFormat:"",constrainInput:!0,showButtonPanel:!1,autoSize:!1,disabled:!1},t.extend(this._defaults,this.regional[""]),this.regional.en=t.extend(!0,{},this.regional[""]),this.regional["en-US"]=t.extend(!0,{},this.regional.en),this.dpDiv=n(t("<div id='"+this._mainDivId+"' class='ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>"))}function n(e){var i="button, .ui-datepicker-prev, .ui-datepicker-next, .ui-datepicker-calendar td a";return e.on("mouseout",i,function(){t(this).removeClass("ui-state-hover"),-1!==this.className.indexOf("ui-datepicker-prev")&&t(this).removeClass("ui-datepicker-prev-hover"),-1!==this.className.indexOf("ui-datepicker-next")&&t(this).removeClass("ui-datepicker-next-hover")}).on("mouseover",i,o)}function o(){t.datepicker._isDisabledDatepicker(m.inline?m.dpDiv.parent()[0]:m.input[0])||(t(this).parents(".ui-datepicker-calendar").find("a").removeClass("ui-state-hover"),t(this).addClass("ui-state-hover"),-1!==this.className.indexOf("ui-datepicker-prev")&&t(this).addClass("ui-datepicker-prev-hover"),-1!==this.className.indexOf("ui-datepicker-next")&&t(this).addClass("ui-datepicker-next-hover"))}function a(e,i){t.extend(e,i);for(var s in i)null==i[s]&&(e[s]=i[s]);return e}function r(t){return function(){var e=this.element.val();t.apply(this,arguments),this._refresh(),e!==this.element.val()&&this._trigger("change")}}t.ui=t.ui||{},t.ui.version="1.12.1",t.extend(t.expr[":"],{data:t.expr.createPseudo?t.expr.createPseudo(function(e){return function(i){return!!t.data(i,e)}}):function(e,i,s){return!!t.data(e,s[3])}}),t.fn.extend({disableSelection:function(){var t="onselectstart"in document.createElement("div")?"selectstart":"mousedown";return function(){return this.on(t+".ui-disableSelection",function(t){t.preventDefault()})}}(),enableSelection:function(){return this.off(".ui-disableSelection")}});var l="ui-effects-",h="ui-effects-style",c="ui-effects-animated",u=t;t.effects={effect:{}},function(t,e){function i(t,e,i){var s=u[e.type]||{};return null==t?i||!e.def?null:e.def:(t=s.floor?~~t:parseFloat(t),isNaN(t)?e.def:s.mod?(t+s.mod)%s.mod:0>t?0:t>s.max?s.max:t)}function s(i){var s=h(),n=s._rgba=[];return i=i.toLowerCase(),f(l,function(t,o){var a,r=o.re.exec(i),l=r&&o.parse(r),h=o.space||"rgba";return l?(a=s[h](l),s[c[h].cache]=a[c[h].cache],n=s._rgba=a._rgba,!1):e}),n.length?("0,0,0,0"===n.join()&&t.extend(n,o.transparent),s):o[i]}function n(t,e,i){return i=(i+1)%1,1>6*i?t+6*(e-t)*i:1>2*i?e:2>3*i?t+6*(e-t)*(2/3-i):t}var o,a="backgroundColor borderBottomColor borderLeftColor borderRightColor borderTopColor color columnRuleColor outlineColor textDecorationColor textEmphasisColor",r=/^([\-+])=\s*(\d+\.?\d*)/,l=[{re:/rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,parse:function(t){return[t[1],t[2],t[3],t[4]]}},{re:/rgba?\(\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,parse:function(t){return[2.55*t[1],2.55*t[2],2.55*t[3],t[4]]}},{re:/#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})/,parse:function(t){return[parseInt(t[1],16),parseInt(t[2],16),parseInt(t[3],16)]}},{re:/#([a-f0-9])([a-f0-9])([a-f0-9])/,parse:function(t){return[parseInt(t[1]+t[1],16),parseInt(t[2]+t[2],16),parseInt(t[3]+t[3],16)]}},{re:/hsla?\(\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,space:"hsla",parse:function(t){return[t[1],t[2]/100,t[3]/100,t[4]]}}],h=t.Color=function(e,i,s,n){return new t.Color.fn.parse(e,i,s,n)},c={rgba:{props:{red:{idx:0,type:"byte"},green:{idx:1,type:"byte"},blue:{idx:2,type:"byte"}}},hsla:{props:{hue:{idx:0,type:"degrees"},saturation:{idx:1,type:"percent"},lightness:{idx:2,type:"percent"}}}},u={"byte":{floor:!0,max:255},percent:{max:1},degrees:{mod:360,floor:!0}},d=h.support={},p=t("<p>")[0],f=t.each;p.style.cssText="background-color:rgba(1,1,1,.5)",d.rgba=p.style.backgroundColor.indexOf("rgba")>-1,f(c,function(t,e){e.cache="_"+t,e.props.alpha={idx:3,type:"percent",def:1}}),h.fn=t.extend(h.prototype,{parse:function(n,a,r,l){if(n===e)return this._rgba=[null,null,null,null],this;(n.jquery||n.nodeType)&&(n=t(n).css(a),a=e);var u=this,d=t.type(n),p=this._rgba=[];return a!==e&&(n=[n,a,r,l],d="array"),"string"===d?this.parse(s(n)||o._default):"array"===d?(f(c.rgba.props,function(t,e){p[e.idx]=i(n[e.idx],e)}),this):"object"===d?(n instanceof h?f(c,function(t,e){n[e.cache]&&(u[e.cache]=n[e.cache].slice())}):f(c,function(e,s){var o=s.cache;f(s.props,function(t,e){if(!u[o]&&s.to){if("alpha"===t||null==n[t])return;u[o]=s.to(u._rgba)}u[o][e.idx]=i(n[t],e,!0)}),u[o]&&0>t.inArray(null,u[o].slice(0,3))&&(u[o][3]=1,s.from&&(u._rgba=s.from(u[o])))}),this):e},is:function(t){var i=h(t),s=!0,n=this;return f(c,function(t,o){var a,r=i[o.cache];return r&&(a=n[o.cache]||o.to&&o.to(n._rgba)||[],f(o.props,function(t,i){return null!=r[i.idx]?s=r[i.idx]===a[i.idx]:e})),s}),s},_space:function(){var t=[],e=this;return f(c,function(i,s){e[s.cache]&&t.push(i)}),t.pop()},transition:function(t,e){var s=h(t),n=s._space(),o=c[n],a=0===this.alpha()?h("transparent"):this,r=a[o.cache]||o.to(a._rgba),l=r.slice();return s=s[o.cache],f(o.props,function(t,n){var o=n.idx,a=r[o],h=s[o],c=u[n.type]||{};null!==h&&(null===a?l[o]=h:(c.mod&&(h-a>c.mod/2?a+=c.mod:a-h>c.mod/2&&(a-=c.mod)),l[o]=i((h-a)*e+a,n)))}),this[n](l)},blend:function(e){if(1===this._rgba[3])return this;var i=this._rgba.slice(),s=i.pop(),n=h(e)._rgba;return h(t.map(i,function(t,e){return(1-s)*n[e]+s*t}))},toRgbaString:function(){var e="rgba(",i=t.map(this._rgba,function(t,e){return null==t?e>2?1:0:t});return 1===i[3]&&(i.pop(),e="rgb("),e+i.join()+")"},toHslaString:function(){var e="hsla(",i=t.map(this.hsla(),function(t,e){return null==t&&(t=e>2?1:0),e&&3>e&&(t=Math.round(100*t)+"%"),t});return 1===i[3]&&(i.pop(),e="hsl("),e+i.join()+")"},toHexString:function(e){var i=this._rgba.slice(),s=i.pop();return e&&i.push(~~(255*s)),"#"+t.map(i,function(t){return t=(t||0).toString(16),1===t.length?"0"+t:t}).join("")},toString:function(){return 0===this._rgba[3]?"transparent":this.toRgbaString()}}),h.fn.parse.prototype=h.fn,c.hsla.to=function(t){if(null==t[0]||null==t[1]||null==t[2])return[null,null,null,t[3]];var e,i,s=t[0]/255,n=t[1]/255,o=t[2]/255,a=t[3],r=Math.max(s,n,o),l=Math.min(s,n,o),h=r-l,c=r+l,u=.5*c;return e=l===r?0:s===r?60*(n-o)/h+360:n===r?60*(o-s)/h+120:60*(s-n)/h+240,i=0===h?0:.5>=u?h/c:h/(2-c),[Math.round(e)%360,i,u,null==a?1:a]},c.hsla.from=function(t){if(null==t[0]||null==t[1]||null==t[2])return[null,null,null,t[3]];var e=t[0]/360,i=t[1],s=t[2],o=t[3],a=.5>=s?s*(1+i):s+i-s*i,r=2*s-a;return[Math.round(255*n(r,a,e+1/3)),Math.round(255*n(r,a,e)),Math.round(255*n(r,a,e-1/3)),o]},f(c,function(s,n){var o=n.props,a=n.cache,l=n.to,c=n.from;h.fn[s]=function(s){if(l&&!this[a]&&(this[a]=l(this._rgba)),s===e)return this[a].slice();var n,r=t.type(s),u="array"===r||"object"===r?s:arguments,d=this[a].slice();return f(o,function(t,e){var s=u["object"===r?t:e.idx];null==s&&(s=d[e.idx]),d[e.idx]=i(s,e)}),c?(n=h(c(d)),n[a]=d,n):h(d)},f(o,function(e,i){h.fn[e]||(h.fn[e]=function(n){var o,a=t.type(n),l="alpha"===e?this._hsla?"hsla":"rgba":s,h=this[l](),c=h[i.idx];return"undefined"===a?c:("function"===a&&(n=n.call(this,c),a=t.type(n)),null==n&&i.empty?this:("string"===a&&(o=r.exec(n),o&&(n=c+parseFloat(o[2])*("+"===o[1]?1:-1))),h[i.idx]=n,this[l](h)))})})}),h.hook=function(e){var i=e.split(" ");f(i,function(e,i){t.cssHooks[i]={set:function(e,n){var o,a,r="";if("transparent"!==n&&("string"!==t.type(n)||(o=s(n)))){if(n=h(o||n),!d.rgba&&1!==n._rgba[3]){for(a="backgroundColor"===i?e.parentNode:e;(""===r||"transparent"===r)&&a&&a.style;)try{r=t.css(a,"backgroundColor"),a=a.parentNode}catch(l){}n=n.blend(r&&"transparent"!==r?r:"_default")}n=n.toRgbaString()}try{e.style[i]=n}catch(l){}}},t.fx.step[i]=function(e){e.colorInit||(e.start=h(e.elem,i),e.end=h(e.end),e.colorInit=!0),t.cssHooks[i].set(e.elem,e.start.transition(e.end,e.pos))}})},h.hook(a),t.cssHooks.borderColor={expand:function(t){var e={};return f(["Top","Right","Bottom","Left"],function(i,s){e["border"+s+"Color"]=t}),e}},o=t.Color.names={aqua:"#00ffff",black:"#000000",blue:"#0000ff",fuchsia:"#ff00ff",gray:"#808080",green:"#008000",lime:"#00ff00",maroon:"#800000",navy:"#000080",olive:"#808000",purple:"#800080",red:"#ff0000",silver:"#c0c0c0",teal:"#008080",white:"#ffffff",yellow:"#ffff00",transparent:[null,null,null,0],_default:"#ffffff"}}(u),function(){function e(e){var i,s,n=e.ownerDocument.defaultView?e.ownerDocument.defaultView.getComputedStyle(e,null):e.currentStyle,o={};if(n&&n.length&&n[0]&&n[n[0]])for(s=n.length;s--;)i=n[s],"string"==typeof n[i]&&(o[t.camelCase(i)]=n[i]);else for(i in n)"string"==typeof n[i]&&(o[i]=n[i]);return o}function i(e,i){var s,o,a={};for(s in i)o=i[s],e[s]!==o&&(n[s]||(t.fx.step[s]||!isNaN(parseFloat(o)))&&(a[s]=o));return a}var s=["add","remove","toggle"],n={border:1,borderBottom:1,borderColor:1,borderLeft:1,borderRight:1,borderTop:1,borderWidth:1,margin:1,padding:1};t.each(["borderLeftStyle","borderRightStyle","borderBottomStyle","borderTopStyle"],function(e,i){t.fx.step[i]=function(t){("none"!==t.end&&!t.setAttr||1===t.pos&&!t.setAttr)&&(u.style(t.elem,i,t.end),t.setAttr=!0)}}),t.fn.addBack||(t.fn.addBack=function(t){return this.add(null==t?this.prevObject:this.prevObject.filter(t))}),t.effects.animateClass=function(n,o,a,r){var l=t.speed(o,a,r);return this.queue(function(){var o,a=t(this),r=a.attr("class")||"",h=l.children?a.find("*").addBack():a;h=h.map(function(){var i=t(this);return{el:i,start:e(this)}}),o=function(){t.each(s,function(t,e){n[e]&&a[e+"Class"](n[e])})},o(),h=h.map(function(){return this.end=e(this.el[0]),this.diff=i(this.start,this.end),this}),a.attr("class",r),h=h.map(function(){var e=this,i=t.Deferred(),s=t.extend({},l,{queue:!1,complete:function(){i.resolve(e)}});return this.el.animate(this.diff,s),i.promise()}),t.when.apply(t,h.get()).done(function(){o(),t.each(arguments,function(){var e=this.el;t.each(this.diff,function(t){e.css(t,"")})}),l.complete.call(a[0])})})},t.fn.extend({addClass:function(e){return function(i,s,n,o){return s?t.effects.animateClass.call(this,{add:i},s,n,o):e.apply(this,arguments)}}(t.fn.addClass),removeClass:function(e){return function(i,s,n,o){return arguments.length>1?t.effects.animateClass.call(this,{remove:i},s,n,o):e.apply(this,arguments)}}(t.fn.removeClass),toggleClass:function(e){return function(i,s,n,o,a){return"boolean"==typeof s||void 0===s?n?t.effects.animateClass.call(this,s?{add:i}:{remove:i},n,o,a):e.apply(this,arguments):t.effects.animateClass.call(this,{toggle:i},s,n,o)}}(t.fn.toggleClass),switchClass:function(e,i,s,n,o){return t.effects.animateClass.call(this,{add:i,remove:e},s,n,o)}})}(),function(){function e(e,i,s,n){return t.isPlainObject(e)&&(i=e,e=e.effect),e={effect:e},null==i&&(i={}),t.isFunction(i)&&(n=i,s=null,i={}),("number"==typeof i||t.fx.speeds[i])&&(n=s,s=i,i={}),t.isFunction(s)&&(n=s,s=null),i&&t.extend(e,i),s=s||i.duration,e.duration=t.fx.off?0:"number"==typeof s?s:s in t.fx.speeds?t.fx.speeds[s]:t.fx.speeds._default,e.complete=n||i.complete,e}function i(e){return!e||"number"==typeof e||t.fx.speeds[e]?!0:"string"!=typeof e||t.effects.effect[e]?t.isFunction(e)?!0:"object"!=typeof e||e.effect?!1:!0:!0}function s(t,e){var i=e.outerWidth(),s=e.outerHeight(),n=/^rect\((-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto)\)$/,o=n.exec(t)||["",0,i,s,0];return{top:parseFloat(o[1])||0,right:"auto"===o[2]?i:parseFloat(o[2]),bottom:"auto"===o[3]?s:parseFloat(o[3]),left:parseFloat(o[4])||0}}t.expr&&t.expr.filters&&t.expr.filters.animated&&(t.expr.filters.animated=function(e){return function(i){return!!t(i).data(c)||e(i)}}(t.expr.filters.animated)),t.uiBackCompat!==!1&&t.extend(t.effects,{save:function(t,e){for(var i=0,s=e.length;s>i;i++)null!==e[i]&&t.data(l+e[i],t[0].style[e[i]])},restore:function(t,e){for(var i,s=0,n=e.length;n>s;s++)null!==e[s]&&(i=t.data(l+e[s]),t.css(e[s],i))},setMode:function(t,e){return"toggle"===e&&(e=t.is(":hidden")?"show":"hide"),e},createWrapper:function(e){if(e.parent().is(".ui-effects-wrapper"))return e.parent();var i={width:e.outerWidth(!0),height:e.outerHeight(!0),"float":e.css("float")},s=t("<div></div>").addClass("ui-effects-wrapper").css({fontSize:"100%",background:"transparent",border:"none",margin:0,padding:0}),n={width:e.width(),height:e.height()},o=document.activeElement;try{o.id}catch(a){o=document.body}return e.wrap(s),(e[0]===o||t.contains(e[0],o))&&t(o).trigger("focus"),s=e.parent(),"static"===e.css("position")?(s.css({position:"relative"}),e.css({position:"relative"})):(t.extend(i,{position:e.css("position"),zIndex:e.css("z-index")}),t.each(["top","left","bottom","right"],function(t,s){i[s]=e.css(s),isNaN(parseInt(i[s],10))&&(i[s]="auto")}),e.css({position:"relative",top:0,left:0,right:"auto",bottom:"auto"})),e.css(n),s.css(i).show()},removeWrapper:function(e){var i=document.activeElement;return e.parent().is(".ui-effects-wrapper")&&(e.parent().replaceWith(e),(e[0]===i||t.contains(e[0],i))&&t(i).trigger("focus")),e}}),t.extend(t.effects,{version:"1.12.1",define:function(e,i,s){return s||(s=i,i="effect"),t.effects.effect[e]=s,t.effects.effect[e].mode=i,s},scaledDimensions:function(t,e,i){if(0===e)return{height:0,width:0,outerHeight:0,outerWidth:0};var s="horizontal"!==i?(e||100)/100:1,n="vertical"!==i?(e||100)/100:1;return{height:t.height()*n,width:t.width()*s,outerHeight:t.outerHeight()*n,outerWidth:t.outerWidth()*s}},clipToBox:function(t){return{width:t.clip.right-t.clip.left,height:t.clip.bottom-t.clip.top,left:t.clip.left,top:t.clip.top}},unshift:function(t,e,i){var s=t.queue();e>1&&s.splice.apply(s,[1,0].concat(s.splice(e,i))),t.dequeue()},saveStyle:function(t){t.data(h,t[0].style.cssText)},restoreStyle:function(t){t[0].style.cssText=t.data(h)||"",t.removeData(h)},mode:function(t,e){var i=t.is(":hidden");return"toggle"===e&&(e=i?"show":"hide"),(i?"hide"===e:"show"===e)&&(e="none"),e},getBaseline:function(t,e){var i,s;switch(t[0]){case"top":i=0;break;case"middle":i=.5;break;case"bottom":i=1;break;default:i=t[0]/e.height}switch(t[1]){case"left":s=0;break;case"center":s=.5;break;case"right":s=1;break;default:s=t[1]/e.width}return{x:s,y:i}},createPlaceholder:function(e){var i,s=e.css("position"),n=e.position();return e.css({marginTop:e.css("marginTop"),marginBottom:e.css("marginBottom"),marginLeft:e.css("marginLeft"),marginRight:e.css("marginRight")}).outerWidth(e.outerWidth()).outerHeight(e.outerHeight()),/^(static|relative)/.test(s)&&(s="absolute",i=t("<"+e[0].nodeName+">").insertAfter(e).css({display:/^(inline|ruby)/.test(e.css("display"))?"inline-block":"block",visibility:"hidden",marginTop:e.css("marginTop"),marginBottom:e.css("marginBottom"),marginLeft:e.css("marginLeft"),marginRight:e.css("marginRight"),"float":e.css("float")}).outerWidth(e.outerWidth()).outerHeight(e.outerHeight()).addClass("ui-effects-placeholder"),e.data(l+"placeholder",i)),e.css({position:s,left:n.left,top:n.top}),i},removePlaceholder:function(t){var e=l+"placeholder",i=t.data(e);i&&(i.remove(),t.removeData(e))},cleanUp:function(e){t.effects.restoreStyle(e),t.effects.removePlaceholder(e)},setTransition:function(e,i,s,n){return n=n||{},t.each(i,function(t,i){var o=e.cssUnit(i);o[0]>0&&(n[i]=o[0]*s+o[1])}),n}}),t.fn.extend({effect:function(){function i(e){function i(){r.removeData(c),t.effects.cleanUp(r),"hide"===s.mode&&r.hide(),a()}function a(){t.isFunction(l)&&l.call(r[0]),t.isFunction(e)&&e()}var r=t(this);s.mode=u.shift(),t.uiBackCompat===!1||o?"none"===s.mode?(r[h](),a()):n.call(r[0],s,i):(r.is(":hidden")?"hide"===h:"show"===h)?(r[h](),a()):n.call(r[0],s,a)}var s=e.apply(this,arguments),n=t.effects.effect[s.effect],o=n.mode,a=s.queue,r=a||"fx",l=s.complete,h=s.mode,u=[],d=function(e){var i=t(this),s=t.effects.mode(i,h)||o;i.data(c,!0),u.push(s),o&&("show"===s||s===o&&"hide"===s)&&i.show(),o&&"none"===s||t.effects.saveStyle(i),t.isFunction(e)&&e()};return t.fx.off||!n?h?this[h](s.duration,l):this.each(function(){l&&l.call(this)}):a===!1?this.each(d).each(i):this.queue(r,d).queue(r,i)},show:function(t){return function(s){if(i(s))return t.apply(this,arguments);var n=e.apply(this,arguments);return n.mode="show",this.effect.call(this,n)}}(t.fn.show),hide:function(t){return function(s){if(i(s))return t.apply(this,arguments);var n=e.apply(this,arguments);return n.mode="hide",this.effect.call(this,n)}}(t.fn.hide),toggle:function(t){return function(s){if(i(s)||"boolean"==typeof s)return t.apply(this,arguments);var n=e.apply(this,arguments);return n.mode="toggle",this.effect.call(this,n)}}(t.fn.toggle),cssUnit:function(e){var i=this.css(e),s=[];return t.each(["em","px","%","pt"],function(t,e){i.indexOf(e)>0&&(s=[parseFloat(i),e])}),s},cssClip:function(t){return t?this.css("clip","rect("+t.top+"px "+t.right+"px "+t.bottom+"px "+t.left+"px)"):s(this.css("clip"),this)},transfer:function(e,i){var s=t(this),n=t(e.to),o="fixed"===n.css("position"),a=t("body"),r=o?a.scrollTop():0,l=o?a.scrollLeft():0,h=n.offset(),c={top:h.top-r,left:h.left-l,height:n.innerHeight(),width:n.innerWidth()},u=s.offset(),d=t("<div class='ui-effects-transfer'></div>").appendTo("body").addClass(e.className).css({top:u.top-r,left:u.left-l,height:s.innerHeight(),width:s.innerWidth(),position:o?"fixed":"absolute"}).animate(c,e.duration,e.easing,function(){d.remove(),t.isFunction(i)&&i()})}}),t.fx.step.clip=function(e){e.clipInit||(e.start=t(e.elem).cssClip(),"string"==typeof e.end&&(e.end=s(e.end,e.elem)),e.clipInit=!0),t(e.elem).cssClip({top:e.pos*(e.end.top-e.start.top)+e.start.top,right:e.pos*(e.end.right-e.start.right)+e.start.right,bottom:e.pos*(e.end.bottom-e.start.bottom)+e.start.bottom,left:e.pos*(e.end.left-e.start.left)+e.start.left})}}(),function(){var e={};t.each(["Quad","Cubic","Quart","Quint","Expo"],function(t,i){e[i]=function(e){return Math.pow(e,t+2)}}),t.extend(e,{Sine:function(t){return 1-Math.cos(t*Math.PI/2)},Circ:function(t){return 1-Math.sqrt(1-t*t)},Elastic:function(t){return 0===t||1===t?t:-Math.pow(2,8*(t-1))*Math.sin((80*(t-1)-7.5)*Math.PI/15)},Back:function(t){return t*t*(3*t-2)},Bounce:function(t){for(var e,i=4;((e=Math.pow(2,--i))-1)/11>t;);return 1/Math.pow(4,3-i)-7.5625*Math.pow((3*e-2)/22-t,2)}}),t.each(e,function(e,i){t.easing["easeIn"+e]=i,t.easing["easeOut"+e]=function(t){return 1-i(1-t)},t.easing["easeInOut"+e]=function(t){return.5>t?i(2*t)/2:1-i(-2*t+2)/2}})}();var d=t.effects;t.effects.define("blind","hide",function(e,i){var s={up:["bottom","top"],vertical:["bottom","top"],down:["top","bottom"],left:["right","left"],horizontal:["right","left"],right:["left","right"]},n=t(this),o=e.direction||"up",a=n.cssClip(),r={clip:t.extend({},a)},l=t.effects.createPlaceholder(n);r.clip[s[o][0]]=r.clip[s[o][1]],"show"===e.mode&&(n.cssClip(r.clip),l&&l.css(t.effects.clipToBox(r)),r.clip=a),l&&l.animate(t.effects.clipToBox(r),e.duration,e.easing),n.animate(r,{queue:!1,duration:e.duration,easing:e.easing,complete:i})}),t.effects.define("bounce",function(e,i){var s,n,o,a=t(this),r=e.mode,l="hide"===r,h="show"===r,c=e.direction||"up",u=e.distance,d=e.times||5,p=2*d+(h||l?1:0),f=e.duration/p,g=e.easing,m="up"===c||"down"===c?"top":"left",_="up"===c||"left"===c,v=0,b=a.queue().length;for(t.effects.createPlaceholder(a),o=a.css(m),u||(u=a["top"===m?"outerHeight":"outerWidth"]()/3),h&&(n={opacity:1},n[m]=o,a.css("opacity",0).css(m,_?2*-u:2*u).animate(n,f,g)),l&&(u/=Math.pow(2,d-1)),n={},n[m]=o;d>v;v++)s={},s[m]=(_?"-=":"+=")+u,a.animate(s,f,g).animate(n,f,g),u=l?2*u:u/2;l&&(s={opacity:0},s[m]=(_?"-=":"+=")+u,a.animate(s,f,g)),a.queue(i),t.effects.unshift(a,b,p+1)}),t.effects.define("clip","hide",function(e,i){var s,n={},o=t(this),a=e.direction||"vertical",r="both"===a,l=r||"horizontal"===a,h=r||"vertical"===a;s=o.cssClip(),n.clip={top:h?(s.bottom-s.top)/2:s.top,right:l?(s.right-s.left)/2:s.right,bottom:h?(s.bottom-s.top)/2:s.bottom,left:l?(s.right-s.left)/2:s.left},t.effects.createPlaceholder(o),"show"===e.mode&&(o.cssClip(n.clip),n.clip=s),o.animate(n,{queue:!1,duration:e.duration,easing:e.easing,complete:i})}),t.effects.define("drop","hide",function(e,i){var s,n=t(this),o=e.mode,a="show"===o,r=e.direction||"left",l="up"===r||"down"===r?"top":"left",h="up"===r||"left"===r?"-=":"+=",c="+="===h?"-=":"+=",u={opacity:0};t.effects.createPlaceholder(n),s=e.distance||n["top"===l?"outerHeight":"outerWidth"](!0)/2,u[l]=h+s,a&&(n.css(u),u[l]=c+s,u.opacity=1),n.animate(u,{queue:!1,duration:e.duration,easing:e.easing,complete:i})}),t.effects.define("explode","hide",function(e,i){function s(){b.push(this),b.length===u*d&&n()}function n(){p.css({visibility:"visible"}),t(b).remove(),i()}var o,a,r,l,h,c,u=e.pieces?Math.round(Math.sqrt(e.pieces)):3,d=u,p=t(this),f=e.mode,g="show"===f,m=p.show().css("visibility","hidden").offset(),_=Math.ceil(p.outerWidth()/d),v=Math.ceil(p.outerHeight()/u),b=[];for(o=0;u>o;o++)for(l=m.top+o*v,c=o-(u-1)/2,a=0;d>a;a++)r=m.left+a*_,h=a-(d-1)/2,p.clone().appendTo("body").wrap("<div></div>").css({position:"absolute",visibility:"visible",left:-a*_,top:-o*v}).parent().addClass("ui-effects-explode").css({position:"absolute",overflow:"hidden",width:_,height:v,left:r+(g?h*_:0),top:l+(g?c*v:0),opacity:g?0:1}).animate({left:r+(g?0:h*_),top:l+(g?0:c*v),opacity:g?1:0},e.duration||500,e.easing,s)}),t.effects.define("fade","toggle",function(e,i){var s="show"===e.mode;t(this).css("opacity",s?0:1).animate({opacity:s?1:0},{queue:!1,duration:e.duration,easing:e.easing,complete:i})}),t.effects.define("fold","hide",function(e,i){var s=t(this),n=e.mode,o="show"===n,a="hide"===n,r=e.size||15,l=/([0-9]+)%/.exec(r),h=!!e.horizFirst,c=h?["right","bottom"]:["bottom","right"],u=e.duration/2,d=t.effects.createPlaceholder(s),p=s.cssClip(),f={clip:t.extend({},p)},g={clip:t.extend({},p)},m=[p[c[0]],p[c[1]]],_=s.queue().length;l&&(r=parseInt(l[1],10)/100*m[a?0:1]),f.clip[c[0]]=r,g.clip[c[0]]=r,g.clip[c[1]]=0,o&&(s.cssClip(g.clip),d&&d.css(t.effects.clipToBox(g)),g.clip=p),s.queue(function(i){d&&d.animate(t.effects.clipToBox(f),u,e.easing).animate(t.effects.clipToBox(g),u,e.easing),i()}).animate(f,u,e.easing).animate(g,u,e.easing).queue(i),t.effects.unshift(s,_,4)}),t.effects.define("highlight","show",function(e,i){var s=t(this),n={backgroundColor:s.css("backgroundColor")};"hide"===e.mode&&(n.opacity=0),t.effects.saveStyle(s),s.css({backgroundImage:"none",backgroundColor:e.color||"#ffff99"}).animate(n,{queue:!1,duration:e.duration,easing:e.easing,complete:i})}),t.effects.define("size",function(e,i){var s,n,o,a=t(this),r=["fontSize"],l=["borderTopWidth","borderBottomWidth","paddingTop","paddingBottom"],h=["borderLeftWidth","borderRightWidth","paddingLeft","paddingRight"],c=e.mode,u="effect"!==c,d=e.scale||"both",p=e.origin||["middle","center"],f=a.css("position"),g=a.position(),m=t.effects.scaledDimensions(a),_=e.from||m,v=e.to||t.effects.scaledDimensions(a,0);t.effects.createPlaceholder(a),"show"===c&&(o=_,_=v,v=o),n={from:{y:_.height/m.height,x:_.width/m.width},to:{y:v.height/m.height,x:v.width/m.width}},("box"===d||"both"===d)&&(n.from.y!==n.to.y&&(_=t.effects.setTransition(a,l,n.from.y,_),v=t.effects.setTransition(a,l,n.to.y,v)),n.from.x!==n.to.x&&(_=t.effects.setTransition(a,h,n.from.x,_),v=t.effects.setTransition(a,h,n.to.x,v))),("content"===d||"both"===d)&&n.from.y!==n.to.y&&(_=t.effects.setTransition(a,r,n.from.y,_),v=t.effects.setTransition(a,r,n.to.y,v)),p&&(s=t.effects.getBaseline(p,m),_.top=(m.outerHeight-_.outerHeight)*s.y+g.top,_.left=(m.outerWidth-_.outerWidth)*s.x+g.left,v.top=(m.outerHeight-v.outerHeight)*s.y+g.top,v.left=(m.outerWidth-v.outerWidth)*s.x+g.left),a.css(_),("content"===d||"both"===d)&&(l=l.concat(["marginTop","marginBottom"]).concat(r),h=h.concat(["marginLeft","marginRight"]),a.find("*[width]").each(function(){var i=t(this),s=t.effects.scaledDimensions(i),o={height:s.height*n.from.y,width:s.width*n.from.x,outerHeight:s.outerHeight*n.from.y,outerWidth:s.outerWidth*n.from.x},a={height:s.height*n.to.y,width:s.width*n.to.x,outerHeight:s.height*n.to.y,outerWidth:s.width*n.to.x};n.from.y!==n.to.y&&(o=t.effects.setTransition(i,l,n.from.y,o),a=t.effects.setTransition(i,l,n.to.y,a)),n.from.x!==n.to.x&&(o=t.effects.setTransition(i,h,n.from.x,o),a=t.effects.setTransition(i,h,n.to.x,a)),u&&t.effects.saveStyle(i),i.css(o),i.animate(a,e.duration,e.easing,function(){u&&t.effects.restoreStyle(i)})})),a.animate(v,{queue:!1,duration:e.duration,easing:e.easing,complete:function(){var e=a.offset();0===v.opacity&&a.css("opacity",_.opacity),u||(a.css("position","static"===f?"relative":f).offset(e),t.effects.saveStyle(a)),i()}})}),t.effects.define("scale",function(e,i){var s=t(this),n=e.mode,o=parseInt(e.percent,10)||(0===parseInt(e.percent,10)?0:"effect"!==n?0:100),a=t.extend(!0,{from:t.effects.scaledDimensions(s),to:t.effects.scaledDimensions(s,o,e.direction||"both"),origin:e.origin||["middle","center"]},e);e.fade&&(a.from.opacity=1,a.to.opacity=0),t.effects.effect.size.call(this,a,i)}),t.effects.define("puff","hide",function(e,i){var s=t.extend(!0,{},e,{fade:!0,percent:parseInt(e.percent,10)||150});t.effects.effect.scale.call(this,s,i)}),t.effects.define("pulsate","show",function(e,i){var s=t(this),n=e.mode,o="show"===n,a="hide"===n,r=o||a,l=2*(e.times||5)+(r?1:0),h=e.duration/l,c=0,u=1,d=s.queue().length;for((o||!s.is(":visible"))&&(s.css("opacity",0).show(),c=1);l>u;u++)s.animate({opacity:c},h,e.easing),c=1-c;s.animate({opacity:c},h,e.easing),s.queue(i),t.effects.unshift(s,d,l+1)}),t.effects.define("shake",function(e,i){var s=1,n=t(this),o=e.direction||"left",a=e.distance||20,r=e.times||3,l=2*r+1,h=Math.round(e.duration/l),c="up"===o||"down"===o?"top":"left",u="up"===o||"left"===o,d={},p={},f={},g=n.queue().length;for(t.effects.createPlaceholder(n),d[c]=(u?"-=":"+=")+a,p[c]=(u?"+=":"-=")+2*a,f[c]=(u?"-=":"+=")+2*a,n.animate(d,h,e.easing);r>s;s++)n.animate(p,h,e.easing).animate(f,h,e.easing);n.animate(p,h,e.easing).animate(d,h/2,e.easing).queue(i),t.effects.unshift(n,g,l+1)}),t.effects.define("slide","show",function(e,i){var s,n,o=t(this),a={up:["bottom","top"],down:["top","bottom"],left:["right","left"],right:["left","right"]},r=e.mode,l=e.direction||"left",h="up"===l||"down"===l?"top":"left",c="up"===l||"left"===l,u=e.distance||o["top"===h?"outerHeight":"outerWidth"](!0),d={};t.effects.createPlaceholder(o),s=o.cssClip(),n=o.position()[h],d[h]=(c?-1:1)*u+n,d.clip=o.cssClip(),d.clip[a[l][1]]=d.clip[a[l][0]],"show"===r&&(o.cssClip(d.clip),o.css(h,d[h]),d.clip=s,d[h]=n),o.animate(d,{queue:!1,duration:e.duration,easing:e.easing,complete:i})});var d;t.uiBackCompat!==!1&&(d=t.effects.define("transfer",function(e,i){t(this).transfer(e,i)})),t.ui.focusable=function(i,s){var n,o,a,r,l,h=i.nodeName.toLowerCase();return"area"===h?(n=i.parentNode,o=n.name,i.href&&o&&"map"===n.nodeName.toLowerCase()?(a=t("img[usemap='#"+o+"']"),a.length>0&&a.is(":visible")):!1):(/^(input|select|textarea|button|object)$/.test(h)?(r=!i.disabled,r&&(l=t(i).closest("fieldset")[0],l&&(r=!l.disabled))):r="a"===h?i.href||s:s,r&&t(i).is(":visible")&&e(t(i)))},t.extend(t.expr[":"],{focusable:function(e){return t.ui.focusable(e,null!=t.attr(e,"tabindex"))}}),t.ui.focusable,t.fn.form=function(){return"string"==typeof this[0].form?this.closest("form"):t(this[0].form)},t.ui.formResetMixin={_formResetHandler:function(){var e=t(this);setTimeout(function(){var i=e.data("ui-form-reset-instances");t.each(i,function(){this.refresh()})})},_bindFormResetHandler:function(){if(this.form=this.element.form(),this.form.length){var t=this.form.data("ui-form-reset-instances")||[];t.length||this.form.on("reset.ui-form-reset",this._formResetHandler),t.push(this),this.form.data("ui-form-reset-instances",t)}},_unbindFormResetHandler:function(){if(this.form.length){var e=this.form.data("ui-form-reset-instances");e.splice(t.inArray(this,e),1),e.length?this.form.data("ui-form-reset-instances",e):this.form.removeData("ui-form-reset-instances").off("reset.ui-form-reset")}}},"1.7"===t.fn.jquery.substring(0,3)&&(t.each(["Width","Height"],function(e,i){function s(e,i,s,o){return t.each(n,function(){i-=parseFloat(t.css(e,"padding"+this))||0,s&&(i-=parseFloat(t.css(e,"border"+this+"Width"))||0),o&&(i-=parseFloat(t.css(e,"margin"+this))||0)}),i}var n="Width"===i?["Left","Right"]:["Top","Bottom"],o=i.toLowerCase(),a={innerWidth:t.fn.innerWidth,innerHeight:t.fn.innerHeight,outerWidth:t.fn.outerWidth,outerHeight:t.fn.outerHeight};t.fn["inner"+i]=function(e){return void 0===e?a["inner"+i].call(this):this.each(function(){t(this).css(o,s(this,e)+"px")})},t.fn["outer"+i]=function(e,n){return"number"!=typeof e?a["outer"+i].call(this,e):this.each(function(){t(this).css(o,s(this,e,!0,n)+"px")})}}),t.fn.addBack=function(t){return this.add(null==t?this.prevObject:this.prevObject.filter(t))}),t.ui.keyCode={BACKSPACE:8,COMMA:188,DELETE:46,DOWN:40,END:35,ENTER:13,ESCAPE:27,HOME:36,LEFT:37,PAGE_DOWN:34,PAGE_UP:33,PERIOD:190,RIGHT:39,SPACE:32,TAB:9,UP:38},t.ui.escapeSelector=function(){var t=/([!"#$%&'()*+,./:;<=>?@[\]^`{|}~])/g;return function(e){return e.replace(t,"\\$1")}}(),t.fn.labels=function(){var e,i,s,n,o;return this[0].labels&&this[0].labels.length?this.pushStack(this[0].labels):(n=this.eq(0).parents("label"),s=this.attr("id"),s&&(e=this.eq(0).parents().last(),o=e.add(e.length?e.siblings():this.siblings()),i="label[for='"+t.ui.escapeSelector(s)+"']",n=n.add(o.find(i).addBack(i))),this.pushStack(n))},function(){function e(t,e,i){return[parseFloat(t[0])*(u.test(t[0])?e/100:1),parseFloat(t[1])*(u.test(t[1])?i/100:1)]}function i(e,i){return parseInt(t.css(e,i),10)||0}function s(e){var i=e[0];return 9===i.nodeType?{width:e.width(),height:e.height(),offset:{top:0,left:0}}:t.isWindow(i)?{width:e.width(),height:e.height(),offset:{top:e.scrollTop(),left:e.scrollLeft()}}:i.preventDefault?{width:0,height:0,offset:{top:i.pageY,left:i.pageX}}:{width:e.outerWidth(),height:e.outerHeight(),offset:e.offset()}}var n,o=Math.max,a=Math.abs,r=/left|center|right/,l=/top|center|bottom/,h=/[\+\-]\d+(\.[\d]+)?%?/,c=/^\w+/,u=/%$/,d=t.fn.position;
t.position={scrollbarWidth:function(){if(void 0!==n)return n;var e,i,s=t("<div style='display:block;position:absolute;width:50px;height:50px;overflow:hidden;'><div style='height:100px;width:auto;'></div></div>"),o=s.children()[0];return t("body").append(s),e=o.offsetWidth,s.css("overflow","scroll"),i=o.offsetWidth,e===i&&(i=s[0].clientWidth),s.remove(),n=e-i},getScrollInfo:function(e){var i=e.isWindow||e.isDocument?"":e.element.css("overflow-x"),s=e.isWindow||e.isDocument?"":e.element.css("overflow-y"),n="scroll"===i||"auto"===i&&e.width<e.element[0].scrollWidth,o="scroll"===s||"auto"===s&&e.height<e.element[0].scrollHeight;return{width:o?t.position.scrollbarWidth():0,height:n?t.position.scrollbarWidth():0}},getWithinInfo:function(e){var i=t(e||window),s=t.isWindow(i[0]),n=!!i[0]&&9===i[0].nodeType,o=!s&&!n;return{element:i,isWindow:s,isDocument:n,offset:o?t(e).offset():{left:0,top:0},scrollLeft:i.scrollLeft(),scrollTop:i.scrollTop(),width:i.outerWidth(),height:i.outerHeight()}}},t.fn.position=function(n){if(!n||!n.of)return d.apply(this,arguments);n=t.extend({},n);var u,p,f,g,m,_,v=t(n.of),b=t.position.getWithinInfo(n.within),y=t.position.getScrollInfo(b),w=(n.collision||"flip").split(" "),k={};return _=s(v),v[0].preventDefault&&(n.at="left top"),p=_.width,f=_.height,g=_.offset,m=t.extend({},g),t.each(["my","at"],function(){var t,e,i=(n[this]||"").split(" ");1===i.length&&(i=r.test(i[0])?i.concat(["center"]):l.test(i[0])?["center"].concat(i):["center","center"]),i[0]=r.test(i[0])?i[0]:"center",i[1]=l.test(i[1])?i[1]:"center",t=h.exec(i[0]),e=h.exec(i[1]),k[this]=[t?t[0]:0,e?e[0]:0],n[this]=[c.exec(i[0])[0],c.exec(i[1])[0]]}),1===w.length&&(w[1]=w[0]),"right"===n.at[0]?m.left+=p:"center"===n.at[0]&&(m.left+=p/2),"bottom"===n.at[1]?m.top+=f:"center"===n.at[1]&&(m.top+=f/2),u=e(k.at,p,f),m.left+=u[0],m.top+=u[1],this.each(function(){var s,r,l=t(this),h=l.outerWidth(),c=l.outerHeight(),d=i(this,"marginLeft"),_=i(this,"marginTop"),x=h+d+i(this,"marginRight")+y.width,C=c+_+i(this,"marginBottom")+y.height,D=t.extend({},m),T=e(k.my,l.outerWidth(),l.outerHeight());"right"===n.my[0]?D.left-=h:"center"===n.my[0]&&(D.left-=h/2),"bottom"===n.my[1]?D.top-=c:"center"===n.my[1]&&(D.top-=c/2),D.left+=T[0],D.top+=T[1],s={marginLeft:d,marginTop:_},t.each(["left","top"],function(e,i){t.ui.position[w[e]]&&t.ui.position[w[e]][i](D,{targetWidth:p,targetHeight:f,elemWidth:h,elemHeight:c,collisionPosition:s,collisionWidth:x,collisionHeight:C,offset:[u[0]+T[0],u[1]+T[1]],my:n.my,at:n.at,within:b,elem:l})}),n.using&&(r=function(t){var e=g.left-D.left,i=e+p-h,s=g.top-D.top,r=s+f-c,u={target:{element:v,left:g.left,top:g.top,width:p,height:f},element:{element:l,left:D.left,top:D.top,width:h,height:c},horizontal:0>i?"left":e>0?"right":"center",vertical:0>r?"top":s>0?"bottom":"middle"};h>p&&p>a(e+i)&&(u.horizontal="center"),c>f&&f>a(s+r)&&(u.vertical="middle"),u.important=o(a(e),a(i))>o(a(s),a(r))?"horizontal":"vertical",n.using.call(this,t,u)}),l.offset(t.extend(D,{using:r}))})},t.ui.position={fit:{left:function(t,e){var i,s=e.within,n=s.isWindow?s.scrollLeft:s.offset.left,a=s.width,r=t.left-e.collisionPosition.marginLeft,l=n-r,h=r+e.collisionWidth-a-n;e.collisionWidth>a?l>0&&0>=h?(i=t.left+l+e.collisionWidth-a-n,t.left+=l-i):t.left=h>0&&0>=l?n:l>h?n+a-e.collisionWidth:n:l>0?t.left+=l:h>0?t.left-=h:t.left=o(t.left-r,t.left)},top:function(t,e){var i,s=e.within,n=s.isWindow?s.scrollTop:s.offset.top,a=e.within.height,r=t.top-e.collisionPosition.marginTop,l=n-r,h=r+e.collisionHeight-a-n;e.collisionHeight>a?l>0&&0>=h?(i=t.top+l+e.collisionHeight-a-n,t.top+=l-i):t.top=h>0&&0>=l?n:l>h?n+a-e.collisionHeight:n:l>0?t.top+=l:h>0?t.top-=h:t.top=o(t.top-r,t.top)}},flip:{left:function(t,e){var i,s,n=e.within,o=n.offset.left+n.scrollLeft,r=n.width,l=n.isWindow?n.scrollLeft:n.offset.left,h=t.left-e.collisionPosition.marginLeft,c=h-l,u=h+e.collisionWidth-r-l,d="left"===e.my[0]?-e.elemWidth:"right"===e.my[0]?e.elemWidth:0,p="left"===e.at[0]?e.targetWidth:"right"===e.at[0]?-e.targetWidth:0,f=-2*e.offset[0];0>c?(i=t.left+d+p+f+e.collisionWidth-r-o,(0>i||a(c)>i)&&(t.left+=d+p+f)):u>0&&(s=t.left-e.collisionPosition.marginLeft+d+p+f-l,(s>0||u>a(s))&&(t.left+=d+p+f))},top:function(t,e){var i,s,n=e.within,o=n.offset.top+n.scrollTop,r=n.height,l=n.isWindow?n.scrollTop:n.offset.top,h=t.top-e.collisionPosition.marginTop,c=h-l,u=h+e.collisionHeight-r-l,d="top"===e.my[1],p=d?-e.elemHeight:"bottom"===e.my[1]?e.elemHeight:0,f="top"===e.at[1]?e.targetHeight:"bottom"===e.at[1]?-e.targetHeight:0,g=-2*e.offset[1];0>c?(s=t.top+p+f+g+e.collisionHeight-r-o,(0>s||a(c)>s)&&(t.top+=p+f+g)):u>0&&(i=t.top-e.collisionPosition.marginTop+p+f+g-l,(i>0||u>a(i))&&(t.top+=p+f+g))}},flipfit:{left:function(){t.ui.position.flip.left.apply(this,arguments),t.ui.position.fit.left.apply(this,arguments)},top:function(){t.ui.position.flip.top.apply(this,arguments),t.ui.position.fit.top.apply(this,arguments)}}}}(),t.ui.position,t.fn.scrollParent=function(e){var i=this.css("position"),s="absolute"===i,n=e?/(auto|scroll|hidden)/:/(auto|scroll)/,o=this.parents().filter(function(){var e=t(this);return s&&"static"===e.css("position")?!1:n.test(e.css("overflow")+e.css("overflow-y")+e.css("overflow-x"))}).eq(0);return"fixed"!==i&&o.length?o:t(this[0].ownerDocument||document)},t.extend(t.expr[":"],{tabbable:function(e){var i=t.attr(e,"tabindex"),s=null!=i;return(!s||i>=0)&&t.ui.focusable(e,s)}}),t.fn.extend({uniqueId:function(){var t=0;return function(){return this.each(function(){this.id||(this.id="ui-id-"+ ++t)})}}(),removeUniqueId:function(){return this.each(function(){/^ui-id-\d+$/.test(this.id)&&t(this).removeAttr("id")})}});var p=0,f=Array.prototype.slice;t.cleanData=function(e){return function(i){var s,n,o;for(o=0;null!=(n=i[o]);o++)try{s=t._data(n,"events"),s&&s.remove&&t(n).triggerHandler("remove")}catch(a){}e(i)}}(t.cleanData),t.widget=function(e,i,s){var n,o,a,r={},l=e.split(".")[0];e=e.split(".")[1];var h=l+"-"+e;return s||(s=i,i=t.Widget),t.isArray(s)&&(s=t.extend.apply(null,[{}].concat(s))),t.expr[":"][h.toLowerCase()]=function(e){return!!t.data(e,h)},t[l]=t[l]||{},n=t[l][e],o=t[l][e]=function(t,e){return this._createWidget?(arguments.length&&this._createWidget(t,e),void 0):new o(t,e)},t.extend(o,n,{version:s.version,_proto:t.extend({},s),_childConstructors:[]}),a=new i,a.options=t.widget.extend({},a.options),t.each(s,function(e,s){return t.isFunction(s)?(r[e]=function(){function t(){return i.prototype[e].apply(this,arguments)}function n(t){return i.prototype[e].apply(this,t)}return function(){var e,i=this._super,o=this._superApply;return this._super=t,this._superApply=n,e=s.apply(this,arguments),this._super=i,this._superApply=o,e}}(),void 0):(r[e]=s,void 0)}),o.prototype=t.widget.extend(a,{widgetEventPrefix:n?a.widgetEventPrefix||e:e},r,{constructor:o,namespace:l,widgetName:e,widgetFullName:h}),n?(t.each(n._childConstructors,function(e,i){var s=i.prototype;t.widget(s.namespace+"."+s.widgetName,o,i._proto)}),delete n._childConstructors):i._childConstructors.push(o),t.widget.bridge(e,o),o},t.widget.extend=function(e){for(var i,s,n=f.call(arguments,1),o=0,a=n.length;a>o;o++)for(i in n[o])s=n[o][i],n[o].hasOwnProperty(i)&&void 0!==s&&(e[i]=t.isPlainObject(s)?t.isPlainObject(e[i])?t.widget.extend({},e[i],s):t.widget.extend({},s):s);return e},t.widget.bridge=function(e,i){var s=i.prototype.widgetFullName||e;t.fn[e]=function(n){var o="string"==typeof n,a=f.call(arguments,1),r=this;return o?this.length||"instance"!==n?this.each(function(){var i,o=t.data(this,s);return"instance"===n?(r=o,!1):o?t.isFunction(o[n])&&"_"!==n.charAt(0)?(i=o[n].apply(o,a),i!==o&&void 0!==i?(r=i&&i.jquery?r.pushStack(i.get()):i,!1):void 0):t.error("no such method '"+n+"' for "+e+" widget instance"):t.error("cannot call methods on "+e+" prior to initialization; "+"attempted to call method '"+n+"'")}):r=void 0:(a.length&&(n=t.widget.extend.apply(null,[n].concat(a))),this.each(function(){var e=t.data(this,s);e?(e.option(n||{}),e._init&&e._init()):t.data(this,s,new i(n,this))})),r}},t.Widget=function(){},t.Widget._childConstructors=[],t.Widget.prototype={widgetName:"widget",widgetEventPrefix:"",defaultElement:"<div>",options:{classes:{},disabled:!1,create:null},_createWidget:function(e,i){i=t(i||this.defaultElement||this)[0],this.element=t(i),this.uuid=p++,this.eventNamespace="."+this.widgetName+this.uuid,this.bindings=t(),this.hoverable=t(),this.focusable=t(),this.classesElementLookup={},i!==this&&(t.data(i,this.widgetFullName,this),this._on(!0,this.element,{remove:function(t){t.target===i&&this.destroy()}}),this.document=t(i.style?i.ownerDocument:i.document||i),this.window=t(this.document[0].defaultView||this.document[0].parentWindow)),this.options=t.widget.extend({},this.options,this._getCreateOptions(),e),this._create(),this.options.disabled&&this._setOptionDisabled(this.options.disabled),this._trigger("create",null,this._getCreateEventData()),this._init()},_getCreateOptions:function(){return{}},_getCreateEventData:t.noop,_create:t.noop,_init:t.noop,destroy:function(){var e=this;this._destroy(),t.each(this.classesElementLookup,function(t,i){e._removeClass(i,t)}),this.element.off(this.eventNamespace).removeData(this.widgetFullName),this.widget().off(this.eventNamespace).removeAttr("aria-disabled"),this.bindings.off(this.eventNamespace)},_destroy:t.noop,widget:function(){return this.element},option:function(e,i){var s,n,o,a=e;if(0===arguments.length)return t.widget.extend({},this.options);if("string"==typeof e)if(a={},s=e.split("."),e=s.shift(),s.length){for(n=a[e]=t.widget.extend({},this.options[e]),o=0;s.length-1>o;o++)n[s[o]]=n[s[o]]||{},n=n[s[o]];if(e=s.pop(),1===arguments.length)return void 0===n[e]?null:n[e];n[e]=i}else{if(1===arguments.length)return void 0===this.options[e]?null:this.options[e];a[e]=i}return this._setOptions(a),this},_setOptions:function(t){var e;for(e in t)this._setOption(e,t[e]);return this},_setOption:function(t,e){return"classes"===t&&this._setOptionClasses(e),this.options[t]=e,"disabled"===t&&this._setOptionDisabled(e),this},_setOptionClasses:function(e){var i,s,n;for(i in e)n=this.classesElementLookup[i],e[i]!==this.options.classes[i]&&n&&n.length&&(s=t(n.get()),this._removeClass(n,i),s.addClass(this._classes({element:s,keys:i,classes:e,add:!0})))},_setOptionDisabled:function(t){this._toggleClass(this.widget(),this.widgetFullName+"-disabled",null,!!t),t&&(this._removeClass(this.hoverable,null,"ui-state-hover"),this._removeClass(this.focusable,null,"ui-state-focus"))},enable:function(){return this._setOptions({disabled:!1})},disable:function(){return this._setOptions({disabled:!0})},_classes:function(e){function i(i,o){var a,r;for(r=0;i.length>r;r++)a=n.classesElementLookup[i[r]]||t(),a=e.add?t(t.unique(a.get().concat(e.element.get()))):t(a.not(e.element).get()),n.classesElementLookup[i[r]]=a,s.push(i[r]),o&&e.classes[i[r]]&&s.push(e.classes[i[r]])}var s=[],n=this;return e=t.extend({element:this.element,classes:this.options.classes||{}},e),this._on(e.element,{remove:"_untrackClassesElement"}),e.keys&&i(e.keys.match(/\S+/g)||[],!0),e.extra&&i(e.extra.match(/\S+/g)||[]),s.join(" ")},_untrackClassesElement:function(e){var i=this;t.each(i.classesElementLookup,function(s,n){-1!==t.inArray(e.target,n)&&(i.classesElementLookup[s]=t(n.not(e.target).get()))})},_removeClass:function(t,e,i){return this._toggleClass(t,e,i,!1)},_addClass:function(t,e,i){return this._toggleClass(t,e,i,!0)},_toggleClass:function(t,e,i,s){s="boolean"==typeof s?s:i;var n="string"==typeof t||null===t,o={extra:n?e:i,keys:n?t:e,element:n?this.element:t,add:s};return o.element.toggleClass(this._classes(o),s),this},_on:function(e,i,s){var n,o=this;"boolean"!=typeof e&&(s=i,i=e,e=!1),s?(i=n=t(i),this.bindings=this.bindings.add(i)):(s=i,i=this.element,n=this.widget()),t.each(s,function(s,a){function r(){return e||o.options.disabled!==!0&&!t(this).hasClass("ui-state-disabled")?("string"==typeof a?o[a]:a).apply(o,arguments):void 0}"string"!=typeof a&&(r.guid=a.guid=a.guid||r.guid||t.guid++);var l=s.match(/^([\w:-]*)\s*(.*)$/),h=l[1]+o.eventNamespace,c=l[2];c?n.on(h,c,r):i.on(h,r)})},_off:function(e,i){i=(i||"").split(" ").join(this.eventNamespace+" ")+this.eventNamespace,e.off(i).off(i),this.bindings=t(this.bindings.not(e).get()),this.focusable=t(this.focusable.not(e).get()),this.hoverable=t(this.hoverable.not(e).get())},_delay:function(t,e){function i(){return("string"==typeof t?s[t]:t).apply(s,arguments)}var s=this;return setTimeout(i,e||0)},_hoverable:function(e){this.hoverable=this.hoverable.add(e),this._on(e,{mouseenter:function(e){this._addClass(t(e.currentTarget),null,"ui-state-hover")},mouseleave:function(e){this._removeClass(t(e.currentTarget),null,"ui-state-hover")}})},_focusable:function(e){this.focusable=this.focusable.add(e),this._on(e,{focusin:function(e){this._addClass(t(e.currentTarget),null,"ui-state-focus")},focusout:function(e){this._removeClass(t(e.currentTarget),null,"ui-state-focus")}})},_trigger:function(e,i,s){var n,o,a=this.options[e];if(s=s||{},i=t.Event(i),i.type=(e===this.widgetEventPrefix?e:this.widgetEventPrefix+e).toLowerCase(),i.target=this.element[0],o=i.originalEvent)for(n in o)n in i||(i[n]=o[n]);return this.element.trigger(i,s),!(t.isFunction(a)&&a.apply(this.element[0],[i].concat(s))===!1||i.isDefaultPrevented())}},t.each({show:"fadeIn",hide:"fadeOut"},function(e,i){t.Widget.prototype["_"+e]=function(s,n,o){"string"==typeof n&&(n={effect:n});var a,r=n?n===!0||"number"==typeof n?i:n.effect||i:e;n=n||{},"number"==typeof n&&(n={duration:n}),a=!t.isEmptyObject(n),n.complete=o,n.delay&&s.delay(n.delay),a&&t.effects&&t.effects.effect[r]?s[e](n):r!==e&&s[r]?s[r](n.duration,n.easing,o):s.queue(function(i){t(this)[e](),o&&o.call(s[0]),i()})}}),t.widget,t.widget("ui.accordion",{version:"1.12.1",options:{active:0,animate:{},classes:{"ui-accordion-header":"ui-corner-top","ui-accordion-header-collapsed":"ui-corner-all","ui-accordion-content":"ui-corner-bottom"},collapsible:!1,event:"click",header:"> li > :first-child, > :not(li):even",heightStyle:"auto",icons:{activeHeader:"ui-icon-triangle-1-s",header:"ui-icon-triangle-1-e"},activate:null,beforeActivate:null},hideProps:{borderTopWidth:"hide",borderBottomWidth:"hide",paddingTop:"hide",paddingBottom:"hide",height:"hide"},showProps:{borderTopWidth:"show",borderBottomWidth:"show",paddingTop:"show",paddingBottom:"show",height:"show"},_create:function(){var e=this.options;this.prevShow=this.prevHide=t(),this._addClass("ui-accordion","ui-widget ui-helper-reset"),this.element.attr("role","tablist"),e.collapsible||e.active!==!1&&null!=e.active||(e.active=0),this._processPanels(),0>e.active&&(e.active+=this.headers.length),this._refresh()},_getCreateEventData:function(){return{header:this.active,panel:this.active.length?this.active.next():t()}},_createIcons:function(){var e,i,s=this.options.icons;s&&(e=t("<span>"),this._addClass(e,"ui-accordion-header-icon","ui-icon "+s.header),e.prependTo(this.headers),i=this.active.children(".ui-accordion-header-icon"),this._removeClass(i,s.header)._addClass(i,null,s.activeHeader)._addClass(this.headers,"ui-accordion-icons"))},_destroyIcons:function(){this._removeClass(this.headers,"ui-accordion-icons"),this.headers.children(".ui-accordion-header-icon").remove()},_destroy:function(){var t;this.element.removeAttr("role"),this.headers.removeAttr("role aria-expanded aria-selected aria-controls tabIndex").removeUniqueId(),this._destroyIcons(),t=this.headers.next().css("display","").removeAttr("role aria-hidden aria-labelledby").removeUniqueId(),"content"!==this.options.heightStyle&&t.css("height","")},_setOption:function(t,e){return"active"===t?(this._activate(e),void 0):("event"===t&&(this.options.event&&this._off(this.headers,this.options.event),this._setupEvents(e)),this._super(t,e),"collapsible"!==t||e||this.options.active!==!1||this._activate(0),"icons"===t&&(this._destroyIcons(),e&&this._createIcons()),void 0)},_setOptionDisabled:function(t){this._super(t),this.element.attr("aria-disabled",t),this._toggleClass(null,"ui-state-disabled",!!t),this._toggleClass(this.headers.add(this.headers.next()),null,"ui-state-disabled",!!t)},_keydown:function(e){if(!e.altKey&&!e.ctrlKey){var i=t.ui.keyCode,s=this.headers.length,n=this.headers.index(e.target),o=!1;switch(e.keyCode){case i.RIGHT:case i.DOWN:o=this.headers[(n+1)%s];break;case i.LEFT:case i.UP:o=this.headers[(n-1+s)%s];break;case i.SPACE:case i.ENTER:this._eventHandler(e);break;case i.HOME:o=this.headers[0];break;case i.END:o=this.headers[s-1]}o&&(t(e.target).attr("tabIndex",-1),t(o).attr("tabIndex",0),t(o).trigger("focus"),e.preventDefault())}},_panelKeyDown:function(e){e.keyCode===t.ui.keyCode.UP&&e.ctrlKey&&t(e.currentTarget).prev().trigger("focus")},refresh:function(){var e=this.options;this._processPanels(),e.active===!1&&e.collapsible===!0||!this.headers.length?(e.active=!1,this.active=t()):e.active===!1?this._activate(0):this.active.length&&!t.contains(this.element[0],this.active[0])?this.headers.length===this.headers.find(".ui-state-disabled").length?(e.active=!1,this.active=t()):this._activate(Math.max(0,e.active-1)):e.active=this.headers.index(this.active),this._destroyIcons(),this._refresh()},_processPanels:function(){var t=this.headers,e=this.panels;this.headers=this.element.find(this.options.header),this._addClass(this.headers,"ui-accordion-header ui-accordion-header-collapsed","ui-state-default"),this.panels=this.headers.next().filter(":not(.ui-accordion-content-active)").hide(),this._addClass(this.panels,"ui-accordion-content","ui-helper-reset ui-widget-content"),e&&(this._off(t.not(this.headers)),this._off(e.not(this.panels)))},_refresh:function(){var e,i=this.options,s=i.heightStyle,n=this.element.parent();this.active=this._findActive(i.active),this._addClass(this.active,"ui-accordion-header-active","ui-state-active")._removeClass(this.active,"ui-accordion-header-collapsed"),this._addClass(this.active.next(),"ui-accordion-content-active"),this.active.next().show(),this.headers.attr("role","tab").each(function(){var e=t(this),i=e.uniqueId().attr("id"),s=e.next(),n=s.uniqueId().attr("id");e.attr("aria-controls",n),s.attr("aria-labelledby",i)}).next().attr("role","tabpanel"),this.headers.not(this.active).attr({"aria-selected":"false","aria-expanded":"false",tabIndex:-1}).next().attr({"aria-hidden":"true"}).hide(),this.active.length?this.active.attr({"aria-selected":"true","aria-expanded":"true",tabIndex:0}).next().attr({"aria-hidden":"false"}):this.headers.eq(0).attr("tabIndex",0),this._createIcons(),this._setupEvents(i.event),"fill"===s?(e=n.height(),this.element.siblings(":visible").each(function(){var i=t(this),s=i.css("position");"absolute"!==s&&"fixed"!==s&&(e-=i.outerHeight(!0))}),this.headers.each(function(){e-=t(this).outerHeight(!0)}),this.headers.next().each(function(){t(this).height(Math.max(0,e-t(this).innerHeight()+t(this).height()))}).css("overflow","auto")):"auto"===s&&(e=0,this.headers.next().each(function(){var i=t(this).is(":visible");i||t(this).show(),e=Math.max(e,t(this).css("height","").height()),i||t(this).hide()}).height(e))},_activate:function(e){var i=this._findActive(e)[0];i!==this.active[0]&&(i=i||this.active[0],this._eventHandler({target:i,currentTarget:i,preventDefault:t.noop}))},_findActive:function(e){return"number"==typeof e?this.headers.eq(e):t()},_setupEvents:function(e){var i={keydown:"_keydown"};e&&t.each(e.split(" "),function(t,e){i[e]="_eventHandler"}),this._off(this.headers.add(this.headers.next())),this._on(this.headers,i),this._on(this.headers.next(),{keydown:"_panelKeyDown"}),this._hoverable(this.headers),this._focusable(this.headers)},_eventHandler:function(e){var i,s,n=this.options,o=this.active,a=t(e.currentTarget),r=a[0]===o[0],l=r&&n.collapsible,h=l?t():a.next(),c=o.next(),u={oldHeader:o,oldPanel:c,newHeader:l?t():a,newPanel:h};e.preventDefault(),r&&!n.collapsible||this._trigger("beforeActivate",e,u)===!1||(n.active=l?!1:this.headers.index(a),this.active=r?t():a,this._toggle(u),this._removeClass(o,"ui-accordion-header-active","ui-state-active"),n.icons&&(i=o.children(".ui-accordion-header-icon"),this._removeClass(i,null,n.icons.activeHeader)._addClass(i,null,n.icons.header)),r||(this._removeClass(a,"ui-accordion-header-collapsed")._addClass(a,"ui-accordion-header-active","ui-state-active"),n.icons&&(s=a.children(".ui-accordion-header-icon"),this._removeClass(s,null,n.icons.header)._addClass(s,null,n.icons.activeHeader)),this._addClass(a.next(),"ui-accordion-content-active")))},_toggle:function(e){var i=e.newPanel,s=this.prevShow.length?this.prevShow:e.oldPanel;this.prevShow.add(this.prevHide).stop(!0,!0),this.prevShow=i,this.prevHide=s,this.options.animate?this._animate(i,s,e):(s.hide(),i.show(),this._toggleComplete(e)),s.attr({"aria-hidden":"true"}),s.prev().attr({"aria-selected":"false","aria-expanded":"false"}),i.length&&s.length?s.prev().attr({tabIndex:-1,"aria-expanded":"false"}):i.length&&this.headers.filter(function(){return 0===parseInt(t(this).attr("tabIndex"),10)}).attr("tabIndex",-1),i.attr("aria-hidden","false").prev().attr({"aria-selected":"true","aria-expanded":"true",tabIndex:0})},_animate:function(t,e,i){var s,n,o,a=this,r=0,l=t.css("box-sizing"),h=t.length&&(!e.length||t.index()<e.index()),c=this.options.animate||{},u=h&&c.down||c,d=function(){a._toggleComplete(i)};return"number"==typeof u&&(o=u),"string"==typeof u&&(n=u),n=n||u.easing||c.easing,o=o||u.duration||c.duration,e.length?t.length?(s=t.show().outerHeight(),e.animate(this.hideProps,{duration:o,easing:n,step:function(t,e){e.now=Math.round(t)}}),t.hide().animate(this.showProps,{duration:o,easing:n,complete:d,step:function(t,i){i.now=Math.round(t),"height"!==i.prop?"content-box"===l&&(r+=i.now):"content"!==a.options.heightStyle&&(i.now=Math.round(s-e.outerHeight()-r),r=0)}}),void 0):e.animate(this.hideProps,o,n,d):t.animate(this.showProps,o,n,d)},_toggleComplete:function(t){var e=t.oldPanel,i=e.prev();this._removeClass(e,"ui-accordion-content-active"),this._removeClass(i,"ui-accordion-header-active")._addClass(i,"ui-accordion-header-collapsed"),e.length&&(e.parent()[0].className=e.parent()[0].className),this._trigger("activate",null,t)}}),t.ui.safeActiveElement=function(t){var e;try{e=t.activeElement}catch(i){e=t.body}return e||(e=t.body),e.nodeName||(e=t.body),e},t.widget("ui.menu",{version:"1.12.1",defaultElement:"<ul>",delay:300,options:{icons:{submenu:"ui-icon-caret-1-e"},items:"> *",menus:"ul",position:{my:"left top",at:"right top"},role:"menu",blur:null,focus:null,select:null},_create:function(){this.activeMenu=this.element,this.mouseHandled=!1,this.element.uniqueId().attr({role:this.options.role,tabIndex:0}),this._addClass("ui-menu","ui-widget ui-widget-content"),this._on({"mousedown .ui-menu-item":function(t){t.preventDefault()},"click .ui-menu-item":function(e){var i=t(e.target),s=t(t.ui.safeActiveElement(this.document[0]));!this.mouseHandled&&i.not(".ui-state-disabled").length&&(this.select(e),e.isPropagationStopped()||(this.mouseHandled=!0),i.has(".ui-menu").length?this.expand(e):!this.element.is(":focus")&&s.closest(".ui-menu").length&&(this.element.trigger("focus",[!0]),this.active&&1===this.active.parents(".ui-menu").length&&clearTimeout(this.timer)))},"mouseenter .ui-menu-item":function(e){if(!this.previousFilter){var i=t(e.target).closest(".ui-menu-item"),s=t(e.currentTarget);i[0]===s[0]&&(this._removeClass(s.siblings().children(".ui-state-active"),null,"ui-state-active"),this.focus(e,s))}},mouseleave:"collapseAll","mouseleave .ui-menu":"collapseAll",focus:function(t,e){var i=this.active||this.element.find(this.options.items).eq(0);e||this.focus(t,i)},blur:function(e){this._delay(function(){var i=!t.contains(this.element[0],t.ui.safeActiveElement(this.document[0]));i&&this.collapseAll(e)})},keydown:"_keydown"}),this.refresh(),this._on(this.document,{click:function(t){this._closeOnDocumentClick(t)&&this.collapseAll(t),this.mouseHandled=!1}})},_destroy:function(){var e=this.element.find(".ui-menu-item").removeAttr("role aria-disabled"),i=e.children(".ui-menu-item-wrapper").removeUniqueId().removeAttr("tabIndex role aria-haspopup");this.element.removeAttr("aria-activedescendant").find(".ui-menu").addBack().removeAttr("role aria-labelledby aria-expanded aria-hidden aria-disabled tabIndex").removeUniqueId().show(),i.children().each(function(){var e=t(this);e.data("ui-menu-submenu-caret")&&e.remove()})},_keydown:function(e){var i,s,n,o,a=!0;switch(e.keyCode){case t.ui.keyCode.PAGE_UP:this.previousPage(e);break;case t.ui.keyCode.PAGE_DOWN:this.nextPage(e);break;case t.ui.keyCode.HOME:this._move("first","first",e);break;case t.ui.keyCode.END:this._move("last","last",e);break;case t.ui.keyCode.UP:this.previous(e);break;case t.ui.keyCode.DOWN:this.next(e);break;case t.ui.keyCode.LEFT:this.collapse(e);break;case t.ui.keyCode.RIGHT:this.active&&!this.active.is(".ui-state-disabled")&&this.expand(e);break;case t.ui.keyCode.ENTER:case t.ui.keyCode.SPACE:this._activate(e);break;case t.ui.keyCode.ESCAPE:this.collapse(e);break;default:a=!1,s=this.previousFilter||"",o=!1,n=e.keyCode>=96&&105>=e.keyCode?""+(e.keyCode-96):String.fromCharCode(e.keyCode),clearTimeout(this.filterTimer),n===s?o=!0:n=s+n,i=this._filterMenuItems(n),i=o&&-1!==i.index(this.active.next())?this.active.nextAll(".ui-menu-item"):i,i.length||(n=String.fromCharCode(e.keyCode),i=this._filterMenuItems(n)),i.length?(this.focus(e,i),this.previousFilter=n,this.filterTimer=this._delay(function(){delete this.previousFilter},1e3)):delete this.previousFilter}a&&e.preventDefault()},_activate:function(t){this.active&&!this.active.is(".ui-state-disabled")&&(this.active.children("[aria-haspopup='true']").length?this.expand(t):this.select(t))},refresh:function(){var e,i,s,n,o,a=this,r=this.options.icons.submenu,l=this.element.find(this.options.menus);this._toggleClass("ui-menu-icons",null,!!this.element.find(".ui-icon").length),s=l.filter(":not(.ui-menu)").hide().attr({role:this.options.role,"aria-hidden":"true","aria-expanded":"false"}).each(function(){var e=t(this),i=e.prev(),s=t("<span>").data("ui-menu-submenu-caret",!0);a._addClass(s,"ui-menu-icon","ui-icon "+r),i.attr("aria-haspopup","true").prepend(s),e.attr("aria-labelledby",i.attr("id"))}),this._addClass(s,"ui-menu","ui-widget ui-widget-content ui-front"),e=l.add(this.element),i=e.find(this.options.items),i.not(".ui-menu-item").each(function(){var e=t(this);a._isDivider(e)&&a._addClass(e,"ui-menu-divider","ui-widget-content")}),n=i.not(".ui-menu-item, .ui-menu-divider"),o=n.children().not(".ui-menu").uniqueId().attr({tabIndex:-1,role:this._itemRole()}),this._addClass(n,"ui-menu-item")._addClass(o,"ui-menu-item-wrapper"),i.filter(".ui-state-disabled").attr("aria-disabled","true"),this.active&&!t.contains(this.element[0],this.active[0])&&this.blur()},_itemRole:function(){return{menu:"menuitem",listbox:"option"}[this.options.role]},_setOption:function(t,e){if("icons"===t){var i=this.element.find(".ui-menu-icon");this._removeClass(i,null,this.options.icons.submenu)._addClass(i,null,e.submenu)}this._super(t,e)},_setOptionDisabled:function(t){this._super(t),this.element.attr("aria-disabled",t+""),this._toggleClass(null,"ui-state-disabled",!!t)},focus:function(t,e){var i,s,n;this.blur(t,t&&"focus"===t.type),this._scrollIntoView(e),this.active=e.first(),s=this.active.children(".ui-menu-item-wrapper"),this._addClass(s,null,"ui-state-active"),this.options.role&&this.element.attr("aria-activedescendant",s.attr("id")),n=this.active.parent().closest(".ui-menu-item").children(".ui-menu-item-wrapper"),this._addClass(n,null,"ui-state-active"),t&&"keydown"===t.type?this._close():this.timer=this._delay(function(){this._close()},this.delay),i=e.children(".ui-menu"),i.length&&t&&/^mouse/.test(t.type)&&this._startOpening(i),this.activeMenu=e.parent(),this._trigger("focus",t,{item:e})},_scrollIntoView:function(e){var i,s,n,o,a,r;this._hasScroll()&&(i=parseFloat(t.css(this.activeMenu[0],"borderTopWidth"))||0,s=parseFloat(t.css(this.activeMenu[0],"paddingTop"))||0,n=e.offset().top-this.activeMenu.offset().top-i-s,o=this.activeMenu.scrollTop(),a=this.activeMenu.height(),r=e.outerHeight(),0>n?this.activeMenu.scrollTop(o+n):n+r>a&&this.activeMenu.scrollTop(o+n-a+r))},blur:function(t,e){e||clearTimeout(this.timer),this.active&&(this._removeClass(this.active.children(".ui-menu-item-wrapper"),null,"ui-state-active"),this._trigger("blur",t,{item:this.active}),this.active=null)},_startOpening:function(t){clearTimeout(this.timer),"true"===t.attr("aria-hidden")&&(this.timer=this._delay(function(){this._close(),this._open(t)},this.delay))},_open:function(e){var i=t.extend({of:this.active},this.options.position);clearTimeout(this.timer),this.element.find(".ui-menu").not(e.parents(".ui-menu")).hide().attr("aria-hidden","true"),e.show().removeAttr("aria-hidden").attr("aria-expanded","true").position(i)},collapseAll:function(e,i){clearTimeout(this.timer),this.timer=this._delay(function(){var s=i?this.element:t(e&&e.target).closest(this.element.find(".ui-menu"));s.length||(s=this.element),this._close(s),this.blur(e),this._removeClass(s.find(".ui-state-active"),null,"ui-state-active"),this.activeMenu=s},this.delay)},_close:function(t){t||(t=this.active?this.active.parent():this.element),t.find(".ui-menu").hide().attr("aria-hidden","true").attr("aria-expanded","false")},_closeOnDocumentClick:function(e){return!t(e.target).closest(".ui-menu").length},_isDivider:function(t){return!/[^\-\u2014\u2013\s]/.test(t.text())},collapse:function(t){var e=this.active&&this.active.parent().closest(".ui-menu-item",this.element);e&&e.length&&(this._close(),this.focus(t,e))},expand:function(t){var e=this.active&&this.active.children(".ui-menu ").find(this.options.items).first();e&&e.length&&(this._open(e.parent()),this._delay(function(){this.focus(t,e)}))},next:function(t){this._move("next","first",t)},previous:function(t){this._move("prev","last",t)},isFirstItem:function(){return this.active&&!this.active.prevAll(".ui-menu-item").length},isLastItem:function(){return this.active&&!this.active.nextAll(".ui-menu-item").length},_move:function(t,e,i){var s;this.active&&(s="first"===t||"last"===t?this.active["first"===t?"prevAll":"nextAll"](".ui-menu-item").eq(-1):this.active[t+"All"](".ui-menu-item").eq(0)),s&&s.length&&this.active||(s=this.activeMenu.find(this.options.items)[e]()),this.focus(i,s)},nextPage:function(e){var i,s,n;return this.active?(this.isLastItem()||(this._hasScroll()?(s=this.active.offset().top,n=this.element.height(),this.active.nextAll(".ui-menu-item").each(function(){return i=t(this),0>i.offset().top-s-n}),this.focus(e,i)):this.focus(e,this.activeMenu.find(this.options.items)[this.active?"last":"first"]())),void 0):(this.next(e),void 0)},previousPage:function(e){var i,s,n;return this.active?(this.isFirstItem()||(this._hasScroll()?(s=this.active.offset().top,n=this.element.height(),this.active.prevAll(".ui-menu-item").each(function(){return i=t(this),i.offset().top-s+n>0}),this.focus(e,i)):this.focus(e,this.activeMenu.find(this.options.items).first())),void 0):(this.next(e),void 0)},_hasScroll:function(){return this.element.outerHeight()<this.element.prop("scrollHeight")},select:function(e){this.active=this.active||t(e.target).closest(".ui-menu-item");var i={item:this.active};this.active.has(".ui-menu").length||this.collapseAll(e,!0),this._trigger("select",e,i)},_filterMenuItems:function(e){var i=e.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g,"\\$&"),s=RegExp("^"+i,"i");return this.activeMenu.find(this.options.items).filter(".ui-menu-item").filter(function(){return s.test(t.trim(t(this).children(".ui-menu-item-wrapper").text()))})}}),t.widget("ui.autocomplete",{version:"1.12.1",defaultElement:"<input>",options:{appendTo:null,autoFocus:!1,delay:300,minLength:1,position:{my:"left top",at:"left bottom",collision:"none"},source:null,change:null,close:null,focus:null,open:null,response:null,search:null,select:null},requestIndex:0,pending:0,_create:function(){var e,i,s,n=this.element[0].nodeName.toLowerCase(),o="textarea"===n,a="input"===n;this.isMultiLine=o||!a&&this._isContentEditable(this.element),this.valueMethod=this.element[o||a?"val":"text"],this.isNewMenu=!0,this._addClass("ui-autocomplete-input"),this.element.attr("autocomplete","off"),this._on(this.element,{keydown:function(n){if(this.element.prop("readOnly"))return e=!0,s=!0,i=!0,void 0;
e=!1,s=!1,i=!1;var o=t.ui.keyCode;switch(n.keyCode){case o.PAGE_UP:e=!0,this._move("previousPage",n);break;case o.PAGE_DOWN:e=!0,this._move("nextPage",n);break;case o.UP:e=!0,this._keyEvent("previous",n);break;case o.DOWN:e=!0,this._keyEvent("next",n);break;case o.ENTER:this.menu.active&&(e=!0,n.preventDefault(),this.menu.select(n));break;case o.TAB:this.menu.active&&this.menu.select(n);break;case o.ESCAPE:this.menu.element.is(":visible")&&(this.isMultiLine||this._value(this.term),this.close(n),n.preventDefault());break;default:i=!0,this._searchTimeout(n)}},keypress:function(s){if(e)return e=!1,(!this.isMultiLine||this.menu.element.is(":visible"))&&s.preventDefault(),void 0;if(!i){var n=t.ui.keyCode;switch(s.keyCode){case n.PAGE_UP:this._move("previousPage",s);break;case n.PAGE_DOWN:this._move("nextPage",s);break;case n.UP:this._keyEvent("previous",s);break;case n.DOWN:this._keyEvent("next",s)}}},input:function(t){return s?(s=!1,t.preventDefault(),void 0):(this._searchTimeout(t),void 0)},focus:function(){this.selectedItem=null,this.previous=this._value()},blur:function(t){return this.cancelBlur?(delete this.cancelBlur,void 0):(clearTimeout(this.searching),this.close(t),this._change(t),void 0)}}),this._initSource(),this.menu=t("<ul>").appendTo(this._appendTo()).menu({role:null}).hide().menu("instance"),this._addClass(this.menu.element,"ui-autocomplete","ui-front"),this._on(this.menu.element,{mousedown:function(e){e.preventDefault(),this.cancelBlur=!0,this._delay(function(){delete this.cancelBlur,this.element[0]!==t.ui.safeActiveElement(this.document[0])&&this.element.trigger("focus")})},menufocus:function(e,i){var s,n;return this.isNewMenu&&(this.isNewMenu=!1,e.originalEvent&&/^mouse/.test(e.originalEvent.type))?(this.menu.blur(),this.document.one("mousemove",function(){t(e.target).trigger(e.originalEvent)}),void 0):(n=i.item.data("ui-autocomplete-item"),!1!==this._trigger("focus",e,{item:n})&&e.originalEvent&&/^key/.test(e.originalEvent.type)&&this._value(n.value),s=i.item.attr("aria-label")||n.value,s&&t.trim(s).length&&(this.liveRegion.children().hide(),t("<div>").text(s).appendTo(this.liveRegion)),void 0)},menuselect:function(e,i){var s=i.item.data("ui-autocomplete-item"),n=this.previous;this.element[0]!==t.ui.safeActiveElement(this.document[0])&&(this.element.trigger("focus"),this.previous=n,this._delay(function(){this.previous=n,this.selectedItem=s})),!1!==this._trigger("select",e,{item:s})&&this._value(s.value),this.term=this._value(),this.close(e),this.selectedItem=s}}),this.liveRegion=t("<div>",{role:"status","aria-live":"assertive","aria-relevant":"additions"}).appendTo(this.document[0].body),this._addClass(this.liveRegion,null,"ui-helper-hidden-accessible"),this._on(this.window,{beforeunload:function(){this.element.removeAttr("autocomplete")}})},_destroy:function(){clearTimeout(this.searching),this.element.removeAttr("autocomplete"),this.menu.element.remove(),this.liveRegion.remove()},_setOption:function(t,e){this._super(t,e),"source"===t&&this._initSource(),"appendTo"===t&&this.menu.element.appendTo(this._appendTo()),"disabled"===t&&e&&this.xhr&&this.xhr.abort()},_isEventTargetInWidget:function(e){var i=this.menu.element[0];return e.target===this.element[0]||e.target===i||t.contains(i,e.target)},_closeOnClickOutside:function(t){this._isEventTargetInWidget(t)||this.close()},_appendTo:function(){var e=this.options.appendTo;return e&&(e=e.jquery||e.nodeType?t(e):this.document.find(e).eq(0)),e&&e[0]||(e=this.element.closest(".ui-front, dialog")),e.length||(e=this.document[0].body),e},_initSource:function(){var e,i,s=this;t.isArray(this.options.source)?(e=this.options.source,this.source=function(i,s){s(t.ui.autocomplete.filter(e,i.term))}):"string"==typeof this.options.source?(i=this.options.source,this.source=function(e,n){s.xhr&&s.xhr.abort(),s.xhr=t.ajax({url:i,data:e,dataType:"json",success:function(t){n(t)},error:function(){n([])}})}):this.source=this.options.source},_searchTimeout:function(t){clearTimeout(this.searching),this.searching=this._delay(function(){var e=this.term===this._value(),i=this.menu.element.is(":visible"),s=t.altKey||t.ctrlKey||t.metaKey||t.shiftKey;(!e||e&&!i&&!s)&&(this.selectedItem=null,this.search(null,t))},this.options.delay)},search:function(t,e){return t=null!=t?t:this._value(),this.term=this._value(),t.length<this.options.minLength?this.close(e):this._trigger("search",e)!==!1?this._search(t):void 0},_search:function(t){this.pending++,this._addClass("ui-autocomplete-loading"),this.cancelSearch=!1,this.source({term:t},this._response())},_response:function(){var e=++this.requestIndex;return t.proxy(function(t){e===this.requestIndex&&this.__response(t),this.pending--,this.pending||this._removeClass("ui-autocomplete-loading")},this)},__response:function(t){t&&(t=this._normalize(t)),this._trigger("response",null,{content:t}),!this.options.disabled&&t&&t.length&&!this.cancelSearch?(this._suggest(t),this._trigger("open")):this._close()},close:function(t){this.cancelSearch=!0,this._close(t)},_close:function(t){this._off(this.document,"mousedown"),this.menu.element.is(":visible")&&(this.menu.element.hide(),this.menu.blur(),this.isNewMenu=!0,this._trigger("close",t))},_change:function(t){this.previous!==this._value()&&this._trigger("change",t,{item:this.selectedItem})},_normalize:function(e){return e.length&&e[0].label&&e[0].value?e:t.map(e,function(e){return"string"==typeof e?{label:e,value:e}:t.extend({},e,{label:e.label||e.value,value:e.value||e.label})})},_suggest:function(e){var i=this.menu.element.empty();this._renderMenu(i,e),this.isNewMenu=!0,this.menu.refresh(),i.show(),this._resizeMenu(),i.position(t.extend({of:this.element},this.options.position)),this.options.autoFocus&&this.menu.next(),this._on(this.document,{mousedown:"_closeOnClickOutside"})},_resizeMenu:function(){var t=this.menu.element;t.outerWidth(Math.max(t.width("").outerWidth()+1,this.element.outerWidth()))},_renderMenu:function(e,i){var s=this;t.each(i,function(t,i){s._renderItemData(e,i)})},_renderItemData:function(t,e){return this._renderItem(t,e).data("ui-autocomplete-item",e)},_renderItem:function(e,i){return t("<li>").append(t("<div>").text(i.label)).appendTo(e)},_move:function(t,e){return this.menu.element.is(":visible")?this.menu.isFirstItem()&&/^previous/.test(t)||this.menu.isLastItem()&&/^next/.test(t)?(this.isMultiLine||this._value(this.term),this.menu.blur(),void 0):(this.menu[t](e),void 0):(this.search(null,e),void 0)},widget:function(){return this.menu.element},_value:function(){return this.valueMethod.apply(this.element,arguments)},_keyEvent:function(t,e){(!this.isMultiLine||this.menu.element.is(":visible"))&&(this._move(t,e),e.preventDefault())},_isContentEditable:function(t){if(!t.length)return!1;var e=t.prop("contentEditable");return"inherit"===e?this._isContentEditable(t.parent()):"true"===e}}),t.extend(t.ui.autocomplete,{escapeRegex:function(t){return t.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g,"\\$&")},filter:function(e,i){var s=RegExp(t.ui.autocomplete.escapeRegex(i),"i");return t.grep(e,function(t){return s.test(t.label||t.value||t)})}}),t.widget("ui.autocomplete",t.ui.autocomplete,{options:{messages:{noResults:"No search results.",results:function(t){return t+(t>1?" results are":" result is")+" available, use up and down arrow keys to navigate."}}},__response:function(e){var i;this._superApply(arguments),this.options.disabled||this.cancelSearch||(i=e&&e.length?this.options.messages.results(e.length):this.options.messages.noResults,this.liveRegion.children().hide(),t("<div>").text(i).appendTo(this.liveRegion))}}),t.ui.autocomplete;var g=/ui-corner-([a-z]){2,6}/g;t.widget("ui.controlgroup",{version:"1.12.1",defaultElement:"<div>",options:{direction:"horizontal",disabled:null,onlyVisible:!0,items:{button:"input[type=button], input[type=submit], input[type=reset], button, a",controlgroupLabel:".ui-controlgroup-label",checkboxradio:"input[type='checkbox'], input[type='radio']",selectmenu:"select",spinner:".ui-spinner-input"}},_create:function(){this._enhance()},_enhance:function(){this.element.attr("role","toolbar"),this.refresh()},_destroy:function(){this._callChildMethod("destroy"),this.childWidgets.removeData("ui-controlgroup-data"),this.element.removeAttr("role"),this.options.items.controlgroupLabel&&this.element.find(this.options.items.controlgroupLabel).find(".ui-controlgroup-label-contents").contents().unwrap()},_initWidgets:function(){var e=this,i=[];t.each(this.options.items,function(s,n){var o,a={};return n?"controlgroupLabel"===s?(o=e.element.find(n),o.each(function(){var e=t(this);e.children(".ui-controlgroup-label-contents").length||e.contents().wrapAll("<span class='ui-controlgroup-label-contents'></span>")}),e._addClass(o,null,"ui-widget ui-widget-content ui-state-default"),i=i.concat(o.get()),void 0):(t.fn[s]&&(a=e["_"+s+"Options"]?e["_"+s+"Options"]("middle"):{classes:{}},e.element.find(n).each(function(){var n=t(this),o=n[s]("instance"),r=t.widget.extend({},a);if("button"!==s||!n.parent(".ui-spinner").length){o||(o=n[s]()[s]("instance")),o&&(r.classes=e._resolveClassesValues(r.classes,o)),n[s](r);var l=n[s]("widget");t.data(l[0],"ui-controlgroup-data",o?o:n[s]("instance")),i.push(l[0])}})),void 0):void 0}),this.childWidgets=t(t.unique(i)),this._addClass(this.childWidgets,"ui-controlgroup-item")},_callChildMethod:function(e){this.childWidgets.each(function(){var i=t(this),s=i.data("ui-controlgroup-data");s&&s[e]&&s[e]()})},_updateCornerClass:function(t,e){var i="ui-corner-top ui-corner-bottom ui-corner-left ui-corner-right ui-corner-all",s=this._buildSimpleOptions(e,"label").classes.label;this._removeClass(t,null,i),this._addClass(t,null,s)},_buildSimpleOptions:function(t,e){var i="vertical"===this.options.direction,s={classes:{}};return s.classes[e]={middle:"",first:"ui-corner-"+(i?"top":"left"),last:"ui-corner-"+(i?"bottom":"right"),only:"ui-corner-all"}[t],s},_spinnerOptions:function(t){var e=this._buildSimpleOptions(t,"ui-spinner");return e.classes["ui-spinner-up"]="",e.classes["ui-spinner-down"]="",e},_buttonOptions:function(t){return this._buildSimpleOptions(t,"ui-button")},_checkboxradioOptions:function(t){return this._buildSimpleOptions(t,"ui-checkboxradio-label")},_selectmenuOptions:function(t){var e="vertical"===this.options.direction;return{width:e?"auto":!1,classes:{middle:{"ui-selectmenu-button-open":"","ui-selectmenu-button-closed":""},first:{"ui-selectmenu-button-open":"ui-corner-"+(e?"top":"tl"),"ui-selectmenu-button-closed":"ui-corner-"+(e?"top":"left")},last:{"ui-selectmenu-button-open":e?"":"ui-corner-tr","ui-selectmenu-button-closed":"ui-corner-"+(e?"bottom":"right")},only:{"ui-selectmenu-button-open":"ui-corner-top","ui-selectmenu-button-closed":"ui-corner-all"}}[t]}},_resolveClassesValues:function(e,i){var s={};return t.each(e,function(n){var o=i.options.classes[n]||"";o=t.trim(o.replace(g,"")),s[n]=(o+" "+e[n]).replace(/\s+/g," ")}),s},_setOption:function(t,e){return"direction"===t&&this._removeClass("ui-controlgroup-"+this.options.direction),this._super(t,e),"disabled"===t?(this._callChildMethod(e?"disable":"enable"),void 0):(this.refresh(),void 0)},refresh:function(){var e,i=this;this._addClass("ui-controlgroup ui-controlgroup-"+this.options.direction),"horizontal"===this.options.direction&&this._addClass(null,"ui-helper-clearfix"),this._initWidgets(),e=this.childWidgets,this.options.onlyVisible&&(e=e.filter(":visible")),e.length&&(t.each(["first","last"],function(t,s){var n=e[s]().data("ui-controlgroup-data");if(n&&i["_"+n.widgetName+"Options"]){var o=i["_"+n.widgetName+"Options"](1===e.length?"only":s);o.classes=i._resolveClassesValues(o.classes,n),n.element[n.widgetName](o)}else i._updateCornerClass(e[s](),s)}),this._callChildMethod("refresh"))}}),t.widget("ui.checkboxradio",[t.ui.formResetMixin,{version:"1.12.1",options:{disabled:null,label:null,icon:!0,classes:{"ui-checkboxradio-label":"ui-corner-all","ui-checkboxradio-icon":"ui-corner-all"}},_getCreateOptions:function(){var e,i,s=this,n=this._super()||{};return this._readType(),i=this.element.labels(),this.label=t(i[i.length-1]),this.label.length||t.error("No label found for checkboxradio widget"),this.originalLabel="",this.label.contents().not(this.element[0]).each(function(){s.originalLabel+=3===this.nodeType?t(this).text():this.outerHTML}),this.originalLabel&&(n.label=this.originalLabel),e=this.element[0].disabled,null!=e&&(n.disabled=e),n},_create:function(){var t=this.element[0].checked;this._bindFormResetHandler(),null==this.options.disabled&&(this.options.disabled=this.element[0].disabled),this._setOption("disabled",this.options.disabled),this._addClass("ui-checkboxradio","ui-helper-hidden-accessible"),this._addClass(this.label,"ui-checkboxradio-label","ui-button ui-widget"),"radio"===this.type&&this._addClass(this.label,"ui-checkboxradio-radio-label"),this.options.label&&this.options.label!==this.originalLabel?this._updateLabel():this.originalLabel&&(this.options.label=this.originalLabel),this._enhance(),t&&(this._addClass(this.label,"ui-checkboxradio-checked","ui-state-active"),this.icon&&this._addClass(this.icon,null,"ui-state-hover")),this._on({change:"_toggleClasses",focus:function(){this._addClass(this.label,null,"ui-state-focus ui-visual-focus")},blur:function(){this._removeClass(this.label,null,"ui-state-focus ui-visual-focus")}})},_readType:function(){var e=this.element[0].nodeName.toLowerCase();this.type=this.element[0].type,"input"===e&&/radio|checkbox/.test(this.type)||t.error("Can't create checkboxradio on element.nodeName="+e+" and element.type="+this.type)},_enhance:function(){this._updateIcon(this.element[0].checked)},widget:function(){return this.label},_getRadioGroup:function(){var e,i=this.element[0].name,s="input[name='"+t.ui.escapeSelector(i)+"']";return i?(e=this.form.length?t(this.form[0].elements).filter(s):t(s).filter(function(){return 0===t(this).form().length}),e.not(this.element)):t([])},_toggleClasses:function(){var e=this.element[0].checked;this._toggleClass(this.label,"ui-checkboxradio-checked","ui-state-active",e),this.options.icon&&"checkbox"===this.type&&this._toggleClass(this.icon,null,"ui-icon-check ui-state-checked",e)._toggleClass(this.icon,null,"ui-icon-blank",!e),"radio"===this.type&&this._getRadioGroup().each(function(){var e=t(this).checkboxradio("instance");e&&e._removeClass(e.label,"ui-checkboxradio-checked","ui-state-active")})},_destroy:function(){this._unbindFormResetHandler(),this.icon&&(this.icon.remove(),this.iconSpace.remove())},_setOption:function(t,e){return"label"!==t||e?(this._super(t,e),"disabled"===t?(this._toggleClass(this.label,null,"ui-state-disabled",e),this.element[0].disabled=e,void 0):(this.refresh(),void 0)):void 0},_updateIcon:function(e){var i="ui-icon ui-icon-background ";this.options.icon?(this.icon||(this.icon=t("<span>"),this.iconSpace=t("<span> </span>"),this._addClass(this.iconSpace,"ui-checkboxradio-icon-space")),"checkbox"===this.type?(i+=e?"ui-icon-check ui-state-checked":"ui-icon-blank",this._removeClass(this.icon,null,e?"ui-icon-blank":"ui-icon-check")):i+="ui-icon-blank",this._addClass(this.icon,"ui-checkboxradio-icon",i),e||this._removeClass(this.icon,null,"ui-icon-check ui-state-checked"),this.icon.prependTo(this.label).after(this.iconSpace)):void 0!==this.icon&&(this.icon.remove(),this.iconSpace.remove(),delete this.icon)},_updateLabel:function(){var t=this.label.contents().not(this.element[0]);this.icon&&(t=t.not(this.icon[0])),this.iconSpace&&(t=t.not(this.iconSpace[0])),t.remove(),this.label.append(this.options.label)},refresh:function(){var t=this.element[0].checked,e=this.element[0].disabled;this._updateIcon(t),this._toggleClass(this.label,"ui-checkboxradio-checked","ui-state-active",t),null!==this.options.label&&this._updateLabel(),e!==this.options.disabled&&this._setOptions({disabled:e})}}]),t.ui.checkboxradio,t.widget("ui.button",{version:"1.12.1",defaultElement:"<button>",options:{classes:{"ui-button":"ui-corner-all"},disabled:null,icon:null,iconPosition:"beginning",label:null,showLabel:!0},_getCreateOptions:function(){var t,e=this._super()||{};return this.isInput=this.element.is("input"),t=this.element[0].disabled,null!=t&&(e.disabled=t),this.originalLabel=this.isInput?this.element.val():this.element.html(),this.originalLabel&&(e.label=this.originalLabel),e},_create:function(){!this.option.showLabel&!this.options.icon&&(this.options.showLabel=!0),null==this.options.disabled&&(this.options.disabled=this.element[0].disabled||!1),this.hasTitle=!!this.element.attr("title"),this.options.label&&this.options.label!==this.originalLabel&&(this.isInput?this.element.val(this.options.label):this.element.html(this.options.label)),this._addClass("ui-button","ui-widget"),this._setOption("disabled",this.options.disabled),this._enhance(),this.element.is("a")&&this._on({keyup:function(e){e.keyCode===t.ui.keyCode.SPACE&&(e.preventDefault(),this.element[0].click?this.element[0].click():this.element.trigger("click"))}})},_enhance:function(){this.element.is("button")||this.element.attr("role","button"),this.options.icon&&(this._updateIcon("icon",this.options.icon),this._updateTooltip())},_updateTooltip:function(){this.title=this.element.attr("title"),this.options.showLabel||this.title||this.element.attr("title",this.options.label)},_updateIcon:function(e,i){var s="iconPosition"!==e,n=s?this.options.iconPosition:i,o="top"===n||"bottom"===n;this.icon?s&&this._removeClass(this.icon,null,this.options.icon):(this.icon=t("<span>"),this._addClass(this.icon,"ui-button-icon","ui-icon"),this.options.showLabel||this._addClass("ui-button-icon-only")),s&&this._addClass(this.icon,null,i),this._attachIcon(n),o?(this._addClass(this.icon,null,"ui-widget-icon-block"),this.iconSpace&&this.iconSpace.remove()):(this.iconSpace||(this.iconSpace=t("<span> </span>"),this._addClass(this.iconSpace,"ui-button-icon-space")),this._removeClass(this.icon,null,"ui-wiget-icon-block"),this._attachIconSpace(n))},_destroy:function(){this.element.removeAttr("role"),this.icon&&this.icon.remove(),this.iconSpace&&this.iconSpace.remove(),this.hasTitle||this.element.removeAttr("title")},_attachIconSpace:function(t){this.icon[/^(?:end|bottom)/.test(t)?"before":"after"](this.iconSpace)},_attachIcon:function(t){this.element[/^(?:end|bottom)/.test(t)?"append":"prepend"](this.icon)},_setOptions:function(t){var e=void 0===t.showLabel?this.options.showLabel:t.showLabel,i=void 0===t.icon?this.options.icon:t.icon;e||i||(t.showLabel=!0),this._super(t)},_setOption:function(t,e){"icon"===t&&(e?this._updateIcon(t,e):this.icon&&(this.icon.remove(),this.iconSpace&&this.iconSpace.remove())),"iconPosition"===t&&this._updateIcon(t,e),"showLabel"===t&&(this._toggleClass("ui-button-icon-only",null,!e),this._updateTooltip()),"label"===t&&(this.isInput?this.element.val(e):(this.element.html(e),this.icon&&(this._attachIcon(this.options.iconPosition),this._attachIconSpace(this.options.iconPosition)))),this._super(t,e),"disabled"===t&&(this._toggleClass(null,"ui-state-disabled",e),this.element[0].disabled=e,e&&this.element.blur())},refresh:function(){var t=this.element.is("input, button")?this.element[0].disabled:this.element.hasClass("ui-button-disabled");t!==this.options.disabled&&this._setOptions({disabled:t}),this._updateTooltip()}}),t.uiBackCompat!==!1&&(t.widget("ui.button",t.ui.button,{options:{text:!0,icons:{primary:null,secondary:null}},_create:function(){this.options.showLabel&&!this.options.text&&(this.options.showLabel=this.options.text),!this.options.showLabel&&this.options.text&&(this.options.text=this.options.showLabel),this.options.icon||!this.options.icons.primary&&!this.options.icons.secondary?this.options.icon&&(this.options.icons.primary=this.options.icon):this.options.icons.primary?this.options.icon=this.options.icons.primary:(this.options.icon=this.options.icons.secondary,this.options.iconPosition="end"),this._super()},_setOption:function(t,e){return"text"===t?(this._super("showLabel",e),void 0):("showLabel"===t&&(this.options.text=e),"icon"===t&&(this.options.icons.primary=e),"icons"===t&&(e.primary?(this._super("icon",e.primary),this._super("iconPosition","beginning")):e.secondary&&(this._super("icon",e.secondary),this._super("iconPosition","end"))),this._superApply(arguments),void 0)}}),t.fn.button=function(e){return function(){return!this.length||this.length&&"INPUT"!==this[0].tagName||this.length&&"INPUT"===this[0].tagName&&"checkbox"!==this.attr("type")&&"radio"!==this.attr("type")?e.apply(this,arguments):(t.ui.checkboxradio||t.error("Checkboxradio widget missing"),0===arguments.length?this.checkboxradio({icon:!1}):this.checkboxradio.apply(this,arguments))}}(t.fn.button),t.fn.buttonset=function(){return t.ui.controlgroup||t.error("Controlgroup widget missing"),"option"===arguments[0]&&"items"===arguments[1]&&arguments[2]?this.controlgroup.apply(this,[arguments[0],"items.button",arguments[2]]):"option"===arguments[0]&&"items"===arguments[1]?this.controlgroup.apply(this,[arguments[0],"items.button"]):("object"==typeof arguments[0]&&arguments[0].items&&(arguments[0].items={button:arguments[0].items}),this.controlgroup.apply(this,arguments))}),t.ui.button,t.extend(t.ui,{datepicker:{version:"1.12.1"}});var m;t.extend(s.prototype,{markerClassName:"hasDatepicker",maxRows:4,_widgetDatepicker:function(){return this.dpDiv},setDefaults:function(t){return a(this._defaults,t||{}),this},_attachDatepicker:function(e,i){var s,n,o;s=e.nodeName.toLowerCase(),n="div"===s||"span"===s,e.id||(this.uuid+=1,e.id="dp"+this.uuid),o=this._newInst(t(e),n),o.settings=t.extend({},i||{}),"input"===s?this._connectDatepicker(e,o):n&&this._inlineDatepicker(e,o)},_newInst:function(e,i){var s=e[0].id.replace(/([^A-Za-z0-9_\-])/g,"\\\\$1");return{id:s,input:e,selectedDay:0,selectedMonth:0,selectedYear:0,drawMonth:0,drawYear:0,inline:i,dpDiv:i?n(t("<div class='"+this._inlineClass+" ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>")):this.dpDiv}},_connectDatepicker:function(e,i){var s=t(e);i.append=t([]),i.trigger=t([]),s.hasClass(this.markerClassName)||(this._attachments(s,i),s.addClass(this.markerClassName).on("keydown",this._doKeyDown).on("keypress",this._doKeyPress).on("keyup",this._doKeyUp),this._autoSize(i),t.data(e,"datepicker",i),i.settings.disabled&&this._disableDatepicker(e))},_attachments:function(e,i){var s,n,o,a=this._get(i,"appendText"),r=this._get(i,"isRTL");i.append&&i.append.remove(),a&&(i.append=t("<span class='"+this._appendClass+"'>"+a+"</span>"),e[r?"before":"after"](i.append)),e.off("focus",this._showDatepicker),i.trigger&&i.trigger.remove(),s=this._get(i,"showOn"),("focus"===s||"both"===s)&&e.on("focus",this._showDatepicker),("button"===s||"both"===s)&&(n=this._get(i,"buttonText"),o=this._get(i,"buttonImage"),i.trigger=t(this._get(i,"buttonImageOnly")?t("<img/>").addClass(this._triggerClass).attr({src:o,alt:n,title:n}):t("<button type='button'></button>").addClass(this._triggerClass).html(o?t("<img/>").attr({src:o,alt:n,title:n}):n)),e[r?"before":"after"](i.trigger),i.trigger.on("click",function(){return t.datepicker._datepickerShowing&&t.datepicker._lastInput===e[0]?t.datepicker._hideDatepicker():t.datepicker._datepickerShowing&&t.datepicker._lastInput!==e[0]?(t.datepicker._hideDatepicker(),t.datepicker._showDatepicker(e[0])):t.datepicker._showDatepicker(e[0]),!1}))},_autoSize:function(t){if(this._get(t,"autoSize")&&!t.inline){var e,i,s,n,o=new Date(2009,11,20),a=this._get(t,"dateFormat");a.match(/[DM]/)&&(e=function(t){for(i=0,s=0,n=0;t.length>n;n++)t[n].length>i&&(i=t[n].length,s=n);return s},o.setMonth(e(this._get(t,a.match(/MM/)?"monthNames":"monthNamesShort"))),o.setDate(e(this._get(t,a.match(/DD/)?"dayNames":"dayNamesShort"))+20-o.getDay())),t.input.attr("size",this._formatDate(t,o).length)}},_inlineDatepicker:function(e,i){var s=t(e);s.hasClass(this.markerClassName)||(s.addClass(this.markerClassName).append(i.dpDiv),t.data(e,"datepicker",i),this._setDate(i,this._getDefaultDate(i),!0),this._updateDatepicker(i),this._updateAlternate(i),i.settings.disabled&&this._disableDatepicker(e),i.dpDiv.css("display","block"))},_dialogDatepicker:function(e,i,s,n,o){var r,l,h,c,u,d=this._dialogInst;return d||(this.uuid+=1,r="dp"+this.uuid,this._dialogInput=t("<input type='text' id='"+r+"' style='position: absolute; top: -100px; width: 0px;'/>"),this._dialogInput.on("keydown",this._doKeyDown),t("body").append(this._dialogInput),d=this._dialogInst=this._newInst(this._dialogInput,!1),d.settings={},t.data(this._dialogInput[0],"datepicker",d)),a(d.settings,n||{}),i=i&&i.constructor===Date?this._formatDate(d,i):i,this._dialogInput.val(i),this._pos=o?o.length?o:[o.pageX,o.pageY]:null,this._pos||(l=document.documentElement.clientWidth,h=document.documentElement.clientHeight,c=document.documentElement.scrollLeft||document.body.scrollLeft,u=document.documentElement.scrollTop||document.body.scrollTop,this._pos=[l/2-100+c,h/2-150+u]),this._dialogInput.css("left",this._pos[0]+20+"px").css("top",this._pos[1]+"px"),d.settings.onSelect=s,this._inDialog=!0,this.dpDiv.addClass(this._dialogClass),this._showDatepicker(this._dialogInput[0]),t.blockUI&&t.blockUI(this.dpDiv),t.data(this._dialogInput[0],"datepicker",d),this},_destroyDatepicker:function(e){var i,s=t(e),n=t.data(e,"datepicker");s.hasClass(this.markerClassName)&&(i=e.nodeName.toLowerCase(),t.removeData(e,"datepicker"),"input"===i?(n.append.remove(),n.trigger.remove(),s.removeClass(this.markerClassName).off("focus",this._showDatepicker).off("keydown",this._doKeyDown).off("keypress",this._doKeyPress).off("keyup",this._doKeyUp)):("div"===i||"span"===i)&&s.removeClass(this.markerClassName).empty(),m===n&&(m=null))},_enableDatepicker:function(e){var i,s,n=t(e),o=t.data(e,"datepicker");n.hasClass(this.markerClassName)&&(i=e.nodeName.toLowerCase(),"input"===i?(e.disabled=!1,o.trigger.filter("button").each(function(){this.disabled=!1}).end().filter("img").css({opacity:"1.0",cursor:""})):("div"===i||"span"===i)&&(s=n.children("."+this._inlineClass),s.children().removeClass("ui-state-disabled"),s.find("select.ui-datepicker-month, select.ui-datepicker-year").prop("disabled",!1)),this._disabledInputs=t.map(this._disabledInputs,function(t){return t===e?null:t}))},_disableDatepicker:function(e){var i,s,n=t(e),o=t.data(e,"datepicker");n.hasClass(this.markerClassName)&&(i=e.nodeName.toLowerCase(),"input"===i?(e.disabled=!0,o.trigger.filter("button").each(function(){this.disabled=!0}).end().filter("img").css({opacity:"0.5",cursor:"default"})):("div"===i||"span"===i)&&(s=n.children("."+this._inlineClass),s.children().addClass("ui-state-disabled"),s.find("select.ui-datepicker-month, select.ui-datepicker-year").prop("disabled",!0)),this._disabledInputs=t.map(this._disabledInputs,function(t){return t===e?null:t}),this._disabledInputs[this._disabledInputs.length]=e)},_isDisabledDatepicker:function(t){if(!t)return!1;for(var e=0;this._disabledInputs.length>e;e++)if(this._disabledInputs[e]===t)return!0;return!1},_getInst:function(e){try{return t.data(e,"datepicker")}catch(i){throw"Missing instance data for this datepicker"}},_optionDatepicker:function(e,i,s){var n,o,r,l,h=this._getInst(e);return 2===arguments.length&&"string"==typeof i?"defaults"===i?t.extend({},t.datepicker._defaults):h?"all"===i?t.extend({},h.settings):this._get(h,i):null:(n=i||{},"string"==typeof i&&(n={},n[i]=s),h&&(this._curInst===h&&this._hideDatepicker(),o=this._getDateDatepicker(e,!0),r=this._getMinMaxDate(h,"min"),l=this._getMinMaxDate(h,"max"),a(h.settings,n),null!==r&&void 0!==n.dateFormat&&void 0===n.minDate&&(h.settings.minDate=this._formatDate(h,r)),null!==l&&void 0!==n.dateFormat&&void 0===n.maxDate&&(h.settings.maxDate=this._formatDate(h,l)),"disabled"in n&&(n.disabled?this._disableDatepicker(e):this._enableDatepicker(e)),this._attachments(t(e),h),this._autoSize(h),this._setDate(h,o),this._updateAlternate(h),this._updateDatepicker(h)),void 0)},_changeDatepicker:function(t,e,i){this._optionDatepicker(t,e,i)},_refreshDatepicker:function(t){var e=this._getInst(t);e&&this._updateDatepicker(e)},_setDateDatepicker:function(t,e){var i=this._getInst(t);i&&(this._setDate(i,e),this._updateDatepicker(i),this._updateAlternate(i))},_getDateDatepicker:function(t,e){var i=this._getInst(t);return i&&!i.inline&&this._setDateFromField(i,e),i?this._getDate(i):null},_doKeyDown:function(e){var i,s,n,o=t.datepicker._getInst(e.target),a=!0,r=o.dpDiv.is(".ui-datepicker-rtl");if(o._keyEvent=!0,t.datepicker._datepickerShowing)switch(e.keyCode){case 9:t.datepicker._hideDatepicker(),a=!1;break;case 13:return n=t("td."+t.datepicker._dayOverClass+":not(."+t.datepicker._currentClass+")",o.dpDiv),n[0]&&t.datepicker._selectDay(e.target,o.selectedMonth,o.selectedYear,n[0]),i=t.datepicker._get(o,"onSelect"),i?(s=t.datepicker._formatDate(o),i.apply(o.input?o.input[0]:null,[s,o])):t.datepicker._hideDatepicker(),!1;case 27:t.datepicker._hideDatepicker();break;case 33:t.datepicker._adjustDate(e.target,e.ctrlKey?-t.datepicker._get(o,"stepBigMonths"):-t.datepicker._get(o,"stepMonths"),"M");break;case 34:t.datepicker._adjustDate(e.target,e.ctrlKey?+t.datepicker._get(o,"stepBigMonths"):+t.datepicker._get(o,"stepMonths"),"M");break;case 35:(e.ctrlKey||e.metaKey)&&t.datepicker._clearDate(e.target),a=e.ctrlKey||e.metaKey;break;case 36:(e.ctrlKey||e.metaKey)&&t.datepicker._gotoToday(e.target),a=e.ctrlKey||e.metaKey;break;case 37:(e.ctrlKey||e.metaKey)&&t.datepicker._adjustDate(e.target,r?1:-1,"D"),a=e.ctrlKey||e.metaKey,e.originalEvent.altKey&&t.datepicker._adjustDate(e.target,e.ctrlKey?-t.datepicker._get(o,"stepBigMonths"):-t.datepicker._get(o,"stepMonths"),"M");break;case 38:(e.ctrlKey||e.metaKey)&&t.datepicker._adjustDate(e.target,-7,"D"),a=e.ctrlKey||e.metaKey;break;case 39:(e.ctrlKey||e.metaKey)&&t.datepicker._adjustDate(e.target,r?-1:1,"D"),a=e.ctrlKey||e.metaKey,e.originalEvent.altKey&&t.datepicker._adjustDate(e.target,e.ctrlKey?+t.datepicker._get(o,"stepBigMonths"):+t.datepicker._get(o,"stepMonths"),"M");break;case 40:(e.ctrlKey||e.metaKey)&&t.datepicker._adjustDate(e.target,7,"D"),a=e.ctrlKey||e.metaKey;break;default:a=!1}else 36===e.keyCode&&e.ctrlKey?t.datepicker._showDatepicker(this):a=!1;a&&(e.preventDefault(),e.stopPropagation())},_doKeyPress:function(e){var i,s,n=t.datepicker._getInst(e.target);return t.datepicker._get(n,"constrainInput")?(i=t.datepicker._possibleChars(t.datepicker._get(n,"dateFormat")),s=String.fromCharCode(null==e.charCode?e.keyCode:e.charCode),e.ctrlKey||e.metaKey||" ">s||!i||i.indexOf(s)>-1):void 0},_doKeyUp:function(e){var i,s=t.datepicker._getInst(e.target);if(s.input.val()!==s.lastVal)try{i=t.datepicker.parseDate(t.datepicker._get(s,"dateFormat"),s.input?s.input.val():null,t.datepicker._getFormatConfig(s)),i&&(t.datepicker._setDateFromField(s),t.datepicker._updateAlternate(s),t.datepicker._updateDatepicker(s))}catch(n){}return!0},_showDatepicker:function(e){if(e=e.target||e,"input"!==e.nodeName.toLowerCase()&&(e=t("input",e.parentNode)[0]),!t.datepicker._isDisabledDatepicker(e)&&t.datepicker._lastInput!==e){var s,n,o,r,l,h,c;s=t.datepicker._getInst(e),t.datepicker._curInst&&t.datepicker._curInst!==s&&(t.datepicker._curInst.dpDiv.stop(!0,!0),s&&t.datepicker._datepickerShowing&&t.datepicker._hideDatepicker(t.datepicker._curInst.input[0])),n=t.datepicker._get(s,"beforeShow"),o=n?n.apply(e,[e,s]):{},o!==!1&&(a(s.settings,o),s.lastVal=null,t.datepicker._lastInput=e,t.datepicker._setDateFromField(s),t.datepicker._inDialog&&(e.value=""),t.datepicker._pos||(t.datepicker._pos=t.datepicker._findPos(e),t.datepicker._pos[1]+=e.offsetHeight),r=!1,t(e).parents().each(function(){return r|="fixed"===t(this).css("position"),!r}),l={left:t.datepicker._pos[0],top:t.datepicker._pos[1]},t.datepicker._pos=null,s.dpDiv.empty(),s.dpDiv.css({position:"absolute",display:"block",top:"-1000px"}),t.datepicker._updateDatepicker(s),l=t.datepicker._checkOffset(s,l,r),s.dpDiv.css({position:t.datepicker._inDialog&&t.blockUI?"static":r?"fixed":"absolute",display:"none",left:l.left+"px",top:l.top+"px"}),s.inline||(h=t.datepicker._get(s,"showAnim"),c=t.datepicker._get(s,"duration"),s.dpDiv.css("z-index",i(t(e))+1),t.datepicker._datepickerShowing=!0,t.effects&&t.effects.effect[h]?s.dpDiv.show(h,t.datepicker._get(s,"showOptions"),c):s.dpDiv[h||"show"](h?c:null),t.datepicker._shouldFocusInput(s)&&s.input.trigger("focus"),t.datepicker._curInst=s))
}},_updateDatepicker:function(e){this.maxRows=4,m=e,e.dpDiv.empty().append(this._generateHTML(e)),this._attachHandlers(e);var i,s=this._getNumberOfMonths(e),n=s[1],a=17,r=e.dpDiv.find("."+this._dayOverClass+" a");r.length>0&&o.apply(r.get(0)),e.dpDiv.removeClass("ui-datepicker-multi-2 ui-datepicker-multi-3 ui-datepicker-multi-4").width(""),n>1&&e.dpDiv.addClass("ui-datepicker-multi-"+n).css("width",a*n+"em"),e.dpDiv[(1!==s[0]||1!==s[1]?"add":"remove")+"Class"]("ui-datepicker-multi"),e.dpDiv[(this._get(e,"isRTL")?"add":"remove")+"Class"]("ui-datepicker-rtl"),e===t.datepicker._curInst&&t.datepicker._datepickerShowing&&t.datepicker._shouldFocusInput(e)&&e.input.trigger("focus"),e.yearshtml&&(i=e.yearshtml,setTimeout(function(){i===e.yearshtml&&e.yearshtml&&e.dpDiv.find("select.ui-datepicker-year:first").replaceWith(e.yearshtml),i=e.yearshtml=null},0))},_shouldFocusInput:function(t){return t.input&&t.input.is(":visible")&&!t.input.is(":disabled")&&!t.input.is(":focus")},_checkOffset:function(e,i,s){var n=e.dpDiv.outerWidth(),o=e.dpDiv.outerHeight(),a=e.input?e.input.outerWidth():0,r=e.input?e.input.outerHeight():0,l=document.documentElement.clientWidth+(s?0:t(document).scrollLeft()),h=document.documentElement.clientHeight+(s?0:t(document).scrollTop());return i.left-=this._get(e,"isRTL")?n-a:0,i.left-=s&&i.left===e.input.offset().left?t(document).scrollLeft():0,i.top-=s&&i.top===e.input.offset().top+r?t(document).scrollTop():0,i.left-=Math.min(i.left,i.left+n>l&&l>n?Math.abs(i.left+n-l):0),i.top-=Math.min(i.top,i.top+o>h&&h>o?Math.abs(o+r):0),i},_findPos:function(e){for(var i,s=this._getInst(e),n=this._get(s,"isRTL");e&&("hidden"===e.type||1!==e.nodeType||t.expr.filters.hidden(e));)e=e[n?"previousSibling":"nextSibling"];return i=t(e).offset(),[i.left,i.top]},_hideDatepicker:function(e){var i,s,n,o,a=this._curInst;!a||e&&a!==t.data(e,"datepicker")||this._datepickerShowing&&(i=this._get(a,"showAnim"),s=this._get(a,"duration"),n=function(){t.datepicker._tidyDialog(a)},t.effects&&(t.effects.effect[i]||t.effects[i])?a.dpDiv.hide(i,t.datepicker._get(a,"showOptions"),s,n):a.dpDiv["slideDown"===i?"slideUp":"fadeIn"===i?"fadeOut":"hide"](i?s:null,n),i||n(),this._datepickerShowing=!1,o=this._get(a,"onClose"),o&&o.apply(a.input?a.input[0]:null,[a.input?a.input.val():"",a]),this._lastInput=null,this._inDialog&&(this._dialogInput.css({position:"absolute",left:"0",top:"-100px"}),t.blockUI&&(t.unblockUI(),t("body").append(this.dpDiv))),this._inDialog=!1)},_tidyDialog:function(t){t.dpDiv.removeClass(this._dialogClass).off(".ui-datepicker-calendar")},_checkExternalClick:function(e){if(t.datepicker._curInst){var i=t(e.target),s=t.datepicker._getInst(i[0]);(i[0].id!==t.datepicker._mainDivId&&0===i.parents("#"+t.datepicker._mainDivId).length&&!i.hasClass(t.datepicker.markerClassName)&&!i.closest("."+t.datepicker._triggerClass).length&&t.datepicker._datepickerShowing&&(!t.datepicker._inDialog||!t.blockUI)||i.hasClass(t.datepicker.markerClassName)&&t.datepicker._curInst!==s)&&t.datepicker._hideDatepicker()}},_adjustDate:function(e,i,s){var n=t(e),o=this._getInst(n[0]);this._isDisabledDatepicker(n[0])||(this._adjustInstDate(o,i+("M"===s?this._get(o,"showCurrentAtPos"):0),s),this._updateDatepicker(o))},_gotoToday:function(e){var i,s=t(e),n=this._getInst(s[0]);this._get(n,"gotoCurrent")&&n.currentDay?(n.selectedDay=n.currentDay,n.drawMonth=n.selectedMonth=n.currentMonth,n.drawYear=n.selectedYear=n.currentYear):(i=new Date,n.selectedDay=i.getDate(),n.drawMonth=n.selectedMonth=i.getMonth(),n.drawYear=n.selectedYear=i.getFullYear()),this._notifyChange(n),this._adjustDate(s)},_selectMonthYear:function(e,i,s){var n=t(e),o=this._getInst(n[0]);o["selected"+("M"===s?"Month":"Year")]=o["draw"+("M"===s?"Month":"Year")]=parseInt(i.options[i.selectedIndex].value,10),this._notifyChange(o),this._adjustDate(n)},_selectDay:function(e,i,s,n){var o,a=t(e);t(n).hasClass(this._unselectableClass)||this._isDisabledDatepicker(a[0])||(o=this._getInst(a[0]),o.selectedDay=o.currentDay=t("a",n).html(),o.selectedMonth=o.currentMonth=i,o.selectedYear=o.currentYear=s,this._selectDate(e,this._formatDate(o,o.currentDay,o.currentMonth,o.currentYear)))},_clearDate:function(e){var i=t(e);this._selectDate(i,"")},_selectDate:function(e,i){var s,n=t(e),o=this._getInst(n[0]);i=null!=i?i:this._formatDate(o),o.input&&o.input.val(i),this._updateAlternate(o),s=this._get(o,"onSelect"),s?s.apply(o.input?o.input[0]:null,[i,o]):o.input&&o.input.trigger("change"),o.inline?this._updateDatepicker(o):(this._hideDatepicker(),this._lastInput=o.input[0],"object"!=typeof o.input[0]&&o.input.trigger("focus"),this._lastInput=null)},_updateAlternate:function(e){var i,s,n,o=this._get(e,"altField");o&&(i=this._get(e,"altFormat")||this._get(e,"dateFormat"),s=this._getDate(e),n=this.formatDate(i,s,this._getFormatConfig(e)),t(o).val(n))},noWeekends:function(t){var e=t.getDay();return[e>0&&6>e,""]},iso8601Week:function(t){var e,i=new Date(t.getTime());return i.setDate(i.getDate()+4-(i.getDay()||7)),e=i.getTime(),i.setMonth(0),i.setDate(1),Math.floor(Math.round((e-i)/864e5)/7)+1},parseDate:function(e,i,s){if(null==e||null==i)throw"Invalid arguments";if(i="object"==typeof i?""+i:i+"",""===i)return null;var n,o,a,r,l=0,h=(s?s.shortYearCutoff:null)||this._defaults.shortYearCutoff,c="string"!=typeof h?h:(new Date).getFullYear()%100+parseInt(h,10),u=(s?s.dayNamesShort:null)||this._defaults.dayNamesShort,d=(s?s.dayNames:null)||this._defaults.dayNames,p=(s?s.monthNamesShort:null)||this._defaults.monthNamesShort,f=(s?s.monthNames:null)||this._defaults.monthNames,g=-1,m=-1,_=-1,v=-1,b=!1,y=function(t){var i=e.length>n+1&&e.charAt(n+1)===t;return i&&n++,i},w=function(t){var e=y(t),s="@"===t?14:"!"===t?20:"y"===t&&e?4:"o"===t?3:2,n="y"===t?s:1,o=RegExp("^\\d{"+n+","+s+"}"),a=i.substring(l).match(o);if(!a)throw"Missing number at position "+l;return l+=a[0].length,parseInt(a[0],10)},k=function(e,s,n){var o=-1,a=t.map(y(e)?n:s,function(t,e){return[[e,t]]}).sort(function(t,e){return-(t[1].length-e[1].length)});if(t.each(a,function(t,e){var s=e[1];return i.substr(l,s.length).toLowerCase()===s.toLowerCase()?(o=e[0],l+=s.length,!1):void 0}),-1!==o)return o+1;throw"Unknown name at position "+l},x=function(){if(i.charAt(l)!==e.charAt(n))throw"Unexpected literal at position "+l;l++};for(n=0;e.length>n;n++)if(b)"'"!==e.charAt(n)||y("'")?x():b=!1;else switch(e.charAt(n)){case"d":_=w("d");break;case"D":k("D",u,d);break;case"o":v=w("o");break;case"m":m=w("m");break;case"M":m=k("M",p,f);break;case"y":g=w("y");break;case"@":r=new Date(w("@")),g=r.getFullYear(),m=r.getMonth()+1,_=r.getDate();break;case"!":r=new Date((w("!")-this._ticksTo1970)/1e4),g=r.getFullYear(),m=r.getMonth()+1,_=r.getDate();break;case"'":y("'")?x():b=!0;break;default:x()}if(i.length>l&&(a=i.substr(l),!/^\s+/.test(a)))throw"Extra/unparsed characters found in date: "+a;if(-1===g?g=(new Date).getFullYear():100>g&&(g+=(new Date).getFullYear()-(new Date).getFullYear()%100+(c>=g?0:-100)),v>-1)for(m=1,_=v;;){if(o=this._getDaysInMonth(g,m-1),o>=_)break;m++,_-=o}if(r=this._daylightSavingAdjust(new Date(g,m-1,_)),r.getFullYear()!==g||r.getMonth()+1!==m||r.getDate()!==_)throw"Invalid date";return r},ATOM:"yy-mm-dd",COOKIE:"D, dd M yy",ISO_8601:"yy-mm-dd",RFC_822:"D, d M y",RFC_850:"DD, dd-M-y",RFC_1036:"D, d M y",RFC_1123:"D, d M yy",RFC_2822:"D, d M yy",RSS:"D, d M y",TICKS:"!",TIMESTAMP:"@",W3C:"yy-mm-dd",_ticksTo1970:1e7*60*60*24*(718685+Math.floor(492.5)-Math.floor(19.7)+Math.floor(4.925)),formatDate:function(t,e,i){if(!e)return"";var s,n=(i?i.dayNamesShort:null)||this._defaults.dayNamesShort,o=(i?i.dayNames:null)||this._defaults.dayNames,a=(i?i.monthNamesShort:null)||this._defaults.monthNamesShort,r=(i?i.monthNames:null)||this._defaults.monthNames,l=function(e){var i=t.length>s+1&&t.charAt(s+1)===e;return i&&s++,i},h=function(t,e,i){var s=""+e;if(l(t))for(;i>s.length;)s="0"+s;return s},c=function(t,e,i,s){return l(t)?s[e]:i[e]},u="",d=!1;if(e)for(s=0;t.length>s;s++)if(d)"'"!==t.charAt(s)||l("'")?u+=t.charAt(s):d=!1;else switch(t.charAt(s)){case"d":u+=h("d",e.getDate(),2);break;case"D":u+=c("D",e.getDay(),n,o);break;case"o":u+=h("o",Math.round((new Date(e.getFullYear(),e.getMonth(),e.getDate()).getTime()-new Date(e.getFullYear(),0,0).getTime())/864e5),3);break;case"m":u+=h("m",e.getMonth()+1,2);break;case"M":u+=c("M",e.getMonth(),a,r);break;case"y":u+=l("y")?e.getFullYear():(10>e.getFullYear()%100?"0":"")+e.getFullYear()%100;break;case"@":u+=e.getTime();break;case"!":u+=1e4*e.getTime()+this._ticksTo1970;break;case"'":l("'")?u+="'":d=!0;break;default:u+=t.charAt(s)}return u},_possibleChars:function(t){var e,i="",s=!1,n=function(i){var s=t.length>e+1&&t.charAt(e+1)===i;return s&&e++,s};for(e=0;t.length>e;e++)if(s)"'"!==t.charAt(e)||n("'")?i+=t.charAt(e):s=!1;else switch(t.charAt(e)){case"d":case"m":case"y":case"@":i+="0123456789";break;case"D":case"M":return null;case"'":n("'")?i+="'":s=!0;break;default:i+=t.charAt(e)}return i},_get:function(t,e){return void 0!==t.settings[e]?t.settings[e]:this._defaults[e]},_setDateFromField:function(t,e){if(t.input.val()!==t.lastVal){var i=this._get(t,"dateFormat"),s=t.lastVal=t.input?t.input.val():null,n=this._getDefaultDate(t),o=n,a=this._getFormatConfig(t);try{o=this.parseDate(i,s,a)||n}catch(r){s=e?"":s}t.selectedDay=o.getDate(),t.drawMonth=t.selectedMonth=o.getMonth(),t.drawYear=t.selectedYear=o.getFullYear(),t.currentDay=s?o.getDate():0,t.currentMonth=s?o.getMonth():0,t.currentYear=s?o.getFullYear():0,this._adjustInstDate(t)}},_getDefaultDate:function(t){return this._restrictMinMax(t,this._determineDate(t,this._get(t,"defaultDate"),new Date))},_determineDate:function(e,i,s){var n=function(t){var e=new Date;return e.setDate(e.getDate()+t),e},o=function(i){try{return t.datepicker.parseDate(t.datepicker._get(e,"dateFormat"),i,t.datepicker._getFormatConfig(e))}catch(s){}for(var n=(i.toLowerCase().match(/^c/)?t.datepicker._getDate(e):null)||new Date,o=n.getFullYear(),a=n.getMonth(),r=n.getDate(),l=/([+\-]?[0-9]+)\s*(d|D|w|W|m|M|y|Y)?/g,h=l.exec(i);h;){switch(h[2]||"d"){case"d":case"D":r+=parseInt(h[1],10);break;case"w":case"W":r+=7*parseInt(h[1],10);break;case"m":case"M":a+=parseInt(h[1],10),r=Math.min(r,t.datepicker._getDaysInMonth(o,a));break;case"y":case"Y":o+=parseInt(h[1],10),r=Math.min(r,t.datepicker._getDaysInMonth(o,a))}h=l.exec(i)}return new Date(o,a,r)},a=null==i||""===i?s:"string"==typeof i?o(i):"number"==typeof i?isNaN(i)?s:n(i):new Date(i.getTime());return a=a&&"Invalid Date"==""+a?s:a,a&&(a.setHours(0),a.setMinutes(0),a.setSeconds(0),a.setMilliseconds(0)),this._daylightSavingAdjust(a)},_daylightSavingAdjust:function(t){return t?(t.setHours(t.getHours()>12?t.getHours()+2:0),t):null},_setDate:function(t,e,i){var s=!e,n=t.selectedMonth,o=t.selectedYear,a=this._restrictMinMax(t,this._determineDate(t,e,new Date));t.selectedDay=t.currentDay=a.getDate(),t.drawMonth=t.selectedMonth=t.currentMonth=a.getMonth(),t.drawYear=t.selectedYear=t.currentYear=a.getFullYear(),n===t.selectedMonth&&o===t.selectedYear||i||this._notifyChange(t),this._adjustInstDate(t),t.input&&t.input.val(s?"":this._formatDate(t))},_getDate:function(t){var e=!t.currentYear||t.input&&""===t.input.val()?null:this._daylightSavingAdjust(new Date(t.currentYear,t.currentMonth,t.currentDay));return e},_attachHandlers:function(e){var i=this._get(e,"stepMonths"),s="#"+e.id.replace(/\\\\/g,"\\");e.dpDiv.find("[data-handler]").map(function(){var e={prev:function(){t.datepicker._adjustDate(s,-i,"M")},next:function(){t.datepicker._adjustDate(s,+i,"M")},hide:function(){t.datepicker._hideDatepicker()},today:function(){t.datepicker._gotoToday(s)},selectDay:function(){return t.datepicker._selectDay(s,+this.getAttribute("data-month"),+this.getAttribute("data-year"),this),!1},selectMonth:function(){return t.datepicker._selectMonthYear(s,this,"M"),!1},selectYear:function(){return t.datepicker._selectMonthYear(s,this,"Y"),!1}};t(this).on(this.getAttribute("data-event"),e[this.getAttribute("data-handler")])})},_generateHTML:function(t){var e,i,s,n,o,a,r,l,h,c,u,d,p,f,g,m,_,v,b,y,w,k,x,C,D,T,I,M,P,S,N,H,A,z,O,E,W,F,L,R=new Date,Y=this._daylightSavingAdjust(new Date(R.getFullYear(),R.getMonth(),R.getDate())),B=this._get(t,"isRTL"),j=this._get(t,"showButtonPanel"),q=this._get(t,"hideIfNoPrevNext"),K=this._get(t,"navigationAsDateFormat"),U=this._getNumberOfMonths(t),V=this._get(t,"showCurrentAtPos"),X=this._get(t,"stepMonths"),$=1!==U[0]||1!==U[1],G=this._daylightSavingAdjust(t.currentDay?new Date(t.currentYear,t.currentMonth,t.currentDay):new Date(9999,9,9)),J=this._getMinMaxDate(t,"min"),Q=this._getMinMaxDate(t,"max"),Z=t.drawMonth-V,te=t.drawYear;if(0>Z&&(Z+=12,te--),Q)for(e=this._daylightSavingAdjust(new Date(Q.getFullYear(),Q.getMonth()-U[0]*U[1]+1,Q.getDate())),e=J&&J>e?J:e;this._daylightSavingAdjust(new Date(te,Z,1))>e;)Z--,0>Z&&(Z=11,te--);for(t.drawMonth=Z,t.drawYear=te,i=this._get(t,"prevText"),i=K?this.formatDate(i,this._daylightSavingAdjust(new Date(te,Z-X,1)),this._getFormatConfig(t)):i,s=this._canAdjustMonth(t,-1,te,Z)?"<a class='ui-datepicker-prev ui-corner-all' data-handler='prev' data-event='click' title='"+i+"'><span class='ui-icon ui-icon-circle-triangle-"+(B?"e":"w")+"'>"+i+"</span></a>":q?"":"<a class='ui-datepicker-prev ui-corner-all ui-state-disabled' title='"+i+"'><span class='ui-icon ui-icon-circle-triangle-"+(B?"e":"w")+"'>"+i+"</span></a>",n=this._get(t,"nextText"),n=K?this.formatDate(n,this._daylightSavingAdjust(new Date(te,Z+X,1)),this._getFormatConfig(t)):n,o=this._canAdjustMonth(t,1,te,Z)?"<a class='ui-datepicker-next ui-corner-all' data-handler='next' data-event='click' title='"+n+"'><span class='ui-icon ui-icon-circle-triangle-"+(B?"w":"e")+"'>"+n+"</span></a>":q?"":"<a class='ui-datepicker-next ui-corner-all ui-state-disabled' title='"+n+"'><span class='ui-icon ui-icon-circle-triangle-"+(B?"w":"e")+"'>"+n+"</span></a>",a=this._get(t,"currentText"),r=this._get(t,"gotoCurrent")&&t.currentDay?G:Y,a=K?this.formatDate(a,r,this._getFormatConfig(t)):a,l=t.inline?"":"<button type='button' class='ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all' data-handler='hide' data-event='click'>"+this._get(t,"closeText")+"</button>",h=j?"<div class='ui-datepicker-buttonpane ui-widget-content'>"+(B?l:"")+(this._isInRange(t,r)?"<button type='button' class='ui-datepicker-current ui-state-default ui-priority-secondary ui-corner-all' data-handler='today' data-event='click'>"+a+"</button>":"")+(B?"":l)+"</div>":"",c=parseInt(this._get(t,"firstDay"),10),c=isNaN(c)?0:c,u=this._get(t,"showWeek"),d=this._get(t,"dayNames"),p=this._get(t,"dayNamesMin"),f=this._get(t,"monthNames"),g=this._get(t,"monthNamesShort"),m=this._get(t,"beforeShowDay"),_=this._get(t,"showOtherMonths"),v=this._get(t,"selectOtherMonths"),b=this._getDefaultDate(t),y="",k=0;U[0]>k;k++){for(x="",this.maxRows=4,C=0;U[1]>C;C++){if(D=this._daylightSavingAdjust(new Date(te,Z,t.selectedDay)),T=" ui-corner-all",I="",$){if(I+="<div class='ui-datepicker-group",U[1]>1)switch(C){case 0:I+=" ui-datepicker-group-first",T=" ui-corner-"+(B?"right":"left");break;case U[1]-1:I+=" ui-datepicker-group-last",T=" ui-corner-"+(B?"left":"right");break;default:I+=" ui-datepicker-group-middle",T=""}I+="'>"}for(I+="<div class='ui-datepicker-header ui-widget-header ui-helper-clearfix"+T+"'>"+(/all|left/.test(T)&&0===k?B?o:s:"")+(/all|right/.test(T)&&0===k?B?s:o:"")+this._generateMonthYearHeader(t,Z,te,J,Q,k>0||C>0,f,g)+"</div><table class='ui-datepicker-calendar'><thead>"+"<tr>",M=u?"<th class='ui-datepicker-week-col'>"+this._get(t,"weekHeader")+"</th>":"",w=0;7>w;w++)P=(w+c)%7,M+="<th scope='col'"+((w+c+6)%7>=5?" class='ui-datepicker-week-end'":"")+">"+"<span title='"+d[P]+"'>"+p[P]+"</span></th>";for(I+=M+"</tr></thead><tbody>",S=this._getDaysInMonth(te,Z),te===t.selectedYear&&Z===t.selectedMonth&&(t.selectedDay=Math.min(t.selectedDay,S)),N=(this._getFirstDayOfMonth(te,Z)-c+7)%7,H=Math.ceil((N+S)/7),A=$?this.maxRows>H?this.maxRows:H:H,this.maxRows=A,z=this._daylightSavingAdjust(new Date(te,Z,1-N)),O=0;A>O;O++){for(I+="<tr>",E=u?"<td class='ui-datepicker-week-col'>"+this._get(t,"calculateWeek")(z)+"</td>":"",w=0;7>w;w++)W=m?m.apply(t.input?t.input[0]:null,[z]):[!0,""],F=z.getMonth()!==Z,L=F&&!v||!W[0]||J&&J>z||Q&&z>Q,E+="<td class='"+((w+c+6)%7>=5?" ui-datepicker-week-end":"")+(F?" ui-datepicker-other-month":"")+(z.getTime()===D.getTime()&&Z===t.selectedMonth&&t._keyEvent||b.getTime()===z.getTime()&&b.getTime()===D.getTime()?" "+this._dayOverClass:"")+(L?" "+this._unselectableClass+" ui-state-disabled":"")+(F&&!_?"":" "+W[1]+(z.getTime()===G.getTime()?" "+this._currentClass:"")+(z.getTime()===Y.getTime()?" ui-datepicker-today":""))+"'"+(F&&!_||!W[2]?"":" title='"+W[2].replace(/'/g,"&#39;")+"'")+(L?"":" data-handler='selectDay' data-event='click' data-month='"+z.getMonth()+"' data-year='"+z.getFullYear()+"'")+">"+(F&&!_?"&#xa0;":L?"<span class='ui-state-default'>"+z.getDate()+"</span>":"<a class='ui-state-default"+(z.getTime()===Y.getTime()?" ui-state-highlight":"")+(z.getTime()===G.getTime()?" ui-state-active":"")+(F?" ui-priority-secondary":"")+"' href='#'>"+z.getDate()+"</a>")+"</td>",z.setDate(z.getDate()+1),z=this._daylightSavingAdjust(z);I+=E+"</tr>"}Z++,Z>11&&(Z=0,te++),I+="</tbody></table>"+($?"</div>"+(U[0]>0&&C===U[1]-1?"<div class='ui-datepicker-row-break'></div>":""):""),x+=I}y+=x}return y+=h,t._keyEvent=!1,y},_generateMonthYearHeader:function(t,e,i,s,n,o,a,r){var l,h,c,u,d,p,f,g,m=this._get(t,"changeMonth"),_=this._get(t,"changeYear"),v=this._get(t,"showMonthAfterYear"),b="<div class='ui-datepicker-title'>",y="";if(o||!m)y+="<span class='ui-datepicker-month'>"+a[e]+"</span>";else{for(l=s&&s.getFullYear()===i,h=n&&n.getFullYear()===i,y+="<select class='ui-datepicker-month' data-handler='selectMonth' data-event='change'>",c=0;12>c;c++)(!l||c>=s.getMonth())&&(!h||n.getMonth()>=c)&&(y+="<option value='"+c+"'"+(c===e?" selected='selected'":"")+">"+r[c]+"</option>");y+="</select>"}if(v||(b+=y+(!o&&m&&_?"":"&#xa0;")),!t.yearshtml)if(t.yearshtml="",o||!_)b+="<span class='ui-datepicker-year'>"+i+"</span>";else{for(u=this._get(t,"yearRange").split(":"),d=(new Date).getFullYear(),p=function(t){var e=t.match(/c[+\-].*/)?i+parseInt(t.substring(1),10):t.match(/[+\-].*/)?d+parseInt(t,10):parseInt(t,10);return isNaN(e)?d:e},f=p(u[0]),g=Math.max(f,p(u[1]||"")),f=s?Math.max(f,s.getFullYear()):f,g=n?Math.min(g,n.getFullYear()):g,t.yearshtml+="<select class='ui-datepicker-year' data-handler='selectYear' data-event='change'>";g>=f;f++)t.yearshtml+="<option value='"+f+"'"+(f===i?" selected='selected'":"")+">"+f+"</option>";t.yearshtml+="</select>",b+=t.yearshtml,t.yearshtml=null}return b+=this._get(t,"yearSuffix"),v&&(b+=(!o&&m&&_?"":"&#xa0;")+y),b+="</div>"},_adjustInstDate:function(t,e,i){var s=t.selectedYear+("Y"===i?e:0),n=t.selectedMonth+("M"===i?e:0),o=Math.min(t.selectedDay,this._getDaysInMonth(s,n))+("D"===i?e:0),a=this._restrictMinMax(t,this._daylightSavingAdjust(new Date(s,n,o)));t.selectedDay=a.getDate(),t.drawMonth=t.selectedMonth=a.getMonth(),t.drawYear=t.selectedYear=a.getFullYear(),("M"===i||"Y"===i)&&this._notifyChange(t)},_restrictMinMax:function(t,e){var i=this._getMinMaxDate(t,"min"),s=this._getMinMaxDate(t,"max"),n=i&&i>e?i:e;return s&&n>s?s:n},_notifyChange:function(t){var e=this._get(t,"onChangeMonthYear");e&&e.apply(t.input?t.input[0]:null,[t.selectedYear,t.selectedMonth+1,t])},_getNumberOfMonths:function(t){var e=this._get(t,"numberOfMonths");return null==e?[1,1]:"number"==typeof e?[1,e]:e},_getMinMaxDate:function(t,e){return this._determineDate(t,this._get(t,e+"Date"),null)},_getDaysInMonth:function(t,e){return 32-this._daylightSavingAdjust(new Date(t,e,32)).getDate()},_getFirstDayOfMonth:function(t,e){return new Date(t,e,1).getDay()},_canAdjustMonth:function(t,e,i,s){var n=this._getNumberOfMonths(t),o=this._daylightSavingAdjust(new Date(i,s+(0>e?e:n[0]*n[1]),1));return 0>e&&o.setDate(this._getDaysInMonth(o.getFullYear(),o.getMonth())),this._isInRange(t,o)},_isInRange:function(t,e){var i,s,n=this._getMinMaxDate(t,"min"),o=this._getMinMaxDate(t,"max"),a=null,r=null,l=this._get(t,"yearRange");return l&&(i=l.split(":"),s=(new Date).getFullYear(),a=parseInt(i[0],10),r=parseInt(i[1],10),i[0].match(/[+\-].*/)&&(a+=s),i[1].match(/[+\-].*/)&&(r+=s)),(!n||e.getTime()>=n.getTime())&&(!o||e.getTime()<=o.getTime())&&(!a||e.getFullYear()>=a)&&(!r||r>=e.getFullYear())},_getFormatConfig:function(t){var e=this._get(t,"shortYearCutoff");return e="string"!=typeof e?e:(new Date).getFullYear()%100+parseInt(e,10),{shortYearCutoff:e,dayNamesShort:this._get(t,"dayNamesShort"),dayNames:this._get(t,"dayNames"),monthNamesShort:this._get(t,"monthNamesShort"),monthNames:this._get(t,"monthNames")}},_formatDate:function(t,e,i,s){e||(t.currentDay=t.selectedDay,t.currentMonth=t.selectedMonth,t.currentYear=t.selectedYear);var n=e?"object"==typeof e?e:this._daylightSavingAdjust(new Date(s,i,e)):this._daylightSavingAdjust(new Date(t.currentYear,t.currentMonth,t.currentDay));return this.formatDate(this._get(t,"dateFormat"),n,this._getFormatConfig(t))}}),t.fn.datepicker=function(e){if(!this.length)return this;t.datepicker.initialized||(t(document).on("mousedown",t.datepicker._checkExternalClick),t.datepicker.initialized=!0),0===t("#"+t.datepicker._mainDivId).length&&t("body").append(t.datepicker.dpDiv);var i=Array.prototype.slice.call(arguments,1);return"string"!=typeof e||"isDisabled"!==e&&"getDate"!==e&&"widget"!==e?"option"===e&&2===arguments.length&&"string"==typeof arguments[1]?t.datepicker["_"+e+"Datepicker"].apply(t.datepicker,[this[0]].concat(i)):this.each(function(){"string"==typeof e?t.datepicker["_"+e+"Datepicker"].apply(t.datepicker,[this].concat(i)):t.datepicker._attachDatepicker(this,e)}):t.datepicker["_"+e+"Datepicker"].apply(t.datepicker,[this[0]].concat(i))},t.datepicker=new s,t.datepicker.initialized=!1,t.datepicker.uuid=(new Date).getTime(),t.datepicker.version="1.12.1",t.datepicker,t.ui.ie=!!/msie [\w.]+/.exec(navigator.userAgent.toLowerCase());var _=!1;t(document).on("mouseup",function(){_=!1}),t.widget("ui.mouse",{version:"1.12.1",options:{cancel:"input, textarea, button, select, option",distance:1,delay:0},_mouseInit:function(){var e=this;this.element.on("mousedown."+this.widgetName,function(t){return e._mouseDown(t)}).on("click."+this.widgetName,function(i){return!0===t.data(i.target,e.widgetName+".preventClickEvent")?(t.removeData(i.target,e.widgetName+".preventClickEvent"),i.stopImmediatePropagation(),!1):void 0}),this.started=!1},_mouseDestroy:function(){this.element.off("."+this.widgetName),this._mouseMoveDelegate&&this.document.off("mousemove."+this.widgetName,this._mouseMoveDelegate).off("mouseup."+this.widgetName,this._mouseUpDelegate)},_mouseDown:function(e){if(!_){this._mouseMoved=!1,this._mouseStarted&&this._mouseUp(e),this._mouseDownEvent=e;var i=this,s=1===e.which,n="string"==typeof this.options.cancel&&e.target.nodeName?t(e.target).closest(this.options.cancel).length:!1;return s&&!n&&this._mouseCapture(e)?(this.mouseDelayMet=!this.options.delay,this.mouseDelayMet||(this._mouseDelayTimer=setTimeout(function(){i.mouseDelayMet=!0},this.options.delay)),this._mouseDistanceMet(e)&&this._mouseDelayMet(e)&&(this._mouseStarted=this._mouseStart(e)!==!1,!this._mouseStarted)?(e.preventDefault(),!0):(!0===t.data(e.target,this.widgetName+".preventClickEvent")&&t.removeData(e.target,this.widgetName+".preventClickEvent"),this._mouseMoveDelegate=function(t){return i._mouseMove(t)},this._mouseUpDelegate=function(t){return i._mouseUp(t)},this.document.on("mousemove."+this.widgetName,this._mouseMoveDelegate).on("mouseup."+this.widgetName,this._mouseUpDelegate),e.preventDefault(),_=!0,!0)):!0}},_mouseMove:function(e){if(this._mouseMoved){if(t.ui.ie&&(!document.documentMode||9>document.documentMode)&&!e.button)return this._mouseUp(e);if(!e.which)if(e.originalEvent.altKey||e.originalEvent.ctrlKey||e.originalEvent.metaKey||e.originalEvent.shiftKey)this.ignoreMissingWhich=!0;else if(!this.ignoreMissingWhich)return this._mouseUp(e)}return(e.which||e.button)&&(this._mouseMoved=!0),this._mouseStarted?(this._mouseDrag(e),e.preventDefault()):(this._mouseDistanceMet(e)&&this._mouseDelayMet(e)&&(this._mouseStarted=this._mouseStart(this._mouseDownEvent,e)!==!1,this._mouseStarted?this._mouseDrag(e):this._mouseUp(e)),!this._mouseStarted)},_mouseUp:function(e){this.document.off("mousemove."+this.widgetName,this._mouseMoveDelegate).off("mouseup."+this.widgetName,this._mouseUpDelegate),this._mouseStarted&&(this._mouseStarted=!1,e.target===this._mouseDownEvent.target&&t.data(e.target,this.widgetName+".preventClickEvent",!0),this._mouseStop(e)),this._mouseDelayTimer&&(clearTimeout(this._mouseDelayTimer),delete this._mouseDelayTimer),this.ignoreMissingWhich=!1,_=!1,e.preventDefault()},_mouseDistanceMet:function(t){return Math.max(Math.abs(this._mouseDownEvent.pageX-t.pageX),Math.abs(this._mouseDownEvent.pageY-t.pageY))>=this.options.distance},_mouseDelayMet:function(){return this.mouseDelayMet},_mouseStart:function(){},_mouseDrag:function(){},_mouseStop:function(){},_mouseCapture:function(){return!0}}),t.ui.plugin={add:function(e,i,s){var n,o=t.ui[e].prototype;for(n in s)o.plugins[n]=o.plugins[n]||[],o.plugins[n].push([i,s[n]])},call:function(t,e,i,s){var n,o=t.plugins[e];if(o&&(s||t.element[0].parentNode&&11!==t.element[0].parentNode.nodeType))for(n=0;o.length>n;n++)t.options[o[n][0]]&&o[n][1].apply(t.element,i)}},t.ui.safeBlur=function(e){e&&"body"!==e.nodeName.toLowerCase()&&t(e).trigger("blur")},t.widget("ui.draggable",t.ui.mouse,{version:"1.12.1",widgetEventPrefix:"drag",options:{addClasses:!0,appendTo:"parent",axis:!1,connectToSortable:!1,containment:!1,cursor:"auto",cursorAt:!1,grid:!1,handle:!1,helper:"original",iframeFix:!1,opacity:!1,refreshPositions:!1,revert:!1,revertDuration:500,scope:"default",scroll:!0,scrollSensitivity:20,scrollSpeed:20,snap:!1,snapMode:"both",snapTolerance:20,stack:!1,zIndex:!1,drag:null,start:null,stop:null},_create:function(){"original"===this.options.helper&&this._setPositionRelative(),this.options.addClasses&&this._addClass("ui-draggable"),this._setHandleClassName(),this._mouseInit()},_setOption:function(t,e){this._super(t,e),"handle"===t&&(this._removeHandleClassName(),this._setHandleClassName())},_destroy:function(){return(this.helper||this.element).is(".ui-draggable-dragging")?(this.destroyOnClear=!0,void 0):(this._removeHandleClassName(),this._mouseDestroy(),void 0)},_mouseCapture:function(e){var i=this.options;return this.helper||i.disabled||t(e.target).closest(".ui-resizable-handle").length>0?!1:(this.handle=this._getHandle(e),this.handle?(this._blurActiveElement(e),this._blockFrames(i.iframeFix===!0?"iframe":i.iframeFix),!0):!1)},_blockFrames:function(e){this.iframeBlocks=this.document.find(e).map(function(){var e=t(this);return t("<div>").css("position","absolute").appendTo(e.parent()).outerWidth(e.outerWidth()).outerHeight(e.outerHeight()).offset(e.offset())[0]})},_unblockFrames:function(){this.iframeBlocks&&(this.iframeBlocks.remove(),delete this.iframeBlocks)},_blurActiveElement:function(e){var i=t.ui.safeActiveElement(this.document[0]),s=t(e.target);s.closest(i).length||t.ui.safeBlur(i)},_mouseStart:function(e){var i=this.options;return this.helper=this._createHelper(e),this._addClass(this.helper,"ui-draggable-dragging"),this._cacheHelperProportions(),t.ui.ddmanager&&(t.ui.ddmanager.current=this),this._cacheMargins(),this.cssPosition=this.helper.css("position"),this.scrollParent=this.helper.scrollParent(!0),this.offsetParent=this.helper.offsetParent(),this.hasFixedAncestor=this.helper.parents().filter(function(){return"fixed"===t(this).css("position")}).length>0,this.positionAbs=this.element.offset(),this._refreshOffsets(e),this.originalPosition=this.position=this._generatePosition(e,!1),this.originalPageX=e.pageX,this.originalPageY=e.pageY,i.cursorAt&&this._adjustOffsetFromHelper(i.cursorAt),this._setContainment(),this._trigger("start",e)===!1?(this._clear(),!1):(this._cacheHelperProportions(),t.ui.ddmanager&&!i.dropBehaviour&&t.ui.ddmanager.prepareOffsets(this,e),this._mouseDrag(e,!0),t.ui.ddmanager&&t.ui.ddmanager.dragStart(this,e),!0)},_refreshOffsets:function(t){this.offset={top:this.positionAbs.top-this.margins.top,left:this.positionAbs.left-this.margins.left,scroll:!1,parent:this._getParentOffset(),relative:this._getRelativeOffset()},this.offset.click={left:t.pageX-this.offset.left,top:t.pageY-this.offset.top}},_mouseDrag:function(e,i){if(this.hasFixedAncestor&&(this.offset.parent=this._getParentOffset()),this.position=this._generatePosition(e,!0),this.positionAbs=this._convertPositionTo("absolute"),!i){var s=this._uiHash();if(this._trigger("drag",e,s)===!1)return this._mouseUp(new t.Event("mouseup",e)),!1;this.position=s.position}return this.helper[0].style.left=this.position.left+"px",this.helper[0].style.top=this.position.top+"px",t.ui.ddmanager&&t.ui.ddmanager.drag(this,e),!1},_mouseStop:function(e){var i=this,s=!1;return t.ui.ddmanager&&!this.options.dropBehaviour&&(s=t.ui.ddmanager.drop(this,e)),this.dropped&&(s=this.dropped,this.dropped=!1),"invalid"===this.options.revert&&!s||"valid"===this.options.revert&&s||this.options.revert===!0||t.isFunction(this.options.revert)&&this.options.revert.call(this.element,s)?t(this.helper).animate(this.originalPosition,parseInt(this.options.revertDuration,10),function(){i._trigger("stop",e)!==!1&&i._clear()}):this._trigger("stop",e)!==!1&&this._clear(),!1},_mouseUp:function(e){return this._unblockFrames(),t.ui.ddmanager&&t.ui.ddmanager.dragStop(this,e),this.handleElement.is(e.target)&&this.element.trigger("focus"),t.ui.mouse.prototype._mouseUp.call(this,e)},cancel:function(){return this.helper.is(".ui-draggable-dragging")?this._mouseUp(new t.Event("mouseup",{target:this.element[0]})):this._clear(),this},_getHandle:function(e){return this.options.handle?!!t(e.target).closest(this.element.find(this.options.handle)).length:!0},_setHandleClassName:function(){this.handleElement=this.options.handle?this.element.find(this.options.handle):this.element,this._addClass(this.handleElement,"ui-draggable-handle")},_removeHandleClassName:function(){this._removeClass(this.handleElement,"ui-draggable-handle")},_createHelper:function(e){var i=this.options,s=t.isFunction(i.helper),n=s?t(i.helper.apply(this.element[0],[e])):"clone"===i.helper?this.element.clone().removeAttr("id"):this.element;return n.parents("body").length||n.appendTo("parent"===i.appendTo?this.element[0].parentNode:i.appendTo),s&&n[0]===this.element[0]&&this._setPositionRelative(),n[0]===this.element[0]||/(fixed|absolute)/.test(n.css("position"))||n.css("position","absolute"),n},_setPositionRelative:function(){/^(?:r|a|f)/.test(this.element.css("position"))||(this.element[0].style.position="relative")},_adjustOffsetFromHelper:function(e){"string"==typeof e&&(e=e.split(" ")),t.isArray(e)&&(e={left:+e[0],top:+e[1]||0}),"left"in e&&(this.offset.click.left=e.left+this.margins.left),"right"in e&&(this.offset.click.left=this.helperProportions.width-e.right+this.margins.left),"top"in e&&(this.offset.click.top=e.top+this.margins.top),"bottom"in e&&(this.offset.click.top=this.helperProportions.height-e.bottom+this.margins.top)},_isRootNode:function(t){return/(html|body)/i.test(t.tagName)||t===this.document[0]},_getParentOffset:function(){var e=this.offsetParent.offset(),i=this.document[0];return"absolute"===this.cssPosition&&this.scrollParent[0]!==i&&t.contains(this.scrollParent[0],this.offsetParent[0])&&(e.left+=this.scrollParent.scrollLeft(),e.top+=this.scrollParent.scrollTop()),this._isRootNode(this.offsetParent[0])&&(e={top:0,left:0}),{top:e.top+(parseInt(this.offsetParent.css("borderTopWidth"),10)||0),left:e.left+(parseInt(this.offsetParent.css("borderLeftWidth"),10)||0)}},_getRelativeOffset:function(){if("relative"!==this.cssPosition)return{top:0,left:0};var t=this.element.position(),e=this._isRootNode(this.scrollParent[0]);return{top:t.top-(parseInt(this.helper.css("top"),10)||0)+(e?0:this.scrollParent.scrollTop()),left:t.left-(parseInt(this.helper.css("left"),10)||0)+(e?0:this.scrollParent.scrollLeft())}
},_cacheMargins:function(){this.margins={left:parseInt(this.element.css("marginLeft"),10)||0,top:parseInt(this.element.css("marginTop"),10)||0,right:parseInt(this.element.css("marginRight"),10)||0,bottom:parseInt(this.element.css("marginBottom"),10)||0}},_cacheHelperProportions:function(){this.helperProportions={width:this.helper.outerWidth(),height:this.helper.outerHeight()}},_setContainment:function(){var e,i,s,n=this.options,o=this.document[0];return this.relativeContainer=null,n.containment?"window"===n.containment?(this.containment=[t(window).scrollLeft()-this.offset.relative.left-this.offset.parent.left,t(window).scrollTop()-this.offset.relative.top-this.offset.parent.top,t(window).scrollLeft()+t(window).width()-this.helperProportions.width-this.margins.left,t(window).scrollTop()+(t(window).height()||o.body.parentNode.scrollHeight)-this.helperProportions.height-this.margins.top],void 0):"document"===n.containment?(this.containment=[0,0,t(o).width()-this.helperProportions.width-this.margins.left,(t(o).height()||o.body.parentNode.scrollHeight)-this.helperProportions.height-this.margins.top],void 0):n.containment.constructor===Array?(this.containment=n.containment,void 0):("parent"===n.containment&&(n.containment=this.helper[0].parentNode),i=t(n.containment),s=i[0],s&&(e=/(scroll|auto)/.test(i.css("overflow")),this.containment=[(parseInt(i.css("borderLeftWidth"),10)||0)+(parseInt(i.css("paddingLeft"),10)||0),(parseInt(i.css("borderTopWidth"),10)||0)+(parseInt(i.css("paddingTop"),10)||0),(e?Math.max(s.scrollWidth,s.offsetWidth):s.offsetWidth)-(parseInt(i.css("borderRightWidth"),10)||0)-(parseInt(i.css("paddingRight"),10)||0)-this.helperProportions.width-this.margins.left-this.margins.right,(e?Math.max(s.scrollHeight,s.offsetHeight):s.offsetHeight)-(parseInt(i.css("borderBottomWidth"),10)||0)-(parseInt(i.css("paddingBottom"),10)||0)-this.helperProportions.height-this.margins.top-this.margins.bottom],this.relativeContainer=i),void 0):(this.containment=null,void 0)},_convertPositionTo:function(t,e){e||(e=this.position);var i="absolute"===t?1:-1,s=this._isRootNode(this.scrollParent[0]);return{top:e.top+this.offset.relative.top*i+this.offset.parent.top*i-("fixed"===this.cssPosition?-this.offset.scroll.top:s?0:this.offset.scroll.top)*i,left:e.left+this.offset.relative.left*i+this.offset.parent.left*i-("fixed"===this.cssPosition?-this.offset.scroll.left:s?0:this.offset.scroll.left)*i}},_generatePosition:function(t,e){var i,s,n,o,a=this.options,r=this._isRootNode(this.scrollParent[0]),l=t.pageX,h=t.pageY;return r&&this.offset.scroll||(this.offset.scroll={top:this.scrollParent.scrollTop(),left:this.scrollParent.scrollLeft()}),e&&(this.containment&&(this.relativeContainer?(s=this.relativeContainer.offset(),i=[this.containment[0]+s.left,this.containment[1]+s.top,this.containment[2]+s.left,this.containment[3]+s.top]):i=this.containment,t.pageX-this.offset.click.left<i[0]&&(l=i[0]+this.offset.click.left),t.pageY-this.offset.click.top<i[1]&&(h=i[1]+this.offset.click.top),t.pageX-this.offset.click.left>i[2]&&(l=i[2]+this.offset.click.left),t.pageY-this.offset.click.top>i[3]&&(h=i[3]+this.offset.click.top)),a.grid&&(n=a.grid[1]?this.originalPageY+Math.round((h-this.originalPageY)/a.grid[1])*a.grid[1]:this.originalPageY,h=i?n-this.offset.click.top>=i[1]||n-this.offset.click.top>i[3]?n:n-this.offset.click.top>=i[1]?n-a.grid[1]:n+a.grid[1]:n,o=a.grid[0]?this.originalPageX+Math.round((l-this.originalPageX)/a.grid[0])*a.grid[0]:this.originalPageX,l=i?o-this.offset.click.left>=i[0]||o-this.offset.click.left>i[2]?o:o-this.offset.click.left>=i[0]?o-a.grid[0]:o+a.grid[0]:o),"y"===a.axis&&(l=this.originalPageX),"x"===a.axis&&(h=this.originalPageY)),{top:h-this.offset.click.top-this.offset.relative.top-this.offset.parent.top+("fixed"===this.cssPosition?-this.offset.scroll.top:r?0:this.offset.scroll.top),left:l-this.offset.click.left-this.offset.relative.left-this.offset.parent.left+("fixed"===this.cssPosition?-this.offset.scroll.left:r?0:this.offset.scroll.left)}},_clear:function(){this._removeClass(this.helper,"ui-draggable-dragging"),this.helper[0]===this.element[0]||this.cancelHelperRemoval||this.helper.remove(),this.helper=null,this.cancelHelperRemoval=!1,this.destroyOnClear&&this.destroy()},_trigger:function(e,i,s){return s=s||this._uiHash(),t.ui.plugin.call(this,e,[i,s,this],!0),/^(drag|start|stop)/.test(e)&&(this.positionAbs=this._convertPositionTo("absolute"),s.offset=this.positionAbs),t.Widget.prototype._trigger.call(this,e,i,s)},plugins:{},_uiHash:function(){return{helper:this.helper,position:this.position,originalPosition:this.originalPosition,offset:this.positionAbs}}}),t.ui.plugin.add("draggable","connectToSortable",{start:function(e,i,s){var n=t.extend({},i,{item:s.element});s.sortables=[],t(s.options.connectToSortable).each(function(){var i=t(this).sortable("instance");i&&!i.options.disabled&&(s.sortables.push(i),i.refreshPositions(),i._trigger("activate",e,n))})},stop:function(e,i,s){var n=t.extend({},i,{item:s.element});s.cancelHelperRemoval=!1,t.each(s.sortables,function(){var t=this;t.isOver?(t.isOver=0,s.cancelHelperRemoval=!0,t.cancelHelperRemoval=!1,t._storedCSS={position:t.placeholder.css("position"),top:t.placeholder.css("top"),left:t.placeholder.css("left")},t._mouseStop(e),t.options.helper=t.options._helper):(t.cancelHelperRemoval=!0,t._trigger("deactivate",e,n))})},drag:function(e,i,s){t.each(s.sortables,function(){var n=!1,o=this;o.positionAbs=s.positionAbs,o.helperProportions=s.helperProportions,o.offset.click=s.offset.click,o._intersectsWith(o.containerCache)&&(n=!0,t.each(s.sortables,function(){return this.positionAbs=s.positionAbs,this.helperProportions=s.helperProportions,this.offset.click=s.offset.click,this!==o&&this._intersectsWith(this.containerCache)&&t.contains(o.element[0],this.element[0])&&(n=!1),n})),n?(o.isOver||(o.isOver=1,s._parent=i.helper.parent(),o.currentItem=i.helper.appendTo(o.element).data("ui-sortable-item",!0),o.options._helper=o.options.helper,o.options.helper=function(){return i.helper[0]},e.target=o.currentItem[0],o._mouseCapture(e,!0),o._mouseStart(e,!0,!0),o.offset.click.top=s.offset.click.top,o.offset.click.left=s.offset.click.left,o.offset.parent.left-=s.offset.parent.left-o.offset.parent.left,o.offset.parent.top-=s.offset.parent.top-o.offset.parent.top,s._trigger("toSortable",e),s.dropped=o.element,t.each(s.sortables,function(){this.refreshPositions()}),s.currentItem=s.element,o.fromOutside=s),o.currentItem&&(o._mouseDrag(e),i.position=o.position)):o.isOver&&(o.isOver=0,o.cancelHelperRemoval=!0,o.options._revert=o.options.revert,o.options.revert=!1,o._trigger("out",e,o._uiHash(o)),o._mouseStop(e,!0),o.options.revert=o.options._revert,o.options.helper=o.options._helper,o.placeholder&&o.placeholder.remove(),i.helper.appendTo(s._parent),s._refreshOffsets(e),i.position=s._generatePosition(e,!0),s._trigger("fromSortable",e),s.dropped=!1,t.each(s.sortables,function(){this.refreshPositions()}))})}}),t.ui.plugin.add("draggable","cursor",{start:function(e,i,s){var n=t("body"),o=s.options;n.css("cursor")&&(o._cursor=n.css("cursor")),n.css("cursor",o.cursor)},stop:function(e,i,s){var n=s.options;n._cursor&&t("body").css("cursor",n._cursor)}}),t.ui.plugin.add("draggable","opacity",{start:function(e,i,s){var n=t(i.helper),o=s.options;n.css("opacity")&&(o._opacity=n.css("opacity")),n.css("opacity",o.opacity)},stop:function(e,i,s){var n=s.options;n._opacity&&t(i.helper).css("opacity",n._opacity)}}),t.ui.plugin.add("draggable","scroll",{start:function(t,e,i){i.scrollParentNotHidden||(i.scrollParentNotHidden=i.helper.scrollParent(!1)),i.scrollParentNotHidden[0]!==i.document[0]&&"HTML"!==i.scrollParentNotHidden[0].tagName&&(i.overflowOffset=i.scrollParentNotHidden.offset())},drag:function(e,i,s){var n=s.options,o=!1,a=s.scrollParentNotHidden[0],r=s.document[0];a!==r&&"HTML"!==a.tagName?(n.axis&&"x"===n.axis||(s.overflowOffset.top+a.offsetHeight-e.pageY<n.scrollSensitivity?a.scrollTop=o=a.scrollTop+n.scrollSpeed:e.pageY-s.overflowOffset.top<n.scrollSensitivity&&(a.scrollTop=o=a.scrollTop-n.scrollSpeed)),n.axis&&"y"===n.axis||(s.overflowOffset.left+a.offsetWidth-e.pageX<n.scrollSensitivity?a.scrollLeft=o=a.scrollLeft+n.scrollSpeed:e.pageX-s.overflowOffset.left<n.scrollSensitivity&&(a.scrollLeft=o=a.scrollLeft-n.scrollSpeed))):(n.axis&&"x"===n.axis||(e.pageY-t(r).scrollTop()<n.scrollSensitivity?o=t(r).scrollTop(t(r).scrollTop()-n.scrollSpeed):t(window).height()-(e.pageY-t(r).scrollTop())<n.scrollSensitivity&&(o=t(r).scrollTop(t(r).scrollTop()+n.scrollSpeed))),n.axis&&"y"===n.axis||(e.pageX-t(r).scrollLeft()<n.scrollSensitivity?o=t(r).scrollLeft(t(r).scrollLeft()-n.scrollSpeed):t(window).width()-(e.pageX-t(r).scrollLeft())<n.scrollSensitivity&&(o=t(r).scrollLeft(t(r).scrollLeft()+n.scrollSpeed)))),o!==!1&&t.ui.ddmanager&&!n.dropBehaviour&&t.ui.ddmanager.prepareOffsets(s,e)}}),t.ui.plugin.add("draggable","snap",{start:function(e,i,s){var n=s.options;s.snapElements=[],t(n.snap.constructor!==String?n.snap.items||":data(ui-draggable)":n.snap).each(function(){var e=t(this),i=e.offset();this!==s.element[0]&&s.snapElements.push({item:this,width:e.outerWidth(),height:e.outerHeight(),top:i.top,left:i.left})})},drag:function(e,i,s){var n,o,a,r,l,h,c,u,d,p,f=s.options,g=f.snapTolerance,m=i.offset.left,_=m+s.helperProportions.width,v=i.offset.top,b=v+s.helperProportions.height;for(d=s.snapElements.length-1;d>=0;d--)l=s.snapElements[d].left-s.margins.left,h=l+s.snapElements[d].width,c=s.snapElements[d].top-s.margins.top,u=c+s.snapElements[d].height,l-g>_||m>h+g||c-g>b||v>u+g||!t.contains(s.snapElements[d].item.ownerDocument,s.snapElements[d].item)?(s.snapElements[d].snapping&&s.options.snap.release&&s.options.snap.release.call(s.element,e,t.extend(s._uiHash(),{snapItem:s.snapElements[d].item})),s.snapElements[d].snapping=!1):("inner"!==f.snapMode&&(n=g>=Math.abs(c-b),o=g>=Math.abs(u-v),a=g>=Math.abs(l-_),r=g>=Math.abs(h-m),n&&(i.position.top=s._convertPositionTo("relative",{top:c-s.helperProportions.height,left:0}).top),o&&(i.position.top=s._convertPositionTo("relative",{top:u,left:0}).top),a&&(i.position.left=s._convertPositionTo("relative",{top:0,left:l-s.helperProportions.width}).left),r&&(i.position.left=s._convertPositionTo("relative",{top:0,left:h}).left)),p=n||o||a||r,"outer"!==f.snapMode&&(n=g>=Math.abs(c-v),o=g>=Math.abs(u-b),a=g>=Math.abs(l-m),r=g>=Math.abs(h-_),n&&(i.position.top=s._convertPositionTo("relative",{top:c,left:0}).top),o&&(i.position.top=s._convertPositionTo("relative",{top:u-s.helperProportions.height,left:0}).top),a&&(i.position.left=s._convertPositionTo("relative",{top:0,left:l}).left),r&&(i.position.left=s._convertPositionTo("relative",{top:0,left:h-s.helperProportions.width}).left)),!s.snapElements[d].snapping&&(n||o||a||r||p)&&s.options.snap.snap&&s.options.snap.snap.call(s.element,e,t.extend(s._uiHash(),{snapItem:s.snapElements[d].item})),s.snapElements[d].snapping=n||o||a||r||p)}}),t.ui.plugin.add("draggable","stack",{start:function(e,i,s){var n,o=s.options,a=t.makeArray(t(o.stack)).sort(function(e,i){return(parseInt(t(e).css("zIndex"),10)||0)-(parseInt(t(i).css("zIndex"),10)||0)});a.length&&(n=parseInt(t(a[0]).css("zIndex"),10)||0,t(a).each(function(e){t(this).css("zIndex",n+e)}),this.css("zIndex",n+a.length))}}),t.ui.plugin.add("draggable","zIndex",{start:function(e,i,s){var n=t(i.helper),o=s.options;n.css("zIndex")&&(o._zIndex=n.css("zIndex")),n.css("zIndex",o.zIndex)},stop:function(e,i,s){var n=s.options;n._zIndex&&t(i.helper).css("zIndex",n._zIndex)}}),t.ui.draggable,t.widget("ui.resizable",t.ui.mouse,{version:"1.12.1",widgetEventPrefix:"resize",options:{alsoResize:!1,animate:!1,animateDuration:"slow",animateEasing:"swing",aspectRatio:!1,autoHide:!1,classes:{"ui-resizable-se":"ui-icon ui-icon-gripsmall-diagonal-se"},containment:!1,ghost:!1,grid:!1,handles:"e,s,se",helper:!1,maxHeight:null,maxWidth:null,minHeight:10,minWidth:10,zIndex:90,resize:null,start:null,stop:null},_num:function(t){return parseFloat(t)||0},_isNumber:function(t){return!isNaN(parseFloat(t))},_hasScroll:function(e,i){if("hidden"===t(e).css("overflow"))return!1;var s=i&&"left"===i?"scrollLeft":"scrollTop",n=!1;return e[s]>0?!0:(e[s]=1,n=e[s]>0,e[s]=0,n)},_create:function(){var e,i=this.options,s=this;this._addClass("ui-resizable"),t.extend(this,{_aspectRatio:!!i.aspectRatio,aspectRatio:i.aspectRatio,originalElement:this.element,_proportionallyResizeElements:[],_helper:i.helper||i.ghost||i.animate?i.helper||"ui-resizable-helper":null}),this.element[0].nodeName.match(/^(canvas|textarea|input|select|button|img)$/i)&&(this.element.wrap(t("<div class='ui-wrapper' style='overflow: hidden;'></div>").css({position:this.element.css("position"),width:this.element.outerWidth(),height:this.element.outerHeight(),top:this.element.css("top"),left:this.element.css("left")})),this.element=this.element.parent().data("ui-resizable",this.element.resizable("instance")),this.elementIsWrapper=!0,e={marginTop:this.originalElement.css("marginTop"),marginRight:this.originalElement.css("marginRight"),marginBottom:this.originalElement.css("marginBottom"),marginLeft:this.originalElement.css("marginLeft")},this.element.css(e),this.originalElement.css("margin",0),this.originalResizeStyle=this.originalElement.css("resize"),this.originalElement.css("resize","none"),this._proportionallyResizeElements.push(this.originalElement.css({position:"static",zoom:1,display:"block"})),this.originalElement.css(e),this._proportionallyResize()),this._setupHandles(),i.autoHide&&t(this.element).on("mouseenter",function(){i.disabled||(s._removeClass("ui-resizable-autohide"),s._handles.show())}).on("mouseleave",function(){i.disabled||s.resizing||(s._addClass("ui-resizable-autohide"),s._handles.hide())}),this._mouseInit()},_destroy:function(){this._mouseDestroy();var e,i=function(e){t(e).removeData("resizable").removeData("ui-resizable").off(".resizable").find(".ui-resizable-handle").remove()};return this.elementIsWrapper&&(i(this.element),e=this.element,this.originalElement.css({position:e.css("position"),width:e.outerWidth(),height:e.outerHeight(),top:e.css("top"),left:e.css("left")}).insertAfter(e),e.remove()),this.originalElement.css("resize",this.originalResizeStyle),i(this.originalElement),this},_setOption:function(t,e){switch(this._super(t,e),t){case"handles":this._removeHandles(),this._setupHandles();break;default:}},_setupHandles:function(){var e,i,s,n,o,a=this.options,r=this;if(this.handles=a.handles||(t(".ui-resizable-handle",this.element).length?{n:".ui-resizable-n",e:".ui-resizable-e",s:".ui-resizable-s",w:".ui-resizable-w",se:".ui-resizable-se",sw:".ui-resizable-sw",ne:".ui-resizable-ne",nw:".ui-resizable-nw"}:"e,s,se"),this._handles=t(),this.handles.constructor===String)for("all"===this.handles&&(this.handles="n,e,s,w,se,sw,ne,nw"),s=this.handles.split(","),this.handles={},i=0;s.length>i;i++)e=t.trim(s[i]),n="ui-resizable-"+e,o=t("<div>"),this._addClass(o,"ui-resizable-handle "+n),o.css({zIndex:a.zIndex}),this.handles[e]=".ui-resizable-"+e,this.element.append(o);this._renderAxis=function(e){var i,s,n,o;e=e||this.element;for(i in this.handles)this.handles[i].constructor===String?this.handles[i]=this.element.children(this.handles[i]).first().show():(this.handles[i].jquery||this.handles[i].nodeType)&&(this.handles[i]=t(this.handles[i]),this._on(this.handles[i],{mousedown:r._mouseDown})),this.elementIsWrapper&&this.originalElement[0].nodeName.match(/^(textarea|input|select|button)$/i)&&(s=t(this.handles[i],this.element),o=/sw|ne|nw|se|n|s/.test(i)?s.outerHeight():s.outerWidth(),n=["padding",/ne|nw|n/.test(i)?"Top":/se|sw|s/.test(i)?"Bottom":/^e$/.test(i)?"Right":"Left"].join(""),e.css(n,o),this._proportionallyResize()),this._handles=this._handles.add(this.handles[i])},this._renderAxis(this.element),this._handles=this._handles.add(this.element.find(".ui-resizable-handle")),this._handles.disableSelection(),this._handles.on("mouseover",function(){r.resizing||(this.className&&(o=this.className.match(/ui-resizable-(se|sw|ne|nw|n|e|s|w)/i)),r.axis=o&&o[1]?o[1]:"se")}),a.autoHide&&(this._handles.hide(),this._addClass("ui-resizable-autohide"))},_removeHandles:function(){this._handles.remove()},_mouseCapture:function(e){var i,s,n=!1;for(i in this.handles)s=t(this.handles[i])[0],(s===e.target||t.contains(s,e.target))&&(n=!0);return!this.options.disabled&&n},_mouseStart:function(e){var i,s,n,o=this.options,a=this.element;return this.resizing=!0,this._renderProxy(),i=this._num(this.helper.css("left")),s=this._num(this.helper.css("top")),o.containment&&(i+=t(o.containment).scrollLeft()||0,s+=t(o.containment).scrollTop()||0),this.offset=this.helper.offset(),this.position={left:i,top:s},this.size=this._helper?{width:this.helper.width(),height:this.helper.height()}:{width:a.width(),height:a.height()},this.originalSize=this._helper?{width:a.outerWidth(),height:a.outerHeight()}:{width:a.width(),height:a.height()},this.sizeDiff={width:a.outerWidth()-a.width(),height:a.outerHeight()-a.height()},this.originalPosition={left:i,top:s},this.originalMousePosition={left:e.pageX,top:e.pageY},this.aspectRatio="number"==typeof o.aspectRatio?o.aspectRatio:this.originalSize.width/this.originalSize.height||1,n=t(".ui-resizable-"+this.axis).css("cursor"),t("body").css("cursor","auto"===n?this.axis+"-resize":n),this._addClass("ui-resizable-resizing"),this._propagate("start",e),!0},_mouseDrag:function(e){var i,s,n=this.originalMousePosition,o=this.axis,a=e.pageX-n.left||0,r=e.pageY-n.top||0,l=this._change[o];return this._updatePrevProperties(),l?(i=l.apply(this,[e,a,r]),this._updateVirtualBoundaries(e.shiftKey),(this._aspectRatio||e.shiftKey)&&(i=this._updateRatio(i,e)),i=this._respectSize(i,e),this._updateCache(i),this._propagate("resize",e),s=this._applyChanges(),!this._helper&&this._proportionallyResizeElements.length&&this._proportionallyResize(),t.isEmptyObject(s)||(this._updatePrevProperties(),this._trigger("resize",e,this.ui()),this._applyChanges()),!1):!1},_mouseStop:function(e){this.resizing=!1;var i,s,n,o,a,r,l,h=this.options,c=this;return this._helper&&(i=this._proportionallyResizeElements,s=i.length&&/textarea/i.test(i[0].nodeName),n=s&&this._hasScroll(i[0],"left")?0:c.sizeDiff.height,o=s?0:c.sizeDiff.width,a={width:c.helper.width()-o,height:c.helper.height()-n},r=parseFloat(c.element.css("left"))+(c.position.left-c.originalPosition.left)||null,l=parseFloat(c.element.css("top"))+(c.position.top-c.originalPosition.top)||null,h.animate||this.element.css(t.extend(a,{top:l,left:r})),c.helper.height(c.size.height),c.helper.width(c.size.width),this._helper&&!h.animate&&this._proportionallyResize()),t("body").css("cursor","auto"),this._removeClass("ui-resizable-resizing"),this._propagate("stop",e),this._helper&&this.helper.remove(),!1},_updatePrevProperties:function(){this.prevPosition={top:this.position.top,left:this.position.left},this.prevSize={width:this.size.width,height:this.size.height}},_applyChanges:function(){var t={};return this.position.top!==this.prevPosition.top&&(t.top=this.position.top+"px"),this.position.left!==this.prevPosition.left&&(t.left=this.position.left+"px"),this.size.width!==this.prevSize.width&&(t.width=this.size.width+"px"),this.size.height!==this.prevSize.height&&(t.height=this.size.height+"px"),this.helper.css(t),t},_updateVirtualBoundaries:function(t){var e,i,s,n,o,a=this.options;o={minWidth:this._isNumber(a.minWidth)?a.minWidth:0,maxWidth:this._isNumber(a.maxWidth)?a.maxWidth:1/0,minHeight:this._isNumber(a.minHeight)?a.minHeight:0,maxHeight:this._isNumber(a.maxHeight)?a.maxHeight:1/0},(this._aspectRatio||t)&&(e=o.minHeight*this.aspectRatio,s=o.minWidth/this.aspectRatio,i=o.maxHeight*this.aspectRatio,n=o.maxWidth/this.aspectRatio,e>o.minWidth&&(o.minWidth=e),s>o.minHeight&&(o.minHeight=s),o.maxWidth>i&&(o.maxWidth=i),o.maxHeight>n&&(o.maxHeight=n)),this._vBoundaries=o},_updateCache:function(t){this.offset=this.helper.offset(),this._isNumber(t.left)&&(this.position.left=t.left),this._isNumber(t.top)&&(this.position.top=t.top),this._isNumber(t.height)&&(this.size.height=t.height),this._isNumber(t.width)&&(this.size.width=t.width)},_updateRatio:function(t){var e=this.position,i=this.size,s=this.axis;return this._isNumber(t.height)?t.width=t.height*this.aspectRatio:this._isNumber(t.width)&&(t.height=t.width/this.aspectRatio),"sw"===s&&(t.left=e.left+(i.width-t.width),t.top=null),"nw"===s&&(t.top=e.top+(i.height-t.height),t.left=e.left+(i.width-t.width)),t},_respectSize:function(t){var e=this._vBoundaries,i=this.axis,s=this._isNumber(t.width)&&e.maxWidth&&e.maxWidth<t.width,n=this._isNumber(t.height)&&e.maxHeight&&e.maxHeight<t.height,o=this._isNumber(t.width)&&e.minWidth&&e.minWidth>t.width,a=this._isNumber(t.height)&&e.minHeight&&e.minHeight>t.height,r=this.originalPosition.left+this.originalSize.width,l=this.originalPosition.top+this.originalSize.height,h=/sw|nw|w/.test(i),c=/nw|ne|n/.test(i);return o&&(t.width=e.minWidth),a&&(t.height=e.minHeight),s&&(t.width=e.maxWidth),n&&(t.height=e.maxHeight),o&&h&&(t.left=r-e.minWidth),s&&h&&(t.left=r-e.maxWidth),a&&c&&(t.top=l-e.minHeight),n&&c&&(t.top=l-e.maxHeight),t.width||t.height||t.left||!t.top?t.width||t.height||t.top||!t.left||(t.left=null):t.top=null,t},_getPaddingPlusBorderDimensions:function(t){for(var e=0,i=[],s=[t.css("borderTopWidth"),t.css("borderRightWidth"),t.css("borderBottomWidth"),t.css("borderLeftWidth")],n=[t.css("paddingTop"),t.css("paddingRight"),t.css("paddingBottom"),t.css("paddingLeft")];4>e;e++)i[e]=parseFloat(s[e])||0,i[e]+=parseFloat(n[e])||0;return{height:i[0]+i[2],width:i[1]+i[3]}},_proportionallyResize:function(){if(this._proportionallyResizeElements.length)for(var t,e=0,i=this.helper||this.element;this._proportionallyResizeElements.length>e;e++)t=this._proportionallyResizeElements[e],this.outerDimensions||(this.outerDimensions=this._getPaddingPlusBorderDimensions(t)),t.css({height:i.height()-this.outerDimensions.height||0,width:i.width()-this.outerDimensions.width||0})},_renderProxy:function(){var e=this.element,i=this.options;this.elementOffset=e.offset(),this._helper?(this.helper=this.helper||t("<div style='overflow:hidden;'></div>"),this._addClass(this.helper,this._helper),this.helper.css({width:this.element.outerWidth(),height:this.element.outerHeight(),position:"absolute",left:this.elementOffset.left+"px",top:this.elementOffset.top+"px",zIndex:++i.zIndex}),this.helper.appendTo("body").disableSelection()):this.helper=this.element},_change:{e:function(t,e){return{width:this.originalSize.width+e}},w:function(t,e){var i=this.originalSize,s=this.originalPosition;return{left:s.left+e,width:i.width-e}},n:function(t,e,i){var s=this.originalSize,n=this.originalPosition;return{top:n.top+i,height:s.height-i}},s:function(t,e,i){return{height:this.originalSize.height+i}},se:function(e,i,s){return t.extend(this._change.s.apply(this,arguments),this._change.e.apply(this,[e,i,s]))},sw:function(e,i,s){return t.extend(this._change.s.apply(this,arguments),this._change.w.apply(this,[e,i,s]))},ne:function(e,i,s){return t.extend(this._change.n.apply(this,arguments),this._change.e.apply(this,[e,i,s]))},nw:function(e,i,s){return t.extend(this._change.n.apply(this,arguments),this._change.w.apply(this,[e,i,s]))}},_propagate:function(e,i){t.ui.plugin.call(this,e,[i,this.ui()]),"resize"!==e&&this._trigger(e,i,this.ui())},plugins:{},ui:function(){return{originalElement:this.originalElement,element:this.element,helper:this.helper,position:this.position,size:this.size,originalSize:this.originalSize,originalPosition:this.originalPosition}}}),t.ui.plugin.add("resizable","animate",{stop:function(e){var i=t(this).resizable("instance"),s=i.options,n=i._proportionallyResizeElements,o=n.length&&/textarea/i.test(n[0].nodeName),a=o&&i._hasScroll(n[0],"left")?0:i.sizeDiff.height,r=o?0:i.sizeDiff.width,l={width:i.size.width-r,height:i.size.height-a},h=parseFloat(i.element.css("left"))+(i.position.left-i.originalPosition.left)||null,c=parseFloat(i.element.css("top"))+(i.position.top-i.originalPosition.top)||null;i.element.animate(t.extend(l,c&&h?{top:c,left:h}:{}),{duration:s.animateDuration,easing:s.animateEasing,step:function(){var s={width:parseFloat(i.element.css("width")),height:parseFloat(i.element.css("height")),top:parseFloat(i.element.css("top")),left:parseFloat(i.element.css("left"))};n&&n.length&&t(n[0]).css({width:s.width,height:s.height}),i._updateCache(s),i._propagate("resize",e)}})}}),t.ui.plugin.add("resizable","containment",{start:function(){var e,i,s,n,o,a,r,l=t(this).resizable("instance"),h=l.options,c=l.element,u=h.containment,d=u instanceof t?u.get(0):/parent/.test(u)?c.parent().get(0):u;d&&(l.containerElement=t(d),/document/.test(u)||u===document?(l.containerOffset={left:0,top:0},l.containerPosition={left:0,top:0},l.parentData={element:t(document),left:0,top:0,width:t(document).width(),height:t(document).height()||document.body.parentNode.scrollHeight}):(e=t(d),i=[],t(["Top","Right","Left","Bottom"]).each(function(t,s){i[t]=l._num(e.css("padding"+s))}),l.containerOffset=e.offset(),l.containerPosition=e.position(),l.containerSize={height:e.innerHeight()-i[3],width:e.innerWidth()-i[1]},s=l.containerOffset,n=l.containerSize.height,o=l.containerSize.width,a=l._hasScroll(d,"left")?d.scrollWidth:o,r=l._hasScroll(d)?d.scrollHeight:n,l.parentData={element:d,left:s.left,top:s.top,width:a,height:r}))},resize:function(e){var i,s,n,o,a=t(this).resizable("instance"),r=a.options,l=a.containerOffset,h=a.position,c=a._aspectRatio||e.shiftKey,u={top:0,left:0},d=a.containerElement,p=!0;d[0]!==document&&/static/.test(d.css("position"))&&(u=l),h.left<(a._helper?l.left:0)&&(a.size.width=a.size.width+(a._helper?a.position.left-l.left:a.position.left-u.left),c&&(a.size.height=a.size.width/a.aspectRatio,p=!1),a.position.left=r.helper?l.left:0),h.top<(a._helper?l.top:0)&&(a.size.height=a.size.height+(a._helper?a.position.top-l.top:a.position.top),c&&(a.size.width=a.size.height*a.aspectRatio,p=!1),a.position.top=a._helper?l.top:0),n=a.containerElement.get(0)===a.element.parent().get(0),o=/relative|absolute/.test(a.containerElement.css("position")),n&&o?(a.offset.left=a.parentData.left+a.position.left,a.offset.top=a.parentData.top+a.position.top):(a.offset.left=a.element.offset().left,a.offset.top=a.element.offset().top),i=Math.abs(a.sizeDiff.width+(a._helper?a.offset.left-u.left:a.offset.left-l.left)),s=Math.abs(a.sizeDiff.height+(a._helper?a.offset.top-u.top:a.offset.top-l.top)),i+a.size.width>=a.parentData.width&&(a.size.width=a.parentData.width-i,c&&(a.size.height=a.size.width/a.aspectRatio,p=!1)),s+a.size.height>=a.parentData.height&&(a.size.height=a.parentData.height-s,c&&(a.size.width=a.size.height*a.aspectRatio,p=!1)),p||(a.position.left=a.prevPosition.left,a.position.top=a.prevPosition.top,a.size.width=a.prevSize.width,a.size.height=a.prevSize.height)},stop:function(){var e=t(this).resizable("instance"),i=e.options,s=e.containerOffset,n=e.containerPosition,o=e.containerElement,a=t(e.helper),r=a.offset(),l=a.outerWidth()-e.sizeDiff.width,h=a.outerHeight()-e.sizeDiff.height;e._helper&&!i.animate&&/relative/.test(o.css("position"))&&t(this).css({left:r.left-n.left-s.left,width:l,height:h}),e._helper&&!i.animate&&/static/.test(o.css("position"))&&t(this).css({left:r.left-n.left-s.left,width:l,height:h})}}),t.ui.plugin.add("resizable","alsoResize",{start:function(){var e=t(this).resizable("instance"),i=e.options;t(i.alsoResize).each(function(){var e=t(this);e.data("ui-resizable-alsoresize",{width:parseFloat(e.width()),height:parseFloat(e.height()),left:parseFloat(e.css("left")),top:parseFloat(e.css("top"))})})},resize:function(e,i){var s=t(this).resizable("instance"),n=s.options,o=s.originalSize,a=s.originalPosition,r={height:s.size.height-o.height||0,width:s.size.width-o.width||0,top:s.position.top-a.top||0,left:s.position.left-a.left||0};t(n.alsoResize).each(function(){var e=t(this),s=t(this).data("ui-resizable-alsoresize"),n={},o=e.parents(i.originalElement[0]).length?["width","height"]:["width","height","top","left"];t.each(o,function(t,e){var i=(s[e]||0)+(r[e]||0);i&&i>=0&&(n[e]=i||null)}),e.css(n)})},stop:function(){t(this).removeData("ui-resizable-alsoresize")}}),t.ui.plugin.add("resizable","ghost",{start:function(){var e=t(this).resizable("instance"),i=e.size;e.ghost=e.originalElement.clone(),e.ghost.css({opacity:.25,display:"block",position:"relative",height:i.height,width:i.width,margin:0,left:0,top:0}),e._addClass(e.ghost,"ui-resizable-ghost"),t.uiBackCompat!==!1&&"string"==typeof e.options.ghost&&e.ghost.addClass(this.options.ghost),e.ghost.appendTo(e.helper)},resize:function(){var e=t(this).resizable("instance");e.ghost&&e.ghost.css({position:"relative",height:e.size.height,width:e.size.width})},stop:function(){var e=t(this).resizable("instance");e.ghost&&e.helper&&e.helper.get(0).removeChild(e.ghost.get(0))}}),t.ui.plugin.add("resizable","grid",{resize:function(){var e,i=t(this).resizable("instance"),s=i.options,n=i.size,o=i.originalSize,a=i.originalPosition,r=i.axis,l="number"==typeof s.grid?[s.grid,s.grid]:s.grid,h=l[0]||1,c=l[1]||1,u=Math.round((n.width-o.width)/h)*h,d=Math.round((n.height-o.height)/c)*c,p=o.width+u,f=o.height+d,g=s.maxWidth&&p>s.maxWidth,m=s.maxHeight&&f>s.maxHeight,_=s.minWidth&&s.minWidth>p,v=s.minHeight&&s.minHeight>f;s.grid=l,_&&(p+=h),v&&(f+=c),g&&(p-=h),m&&(f-=c),/^(se|s|e)$/.test(r)?(i.size.width=p,i.size.height=f):/^(ne)$/.test(r)?(i.size.width=p,i.size.height=f,i.position.top=a.top-d):/^(sw)$/.test(r)?(i.size.width=p,i.size.height=f,i.position.left=a.left-u):((0>=f-c||0>=p-h)&&(e=i._getPaddingPlusBorderDimensions(this)),f-c>0?(i.size.height=f,i.position.top=a.top-d):(f=c-e.height,i.size.height=f,i.position.top=a.top+o.height-f),p-h>0?(i.size.width=p,i.position.left=a.left-u):(p=h-e.width,i.size.width=p,i.position.left=a.left+o.width-p))}}),t.ui.resizable,t.widget("ui.dialog",{version:"1.12.1",options:{appendTo:"body",autoOpen:!0,buttons:[],classes:{"ui-dialog":"ui-corner-all","ui-dialog-titlebar":"ui-corner-all"},closeOnEscape:!0,closeText:"Close",draggable:!0,hide:null,height:"auto",maxHeight:null,maxWidth:null,minHeight:150,minWidth:150,modal:!1,position:{my:"center",at:"center",of:window,collision:"fit",using:function(e){var i=t(this).css(e).offset().top;0>i&&t(this).css("top",e.top-i)}},resizable:!0,show:null,title:null,width:300,beforeClose:null,close:null,drag:null,dragStart:null,dragStop:null,focus:null,open:null,resize:null,resizeStart:null,resizeStop:null},sizeRelatedOptions:{buttons:!0,height:!0,maxHeight:!0,maxWidth:!0,minHeight:!0,minWidth:!0,width:!0},resizableRelatedOptions:{maxHeight:!0,maxWidth:!0,minHeight:!0,minWidth:!0},_create:function(){this.originalCss={display:this.element[0].style.display,width:this.element[0].style.width,minHeight:this.element[0].style.minHeight,maxHeight:this.element[0].style.maxHeight,height:this.element[0].style.height},this.originalPosition={parent:this.element.parent(),index:this.element.parent().children().index(this.element)},this.originalTitle=this.element.attr("title"),null==this.options.title&&null!=this.originalTitle&&(this.options.title=this.originalTitle),this.options.disabled&&(this.options.disabled=!1),this._createWrapper(),this.element.show().removeAttr("title").appendTo(this.uiDialog),this._addClass("ui-dialog-content","ui-widget-content"),this._createTitlebar(),this._createButtonPane(),this.options.draggable&&t.fn.draggable&&this._makeDraggable(),this.options.resizable&&t.fn.resizable&&this._makeResizable(),this._isOpen=!1,this._trackFocus()},_init:function(){this.options.autoOpen&&this.open()},_appendTo:function(){var e=this.options.appendTo;return e&&(e.jquery||e.nodeType)?t(e):this.document.find(e||"body").eq(0)},_destroy:function(){var t,e=this.originalPosition;this._untrackInstance(),this._destroyOverlay(),this.element.removeUniqueId().css(this.originalCss).detach(),this.uiDialog.remove(),this.originalTitle&&this.element.attr("title",this.originalTitle),t=e.parent.children().eq(e.index),t.length&&t[0]!==this.element[0]?t.before(this.element):e.parent.append(this.element)},widget:function(){return this.uiDialog
},disable:t.noop,enable:t.noop,close:function(e){var i=this;this._isOpen&&this._trigger("beforeClose",e)!==!1&&(this._isOpen=!1,this._focusedElement=null,this._destroyOverlay(),this._untrackInstance(),this.opener.filter(":focusable").trigger("focus").length||t.ui.safeBlur(t.ui.safeActiveElement(this.document[0])),this._hide(this.uiDialog,this.options.hide,function(){i._trigger("close",e)}))},isOpen:function(){return this._isOpen},moveToTop:function(){this._moveToTop()},_moveToTop:function(e,i){var s=!1,n=this.uiDialog.siblings(".ui-front:visible").map(function(){return+t(this).css("z-index")}).get(),o=Math.max.apply(null,n);return o>=+this.uiDialog.css("z-index")&&(this.uiDialog.css("z-index",o+1),s=!0),s&&!i&&this._trigger("focus",e),s},open:function(){var e=this;return this._isOpen?(this._moveToTop()&&this._focusTabbable(),void 0):(this._isOpen=!0,this.opener=t(t.ui.safeActiveElement(this.document[0])),this._size(),this._position(),this._createOverlay(),this._moveToTop(null,!0),this.overlay&&this.overlay.css("z-index",this.uiDialog.css("z-index")-1),this._show(this.uiDialog,this.options.show,function(){e._focusTabbable(),e._trigger("focus")}),this._makeFocusTarget(),this._trigger("open"),void 0)},_focusTabbable:function(){var t=this._focusedElement;t||(t=this.element.find("[autofocus]")),t.length||(t=this.element.find(":tabbable")),t.length||(t=this.uiDialogButtonPane.find(":tabbable")),t.length||(t=this.uiDialogTitlebarClose.filter(":tabbable")),t.length||(t=this.uiDialog),t.eq(0).trigger("focus")},_keepFocus:function(e){function i(){var e=t.ui.safeActiveElement(this.document[0]),i=this.uiDialog[0]===e||t.contains(this.uiDialog[0],e);i||this._focusTabbable()}e.preventDefault(),i.call(this),this._delay(i)},_createWrapper:function(){this.uiDialog=t("<div>").hide().attr({tabIndex:-1,role:"dialog"}).appendTo(this._appendTo()),this._addClass(this.uiDialog,"ui-dialog","ui-widget ui-widget-content ui-front"),this._on(this.uiDialog,{keydown:function(e){if(this.options.closeOnEscape&&!e.isDefaultPrevented()&&e.keyCode&&e.keyCode===t.ui.keyCode.ESCAPE)return e.preventDefault(),this.close(e),void 0;if(e.keyCode===t.ui.keyCode.TAB&&!e.isDefaultPrevented()){var i=this.uiDialog.find(":tabbable"),s=i.filter(":first"),n=i.filter(":last");e.target!==n[0]&&e.target!==this.uiDialog[0]||e.shiftKey?e.target!==s[0]&&e.target!==this.uiDialog[0]||!e.shiftKey||(this._delay(function(){n.trigger("focus")}),e.preventDefault()):(this._delay(function(){s.trigger("focus")}),e.preventDefault())}},mousedown:function(t){this._moveToTop(t)&&this._focusTabbable()}}),this.element.find("[aria-describedby]").length||this.uiDialog.attr({"aria-describedby":this.element.uniqueId().attr("id")})},_createTitlebar:function(){var e;this.uiDialogTitlebar=t("<div>"),this._addClass(this.uiDialogTitlebar,"ui-dialog-titlebar","ui-widget-header ui-helper-clearfix"),this._on(this.uiDialogTitlebar,{mousedown:function(e){t(e.target).closest(".ui-dialog-titlebar-close")||this.uiDialog.trigger("focus")}}),this.uiDialogTitlebarClose=t("<button type='button'></button>").button({label:t("<a>").text(this.options.closeText).html(),icon:"ui-icon-closethick",showLabel:!1}).appendTo(this.uiDialogTitlebar),this._addClass(this.uiDialogTitlebarClose,"ui-dialog-titlebar-close"),this._on(this.uiDialogTitlebarClose,{click:function(t){t.preventDefault(),this.close(t)}}),e=t("<span>").uniqueId().prependTo(this.uiDialogTitlebar),this._addClass(e,"ui-dialog-title"),this._title(e),this.uiDialogTitlebar.prependTo(this.uiDialog),this.uiDialog.attr({"aria-labelledby":e.attr("id")})},_title:function(t){this.options.title?t.text(this.options.title):t.html("&#160;")},_createButtonPane:function(){this.uiDialogButtonPane=t("<div>"),this._addClass(this.uiDialogButtonPane,"ui-dialog-buttonpane","ui-widget-content ui-helper-clearfix"),this.uiButtonSet=t("<div>").appendTo(this.uiDialogButtonPane),this._addClass(this.uiButtonSet,"ui-dialog-buttonset"),this._createButtons()},_createButtons:function(){var e=this,i=this.options.buttons;return this.uiDialogButtonPane.remove(),this.uiButtonSet.empty(),t.isEmptyObject(i)||t.isArray(i)&&!i.length?(this._removeClass(this.uiDialog,"ui-dialog-buttons"),void 0):(t.each(i,function(i,s){var n,o;s=t.isFunction(s)?{click:s,text:i}:s,s=t.extend({type:"button"},s),n=s.click,o={icon:s.icon,iconPosition:s.iconPosition,showLabel:s.showLabel,icons:s.icons,text:s.text},delete s.click,delete s.icon,delete s.iconPosition,delete s.showLabel,delete s.icons,"boolean"==typeof s.text&&delete s.text,t("<button></button>",s).button(o).appendTo(e.uiButtonSet).on("click",function(){n.apply(e.element[0],arguments)})}),this._addClass(this.uiDialog,"ui-dialog-buttons"),this.uiDialogButtonPane.appendTo(this.uiDialog),void 0)},_makeDraggable:function(){function e(t){return{position:t.position,offset:t.offset}}var i=this,s=this.options;this.uiDialog.draggable({cancel:".ui-dialog-content, .ui-dialog-titlebar-close",handle:".ui-dialog-titlebar",containment:"document",start:function(s,n){i._addClass(t(this),"ui-dialog-dragging"),i._blockFrames(),i._trigger("dragStart",s,e(n))},drag:function(t,s){i._trigger("drag",t,e(s))},stop:function(n,o){var a=o.offset.left-i.document.scrollLeft(),r=o.offset.top-i.document.scrollTop();s.position={my:"left top",at:"left"+(a>=0?"+":"")+a+" "+"top"+(r>=0?"+":"")+r,of:i.window},i._removeClass(t(this),"ui-dialog-dragging"),i._unblockFrames(),i._trigger("dragStop",n,e(o))}})},_makeResizable:function(){function e(t){return{originalPosition:t.originalPosition,originalSize:t.originalSize,position:t.position,size:t.size}}var i=this,s=this.options,n=s.resizable,o=this.uiDialog.css("position"),a="string"==typeof n?n:"n,e,s,w,se,sw,ne,nw";this.uiDialog.resizable({cancel:".ui-dialog-content",containment:"document",alsoResize:this.element,maxWidth:s.maxWidth,maxHeight:s.maxHeight,minWidth:s.minWidth,minHeight:this._minHeight(),handles:a,start:function(s,n){i._addClass(t(this),"ui-dialog-resizing"),i._blockFrames(),i._trigger("resizeStart",s,e(n))},resize:function(t,s){i._trigger("resize",t,e(s))},stop:function(n,o){var a=i.uiDialog.offset(),r=a.left-i.document.scrollLeft(),l=a.top-i.document.scrollTop();s.height=i.uiDialog.height(),s.width=i.uiDialog.width(),s.position={my:"left top",at:"left"+(r>=0?"+":"")+r+" "+"top"+(l>=0?"+":"")+l,of:i.window},i._removeClass(t(this),"ui-dialog-resizing"),i._unblockFrames(),i._trigger("resizeStop",n,e(o))}}).css("position",o)},_trackFocus:function(){this._on(this.widget(),{focusin:function(e){this._makeFocusTarget(),this._focusedElement=t(e.target)}})},_makeFocusTarget:function(){this._untrackInstance(),this._trackingInstances().unshift(this)},_untrackInstance:function(){var e=this._trackingInstances(),i=t.inArray(this,e);-1!==i&&e.splice(i,1)},_trackingInstances:function(){var t=this.document.data("ui-dialog-instances");return t||(t=[],this.document.data("ui-dialog-instances",t)),t},_minHeight:function(){var t=this.options;return"auto"===t.height?t.minHeight:Math.min(t.minHeight,t.height)},_position:function(){var t=this.uiDialog.is(":visible");t||this.uiDialog.show(),this.uiDialog.position(this.options.position),t||this.uiDialog.hide()},_setOptions:function(e){var i=this,s=!1,n={};t.each(e,function(t,e){i._setOption(t,e),t in i.sizeRelatedOptions&&(s=!0),t in i.resizableRelatedOptions&&(n[t]=e)}),s&&(this._size(),this._position()),this.uiDialog.is(":data(ui-resizable)")&&this.uiDialog.resizable("option",n)},_setOption:function(e,i){var s,n,o=this.uiDialog;"disabled"!==e&&(this._super(e,i),"appendTo"===e&&this.uiDialog.appendTo(this._appendTo()),"buttons"===e&&this._createButtons(),"closeText"===e&&this.uiDialogTitlebarClose.button({label:t("<a>").text(""+this.options.closeText).html()}),"draggable"===e&&(s=o.is(":data(ui-draggable)"),s&&!i&&o.draggable("destroy"),!s&&i&&this._makeDraggable()),"position"===e&&this._position(),"resizable"===e&&(n=o.is(":data(ui-resizable)"),n&&!i&&o.resizable("destroy"),n&&"string"==typeof i&&o.resizable("option","handles",i),n||i===!1||this._makeResizable()),"title"===e&&this._title(this.uiDialogTitlebar.find(".ui-dialog-title")))},_size:function(){var t,e,i,s=this.options;this.element.show().css({width:"auto",minHeight:0,maxHeight:"none",height:0}),s.minWidth>s.width&&(s.width=s.minWidth),t=this.uiDialog.css({height:"auto",width:s.width}).outerHeight(),e=Math.max(0,s.minHeight-t),i="number"==typeof s.maxHeight?Math.max(0,s.maxHeight-t):"none","auto"===s.height?this.element.css({minHeight:e,maxHeight:i,height:"auto"}):this.element.height(Math.max(0,s.height-t)),this.uiDialog.is(":data(ui-resizable)")&&this.uiDialog.resizable("option","minHeight",this._minHeight())},_blockFrames:function(){this.iframeBlocks=this.document.find("iframe").map(function(){var e=t(this);return t("<div>").css({position:"absolute",width:e.outerWidth(),height:e.outerHeight()}).appendTo(e.parent()).offset(e.offset())[0]})},_unblockFrames:function(){this.iframeBlocks&&(this.iframeBlocks.remove(),delete this.iframeBlocks)},_allowInteraction:function(e){return t(e.target).closest(".ui-dialog").length?!0:!!t(e.target).closest(".ui-datepicker").length},_createOverlay:function(){if(this.options.modal){var e=!0;this._delay(function(){e=!1}),this.document.data("ui-dialog-overlays")||this._on(this.document,{focusin:function(t){e||this._allowInteraction(t)||(t.preventDefault(),this._trackingInstances()[0]._focusTabbable())}}),this.overlay=t("<div>").appendTo(this._appendTo()),this._addClass(this.overlay,null,"ui-widget-overlay ui-front"),this._on(this.overlay,{mousedown:"_keepFocus"}),this.document.data("ui-dialog-overlays",(this.document.data("ui-dialog-overlays")||0)+1)}},_destroyOverlay:function(){if(this.options.modal&&this.overlay){var t=this.document.data("ui-dialog-overlays")-1;t?this.document.data("ui-dialog-overlays",t):(this._off(this.document,"focusin"),this.document.removeData("ui-dialog-overlays")),this.overlay.remove(),this.overlay=null}}}),t.uiBackCompat!==!1&&t.widget("ui.dialog",t.ui.dialog,{options:{dialogClass:""},_createWrapper:function(){this._super(),this.uiDialog.addClass(this.options.dialogClass)},_setOption:function(t,e){"dialogClass"===t&&this.uiDialog.removeClass(this.options.dialogClass).addClass(e),this._superApply(arguments)}}),t.ui.dialog,t.widget("ui.droppable",{version:"1.12.1",widgetEventPrefix:"drop",options:{accept:"*",addClasses:!0,greedy:!1,scope:"default",tolerance:"intersect",activate:null,deactivate:null,drop:null,out:null,over:null},_create:function(){var e,i=this.options,s=i.accept;this.isover=!1,this.isout=!0,this.accept=t.isFunction(s)?s:function(t){return t.is(s)},this.proportions=function(){return arguments.length?(e=arguments[0],void 0):e?e:e={width:this.element[0].offsetWidth,height:this.element[0].offsetHeight}},this._addToManager(i.scope),i.addClasses&&this._addClass("ui-droppable")},_addToManager:function(e){t.ui.ddmanager.droppables[e]=t.ui.ddmanager.droppables[e]||[],t.ui.ddmanager.droppables[e].push(this)},_splice:function(t){for(var e=0;t.length>e;e++)t[e]===this&&t.splice(e,1)},_destroy:function(){var e=t.ui.ddmanager.droppables[this.options.scope];this._splice(e)},_setOption:function(e,i){if("accept"===e)this.accept=t.isFunction(i)?i:function(t){return t.is(i)};else if("scope"===e){var s=t.ui.ddmanager.droppables[this.options.scope];this._splice(s),this._addToManager(i)}this._super(e,i)},_activate:function(e){var i=t.ui.ddmanager.current;this._addActiveClass(),i&&this._trigger("activate",e,this.ui(i))},_deactivate:function(e){var i=t.ui.ddmanager.current;this._removeActiveClass(),i&&this._trigger("deactivate",e,this.ui(i))},_over:function(e){var i=t.ui.ddmanager.current;i&&(i.currentItem||i.element)[0]!==this.element[0]&&this.accept.call(this.element[0],i.currentItem||i.element)&&(this._addHoverClass(),this._trigger("over",e,this.ui(i)))},_out:function(e){var i=t.ui.ddmanager.current;i&&(i.currentItem||i.element)[0]!==this.element[0]&&this.accept.call(this.element[0],i.currentItem||i.element)&&(this._removeHoverClass(),this._trigger("out",e,this.ui(i)))},_drop:function(e,i){var s=i||t.ui.ddmanager.current,n=!1;return s&&(s.currentItem||s.element)[0]!==this.element[0]?(this.element.find(":data(ui-droppable)").not(".ui-draggable-dragging").each(function(){var i=t(this).droppable("instance");return i.options.greedy&&!i.options.disabled&&i.options.scope===s.options.scope&&i.accept.call(i.element[0],s.currentItem||s.element)&&v(s,t.extend(i,{offset:i.element.offset()}),i.options.tolerance,e)?(n=!0,!1):void 0}),n?!1:this.accept.call(this.element[0],s.currentItem||s.element)?(this._removeActiveClass(),this._removeHoverClass(),this._trigger("drop",e,this.ui(s)),this.element):!1):!1},ui:function(t){return{draggable:t.currentItem||t.element,helper:t.helper,position:t.position,offset:t.positionAbs}},_addHoverClass:function(){this._addClass("ui-droppable-hover")},_removeHoverClass:function(){this._removeClass("ui-droppable-hover")},_addActiveClass:function(){this._addClass("ui-droppable-active")},_removeActiveClass:function(){this._removeClass("ui-droppable-active")}});var v=t.ui.intersect=function(){function t(t,e,i){return t>=e&&e+i>t}return function(e,i,s,n){if(!i.offset)return!1;var o=(e.positionAbs||e.position.absolute).left+e.margins.left,a=(e.positionAbs||e.position.absolute).top+e.margins.top,r=o+e.helperProportions.width,l=a+e.helperProportions.height,h=i.offset.left,c=i.offset.top,u=h+i.proportions().width,d=c+i.proportions().height;switch(s){case"fit":return o>=h&&u>=r&&a>=c&&d>=l;case"intersect":return o+e.helperProportions.width/2>h&&u>r-e.helperProportions.width/2&&a+e.helperProportions.height/2>c&&d>l-e.helperProportions.height/2;case"pointer":return t(n.pageY,c,i.proportions().height)&&t(n.pageX,h,i.proportions().width);case"touch":return(a>=c&&d>=a||l>=c&&d>=l||c>a&&l>d)&&(o>=h&&u>=o||r>=h&&u>=r||h>o&&r>u);default:return!1}}}();t.ui.ddmanager={current:null,droppables:{"default":[]},prepareOffsets:function(e,i){var s,n,o=t.ui.ddmanager.droppables[e.options.scope]||[],a=i?i.type:null,r=(e.currentItem||e.element).find(":data(ui-droppable)").addBack();t:for(s=0;o.length>s;s++)if(!(o[s].options.disabled||e&&!o[s].accept.call(o[s].element[0],e.currentItem||e.element))){for(n=0;r.length>n;n++)if(r[n]===o[s].element[0]){o[s].proportions().height=0;continue t}o[s].visible="none"!==o[s].element.css("display"),o[s].visible&&("mousedown"===a&&o[s]._activate.call(o[s],i),o[s].offset=o[s].element.offset(),o[s].proportions({width:o[s].element[0].offsetWidth,height:o[s].element[0].offsetHeight}))}},drop:function(e,i){var s=!1;return t.each((t.ui.ddmanager.droppables[e.options.scope]||[]).slice(),function(){this.options&&(!this.options.disabled&&this.visible&&v(e,this,this.options.tolerance,i)&&(s=this._drop.call(this,i)||s),!this.options.disabled&&this.visible&&this.accept.call(this.element[0],e.currentItem||e.element)&&(this.isout=!0,this.isover=!1,this._deactivate.call(this,i)))}),s},dragStart:function(e,i){e.element.parentsUntil("body").on("scroll.droppable",function(){e.options.refreshPositions||t.ui.ddmanager.prepareOffsets(e,i)})},drag:function(e,i){e.options.refreshPositions&&t.ui.ddmanager.prepareOffsets(e,i),t.each(t.ui.ddmanager.droppables[e.options.scope]||[],function(){if(!this.options.disabled&&!this.greedyChild&&this.visible){var s,n,o,a=v(e,this,this.options.tolerance,i),r=!a&&this.isover?"isout":a&&!this.isover?"isover":null;r&&(this.options.greedy&&(n=this.options.scope,o=this.element.parents(":data(ui-droppable)").filter(function(){return t(this).droppable("instance").options.scope===n}),o.length&&(s=t(o[0]).droppable("instance"),s.greedyChild="isover"===r)),s&&"isover"===r&&(s.isover=!1,s.isout=!0,s._out.call(s,i)),this[r]=!0,this["isout"===r?"isover":"isout"]=!1,this["isover"===r?"_over":"_out"].call(this,i),s&&"isout"===r&&(s.isout=!1,s.isover=!0,s._over.call(s,i)))}})},dragStop:function(e,i){e.element.parentsUntil("body").off("scroll.droppable"),e.options.refreshPositions||t.ui.ddmanager.prepareOffsets(e,i)}},t.uiBackCompat!==!1&&t.widget("ui.droppable",t.ui.droppable,{options:{hoverClass:!1,activeClass:!1},_addActiveClass:function(){this._super(),this.options.activeClass&&this.element.addClass(this.options.activeClass)},_removeActiveClass:function(){this._super(),this.options.activeClass&&this.element.removeClass(this.options.activeClass)},_addHoverClass:function(){this._super(),this.options.hoverClass&&this.element.addClass(this.options.hoverClass)},_removeHoverClass:function(){this._super(),this.options.hoverClass&&this.element.removeClass(this.options.hoverClass)}}),t.ui.droppable,t.widget("ui.progressbar",{version:"1.12.1",options:{classes:{"ui-progressbar":"ui-corner-all","ui-progressbar-value":"ui-corner-left","ui-progressbar-complete":"ui-corner-right"},max:100,value:0,change:null,complete:null},min:0,_create:function(){this.oldValue=this.options.value=this._constrainedValue(),this.element.attr({role:"progressbar","aria-valuemin":this.min}),this._addClass("ui-progressbar","ui-widget ui-widget-content"),this.valueDiv=t("<div>").appendTo(this.element),this._addClass(this.valueDiv,"ui-progressbar-value","ui-widget-header"),this._refreshValue()},_destroy:function(){this.element.removeAttr("role aria-valuemin aria-valuemax aria-valuenow"),this.valueDiv.remove()},value:function(t){return void 0===t?this.options.value:(this.options.value=this._constrainedValue(t),this._refreshValue(),void 0)},_constrainedValue:function(t){return void 0===t&&(t=this.options.value),this.indeterminate=t===!1,"number"!=typeof t&&(t=0),this.indeterminate?!1:Math.min(this.options.max,Math.max(this.min,t))},_setOptions:function(t){var e=t.value;delete t.value,this._super(t),this.options.value=this._constrainedValue(e),this._refreshValue()},_setOption:function(t,e){"max"===t&&(e=Math.max(this.min,e)),this._super(t,e)},_setOptionDisabled:function(t){this._super(t),this.element.attr("aria-disabled",t),this._toggleClass(null,"ui-state-disabled",!!t)},_percentage:function(){return this.indeterminate?100:100*(this.options.value-this.min)/(this.options.max-this.min)},_refreshValue:function(){var e=this.options.value,i=this._percentage();this.valueDiv.toggle(this.indeterminate||e>this.min).width(i.toFixed(0)+"%"),this._toggleClass(this.valueDiv,"ui-progressbar-complete",null,e===this.options.max)._toggleClass("ui-progressbar-indeterminate",null,this.indeterminate),this.indeterminate?(this.element.removeAttr("aria-valuenow"),this.overlayDiv||(this.overlayDiv=t("<div>").appendTo(this.valueDiv),this._addClass(this.overlayDiv,"ui-progressbar-overlay"))):(this.element.attr({"aria-valuemax":this.options.max,"aria-valuenow":e}),this.overlayDiv&&(this.overlayDiv.remove(),this.overlayDiv=null)),this.oldValue!==e&&(this.oldValue=e,this._trigger("change")),e===this.options.max&&this._trigger("complete")}}),t.widget("ui.selectable",t.ui.mouse,{version:"1.12.1",options:{appendTo:"body",autoRefresh:!0,distance:0,filter:"*",tolerance:"touch",selected:null,selecting:null,start:null,stop:null,unselected:null,unselecting:null},_create:function(){var e=this;this._addClass("ui-selectable"),this.dragged=!1,this.refresh=function(){e.elementPos=t(e.element[0]).offset(),e.selectees=t(e.options.filter,e.element[0]),e._addClass(e.selectees,"ui-selectee"),e.selectees.each(function(){var i=t(this),s=i.offset(),n={left:s.left-e.elementPos.left,top:s.top-e.elementPos.top};t.data(this,"selectable-item",{element:this,$element:i,left:n.left,top:n.top,right:n.left+i.outerWidth(),bottom:n.top+i.outerHeight(),startselected:!1,selected:i.hasClass("ui-selected"),selecting:i.hasClass("ui-selecting"),unselecting:i.hasClass("ui-unselecting")})})},this.refresh(),this._mouseInit(),this.helper=t("<div>"),this._addClass(this.helper,"ui-selectable-helper")},_destroy:function(){this.selectees.removeData("selectable-item"),this._mouseDestroy()},_mouseStart:function(e){var i=this,s=this.options;this.opos=[e.pageX,e.pageY],this.elementPos=t(this.element[0]).offset(),this.options.disabled||(this.selectees=t(s.filter,this.element[0]),this._trigger("start",e),t(s.appendTo).append(this.helper),this.helper.css({left:e.pageX,top:e.pageY,width:0,height:0}),s.autoRefresh&&this.refresh(),this.selectees.filter(".ui-selected").each(function(){var s=t.data(this,"selectable-item");s.startselected=!0,e.metaKey||e.ctrlKey||(i._removeClass(s.$element,"ui-selected"),s.selected=!1,i._addClass(s.$element,"ui-unselecting"),s.unselecting=!0,i._trigger("unselecting",e,{unselecting:s.element}))}),t(e.target).parents().addBack().each(function(){var s,n=t.data(this,"selectable-item");return n?(s=!e.metaKey&&!e.ctrlKey||!n.$element.hasClass("ui-selected"),i._removeClass(n.$element,s?"ui-unselecting":"ui-selected")._addClass(n.$element,s?"ui-selecting":"ui-unselecting"),n.unselecting=!s,n.selecting=s,n.selected=s,s?i._trigger("selecting",e,{selecting:n.element}):i._trigger("unselecting",e,{unselecting:n.element}),!1):void 0}))},_mouseDrag:function(e){if(this.dragged=!0,!this.options.disabled){var i,s=this,n=this.options,o=this.opos[0],a=this.opos[1],r=e.pageX,l=e.pageY;return o>r&&(i=r,r=o,o=i),a>l&&(i=l,l=a,a=i),this.helper.css({left:o,top:a,width:r-o,height:l-a}),this.selectees.each(function(){var i=t.data(this,"selectable-item"),h=!1,c={};i&&i.element!==s.element[0]&&(c.left=i.left+s.elementPos.left,c.right=i.right+s.elementPos.left,c.top=i.top+s.elementPos.top,c.bottom=i.bottom+s.elementPos.top,"touch"===n.tolerance?h=!(c.left>r||o>c.right||c.top>l||a>c.bottom):"fit"===n.tolerance&&(h=c.left>o&&r>c.right&&c.top>a&&l>c.bottom),h?(i.selected&&(s._removeClass(i.$element,"ui-selected"),i.selected=!1),i.unselecting&&(s._removeClass(i.$element,"ui-unselecting"),i.unselecting=!1),i.selecting||(s._addClass(i.$element,"ui-selecting"),i.selecting=!0,s._trigger("selecting",e,{selecting:i.element}))):(i.selecting&&((e.metaKey||e.ctrlKey)&&i.startselected?(s._removeClass(i.$element,"ui-selecting"),i.selecting=!1,s._addClass(i.$element,"ui-selected"),i.selected=!0):(s._removeClass(i.$element,"ui-selecting"),i.selecting=!1,i.startselected&&(s._addClass(i.$element,"ui-unselecting"),i.unselecting=!0),s._trigger("unselecting",e,{unselecting:i.element}))),i.selected&&(e.metaKey||e.ctrlKey||i.startselected||(s._removeClass(i.$element,"ui-selected"),i.selected=!1,s._addClass(i.$element,"ui-unselecting"),i.unselecting=!0,s._trigger("unselecting",e,{unselecting:i.element})))))}),!1}},_mouseStop:function(e){var i=this;return this.dragged=!1,t(".ui-unselecting",this.element[0]).each(function(){var s=t.data(this,"selectable-item");i._removeClass(s.$element,"ui-unselecting"),s.unselecting=!1,s.startselected=!1,i._trigger("unselected",e,{unselected:s.element})}),t(".ui-selecting",this.element[0]).each(function(){var s=t.data(this,"selectable-item");i._removeClass(s.$element,"ui-selecting")._addClass(s.$element,"ui-selected"),s.selecting=!1,s.selected=!0,s.startselected=!0,i._trigger("selected",e,{selected:s.element})}),this._trigger("stop",e),this.helper.remove(),!1}}),t.widget("ui.selectmenu",[t.ui.formResetMixin,{version:"1.12.1",defaultElement:"<select>",options:{appendTo:null,classes:{"ui-selectmenu-button-open":"ui-corner-top","ui-selectmenu-button-closed":"ui-corner-all"},disabled:null,icons:{button:"ui-icon-triangle-1-s"},position:{my:"left top",at:"left bottom",collision:"none"},width:!1,change:null,close:null,focus:null,open:null,select:null},_create:function(){var e=this.element.uniqueId().attr("id");this.ids={element:e,button:e+"-button",menu:e+"-menu"},this._drawButton(),this._drawMenu(),this._bindFormResetHandler(),this._rendered=!1,this.menuItems=t()},_drawButton:function(){var e,i=this,s=this._parseOption(this.element.find("option:selected"),this.element[0].selectedIndex);this.labels=this.element.labels().attr("for",this.ids.button),this._on(this.labels,{click:function(t){this.button.focus(),t.preventDefault()}}),this.element.hide(),this.button=t("<span>",{tabindex:this.options.disabled?-1:0,id:this.ids.button,role:"combobox","aria-expanded":"false","aria-autocomplete":"list","aria-owns":this.ids.menu,"aria-haspopup":"true",title:this.element.attr("title")}).insertAfter(this.element),this._addClass(this.button,"ui-selectmenu-button ui-selectmenu-button-closed","ui-button ui-widget"),e=t("<span>").appendTo(this.button),this._addClass(e,"ui-selectmenu-icon","ui-icon "+this.options.icons.button),this.buttonItem=this._renderButtonItem(s).appendTo(this.button),this.options.width!==!1&&this._resizeButton(),this._on(this.button,this._buttonEvents),this.button.one("focusin",function(){i._rendered||i._refreshMenu()})},_drawMenu:function(){var e=this;this.menu=t("<ul>",{"aria-hidden":"true","aria-labelledby":this.ids.button,id:this.ids.menu}),this.menuWrap=t("<div>").append(this.menu),this._addClass(this.menuWrap,"ui-selectmenu-menu","ui-front"),this.menuWrap.appendTo(this._appendTo()),this.menuInstance=this.menu.menu({classes:{"ui-menu":"ui-corner-bottom"},role:"listbox",select:function(t,i){t.preventDefault(),e._setSelection(),e._select(i.item.data("ui-selectmenu-item"),t)},focus:function(t,i){var s=i.item.data("ui-selectmenu-item");null!=e.focusIndex&&s.index!==e.focusIndex&&(e._trigger("focus",t,{item:s}),e.isOpen||e._select(s,t)),e.focusIndex=s.index,e.button.attr("aria-activedescendant",e.menuItems.eq(s.index).attr("id"))}}).menu("instance"),this.menuInstance._off(this.menu,"mouseleave"),this.menuInstance._closeOnDocumentClick=function(){return!1},this.menuInstance._isDivider=function(){return!1}},refresh:function(){this._refreshMenu(),this.buttonItem.replaceWith(this.buttonItem=this._renderButtonItem(this._getSelectedItem().data("ui-selectmenu-item")||{})),null===this.options.width&&this._resizeButton()},_refreshMenu:function(){var t,e=this.element.find("option");this.menu.empty(),this._parseOptions(e),this._renderMenu(this.menu,this.items),this.menuInstance.refresh(),this.menuItems=this.menu.find("li").not(".ui-selectmenu-optgroup").find(".ui-menu-item-wrapper"),this._rendered=!0,e.length&&(t=this._getSelectedItem(),this.menuInstance.focus(null,t),this._setAria(t.data("ui-selectmenu-item")),this._setOption("disabled",this.element.prop("disabled")))},open:function(t){this.options.disabled||(this._rendered?(this._removeClass(this.menu.find(".ui-state-active"),null,"ui-state-active"),this.menuInstance.focus(null,this._getSelectedItem())):this._refreshMenu(),this.menuItems.length&&(this.isOpen=!0,this._toggleAttr(),this._resizeMenu(),this._position(),this._on(this.document,this._documentClick),this._trigger("open",t)))},_position:function(){this.menuWrap.position(t.extend({of:this.button},this.options.position))},close:function(t){this.isOpen&&(this.isOpen=!1,this._toggleAttr(),this.range=null,this._off(this.document),this._trigger("close",t))},widget:function(){return this.button},menuWidget:function(){return this.menu},_renderButtonItem:function(e){var i=t("<span>");return this._setText(i,e.label),this._addClass(i,"ui-selectmenu-text"),i},_renderMenu:function(e,i){var s=this,n="";t.each(i,function(i,o){var a;o.optgroup!==n&&(a=t("<li>",{text:o.optgroup}),s._addClass(a,"ui-selectmenu-optgroup","ui-menu-divider"+(o.element.parent("optgroup").prop("disabled")?" ui-state-disabled":"")),a.appendTo(e),n=o.optgroup),s._renderItemData(e,o)})},_renderItemData:function(t,e){return this._renderItem(t,e).data("ui-selectmenu-item",e)},_renderItem:function(e,i){var s=t("<li>"),n=t("<div>",{title:i.element.attr("title")});return i.disabled&&this._addClass(s,null,"ui-state-disabled"),this._setText(n,i.label),s.append(n).appendTo(e)},_setText:function(t,e){e?t.text(e):t.html("&#160;")},_move:function(t,e){var i,s,n=".ui-menu-item";this.isOpen?i=this.menuItems.eq(this.focusIndex).parent("li"):(i=this.menuItems.eq(this.element[0].selectedIndex).parent("li"),n+=":not(.ui-state-disabled)"),s="first"===t||"last"===t?i["first"===t?"prevAll":"nextAll"](n).eq(-1):i[t+"All"](n).eq(0),s.length&&this.menuInstance.focus(e,s)},_getSelectedItem:function(){return this.menuItems.eq(this.element[0].selectedIndex).parent("li")},_toggle:function(t){this[this.isOpen?"close":"open"](t)},_setSelection:function(){var t;this.range&&(window.getSelection?(t=window.getSelection(),t.removeAllRanges(),t.addRange(this.range)):this.range.select(),this.button.focus())},_documentClick:{mousedown:function(e){this.isOpen&&(t(e.target).closest(".ui-selectmenu-menu, #"+t.ui.escapeSelector(this.ids.button)).length||this.close(e))}},_buttonEvents:{mousedown:function(){var t;window.getSelection?(t=window.getSelection(),t.rangeCount&&(this.range=t.getRangeAt(0))):this.range=document.selection.createRange()},click:function(t){this._setSelection(),this._toggle(t)},keydown:function(e){var i=!0;switch(e.keyCode){case t.ui.keyCode.TAB:case t.ui.keyCode.ESCAPE:this.close(e),i=!1;break;case t.ui.keyCode.ENTER:this.isOpen&&this._selectFocusedItem(e);break;case t.ui.keyCode.UP:e.altKey?this._toggle(e):this._move("prev",e);break;case t.ui.keyCode.DOWN:e.altKey?this._toggle(e):this._move("next",e);break;case t.ui.keyCode.SPACE:this.isOpen?this._selectFocusedItem(e):this._toggle(e);break;case t.ui.keyCode.LEFT:this._move("prev",e);break;case t.ui.keyCode.RIGHT:this._move("next",e);break;case t.ui.keyCode.HOME:case t.ui.keyCode.PAGE_UP:this._move("first",e);break;case t.ui.keyCode.END:case t.ui.keyCode.PAGE_DOWN:this._move("last",e);break;default:this.menu.trigger(e),i=!1}i&&e.preventDefault()}},_selectFocusedItem:function(t){var e=this.menuItems.eq(this.focusIndex).parent("li");e.hasClass("ui-state-disabled")||this._select(e.data("ui-selectmenu-item"),t)},_select:function(t,e){var i=this.element[0].selectedIndex;this.element[0].selectedIndex=t.index,this.buttonItem.replaceWith(this.buttonItem=this._renderButtonItem(t)),this._setAria(t),this._trigger("select",e,{item:t}),t.index!==i&&this._trigger("change",e,{item:t}),this.close(e)},_setAria:function(t){var e=this.menuItems.eq(t.index).attr("id");this.button.attr({"aria-labelledby":e,"aria-activedescendant":e}),this.menu.attr("aria-activedescendant",e)},_setOption:function(t,e){if("icons"===t){var i=this.button.find("span.ui-icon");this._removeClass(i,null,this.options.icons.button)._addClass(i,null,e.button)}this._super(t,e),"appendTo"===t&&this.menuWrap.appendTo(this._appendTo()),"width"===t&&this._resizeButton()},_setOptionDisabled:function(t){this._super(t),this.menuInstance.option("disabled",t),this.button.attr("aria-disabled",t),this._toggleClass(this.button,null,"ui-state-disabled",t),this.element.prop("disabled",t),t?(this.button.attr("tabindex",-1),this.close()):this.button.attr("tabindex",0)},_appendTo:function(){var e=this.options.appendTo;return e&&(e=e.jquery||e.nodeType?t(e):this.document.find(e).eq(0)),e&&e[0]||(e=this.element.closest(".ui-front, dialog")),e.length||(e=this.document[0].body),e},_toggleAttr:function(){this.button.attr("aria-expanded",this.isOpen),this._removeClass(this.button,"ui-selectmenu-button-"+(this.isOpen?"closed":"open"))._addClass(this.button,"ui-selectmenu-button-"+(this.isOpen?"open":"closed"))._toggleClass(this.menuWrap,"ui-selectmenu-open",null,this.isOpen),this.menu.attr("aria-hidden",!this.isOpen)},_resizeButton:function(){var t=this.options.width;return t===!1?(this.button.css("width",""),void 0):(null===t&&(t=this.element.show().outerWidth(),this.element.hide()),this.button.outerWidth(t),void 0)},_resizeMenu:function(){this.menu.outerWidth(Math.max(this.button.outerWidth(),this.menu.width("").outerWidth()+1))},_getCreateOptions:function(){var t=this._super();return t.disabled=this.element.prop("disabled"),t},_parseOptions:function(e){var i=this,s=[];e.each(function(e,n){s.push(i._parseOption(t(n),e))}),this.items=s},_parseOption:function(t,e){var i=t.parent("optgroup");return{element:t,index:e,value:t.val(),label:t.text(),optgroup:i.attr("label")||"",disabled:i.prop("disabled")||t.prop("disabled")}},_destroy:function(){this._unbindFormResetHandler(),this.menuWrap.remove(),this.button.remove(),this.element.show(),this.element.removeUniqueId(),this.labels.attr("for",this.ids.element)}}]),t.widget("ui.slider",t.ui.mouse,{version:"1.12.1",widgetEventPrefix:"slide",options:{animate:!1,classes:{"ui-slider":"ui-corner-all","ui-slider-handle":"ui-corner-all","ui-slider-range":"ui-corner-all ui-widget-header"},distance:0,max:100,min:0,orientation:"horizontal",range:!1,step:1,value:0,values:null,change:null,slide:null,start:null,stop:null},numPages:5,_create:function(){this._keySliding=!1,this._mouseSliding=!1,this._animateOff=!0,this._handleIndex=null,this._detectOrientation(),this._mouseInit(),this._calculateNewMax(),this._addClass("ui-slider ui-slider-"+this.orientation,"ui-widget ui-widget-content"),this._refresh(),this._animateOff=!1
},_refresh:function(){this._createRange(),this._createHandles(),this._setupEvents(),this._refreshValue()},_createHandles:function(){var e,i,s=this.options,n=this.element.find(".ui-slider-handle"),o="<span tabindex='0'></span>",a=[];for(i=s.values&&s.values.length||1,n.length>i&&(n.slice(i).remove(),n=n.slice(0,i)),e=n.length;i>e;e++)a.push(o);this.handles=n.add(t(a.join("")).appendTo(this.element)),this._addClass(this.handles,"ui-slider-handle","ui-state-default"),this.handle=this.handles.eq(0),this.handles.each(function(e){t(this).data("ui-slider-handle-index",e).attr("tabIndex",0)})},_createRange:function(){var e=this.options;e.range?(e.range===!0&&(e.values?e.values.length&&2!==e.values.length?e.values=[e.values[0],e.values[0]]:t.isArray(e.values)&&(e.values=e.values.slice(0)):e.values=[this._valueMin(),this._valueMin()]),this.range&&this.range.length?(this._removeClass(this.range,"ui-slider-range-min ui-slider-range-max"),this.range.css({left:"",bottom:""})):(this.range=t("<div>").appendTo(this.element),this._addClass(this.range,"ui-slider-range")),("min"===e.range||"max"===e.range)&&this._addClass(this.range,"ui-slider-range-"+e.range)):(this.range&&this.range.remove(),this.range=null)},_setupEvents:function(){this._off(this.handles),this._on(this.handles,this._handleEvents),this._hoverable(this.handles),this._focusable(this.handles)},_destroy:function(){this.handles.remove(),this.range&&this.range.remove(),this._mouseDestroy()},_mouseCapture:function(e){var i,s,n,o,a,r,l,h,c=this,u=this.options;return u.disabled?!1:(this.elementSize={width:this.element.outerWidth(),height:this.element.outerHeight()},this.elementOffset=this.element.offset(),i={x:e.pageX,y:e.pageY},s=this._normValueFromMouse(i),n=this._valueMax()-this._valueMin()+1,this.handles.each(function(e){var i=Math.abs(s-c.values(e));(n>i||n===i&&(e===c._lastChangedValue||c.values(e)===u.min))&&(n=i,o=t(this),a=e)}),r=this._start(e,a),r===!1?!1:(this._mouseSliding=!0,this._handleIndex=a,this._addClass(o,null,"ui-state-active"),o.trigger("focus"),l=o.offset(),h=!t(e.target).parents().addBack().is(".ui-slider-handle"),this._clickOffset=h?{left:0,top:0}:{left:e.pageX-l.left-o.width()/2,top:e.pageY-l.top-o.height()/2-(parseInt(o.css("borderTopWidth"),10)||0)-(parseInt(o.css("borderBottomWidth"),10)||0)+(parseInt(o.css("marginTop"),10)||0)},this.handles.hasClass("ui-state-hover")||this._slide(e,a,s),this._animateOff=!0,!0))},_mouseStart:function(){return!0},_mouseDrag:function(t){var e={x:t.pageX,y:t.pageY},i=this._normValueFromMouse(e);return this._slide(t,this._handleIndex,i),!1},_mouseStop:function(t){return this._removeClass(this.handles,null,"ui-state-active"),this._mouseSliding=!1,this._stop(t,this._handleIndex),this._change(t,this._handleIndex),this._handleIndex=null,this._clickOffset=null,this._animateOff=!1,!1},_detectOrientation:function(){this.orientation="vertical"===this.options.orientation?"vertical":"horizontal"},_normValueFromMouse:function(t){var e,i,s,n,o;return"horizontal"===this.orientation?(e=this.elementSize.width,i=t.x-this.elementOffset.left-(this._clickOffset?this._clickOffset.left:0)):(e=this.elementSize.height,i=t.y-this.elementOffset.top-(this._clickOffset?this._clickOffset.top:0)),s=i/e,s>1&&(s=1),0>s&&(s=0),"vertical"===this.orientation&&(s=1-s),n=this._valueMax()-this._valueMin(),o=this._valueMin()+s*n,this._trimAlignValue(o)},_uiHash:function(t,e,i){var s={handle:this.handles[t],handleIndex:t,value:void 0!==e?e:this.value()};return this._hasMultipleValues()&&(s.value=void 0!==e?e:this.values(t),s.values=i||this.values()),s},_hasMultipleValues:function(){return this.options.values&&this.options.values.length},_start:function(t,e){return this._trigger("start",t,this._uiHash(e))},_slide:function(t,e,i){var s,n,o=this.value(),a=this.values();this._hasMultipleValues()&&(n=this.values(e?0:1),o=this.values(e),2===this.options.values.length&&this.options.range===!0&&(i=0===e?Math.min(n,i):Math.max(n,i)),a[e]=i),i!==o&&(s=this._trigger("slide",t,this._uiHash(e,i,a)),s!==!1&&(this._hasMultipleValues()?this.values(e,i):this.value(i)))},_stop:function(t,e){this._trigger("stop",t,this._uiHash(e))},_change:function(t,e){this._keySliding||this._mouseSliding||(this._lastChangedValue=e,this._trigger("change",t,this._uiHash(e)))},value:function(t){return arguments.length?(this.options.value=this._trimAlignValue(t),this._refreshValue(),this._change(null,0),void 0):this._value()},values:function(e,i){var s,n,o;if(arguments.length>1)return this.options.values[e]=this._trimAlignValue(i),this._refreshValue(),this._change(null,e),void 0;if(!arguments.length)return this._values();if(!t.isArray(arguments[0]))return this._hasMultipleValues()?this._values(e):this.value();for(s=this.options.values,n=arguments[0],o=0;s.length>o;o+=1)s[o]=this._trimAlignValue(n[o]),this._change(null,o);this._refreshValue()},_setOption:function(e,i){var s,n=0;switch("range"===e&&this.options.range===!0&&("min"===i?(this.options.value=this._values(0),this.options.values=null):"max"===i&&(this.options.value=this._values(this.options.values.length-1),this.options.values=null)),t.isArray(this.options.values)&&(n=this.options.values.length),this._super(e,i),e){case"orientation":this._detectOrientation(),this._removeClass("ui-slider-horizontal ui-slider-vertical")._addClass("ui-slider-"+this.orientation),this._refreshValue(),this.options.range&&this._refreshRange(i),this.handles.css("horizontal"===i?"bottom":"left","");break;case"value":this._animateOff=!0,this._refreshValue(),this._change(null,0),this._animateOff=!1;break;case"values":for(this._animateOff=!0,this._refreshValue(),s=n-1;s>=0;s--)this._change(null,s);this._animateOff=!1;break;case"step":case"min":case"max":this._animateOff=!0,this._calculateNewMax(),this._refreshValue(),this._animateOff=!1;break;case"range":this._animateOff=!0,this._refresh(),this._animateOff=!1}},_setOptionDisabled:function(t){this._super(t),this._toggleClass(null,"ui-state-disabled",!!t)},_value:function(){var t=this.options.value;return t=this._trimAlignValue(t)},_values:function(t){var e,i,s;if(arguments.length)return e=this.options.values[t],e=this._trimAlignValue(e);if(this._hasMultipleValues()){for(i=this.options.values.slice(),s=0;i.length>s;s+=1)i[s]=this._trimAlignValue(i[s]);return i}return[]},_trimAlignValue:function(t){if(this._valueMin()>=t)return this._valueMin();if(t>=this._valueMax())return this._valueMax();var e=this.options.step>0?this.options.step:1,i=(t-this._valueMin())%e,s=t-i;return 2*Math.abs(i)>=e&&(s+=i>0?e:-e),parseFloat(s.toFixed(5))},_calculateNewMax:function(){var t=this.options.max,e=this._valueMin(),i=this.options.step,s=Math.round((t-e)/i)*i;t=s+e,t>this.options.max&&(t-=i),this.max=parseFloat(t.toFixed(this._precision()))},_precision:function(){var t=this._precisionOf(this.options.step);return null!==this.options.min&&(t=Math.max(t,this._precisionOf(this.options.min))),t},_precisionOf:function(t){var e=""+t,i=e.indexOf(".");return-1===i?0:e.length-i-1},_valueMin:function(){return this.options.min},_valueMax:function(){return this.max},_refreshRange:function(t){"vertical"===t&&this.range.css({width:"",left:""}),"horizontal"===t&&this.range.css({height:"",bottom:""})},_refreshValue:function(){var e,i,s,n,o,a=this.options.range,r=this.options,l=this,h=this._animateOff?!1:r.animate,c={};this._hasMultipleValues()?this.handles.each(function(s){i=100*((l.values(s)-l._valueMin())/(l._valueMax()-l._valueMin())),c["horizontal"===l.orientation?"left":"bottom"]=i+"%",t(this).stop(1,1)[h?"animate":"css"](c,r.animate),l.options.range===!0&&("horizontal"===l.orientation?(0===s&&l.range.stop(1,1)[h?"animate":"css"]({left:i+"%"},r.animate),1===s&&l.range[h?"animate":"css"]({width:i-e+"%"},{queue:!1,duration:r.animate})):(0===s&&l.range.stop(1,1)[h?"animate":"css"]({bottom:i+"%"},r.animate),1===s&&l.range[h?"animate":"css"]({height:i-e+"%"},{queue:!1,duration:r.animate}))),e=i}):(s=this.value(),n=this._valueMin(),o=this._valueMax(),i=o!==n?100*((s-n)/(o-n)):0,c["horizontal"===this.orientation?"left":"bottom"]=i+"%",this.handle.stop(1,1)[h?"animate":"css"](c,r.animate),"min"===a&&"horizontal"===this.orientation&&this.range.stop(1,1)[h?"animate":"css"]({width:i+"%"},r.animate),"max"===a&&"horizontal"===this.orientation&&this.range.stop(1,1)[h?"animate":"css"]({width:100-i+"%"},r.animate),"min"===a&&"vertical"===this.orientation&&this.range.stop(1,1)[h?"animate":"css"]({height:i+"%"},r.animate),"max"===a&&"vertical"===this.orientation&&this.range.stop(1,1)[h?"animate":"css"]({height:100-i+"%"},r.animate))},_handleEvents:{keydown:function(e){var i,s,n,o,a=t(e.target).data("ui-slider-handle-index");switch(e.keyCode){case t.ui.keyCode.HOME:case t.ui.keyCode.END:case t.ui.keyCode.PAGE_UP:case t.ui.keyCode.PAGE_DOWN:case t.ui.keyCode.UP:case t.ui.keyCode.RIGHT:case t.ui.keyCode.DOWN:case t.ui.keyCode.LEFT:if(e.preventDefault(),!this._keySliding&&(this._keySliding=!0,this._addClass(t(e.target),null,"ui-state-active"),i=this._start(e,a),i===!1))return}switch(o=this.options.step,s=n=this._hasMultipleValues()?this.values(a):this.value(),e.keyCode){case t.ui.keyCode.HOME:n=this._valueMin();break;case t.ui.keyCode.END:n=this._valueMax();break;case t.ui.keyCode.PAGE_UP:n=this._trimAlignValue(s+(this._valueMax()-this._valueMin())/this.numPages);break;case t.ui.keyCode.PAGE_DOWN:n=this._trimAlignValue(s-(this._valueMax()-this._valueMin())/this.numPages);break;case t.ui.keyCode.UP:case t.ui.keyCode.RIGHT:if(s===this._valueMax())return;n=this._trimAlignValue(s+o);break;case t.ui.keyCode.DOWN:case t.ui.keyCode.LEFT:if(s===this._valueMin())return;n=this._trimAlignValue(s-o)}this._slide(e,a,n)},keyup:function(e){var i=t(e.target).data("ui-slider-handle-index");this._keySliding&&(this._keySliding=!1,this._stop(e,i),this._change(e,i),this._removeClass(t(e.target),null,"ui-state-active"))}}}),t.widget("ui.sortable",t.ui.mouse,{version:"1.12.1",widgetEventPrefix:"sort",ready:!1,options:{appendTo:"parent",axis:!1,connectWith:!1,containment:!1,cursor:"auto",cursorAt:!1,dropOnEmpty:!0,forcePlaceholderSize:!1,forceHelperSize:!1,grid:!1,handle:!1,helper:"original",items:"> *",opacity:!1,placeholder:!1,revert:!1,scroll:!0,scrollSensitivity:20,scrollSpeed:20,scope:"default",tolerance:"intersect",zIndex:1e3,activate:null,beforeStop:null,change:null,deactivate:null,out:null,over:null,receive:null,remove:null,sort:null,start:null,stop:null,update:null},_isOverAxis:function(t,e,i){return t>=e&&e+i>t},_isFloating:function(t){return/left|right/.test(t.css("float"))||/inline|table-cell/.test(t.css("display"))},_create:function(){this.containerCache={},this._addClass("ui-sortable"),this.refresh(),this.offset=this.element.offset(),this._mouseInit(),this._setHandleClassName(),this.ready=!0},_setOption:function(t,e){this._super(t,e),"handle"===t&&this._setHandleClassName()},_setHandleClassName:function(){var e=this;this._removeClass(this.element.find(".ui-sortable-handle"),"ui-sortable-handle"),t.each(this.items,function(){e._addClass(this.instance.options.handle?this.item.find(this.instance.options.handle):this.item,"ui-sortable-handle")})},_destroy:function(){this._mouseDestroy();for(var t=this.items.length-1;t>=0;t--)this.items[t].item.removeData(this.widgetName+"-item");return this},_mouseCapture:function(e,i){var s=null,n=!1,o=this;return this.reverting?!1:this.options.disabled||"static"===this.options.type?!1:(this._refreshItems(e),t(e.target).parents().each(function(){return t.data(this,o.widgetName+"-item")===o?(s=t(this),!1):void 0}),t.data(e.target,o.widgetName+"-item")===o&&(s=t(e.target)),s?!this.options.handle||i||(t(this.options.handle,s).find("*").addBack().each(function(){this===e.target&&(n=!0)}),n)?(this.currentItem=s,this._removeCurrentsFromItems(),!0):!1:!1)},_mouseStart:function(e,i,s){var n,o,a=this.options;if(this.currentContainer=this,this.refreshPositions(),this.helper=this._createHelper(e),this._cacheHelperProportions(),this._cacheMargins(),this.scrollParent=this.helper.scrollParent(),this.offset=this.currentItem.offset(),this.offset={top:this.offset.top-this.margins.top,left:this.offset.left-this.margins.left},t.extend(this.offset,{click:{left:e.pageX-this.offset.left,top:e.pageY-this.offset.top},parent:this._getParentOffset(),relative:this._getRelativeOffset()}),this.helper.css("position","absolute"),this.cssPosition=this.helper.css("position"),this.originalPosition=this._generatePosition(e),this.originalPageX=e.pageX,this.originalPageY=e.pageY,a.cursorAt&&this._adjustOffsetFromHelper(a.cursorAt),this.domPosition={prev:this.currentItem.prev()[0],parent:this.currentItem.parent()[0]},this.helper[0]!==this.currentItem[0]&&this.currentItem.hide(),this._createPlaceholder(),a.containment&&this._setContainment(),a.cursor&&"auto"!==a.cursor&&(o=this.document.find("body"),this.storedCursor=o.css("cursor"),o.css("cursor",a.cursor),this.storedStylesheet=t("<style>*{ cursor: "+a.cursor+" !important; }</style>").appendTo(o)),a.opacity&&(this.helper.css("opacity")&&(this._storedOpacity=this.helper.css("opacity")),this.helper.css("opacity",a.opacity)),a.zIndex&&(this.helper.css("zIndex")&&(this._storedZIndex=this.helper.css("zIndex")),this.helper.css("zIndex",a.zIndex)),this.scrollParent[0]!==this.document[0]&&"HTML"!==this.scrollParent[0].tagName&&(this.overflowOffset=this.scrollParent.offset()),this._trigger("start",e,this._uiHash()),this._preserveHelperProportions||this._cacheHelperProportions(),!s)for(n=this.containers.length-1;n>=0;n--)this.containers[n]._trigger("activate",e,this._uiHash(this));return t.ui.ddmanager&&(t.ui.ddmanager.current=this),t.ui.ddmanager&&!a.dropBehaviour&&t.ui.ddmanager.prepareOffsets(this,e),this.dragging=!0,this._addClass(this.helper,"ui-sortable-helper"),this._mouseDrag(e),!0},_mouseDrag:function(e){var i,s,n,o,a=this.options,r=!1;for(this.position=this._generatePosition(e),this.positionAbs=this._convertPositionTo("absolute"),this.lastPositionAbs||(this.lastPositionAbs=this.positionAbs),this.options.scroll&&(this.scrollParent[0]!==this.document[0]&&"HTML"!==this.scrollParent[0].tagName?(this.overflowOffset.top+this.scrollParent[0].offsetHeight-e.pageY<a.scrollSensitivity?this.scrollParent[0].scrollTop=r=this.scrollParent[0].scrollTop+a.scrollSpeed:e.pageY-this.overflowOffset.top<a.scrollSensitivity&&(this.scrollParent[0].scrollTop=r=this.scrollParent[0].scrollTop-a.scrollSpeed),this.overflowOffset.left+this.scrollParent[0].offsetWidth-e.pageX<a.scrollSensitivity?this.scrollParent[0].scrollLeft=r=this.scrollParent[0].scrollLeft+a.scrollSpeed:e.pageX-this.overflowOffset.left<a.scrollSensitivity&&(this.scrollParent[0].scrollLeft=r=this.scrollParent[0].scrollLeft-a.scrollSpeed)):(e.pageY-this.document.scrollTop()<a.scrollSensitivity?r=this.document.scrollTop(this.document.scrollTop()-a.scrollSpeed):this.window.height()-(e.pageY-this.document.scrollTop())<a.scrollSensitivity&&(r=this.document.scrollTop(this.document.scrollTop()+a.scrollSpeed)),e.pageX-this.document.scrollLeft()<a.scrollSensitivity?r=this.document.scrollLeft(this.document.scrollLeft()-a.scrollSpeed):this.window.width()-(e.pageX-this.document.scrollLeft())<a.scrollSensitivity&&(r=this.document.scrollLeft(this.document.scrollLeft()+a.scrollSpeed))),r!==!1&&t.ui.ddmanager&&!a.dropBehaviour&&t.ui.ddmanager.prepareOffsets(this,e)),this.positionAbs=this._convertPositionTo("absolute"),this.options.axis&&"y"===this.options.axis||(this.helper[0].style.left=this.position.left+"px"),this.options.axis&&"x"===this.options.axis||(this.helper[0].style.top=this.position.top+"px"),i=this.items.length-1;i>=0;i--)if(s=this.items[i],n=s.item[0],o=this._intersectsWithPointer(s),o&&s.instance===this.currentContainer&&n!==this.currentItem[0]&&this.placeholder[1===o?"next":"prev"]()[0]!==n&&!t.contains(this.placeholder[0],n)&&("semi-dynamic"===this.options.type?!t.contains(this.element[0],n):!0)){if(this.direction=1===o?"down":"up","pointer"!==this.options.tolerance&&!this._intersectsWithSides(s))break;this._rearrange(e,s),this._trigger("change",e,this._uiHash());break}return this._contactContainers(e),t.ui.ddmanager&&t.ui.ddmanager.drag(this,e),this._trigger("sort",e,this._uiHash()),this.lastPositionAbs=this.positionAbs,!1},_mouseStop:function(e,i){if(e){if(t.ui.ddmanager&&!this.options.dropBehaviour&&t.ui.ddmanager.drop(this,e),this.options.revert){var s=this,n=this.placeholder.offset(),o=this.options.axis,a={};o&&"x"!==o||(a.left=n.left-this.offset.parent.left-this.margins.left+(this.offsetParent[0]===this.document[0].body?0:this.offsetParent[0].scrollLeft)),o&&"y"!==o||(a.top=n.top-this.offset.parent.top-this.margins.top+(this.offsetParent[0]===this.document[0].body?0:this.offsetParent[0].scrollTop)),this.reverting=!0,t(this.helper).animate(a,parseInt(this.options.revert,10)||500,function(){s._clear(e)})}else this._clear(e,i);return!1}},cancel:function(){if(this.dragging){this._mouseUp(new t.Event("mouseup",{target:null})),"original"===this.options.helper?(this.currentItem.css(this._storedCSS),this._removeClass(this.currentItem,"ui-sortable-helper")):this.currentItem.show();for(var e=this.containers.length-1;e>=0;e--)this.containers[e]._trigger("deactivate",null,this._uiHash(this)),this.containers[e].containerCache.over&&(this.containers[e]._trigger("out",null,this._uiHash(this)),this.containers[e].containerCache.over=0)}return this.placeholder&&(this.placeholder[0].parentNode&&this.placeholder[0].parentNode.removeChild(this.placeholder[0]),"original"!==this.options.helper&&this.helper&&this.helper[0].parentNode&&this.helper.remove(),t.extend(this,{helper:null,dragging:!1,reverting:!1,_noFinalSort:null}),this.domPosition.prev?t(this.domPosition.prev).after(this.currentItem):t(this.domPosition.parent).prepend(this.currentItem)),this},serialize:function(e){var i=this._getItemsAsjQuery(e&&e.connected),s=[];return e=e||{},t(i).each(function(){var i=(t(e.item||this).attr(e.attribute||"id")||"").match(e.expression||/(.+)[\-=_](.+)/);i&&s.push((e.key||i[1]+"[]")+"="+(e.key&&e.expression?i[1]:i[2]))}),!s.length&&e.key&&s.push(e.key+"="),s.join("&")},toArray:function(e){var i=this._getItemsAsjQuery(e&&e.connected),s=[];return e=e||{},i.each(function(){s.push(t(e.item||this).attr(e.attribute||"id")||"")}),s},_intersectsWith:function(t){var e=this.positionAbs.left,i=e+this.helperProportions.width,s=this.positionAbs.top,n=s+this.helperProportions.height,o=t.left,a=o+t.width,r=t.top,l=r+t.height,h=this.offset.click.top,c=this.offset.click.left,u="x"===this.options.axis||s+h>r&&l>s+h,d="y"===this.options.axis||e+c>o&&a>e+c,p=u&&d;return"pointer"===this.options.tolerance||this.options.forcePointerForContainers||"pointer"!==this.options.tolerance&&this.helperProportions[this.floating?"width":"height"]>t[this.floating?"width":"height"]?p:e+this.helperProportions.width/2>o&&a>i-this.helperProportions.width/2&&s+this.helperProportions.height/2>r&&l>n-this.helperProportions.height/2},_intersectsWithPointer:function(t){var e,i,s="x"===this.options.axis||this._isOverAxis(this.positionAbs.top+this.offset.click.top,t.top,t.height),n="y"===this.options.axis||this._isOverAxis(this.positionAbs.left+this.offset.click.left,t.left,t.width),o=s&&n;return o?(e=this._getDragVerticalDirection(),i=this._getDragHorizontalDirection(),this.floating?"right"===i||"down"===e?2:1:e&&("down"===e?2:1)):!1},_intersectsWithSides:function(t){var e=this._isOverAxis(this.positionAbs.top+this.offset.click.top,t.top+t.height/2,t.height),i=this._isOverAxis(this.positionAbs.left+this.offset.click.left,t.left+t.width/2,t.width),s=this._getDragVerticalDirection(),n=this._getDragHorizontalDirection();return this.floating&&n?"right"===n&&i||"left"===n&&!i:s&&("down"===s&&e||"up"===s&&!e)},_getDragVerticalDirection:function(){var t=this.positionAbs.top-this.lastPositionAbs.top;return 0!==t&&(t>0?"down":"up")},_getDragHorizontalDirection:function(){var t=this.positionAbs.left-this.lastPositionAbs.left;return 0!==t&&(t>0?"right":"left")},refresh:function(t){return this._refreshItems(t),this._setHandleClassName(),this.refreshPositions(),this},_connectWith:function(){var t=this.options;return t.connectWith.constructor===String?[t.connectWith]:t.connectWith},_getItemsAsjQuery:function(e){function i(){r.push(this)}var s,n,o,a,r=[],l=[],h=this._connectWith();if(h&&e)for(s=h.length-1;s>=0;s--)for(o=t(h[s],this.document[0]),n=o.length-1;n>=0;n--)a=t.data(o[n],this.widgetFullName),a&&a!==this&&!a.options.disabled&&l.push([t.isFunction(a.options.items)?a.options.items.call(a.element):t(a.options.items,a.element).not(".ui-sortable-helper").not(".ui-sortable-placeholder"),a]);for(l.push([t.isFunction(this.options.items)?this.options.items.call(this.element,null,{options:this.options,item:this.currentItem}):t(this.options.items,this.element).not(".ui-sortable-helper").not(".ui-sortable-placeholder"),this]),s=l.length-1;s>=0;s--)l[s][0].each(i);return t(r)},_removeCurrentsFromItems:function(){var e=this.currentItem.find(":data("+this.widgetName+"-item)");this.items=t.grep(this.items,function(t){for(var i=0;e.length>i;i++)if(e[i]===t.item[0])return!1;return!0})},_refreshItems:function(e){this.items=[],this.containers=[this];var i,s,n,o,a,r,l,h,c=this.items,u=[[t.isFunction(this.options.items)?this.options.items.call(this.element[0],e,{item:this.currentItem}):t(this.options.items,this.element),this]],d=this._connectWith();if(d&&this.ready)for(i=d.length-1;i>=0;i--)for(n=t(d[i],this.document[0]),s=n.length-1;s>=0;s--)o=t.data(n[s],this.widgetFullName),o&&o!==this&&!o.options.disabled&&(u.push([t.isFunction(o.options.items)?o.options.items.call(o.element[0],e,{item:this.currentItem}):t(o.options.items,o.element),o]),this.containers.push(o));for(i=u.length-1;i>=0;i--)for(a=u[i][1],r=u[i][0],s=0,h=r.length;h>s;s++)l=t(r[s]),l.data(this.widgetName+"-item",a),c.push({item:l,instance:a,width:0,height:0,left:0,top:0})},refreshPositions:function(e){this.floating=this.items.length?"x"===this.options.axis||this._isFloating(this.items[0].item):!1,this.offsetParent&&this.helper&&(this.offset.parent=this._getParentOffset());var i,s,n,o;for(i=this.items.length-1;i>=0;i--)s=this.items[i],s.instance!==this.currentContainer&&this.currentContainer&&s.item[0]!==this.currentItem[0]||(n=this.options.toleranceElement?t(this.options.toleranceElement,s.item):s.item,e||(s.width=n.outerWidth(),s.height=n.outerHeight()),o=n.offset(),s.left=o.left,s.top=o.top);if(this.options.custom&&this.options.custom.refreshContainers)this.options.custom.refreshContainers.call(this);else for(i=this.containers.length-1;i>=0;i--)o=this.containers[i].element.offset(),this.containers[i].containerCache.left=o.left,this.containers[i].containerCache.top=o.top,this.containers[i].containerCache.width=this.containers[i].element.outerWidth(),this.containers[i].containerCache.height=this.containers[i].element.outerHeight();return this},_createPlaceholder:function(e){e=e||this;var i,s=e.options;s.placeholder&&s.placeholder.constructor!==String||(i=s.placeholder,s.placeholder={element:function(){var s=e.currentItem[0].nodeName.toLowerCase(),n=t("<"+s+">",e.document[0]);return e._addClass(n,"ui-sortable-placeholder",i||e.currentItem[0].className)._removeClass(n,"ui-sortable-helper"),"tbody"===s?e._createTrPlaceholder(e.currentItem.find("tr").eq(0),t("<tr>",e.document[0]).appendTo(n)):"tr"===s?e._createTrPlaceholder(e.currentItem,n):"img"===s&&n.attr("src",e.currentItem.attr("src")),i||n.css("visibility","hidden"),n},update:function(t,n){(!i||s.forcePlaceholderSize)&&(n.height()||n.height(e.currentItem.innerHeight()-parseInt(e.currentItem.css("paddingTop")||0,10)-parseInt(e.currentItem.css("paddingBottom")||0,10)),n.width()||n.width(e.currentItem.innerWidth()-parseInt(e.currentItem.css("paddingLeft")||0,10)-parseInt(e.currentItem.css("paddingRight")||0,10)))}}),e.placeholder=t(s.placeholder.element.call(e.element,e.currentItem)),e.currentItem.after(e.placeholder),s.placeholder.update(e,e.placeholder)},_createTrPlaceholder:function(e,i){var s=this;e.children().each(function(){t("<td>&#160;</td>",s.document[0]).attr("colspan",t(this).attr("colspan")||1).appendTo(i)})},_contactContainers:function(e){var i,s,n,o,a,r,l,h,c,u,d=null,p=null;for(i=this.containers.length-1;i>=0;i--)if(!t.contains(this.currentItem[0],this.containers[i].element[0]))if(this._intersectsWith(this.containers[i].containerCache)){if(d&&t.contains(this.containers[i].element[0],d.element[0]))continue;d=this.containers[i],p=i}else this.containers[i].containerCache.over&&(this.containers[i]._trigger("out",e,this._uiHash(this)),this.containers[i].containerCache.over=0);if(d)if(1===this.containers.length)this.containers[p].containerCache.over||(this.containers[p]._trigger("over",e,this._uiHash(this)),this.containers[p].containerCache.over=1);else{for(n=1e4,o=null,c=d.floating||this._isFloating(this.currentItem),a=c?"left":"top",r=c?"width":"height",u=c?"pageX":"pageY",s=this.items.length-1;s>=0;s--)t.contains(this.containers[p].element[0],this.items[s].item[0])&&this.items[s].item[0]!==this.currentItem[0]&&(l=this.items[s].item.offset()[a],h=!1,e[u]-l>this.items[s][r]/2&&(h=!0),n>Math.abs(e[u]-l)&&(n=Math.abs(e[u]-l),o=this.items[s],this.direction=h?"up":"down"));if(!o&&!this.options.dropOnEmpty)return;if(this.currentContainer===this.containers[p])return this.currentContainer.containerCache.over||(this.containers[p]._trigger("over",e,this._uiHash()),this.currentContainer.containerCache.over=1),void 0;o?this._rearrange(e,o,null,!0):this._rearrange(e,null,this.containers[p].element,!0),this._trigger("change",e,this._uiHash()),this.containers[p]._trigger("change",e,this._uiHash(this)),this.currentContainer=this.containers[p],this.options.placeholder.update(this.currentContainer,this.placeholder),this.containers[p]._trigger("over",e,this._uiHash(this)),this.containers[p].containerCache.over=1}},_createHelper:function(e){var i=this.options,s=t.isFunction(i.helper)?t(i.helper.apply(this.element[0],[e,this.currentItem])):"clone"===i.helper?this.currentItem.clone():this.currentItem;return s.parents("body").length||t("parent"!==i.appendTo?i.appendTo:this.currentItem[0].parentNode)[0].appendChild(s[0]),s[0]===this.currentItem[0]&&(this._storedCSS={width:this.currentItem[0].style.width,height:this.currentItem[0].style.height,position:this.currentItem.css("position"),top:this.currentItem.css("top"),left:this.currentItem.css("left")}),(!s[0].style.width||i.forceHelperSize)&&s.width(this.currentItem.width()),(!s[0].style.height||i.forceHelperSize)&&s.height(this.currentItem.height()),s},_adjustOffsetFromHelper:function(e){"string"==typeof e&&(e=e.split(" ")),t.isArray(e)&&(e={left:+e[0],top:+e[1]||0}),"left"in e&&(this.offset.click.left=e.left+this.margins.left),"right"in e&&(this.offset.click.left=this.helperProportions.width-e.right+this.margins.left),"top"in e&&(this.offset.click.top=e.top+this.margins.top),"bottom"in e&&(this.offset.click.top=this.helperProportions.height-e.bottom+this.margins.top)},_getParentOffset:function(){this.offsetParent=this.helper.offsetParent();var e=this.offsetParent.offset();return"absolute"===this.cssPosition&&this.scrollParent[0]!==this.document[0]&&t.contains(this.scrollParent[0],this.offsetParent[0])&&(e.left+=this.scrollParent.scrollLeft(),e.top+=this.scrollParent.scrollTop()),(this.offsetParent[0]===this.document[0].body||this.offsetParent[0].tagName&&"html"===this.offsetParent[0].tagName.toLowerCase()&&t.ui.ie)&&(e={top:0,left:0}),{top:e.top+(parseInt(this.offsetParent.css("borderTopWidth"),10)||0),left:e.left+(parseInt(this.offsetParent.css("borderLeftWidth"),10)||0)}},_getRelativeOffset:function(){if("relative"===this.cssPosition){var t=this.currentItem.position();return{top:t.top-(parseInt(this.helper.css("top"),10)||0)+this.scrollParent.scrollTop(),left:t.left-(parseInt(this.helper.css("left"),10)||0)+this.scrollParent.scrollLeft()}}return{top:0,left:0}},_cacheMargins:function(){this.margins={left:parseInt(this.currentItem.css("marginLeft"),10)||0,top:parseInt(this.currentItem.css("marginTop"),10)||0}},_cacheHelperProportions:function(){this.helperProportions={width:this.helper.outerWidth(),height:this.helper.outerHeight()}},_setContainment:function(){var e,i,s,n=this.options;"parent"===n.containment&&(n.containment=this.helper[0].parentNode),("document"===n.containment||"window"===n.containment)&&(this.containment=[0-this.offset.relative.left-this.offset.parent.left,0-this.offset.relative.top-this.offset.parent.top,"document"===n.containment?this.document.width():this.window.width()-this.helperProportions.width-this.margins.left,("document"===n.containment?this.document.height()||document.body.parentNode.scrollHeight:this.window.height()||this.document[0].body.parentNode.scrollHeight)-this.helperProportions.height-this.margins.top]),/^(document|window|parent)$/.test(n.containment)||(e=t(n.containment)[0],i=t(n.containment).offset(),s="hidden"!==t(e).css("overflow"),this.containment=[i.left+(parseInt(t(e).css("borderLeftWidth"),10)||0)+(parseInt(t(e).css("paddingLeft"),10)||0)-this.margins.left,i.top+(parseInt(t(e).css("borderTopWidth"),10)||0)+(parseInt(t(e).css("paddingTop"),10)||0)-this.margins.top,i.left+(s?Math.max(e.scrollWidth,e.offsetWidth):e.offsetWidth)-(parseInt(t(e).css("borderLeftWidth"),10)||0)-(parseInt(t(e).css("paddingRight"),10)||0)-this.helperProportions.width-this.margins.left,i.top+(s?Math.max(e.scrollHeight,e.offsetHeight):e.offsetHeight)-(parseInt(t(e).css("borderTopWidth"),10)||0)-(parseInt(t(e).css("paddingBottom"),10)||0)-this.helperProportions.height-this.margins.top])},_convertPositionTo:function(e,i){i||(i=this.position);var s="absolute"===e?1:-1,n="absolute"!==this.cssPosition||this.scrollParent[0]!==this.document[0]&&t.contains(this.scrollParent[0],this.offsetParent[0])?this.scrollParent:this.offsetParent,o=/(html|body)/i.test(n[0].tagName);return{top:i.top+this.offset.relative.top*s+this.offset.parent.top*s-("fixed"===this.cssPosition?-this.scrollParent.scrollTop():o?0:n.scrollTop())*s,left:i.left+this.offset.relative.left*s+this.offset.parent.left*s-("fixed"===this.cssPosition?-this.scrollParent.scrollLeft():o?0:n.scrollLeft())*s}},_generatePosition:function(e){var i,s,n=this.options,o=e.pageX,a=e.pageY,r="absolute"!==this.cssPosition||this.scrollParent[0]!==this.document[0]&&t.contains(this.scrollParent[0],this.offsetParent[0])?this.scrollParent:this.offsetParent,l=/(html|body)/i.test(r[0].tagName);return"relative"!==this.cssPosition||this.scrollParent[0]!==this.document[0]&&this.scrollParent[0]!==this.offsetParent[0]||(this.offset.relative=this._getRelativeOffset()),this.originalPosition&&(this.containment&&(e.pageX-this.offset.click.left<this.containment[0]&&(o=this.containment[0]+this.offset.click.left),e.pageY-this.offset.click.top<this.containment[1]&&(a=this.containment[1]+this.offset.click.top),e.pageX-this.offset.click.left>this.containment[2]&&(o=this.containment[2]+this.offset.click.left),e.pageY-this.offset.click.top>this.containment[3]&&(a=this.containment[3]+this.offset.click.top)),n.grid&&(i=this.originalPageY+Math.round((a-this.originalPageY)/n.grid[1])*n.grid[1],a=this.containment?i-this.offset.click.top>=this.containment[1]&&i-this.offset.click.top<=this.containment[3]?i:i-this.offset.click.top>=this.containment[1]?i-n.grid[1]:i+n.grid[1]:i,s=this.originalPageX+Math.round((o-this.originalPageX)/n.grid[0])*n.grid[0],o=this.containment?s-this.offset.click.left>=this.containment[0]&&s-this.offset.click.left<=this.containment[2]?s:s-this.offset.click.left>=this.containment[0]?s-n.grid[0]:s+n.grid[0]:s)),{top:a-this.offset.click.top-this.offset.relative.top-this.offset.parent.top+("fixed"===this.cssPosition?-this.scrollParent.scrollTop():l?0:r.scrollTop()),left:o-this.offset.click.left-this.offset.relative.left-this.offset.parent.left+("fixed"===this.cssPosition?-this.scrollParent.scrollLeft():l?0:r.scrollLeft())}},_rearrange:function(t,e,i,s){i?i[0].appendChild(this.placeholder[0]):e.item[0].parentNode.insertBefore(this.placeholder[0],"down"===this.direction?e.item[0]:e.item[0].nextSibling),this.counter=this.counter?++this.counter:1;var n=this.counter;
this._delay(function(){n===this.counter&&this.refreshPositions(!s)})},_clear:function(t,e){function i(t,e,i){return function(s){i._trigger(t,s,e._uiHash(e))}}this.reverting=!1;var s,n=[];if(!this._noFinalSort&&this.currentItem.parent().length&&this.placeholder.before(this.currentItem),this._noFinalSort=null,this.helper[0]===this.currentItem[0]){for(s in this._storedCSS)("auto"===this._storedCSS[s]||"static"===this._storedCSS[s])&&(this._storedCSS[s]="");this.currentItem.css(this._storedCSS),this._removeClass(this.currentItem,"ui-sortable-helper")}else this.currentItem.show();for(this.fromOutside&&!e&&n.push(function(t){this._trigger("receive",t,this._uiHash(this.fromOutside))}),!this.fromOutside&&this.domPosition.prev===this.currentItem.prev().not(".ui-sortable-helper")[0]&&this.domPosition.parent===this.currentItem.parent()[0]||e||n.push(function(t){this._trigger("update",t,this._uiHash())}),this!==this.currentContainer&&(e||(n.push(function(t){this._trigger("remove",t,this._uiHash())}),n.push(function(t){return function(e){t._trigger("receive",e,this._uiHash(this))}}.call(this,this.currentContainer)),n.push(function(t){return function(e){t._trigger("update",e,this._uiHash(this))}}.call(this,this.currentContainer)))),s=this.containers.length-1;s>=0;s--)e||n.push(i("deactivate",this,this.containers[s])),this.containers[s].containerCache.over&&(n.push(i("out",this,this.containers[s])),this.containers[s].containerCache.over=0);if(this.storedCursor&&(this.document.find("body").css("cursor",this.storedCursor),this.storedStylesheet.remove()),this._storedOpacity&&this.helper.css("opacity",this._storedOpacity),this._storedZIndex&&this.helper.css("zIndex","auto"===this._storedZIndex?"":this._storedZIndex),this.dragging=!1,e||this._trigger("beforeStop",t,this._uiHash()),this.placeholder[0].parentNode.removeChild(this.placeholder[0]),this.cancelHelperRemoval||(this.helper[0]!==this.currentItem[0]&&this.helper.remove(),this.helper=null),!e){for(s=0;n.length>s;s++)n[s].call(this,t);this._trigger("stop",t,this._uiHash())}return this.fromOutside=!1,!this.cancelHelperRemoval},_trigger:function(){t.Widget.prototype._trigger.apply(this,arguments)===!1&&this.cancel()},_uiHash:function(e){var i=e||this;return{helper:i.helper,placeholder:i.placeholder||t([]),position:i.position,originalPosition:i.originalPosition,offset:i.positionAbs,item:i.currentItem,sender:e?e.element:null}}}),t.widget("ui.spinner",{version:"1.12.1",defaultElement:"<input>",widgetEventPrefix:"spin",options:{classes:{"ui-spinner":"ui-corner-all","ui-spinner-down":"ui-corner-br","ui-spinner-up":"ui-corner-tr"},culture:null,icons:{down:"ui-icon-triangle-1-s",up:"ui-icon-triangle-1-n"},incremental:!0,max:null,min:null,numberFormat:null,page:10,step:1,change:null,spin:null,start:null,stop:null},_create:function(){this._setOption("max",this.options.max),this._setOption("min",this.options.min),this._setOption("step",this.options.step),""!==this.value()&&this._value(this.element.val(),!0),this._draw(),this._on(this._events),this._refresh(),this._on(this.window,{beforeunload:function(){this.element.removeAttr("autocomplete")}})},_getCreateOptions:function(){var e=this._super(),i=this.element;return t.each(["min","max","step"],function(t,s){var n=i.attr(s);null!=n&&n.length&&(e[s]=n)}),e},_events:{keydown:function(t){this._start(t)&&this._keydown(t)&&t.preventDefault()},keyup:"_stop",focus:function(){this.previous=this.element.val()},blur:function(t){return this.cancelBlur?(delete this.cancelBlur,void 0):(this._stop(),this._refresh(),this.previous!==this.element.val()&&this._trigger("change",t),void 0)},mousewheel:function(t,e){if(e){if(!this.spinning&&!this._start(t))return!1;this._spin((e>0?1:-1)*this.options.step,t),clearTimeout(this.mousewheelTimer),this.mousewheelTimer=this._delay(function(){this.spinning&&this._stop(t)},100),t.preventDefault()}},"mousedown .ui-spinner-button":function(e){function i(){var e=this.element[0]===t.ui.safeActiveElement(this.document[0]);e||(this.element.trigger("focus"),this.previous=s,this._delay(function(){this.previous=s}))}var s;s=this.element[0]===t.ui.safeActiveElement(this.document[0])?this.previous:this.element.val(),e.preventDefault(),i.call(this),this.cancelBlur=!0,this._delay(function(){delete this.cancelBlur,i.call(this)}),this._start(e)!==!1&&this._repeat(null,t(e.currentTarget).hasClass("ui-spinner-up")?1:-1,e)},"mouseup .ui-spinner-button":"_stop","mouseenter .ui-spinner-button":function(e){return t(e.currentTarget).hasClass("ui-state-active")?this._start(e)===!1?!1:(this._repeat(null,t(e.currentTarget).hasClass("ui-spinner-up")?1:-1,e),void 0):void 0},"mouseleave .ui-spinner-button":"_stop"},_enhance:function(){this.uiSpinner=this.element.attr("autocomplete","off").wrap("<span>").parent().append("<a></a><a></a>")},_draw:function(){this._enhance(),this._addClass(this.uiSpinner,"ui-spinner","ui-widget ui-widget-content"),this._addClass("ui-spinner-input"),this.element.attr("role","spinbutton"),this.buttons=this.uiSpinner.children("a").attr("tabIndex",-1).attr("aria-hidden",!0).button({classes:{"ui-button":""}}),this._removeClass(this.buttons,"ui-corner-all"),this._addClass(this.buttons.first(),"ui-spinner-button ui-spinner-up"),this._addClass(this.buttons.last(),"ui-spinner-button ui-spinner-down"),this.buttons.first().button({icon:this.options.icons.up,showLabel:!1}),this.buttons.last().button({icon:this.options.icons.down,showLabel:!1}),this.buttons.height()>Math.ceil(.5*this.uiSpinner.height())&&this.uiSpinner.height()>0&&this.uiSpinner.height(this.uiSpinner.height())},_keydown:function(e){var i=this.options,s=t.ui.keyCode;switch(e.keyCode){case s.UP:return this._repeat(null,1,e),!0;case s.DOWN:return this._repeat(null,-1,e),!0;case s.PAGE_UP:return this._repeat(null,i.page,e),!0;case s.PAGE_DOWN:return this._repeat(null,-i.page,e),!0}return!1},_start:function(t){return this.spinning||this._trigger("start",t)!==!1?(this.counter||(this.counter=1),this.spinning=!0,!0):!1},_repeat:function(t,e,i){t=t||500,clearTimeout(this.timer),this.timer=this._delay(function(){this._repeat(40,e,i)},t),this._spin(e*this.options.step,i)},_spin:function(t,e){var i=this.value()||0;this.counter||(this.counter=1),i=this._adjustValue(i+t*this._increment(this.counter)),this.spinning&&this._trigger("spin",e,{value:i})===!1||(this._value(i),this.counter++)},_increment:function(e){var i=this.options.incremental;return i?t.isFunction(i)?i(e):Math.floor(e*e*e/5e4-e*e/500+17*e/200+1):1},_precision:function(){var t=this._precisionOf(this.options.step);return null!==this.options.min&&(t=Math.max(t,this._precisionOf(this.options.min))),t},_precisionOf:function(t){var e=""+t,i=e.indexOf(".");return-1===i?0:e.length-i-1},_adjustValue:function(t){var e,i,s=this.options;return e=null!==s.min?s.min:0,i=t-e,i=Math.round(i/s.step)*s.step,t=e+i,t=parseFloat(t.toFixed(this._precision())),null!==s.max&&t>s.max?s.max:null!==s.min&&s.min>t?s.min:t},_stop:function(t){this.spinning&&(clearTimeout(this.timer),clearTimeout(this.mousewheelTimer),this.counter=0,this.spinning=!1,this._trigger("stop",t))},_setOption:function(t,e){var i,s,n;return"culture"===t||"numberFormat"===t?(i=this._parse(this.element.val()),this.options[t]=e,this.element.val(this._format(i)),void 0):(("max"===t||"min"===t||"step"===t)&&"string"==typeof e&&(e=this._parse(e)),"icons"===t&&(s=this.buttons.first().find(".ui-icon"),this._removeClass(s,null,this.options.icons.up),this._addClass(s,null,e.up),n=this.buttons.last().find(".ui-icon"),this._removeClass(n,null,this.options.icons.down),this._addClass(n,null,e.down)),this._super(t,e),void 0)},_setOptionDisabled:function(t){this._super(t),this._toggleClass(this.uiSpinner,null,"ui-state-disabled",!!t),this.element.prop("disabled",!!t),this.buttons.button(t?"disable":"enable")},_setOptions:r(function(t){this._super(t)}),_parse:function(t){return"string"==typeof t&&""!==t&&(t=window.Globalize&&this.options.numberFormat?Globalize.parseFloat(t,10,this.options.culture):+t),""===t||isNaN(t)?null:t},_format:function(t){return""===t?"":window.Globalize&&this.options.numberFormat?Globalize.format(t,this.options.numberFormat,this.options.culture):t},_refresh:function(){this.element.attr({"aria-valuemin":this.options.min,"aria-valuemax":this.options.max,"aria-valuenow":this._parse(this.element.val())})},isValid:function(){var t=this.value();return null===t?!1:t===this._adjustValue(t)},_value:function(t,e){var i;""!==t&&(i=this._parse(t),null!==i&&(e||(i=this._adjustValue(i)),t=this._format(i))),this.element.val(t),this._refresh()},_destroy:function(){this.element.prop("disabled",!1).removeAttr("autocomplete role aria-valuemin aria-valuemax aria-valuenow"),this.uiSpinner.replaceWith(this.element)},stepUp:r(function(t){this._stepUp(t)}),_stepUp:function(t){this._start()&&(this._spin((t||1)*this.options.step),this._stop())},stepDown:r(function(t){this._stepDown(t)}),_stepDown:function(t){this._start()&&(this._spin((t||1)*-this.options.step),this._stop())},pageUp:r(function(t){this._stepUp((t||1)*this.options.page)}),pageDown:r(function(t){this._stepDown((t||1)*this.options.page)}),value:function(t){return arguments.length?(r(this._value).call(this,t),void 0):this._parse(this.element.val())},widget:function(){return this.uiSpinner}}),t.uiBackCompat!==!1&&t.widget("ui.spinner",t.ui.spinner,{_enhance:function(){this.uiSpinner=this.element.attr("autocomplete","off").wrap(this._uiSpinnerHtml()).parent().append(this._buttonHtml())},_uiSpinnerHtml:function(){return"<span>"},_buttonHtml:function(){return"<a></a><a></a>"}}),t.ui.spinner,t.widget("ui.tabs",{version:"1.12.1",delay:300,options:{active:null,classes:{"ui-tabs":"ui-corner-all","ui-tabs-nav":"ui-corner-all","ui-tabs-panel":"ui-corner-bottom","ui-tabs-tab":"ui-corner-top"},collapsible:!1,event:"click",heightStyle:"content",hide:null,show:null,activate:null,beforeActivate:null,beforeLoad:null,load:null},_isLocal:function(){var t=/#.*$/;return function(e){var i,s;i=e.href.replace(t,""),s=location.href.replace(t,"");try{i=decodeURIComponent(i)}catch(n){}try{s=decodeURIComponent(s)}catch(n){}return e.hash.length>1&&i===s}}(),_create:function(){var e=this,i=this.options;this.running=!1,this._addClass("ui-tabs","ui-widget ui-widget-content"),this._toggleClass("ui-tabs-collapsible",null,i.collapsible),this._processTabs(),i.active=this._initialActive(),t.isArray(i.disabled)&&(i.disabled=t.unique(i.disabled.concat(t.map(this.tabs.filter(".ui-state-disabled"),function(t){return e.tabs.index(t)}))).sort()),this.active=this.options.active!==!1&&this.anchors.length?this._findActive(i.active):t(),this._refresh(),this.active.length&&this.load(i.active)},_initialActive:function(){var e=this.options.active,i=this.options.collapsible,s=location.hash.substring(1);return null===e&&(s&&this.tabs.each(function(i,n){return t(n).attr("aria-controls")===s?(e=i,!1):void 0}),null===e&&(e=this.tabs.index(this.tabs.filter(".ui-tabs-active"))),(null===e||-1===e)&&(e=this.tabs.length?0:!1)),e!==!1&&(e=this.tabs.index(this.tabs.eq(e)),-1===e&&(e=i?!1:0)),!i&&e===!1&&this.anchors.length&&(e=0),e},_getCreateEventData:function(){return{tab:this.active,panel:this.active.length?this._getPanelForTab(this.active):t()}},_tabKeydown:function(e){var i=t(t.ui.safeActiveElement(this.document[0])).closest("li"),s=this.tabs.index(i),n=!0;if(!this._handlePageNav(e)){switch(e.keyCode){case t.ui.keyCode.RIGHT:case t.ui.keyCode.DOWN:s++;break;case t.ui.keyCode.UP:case t.ui.keyCode.LEFT:n=!1,s--;break;case t.ui.keyCode.END:s=this.anchors.length-1;break;case t.ui.keyCode.HOME:s=0;break;case t.ui.keyCode.SPACE:return e.preventDefault(),clearTimeout(this.activating),this._activate(s),void 0;case t.ui.keyCode.ENTER:return e.preventDefault(),clearTimeout(this.activating),this._activate(s===this.options.active?!1:s),void 0;default:return}e.preventDefault(),clearTimeout(this.activating),s=this._focusNextTab(s,n),e.ctrlKey||e.metaKey||(i.attr("aria-selected","false"),this.tabs.eq(s).attr("aria-selected","true"),this.activating=this._delay(function(){this.option("active",s)},this.delay))}},_panelKeydown:function(e){this._handlePageNav(e)||e.ctrlKey&&e.keyCode===t.ui.keyCode.UP&&(e.preventDefault(),this.active.trigger("focus"))},_handlePageNav:function(e){return e.altKey&&e.keyCode===t.ui.keyCode.PAGE_UP?(this._activate(this._focusNextTab(this.options.active-1,!1)),!0):e.altKey&&e.keyCode===t.ui.keyCode.PAGE_DOWN?(this._activate(this._focusNextTab(this.options.active+1,!0)),!0):void 0},_findNextTab:function(e,i){function s(){return e>n&&(e=0),0>e&&(e=n),e}for(var n=this.tabs.length-1;-1!==t.inArray(s(),this.options.disabled);)e=i?e+1:e-1;return e},_focusNextTab:function(t,e){return t=this._findNextTab(t,e),this.tabs.eq(t).trigger("focus"),t},_setOption:function(t,e){return"active"===t?(this._activate(e),void 0):(this._super(t,e),"collapsible"===t&&(this._toggleClass("ui-tabs-collapsible",null,e),e||this.options.active!==!1||this._activate(0)),"event"===t&&this._setupEvents(e),"heightStyle"===t&&this._setupHeightStyle(e),void 0)},_sanitizeSelector:function(t){return t?t.replace(/[!"$%&'()*+,.\/:;<=>?@\[\]\^`{|}~]/g,"\\$&"):""},refresh:function(){var e=this.options,i=this.tablist.children(":has(a[href])");e.disabled=t.map(i.filter(".ui-state-disabled"),function(t){return i.index(t)}),this._processTabs(),e.active!==!1&&this.anchors.length?this.active.length&&!t.contains(this.tablist[0],this.active[0])?this.tabs.length===e.disabled.length?(e.active=!1,this.active=t()):this._activate(this._findNextTab(Math.max(0,e.active-1),!1)):e.active=this.tabs.index(this.active):(e.active=!1,this.active=t()),this._refresh()},_refresh:function(){this._setOptionDisabled(this.options.disabled),this._setupEvents(this.options.event),this._setupHeightStyle(this.options.heightStyle),this.tabs.not(this.active).attr({"aria-selected":"false","aria-expanded":"false",tabIndex:-1}),this.panels.not(this._getPanelForTab(this.active)).hide().attr({"aria-hidden":"true"}),this.active.length?(this.active.attr({"aria-selected":"true","aria-expanded":"true",tabIndex:0}),this._addClass(this.active,"ui-tabs-active","ui-state-active"),this._getPanelForTab(this.active).show().attr({"aria-hidden":"false"})):this.tabs.eq(0).attr("tabIndex",0)},_processTabs:function(){var e=this,i=this.tabs,s=this.anchors,n=this.panels;this.tablist=this._getList().attr("role","tablist"),this._addClass(this.tablist,"ui-tabs-nav","ui-helper-reset ui-helper-clearfix ui-widget-header"),this.tablist.on("mousedown"+this.eventNamespace,"> li",function(e){t(this).is(".ui-state-disabled")&&e.preventDefault()}).on("focus"+this.eventNamespace,".ui-tabs-anchor",function(){t(this).closest("li").is(".ui-state-disabled")&&this.blur()}),this.tabs=this.tablist.find("> li:has(a[href])").attr({role:"tab",tabIndex:-1}),this._addClass(this.tabs,"ui-tabs-tab","ui-state-default"),this.anchors=this.tabs.map(function(){return t("a",this)[0]}).attr({role:"presentation",tabIndex:-1}),this._addClass(this.anchors,"ui-tabs-anchor"),this.panels=t(),this.anchors.each(function(i,s){var n,o,a,r=t(s).uniqueId().attr("id"),l=t(s).closest("li"),h=l.attr("aria-controls");e._isLocal(s)?(n=s.hash,a=n.substring(1),o=e.element.find(e._sanitizeSelector(n))):(a=l.attr("aria-controls")||t({}).uniqueId()[0].id,n="#"+a,o=e.element.find(n),o.length||(o=e._createPanel(a),o.insertAfter(e.panels[i-1]||e.tablist)),o.attr("aria-live","polite")),o.length&&(e.panels=e.panels.add(o)),h&&l.data("ui-tabs-aria-controls",h),l.attr({"aria-controls":a,"aria-labelledby":r}),o.attr("aria-labelledby",r)}),this.panels.attr("role","tabpanel"),this._addClass(this.panels,"ui-tabs-panel","ui-widget-content"),i&&(this._off(i.not(this.tabs)),this._off(s.not(this.anchors)),this._off(n.not(this.panels)))},_getList:function(){return this.tablist||this.element.find("ol, ul").eq(0)},_createPanel:function(e){return t("<div>").attr("id",e).data("ui-tabs-destroy",!0)},_setOptionDisabled:function(e){var i,s,n;for(t.isArray(e)&&(e.length?e.length===this.anchors.length&&(e=!0):e=!1),n=0;s=this.tabs[n];n++)i=t(s),e===!0||-1!==t.inArray(n,e)?(i.attr("aria-disabled","true"),this._addClass(i,null,"ui-state-disabled")):(i.removeAttr("aria-disabled"),this._removeClass(i,null,"ui-state-disabled"));this.options.disabled=e,this._toggleClass(this.widget(),this.widgetFullName+"-disabled",null,e===!0)},_setupEvents:function(e){var i={};e&&t.each(e.split(" "),function(t,e){i[e]="_eventHandler"}),this._off(this.anchors.add(this.tabs).add(this.panels)),this._on(!0,this.anchors,{click:function(t){t.preventDefault()}}),this._on(this.anchors,i),this._on(this.tabs,{keydown:"_tabKeydown"}),this._on(this.panels,{keydown:"_panelKeydown"}),this._focusable(this.tabs),this._hoverable(this.tabs)},_setupHeightStyle:function(e){var i,s=this.element.parent();"fill"===e?(i=s.height(),i-=this.element.outerHeight()-this.element.height(),this.element.siblings(":visible").each(function(){var e=t(this),s=e.css("position");"absolute"!==s&&"fixed"!==s&&(i-=e.outerHeight(!0))}),this.element.children().not(this.panels).each(function(){i-=t(this).outerHeight(!0)}),this.panels.each(function(){t(this).height(Math.max(0,i-t(this).innerHeight()+t(this).height()))}).css("overflow","auto")):"auto"===e&&(i=0,this.panels.each(function(){i=Math.max(i,t(this).height("").height())}).height(i))},_eventHandler:function(e){var i=this.options,s=this.active,n=t(e.currentTarget),o=n.closest("li"),a=o[0]===s[0],r=a&&i.collapsible,l=r?t():this._getPanelForTab(o),h=s.length?this._getPanelForTab(s):t(),c={oldTab:s,oldPanel:h,newTab:r?t():o,newPanel:l};e.preventDefault(),o.hasClass("ui-state-disabled")||o.hasClass("ui-tabs-loading")||this.running||a&&!i.collapsible||this._trigger("beforeActivate",e,c)===!1||(i.active=r?!1:this.tabs.index(o),this.active=a?t():o,this.xhr&&this.xhr.abort(),h.length||l.length||t.error("jQuery UI Tabs: Mismatching fragment identifier."),l.length&&this.load(this.tabs.index(o),e),this._toggle(e,c))},_toggle:function(e,i){function s(){o.running=!1,o._trigger("activate",e,i)}function n(){o._addClass(i.newTab.closest("li"),"ui-tabs-active","ui-state-active"),a.length&&o.options.show?o._show(a,o.options.show,s):(a.show(),s())}var o=this,a=i.newPanel,r=i.oldPanel;this.running=!0,r.length&&this.options.hide?this._hide(r,this.options.hide,function(){o._removeClass(i.oldTab.closest("li"),"ui-tabs-active","ui-state-active"),n()}):(this._removeClass(i.oldTab.closest("li"),"ui-tabs-active","ui-state-active"),r.hide(),n()),r.attr("aria-hidden","true"),i.oldTab.attr({"aria-selected":"false","aria-expanded":"false"}),a.length&&r.length?i.oldTab.attr("tabIndex",-1):a.length&&this.tabs.filter(function(){return 0===t(this).attr("tabIndex")}).attr("tabIndex",-1),a.attr("aria-hidden","false"),i.newTab.attr({"aria-selected":"true","aria-expanded":"true",tabIndex:0})},_activate:function(e){var i,s=this._findActive(e);s[0]!==this.active[0]&&(s.length||(s=this.active),i=s.find(".ui-tabs-anchor")[0],this._eventHandler({target:i,currentTarget:i,preventDefault:t.noop}))},_findActive:function(e){return e===!1?t():this.tabs.eq(e)},_getIndex:function(e){return"string"==typeof e&&(e=this.anchors.index(this.anchors.filter("[href$='"+t.ui.escapeSelector(e)+"']"))),e},_destroy:function(){this.xhr&&this.xhr.abort(),this.tablist.removeAttr("role").off(this.eventNamespace),this.anchors.removeAttr("role tabIndex").removeUniqueId(),this.tabs.add(this.panels).each(function(){t.data(this,"ui-tabs-destroy")?t(this).remove():t(this).removeAttr("role tabIndex aria-live aria-busy aria-selected aria-labelledby aria-hidden aria-expanded")}),this.tabs.each(function(){var e=t(this),i=e.data("ui-tabs-aria-controls");i?e.attr("aria-controls",i).removeData("ui-tabs-aria-controls"):e.removeAttr("aria-controls")}),this.panels.show(),"content"!==this.options.heightStyle&&this.panels.css("height","")},enable:function(e){var i=this.options.disabled;i!==!1&&(void 0===e?i=!1:(e=this._getIndex(e),i=t.isArray(i)?t.map(i,function(t){return t!==e?t:null}):t.map(this.tabs,function(t,i){return i!==e?i:null})),this._setOptionDisabled(i))},disable:function(e){var i=this.options.disabled;if(i!==!0){if(void 0===e)i=!0;else{if(e=this._getIndex(e),-1!==t.inArray(e,i))return;i=t.isArray(i)?t.merge([e],i).sort():[e]}this._setOptionDisabled(i)}},load:function(e,i){e=this._getIndex(e);var s=this,n=this.tabs.eq(e),o=n.find(".ui-tabs-anchor"),a=this._getPanelForTab(n),r={tab:n,panel:a},l=function(t,e){"abort"===e&&s.panels.stop(!1,!0),s._removeClass(n,"ui-tabs-loading"),a.removeAttr("aria-busy"),t===s.xhr&&delete s.xhr};this._isLocal(o[0])||(this.xhr=t.ajax(this._ajaxSettings(o,i,r)),this.xhr&&"canceled"!==this.xhr.statusText&&(this._addClass(n,"ui-tabs-loading"),a.attr("aria-busy","true"),this.xhr.done(function(t,e,n){setTimeout(function(){a.html(t),s._trigger("load",i,r),l(n,e)},1)}).fail(function(t,e){setTimeout(function(){l(t,e)},1)})))},_ajaxSettings:function(e,i,s){var n=this;return{url:e.attr("href").replace(/#.*$/,""),beforeSend:function(e,o){return n._trigger("beforeLoad",i,t.extend({jqXHR:e,ajaxSettings:o},s))}}},_getPanelForTab:function(e){var i=t(e).attr("aria-controls");return this.element.find(this._sanitizeSelector("#"+i))}}),t.uiBackCompat!==!1&&t.widget("ui.tabs",t.ui.tabs,{_processTabs:function(){this._superApply(arguments),this._addClass(this.tabs,"ui-tab")}}),t.ui.tabs,t.widget("ui.tooltip",{version:"1.12.1",options:{classes:{"ui-tooltip":"ui-corner-all ui-widget-shadow"},content:function(){var e=t(this).attr("title")||"";return t("<a>").text(e).html()},hide:!0,items:"[title]:not([disabled])",position:{my:"left top+15",at:"left bottom",collision:"flipfit flip"},show:!0,track:!1,close:null,open:null},_addDescribedBy:function(e,i){var s=(e.attr("aria-describedby")||"").split(/\s+/);s.push(i),e.data("ui-tooltip-id",i).attr("aria-describedby",t.trim(s.join(" ")))},_removeDescribedBy:function(e){var i=e.data("ui-tooltip-id"),s=(e.attr("aria-describedby")||"").split(/\s+/),n=t.inArray(i,s);-1!==n&&s.splice(n,1),e.removeData("ui-tooltip-id"),s=t.trim(s.join(" ")),s?e.attr("aria-describedby",s):e.removeAttr("aria-describedby")},_create:function(){this._on({mouseover:"open",focusin:"open"}),this.tooltips={},this.parents={},this.liveRegion=t("<div>").attr({role:"log","aria-live":"assertive","aria-relevant":"additions"}).appendTo(this.document[0].body),this._addClass(this.liveRegion,null,"ui-helper-hidden-accessible"),this.disabledTitles=t([])},_setOption:function(e,i){var s=this;this._super(e,i),"content"===e&&t.each(this.tooltips,function(t,e){s._updateContent(e.element)})},_setOptionDisabled:function(t){this[t?"_disable":"_enable"]()},_disable:function(){var e=this;t.each(this.tooltips,function(i,s){var n=t.Event("blur");n.target=n.currentTarget=s.element[0],e.close(n,!0)}),this.disabledTitles=this.disabledTitles.add(this.element.find(this.options.items).addBack().filter(function(){var e=t(this);return e.is("[title]")?e.data("ui-tooltip-title",e.attr("title")).removeAttr("title"):void 0}))},_enable:function(){this.disabledTitles.each(function(){var e=t(this);e.data("ui-tooltip-title")&&e.attr("title",e.data("ui-tooltip-title"))}),this.disabledTitles=t([])},open:function(e){var i=this,s=t(e?e.target:this.element).closest(this.options.items);s.length&&!s.data("ui-tooltip-id")&&(s.attr("title")&&s.data("ui-tooltip-title",s.attr("title")),s.data("ui-tooltip-open",!0),e&&"mouseover"===e.type&&s.parents().each(function(){var e,s=t(this);s.data("ui-tooltip-open")&&(e=t.Event("blur"),e.target=e.currentTarget=this,i.close(e,!0)),s.attr("title")&&(s.uniqueId(),i.parents[this.id]={element:this,title:s.attr("title")},s.attr("title",""))}),this._registerCloseHandlers(e,s),this._updateContent(s,e))},_updateContent:function(t,e){var i,s=this.options.content,n=this,o=e?e.type:null;return"string"==typeof s||s.nodeType||s.jquery?this._open(e,t,s):(i=s.call(t[0],function(i){n._delay(function(){t.data("ui-tooltip-open")&&(e&&(e.type=o),this._open(e,t,i))})}),i&&this._open(e,t,i),void 0)},_open:function(e,i,s){function n(t){h.of=t,a.is(":hidden")||a.position(h)}var o,a,r,l,h=t.extend({},this.options.position);if(s){if(o=this._find(i))return o.tooltip.find(".ui-tooltip-content").html(s),void 0;i.is("[title]")&&(e&&"mouseover"===e.type?i.attr("title",""):i.removeAttr("title")),o=this._tooltip(i),a=o.tooltip,this._addDescribedBy(i,a.attr("id")),a.find(".ui-tooltip-content").html(s),this.liveRegion.children().hide(),l=t("<div>").html(a.find(".ui-tooltip-content").html()),l.removeAttr("name").find("[name]").removeAttr("name"),l.removeAttr("id").find("[id]").removeAttr("id"),l.appendTo(this.liveRegion),this.options.track&&e&&/^mouse/.test(e.type)?(this._on(this.document,{mousemove:n}),n(e)):a.position(t.extend({of:i},this.options.position)),a.hide(),this._show(a,this.options.show),this.options.track&&this.options.show&&this.options.show.delay&&(r=this.delayedShow=setInterval(function(){a.is(":visible")&&(n(h.of),clearInterval(r))},t.fx.interval)),this._trigger("open",e,{tooltip:a})}},_registerCloseHandlers:function(e,i){var s={keyup:function(e){if(e.keyCode===t.ui.keyCode.ESCAPE){var s=t.Event(e);s.currentTarget=i[0],this.close(s,!0)}}};i[0]!==this.element[0]&&(s.remove=function(){this._removeTooltip(this._find(i).tooltip)}),e&&"mouseover"!==e.type||(s.mouseleave="close"),e&&"focusin"!==e.type||(s.focusout="close"),this._on(!0,i,s)},close:function(e){var i,s=this,n=t(e?e.currentTarget:this.element),o=this._find(n);return o?(i=o.tooltip,o.closing||(clearInterval(this.delayedShow),n.data("ui-tooltip-title")&&!n.attr("title")&&n.attr("title",n.data("ui-tooltip-title")),this._removeDescribedBy(n),o.hiding=!0,i.stop(!0),this._hide(i,this.options.hide,function(){s._removeTooltip(t(this))}),n.removeData("ui-tooltip-open"),this._off(n,"mouseleave focusout keyup"),n[0]!==this.element[0]&&this._off(n,"remove"),this._off(this.document,"mousemove"),e&&"mouseleave"===e.type&&t.each(this.parents,function(e,i){t(i.element).attr("title",i.title),delete s.parents[e]}),o.closing=!0,this._trigger("close",e,{tooltip:i}),o.hiding||(o.closing=!1)),void 0):(n.removeData("ui-tooltip-open"),void 0)},_tooltip:function(e){var i=t("<div>").attr("role","tooltip"),s=t("<div>").appendTo(i),n=i.uniqueId().attr("id");return this._addClass(s,"ui-tooltip-content"),this._addClass(i,"ui-tooltip","ui-widget ui-widget-content"),i.appendTo(this._appendTo(e)),this.tooltips[n]={element:e,tooltip:i}},_find:function(t){var e=t.data("ui-tooltip-id");return e?this.tooltips[e]:null},_removeTooltip:function(t){t.remove(),delete this.tooltips[t.attr("id")]},_appendTo:function(t){var e=t.closest(".ui-front, dialog");return e.length||(e=this.document[0].body),e},_destroy:function(){var e=this;t.each(this.tooltips,function(i,s){var n=t.Event("blur"),o=s.element;n.target=n.currentTarget=o[0],e.close(n,!0),t("#"+i).remove(),o.data("ui-tooltip-title")&&(o.attr("title")||o.attr("title",o.data("ui-tooltip-title")),o.removeData("ui-tooltip-title"))}),this.liveRegion.remove()}}),t.uiBackCompat!==!1&&t.widget("ui.tooltip",t.ui.tooltip,{options:{tooltipClass:null},_tooltip:function(){var t=this._superApply(arguments);return this.options.tooltipClass&&t.tooltip.addClass(this.options.tooltipClass),t}}),t.ui.tooltip});
/*! jQuery Migrate v3.0.1 | (c) jQuery Foundation and other contributors | jquery.org/license */
void 0 === jQuery.migrateMute && (jQuery.migrateMute = !0),
    (function (e) {
        "function" == typeof define && define.amd
            ? define(["jquery"], window, e)
            : "object" == typeof module && module.exports
            ? (module.exports = e(require("jquery"), window))
            : e(jQuery, window);
    })(function (e, t) {
        "use strict";
        function r(r) {
            var n = t.console;
            a[r] ||
                ((a[r] = !0),
                e.migrateWarnings.push(r),
                n &&
                    n.warn &&
                    !e.migrateMute &&
                    (n.warn("JQMIGRATE: " + r),
                    e.migrateTrace && n.trace && n.trace()));
        }
        function n(e, t, n, o) {
            Object.defineProperty(e, t, {
                configurable: !0,
                enumerable: !0,
                get: function () {
                    return r(o), n;
                },
                set: function (e) {
                    r(o), (n = e);
                },
            });
        }
        function o(e, t, n, o) {
            e[t] = function () {
                return r(o), n.apply(this, arguments);
            };
        }
        (e.migrateVersion = "3.0.1"),
            t.console &&
                t.console.log &&
                ((e && !/^[12]\./.test(e.fn.jquery)) ||
                    t.console.log("JQMIGRATE: jQuery 3.0.0+ REQUIRED"),
                e.migrateWarnings &&
                    t.console.log(
                        "JQMIGRATE: Migrate plugin loaded multiple times"
                    ));
        var a = {};
        (e.migrateWarnings = []),
            void 0 === e.migrateTrace && (e.migrateTrace = !0),
            (e.migrateReset = function () {
                (a = {}), (e.migrateWarnings.length = 0);
            }),
            "BackCompat" === t.document.compatMode &&
                r("jQuery is not compatible with Quirks Mode");
        var i,
            s = e.fn.init,
            u = e.isNumeric,
            c = e.find,
            l = /\[(\s*[-\w]+\s*)([~|^$*]?=)\s*([-\w#]*?#[-\w#]*)\s*\]/,
            d = /\[(\s*[-\w]+\s*)([~|^$*]?=)\s*([-\w#]*?#[-\w#]*)\s*\]/g;
        for (i in ((e.fn.init = function (e) {
            var t = Array.prototype.slice.call(arguments);
            return (
                "string" == typeof e &&
                    "#" === e &&
                    (r("jQuery( '#' ) is not a valid selector"), (t[0] = [])),
                s.apply(this, t)
            );
        }),
        (e.fn.init.prototype = e.fn),
        (e.find = function (e) {
            var n = Array.prototype.slice.call(arguments);
            if ("string" == typeof e && l.test(e))
                try {
                    t.document.querySelector(e);
                } catch (o) {
                    e = e.replace(d, function (e, t, r, n) {
                        return "[" + t + r + '"' + n + '"]';
                    });
                    try {
                        t.document.querySelector(e),
                            r(
                                "Attribute selector with '#' must be quoted: " +
                                    n[0]
                            ),
                            (n[0] = e);
                    } catch (e) {
                        r("Attribute selector with '#' was not fixed: " + n[0]);
                    }
                }
            return c.apply(this, n);
        }),
        c))
            Object.prototype.hasOwnProperty.call(c, i) && (e.find[i] = c[i]);
        (e.fn.size = function () {
            return (
                r(
                    "jQuery.fn.size() is deprecated and removed; use the .length property"
                ),
                this.length
            );
        }),
            (e.parseJSON = function () {
                return (
                    r("jQuery.parseJSON is deprecated; use JSON.parse"),
                    JSON.parse.apply(null, arguments)
                );
            }),
            (e.isNumeric = function (t) {
                var n = u(t),
                    o = (function (t) {
                        var r = t && t.toString();
                        return !e.isArray(t) && r - parseFloat(r) + 1 >= 0;
                    })(t);
                return (
                    n !== o &&
                        r(
                            "jQuery.isNumeric() should not be called on constructed objects"
                        ),
                    o
                );
            }),
            o(e, "holdReady", e.holdReady, "jQuery.holdReady is deprecated"),
            o(
                e,
                "unique",
                e.uniqueSort,
                "jQuery.unique is deprecated; use jQuery.uniqueSort"
            ),
            n(
                e.expr,
                "filters",
                e.expr.pseudos,
                "jQuery.expr.filters is deprecated; use jQuery.expr.pseudos"
            ),
            n(
                e.expr,
                ":",
                e.expr.pseudos,
                "jQuery.expr[':'] is deprecated; use jQuery.expr.pseudos"
            );
        var p = e.ajax;
        e.ajax = function () {
            var e = p.apply(this, arguments);
            return (
                e.promise &&
                    (o(
                        e,
                        "success",
                        e.done,
                        "jQXHR.success is deprecated and removed"
                    ),
                    o(
                        e,
                        "error",
                        e.fail,
                        "jQXHR.error is deprecated and removed"
                    ),
                    o(
                        e,
                        "complete",
                        e.always,
                        "jQXHR.complete is deprecated and removed"
                    )),
                e
            );
        };
        var f = e.fn.removeAttr,
            y = e.fn.toggleClass,
            m = /\S+/g;
        (e.fn.removeAttr = function (t) {
            var n = this;
            return (
                e.each(t.match(m), function (t, o) {
                    e.expr.match.bool.test(o) &&
                        (r(
                            "jQuery.fn.removeAttr no longer sets boolean properties: " +
                                o
                        ),
                        n.prop(o, !1));
                }),
                f.apply(this, arguments)
            );
        }),
            (e.fn.toggleClass = function (t) {
                return void 0 !== t && "boolean" != typeof t
                    ? y.apply(this, arguments)
                    : (r("jQuery.fn.toggleClass( boolean ) is deprecated"),
                      this.each(function () {
                          var r =
                              (this.getAttribute &&
                                  this.getAttribute("class")) ||
                              "";
                          r && e.data(this, "__className__", r),
                              this.setAttribute &&
                                  this.setAttribute(
                                      "class",
                                      r || !1 === t
                                          ? ""
                                          : e.data(this, "__className__") || ""
                                  );
                      }));
            });
        var h = !1;
        e.swap &&
            e.each(["height", "width", "reliableMarginRight"], function (t, r) {
                var n = e.cssHooks[r] && e.cssHooks[r].get;
                n &&
                    (e.cssHooks[r].get = function () {
                        var e;
                        return (
                            (h = !0),
                            (e = n.apply(this, arguments)),
                            (h = !1),
                            e
                        );
                    });
            }),
            (e.swap = function (e, t, n, o) {
                var a,
                    i,
                    s = {};
                for (i in (h ||
                    r("jQuery.swap() is undocumented and deprecated"),
                t))
                    (s[i] = e.style[i]), (e.style[i] = t[i]);
                for (i in ((a = n.apply(e, o || [])), t)) e.style[i] = s[i];
                return a;
            });
        var g = e.data;
        e.data = function (t, n, o) {
            var a;
            if (n && "object" == typeof n && 2 === arguments.length) {
                a = e.hasData(t) && g.call(this, t);
                var i = {};
                for (var s in n)
                    s !== e.camelCase(s)
                        ? (r(
                              "jQuery.data() always sets/gets camelCased names: " +
                                  s
                          ),
                          (a[s] = n[s]))
                        : (i[s] = n[s]);
                return g.call(this, t, i), n;
            }
            return n &&
                "string" == typeof n &&
                n !== e.camelCase(n) &&
                (a = e.hasData(t) && g.call(this, t)) &&
                n in a
                ? (r("jQuery.data() always sets/gets camelCased names: " + n),
                  arguments.length > 2 && (a[n] = o),
                  a[n])
                : g.apply(this, arguments);
        };
        var v = e.Tween.prototype.run,
            j = function (e) {
                return e;
            };
        (e.Tween.prototype.run = function () {
            e.easing[this.easing].length > 1 &&
                (r(
                    "'jQuery.easing." +
                        this.easing.toString() +
                        "' should use only one argument"
                ),
                (e.easing[this.easing] = j)),
                v.apply(this, arguments);
        }),
            (e.fx.interval = e.fx.interval || 13),
            t.requestAnimationFrame &&
                n(
                    e.fx,
                    "interval",
                    e.fx.interval,
                    "jQuery.fx.interval is deprecated"
                );
        var Q = e.fn.load,
            b = e.event.add,
            w = e.event.fix;
        (e.event.props = []),
            (e.event.fixHooks = {}),
            n(
                e.event.props,
                "concat",
                e.event.props.concat,
                "jQuery.event.props.concat() is deprecated and removed"
            ),
            (e.event.fix = function (t) {
                var n,
                    o = t.type,
                    a = this.fixHooks[o],
                    i = e.event.props;
                if (i.length)
                    for (
                        r(
                            "jQuery.event.props are deprecated and removed: " +
                                i.join()
                        );
                        i.length;

                    )
                        e.event.addProp(i.pop());
                if (
                    a &&
                    !a._migrated_ &&
                    ((a._migrated_ = !0),
                    r("jQuery.event.fixHooks are deprecated and removed: " + o),
                    (i = a.props) && i.length)
                )
                    for (; i.length; ) e.event.addProp(i.pop());
                return (
                    (n = w.call(this, t)), a && a.filter ? a.filter(n, t) : n
                );
            }),
            (e.event.add = function (e, n) {
                return (
                    e === t &&
                        "load" === n &&
                        "complete" === t.document.readyState &&
                        r(
                            "jQuery(window).on('load'...) called after load event occurred"
                        ),
                    b.apply(this, arguments)
                );
            }),
            e.each(["load", "unload", "error"], function (t, n) {
                e.fn[n] = function () {
                    var e = Array.prototype.slice.call(arguments, 0);
                    return "load" === n && "string" == typeof e[0]
                        ? Q.apply(this, e)
                        : (r("jQuery.fn." + n + "() is deprecated"),
                          e.splice(0, 0, n),
                          arguments.length
                              ? this.on.apply(this, e)
                              : (this.triggerHandler.apply(this, e), this));
                };
            }),
            e.each(
                "blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(
                    " "
                ),
                function (t, n) {
                    e.fn[n] = function (e, t) {
                        return (
                            r(
                                "jQuery.fn." +
                                    n +
                                    "() event shorthand is deprecated"
                            ),
                            arguments.length > 0
                                ? this.on(n, null, e, t)
                                : this.trigger(n)
                        );
                    };
                }
            ),
            e(function () {
                e(t.document).triggerHandler("ready");
            }),
            (e.event.special.ready = {
                setup: function () {
                    this === t.document && r("'ready' event is deprecated");
                },
            }),
            e.fn.extend({
                bind: function (e, t, n) {
                    return (
                        r("jQuery.fn.bind() is deprecated"),
                        this.on(e, null, t, n)
                    );
                },
                unbind: function (e, t) {
                    return (
                        r("jQuery.fn.unbind() is deprecated"),
                        this.off(e, null, t)
                    );
                },
                delegate: function (e, t, n, o) {
                    return (
                        r("jQuery.fn.delegate() is deprecated"),
                        this.on(t, e, n, o)
                    );
                },
                undelegate: function (e, t, n) {
                    return (
                        r("jQuery.fn.undelegate() is deprecated"),
                        1 === arguments.length
                            ? this.off(e, "**")
                            : this.off(t, e || "**", n)
                    );
                },
                hover: function (e, t) {
                    return (
                        r("jQuery.fn.hover() is deprecated"),
                        this.on("mouseenter", e).on("mouseleave", t || e)
                    );
                },
            });
        var x = e.fn.offset;
        e.fn.offset = function () {
            var n,
                o = this[0],
                a = { top: 0, left: 0 };
            return o && o.nodeType
                ? ((n = (o.ownerDocument || t.document).documentElement),
                  e.contains(n, o)
                      ? x.apply(this, arguments)
                      : (r(
                            "jQuery.fn.offset() requires an element connected to a document"
                        ),
                        a))
                : (r("jQuery.fn.offset() requires a valid DOM element"), a);
        };
        var k = e.param;
        e.param = function (t, n) {
            var o = e.ajaxSettings && e.ajaxSettings.traditional;
            return (
                void 0 === n &&
                    o &&
                    (r(
                        "jQuery.param() no longer uses jQuery.ajaxSettings.traditional"
                    ),
                    (n = o)),
                k.call(this, t, n)
            );
        };
        var A = e.fn.andSelf || e.fn.addBack;
        e.fn.andSelf = function () {
            return (
                r(
                    "jQuery.fn.andSelf() is deprecated and removed, use jQuery.fn.addBack()"
                ),
                A.apply(this, arguments)
            );
        };
        var S = e.Deferred,
            q = [
                [
                    "resolve",
                    "done",
                    e.Callbacks("once memory"),
                    e.Callbacks("once memory"),
                    "resolved",
                ],
                [
                    "reject",
                    "fail",
                    e.Callbacks("once memory"),
                    e.Callbacks("once memory"),
                    "rejected",
                ],
                [
                    "notify",
                    "progress",
                    e.Callbacks("memory"),
                    e.Callbacks("memory"),
                ],
            ];
        return (
            (e.Deferred = function (t) {
                var n = S(),
                    o = n.promise();
                return (
                    (n.pipe = o.pipe =
                        function () {
                            var t = arguments;
                            return (
                                r("deferred.pipe() is deprecated"),
                                e
                                    .Deferred(function (r) {
                                        e.each(q, function (a, i) {
                                            var s = e.isFunction(t[a]) && t[a];
                                            n[i[1]](function () {
                                                var t =
                                                    s &&
                                                    s.apply(this, arguments);
                                                t && e.isFunction(t.promise)
                                                    ? t
                                                          .promise()
                                                          .done(r.resolve)
                                                          .fail(r.reject)
                                                          .progress(r.notify)
                                                    : r[i[0] + "With"](
                                                          this === o
                                                              ? r.promise()
                                                              : this,
                                                          s ? [t] : arguments
                                                      );
                                            });
                                        }),
                                            (t = null);
                                    })
                                    .promise()
                            );
                        }),
                    t && t.call(n, n),
                    n
                );
            }),
            (e.Deferred.exceptionHook = S.exceptionHook),
            e
        );
    });

;(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    define(['jquery'], factory);
  } else if (typeof exports === 'object') {
    module.exports = factory(require('jquery'));
  } else {
    root.jquery_mmenu_js = factory(root.jQuery);
  }
}(this, function(jQuery) {
/*!
 * jQuery mmenu v7.3.2
 * @requires jQuery 1.7.0 or later
 *
 * mmenujs.com
 *
 * Copyright (c) Fred Heusschen
 * www.frebsite.nl
 *
 * License: CC-BY-NC-4.0
 * http://creativecommons.org/licenses/by-nc/4.0/
 */
!function(t){var e,n,i,s,a,r="mmenu";t[r]&&t[r].version>"7.3.2"||(t[r]=function(t,e,n){return this.$menu=t,this._api=["bind","getInstance","initPanels","openPanel","closePanel","closeAllPanels","setSelected"],this.opts=e,this.conf=n,this.vars={},this.cbck={},this.mtch={},"function"==typeof this.___deprecated&&this.___deprecated(),this._initWrappers(),this._initAddons(),this._initExtensions(),this._initHooks(),this._initMenu(),this._initPanels(),this._initOpened(),this._initAnchors(),this._initMatchMedia(),"function"==typeof this.___debug&&this.___debug(),this},t[r].version="7.3.2",t[r].uniqueId=0,t[r].wrappers={},t[r].addons={},t[r].defaults={hooks:{},extensions:[],wrappers:[],navbar:{add:!0,title:"Menu",titleLink:"parent"},onClick:{setSelected:!0},slidingSubmenus:!0},t[r].configuration={classNames:{divider:"Divider",inset:"Inset",nolistview:"NoListview",nopanel:"NoPanel",panel:"Panel",selected:"Selected",spacer:"Spacer",vertical:"Vertical"},clone:!1,language:null,openingInterval:25,panelNodetype:"ul, ol, div",transitionDuration:400},t[r].prototype={getInstance:function(){return this},initPanels:function(t){this._initPanels(t)},openPanel:function(e,s){if(this.trigger("openPanel:before",e),e&&e.length&&(e.is("."+n.panel)||(e=e.closest("."+n.panel)),e.is("."+n.panel))){var a=this;if("boolean"!=typeof s&&(s=!0),e.parent("."+n.listitem+"_vertical").length)e.parents("."+n.listitem+"_vertical").addClass(n.listitem+"_opened").children("."+n.panel).removeClass(n.hidden),this.openPanel(e.parents("."+n.panel).not(function(){return t(this).parent("."+n.listitem+"_vertical").length}).first()),this.trigger("openPanel:start",e),this.trigger("openPanel:finish",e);else{if(e.hasClass(n.panel+"_opened"))return;var l=this.$pnls.children("."+n.panel),o=this.$pnls.children("."+n.panel+"_opened");if(!t[r].support.csstransitions)return o.addClass(n.hidden).removeClass(n.panel+"_opened"),e.removeClass(n.hidden).addClass(n.panel+"_opened"),this.trigger("openPanel:start",e),void this.trigger("openPanel:finish",e);l.not(e).removeClass(n.panel+"_opened-parent");for(var d=e.data(i.parent);d;)(d=d.closest("."+n.panel)).parent("."+n.listitem+"_vertical").length||d.addClass(n.panel+"_opened-parent"),d=d.data(i.parent);l.removeClass(n.panel+"_highest").not(o).not(e).addClass(n.hidden),e.removeClass(n.hidden);var c=function(){o.removeClass(n.panel+"_opened"),e.addClass(n.panel+"_opened"),e.hasClass(n.panel+"_opened-parent")?(o.addClass(n.panel+"_highest"),e.removeClass(n.panel+"_opened-parent")):(o.addClass(n.panel+"_opened-parent"),e.addClass(n.panel+"_highest")),a.trigger("openPanel:start",e)},h=function(){o.removeClass(n.panel+"_highest").addClass(n.hidden),e.removeClass(n.panel+"_highest"),a.trigger("openPanel:finish",e)};s&&!e.hasClass(n.panel+"_noanimation")?setTimeout(function(){a.__transitionend(e,function(){h()},a.conf.transitionDuration),c()},a.conf.openingInterval):(c(),h())}this.trigger("openPanel:after",e)}},closePanel:function(t){this.trigger("closePanel:before",t);var e=t.parent();e.hasClass(n.listitem+"_vertical")&&(e.removeClass(n.listitem+"_opened"),t.addClass(n.hidden),this.trigger("closePanel",t)),this.trigger("closePanel:after",t)},closeAllPanels:function(t){this.trigger("closeAllPanels:before"),this.$pnls.find("."+n.listview).children().removeClass(n.listitem+"_selected").filter("."+n.listitem+"_vertical").removeClass(n.listitem+"_opened");var e=this.$pnls.children("."+n.panel),i=t&&t.length?t:e.first();this.$pnls.children("."+n.panel).not(i).removeClass(n.panel+"_opened").removeClass(n.panel+"_opened-parent").removeClass(n.panel+"_highest").addClass(n.hidden),this.openPanel(i,!1),this.trigger("closeAllPanels:after")},togglePanel:function(t){var e=t.parent();e.hasClass(n.listitem+"_vertical")&&this[e.hasClass(n.listitem+"_opened")?"closePanel":"openPanel"](t)},setSelected:function(t){this.trigger("setSelected:before",t),this.$menu.find("."+n.listitem+"_selected").removeClass(n.listitem+"_selected"),t.addClass(n.listitem+"_selected"),this.trigger("setSelected:after",t)},bind:function(t,e){this.cbck[t]=this.cbck[t]||[],this.cbck[t].push(e)},trigger:function(){var t=Array.prototype.slice.call(arguments),e=t.shift();if(this.cbck[e])for(var n=0,i=this.cbck[e].length;n<i;n++)this.cbck[e][n].apply(this,t)},matchMedia:function(t,e,n){var i={yes:e,no:n};this.mtch[t]=this.mtch[t]||[],this.mtch[t].push(i)},i18n:function(e){return t[r].i18n(e,this.conf.language)},_initHooks:function(){for(var t in this.opts.hooks)this.bind(t,this.opts.hooks[t])},_initWrappers:function(){this.trigger("initWrappers:before");for(var e=0;e<this.opts.wrappers.length;e++){var n=t[r].wrappers[this.opts.wrappers[e]];"function"==typeof n&&n.call(this)}this.trigger("initWrappers:after")},_initAddons:function(){var e;for(e in this.trigger("initAddons:before"),t[r].addons)t[r].addons[e].add.call(this),t[r].addons[e].add=function(){};for(e in t[r].addons)t[r].addons[e].setup.call(this);this.trigger("initAddons:after")},_initExtensions:function(){this.trigger("initExtensions:before");var t=this;for(var e in this.opts.extensions.constructor===Array&&(this.opts.extensions={all:this.opts.extensions}),this.opts.extensions)this.opts.extensions[e]=this.opts.extensions[e].length?n.menu+"_"+this.opts.extensions[e].join(" "+n.menu+"_"):"",this.opts.extensions[e]&&function(e){t.matchMedia(e,function(){this.$menu.addClass(this.opts.extensions[e])},function(){this.$menu.removeClass(this.opts.extensions[e])})}(e);this.trigger("initExtensions:after")},_initMenu:function(){this.trigger("initMenu:before");this.conf.clone&&(this.$orig=this.$menu,this.$menu=this.$orig.clone(),this.$menu.add(this.$menu.find("[id]")).filter("[id]").each(function(){t(this).attr("id",n.mm(t(this).attr("id")))})),this.$menu.attr("id",this.$menu.attr("id")||this.__getUniqueId()),this.$pnls=t('<div class="'+n.panels+'" />').append(this.$menu.children(this.conf.panelNodetype)).prependTo(this.$menu),this.$menu.addClass(n.menu).parent().addClass(n.wrapper),this.trigger("initMenu:after")},_initPanels:function(e){this.trigger("initPanels:before",e),e=e||this.$pnls.children(this.conf.panelNodetype);var i=t(),s=this,a=function(e){e.filter(s.conf.panelNodetype).each(function(e){var r=s._initPanel(t(this));if(r){s._initNavbar(r),s._initListview(r),i=i.add(r);var l=r.children("."+n.listview).children("li").children(s.conf.panelNodetype).add(r.children("."+s.conf.classNames.panel));l.length&&a(l)}})};a(e),this.trigger("initPanels:after",i)},_initPanel:function(t){this.trigger("initPanel:before",t);if(t.hasClass(n.panel))return t;if(this.__refactorClass(t,this.conf.classNames.panel,n.panel),this.__refactorClass(t,this.conf.classNames.nopanel,n.nopanel),this.__refactorClass(t,this.conf.classNames.inset,n.listview+"_inset"),t.filter("."+n.listview+"_inset").addClass(n.nopanel),t.hasClass(n.nopanel))return!1;var e=t.hasClass(this.conf.classNames.vertical)||!this.opts.slidingSubmenus;t.removeClass(this.conf.classNames.vertical);var s=t.attr("id")||this.__getUniqueId();t.is("ul, ol")&&(t.removeAttr("id"),t.wrap("<div />"),t=t.parent()),t.attr("id",s),t.addClass(n.panel+" "+n.hidden);var a=t.parent("li");return e?a.addClass(n.listitem+"_vertical"):t.appendTo(this.$pnls),a.length&&(a.data(i.child,t),t.data(i.parent,a)),this.trigger("initPanel:after",t),t},_initNavbar:function(e){if(this.trigger("initNavbar:before",e),!e.children("."+n.navbar).length){var s=e.data(i.parent),a=t('<div class="'+n.navbar+'" />'),r=this.__getPanelTitle(e,this.opts.navbar.title),l="";if(s&&s.length){if(s.hasClass(n.listitem+"_vertical"))return;if(s.parent().is("."+n.listview))var o=s.children("a, span").not("."+n.btn+"_next");else o=s.closest("."+n.panel).find('a[href="#'+e.attr("id")+'"]');var d=(s=(o=o.first()).closest("."+n.panel)).attr("id");switch(r=this.__getPanelTitle(e,t("<span>"+o.text()+"</span>").text()),this.opts.navbar.titleLink){case"anchor":l=o.attr("href")||"";break;case"parent":l="#"+d}a.append('<a class="'+n.btn+" "+n.btn+"_prev "+n.navbar+'__btn" href="#'+d+'" />')}else if(!this.opts.navbar.title)return;this.opts.navbar.add&&e.addClass(n.panel+"_has-navbar"),a.append('<a class="'+n.navbar+'__title"'+(l.length?' href="'+l+'"':"")+">"+r+"</a>").prependTo(e),this.trigger("initNavbar:after",e)}},_initListview:function(e){this.trigger("initListview:before",e);var s=this.__childAddBack(e,"ul, ol");this.__refactorClass(s,this.conf.classNames.nolistview,n.nolistview);var a=s.not("."+n.nolistview).addClass(n.listview).children().addClass(n.listitem);this.__refactorClass(a,this.conf.classNames.selected,n.listitem+"_selected"),this.__refactorClass(a,this.conf.classNames.divider,n.listitem+"_divider"),this.__refactorClass(a,this.conf.classNames.spacer,n.listitem+"_spacer"),a.children("a, span").not("."+n.btn).addClass(n.listitem+"__text");var r=e.data(i.parent);if(r&&r.is("."+n.listitem)&&!r.children("."+n.btn).length){var l=r.children("a, span").first(),o=t('<a class="'+n.btn+" "+n.btn+"_next "+n.listitem+'__btn" href="#'+e.attr("id")+'" />');o.insertAfter(l),l.is("span")&&(o.addClass(n.listitem+"__text").html(l.html()),l.remove())}this.trigger("initListview:after",e)},_initOpened:function(){this.trigger("initOpened:before");var t=this.$pnls.find("."+n.listitem+"_selected").removeClass(n.listitem+"_selected").last().addClass(n.listitem+"_selected"),e=t.length?t.closest("."+n.panel):this.$pnls.children("."+n.panel).first();this.openPanel(e,!1),this.trigger("initOpened:after")},_initAnchors:function(){this.trigger("initAnchors:before");var e=this;a.$body.on(s.click+"-oncanvas","a[href]",function(i){var s=t(this),a=s.attr("href"),l=e.$menu.find(s).length,o=s.is("."+n.listitem+" > a"),d=s.is('[rel="external"]')||s.is('[target="_blank"]');if(l&&a.length>1&&"#"==a.slice(0,1))try{var c=e.$menu.find(a);if(c.is("."+n.panel))return e[s.parent().hasClass(n.listitem+"_vertical")?"togglePanel":"openPanel"](c),void i.preventDefault()}catch(t){}var h={close:null,setSelected:null,preventDefault:"#"==a.slice(0,1)};for(var p in t[r].addons){var f=t[r].addons[p].clickAnchor.call(e,s,l,o,d);if(f){if("boolean"==typeof f)return void i.preventDefault();"object"==typeof f&&(h=t.extend({},h,f))}}l&&o&&!d&&(e.__valueOrFn(s,e.opts.onClick.setSelected,h.setSelected)&&e.setSelected(t(i.target).parent()),e.__valueOrFn(s,e.opts.onClick.preventDefault,h.preventDefault)&&i.preventDefault(),e.__valueOrFn(s,e.opts.onClick.close,h.close)&&e.opts.offCanvas&&"function"==typeof e.close&&e.close())}),this.trigger("initAnchors:after")},_initMatchMedia:function(){var t=this;for(var e in this.mtch)!function(){var n=e,i=window.matchMedia(n);t._fireMatchMedia(n,i),i.addListener(function(e){t._fireMatchMedia(n,e)})}()},_fireMatchMedia:function(t,e){for(var n=e.matches?"yes":"no",i=0;i<this.mtch[t].length;i++)this.mtch[t][i][n].call(this)},_getOriginalMenuId:function(){var t=this.$menu.attr("id");return this.conf.clone&&t&&t.length&&(t=n.umm(t)),t},__api:function(){var e=this,n={};return t.each(this._api,function(t){var i=this;n[i]=function(){var t=e[i].apply(e,arguments);return void 0===t?n:t}}),n},__valueOrFn:function(t,e,n){if("function"==typeof e){var i=e.call(t[0]);if(void 0!==i)return i}return"function"!=typeof e&&void 0!==e||void 0===n?e:n},__getPanelTitle:function(e,n){var s;return"function"==typeof this.opts.navbar.title&&(s=this.opts.navbar.title.call(e[0])),void 0===s&&(s=e.data(i.title)),void 0!==s?s:"string"==typeof n?this.i18n(n):this.i18n(t[r].defaults.navbar.title)},__refactorClass:function(t,e,n){return t.filter("."+e).removeClass(e).addClass(n)},__findAddBack:function(t,e){return t.find(e).add(t.filter(e))},__childAddBack:function(t,e){return t.children(e).add(t.filter(e))},__filterListItems:function(t){return t.not("."+n.listitem+"_divider").not("."+n.hidden)},__filterListItemAnchors:function(t){return this.__filterListItems(t).children("a").not("."+n.btn+"_next")},__openPanelWoAnimation:function(t){t.hasClass(n.panel+"_noanimation")||(t.addClass(n.panel+"_noanimation"),this.__transitionend(t,function(){t.removeClass(n.panel+"_noanimation")},this.conf.openingInterval),this.openPanel(t))},__transitionend:function(t,e,n){var i=!1,a=function(n){void 0!==n&&n.target!=t[0]||(i||(t.off(s.transitionend),t.off(s.webkitTransitionEnd),e.call(t[0])),i=!0)};t.on(s.transitionend,a),t.on(s.webkitTransitionEnd,a),setTimeout(a,1.1*n)},__getUniqueId:function(){return n.mm(t[r].uniqueId++)}},t.fn[r]=function(e,l){!function(){if(t[r].glbl)return;a={$wndw:t(window),$docu:t(document),$html:t("html"),$body:t("body")},n={},i={},s={},t.each([n,i,s],function(t,e){e.add=function(t){t=t.split(" ");for(var n=0,i=t.length;n<i;n++)e[t[n]]=e.mm(t[n])}}),n.mm=function(t){return"mm-"+t},n.add("wrapper menu panels panel nopanel navbar listview nolistview listitem btn hidden"),n.umm=function(t){return"mm-"==t.slice(0,3)&&(t=t.slice(3)),t},i.mm=function(t){return"mm-"+t},i.add("parent child title"),s.mm=function(t){return t+".mm"},s.add("transitionend webkitTransitionEnd click scroll resize keydown mousedown mouseup touchstart touchmove touchend orientationchange"),t[r]._c=n,t[r]._d=i,t[r]._e=s,t[r].glbl=a}();var o=t();return this.each(function(){var n=t(this);if(!n.data(r)){var i=jQuery.extend(!0,{},t[r].defaults,e),s=jQuery.extend(!0,{},t[r].configuration,l),a=new t[r](n,i,s);a.$menu.data(r,a.__api()),o=o.add(a.$menu)}}),o},t[r].i18n=(e={},function(n,i){switch(typeof n){case"object":return"string"==typeof i&&(void 0===e[i]&&(e[i]={}),t.extend(e[i],n)),e;case"string":return"string"==typeof i&&void 0!==e[i]&&e[i][n]||n;case"undefined":default:return e}}),t[r].support={touch:"ontouchstart"in window||navigator.msMaxTouchPoints||!1,csstransitions:"undefined"==typeof Modernizr||void 0===Modernizr.csstransitions||Modernizr.csstransitions})}(jQuery);
!function(e){var t,n,i,o,r="offCanvas";e.mmenu.addons[r]={setup:function(){if(this.opts[r]){var n=this.opts[r],i=this.conf[r];o=e.mmenu.glbl,this._api=e.merge(this._api,["open","close","setPage"]),"object"!=typeof n&&(n={}),n=this.opts[r]=e.extend(!0,{},e.mmenu.defaults[r],n),"string"!=typeof i.page.selector&&(i.page.selector="> "+i.page.nodetype),this.vars.opened=!1;var s=[t.menu+"_offcanvas"];this.bind("initMenu:after",function(){var e=this;this._initBlocker(),this.setPage(o.$page),this._initWindow_offCanvas(),this.$menu.addClass(s.join(" ")).parent("."+t.wrapper).removeClass(t.wrapper),this.$menu[i.menu.insertMethod](i.menu.insertSelector);var n=window.location.hash;if(n){var r=this._getOriginalMenuId();r&&r==n.slice(1)&&setTimeout(function(){e.open()},1e3)}}),this.bind("setPage:after",function(e){o.$blck&&o.$blck.children("a").attr("href","#"+e.attr("id"))}),this.bind("open:start:sr-aria",function(){this.__sr_aria(this.$menu,"hidden",!1)}),this.bind("close:finish:sr-aria",function(){this.__sr_aria(this.$menu,"hidden",!0)}),this.bind("initMenu:after:sr-aria",function(){this.__sr_aria(this.$menu,"hidden",!0)}),this.bind("initBlocker:after:sr-text",function(){o.$blck.children("a").html(this.__sr_text(this.i18n(this.conf.screenReader.text.closeMenu)))})}},add:function(){t=e.mmenu._c,n=e.mmenu._d,i=e.mmenu._e,t.add("slideout page no-csstransforms3d"),n.add("style")},clickAnchor:function(e,n){var i=this;if(this.opts[r]){var s=this._getOriginalMenuId();if(s&&e.is('[href="#'+s+'"]')){if(n)return this.open(),!0;var a=e.closest("."+t.menu);if(a.length){var p=a.data("mmenu");if(p&&p.close)return p.close(),i.__transitionend(a,function(){i.open()},i.conf.transitionDuration),!0}return this.open(),!0}if(o.$page)return(s=o.$page.first().attr("id"))&&e.is('[href="#'+s+'"]')?(this.close(),!0):void 0}}},e.mmenu.defaults[r]={blockUI:!0,moveBackground:!0},e.mmenu.configuration[r]={menu:{insertMethod:"prependTo",insertSelector:"body"},page:{nodetype:"div",selector:null,noSelector:[],wrapIfNeeded:!0}},e.mmenu.prototype.open=function(){if(this.trigger("open:before"),!this.vars.opened){var e=this;this._openSetup(),setTimeout(function(){e._openFinish()},this.conf.openingInterval),this.trigger("open:after")}},e.mmenu.prototype._openSetup=function(){var s=this,a=this.opts[r];this.closeAllOthers(),o.$page.each(function(){e(this).data(n.style,e(this).attr("style")||"")}),o.$wndw.trigger(i.resize+"-"+r,[!0]);var p=[t.wrapper+"_opened"];a.blockUI&&p.push(t.wrapper+"_blocking"),"modal"==a.blockUI&&p.push(t.wrapper+"_modal"),a.moveBackground&&p.push(t.wrapper+"_background"),o.$html.addClass(p.join(" ")),setTimeout(function(){s.vars.opened=!0},this.conf.openingInterval),this.$menu.addClass(t.menu+"_opened")},e.mmenu.prototype._openFinish=function(){var e=this;this.__transitionend(o.$page.first(),function(){e.trigger("open:finish")},this.conf.transitionDuration),this.trigger("open:start"),o.$html.addClass(t.wrapper+"_opening")},e.mmenu.prototype.close=function(){if(this.trigger("close:before"),this.vars.opened){var i=this;this.__transitionend(o.$page.first(),function(){i.$menu.removeClass(t.menu+"_opened");var r=[t.wrapper+"_opened",t.wrapper+"_blocking",t.wrapper+"_modal",t.wrapper+"_background"];o.$html.removeClass(r.join(" ")),o.$page.each(function(){var t=e(this).data(n.style);e(this).attr("style",t)}),i.vars.opened=!1,i.trigger("close:finish")},this.conf.transitionDuration),this.trigger("close:start"),o.$html.removeClass(t.wrapper+"_opening"),this.trigger("close:after")}},e.mmenu.prototype.closeAllOthers=function(){o.$body.find("."+t.menu+"_offcanvas").not(this.$menu).each(function(){var t=e(this).data("mmenu");t&&t.close&&t.close()})},e.mmenu.prototype.setPage=function(n){this.trigger("setPage:before",n);var i=this,s=this.conf[r];n&&n.length||(n=o.$body.find(s.page.selector).not("."+t.menu).not("."+t.wrapper+"__blocker"),s.page.noSelector.length&&(n=n.not(s.page.noSelector.join(", "))),n.length>1&&s.page.wrapIfNeeded&&(n=n.wrapAll("<"+this.conf[r].page.nodetype+" />").parent())),n.addClass(t.page+" "+t.slideout).each(function(){e(this).attr("id",e(this).attr("id")||i.__getUniqueId())}),o.$page=n,this.trigger("setPage:after",n)},e.mmenu.prototype._initWindow_offCanvas=function(){o.$wndw.off(i.keydown+"-"+r).on(i.keydown+"-"+r,function(e){if(o.$html.hasClass(t.wrapper+"_opened")&&9==e.keyCode)return e.preventDefault(),!1});var e=0;o.$wndw.off(i.resize+"-"+r).on(i.resize+"-"+r,function(n,i){if(1==o.$page.length&&(i||o.$html.hasClass(t.wrapper+"_opened"))){var r=o.$wndw.height();(i||r!=e)&&(e=r,o.$page.css("minHeight",r))}})},e.mmenu.prototype._initBlocker=function(){var n=this,s=this.opts[r],a=this.conf[r];this.trigger("initBlocker:before"),s.blockUI&&(o.$blck||(o.$blck=e('<div class="'+t.wrapper+"__blocker "+t.slideout+'" />').append("<a />")),o.$blck.appendTo(a.menu.insertSelector).off(i.touchstart+"-"+r+" "+i.touchmove+"-"+r).on(i.touchstart+"-"+r+" "+i.touchmove+"-"+r,function(e){e.preventDefault(),e.stopPropagation(),o.$blck.trigger(i.mousedown+"-"+r)}).off(i.mousedown+"-"+r).on(i.mousedown+"-"+r,function(e){e.preventDefault(),o.$html.hasClass(t.wrapper+"_modal")||(n.closeAllOthers(),n.close())}),this.trigger("initBlocker:after"))}}(jQuery);
!function(t){var i,n,e="screenReader";t.mmenu.addons[e]={setup:function(){var r=this,a=this.opts[e],s=this.conf[e];t.mmenu.glbl,"boolean"==typeof a&&(a={aria:a,text:a}),"object"!=typeof a&&(a={}),(a=this.opts[e]=t.extend(!0,{},t.mmenu.defaults[e],a)).aria&&(this.bind("initAddons:after",function(){this.bind("initMenu:after",function(){this.trigger("initMenu:after:sr-aria")}),this.bind("initNavbar:after",function(){this.trigger("initNavbar:after:sr-aria",arguments[0])}),this.bind("openPanel:start",function(){this.trigger("openPanel:start:sr-aria",arguments[0])}),this.bind("close:start",function(){this.trigger("close:start:sr-aria")}),this.bind("close:finish",function(){this.trigger("close:finish:sr-aria")}),this.bind("open:start",function(){this.trigger("open:start:sr-aria")}),this.bind("initOpened:after",function(){this.trigger("initOpened:after:sr-aria")})}),this.bind("updateListview",function(){this.$pnls.find("."+i.listview).children().each(function(){r.__sr_aria(t(this),"hidden",t(this).is("."+i.hidden))})}),this.bind("openPanel:start",function(t){var n=this.$menu.find("."+i.panel).not(t).not(t.parents("."+i.panel)),e=t.add(t.find("."+i.listitem+"_vertical ."+i.listitem+"_opened").children("."+i.panel));this.__sr_aria(n,"hidden",!0),this.__sr_aria(e,"hidden",!1)}),this.bind("closePanel",function(t){this.__sr_aria(t,"hidden",!0)}),this.bind("initPanels:after",function(n){var e=n.find("."+i.btn).each(function(){r.__sr_aria(t(this),"owns",t(this).attr("href").replace("#",""))});this.__sr_aria(e,"haspopup",!0)}),this.bind("initNavbar:after",function(t){var n=t.children("."+i.navbar);this.__sr_aria(n,"hidden",!t.hasClass(i.panel+"_has-navbar"))}),a.text&&"parent"==this.opts.navbar.titleLink&&this.bind("initNavbar:after",function(t){var n=t.children("."+i.navbar),e=!!n.children("."+i.btn+"_prev").length;this.__sr_aria(n.children("."+i.title),"hidden",e)})),a.text&&(this.bind("initAddons:after",function(){this.bind("setPage:after",function(){this.trigger("setPage:after:sr-text",arguments[0])}),this.bind("initBlocker:after",function(){this.trigger("initBlocker:after:sr-text")})}),this.bind("initNavbar:after",function(t){var n=t.children("."+i.navbar),e=this.i18n(s.text.closeSubmenu);n.children("."+i.btn+"_prev").html(this.__sr_text(e))}),this.bind("initListview:after",function(t){var e=t.data(n.parent);if(e&&e.length){var a=e.children("."+i.btn+"_next"),o=this.i18n(s.text[a.parent().is("."+i.listitem+"_vertical")?"toggleSubmenu":"openSubmenu"]);a.append(r.__sr_text(o))}}))},add:function(){i=t.mmenu._c,n=t.mmenu._d,t.mmenu._e,i.add("sronly")},clickAnchor:function(t,i){}},t.mmenu.defaults[e]={aria:!0,text:!0},t.mmenu.configuration[e]={text:{closeMenu:"Close menu",closeSubmenu:"Close submenu",openSubmenu:"Open submenu",toggleSubmenu:"Toggle submenu"}},t.mmenu.prototype.__sr_aria=function(t,i,n){t.prop("aria-"+i,n)[n?"attr":"removeAttr"]("aria-"+i,n)},t.mmenu.prototype.__sr_role=function(t,i){t.prop("role",i)[i?"attr":"removeAttr"]("role",i)},t.mmenu.prototype.__sr_text=function(t){return'<span class="'+i.sronly+'">'+t+"</span>"}}(jQuery);
!function(o){var t,n,e,r="scrollBugFix";o.mmenu.addons[r]={setup:function(){var n=this.opts[r];this.conf[r];e=o.mmenu.glbl,o.mmenu.support.touch&&this.opts.offCanvas&&this.opts.offCanvas.blockUI&&("boolean"==typeof n&&(n={fix:n}),"object"!=typeof n&&(n={}),(n=this.opts[r]=o.extend(!0,{},o.mmenu.defaults[r],n)).fix&&(this.bind("open:start",function(){this.$pnls.children("."+t.panel+"_opened").scrollTop(0)}),this.bind("initMenu:after",function(){this["_initWindow_"+r]()})))},add:function(){t=o.mmenu._c,o.mmenu._d,n=o.mmenu._e},clickAnchor:function(o,t){}},o.mmenu.defaults[r]={fix:!0},o.mmenu.prototype["_initWindow_"+r]=function(){var s=this;o(document).off(n.touchmove+"-"+r).on(n.touchmove+"-"+r,function(o){e.$html.hasClass(t.wrapper+"_opened")&&o.preventDefault()});var i=!1;e.$body.off(n.touchstart+"-"+r).on(n.touchstart+"-"+r,"."+t.panels+"> ."+t.panel,function(o){e.$html.hasClass(t.wrapper+"_opened")&&(i||(i=!0,0===o.currentTarget.scrollTop?o.currentTarget.scrollTop=1:o.currentTarget.scrollHeight===o.currentTarget.scrollTop+o.currentTarget.offsetHeight&&(o.currentTarget.scrollTop-=1),i=!1))}).off(n.touchmove+"-"+r).on(n.touchmove+"-"+r,"."+t.panels+"> ."+t.panel,function(n){e.$html.hasClass(t.wrapper+"_opened")&&o(this)[0].scrollHeight>o(this).innerHeight()&&n.stopPropagation()}),e.$wndw.off(n.orientationchange+"-"+r).on(n.orientationchange+"-"+r,function(){s.$pnls.children("."+t.panel+"_opened").scrollTop(0).css({"-webkit-overflow-scrolling":"auto"}).css({"-webkit-overflow-scrolling":"touch"})})}}(jQuery);
return jQuery.mmenu;
}));

// scrollToFixed
(function(a){a.isScrollToFixed=function(b){return !!a(b).data("ScrollToFixed")};a.ScrollToFixed=function(d,i){var m=this;m.$el=a(d);m.el=d;m.$el.data("ScrollToFixed",m);var c=false;var H=m.$el;var I;var F;var k;var e;var z;var E=0;var r=0;var j=-1;var f=-1;var u=null;var A;var g;function v(){H.trigger("preUnfixed.ScrollToFixed");l();H.trigger("unfixed.ScrollToFixed");f=-1;E=H.offset().top;r=H.offset().left;if(m.options.offsets){r+=(H.offset().left-H.position().left)}if(j==-1){j=r}I=H.css("position");c=true;if(m.options.bottom!=-1){H.trigger("preFixed.ScrollToFixed");x();H.trigger("fixed.ScrollToFixed")}}function o(){var J=m.options.limit;if(!J){return 0}if(typeof(J)==="function"){return J.apply(H)}return J}function q(){return I==="fixed"}function y(){return I==="absolute"}function h(){return !(q()||y())}function x(){if(!q()){var J=H[0].getBoundingClientRect();u.css({display:H.css("display"),width:J.width,height:J.height,"float":H.css("float")});cssOptions={"z-index":m.options.zIndex,position:"fixed",top:m.options.bottom==-1?t():"",bottom:m.options.bottom==-1?"":m.options.bottom,"margin-left":"0px"};if(!m.options.dontSetWidth){cssOptions.width=H.css("width")}H.css(cssOptions);H.addClass(m.options.baseClassName);if(m.options.className){H.addClass(m.options.className)}I="fixed"}}function b(){var K=o();var J=r;if(m.options.removeOffsets){J="";K=K-E}cssOptions={position:"absolute",top:K,left:J,"margin-left":"0px",bottom:""};if(!m.options.dontSetWidth){cssOptions.width=H.css("width")}H.css(cssOptions);I="absolute"}function l(){if(!h()){f=-1;u.css("display","none");H.css({"z-index":z,width:"",position:F,left:"",top:e,"margin-left":""});H.removeClass("scroll-to-fixed-fixed");if(m.options.className){H.removeClass(m.options.className)}I=null}}function w(J){if(J!=f){H.css("left",r-J);f=J}}function t(){var J=m.options.marginTop;if(!J){return 0}if(typeof(J)==="function"){return J.apply(H)}return J}function B(){if(!a.isScrollToFixed(H)||H.is(":hidden")){return}var M=c;var L=h();if(!c){v()}else{if(h()){E=H.offset().top;r=H.offset().left}}var J=a(window).scrollLeft();var N=a(window).scrollTop();var K=o();if(m.options.minWidth&&a(window).width()<m.options.minWidth){if(!h()||!M){p();H.trigger("preUnfixed.ScrollToFixed");l();H.trigger("unfixed.ScrollToFixed")}}else{if(m.options.maxWidth&&a(window).width()>m.options.maxWidth){if(!h()||!M){p();H.trigger("preUnfixed.ScrollToFixed");l();H.trigger("unfixed.ScrollToFixed")}}else{if(m.options.bottom==-1){if(K>0&&N>=K-t()){if(!L&&(!y()||!M)){p();H.trigger("preAbsolute.ScrollToFixed");b();H.trigger("unfixed.ScrollToFixed")}}else{if(N>=E-t()){if(!q()||!M){p();H.trigger("preFixed.ScrollToFixed");x();f=-1;H.trigger("fixed.ScrollToFixed")}w(J)}else{if(!h()||!M){p();H.trigger("preUnfixed.ScrollToFixed");l();H.trigger("unfixed.ScrollToFixed")}}}}else{if(K>0){if(N+a(window).height()-H.outerHeight(true)>=K-(t()||-n())){if(q()){p();H.trigger("preUnfixed.ScrollToFixed");if(F==="absolute"){b()}else{l()}H.trigger("unfixed.ScrollToFixed")}}else{if(!q()){p();H.trigger("preFixed.ScrollToFixed");x()}w(J);H.trigger("fixed.ScrollToFixed")}}else{w(J)}}}}}function n(){if(!m.options.bottom){return 0}return m.options.bottom}function p(){var J=H.css("position");if(J=="absolute"){H.trigger("postAbsolute.ScrollToFixed")}else{if(J=="fixed"){H.trigger("postFixed.ScrollToFixed")}else{H.trigger("postUnfixed.ScrollToFixed")}}}var D=function(J){if(H.is(":visible")){c=false;B()}else{l()}};var G=function(J){(!!window.requestAnimationFrame)?requestAnimationFrame(B):B()};var C=function(){var K=document.body;if(document.createElement&&K&&K.appendChild&&K.removeChild){var M=document.createElement("div");if(!M.getBoundingClientRect){return null}M.innerHTML="x";M.style.cssText="position:fixed;top:100px;";K.appendChild(M);var N=K.style.height,O=K.scrollTop;K.style.height="3000px";K.scrollTop=500;var J=M.getBoundingClientRect().top;K.style.height=N;var L=(J===100);K.removeChild(M);K.scrollTop=O;return L}return null};var s=function(J){J=J||window.event;if(J.preventDefault){J.preventDefault()}J.returnValue=false};m.init=function(){m.options=a.extend({},a.ScrollToFixed.defaultOptions,i);z=H.css("z-index");m.$el.css("z-index",m.options.zIndex);u=a("<div />");I=H.css("position");F=H.css("position");k=H.css("float");e=H.css("top");if(h()){m.$el.after(u)}a(window).bind("resize.ScrollToFixed",D);a(window).bind("scroll.ScrollToFixed",G);if("ontouchmove" in window){a(window).bind("touchmove.ScrollToFixed",B)}if(m.options.preFixed){H.bind("preFixed.ScrollToFixed",m.options.preFixed)}if(m.options.postFixed){H.bind("postFixed.ScrollToFixed",m.options.postFixed)}if(m.options.preUnfixed){H.bind("preUnfixed.ScrollToFixed",m.options.preUnfixed)}if(m.options.postUnfixed){H.bind("postUnfixed.ScrollToFixed",m.options.postUnfixed)}if(m.options.preAbsolute){H.bind("preAbsolute.ScrollToFixed",m.options.preAbsolute)}if(m.options.postAbsolute){H.bind("postAbsolute.ScrollToFixed",m.options.postAbsolute)}if(m.options.fixed){H.bind("fixed.ScrollToFixed",m.options.fixed)}if(m.options.unfixed){H.bind("unfixed.ScrollToFixed",m.options.unfixed)}if(m.options.spacerClass){u.addClass(m.options.spacerClass)}H.bind("resize.ScrollToFixed",function(){u.height(H.height())});H.bind("scroll.ScrollToFixed",function(){H.trigger("preUnfixed.ScrollToFixed");l();H.trigger("unfixed.ScrollToFixed");B()});H.bind("detach.ScrollToFixed",function(J){s(J);H.trigger("preUnfixed.ScrollToFixed");l();H.trigger("unfixed.ScrollToFixed");a(window).unbind("resize.ScrollToFixed",D);a(window).unbind("scroll.ScrollToFixed",G);H.unbind(".ScrollToFixed");u.remove();m.$el.removeData("ScrollToFixed")});D()};m.init()};a.ScrollToFixed.defaultOptions={marginTop:0,limit:0,bottom:-1,zIndex:1000,baseClassName:"scroll-to-fixed-fixed"};a.fn.scrollToFixed=function(b){return this.each(function(){(new a.ScrollToFixed(this,b))})}})(jQuery);

//
// SmoothScroll for websites v1.4.6 (Balazs Galambosi)
// http://www.smoothscroll.net/
//
// Licensed under the terms of the MIT license.
//
// You may use it in your theme if you credit me. 
// It is also free to use on any individual website.
//
// Exception:
// The only restriction is to not publish any  
// extension for browsers or native application
// without getting a written permission first.
//

//
// SmoothScroll for websites v1.4.9 (Balazs Galambosi)
// http://www.smoothscroll.net/
//
// Licensed under the terms of the MIT license.
//
// You may use it in your theme if you credit me. 
// It is also free to use on any individual website.
//
// Exception:
// The only restriction is to not publish any  
// extension for browsers or native application
// without getting a written permission first.
//

(function () {
  
// Scroll Variables (tweakable)
var defaultOptions = {

    // Scrolling Core
    frameRate        : 150, // [Hz]
    animationTime    : 400, // [ms]
    stepSize         : 100, // [px]

    // Pulse (less tweakable)
    // ratio of "tail" to "acceleration"
    pulseAlgorithm   : true,
    pulseScale       : 4,
    pulseNormalize   : 1,

    // Acceleration
    accelerationDelta : 50,  // 50
    accelerationMax   : 3,   // 3

    // Keyboard Settings
    keyboardSupport   : true,  // option
    arrowScroll       : 50,    // [px]

    // Other
    fixedBackground   : true, 
    excluded          : ''    
};

var options = defaultOptions;


// Other Variables
var isExcluded = false;
var isFrame = false;
var direction = { x: 0, y: 0 };
var initDone  = false;
var root = document.documentElement;
var activeElement;
var observer;
var refreshSize;
var deltaBuffer = [];
var deltaBufferTimer;
var isMac = /^Mac/.test(navigator.platform);

var key = { left: 37, up: 38, right: 39, down: 40, spacebar: 32, 
            pageup: 33, pagedown: 34, end: 35, home: 36 };
var arrowKeys = { 37: 1, 38: 1, 39: 1, 40: 1 };

/***********************************************
 * INITIALIZE
 ***********************************************/

/**
 * Tests if smooth scrolling is allowed. Shuts down everything if not.
 */
function initTest() {
    if (options.keyboardSupport) {
        addEvent('keydown', keydown);
    }
}

/**
 * Sets up scrolls array, determines if frames are involved.
 */
function init() {
  
    if (initDone || !document.body) return;

    initDone = true;

    var body = document.body;
    var html = document.documentElement;
    var windowHeight = window.innerHeight; 
    var scrollHeight = body.scrollHeight;
    
    // check compat mode for root element
    root = (document.compatMode.indexOf('CSS') >= 0) ? html : body;
    activeElement = body;
    
    initTest();

    // Checks if this script is running in a frame
    if (top != self) {
        isFrame = true;
    }

    /**
     * Safari 10 fixed it, Chrome fixed it in v45:
     * This fixes a bug where the areas left and right to 
     * the content does not trigger the onmousewheel event
     * on some pages. e.g.: html, body { height: 100% }
     */
    else if (isOldSafari &&
             scrollHeight > windowHeight &&
            (body.offsetHeight <= windowHeight || 
             html.offsetHeight <= windowHeight)) {

        var fullPageElem = document.createElement('div');
        fullPageElem.style.cssText = 'position:absolute; z-index:-10000; ' +
                                     'top:0; left:0; right:0; height:' + 
                                      root.scrollHeight + 'px';
        document.body.appendChild(fullPageElem);
        
        // DOM changed (throttled) to fix height
        var pendingRefresh;
        refreshSize = function () {
            if (pendingRefresh) return; // could also be: clearTimeout(pendingRefresh);
            pendingRefresh = setTimeout(function () {
                if (isExcluded) return; // could be running after cleanup
                fullPageElem.style.height = '0';
                fullPageElem.style.height = root.scrollHeight + 'px';
                pendingRefresh = null;
            }, 500); // act rarely to stay fast
        };
  
        setTimeout(refreshSize, 10);

        addEvent('resize', refreshSize);

        // TODO: attributeFilter?
        var config = {
            attributes: true, 
            childList: true, 
            characterData: false 
            // subtree: true
        };

        observer = new MutationObserver(refreshSize);
        observer.observe(body, config);

        if (root.offsetHeight <= windowHeight) {
            var clearfix = document.createElement('div');   
            clearfix.style.clear = 'both';
            body.appendChild(clearfix);
        }
    }

    // disable fixed background
    if (!options.fixedBackground && !isExcluded) {
        body.style.backgroundAttachment = 'scroll';
        html.style.backgroundAttachment = 'scroll';
    }
}

/**
 * Removes event listeners and other traces left on the page.
 */
function cleanup() {
    observer && observer.disconnect();
    removeEvent(wheelEvent, wheel);
    removeEvent('mousedown', mousedown);
    removeEvent('keydown', keydown);
    removeEvent('resize', refreshSize);
    removeEvent('load', init);
}


/************************************************
 * SCROLLING 
 ************************************************/
 
var que = [];
var pending = false;
var lastScroll = Date.now();

/**
 * Pushes scroll actions to the scrolling queue.
 */
function scrollArray(elem, left, top) {
    
    directionCheck(left, top);

    if (options.accelerationMax != 1) {
        var now = Date.now();
        var elapsed = now - lastScroll;
        if (elapsed < options.accelerationDelta) {
            var factor = (1 + (50 / elapsed)) / 2;
            if (factor > 1) {
                factor = Math.min(factor, options.accelerationMax);
                left *= factor;
                top  *= factor;
            }
        }
        lastScroll = Date.now();
    }          
    
    // push a scroll command
    que.push({
        x: left, 
        y: top, 
        lastX: (left < 0) ? 0.99 : -0.99,
        lastY: (top  < 0) ? 0.99 : -0.99, 
        start: Date.now()
    });
        
    // don't act if there's a pending queue
    if (pending) {
        return;
    }  

    var scrollRoot = getScrollRoot();
    var isWindowScroll = (elem === scrollRoot || elem === document.body);
    
    // if we haven't already fixed the behavior, 
    // and it needs fixing for this sesh
    if (elem.$scrollBehavior == null && isScrollBehaviorSmooth(elem)) {
        elem.$scrollBehavior = elem.style.scrollBehavior;
        elem.style.scrollBehavior = 'auto';
    }

    var step = function (time) {
        
        var now = Date.now();
        var scrollX = 0;
        var scrollY = 0; 
    
        for (var i = 0; i < que.length; i++) {
            
            var item = que[i];
            var elapsed  = now - item.start;
            var finished = (elapsed >= options.animationTime);
            
            // scroll position: [0, 1]
            var position = (finished) ? 1 : elapsed / options.animationTime;
            
            // easing [optional]
            if (options.pulseAlgorithm) {
                position = pulse(position);
            }
            
            // only need the difference
            var x = (item.x * position - item.lastX) >> 0;
            var y = (item.y * position - item.lastY) >> 0;
            
            // add this to the total scrolling
            scrollX += x;
            scrollY += y;            
            
            // update last values
            item.lastX += x;
            item.lastY += y;
        
            // delete and step back if it's over
            if (finished) {
                que.splice(i, 1); i--;
            }           
        }

        // scroll left and top
        if (isWindowScroll) {
            window.scrollBy(scrollX, scrollY);
        } 
        else {
            if (scrollX) elem.scrollLeft += scrollX;
            if (scrollY) elem.scrollTop  += scrollY;                    
        }
        
        // clean up if there's nothing left to do
        if (!left && !top) {
            que = [];
        }
        
        if (que.length) { 
            requestFrame(step, elem, (1000 / options.frameRate + 1)); 
        } else { 
            pending = false;
            // restore default behavior at the end of scrolling sesh
            if (elem.$scrollBehavior != null) {
                elem.style.scrollBehavior = elem.$scrollBehavior;
                elem.$scrollBehavior = null;
            }
        }
    };
    
    // start a new queue of actions
    requestFrame(step, elem, 0);
    pending = true;
}


/***********************************************
 * EVENTS
 ***********************************************/

/**
 * Mouse wheel handler.
 * @param {Object} event
 */
function wheel(event) {

    if (!initDone) {
        init();
    }
    
    var target = event.target;

    // leave early if default action is prevented   
    // or it's a zooming event with CTRL 
    if (event.defaultPrevented || event.ctrlKey) {
        return true;
    }
    
    // leave embedded content alone (flash & pdf)
    if (isNodeName(activeElement, 'embed') || 
       (isNodeName(target, 'embed') && /\.pdf/i.test(target.src)) ||
        isNodeName(activeElement, 'object') ||
        target.shadowRoot) {
        return true;
    }

    var deltaX = -event.wheelDeltaX || event.deltaX || 0;
    var deltaY = -event.wheelDeltaY || event.deltaY || 0;
    
    if (isMac) {
        if (event.wheelDeltaX && isDivisible(event.wheelDeltaX, 120)) {
            deltaX = -120 * (event.wheelDeltaX / Math.abs(event.wheelDeltaX));
        }
        if (event.wheelDeltaY && isDivisible(event.wheelDeltaY, 120)) {
            deltaY = -120 * (event.wheelDeltaY / Math.abs(event.wheelDeltaY));
        }
    }
    
    // use wheelDelta if deltaX/Y is not available
    if (!deltaX && !deltaY) {
        deltaY = -event.wheelDelta || 0;
    }

    // line based scrolling (Firefox mostly)
    if (event.deltaMode === 1) {
        deltaX *= 40;
        deltaY *= 40;
    }

    var overflowing = overflowingAncestor(target);

    // nothing to do if there's no element that's scrollable
    if (!overflowing) {
        // except Chrome iframes seem to eat wheel events, which we need to 
        // propagate up, if the iframe has nothing overflowing to scroll
        if (isFrame && isChrome)  {
            // change target to iframe element itself for the parent frame
            Object.defineProperty(event, "target", {value: window.frameElement});
            return parent.wheel(event);
        }
        return true;
    }
    
    // check if it's a touchpad scroll that should be ignored
    if (isTouchpad(deltaY)) {
        return true;
    }

    // scale by step size
    // delta is 120 most of the time
    // synaptics seems to send 1 sometimes
    if (Math.abs(deltaX) > 1.2) {
        deltaX *= options.stepSize / 120;
    }
    if (Math.abs(deltaY) > 1.2) {
        deltaY *= options.stepSize / 120;
    }
    
    scrollArray(overflowing, deltaX, deltaY);
    event.preventDefault();
    scheduleClearCache();
}

/**
 * Keydown event handler.
 * @param {Object} event
 */
function keydown(event) {

    var target   = event.target;
    var modifier = event.ctrlKey || event.altKey || event.metaKey || 
                  (event.shiftKey && event.keyCode !== key.spacebar);
    
    // our own tracked active element could've been removed from the DOM
    if (!document.body.contains(activeElement)) {
        activeElement = document.activeElement;
    }

    // do nothing if user is editing text
    // or using a modifier key (except shift)
    // or in a dropdown
    // or inside interactive elements
    var inputNodeNames = /^(textarea|select|embed|object)$/i;
    var buttonTypes = /^(button|submit|radio|checkbox|file|color|image)$/i;
    if ( event.defaultPrevented ||
         inputNodeNames.test(target.nodeName) ||
         isNodeName(target, 'input') && !buttonTypes.test(target.type) ||
         isNodeName(activeElement, 'video') ||
         isInsideYoutubeVideo(event) ||
         target.isContentEditable || 
         modifier ) {
      return true;
    }

    // [spacebar] should trigger button press, leave it alone
    if ((isNodeName(target, 'button') ||
         isNodeName(target, 'input') && buttonTypes.test(target.type)) &&
        event.keyCode === key.spacebar) {
      return true;
    }

    // [arrwow keys] on radio buttons should be left alone
    if (isNodeName(target, 'input') && target.type == 'radio' &&
        arrowKeys[event.keyCode])  {
      return true;
    }
    
    var shift, x = 0, y = 0;
    var overflowing = overflowingAncestor(activeElement);

    if (!overflowing) {
        // Chrome iframes seem to eat key events, which we need to 
        // propagate up, if the iframe has nothing overflowing to scroll
        return (isFrame && isChrome) ? parent.keydown(event) : true;
    }

    var clientHeight = overflowing.clientHeight; 

    if (overflowing == document.body) {
        clientHeight = window.innerHeight;
    }

    switch (event.keyCode) {
        case key.up:
            y = -options.arrowScroll;
            break;
        case key.down:
            y = options.arrowScroll;
            break;         
        case key.spacebar: // (+ shift)
            shift = event.shiftKey ? 1 : -1;
            y = -shift * clientHeight * 0.9;
            break;
        case key.pageup:
            y = -clientHeight * 0.9;
            break;
        case key.pagedown:
            y = clientHeight * 0.9;
            break;
        case key.home:
            if (overflowing == document.body && document.scrollingElement)
                overflowing = document.scrollingElement;
            y = -overflowing.scrollTop;
            break;
        case key.end:
            var scroll = overflowing.scrollHeight - overflowing.scrollTop;
            var scrollRemaining = scroll - clientHeight;
            y = (scrollRemaining > 0) ? scrollRemaining + 10 : 0;
            break;
        case key.left:
            x = -options.arrowScroll;
            break;
        case key.right:
            x = options.arrowScroll;
            break;            
        default:
            return true; // a key we don't care about
    }

    scrollArray(overflowing, x, y);
    event.preventDefault();
    scheduleClearCache();
}

/**
 * Mousedown event only for updating activeElement
 */
function mousedown(event) {
    activeElement = event.target;
}


/***********************************************
 * OVERFLOW
 ***********************************************/

var uniqueID = (function () {
    var i = 0;
    return function (el) {
        return el.uniqueID || (el.uniqueID = i++);
    };
})();

var cacheX = {}; // cleared out after a scrolling session
var cacheY = {}; // cleared out after a scrolling session
var clearCacheTimer;
var smoothBehaviorForElement = {};

//setInterval(function () { cache = {}; }, 10 * 1000);

function scheduleClearCache() {
    clearTimeout(clearCacheTimer);
    clearCacheTimer = setInterval(function () { 
        cacheX = cacheY = smoothBehaviorForElement = {}; 
    }, 1*1000);
}

function setCache(elems, overflowing, x) {
    var cache = x ? cacheX : cacheY;
    for (var i = elems.length; i--;)
        cache[uniqueID(elems[i])] = overflowing;
    return overflowing;
}

function getCache(el, x) {
    return (x ? cacheX : cacheY)[uniqueID(el)];
}

//  (body)                (root)
//         | hidden | visible | scroll |  auto  |
// hidden  |   no   |    no   |   YES  |   YES  |
// visible |   no   |   YES   |   YES  |   YES  |
// scroll  |   no   |   YES   |   YES  |   YES  |
// auto    |   no   |   YES   |   YES  |   YES  |

function overflowingAncestor(el) {
    var elems = [];
    var body = document.body;
    var rootScrollHeight = root.scrollHeight;
    do {
        var cached = getCache(el, false);
        if (cached) {
            return setCache(elems, cached);
        }
        elems.push(el);
        if (rootScrollHeight === el.scrollHeight) {
            var topOverflowsNotHidden = overflowNotHidden(root) && overflowNotHidden(body);
            var isOverflowCSS = topOverflowsNotHidden || overflowAutoOrScroll(root);
            if (isFrame && isContentOverflowing(root) || 
               !isFrame && isOverflowCSS) {
                return setCache(elems, getScrollRoot()); 
            }
        } else if (isContentOverflowing(el) && overflowAutoOrScroll(el)) {
            return setCache(elems, el);
        }
    } while ((el = el.parentElement));
}

function isContentOverflowing(el) {
    return (el.clientHeight + 10 < el.scrollHeight);
}

// typically for <body> and <html>
function overflowNotHidden(el) {
    var overflow = getComputedStyle(el, '').getPropertyValue('overflow-y');
    return (overflow !== 'hidden');
}

// for all other elements
function overflowAutoOrScroll(el) {
    var overflow = getComputedStyle(el, '').getPropertyValue('overflow-y');
    return (overflow === 'scroll' || overflow === 'auto');
}

// for all other elements
function isScrollBehaviorSmooth(el) {
    var id = uniqueID(el);
    if (smoothBehaviorForElement[id] == null) {
        var scrollBehavior = getComputedStyle(el, '')['scroll-behavior'];
        smoothBehaviorForElement[id] = ('smooth' == scrollBehavior);
    }
    return smoothBehaviorForElement[id];
}


/***********************************************
 * HELPERS
 ***********************************************/

function addEvent(type, fn, arg) {
    window.addEventListener(type, fn, arg || false);
}

function removeEvent(type, fn, arg) {
    window.removeEventListener(type, fn, arg || false);  
}

function isNodeName(el, tag) {
    return el && (el.nodeName||'').toLowerCase() === tag.toLowerCase();
}

function directionCheck(x, y) {
    x = (x > 0) ? 1 : -1;
    y = (y > 0) ? 1 : -1;
    if (direction.x !== x || direction.y !== y) {
        direction.x = x;
        direction.y = y;
        que = [];
        lastScroll = 0;
    }
}

if (window.localStorage && localStorage.SS_deltaBuffer) {
    try { // #46 Safari throws in private browsing for localStorage 
        deltaBuffer = localStorage.SS_deltaBuffer.split(',');
    } catch (e) { } 
}

function isTouchpad(deltaY) {
    if (!deltaY) return;
    if (!deltaBuffer.length) {
        deltaBuffer = [deltaY, deltaY, deltaY];
    }
    deltaY = Math.abs(deltaY);
    deltaBuffer.push(deltaY);
    deltaBuffer.shift();
    clearTimeout(deltaBufferTimer);
    deltaBufferTimer = setTimeout(function () {
        try { // #46 Safari throws in private browsing for localStorage
            localStorage.SS_deltaBuffer = deltaBuffer.join(',');
        } catch (e) { }  
    }, 1000);
    var dpiScaledWheelDelta = deltaY > 120 && allDeltasDivisableBy(deltaY); // win64 
    return !allDeltasDivisableBy(120) && !allDeltasDivisableBy(100) && !dpiScaledWheelDelta;
} 

function isDivisible(n, divisor) {
    return (Math.floor(n / divisor) == n / divisor);
}

function allDeltasDivisableBy(divisor) {
    return (isDivisible(deltaBuffer[0], divisor) &&
            isDivisible(deltaBuffer[1], divisor) &&
            isDivisible(deltaBuffer[2], divisor));
}

function isInsideYoutubeVideo(event) {
    var elem = event.target;
    var isControl = false;
    if (document.URL.indexOf ('www.youtube.com/watch') != -1) {
        do {
            isControl = (elem.classList && 
                         elem.classList.contains('html5-video-controls'));
            if (isControl) break;
        } while ((elem = elem.parentNode));
    }
    return isControl;
}

var requestFrame = (function () {
      return (window.requestAnimationFrame       || 
              window.webkitRequestAnimationFrame || 
              window.mozRequestAnimationFrame    ||
              function (callback, element, delay) {
                 window.setTimeout(callback, delay || (1000/60));
             });
})();

var MutationObserver = (window.MutationObserver || 
                        window.WebKitMutationObserver ||
                        window.MozMutationObserver);  

var getScrollRoot = (function() {
  var SCROLL_ROOT = document.scrollingElement;
  return function() {
    if (!SCROLL_ROOT) {
      var dummy = document.createElement('div');
      dummy.style.cssText = 'height:10000px;width:1px;';
      document.body.appendChild(dummy);
      var bodyScrollTop  = document.body.scrollTop;
      var docElScrollTop = document.documentElement.scrollTop;
      window.scrollBy(0, 3);
      if (document.body.scrollTop != bodyScrollTop)
        (SCROLL_ROOT = document.body);
      else 
        (SCROLL_ROOT = document.documentElement);
      window.scrollBy(0, -3);
      document.body.removeChild(dummy);
    }
    return SCROLL_ROOT;
  };
})();


/***********************************************
 * PULSE (by Michael Herf)
 ***********************************************/
 
/**
 * Viscous fluid with a pulse for part and decay for the rest.
 * - Applies a fixed force over an interval (a damped acceleration), and
 * - Lets the exponential bleed away the velocity over a longer interval
 * - Michael Herf, http://stereopsis.com/stopping/
 */
function pulse_(x) {
    var val, start, expx;
    // test
    x = x * options.pulseScale;
    if (x < 1) { // acceleartion
        val = x - (1 - Math.exp(-x));
    } else {     // tail
        // the previous animation ended here:
        start = Math.exp(-1);
        // simple viscous drag
        x -= 1;
        expx = 1 - Math.exp(-x);
        val = start + (expx * (1 - start));
    }
    return val * options.pulseNormalize;
}

function pulse(x) {
    if (x >= 1) return 1;
    if (x <= 0) return 0;

    if (options.pulseNormalize == 1) {
        options.pulseNormalize /= pulse_(1);
    }
    return pulse_(x);
}


/***********************************************
 * FIRST RUN
 ***********************************************/

var userAgent = window.navigator.userAgent;
var isEdge    = /Edge/.test(userAgent); // thank you MS
var isChrome  = /chrome/i.test(userAgent) && !isEdge; 
var isSafari  = /safari/i.test(userAgent) && !isEdge; 
var isMobile  = /mobile/i.test(userAgent);
var isIEWin7  = /Windows NT 6.1/i.test(userAgent) && /rv:11/i.test(userAgent);
var isOldSafari = isSafari && (/Version\/8/i.test(userAgent) || /Version\/9/i.test(userAgent));
var isEnabledForBrowser = (isChrome || isSafari || isIEWin7) && !isMobile;

var supportsPassive = false;
try {
  window.addEventListener("test", null, Object.defineProperty({}, 'passive', {
    get: function () {
            supportsPassive = true;
        } 
    }));
} catch(e) {}

var wheelOpt = supportsPassive ? { passive: false } : false;
var wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel'; 

if (wheelEvent && isEnabledForBrowser) {
    addEvent(wheelEvent, wheel, wheelOpt);
    addEvent('mousedown', mousedown);
    addEvent('load', init);
}


/***********************************************
 * PUBLIC INTERFACE
 ***********************************************/

function SmoothScroll(optionsToSet) {
    for (var key in optionsToSet)
        if (defaultOptions.hasOwnProperty(key)) 
            options[key] = optionsToSet[key];
}
SmoothScroll.destroy = cleanup;

if (window.SmoothScrollOptions) // async API
    SmoothScroll(window.SmoothScrollOptions);

if (typeof define === 'function' && define.amd)
    define(function() {
        return SmoothScroll;
    });
else if ('object' == typeof exports)
    module.exports = SmoothScroll;
else
    window.SmoothScroll = SmoothScroll;

})();
/*!
  * Bootstrap v4.6.2 (https://getbootstrap.com/)
  * Copyright 2011-2022 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */
!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?e(exports,require("jquery")):"function"==typeof define&&define.amd?define(["exports","jquery"],e):e((t="undefined"!=typeof globalThis?globalThis:t||self).bootstrap={},t.jQuery)}(this,(function(t,e){"use strict";function n(t){return t&&"object"==typeof t&&"default"in t?t:{default:t}}var i=n(e);function o(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function r(t,e,n){return e&&o(t.prototype,e),n&&o(t,n),Object.defineProperty(t,"prototype",{writable:!1}),t}function a(){return a=Object.assign?Object.assign.bind():function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var i in n)Object.prototype.hasOwnProperty.call(n,i)&&(t[i]=n[i])}return t},a.apply(this,arguments)}function s(t,e){return s=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t},s(t,e)}var l="transitionend";var u={TRANSITION_END:"bsTransitionEnd",getUID:function(t){do{t+=~~(1e6*Math.random())}while(document.getElementById(t));return t},getSelectorFromElement:function(t){var e=t.getAttribute("data-target");if(!e||"#"===e){var n=t.getAttribute("href");e=n&&"#"!==n?n.trim():""}try{return document.querySelector(e)?e:null}catch(t){return null}},getTransitionDurationFromElement:function(t){if(!t)return 0;var e=i.default(t).css("transition-duration"),n=i.default(t).css("transition-delay"),o=parseFloat(e),r=parseFloat(n);return o||r?(e=e.split(",")[0],n=n.split(",")[0],1e3*(parseFloat(e)+parseFloat(n))):0},reflow:function(t){return t.offsetHeight},triggerTransitionEnd:function(t){i.default(t).trigger(l)},supportsTransitionEnd:function(){return Boolean(l)},isElement:function(t){return(t[0]||t).nodeType},typeCheckConfig:function(t,e,n){for(var i in n)if(Object.prototype.hasOwnProperty.call(n,i)){var o=n[i],r=e[i],a=r&&u.isElement(r)?"element":null===(s=r)||"undefined"==typeof s?""+s:{}.toString.call(s).match(/\s([a-z]+)/i)[1].toLowerCase();if(!new RegExp(o).test(a))throw new Error(t.toUpperCase()+': Option "'+i+'" provided type "'+a+'" but expected type "'+o+'".')}var s},findShadowRoot:function(t){if(!document.documentElement.attachShadow)return null;if("function"==typeof t.getRootNode){var e=t.getRootNode();return e instanceof ShadowRoot?e:null}return t instanceof ShadowRoot?t:t.parentNode?u.findShadowRoot(t.parentNode):null},jQueryDetection:function(){if("undefined"==typeof i.default)throw new TypeError("Bootstrap's JavaScript requires jQuery. jQuery must be included before Bootstrap's JavaScript.");var t=i.default.fn.jquery.split(" ")[0].split(".");if(t[0]<2&&t[1]<9||1===t[0]&&9===t[1]&&t[2]<1||t[0]>=4)throw new Error("Bootstrap's JavaScript requires at least jQuery v1.9.1 but less than v4.0.0")}};u.jQueryDetection(),i.default.fn.emulateTransitionEnd=function(t){var e=this,n=!1;return i.default(this).one(u.TRANSITION_END,(function(){n=!0})),setTimeout((function(){n||u.triggerTransitionEnd(e)}),t),this},i.default.event.special[u.TRANSITION_END]={bindType:l,delegateType:l,handle:function(t){if(i.default(t.target).is(this))return t.handleObj.handler.apply(this,arguments)}};var f="bs.alert",d=i.default.fn.alert,c=function(){function t(t){this._element=t}var e=t.prototype;return e.close=function(t){var e=this._element;t&&(e=this._getRootElement(t)),this._triggerCloseEvent(e).isDefaultPrevented()||this._removeElement(e)},e.dispose=function(){i.default.removeData(this._element,f),this._element=null},e._getRootElement=function(t){var e=u.getSelectorFromElement(t),n=!1;return e&&(n=document.querySelector(e)),n||(n=i.default(t).closest(".alert")[0]),n},e._triggerCloseEvent=function(t){var e=i.default.Event("close.bs.alert");return i.default(t).trigger(e),e},e._removeElement=function(t){var e=this;if(i.default(t).removeClass("show"),i.default(t).hasClass("fade")){var n=u.getTransitionDurationFromElement(t);i.default(t).one(u.TRANSITION_END,(function(n){return e._destroyElement(t,n)})).emulateTransitionEnd(n)}else this._destroyElement(t)},e._destroyElement=function(t){i.default(t).detach().trigger("closed.bs.alert").remove()},t._jQueryInterface=function(e){return this.each((function(){var n=i.default(this),o=n.data(f);o||(o=new t(this),n.data(f,o)),"close"===e&&o[e](this)}))},t._handleDismiss=function(t){return function(e){e&&e.preventDefault(),t.close(this)}},r(t,null,[{key:"VERSION",get:function(){return"4.6.2"}}]),t}();i.default(document).on("click.bs.alert.data-api",'[data-dismiss="alert"]',c._handleDismiss(new c)),i.default.fn.alert=c._jQueryInterface,i.default.fn.alert.Constructor=c,i.default.fn.alert.noConflict=function(){return i.default.fn.alert=d,c._jQueryInterface};var h="bs.button",p=i.default.fn.button,m="active",g='[data-toggle^="button"]',_='input:not([type="hidden"])',v=".btn",b=function(){function t(t){this._element=t,this.shouldAvoidTriggerChange=!1}var e=t.prototype;return e.toggle=function(){var t=!0,e=!0,n=i.default(this._element).closest('[data-toggle="buttons"]')[0];if(n){var o=this._element.querySelector(_);if(o){if("radio"===o.type)if(o.checked&&this._element.classList.contains(m))t=!1;else{var r=n.querySelector(".active");r&&i.default(r).removeClass(m)}t&&("checkbox"!==o.type&&"radio"!==o.type||(o.checked=!this._element.classList.contains(m)),this.shouldAvoidTriggerChange||i.default(o).trigger("change")),o.focus(),e=!1}}this._element.hasAttribute("disabled")||this._element.classList.contains("disabled")||(e&&this._element.setAttribute("aria-pressed",!this._element.classList.contains(m)),t&&i.default(this._element).toggleClass(m))},e.dispose=function(){i.default.removeData(this._element,h),this._element=null},t._jQueryInterface=function(e,n){return this.each((function(){var o=i.default(this),r=o.data(h);r||(r=new t(this),o.data(h,r)),r.shouldAvoidTriggerChange=n,"toggle"===e&&r[e]()}))},r(t,null,[{key:"VERSION",get:function(){return"4.6.2"}}]),t}();i.default(document).on("click.bs.button.data-api",g,(function(t){var e=t.target,n=e;if(i.default(e).hasClass("btn")||(e=i.default(e).closest(v)[0]),!e||e.hasAttribute("disabled")||e.classList.contains("disabled"))t.preventDefault();else{var o=e.querySelector(_);if(o&&(o.hasAttribute("disabled")||o.classList.contains("disabled")))return void t.preventDefault();"INPUT"!==n.tagName&&"LABEL"===e.tagName||b._jQueryInterface.call(i.default(e),"toggle","INPUT"===n.tagName)}})).on("focus.bs.button.data-api blur.bs.button.data-api",g,(function(t){var e=i.default(t.target).closest(v)[0];i.default(e).toggleClass("focus",/^focus(in)?$/.test(t.type))})),i.default(window).on("load.bs.button.data-api",(function(){for(var t=[].slice.call(document.querySelectorAll('[data-toggle="buttons"] .btn')),e=0,n=t.length;e<n;e++){var i=t[e],o=i.querySelector(_);o.checked||o.hasAttribute("checked")?i.classList.add(m):i.classList.remove(m)}for(var r=0,a=(t=[].slice.call(document.querySelectorAll('[data-toggle="button"]'))).length;r<a;r++){var s=t[r];"true"===s.getAttribute("aria-pressed")?s.classList.add(m):s.classList.remove(m)}})),i.default.fn.button=b._jQueryInterface,i.default.fn.button.Constructor=b,i.default.fn.button.noConflict=function(){return i.default.fn.button=p,b._jQueryInterface};var y="carousel",E="bs.carousel",w=i.default.fn[y],T="active",C="next",S="prev",N="slid.bs.carousel",D=".active.carousel-item",A={interval:5e3,keyboard:!0,slide:!1,pause:"hover",wrap:!0,touch:!0},k={interval:"(number|boolean)",keyboard:"boolean",slide:"(boolean|string)",pause:"(string|boolean)",wrap:"boolean",touch:"boolean"},I={TOUCH:"touch",PEN:"pen"},O=function(){function t(t,e){this._items=null,this._interval=null,this._activeElement=null,this._isPaused=!1,this._isSliding=!1,this.touchTimeout=null,this.touchStartX=0,this.touchDeltaX=0,this._config=this._getConfig(e),this._element=t,this._indicatorsElement=this._element.querySelector(".carousel-indicators"),this._touchSupported="ontouchstart"in document.documentElement||navigator.maxTouchPoints>0,this._pointerEvent=Boolean(window.PointerEvent||window.MSPointerEvent),this._addEventListeners()}var e=t.prototype;return e.next=function(){this._isSliding||this._slide(C)},e.nextWhenVisible=function(){var t=i.default(this._element);!document.hidden&&t.is(":visible")&&"hidden"!==t.css("visibility")&&this.next()},e.prev=function(){this._isSliding||this._slide(S)},e.pause=function(t){t||(this._isPaused=!0),this._element.querySelector(".carousel-item-next, .carousel-item-prev")&&(u.triggerTransitionEnd(this._element),this.cycle(!0)),clearInterval(this._interval),this._interval=null},e.cycle=function(t){t||(this._isPaused=!1),this._interval&&(clearInterval(this._interval),this._interval=null),this._config.interval&&!this._isPaused&&(this._updateInterval(),this._interval=setInterval((document.visibilityState?this.nextWhenVisible:this.next).bind(this),this._config.interval))},e.to=function(t){var e=this;this._activeElement=this._element.querySelector(D);var n=this._getItemIndex(this._activeElement);if(!(t>this._items.length-1||t<0))if(this._isSliding)i.default(this._element).one(N,(function(){return e.to(t)}));else{if(n===t)return this.pause(),void this.cycle();var o=t>n?C:S;this._slide(o,this._items[t])}},e.dispose=function(){i.default(this._element).off(".bs.carousel"),i.default.removeData(this._element,E),this._items=null,this._config=null,this._element=null,this._interval=null,this._isPaused=null,this._isSliding=null,this._activeElement=null,this._indicatorsElement=null},e._getConfig=function(t){return t=a({},A,t),u.typeCheckConfig(y,t,k),t},e._handleSwipe=function(){var t=Math.abs(this.touchDeltaX);if(!(t<=40)){var e=t/this.touchDeltaX;this.touchDeltaX=0,e>0&&this.prev(),e<0&&this.next()}},e._addEventListeners=function(){var t=this;this._config.keyboard&&i.default(this._element).on("keydown.bs.carousel",(function(e){return t._keydown(e)})),"hover"===this._config.pause&&i.default(this._element).on("mouseenter.bs.carousel",(function(e){return t.pause(e)})).on("mouseleave.bs.carousel",(function(e){return t.cycle(e)})),this._config.touch&&this._addTouchEventListeners()},e._addTouchEventListeners=function(){var t=this;if(this._touchSupported){var e=function(e){t._pointerEvent&&I[e.originalEvent.pointerType.toUpperCase()]?t.touchStartX=e.originalEvent.clientX:t._pointerEvent||(t.touchStartX=e.originalEvent.touches[0].clientX)},n=function(e){t._pointerEvent&&I[e.originalEvent.pointerType.toUpperCase()]&&(t.touchDeltaX=e.originalEvent.clientX-t.touchStartX),t._handleSwipe(),"hover"===t._config.pause&&(t.pause(),t.touchTimeout&&clearTimeout(t.touchTimeout),t.touchTimeout=setTimeout((function(e){return t.cycle(e)}),500+t._config.interval))};i.default(this._element.querySelectorAll(".carousel-item img")).on("dragstart.bs.carousel",(function(t){return t.preventDefault()})),this._pointerEvent?(i.default(this._element).on("pointerdown.bs.carousel",(function(t){return e(t)})),i.default(this._element).on("pointerup.bs.carousel",(function(t){return n(t)})),this._element.classList.add("pointer-event")):(i.default(this._element).on("touchstart.bs.carousel",(function(t){return e(t)})),i.default(this._element).on("touchmove.bs.carousel",(function(e){return function(e){t.touchDeltaX=e.originalEvent.touches&&e.originalEvent.touches.length>1?0:e.originalEvent.touches[0].clientX-t.touchStartX}(e)})),i.default(this._element).on("touchend.bs.carousel",(function(t){return n(t)})))}},e._keydown=function(t){if(!/input|textarea/i.test(t.target.tagName))switch(t.which){case 37:t.preventDefault(),this.prev();break;case 39:t.preventDefault(),this.next()}},e._getItemIndex=function(t){return this._items=t&&t.parentNode?[].slice.call(t.parentNode.querySelectorAll(".carousel-item")):[],this._items.indexOf(t)},e._getItemByDirection=function(t,e){var n=t===C,i=t===S,o=this._getItemIndex(e),r=this._items.length-1;if((i&&0===o||n&&o===r)&&!this._config.wrap)return e;var a=(o+(t===S?-1:1))%this._items.length;return-1===a?this._items[this._items.length-1]:this._items[a]},e._triggerSlideEvent=function(t,e){var n=this._getItemIndex(t),o=this._getItemIndex(this._element.querySelector(D)),r=i.default.Event("slide.bs.carousel",{relatedTarget:t,direction:e,from:o,to:n});return i.default(this._element).trigger(r),r},e._setActiveIndicatorElement=function(t){if(this._indicatorsElement){var e=[].slice.call(this._indicatorsElement.querySelectorAll(".active"));i.default(e).removeClass(T);var n=this._indicatorsElement.children[this._getItemIndex(t)];n&&i.default(n).addClass(T)}},e._updateInterval=function(){var t=this._activeElement||this._element.querySelector(D);if(t){var e=parseInt(t.getAttribute("data-interval"),10);e?(this._config.defaultInterval=this._config.defaultInterval||this._config.interval,this._config.interval=e):this._config.interval=this._config.defaultInterval||this._config.interval}},e._slide=function(t,e){var n,o,r,a=this,s=this._element.querySelector(D),l=this._getItemIndex(s),f=e||s&&this._getItemByDirection(t,s),d=this._getItemIndex(f),c=Boolean(this._interval);if(t===C?(n="carousel-item-left",o="carousel-item-next",r="left"):(n="carousel-item-right",o="carousel-item-prev",r="right"),f&&i.default(f).hasClass(T))this._isSliding=!1;else if(!this._triggerSlideEvent(f,r).isDefaultPrevented()&&s&&f){this._isSliding=!0,c&&this.pause(),this._setActiveIndicatorElement(f),this._activeElement=f;var h=i.default.Event(N,{relatedTarget:f,direction:r,from:l,to:d});if(i.default(this._element).hasClass("slide")){i.default(f).addClass(o),u.reflow(f),i.default(s).addClass(n),i.default(f).addClass(n);var p=u.getTransitionDurationFromElement(s);i.default(s).one(u.TRANSITION_END,(function(){i.default(f).removeClass(n+" "+o).addClass(T),i.default(s).removeClass("active "+o+" "+n),a._isSliding=!1,setTimeout((function(){return i.default(a._element).trigger(h)}),0)})).emulateTransitionEnd(p)}else i.default(s).removeClass(T),i.default(f).addClass(T),this._isSliding=!1,i.default(this._element).trigger(h);c&&this.cycle()}},t._jQueryInterface=function(e){return this.each((function(){var n=i.default(this).data(E),o=a({},A,i.default(this).data());"object"==typeof e&&(o=a({},o,e));var r="string"==typeof e?e:o.slide;if(n||(n=new t(this,o),i.default(this).data(E,n)),"number"==typeof e)n.to(e);else if("string"==typeof r){if("undefined"==typeof n[r])throw new TypeError('No method named "'+r+'"');n[r]()}else o.interval&&o.ride&&(n.pause(),n.cycle())}))},t._dataApiClickHandler=function(e){var n=u.getSelectorFromElement(this);if(n){var o=i.default(n)[0];if(o&&i.default(o).hasClass("carousel")){var r=a({},i.default(o).data(),i.default(this).data()),s=this.getAttribute("data-slide-to");s&&(r.interval=!1),t._jQueryInterface.call(i.default(o),r),s&&i.default(o).data(E).to(s),e.preventDefault()}}},r(t,null,[{key:"VERSION",get:function(){return"4.6.2"}},{key:"Default",get:function(){return A}}]),t}();i.default(document).on("click.bs.carousel.data-api","[data-slide], [data-slide-to]",O._dataApiClickHandler),i.default(window).on("load.bs.carousel.data-api",(function(){for(var t=[].slice.call(document.querySelectorAll('[data-ride="carousel"]')),e=0,n=t.length;e<n;e++){var o=i.default(t[e]);O._jQueryInterface.call(o,o.data())}})),i.default.fn[y]=O._jQueryInterface,i.default.fn[y].Constructor=O,i.default.fn[y].noConflict=function(){return i.default.fn[y]=w,O._jQueryInterface};var x="collapse",j="bs.collapse",L=i.default.fn[x],P="show",F="collapse",R="collapsing",B="collapsed",H="width",M='[data-toggle="collapse"]',q={toggle:!0,parent:""},Q={toggle:"boolean",parent:"(string|element)"},W=function(){function t(t,e){this._isTransitioning=!1,this._element=t,this._config=this._getConfig(e),this._triggerArray=[].slice.call(document.querySelectorAll('[data-toggle="collapse"][href="#'+t.id+'"],[data-toggle="collapse"][data-target="#'+t.id+'"]'));for(var n=[].slice.call(document.querySelectorAll(M)),i=0,o=n.length;i<o;i++){var r=n[i],a=u.getSelectorFromElement(r),s=[].slice.call(document.querySelectorAll(a)).filter((function(e){return e===t}));null!==a&&s.length>0&&(this._selector=a,this._triggerArray.push(r))}this._parent=this._config.parent?this._getParent():null,this._config.parent||this._addAriaAndCollapsedClass(this._element,this._triggerArray),this._config.toggle&&this.toggle()}var e=t.prototype;return e.toggle=function(){i.default(this._element).hasClass(P)?this.hide():this.show()},e.show=function(){var e,n,o=this;if(!(this._isTransitioning||i.default(this._element).hasClass(P)||(this._parent&&0===(e=[].slice.call(this._parent.querySelectorAll(".show, .collapsing")).filter((function(t){return"string"==typeof o._config.parent?t.getAttribute("data-parent")===o._config.parent:t.classList.contains(F)}))).length&&(e=null),e&&(n=i.default(e).not(this._selector).data(j))&&n._isTransitioning))){var r=i.default.Event("show.bs.collapse");if(i.default(this._element).trigger(r),!r.isDefaultPrevented()){e&&(t._jQueryInterface.call(i.default(e).not(this._selector),"hide"),n||i.default(e).data(j,null));var a=this._getDimension();i.default(this._element).removeClass(F).addClass(R),this._element.style[a]=0,this._triggerArray.length&&i.default(this._triggerArray).removeClass(B).attr("aria-expanded",!0),this.setTransitioning(!0);var s="scroll"+(a[0].toUpperCase()+a.slice(1)),l=u.getTransitionDurationFromElement(this._element);i.default(this._element).one(u.TRANSITION_END,(function(){i.default(o._element).removeClass(R).addClass("collapse show"),o._element.style[a]="",o.setTransitioning(!1),i.default(o._element).trigger("shown.bs.collapse")})).emulateTransitionEnd(l),this._element.style[a]=this._element[s]+"px"}}},e.hide=function(){var t=this;if(!this._isTransitioning&&i.default(this._element).hasClass(P)){var e=i.default.Event("hide.bs.collapse");if(i.default(this._element).trigger(e),!e.isDefaultPrevented()){var n=this._getDimension();this._element.style[n]=this._element.getBoundingClientRect()[n]+"px",u.reflow(this._element),i.default(this._element).addClass(R).removeClass("collapse show");var o=this._triggerArray.length;if(o>0)for(var r=0;r<o;r++){var a=this._triggerArray[r],s=u.getSelectorFromElement(a);null!==s&&(i.default([].slice.call(document.querySelectorAll(s))).hasClass(P)||i.default(a).addClass(B).attr("aria-expanded",!1))}this.setTransitioning(!0),this._element.style[n]="";var l=u.getTransitionDurationFromElement(this._element);i.default(this._element).one(u.TRANSITION_END,(function(){t.setTransitioning(!1),i.default(t._element).removeClass(R).addClass(F).trigger("hidden.bs.collapse")})).emulateTransitionEnd(l)}}},e.setTransitioning=function(t){this._isTransitioning=t},e.dispose=function(){i.default.removeData(this._element,j),this._config=null,this._parent=null,this._element=null,this._triggerArray=null,this._isTransitioning=null},e._getConfig=function(t){return(t=a({},q,t)).toggle=Boolean(t.toggle),u.typeCheckConfig(x,t,Q),t},e._getDimension=function(){return i.default(this._element).hasClass(H)?H:"height"},e._getParent=function(){var e,n=this;u.isElement(this._config.parent)?(e=this._config.parent,"undefined"!=typeof this._config.parent.jquery&&(e=this._config.parent[0])):e=document.querySelector(this._config.parent);var o='[data-toggle="collapse"][data-parent="'+this._config.parent+'"]',r=[].slice.call(e.querySelectorAll(o));return i.default(r).each((function(e,i){n._addAriaAndCollapsedClass(t._getTargetFromElement(i),[i])})),e},e._addAriaAndCollapsedClass=function(t,e){var n=i.default(t).hasClass(P);e.length&&i.default(e).toggleClass(B,!n).attr("aria-expanded",n)},t._getTargetFromElement=function(t){var e=u.getSelectorFromElement(t);return e?document.querySelector(e):null},t._jQueryInterface=function(e){return this.each((function(){var n=i.default(this),o=n.data(j),r=a({},q,n.data(),"object"==typeof e&&e?e:{});if(!o&&r.toggle&&"string"==typeof e&&/show|hide/.test(e)&&(r.toggle=!1),o||(o=new t(this,r),n.data(j,o)),"string"==typeof e){if("undefined"==typeof o[e])throw new TypeError('No method named "'+e+'"');o[e]()}}))},r(t,null,[{key:"VERSION",get:function(){return"4.6.2"}},{key:"Default",get:function(){return q}}]),t}();i.default(document).on("click.bs.collapse.data-api",M,(function(t){"A"===t.currentTarget.tagName&&t.preventDefault();var e=i.default(this),n=u.getSelectorFromElement(this),o=[].slice.call(document.querySelectorAll(n));i.default(o).each((function(){var t=i.default(this),n=t.data(j)?"toggle":e.data();W._jQueryInterface.call(t,n)}))})),i.default.fn[x]=W._jQueryInterface,i.default.fn[x].Constructor=W,i.default.fn[x].noConflict=function(){return i.default.fn[x]=L,W._jQueryInterface};var U="undefined"!=typeof window&&"undefined"!=typeof document&&"undefined"!=typeof navigator,V=function(){for(var t=["Edge","Trident","Firefox"],e=0;e<t.length;e+=1)if(U&&navigator.userAgent.indexOf(t[e])>=0)return 1;return 0}(),Y=U&&window.Promise?function(t){var e=!1;return function(){e||(e=!0,window.Promise.resolve().then((function(){e=!1,t()})))}}:function(t){var e=!1;return function(){e||(e=!0,setTimeout((function(){e=!1,t()}),V))}};function z(t){return t&&"[object Function]"==={}.toString.call(t)}function K(t,e){if(1!==t.nodeType)return[];var n=t.ownerDocument.defaultView.getComputedStyle(t,null);return e?n[e]:n}function X(t){return"HTML"===t.nodeName?t:t.parentNode||t.host}function G(t){if(!t)return document.body;switch(t.nodeName){case"HTML":case"BODY":return t.ownerDocument.body;case"#document":return t.body}var e=K(t),n=e.overflow,i=e.overflowX,o=e.overflowY;return/(auto|scroll|overlay)/.test(n+o+i)?t:G(X(t))}function $(t){return t&&t.referenceNode?t.referenceNode:t}var J=U&&!(!window.MSInputMethodContext||!document.documentMode),Z=U&&/MSIE 10/.test(navigator.userAgent);function tt(t){return 11===t?J:10===t?Z:J||Z}function et(t){if(!t)return document.documentElement;for(var e=tt(10)?document.body:null,n=t.offsetParent||null;n===e&&t.nextElementSibling;)n=(t=t.nextElementSibling).offsetParent;var i=n&&n.nodeName;return i&&"BODY"!==i&&"HTML"!==i?-1!==["TH","TD","TABLE"].indexOf(n.nodeName)&&"static"===K(n,"position")?et(n):n:t?t.ownerDocument.documentElement:document.documentElement}function nt(t){return null!==t.parentNode?nt(t.parentNode):t}function it(t,e){if(!(t&&t.nodeType&&e&&e.nodeType))return document.documentElement;var n=t.compareDocumentPosition(e)&Node.DOCUMENT_POSITION_FOLLOWING,i=n?t:e,o=n?e:t,r=document.createRange();r.setStart(i,0),r.setEnd(o,0);var a,s,l=r.commonAncestorContainer;if(t!==l&&e!==l||i.contains(o))return"BODY"===(s=(a=l).nodeName)||"HTML"!==s&&et(a.firstElementChild)!==a?et(l):l;var u=nt(t);return u.host?it(u.host,e):it(t,nt(e).host)}function ot(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"top",n="top"===e?"scrollTop":"scrollLeft",i=t.nodeName;if("BODY"===i||"HTML"===i){var o=t.ownerDocument.documentElement,r=t.ownerDocument.scrollingElement||o;return r[n]}return t[n]}function rt(t,e){var n=arguments.length>2&&void 0!==arguments[2]&&arguments[2],i=ot(e,"top"),o=ot(e,"left"),r=n?-1:1;return t.top+=i*r,t.bottom+=i*r,t.left+=o*r,t.right+=o*r,t}function at(t,e){var n="x"===e?"Left":"Top",i="Left"===n?"Right":"Bottom";return parseFloat(t["border"+n+"Width"])+parseFloat(t["border"+i+"Width"])}function st(t,e,n,i){return Math.max(e["offset"+t],e["scroll"+t],n["client"+t],n["offset"+t],n["scroll"+t],tt(10)?parseInt(n["offset"+t])+parseInt(i["margin"+("Height"===t?"Top":"Left")])+parseInt(i["margin"+("Height"===t?"Bottom":"Right")]):0)}function lt(t){var e=t.body,n=t.documentElement,i=tt(10)&&getComputedStyle(n);return{height:st("Height",e,n,i),width:st("Width",e,n,i)}}var ut=function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")},ft=function(){function t(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}return function(e,n,i){return n&&t(e.prototype,n),i&&t(e,i),e}}(),dt=function(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t},ct=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var i in n)Object.prototype.hasOwnProperty.call(n,i)&&(t[i]=n[i])}return t};function ht(t){return ct({},t,{right:t.left+t.width,bottom:t.top+t.height})}function pt(t){var e={};try{if(tt(10)){e=t.getBoundingClientRect();var n=ot(t,"top"),i=ot(t,"left");e.top+=n,e.left+=i,e.bottom+=n,e.right+=i}else e=t.getBoundingClientRect()}catch(t){}var o={left:e.left,top:e.top,width:e.right-e.left,height:e.bottom-e.top},r="HTML"===t.nodeName?lt(t.ownerDocument):{},a=r.width||t.clientWidth||o.width,s=r.height||t.clientHeight||o.height,l=t.offsetWidth-a,u=t.offsetHeight-s;if(l||u){var f=K(t);l-=at(f,"x"),u-=at(f,"y"),o.width-=l,o.height-=u}return ht(o)}function mt(t,e){var n=arguments.length>2&&void 0!==arguments[2]&&arguments[2],i=tt(10),o="HTML"===e.nodeName,r=pt(t),a=pt(e),s=G(t),l=K(e),u=parseFloat(l.borderTopWidth),f=parseFloat(l.borderLeftWidth);n&&o&&(a.top=Math.max(a.top,0),a.left=Math.max(a.left,0));var d=ht({top:r.top-a.top-u,left:r.left-a.left-f,width:r.width,height:r.height});if(d.marginTop=0,d.marginLeft=0,!i&&o){var c=parseFloat(l.marginTop),h=parseFloat(l.marginLeft);d.top-=u-c,d.bottom-=u-c,d.left-=f-h,d.right-=f-h,d.marginTop=c,d.marginLeft=h}return(i&&!n?e.contains(s):e===s&&"BODY"!==s.nodeName)&&(d=rt(d,e)),d}function gt(t){var e=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=t.ownerDocument.documentElement,i=mt(t,n),o=Math.max(n.clientWidth,window.innerWidth||0),r=Math.max(n.clientHeight,window.innerHeight||0),a=e?0:ot(n),s=e?0:ot(n,"left"),l={top:a-i.top+i.marginTop,left:s-i.left+i.marginLeft,width:o,height:r};return ht(l)}function _t(t){var e=t.nodeName;if("BODY"===e||"HTML"===e)return!1;if("fixed"===K(t,"position"))return!0;var n=X(t);return!!n&&_t(n)}function vt(t){if(!t||!t.parentElement||tt())return document.documentElement;for(var e=t.parentElement;e&&"none"===K(e,"transform");)e=e.parentElement;return e||document.documentElement}function bt(t,e,n,i){var o=arguments.length>4&&void 0!==arguments[4]&&arguments[4],r={top:0,left:0},a=o?vt(t):it(t,$(e));if("viewport"===i)r=gt(a,o);else{var s=void 0;"scrollParent"===i?"BODY"===(s=G(X(e))).nodeName&&(s=t.ownerDocument.documentElement):s="window"===i?t.ownerDocument.documentElement:i;var l=mt(s,a,o);if("HTML"!==s.nodeName||_t(a))r=l;else{var u=lt(t.ownerDocument),f=u.height,d=u.width;r.top+=l.top-l.marginTop,r.bottom=f+l.top,r.left+=l.left-l.marginLeft,r.right=d+l.left}}var c="number"==typeof(n=n||0);return r.left+=c?n:n.left||0,r.top+=c?n:n.top||0,r.right-=c?n:n.right||0,r.bottom-=c?n:n.bottom||0,r}function yt(t){return t.width*t.height}function Et(t,e,n,i,o){var r=arguments.length>5&&void 0!==arguments[5]?arguments[5]:0;if(-1===t.indexOf("auto"))return t;var a=bt(n,i,r,o),s={top:{width:a.width,height:e.top-a.top},right:{width:a.right-e.right,height:a.height},bottom:{width:a.width,height:a.bottom-e.bottom},left:{width:e.left-a.left,height:a.height}},l=Object.keys(s).map((function(t){return ct({key:t},s[t],{area:yt(s[t])})})).sort((function(t,e){return e.area-t.area})),u=l.filter((function(t){var e=t.width,i=t.height;return e>=n.clientWidth&&i>=n.clientHeight})),f=u.length>0?u[0].key:l[0].key,d=t.split("-")[1];return f+(d?"-"+d:"")}function wt(t,e,n){var i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:null,o=i?vt(e):it(e,$(n));return mt(n,o,i)}function Tt(t){var e=t.ownerDocument.defaultView.getComputedStyle(t),n=parseFloat(e.marginTop||0)+parseFloat(e.marginBottom||0),i=parseFloat(e.marginLeft||0)+parseFloat(e.marginRight||0);return{width:t.offsetWidth+i,height:t.offsetHeight+n}}function Ct(t){var e={left:"right",right:"left",bottom:"top",top:"bottom"};return t.replace(/left|right|bottom|top/g,(function(t){return e[t]}))}function St(t,e,n){n=n.split("-")[0];var i=Tt(t),o={width:i.width,height:i.height},r=-1!==["right","left"].indexOf(n),a=r?"top":"left",s=r?"left":"top",l=r?"height":"width",u=r?"width":"height";return o[a]=e[a]+e[l]/2-i[l]/2,o[s]=n===s?e[s]-i[u]:e[Ct(s)],o}function Nt(t,e){return Array.prototype.find?t.find(e):t.filter(e)[0]}function Dt(t,e,n){return(void 0===n?t:t.slice(0,function(t,e,n){if(Array.prototype.findIndex)return t.findIndex((function(t){return t.name===n}));var i=Nt(t,(function(t){return t.name===n}));return t.indexOf(i)}(t,0,n))).forEach((function(t){t.function&&console.warn("`modifier.function` is deprecated, use `modifier.fn`!");var n=t.function||t.fn;t.enabled&&z(n)&&(e.offsets.popper=ht(e.offsets.popper),e.offsets.reference=ht(e.offsets.reference),e=n(e,t))})),e}function At(){if(!this.state.isDestroyed){var t={instance:this,styles:{},arrowStyles:{},attributes:{},flipped:!1,offsets:{}};t.offsets.reference=wt(this.state,this.popper,this.reference,this.options.positionFixed),t.placement=Et(this.options.placement,t.offsets.reference,this.popper,this.reference,this.options.modifiers.flip.boundariesElement,this.options.modifiers.flip.padding),t.originalPlacement=t.placement,t.positionFixed=this.options.positionFixed,t.offsets.popper=St(this.popper,t.offsets.reference,t.placement),t.offsets.popper.position=this.options.positionFixed?"fixed":"absolute",t=Dt(this.modifiers,t),this.state.isCreated?this.options.onUpdate(t):(this.state.isCreated=!0,this.options.onCreate(t))}}function kt(t,e){return t.some((function(t){var n=t.name;return t.enabled&&n===e}))}function It(t){for(var e=[!1,"ms","Webkit","Moz","O"],n=t.charAt(0).toUpperCase()+t.slice(1),i=0;i<e.length;i++){var o=e[i],r=o?""+o+n:t;if("undefined"!=typeof document.body.style[r])return r}return null}function Ot(){return this.state.isDestroyed=!0,kt(this.modifiers,"applyStyle")&&(this.popper.removeAttribute("x-placement"),this.popper.style.position="",this.popper.style.top="",this.popper.style.left="",this.popper.style.right="",this.popper.style.bottom="",this.popper.style.willChange="",this.popper.style[It("transform")]=""),this.disableEventListeners(),this.options.removeOnDestroy&&this.popper.parentNode.removeChild(this.popper),this}function xt(t){var e=t.ownerDocument;return e?e.defaultView:window}function jt(t,e,n,i){var o="BODY"===t.nodeName,r=o?t.ownerDocument.defaultView:t;r.addEventListener(e,n,{passive:!0}),o||jt(G(r.parentNode),e,n,i),i.push(r)}function Lt(t,e,n,i){n.updateBound=i,xt(t).addEventListener("resize",n.updateBound,{passive:!0});var o=G(t);return jt(o,"scroll",n.updateBound,n.scrollParents),n.scrollElement=o,n.eventsEnabled=!0,n}function Pt(){this.state.eventsEnabled||(this.state=Lt(this.reference,this.options,this.state,this.scheduleUpdate))}function Ft(){var t,e;this.state.eventsEnabled&&(cancelAnimationFrame(this.scheduleUpdate),this.state=(t=this.reference,e=this.state,xt(t).removeEventListener("resize",e.updateBound),e.scrollParents.forEach((function(t){t.removeEventListener("scroll",e.updateBound)})),e.updateBound=null,e.scrollParents=[],e.scrollElement=null,e.eventsEnabled=!1,e))}function Rt(t){return""!==t&&!isNaN(parseFloat(t))&&isFinite(t)}function Bt(t,e){Object.keys(e).forEach((function(n){var i="";-1!==["width","height","top","right","bottom","left"].indexOf(n)&&Rt(e[n])&&(i="px"),t.style[n]=e[n]+i}))}var Ht=U&&/Firefox/i.test(navigator.userAgent);function Mt(t,e,n){var i=Nt(t,(function(t){return t.name===e})),o=!!i&&t.some((function(t){return t.name===n&&t.enabled&&t.order<i.order}));if(!o){var r="`"+e+"`",a="`"+n+"`";console.warn(a+" modifier is required by "+r+" modifier in order to work, be sure to include it before "+r+"!")}return o}var qt=["auto-start","auto","auto-end","top-start","top","top-end","right-start","right","right-end","bottom-end","bottom","bottom-start","left-end","left","left-start"],Qt=qt.slice(3);function Wt(t){var e=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=Qt.indexOf(t),i=Qt.slice(n+1).concat(Qt.slice(0,n));return e?i.reverse():i}var Ut={placement:"bottom",positionFixed:!1,eventsEnabled:!0,removeOnDestroy:!1,onCreate:function(){},onUpdate:function(){},modifiers:{shift:{order:100,enabled:!0,fn:function(t){var e=t.placement,n=e.split("-")[0],i=e.split("-")[1];if(i){var o=t.offsets,r=o.reference,a=o.popper,s=-1!==["bottom","top"].indexOf(n),l=s?"left":"top",u=s?"width":"height",f={start:dt({},l,r[l]),end:dt({},l,r[l]+r[u]-a[u])};t.offsets.popper=ct({},a,f[i])}return t}},offset:{order:200,enabled:!0,fn:function(t,e){var n,i=e.offset,o=t.placement,r=t.offsets,a=r.popper,s=r.reference,l=o.split("-")[0];return n=Rt(+i)?[+i,0]:function(t,e,n,i){var o=[0,0],r=-1!==["right","left"].indexOf(i),a=t.split(/(\+|\-)/).map((function(t){return t.trim()})),s=a.indexOf(Nt(a,(function(t){return-1!==t.search(/,|\s/)})));a[s]&&-1===a[s].indexOf(",")&&console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");var l=/\s*,\s*|\s+/,u=-1!==s?[a.slice(0,s).concat([a[s].split(l)[0]]),[a[s].split(l)[1]].concat(a.slice(s+1))]:[a];return u=u.map((function(t,i){var o=(1===i?!r:r)?"height":"width",a=!1;return t.reduce((function(t,e){return""===t[t.length-1]&&-1!==["+","-"].indexOf(e)?(t[t.length-1]=e,a=!0,t):a?(t[t.length-1]+=e,a=!1,t):t.concat(e)}),[]).map((function(t){return function(t,e,n,i){var o=t.match(/((?:\-|\+)?\d*\.?\d*)(.*)/),r=+o[1],a=o[2];return r?0===a.indexOf("%")?ht("%p"===a?n:i)[e]/100*r:"vh"===a||"vw"===a?("vh"===a?Math.max(document.documentElement.clientHeight,window.innerHeight||0):Math.max(document.documentElement.clientWidth,window.innerWidth||0))/100*r:r:t}(t,o,e,n)}))})),u.forEach((function(t,e){t.forEach((function(n,i){Rt(n)&&(o[e]+=n*("-"===t[i-1]?-1:1))}))})),o}(i,a,s,l),"left"===l?(a.top+=n[0],a.left-=n[1]):"right"===l?(a.top+=n[0],a.left+=n[1]):"top"===l?(a.left+=n[0],a.top-=n[1]):"bottom"===l&&(a.left+=n[0],a.top+=n[1]),t.popper=a,t},offset:0},preventOverflow:{order:300,enabled:!0,fn:function(t,e){var n=e.boundariesElement||et(t.instance.popper);t.instance.reference===n&&(n=et(n));var i=It("transform"),o=t.instance.popper.style,r=o.top,a=o.left,s=o[i];o.top="",o.left="",o[i]="";var l=bt(t.instance.popper,t.instance.reference,e.padding,n,t.positionFixed);o.top=r,o.left=a,o[i]=s,e.boundaries=l;var u=e.priority,f=t.offsets.popper,d={primary:function(t){var n=f[t];return f[t]<l[t]&&!e.escapeWithReference&&(n=Math.max(f[t],l[t])),dt({},t,n)},secondary:function(t){var n="right"===t?"left":"top",i=f[n];return f[t]>l[t]&&!e.escapeWithReference&&(i=Math.min(f[n],l[t]-("right"===t?f.width:f.height))),dt({},n,i)}};return u.forEach((function(t){var e=-1!==["left","top"].indexOf(t)?"primary":"secondary";f=ct({},f,d[e](t))})),t.offsets.popper=f,t},priority:["left","right","top","bottom"],padding:5,boundariesElement:"scrollParent"},keepTogether:{order:400,enabled:!0,fn:function(t){var e=t.offsets,n=e.popper,i=e.reference,o=t.placement.split("-")[0],r=Math.floor,a=-1!==["top","bottom"].indexOf(o),s=a?"right":"bottom",l=a?"left":"top",u=a?"width":"height";return n[s]<r(i[l])&&(t.offsets.popper[l]=r(i[l])-n[u]),n[l]>r(i[s])&&(t.offsets.popper[l]=r(i[s])),t}},arrow:{order:500,enabled:!0,fn:function(t,e){var n;if(!Mt(t.instance.modifiers,"arrow","keepTogether"))return t;var i=e.element;if("string"==typeof i){if(!(i=t.instance.popper.querySelector(i)))return t}else if(!t.instance.popper.contains(i))return console.warn("WARNING: `arrow.element` must be child of its popper element!"),t;var o=t.placement.split("-")[0],r=t.offsets,a=r.popper,s=r.reference,l=-1!==["left","right"].indexOf(o),u=l?"height":"width",f=l?"Top":"Left",d=f.toLowerCase(),c=l?"left":"top",h=l?"bottom":"right",p=Tt(i)[u];s[h]-p<a[d]&&(t.offsets.popper[d]-=a[d]-(s[h]-p)),s[d]+p>a[h]&&(t.offsets.popper[d]+=s[d]+p-a[h]),t.offsets.popper=ht(t.offsets.popper);var m=s[d]+s[u]/2-p/2,g=K(t.instance.popper),_=parseFloat(g["margin"+f]),v=parseFloat(g["border"+f+"Width"]),b=m-t.offsets.popper[d]-_-v;return b=Math.max(Math.min(a[u]-p,b),0),t.arrowElement=i,t.offsets.arrow=(dt(n={},d,Math.round(b)),dt(n,c,""),n),t},element:"[x-arrow]"},flip:{order:600,enabled:!0,fn:function(t,e){if(kt(t.instance.modifiers,"inner"))return t;if(t.flipped&&t.placement===t.originalPlacement)return t;var n=bt(t.instance.popper,t.instance.reference,e.padding,e.boundariesElement,t.positionFixed),i=t.placement.split("-")[0],o=Ct(i),r=t.placement.split("-")[1]||"",a=[];switch(e.behavior){case"flip":a=[i,o];break;case"clockwise":a=Wt(i);break;case"counterclockwise":a=Wt(i,!0);break;default:a=e.behavior}return a.forEach((function(s,l){if(i!==s||a.length===l+1)return t;i=t.placement.split("-")[0],o=Ct(i);var u=t.offsets.popper,f=t.offsets.reference,d=Math.floor,c="left"===i&&d(u.right)>d(f.left)||"right"===i&&d(u.left)<d(f.right)||"top"===i&&d(u.bottom)>d(f.top)||"bottom"===i&&d(u.top)<d(f.bottom),h=d(u.left)<d(n.left),p=d(u.right)>d(n.right),m=d(u.top)<d(n.top),g=d(u.bottom)>d(n.bottom),_="left"===i&&h||"right"===i&&p||"top"===i&&m||"bottom"===i&&g,v=-1!==["top","bottom"].indexOf(i),b=!!e.flipVariations&&(v&&"start"===r&&h||v&&"end"===r&&p||!v&&"start"===r&&m||!v&&"end"===r&&g),y=!!e.flipVariationsByContent&&(v&&"start"===r&&p||v&&"end"===r&&h||!v&&"start"===r&&g||!v&&"end"===r&&m),E=b||y;(c||_||E)&&(t.flipped=!0,(c||_)&&(i=a[l+1]),E&&(r=function(t){return"end"===t?"start":"start"===t?"end":t}(r)),t.placement=i+(r?"-"+r:""),t.offsets.popper=ct({},t.offsets.popper,St(t.instance.popper,t.offsets.reference,t.placement)),t=Dt(t.instance.modifiers,t,"flip"))})),t},behavior:"flip",padding:5,boundariesElement:"viewport",flipVariations:!1,flipVariationsByContent:!1},inner:{order:700,enabled:!1,fn:function(t){var e=t.placement,n=e.split("-")[0],i=t.offsets,o=i.popper,r=i.reference,a=-1!==["left","right"].indexOf(n),s=-1===["top","left"].indexOf(n);return o[a?"left":"top"]=r[n]-(s?o[a?"width":"height"]:0),t.placement=Ct(e),t.offsets.popper=ht(o),t}},hide:{order:800,enabled:!0,fn:function(t){if(!Mt(t.instance.modifiers,"hide","preventOverflow"))return t;var e=t.offsets.reference,n=Nt(t.instance.modifiers,(function(t){return"preventOverflow"===t.name})).boundaries;if(e.bottom<n.top||e.left>n.right||e.top>n.bottom||e.right<n.left){if(!0===t.hide)return t;t.hide=!0,t.attributes["x-out-of-boundaries"]=""}else{if(!1===t.hide)return t;t.hide=!1,t.attributes["x-out-of-boundaries"]=!1}return t}},computeStyle:{order:850,enabled:!0,fn:function(t,e){var n=e.x,i=e.y,o=t.offsets.popper,r=Nt(t.instance.modifiers,(function(t){return"applyStyle"===t.name})).gpuAcceleration;void 0!==r&&console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");var a,s,l=void 0!==r?r:e.gpuAcceleration,u=et(t.instance.popper),f=pt(u),d={position:o.position},c=function(t,e){var n=t.offsets,i=n.popper,o=n.reference,r=Math.round,a=Math.floor,s=function(t){return t},l=r(o.width),u=r(i.width),f=-1!==["left","right"].indexOf(t.placement),d=-1!==t.placement.indexOf("-"),c=e?f||d||l%2==u%2?r:a:s,h=e?r:s;return{left:c(l%2==1&&u%2==1&&!d&&e?i.left-1:i.left),top:h(i.top),bottom:h(i.bottom),right:c(i.right)}}(t,window.devicePixelRatio<2||!Ht),h="bottom"===n?"top":"bottom",p="right"===i?"left":"right",m=It("transform");if(s="bottom"===h?"HTML"===u.nodeName?-u.clientHeight+c.bottom:-f.height+c.bottom:c.top,a="right"===p?"HTML"===u.nodeName?-u.clientWidth+c.right:-f.width+c.right:c.left,l&&m)d[m]="translate3d("+a+"px, "+s+"px, 0)",d[h]=0,d[p]=0,d.willChange="transform";else{var g="bottom"===h?-1:1,_="right"===p?-1:1;d[h]=s*g,d[p]=a*_,d.willChange=h+", "+p}var v={"x-placement":t.placement};return t.attributes=ct({},v,t.attributes),t.styles=ct({},d,t.styles),t.arrowStyles=ct({},t.offsets.arrow,t.arrowStyles),t},gpuAcceleration:!0,x:"bottom",y:"right"},applyStyle:{order:900,enabled:!0,fn:function(t){var e,n;return Bt(t.instance.popper,t.styles),e=t.instance.popper,n=t.attributes,Object.keys(n).forEach((function(t){!1!==n[t]?e.setAttribute(t,n[t]):e.removeAttribute(t)})),t.arrowElement&&Object.keys(t.arrowStyles).length&&Bt(t.arrowElement,t.arrowStyles),t},onLoad:function(t,e,n,i,o){var r=wt(o,e,t,n.positionFixed),a=Et(n.placement,r,e,t,n.modifiers.flip.boundariesElement,n.modifiers.flip.padding);return e.setAttribute("x-placement",a),Bt(e,{position:n.positionFixed?"fixed":"absolute"}),n},gpuAcceleration:void 0}}},Vt=function(){function t(e,n){var i=this,o=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};ut(this,t),this.scheduleUpdate=function(){return requestAnimationFrame(i.update)},this.update=Y(this.update.bind(this)),this.options=ct({},t.Defaults,o),this.state={isDestroyed:!1,isCreated:!1,scrollParents:[]},this.reference=e&&e.jquery?e[0]:e,this.popper=n&&n.jquery?n[0]:n,this.options.modifiers={},Object.keys(ct({},t.Defaults.modifiers,o.modifiers)).forEach((function(e){i.options.modifiers[e]=ct({},t.Defaults.modifiers[e]||{},o.modifiers?o.modifiers[e]:{})})),this.modifiers=Object.keys(this.options.modifiers).map((function(t){return ct({name:t},i.options.modifiers[t])})).sort((function(t,e){return t.order-e.order})),this.modifiers.forEach((function(t){t.enabled&&z(t.onLoad)&&t.onLoad(i.reference,i.popper,i.options,t,i.state)})),this.update();var r=this.options.eventsEnabled;r&&this.enableEventListeners(),this.state.eventsEnabled=r}return ft(t,[{key:"update",value:function(){return At.call(this)}},{key:"destroy",value:function(){return Ot.call(this)}},{key:"enableEventListeners",value:function(){return Pt.call(this)}},{key:"disableEventListeners",value:function(){return Ft.call(this)}}]),t}();Vt.Utils=("undefined"!=typeof window?window:global).PopperUtils,Vt.placements=qt,Vt.Defaults=Ut;var Yt=Vt,zt="dropdown",Kt="bs.dropdown",Xt=i.default.fn[zt],Gt=new RegExp("38|40|27"),$t="disabled",Jt="show",Zt="dropdown-menu-right",te="hide.bs.dropdown",ee="hidden.bs.dropdown",ne="click.bs.dropdown.data-api",ie="keydown.bs.dropdown.data-api",oe='[data-toggle="dropdown"]',re=".dropdown-menu",ae={offset:0,flip:!0,boundary:"scrollParent",reference:"toggle",display:"dynamic",popperConfig:null},se={offset:"(number|string|function)",flip:"boolean",boundary:"(string|element)",reference:"(string|element)",display:"string",popperConfig:"(null|object)"},le=function(){function t(t,e){this._element=t,this._popper=null,this._config=this._getConfig(e),this._menu=this._getMenuElement(),this._inNavbar=this._detectNavbar(),this._addEventListeners()}var e=t.prototype;return e.toggle=function(){if(!this._element.disabled&&!i.default(this._element).hasClass($t)){var e=i.default(this._menu).hasClass(Jt);t._clearMenus(),e||this.show(!0)}},e.show=function(e){if(void 0===e&&(e=!1),!(this._element.disabled||i.default(this._element).hasClass($t)||i.default(this._menu).hasClass(Jt))){var n={relatedTarget:this._element},o=i.default.Event("show.bs.dropdown",n),r=t._getParentFromElement(this._element);if(i.default(r).trigger(o),!o.isDefaultPrevented()){if(!this._inNavbar&&e){if("undefined"==typeof Yt)throw new TypeError("Bootstrap's dropdowns require Popper (https://popper.js.org)");var a=this._element;"parent"===this._config.reference?a=r:u.isElement(this._config.reference)&&(a=this._config.reference,"undefined"!=typeof this._config.reference.jquery&&(a=this._config.reference[0])),"scrollParent"!==this._config.boundary&&i.default(r).addClass("position-static"),this._popper=new Yt(a,this._menu,this._getPopperConfig())}"ontouchstart"in document.documentElement&&0===i.default(r).closest(".navbar-nav").length&&i.default(document.body).children().on("mouseover",null,i.default.noop),this._element.focus(),this._element.setAttribute("aria-expanded",!0),i.default(this._menu).toggleClass(Jt),i.default(r).toggleClass(Jt).trigger(i.default.Event("shown.bs.dropdown",n))}}},e.hide=function(){if(!this._element.disabled&&!i.default(this._element).hasClass($t)&&i.default(this._menu).hasClass(Jt)){var e={relatedTarget:this._element},n=i.default.Event(te,e),o=t._getParentFromElement(this._element);i.default(o).trigger(n),n.isDefaultPrevented()||(this._popper&&this._popper.destroy(),i.default(this._menu).toggleClass(Jt),i.default(o).toggleClass(Jt).trigger(i.default.Event(ee,e)))}},e.dispose=function(){i.default.removeData(this._element,Kt),i.default(this._element).off(".bs.dropdown"),this._element=null,this._menu=null,null!==this._popper&&(this._popper.destroy(),this._popper=null)},e.update=function(){this._inNavbar=this._detectNavbar(),null!==this._popper&&this._popper.scheduleUpdate()},e._addEventListeners=function(){var t=this;i.default(this._element).on("click.bs.dropdown",(function(e){e.preventDefault(),e.stopPropagation(),t.toggle()}))},e._getConfig=function(t){return t=a({},this.constructor.Default,i.default(this._element).data(),t),u.typeCheckConfig(zt,t,this.constructor.DefaultType),t},e._getMenuElement=function(){if(!this._menu){var e=t._getParentFromElement(this._element);e&&(this._menu=e.querySelector(re))}return this._menu},e._getPlacement=function(){var t=i.default(this._element.parentNode),e="bottom-start";return t.hasClass("dropup")?e=i.default(this._menu).hasClass(Zt)?"top-end":"top-start":t.hasClass("dropright")?e="right-start":t.hasClass("dropleft")?e="left-start":i.default(this._menu).hasClass(Zt)&&(e="bottom-end"),e},e._detectNavbar=function(){return i.default(this._element).closest(".navbar").length>0},e._getOffset=function(){var t=this,e={};return"function"==typeof this._config.offset?e.fn=function(e){return e.offsets=a({},e.offsets,t._config.offset(e.offsets,t._element)),e}:e.offset=this._config.offset,e},e._getPopperConfig=function(){var t={placement:this._getPlacement(),modifiers:{offset:this._getOffset(),flip:{enabled:this._config.flip},preventOverflow:{boundariesElement:this._config.boundary}}};return"static"===this._config.display&&(t.modifiers.applyStyle={enabled:!1}),a({},t,this._config.popperConfig)},t._jQueryInterface=function(e){return this.each((function(){var n=i.default(this).data(Kt);if(n||(n=new t(this,"object"==typeof e?e:null),i.default(this).data(Kt,n)),"string"==typeof e){if("undefined"==typeof n[e])throw new TypeError('No method named "'+e+'"');n[e]()}}))},t._clearMenus=function(e){if(!e||3!==e.which&&("keyup"!==e.type||9===e.which))for(var n=[].slice.call(document.querySelectorAll(oe)),o=0,r=n.length;o<r;o++){var a=t._getParentFromElement(n[o]),s=i.default(n[o]).data(Kt),l={relatedTarget:n[o]};if(e&&"click"===e.type&&(l.clickEvent=e),s){var u=s._menu;if(i.default(a).hasClass(Jt)&&!(e&&("click"===e.type&&/input|textarea/i.test(e.target.tagName)||"keyup"===e.type&&9===e.which)&&i.default.contains(a,e.target))){var f=i.default.Event(te,l);i.default(a).trigger(f),f.isDefaultPrevented()||("ontouchstart"in document.documentElement&&i.default(document.body).children().off("mouseover",null,i.default.noop),n[o].setAttribute("aria-expanded","false"),s._popper&&s._popper.destroy(),i.default(u).removeClass(Jt),i.default(a).removeClass(Jt).trigger(i.default.Event(ee,l)))}}}},t._getParentFromElement=function(t){var e,n=u.getSelectorFromElement(t);return n&&(e=document.querySelector(n)),e||t.parentNode},t._dataApiKeydownHandler=function(e){if(!(/input|textarea/i.test(e.target.tagName)?32===e.which||27!==e.which&&(40!==e.which&&38!==e.which||i.default(e.target).closest(re).length):!Gt.test(e.which))&&!this.disabled&&!i.default(this).hasClass($t)){var n=t._getParentFromElement(this),o=i.default(n).hasClass(Jt);if(o||27!==e.which){if(e.preventDefault(),e.stopPropagation(),!o||27===e.which||32===e.which)return 27===e.which&&i.default(n.querySelector(oe)).trigger("focus"),void i.default(this).trigger("click");var r=[].slice.call(n.querySelectorAll(".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)")).filter((function(t){return i.default(t).is(":visible")}));if(0!==r.length){var a=r.indexOf(e.target);38===e.which&&a>0&&a--,40===e.which&&a<r.length-1&&a++,a<0&&(a=0),r[a].focus()}}}},r(t,null,[{key:"VERSION",get:function(){return"4.6.2"}},{key:"Default",get:function(){return ae}},{key:"DefaultType",get:function(){return se}}]),t}();i.default(document).on(ie,oe,le._dataApiKeydownHandler).on(ie,re,le._dataApiKeydownHandler).on(ne+" keyup.bs.dropdown.data-api",le._clearMenus).on(ne,oe,(function(t){t.preventDefault(),t.stopPropagation(),le._jQueryInterface.call(i.default(this),"toggle")})).on(ne,".dropdown form",(function(t){t.stopPropagation()})),i.default.fn[zt]=le._jQueryInterface,i.default.fn[zt].Constructor=le,i.default.fn[zt].noConflict=function(){return i.default.fn[zt]=Xt,le._jQueryInterface};var ue="bs.modal",fe=i.default.fn.modal,de="modal-open",ce="fade",he="show",pe="modal-static",me="hidden.bs.modal",ge="show.bs.modal",_e="focusin.bs.modal",ve="resize.bs.modal",be="click.dismiss.bs.modal",ye="keydown.dismiss.bs.modal",Ee="mousedown.dismiss.bs.modal",we=".fixed-top, .fixed-bottom, .is-fixed, .sticky-top",Te={backdrop:!0,keyboard:!0,focus:!0,show:!0},Ce={backdrop:"(boolean|string)",keyboard:"boolean",focus:"boolean",show:"boolean"},Se=function(){function t(t,e){this._config=this._getConfig(e),this._element=t,this._dialog=t.querySelector(".modal-dialog"),this._backdrop=null,this._isShown=!1,this._isBodyOverflowing=!1,this._ignoreBackdropClick=!1,this._isTransitioning=!1,this._scrollbarWidth=0}var e=t.prototype;return e.toggle=function(t){return this._isShown?this.hide():this.show(t)},e.show=function(t){var e=this;if(!this._isShown&&!this._isTransitioning){var n=i.default.Event(ge,{relatedTarget:t});i.default(this._element).trigger(n),n.isDefaultPrevented()||(this._isShown=!0,i.default(this._element).hasClass(ce)&&(this._isTransitioning=!0),this._checkScrollbar(),this._setScrollbar(),this._adjustDialog(),this._setEscapeEvent(),this._setResizeEvent(),i.default(this._element).on(be,'[data-dismiss="modal"]',(function(t){return e.hide(t)})),i.default(this._dialog).on(Ee,(function(){i.default(e._element).one("mouseup.dismiss.bs.modal",(function(t){i.default(t.target).is(e._element)&&(e._ignoreBackdropClick=!0)}))})),this._showBackdrop((function(){return e._showElement(t)})))}},e.hide=function(t){var e=this;if(t&&t.preventDefault(),this._isShown&&!this._isTransitioning){var n=i.default.Event("hide.bs.modal");if(i.default(this._element).trigger(n),this._isShown&&!n.isDefaultPrevented()){this._isShown=!1;var o=i.default(this._element).hasClass(ce);if(o&&(this._isTransitioning=!0),this._setEscapeEvent(),this._setResizeEvent(),i.default(document).off(_e),i.default(this._element).removeClass(he),i.default(this._element).off(be),i.default(this._dialog).off(Ee),o){var r=u.getTransitionDurationFromElement(this._element);i.default(this._element).one(u.TRANSITION_END,(function(t){return e._hideModal(t)})).emulateTransitionEnd(r)}else this._hideModal()}}},e.dispose=function(){[window,this._element,this._dialog].forEach((function(t){return i.default(t).off(".bs.modal")})),i.default(document).off(_e),i.default.removeData(this._element,ue),this._config=null,this._element=null,this._dialog=null,this._backdrop=null,this._isShown=null,this._isBodyOverflowing=null,this._ignoreBackdropClick=null,this._isTransitioning=null,this._scrollbarWidth=null},e.handleUpdate=function(){this._adjustDialog()},e._getConfig=function(t){return t=a({},Te,t),u.typeCheckConfig("modal",t,Ce),t},e._triggerBackdropTransition=function(){var t=this,e=i.default.Event("hidePrevented.bs.modal");if(i.default(this._element).trigger(e),!e.isDefaultPrevented()){var n=this._element.scrollHeight>document.documentElement.clientHeight;n||(this._element.style.overflowY="hidden"),this._element.classList.add(pe);var o=u.getTransitionDurationFromElement(this._dialog);i.default(this._element).off(u.TRANSITION_END),i.default(this._element).one(u.TRANSITION_END,(function(){t._element.classList.remove(pe),n||i.default(t._element).one(u.TRANSITION_END,(function(){t._element.style.overflowY=""})).emulateTransitionEnd(t._element,o)})).emulateTransitionEnd(o),this._element.focus()}},e._showElement=function(t){var e=this,n=i.default(this._element).hasClass(ce),o=this._dialog?this._dialog.querySelector(".modal-body"):null;this._element.parentNode&&this._element.parentNode.nodeType===Node.ELEMENT_NODE||document.body.appendChild(this._element),this._element.style.display="block",this._element.removeAttribute("aria-hidden"),this._element.setAttribute("aria-modal",!0),this._element.setAttribute("role","dialog"),i.default(this._dialog).hasClass("modal-dialog-scrollable")&&o?o.scrollTop=0:this._element.scrollTop=0,n&&u.reflow(this._element),i.default(this._element).addClass(he),this._config.focus&&this._enforceFocus();var r=i.default.Event("shown.bs.modal",{relatedTarget:t}),a=function(){e._config.focus&&e._element.focus(),e._isTransitioning=!1,i.default(e._element).trigger(r)};if(n){var s=u.getTransitionDurationFromElement(this._dialog);i.default(this._dialog).one(u.TRANSITION_END,a).emulateTransitionEnd(s)}else a()},e._enforceFocus=function(){var t=this;i.default(document).off(_e).on(_e,(function(e){document!==e.target&&t._element!==e.target&&0===i.default(t._element).has(e.target).length&&t._element.focus()}))},e._setEscapeEvent=function(){var t=this;this._isShown?i.default(this._element).on(ye,(function(e){t._config.keyboard&&27===e.which?(e.preventDefault(),t.hide()):t._config.keyboard||27!==e.which||t._triggerBackdropTransition()})):this._isShown||i.default(this._element).off(ye)},e._setResizeEvent=function(){var t=this;this._isShown?i.default(window).on(ve,(function(e){return t.handleUpdate(e)})):i.default(window).off(ve)},e._hideModal=function(){var t=this;this._element.style.display="none",this._element.setAttribute("aria-hidden",!0),this._element.removeAttribute("aria-modal"),this._element.removeAttribute("role"),this._isTransitioning=!1,this._showBackdrop((function(){i.default(document.body).removeClass(de),t._resetAdjustments(),t._resetScrollbar(),i.default(t._element).trigger(me)}))},e._removeBackdrop=function(){this._backdrop&&(i.default(this._backdrop).remove(),this._backdrop=null)},e._showBackdrop=function(t){var e=this,n=i.default(this._element).hasClass(ce)?ce:"";if(this._isShown&&this._config.backdrop){if(this._backdrop=document.createElement("div"),this._backdrop.className="modal-backdrop",n&&this._backdrop.classList.add(n),i.default(this._backdrop).appendTo(document.body),i.default(this._element).on(be,(function(t){e._ignoreBackdropClick?e._ignoreBackdropClick=!1:t.target===t.currentTarget&&("static"===e._config.backdrop?e._triggerBackdropTransition():e.hide())})),n&&u.reflow(this._backdrop),i.default(this._backdrop).addClass(he),!t)return;if(!n)return void t();var o=u.getTransitionDurationFromElement(this._backdrop);i.default(this._backdrop).one(u.TRANSITION_END,t).emulateTransitionEnd(o)}else if(!this._isShown&&this._backdrop){i.default(this._backdrop).removeClass(he);var r=function(){e._removeBackdrop(),t&&t()};if(i.default(this._element).hasClass(ce)){var a=u.getTransitionDurationFromElement(this._backdrop);i.default(this._backdrop).one(u.TRANSITION_END,r).emulateTransitionEnd(a)}else r()}else t&&t()},e._adjustDialog=function(){var t=this._element.scrollHeight>document.documentElement.clientHeight;!this._isBodyOverflowing&&t&&(this._element.style.paddingLeft=this._scrollbarWidth+"px"),this._isBodyOverflowing&&!t&&(this._element.style.paddingRight=this._scrollbarWidth+"px")},e._resetAdjustments=function(){this._element.style.paddingLeft="",this._element.style.paddingRight=""},e._checkScrollbar=function(){var t=document.body.getBoundingClientRect();this._isBodyOverflowing=Math.round(t.left+t.right)<window.innerWidth,this._scrollbarWidth=this._getScrollbarWidth()},e._setScrollbar=function(){var t=this;if(this._isBodyOverflowing){var e=[].slice.call(document.querySelectorAll(we)),n=[].slice.call(document.querySelectorAll(".sticky-top"));i.default(e).each((function(e,n){var o=n.style.paddingRight,r=i.default(n).css("padding-right");i.default(n).data("padding-right",o).css("padding-right",parseFloat(r)+t._scrollbarWidth+"px")})),i.default(n).each((function(e,n){var o=n.style.marginRight,r=i.default(n).css("margin-right");i.default(n).data("margin-right",o).css("margin-right",parseFloat(r)-t._scrollbarWidth+"px")}));var o=document.body.style.paddingRight,r=i.default(document.body).css("padding-right");i.default(document.body).data("padding-right",o).css("padding-right",parseFloat(r)+this._scrollbarWidth+"px")}i.default(document.body).addClass(de)},e._resetScrollbar=function(){var t=[].slice.call(document.querySelectorAll(we));i.default(t).each((function(t,e){var n=i.default(e).data("padding-right");i.default(e).removeData("padding-right"),e.style.paddingRight=n||""}));var e=[].slice.call(document.querySelectorAll(".sticky-top"));i.default(e).each((function(t,e){var n=i.default(e).data("margin-right");"undefined"!=typeof n&&i.default(e).css("margin-right",n).removeData("margin-right")}));var n=i.default(document.body).data("padding-right");i.default(document.body).removeData("padding-right"),document.body.style.paddingRight=n||""},e._getScrollbarWidth=function(){var t=document.createElement("div");t.className="modal-scrollbar-measure",document.body.appendChild(t);var e=t.getBoundingClientRect().width-t.clientWidth;return document.body.removeChild(t),e},t._jQueryInterface=function(e,n){return this.each((function(){var o=i.default(this).data(ue),r=a({},Te,i.default(this).data(),"object"==typeof e&&e?e:{});if(o||(o=new t(this,r),i.default(this).data(ue,o)),"string"==typeof e){if("undefined"==typeof o[e])throw new TypeError('No method named "'+e+'"');o[e](n)}else r.show&&o.show(n)}))},r(t,null,[{key:"VERSION",get:function(){return"4.6.2"}},{key:"Default",get:function(){return Te}}]),t}();i.default(document).on("click.bs.modal.data-api",'[data-toggle="modal"]',(function(t){var e,n=this,o=u.getSelectorFromElement(this);o&&(e=document.querySelector(o));var r=i.default(e).data(ue)?"toggle":a({},i.default(e).data(),i.default(this).data());"A"!==this.tagName&&"AREA"!==this.tagName||t.preventDefault();var s=i.default(e).one(ge,(function(t){t.isDefaultPrevented()||s.one(me,(function(){i.default(n).is(":visible")&&n.focus()}))}));Se._jQueryInterface.call(i.default(e),r,this)})),i.default.fn.modal=Se._jQueryInterface,i.default.fn.modal.Constructor=Se,i.default.fn.modal.noConflict=function(){return i.default.fn.modal=fe,Se._jQueryInterface};var Ne=["background","cite","href","itemtype","longdesc","poster","src","xlink:href"],De=/^(?:(?:https?|mailto|ftp|tel|file|sms):|[^#&/:?]*(?:[#/?]|$))/i,Ae=/^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[\d+/a-z]+=*$/i;function ke(t,e,n){if(0===t.length)return t;if(n&&"function"==typeof n)return n(t);for(var i=(new window.DOMParser).parseFromString(t,"text/html"),o=Object.keys(e),r=[].slice.call(i.body.querySelectorAll("*")),a=function(t,n){var i=r[t],a=i.nodeName.toLowerCase();if(-1===o.indexOf(i.nodeName.toLowerCase()))return i.parentNode.removeChild(i),"continue";var s=[].slice.call(i.attributes),l=[].concat(e["*"]||[],e[a]||[]);s.forEach((function(t){(function(t,e){var n=t.nodeName.toLowerCase();if(-1!==e.indexOf(n))return-1===Ne.indexOf(n)||Boolean(De.test(t.nodeValue)||Ae.test(t.nodeValue));for(var i=e.filter((function(t){return t instanceof RegExp})),o=0,r=i.length;o<r;o++)if(i[o].test(n))return!0;return!1})(t,l)||i.removeAttribute(t.nodeName)}))},s=0,l=r.length;s<l;s++)a(s);return i.body.innerHTML}var Ie="tooltip",Oe="bs.tooltip",xe=i.default.fn.tooltip,je=new RegExp("(^|\\s)bs-tooltip\\S+","g"),Le=["sanitize","whiteList","sanitizeFn"],Pe="fade",Fe="show",Re="show",Be="out",He="hover",Me="focus",qe={AUTO:"auto",TOP:"top",RIGHT:"right",BOTTOM:"bottom",LEFT:"left"},Qe={animation:!0,template:'<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',trigger:"hover focus",title:"",delay:0,html:!1,selector:!1,placement:"top",offset:0,container:!1,fallbackPlacement:"flip",boundary:"scrollParent",customClass:"",sanitize:!0,sanitizeFn:null,whiteList:{"*":["class","dir","id","lang","role",/^aria-[\w-]*$/i],a:["target","href","title","rel"],area:[],b:[],br:[],col:[],code:[],div:[],em:[],hr:[],h1:[],h2:[],h3:[],h4:[],h5:[],h6:[],i:[],img:["src","srcset","alt","title","width","height"],li:[],ol:[],p:[],pre:[],s:[],small:[],span:[],sub:[],sup:[],strong:[],u:[],ul:[]},popperConfig:null},We={animation:"boolean",template:"string",title:"(string|element|function)",trigger:"string",delay:"(number|object)",html:"boolean",selector:"(string|boolean)",placement:"(string|function)",offset:"(number|string|function)",container:"(string|element|boolean)",fallbackPlacement:"(string|array)",boundary:"(string|element)",customClass:"(string|function)",sanitize:"boolean",sanitizeFn:"(null|function)",whiteList:"object",popperConfig:"(null|object)"},Ue={HIDE:"hide.bs.tooltip",HIDDEN:"hidden.bs.tooltip",SHOW:"show.bs.tooltip",SHOWN:"shown.bs.tooltip",INSERTED:"inserted.bs.tooltip",CLICK:"click.bs.tooltip",FOCUSIN:"focusin.bs.tooltip",FOCUSOUT:"focusout.bs.tooltip",MOUSEENTER:"mouseenter.bs.tooltip",MOUSELEAVE:"mouseleave.bs.tooltip"},Ve=function(){function t(t,e){if("undefined"==typeof Yt)throw new TypeError("Bootstrap's tooltips require Popper (https://popper.js.org)");this._isEnabled=!0,this._timeout=0,this._hoverState="",this._activeTrigger={},this._popper=null,this.element=t,this.config=this._getConfig(e),this.tip=null,this._setListeners()}var e=t.prototype;return e.enable=function(){this._isEnabled=!0},e.disable=function(){this._isEnabled=!1},e.toggleEnabled=function(){this._isEnabled=!this._isEnabled},e.toggle=function(t){if(this._isEnabled)if(t){var e=this.constructor.DATA_KEY,n=i.default(t.currentTarget).data(e);n||(n=new this.constructor(t.currentTarget,this._getDelegateConfig()),i.default(t.currentTarget).data(e,n)),n._activeTrigger.click=!n._activeTrigger.click,n._isWithActiveTrigger()?n._enter(null,n):n._leave(null,n)}else{if(i.default(this.getTipElement()).hasClass(Fe))return void this._leave(null,this);this._enter(null,this)}},e.dispose=function(){clearTimeout(this._timeout),i.default.removeData(this.element,this.constructor.DATA_KEY),i.default(this.element).off(this.constructor.EVENT_KEY),i.default(this.element).closest(".modal").off("hide.bs.modal",this._hideModalHandler),this.tip&&i.default(this.tip).remove(),this._isEnabled=null,this._timeout=null,this._hoverState=null,this._activeTrigger=null,this._popper&&this._popper.destroy(),this._popper=null,this.element=null,this.config=null,this.tip=null},e.show=function(){var t=this;if("none"===i.default(this.element).css("display"))throw new Error("Please use show on visible elements");var e=i.default.Event(this.constructor.Event.SHOW);if(this.isWithContent()&&this._isEnabled){i.default(this.element).trigger(e);var n=u.findShadowRoot(this.element),o=i.default.contains(null!==n?n:this.element.ownerDocument.documentElement,this.element);if(e.isDefaultPrevented()||!o)return;var r=this.getTipElement(),a=u.getUID(this.constructor.NAME);r.setAttribute("id",a),this.element.setAttribute("aria-describedby",a),this.setContent(),this.config.animation&&i.default(r).addClass(Pe);var s="function"==typeof this.config.placement?this.config.placement.call(this,r,this.element):this.config.placement,l=this._getAttachment(s);this.addAttachmentClass(l);var f=this._getContainer();i.default(r).data(this.constructor.DATA_KEY,this),i.default.contains(this.element.ownerDocument.documentElement,this.tip)||i.default(r).appendTo(f),i.default(this.element).trigger(this.constructor.Event.INSERTED),this._popper=new Yt(this.element,r,this._getPopperConfig(l)),i.default(r).addClass(Fe),i.default(r).addClass(this.config.customClass),"ontouchstart"in document.documentElement&&i.default(document.body).children().on("mouseover",null,i.default.noop);var d=function(){t.config.animation&&t._fixTransition();var e=t._hoverState;t._hoverState=null,i.default(t.element).trigger(t.constructor.Event.SHOWN),e===Be&&t._leave(null,t)};if(i.default(this.tip).hasClass(Pe)){var c=u.getTransitionDurationFromElement(this.tip);i.default(this.tip).one(u.TRANSITION_END,d).emulateTransitionEnd(c)}else d()}},e.hide=function(t){var e=this,n=this.getTipElement(),o=i.default.Event(this.constructor.Event.HIDE),r=function(){e._hoverState!==Re&&n.parentNode&&n.parentNode.removeChild(n),e._cleanTipClass(),e.element.removeAttribute("aria-describedby"),i.default(e.element).trigger(e.constructor.Event.HIDDEN),null!==e._popper&&e._popper.destroy(),t&&t()};if(i.default(this.element).trigger(o),!o.isDefaultPrevented()){if(i.default(n).removeClass(Fe),"ontouchstart"in document.documentElement&&i.default(document.body).children().off("mouseover",null,i.default.noop),this._activeTrigger.click=!1,this._activeTrigger.focus=!1,this._activeTrigger.hover=!1,i.default(this.tip).hasClass(Pe)){var a=u.getTransitionDurationFromElement(n);i.default(n).one(u.TRANSITION_END,r).emulateTransitionEnd(a)}else r();this._hoverState=""}},e.update=function(){null!==this._popper&&this._popper.scheduleUpdate()},e.isWithContent=function(){return Boolean(this.getTitle())},e.addAttachmentClass=function(t){i.default(this.getTipElement()).addClass("bs-tooltip-"+t)},e.getTipElement=function(){return this.tip=this.tip||i.default(this.config.template)[0],this.tip},e.setContent=function(){var t=this.getTipElement();this.setElementContent(i.default(t.querySelectorAll(".tooltip-inner")),this.getTitle()),i.default(t).removeClass("fade show")},e.setElementContent=function(t,e){"object"!=typeof e||!e.nodeType&&!e.jquery?this.config.html?(this.config.sanitize&&(e=ke(e,this.config.whiteList,this.config.sanitizeFn)),t.html(e)):t.text(e):this.config.html?i.default(e).parent().is(t)||t.empty().append(e):t.text(i.default(e).text())},e.getTitle=function(){var t=this.element.getAttribute("data-original-title");return t||(t="function"==typeof this.config.title?this.config.title.call(this.element):this.config.title),t},e._getPopperConfig=function(t){var e=this;return a({},{placement:t,modifiers:{offset:this._getOffset(),flip:{behavior:this.config.fallbackPlacement},arrow:{element:".arrow"},preventOverflow:{boundariesElement:this.config.boundary}},onCreate:function(t){t.originalPlacement!==t.placement&&e._handlePopperPlacementChange(t)},onUpdate:function(t){return e._handlePopperPlacementChange(t)}},this.config.popperConfig)},e._getOffset=function(){var t=this,e={};return"function"==typeof this.config.offset?e.fn=function(e){return e.offsets=a({},e.offsets,t.config.offset(e.offsets,t.element)),e}:e.offset=this.config.offset,e},e._getContainer=function(){return!1===this.config.container?document.body:u.isElement(this.config.container)?i.default(this.config.container):i.default(document).find(this.config.container)},e._getAttachment=function(t){return qe[t.toUpperCase()]},e._setListeners=function(){var t=this;this.config.trigger.split(" ").forEach((function(e){if("click"===e)i.default(t.element).on(t.constructor.Event.CLICK,t.config.selector,(function(e){return t.toggle(e)}));else if("manual"!==e){var n=e===He?t.constructor.Event.MOUSEENTER:t.constructor.Event.FOCUSIN,o=e===He?t.constructor.Event.MOUSELEAVE:t.constructor.Event.FOCUSOUT;i.default(t.element).on(n,t.config.selector,(function(e){return t._enter(e)})).on(o,t.config.selector,(function(e){return t._leave(e)}))}})),this._hideModalHandler=function(){t.element&&t.hide()},i.default(this.element).closest(".modal").on("hide.bs.modal",this._hideModalHandler),this.config.selector?this.config=a({},this.config,{trigger:"manual",selector:""}):this._fixTitle()},e._fixTitle=function(){var t=typeof this.element.getAttribute("data-original-title");(this.element.getAttribute("title")||"string"!==t)&&(this.element.setAttribute("data-original-title",this.element.getAttribute("title")||""),this.element.setAttribute("title",""))},e._enter=function(t,e){var n=this.constructor.DATA_KEY;(e=e||i.default(t.currentTarget).data(n))||(e=new this.constructor(t.currentTarget,this._getDelegateConfig()),i.default(t.currentTarget).data(n,e)),t&&(e._activeTrigger["focusin"===t.type?Me:He]=!0),i.default(e.getTipElement()).hasClass(Fe)||e._hoverState===Re?e._hoverState=Re:(clearTimeout(e._timeout),e._hoverState=Re,e.config.delay&&e.config.delay.show?e._timeout=setTimeout((function(){e._hoverState===Re&&e.show()}),e.config.delay.show):e.show())},e._leave=function(t,e){var n=this.constructor.DATA_KEY;(e=e||i.default(t.currentTarget).data(n))||(e=new this.constructor(t.currentTarget,this._getDelegateConfig()),i.default(t.currentTarget).data(n,e)),t&&(e._activeTrigger["focusout"===t.type?Me:He]=!1),e._isWithActiveTrigger()||(clearTimeout(e._timeout),e._hoverState=Be,e.config.delay&&e.config.delay.hide?e._timeout=setTimeout((function(){e._hoverState===Be&&e.hide()}),e.config.delay.hide):e.hide())},e._isWithActiveTrigger=function(){for(var t in this._activeTrigger)if(this._activeTrigger[t])return!0;return!1},e._getConfig=function(t){var e=i.default(this.element).data();return Object.keys(e).forEach((function(t){-1!==Le.indexOf(t)&&delete e[t]})),"number"==typeof(t=a({},this.constructor.Default,e,"object"==typeof t&&t?t:{})).delay&&(t.delay={show:t.delay,hide:t.delay}),"number"==typeof t.title&&(t.title=t.title.toString()),"number"==typeof t.content&&(t.content=t.content.toString()),u.typeCheckConfig(Ie,t,this.constructor.DefaultType),t.sanitize&&(t.template=ke(t.template,t.whiteList,t.sanitizeFn)),t},e._getDelegateConfig=function(){var t={};if(this.config)for(var e in this.config)this.constructor.Default[e]!==this.config[e]&&(t[e]=this.config[e]);return t},e._cleanTipClass=function(){var t=i.default(this.getTipElement()),e=t.attr("class").match(je);null!==e&&e.length&&t.removeClass(e.join(""))},e._handlePopperPlacementChange=function(t){this.tip=t.instance.popper,this._cleanTipClass(),this.addAttachmentClass(this._getAttachment(t.placement))},e._fixTransition=function(){var t=this.getTipElement(),e=this.config.animation;null===t.getAttribute("x-placement")&&(i.default(t).removeClass(Pe),this.config.animation=!1,this.hide(),this.show(),this.config.animation=e)},t._jQueryInterface=function(e){return this.each((function(){var n=i.default(this),o=n.data(Oe),r="object"==typeof e&&e;if((o||!/dispose|hide/.test(e))&&(o||(o=new t(this,r),n.data(Oe,o)),"string"==typeof e)){if("undefined"==typeof o[e])throw new TypeError('No method named "'+e+'"');o[e]()}}))},r(t,null,[{key:"VERSION",get:function(){return"4.6.2"}},{key:"Default",get:function(){return Qe}},{key:"NAME",get:function(){return Ie}},{key:"DATA_KEY",get:function(){return Oe}},{key:"Event",get:function(){return Ue}},{key:"EVENT_KEY",get:function(){return".bs.tooltip"}},{key:"DefaultType",get:function(){return We}}]),t}();i.default.fn.tooltip=Ve._jQueryInterface,i.default.fn.tooltip.Constructor=Ve,i.default.fn.tooltip.noConflict=function(){return i.default.fn.tooltip=xe,Ve._jQueryInterface};var Ye="bs.popover",ze=i.default.fn.popover,Ke=new RegExp("(^|\\s)bs-popover\\S+","g"),Xe=a({},Ve.Default,{placement:"right",trigger:"click",content:"",template:'<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>'}),Ge=a({},Ve.DefaultType,{content:"(string|element|function)"}),$e={HIDE:"hide.bs.popover",HIDDEN:"hidden.bs.popover",SHOW:"show.bs.popover",SHOWN:"shown.bs.popover",INSERTED:"inserted.bs.popover",CLICK:"click.bs.popover",FOCUSIN:"focusin.bs.popover",FOCUSOUT:"focusout.bs.popover",MOUSEENTER:"mouseenter.bs.popover",MOUSELEAVE:"mouseleave.bs.popover"},Je=function(t){var e,n;function o(){return t.apply(this,arguments)||this}n=t,(e=o).prototype=Object.create(n.prototype),e.prototype.constructor=e,s(e,n);var a=o.prototype;return a.isWithContent=function(){return this.getTitle()||this._getContent()},a.addAttachmentClass=function(t){i.default(this.getTipElement()).addClass("bs-popover-"+t)},a.getTipElement=function(){return this.tip=this.tip||i.default(this.config.template)[0],this.tip},a.setContent=function(){var t=i.default(this.getTipElement());this.setElementContent(t.find(".popover-header"),this.getTitle());var e=this._getContent();"function"==typeof e&&(e=e.call(this.element)),this.setElementContent(t.find(".popover-body"),e),t.removeClass("fade show")},a._getContent=function(){return this.element.getAttribute("data-content")||this.config.content},a._cleanTipClass=function(){var t=i.default(this.getTipElement()),e=t.attr("class").match(Ke);null!==e&&e.length>0&&t.removeClass(e.join(""))},o._jQueryInterface=function(t){return this.each((function(){var e=i.default(this).data(Ye),n="object"==typeof t?t:null;if((e||!/dispose|hide/.test(t))&&(e||(e=new o(this,n),i.default(this).data(Ye,e)),"string"==typeof t)){if("undefined"==typeof e[t])throw new TypeError('No method named "'+t+'"');e[t]()}}))},r(o,null,[{key:"VERSION",get:function(){return"4.6.2"}},{key:"Default",get:function(){return Xe}},{key:"NAME",get:function(){return"popover"}},{key:"DATA_KEY",get:function(){return Ye}},{key:"Event",get:function(){return $e}},{key:"EVENT_KEY",get:function(){return".bs.popover"}},{key:"DefaultType",get:function(){return Ge}}]),o}(Ve);i.default.fn.popover=Je._jQueryInterface,i.default.fn.popover.Constructor=Je,i.default.fn.popover.noConflict=function(){return i.default.fn.popover=ze,Je._jQueryInterface};var Ze="scrollspy",tn="bs.scrollspy",en=i.default.fn[Ze],nn="active",on="position",rn=".nav, .list-group",an={offset:10,method:"auto",target:""},sn={offset:"number",method:"string",target:"(string|element)"},ln=function(){function t(t,e){var n=this;this._element=t,this._scrollElement="BODY"===t.tagName?window:t,this._config=this._getConfig(e),this._selector=this._config.target+" .nav-link,"+this._config.target+" .list-group-item,"+this._config.target+" .dropdown-item",this._offsets=[],this._targets=[],this._activeTarget=null,this._scrollHeight=0,i.default(this._scrollElement).on("scroll.bs.scrollspy",(function(t){return n._process(t)})),this.refresh(),this._process()}var e=t.prototype;return e.refresh=function(){var t=this,e=this._scrollElement===this._scrollElement.window?"offset":on,n="auto"===this._config.method?e:this._config.method,o=n===on?this._getScrollTop():0;this._offsets=[],this._targets=[],this._scrollHeight=this._getScrollHeight(),[].slice.call(document.querySelectorAll(this._selector)).map((function(t){var e,r=u.getSelectorFromElement(t);if(r&&(e=document.querySelector(r)),e){var a=e.getBoundingClientRect();if(a.width||a.height)return[i.default(e)[n]().top+o,r]}return null})).filter(Boolean).sort((function(t,e){return t[0]-e[0]})).forEach((function(e){t._offsets.push(e[0]),t._targets.push(e[1])}))},e.dispose=function(){i.default.removeData(this._element,tn),i.default(this._scrollElement).off(".bs.scrollspy"),this._element=null,this._scrollElement=null,this._config=null,this._selector=null,this._offsets=null,this._targets=null,this._activeTarget=null,this._scrollHeight=null},e._getConfig=function(t){if("string"!=typeof(t=a({},an,"object"==typeof t&&t?t:{})).target&&u.isElement(t.target)){var e=i.default(t.target).attr("id");e||(e=u.getUID(Ze),i.default(t.target).attr("id",e)),t.target="#"+e}return u.typeCheckConfig(Ze,t,sn),t},e._getScrollTop=function(){return this._scrollElement===window?this._scrollElement.pageYOffset:this._scrollElement.scrollTop},e._getScrollHeight=function(){return this._scrollElement.scrollHeight||Math.max(document.body.scrollHeight,document.documentElement.scrollHeight)},e._getOffsetHeight=function(){return this._scrollElement===window?window.innerHeight:this._scrollElement.getBoundingClientRect().height},e._process=function(){var t=this._getScrollTop()+this._config.offset,e=this._getScrollHeight(),n=this._config.offset+e-this._getOffsetHeight();if(this._scrollHeight!==e&&this.refresh(),t>=n){var i=this._targets[this._targets.length-1];this._activeTarget!==i&&this._activate(i)}else{if(this._activeTarget&&t<this._offsets[0]&&this._offsets[0]>0)return this._activeTarget=null,void this._clear();for(var o=this._offsets.length;o--;)this._activeTarget!==this._targets[o]&&t>=this._offsets[o]&&("undefined"==typeof this._offsets[o+1]||t<this._offsets[o+1])&&this._activate(this._targets[o])}},e._activate=function(t){this._activeTarget=t,this._clear();var e=this._selector.split(",").map((function(e){return e+'[data-target="'+t+'"],'+e+'[href="'+t+'"]'})),n=i.default([].slice.call(document.querySelectorAll(e.join(","))));n.hasClass("dropdown-item")?(n.closest(".dropdown").find(".dropdown-toggle").addClass(nn),n.addClass(nn)):(n.addClass(nn),n.parents(rn).prev(".nav-link, .list-group-item").addClass(nn),n.parents(rn).prev(".nav-item").children(".nav-link").addClass(nn)),i.default(this._scrollElement).trigger("activate.bs.scrollspy",{relatedTarget:t})},e._clear=function(){[].slice.call(document.querySelectorAll(this._selector)).filter((function(t){return t.classList.contains(nn)})).forEach((function(t){return t.classList.remove(nn)}))},t._jQueryInterface=function(e){return this.each((function(){var n=i.default(this).data(tn);if(n||(n=new t(this,"object"==typeof e&&e),i.default(this).data(tn,n)),"string"==typeof e){if("undefined"==typeof n[e])throw new TypeError('No method named "'+e+'"');n[e]()}}))},r(t,null,[{key:"VERSION",get:function(){return"4.6.2"}},{key:"Default",get:function(){return an}}]),t}();i.default(window).on("load.bs.scrollspy.data-api",(function(){for(var t=[].slice.call(document.querySelectorAll('[data-spy="scroll"]')),e=t.length;e--;){var n=i.default(t[e]);ln._jQueryInterface.call(n,n.data())}})),i.default.fn[Ze]=ln._jQueryInterface,i.default.fn[Ze].Constructor=ln,i.default.fn[Ze].noConflict=function(){return i.default.fn[Ze]=en,ln._jQueryInterface};var un="bs.tab",fn=i.default.fn.tab,dn="active",cn="fade",hn="show",pn=".active",mn="> li > .active",gn=function(){function t(t){this._element=t}var e=t.prototype;return e.show=function(){var t=this;if(!(this._element.parentNode&&this._element.parentNode.nodeType===Node.ELEMENT_NODE&&i.default(this._element).hasClass(dn)||i.default(this._element).hasClass("disabled")||this._element.hasAttribute("disabled"))){var e,n,o=i.default(this._element).closest(".nav, .list-group")[0],r=u.getSelectorFromElement(this._element);if(o){var a="UL"===o.nodeName||"OL"===o.nodeName?mn:pn;n=(n=i.default.makeArray(i.default(o).find(a)))[n.length-1]}var s=i.default.Event("hide.bs.tab",{relatedTarget:this._element}),l=i.default.Event("show.bs.tab",{relatedTarget:n});if(n&&i.default(n).trigger(s),i.default(this._element).trigger(l),!l.isDefaultPrevented()&&!s.isDefaultPrevented()){r&&(e=document.querySelector(r)),this._activate(this._element,o);var f=function(){var e=i.default.Event("hidden.bs.tab",{relatedTarget:t._element}),o=i.default.Event("shown.bs.tab",{relatedTarget:n});i.default(n).trigger(e),i.default(t._element).trigger(o)};e?this._activate(e,e.parentNode,f):f()}}},e.dispose=function(){i.default.removeData(this._element,un),this._element=null},e._activate=function(t,e,n){var o=this,r=(!e||"UL"!==e.nodeName&&"OL"!==e.nodeName?i.default(e).children(pn):i.default(e).find(mn))[0],a=n&&r&&i.default(r).hasClass(cn),s=function(){return o._transitionComplete(t,r,n)};if(r&&a){var l=u.getTransitionDurationFromElement(r);i.default(r).removeClass(hn).one(u.TRANSITION_END,s).emulateTransitionEnd(l)}else s()},e._transitionComplete=function(t,e,n){if(e){i.default(e).removeClass(dn);var o=i.default(e.parentNode).find("> .dropdown-menu .active")[0];o&&i.default(o).removeClass(dn),"tab"===e.getAttribute("role")&&e.setAttribute("aria-selected",!1)}i.default(t).addClass(dn),"tab"===t.getAttribute("role")&&t.setAttribute("aria-selected",!0),u.reflow(t),t.classList.contains(cn)&&t.classList.add(hn);var r=t.parentNode;if(r&&"LI"===r.nodeName&&(r=r.parentNode),r&&i.default(r).hasClass("dropdown-menu")){var a=i.default(t).closest(".dropdown")[0];if(a){var s=[].slice.call(a.querySelectorAll(".dropdown-toggle"));i.default(s).addClass(dn)}t.setAttribute("aria-expanded",!0)}n&&n()},t._jQueryInterface=function(e){return this.each((function(){var n=i.default(this),o=n.data(un);if(o||(o=new t(this),n.data(un,o)),"string"==typeof e){if("undefined"==typeof o[e])throw new TypeError('No method named "'+e+'"');o[e]()}}))},r(t,null,[{key:"VERSION",get:function(){return"4.6.2"}}]),t}();i.default(document).on("click.bs.tab.data-api",'[data-toggle="tab"], [data-toggle="pill"], [data-toggle="list"]',(function(t){t.preventDefault(),gn._jQueryInterface.call(i.default(this),"show")})),i.default.fn.tab=gn._jQueryInterface,i.default.fn.tab.Constructor=gn,i.default.fn.tab.noConflict=function(){return i.default.fn.tab=fn,gn._jQueryInterface};var _n="bs.toast",vn=i.default.fn.toast,bn="hide",yn="show",En="showing",wn="click.dismiss.bs.toast",Tn={animation:!0,autohide:!0,delay:500},Cn={animation:"boolean",autohide:"boolean",delay:"number"},Sn=function(){function t(t,e){this._element=t,this._config=this._getConfig(e),this._timeout=null,this._setListeners()}var e=t.prototype;return e.show=function(){var t=this,e=i.default.Event("show.bs.toast");if(i.default(this._element).trigger(e),!e.isDefaultPrevented()){this._clearTimeout(),this._config.animation&&this._element.classList.add("fade");var n=function(){t._element.classList.remove(En),t._element.classList.add(yn),i.default(t._element).trigger("shown.bs.toast"),t._config.autohide&&(t._timeout=setTimeout((function(){t.hide()}),t._config.delay))};if(this._element.classList.remove(bn),u.reflow(this._element),this._element.classList.add(En),this._config.animation){var o=u.getTransitionDurationFromElement(this._element);i.default(this._element).one(u.TRANSITION_END,n).emulateTransitionEnd(o)}else n()}},e.hide=function(){if(this._element.classList.contains(yn)){var t=i.default.Event("hide.bs.toast");i.default(this._element).trigger(t),t.isDefaultPrevented()||this._close()}},e.dispose=function(){this._clearTimeout(),this._element.classList.contains(yn)&&this._element.classList.remove(yn),i.default(this._element).off(wn),i.default.removeData(this._element,_n),this._element=null,this._config=null},e._getConfig=function(t){return t=a({},Tn,i.default(this._element).data(),"object"==typeof t&&t?t:{}),u.typeCheckConfig("toast",t,this.constructor.DefaultType),t},e._setListeners=function(){var t=this;i.default(this._element).on(wn,'[data-dismiss="toast"]',(function(){return t.hide()}))},e._close=function(){var t=this,e=function(){t._element.classList.add(bn),i.default(t._element).trigger("hidden.bs.toast")};if(this._element.classList.remove(yn),this._config.animation){var n=u.getTransitionDurationFromElement(this._element);i.default(this._element).one(u.TRANSITION_END,e).emulateTransitionEnd(n)}else e()},e._clearTimeout=function(){clearTimeout(this._timeout),this._timeout=null},t._jQueryInterface=function(e){return this.each((function(){var n=i.default(this),o=n.data(_n);if(o||(o=new t(this,"object"==typeof e&&e),n.data(_n,o)),"string"==typeof e){if("undefined"==typeof o[e])throw new TypeError('No method named "'+e+'"');o[e](this)}}))},r(t,null,[{key:"VERSION",get:function(){return"4.6.2"}},{key:"DefaultType",get:function(){return Cn}},{key:"Default",get:function(){return Tn}}]),t}();i.default.fn.toast=Sn._jQueryInterface,i.default.fn.toast.Constructor=Sn,i.default.fn.toast.noConflict=function(){return i.default.fn.toast=vn,Sn._jQueryInterface},t.Alert=c,t.Button=b,t.Carousel=O,t.Collapse=W,t.Dropdown=le,t.Modal=Se,t.Popover=Je,t.Scrollspy=ln,t.Tab=gn,t.Toast=Sn,t.Tooltip=Ve,t.Util=u,Object.defineProperty(t,"__esModule",{value:!0})}));
//# sourceMappingURL=bootstrap.bundle.min.js.map
!(function (u) {
    var n = {
        treshold: 4,
        maximumItems: 5,
        highlightTyped: !0,
        highlightClass: "text-primary",
    };
    function p(e, t, o) {
        var a;
        if (o.highlightTyped) {
            var n = t.label.toLowerCase().indexOf(e.toLowerCase());
            a =
                t.label.substring(0, n) +
                '<span class="' +
                (function (e) {
                    if ("string" == typeof e) return e;
                    if (0 == e.length) return "";
                    for (var t = "", o = 0, a = e; o < a.length; o++) {
                        var n = a[o];
                        t += n + " ";
                    }
                    return t.substring(0, t.length - 1);
                })(o.highlightClass) +
                '">' +
                t.label.substring(n, n + e.length) +
                "</span>" +
                t.label.substring(n + e.length, t.label.length);
        } else a = t.label;
        return (
            '<button type="button" class="dropdown-item" data-value="' +
            t.value +
            '">' +
            a +
            "</button>"
        );
    }
    function l(e, t) {
        var o = e.val();
        if (o.length < t.treshold) return e.dropdown("hide"), 0;
        var a = e.next();
        a.html("");
        for (
            var n = 0, l = Object.keys(t.source || {}), r = 0;
            r < l.length;
            r++
        ) {
            var d = l[r],
                s = t.source[d],
                i = {
                    label: t.label ? s[t.label] : d,
                    value: t.value ? s[t.value] : s,
                };
            if (
                0 <= i.label.toLowerCase().indexOf(o.toLowerCase()) &&
                (a.append(p(o, i, t)),
                0 < t.maximumItems && ++n >= t.maximumItems)
            )
                break;
        }
        return (
            e
                .next()
                .find(".dropdown-item")
                .click(function () {
                    e.val(u(this).text()),
                        t.onSelectItem &&
                            t.onSelectItem(
                                {
                                    value: u(this).data("value"),
                                    label: u(this).text(),
                                },
                                e[0]
                            );
                }),
            a.children().length
        );
    }
    u.fn.autocomplete = function (e) {
        var t = {};
        u.extend(t, n, e);
        var o = u(this);
        o.parent().removeClass("dropdown"),
            o.removeAttr("data-toggle"),
            o.removeClass("dropdown-toggle"),
            o.parent().find(".dropdown-menu").remove(),
            o.dropdown("dispose"),
            o.parent().addClass("dropdown"),
            o.attr("data-toggle", "dropdown"),
            o.addClass("dropdown-toggle");
        var a = u('<div class="dropdown-menu" ></div>');
        return (
            t.dropdownClass && a.addClass(t.dropdownClass),
            o.after(a),
            o.dropdown(t.dropdownOptions),
            this.off("click.autocomplete").click(
                "click.autocomplete",
                function (e) {
                    0 == l(o, t) && (e.stopPropagation(), o.dropdown("hide"));
                }
            ),
            this.off("keyup.autocomplete").keyup(
                "keyup.autocomplete",
                function () {
                    0 < l(o, t) ? o.dropdown("show") : o.click();
                }
            ),
            this
        );
    };
})(jQuery);

/*!
 * Bootstrap-select v1.13.2 (https://developer.snapappointments.com/bootstrap-select)
 *
 * Copyright 2012-2018 SnapAppointments, LLC
 * Licensed under MIT (https://github.com/snapappointments/bootstrap-select/blob/master/LICENSE)
 */

!(function (e, t) {
    void 0 === e && void 0 !== window && (e = window),
        "function" == typeof define && define.amd
            ? define(["jquery"], function (e) {
                  return t(e);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = t(require("jquery")))
            : t(e.jQuery);
})(this, function (e) {
    !(function (F) {
        "use strict";
        var e,
            a,
            t,
            i = document.createElement("_");
        if ((i.classList.toggle("c3", !1), i.classList.contains("c3"))) {
            var s = DOMTokenList.prototype.toggle;
            DOMTokenList.prototype.toggle = function (e, t) {
                return 1 in arguments && !this.contains(e) == !t
                    ? t
                    : s.call(this, e);
            };
        }
        function S(e) {
            var t,
                i = [],
                s = e && e.options;
            if (e.multiple)
                for (var n = 0, o = s.length; n < o; n++)
                    (t = s[n]).selected && i.push(t.value || t.text);
            else i = e.value;
            return i;
        }
        String.prototype.startsWith ||
            ((e = (function () {
                try {
                    var e = {},
                        t = Object.defineProperty,
                        i = t(e, e, e) && t;
                } catch (e) {}
                return i;
            })()),
            (a = {}.toString),
            (t = function (e) {
                if (null == this) throw new TypeError();
                var t = String(this);
                if (e && "[object RegExp]" == a.call(e)) throw new TypeError();
                var i = t.length,
                    s = String(e),
                    n = s.length,
                    o = 1 < arguments.length ? arguments[1] : void 0,
                    l = o ? Number(o) : 0;
                l != l && (l = 0);
                var r = Math.min(Math.max(l, 0), i);
                if (i < n + r) return !1;
                for (var c = -1; ++c < n; )
                    if (t.charCodeAt(r + c) != s.charCodeAt(c)) return !1;
                return !0;
            }),
            e
                ? e(String.prototype, "startsWith", {
                      value: t,
                      configurable: !0,
                      writable: !0,
                  })
                : (String.prototype.startsWith = t)),
            Object.keys ||
                (Object.keys = function (e, t, i) {
                    for (t in ((i = []), e))
                        i.hasOwnProperty.call(e, t) && i.push(t);
                    return i;
                });
        var n = { useDefault: !1, _set: F.valHooks.select.set };
        F.valHooks.select.set = function (e, t) {
            return (
                t && !n.useDefault && F(e).data("selected", !0),
                n._set.apply(this, arguments)
            );
        };
        var y = null,
            o = (function () {
                try {
                    return new Event("change"), !0;
                } catch (e) {
                    return !1;
                }
            })();
        function $(e, t, i, s) {
            for (
                var n = ["content", "subtext", "tokens"], o = !1, l = 0;
                l < n.length;
                l++
            ) {
                var r = n[l],
                    c = e[r];
                if (
                    c &&
                    ((c = c.toString()),
                    "content" === r && (c = c.replace(/<[^>]+>/g, "")),
                    s && (c = d(c)),
                    (c = c.toUpperCase()),
                    (o =
                        "contains" === i ? 0 <= c.indexOf(t) : c.startsWith(t)))
                )
                    break;
            }
            return o;
        }
        function O(e) {
            return parseInt(e, 10) || 0;
        }
        function d(e) {
            return (
                F.each(
                    [
                        { re: /[\xC0-\xC6]/g, ch: "A" },
                        { re: /[\xE0-\xE6]/g, ch: "a" },
                        { re: /[\xC8-\xCB]/g, ch: "E" },
                        { re: /[\xE8-\xEB]/g, ch: "e" },
                        { re: /[\xCC-\xCF]/g, ch: "I" },
                        { re: /[\xEC-\xEF]/g, ch: "i" },
                        { re: /[\xD2-\xD6]/g, ch: "O" },
                        { re: /[\xF2-\xF6]/g, ch: "o" },
                        { re: /[\xD9-\xDC]/g, ch: "U" },
                        { re: /[\xF9-\xFC]/g, ch: "u" },
                        { re: /[\xC7-\xE7]/g, ch: "c" },
                        { re: /[\xD1]/g, ch: "N" },
                        { re: /[\xF1]/g, ch: "n" },
                    ],
                    function () {
                        e = e ? e.replace(this.re, this.ch) : "";
                    }
                ),
                e
            );
        }
        F.fn.triggerNative = function (e) {
            var t,
                i = this[0];
            i.dispatchEvent
                ? (o
                      ? (t = new Event(e, { bubbles: !0 }))
                      : (t = document.createEvent("Event")).initEvent(
                            e,
                            !0,
                            !1
                        ),
                  i.dispatchEvent(t))
                : i.fireEvent
                ? (((t = document.createEventObject()).eventType = e),
                  i.fireEvent("on" + e, t))
                : this.trigger(e);
        };
        var l = function (t) {
                var i = function (e) {
                        return t[e];
                    },
                    e = "(?:" + Object.keys(t).join("|") + ")",
                    s = RegExp(e),
                    n = RegExp(e, "g");
                return function (e) {
                    return (
                        (e = null == e ? "" : "" + e),
                        s.test(e) ? e.replace(n, i) : e
                    );
                };
            },
            G = l({
                "&": "&amp;",
                "<": "&lt;",
                ">": "&gt;",
                '"': "&quot;",
                "'": "&#x27;",
                "`": "&#x60;",
            }),
            f = l({
                "&amp;": "&",
                "&lt;": "<",
                "&gt;": ">",
                "&quot;": '"',
                "&#x27;": "'",
                "&#x60;": "`",
            }),
            E = {
                32: " ",
                48: "0",
                49: "1",
                50: "2",
                51: "3",
                52: "4",
                53: "5",
                54: "6",
                55: "7",
                56: "8",
                57: "9",
                59: ";",
                65: "A",
                66: "B",
                67: "C",
                68: "D",
                69: "E",
                70: "F",
                71: "G",
                72: "H",
                73: "I",
                74: "J",
                75: "K",
                76: "L",
                77: "M",
                78: "N",
                79: "O",
                80: "P",
                81: "Q",
                82: "R",
                83: "S",
                84: "T",
                85: "U",
                86: "V",
                87: "W",
                88: "X",
                89: "Y",
                90: "Z",
                96: "0",
                97: "1",
                98: "2",
                99: "3",
                100: "4",
                101: "5",
                102: "6",
                103: "7",
                104: "8",
                105: "9",
            },
            C = 27,
            z = 13,
            T = 32,
            D = 9,
            H = 38,
            L = 40,
            _ = { success: !1, major: "3" };
        try {
            (_.full = (F.fn.dropdown.Constructor.VERSION || "")
                .split(" ")[0]
                .split(".")),
                (_.major = _.full[0]),
                (_.success = !0);
        } catch (e) {
            console.warn(
                "There was an issue retrieving Bootstrap's version. Ensure Bootstrap is being loaded before bootstrap-select and there is no namespace collision. If loading Bootstrap asynchronously, the version may need to be manually specified via $.fn.selectpicker.Constructor.BootstrapVersion.",
                e
            );
        }
        var q = {
                DISABLED: "disabled",
                DIVIDER: "divider",
                SHOW: "open",
                DROPUP: "dropup",
                MENU: "dropdown-menu",
                MENURIGHT: "dropdown-menu-right",
                MENULEFT: "dropdown-menu-left",
                BUTTONCLASS: "btn-default",
                POPOVERHEADER: "popover-title",
            },
            N = { MENU: "." + q.MENU };
        "4" === _.major &&
            ((q.DIVIDER = "dropdown-divider"),
            (q.SHOW = "show"),
            (q.BUTTONCLASS = "btn-light"),
            (q.POPOVERHEADER = "popover-header"));
        var A = new RegExp(H + "|" + L),
            P = new RegExp("^" + D + "$|" + C),
            c =
                (new RegExp(z + "|" + T),
                function (e, t) {
                    var i = this;
                    n.useDefault ||
                        ((F.valHooks.select.set = n._set), (n.useDefault = !0)),
                        (this.$element = F(e)),
                        (this.$newElement = null),
                        (this.$button = null),
                        (this.$menu = null),
                        (this.options = t),
                        (this.selectpicker = {
                            main: { map: { newIndex: {}, originalIndex: {} } },
                            current: { map: {} },
                            search: { map: {} },
                            view: {},
                            keydown: {
                                keyHistory: "",
                                resetKeyHistory: {
                                    start: function () {
                                        return setTimeout(function () {
                                            i.selectpicker.keydown.keyHistory =
                                                "";
                                        }, 800);
                                    },
                                },
                            },
                        }),
                        null === this.options.title &&
                            (this.options.title = this.$element.attr("title"));
                    var s = this.options.windowPadding;
                    "number" == typeof s &&
                        (this.options.windowPadding = [s, s, s, s]),
                        (this.val = c.prototype.val),
                        (this.render = c.prototype.render),
                        (this.refresh = c.prototype.refresh),
                        (this.setStyle = c.prototype.setStyle),
                        (this.selectAll = c.prototype.selectAll),
                        (this.deselectAll = c.prototype.deselectAll),
                        (this.destroy = c.prototype.destroy),
                        (this.remove = c.prototype.remove),
                        (this.show = c.prototype.show),
                        (this.hide = c.prototype.hide),
                        this.init();
                });
        function r(e) {
            var o,
                l = arguments,
                r = e;
            if (([].shift.apply(l), !_.success)) {
                try {
                    _.full = (F.fn.dropdown.Constructor.VERSION || "")
                        .split(" ")[0]
                        .split(".");
                } catch (e) {
                    _.full = c.BootstrapVersion.split(" ")[0].split(".");
                }
                (_.major = _.full[0]),
                    (_.success = !0),
                    "4" === _.major &&
                        ((q.DIVIDER = "dropdown-divider"),
                        (q.SHOW = "show"),
                        (q.BUTTONCLASS = "btn-light"),
                        (c.DEFAULTS.style = q.BUTTONCLASS = "btn-light"),
                        (q.POPOVERHEADER = "popover-header"));
            }
            var t = this.each(function () {
                var e = F(this);
                if (e.is("select")) {
                    var t = e.data("selectpicker"),
                        i = "object" == typeof r && r;
                    if (t) {
                        if (i)
                            for (var s in i)
                                i.hasOwnProperty(s) && (t.options[s] = i[s]);
                    } else {
                        var n = F.extend(
                            {},
                            c.DEFAULTS,
                            F.fn.selectpicker.defaults || {},
                            e.data(),
                            i
                        );
                        (n.template = F.extend(
                            {},
                            c.DEFAULTS.template,
                            F.fn.selectpicker.defaults
                                ? F.fn.selectpicker.defaults.template
                                : {},
                            e.data().template,
                            i.template
                        )),
                            e.data("selectpicker", (t = new c(this, n)));
                    }
                    "string" == typeof r &&
                        (o =
                            t[r] instanceof Function
                                ? t[r].apply(t, l)
                                : t.options[r]);
                }
            });
            return void 0 !== o ? o : t;
        }
        (c.VERSION = "1.13.2"),
            (c.BootstrapVersion = _.major),
            (c.DEFAULTS = {
                noneSelectedText: "All",
                noneResultsText: "No results matched {0}",
                countSelectedText: function (e, t) {
                    return 1 == e ? "{0} item selected" : "{0} items selected";
                },
                maxOptionsText: function (e, t) {
                    return [
                        1 == e
                            ? "Limit reached ({n} item max)"
                            : "Limit reached ({n} items max)",
                        1 == t
                            ? "Group limit reached ({n} item max)"
                            : "Group limit reached ({n} items max)",
                    ];
                },
                selectAllText: "Select All",
                deselectAllText: "Deselect All",
                doneButton: !1,
                doneButtonText: "Close",
                multipleSeparator: ", ",
                styleBase: "btn",
                style: q.BUTTONCLASS,
                size: "auto",
                title: null,
                selectedTextFormat: "values",
                width: !1,
                container: !1,
                hideDisabled: !1,
                showSubtext: !1,
                showIcon: !0,
                showContent: !0,
                dropupAuto: !0,
                header: !1,
                liveSearch: !1,
                liveSearchPlaceholder: null,
                liveSearchNormalize: !1,
                liveSearchStyle: "contains",
                actionsBox: !1,
                iconBase: "glyphicon",
                tickIcon: "glyphicon-ok",
                showTick: !1,
                template: { caret: '<span class="caret"></span>' },
                maxOptions: !1,
                mobile: !1,
                selectOnTab: !1,
                dropdownAlignRight: !1,
                windowPadding: 0,
                virtualScroll: 600,
                display: !1,
            }),
            "4" === _.major &&
                ((c.DEFAULTS.style = "btn-light"),
                (c.DEFAULTS.iconBase = ""),
                (c.DEFAULTS.tickIcon = "bs-ok-default")),
            (c.prototype = {
                constructor: c,
                init: function () {
                    var i = this,
                        e = this.$element.attr("id");
                    this.$element.addClass("bs-select-hidden"),
                        (this.multiple = this.$element.prop("multiple")),
                        (this.autofocus = this.$element.prop("autofocus")),
                        (this.$newElement = this.createDropdown()),
                        this.createLi(),
                        this.$element
                            .after(this.$newElement)
                            .prependTo(this.$newElement),
                        (this.$button = this.$newElement.children("button")),
                        (this.$menu = this.$newElement.children(N.MENU)),
                        (this.$menuInner = this.$menu.children(".inner")),
                        (this.$searchbox = this.$menu.find("input")),
                        this.$element.removeClass("bs-select-hidden"),
                        !0 === this.options.dropdownAlignRight &&
                            this.$menu.addClass(q.MENURIGHT),
                        void 0 !== e && this.$button.attr("data-id", e),
                        this.checkDisabled(),
                        this.clickListener(),
                        this.options.liveSearch && this.liveSearchListener(),
                        this.render(),
                        this.setStyle(),
                        this.setWidth(),
                        this.options.container
                            ? this.selectPosition()
                            : this.$element.on("hide.bs.select", function () {
                                  if (i.isVirtual()) {
                                      var e = i.$menuInner[0],
                                          t = e.firstChild.cloneNode(!1);
                                      e.replaceChild(t, e.firstChild),
                                          (e.scrollTop = 0);
                                  }
                              }),
                        this.$menu.data("this", this),
                        this.$newElement.data("this", this),
                        this.options.mobile && this.mobile(),
                        this.$newElement.on({
                            "hide.bs.dropdown": function (e) {
                                i.$menuInner.attr("aria-expanded", !1),
                                    i.$element.trigger("hide.bs.select", e);
                            },
                            "hidden.bs.dropdown": function (e) {
                                i.$element.trigger("hidden.bs.select", e);
                            },
                            "show.bs.dropdown": function (e) {
                                i.$menuInner.attr("aria-expanded", !0),
                                    i.$element.trigger("show.bs.select", e);
                            },
                            "shown.bs.dropdown": function (e) {
                                i.$element.trigger("shown.bs.select", e);
                            },
                        }),
                        i.$element[0].hasAttribute("required") &&
                            this.$element.on("invalid", function () {
                                i.$button.addClass("bs-invalid"),
                                    i.$element.on({
                                        "shown.bs.select": function () {
                                            i.$element
                                                .val(i.$element.val())
                                                .off("shown.bs.select");
                                        },
                                        "rendered.bs.select": function () {
                                            this.validity.valid &&
                                                i.$button.removeClass(
                                                    "bs-invalid"
                                                ),
                                                i.$element.off(
                                                    "rendered.bs.select"
                                                );
                                        },
                                    }),
                                    i.$button.on("blur.bs.select", function () {
                                        i.$element.focus().blur(),
                                            i.$button.off("blur.bs.select");
                                    });
                            }),
                        setTimeout(function () {
                            i.$element.trigger("loaded.bs.select");
                        });
                },
                createDropdown: function () {
                    var e =
                            this.multiple || this.options.showTick
                                ? " show-tick"
                                : "",
                        t = this.autofocus ? " autofocus" : "",
                        i = this.options.header
                            ? '<div class="' +
                              q.POPOVERHEADER +
                              '"><button type="button" class="close" aria-hidden="true">&times;</button>' +
                              this.options.header +
                              "</div>"
                            : "",
                        s = this.options.liveSearch
                            ? '<div class="bs-searchbox"><input type="text" class="form-control" autocomplete="off"' +
                              (null === this.options.liveSearchPlaceholder
                                  ? ""
                                  : ' placeholder="' +
                                    G(this.options.liveSearchPlaceholder) +
                                    '"') +
                              ' role="textbox" aria-label="Search"></div>'
                            : "",
                        n =
                            this.multiple && this.options.actionsBox
                                ? '<div class="bs-actionsbox"><div class="btn-group btn-group-sm btn-block"><button type="button" class="actions-btn bs-select-all btn ' +
                                  q.BUTTONCLASS +
                                  '">' +
                                  this.options.selectAllText +
                                  '</button><button type="button" class="actions-btn bs-deselect-all btn ' +
                                  q.BUTTONCLASS +
                                  '">' +
                                  this.options.deselectAllText +
                                  "</button></div></div>"
                                : "",
                        o =
                            this.multiple && this.options.doneButton
                                ? '<div class="bs-donebutton"><div class="btn-group btn-block"><button type="button" class="btn btn-sm ' +
                                  q.BUTTONCLASS +
                                  '">' +
                                  this.options.doneButtonText +
                                  "</button></div></div>"
                                : "",
                        l =
                            '<div class="dropdown bootstrap-select' +
                            e +
                            '"><button type="button" class="' +
                            this.options.styleBase +
                            ' dropdown-toggle" ' +
                            ("static" === this.options.display
                                ? 'data-display="static"'
                                : "") +
                            'data-toggle="dropdown"' +
                            t +
                            ' role="button"><div class="filter-option"><div class="filter-option-inner"><div class="filter-option-inner-inner"></div></div> </div>' +
                            ("4" === _.major
                                ? ""
                                : '<span class="bs-caret">' +
                                  this.options.template.caret +
                                  "</span>") +
                            '</button><div class="' +
                            q.MENU +
                            " " +
                            ("4" === _.major ? "" : q.SHOW) +
                            '" role="combobox">' +
                            i +
                            s +
                            n +
                            '<div class="inner ' +
                            q.SHOW +
                            '" role="listbox" aria-expanded="false" tabindex="-1"><ul class="' +
                            q.MENU +
                            " inner " +
                            ("4" === _.major ? q.SHOW : "") +
                            '"></ul></div>' +
                            o +
                            "</div></div>";
                    return F(l);
                },
                setPositionData: function () {
                    this.selectpicker.view.canHighlight = [];
                    for (
                        var e = 0;
                        e < this.selectpicker.current.data.length;
                        e++
                    ) {
                        var t = this.selectpicker.current.data[e],
                            i = !0;
                        "divider" === t.type
                            ? ((i = !1),
                              (t.height = this.sizeInfo.dividerHeight))
                            : "optgroup-label" === t.type
                            ? ((i = !1),
                              (t.height = this.sizeInfo.dropdownHeaderHeight))
                            : (t.height = this.sizeInfo.liHeight),
                            t.disabled && (i = !1),
                            this.selectpicker.view.canHighlight.push(i),
                            (t.position =
                                (0 === e
                                    ? 0
                                    : this.selectpicker.current.data[e - 1]
                                          .position) + t.height);
                    }
                },
                isVirtual: function () {
                    return (
                        (!1 !== this.options.virtualScroll &&
                            this.selectpicker.main.elements.length >=
                                this.options.virtualScroll) ||
                        !0 === this.options.virtualScroll
                    );
                },
                createView: function (C, e) {
                    e = e || 0;
                    var O = this;
                    this.selectpicker.current = C
                        ? this.selectpicker.search
                        : this.selectpicker.main;
                    var z,
                        T,
                        D = [];
                    function i(e, t) {
                        var i,
                            s,
                            n,
                            o,
                            l,
                            r,
                            c,
                            a,
                            d,
                            h = O.selectpicker.current.elements.length,
                            p = [],
                            u = void 0,
                            f = !0,
                            m = O.isVirtual();
                        (O.selectpicker.view.scrollTop = e),
                            !0 === m &&
                                O.sizeInfo.hasScrollBar &&
                                O.$menu[0].offsetWidth >
                                    O.sizeInfo.totalMenuWidth &&
                                ((O.sizeInfo.menuWidth =
                                    O.$menu[0].offsetWidth),
                                (O.sizeInfo.totalMenuWidth =
                                    O.sizeInfo.menuWidth +
                                    O.sizeInfo.scrollBarWidth),
                                O.$menu.css("min-width", O.sizeInfo.menuWidth)),
                            (i = Math.ceil(
                                (O.sizeInfo.menuInnerHeight /
                                    O.sizeInfo.liHeight) *
                                    1.5
                            )),
                            (s = Math.round(h / i) || 1);
                        for (var v = 0; v < s; v++) {
                            var g = (v + 1) * i;
                            if (
                                (v === s - 1 && (g = h),
                                (p[v] = [v * i + (v ? 1 : 0), g]),
                                !h)
                            )
                                break;
                            void 0 === u &&
                                e <=
                                    O.selectpicker.current.data[g - 1]
                                        .position -
                                        O.sizeInfo.menuInnerHeight &&
                                (u = v);
                        }
                        if (
                            (void 0 === u && (u = 0),
                            (l = [
                                O.selectpicker.view.position0,
                                O.selectpicker.view.position1,
                            ]),
                            (n = Math.max(0, u - 1)),
                            (o = Math.min(s - 1, u + 1)),
                            (O.selectpicker.view.position0 =
                                Math.max(0, p[n][0]) || 0),
                            (O.selectpicker.view.position1 =
                                Math.min(h, p[o][1]) || 0),
                            (r =
                                l[0] !== O.selectpicker.view.position0 ||
                                l[1] !== O.selectpicker.view.position1),
                            void 0 !== O.activeIndex &&
                                ((T =
                                    O.selectpicker.current.elements[
                                        O.selectpicker.current.map.newIndex[
                                            O.prevActiveIndex
                                        ]
                                    ]),
                                (D =
                                    O.selectpicker.current.elements[
                                        O.selectpicker.current.map.newIndex[
                                            O.activeIndex
                                        ]
                                    ]),
                                (z =
                                    O.selectpicker.current.elements[
                                        O.selectpicker.current.map.newIndex[
                                            O.selectedIndex
                                        ]
                                    ]),
                                t &&
                                    (O.activeIndex !== O.selectedIndex &&
                                        (D.classList.remove("active"),
                                        D.firstChild &&
                                            D.firstChild.classList.remove(
                                                "active"
                                            )),
                                    (O.activeIndex = void 0)),
                                O.activeIndex &&
                                    O.activeIndex !== O.selectedIndex &&
                                    z &&
                                    z.length &&
                                    (z.classList.remove("active"),
                                    z.firstChild &&
                                        z.firstChild.classList.remove(
                                            "active"
                                        ))),
                            void 0 !== O.prevActiveIndex &&
                                O.prevActiveIndex !== O.activeIndex &&
                                O.prevActiveIndex !== O.selectedIndex &&
                                T &&
                                T.length &&
                                (T.classList.remove("active"),
                                T.firstChild &&
                                    T.firstChild.classList.remove("active")),
                            (t || r) &&
                                ((c = O.selectpicker.view.visibleElements
                                    ? O.selectpicker.view.visibleElements.slice()
                                    : []),
                                (O.selectpicker.view.visibleElements =
                                    O.selectpicker.current.elements.slice(
                                        O.selectpicker.view.position0,
                                        O.selectpicker.view.position1
                                    )),
                                O.setOptionStatus(),
                                (C || (!1 === m && t)) &&
                                    ((a = c),
                                    (d = O.selectpicker.view.visibleElements),
                                    (f = !(
                                        a.length === d.length &&
                                        a.every(function (e, t) {
                                            return e === d[t];
                                        })
                                    ))),
                                (t || !0 === m) && f))
                        ) {
                            var b,
                                w,
                                x = O.$menuInner[0],
                                I = document.createDocumentFragment(),
                                k = x.firstChild.cloneNode(!1),
                                $ =
                                    !0 === m
                                        ? O.selectpicker.view.visibleElements
                                        : O.selectpicker.current.elements;
                            x.replaceChild(k, x.firstChild);
                            v = 0;
                            for (var E = $.length; v < E; v++)
                                I.appendChild($[v]);
                            !0 === m &&
                                ((b =
                                    0 === O.selectpicker.view.position0
                                        ? 0
                                        : O.selectpicker.current.data[
                                              O.selectpicker.view.position0 - 1
                                          ].position),
                                (w =
                                    O.selectpicker.view.position1 > h - 1
                                        ? 0
                                        : O.selectpicker.current.data[h - 1]
                                              .position -
                                          O.selectpicker.current.data[
                                              O.selectpicker.view.position1 - 1
                                          ].position),
                                (x.firstChild.style.marginTop = b + "px"),
                                (x.firstChild.style.marginBottom = w + "px")),
                                x.firstChild.appendChild(I);
                        }
                        if (
                            ((O.prevActiveIndex = O.activeIndex),
                            O.options.liveSearch)
                        ) {
                            if (C && t) {
                                var S,
                                    y = 0;
                                O.selectpicker.view.canHighlight[y] ||
                                    (y =
                                        1 +
                                        O.selectpicker.view.canHighlight
                                            .slice(1)
                                            .indexOf(!0)),
                                    (S =
                                        O.selectpicker.view.visibleElements[y]),
                                    O.selectpicker.view.currentActive &&
                                        (O.selectpicker.view.currentActive.classList.remove(
                                            "active"
                                        ),
                                        O.selectpicker.view.currentActive
                                            .firstChild &&
                                            O.selectpicker.view.currentActive.firstChild.classList.remove(
                                                "active"
                                            )),
                                    S &&
                                        (S.classList.add("active"),
                                        S.firstChild &&
                                            S.firstChild.classList.add(
                                                "active"
                                            )),
                                    (O.activeIndex =
                                        O.selectpicker.current.map.originalIndex[
                                            y
                                        ]);
                            }
                        } else O.$menuInner.focus();
                    }
                    this.setPositionData(),
                        i(e, !0),
                        this.$menuInner
                            .off("scroll.createView")
                            .on("scroll.createView", function (e, t) {
                                O.noScroll || i(this.scrollTop, t),
                                    (O.noScroll = !1);
                            }),
                        F(window)
                            .off("resize.createView")
                            .on("resize.createView", function () {
                                i(O.$menuInner[0].scrollTop);
                            });
                },
                createLi: function () {
                    var z,
                        T = this,
                        D = [],
                        H = 0,
                        L = 0,
                        N = [],
                        A = 0,
                        P = 0,
                        R = -1;
                    this.selectpicker.view.titleOption ||
                        (this.selectpicker.view.titleOption =
                            document.createElement("option"));
                    var W = {
                            span: document.createElement("span"),
                            subtext: document.createElement("small"),
                            a: document.createElement("a"),
                            li: document.createElement("li"),
                            whitespace: document.createTextNode(" "),
                        },
                        e = W.span.cloneNode(!1),
                        B = document.createDocumentFragment();
                    (e.className =
                        T.options.iconBase +
                        " " +
                        T.options.tickIcon +
                        " check-mark"),
                        W.a.appendChild(e),
                        W.a.setAttribute("role", "option"),
                        (W.subtext.className = "text-muted"),
                        (W.text = W.span.cloneNode(!1)),
                        (W.text.className = "text");
                    var M = function (e, t, i, s) {
                            var n = W.li.cloneNode(!1);
                            return (
                                e &&
                                    (1 === e.nodeType || 11 === e.nodeType
                                        ? n.appendChild(e)
                                        : (n.innerHTML = e)),
                                void 0 !== i && "" !== i && (n.className = i),
                                null != s && n.classList.add("optgroup-" + s),
                                n
                            );
                        },
                        U = function (e, t, i) {
                            var s = W.a.cloneNode(!0);
                            return (
                                e &&
                                    (11 === e.nodeType
                                        ? s.appendChild(e)
                                        : s.insertAdjacentHTML("beforeend", e)),
                                (void 0 !== t) & ("" !== t) &&
                                    (s.className = t),
                                "4" === _.major &&
                                    s.classList.add("dropdown-item"),
                                i && s.setAttribute("style", i),
                                s
                            );
                        },
                        V = function (e) {
                            var t,
                                i,
                                s = W.text.cloneNode(!1);
                            if (e.optionContent) s.innerHTML = e.optionContent;
                            else {
                                if (((s.textContent = e.text), e.optionIcon)) {
                                    var n = W.whitespace.cloneNode(!1);
                                    ((i = W.span.cloneNode(!1)).className =
                                        T.options.iconBase +
                                        " " +
                                        e.optionIcon),
                                        B.appendChild(i),
                                        B.appendChild(n);
                                }
                                e.optionSubtext &&
                                    (((t = W.subtext.cloneNode(!1)).innerHTML =
                                        e.optionSubtext),
                                    s.appendChild(t));
                            }
                            return B.appendChild(s), B;
                        };
                    if (this.options.title && !this.multiple) {
                        R--;
                        var t = this.$element[0],
                            i = !1,
                            s = !this.selectpicker.view.titleOption.parentNode;
                        if (s)
                            (this.selectpicker.view.titleOption.className =
                                "bs-title-option"),
                                (this.selectpicker.view.titleOption.value = ""),
                                (i =
                                    void 0 ===
                                        F(t.options[t.selectedIndex]).attr(
                                            "selected"
                                        ) &&
                                    void 0 === this.$element.data("selected"));
                        (s || 0 !== this.selectpicker.view.titleOption.index) &&
                            t.insertBefore(
                                this.selectpicker.view.titleOption,
                                t.firstChild
                            ),
                            i && (t.selectedIndex = 0);
                    }
                    var j = this.$element.find("option");
                    j.each(function (e) {
                        var t = F(this);
                        if ((R++, !t.hasClass("bs-title-option"))) {
                            var i,
                                s,
                                n = t.data(),
                                o = this.className || "",
                                l = G(this.style.cssText),
                                r = n.content,
                                c = this.textContent,
                                a = n.tokens,
                                d = n.subtext,
                                h = n.icon,
                                p = t.parent(),
                                u = p[0],
                                f = "OPTGROUP" === u.tagName,
                                m = f && u.disabled,
                                v = this.disabled || m,
                                g =
                                    this.previousElementSibling &&
                                    "OPTGROUP" ===
                                        this.previousElementSibling.tagName,
                                b = p.data();
                            if (
                                !0 === n.hidden ||
                                (T.options.hideDisabled && ((v && !f) || m))
                            ) {
                                (i = n.prevHiddenIndex),
                                    t
                                        .next()
                                        .data(
                                            "prevHiddenIndex",
                                            void 0 !== i ? i : e
                                        ),
                                    R--,
                                    g ||
                                        (void 0 !== i &&
                                            (y = j[i].previousElementSibling) &&
                                            "OPTGROUP" === y.tagName &&
                                            !y.disabled &&
                                            (g = !0)),
                                    g &&
                                        "divider" !== N[N.length - 1].type &&
                                        (R++,
                                        D.push(M(!1, 0, q.DIVIDER, A + "div")),
                                        N.push({ type: "divider", optID: A }));
                            } else {
                                if (f && !0 !== n.divider) {
                                    if (T.options.hideDisabled && v) {
                                        if (void 0 === b.allOptionsDisabled) {
                                            var w = p.children();
                                            p.data(
                                                "allOptionsDisabled",
                                                w.filter(":disabled").length ===
                                                    w.length
                                            );
                                        }
                                        if (p.data("allOptionsDisabled"))
                                            return void R--;
                                    }
                                    var x = " " + u.className || "";
                                    if (!this.previousElementSibling) {
                                        A += 1;
                                        var I = u.label,
                                            k = G(I),
                                            $ = b.subtext,
                                            E = b.icon;
                                        0 !== e &&
                                            0 < D.length &&
                                            (R++,
                                            D.push(
                                                M(!1, 0, q.DIVIDER, A + "div")
                                            ),
                                            N.push({
                                                type: "divider",
                                                optID: A,
                                            })),
                                            R++;
                                        var S = (function (e) {
                                            var t,
                                                i,
                                                s = W.text.cloneNode(!1);
                                            if (
                                                ((s.innerHTML = e.labelEscaped),
                                                e.labelIcon)
                                            ) {
                                                var n = W.whitespace.cloneNode(
                                                    !1
                                                );
                                                ((i = W.span.cloneNode(
                                                    !1
                                                )).className =
                                                    T.options.iconBase +
                                                    " " +
                                                    e.labelIcon),
                                                    B.appendChild(i),
                                                    B.appendChild(n);
                                            }
                                            return (
                                                e.labelSubtext &&
                                                    (((t = W.subtext.cloneNode(
                                                        !1
                                                    )).textContent =
                                                        e.labelSubtext),
                                                    s.appendChild(t)),
                                                B.appendChild(s),
                                                B
                                            );
                                        })({
                                            labelEscaped: k,
                                            labelSubtext: $,
                                            labelIcon: E,
                                        });
                                        D.push(
                                            M(S, 0, "dropdown-header" + x, A)
                                        ),
                                            N.push({
                                                content: k,
                                                subtext: $,
                                                type: "optgroup-label",
                                                optID: A,
                                            }),
                                            (P = R - 1);
                                    }
                                    if (
                                        (T.options.hideDisabled && v) ||
                                        !0 === n.hidden
                                    )
                                        return void R--;
                                    (s = V({
                                        text: c,
                                        optionContent: r,
                                        optionSubtext: d,
                                        optionIcon: h,
                                    })),
                                        D.push(
                                            M(U(s, "opt " + o + x, l), 0, "", A)
                                        ),
                                        N.push({
                                            content: r || c,
                                            subtext: d,
                                            tokens: a,
                                            type: "option",
                                            optID: A,
                                            headerIndex: P,
                                            lastIndex: P + u.childElementCount,
                                            originalIndex: e,
                                            data: n,
                                        }),
                                        H++;
                                } else if (!0 === n.divider)
                                    D.push(M(!1, 0, q.DIVIDER)),
                                        N.push({
                                            type: "divider",
                                            originalIndex: e,
                                            data: n,
                                        });
                                else {
                                    var y;
                                    if (!g && T.options.hideDisabled)
                                        if (void 0 !== (i = n.prevHiddenIndex))
                                            (y = j[i].previousElementSibling) &&
                                                "OPTGROUP" === y.tagName &&
                                                !y.disabled &&
                                                (g = !0);
                                    g &&
                                        "divider" !== N[N.length - 1].type &&
                                        (R++,
                                        D.push(M(!1, 0, q.DIVIDER, A + "div")),
                                        N.push({ type: "divider", optID: A })),
                                        (s = V({
                                            text: c,
                                            optionContent: r,
                                            optionSubtext: d,
                                            optionIcon: h,
                                        })),
                                        D.push(M(U(s, o, l))),
                                        N.push({
                                            content: r || c,
                                            subtext: d,
                                            tokens: a,
                                            type: "option",
                                            originalIndex: e,
                                            data: n,
                                        }),
                                        H++;
                                }
                                (T.selectpicker.main.map.newIndex[e] = R),
                                    (T.selectpicker.main.map.originalIndex[R] =
                                        e);
                                var C = N[N.length - 1];
                                C.disabled = v;
                                var O = 0;
                                C.content && (O += C.content.length),
                                    C.subtext && (O += C.subtext.length),
                                    h && (O += 1),
                                    L < O && ((L = O), (z = D[D.length - 1]));
                            }
                        }
                    }),
                        (this.selectpicker.main.elements = D),
                        (this.selectpicker.main.data = N),
                        (this.selectpicker.current = this.selectpicker.main),
                        (this.selectpicker.view.widestOption = z),
                        (this.selectpicker.view.availableOptionsCount = H);
                },
                findLis: function () {
                    return this.$menuInner.find(".inner > li");
                },
                render: function () {
                    var e = this,
                        t = this.$element.find("option"),
                        i = [],
                        s = [];
                    this.togglePlaceholder(), this.tabIndex();
                    for (
                        var n = 0, o = this.selectpicker.main.elements.length;
                        n < o;
                        n++
                    ) {
                        var l = t[this.selectpicker.main.map.originalIndex[n]];
                        if (
                            l &&
                            l.selected &&
                            (i.push(l),
                            (s.length < 100 &&
                                "count" !== e.options.selectedTextFormat) ||
                                1 === i.length)
                        ) {
                            if (
                                e.options.hideDisabled &&
                                (l.disabled ||
                                    ("OPTGROUP" === l.parentNode.tagName &&
                                        l.parentNode.disabled))
                            )
                                return;
                            var r,
                                c,
                                a = this.selectpicker.main.data[n].data,
                                d =
                                    a.icon && e.options.showIcon
                                        ? '<i class="' +
                                          e.options.iconBase +
                                          " " +
                                          a.icon +
                                          '"></i> '
                                        : "";
                            (r =
                                e.options.showSubtext &&
                                a.subtext &&
                                !e.multiple
                                    ? ' <small class="text-muted">' +
                                      a.subtext +
                                      "</small>"
                                    : ""),
                                (c = l.title
                                    ? l.title
                                    : a.content && e.options.showContent
                                    ? a.content.toString()
                                    : d + l.innerHTML.trim() + r),
                                s.push(c);
                        }
                    }
                    var h = this.multiple
                        ? s.join(this.options.multipleSeparator)
                        : s[0];
                    if (
                        (50 < i.length && (h += "..."),
                        this.multiple &&
                            -1 !==
                                this.options.selectedTextFormat.indexOf(
                                    "count"
                                ))
                    ) {
                        var p = this.options.selectedTextFormat.split(">");
                        if (
                            (1 < p.length && i.length > p[1]) ||
                            (1 === p.length && 2 <= i.length)
                        ) {
                            var u =
                                this.selectpicker.view.availableOptionsCount;
                            h = (
                                "function" ==
                                typeof this.options.countSelectedText
                                    ? this.options.countSelectedText(
                                          i.length,
                                          u
                                      )
                                    : this.options.countSelectedText
                            )
                                .replace("{0}", i.length.toString())
                                .replace("{1}", u.toString());
                        }
                    }
                    null == this.options.title &&
                        (this.options.title = this.$element.attr("title")),
                        "static" == this.options.selectedTextFormat &&
                            (h = this.options.title),
                        h ||
                            (h =
                                void 0 !== this.options.title
                                    ? this.options.title
                                    : this.options.noneSelectedText),
                        (this.$button[0].title = f(
                            h.replace(/<[^>]*>?/g, "").trim()
                        )),
                        (this.$button.find(
                            ".filter-option-inner-inner"
                        )[0].innerHTML = h),
                        this.$element.trigger("rendered.bs.select");
                },
                setStyle: function (e, t) {
                    this.$element.attr("class") &&
                        this.$newElement.addClass(
                            this.$element
                                .attr("class")
                                .replace(
                                    /selectpicker|mobile-device|bs-select-hidden|validate\[.*\]/gi,
                                    ""
                                )
                        );
                    var i = e || this.options.style;
                    "add" == t
                        ? this.$button.addClass(i)
                        : "remove" == t
                        ? this.$button.removeClass(i)
                        : (this.$button.removeClass(this.options.style),
                          this.$button.addClass(i));
                },
                liHeight: function (e) {
                    if (e || (!1 !== this.options.size && !this.sizeInfo)) {
                        this.sizeInfo || (this.sizeInfo = {});
                        var t = document.createElement("div"),
                            i = document.createElement("div"),
                            s = document.createElement("div"),
                            n = document.createElement("ul"),
                            o = document.createElement("li"),
                            l = document.createElement("li"),
                            r = document.createElement("li"),
                            c = document.createElement("a"),
                            a = document.createElement("span"),
                            d =
                                this.options.header &&
                                0 <
                                    this.$menu.find("." + q.POPOVERHEADER)
                                        .length
                                    ? this.$menu
                                          .find("." + q.POPOVERHEADER)[0]
                                          .cloneNode(!0)
                                    : null,
                            h = this.options.liveSearch
                                ? document.createElement("div")
                                : null,
                            p =
                                this.options.actionsBox &&
                                this.multiple &&
                                0 < this.$menu.find(".bs-actionsbox").length
                                    ? this.$menu
                                          .find(".bs-actionsbox")[0]
                                          .cloneNode(!0)
                                    : null,
                            u =
                                this.options.doneButton &&
                                this.multiple &&
                                0 < this.$menu.find(".bs-donebutton").length
                                    ? this.$menu
                                          .find(".bs-donebutton")[0]
                                          .cloneNode(!0)
                                    : null;
                        if (
                            ((this.sizeInfo.selectWidth =
                                this.$newElement[0].offsetWidth),
                            (a.className = "text"),
                            (c.className =
                                "dropdown-item " +
                                this.$element.find("option")[0].className),
                            (t.className =
                                this.$menu[0].parentNode.className +
                                " " +
                                q.SHOW),
                            (t.style.width = this.sizeInfo.selectWidth + "px"),
                            "auto" === this.options.width &&
                                (i.style.minWidth = 0),
                            (i.className = q.MENU + " " + q.SHOW),
                            (s.className = "inner " + q.SHOW),
                            (n.className =
                                q.MENU +
                                " inner " +
                                ("4" === _.major ? q.SHOW : "")),
                            (o.className = q.DIVIDER),
                            (l.className = "dropdown-header"),
                            a.appendChild(
                                document.createTextNode("Inner text")
                            ),
                            c.appendChild(a),
                            r.appendChild(c),
                            l.appendChild(a.cloneNode(!0)),
                            this.selectpicker.view.widestOption &&
                                n.appendChild(
                                    this.selectpicker.view.widestOption.cloneNode(
                                        !0
                                    )
                                ),
                            n.appendChild(r),
                            n.appendChild(o),
                            n.appendChild(l),
                            d && i.appendChild(d),
                            h)
                        ) {
                            var f = document.createElement("input");
                            (h.className = "bs-searchbox"),
                                (f.className = "form-control"),
                                h.appendChild(f),
                                i.appendChild(h);
                        }
                        p && i.appendChild(p),
                            s.appendChild(n),
                            i.appendChild(s),
                            u && i.appendChild(u),
                            t.appendChild(i),
                            document.body.appendChild(t);
                        var m,
                            v = c.offsetHeight,
                            g = l ? l.offsetHeight : 0,
                            b = d ? d.offsetHeight : 0,
                            w = h ? h.offsetHeight : 0,
                            x = p ? p.offsetHeight : 0,
                            I = u ? u.offsetHeight : 0,
                            k = F(o).outerHeight(!0),
                            $ =
                                !!window.getComputedStyle &&
                                window.getComputedStyle(i),
                            E = i.offsetWidth,
                            S = $ ? null : F(i),
                            y = {
                                vert:
                                    O($ ? $.paddingTop : S.css("paddingTop")) +
                                    O(
                                        $
                                            ? $.paddingBottom
                                            : S.css("paddingBottom")
                                    ) +
                                    O(
                                        $
                                            ? $.borderTopWidth
                                            : S.css("borderTopWidth")
                                    ) +
                                    O(
                                        $
                                            ? $.borderBottomWidth
                                            : S.css("borderBottomWidth")
                                    ),
                                horiz:
                                    O(
                                        $ ? $.paddingLeft : S.css("paddingLeft")
                                    ) +
                                    O(
                                        $
                                            ? $.paddingRight
                                            : S.css("paddingRight")
                                    ) +
                                    O(
                                        $
                                            ? $.borderLeftWidth
                                            : S.css("borderLeftWidth")
                                    ) +
                                    O(
                                        $
                                            ? $.borderRightWidth
                                            : S.css("borderRightWidth")
                                    ),
                            },
                            C = {
                                vert:
                                    y.vert +
                                    O($ ? $.marginTop : S.css("marginTop")) +
                                    O(
                                        $
                                            ? $.marginBottom
                                            : S.css("marginBottom")
                                    ) +
                                    2,
                                horiz:
                                    y.horiz +
                                    O($ ? $.marginLeft : S.css("marginLeft")) +
                                    O(
                                        $ ? $.marginRight : S.css("marginRight")
                                    ) +
                                    2,
                            };
                        (s.style.overflowY = "scroll"),
                            (m = i.offsetWidth - E),
                            document.body.removeChild(t),
                            (this.sizeInfo.liHeight = v),
                            (this.sizeInfo.dropdownHeaderHeight = g),
                            (this.sizeInfo.headerHeight = b),
                            (this.sizeInfo.searchHeight = w),
                            (this.sizeInfo.actionsHeight = x),
                            (this.sizeInfo.doneButtonHeight = I),
                            (this.sizeInfo.dividerHeight = k),
                            (this.sizeInfo.menuPadding = y),
                            (this.sizeInfo.menuExtras = C),
                            (this.sizeInfo.menuWidth = E),
                            (this.sizeInfo.totalMenuWidth =
                                this.sizeInfo.menuWidth),
                            (this.sizeInfo.scrollBarWidth = m),
                            (this.sizeInfo.selectHeight =
                                this.$newElement[0].offsetHeight),
                            this.setPositionData();
                    }
                },
                getSelectPosition: function () {
                    var e,
                        t = F(window),
                        i = this.$newElement.offset(),
                        s = F(this.options.container);
                    this.options.container && !s.is("body")
                        ? (((e = s.offset()).top += parseInt(
                              s.css("borderTopWidth")
                          )),
                          (e.left += parseInt(s.css("borderLeftWidth"))))
                        : (e = { top: 0, left: 0 });
                    var n = this.options.windowPadding;
                    (this.sizeInfo.selectOffsetTop =
                        i.top - e.top - t.scrollTop()),
                        (this.sizeInfo.selectOffsetBot =
                            t.height() -
                            this.sizeInfo.selectOffsetTop -
                            this.sizeInfo.selectHeight -
                            e.top -
                            n[2]),
                        (this.sizeInfo.selectOffsetLeft =
                            i.left - e.left - t.scrollLeft()),
                        (this.sizeInfo.selectOffsetRight =
                            t.width() -
                            this.sizeInfo.selectOffsetLeft -
                            this.sizeInfo.selectWidth -
                            e.left -
                            n[1]),
                        (this.sizeInfo.selectOffsetTop -= n[0]),
                        (this.sizeInfo.selectOffsetLeft -= n[3]);
                },
                setMenuSize: function (e) {
                    this.getSelectPosition();
                    var t,
                        i,
                        s,
                        n,
                        o,
                        l,
                        r,
                        c = this.sizeInfo.selectWidth,
                        a = this.sizeInfo.liHeight,
                        d = this.sizeInfo.headerHeight,
                        h = this.sizeInfo.searchHeight,
                        p = this.sizeInfo.actionsHeight,
                        u = this.sizeInfo.doneButtonHeight,
                        f = this.sizeInfo.dividerHeight,
                        m = this.sizeInfo.menuPadding,
                        v = 0;
                    if (
                        (this.options.dropupAuto &&
                            ((r =
                                a * this.selectpicker.current.elements.length +
                                m.vert),
                            this.$newElement.toggleClass(
                                q.DROPUP,
                                this.sizeInfo.selectOffsetTop -
                                    this.sizeInfo.selectOffsetBot >
                                    this.sizeInfo.menuExtras.vert &&
                                    r + this.sizeInfo.menuExtras.vert + 50 >
                                        this.sizeInfo.selectOffsetBot
                            )),
                        "auto" === this.options.size)
                    )
                        (n =
                            3 < this.selectpicker.current.elements.length
                                ? 3 * this.sizeInfo.liHeight +
                                  this.sizeInfo.menuExtras.vert -
                                  2
                                : 0),
                            (i =
                                this.sizeInfo.selectOffsetBot -
                                this.sizeInfo.menuExtras.vert),
                            (s = n + d + h + p + u),
                            (l = Math.max(n - m.vert, 0)),
                            this.$newElement.hasClass(q.DROPUP) &&
                                (i =
                                    this.sizeInfo.selectOffsetTop -
                                    this.sizeInfo.menuExtras.vert),
                            (t = (o = i) - d - h - p - u - m.vert);
                    else if (
                        this.options.size &&
                        "auto" != this.options.size &&
                        this.selectpicker.current.elements.length >
                            this.options.size
                    ) {
                        for (var g = 0; g < this.options.size; g++)
                            "divider" ===
                                this.selectpicker.current.data[g].type && v++;
                        (t =
                            (i = a * this.options.size + v * f + m.vert) -
                            m.vert),
                            (o = i + d + h + p + u),
                            (s = l = "");
                    }
                    "auto" === this.options.dropdownAlignRight &&
                        this.$menu.toggleClass(
                            q.MENURIGHT,
                            this.sizeInfo.selectOffsetLeft >
                                this.sizeInfo.selectOffsetRight &&
                                this.sizeInfo.selectOffsetRight <
                                    this.$menu[0].offsetWidth - c
                        ),
                        this.$menu.css({
                            "max-height": o + "px",
                            overflow: "hidden",
                            "min-height": s + "px",
                        }),
                        this.$menuInner.css({
                            "max-height": t + "px",
                            "overflow-y": "auto",
                            "min-height": l + "px",
                        }),
                        (this.sizeInfo.menuInnerHeight = t),
                        this.selectpicker.current.data.length &&
                            this.selectpicker.current.data[
                                this.selectpicker.current.data.length - 1
                            ].position > this.sizeInfo.menuInnerHeight &&
                            ((this.sizeInfo.hasScrollBar = !0),
                            (this.sizeInfo.totalMenuWidth =
                                this.sizeInfo.menuWidth +
                                this.sizeInfo.scrollBarWidth),
                            this.$menu.css("min-width", "100%")),
                        this.dropdown &&
                            this.dropdown._popper &&
                            this.dropdown._popper.update();
                },
                setSize: function (e) {
                    if (
                        (this.liHeight(e),
                        this.options.header && this.$menu.css("padding-top", 0),
                        !1 !== this.options.size)
                    ) {
                        var t,
                            i = this,
                            s = F(window),
                            n = 0;
                        this.setMenuSize(),
                            "auto" === this.options.size
                                ? (this.$searchbox
                                      .off(
                                          "input.setMenuSize propertychange.setMenuSize"
                                      )
                                      .on(
                                          "input.setMenuSize propertychange.setMenuSize",
                                          function () {
                                              return i.setMenuSize();
                                          }
                                      ),
                                  s
                                      .off(
                                          "resize.setMenuSize scroll.setMenuSize"
                                      )
                                      .on(
                                          "resize.setMenuSize scroll.setMenuSize",
                                          function () {
                                              return i.setMenuSize();
                                          }
                                      ))
                                : this.options.size &&
                                  "auto" != this.options.size &&
                                  this.selectpicker.current.elements.length >
                                      this.options.size &&
                                  (this.$searchbox.off(
                                      "input.setMenuSize propertychange.setMenuSize"
                                  ),
                                  s.off(
                                      "resize.setMenuSize scroll.setMenuSize"
                                  )),
                            e
                                ? (n = this.$menuInner[0].scrollTop)
                                : i.multiple ||
                                  ("number" ==
                                      typeof (t =
                                          i.selectpicker.main.map.newIndex[
                                              i.$element[0].selectedIndex
                                          ]) &&
                                      !1 !== i.options.size &&
                                      (n =
                                          (n = i.sizeInfo.liHeight * t) -
                                          i.sizeInfo.menuInnerHeight / 2 +
                                          i.sizeInfo.liHeight / 2)),
                            i.createView(!1, n);
                    }
                },
                setWidth: function () {
                    var i = this;
                    "auto" === this.options.width
                        ? requestAnimationFrame(function () {
                              i.$menu.css("min-width", "0"),
                                  i.liHeight(),
                                  i.setMenuSize();
                              var e = i.$newElement.clone().appendTo("body"),
                                  t = e
                                      .css("width", "auto")
                                      .children("button")
                                      .outerWidth();
                              e.remove(),
                                  (i.sizeInfo.selectWidth = Math.max(
                                      i.sizeInfo.totalMenuWidth,
                                      t
                                  )),
                                  i.$newElement.css(
                                      "width",
                                      i.sizeInfo.selectWidth + "px"
                                  );
                          })
                        : "fit" === this.options.width
                        ? (this.$menu.css("min-width", ""),
                          this.$newElement
                              .css("width", "")
                              .addClass("fit-width"))
                        : this.options.width
                        ? (this.$menu.css("min-width", ""),
                          this.$newElement.css("width", this.options.width))
                        : (this.$menu.css("min-width", ""),
                          this.$newElement.css("width", "")),
                        this.$newElement.hasClass("fit-width") &&
                            "fit" !== this.options.width &&
                            this.$newElement.removeClass("fit-width");
                },
                selectPosition: function () {
                    this.$bsContainer = F('<div class="bs-container" />');
                    var s,
                        n,
                        o,
                        l = this,
                        r = F(this.options.container),
                        e = function (e) {
                            var t = {},
                                i =
                                    l.options.display ||
                                    F.fn.dropdown.Constructor.Default.display;
                            l.$bsContainer
                                .addClass(
                                    e
                                        .attr("class")
                                        .replace(/form-control|fit-width/gi, "")
                                )
                                .toggleClass(q.DROPUP, e.hasClass(q.DROPUP)),
                                (s = e.offset()),
                                r.is("body")
                                    ? (n = { top: 0, left: 0 })
                                    : (((n = r.offset()).top +=
                                          parseInt(r.css("borderTopWidth")) -
                                          r.scrollTop()),
                                      (n.left +=
                                          parseInt(r.css("borderLeftWidth")) -
                                          r.scrollLeft())),
                                (o = e.hasClass(q.DROPUP)
                                    ? 0
                                    : e[0].offsetHeight),
                                (_.major < 4 || "static" === i) &&
                                    ((t.top = s.top - n.top + o),
                                    (t.left = s.left - n.left)),
                                (t.width = e[0].offsetWidth),
                                l.$bsContainer.css(t);
                        };
                    this.$button.on("click.bs.dropdown.data-api", function () {
                        l.isDisabled() ||
                            (e(l.$newElement),
                            l.$bsContainer
                                .appendTo(l.options.container)
                                .toggleClass(
                                    q.SHOW,
                                    !l.$button.hasClass(q.SHOW)
                                )
                                .append(l.$menu));
                    }),
                        F(window).on("resize scroll", function () {
                            e(l.$newElement);
                        }),
                        this.$element.on("hide.bs.select", function () {
                            l.$menu.data("height", l.$menu.height()),
                                l.$bsContainer.detach();
                        });
                },
                setOptionStatus: function () {
                    var e = this,
                        t = this.$element.find("option");
                    if (
                        ((e.noScroll = !1),
                        e.selectpicker.view.visibleElements &&
                            e.selectpicker.view.visibleElements.length)
                    )
                        for (
                            var i = 0;
                            i < e.selectpicker.view.visibleElements.length;
                            i++
                        ) {
                            var s =
                                    e.selectpicker.current.map.originalIndex[
                                        i + e.selectpicker.view.position0
                                    ],
                                n = t[s];
                            if (n) {
                                var o = this.selectpicker.main.map.newIndex[s],
                                    l = this.selectpicker.main.elements[o];
                                e.setDisabled(
                                    s,
                                    n.disabled ||
                                        ("OPTGROUP" === n.parentNode.tagName &&
                                            n.parentNode.disabled),
                                    o,
                                    l
                                ),
                                    e.setSelected(s, n.selected, o, l);
                            }
                        }
                },
                setSelected: function (e, t, i, s) {
                    var n,
                        o,
                        l,
                        r = void 0 !== this.activeIndex,
                        c =
                            this.activeIndex === e ||
                            (t && !this.multiple && !r);
                    i || (i = this.selectpicker.main.map.newIndex[e]),
                        s || (s = this.selectpicker.main.elements[i]),
                        (l = s.firstChild),
                        t && (this.selectedIndex = e),
                        s.classList.toggle("selected", t),
                        s.classList.toggle("active", c),
                        c &&
                            ((this.selectpicker.view.currentActive = s),
                            (this.activeIndex = e)),
                        l &&
                            (l.classList.toggle("selected", t),
                            l.classList.toggle("active", c),
                            l.setAttribute("aria-selected", t)),
                        c ||
                            (!r &&
                                t &&
                                void 0 !== this.prevActiveIndex &&
                                ((n =
                                    this.selectpicker.main.map.newIndex[
                                        this.prevActiveIndex
                                    ]),
                                (o =
                                    this.selectpicker.main.elements[
                                        n
                                    ]).classList.toggle("selected", t),
                                o.classList.remove("active"),
                                o.firstChild &&
                                    (o.firstChild.classList.toggle(
                                        "selected",
                                        t
                                    ),
                                    o.firstChild.classList.remove("active"))));
                },
                setDisabled: function (e, t, i, s) {
                    var n;
                    i || (i = this.selectpicker.main.map.newIndex[e]),
                        s || (s = this.selectpicker.main.elements[i]),
                        (n = s.firstChild),
                        s.classList.toggle(q.DISABLED, t),
                        n &&
                            ("4" === _.major &&
                                n.classList.toggle(q.DISABLED, t),
                            n.setAttribute("aria-disabled", t),
                            t
                                ? n.setAttribute("tabindex", -1)
                                : n.setAttribute("tabindex", 0));
                },
                isDisabled: function () {
                    return this.$element[0].disabled;
                },
                checkDisabled: function () {
                    var e = this;
                    this.isDisabled()
                        ? (this.$newElement.addClass(q.DISABLED),
                          this.$button
                              .addClass(q.DISABLED)
                              .attr("tabindex", -1)
                              .attr("aria-disabled", !0))
                        : (this.$button.hasClass(q.DISABLED) &&
                              (this.$newElement.removeClass(q.DISABLED),
                              this.$button
                                  .removeClass(q.DISABLED)
                                  .attr("aria-disabled", !1)),
                          -1 != this.$button.attr("tabindex") ||
                              this.$element.data("tabindex") ||
                              this.$button.removeAttr("tabindex")),
                        this.$button.click(function () {
                            return !e.isDisabled();
                        });
                },
                togglePlaceholder: function () {
                    var e = this.$element[0],
                        t = e.selectedIndex,
                        i = -1 === t;
                    i || e.options[t].value || (i = !0),
                        this.$button.toggleClass("bs-placeholder", i);
                },
                tabIndex: function () {
                    this.$element.data("tabindex") !==
                        this.$element.attr("tabindex") &&
                        -98 !== this.$element.attr("tabindex") &&
                        "-98" !== this.$element.attr("tabindex") &&
                        (this.$element.data(
                            "tabindex",
                            this.$element.attr("tabindex")
                        ),
                        this.$button.attr(
                            "tabindex",
                            this.$element.data("tabindex")
                        )),
                        this.$element.attr("tabindex", -98);
                },
                clickListener: function () {
                    var E = this,
                        t = F(document);
                    function e() {
                        E.options.liveSearch
                            ? E.$searchbox.focus()
                            : E.$menuInner.focus();
                    }
                    function i() {
                        E.dropdown &&
                        E.dropdown._popper &&
                        E.dropdown._popper.state.isCreated
                            ? e()
                            : requestAnimationFrame(i);
                    }
                    t.data("spaceSelect", !1),
                        this.$button.on("keyup", function (e) {
                            /(32)/.test(e.keyCode.toString(10)) &&
                                t.data("spaceSelect") &&
                                (e.preventDefault(), t.data("spaceSelect", !1));
                        }),
                        this.$newElement.on("show.bs.dropdown", function () {
                            3 < _.major &&
                                !E.dropdown &&
                                ((E.dropdown = E.$button.data("bs.dropdown")),
                                (E.dropdown._menu = E.$menu[0]));
                        }),
                        this.$button.on(
                            "click.bs.dropdown.data-api",
                            function () {
                                E.$newElement.hasClass(q.SHOW) || E.setSize();
                            }
                        ),
                        this.$element.on("shown.bs.select", function () {
                            E.$menuInner[0].scrollTop !==
                                E.selectpicker.view.scrollTop &&
                                (E.$menuInner[0].scrollTop =
                                    E.selectpicker.view.scrollTop),
                                3 < _.major ? requestAnimationFrame(i) : e();
                        }),
                        this.$menuInner.on("click", "li a", function (e, t) {
                            var i = F(this),
                                s = E.isVirtual()
                                    ? E.selectpicker.view.position0
                                    : 0,
                                n =
                                    E.selectpicker.current.map.originalIndex[
                                        i.parent().index() + s
                                    ],
                                o = S(E.$element[0]),
                                l = E.$element.prop("selectedIndex"),
                                r = !0;
                            if (
                                (E.multiple &&
                                    1 !== E.options.maxOptions &&
                                    e.stopPropagation(),
                                e.preventDefault(),
                                !E.isDisabled() &&
                                    !i.parent().hasClass(q.DISABLED))
                            ) {
                                var c = E.$element.find("option"),
                                    a = c.eq(n),
                                    d = a.prop("selected"),
                                    h = a.parent("optgroup"),
                                    p = h.find("option"),
                                    u = E.options.maxOptions,
                                    f = h.data("maxOptions") || !1;
                                if (
                                    (n === E.activeIndex && (t = !0),
                                    t ||
                                        ((E.prevActiveIndex = E.activeIndex),
                                        (E.activeIndex = void 0)),
                                    E.multiple)
                                ) {
                                    if (
                                        (a.prop("selected", !d),
                                        E.setSelected(n, !d),
                                        i.blur(),
                                        !1 !== u || !1 !== f)
                                    ) {
                                        var m =
                                                u <
                                                c.filter(":selected").length,
                                            v =
                                                f <
                                                h.find("option:selected")
                                                    .length;
                                        if ((u && m) || (f && v))
                                            if (u && 1 == u) {
                                                c.prop("selected", !1),
                                                    a.prop("selected", !0);
                                                for (
                                                    var g = 0;
                                                    g < c.length;
                                                    g++
                                                )
                                                    E.setSelected(g, !1);
                                                E.setSelected(n, !0);
                                            } else if (f && 1 == f) {
                                                h
                                                    .find("option:selected")
                                                    .prop("selected", !1),
                                                    a.prop("selected", !0);
                                                for (g = 0; g < p.length; g++) {
                                                    var b = p[g];
                                                    E.setSelected(
                                                        c.index(b),
                                                        !1
                                                    );
                                                }
                                                E.setSelected(n, !0);
                                            } else {
                                                var w =
                                                        "string" ==
                                                        typeof E.options
                                                            .maxOptionsText
                                                            ? [
                                                                  E.options
                                                                      .maxOptionsText,
                                                                  E.options
                                                                      .maxOptionsText,
                                                              ]
                                                            : E.options
                                                                  .maxOptionsText,
                                                    x =
                                                        "function" == typeof w
                                                            ? w(u, f)
                                                            : w,
                                                    I = x[0].replace("{n}", u),
                                                    k = x[1].replace("{n}", f),
                                                    $ = F(
                                                        '<div class="notify"></div>'
                                                    );
                                                x[2] &&
                                                    ((I = I.replace(
                                                        "{var}",
                                                        x[2][1 < u ? 0 : 1]
                                                    )),
                                                    (k = k.replace(
                                                        "{var}",
                                                        x[2][1 < f ? 0 : 1]
                                                    ))),
                                                    a.prop("selected", !1),
                                                    E.$menu.append($),
                                                    u &&
                                                        m &&
                                                        ($.append(
                                                            F(
                                                                "<div>" +
                                                                    I +
                                                                    "</div>"
                                                            )
                                                        ),
                                                        (r = !1),
                                                        E.$element.trigger(
                                                            "maxReached.bs.select"
                                                        )),
                                                    f &&
                                                        v &&
                                                        ($.append(
                                                            F(
                                                                "<div>" +
                                                                    k +
                                                                    "</div>"
                                                            )
                                                        ),
                                                        (r = !1),
                                                        E.$element.trigger(
                                                            "maxReachedGrp.bs.select"
                                                        )),
                                                    setTimeout(function () {
                                                        E.setSelected(n, !1);
                                                    }, 10),
                                                    $.delay(750).fadeOut(
                                                        300,
                                                        function () {
                                                            F(this).remove();
                                                        }
                                                    );
                                            }
                                    }
                                } else
                                    c.prop("selected", !1),
                                        a.prop("selected", !0),
                                        E.setSelected(n, !0);
                                !E.multiple ||
                                (E.multiple && 1 === E.options.maxOptions)
                                    ? E.$button.focus()
                                    : E.options.liveSearch &&
                                      E.$searchbox.focus(),
                                    r &&
                                        ((o != S(E.$element[0]) &&
                                            E.multiple) ||
                                            (l !=
                                                E.$element.prop(
                                                    "selectedIndex"
                                                ) &&
                                                !E.multiple)) &&
                                        ((y = [n, a.prop("selected"), o]),
                                        E.$element.triggerNative("change"));
                            }
                        }),
                        this.$menu.on(
                            "click",
                            "li." +
                                q.DISABLED +
                                " a, ." +
                                q.POPOVERHEADER +
                                ", ." +
                                q.POPOVERHEADER +
                                " :not(.close)",
                            function (e) {
                                e.currentTarget == this &&
                                    (e.preventDefault(),
                                    e.stopPropagation(),
                                    E.options.liveSearch &&
                                    !F(e.target).hasClass("close")
                                        ? E.$searchbox.focus()
                                        : E.$button.focus());
                            }
                        ),
                        this.$menuInner.on(
                            "click",
                            ".divider, .dropdown-header",
                            function (e) {
                                e.preventDefault(),
                                    e.stopPropagation(),
                                    E.options.liveSearch
                                        ? E.$searchbox.focus()
                                        : E.$button.focus();
                            }
                        ),
                        this.$menu.on(
                            "click",
                            "." + q.POPOVERHEADER + " .close",
                            function () {
                                E.$button.click();
                            }
                        ),
                        this.$searchbox.on("click", function (e) {
                            e.stopPropagation();
                        }),
                        this.$menu.on("click", ".actions-btn", function (e) {
                            E.options.liveSearch
                                ? E.$searchbox.focus()
                                : E.$button.focus(),
                                e.preventDefault(),
                                e.stopPropagation(),
                                F(this).hasClass("bs-select-all")
                                    ? E.selectAll()
                                    : E.deselectAll();
                        }),
                        this.$element.on({
                            change: function () {
                                E.render(),
                                    E.$element.trigger("changed.bs.select", y),
                                    (y = null);
                            },
                            focus: function () {
                                E.$button.focus();
                            },
                        });
                },
                liveSearchListener: function () {
                    var u = this,
                        f = document.createElement("li");
                    this.$button.on("click.bs.dropdown.data-api", function () {
                        u.$searchbox.val() && u.$searchbox.val("");
                    }),
                        this.$searchbox.on(
                            "click.bs.dropdown.data-api focus.bs.dropdown.data-api touchend.bs.dropdown.data-api",
                            function (e) {
                                e.stopPropagation();
                            }
                        ),
                        this.$searchbox.on("input propertychange", function () {
                            var e = u.$searchbox.val();
                            if (
                                ((u.selectpicker.search.map.newIndex = {}),
                                (u.selectpicker.search.map.originalIndex = {}),
                                (u.selectpicker.search.elements = []),
                                (u.selectpicker.search.data = []),
                                e)
                            ) {
                                var t = [],
                                    i = e.toUpperCase(),
                                    s = {},
                                    n = [],
                                    o = u._searchStyle(),
                                    l = u.options.liveSearchNormalize;
                                u._$lisSelected =
                                    u.$menuInner.find(".selected");
                                for (
                                    var r = 0;
                                    r < u.selectpicker.main.data.length;
                                    r++
                                ) {
                                    var c = u.selectpicker.main.data[r];
                                    s[r] || (s[r] = $(c, i, o, l)),
                                        s[r] &&
                                            void 0 !== c.headerIndex &&
                                            -1 === n.indexOf(c.headerIndex) &&
                                            (0 < c.headerIndex &&
                                                ((s[c.headerIndex - 1] = !0),
                                                n.push(c.headerIndex - 1)),
                                            (s[c.headerIndex] = !0),
                                            n.push(c.headerIndex),
                                            (s[c.lastIndex + 1] = !0)),
                                        s[r] &&
                                            "optgroup-label" !== c.type &&
                                            n.push(r);
                                }
                                r = 0;
                                for (var a = n.length; r < a; r++) {
                                    var d = n[r],
                                        h = n[r - 1],
                                        p =
                                            ((c = u.selectpicker.main.data[d]),
                                            u.selectpicker.main.data[h]);
                                    ("divider" !== c.type ||
                                        ("divider" === c.type &&
                                            p &&
                                            "divider" !== p.type &&
                                            a - 1 !== r)) &&
                                        (u.selectpicker.search.data.push(c),
                                        t.push(u.selectpicker.main.elements[d]),
                                        c.hasOwnProperty("originalIndex") &&
                                            ((u.selectpicker.search.map.newIndex[
                                                c.originalIndex
                                            ] = t.length - 1),
                                            (u.selectpicker.search.map.originalIndex[
                                                t.length - 1
                                            ] = c.originalIndex)));
                                }
                                (u.activeIndex = void 0),
                                    (u.noScroll = !0),
                                    u.$menuInner.scrollTop(0),
                                    (u.selectpicker.search.elements = t),
                                    u.createView(!0),
                                    t.length ||
                                        ((f.className = "no-results"),
                                        (f.innerHTML =
                                            u.options.noneResultsText.replace(
                                                "{0}",
                                                '"' + G(e) + '"'
                                            )),
                                        u.$menuInner[0].firstChild.appendChild(
                                            f
                                        ));
                            } else u.$menuInner.scrollTop(0), u.createView(!1);
                        });
                },
                _searchStyle: function () {
                    return this.options.liveSearchStyle || "contains";
                },
                val: function (e) {
                    return void 0 !== e
                        ? (this.$element.val(e).triggerNative("change"),
                          this.$element)
                        : this.$element.val();
                },
                changeAll: function (e) {
                    if (this.multiple) {
                        void 0 === e && (e = !0);
                        var t = this.$element.find("option"),
                            i = 0,
                            s = 0,
                            n = S(this.$element[0]);
                        this.$element.addClass("bs-select-hidden");
                        for (
                            var o = 0;
                            o < this.selectpicker.current.elements.length;
                            o++
                        ) {
                            var l = this.selectpicker.current.data[o],
                                r =
                                    t[
                                        this.selectpicker.current.map
                                            .originalIndex[o]
                                    ];
                            r &&
                                !r.disabled &&
                                "divider" !== l.type &&
                                (r.selected && i++,
                                (r.selected = e),
                                r.selected && s++);
                        }
                        this.$element.removeClass("bs-select-hidden"),
                            i !== s &&
                                (this.setOptionStatus(),
                                this.togglePlaceholder(),
                                (y = [null, null, n]),
                                this.$element.triggerNative("change"));
                    }
                },
                selectAll: function () {
                    return this.changeAll(!0);
                },
                deselectAll: function () {
                    return this.changeAll(!1);
                },
                toggle: function (e) {
                    (e = e || window.event) && e.stopPropagation(),
                        this.$button.trigger("click.bs.dropdown.data-api");
                },
                keydown: function (e) {
                    var t,
                        i,
                        s,
                        n,
                        o,
                        l = F(this),
                        r = l.hasClass("dropdown-toggle"),
                        c = (
                            r ? l.closest(".dropdown") : l.closest(N.MENU)
                        ).data("this"),
                        a = c.findLis(),
                        d = !1,
                        h = e.which === D && !r && !c.options.selectOnTab,
                        p = A.test(e.which) || h,
                        u = c.$menuInner[0].scrollTop,
                        f = c.isVirtual(),
                        m = !0 === f ? c.selectpicker.view.position0 : 0;
                    if (
                        (!(i = c.$newElement.hasClass(q.SHOW)) &&
                            (p ||
                                (48 <= e.which && e.which <= 57) ||
                                (96 <= e.which && e.which <= 105) ||
                                (65 <= e.which && e.which <= 90)) &&
                            c.$button.trigger("click.bs.dropdown.data-api"),
                        e.which === C &&
                            i &&
                            (e.preventDefault(),
                            c.$button
                                .trigger("click.bs.dropdown.data-api")
                                .focus()),
                        p)
                    ) {
                        if (!a.length) return;
                        void 0 ===
                            (t =
                                !0 === f
                                    ? a.index(a.filter(".active"))
                                    : c.selectpicker.current.map.newIndex[
                                          c.activeIndex
                                      ]) && (t = -1),
                            -1 !== t &&
                                ((s =
                                    c.selectpicker.current.elements[
                                        t + m
                                    ]).classList.remove("active"),
                                s.firstChild &&
                                    s.firstChild.classList.remove("active")),
                            e.which === H
                                ? (-1 !== t && t--,
                                  t + m < 0 && (t += a.length),
                                  c.selectpicker.view.canHighlight[t + m] ||
                                      (-1 ===
                                          (t =
                                              c.selectpicker.view.canHighlight
                                                  .slice(0, t + m)
                                                  .lastIndexOf(!0) - m) &&
                                          (t = a.length - 1)))
                                : (e.which === L || h) &&
                                  (++t + m >=
                                      c.selectpicker.view.canHighlight.length &&
                                      (t = 0),
                                  c.selectpicker.view.canHighlight[t + m] ||
                                      (t =
                                          t +
                                          1 +
                                          c.selectpicker.view.canHighlight
                                              .slice(t + m + 1)
                                              .indexOf(!0))),
                            e.preventDefault();
                        var v = m + t;
                        e.which === H
                            ? 0 === m && t === a.length - 1
                                ? ((c.$menuInner[0].scrollTop =
                                      c.$menuInner[0].scrollHeight),
                                  (v =
                                      c.selectpicker.current.elements.length -
                                      1))
                                : (d =
                                      (o =
                                          (n = c.selectpicker.current.data[v])
                                              .position - n.height) < u)
                            : (e.which === L || h) &&
                              (0 === t
                                  ? (v = c.$menuInner[0].scrollTop = 0)
                                  : (d =
                                        u <
                                        (o =
                                            (n = c.selectpicker.current.data[v])
                                                .position -
                                            c.sizeInfo.menuInnerHeight))),
                            (s = c.selectpicker.current.elements[v]) &&
                                (s.classList.add("active"),
                                s.firstChild &&
                                    s.firstChild.classList.add("active")),
                            (c.activeIndex =
                                c.selectpicker.current.map.originalIndex[v]),
                            (c.selectpicker.view.currentActive = s),
                            d && (c.$menuInner[0].scrollTop = o),
                            c.options.liveSearch
                                ? c.$searchbox.focus()
                                : l.focus();
                    } else if (
                        (!l.is("input") && !P.test(e.which)) ||
                        (e.which === T && c.selectpicker.keydown.keyHistory)
                    ) {
                        var g,
                            b,
                            w = [];
                        e.preventDefault(),
                            (c.selectpicker.keydown.keyHistory += E[e.which]),
                            c.selectpicker.keydown.resetKeyHistory.cancel &&
                                clearTimeout(
                                    c.selectpicker.keydown.resetKeyHistory
                                        .cancel
                                ),
                            (c.selectpicker.keydown.resetKeyHistory.cancel =
                                c.selectpicker.keydown.resetKeyHistory.start()),
                            (b = c.selectpicker.keydown.keyHistory),
                            /^(.)\1+$/.test(b) && (b = b.charAt(0));
                        for (
                            var x = 0;
                            x < c.selectpicker.current.data.length;
                            x++
                        ) {
                            var I = c.selectpicker.current.data[x];
                            $(I, b, "startsWith", !0) &&
                                c.selectpicker.view.canHighlight[x] &&
                                ((I.index = x), w.push(I.originalIndex));
                        }
                        if (w.length) {
                            var k = 0;
                            a
                                .removeClass("active")
                                .find("a")
                                .removeClass("active"),
                                1 === b.length &&
                                    (-1 === (k = w.indexOf(c.activeIndex)) ||
                                    k === w.length - 1
                                        ? (k = 0)
                                        : k++),
                                (g = c.selectpicker.current.map.newIndex[w[k]]),
                                0 <
                                u -
                                    (n = c.selectpicker.current.data[g])
                                        .position
                                    ? ((o = n.position - n.height), (d = !0))
                                    : ((o =
                                          n.position -
                                          c.sizeInfo.menuInnerHeight),
                                      (d =
                                          n.position >
                                          u + c.sizeInfo.menuInnerHeight)),
                                (s =
                                    c.selectpicker.current.elements[
                                        g
                                    ]).classList.add("active"),
                                s.firstChild &&
                                    s.firstChild.classList.add("active"),
                                (c.activeIndex = w[k]),
                                s.firstChild.focus(),
                                d && (c.$menuInner[0].scrollTop = o),
                                l.focus();
                        }
                    }
                    i &&
                        ((e.which === T &&
                            !c.selectpicker.keydown.keyHistory) ||
                            e.which === z ||
                            (e.which === D && c.options.selectOnTab)) &&
                        (e.which !== T && e.preventDefault(),
                        (c.options.liveSearch && e.which === T) ||
                            (c.$menuInner
                                .find(".active a")
                                .trigger("click", !0),
                            l.focus(),
                            c.options.liveSearch ||
                                (e.preventDefault(),
                                F(document).data("spaceSelect", !0))));
                },
                mobile: function () {
                    this.$element.addClass("mobile-device");
                },
                refresh: function () {
                    var e = F.extend({}, this.options, this.$element.data());
                    (this.options = e),
                        (this.selectpicker.main.map.newIndex = {}),
                        (this.selectpicker.main.map.originalIndex = {}),
                        this.createLi(),
                        this.checkDisabled(),
                        this.render(),
                        this.setStyle(),
                        this.setWidth(),
                        this.setSize(!0),
                        this.$element.trigger("refreshed.bs.select");
                },
                hide: function () {
                    this.$newElement.hide();
                },
                show: function () {
                    this.$newElement.show();
                },
                remove: function () {
                    this.$newElement.remove(), this.$element.remove();
                },
                destroy: function () {
                    this.$newElement.before(this.$element).remove(),
                        this.$bsContainer
                            ? this.$bsContainer.remove()
                            : this.$menu.remove(),
                        this.$element
                            .off(".bs.select")
                            .removeData("selectpicker")
                            .removeClass("bs-select-hidden selectpicker");
                },
            });
        var h = F.fn.selectpicker;
        (F.fn.selectpicker = r),
            (F.fn.selectpicker.Constructor = c),
            (F.fn.selectpicker.noConflict = function () {
                return (F.fn.selectpicker = h), this;
            }),
            F(document)
                .off("keydown.bs.dropdown.data-api")
                .on(
                    "keydown.bs.select",
                    '.bootstrap-select [data-toggle="dropdown"], .bootstrap-select [role="listbox"], .bs-searchbox input',
                    c.prototype.keydown
                )
                .on(
                    "focusin.modal",
                    '.bootstrap-select [data-toggle="dropdown"], .bootstrap-select [role="listbox"], .bs-searchbox input',
                    function (e) {
                        e.stopPropagation();
                    }
                ),
            F(window).on("load.bs.select.data-api", function () {
                F(".selectpicker").each(function () {
                    var e = F(this);
                    r.call(e, e.data());
                });
            });
    })(e);
});

/* 
Ace Responsive Menu Plugin
Version: 1.0
Author: Samson.Onna 
Email : samson3d@gmail.com
----------------------------------------*/

(function ($) {
    $.fn.aceResponsiveMenu = function (options) {

        //plugin's default options
        var defaults = {
            resizeWidth: '768',
            animationSpeed: 'fast',
            accoridonExpAll: false
        };

        //Variables
        var options = $.extend(defaults, options),
            opt = options,
            $resizeWidth = opt.resizeWidth,
            $animationSpeed = opt.animationSpeed,
            $expandAll = opt.accoridonExpAll,
            $aceMenu = $(this),
            $menuStyle = $(this).attr('data-menu-style');

        // Initilizing        
        $aceMenu.find('ul').addClass("sub-menu");
        $aceMenu.find('ul').siblings('a').append('<span class="arrow "></span>');
        if ($menuStyle == 'accordion') { $(this).addClass('collapse'); }

        // Window resize on menu breakpoint 
        if ($(window).innerWidth() <= $resizeWidth) {
            menuCollapse();
        }
        $(window).resize(function () {
            menuCollapse();
        });

        // Menu Toggle
        function menuCollapse() {
            var w = $(window).innerWidth();
            if (w <= $resizeWidth) {
                $aceMenu.find('li.menu-active').removeClass('menu-active');
                $aceMenu.find('ul.slide').removeClass('slide').removeAttr('style');
                $aceMenu.addClass('collapse hide-menu');
                $aceMenu.attr('data-menu-style', '');
                $('.menu-toggle').show();
            } else {
                $aceMenu.attr('data-menu-style', $menuStyle);
                $aceMenu.removeClass('collapse hide-menu').removeAttr('style');
                $('.menu-toggle').hide();
                if ($aceMenu.attr('data-menu-style') == 'accordion') {
                    $aceMenu.addClass('collapse');
                    return;
                }
                $aceMenu.find('li.menu-active').removeClass('menu-active');
                $aceMenu.find('ul.slide').removeClass('slide').removeAttr('style');
            }
        }

        //ToggleBtn Click
        $('#menu-btn').click(function () {
            $aceMenu.slideToggle().toggleClass('hide-menu');
        });


        // Main function 
        return this.each(function () {
            // Function for Horizontal menu on mouseenter
            $aceMenu.on('mouseover', '> li a', function () {
                if ($aceMenu.hasClass('collapse') === true) {
                    return false;
                }
                $(this).off('click', '> li a');
                $(this).parent('li').siblings().children('.sub-menu').stop(true, true).slideUp($animationSpeed).removeClass('slide').removeAttr('style').stop();
                $(this).parent().addClass('menu-active').children('.sub-menu').slideDown($animationSpeed).addClass('slide');
                return;
            });
            $aceMenu.on('mouseleave', 'li', function () {
                if ($aceMenu.hasClass('collapse') === true) {
                    return false;
                }
                $(this).off('click', '> li a');
                $(this).removeClass('menu-active');
                $(this).children('ul.sub-menu').stop(true, true).slideUp($animationSpeed).removeClass('slide').removeAttr('style');
                return;
            });
            //End of Horizontal menu function

            // Function for Vertical/Responsive Menu on mouse click
            $aceMenu.on('click', '> li a', function () {
                if ($aceMenu.hasClass('collapse') === false) {
                    //return false;
                }
                $(this).off('mouseover', '> li a');
                if ($(this).parent().hasClass('menu-active')) {
                    $(this).parent().children('.sub-menu').slideUp().removeClass('slide');
                    $(this).parent().removeClass('menu-active');
                } else {
                    if ($expandAll == true) {
                        $(this).parent().addClass('menu-active').children('.sub-menu').slideDown($animationSpeed).addClass('slide');
                        return;
                    }
                    $(this).parent().siblings().removeClass('menu-active');
                    $(this).parent('li').siblings().children('.sub-menu').slideUp().removeClass('slide');
                    $(this).parent().addClass('menu-active').children('.sub-menu').slideDown($animationSpeed).addClass('slide');
                }
            });
            //End of responsive menu function

        });
        //End of Main function
    }
})(jQuery);


/**
 * Owl carousel
 * @version 2.0.0
 * @author Bartosz Wojciechowski
 * @license The MIT License (MIT)
 * @todo Lazy Load Icon
 * @todo prevent animationend bubling
 * @todo itemsScaleUp
 * @todo Test Zepto
 * @todo stagePadding calculate wrong active classes
 */
!function(a,b,c,d){function e(b,c){this.settings=null,this.options=a.extend({},e.Defaults,c),this.$element=a(b),this.drag=a.extend({},m),this.state=a.extend({},n),this.e=a.extend({},o),this._plugins={},this._supress={},this._current=null,this._speed=null,this._coordinates=[],this._breakpoint=null,this._width=null,this._items=[],this._clones=[],this._mergers=[],this._invalidated={},this._pipe=[],a.each(e.Plugins,a.proxy(function(a,b){this._plugins[a[0].toLowerCase()+a.slice(1)]=new b(this)},this)),a.each(e.Pipe,a.proxy(function(b,c){this._pipe.push({filter:c.filter,run:a.proxy(c.run,this)})},this)),this.setup(),this.initialize()}function f(a){if(a.touches!==d)return{x:a.touches[0].pageX,y:a.touches[0].pageY};if(a.touches===d){if(a.pageX!==d)return{x:a.pageX,y:a.pageY};if(a.pageX===d)return{x:a.clientX,y:a.clientY}}}function g(a){var b,d,e=c.createElement("div"),f=a;for(b in f)if(d=f[b],"undefined"!=typeof e.style[d])return e=null,[d,b];return[!1]}function h(){return g(["transition","WebkitTransition","MozTransition","OTransition"])[1]}function i(){return g(["transform","WebkitTransform","MozTransform","OTransform","msTransform"])[0]}function j(){return g(["perspective","webkitPerspective","MozPerspective","OPerspective","MsPerspective"])[0]}function k(){return"ontouchstart"in b||!!navigator.msMaxTouchPoints}function l(){return b.navigator.msPointerEnabled}var m,n,o;m={start:0,startX:0,startY:0,current:0,currentX:0,currentY:0,offsetX:0,offsetY:0,distance:null,startTime:0,endTime:0,updatedX:0,targetEl:null},n={isTouch:!1,isScrolling:!1,isSwiping:!1,direction:!1,inMotion:!1},o={_onDragStart:null,_onDragMove:null,_onDragEnd:null,_transitionEnd:null,_resizer:null,_responsiveCall:null,_goToLoop:null,_checkVisibile:null},e.Defaults={items:3,loop:!1,center:!1,mouseDrag:!0,touchDrag:!0,pullDrag:!0,freeDrag:!1,margin:0,stagePadding:0,merge:!1,mergeFit:!0,autoWidth:!1,startPosition:0,rtl:!1,smartSpeed:250,fluidSpeed:!1,dragEndSpeed:!1,responsive:{},responsiveRefreshRate:200,responsiveBaseElement:b,responsiveClass:!1,fallbackEasing:"swing",info:!1,nestedItemSelector:!1,itemElement:"div",stageElement:"div",themeClass:"owl-theme",baseClass:"owl-carousel",itemClass:"owl-item",centerClass:"center",activeClass:"active"},e.Width={Default:"default",Inner:"inner",Outer:"outer"},e.Plugins={},e.Pipe=[{filter:["width","items","settings"],run:function(a){a.current=this._items&&this._items[this.relative(this._current)]}},{filter:["items","settings"],run:function(){var a=this._clones,b=this.$stage.children(".cloned");(b.length!==a.length||!this.settings.loop&&a.length>0)&&(this.$stage.children(".cloned").remove(),this._clones=[])}},{filter:["items","settings"],run:function(){var a,b,c=this._clones,d=this._items,e=this.settings.loop?c.length-Math.max(2*this.settings.items,4):0;for(a=0,b=Math.abs(e/2);b>a;a++)e>0?(this.$stage.children().eq(d.length+c.length-1).remove(),c.pop(),this.$stage.children().eq(0).remove(),c.pop()):(c.push(c.length/2),this.$stage.append(d[c[c.length-1]].clone().addClass("cloned")),c.push(d.length-1-(c.length-1)/2),this.$stage.prepend(d[c[c.length-1]].clone().addClass("cloned")))}},{filter:["width","items","settings"],run:function(){var a,b,c,d=this.settings.rtl?1:-1,e=(this.width()/this.settings.items).toFixed(3),f=0;for(this._coordinates=[],b=0,c=this._clones.length+this._items.length;c>b;b++)a=this._mergers[this.relative(b)],a=this.settings.mergeFit&&Math.min(a,this.settings.items)||a,f+=(this.settings.autoWidth?this._items[this.relative(b)].width()+this.settings.margin:e*a)*d,this._coordinates.push(f)}},{filter:["width","items","settings"],run:function(){var b,c,d=(this.width()/this.settings.items).toFixed(3),e={width:Math.abs(this._coordinates[this._coordinates.length-1])+2*this.settings.stagePadding,"padding-left":this.settings.stagePadding||"","padding-right":this.settings.stagePadding||""};if(this.$stage.css(e),e={width:this.settings.autoWidth?"auto":d-this.settings.margin},e[this.settings.rtl?"margin-left":"margin-right"]=this.settings.margin,!this.settings.autoWidth&&a.grep(this._mergers,function(a){return a>1}).length>0)for(b=0,c=this._coordinates.length;c>b;b++)e.width=Math.abs(this._coordinates[b])-Math.abs(this._coordinates[b-1]||0)-this.settings.margin,this.$stage.children().eq(b).css(e);else this.$stage.children().css(e)}},{filter:["width","items","settings"],run:function(a){a.current&&this.reset(this.$stage.children().index(a.current))}},{filter:["position"],run:function(){this.animate(this.coordinates(this._current))}},{filter:["width","position","items","settings"],run:function(){var a,b,c,d,e=this.settings.rtl?1:-1,f=2*this.settings.stagePadding,g=this.coordinates(this.current())+f,h=g+this.width()*e,i=[];for(c=0,d=this._coordinates.length;d>c;c++)a=this._coordinates[c-1]||0,b=Math.abs(this._coordinates[c])+f*e,(this.op(a,"<=",g)&&this.op(a,">",h)||this.op(b,"<",g)&&this.op(b,">",h))&&i.push(c);this.$stage.children("."+this.settings.activeClass).removeClass(this.settings.activeClass),this.$stage.children(":eq("+i.join("), :eq(")+")").addClass(this.settings.activeClass),this.settings.center&&(this.$stage.children("."+this.settings.centerClass).removeClass(this.settings.centerClass),this.$stage.children().eq(this.current()).addClass(this.settings.centerClass))}}],e.prototype.initialize=function(){if(this.trigger("initialize"),this.$element.addClass(this.settings.baseClass).addClass(this.settings.themeClass).toggleClass("owl-rtl",this.settings.rtl),this.browserSupport(),this.settings.autoWidth&&this.state.imagesLoaded!==!0){var b,c,e;if(b=this.$element.find("img"),c=this.settings.nestedItemSelector?"."+this.settings.nestedItemSelector:d,e=this.$element.children(c).width(),b.length&&0>=e)return this.preloadAutoWidthImages(b),!1}this.$element.addClass("owl-loading"),this.$stage=a("<"+this.settings.stageElement+' class="owl-stage"/>').wrap('<div class="owl-stage-outer">'),this.$element.append(this.$stage.parent()),this.replace(this.$element.children().not(this.$stage.parent())),this._width=this.$element.width(),this.refresh(),this.$element.removeClass("owl-loading").addClass("owl-loaded"),this.eventsCall(),this.internalEvents(),this.addTriggerableEvents(),this.trigger("initialized")},e.prototype.setup=function(){var b=this.viewport(),c=this.options.responsive,d=-1,e=null;c?(a.each(c,function(a){b>=a&&a>d&&(d=Number(a))}),e=a.extend({},this.options,c[d]),delete e.responsive,e.responsiveClass&&this.$element.attr("class",function(a,b){return b.replace(/\b owl-responsive-\S+/g,"")}).addClass("owl-responsive-"+d)):e=a.extend({},this.options),(null===this.settings||this._breakpoint!==d)&&(this.trigger("change",{property:{name:"settings",value:e}}),this._breakpoint=d,this.settings=e,this.invalidate("settings"),this.trigger("changed",{property:{name:"settings",value:this.settings}}))},e.prototype.optionsLogic=function(){this.$element.toggleClass("owl-center",this.settings.center),this.settings.loop&&this._items.length<this.settings.items&&(this.settings.loop=!1),this.settings.autoWidth&&(this.settings.stagePadding=!1,this.settings.merge=!1)},e.prototype.prepare=function(b){var c=this.trigger("prepare",{content:b});return c.data||(c.data=a("<"+this.settings.itemElement+"/>").addClass(this.settings.itemClass).append(b)),this.trigger("prepared",{content:c.data}),c.data},e.prototype.update=function(){for(var b=0,c=this._pipe.length,d=a.proxy(function(a){return this[a]},this._invalidated),e={};c>b;)(this._invalidated.all||a.grep(this._pipe[b].filter,d).length>0)&&this._pipe[b].run(e),b++;this._invalidated={}},e.prototype.width=function(a){switch(a=a||e.Width.Default){case e.Width.Inner:case e.Width.Outer:return this._width;default:return this._width-2*this.settings.stagePadding+this.settings.margin}},e.prototype.refresh=function(){if(0===this._items.length)return!1;(new Date).getTime();this.trigger("refresh"),this.setup(),this.optionsLogic(),this.$stage.addClass("owl-refresh"),this.update(),this.$stage.removeClass("owl-refresh"),this.state.orientation=b.orientation,this.watchVisibility(),this.trigger("refreshed")},e.prototype.eventsCall=function(){this.e._onDragStart=a.proxy(function(a){this.onDragStart(a)},this),this.e._onDragMove=a.proxy(function(a){this.onDragMove(a)},this),this.e._onDragEnd=a.proxy(function(a){this.onDragEnd(a)},this),this.e._onResize=a.proxy(function(a){this.onResize(a)},this),this.e._transitionEnd=a.proxy(function(a){this.transitionEnd(a)},this),this.e._preventClick=a.proxy(function(a){this.preventClick(a)},this)},e.prototype.onThrottledResize=function(){b.clearTimeout(this.resizeTimer),this.resizeTimer=b.setTimeout(this.e._onResize,this.settings.responsiveRefreshRate)},e.prototype.onResize=function(){return this._items.length?this._width===this.$element.width()?!1:this.trigger("resize").isDefaultPrevented()?!1:(this._width=this.$element.width(),this.invalidate("width"),this.refresh(),void this.trigger("resized")):!1},e.prototype.eventsRouter=function(a){var b=a.type;"mousedown"===b||"touchstart"===b?this.onDragStart(a):"mousemove"===b||"touchmove"===b?this.onDragMove(a):"mouseup"===b||"touchend"===b?this.onDragEnd(a):"touchcancel"===b&&this.onDragEnd(a)},e.prototype.internalEvents=function(){var c=(k(),l());this.settings.mouseDrag?(this.$stage.on("mousedown",a.proxy(function(a){this.eventsRouter(a)},this)),this.$stage.on("dragstart",function(){return!1}),this.$stage.get(0).onselectstart=function(){return!1}):this.$element.addClass("owl-text-select-on"),this.settings.touchDrag&&!c&&this.$stage.on("touchstart touchcancel",a.proxy(function(a){this.eventsRouter(a)},this)),this.transitionEndVendor&&this.on(this.$stage.get(0),this.transitionEndVendor,this.e._transitionEnd,!1),this.settings.responsive!==!1&&this.on(b,"resize",a.proxy(this.onThrottledResize,this))},e.prototype.onDragStart=function(d){var e,g,h,i;if(e=d.originalEvent||d||b.event,3===e.which||this.state.isTouch)return!1;if("mousedown"===e.type&&this.$stage.addClass("owl-grab"),this.trigger("drag"),this.drag.startTime=(new Date).getTime(),this.speed(0),this.state.isTouch=!0,this.state.isScrolling=!1,this.state.isSwiping=!1,this.drag.distance=0,g=f(e).x,h=f(e).y,this.drag.offsetX=this.$stage.position().left,this.drag.offsetY=this.$stage.position().top,this.settings.rtl&&(this.drag.offsetX=this.$stage.position().left+this.$stage.width()-this.width()+this.settings.margin),this.state.inMotion&&this.support3d)i=this.getTransformProperty(),this.drag.offsetX=i,this.animate(i),this.state.inMotion=!0;else if(this.state.inMotion&&!this.support3d)return this.state.inMotion=!1,!1;this.drag.startX=g-this.drag.offsetX,this.drag.startY=h-this.drag.offsetY,this.drag.start=g-this.drag.startX,this.drag.targetEl=e.target||e.srcElement,this.drag.updatedX=this.drag.start,("IMG"===this.drag.targetEl.tagName||"A"===this.drag.targetEl.tagName)&&(this.drag.targetEl.draggable=!1),a(c).on("mousemove.owl.dragEvents mouseup.owl.dragEvents touchmove.owl.dragEvents touchend.owl.dragEvents",a.proxy(function(a){this.eventsRouter(a)},this))},e.prototype.onDragMove=function(a){var c,e,g,h,i,j;this.state.isTouch&&(this.state.isScrolling||(c=a.originalEvent||a||b.event,e=f(c).x,g=f(c).y,this.drag.currentX=e-this.drag.startX,this.drag.currentY=g-this.drag.startY,this.drag.distance=this.drag.currentX-this.drag.offsetX,this.drag.distance<0?this.state.direction=this.settings.rtl?"right":"left":this.drag.distance>0&&(this.state.direction=this.settings.rtl?"left":"right"),this.settings.loop?this.op(this.drag.currentX,">",this.coordinates(this.minimum()))&&"right"===this.state.direction?this.drag.currentX-=(this.settings.center&&this.coordinates(0))-this.coordinates(this._items.length):this.op(this.drag.currentX,"<",this.coordinates(this.maximum()))&&"left"===this.state.direction&&(this.drag.currentX+=(this.settings.center&&this.coordinates(0))-this.coordinates(this._items.length)):(h=this.coordinates(this.settings.rtl?this.maximum():this.minimum()),i=this.coordinates(this.settings.rtl?this.minimum():this.maximum()),j=this.settings.pullDrag?this.drag.distance/5:0,this.drag.currentX=Math.max(Math.min(this.drag.currentX,h+j),i+j)),(this.drag.distance>8||this.drag.distance<-8)&&(c.preventDefault!==d?c.preventDefault():c.returnValue=!1,this.state.isSwiping=!0),this.drag.updatedX=this.drag.currentX,(this.drag.currentY>16||this.drag.currentY<-16)&&this.state.isSwiping===!1&&(this.state.isScrolling=!0,this.drag.updatedX=this.drag.start),this.animate(this.drag.updatedX)))},e.prototype.onDragEnd=function(b){var d,e,f;if(this.state.isTouch){if("mouseup"===b.type&&this.$stage.removeClass("owl-grab"),this.trigger("dragged"),this.drag.targetEl.removeAttribute("draggable"),this.state.isTouch=!1,this.state.isScrolling=!1,this.state.isSwiping=!1,0===this.drag.distance&&this.state.inMotion!==!0)return this.state.inMotion=!1,!1;this.drag.endTime=(new Date).getTime(),d=this.drag.endTime-this.drag.startTime,e=Math.abs(this.drag.distance),(e>3||d>300)&&this.removeClick(this.drag.targetEl),f=this.closest(this.drag.updatedX),this.speed(this.settings.dragEndSpeed||this.settings.smartSpeed),this.current(f),this.invalidate("position"),this.update(),this.settings.pullDrag||this.drag.updatedX!==this.coordinates(f)||this.transitionEnd(),this.drag.distance=0,a(c).off(".owl.dragEvents")}},e.prototype.removeClick=function(c){this.drag.targetEl=c,a(c).on("click.preventClick",this.e._preventClick),b.setTimeout(function(){a(c).off("click.preventClick")},300)},e.prototype.preventClick=function(b){b.preventDefault?b.preventDefault():b.returnValue=!1,b.stopPropagation&&b.stopPropagation(),a(b.target).off("click.preventClick")},e.prototype.getTransformProperty=function(){var a,c;return a=b.getComputedStyle(this.$stage.get(0),null).getPropertyValue(this.vendorName+"transform"),a=a.replace(/matrix(3d)?\(|\)/g,"").split(","),c=16===a.length,c!==!0?a[4]:a[12]},e.prototype.closest=function(b){var c=-1,d=30,e=this.width(),f=this.coordinates();return this.settings.freeDrag||a.each(f,a.proxy(function(a,g){return b>g-d&&g+d>b?c=a:this.op(b,"<",g)&&this.op(b,">",f[a+1]||g-e)&&(c="left"===this.state.direction?a+1:a),-1===c},this)),this.settings.loop||(this.op(b,">",f[this.minimum()])?c=b=this.minimum():this.op(b,"<",f[this.maximum()])&&(c=b=this.maximum())),c},e.prototype.animate=function(b){this.trigger("translate"),this.state.inMotion=this.speed()>0,this.support3d?this.$stage.css({transform:"translate3d("+b+"px,0px, 0px)",transition:this.speed()/1e3+"s"}):this.state.isTouch?this.$stage.css({left:b+"px"}):this.$stage.animate({left:b},this.speed()/1e3,this.settings.fallbackEasing,a.proxy(function(){this.state.inMotion&&this.transitionEnd()},this))},e.prototype.current=function(a){if(a===d)return this._current;if(0===this._items.length)return d;if(a=this.normalize(a),this._current!==a){var b=this.trigger("change",{property:{name:"position",value:a}});b.data!==d&&(a=this.normalize(b.data)),this._current=a,this.invalidate("position"),this.trigger("changed",{property:{name:"position",value:this._current}})}return this._current},e.prototype.invalidate=function(a){this._invalidated[a]=!0},e.prototype.reset=function(a){a=this.normalize(a),a!==d&&(this._speed=0,this._current=a,this.suppress(["translate","translated"]),this.animate(this.coordinates(a)),this.release(["translate","translated"]))},e.prototype.normalize=function(b,c){var e=c?this._items.length:this._items.length+this._clones.length;return!a.isNumeric(b)||1>e?d:b=this._clones.length?(b%e+e)%e:Math.max(this.minimum(c),Math.min(this.maximum(c),b))},e.prototype.relative=function(a){return a=this.normalize(a),a-=this._clones.length/2,this.normalize(a,!0)},e.prototype.maximum=function(a){var b,c,d,e=0,f=this.settings;if(a)return this._items.length-1;if(!f.loop&&f.center)b=this._items.length-1;else if(f.loop||f.center)if(f.loop||f.center)b=this._items.length+f.items;else{if(!f.autoWidth&&!f.merge)throw"Can not detect maximum absolute position.";for(revert=f.rtl?1:-1,c=this.$stage.width()-this.$element.width();(d=this.coordinates(e))&&!(d*revert>=c);)b=++e}else b=this._items.length-f.items;return b},e.prototype.minimum=function(a){return a?0:this._clones.length/2},e.prototype.items=function(a){return a===d?this._items.slice():(a=this.normalize(a,!0),this._items[a])},e.prototype.mergers=function(a){return a===d?this._mergers.slice():(a=this.normalize(a,!0),this._mergers[a])},e.prototype.clones=function(b){var c=this._clones.length/2,e=c+this._items.length,f=function(a){return a%2===0?e+a/2:c-(a+1)/2};return b===d?a.map(this._clones,function(a,b){return f(b)}):a.map(this._clones,function(a,c){return a===b?f(c):null})},e.prototype.speed=function(a){return a!==d&&(this._speed=a),this._speed},e.prototype.coordinates=function(b){var c=null;return b===d?a.map(this._coordinates,a.proxy(function(a,b){return this.coordinates(b)},this)):(this.settings.center?(c=this._coordinates[b],c+=(this.width()-c+(this._coordinates[b-1]||0))/2*(this.settings.rtl?-1:1)):c=this._coordinates[b-1]||0,c)},e.prototype.duration=function(a,b,c){return Math.min(Math.max(Math.abs(b-a),1),6)*Math.abs(c||this.settings.smartSpeed)},e.prototype.to=function(c,d){if(this.settings.loop){var e=c-this.relative(this.current()),f=this.current(),g=this.current(),h=this.current()+e,i=0>g-h?!0:!1,j=this._clones.length+this._items.length;h<this.settings.items&&i===!1?(f=g+this._items.length,this.reset(f)):h>=j-this.settings.items&&i===!0&&(f=g-this._items.length,this.reset(f)),b.clearTimeout(this.e._goToLoop),this.e._goToLoop=b.setTimeout(a.proxy(function(){this.speed(this.duration(this.current(),f+e,d)),this.current(f+e),this.update()},this),30)}else this.speed(this.duration(this.current(),c,d)),this.current(c),this.update()},e.prototype.next=function(a){a=a||!1,this.to(this.relative(this.current())+1,a)},e.prototype.prev=function(a){a=a||!1,this.to(this.relative(this.current())-1,a)},e.prototype.transitionEnd=function(a){return a!==d&&(a.stopPropagation(),(a.target||a.srcElement||a.originalTarget)!==this.$stage.get(0))?!1:(this.state.inMotion=!1,void this.trigger("translated"))},e.prototype.viewport=function(){var d;if(this.options.responsiveBaseElement!==b)d=a(this.options.responsiveBaseElement).width();else if(b.innerWidth)d=b.innerWidth;else{if(!c.documentElement||!c.documentElement.clientWidth)throw"Can not detect viewport width.";d=c.documentElement.clientWidth}return d},e.prototype.replace=function(b){this.$stage.empty(),this._items=[],b&&(b=b instanceof jQuery?b:a(b)),this.settings.nestedItemSelector&&(b=b.find("."+this.settings.nestedItemSelector)),b.filter(function(){return 1===this.nodeType}).each(a.proxy(function(a,b){b=this.prepare(b),this.$stage.append(b),this._items.push(b),this._mergers.push(1*b.find("[data-merge]").andSelf("[data-merge]").attr("data-merge")||1)},this)),this.reset(a.isNumeric(this.settings.startPosition)?this.settings.startPosition:0),this.invalidate("items")},e.prototype.add=function(a,b){b=b===d?this._items.length:this.normalize(b,!0),this.trigger("add",{content:a,position:b}),0===this._items.length||b===this._items.length?(this.$stage.append(a),this._items.push(a),this._mergers.push(1*a.find("[data-merge]").andSelf("[data-merge]").attr("data-merge")||1)):(this._items[b].before(a),this._items.splice(b,0,a),this._mergers.splice(b,0,1*a.find("[data-merge]").andSelf("[data-merge]").attr("data-merge")||1)),this.invalidate("items"),this.trigger("added",{content:a,position:b})},e.prototype.remove=function(a){a=this.normalize(a,!0),a!==d&&(this.trigger("remove",{content:this._items[a],position:a}),this._items[a].remove(),this._items.splice(a,1),this._mergers.splice(a,1),this.invalidate("items"),this.trigger("removed",{content:null,position:a}))},e.prototype.addTriggerableEvents=function(){var b=a.proxy(function(b,c){return a.proxy(function(a){a.relatedTarget!==this&&(this.suppress([c]),b.apply(this,[].slice.call(arguments,1)),this.release([c]))},this)},this);a.each({next:this.next,prev:this.prev,to:this.to,destroy:this.destroy,refresh:this.refresh,replace:this.replace,add:this.add,remove:this.remove},a.proxy(function(a,c){this.$element.on(a+".owl.carousel",b(c,a+".owl.carousel"))},this))},e.prototype.watchVisibility=function(){function c(a){return a.offsetWidth>0&&a.offsetHeight>0}function d(){c(this.$element.get(0))&&(this.$element.removeClass("owl-hidden"),this.refresh(),b.clearInterval(this.e._checkVisibile))}c(this.$element.get(0))||(this.$element.addClass("owl-hidden"),b.clearInterval(this.e._checkVisibile),this.e._checkVisibile=b.setInterval(a.proxy(d,this),500))},e.prototype.preloadAutoWidthImages=function(b){var c,d,e,f;c=0,d=this,b.each(function(g,h){e=a(h),f=new Image,f.onload=function(){c++,e.attr("src",f.src),e.css("opacity",1),c>=b.length&&(d.state.imagesLoaded=!0,d.initialize())},f.src=e.attr("src")||e.attr("data-src")||e.attr("data-src-retina")})},e.prototype.destroy=function(){this.$element.hasClass(this.settings.themeClass)&&this.$element.removeClass(this.settings.themeClass),this.settings.responsive!==!1&&a(b).off("resize.owl.carousel"),this.transitionEndVendor&&this.off(this.$stage.get(0),this.transitionEndVendor,this.e._transitionEnd);for(var d in this._plugins)this._plugins[d].destroy();(this.settings.mouseDrag||this.settings.touchDrag)&&(this.$stage.off("mousedown touchstart touchcancel"),a(c).off(".owl.dragEvents"),this.$stage.get(0).onselectstart=function(){},this.$stage.off("dragstart",function(){return!1})),this.$element.off(".owl"),this.$stage.children(".cloned").remove(),this.e=null,this.$element.removeData("owlCarousel"),this.$stage.children().contents().unwrap(),this.$stage.children().unwrap(),this.$stage.unwrap()},e.prototype.op=function(a,b,c){var d=this.settings.rtl;switch(b){case"<":return d?a>c:c>a;case">":return d?c>a:a>c;case">=":return d?c>=a:a>=c;case"<=":return d?a>=c:c>=a}},e.prototype.on=function(a,b,c,d){a.addEventListener?a.addEventListener(b,c,d):a.attachEvent&&a.attachEvent("on"+b,c)},e.prototype.off=function(a,b,c,d){a.removeEventListener?a.removeEventListener(b,c,d):a.detachEvent&&a.detachEvent("on"+b,c)},e.prototype.trigger=function(b,c,d){var e={item:{count:this._items.length,index:this.current()}},f=a.camelCase(a.grep(["on",b,d],function(a){return a}).join("-").toLowerCase()),g=a.Event([b,"owl",d||"carousel"].join(".").toLowerCase(),a.extend({relatedTarget:this},e,c));return this._supress[b]||(a.each(this._plugins,function(a,b){b.onTrigger&&b.onTrigger(g)}),this.$element.trigger(g),this.settings&&"function"==typeof this.settings[f]&&this.settings[f].apply(this,g)),g},e.prototype.suppress=function(b){a.each(b,a.proxy(function(a,b){this._supress[b]=!0},this))},e.prototype.release=function(b){a.each(b,a.proxy(function(a,b){delete this._supress[b]},this))},e.prototype.browserSupport=function(){if(this.support3d=j(),this.support3d){this.transformVendor=i();var a=["transitionend","webkitTransitionEnd","transitionend","oTransitionEnd"];this.transitionEndVendor=a[h()],this.vendorName=this.transformVendor.replace(/Transform/i,""),this.vendorName=""!==this.vendorName?"-"+this.vendorName.toLowerCase()+"-":""}this.state.orientation=b.orientation},a.fn.owlCarousel=function(b){return this.each(function(){a(this).data("owlCarousel")||a(this).data("owlCarousel",new e(this,b))})},a.fn.owlCarousel.Constructor=e}(window.Zepto||window.jQuery,window,document),function(a,b){var c=function(b){this._core=b,this._loaded=[],this._handlers={"initialized.owl.carousel change.owl.carousel":a.proxy(function(b){if(b.namespace&&this._core.settings&&this._core.settings.lazyLoad&&(b.property&&"position"==b.property.name||"initialized"==b.type))for(var c=this._core.settings,d=c.center&&Math.ceil(c.items/2)||c.items,e=c.center&&-1*d||0,f=(b.property&&b.property.value||this._core.current())+e,g=this._core.clones().length,h=a.proxy(function(a,b){this.load(b)},this);e++<d;)this.load(g/2+this._core.relative(f)),g&&a.each(this._core.clones(this._core.relative(f++)),h)},this)},this._core.options=a.extend({},c.Defaults,this._core.options),this._core.$element.on(this._handlers)};c.Defaults={lazyLoad:!1},c.prototype.load=function(c){var d=this._core.$stage.children().eq(c),e=d&&d.find(".owl-lazy");!e||a.inArray(d.get(0),this._loaded)>-1||(e.each(a.proxy(function(c,d){var e,f=a(d),g=b.devicePixelRatio>1&&f.attr("data-src-retina")||f.attr("data-src");this._core.trigger("load",{element:f,url:g},"lazy"),f.is("img")?f.one("load.owl.lazy",a.proxy(function(){f.css("opacity",1),this._core.trigger("loaded",{element:f,url:g},"lazy")},this)).attr("src",g):(e=new Image,e.onload=a.proxy(function(){f.css({"background-image":"url("+g+")",opacity:"1"}),this._core.trigger("loaded",{element:f,url:g},"lazy")},this),e.src=g)},this)),this._loaded.push(d.get(0)))},c.prototype.destroy=function(){var a,b;for(a in this.handlers)this._core.$element.off(a,this.handlers[a]);for(b in Object.getOwnPropertyNames(this))"function"!=typeof this[b]&&(this[b]=null)},a.fn.owlCarousel.Constructor.Plugins.Lazy=c}(window.Zepto||window.jQuery,window,document),function(a){var b=function(c){this._core=c,this._handlers={"initialized.owl.carousel":a.proxy(function(){this._core.settings.autoHeight&&this.update()},this),"changed.owl.carousel":a.proxy(function(a){this._core.settings.autoHeight&&"position"==a.property.name&&this.update()},this),"loaded.owl.lazy":a.proxy(function(a){this._core.settings.autoHeight&&a.element.closest("."+this._core.settings.itemClass)===this._core.$stage.children().eq(this._core.current())&&this.update()},this)},this._core.options=a.extend({},b.Defaults,this._core.options),this._core.$element.on(this._handlers)};b.Defaults={autoHeight:!1,autoHeightClass:"owl-height"},b.prototype.update=function(){this._core.$stage.parent().height(this._core.$stage.children().eq(this._core.current()).height()).addClass(this._core.settings.autoHeightClass)},b.prototype.destroy=function(){var a,b;for(a in this._handlers)this._core.$element.off(a,this._handlers[a]);for(b in Object.getOwnPropertyNames(this))"function"!=typeof this[b]&&(this[b]=null)},a.fn.owlCarousel.Constructor.Plugins.AutoHeight=b}(window.Zepto||window.jQuery,window,document),function(a,b,c){var d=function(b){this._core=b,this._videos={},this._playing=null,this._fullscreen=!1,this._handlers={"resize.owl.carousel":a.proxy(function(a){this._core.settings.video&&!this.isInFullScreen()&&a.preventDefault()},this),"refresh.owl.carousel changed.owl.carousel":a.proxy(function(){this._playing&&this.stop()},this),"prepared.owl.carousel":a.proxy(function(b){var c=a(b.content).find(".owl-video");c.length&&(c.css("display","none"),this.fetch(c,a(b.content)))},this)},this._core.options=a.extend({},d.Defaults,this._core.options),this._core.$element.on(this._handlers),this._core.$element.on("click.owl.video",".owl-video-play-icon",a.proxy(function(a){this.play(a)},this))};d.Defaults={video:!1,videoHeight:!1,videoWidth:!1},d.prototype.fetch=function(a,b){var c=a.attr("data-vimeo-id")?"vimeo":"youtube",d=a.attr("data-vimeo-id")||a.attr("data-youtube-id"),e=a.attr("data-width")||this._core.settings.videoWidth,f=a.attr("data-height")||this._core.settings.videoHeight,g=a.attr("href");if(!g)throw new Error("Missing video URL.");if(d=g.match(/(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/),d[3].indexOf("youtu")>-1)c="youtube";else{if(!(d[3].indexOf("vimeo")>-1))throw new Error("Video URL not supported.");c="vimeo"}d=d[6],this._videos[g]={type:c,id:d,width:e,height:f},b.attr("data-video",g),this.thumbnail(a,this._videos[g])},d.prototype.thumbnail=function(b,c){var d,e,f,g=c.width&&c.height?'style="width:'+c.width+"px;height:"+c.height+'px;"':"",h=b.find("img"),i="src",j="",k=this._core.settings,l=function(a){e='<div class="owl-video-play-icon"></div>',d=k.lazyLoad?'<div class="owl-video-tn '+j+'" '+i+'="'+a+'"></div>':'<div class="owl-video-tn" style="opacity:1;background-image:url('+a+')"></div>',b.after(d),b.after(e)};return b.wrap('<div class="owl-video-wrapper"'+g+"></div>"),this._core.settings.lazyLoad&&(i="data-src",j="owl-lazy"),h.length?(l(h.attr(i)),h.remove(),!1):void("youtube"===c.type?(f="http://img.youtube.com/vi/"+c.id+"/hqdefault.jpg",l(f)):"vimeo"===c.type&&a.ajax({type:"GET",url:"http://vimeo.com/api/v2/video/"+c.id+".json",jsonp:"callback",dataType:"jsonp",success:function(a){f=a[0].thumbnail_large,l(f)}}))},d.prototype.stop=function(){this._core.trigger("stop",null,"video"),this._playing.find(".owl-video-frame").remove(),this._playing.removeClass("owl-video-playing"),this._playing=null},d.prototype.play=function(b){this._core.trigger("play",null,"video"),this._playing&&this.stop();var c,d,e=a(b.target||b.srcElement),f=e.closest("."+this._core.settings.itemClass),g=this._videos[f.attr("data-video")],h=g.width||"100%",i=g.height||this._core.$stage.height();"youtube"===g.type?c='<iframe width="'+h+'" height="'+i+'" src="http://www.youtube.com/embed/'+g.id+"?autoplay=1&v="+g.id+'" frameborder="0" allowfullscreen></iframe>':"vimeo"===g.type&&(c='<iframe src="http://player.vimeo.com/video/'+g.id+'?autoplay=1" width="'+h+'" height="'+i+'" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>'),f.addClass("owl-video-playing"),this._playing=f,d=a('<div style="height:'+i+"px; width:"+h+'px" class="owl-video-frame">'+c+"</div>"),e.after(d)},d.prototype.isInFullScreen=function(){var d=c.fullscreenElement||c.mozFullScreenElement||c.webkitFullscreenElement;return d&&a(d).parent().hasClass("owl-video-frame")&&(this._core.speed(0),this._fullscreen=!0),d&&this._fullscreen&&this._playing?!1:this._fullscreen?(this._fullscreen=!1,!1):this._playing&&this._core.state.orientation!==b.orientation?(this._core.state.orientation=b.orientation,!1):!0},d.prototype.destroy=function(){var a,b;this._core.$element.off("click.owl.video");for(a in this._handlers)this._core.$element.off(a,this._handlers[a]);for(b in Object.getOwnPropertyNames(this))"function"!=typeof this[b]&&(this[b]=null)},a.fn.owlCarousel.Constructor.Plugins.Video=d}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){var e=function(b){this.core=b,this.core.options=a.extend({},e.Defaults,this.core.options),this.swapping=!0,this.previous=d,this.next=d,this.handlers={"change.owl.carousel":a.proxy(function(a){"position"==a.property.name&&(this.previous=this.core.current(),this.next=a.property.value)},this),"drag.owl.carousel dragged.owl.carousel translated.owl.carousel":a.proxy(function(a){this.swapping="translated"==a.type},this),"translate.owl.carousel":a.proxy(function(){this.swapping&&(this.core.options.animateOut||this.core.options.animateIn)&&this.swap()},this)},this.core.$element.on(this.handlers)};e.Defaults={animateOut:!1,animateIn:!1},e.prototype.swap=function(){if(1===this.core.settings.items&&this.core.support3d){this.core.speed(0);var b,c=a.proxy(this.clear,this),d=this.core.$stage.children().eq(this.previous),e=this.core.$stage.children().eq(this.next),f=this.core.settings.animateIn,g=this.core.settings.animateOut;this.core.current()!==this.previous&&(g&&(b=this.core.coordinates(this.previous)-this.core.coordinates(this.next),d.css({left:b+"px"}).addClass("animated owl-animated-out").addClass(g).one("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend",c)),f&&e.addClass("animated owl-animated-in").addClass(f).one("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend",c))}},e.prototype.clear=function(b){a(b.target).css({left:""}).removeClass("animated owl-animated-out owl-animated-in").removeClass(this.core.settings.animateIn).removeClass(this.core.settings.animateOut),this.core.transitionEnd()},e.prototype.destroy=function(){var a,b;for(a in this.handlers)this.core.$element.off(a,this.handlers[a]);for(b in Object.getOwnPropertyNames(this))"function"!=typeof this[b]&&(this[b]=null)},a.fn.owlCarousel.Constructor.Plugins.Animate=e}(window.Zepto||window.jQuery,window,document),function(a,b,c){var d=function(b){this.core=b,this.core.options=a.extend({},d.Defaults,this.core.options),this.handlers={"translated.owl.carousel refreshed.owl.carousel":a.proxy(function(){this.autoplay()
},this),"play.owl.autoplay":a.proxy(function(a,b,c){this.play(b,c)},this),"stop.owl.autoplay":a.proxy(function(){this.stop()},this),"mouseover.owl.autoplay":a.proxy(function(){this.core.settings.autoplayHoverPause&&this.pause()},this),"mouseleave.owl.autoplay":a.proxy(function(){this.core.settings.autoplayHoverPause&&this.autoplay()},this)},this.core.$element.on(this.handlers)};d.Defaults={autoplay:!1,autoplayTimeout:5e3,autoplayHoverPause:!1,autoplaySpeed:!1},d.prototype.autoplay=function(){this.core.settings.autoplay&&!this.core.state.videoPlay?(b.clearInterval(this.interval),this.interval=b.setInterval(a.proxy(function(){this.play()},this),this.core.settings.autoplayTimeout)):b.clearInterval(this.interval)},d.prototype.play=function(){return c.hidden===!0||this.core.state.isTouch||this.core.state.isScrolling||this.core.state.isSwiping||this.core.state.inMotion?void 0:this.core.settings.autoplay===!1?void b.clearInterval(this.interval):void this.core.next(this.core.settings.autoplaySpeed)},d.prototype.stop=function(){b.clearInterval(this.interval)},d.prototype.pause=function(){b.clearInterval(this.interval)},d.prototype.destroy=function(){var a,c;b.clearInterval(this.interval);for(a in this.handlers)this.core.$element.off(a,this.handlers[a]);for(c in Object.getOwnPropertyNames(this))"function"!=typeof this[c]&&(this[c]=null)},a.fn.owlCarousel.Constructor.Plugins.autoplay=d}(window.Zepto||window.jQuery,window,document),function(a){"use strict";var b=function(c){this._core=c,this._initialized=!1,this._pages=[],this._controls={},this._templates=[],this.$element=this._core.$element,this._overrides={next:this._core.next,prev:this._core.prev,to:this._core.to},this._handlers={"prepared.owl.carousel":a.proxy(function(b){this._core.settings.dotsData&&this._templates.push(a(b.content).find("[data-dot]").andSelf("[data-dot]").attr("data-dot"))},this),"add.owl.carousel":a.proxy(function(b){this._core.settings.dotsData&&this._templates.splice(b.position,0,a(b.content).find("[data-dot]").andSelf("[data-dot]").attr("data-dot"))},this),"remove.owl.carousel prepared.owl.carousel":a.proxy(function(a){this._core.settings.dotsData&&this._templates.splice(a.position,1)},this),"change.owl.carousel":a.proxy(function(a){if("position"==a.property.name&&!this._core.state.revert&&!this._core.settings.loop&&this._core.settings.navRewind){var b=this._core.current(),c=this._core.maximum(),d=this._core.minimum();a.data=a.property.value>c?b>=c?d:c:a.property.value<d?c:a.property.value}},this),"changed.owl.carousel":a.proxy(function(a){"position"==a.property.name&&this.draw()},this),"refreshed.owl.carousel":a.proxy(function(){this._initialized||(this.initialize(),this._initialized=!0),this._core.trigger("refresh",null,"navigation"),this.update(),this.draw(),this._core.trigger("refreshed",null,"navigation")},this)},this._core.options=a.extend({},b.Defaults,this._core.options),this.$element.on(this._handlers)};b.Defaults={nav:!1,navRewind:!0,navText:["prev","next"],navSpeed:!1,navElement:"div",navContainer:!1,navContainerClass:"owl-nav",navClass:["owl-prev","owl-next"],slideBy:1,dotClass:"owl-dot",dotsClass:"owl-dots",dots:!0,dotsEach:!1,dotData:!1,dotsSpeed:!1,dotsContainer:!1,controlsClass:"owl-controls"},b.prototype.initialize=function(){var b,c,d=this._core.settings;d.dotsData||(this._templates=[a("<div>").addClass(d.dotClass).append(a("<span>")).prop("outerHTML")]),d.navContainer&&d.dotsContainer||(this._controls.$container=a("<div>").addClass(d.controlsClass).appendTo(this.$element)),this._controls.$indicators=d.dotsContainer?a(d.dotsContainer):a("<div>").hide().addClass(d.dotsClass).appendTo(this._controls.$container),this._controls.$indicators.on("click","div",a.proxy(function(b){var c=a(b.target).parent().is(this._controls.$indicators)?a(b.target).index():a(b.target).parent().index();b.preventDefault(),this.to(c,d.dotsSpeed)},this)),b=d.navContainer?a(d.navContainer):a("<div>").addClass(d.navContainerClass).prependTo(this._controls.$container),this._controls.$next=a("<"+d.navElement+">"),this._controls.$previous=this._controls.$next.clone(),this._controls.$previous.addClass(d.navClass[0]).html(d.navText[0]).hide().prependTo(b).on("click",a.proxy(function(){this.prev(d.navSpeed)},this)),this._controls.$next.addClass(d.navClass[1]).html(d.navText[1]).hide().appendTo(b).on("click",a.proxy(function(){this.next(d.navSpeed)},this));for(c in this._overrides)this._core[c]=a.proxy(this[c],this)},b.prototype.destroy=function(){var a,b,c,d;for(a in this._handlers)this.$element.off(a,this._handlers[a]);for(b in this._controls)this._controls[b].remove();for(d in this.overides)this._core[d]=this._overrides[d];for(c in Object.getOwnPropertyNames(this))"function"!=typeof this[c]&&(this[c]=null)},b.prototype.update=function(){var a,b,c,d=this._core.settings,e=this._core.clones().length/2,f=e+this._core.items().length,g=d.center||d.autoWidth||d.dotData?1:d.dotsEach||d.items;if("page"!==d.slideBy&&(d.slideBy=Math.min(d.slideBy,d.items)),d.dots||"page"==d.slideBy)for(this._pages=[],a=e,b=0,c=0;f>a;a++)(b>=g||0===b)&&(this._pages.push({start:a-e,end:a-e+g-1}),b=0,++c),b+=this._core.mergers(this._core.relative(a))},b.prototype.draw=function(){var b,c,d="",e=this._core.settings,f=(this._core.$stage.children(),this._core.relative(this._core.current()));if(!e.nav||e.loop||e.navRewind||(this._controls.$previous.toggleClass("disabled",0>=f),this._controls.$next.toggleClass("disabled",f>=this._core.maximum())),this._controls.$previous.toggle(e.nav),this._controls.$next.toggle(e.nav),e.dots){if(b=this._pages.length-this._controls.$indicators.children().length,e.dotData&&0!==b){for(c=0;c<this._controls.$indicators.children().length;c++)d+=this._templates[this._core.relative(c)];this._controls.$indicators.html(d)}else b>0?(d=new Array(b+1).join(this._templates[0]),this._controls.$indicators.append(d)):0>b&&this._controls.$indicators.children().slice(b).remove();this._controls.$indicators.find(".active").removeClass("active"),this._controls.$indicators.children().eq(a.inArray(this.current(),this._pages)).addClass("active")}this._controls.$indicators.toggle(e.dots)},b.prototype.onTrigger=function(b){var c=this._core.settings;b.page={index:a.inArray(this.current(),this._pages),count:this._pages.length,size:c&&(c.center||c.autoWidth||c.dotData?1:c.dotsEach||c.items)}},b.prototype.current=function(){var b=this._core.relative(this._core.current());return a.grep(this._pages,function(a){return a.start<=b&&a.end>=b}).pop()},b.prototype.getPosition=function(b){var c,d,e=this._core.settings;return"page"==e.slideBy?(c=a.inArray(this.current(),this._pages),d=this._pages.length,b?++c:--c,c=this._pages[(c%d+d)%d].start):(c=this._core.relative(this._core.current()),d=this._core.items().length,b?c+=e.slideBy:c-=e.slideBy),c},b.prototype.next=function(b){a.proxy(this._overrides.to,this._core)(this.getPosition(!0),b)},b.prototype.prev=function(b){a.proxy(this._overrides.to,this._core)(this.getPosition(!1),b)},b.prototype.to=function(b,c,d){var e;d?a.proxy(this._overrides.to,this._core)(b,c):(e=this._pages.length,a.proxy(this._overrides.to,this._core)(this._pages[(b%e+e)%e].start,c))},a.fn.owlCarousel.Constructor.Plugins.Navigation=b}(window.Zepto||window.jQuery,window,document),function(a,b){"use strict";var c=function(d){this._core=d,this._hashes={},this.$element=this._core.$element,this._handlers={"initialized.owl.carousel":a.proxy(function(){"URLHash"==this._core.settings.startPosition&&a(b).trigger("hashchange.owl.navigation")},this),"prepared.owl.carousel":a.proxy(function(b){var c=a(b.content).find("[data-hash]").andSelf("[data-hash]").attr("data-hash");this._hashes[c]=b.content},this)},this._core.options=a.extend({},c.Defaults,this._core.options),this.$element.on(this._handlers),a(b).on("hashchange.owl.navigation",a.proxy(function(){var a=b.location.hash.substring(1),c=this._core.$stage.children(),d=this._hashes[a]&&c.index(this._hashes[a])||0;return a?void this._core.to(d,!1,!0):!1},this))};c.Defaults={URLhashListener:!1},c.prototype.destroy=function(){var c,d;a(b).off("hashchange.owl.navigation");for(c in this._handlers)this._core.$element.off(c,this._handlers[c]);for(d in Object.getOwnPropertyNames(this))"function"!=typeof this[d]&&(this[d]=null)},a.fn.owlCarousel.Constructor.Plugins.Hash=c}(window.Zepto||window.jQuery,window,document);

/* SlickSlider */
!function(i){"use strict";"function"==typeof define&&define.amd?define(["jquery"],i):"undefined"!=typeof exports?module.exports=i(require("jquery")):i(jQuery)}(function(i){"use strict";var e=window.Slick||{};(e=function(){var e=0;return function(t,o){var s,n=this;n.defaults={accessibility:!0,adaptiveHeight:!1,appendArrows:i(t),appendDots:i(t),arrows:!0,asNavFor:null,prevArrow:'<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',nextArrow:'<button class="slick-next" aria-label="Next" type="button">Next</button>',autoplay:!1,autoplaySpeed:3e3,centerMode:!1,centerPadding:"50px",cssEase:"ease",customPaging:function(e,t){return i('<button type="button" />').text(t+1)},dots:!1,dotsClass:"slick-dots",draggable:!0,easing:"linear",edgeFriction:.35,fade:!1,focusOnSelect:!1,focusOnChange:!1,infinite:!0,initialSlide:0,lazyLoad:"ondemand",mobileFirst:!1,pauseOnHover:!0,pauseOnFocus:!0,pauseOnDotsHover:!1,respondTo:"window",responsive:null,rows:1,rtl:!1,slide:"",slidesPerRow:1,slidesToShow:1,slidesToScroll:1,speed:500,swipe:!0,swipeToSlide:!1,touchMove:!0,touchThreshold:5,useCSS:!0,useTransform:!0,variableWidth:!1,vertical:!1,verticalSwiping:!1,waitForAnimate:!0,zIndex:1e3},n.initials={animating:!1,dragging:!1,autoPlayTimer:null,currentDirection:0,currentLeft:null,currentSlide:0,direction:1,$dots:null,listWidth:null,listHeight:null,loadIndex:0,$nextArrow:null,$prevArrow:null,scrolling:!1,slideCount:null,slideWidth:null,$slideTrack:null,$slides:null,sliding:!1,slideOffset:0,swipeLeft:null,swiping:!1,$list:null,touchObject:{},transformsEnabled:!1,unslicked:!1},i.extend(n,n.initials),n.activeBreakpoint=null,n.animType=null,n.animProp=null,n.breakpoints=[],n.breakpointSettings=[],n.cssTransitions=!1,n.focussed=!1,n.interrupted=!1,n.hidden="hidden",n.paused=!0,n.positionProp=null,n.respondTo=null,n.rowCount=1,n.shouldClick=!0,n.$slider=i(t),n.$slidesCache=null,n.transformType=null,n.transitionType=null,n.visibilityChange="visibilitychange",n.windowWidth=0,n.windowTimer=null,s=i(t).data("slick")||{},n.options=i.extend({},n.defaults,o,s),n.currentSlide=n.options.initialSlide,n.originalSettings=n.options,void 0!==document.mozHidden?(n.hidden="mozHidden",n.visibilityChange="mozvisibilitychange"):void 0!==document.webkitHidden&&(n.hidden="webkitHidden",n.visibilityChange="webkitvisibilitychange"),n.autoPlay=i.proxy(n.autoPlay,n),n.autoPlayClear=i.proxy(n.autoPlayClear,n),n.autoPlayIterator=i.proxy(n.autoPlayIterator,n),n.changeSlide=i.proxy(n.changeSlide,n),n.clickHandler=i.proxy(n.clickHandler,n),n.selectHandler=i.proxy(n.selectHandler,n),n.setPosition=i.proxy(n.setPosition,n),n.swipeHandler=i.proxy(n.swipeHandler,n),n.dragHandler=i.proxy(n.dragHandler,n),n.keyHandler=i.proxy(n.keyHandler,n),n.instanceUid=e++,n.htmlExpr=/^(?:\s*(<[\w\W]+>)[^>]*)$/,n.registerBreakpoints(),n.init(!0)}}()).prototype.activateADA=function(){this.$slideTrack.find(".slick-active").attr({"aria-hidden":"false"}).find("a, input, button, select").attr({tabindex:"0"})},e.prototype.addSlide=e.prototype.slickAdd=function(e,t,o){var s=this;if("boolean"==typeof t)o=t,t=null;else if(t<0||t>=s.slideCount)return!1;s.unload(),"number"==typeof t?0===t&&0===s.$slides.length?i(e).appendTo(s.$slideTrack):o?i(e).insertBefore(s.$slides.eq(t)):i(e).insertAfter(s.$slides.eq(t)):!0===o?i(e).prependTo(s.$slideTrack):i(e).appendTo(s.$slideTrack),s.$slides=s.$slideTrack.children(this.options.slide),s.$slideTrack.children(this.options.slide).detach(),s.$slideTrack.append(s.$slides),s.$slides.each(function(e,t){i(t).attr("data-slick-index",e)}),s.$slidesCache=s.$slides,s.reinit()},e.prototype.animateHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.animate({height:e},i.options.speed)}},e.prototype.animateSlide=function(e,t){var o={},s=this;s.animateHeight(),!0===s.options.rtl&&!1===s.options.vertical&&(e=-e),!1===s.transformsEnabled?!1===s.options.vertical?s.$slideTrack.animate({left:e},s.options.speed,s.options.easing,t):s.$slideTrack.animate({top:e},s.options.speed,s.options.easing,t):!1===s.cssTransitions?(!0===s.options.rtl&&(s.currentLeft=-s.currentLeft),i({animStart:s.currentLeft}).animate({animStart:e},{duration:s.options.speed,easing:s.options.easing,step:function(i){i=Math.ceil(i),!1===s.options.vertical?(o[s.animType]="translate("+i+"px, 0px)",s.$slideTrack.css(o)):(o[s.animType]="translate(0px,"+i+"px)",s.$slideTrack.css(o))},complete:function(){t&&t.call()}})):(s.applyTransition(),e=Math.ceil(e),!1===s.options.vertical?o[s.animType]="translate3d("+e+"px, 0px, 0px)":o[s.animType]="translate3d(0px,"+e+"px, 0px)",s.$slideTrack.css(o),t&&setTimeout(function(){s.disableTransition(),t.call()},s.options.speed))},e.prototype.getNavTarget=function(){var e=this,t=e.options.asNavFor;return t&&null!==t&&(t=i(t).not(e.$slider)),t},e.prototype.asNavFor=function(e){var t=this.getNavTarget();null!==t&&"object"==typeof t&&t.each(function(){var t=i(this).slick("getSlick");t.unslicked||t.slideHandler(e,!0)})},e.prototype.applyTransition=function(i){var e=this,t={};!1===e.options.fade?t[e.transitionType]=e.transformType+" "+e.options.speed+"ms "+e.options.cssEase:t[e.transitionType]="opacity "+e.options.speed+"ms "+e.options.cssEase,!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.autoPlay=function(){var i=this;i.autoPlayClear(),i.slideCount>i.options.slidesToShow&&(i.autoPlayTimer=setInterval(i.autoPlayIterator,i.options.autoplaySpeed))},e.prototype.autoPlayClear=function(){var i=this;i.autoPlayTimer&&clearInterval(i.autoPlayTimer)},e.prototype.autoPlayIterator=function(){var i=this,e=i.currentSlide+i.options.slidesToScroll;i.paused||i.interrupted||i.focussed||(!1===i.options.infinite&&(1===i.direction&&i.currentSlide+1===i.slideCount-1?i.direction=0:0===i.direction&&(e=i.currentSlide-i.options.slidesToScroll,i.currentSlide-1==0&&(i.direction=1))),i.slideHandler(e))},e.prototype.buildArrows=function(){var e=this;!0===e.options.arrows&&(e.$prevArrow=i(e.options.prevArrow).addClass("slick-arrow"),e.$nextArrow=i(e.options.nextArrow).addClass("slick-arrow"),e.slideCount>e.options.slidesToShow?(e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.prependTo(e.options.appendArrows),e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.appendTo(e.options.appendArrows),!0!==e.options.infinite&&e.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true")):e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({"aria-disabled":"true",tabindex:"-1"}))},e.prototype.buildDots=function(){var e,t,o=this;if(!0===o.options.dots){for(o.$slider.addClass("slick-dotted"),t=i("<ul />").addClass(o.options.dotsClass),e=0;e<=o.getDotCount();e+=1)t.append(i("<li />").append(o.options.customPaging.call(this,o,e)));o.$dots=t.appendTo(o.options.appendDots),o.$dots.find("li").first().addClass("slick-active")}},e.prototype.buildOut=function(){var e=this;e.$slides=e.$slider.children(e.options.slide+":not(.slick-cloned)").addClass("slick-slide"),e.slideCount=e.$slides.length,e.$slides.each(function(e,t){i(t).attr("data-slick-index",e).data("originalStyling",i(t).attr("style")||"")}),e.$slider.addClass("slick-slider"),e.$slideTrack=0===e.slideCount?i('<div class="slick-track"/>').appendTo(e.$slider):e.$slides.wrapAll('<div class="slick-track"/>').parent(),e.$list=e.$slideTrack.wrap('<div class="slick-list"/>').parent(),e.$slideTrack.css("opacity",0),!0!==e.options.centerMode&&!0!==e.options.swipeToSlide||(e.options.slidesToScroll=1),i("img[data-lazy]",e.$slider).not("[src]").addClass("slick-loading"),e.setupInfinite(),e.buildArrows(),e.buildDots(),e.updateDots(),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),!0===e.options.draggable&&e.$list.addClass("draggable")},e.prototype.buildRows=function(){var i,e,t,o,s,n,r,l=this;if(o=document.createDocumentFragment(),n=l.$slider.children(),l.options.rows>1){for(r=l.options.slidesPerRow*l.options.rows,s=Math.ceil(n.length/r),i=0;i<s;i++){var d=document.createElement("div");for(e=0;e<l.options.rows;e++){var a=document.createElement("div");for(t=0;t<l.options.slidesPerRow;t++){var c=i*r+(e*l.options.slidesPerRow+t);n.get(c)&&a.appendChild(n.get(c))}d.appendChild(a)}o.appendChild(d)}l.$slider.empty().append(o),l.$slider.children().children().children().css({width:100/l.options.slidesPerRow+"%",display:"inline-block"})}},e.prototype.checkResponsive=function(e,t){var o,s,n,r=this,l=!1,d=r.$slider.width(),a=window.innerWidth||i(window).width();if("window"===r.respondTo?n=a:"slider"===r.respondTo?n=d:"min"===r.respondTo&&(n=Math.min(a,d)),r.options.responsive&&r.options.responsive.length&&null!==r.options.responsive){s=null;for(o in r.breakpoints)r.breakpoints.hasOwnProperty(o)&&(!1===r.originalSettings.mobileFirst?n<r.breakpoints[o]&&(s=r.breakpoints[o]):n>r.breakpoints[o]&&(s=r.breakpoints[o]));null!==s?null!==r.activeBreakpoint?(s!==r.activeBreakpoint||t)&&(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):null!==r.activeBreakpoint&&(r.activeBreakpoint=null,r.options=r.originalSettings,!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e),l=s),e||!1===l||r.$slider.trigger("breakpoint",[r,l])}},e.prototype.changeSlide=function(e,t){var o,s,n,r=this,l=i(e.currentTarget);switch(l.is("a")&&e.preventDefault(),l.is("li")||(l=l.closest("li")),n=r.slideCount%r.options.slidesToScroll!=0,o=n?0:(r.slideCount-r.currentSlide)%r.options.slidesToScroll,e.data.message){case"previous":s=0===o?r.options.slidesToScroll:r.options.slidesToShow-o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide-s,!1,t);break;case"next":s=0===o?r.options.slidesToScroll:o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide+s,!1,t);break;case"index":var d=0===e.data.index?0:e.data.index||l.index()*r.options.slidesToScroll;r.slideHandler(r.checkNavigable(d),!1,t),l.children().trigger("focus");break;default:return}},e.prototype.checkNavigable=function(i){var e,t;if(e=this.getNavigableIndexes(),t=0,i>e[e.length-1])i=e[e.length-1];else for(var o in e){if(i<e[o]){i=t;break}t=e[o]}return i},e.prototype.cleanUpEvents=function(){var e=this;e.options.dots&&null!==e.$dots&&(i("li",e.$dots).off("click.slick",e.changeSlide).off("mouseenter.slick",i.proxy(e.interrupt,e,!0)).off("mouseleave.slick",i.proxy(e.interrupt,e,!1)),!0===e.options.accessibility&&e.$dots.off("keydown.slick",e.keyHandler)),e.$slider.off("focus.slick blur.slick"),!0===e.options.arrows&&e.slideCount>e.options.slidesToShow&&(e.$prevArrow&&e.$prevArrow.off("click.slick",e.changeSlide),e.$nextArrow&&e.$nextArrow.off("click.slick",e.changeSlide),!0===e.options.accessibility&&(e.$prevArrow&&e.$prevArrow.off("keydown.slick",e.keyHandler),e.$nextArrow&&e.$nextArrow.off("keydown.slick",e.keyHandler))),e.$list.off("touchstart.slick mousedown.slick",e.swipeHandler),e.$list.off("touchmove.slick mousemove.slick",e.swipeHandler),e.$list.off("touchend.slick mouseup.slick",e.swipeHandler),e.$list.off("touchcancel.slick mouseleave.slick",e.swipeHandler),e.$list.off("click.slick",e.clickHandler),i(document).off(e.visibilityChange,e.visibility),e.cleanUpSlideEvents(),!0===e.options.accessibility&&e.$list.off("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().off("click.slick",e.selectHandler),i(window).off("orientationchange.slick.slick-"+e.instanceUid,e.orientationChange),i(window).off("resize.slick.slick-"+e.instanceUid,e.resize),i("[draggable!=true]",e.$slideTrack).off("dragstart",e.preventDefault),i(window).off("load.slick.slick-"+e.instanceUid,e.setPosition)},e.prototype.cleanUpSlideEvents=function(){var e=this;e.$list.off("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.off("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.cleanUpRows=function(){var i,e=this;e.options.rows>1&&((i=e.$slides.children().children()).removeAttr("style"),e.$slider.empty().append(i))},e.prototype.clickHandler=function(i){!1===this.shouldClick&&(i.stopImmediatePropagation(),i.stopPropagation(),i.preventDefault())},e.prototype.destroy=function(e){var t=this;t.autoPlayClear(),t.touchObject={},t.cleanUpEvents(),i(".slick-cloned",t.$slider).detach(),t.$dots&&t.$dots.remove(),t.$prevArrow&&t.$prevArrow.length&&(t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.prevArrow)&&t.$prevArrow.remove()),t.$nextArrow&&t.$nextArrow.length&&(t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.nextArrow)&&t.$nextArrow.remove()),t.$slides&&(t.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function(){i(this).attr("style",i(this).data("originalStyling"))}),t.$slideTrack.children(this.options.slide).detach(),t.$slideTrack.detach(),t.$list.detach(),t.$slider.append(t.$slides)),t.cleanUpRows(),t.$slider.removeClass("slick-slider"),t.$slider.removeClass("slick-initialized"),t.$slider.removeClass("slick-dotted"),t.unslicked=!0,e||t.$slider.trigger("destroy",[t])},e.prototype.disableTransition=function(i){var e=this,t={};t[e.transitionType]="",!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.fadeSlide=function(i,e){var t=this;!1===t.cssTransitions?(t.$slides.eq(i).css({zIndex:t.options.zIndex}),t.$slides.eq(i).animate({opacity:1},t.options.speed,t.options.easing,e)):(t.applyTransition(i),t.$slides.eq(i).css({opacity:1,zIndex:t.options.zIndex}),e&&setTimeout(function(){t.disableTransition(i),e.call()},t.options.speed))},e.prototype.fadeSlideOut=function(i){var e=this;!1===e.cssTransitions?e.$slides.eq(i).animate({opacity:0,zIndex:e.options.zIndex-2},e.options.speed,e.options.easing):(e.applyTransition(i),e.$slides.eq(i).css({opacity:0,zIndex:e.options.zIndex-2}))},e.prototype.filterSlides=e.prototype.slickFilter=function(i){var e=this;null!==i&&(e.$slidesCache=e.$slides,e.unload(),e.$slideTrack.children(this.options.slide).detach(),e.$slidesCache.filter(i).appendTo(e.$slideTrack),e.reinit())},e.prototype.focusHandler=function(){var e=this;e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick","*",function(t){t.stopImmediatePropagation();var o=i(this);setTimeout(function(){e.options.pauseOnFocus&&(e.focussed=o.is(":focus"),e.autoPlay())},0)})},e.prototype.getCurrent=e.prototype.slickCurrentSlide=function(){return this.currentSlide},e.prototype.getDotCount=function(){var i=this,e=0,t=0,o=0;if(!0===i.options.infinite)if(i.slideCount<=i.options.slidesToShow)++o;else for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else if(!0===i.options.centerMode)o=i.slideCount;else if(i.options.asNavFor)for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else o=1+Math.ceil((i.slideCount-i.options.slidesToShow)/i.options.slidesToScroll);return o-1},e.prototype.getLeft=function(i){var e,t,o,s,n=this,r=0;return n.slideOffset=0,t=n.$slides.first().outerHeight(!0),!0===n.options.infinite?(n.slideCount>n.options.slidesToShow&&(n.slideOffset=n.slideWidth*n.options.slidesToShow*-1,s=-1,!0===n.options.vertical&&!0===n.options.centerMode&&(2===n.options.slidesToShow?s=-1.5:1===n.options.slidesToShow&&(s=-2)),r=t*n.options.slidesToShow*s),n.slideCount%n.options.slidesToScroll!=0&&i+n.options.slidesToScroll>n.slideCount&&n.slideCount>n.options.slidesToShow&&(i>n.slideCount?(n.slideOffset=(n.options.slidesToShow-(i-n.slideCount))*n.slideWidth*-1,r=(n.options.slidesToShow-(i-n.slideCount))*t*-1):(n.slideOffset=n.slideCount%n.options.slidesToScroll*n.slideWidth*-1,r=n.slideCount%n.options.slidesToScroll*t*-1))):i+n.options.slidesToShow>n.slideCount&&(n.slideOffset=(i+n.options.slidesToShow-n.slideCount)*n.slideWidth,r=(i+n.options.slidesToShow-n.slideCount)*t),n.slideCount<=n.options.slidesToShow&&(n.slideOffset=0,r=0),!0===n.options.centerMode&&n.slideCount<=n.options.slidesToShow?n.slideOffset=n.slideWidth*Math.floor(n.options.slidesToShow)/2-n.slideWidth*n.slideCount/2:!0===n.options.centerMode&&!0===n.options.infinite?n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)-n.slideWidth:!0===n.options.centerMode&&(n.slideOffset=0,n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)),e=!1===n.options.vertical?i*n.slideWidth*-1+n.slideOffset:i*t*-1+r,!0===n.options.variableWidth&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,!0===n.options.centerMode&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow+1),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,e+=(n.$list.width()-o.outerWidth())/2)),e},e.prototype.getOption=e.prototype.slickGetOption=function(i){return this.options[i]},e.prototype.getNavigableIndexes=function(){var i,e=this,t=0,o=0,s=[];for(!1===e.options.infinite?i=e.slideCount:(t=-1*e.options.slidesToScroll,o=-1*e.options.slidesToScroll,i=2*e.slideCount);t<i;)s.push(t),t=o+e.options.slidesToScroll,o+=e.options.slidesToScroll<=e.options.slidesToShow?e.options.slidesToScroll:e.options.slidesToShow;return s},e.prototype.getSlick=function(){return this},e.prototype.getSlideCount=function(){var e,t,o=this;return t=!0===o.options.centerMode?o.slideWidth*Math.floor(o.options.slidesToShow/2):0,!0===o.options.swipeToSlide?(o.$slideTrack.find(".slick-slide").each(function(s,n){if(n.offsetLeft-t+i(n).outerWidth()/2>-1*o.swipeLeft)return e=n,!1}),Math.abs(i(e).attr("data-slick-index")-o.currentSlide)||1):o.options.slidesToScroll},e.prototype.goTo=e.prototype.slickGoTo=function(i,e){this.changeSlide({data:{message:"index",index:parseInt(i)}},e)},e.prototype.init=function(e){var t=this;i(t.$slider).hasClass("slick-initialized")||(i(t.$slider).addClass("slick-initialized"),t.buildRows(),t.buildOut(),t.setProps(),t.startLoad(),t.loadSlider(),t.initializeEvents(),t.updateArrows(),t.updateDots(),t.checkResponsive(!0),t.focusHandler()),e&&t.$slider.trigger("init",[t]),!0===t.options.accessibility&&t.initADA(),t.options.autoplay&&(t.paused=!1,t.autoPlay())},e.prototype.initADA=function(){var e=this,t=Math.ceil(e.slideCount/e.options.slidesToShow),o=e.getNavigableIndexes().filter(function(i){return i>=0&&i<e.slideCount});e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({"aria-hidden":"true",tabindex:"-1"}).find("a, input, button, select").attr({tabindex:"-1"}),null!==e.$dots&&(e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function(t){var s=o.indexOf(t);i(this).attr({role:"tabpanel",id:"slick-slide"+e.instanceUid+t,tabindex:-1}),-1!==s&&i(this).attr({"aria-describedby":"slick-slide-control"+e.instanceUid+s})}),e.$dots.attr("role","tablist").find("li").each(function(s){var n=o[s];i(this).attr({role:"presentation"}),i(this).find("button").first().attr({role:"tab",id:"slick-slide-control"+e.instanceUid+s,"aria-controls":"slick-slide"+e.instanceUid+n,"aria-label":s+1+" of "+t,"aria-selected":null,tabindex:"-1"})}).eq(e.currentSlide).find("button").attr({"aria-selected":"true",tabindex:"0"}).end());for(var s=e.currentSlide,n=s+e.options.slidesToShow;s<n;s++)e.$slides.eq(s).attr("tabindex",0);e.activateADA()},e.prototype.initArrowEvents=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.off("click.slick").on("click.slick",{message:"previous"},i.changeSlide),i.$nextArrow.off("click.slick").on("click.slick",{message:"next"},i.changeSlide),!0===i.options.accessibility&&(i.$prevArrow.on("keydown.slick",i.keyHandler),i.$nextArrow.on("keydown.slick",i.keyHandler)))},e.prototype.initDotEvents=function(){var e=this;!0===e.options.dots&&(i("li",e.$dots).on("click.slick",{message:"index"},e.changeSlide),!0===e.options.accessibility&&e.$dots.on("keydown.slick",e.keyHandler)),!0===e.options.dots&&!0===e.options.pauseOnDotsHover&&i("li",e.$dots).on("mouseenter.slick",i.proxy(e.interrupt,e,!0)).on("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.initSlideEvents=function(){var e=this;e.options.pauseOnHover&&(e.$list.on("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.on("mouseleave.slick",i.proxy(e.interrupt,e,!1)))},e.prototype.initializeEvents=function(){var e=this;e.initArrowEvents(),e.initDotEvents(),e.initSlideEvents(),e.$list.on("touchstart.slick mousedown.slick",{action:"start"},e.swipeHandler),e.$list.on("touchmove.slick mousemove.slick",{action:"move"},e.swipeHandler),e.$list.on("touchend.slick mouseup.slick",{action:"end"},e.swipeHandler),e.$list.on("touchcancel.slick mouseleave.slick",{action:"end"},e.swipeHandler),e.$list.on("click.slick",e.clickHandler),i(document).on(e.visibilityChange,i.proxy(e.visibility,e)),!0===e.options.accessibility&&e.$list.on("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),i(window).on("orientationchange.slick.slick-"+e.instanceUid,i.proxy(e.orientationChange,e)),i(window).on("resize.slick.slick-"+e.instanceUid,i.proxy(e.resize,e)),i("[draggable!=true]",e.$slideTrack).on("dragstart",e.preventDefault),i(window).on("load.slick.slick-"+e.instanceUid,e.setPosition),i(e.setPosition)},e.prototype.initUI=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.show(),i.$nextArrow.show()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.show()},e.prototype.keyHandler=function(i){var e=this;i.target.tagName.match("TEXTAREA|INPUT|SELECT")||(37===i.keyCode&&!0===e.options.accessibility?e.changeSlide({data:{message:!0===e.options.rtl?"next":"previous"}}):39===i.keyCode&&!0===e.options.accessibility&&e.changeSlide({data:{message:!0===e.options.rtl?"previous":"next"}}))},e.prototype.lazyLoad=function(){function e(e){i("img[data-lazy]",e).each(function(){var e=i(this),t=i(this).attr("data-lazy"),o=i(this).attr("data-srcset"),s=i(this).attr("data-sizes")||n.$slider.attr("data-sizes"),r=document.createElement("img");r.onload=function(){e.animate({opacity:0},100,function(){o&&(e.attr("srcset",o),s&&e.attr("sizes",s)),e.attr("src",t).animate({opacity:1},200,function(){e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")}),n.$slider.trigger("lazyLoaded",[n,e,t])})},r.onerror=function(){e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),n.$slider.trigger("lazyLoadError",[n,e,t])},r.src=t})}var t,o,s,n=this;if(!0===n.options.centerMode?!0===n.options.infinite?s=(o=n.currentSlide+(n.options.slidesToShow/2+1))+n.options.slidesToShow+2:(o=Math.max(0,n.currentSlide-(n.options.slidesToShow/2+1)),s=n.options.slidesToShow/2+1+2+n.currentSlide):(o=n.options.infinite?n.options.slidesToShow+n.currentSlide:n.currentSlide,s=Math.ceil(o+n.options.slidesToShow),!0===n.options.fade&&(o>0&&o--,s<=n.slideCount&&s++)),t=n.$slider.find(".slick-slide").slice(o,s),"anticipated"===n.options.lazyLoad)for(var r=o-1,l=s,d=n.$slider.find(".slick-slide"),a=0;a<n.options.slidesToScroll;a++)r<0&&(r=n.slideCount-1),t=(t=t.add(d.eq(r))).add(d.eq(l)),r--,l++;e(t),n.slideCount<=n.options.slidesToShow?e(n.$slider.find(".slick-slide")):n.currentSlide>=n.slideCount-n.options.slidesToShow?e(n.$slider.find(".slick-cloned").slice(0,n.options.slidesToShow)):0===n.currentSlide&&e(n.$slider.find(".slick-cloned").slice(-1*n.options.slidesToShow))},e.prototype.loadSlider=function(){var i=this;i.setPosition(),i.$slideTrack.css({opacity:1}),i.$slider.removeClass("slick-loading"),i.initUI(),"progressive"===i.options.lazyLoad&&i.progressiveLazyLoad()},e.prototype.next=e.prototype.slickNext=function(){this.changeSlide({data:{message:"next"}})},e.prototype.orientationChange=function(){var i=this;i.checkResponsive(),i.setPosition()},e.prototype.pause=e.prototype.slickPause=function(){var i=this;i.autoPlayClear(),i.paused=!0},e.prototype.play=e.prototype.slickPlay=function(){var i=this;i.autoPlay(),i.options.autoplay=!0,i.paused=!1,i.focussed=!1,i.interrupted=!1},e.prototype.postSlide=function(e){var t=this;t.unslicked||(t.$slider.trigger("afterChange",[t,e]),t.animating=!1,t.slideCount>t.options.slidesToShow&&t.setPosition(),t.swipeLeft=null,t.options.autoplay&&t.autoPlay(),!0===t.options.accessibility&&(t.initADA(),t.options.focusOnChange&&i(t.$slides.get(t.currentSlide)).attr("tabindex",0).focus()))},e.prototype.prev=e.prototype.slickPrev=function(){this.changeSlide({data:{message:"previous"}})},e.prototype.preventDefault=function(i){i.preventDefault()},e.prototype.progressiveLazyLoad=function(e){e=e||1;var t,o,s,n,r,l=this,d=i("img[data-lazy]",l.$slider);d.length?(t=d.first(),o=t.attr("data-lazy"),s=t.attr("data-srcset"),n=t.attr("data-sizes")||l.$slider.attr("data-sizes"),(r=document.createElement("img")).onload=function(){s&&(t.attr("srcset",s),n&&t.attr("sizes",n)),t.attr("src",o).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"),!0===l.options.adaptiveHeight&&l.setPosition(),l.$slider.trigger("lazyLoaded",[l,t,o]),l.progressiveLazyLoad()},r.onerror=function(){e<3?setTimeout(function(){l.progressiveLazyLoad(e+1)},500):(t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),l.$slider.trigger("lazyLoadError",[l,t,o]),l.progressiveLazyLoad())},r.src=o):l.$slider.trigger("allImagesLoaded",[l])},e.prototype.refresh=function(e){var t,o,s=this;o=s.slideCount-s.options.slidesToShow,!s.options.infinite&&s.currentSlide>o&&(s.currentSlide=o),s.slideCount<=s.options.slidesToShow&&(s.currentSlide=0),t=s.currentSlide,s.destroy(!0),i.extend(s,s.initials,{currentSlide:t}),s.init(),e||s.changeSlide({data:{message:"index",index:t}},!1)},e.prototype.registerBreakpoints=function(){var e,t,o,s=this,n=s.options.responsive||null;if("array"===i.type(n)&&n.length){s.respondTo=s.options.respondTo||"window";for(e in n)if(o=s.breakpoints.length-1,n.hasOwnProperty(e)){for(t=n[e].breakpoint;o>=0;)s.breakpoints[o]&&s.breakpoints[o]===t&&s.breakpoints.splice(o,1),o--;s.breakpoints.push(t),s.breakpointSettings[t]=n[e].settings}s.breakpoints.sort(function(i,e){return s.options.mobileFirst?i-e:e-i})}},e.prototype.reinit=function(){var e=this;e.$slides=e.$slideTrack.children(e.options.slide).addClass("slick-slide"),e.slideCount=e.$slides.length,e.currentSlide>=e.slideCount&&0!==e.currentSlide&&(e.currentSlide=e.currentSlide-e.options.slidesToScroll),e.slideCount<=e.options.slidesToShow&&(e.currentSlide=0),e.registerBreakpoints(),e.setProps(),e.setupInfinite(),e.buildArrows(),e.updateArrows(),e.initArrowEvents(),e.buildDots(),e.updateDots(),e.initDotEvents(),e.cleanUpSlideEvents(),e.initSlideEvents(),e.checkResponsive(!1,!0),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),e.setPosition(),e.focusHandler(),e.paused=!e.options.autoplay,e.autoPlay(),e.$slider.trigger("reInit",[e])},e.prototype.resize=function(){var e=this;i(window).width()!==e.windowWidth&&(clearTimeout(e.windowDelay),e.windowDelay=window.setTimeout(function(){e.windowWidth=i(window).width(),e.checkResponsive(),e.unslicked||e.setPosition()},50))},e.prototype.removeSlide=e.prototype.slickRemove=function(i,e,t){var o=this;if(i="boolean"==typeof i?!0===(e=i)?0:o.slideCount-1:!0===e?--i:i,o.slideCount<1||i<0||i>o.slideCount-1)return!1;o.unload(),!0===t?o.$slideTrack.children().remove():o.$slideTrack.children(this.options.slide).eq(i).remove(),o.$slides=o.$slideTrack.children(this.options.slide),o.$slideTrack.children(this.options.slide).detach(),o.$slideTrack.append(o.$slides),o.$slidesCache=o.$slides,o.reinit()},e.prototype.setCSS=function(i){var e,t,o=this,s={};!0===o.options.rtl&&(i=-i),e="left"==o.positionProp?Math.ceil(i)+"px":"0px",t="top"==o.positionProp?Math.ceil(i)+"px":"0px",s[o.positionProp]=i,!1===o.transformsEnabled?o.$slideTrack.css(s):(s={},!1===o.cssTransitions?(s[o.animType]="translate("+e+", "+t+")",o.$slideTrack.css(s)):(s[o.animType]="translate3d("+e+", "+t+", 0px)",o.$slideTrack.css(s)))},e.prototype.setDimensions=function(){var i=this;!1===i.options.vertical?!0===i.options.centerMode&&i.$list.css({padding:"0px "+i.options.centerPadding}):(i.$list.height(i.$slides.first().outerHeight(!0)*i.options.slidesToShow),!0===i.options.centerMode&&i.$list.css({padding:i.options.centerPadding+" 0px"})),i.listWidth=i.$list.width(),i.listHeight=i.$list.height(),!1===i.options.vertical&&!1===i.options.variableWidth?(i.slideWidth=Math.ceil(i.listWidth/i.options.slidesToShow),i.$slideTrack.width(Math.ceil(i.slideWidth*i.$slideTrack.children(".slick-slide").length))):!0===i.options.variableWidth?i.$slideTrack.width(5e3*i.slideCount):(i.slideWidth=Math.ceil(i.listWidth),i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0)*i.$slideTrack.children(".slick-slide").length)));var e=i.$slides.first().outerWidth(!0)-i.$slides.first().width();!1===i.options.variableWidth&&i.$slideTrack.children(".slick-slide").width(i.slideWidth-e)},e.prototype.setFade=function(){var e,t=this;t.$slides.each(function(o,s){e=t.slideWidth*o*-1,!0===t.options.rtl?i(s).css({position:"relative",right:e,top:0,zIndex:t.options.zIndex-2,opacity:0}):i(s).css({position:"relative",left:e,top:0,zIndex:t.options.zIndex-2,opacity:0})}),t.$slides.eq(t.currentSlide).css({zIndex:t.options.zIndex-1,opacity:1})},e.prototype.setHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.css("height",e)}},e.prototype.setOption=e.prototype.slickSetOption=function(){var e,t,o,s,n,r=this,l=!1;if("object"===i.type(arguments[0])?(o=arguments[0],l=arguments[1],n="multiple"):"string"===i.type(arguments[0])&&(o=arguments[0],s=arguments[1],l=arguments[2],"responsive"===arguments[0]&&"array"===i.type(arguments[1])?n="responsive":void 0!==arguments[1]&&(n="single")),"single"===n)r.options[o]=s;else if("multiple"===n)i.each(o,function(i,e){r.options[i]=e});else if("responsive"===n)for(t in s)if("array"!==i.type(r.options.responsive))r.options.responsive=[s[t]];else{for(e=r.options.responsive.length-1;e>=0;)r.options.responsive[e].breakpoint===s[t].breakpoint&&r.options.responsive.splice(e,1),e--;r.options.responsive.push(s[t])}l&&(r.unload(),r.reinit())},e.prototype.setPosition=function(){var i=this;i.setDimensions(),i.setHeight(),!1===i.options.fade?i.setCSS(i.getLeft(i.currentSlide)):i.setFade(),i.$slider.trigger("setPosition",[i])},e.prototype.setProps=function(){var i=this,e=document.body.style;i.positionProp=!0===i.options.vertical?"top":"left","top"===i.positionProp?i.$slider.addClass("slick-vertical"):i.$slider.removeClass("slick-vertical"),void 0===e.WebkitTransition&&void 0===e.MozTransition&&void 0===e.msTransition||!0===i.options.useCSS&&(i.cssTransitions=!0),i.options.fade&&("number"==typeof i.options.zIndex?i.options.zIndex<3&&(i.options.zIndex=3):i.options.zIndex=i.defaults.zIndex),void 0!==e.OTransform&&(i.animType="OTransform",i.transformType="-o-transform",i.transitionType="OTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.MozTransform&&(i.animType="MozTransform",i.transformType="-moz-transform",i.transitionType="MozTransition",void 0===e.perspectiveProperty&&void 0===e.MozPerspective&&(i.animType=!1)),void 0!==e.webkitTransform&&(i.animType="webkitTransform",i.transformType="-webkit-transform",i.transitionType="webkitTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.msTransform&&(i.animType="msTransform",i.transformType="-ms-transform",i.transitionType="msTransition",void 0===e.msTransform&&(i.animType=!1)),void 0!==e.transform&&!1!==i.animType&&(i.animType="transform",i.transformType="transform",i.transitionType="transition"),i.transformsEnabled=i.options.useTransform&&null!==i.animType&&!1!==i.animType},e.prototype.setSlideClasses=function(i){var e,t,o,s,n=this;if(t=n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden","true"),n.$slides.eq(i).addClass("slick-current"),!0===n.options.centerMode){var r=n.options.slidesToShow%2==0?1:0;e=Math.floor(n.options.slidesToShow/2),!0===n.options.infinite&&(i>=e&&i<=n.slideCount-1-e?n.$slides.slice(i-e+r,i+e+1).addClass("slick-active").attr("aria-hidden","false"):(o=n.options.slidesToShow+i,t.slice(o-e+1+r,o+e+2).addClass("slick-active").attr("aria-hidden","false")),0===i?t.eq(t.length-1-n.options.slidesToShow).addClass("slick-center"):i===n.slideCount-1&&t.eq(n.options.slidesToShow).addClass("slick-center")),n.$slides.eq(i).addClass("slick-center")}else i>=0&&i<=n.slideCount-n.options.slidesToShow?n.$slides.slice(i,i+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"):t.length<=n.options.slidesToShow?t.addClass("slick-active").attr("aria-hidden","false"):(s=n.slideCount%n.options.slidesToShow,o=!0===n.options.infinite?n.options.slidesToShow+i:i,n.options.slidesToShow==n.options.slidesToScroll&&n.slideCount-i<n.options.slidesToShow?t.slice(o-(n.options.slidesToShow-s),o+s).addClass("slick-active").attr("aria-hidden","false"):t.slice(o,o+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"));"ondemand"!==n.options.lazyLoad&&"anticipated"!==n.options.lazyLoad||n.lazyLoad()},e.prototype.setupInfinite=function(){var e,t,o,s=this;if(!0===s.options.fade&&(s.options.centerMode=!1),!0===s.options.infinite&&!1===s.options.fade&&(t=null,s.slideCount>s.options.slidesToShow)){for(o=!0===s.options.centerMode?s.options.slidesToShow+1:s.options.slidesToShow,e=s.slideCount;e>s.slideCount-o;e-=1)t=e-1,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t-s.slideCount).prependTo(s.$slideTrack).addClass("slick-cloned");for(e=0;e<o+s.slideCount;e+=1)t=e,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t+s.slideCount).appendTo(s.$slideTrack).addClass("slick-cloned");s.$slideTrack.find(".slick-cloned").find("[id]").each(function(){i(this).attr("id","")})}},e.prototype.interrupt=function(i){var e=this;i||e.autoPlay(),e.interrupted=i},e.prototype.selectHandler=function(e){var t=this,o=i(e.target).is(".slick-slide")?i(e.target):i(e.target).parents(".slick-slide"),s=parseInt(o.attr("data-slick-index"));s||(s=0),t.slideCount<=t.options.slidesToShow?t.slideHandler(s,!1,!0):t.slideHandler(s)},e.prototype.slideHandler=function(i,e,t){var o,s,n,r,l,d=null,a=this;if(e=e||!1,!(!0===a.animating&&!0===a.options.waitForAnimate||!0===a.options.fade&&a.currentSlide===i))if(!1===e&&a.asNavFor(i),o=i,d=a.getLeft(o),r=a.getLeft(a.currentSlide),a.currentLeft=null===a.swipeLeft?r:a.swipeLeft,!1===a.options.infinite&&!1===a.options.centerMode&&(i<0||i>a.getDotCount()*a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else if(!1===a.options.infinite&&!0===a.options.centerMode&&(i<0||i>a.slideCount-a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else{if(a.options.autoplay&&clearInterval(a.autoPlayTimer),s=o<0?a.slideCount%a.options.slidesToScroll!=0?a.slideCount-a.slideCount%a.options.slidesToScroll:a.slideCount+o:o>=a.slideCount?a.slideCount%a.options.slidesToScroll!=0?0:o-a.slideCount:o,a.animating=!0,a.$slider.trigger("beforeChange",[a,a.currentSlide,s]),n=a.currentSlide,a.currentSlide=s,a.setSlideClasses(a.currentSlide),a.options.asNavFor&&(l=(l=a.getNavTarget()).slick("getSlick")).slideCount<=l.options.slidesToShow&&l.setSlideClasses(a.currentSlide),a.updateDots(),a.updateArrows(),!0===a.options.fade)return!0!==t?(a.fadeSlideOut(n),a.fadeSlide(s,function(){a.postSlide(s)})):a.postSlide(s),void a.animateHeight();!0!==t?a.animateSlide(d,function(){a.postSlide(s)}):a.postSlide(s)}},e.prototype.startLoad=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.hide(),i.$nextArrow.hide()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.hide(),i.$slider.addClass("slick-loading")},e.prototype.swipeDirection=function(){var i,e,t,o,s=this;return i=s.touchObject.startX-s.touchObject.curX,e=s.touchObject.startY-s.touchObject.curY,t=Math.atan2(e,i),(o=Math.round(180*t/Math.PI))<0&&(o=360-Math.abs(o)),o<=45&&o>=0?!1===s.options.rtl?"left":"right":o<=360&&o>=315?!1===s.options.rtl?"left":"right":o>=135&&o<=225?!1===s.options.rtl?"right":"left":!0===s.options.verticalSwiping?o>=35&&o<=135?"down":"up":"vertical"},e.prototype.swipeEnd=function(i){var e,t,o=this;if(o.dragging=!1,o.swiping=!1,o.scrolling)return o.scrolling=!1,!1;if(o.interrupted=!1,o.shouldClick=!(o.touchObject.swipeLength>10),void 0===o.touchObject.curX)return!1;if(!0===o.touchObject.edgeHit&&o.$slider.trigger("edge",[o,o.swipeDirection()]),o.touchObject.swipeLength>=o.touchObject.minSwipe){switch(t=o.swipeDirection()){case"left":case"down":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide+o.getSlideCount()):o.currentSlide+o.getSlideCount(),o.currentDirection=0;break;case"right":case"up":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide-o.getSlideCount()):o.currentSlide-o.getSlideCount(),o.currentDirection=1}"vertical"!=t&&(o.slideHandler(e),o.touchObject={},o.$slider.trigger("swipe",[o,t]))}else o.touchObject.startX!==o.touchObject.curX&&(o.slideHandler(o.currentSlide),o.touchObject={})},e.prototype.swipeHandler=function(i){var e=this;if(!(!1===e.options.swipe||"ontouchend"in document&&!1===e.options.swipe||!1===e.options.draggable&&-1!==i.type.indexOf("mouse")))switch(e.touchObject.fingerCount=i.originalEvent&&void 0!==i.originalEvent.touches?i.originalEvent.touches.length:1,e.touchObject.minSwipe=e.listWidth/e.options.touchThreshold,!0===e.options.verticalSwiping&&(e.touchObject.minSwipe=e.listHeight/e.options.touchThreshold),i.data.action){case"start":e.swipeStart(i);break;case"move":e.swipeMove(i);break;case"end":e.swipeEnd(i)}},e.prototype.swipeMove=function(i){var e,t,o,s,n,r,l=this;return n=void 0!==i.originalEvent?i.originalEvent.touches:null,!(!l.dragging||l.scrolling||n&&1!==n.length)&&(e=l.getLeft(l.currentSlide),l.touchObject.curX=void 0!==n?n[0].pageX:i.clientX,l.touchObject.curY=void 0!==n?n[0].pageY:i.clientY,l.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(l.touchObject.curX-l.touchObject.startX,2))),r=Math.round(Math.sqrt(Math.pow(l.touchObject.curY-l.touchObject.startY,2))),!l.options.verticalSwiping&&!l.swiping&&r>4?(l.scrolling=!0,!1):(!0===l.options.verticalSwiping&&(l.touchObject.swipeLength=r),t=l.swipeDirection(),void 0!==i.originalEvent&&l.touchObject.swipeLength>4&&(l.swiping=!0,i.preventDefault()),s=(!1===l.options.rtl?1:-1)*(l.touchObject.curX>l.touchObject.startX?1:-1),!0===l.options.verticalSwiping&&(s=l.touchObject.curY>l.touchObject.startY?1:-1),o=l.touchObject.swipeLength,l.touchObject.edgeHit=!1,!1===l.options.infinite&&(0===l.currentSlide&&"right"===t||l.currentSlide>=l.getDotCount()&&"left"===t)&&(o=l.touchObject.swipeLength*l.options.edgeFriction,l.touchObject.edgeHit=!0),!1===l.options.vertical?l.swipeLeft=e+o*s:l.swipeLeft=e+o*(l.$list.height()/l.listWidth)*s,!0===l.options.verticalSwiping&&(l.swipeLeft=e+o*s),!0!==l.options.fade&&!1!==l.options.touchMove&&(!0===l.animating?(l.swipeLeft=null,!1):void l.setCSS(l.swipeLeft))))},e.prototype.swipeStart=function(i){var e,t=this;if(t.interrupted=!0,1!==t.touchObject.fingerCount||t.slideCount<=t.options.slidesToShow)return t.touchObject={},!1;void 0!==i.originalEvent&&void 0!==i.originalEvent.touches&&(e=i.originalEvent.touches[0]),t.touchObject.startX=t.touchObject.curX=void 0!==e?e.pageX:i.clientX,t.touchObject.startY=t.touchObject.curY=void 0!==e?e.pageY:i.clientY,t.dragging=!0},e.prototype.unfilterSlides=e.prototype.slickUnfilter=function(){var i=this;null!==i.$slidesCache&&(i.unload(),i.$slideTrack.children(this.options.slide).detach(),i.$slidesCache.appendTo(i.$slideTrack),i.reinit())},e.prototype.unload=function(){var e=this;i(".slick-cloned",e.$slider).remove(),e.$dots&&e.$dots.remove(),e.$prevArrow&&e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.remove(),e.$nextArrow&&e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.remove(),e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden","true").css("width","")},e.prototype.unslick=function(i){var e=this;e.$slider.trigger("unslick",[e,i]),e.destroy()},e.prototype.updateArrows=function(){var i=this;Math.floor(i.options.slidesToShow/2),!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&!i.options.infinite&&(i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false"),0===i.currentSlide?(i.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-i.options.slidesToShow&&!1===i.options.centerMode?(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-1&&!0===i.options.centerMode&&(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")))},e.prototype.updateDots=function(){var i=this;null!==i.$dots&&(i.$dots.find("li").removeClass("slick-active").end(),i.$dots.find("li").eq(Math.floor(i.currentSlide/i.options.slidesToScroll)).addClass("slick-active"))},e.prototype.visibility=function(){var i=this;i.options.autoplay&&(document[i.hidden]?i.interrupted=!0:i.interrupted=!1)},i.fn.slick=function(){var i,t,o=this,s=arguments[0],n=Array.prototype.slice.call(arguments,1),r=o.length;for(i=0;i<r;i++)if("object"==typeof s||void 0===s?o[i].slick=new e(o[i],s):t=o[i].slick[s].apply(o[i].slick,n),void 0!==t)return t;return o}});

/* This Plugin for Maximage Slider */
/*!
 * jQuery Cycle Plugin (with Transition Definitions)
 * Examples and documentation at: http://jquery.malsup.com/cycle/
 * Copyright (c) 2007-2010 M. Alsup
 * Version: 2.9998 (27-OCT-2011)
 * Dual licensed under the MIT and GPL licenses.
 * http://jquery.malsup.com/license.html
 * Requires: jQuery v1.3.2 or later
 */
 !function(e,t){function n(t){e.fn.cycle.debug&&i(t)}function i(){window.console&&console.log&&console.log("[cycle] "+Array.prototype.join.call(arguments," "))}function c(t,n,i){var c=e(t).data("cycle.opts"),s=!!t.cyclePause;s&&c.paused?c.paused(t,c,n,i):!s&&c.resumed&&c.resumed(t,c,n,i)}function s(n,s,o){function l(t,n,c){if(!t&&n===!0){var s=e(c).data("cycle.opts");if(!s)return i("options not found, can not resume"),!1;c.cycleTimeout&&(clearTimeout(c.cycleTimeout),c.cycleTimeout=0),d(s.elements,s,1,!s.backwards)}}if(n.cycleStop==t&&(n.cycleStop=0),(s===t||null===s)&&(s={}),s.constructor==String){switch(s){case"destroy":case"stop":var a=e(n).data("cycle.opts");return a?(n.cycleStop++,n.cycleTimeout&&clearTimeout(n.cycleTimeout),n.cycleTimeout=0,a.elements&&e(a.elements).stop(),e(n).removeData("cycle.opts"),"destroy"==s&&r(a),!1):!1;case"toggle":return n.cyclePause=1===n.cyclePause?0:1,l(n.cyclePause,o,n),c(n),!1;case"pause":return n.cyclePause=1,c(n),!1;case"resume":return n.cyclePause=0,l(!1,o,n),c(n),!1;case"prev":case"next":var a=e(n).data("cycle.opts");return a?(e.fn.cycle[s](a),!1):(i('options not found, "prev/next" ignored'),!1);default:s={fx:s}}return s}if(s.constructor==Number){var f=s;return(s=e(n).data("cycle.opts"))?0>f||f>=s.elements.length?(i("invalid slide index: "+f),!1):(s.nextSlide=f,n.cycleTimeout&&(clearTimeout(n.cycleTimeout),n.cycleTimeout=0),"string"==typeof o&&(s.oneTimeFx=o),d(s.elements,s,1,f>=s.currSlide),!1):(i("options not found, can not advance slide"),!1)}return s}function o(t,n){if(!e.support.opacity&&n.cleartype&&t.style.filter)try{t.style.removeAttribute("filter")}catch(i){}}function r(t){t.next&&e(t.next).unbind(t.prevNextEvent),t.prev&&e(t.prev).unbind(t.prevNextEvent),(t.pager||t.pagerAnchorBuilder)&&e.each(t.pagerAnchors||[],function(){this.unbind().remove()}),t.pagerAnchors=null,t.destroy&&t.destroy(t)}function l(n,s,r,l,h){var p,x=e.extend({},e.fn.cycle.defaults,l||{},e.metadata?n.metadata():e.meta?n.data():{}),v=e.isFunction(n.data)?n.data(x.metaAttr):null;v&&(x=e.extend(x,v)),x.autostop&&(x.countdown=x.autostopCount||r.length);var w=n[0];if(n.data("cycle.opts",x),x.$cont=n,x.stopCount=w.cycleStop,x.elements=r,x.before=x.before?[x.before]:[],x.after=x.after?[x.after]:[],!e.support.opacity&&x.cleartype&&x.after.push(function(){o(this,x)}),x.continuous&&x.after.push(function(){d(r,x,0,!x.backwards)}),a(x),e.support.opacity||!x.cleartype||x.cleartypeNoBg||g(s),"static"==n.css("position")&&n.css("position","relative"),x.width&&n.width(x.width),x.height&&"auto"!=x.height&&n.height(x.height),x.startingSlide!=t?(x.startingSlide=parseInt(x.startingSlide,10),x.startingSlide>=r.length||x.startSlide<0?x.startingSlide=0:p=!0):x.backwards?x.startingSlide=r.length-1:x.startingSlide=0,x.random){x.randomMap=[];for(var S=0;S<r.length;S++)x.randomMap.push(S);if(x.randomMap.sort(function(e,t){return Math.random()-.5}),p)for(var b=0;b<r.length;b++)x.startingSlide==x.randomMap[b]&&(x.randomIndex=b);else x.randomIndex=1,x.startingSlide=x.randomMap[1]}else x.startingSlide>=r.length&&(x.startingSlide=0);x.currSlide=x.startingSlide||0;var B=x.startingSlide;s.css({position:"absolute",top:0,left:0}).hide().each(function(t){var n;n=x.backwards?B?B>=t?r.length+(t-B):B-t:r.length-t:B?t>=B?r.length-(t-B):B-t:r.length-t,e(this).css("z-index",n)}),e(r[B]).css("opacity",1).show(),o(r[B],x),x.fit&&(x.aspect?s.each(function(){var t=e(this),n=x.aspect===!0?t.width()/t.height():x.aspect;x.width&&t.width()!=x.width&&(t.width(x.width),t.height(x.width/n)),x.height&&t.height()<x.height&&(t.height(x.height),t.width(x.height*n))}):(x.width&&s.width(x.width),x.height&&"auto"!=x.height&&s.height(x.height))),!x.center||x.fit&&!x.aspect||s.each(function(){var t=e(this);t.css({"margin-left":x.width?(x.width-t.width())/2+"px":0,"margin-top":x.height?(x.height-t.height())/2+"px":0})}),!x.center||x.fit||x.slideResize||s.each(function(){var t=e(this);t.css({"margin-left":x.width?(x.width-t.width())/2+"px":0,"margin-top":x.height?(x.height-t.height())/2+"px":0})});var I=x.containerResize&&!n.innerHeight();if(I){for(var O=0,F=0,A=0;A<r.length;A++){var k=e(r[A]),H=k[0],T=k.outerWidth(),W=k.outerHeight();T||(T=H.offsetWidth||H.width||k.attr("width")),W||(W=H.offsetHeight||H.height||k.attr("height")),O=T>O?T:O,F=W>F?W:F}O>0&&F>0&&n.css({width:O+"px",height:F+"px"})}var P=!1;if(x.pause&&n.hover(function(){P=!0,this.cyclePause++,c(w,!0)},function(){P&&this.cyclePause--,c(w,!0)}),f(x)===!1)return!1;var R=!1;if(l.requeueAttempts=l.requeueAttempts||0,s.each(function(){var t=e(this);if(this.cycleH=x.fit&&x.height?x.height:t.height()||this.offsetHeight||this.height||t.attr("height")||0,this.cycleW=x.fit&&x.width?x.width:t.width()||this.offsetWidth||this.width||t.attr("width")||0,t.is("img")){var n=e.browser.msie&&28==this.cycleW&&30==this.cycleH&&!this.complete,c=e.browser.mozilla&&34==this.cycleW&&19==this.cycleH&&!this.complete,s=e.browser.opera&&(42==this.cycleW&&19==this.cycleH||37==this.cycleW&&17==this.cycleH)&&!this.complete,o=0==this.cycleH&&0==this.cycleW&&!this.complete;if(n||c||s||o){if(h.s&&x.requeueOnImageNotLoaded&&++l.requeueAttempts<100)return i(l.requeueAttempts," - img slide not loaded, requeuing slideshow: ",this.src,this.cycleW,this.cycleH),setTimeout(function(){e(h.s,h.c).cycle(l)},x.requeueTimeout),R=!0,!1;i("could not determine size of image: "+this.src,this.cycleW,this.cycleH)}}return!0}),R)return!1;if(x.cssBefore=x.cssBefore||{},x.cssAfter=x.cssAfter||{},x.cssFirst=x.cssFirst||{},x.animIn=x.animIn||{},x.animOut=x.animOut||{},s.not(":eq("+B+")").css(x.cssBefore),e(s[B]).css(x.cssFirst),x.timeout){x.timeout=parseInt(x.timeout,10),x.speed.constructor==String&&(x.speed=e.fx.speeds[x.speed]||parseInt(x.speed,10)),x.sync||(x.speed=x.speed/2);for(var C="none"==x.fx?0:"shuffle"==x.fx?500:250;x.timeout-x.speed<C;)x.timeout+=x.speed}if(x.easing&&(x.easeIn=x.easeOut=x.easing),x.speedIn||(x.speedIn=x.speed),x.speedOut||(x.speedOut=x.speed),x.slideCount=r.length,x.currSlide=x.lastSlide=B,x.random?(++x.randomIndex==r.length&&(x.randomIndex=0),x.nextSlide=x.randomMap[x.randomIndex]):x.backwards?x.nextSlide=0==x.startingSlide?r.length-1:x.startingSlide-1:x.nextSlide=x.startingSlide>=r.length-1?0:x.startingSlide+1,!x.multiFx){var z=e.fn.cycle.transitions[x.fx];if(e.isFunction(z))z(n,s,x);else if("custom"!=x.fx&&!x.multiFx)return i("unknown transition: "+x.fx,"; slideshow terminating"),!1}var E=s[B];return x.skipInitializationCallbacks||(x.before.length&&x.before[0].apply(E,[E,E,x,!0]),x.after.length&&x.after[0].apply(E,[E,E,x,!0])),x.next&&e(x.next).bind(x.prevNextEvent,function(){return m(x,1)}),x.prev&&e(x.prev).bind(x.prevNextEvent,function(){return m(x,0)}),(x.pager||x.pagerAnchorBuilder)&&y(r,x),u(x,r),x}function a(t){t.original={before:[],after:[]},t.original.cssBefore=e.extend({},t.cssBefore),t.original.cssAfter=e.extend({},t.cssAfter),t.original.animIn=e.extend({},t.animIn),t.original.animOut=e.extend({},t.animOut),e.each(t.before,function(){t.original.before.push(this)}),e.each(t.after,function(){t.original.after.push(this)})}function f(t){var c,s,o=e.fn.cycle.transitions;if(t.fx.indexOf(",")>0){for(t.multiFx=!0,t.fxs=t.fx.replace(/\s*/g,"").split(","),c=0;c<t.fxs.length;c++){var r=t.fxs[c];s=o[r],s&&o.hasOwnProperty(r)&&e.isFunction(s)||(i("discarding unknown transition: ",r),t.fxs.splice(c,1),c--)}if(!t.fxs.length)return i("No valid transitions named; slideshow terminating."),!1}else if("all"==t.fx){t.multiFx=!0,t.fxs=[];for(p in o)s=o[p],o.hasOwnProperty(p)&&e.isFunction(s)&&t.fxs.push(p)}if(t.multiFx&&t.randomizeEffects){var l=Math.floor(20*Math.random())+30;for(c=0;l>c;c++){var a=Math.floor(Math.random()*t.fxs.length);t.fxs.push(t.fxs.splice(a,1)[0])}n("randomized fx sequence: ",t.fxs)}return!0}function u(t,n){t.addSlide=function(i,c){var s=e(i),o=s[0];t.autostopCount||t.countdown++,n[c?"unshift":"push"](o),t.els&&t.els[c?"unshift":"push"](o),t.slideCount=n.length,t.random&&(t.randomMap.push(t.slideCount-1),t.randomMap.sort(function(e,t){return Math.random()-.5})),s.css("position","absolute"),s[c?"prependTo":"appendTo"](t.$cont),c&&(t.currSlide++,t.nextSlide++),e.support.opacity||!t.cleartype||t.cleartypeNoBg||g(s),t.fit&&t.width&&s.width(t.width),t.fit&&t.height&&"auto"!=t.height&&s.height(t.height),o.cycleH=t.fit&&t.height?t.height:s.height(),o.cycleW=t.fit&&t.width?t.width:s.width(),s.css(t.cssBefore),(t.pager||t.pagerAnchorBuilder)&&e.fn.cycle.createPagerAnchor(n.length-1,o,e(t.pager),n,t),e.isFunction(t.onAddSlide)?t.onAddSlide(s):s.hide()}}function d(i,c,s,o){function r(){var e=0;c.timeout;c.timeout&&!c.continuous?(e=h(i[c.currSlide],i[c.nextSlide],c,o),"shuffle"==c.fx&&(e-=c.speedOut)):c.continuous&&l.cyclePause&&(e=10),e>0&&(l.cycleTimeout=setTimeout(function(){d(i,c,0,!c.backwards)},e))}if(s&&c.busy&&c.manualTrump&&(n("manualTrump in go(), stopping active transition"),e(i).stop(!0,!0),c.busy=0),c.busy)return void n("transition active, ignoring new tx request");var l=c.$cont[0],a=i[c.currSlide],f=i[c.nextSlide];if(l.cycleStop==c.stopCount&&(0!==l.cycleTimeout||s)){if(!s&&!l.cyclePause&&!c.bounce&&(c.autostop&&--c.countdown<=0||c.nowrap&&!c.random&&c.nextSlide<c.currSlide))return void(c.end&&c.end(c));var u=!1;if(!s&&l.cyclePause||c.nextSlide==c.currSlide)r();else{u=!0;var p=c.fx;a.cycleH=a.cycleH||e(a).height(),a.cycleW=a.cycleW||e(a).width(),f.cycleH=f.cycleH||e(f).height(),f.cycleW=f.cycleW||e(f).width(),c.multiFx&&(o&&(c.lastFx==t||++c.lastFx>=c.fxs.length)?c.lastFx=0:!o&&(c.lastFx==t||--c.lastFx<0)&&(c.lastFx=c.fxs.length-1),p=c.fxs[c.lastFx]),c.oneTimeFx&&(p=c.oneTimeFx,c.oneTimeFx=null),e.fn.cycle.resetState(c,p),c.before.length&&e.each(c.before,function(e,t){l.cycleStop==c.stopCount&&t.apply(f,[a,f,c,o])});var m=function(){c.busy=0,e.each(c.after,function(e,t){l.cycleStop==c.stopCount&&t.apply(f,[a,f,c,o])}),l.cycleStop||r()};n("tx firing("+p+"); currSlide: "+c.currSlide+"; nextSlide: "+c.nextSlide),c.busy=1,c.fxFn?c.fxFn(a,f,c,m,o,s&&c.fastOnEvent):e.isFunction(e.fn.cycle[c.fx])?e.fn.cycle[c.fx](a,f,c,m,o,s&&c.fastOnEvent):e.fn.cycle.custom(a,f,c,m,o,s&&c.fastOnEvent)}if(u||c.nextSlide==c.currSlide)if(c.lastSlide=c.currSlide,c.random)c.currSlide=c.nextSlide,++c.randomIndex==i.length&&(c.randomIndex=0,c.randomMap.sort(function(e,t){return Math.random()-.5})),c.nextSlide=c.randomMap[c.randomIndex],c.nextSlide==c.currSlide&&(c.nextSlide=c.currSlide==c.slideCount-1?0:c.currSlide+1);else if(c.backwards){var y=c.nextSlide-1<0;y&&c.bounce?(c.backwards=!c.backwards,c.nextSlide=1,c.currSlide=0):(c.nextSlide=y?i.length-1:c.nextSlide-1,c.currSlide=y?0:c.nextSlide+1)}else{var y=c.nextSlide+1==i.length;y&&c.bounce?(c.backwards=!c.backwards,c.nextSlide=i.length-2,c.currSlide=i.length-1):(c.nextSlide=y?0:c.nextSlide+1,c.currSlide=y?i.length-1:c.nextSlide-1)}u&&c.pager&&c.updateActivePagerLink(c.pager,c.currSlide,c.activePagerClass)}}function h(e,t,i,c){if(i.timeoutFn){for(var s=i.timeoutFn.call(e,e,t,i,c);"none"!=i.fx&&s-i.speed<250;)s+=i.speed;if(n("calculated timeout: "+s+"; speed: "+i.speed),s!==!1)return s}return i.timeout}function m(t,n){var i=n?1:-1,c=t.elements,s=t.$cont[0],o=s.cycleTimeout;if(o&&(clearTimeout(o),s.cycleTimeout=0),t.random&&0>i)t.randomIndex--,-2==--t.randomIndex?t.randomIndex=c.length-2:-1==t.randomIndex&&(t.randomIndex=c.length-1),t.nextSlide=t.randomMap[t.randomIndex];else if(t.random)t.nextSlide=t.randomMap[t.randomIndex];else if(t.nextSlide=t.currSlide+i,t.nextSlide<0){if(t.nowrap)return!1;t.nextSlide=c.length-1}else if(t.nextSlide>=c.length){if(t.nowrap)return!1;t.nextSlide=0}var r=t.onPrevNextEvent||t.prevNextClick;return e.isFunction(r)&&r(i>0,t.nextSlide,c[t.nextSlide]),d(c,t,1,n),!1}function y(t,n){var i=e(n.pager);e.each(t,function(c,s){e.fn.cycle.createPagerAnchor(c,s,i,t,n)}),n.updateActivePagerLink(n.pager,n.startingSlide,n.activePagerClass)}function g(t){function i(e){return e=parseInt(e,10).toString(16),e.length<2?"0"+e:e}function c(t){for(;t&&"html"!=t.nodeName.toLowerCase();t=t.parentNode){var n=e.css(t,"background-color");if(n&&n.indexOf("rgb")>=0){var c=n.match(/\d+/g);return"#"+i(c[0])+i(c[1])+i(c[2])}if(n&&"transparent"!=n)return n}return"#ffffff"}n("applying clearType background-color hack"),t.each(function(){e(this).css("background-color",c(this))})}var x="2.9998";e.support==t&&(e.support={opacity:!e.browser.msie}),e.expr[":"].paused=function(e){return e.cyclePause},e.fn.cycle=function(t,c){var o={s:this.selector,c:this.context};return 0===this.length&&"stop"!=t?!e.isReady&&o.s?(i("DOM not ready, queuing slideshow"),e(function(){e(o.s,o.c).cycle(t,c)}),this):(i("terminating; zero elements found by selector"+(e.isReady?"":" (DOM not ready)")),this):this.each(function(){var r=s(this,t,c);if(r!==!1){r.updateActivePagerLink=r.updateActivePagerLink||e.fn.cycle.updateActivePagerLink,this.cycleTimeout&&clearTimeout(this.cycleTimeout),this.cycleTimeout=this.cyclePause=0;var a=e(this),f=r.slideExpr?e(r.slideExpr,this):a.children(),u=f.get(),p=l(a,f,u,r,o);if(p!==!1){if(u.length<2)return void i("terminating; too few slides: "+u.length);var m=p.continuous?10:h(u[p.currSlide],u[p.nextSlide],p,!p.backwards);m&&(m+=p.delay||0,10>m&&(m=10),n("first timeout: "+m),this.cycleTimeout=setTimeout(function(){d(u,p,0,!r.backwards)},m))}}})},e.fn.cycle.resetState=function(t,n){n=n||t.fx,t.before=[],t.after=[],t.cssBefore=e.extend({},t.original.cssBefore),t.cssAfter=e.extend({},t.original.cssAfter),t.animIn=e.extend({},t.original.animIn),t.animOut=e.extend({},t.original.animOut),t.fxFn=null,e.each(t.original.before,function(){t.before.push(this)}),e.each(t.original.after,function(){t.after.push(this)});var i=e.fn.cycle.transitions[n];e.isFunction(i)&&i(t.$cont,e(t.elements),t)},e.fn.cycle.updateActivePagerLink=function(t,n,i){e(t).each(function(){e(this).children().removeClass(i).eq(n).addClass(i)})},e.fn.cycle.next=function(e){m(e,1)},e.fn.cycle.prev=function(e){m(e,0)},e.fn.cycle.createPagerAnchor=function(t,i,s,o,r){var l;if(e.isFunction(r.pagerAnchorBuilder)?(l=r.pagerAnchorBuilder(t,i),n("pagerAnchorBuilder("+t+", el) returned: "+l)):l='<a href="#">'+(t+1)+"</a>",l){var a=e(l);if(0===a.parents("body").length){var f=[];s.length>1?(s.each(function(){var t=a.clone(!0);e(this).append(t),f.push(t[0])}),a=e(f)):a.appendTo(s)}r.pagerAnchors=r.pagerAnchors||[],r.pagerAnchors.push(a);var u=function(n){n.preventDefault(),r.nextSlide=t;var i=r.$cont[0],c=i.cycleTimeout;c&&(clearTimeout(c),i.cycleTimeout=0);var s=r.onPagerEvent||r.pagerClick;e.isFunction(s)&&s(r.nextSlide,o[r.nextSlide]),d(o,r,1,r.currSlide<t)};/mouseenter|mouseover/i.test(r.pagerEvent)?a.hover(u,function(){}):a.bind(r.pagerEvent,u),/^click/.test(r.pagerEvent)||r.allowPagerClickBubble||a.bind("click.cycle",function(){return!1});var h=r.$cont[0],p=!1;r.pauseOnPagerHover&&a.hover(function(){p=!0,h.cyclePause++,c(h,!0,!0)},function(){p&&h.cyclePause--,c(h,!0,!0)})}},e.fn.cycle.hopsFromLast=function(e,t){var n,i=e.lastSlide,c=e.currSlide;return n=t?c>i?c-i:e.slideCount-i:i>c?i-c:i+e.slideCount-c},e.fn.cycle.commonReset=function(t,n,i,c,s,o){e(i.elements).not(t).hide(),"undefined"==typeof i.cssBefore.opacity&&(i.cssBefore.opacity=1),i.cssBefore.display="block",i.slideResize&&c!==!1&&n.cycleW>0&&(i.cssBefore.width=n.cycleW),i.slideResize&&s!==!1&&n.cycleH>0&&(i.cssBefore.height=n.cycleH),i.cssAfter=i.cssAfter||{},i.cssAfter.display="none",e(t).css("zIndex",i.slideCount+(o===!0?1:0)),e(n).css("zIndex",i.slideCount+(o===!0?0:1))},e.fn.cycle.custom=function(t,n,i,c,s,o){var r=e(t),l=e(n),a=i.speedIn,f=i.speedOut,u=i.easeIn,d=i.easeOut;l.css(i.cssBefore),o&&(a=f="number"==typeof o?o:1,u=d=null);var h=function(){l.animate(i.animIn,a,u,function(){c()})};r.animate(i.animOut,f,d,function(){r.css(i.cssAfter),i.sync||h()}),i.sync&&h()},e.fn.cycle.transitions={fade:function(t,n,i){n.not(":eq("+i.currSlide+")").css("opacity",0),i.before.push(function(t,n,i){e.fn.cycle.commonReset(t,n,i),i.cssBefore.opacity=0}),i.animIn={opacity:1},i.animOut={opacity:0},i.cssBefore={top:0,left:0}}},e.fn.cycle.ver=function(){return x},e.fn.cycle.defaults={activePagerClass:"activeSlide",after:null,allowPagerClickBubble:!1,animIn:null,animOut:null,aspect:!1,autostop:0,autostopCount:0,backwards:!1,before:null,center:null,cleartype:!e.support.opacity,cleartypeNoBg:!1,containerResize:1,continuous:0,cssAfter:null,cssBefore:null,delay:0,easeIn:null,easeOut:null,easing:null,end:null,fastOnEvent:0,fit:0,fx:"fade",fxFn:null,height:"auto",manualTrump:!0,metaAttr:"cycle",next:null,nowrap:0,onPagerEvent:null,onPrevNextEvent:null,pager:null,pagerAnchorBuilder:null,pagerEvent:"click.cycle",pause:0,pauseOnPagerHover:0,prev:null,prevNextEvent:"click.cycle",random:0,randomizeEffects:1,requeueOnImageNotLoaded:!0,requeueTimeout:250,rev:0,shuffle:null,skipInitializationCallbacks:!1,slideExpr:null,slideResize:1,speed:1e3,speedIn:null,speedOut:null,startingSlide:0,sync:1,timeout:4e3,timeoutFn:null,updateActivePagerLink:null,width:null}}(jQuery),function(e){e.fn.cycle.transitions.none=function(t,n,i){i.fxFn=function(t,n,i,c){e(n).show(),e(t).hide(),c()}},e.fn.cycle.transitions.fadeout=function(t,n,i){n.not(":eq("+i.currSlide+")").css({display:"block",opacity:1}),i.before.push(function(t,n,i,c,s,o){e(t).css("zIndex",i.slideCount+(!o==!0?1:0)),e(n).css("zIndex",i.slideCount+(!o==!0?0:1))}),i.animIn.opacity=1,i.animOut.opacity=0,i.cssBefore.opacity=1,i.cssBefore.display="block",i.cssAfter.zIndex=0},e.fn.cycle.transitions.scrollUp=function(t,n,i){t.css("overflow","hidden"),i.before.push(e.fn.cycle.commonReset);var c=t.height();i.cssBefore.top=c,i.cssBefore.left=0,i.cssFirst.top=0,i.animIn.top=0,i.animOut.top=-c},e.fn.cycle.transitions.scrollDown=function(t,n,i){t.css("overflow","hidden"),i.before.push(e.fn.cycle.commonReset);var c=t.height();i.cssFirst.top=0,i.cssBefore.top=-c,i.cssBefore.left=0,i.animIn.top=0,i.animOut.top=c},e.fn.cycle.transitions.scrollLeft=function(t,n,i){t.css("overflow","hidden"),i.before.push(e.fn.cycle.commonReset);var c=t.width();i.cssFirst.left=0,i.cssBefore.left=c,i.cssBefore.top=0,i.animIn.left=0,i.animOut.left=0-c},e.fn.cycle.transitions.scrollRight=function(t,n,i){t.css("overflow","hidden"),i.before.push(e.fn.cycle.commonReset);var c=t.width();i.cssFirst.left=0,i.cssBefore.left=-c,i.cssBefore.top=0,i.animIn.left=0,i.animOut.left=c},e.fn.cycle.transitions.scrollHorz=function(t,n,i){t.css("overflow","hidden").width(),i.before.push(function(t,n,i,c){i.rev&&(c=!c),e.fn.cycle.commonReset(t,n,i),i.cssBefore.left=c?n.cycleW-1:1-n.cycleW,i.animOut.left=c?-t.cycleW:t.cycleW}),i.cssFirst.left=0,i.cssBefore.top=0,i.animIn.left=0,i.animOut.top=0},e.fn.cycle.transitions.scrollVert=function(t,n,i){t.css("overflow","hidden"),i.before.push(function(t,n,i,c){i.rev&&(c=!c),e.fn.cycle.commonReset(t,n,i),i.cssBefore.top=c?1-n.cycleH:n.cycleH-1,i.animOut.top=c?t.cycleH:-t.cycleH}),i.cssFirst.top=0,i.cssBefore.left=0,i.animIn.top=0,i.animOut.left=0},e.fn.cycle.transitions.slideX=function(t,n,i){i.before.push(function(t,n,i){e(i.elements).not(t).hide(),e.fn.cycle.commonReset(t,n,i,!1,!0),i.animIn.width=n.cycleW}),i.cssBefore.left=0,i.cssBefore.top=0,i.cssBefore.width=0,i.animIn.width="show",i.animOut.width=0},e.fn.cycle.transitions.slideY=function(t,n,i){i.before.push(function(t,n,i){e(i.elements).not(t).hide(),e.fn.cycle.commonReset(t,n,i,!0,!1),i.animIn.height=n.cycleH}),i.cssBefore.left=0,i.cssBefore.top=0,i.cssBefore.height=0,i.animIn.height="show",i.animOut.height=0},e.fn.cycle.transitions.shuffle=function(t,n,i){var c,s=t.css("overflow","visible").width();for(n.css({left:0,top:0}),i.before.push(function(t,n,i){e.fn.cycle.commonReset(t,n,i,!0,!0,!0)}),i.speedAdjusted||(i.speed=i.speed/2,i.speedAdjusted=!0),i.random=0,i.shuffle=i.shuffle||{left:-s,top:15},i.els=[],c=0;c<n.length;c++)i.els.push(n[c]);for(c=0;c<i.currSlide;c++)i.els.push(i.els.shift());i.fxFn=function(t,n,i,c,s){i.rev&&(s=!s);var o=e(s?t:n);e(n).css(i.cssBefore);var r=i.slideCount;o.animate(i.shuffle,i.speedIn,i.easeIn,function(){for(var n=e.fn.cycle.hopsFromLast(i,s),l=0;n>l;l++)s?i.els.push(i.els.shift()):i.els.unshift(i.els.pop());if(s)for(var a=0,f=i.els.length;f>a;a++)e(i.els[a]).css("z-index",f-a+r);else{var u=e(t).css("z-index");o.css("z-index",parseInt(u,10)+1+r)}o.animate({left:0,top:0},i.speedOut,i.easeOut,function(){e(s?this:t).hide(),c&&c()})})},e.extend(i.cssBefore,{display:"block",opacity:1,top:0,left:0})},e.fn.cycle.transitions.turnUp=function(t,n,i){i.before.push(function(t,n,i){e.fn.cycle.commonReset(t,n,i,!0,!1),i.cssBefore.top=n.cycleH,i.animIn.height=n.cycleH,i.animOut.width=n.cycleW}),i.cssFirst.top=0,i.cssBefore.left=0,i.cssBefore.height=0,i.animIn.top=0,i.animOut.height=0},e.fn.cycle.transitions.turnDown=function(t,n,i){i.before.push(function(t,n,i){e.fn.cycle.commonReset(t,n,i,!0,!1),i.animIn.height=n.cycleH,i.animOut.top=t.cycleH}),i.cssFirst.top=0,i.cssBefore.left=0,i.cssBefore.top=0,i.cssBefore.height=0,i.animOut.height=0},e.fn.cycle.transitions.turnLeft=function(t,n,i){i.before.push(function(t,n,i){e.fn.cycle.commonReset(t,n,i,!1,!0),i.cssBefore.left=n.cycleW,i.animIn.width=n.cycleW}),i.cssBefore.top=0,i.cssBefore.width=0,i.animIn.left=0,i.animOut.width=0},e.fn.cycle.transitions.turnRight=function(t,n,i){i.before.push(function(t,n,i){e.fn.cycle.commonReset(t,n,i,!1,!0),i.animIn.width=n.cycleW,i.animOut.left=t.cycleW}),e.extend(i.cssBefore,{top:0,left:0,width:0}),i.animIn.left=0,i.animOut.width=0},e.fn.cycle.transitions.zoom=function(t,n,i){i.before.push(function(t,n,i){e.fn.cycle.commonReset(t,n,i,!1,!1,!0),i.cssBefore.top=n.cycleH/2,i.cssBefore.left=n.cycleW/2,e.extend(i.animIn,{top:0,left:0,width:n.cycleW,height:n.cycleH}),e.extend(i.animOut,{width:0,height:0,top:t.cycleH/2,left:t.cycleW/2})}),i.cssFirst.top=0,i.cssFirst.left=0,i.cssBefore.width=0,i.cssBefore.height=0},e.fn.cycle.transitions.fadeZoom=function(t,n,i){i.before.push(function(t,n,i){e.fn.cycle.commonReset(t,n,i,!1,!1),i.cssBefore.left=n.cycleW/2,i.cssBefore.top=n.cycleH/2,e.extend(i.animIn,{top:0,left:0,width:n.cycleW,height:n.cycleH})}),i.cssBefore.width=0,i.cssBefore.height=0,i.animOut.opacity=0},e.fn.cycle.transitions.blindX=function(t,n,i){var c=t.css("overflow","hidden").width();i.before.push(function(t,n,i){e.fn.cycle.commonReset(t,n,i),i.animIn.width=n.cycleW,i.animOut.left=t.cycleW}),i.cssBefore.left=c,i.cssBefore.top=0,i.animIn.left=0,i.animOut.left=c},e.fn.cycle.transitions.blindY=function(t,n,i){var c=t.css("overflow","hidden").height();i.before.push(function(t,n,i){e.fn.cycle.commonReset(t,n,i),i.animIn.height=n.cycleH,i.animOut.top=t.cycleH}),i.cssBefore.top=c,i.cssBefore.left=0,i.animIn.top=0,i.animOut.top=c},e.fn.cycle.transitions.blindZ=function(t,n,i){var c=t.css("overflow","hidden").height(),s=t.width();i.before.push(function(t,n,i){e.fn.cycle.commonReset(t,n,i),i.animIn.height=n.cycleH,i.animOut.top=t.cycleH}),i.cssBefore.top=c,i.cssBefore.left=s,i.animIn.top=0,i.animIn.left=0,i.animOut.top=c,i.animOut.left=s},e.fn.cycle.transitions.growX=function(t,n,i){i.before.push(function(t,n,i){e.fn.cycle.commonReset(t,n,i,!1,!0),i.cssBefore.left=this.cycleW/2,i.animIn.left=0,i.animIn.width=this.cycleW,i.animOut.left=0}),i.cssBefore.top=0,i.cssBefore.width=0},e.fn.cycle.transitions.growY=function(t,n,i){i.before.push(function(t,n,i){e.fn.cycle.commonReset(t,n,i,!0,!1),i.cssBefore.top=this.cycleH/2,i.animIn.top=0,i.animIn.height=this.cycleH,i.animOut.top=0}),i.cssBefore.height=0,i.cssBefore.left=0},e.fn.cycle.transitions.curtainX=function(t,n,i){i.before.push(function(t,n,i){e.fn.cycle.commonReset(t,n,i,!1,!0,!0),i.cssBefore.left=n.cycleW/2,i.animIn.left=0,i.animIn.width=this.cycleW,i.animOut.left=t.cycleW/2,i.animOut.width=0}),i.cssBefore.top=0,i.cssBefore.width=0},e.fn.cycle.transitions.curtainY=function(t,n,i){i.before.push(function(t,n,i){e.fn.cycle.commonReset(t,n,i,!0,!1,!0),i.cssBefore.top=n.cycleH/2,i.animIn.top=0,i.animIn.height=n.cycleH,i.animOut.top=t.cycleH/2,i.animOut.height=0}),i.cssBefore.height=0,i.cssBefore.left=0},e.fn.cycle.transitions.cover=function(t,n,i){var c=i.direction||"left",s=t.css("overflow","hidden").width(),o=t.height();i.before.push(function(t,n,i){e.fn.cycle.commonReset(t,n,i),"right"==c?i.cssBefore.left=-s:"up"==c?i.cssBefore.top=o:"down"==c?i.cssBefore.top=-o:i.cssBefore.left=s}),i.animIn.left=0,i.animIn.top=0,i.cssBefore.top=0,i.cssBefore.left=0},e.fn.cycle.transitions.uncover=function(t,n,i){var c=i.direction||"left",s=t.css("overflow","hidden").width(),o=t.height();i.before.push(function(t,n,i){e.fn.cycle.commonReset(t,n,i,!0,!0,!0),"right"==c?i.animOut.left=s:"up"==c?i.animOut.top=-o:"down"==c?i.animOut.top=o:i.animOut.left=-s}),i.animIn.left=0,i.animIn.top=0,i.cssBefore.top=0,i.cssBefore.left=0},e.fn.cycle.transitions.toss=function(t,n,i){var c=t.css("overflow","visible").width(),s=t.height();i.before.push(function(t,n,i){e.fn.cycle.commonReset(t,n,i,!0,!0,!0),i.animOut.left||i.animOut.top?i.animOut.opacity=0:e.extend(i.animOut,{left:2*c,top:-s/2,opacity:0})}),i.cssBefore.left=0,i.cssBefore.top=0,i.animIn.left=0},e.fn.cycle.transitions.wipe=function(t,n,i){var c=t.css("overflow","hidden").width(),s=t.height();i.cssBefore=i.cssBefore||{};var o;if(i.clip)if(/l2r/.test(i.clip))o="rect(0px 0px "+s+"px 0px)";else if(/r2l/.test(i.clip))o="rect(0px "+c+"px "+s+"px "+c+"px)";else if(/t2b/.test(i.clip))o="rect(0px "+c+"px 0px 0px)";else if(/b2t/.test(i.clip))o="rect("+s+"px "+c+"px "+s+"px 0px)";else if(/zoom/.test(i.clip)){var r=parseInt(s/2,10),l=parseInt(c/2,10);o="rect("+r+"px "+l+"px "+r+"px "+l+"px)"}i.cssBefore.clip=i.cssBefore.clip||o||"rect(0px 0px 0px 0px)";var a=i.cssBefore.clip.match(/(\d+)/g),f=parseInt(a[0],10),u=parseInt(a[1],10),d=parseInt(a[2],10),h=parseInt(a[3],10);i.before.push(function(t,n,i){if(t!=n){var o=e(t),r=e(n);e.fn.cycle.commonReset(t,n,i,!0,!0,!1),i.cssAfter.display="block";var l=1,a=parseInt(i.speedIn/13,10)-1;!function p(){var e=f?f-parseInt(l*(f/a),10):0,t=h?h-parseInt(l*(h/a),10):0,n=s>d?d+parseInt(l*((s-d)/a||1),10):s,i=c>u?u+parseInt(l*((c-u)/a||1),10):c;r.css({clip:"rect("+e+"px "+i+"px "+n+"px "+t+"px)"}),l++<=a?setTimeout(p,13):o.css("display","none")}()}}),e.extend(i.cssBefore,{display:"block",opacity:1,top:0,left:0}),i.animIn={left:0},i.animOut={left:0}}}(jQuery);
 
 /*	--------------------------------------------------------------------
	MaxImage 2.0 (Fullscreen Slideshow for use with jQuery Cycle Plugin)
	--------------------------------------------------------------------
	
	Examples and documentation at: http://www.aaronvanderzwan.com/maximage/2.0/
	Copyright (c) 2007-2012 Aaron Vanderzwan
	Dual licensed under the MIT and GPL licenses.
	
	NOTES:
	This plugin is intended to simplify the creation of fullscreen 
	background slideshows.  It is intended to be used alongside the 
	jQuery Cycle plugin: 
	http://jquery.malsup.com/cycle/
	
	If you simply need a fullscreen background image, please
	refer to the following document for ways to do this that
	are much more simple:
	http://css-tricks.com/perfect-full-page-background-image/
	
	If you have any questions please contact Aaron Vanderzwan
	at http://www.aaronvanderzwan.com/blog/
	Documentation at:
	http://blog.aaronvanderzwan.com/2012/07/maximage-2-0/
	
	HISTORY:
	MaxImage 2.0 is a project first built as jQuery MaxImage Plugin 
	(http://www.aaronvanderzwan.com/maximage/). Once CSS3 came along, 
	the background-size:cover solved the problem MaxImage
	was intended to solve.  However, fully customizable
	fullscreen slideshows is still fairly complex and I have not
	found any helpers for integrating with the jQuery Cycle Plugin.
	MaxCycle is intended to solve this problem.
	
	TABLE OF CONTENTS:
	@Modern
		@setup
		@resize
		@preload
	@Old
		@setup
		@preload
		@onceloaded
		@maximage
		@windowresize
		@doneresizing
	@Cycle
		@setup
	@Adjust
		@center
		@fill
		@maxcover
		@maxcontain
	@Utils
		@browser_tests
		@construct_slide_object
		@sizes
	@modern_browser
	@debug
		
*/
/*!	
 * Maximage Version: 2.0.8 (16-Jan-2012) - http://www.aaronvanderzwan.com/maximage/2.0/
 */

!function(e){"use strict";e.fn.maximage=function(i,t){function a(e){window.console&&window.console.log&&window.console.log(e)}var d;("object"==typeof i||void 0===i)&&(d=e.extend(e.fn.maximage.defaults,i||{})),"string"==typeof i&&(d=e.fn.maximage.defaults),e.Body=e("body"),e.Window=e(window),e.Scroll=e("html, body"),e.Events={RESIZE:"resize"},this.each(function(){var t=e(this),n=0,s=[],o={setup:function(){if(e.Slides.length>0){var i,a=e.Slides.length;for(i=0;a>i;i++){var d=e.Slides[i];t.append('<div class="mc-image '+d.theclass+'" title="'+d.alt+'" style="background-image:url(\''+d.url+"');"+d.style+'" data-href="'+d.datahref+'">'+d.content+"</div>")}o.preload(0),o.resize()}},preload:function(i){var a=e("<img/>");a.on("load",function(){0==n&&(c.setup(),d.onFirstImageLoaded()),n==e.Slides.length-1?d.onImagesLoaded(t):(n++,o.preload(n))}),a[0].src=e.Slides[i].url,s.push(a[0])},resize:function(){e.Window.bind(e.Events.RESIZE,function(){e.Scroll.addClass("mc-hide-scrolls"),e.Window.data("h",h.sizes().h).data("w",h.sizes().w),t.height(e.Window.data("h")).width(e.Window.data("w")).children().height(e.Window.data("h")).width(e.Window.data("w")),t.children().each(function(){this.cycleH=e.Window.data("h"),this.cycleW=e.Window.data("w")}),e(e.Scroll).removeClass("mc-hide-scrolls")})}},r={setup:function(){var i,a,n,s=e.Slides.length;if(e.BrowserTests.msie&&!d.overrideMSIEStop&&document.execCommand("Stop",!1),t.html(""),e.Body.addClass("mc-old-browser"),e.Slides.length>0){for(e.Scroll.addClass("mc-hide-scrolls"),e.Window.data("h",h.sizes().h).data("w",h.sizes().w),e("body").append(e("<div></div>").attr("class","mc-loader").css({position:"absolute",left:"-9999px"})),n=0;s>n;n++)i=0==e.Slides[n].content.length?'<img src="'+e.Slides[n].url+'" />':e.Slides[n].content,a=e("<div>"+i+"</div>").attr("class","mc-image mc-image-n"+n+" "+e.Slides[n].theclass),t.append(a),0==e(".mc-image-n"+n).children("img").length||e("div.mc-loader").append(e(".mc-image-n"+n).children("img").first().clone().addClass("not-loaded"));r.preload(),r.windowResize()}},preload:function(){var i=setInterval(function(){e(".mc-loader").children("img").each(function(i){var t=e(this);if(t.hasClass("not-loaded")&&t.height()>0){e(this).removeClass("not-loaded");var a=e("div.mc-image-n"+i).children("img").first();a.data("h",t.height()).data("w",t.width()).data("ar",t.width()/t.height()),r.onceLoaded(i)}}),0==e(".not-loaded").length&&(e(".mc-loader").remove(),clearInterval(i))},1e3)},onceLoaded:function(i){r.maximage(i),0==i?(t.css({visibility:"visible"}),d.onFirstImageLoaded()):i==e.Slides.length-1&&(c.setup(),e(e.Scroll).removeClass("mc-hide-scrolls"),d.onImagesLoaded(t),d.debug&&(a(" - Final Maximage - "),a(t)))},maximage:function(i){e("div.mc-image-n"+i).height(e.Window.data("h")).width(e.Window.data("w")).children("img").first().each(function(){l.maxcover(e(this))})},windowResize:function(){e.Window.bind(e.Events.RESIZE,function(){clearTimeout(this.id),e(".mc-image").length>=1&&(this.id=setTimeout(r.doneResizing,200))})},doneResizing:function(){e(e.Scroll).addClass("mc-hide-scrolls"),e.Window.data("h",h.sizes().h).data("w",h.sizes().w),t.height(e.Window.data("h")).width(e.Window.data("w")),t.find(".mc-image").each(function(e){r.maximage(e)});var i=t.data("cycle.opts");void 0!=i&&(i.height=e.Window.data("h"),i.width=e.Window.data("w"),jQuery.each(i.elements,function(i,t){t.cycleW=e.Window.data("w"),t.cycleH=e.Window.data("h")})),e(e.Scroll).removeClass("mc-hide-scrolls")}},c={setup:function(){t.addClass("mc-cycle"),e.Window.data("h",h.sizes().h).data("w",h.sizes().w),jQuery.easing.easeForCSSTransition=function(e,i,t,a,d,n){return t+a};var i=e.extend({fit:1,containerResize:0,height:e.Window.data("h"),width:e.Window.data("w"),slideResize:!1,easing:e.BrowserTests.cssTransitions&&d.cssTransitions?"easeForCSSTransition":"swing"},d.cycleOptions);t.cycle(i)}},l={center:function(i){d.verticalCenter&&i.css({marginTop:(i.height()-e.Window.data("h"))/2*-1}),d.horizontalCenter&&i.css({marginLeft:(i.width()-e.Window.data("w"))/2*-1})},fill:function(i){var t=i.is("object")?i.parent().first():i;"function"==typeof d.backgroundSize?d.backgroundSize(i):"cover"==d.backgroundSize?e.Window.data("w")/e.Window.data("h")<t.data("ar")?i.height(e.Window.data("h")).width((e.Window.data("h")*t.data("ar")).toFixed(0)):i.height((e.Window.data("w")/t.data("ar")).toFixed(0)).width(e.Window.data("w")):"contain"==d.backgroundSize?e.Window.data("w")/e.Window.data("h")<t.data("ar")?i.height((e.Window.data("w")/t.data("ar")).toFixed(0)).width(e.Window.data("w")):i.height(e.Window.data("h")).width((e.Window.data("h")*t.data("ar")).toFixed(0)):a("The backgroundSize option was not recognized for older browsers.")},maxcover:function(e){l.fill(e),l.center(e)},maxcontain:function(e){l.fill(e),l.center(e)}},h={browser_tests:function(){var i=e("<div />")[0],t=["Moz","Webkit","Khtml","O","ms"],n="transition",s={cssTransitions:!1,cssBackgroundSize:"backgroundSize"in i.style&&d.cssBackgroundSize,html5Video:!1,msie:!1};if(d.cssTransitions){"string"==typeof i.style[n]&&(s.cssTransitions=!0),n=n.charAt(0).toUpperCase()+n.substr(1);for(var o=0;o<t.length;o++)t[o]+n in i.style&&(s.cssTransitions=!0)}return document.createElement("video").canPlayType&&(s.html5Video=!0),s.msie=void 0!==h.msie(),d.debug&&(a(" - Browser Test - "),a(s)),s},construct_slide_object:function(){var i=new Object,n=new Array;return t.children().each(function(t){var a=e(this).is("img")?e(this).clone():e(this).find("img").first().clone();i={},i.url=a.attr("src"),i.title=void 0!=a.attr("title")?a.attr("title"):"",i.alt=void 0!=a.attr("alt")?a.attr("alt"):"",i.theclass=void 0!=a.attr("class")?a.attr("class"):"",i.styles=void 0!=a.attr("style")?a.attr("style"):"",i.orig=a.clone(),i.datahref=void 0!=a.attr("data-href")?a.attr("data-href"):"",i.content="",e(this).find("img").length>0&&(e.BrowserTests.cssBackgroundSize&&e(this).find("img").first().remove(),i.content=e(this).html()),a[0].src="",e.BrowserTests.cssBackgroundSize&&e(this).remove(),n.push(i)}),d.debug&&(a(" - Slide Object - "),a(n)),n},msie:function(){for(var e,i=3,t=document.createElement("div"),a=t.getElementsByTagName("i");t.innerHTML="<!--[if gt IE "+ ++i+"]><i></i><![endif]-->",a[0];);return i>4?i:e},sizes:function(){var i={h:0,w:0};if("window"==d.fillElement)i.h=e.Window.height(),i.w=e.Window.width();else{var a=t.parents(d.fillElement).first();0==a.height()||1==a.data("windowHeight")?(a.data("windowHeight",!0),i.h=e.Window.height()):i.h=a.height(),0==a.width()||1==a.data("windowWidth")?(a.data("windowWidth",!0),i.w=e.Window.width()):i.w=a.width()}return i}};if(e.BrowserTests=h.browser_tests(),"string"==typeof i){if(e.BrowserTests.html5Video||!t.is("video")){var w,g=t.is("object")?t.parent().first():t;e.Body.hasClass("mc-old-browser")||e.Body.addClass("mc-old-browser"),e.Window.data("h",h.sizes().h).data("w",h.sizes().w),g.data("h",t.height()).data("w",t.width()).data("ar",t.width()/t.height()),e.Window.bind(e.Events.RESIZE,function(){e.Window.data("h",h.sizes().h).data("w",h.sizes().w),w=t.data("resizer"),clearTimeout(w),w=setTimeout(l[i](t),200),t.data("resizer",w)}),l[i](t)}}else e.Slides=h.construct_slide_object(),e.BrowserTests.cssBackgroundSize?(d.debug&&a(" - Using Modern - "),o.setup()):(d.debug&&a(" - Using Old - "),r.setup())})},e.fn.maximage.defaults={debug:!1,cssBackgroundSize:!0,cssTransitions:!0,verticalCenter:!0,horizontalCenter:!0,scaleInterval:20,backgroundSize:"cover",fillElement:"window",overrideMSIEStop:!1,onFirstImageLoaded:function(){},onImagesLoaded:function(){}}}(jQuery);

!(function (e, a) {
    "object" == typeof exports && "undefined" != typeof module
        ? (module.exports = a())
        : "function" == typeof define && define.amd
        ? define(a)
        : (e.moment = a());
})(this, function () {
    "use strict";
    var E;
    function M() {
        return E.apply(null, arguments);
    }
    function F(e) {
        return (
            e instanceof Array ||
            "[object Array]" === Object.prototype.toString.call(e)
        );
    }
    function z(e) {
        return (
            null != e && "[object Object]" === Object.prototype.toString.call(e)
        );
    }
    function l(e, a) {
        return Object.prototype.hasOwnProperty.call(e, a);
    }
    function N(e) {
        if (Object.getOwnPropertyNames)
            return 0 === Object.getOwnPropertyNames(e).length;
        for (var a in e) if (l(e, a)) return;
        return 1;
    }
    function d(e) {
        return void 0 === e;
    }
    function J(e) {
        return (
            "number" == typeof e ||
            "[object Number]" === Object.prototype.toString.call(e)
        );
    }
    function R(e) {
        return (
            e instanceof Date ||
            "[object Date]" === Object.prototype.toString.call(e)
        );
    }
    function C(e, a) {
        for (var t = [], s = e.length, n = 0; n < s; ++n) t.push(a(e[n], n));
        return t;
    }
    function I(e, a) {
        for (var t in a) l(a, t) && (e[t] = a[t]);
        return (
            l(a, "toString") && (e.toString = a.toString),
            l(a, "valueOf") && (e.valueOf = a.valueOf),
            e
        );
    }
    function U(e, a, t, s) {
        return Fa(e, a, t, s, !0).utc();
    }
    function h(e) {
        return (
            null == e._pf &&
                (e._pf = {
                    empty: !1,
                    unusedTokens: [],
                    unusedInput: [],
                    overflow: -2,
                    charsLeftOver: 0,
                    nullInput: !1,
                    invalidEra: null,
                    invalidMonth: null,
                    invalidFormat: !1,
                    userInvalidated: !1,
                    iso: !1,
                    parsedDateParts: [],
                    era: null,
                    meridiem: null,
                    rfc2822: !1,
                    weekdayMismatch: !1,
                }),
            e._pf
        );
    }
    function G(e) {
        if (null == e._isValid) {
            var a = h(e),
                t = B.call(a.parsedDateParts, function (e) {
                    return null != e;
                }),
                t =
                    !isNaN(e._d.getTime()) &&
                    a.overflow < 0 &&
                    !a.empty &&
                    !a.invalidEra &&
                    !a.invalidMonth &&
                    !a.invalidWeekday &&
                    !a.weekdayMismatch &&
                    !a.nullInput &&
                    !a.invalidFormat &&
                    !a.userInvalidated &&
                    (!a.meridiem || (a.meridiem && t));
            if (
                (e._strict &&
                    (t =
                        t &&
                        0 === a.charsLeftOver &&
                        0 === a.unusedTokens.length &&
                        void 0 === a.bigHour),
                null != Object.isFrozen && Object.isFrozen(e))
            )
                return t;
            e._isValid = t;
        }
        return e._isValid;
    }
    function V(e) {
        var a = U(NaN);
        return null != e ? I(h(a), e) : (h(a).userInvalidated = !0), a;
    }
    var B =
            Array.prototype.some ||
            function (e) {
                for (
                    var a = Object(this), t = a.length >>> 0, s = 0;
                    s < t;
                    s++
                )
                    if (s in a && e.call(this, a[s], s, a)) return !0;
                return !1;
            },
        K = (M.momentProperties = []),
        q = !1;
    function Z(e, a) {
        var t,
            s,
            n,
            r = K.length;
        if (
            (d(a._isAMomentObject) || (e._isAMomentObject = a._isAMomentObject),
            d(a._i) || (e._i = a._i),
            d(a._f) || (e._f = a._f),
            d(a._l) || (e._l = a._l),
            d(a._strict) || (e._strict = a._strict),
            d(a._tzm) || (e._tzm = a._tzm),
            d(a._isUTC) || (e._isUTC = a._isUTC),
            d(a._offset) || (e._offset = a._offset),
            d(a._pf) || (e._pf = h(a)),
            d(a._locale) || (e._locale = a._locale),
            0 < r)
        )
            for (t = 0; t < r; t++) d((n = a[(s = K[t])])) || (e[s] = n);
        return e;
    }
    function $(e) {
        Z(this, e),
            (this._d = new Date(null != e._d ? e._d.getTime() : NaN)),
            this.isValid() || (this._d = new Date(NaN)),
            !1 === q && ((q = !0), M.updateOffset(this), (q = !1));
    }
    function Q(e) {
        return e instanceof $ || (null != e && null != e._isAMomentObject);
    }
    function X(e) {
        !1 === M.suppressDeprecationWarnings &&
            "undefined" != typeof console &&
            console.warn &&
            console.warn("Deprecation warning: " + e);
    }
    function e(r, d) {
        var i = !0;
        return I(function () {
            if (
                (null != M.deprecationHandler && M.deprecationHandler(null, r),
                i)
            ) {
                for (
                    var e, a, t = [], s = arguments.length, n = 0;
                    n < s;
                    n++
                ) {
                    if (((e = ""), "object" == typeof arguments[n])) {
                        for (a in ((e += "\n[" + n + "] "), arguments[0]))
                            l(arguments[0], a) &&
                                (e += a + ": " + arguments[0][a] + ", ");
                        e = e.slice(0, -2);
                    } else e = arguments[n];
                    t.push(e);
                }
                X(
                    r +
                        "\nArguments: " +
                        Array.prototype.slice.call(t).join("") +
                        "\n" +
                        new Error().stack
                ),
                    (i = !1);
            }
            return d.apply(this, arguments);
        }, d);
    }
    var ee = {};
    function ae(e, a) {
        null != M.deprecationHandler && M.deprecationHandler(e, a),
            ee[e] || (X(a), (ee[e] = !0));
    }
    function te(e) {
        return (
            ("undefined" != typeof Function && e instanceof Function) ||
            "[object Function]" === Object.prototype.toString.call(e)
        );
    }
    function se(e, a) {
        var t,
            s = I({}, e);
        for (t in a)
            l(a, t) &&
                (z(e[t]) && z(a[t])
                    ? ((s[t] = {}), I(s[t], e[t]), I(s[t], a[t]))
                    : null != a[t]
                    ? (s[t] = a[t])
                    : delete s[t]);
        for (t in e) l(e, t) && !l(a, t) && z(e[t]) && (s[t] = I({}, s[t]));
        return s;
    }
    function ne(e) {
        null != e && this.set(e);
    }
    (M.suppressDeprecationWarnings = !1), (M.deprecationHandler = null);
    var re =
        Object.keys ||
        function (e) {
            var a,
                t = [];
            for (a in e) l(e, a) && t.push(a);
            return t;
        };
    function de(e, a, t) {
        var s = "" + Math.abs(e);
        return (
            (0 <= e ? (t ? "+" : "") : "-") +
            Math.pow(10, Math.max(0, a - s.length))
                .toString()
                .substr(1) +
            s
        );
    }
    var ie =
            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        _e = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        oe = {},
        me = {};
    function s(e, a, t, s) {
        var n =
            "string" == typeof s
                ? function () {
                      return this[s]();
                  }
                : s;
        e && (me[e] = n),
            a &&
                (me[a[0]] = function () {
                    return de(n.apply(this, arguments), a[1], a[2]);
                }),
            t &&
                (me[t] = function () {
                    return this.localeData().ordinal(
                        n.apply(this, arguments),
                        e
                    );
                });
    }
    function ue(e, a) {
        return e.isValid()
            ? ((a = le(a, e.localeData())),
              (oe[a] =
                  oe[a] ||
                  (function (s) {
                      for (
                          var e, n = s.match(ie), a = 0, r = n.length;
                          a < r;
                          a++
                      )
                          me[n[a]]
                              ? (n[a] = me[n[a]])
                              : (n[a] = (e = n[a]).match(/\[[\s\S]/)
                                    ? e.replace(/^\[|\]$/g, "")
                                    : e.replace(/\\/g, ""));
                      return function (e) {
                          for (var a = "", t = 0; t < r; t++)
                              a += te(n[t]) ? n[t].call(e, s) : n[t];
                          return a;
                      };
                  })(a)),
              oe[a](e))
            : e.localeData().invalidDate();
    }
    function le(e, a) {
        var t = 5;
        function s(e) {
            return a.longDateFormat(e) || e;
        }
        for (_e.lastIndex = 0; 0 <= t && _e.test(e); )
            (e = e.replace(_e, s)), (_e.lastIndex = 0), --t;
        return e;
    }
    var Me = {};
    function a(e, a) {
        var t = e.toLowerCase();
        Me[t] = Me[t + "s"] = Me[a] = e;
    }
    function i(e) {
        return "string" == typeof e ? Me[e] || Me[e.toLowerCase()] : void 0;
    }
    function he(e) {
        var a,
            t,
            s = {};
        for (t in e) l(e, t) && (a = i(t)) && (s[a] = e[t]);
        return s;
    }
    var ce = {};
    function t(e, a) {
        ce[e] = a;
    }
    function Le(e) {
        return (e % 4 == 0 && e % 100 != 0) || e % 400 == 0;
    }
    function u(e) {
        return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
    }
    function m(e) {
        var e = +e,
            a = 0;
        return (a = 0 != e && isFinite(e) ? u(e) : a);
    }
    function Ye(a, t) {
        return function (e) {
            return null != e
                ? (fe(this, a, e), M.updateOffset(this, t), this)
                : ye(this, a);
        };
    }
    function ye(e, a) {
        return e.isValid() ? e._d["get" + (e._isUTC ? "UTC" : "") + a]() : NaN;
    }
    function fe(e, a, t) {
        e.isValid() &&
            !isNaN(t) &&
            ("FullYear" === a &&
            Le(e.year()) &&
            1 === e.month() &&
            29 === e.date()
                ? ((t = m(t)),
                  e._d["set" + (e._isUTC ? "UTC" : "") + a](
                      t,
                      e.month(),
                      ze(t, e.month())
                  ))
                : e._d["set" + (e._isUTC ? "UTC" : "") + a](t));
    }
    var n = /\d/,
        r = /\d\d/,
        pe = /\d{3}/,
        ke = /\d{4}/,
        _ = /[+-]?\d{6}/,
        o = /\d\d?/,
        c = /\d\d\d\d?/,
        L = /\d\d\d\d\d\d?/,
        De = /\d{1,3}/,
        Y = /\d{1,4}/,
        y = /[+-]?\d{1,6}/,
        Te = /\d+/,
        ge = /[+-]?\d+/,
        we = /Z|[+-]\d\d:?\d\d/gi,
        be = /Z|[+-]\d\d(?::?\d\d)?/gi,
        f =
            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
    function p(e, t, s) {
        He[e] = te(t)
            ? t
            : function (e, a) {
                  return e && s ? s : t;
              };
    }
    function Se(e, a) {
        return l(He, e)
            ? He[e](a._strict, a._locale)
            : new RegExp(
                  k(
                      e
                          .replace("\\", "")
                          .replace(
                              /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
                              function (e, a, t, s, n) {
                                  return a || t || s || n;
                              }
                          )
                  )
              );
    }
    function k(e) {
        return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    var He = {},
        ve = {};
    function D(e, t) {
        var a,
            s,
            n = t;
        for (
            "string" == typeof e && (e = [e]),
                J(t) &&
                    (n = function (e, a) {
                        a[t] = m(e);
                    }),
                s = e.length,
                a = 0;
            a < s;
            a++
        )
            ve[e[a]] = n;
    }
    function je(e, n) {
        D(e, function (e, a, t, s) {
            (t._w = t._w || {}), n(e, t._w, t, s);
        });
    }
    var T,
        g = 0,
        xe = 1,
        Pe = 2,
        w = 3,
        Oe = 4,
        We = 5,
        Ae = 6,
        Ee = 7,
        Fe = 8;
    function ze(e, a) {
        if (isNaN(e) || isNaN(a)) return NaN;
        var t = ((a % (t = 12)) + t) % t;
        return (
            (e += (a - t) / 12), 1 == t ? (Le(e) ? 29 : 28) : 31 - ((t % 7) % 2)
        );
    }
    (T =
        Array.prototype.indexOf ||
        function (e) {
            for (var a = 0; a < this.length; ++a) if (this[a] === e) return a;
            return -1;
        }),
        s("M", ["MM", 2], "Mo", function () {
            return this.month() + 1;
        }),
        s("MMM", 0, 0, function (e) {
            return this.localeData().monthsShort(this, e);
        }),
        s("MMMM", 0, 0, function (e) {
            return this.localeData().months(this, e);
        }),
        a("month", "M"),
        t("month", 8),
        p("M", o),
        p("MM", o, r),
        p("MMM", function (e, a) {
            return a.monthsShortRegex(e);
        }),
        p("MMMM", function (e, a) {
            return a.monthsRegex(e);
        }),
        D(["M", "MM"], function (e, a) {
            a[xe] = m(e) - 1;
        }),
        D(["MMM", "MMMM"], function (e, a, t, s) {
            s = t._locale.monthsParse(e, s, t._strict);
            null != s ? (a[xe] = s) : (h(t).invalidMonth = e);
        });
    var Ne =
            "January_February_March_April_May_June_July_August_September_October_November_December".split(
                "_"
            ),
        Je = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
        Re = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        Ce = f,
        Ie = f;
    function Ue(e, a) {
        var t;
        if (e.isValid()) {
            if ("string" == typeof a)
                if (/^\d+$/.test(a)) a = m(a);
                else if (!J((a = e.localeData().monthsParse(a)))) return;
            (t = Math.min(e.date(), ze(e.year(), a))),
                e._d["set" + (e._isUTC ? "UTC" : "") + "Month"](a, t);
        }
    }
    function Ge(e) {
        return null != e
            ? (Ue(this, e), M.updateOffset(this, !0), this)
            : ye(this, "Month");
    }
    function Ve() {
        function e(e, a) {
            return a.length - e.length;
        }
        for (var a, t = [], s = [], n = [], r = 0; r < 12; r++)
            (a = U([2e3, r])),
                t.push(this.monthsShort(a, "")),
                s.push(this.months(a, "")),
                n.push(this.months(a, "")),
                n.push(this.monthsShort(a, ""));
        for (t.sort(e), s.sort(e), n.sort(e), r = 0; r < 12; r++)
            (t[r] = k(t[r])), (s[r] = k(s[r]));
        for (r = 0; r < 24; r++) n[r] = k(n[r]);
        (this._monthsRegex = new RegExp("^(" + n.join("|") + ")", "i")),
            (this._monthsShortRegex = this._monthsRegex),
            (this._monthsStrictRegex = new RegExp(
                "^(" + s.join("|") + ")",
                "i"
            )),
            (this._monthsShortStrictRegex = new RegExp(
                "^(" + t.join("|") + ")",
                "i"
            ));
    }
    function Be(e) {
        return Le(e) ? 366 : 365;
    }
    s("Y", 0, 0, function () {
        var e = this.year();
        return e <= 9999 ? de(e, 4) : "+" + e;
    }),
        s(0, ["YY", 2], 0, function () {
            return this.year() % 100;
        }),
        s(0, ["YYYY", 4], 0, "year"),
        s(0, ["YYYYY", 5], 0, "year"),
        s(0, ["YYYYYY", 6, !0], 0, "year"),
        a("year", "y"),
        t("year", 1),
        p("Y", ge),
        p("YY", o, r),
        p("YYYY", Y, ke),
        p("YYYYY", y, _),
        p("YYYYYY", y, _),
        D(["YYYYY", "YYYYYY"], g),
        D("YYYY", function (e, a) {
            a[g] = 2 === e.length ? M.parseTwoDigitYear(e) : m(e);
        }),
        D("YY", function (e, a) {
            a[g] = M.parseTwoDigitYear(e);
        }),
        D("Y", function (e, a) {
            a[g] = parseInt(e, 10);
        }),
        (M.parseTwoDigitYear = function (e) {
            return m(e) + (68 < m(e) ? 1900 : 2e3);
        });
    var Ke = Ye("FullYear", !0);
    function qe(e, a, t, s, n, r, d) {
        var i;
        return (
            e < 100 && 0 <= e
                ? ((i = new Date(e + 400, a, t, s, n, r, d)),
                  isFinite(i.getFullYear()) && i.setFullYear(e))
                : (i = new Date(e, a, t, s, n, r, d)),
            i
        );
    }
    function Ze(e) {
        var a;
        return (
            e < 100 && 0 <= e
                ? (((a = Array.prototype.slice.call(arguments))[0] = e + 400),
                  (a = new Date(Date.UTC.apply(null, a))),
                  isFinite(a.getUTCFullYear()) && a.setUTCFullYear(e))
                : (a = new Date(Date.UTC.apply(null, arguments))),
            a
        );
    }
    function $e(e, a, t) {
        t = 7 + a - t;
        return t - ((7 + Ze(e, 0, t).getUTCDay() - a) % 7) - 1;
    }
    function Qe(e, a, t, s, n) {
        var r,
            a = 1 + 7 * (a - 1) + ((7 + t - s) % 7) + $e(e, s, n),
            t =
                a <= 0
                    ? Be((r = e - 1)) + a
                    : a > Be(e)
                    ? ((r = e + 1), a - Be(e))
                    : ((r = e), a);
        return { year: r, dayOfYear: t };
    }
    function Xe(e, a, t) {
        var s,
            n,
            r = $e(e.year(), a, t),
            r = Math.floor((e.dayOfYear() - r - 1) / 7) + 1;
        return (
            r < 1
                ? (s = r + ea((n = e.year() - 1), a, t))
                : r > ea(e.year(), a, t)
                ? ((s = r - ea(e.year(), a, t)), (n = e.year() + 1))
                : ((n = e.year()), (s = r)),
            { week: s, year: n }
        );
    }
    function ea(e, a, t) {
        var s = $e(e, a, t),
            a = $e(e + 1, a, t);
        return (Be(e) - s + a) / 7;
    }
    s("w", ["ww", 2], "wo", "week"),
        s("W", ["WW", 2], "Wo", "isoWeek"),
        a("week", "w"),
        a("isoWeek", "W"),
        t("week", 5),
        t("isoWeek", 5),
        p("w", o),
        p("ww", o, r),
        p("W", o),
        p("WW", o, r),
        je(["w", "ww", "W", "WW"], function (e, a, t, s) {
            a[s.substr(0, 1)] = m(e);
        });
    function aa(e, a) {
        return e.slice(a, 7).concat(e.slice(0, a));
    }
    s("d", 0, "do", "day"),
        s("dd", 0, 0, function (e) {
            return this.localeData().weekdaysMin(this, e);
        }),
        s("ddd", 0, 0, function (e) {
            return this.localeData().weekdaysShort(this, e);
        }),
        s("dddd", 0, 0, function (e) {
            return this.localeData().weekdays(this, e);
        }),
        s("e", 0, 0, "weekday"),
        s("E", 0, 0, "isoWeekday"),
        a("day", "d"),
        a("weekday", "e"),
        a("isoWeekday", "E"),
        t("day", 11),
        t("weekday", 11),
        t("isoWeekday", 11),
        p("d", o),
        p("e", o),
        p("E", o),
        p("dd", function (e, a) {
            return a.weekdaysMinRegex(e);
        }),
        p("ddd", function (e, a) {
            return a.weekdaysShortRegex(e);
        }),
        p("dddd", function (e, a) {
            return a.weekdaysRegex(e);
        }),
        je(["dd", "ddd", "dddd"], function (e, a, t, s) {
            s = t._locale.weekdaysParse(e, s, t._strict);
            null != s ? (a.d = s) : (h(t).invalidWeekday = e);
        }),
        je(["d", "e", "E"], function (e, a, t, s) {
            a[s] = m(e);
        });
    var ta = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split(
            "_"
        ),
        sa = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
        na = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
        ra = f,
        da = f,
        ia = f;
    function _a() {
        function e(e, a) {
            return a.length - e.length;
        }
        for (var a, t, s, n = [], r = [], d = [], i = [], _ = 0; _ < 7; _++)
            (s = U([2e3, 1]).day(_)),
                (a = k(this.weekdaysMin(s, ""))),
                (t = k(this.weekdaysShort(s, ""))),
                (s = k(this.weekdays(s, ""))),
                n.push(a),
                r.push(t),
                d.push(s),
                i.push(a),
                i.push(t),
                i.push(s);
        n.sort(e),
            r.sort(e),
            d.sort(e),
            i.sort(e),
            (this._weekdaysRegex = new RegExp("^(" + i.join("|") + ")", "i")),
            (this._weekdaysShortRegex = this._weekdaysRegex),
            (this._weekdaysMinRegex = this._weekdaysRegex),
            (this._weekdaysStrictRegex = new RegExp(
                "^(" + d.join("|") + ")",
                "i"
            )),
            (this._weekdaysShortStrictRegex = new RegExp(
                "^(" + r.join("|") + ")",
                "i"
            )),
            (this._weekdaysMinStrictRegex = new RegExp(
                "^(" + n.join("|") + ")",
                "i"
            ));
    }
    function oa() {
        return this.hours() % 12 || 12;
    }
    function ma(e, a) {
        s(e, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), a);
        });
    }
    function ua(e, a) {
        return a._meridiemParse;
    }
    s("H", ["HH", 2], 0, "hour"),
        s("h", ["hh", 2], 0, oa),
        s("k", ["kk", 2], 0, function () {
            return this.hours() || 24;
        }),
        s("hmm", 0, 0, function () {
            return "" + oa.apply(this) + de(this.minutes(), 2);
        }),
        s("hmmss", 0, 0, function () {
            return (
                "" +
                oa.apply(this) +
                de(this.minutes(), 2) +
                de(this.seconds(), 2)
            );
        }),
        s("Hmm", 0, 0, function () {
            return "" + this.hours() + de(this.minutes(), 2);
        }),
        s("Hmmss", 0, 0, function () {
            return (
                "" +
                this.hours() +
                de(this.minutes(), 2) +
                de(this.seconds(), 2)
            );
        }),
        ma("a", !0),
        ma("A", !1),
        a("hour", "h"),
        t("hour", 13),
        p("a", ua),
        p("A", ua),
        p("H", o),
        p("h", o),
        p("k", o),
        p("HH", o, r),
        p("hh", o, r),
        p("kk", o, r),
        p("hmm", c),
        p("hmmss", L),
        p("Hmm", c),
        p("Hmmss", L),
        D(["H", "HH"], w),
        D(["k", "kk"], function (e, a, t) {
            e = m(e);
            a[w] = 24 === e ? 0 : e;
        }),
        D(["a", "A"], function (e, a, t) {
            (t._isPm = t._locale.isPM(e)), (t._meridiem = e);
        }),
        D(["h", "hh"], function (e, a, t) {
            (a[w] = m(e)), (h(t).bigHour = !0);
        }),
        D("hmm", function (e, a, t) {
            var s = e.length - 2;
            (a[w] = m(e.substr(0, s))),
                (a[Oe] = m(e.substr(s))),
                (h(t).bigHour = !0);
        }),
        D("hmmss", function (e, a, t) {
            var s = e.length - 4,
                n = e.length - 2;
            (a[w] = m(e.substr(0, s))),
                (a[Oe] = m(e.substr(s, 2))),
                (a[We] = m(e.substr(n))),
                (h(t).bigHour = !0);
        }),
        D("Hmm", function (e, a, t) {
            var s = e.length - 2;
            (a[w] = m(e.substr(0, s))), (a[Oe] = m(e.substr(s)));
        }),
        D("Hmmss", function (e, a, t) {
            var s = e.length - 4,
                n = e.length - 2;
            (a[w] = m(e.substr(0, s))),
                (a[Oe] = m(e.substr(s, 2))),
                (a[We] = m(e.substr(n)));
        });
    f = Ye("Hours", !0);
    var la,
        Ma = {
            calendar: {
                sameDay: "[Today at] LT",
                nextDay: "[Tomorrow at] LT",
                nextWeek: "dddd [at] LT",
                lastDay: "[Yesterday at] LT",
                lastWeek: "[Last] dddd [at] LT",
                sameElse: "L",
            },
            longDateFormat: {
                LTS: "h:mm:ss A",
                LT: "h:mm A",
                L: "MM/DD/YYYY",
                LL: "MMMM D, YYYY",
                LLL: "MMMM D, YYYY h:mm A",
                LLLL: "dddd, MMMM D, YYYY h:mm A",
            },
            invalidDate: "Invalid date",
            ordinal: "%d",
            dayOfMonthOrdinalParse: /\d{1,2}/,
            relativeTime: {
                future: "%s ago",
                past: "%s ago",
                s: "a few seconds",
                ss: "%d seconds",
                m: "a minute",
                mm: "%d minutes",
                h: "an hour",
                hh: "%d hours",
                d: "a day",
                dd: "%d days",
                w: "a week",
                ww: "%d weeks",
                M: "a month",
                MM: "%d months",
                y: "a year",
                yy: "%d years",
            },
            months: Ne,
            monthsShort: Je,
            week: { dow: 0, doy: 6 },
            weekdays: ta,
            weekdaysMin: na,
            weekdaysShort: sa,
            meridiemParse: /[ap]\.?m?\.?/i,
        },
        b = {},
        ha = {};
    function ca(e) {
        return e && e.toLowerCase().replace("_", "-");
    }
    function La(e) {
        for (var a, t, s, n, r = 0; r < e.length; ) {
            for (
                a = (n = ca(e[r]).split("-")).length,
                    t = (t = ca(e[r + 1])) ? t.split("-") : null;
                0 < a;

            ) {
                if ((s = Ya(n.slice(0, a).join("-")))) return s;
                if (
                    t &&
                    t.length >= a &&
                    (function (e, a) {
                        for (
                            var t = Math.min(e.length, a.length), s = 0;
                            s < t;
                            s += 1
                        )
                            if (e[s] !== a[s]) return s;
                        return t;
                    })(n, t) >=
                        a - 1
                )
                    break;
                a--;
            }
            r++;
        }
        return la;
    }
    function Ya(a) {
        var e;
        if (
            void 0 === b[a] &&
            "undefined" != typeof module &&
            module &&
            module.exports &&
            null != a.match("^[^/\\\\]*$")
        )
            try {
                (e = la._abbr), require("./locale/" + a), ya(e);
            } catch (e) {
                b[a] = null;
            }
        return b[a];
    }
    function ya(e, a) {
        return (
            e &&
                ((a = d(a) ? pa(e) : fa(e, a))
                    ? (la = a)
                    : "undefined" != typeof console &&
                      console.warn &&
                      console.warn(
                          "Locale " +
                              e +
                              " not found. Did you forget to load it?"
                      )),
            la._abbr
        );
    }
    function fa(e, a) {
        if (null === a) return delete b[e], null;
        var t,
            s = Ma;
        if (((a.abbr = e), null != b[e]))
            ae(
                "defineLocaleOverride",
                "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
            ),
                (s = b[e]._config);
        else if (null != a.parentLocale)
            if (null != b[a.parentLocale]) s = b[a.parentLocale]._config;
            else {
                if (null == (t = Ya(a.parentLocale)))
                    return (
                        ha[a.parentLocale] || (ha[a.parentLocale] = []),
                        ha[a.parentLocale].push({ name: e, config: a }),
                        null
                    );
                s = t._config;
            }
        return (
            (b[e] = new ne(se(s, a))),
            ha[e] &&
                ha[e].forEach(function (e) {
                    fa(e.name, e.config);
                }),
            ya(e),
            b[e]
        );
    }
    function pa(e) {
        var a;
        if (!(e = e && e._locale && e._locale._abbr ? e._locale._abbr : e))
            return la;
        if (!F(e)) {
            if ((a = Ya(e))) return a;
            e = [e];
        }
        return La(e);
    }
    function ka(e) {
        var a = e._a;
        return (
            a &&
                -2 === h(e).overflow &&
                ((a =
                    a[xe] < 0 || 11 < a[xe]
                        ? xe
                        : a[Pe] < 1 || a[Pe] > ze(a[g], a[xe])
                        ? Pe
                        : a[w] < 0 ||
                          24 < a[w] ||
                          (24 === a[w] &&
                              (0 !== a[Oe] || 0 !== a[We] || 0 !== a[Ae]))
                        ? w
                        : a[Oe] < 0 || 59 < a[Oe]
                        ? Oe
                        : a[We] < 0 || 59 < a[We]
                        ? We
                        : a[Ae] < 0 || 999 < a[Ae]
                        ? Ae
                        : -1),
                h(e)._overflowDayOfYear && (a < g || Pe < a) && (a = Pe),
                h(e)._overflowWeeks && -1 === a && (a = Ee),
                h(e)._overflowWeekday && -1 === a && (a = Fe),
                (h(e).overflow = a)),
            e
        );
    }
    var Da =
            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        Ta =
            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        ga = /Z|[+-]\d\d(?::?\d\d)?/,
        wa = [
            ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
            ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
            ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
            ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
            ["YYYY-DDD", /\d{4}-\d{3}/],
            ["YYYY-MM", /\d{4}-\d\d/, !1],
            ["YYYYYYMMDD", /[+-]\d{10}/],
            ["YYYYMMDD", /\d{8}/],
            ["GGGG[W]WWE", /\d{4}W\d{3}/],
            ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
            ["YYYYDDD", /\d{7}/],
            ["YYYYMM", /\d{6}/, !1],
            ["YYYY", /\d{4}/, !1],
        ],
        ba = [
            ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
            ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
            ["HH:mm:ss", /\d\d:\d\d:\d\d/],
            ["HH:mm", /\d\d:\d\d/],
            ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
            ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
            ["HHmmss", /\d\d\d\d\d\d/],
            ["HHmm", /\d\d\d\d/],
            ["HH", /\d\d/],
        ],
        Sa = /^\/?Date\((-?\d+)/i,
        Ha =
            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        va = {
            UT: 0,
            GMT: 0,
            EDT: -240,
            EST: -300,
            CDT: -300,
            CST: -360,
            MDT: -360,
            MST: -420,
            PDT: -420,
            PST: -480,
        };
    function ja(e) {
        var a,
            t,
            s,
            n,
            r,
            d,
            i = e._i,
            _ = Da.exec(i) || Ta.exec(i),
            i = wa.length,
            o = ba.length;
        if (_) {
            for (h(e).iso = !0, a = 0, t = i; a < t; a++)
                if (wa[a][1].exec(_[1])) {
                    (n = wa[a][0]), (s = !1 !== wa[a][2]);
                    break;
                }
            if (null == n) e._isValid = !1;
            else {
                if (_[3]) {
                    for (a = 0, t = o; a < t; a++)
                        if (ba[a][1].exec(_[3])) {
                            r = (_[2] || " ") + ba[a][0];
                            break;
                        }
                    if (null == r) return void (e._isValid = !1);
                }
                if (s || null == r) {
                    if (_[4]) {
                        if (!ga.exec(_[4])) return void (e._isValid = !1);
                        d = "Z";
                    }
                    (e._f = n + (r || "") + (d || "")), Aa(e);
                } else e._isValid = !1;
            }
        } else e._isValid = !1;
    }
    function xa(e, a, t, s, n, r) {
        e = [
            (function (e) {
                e = parseInt(e, 10);
                {
                    if (e <= 49) return 2e3 + e;
                    if (e <= 999) return 1900 + e;
                }
                return e;
            })(e),
            Je.indexOf(a),
            parseInt(t, 10),
            parseInt(s, 10),
            parseInt(n, 10),
        ];
        return r && e.push(parseInt(r, 10)), e;
    }
    function Pa(e) {
        var a,
            t,
            s,
            n,
            r = Ha.exec(
                e._i
                    .replace(/\([^()]*\)|[\n\t]/g, " ")
                    .replace(/(\s\s+)/g, " ")
                    .replace(/^\s\s*/, "")
                    .replace(/\s\s*$/, "")
            );
        r
            ? ((a = xa(r[4], r[3], r[2], r[5], r[6], r[7])),
              (t = r[1]),
              (s = a),
              (n = e),
              t && sa.indexOf(t) !== new Date(s[0], s[1], s[2]).getDay()
                  ? ((h(n).weekdayMismatch = !0), (n._isValid = !1))
                  : ((e._a = a),
                    (e._tzm =
                        ((t = r[8]),
                        (s = r[9]),
                        (n = r[10]),
                        t
                            ? va[t]
                            : s
                            ? 0
                            : 60 *
                                  (((t = parseInt(n, 10)) - (s = t % 100)) /
                                      100) +
                              s)),
                    (e._d = Ze.apply(null, e._a)),
                    e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm),
                    (h(e).rfc2822 = !0)))
            : (e._isValid = !1);
    }
    function Oa(e, a, t) {
        return null != e ? e : null != a ? a : t;
    }
    function Wa(e) {
        var a,
            t,
            s,
            n,
            r,
            d,
            i,
            _,
            o,
            m,
            u,
            l = [];
        if (!e._d) {
            for (
                s = e,
                    n = new Date(M.now()),
                    t = s._useUTC
                        ? [n.getUTCFullYear(), n.getUTCMonth(), n.getUTCDate()]
                        : [n.getFullYear(), n.getMonth(), n.getDate()],
                    e._w &&
                        null == e._a[Pe] &&
                        null == e._a[xe] &&
                        (null != (n = (s = e)._w).GG ||
                        null != n.W ||
                        null != n.E
                            ? ((_ = 1),
                              (o = 4),
                              (r = Oa(n.GG, s._a[g], Xe(S(), 1, 4).year)),
                              (d = Oa(n.W, 1)),
                              ((i = Oa(n.E, 1)) < 1 || 7 < i) && (m = !0))
                            : ((_ = s._locale._week.dow),
                              (o = s._locale._week.doy),
                              (u = Xe(S(), _, o)),
                              (r = Oa(n.gg, s._a[g], u.year)),
                              (d = Oa(n.w, u.week)),
                              null != n.d
                                  ? ((i = n.d) < 0 || 6 < i) && (m = !0)
                                  : null != n.e
                                  ? ((i = n.e + _),
                                    (n.e < 0 || 6 < n.e) && (m = !0))
                                  : (i = _)),
                        d < 1 || d > ea(r, _, o)
                            ? (h(s)._overflowWeeks = !0)
                            : null != m
                            ? (h(s)._overflowWeekday = !0)
                            : ((u = Qe(r, d, i, _, o)),
                              (s._a[g] = u.year),
                              (s._dayOfYear = u.dayOfYear))),
                    null != e._dayOfYear &&
                        ((n = Oa(e._a[g], t[g])),
                        (e._dayOfYear > Be(n) || 0 === e._dayOfYear) &&
                            (h(e)._overflowDayOfYear = !0),
                        (m = Ze(n, 0, e._dayOfYear)),
                        (e._a[xe] = m.getUTCMonth()),
                        (e._a[Pe] = m.getUTCDate())),
                    a = 0;
                a < 3 && null == e._a[a];
                ++a
            )
                e._a[a] = l[a] = t[a];
            for (; a < 7; a++)
                e._a[a] = l[a] = null == e._a[a] ? (2 === a ? 1 : 0) : e._a[a];
            24 === e._a[w] &&
                0 === e._a[Oe] &&
                0 === e._a[We] &&
                0 === e._a[Ae] &&
                ((e._nextDay = !0), (e._a[w] = 0)),
                (e._d = (e._useUTC ? Ze : qe).apply(null, l)),
                (r = e._useUTC ? e._d.getUTCDay() : e._d.getDay()),
                null != e._tzm &&
                    e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm),
                e._nextDay && (e._a[w] = 24),
                e._w &&
                    void 0 !== e._w.d &&
                    e._w.d !== r &&
                    (h(e).weekdayMismatch = !0);
        }
    }
    function Aa(e) {
        if (e._f === M.ISO_8601) ja(e);
        else if (e._f === M.RFC_2822) Pa(e);
        else {
            (e._a = []), (h(e).empty = !0);
            for (
                var a,
                    t,
                    s,
                    n,
                    r,
                    d = "" + e._i,
                    i = d.length,
                    _ = 0,
                    o = le(e._f, e._locale).match(ie) || [],
                    m = o.length,
                    u = 0;
                u < m;
                u++
            )
                (t = o[u]),
                    (a = (d.match(Se(t, e)) || [])[0]) &&
                        (0 < (s = d.substr(0, d.indexOf(a))).length &&
                            h(e).unusedInput.push(s),
                        (d = d.slice(d.indexOf(a) + a.length)),
                        (_ += a.length)),
                    me[t]
                        ? (a ? (h(e).empty = !1) : h(e).unusedTokens.push(t),
                          (s = t),
                          (r = e),
                          null != (n = a) && l(ve, s) && ve[s](n, r._a, r, s))
                        : e._strict && !a && h(e).unusedTokens.push(t);
            (h(e).charsLeftOver = i - _),
                0 < d.length && h(e).unusedInput.push(d),
                e._a[w] <= 12 &&
                    !0 === h(e).bigHour &&
                    0 < e._a[w] &&
                    (h(e).bigHour = void 0),
                (h(e).parsedDateParts = e._a.slice(0)),
                (h(e).meridiem = e._meridiem),
                (e._a[w] = (function (e, a, t) {
                    if (null == t) return a;
                    return null != e.meridiemHour
                        ? e.meridiemHour(a, t)
                        : null != e.isPM
                        ? ((e = e.isPM(t)) && a < 12 && (a += 12),
                          (a = e || 12 !== a ? a : 0))
                        : a;
                })(e._locale, e._a[w], e._meridiem)),
                null !== (i = h(e).era) &&
                    (e._a[g] = e._locale.erasConvertYear(i, e._a[g])),
                Wa(e),
                ka(e);
        }
    }
    function Ea(e) {
        var a,
            t,
            s,
            n = e._i,
            r = e._f;
        if (
            ((e._locale = e._locale || pa(e._l)),
            null === n || (void 0 === r && "" === n))
        )
            return V({ nullInput: !0 });
        if (("string" == typeof n && (e._i = n = e._locale.preparse(n)), Q(n)))
            return new $(ka(n));
        if (R(n)) e._d = n;
        else if (F(r))
            !(function (e) {
                var a,
                    t,
                    s,
                    n,
                    r,
                    d,
                    i = !1,
                    _ = e._f.length;
                if (0 === _)
                    return (h(e).invalidFormat = !0), (e._d = new Date(NaN));
                for (n = 0; n < _; n++)
                    (r = 0),
                        (d = !1),
                        (a = Z({}, e)),
                        null != e._useUTC && (a._useUTC = e._useUTC),
                        (a._f = e._f[n]),
                        Aa(a),
                        G(a) && (d = !0),
                        (r =
                            (r += h(a).charsLeftOver) +
                            10 * h(a).unusedTokens.length),
                        (h(a).score = r),
                        i
                            ? r < s && ((s = r), (t = a))
                            : (null == s || r < s || d) &&
                              ((s = r), (t = a), d && (i = !0));
                I(e, t || a);
            })(e);
        else if (r) Aa(e);
        else if (d((r = (n = e)._i))) n._d = new Date(M.now());
        else
            R(r)
                ? (n._d = new Date(r.valueOf()))
                : "string" == typeof r
                ? ((t = n),
                  null !== (a = Sa.exec(t._i))
                      ? (t._d = new Date(+a[1]))
                      : (ja(t),
                        !1 === t._isValid &&
                            (delete t._isValid,
                            Pa(t),
                            !1 === t._isValid &&
                                (delete t._isValid,
                                t._strict
                                    ? (t._isValid = !1)
                                    : M.createFromInputFallback(t)))))
                : F(r)
                ? ((n._a = C(r.slice(0), function (e) {
                      return parseInt(e, 10);
                  })),
                  Wa(n))
                : z(r)
                ? (a = n)._d ||
                  ((s = void 0 === (t = he(a._i)).day ? t.date : t.day),
                  (a._a = C(
                      [
                          t.year,
                          t.month,
                          s,
                          t.hour,
                          t.minute,
                          t.second,
                          t.millisecond,
                      ],
                      function (e) {
                          return e && parseInt(e, 10);
                      }
                  )),
                  Wa(a))
                : J(r)
                ? (n._d = new Date(r))
                : M.createFromInputFallback(n);
        return G(e) || (e._d = null), e;
    }
    function Fa(e, a, t, s, n) {
        var r = {};
        return (
            (!0 !== a && !1 !== a) || ((s = a), (a = void 0)),
            (!0 !== t && !1 !== t) || ((s = t), (t = void 0)),
            ((z(e) && N(e)) || (F(e) && 0 === e.length)) && (e = void 0),
            (r._isAMomentObject = !0),
            (r._useUTC = r._isUTC = n),
            (r._l = t),
            (r._i = e),
            (r._f = a),
            (r._strict = s),
            (n = new $(ka(Ea((n = r)))))._nextDay &&
                (n.add(1, "d"), (n._nextDay = void 0)),
            n
        );
    }
    function S(e, a, t, s) {
        return Fa(e, a, t, s, !1);
    }
    (M.createFromInputFallback = e(
        "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
        function (e) {
            e._d = new Date(e._i + (e._useUTC ? " UTC" : ""));
        }
    )),
        (M.ISO_8601 = function () {}),
        (M.RFC_2822 = function () {});
    (c = e(
        "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
        function () {
            var e = S.apply(null, arguments);
            return this.isValid() && e.isValid() ? (e < this ? this : e) : V();
        }
    )),
        (L = e(
            "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
            function () {
                var e = S.apply(null, arguments);
                return this.isValid() && e.isValid()
                    ? this < e
                        ? this
                        : e
                    : V();
            }
        ));
    function za(e, a) {
        var t, s;
        if (!(a = 1 === a.length && F(a[0]) ? a[0] : a).length) return S();
        for (t = a[0], s = 1; s < a.length; ++s)
            (a[s].isValid() && !a[s][e](t)) || (t = a[s]);
        return t;
    }
    var Na = [
        "year",
        "quarter",
        "month",
        "week",
        "day",
        "hour",
        "minute",
        "second",
        "millisecond",
    ];
    function Ja(e) {
        var e = he(e),
            a = e.year || 0,
            t = e.quarter || 0,
            s = e.month || 0,
            n = e.week || e.isoWeek || 0,
            r = e.day || 0,
            d = e.hour || 0,
            i = e.minute || 0,
            _ = e.second || 0,
            o = e.millisecond || 0;
        (this._isValid = (function (e) {
            var a,
                t,
                s = !1,
                n = Na.length;
            for (a in e)
                if (
                    l(e, a) &&
                    (-1 === T.call(Na, a) || (null != e[a] && isNaN(e[a])))
                )
                    return !1;
            for (t = 0; t < n; ++t)
                if (e[Na[t]]) {
                    if (s) return !1;
                    parseFloat(e[Na[t]]) !== m(e[Na[t]]) && (s = !0);
                }
            return !0;
        })(e)),
            (this._milliseconds = +o + 1e3 * _ + 6e4 * i + 1e3 * d * 60 * 60),
            (this._days = +r + 7 * n),
            (this._months = +s + 3 * t + 12 * a),
            (this._data = {}),
            (this._locale = pa()),
            this._bubble();
    }
    function Ra(e) {
        return e instanceof Ja;
    }
    function Ca(e) {
        return e < 0 ? -1 * Math.round(-1 * e) : Math.round(e);
    }
    function Ia(e, t) {
        s(e, 0, 0, function () {
            var e = this.utcOffset(),
                a = "+";
            return (
                e < 0 && ((e = -e), (a = "-")),
                a + de(~~(e / 60), 2) + t + de(~~e % 60, 2)
            );
        });
    }
    Ia("Z", ":"),
        Ia("ZZ", ""),
        p("Z", be),
        p("ZZ", be),
        D(["Z", "ZZ"], function (e, a, t) {
            (t._useUTC = !0), (t._tzm = Ga(be, e));
        });
    var Ua = /([\+\-]|\d\d)/gi;
    function Ga(e, a) {
        var a = (a || "").match(e);
        return null === a
            ? null
            : 0 ===
              (a =
                  60 *
                      (e = ((a[a.length - 1] || []) + "").match(Ua) || [
                          "-",
                          0,
                          0,
                      ])[1] +
                  m(e[2]))
            ? 0
            : "+" === e[0]
            ? a
            : -a;
    }
    function Va(e, a) {
        var t;
        return a._isUTC
            ? ((a = a.clone()),
              (t = (Q(e) || R(e) ? e : S(e)).valueOf() - a.valueOf()),
              a._d.setTime(a._d.valueOf() + t),
              M.updateOffset(a, !1),
              a)
            : S(e).local();
    }
    function Ba(e) {
        return -Math.round(e._d.getTimezoneOffset());
    }
    function Ka() {
        return !!this.isValid() && this._isUTC && 0 === this._offset;
    }
    M.updateOffset = function () {};
    var qa = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        Za =
            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function $a(e, a) {
        var t,
            s = e,
            n = null;
        return (
            Ra(e)
                ? (s = { ms: e._milliseconds, d: e._days, M: e._months })
                : J(e) || !isNaN(+e)
                ? ((s = {}), a ? (s[a] = +e) : (s.milliseconds = +e))
                : (n = qa.exec(e))
                ? ((t = "-" === n[1] ? -1 : 1),
                  (s = {
                      y: 0,
                      d: m(n[Pe]) * t,
                      h: m(n[w]) * t,
                      m: m(n[Oe]) * t,
                      s: m(n[We]) * t,
                      ms: m(Ca(1e3 * n[Ae])) * t,
                  }))
                : (n = Za.exec(e))
                ? ((t = "-" === n[1] ? -1 : 1),
                  (s = {
                      y: Qa(n[2], t),
                      M: Qa(n[3], t),
                      w: Qa(n[4], t),
                      d: Qa(n[5], t),
                      h: Qa(n[6], t),
                      m: Qa(n[7], t),
                      s: Qa(n[8], t),
                  }))
                : null == s
                ? (s = {})
                : "object" == typeof s &&
                  ("from" in s || "to" in s) &&
                  ((a = (function (e, a) {
                      var t;
                      if (!e.isValid() || !a.isValid())
                          return { milliseconds: 0, months: 0 };
                      (a = Va(a, e)),
                          e.isBefore(a)
                              ? (t = Xa(e, a))
                              : (((t = Xa(a, e)).milliseconds =
                                    -t.milliseconds),
                                (t.months = -t.months));
                      return t;
                  })(S(s.from), S(s.to))),
                  ((s = {}).ms = a.milliseconds),
                  (s.M = a.months)),
            (n = new Ja(s)),
            Ra(e) && l(e, "_locale") && (n._locale = e._locale),
            Ra(e) && l(e, "_isValid") && (n._isValid = e._isValid),
            n
        );
    }
    function Qa(e, a) {
        e = e && parseFloat(e.replace(",", "."));
        return (isNaN(e) ? 0 : e) * a;
    }
    function Xa(e, a) {
        var t = {};
        return (
            (t.months = a.month() - e.month() + 12 * (a.year() - e.year())),
            e.clone().add(t.months, "M").isAfter(a) && --t.months,
            (t.milliseconds = +a - +e.clone().add(t.months, "M")),
            t
        );
    }
    function et(s, n) {
        return function (e, a) {
            var t;
            return (
                null === a ||
                    isNaN(+a) ||
                    (ae(
                        n,
                        "moment()." +
                            n +
                            "(period, number) is deprecated. Please use moment()." +
                            n +
                            "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
                    ),
                    (t = e),
                    (e = a),
                    (a = t)),
                at(this, $a(e, a), s),
                this
            );
        };
    }
    function at(e, a, t, s) {
        var n = a._milliseconds,
            r = Ca(a._days),
            a = Ca(a._months);
        e.isValid() &&
            ((s = null == s || s),
            a && Ue(e, ye(e, "Month") + a * t),
            r && fe(e, "Date", ye(e, "Date") + r * t),
            n && e._d.setTime(e._d.valueOf() + n * t),
            s && M.updateOffset(e, r || a));
    }
    ($a.fn = Ja.prototype),
        ($a.invalid = function () {
            return $a(NaN);
        });
    (Ne = et(1, "add")), (ta = et(-1, "subtract"));
    function tt(e) {
        return "string" == typeof e || e instanceof String;
    }
    function st(e) {
        return (
            Q(e) ||
            R(e) ||
            tt(e) ||
            J(e) ||
            (function (a) {
                var e = F(a),
                    t = !1;
                e &&
                    (t =
                        0 ===
                        a.filter(function (e) {
                            return !J(e) && tt(a);
                        }).length);
                return e && t;
            })(e) ||
            (function (e) {
                var a,
                    t,
                    s = z(e) && !N(e),
                    n = !1,
                    r = [
                        "years",
                        "year",
                        "y",
                        "months",
                        "month",
                        "M",
                        "days",
                        "day",
                        "d",
                        "dates",
                        "date",
                        "D",
                        "hours",
                        "hour",
                        "h",
                        "minutes",
                        "minute",
                        "m",
                        "seconds",
                        "second",
                        "s",
                        "milliseconds",
                        "millisecond",
                        "ms",
                    ],
                    d = r.length;
                for (a = 0; a < d; a += 1) (t = r[a]), (n = n || l(e, t));
                return s && n;
            })(e) ||
            null == e
        );
    }
    function nt(e, a) {
        if (e.date() < a.date()) return -nt(a, e);
        var t = 12 * (a.year() - e.year()) + (a.month() - e.month()),
            s = e.clone().add(t, "months"),
            a =
                a - s < 0
                    ? (a - s) / (s - e.clone().add(t - 1, "months"))
                    : (a - s) / (e.clone().add(1 + t, "months") - s);
        return -(t + a) || 0;
    }
    function rt(e) {
        return void 0 === e
            ? this._locale._abbr
            : (null != (e = pa(e)) && (this._locale = e), this);
    }
    (M.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ"),
        (M.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]");
    na = e(
        "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
        function (e) {
            return void 0 === e ? this.localeData() : this.locale(e);
        }
    );
    function dt() {
        return this._locale;
    }
    var it = 126227808e5;
    function _t(e, a) {
        return ((e % a) + a) % a;
    }
    function ot(e, a, t) {
        return e < 100 && 0 <= e
            ? new Date(e + 400, a, t) - it
            : new Date(e, a, t).valueOf();
    }
    function mt(e, a, t) {
        return e < 100 && 0 <= e
            ? Date.UTC(e + 400, a, t) - it
            : Date.UTC(e, a, t);
    }
    function ut(e, a) {
        return a.erasAbbrRegex(e);
    }
    function lt() {
        for (
            var e = [],
                a = [],
                t = [],
                s = [],
                n = this.eras(),
                r = 0,
                d = n.length;
            r < d;
            ++r
        )
            a.push(k(n[r].name)),
                e.push(k(n[r].abbr)),
                t.push(k(n[r].narrow)),
                s.push(k(n[r].name)),
                s.push(k(n[r].abbr)),
                s.push(k(n[r].narrow));
        (this._erasRegex = new RegExp("^(" + s.join("|") + ")", "i")),
            (this._erasNameRegex = new RegExp("^(" + a.join("|") + ")", "i")),
            (this._erasAbbrRegex = new RegExp("^(" + e.join("|") + ")", "i")),
            (this._erasNarrowRegex = new RegExp("^(" + t.join("|") + ")", "i"));
    }
    function Mt(e, a) {
        s(0, [e, e.length], 0, a);
    }
    function ht(e, a, t, s, n) {
        var r;
        return null == e
            ? Xe(this, s, n).year
            : ((r = ea(e, s, n)),
              function (e, a, t, s, n) {
                  (e = Qe(e, a, t, s, n)), (a = Ze(e.year, 0, e.dayOfYear));
                  return (
                      this.year(a.getUTCFullYear()),
                      this.month(a.getUTCMonth()),
                      this.date(a.getUTCDate()),
                      this
                  );
              }.call(this, e, (a = r < a ? r : a), t, s, n));
    }
    s("N", 0, 0, "eraAbbr"),
        s("NN", 0, 0, "eraAbbr"),
        s("NNN", 0, 0, "eraAbbr"),
        s("NNNN", 0, 0, "eraName"),
        s("NNNNN", 0, 0, "eraNarrow"),
        s("y", ["y", 1], "yo", "eraYear"),
        s("y", ["yy", 2], 0, "eraYear"),
        s("y", ["yyy", 3], 0, "eraYear"),
        s("y", ["yyyy", 4], 0, "eraYear"),
        p("N", ut),
        p("NN", ut),
        p("NNN", ut),
        p("NNNN", function (e, a) {
            return a.erasNameRegex(e);
        }),
        p("NNNNN", function (e, a) {
            return a.erasNarrowRegex(e);
        }),
        D(["N", "NN", "NNN", "NNNN", "NNNNN"], function (e, a, t, s) {
            s = t._locale.erasParse(e, s, t._strict);
            s ? (h(t).era = s) : (h(t).invalidEra = e);
        }),
        p("y", Te),
        p("yy", Te),
        p("yyy", Te),
        p("yyyy", Te),
        p("yo", function (e, a) {
            return a._eraYearOrdinalRegex || Te;
        }),
        D(["y", "yy", "yyy", "yyyy"], g),
        D(["yo"], function (e, a, t, s) {
            var n;
            t._locale._eraYearOrdinalRegex &&
                (n = e.match(t._locale._eraYearOrdinalRegex)),
                t._locale.eraYearOrdinalParse
                    ? (a[g] = t._locale.eraYearOrdinalParse(e, n))
                    : (a[g] = parseInt(e, 10));
        }),
        s(0, ["gg", 2], 0, function () {
            return this.weekYear() % 100;
        }),
        s(0, ["GG", 2], 0, function () {
            return this.isoWeekYear() % 100;
        }),
        Mt("gggg", "weekYear"),
        Mt("ggggg", "weekYear"),
        Mt("GGGG", "isoWeekYear"),
        Mt("GGGGG", "isoWeekYear"),
        a("weekYear", "gg"),
        a("isoWeekYear", "GG"),
        t("weekYear", 1),
        t("isoWeekYear", 1),
        p("G", ge),
        p("g", ge),
        p("GG", o, r),
        p("gg", o, r),
        p("GGGG", Y, ke),
        p("gggg", Y, ke),
        p("GGGGG", y, _),
        p("ggggg", y, _),
        je(["gggg", "ggggg", "GGGG", "GGGGG"], function (e, a, t, s) {
            a[s.substr(0, 2)] = m(e);
        }),
        je(["gg", "GG"], function (e, a, t, s) {
            a[s] = M.parseTwoDigitYear(e);
        }),
        s("Q", 0, "Qo", "quarter"),
        a("quarter", "Q"),
        t("quarter", 7),
        p("Q", n),
        D("Q", function (e, a) {
            a[xe] = 3 * (m(e) - 1);
        }),
        s("D", ["DD", 2], "Do", "date"),
        a("date", "D"),
        t("date", 9),
        p("D", o),
        p("DD", o, r),
        p("Do", function (e, a) {
            return e
                ? a._dayOfMonthOrdinalParse || a._ordinalParse
                : a._dayOfMonthOrdinalParseLenient;
        }),
        D(["D", "DD"], Pe),
        D("Do", function (e, a) {
            a[Pe] = m(e.match(o)[0]);
        });
    Y = Ye("Date", !0);
    s("DDD", ["DDDD", 3], "DDDo", "dayOfYear"),
        a("dayOfYear", "DDD"),
        t("dayOfYear", 4),
        p("DDD", De),
        p("DDDD", pe),
        D(["DDD", "DDDD"], function (e, a, t) {
            t._dayOfYear = m(e);
        }),
        s("m", ["mm", 2], 0, "minute"),
        a("minute", "m"),
        t("minute", 14),
        p("m", o),
        p("mm", o, r),
        D(["m", "mm"], Oe);
    var ct,
        ke = Ye("Minutes", !1),
        y =
            (s("s", ["ss", 2], 0, "second"),
            a("second", "s"),
            t("second", 15),
            p("s", o),
            p("ss", o, r),
            D(["s", "ss"], We),
            Ye("Seconds", !1));
    for (
        s("S", 0, 0, function () {
            return ~~(this.millisecond() / 100);
        }),
            s(0, ["SS", 2], 0, function () {
                return ~~(this.millisecond() / 10);
            }),
            s(0, ["SSS", 3], 0, "millisecond"),
            s(0, ["SSSS", 4], 0, function () {
                return 10 * this.millisecond();
            }),
            s(0, ["SSSSS", 5], 0, function () {
                return 100 * this.millisecond();
            }),
            s(0, ["SSSSSS", 6], 0, function () {
                return 1e3 * this.millisecond();
            }),
            s(0, ["SSSSSSS", 7], 0, function () {
                return 1e4 * this.millisecond();
            }),
            s(0, ["SSSSSSSS", 8], 0, function () {
                return 1e5 * this.millisecond();
            }),
            s(0, ["SSSSSSSSS", 9], 0, function () {
                return 1e6 * this.millisecond();
            }),
            a("millisecond", "ms"),
            t("millisecond", 16),
            p("S", De, n),
            p("SS", De, r),
            p("SSS", De, pe),
            ct = "SSSS";
        ct.length <= 9;
        ct += "S"
    )
        p(ct, Te);
    function Lt(e, a) {
        a[Ae] = m(1e3 * ("0." + e));
    }
    for (ct = "S"; ct.length <= 9; ct += "S") D(ct, Lt);
    (_ = Ye("Milliseconds", !1)),
        s("z", 0, 0, "zoneAbbr"),
        s("zz", 0, 0, "zoneName");
    n = $.prototype;
    function Yt(e) {
        return e;
    }
    (n.add = Ne),
        (n.calendar = function (e, a) {
            1 === arguments.length &&
                (arguments[0]
                    ? st(arguments[0])
                        ? ((e = arguments[0]), (a = void 0))
                        : (function (e) {
                              for (
                                  var a = z(e) && !N(e),
                                      t = !1,
                                      s = [
                                          "sameDay",
                                          "nextDay",
                                          "lastDay",
                                          "nextWeek",
                                          "lastWeek",
                                          "sameElse",
                                      ],
                                      n = 0;
                                  n < s.length;
                                  n += 1
                              )
                                  t = t || l(e, s[n]);
                              return a && t;
                          })(arguments[0]) && ((a = arguments[0]), (e = void 0))
                    : (a = e = void 0));
            var e = e || S(),
                t = Va(e, this).startOf("day"),
                t = M.calendarFormat(this, t) || "sameElse",
                a = a && (te(a[t]) ? a[t].call(this, e) : a[t]);
            return this.format(a || this.localeData().calendar(t, this, S(e)));
        }),
        (n.clone = function () {
            return new $(this);
        }),
        (n.diff = function (e, a, t) {
            var s, n, r;
            if (!this.isValid()) return NaN;
            if (!(s = Va(e, this)).isValid()) return NaN;
            switch (
                ((n = 6e4 * (s.utcOffset() - this.utcOffset())), (a = i(a)))
            ) {
                case "year":
                    r = nt(this, s) / 12;
                    break;
                case "month":
                    r = nt(this, s);
                    break;
                case "quarter":
                    r = nt(this, s) / 3;
                    break;
                case "second":
                    r = (this - s) / 1e3;
                    break;
                case "minute":
                    r = (this - s) / 6e4;
                    break;
                case "hour":
                    r = (this - s) / 36e5;
                    break;
                case "day":
                    r = (this - s - n) / 864e5;
                    break;
                case "week":
                    r = (this - s - n) / 6048e5;
                    break;
                default:
                    r = this - s;
            }
            return t ? r : u(r);
        }),
        (n.endOf = function (e) {
            var a, t;
            if (void 0 === (e = i(e)) || "millisecond" === e || !this.isValid())
                return this;
            switch (((t = this._isUTC ? mt : ot), e)) {
                case "year":
                    a = t(this.year() + 1, 0, 1) - 1;
                    break;
                case "quarter":
                    a =
                        t(
                            this.year(),
                            this.month() - (this.month() % 3) + 3,
                            1
                        ) - 1;
                    break;
                case "month":
                    a = t(this.year(), this.month() + 1, 1) - 1;
                    break;
                case "week":
                    a =
                        t(
                            this.year(),
                            this.month(),
                            this.date() - this.weekday() + 7
                        ) - 1;
                    break;
                case "isoWeek":
                    a =
                        t(
                            this.year(),
                            this.month(),
                            this.date() - (this.isoWeekday() - 1) + 7
                        ) - 1;
                    break;
                case "day":
                case "date":
                    a = t(this.year(), this.month(), this.date() + 1) - 1;
                    break;
                case "hour":
                    (a = this._d.valueOf()),
                        (a +=
                            36e5 -
                            _t(
                                a + (this._isUTC ? 0 : 6e4 * this.utcOffset()),
                                36e5
                            ) -
                            1);
                    break;
                case "minute":
                    (a = this._d.valueOf()), (a += 6e4 - _t(a, 6e4) - 1);
                    break;
                case "second":
                    (a = this._d.valueOf()), (a += 1e3 - _t(a, 1e3) - 1);
                    break;
            }
            return this._d.setTime(a), M.updateOffset(this, !0), this;
        }),
        (n.format = function (e) {
            return (
                (e =
                    e || (this.isUtc() ? M.defaultFormatUtc : M.defaultFormat)),
                (e = ue(this, e)),
                this.localeData().postformat(e)
            );
        }),
        (n.from = function (e, a) {
            return this.isValid() && ((Q(e) && e.isValid()) || S(e).isValid())
                ? $a({ to: this, from: e }).locale(this.locale()).humanize(!a)
                : this.localeData().invalidDate();
        }),
        (n.fromNow = function (e) {
            return this.from(S(), e);
        }),
        (n.to = function (e, a) {
            return this.isValid() && ((Q(e) && e.isValid()) || S(e).isValid())
                ? $a({ from: this, to: e }).locale(this.locale()).humanize(!a)
                : this.localeData().invalidDate();
        }),
        (n.toNow = function (e) {
            return this.to(S(), e);
        }),
        (n.get = function (e) {
            return te(this[(e = i(e))]) ? this[e]() : this;
        }),
        (n.invalidAt = function () {
            return h(this).overflow;
        }),
        (n.isAfter = function (e, a) {
            return (
                (e = Q(e) ? e : S(e)),
                !(!this.isValid() || !e.isValid()) &&
                    ("millisecond" === (a = i(a) || "millisecond")
                        ? this.valueOf() > e.valueOf()
                        : e.valueOf() < this.clone().startOf(a).valueOf())
            );
        }),
        (n.isBefore = function (e, a) {
            return (
                (e = Q(e) ? e : S(e)),
                !(!this.isValid() || !e.isValid()) &&
                    ("millisecond" === (a = i(a) || "millisecond")
                        ? this.valueOf() < e.valueOf()
                        : this.clone().endOf(a).valueOf() < e.valueOf())
            );
        }),
        (n.isBetween = function (e, a, t, s) {
            return (
                (e = Q(e) ? e : S(e)),
                (a = Q(a) ? a : S(a)),
                !!(this.isValid() && e.isValid() && a.isValid()) &&
                    ("(" === (s = s || "()")[0]
                        ? this.isAfter(e, t)
                        : !this.isBefore(e, t)) &&
                    (")" === s[1] ? this.isBefore(a, t) : !this.isAfter(a, t))
            );
        }),
        (n.isSame = function (e, a) {
            var e = Q(e) ? e : S(e);
            return (
                !(!this.isValid() || !e.isValid()) &&
                ("millisecond" === (a = i(a) || "millisecond")
                    ? this.valueOf() === e.valueOf()
                    : ((e = e.valueOf()),
                      this.clone().startOf(a).valueOf() <= e &&
                          e <= this.clone().endOf(a).valueOf()))
            );
        }),
        (n.isSameOrAfter = function (e, a) {
            return this.isSame(e, a) || this.isAfter(e, a);
        }),
        (n.isSameOrBefore = function (e, a) {
            return this.isSame(e, a) || this.isBefore(e, a);
        }),
        (n.isValid = function () {
            return G(this);
        }),
        (n.lang = na),
        (n.locale = rt),
        (n.localeData = dt),
        (n.max = L),
        (n.min = c),
        (n.parsingFlags = function () {
            return I({}, h(this));
        }),
        (n.set = function (e, a) {
            if ("object" == typeof e)
                for (
                    var t = (function (e) {
                            var a,
                                t = [];
                            for (a in e)
                                l(e, a) && t.push({ unit: a, priority: ce[a] });
                            return (
                                t.sort(function (e, a) {
                                    return e.priority - a.priority;
                                }),
                                t
                            );
                        })((e = he(e))),
                        s = t.length,
                        n = 0;
                    n < s;
                    n++
                )
                    this[t[n].unit](e[t[n].unit]);
            else if (te(this[(e = i(e))])) return this[e](a);
            return this;
        }),
        (n.startOf = function (e) {
            var a, t;
            if (void 0 === (e = i(e)) || "millisecond" === e || !this.isValid())
                return this;
            switch (((t = this._isUTC ? mt : ot), e)) {
                case "year":
                    a = t(this.year(), 0, 1);
                    break;
                case "quarter":
                    a = t(this.year(), this.month() - (this.month() % 3), 1);
                    break;
                case "month":
                    a = t(this.year(), this.month(), 1);
                    break;
                case "week":
                    a = t(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday()
                    );
                    break;
                case "isoWeek":
                    a = t(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1)
                    );
                    break;
                case "day":
                case "date":
                    a = t(this.year(), this.month(), this.date());
                    break;
                case "hour":
                    (a = this._d.valueOf()),
                        (a -= _t(
                            a + (this._isUTC ? 0 : 6e4 * this.utcOffset()),
                            36e5
                        ));
                    break;
                case "minute":
                    (a = this._d.valueOf()), (a -= _t(a, 6e4));
                    break;
                case "second":
                    (a = this._d.valueOf()), (a -= _t(a, 1e3));
                    break;
            }
            return this._d.setTime(a), M.updateOffset(this, !0), this;
        }),
        (n.subtract = ta),
        (n.toArray = function () {
            var e = this;
            return [
                e.year(),
                e.month(),
                e.date(),
                e.hour(),
                e.minute(),
                e.second(),
                e.millisecond(),
            ];
        }),
        (n.toObject = function () {
            var e = this;
            return {
                years: e.year(),
                months: e.month(),
                date: e.date(),
                hours: e.hours(),
                minutes: e.minutes(),
                seconds: e.seconds(),
                milliseconds: e.milliseconds(),
            };
        }),
        (n.toDate = function () {
            return new Date(this.valueOf());
        }),
        (n.toISOString = function (e) {
            if (!this.isValid()) return null;
            var a = (e = !0 !== e) ? this.clone().utc() : this;
            return a.year() < 0 || 9999 < a.year()
                ? ue(
                      a,
                      e
                          ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]"
                          : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
                  )
                : te(Date.prototype.toISOString)
                ? e
                    ? this.toDate().toISOString()
                    : new Date(this.valueOf() + 60 * this.utcOffset() * 1e3)
                          .toISOString()
                          .replace("Z", ue(a, "Z"))
                : ue(
                      a,
                      e
                          ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]"
                          : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
                  );
        }),
        (n.inspect = function () {
            if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
            var e,
                a = "moment",
                t = "";
            return (
                this.isLocal() ||
                    ((a =
                        0 === this.utcOffset()
                            ? "moment.utc"
                            : "moment.parseZone"),
                    (t = "Z")),
                (a = "[" + a + '("]'),
                (e =
                    0 <= this.year() && this.year() <= 9999
                        ? "YYYY"
                        : "YYYYYY"),
                this.format(a + e + "-MM-DD[T]HH:mm:ss.SSS" + (t + '[")]'))
            );
        }),
        "undefined" != typeof Symbol &&
            null != Symbol.for &&
            (n[Symbol.for("nodejs.util.inspect.custom")] = function () {
                return "Moment<" + this.format() + ">";
            }),
        (n.toJSON = function () {
            return this.isValid() ? this.toISOString() : null;
        }),
        (n.toString = function () {
            return this.clone()
                .locale("en")
                .format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
        }),
        (n.unix = function () {
            return Math.floor(this.valueOf() / 1e3);
        }),
        (n.valueOf = function () {
            return this._d.valueOf() - 6e4 * (this._offset || 0);
        }),
        (n.creationData = function () {
            return {
                input: this._i,
                format: this._f,
                locale: this._locale,
                isUTC: this._isUTC,
                strict: this._strict,
            };
        }),
        (n.eraName = function () {
            for (
                var e, a = this.localeData().eras(), t = 0, s = a.length;
                t < s;
                ++t
            ) {
                if (
                    ((e = this.clone().startOf("day").valueOf()),
                    a[t].since <= e && e <= a[t].until)
                )
                    return a[t].name;
                if (a[t].until <= e && e <= a[t].since) return a[t].name;
            }
            return "";
        }),
        (n.eraNarrow = function () {
            for (
                var e, a = this.localeData().eras(), t = 0, s = a.length;
                t < s;
                ++t
            ) {
                if (
                    ((e = this.clone().startOf("day").valueOf()),
                    a[t].since <= e && e <= a[t].until)
                )
                    return a[t].narrow;
                if (a[t].until <= e && e <= a[t].since) return a[t].narrow;
            }
            return "";
        }),
        (n.eraAbbr = function () {
            for (
                var e, a = this.localeData().eras(), t = 0, s = a.length;
                t < s;
                ++t
            ) {
                if (
                    ((e = this.clone().startOf("day").valueOf()),
                    a[t].since <= e && e <= a[t].until)
                )
                    return a[t].abbr;
                if (a[t].until <= e && e <= a[t].since) return a[t].abbr;
            }
            return "";
        }),
        (n.eraYear = function () {
            for (
                var e, a, t = this.localeData().eras(), s = 0, n = t.length;
                s < n;
                ++s
            )
                if (
                    ((e = t[s].since <= t[s].until ? 1 : -1),
                    (a = this.clone().startOf("day").valueOf()),
                    (t[s].since <= a && a <= t[s].until) ||
                        (t[s].until <= a && a <= t[s].since))
                )
                    return (
                        (this.year() - M(t[s].since).year()) * e + t[s].offset
                    );
            return this.year();
        }),
        (n.year = Ke),
        (n.isLeapYear = function () {
            return Le(this.year());
        }),
        (n.weekYear = function (e) {
            return ht.call(
                this,
                e,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy
            );
        }),
        (n.isoWeekYear = function (e) {
            return ht.call(this, e, this.isoWeek(), this.isoWeekday(), 1, 4);
        }),
        (n.quarter = n.quarters =
            function (e) {
                return null == e
                    ? Math.ceil((this.month() + 1) / 3)
                    : this.month(3 * (e - 1) + (this.month() % 3));
            }),
        (n.month = Ge),
        (n.daysInMonth = function () {
            return ze(this.year(), this.month());
        }),
        (n.week = n.weeks =
            function (e) {
                var a = this.localeData().week(this);
                return null == e ? a : this.add(7 * (e - a), "d");
            }),
        (n.isoWeek = n.isoWeeks =
            function (e) {
                var a = Xe(this, 1, 4).week;
                return null == e ? a : this.add(7 * (e - a), "d");
            }),
        (n.weeksInYear = function () {
            var e = this.localeData()._week;
            return ea(this.year(), e.dow, e.doy);
        }),
        (n.weeksInWeekYear = function () {
            var e = this.localeData()._week;
            return ea(this.weekYear(), e.dow, e.doy);
        }),
        (n.isoWeeksInYear = function () {
            return ea(this.year(), 1, 4);
        }),
        (n.isoWeeksInISOWeekYear = function () {
            return ea(this.isoWeekYear(), 1, 4);
        }),
        (n.date = Y),
        (n.day = n.days =
            function (e) {
                if (!this.isValid()) return null != e ? this : NaN;
                var a,
                    t,
                    s = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
                return null != e
                    ? ((a = e),
                      (t = this.localeData()),
                      (e =
                          "string" != typeof a
                              ? a
                              : isNaN(a)
                              ? "number" == typeof (a = t.weekdaysParse(a))
                                  ? a
                                  : null
                              : parseInt(a, 10)),
                      this.add(e - s, "d"))
                    : s;
            }),
        (n.weekday = function (e) {
            if (!this.isValid()) return null != e ? this : NaN;
            var a = (this.day() + 7 - this.localeData()._week.dow) % 7;
            return null == e ? a : this.add(e - a, "d");
        }),
        (n.isoWeekday = function (e) {
            return this.isValid()
                ? null != e
                    ? ((a = e),
                      (t = this.localeData()),
                      (t =
                          "string" == typeof a
                              ? t.weekdaysParse(a) % 7 || 7
                              : isNaN(a)
                              ? null
                              : a),
                      this.day(this.day() % 7 ? t : t - 7))
                    : this.day() || 7
                : null != e
                ? this
                : NaN;
            var a, t;
        }),
        (n.dayOfYear = function (e) {
            var a =
                Math.round(
                    (this.clone().startOf("day") -
                        this.clone().startOf("year")) /
                        864e5
                ) + 1;
            return null == e ? a : this.add(e - a, "d");
        }),
        (n.hour = n.hours = f),
        (n.minute = n.minutes = ke),
        (n.second = n.seconds = y),
        (n.millisecond = n.milliseconds = _),
        (n.utcOffset = function (e, a, t) {
            var s,
                n = this._offset || 0;
            if (!this.isValid()) return null != e ? this : NaN;
            if (null == e) return this._isUTC ? n : Ba(this);
            if ("string" == typeof e) {
                if (null === (e = Ga(be, e))) return this;
            } else Math.abs(e) < 16 && !t && (e *= 60);
            return (
                !this._isUTC && a && (s = Ba(this)),
                (this._offset = e),
                (this._isUTC = !0),
                null != s && this.add(s, "m"),
                n !== e &&
                    (!a || this._changeInProgress
                        ? at(this, $a(e - n, "m"), 1, !1)
                        : this._changeInProgress ||
                          ((this._changeInProgress = !0),
                          M.updateOffset(this, !0),
                          (this._changeInProgress = null))),
                this
            );
        }),
        (n.utc = function (e) {
            return this.utcOffset(0, e);
        }),
        (n.local = function (e) {
            return (
                this._isUTC &&
                    (this.utcOffset(0, e),
                    (this._isUTC = !1),
                    e && this.subtract(Ba(this), "m")),
                this
            );
        }),
        (n.parseZone = function () {
            var e;
            return (
                null != this._tzm
                    ? this.utcOffset(this._tzm, !1, !0)
                    : "string" == typeof this._i &&
                      (null != (e = Ga(we, this._i))
                          ? this.utcOffset(e)
                          : this.utcOffset(0, !0)),
                this
            );
        }),
        (n.hasAlignedHourOffset = function (e) {
            return (
                !!this.isValid() &&
                ((e = e ? S(e).utcOffset() : 0),
                (this.utcOffset() - e) % 60 == 0)
            );
        }),
        (n.isDST = function () {
            return (
                this.utcOffset() > this.clone().month(0).utcOffset() ||
                this.utcOffset() > this.clone().month(5).utcOffset()
            );
        }),
        (n.isLocal = function () {
            return !!this.isValid() && !this._isUTC;
        }),
        (n.isUtcOffset = function () {
            return !!this.isValid() && this._isUTC;
        }),
        (n.isUtc = Ka),
        (n.isUTC = Ka),
        (n.zoneAbbr = function () {
            return this._isUTC ? "UTC" : "";
        }),
        (n.zoneName = function () {
            return this._isUTC ? "Coordinated Universal Time" : "";
        }),
        (n.dates = e("dates accessor is deprecated. Use date instead.", Y)),
        (n.months = e("months accessor is deprecated. Use month instead", Ge)),
        (n.years = e("years accessor is deprecated. Use year instead", Ke)),
        (n.zone = e(
            "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
            function (e, a) {
                return null != e
                    ? (this.utcOffset((e = "string" != typeof e ? -e : e), a),
                      this)
                    : -this.utcOffset();
            }
        )),
        (n.isDSTShifted = e(
            "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
            function () {
                if (!d(this._isDSTShifted)) return this._isDSTShifted;
                var e,
                    a = {};
                return (
                    Z(a, this),
                    (a = Ea(a))._a
                        ? ((e = (a._isUTC ? U : S)(a._a)),
                          (this._isDSTShifted =
                              this.isValid() &&
                              0 <
                                  (function (e, a, t) {
                                      for (
                                          var s = Math.min(e.length, a.length),
                                              n = Math.abs(e.length - a.length),
                                              r = 0,
                                              d = 0;
                                          d < s;
                                          d++
                                      )
                                          ((t && e[d] !== a[d]) ||
                                              (!t && m(e[d]) !== m(a[d]))) &&
                                              r++;
                                      return r + n;
                                  })(a._a, e.toArray())))
                        : (this._isDSTShifted = !1),
                    this._isDSTShifted
                );
            }
        ));
    r = ne.prototype;
    function yt(e, a, t, s) {
        var n = pa(),
            s = U().set(s, a);
        return n[t](s, e);
    }
    function ft(e, a, t) {
        if ((J(e) && ((a = e), (e = void 0)), (e = e || ""), null != a))
            return yt(e, a, t, "month");
        for (var s = [], n = 0; n < 12; n++) s[n] = yt(e, n, t, "month");
        return s;
    }
    function pt(e, a, t, s) {
        a =
            ("boolean" == typeof e
                ? J(a) && ((t = a), (a = void 0))
                : ((a = e), (e = !1), J((t = a)) && ((t = a), (a = void 0))),
            a || "");
        var n,
            r = pa(),
            d = e ? r._week.dow : 0,
            i = [];
        if (null != t) return yt(a, (t + d) % 7, s, "day");
        for (n = 0; n < 7; n++) i[n] = yt(a, (n + d) % 7, s, "day");
        return i;
    }
    (r.calendar = function (e, a, t) {
        return te((e = this._calendar[e] || this._calendar.sameElse))
            ? e.call(a, t)
            : e;
    }),
        (r.longDateFormat = function (e) {
            var a = this._longDateFormat[e],
                t = this._longDateFormat[e.toUpperCase()];
            return a || !t
                ? a
                : ((this._longDateFormat[e] = t
                      .match(ie)
                      .map(function (e) {
                          return "MMMM" === e ||
                              "MM" === e ||
                              "DD" === e ||
                              "dddd" === e
                              ? e.slice(1)
                              : e;
                      })
                      .join("")),
                  this._longDateFormat[e]);
        }),
        (r.invalidDate = function () {
            return this._invalidDate;
        }),
        (r.ordinal = function (e) {
            return this._ordinal.replace("%d", e);
        }),
        (r.preparse = Yt),
        (r.postformat = Yt),
        (r.relativeTime = function (e, a, t, s) {
            var n = this._relativeTime[t];
            return te(n) ? n(e, a, t, s) : n.replace(/%d/i, e);
        }),
        (r.pastFuture = function (e, a) {
            return te((e = this._relativeTime[0 < e ? "future" : "past"]))
                ? e(a)
                : e.replace(/%s/i, a);
        }),
        (r.set = function (e) {
            var a, t;
            for (t in e)
                l(e, t) &&
                    (te((a = e[t])) ? (this[t] = a) : (this["_" + t] = a));
            (this._config = e),
                (this._dayOfMonthOrdinalParseLenient = new RegExp(
                    (this._dayOfMonthOrdinalParse.source ||
                        this._ordinalParse.source) +
                        "|" +
                        /\d{1,2}/.source
                ));
        }),
        (r.eras = function (e, a) {
            for (
                var t, s = this._eras || pa("en")._eras, n = 0, r = s.length;
                n < r;
                ++n
            ) {
                switch (typeof s[n].since) {
                    case "string":
                        (t = M(s[n].since).startOf("day")),
                            (s[n].since = t.valueOf());
                        break;
                }
                switch (typeof s[n].until) {
                    case "undefined":
                        s[n].until = 1 / 0;
                        break;
                    case "string":
                        (t = M(s[n].until).startOf("day").valueOf()),
                            (s[n].until = t.valueOf());
                        break;
                }
            }
            return s;
        }),
        (r.erasParse = function (e, a, t) {
            var s,
                n,
                r,
                d,
                i,
                _ = this.eras();
            for (e = e.toUpperCase(), s = 0, n = _.length; s < n; ++s)
                if (
                    ((r = _[s].name.toUpperCase()),
                    (d = _[s].abbr.toUpperCase()),
                    (i = _[s].narrow.toUpperCase()),
                    t)
                )
                    switch (a) {
                        case "N":
                        case "NN":
                        case "NNN":
                            if (d === e) return _[s];
                            break;
                        case "NNNN":
                            if (r === e) return _[s];
                            break;
                        case "NNNNN":
                            if (i === e) return _[s];
                            break;
                    }
                else if (0 <= [r, d, i].indexOf(e)) return _[s];
        }),
        (r.erasConvertYear = function (e, a) {
            var t = e.since <= e.until ? 1 : -1;
            return void 0 === a
                ? M(e.since).year()
                : M(e.since).year() + (a - e.offset) * t;
        }),
        (r.erasAbbrRegex = function (e) {
            return (
                l(this, "_erasAbbrRegex") || lt.call(this),
                e ? this._erasAbbrRegex : this._erasRegex
            );
        }),
        (r.erasNameRegex = function (e) {
            return (
                l(this, "_erasNameRegex") || lt.call(this),
                e ? this._erasNameRegex : this._erasRegex
            );
        }),
        (r.erasNarrowRegex = function (e) {
            return (
                l(this, "_erasNarrowRegex") || lt.call(this),
                e ? this._erasNarrowRegex : this._erasRegex
            );
        }),
        (r.months = function (e, a) {
            return e
                ? (F(this._months)
                      ? this._months
                      : this._months[
                            (this._months.isFormat || Re).test(a)
                                ? "format"
                                : "standalone"
                        ])[e.month()]
                : F(this._months)
                ? this._months
                : this._months.standalone;
        }),
        (r.monthsShort = function (e, a) {
            return e
                ? (F(this._monthsShort)
                      ? this._monthsShort
                      : this._monthsShort[
                            Re.test(a) ? "format" : "standalone"
                        ])[e.month()]
                : F(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort.standalone;
        }),
        (r.monthsParse = function (e, a, t) {
            var s, n;
            if (this._monthsParseExact)
                return function (e, a, t) {
                    var s,
                        n,
                        r,
                        e = e.toLocaleLowerCase();
                    if (!this._monthsParse)
                        for (
                            this._monthsParse = [],
                                this._longMonthsParse = [],
                                this._shortMonthsParse = [],
                                s = 0;
                            s < 12;
                            ++s
                        )
                            (r = U([2e3, s])),
                                (this._shortMonthsParse[s] = this.monthsShort(
                                    r,
                                    ""
                                ).toLocaleLowerCase()),
                                (this._longMonthsParse[s] = this.months(
                                    r,
                                    ""
                                ).toLocaleLowerCase());
                    return t
                        ? "MMM" === a
                            ? -1 !== (n = T.call(this._shortMonthsParse, e))
                                ? n
                                : null
                            : -1 !== (n = T.call(this._longMonthsParse, e))
                            ? n
                            : null
                        : "MMM" === a
                        ? -1 !== (n = T.call(this._shortMonthsParse, e)) ||
                          -1 !== (n = T.call(this._longMonthsParse, e))
                            ? n
                            : null
                        : -1 !== (n = T.call(this._longMonthsParse, e)) ||
                          -1 !== (n = T.call(this._shortMonthsParse, e))
                        ? n
                        : null;
                }.call(this, e, a, t);
            for (
                this._monthsParse ||
                    ((this._monthsParse = []),
                    (this._longMonthsParse = []),
                    (this._shortMonthsParse = [])),
                    s = 0;
                s < 12;
                s++
            ) {
                if (
                    ((n = U([2e3, s])),
                    t &&
                        !this._longMonthsParse[s] &&
                        ((this._longMonthsParse[s] = new RegExp(
                            "^" + this.months(n, "").replace(".", "") + "$",
                            "i"
                        )),
                        (this._shortMonthsParse[s] = new RegExp(
                            "^" +
                                this.monthsShort(n, "").replace(".", "") +
                                "$",
                            "i"
                        ))),
                    t ||
                        this._monthsParse[s] ||
                        ((n =
                            "^" +
                            this.months(n, "") +
                            "|^" +
                            this.monthsShort(n, "")),
                        (this._monthsParse[s] = new RegExp(
                            n.replace(".", ""),
                            "i"
                        ))),
                    t && "MMMM" === a && this._longMonthsParse[s].test(e))
                )
                    return s;
                if (t && "MMM" === a && this._shortMonthsParse[s].test(e))
                    return s;
                if (!t && this._monthsParse[s].test(e)) return s;
            }
        }),
        (r.monthsRegex = function (e) {
            return this._monthsParseExact
                ? (l(this, "_monthsRegex") || Ve.call(this),
                  e ? this._monthsStrictRegex : this._monthsRegex)
                : (l(this, "_monthsRegex") || (this._monthsRegex = Ie),
                  this._monthsStrictRegex && e
                      ? this._monthsStrictRegex
                      : this._monthsRegex);
        }),
        (r.monthsShortRegex = function (e) {
            return this._monthsParseExact
                ? (l(this, "_monthsRegex") || Ve.call(this),
                  e ? this._monthsShortStrictRegex : this._monthsShortRegex)
                : (l(this, "_monthsShortRegex") ||
                      (this._monthsShortRegex = Ce),
                  this._monthsShortStrictRegex && e
                      ? this._monthsShortStrictRegex
                      : this._monthsShortRegex);
        }),
        (r.week = function (e) {
            return Xe(e, this._week.dow, this._week.doy).week;
        }),
        (r.firstDayOfYear = function () {
            return this._week.doy;
        }),
        (r.firstDayOfWeek = function () {
            return this._week.dow;
        }),
        (r.weekdays = function (e, a) {
            return (
                (a = F(this._weekdays)
                    ? this._weekdays
                    : this._weekdays[
                          e && !0 !== e && this._weekdays.isFormat.test(a)
                              ? "format"
                              : "standalone"
                      ]),
                !0 === e ? aa(a, this._week.dow) : e ? a[e.day()] : a
            );
        }),
        (r.weekdaysMin = function (e) {
            return !0 === e
                ? aa(this._weekdaysMin, this._week.dow)
                : e
                ? this._weekdaysMin[e.day()]
                : this._weekdaysMin;
        }),
        (r.weekdaysShort = function (e) {
            return !0 === e
                ? aa(this._weekdaysShort, this._week.dow)
                : e
                ? this._weekdaysShort[e.day()]
                : this._weekdaysShort;
        }),
        (r.weekdaysParse = function (e, a, t) {
            var s, n;
            if (this._weekdaysParseExact)
                return function (e, a, t) {
                    var s,
                        n,
                        r,
                        e = e.toLocaleLowerCase();
                    if (!this._weekdaysParse)
                        for (
                            this._weekdaysParse = [],
                                this._shortWeekdaysParse = [],
                                this._minWeekdaysParse = [],
                                s = 0;
                            s < 7;
                            ++s
                        )
                            (r = U([2e3, 1]).day(s)),
                                (this._minWeekdaysParse[s] = this.weekdaysMin(
                                    r,
                                    ""
                                ).toLocaleLowerCase()),
                                (this._shortWeekdaysParse[s] =
                                    this.weekdaysShort(
                                        r,
                                        ""
                                    ).toLocaleLowerCase()),
                                (this._weekdaysParse[s] = this.weekdays(
                                    r,
                                    ""
                                ).toLocaleLowerCase());
                    return t
                        ? "dddd" === a
                            ? -1 !== (n = T.call(this._weekdaysParse, e))
                                ? n
                                : null
                            : "ddd" === a
                            ? -1 !== (n = T.call(this._shortWeekdaysParse, e))
                                ? n
                                : null
                            : -1 !== (n = T.call(this._minWeekdaysParse, e))
                            ? n
                            : null
                        : "dddd" === a
                        ? -1 !== (n = T.call(this._weekdaysParse, e)) ||
                          -1 !== (n = T.call(this._shortWeekdaysParse, e)) ||
                          -1 !== (n = T.call(this._minWeekdaysParse, e))
                            ? n
                            : null
                        : "ddd" === a
                        ? -1 !== (n = T.call(this._shortWeekdaysParse, e)) ||
                          -1 !== (n = T.call(this._weekdaysParse, e)) ||
                          -1 !== (n = T.call(this._minWeekdaysParse, e))
                            ? n
                            : null
                        : -1 !== (n = T.call(this._minWeekdaysParse, e)) ||
                          -1 !== (n = T.call(this._weekdaysParse, e)) ||
                          -1 !== (n = T.call(this._shortWeekdaysParse, e))
                        ? n
                        : null;
                }.call(this, e, a, t);
            for (
                this._weekdaysParse ||
                    ((this._weekdaysParse = []),
                    (this._minWeekdaysParse = []),
                    (this._shortWeekdaysParse = []),
                    (this._fullWeekdaysParse = [])),
                    s = 0;
                s < 7;
                s++
            ) {
                if (
                    ((n = U([2e3, 1]).day(s)),
                    t &&
                        !this._fullWeekdaysParse[s] &&
                        ((this._fullWeekdaysParse[s] = new RegExp(
                            "^" +
                                this.weekdays(n, "").replace(".", "\\.?") +
                                "$",
                            "i"
                        )),
                        (this._shortWeekdaysParse[s] = new RegExp(
                            "^" +
                                this.weekdaysShort(n, "").replace(".", "\\.?") +
                                "$",
                            "i"
                        )),
                        (this._minWeekdaysParse[s] = new RegExp(
                            "^" +
                                this.weekdaysMin(n, "").replace(".", "\\.?") +
                                "$",
                            "i"
                        ))),
                    this._weekdaysParse[s] ||
                        ((n =
                            "^" +
                            this.weekdays(n, "") +
                            "|^" +
                            this.weekdaysShort(n, "") +
                            "|^" +
                            this.weekdaysMin(n, "")),
                        (this._weekdaysParse[s] = new RegExp(
                            n.replace(".", ""),
                            "i"
                        ))),
                    t && "dddd" === a && this._fullWeekdaysParse[s].test(e))
                )
                    return s;
                if (t && "ddd" === a && this._shortWeekdaysParse[s].test(e))
                    return s;
                if (t && "dd" === a && this._minWeekdaysParse[s].test(e))
                    return s;
                if (!t && this._weekdaysParse[s].test(e)) return s;
            }
        }),
        (r.weekdaysRegex = function (e) {
            return this._weekdaysParseExact
                ? (l(this, "_weekdaysRegex") || _a.call(this),
                  e ? this._weekdaysStrictRegex : this._weekdaysRegex)
                : (l(this, "_weekdaysRegex") || (this._weekdaysRegex = ra),
                  this._weekdaysStrictRegex && e
                      ? this._weekdaysStrictRegex
                      : this._weekdaysRegex);
        }),
        (r.weekdaysShortRegex = function (e) {
            return this._weekdaysParseExact
                ? (l(this, "_weekdaysRegex") || _a.call(this),
                  e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex)
                : (l(this, "_weekdaysShortRegex") ||
                      (this._weekdaysShortRegex = da),
                  this._weekdaysShortStrictRegex && e
                      ? this._weekdaysShortStrictRegex
                      : this._weekdaysShortRegex);
        }),
        (r.weekdaysMinRegex = function (e) {
            return this._weekdaysParseExact
                ? (l(this, "_weekdaysRegex") || _a.call(this),
                  e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex)
                : (l(this, "_weekdaysMinRegex") ||
                      (this._weekdaysMinRegex = ia),
                  this._weekdaysMinStrictRegex && e
                      ? this._weekdaysMinStrictRegex
                      : this._weekdaysMinRegex);
        }),
        (r.isPM = function (e) {
            return "p" === (e + "").toLowerCase().charAt(0);
        }),
        (r.meridiem = function (e, a, t) {
            return 11 < e ? (t ? "pm" : "PM") : t ? "am" : "AM";
        }),
        ya("en", {
            eras: [
                {
                    since: "0001-01-01",
                    until: 1 / 0,
                    offset: 1,
                    name: "Anno Domini",
                    narrow: "AD",
                    abbr: "AD",
                },
                {
                    since: "0000-12-31",
                    until: -1 / 0,
                    offset: 1,
                    name: "Before Christ",
                    narrow: "BC",
                    abbr: "BC",
                },
            ],
            dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
            ordinal: function (e) {
                var a = e % 10;
                return (
                    e +
                    (1 === m((e % 100) / 10)
                        ? "th"
                        : 1 == a
                        ? "st"
                        : 2 == a
                        ? "nd"
                        : 3 == a
                        ? "rd"
                        : "th")
                );
            },
        }),
        (M.lang = e(
            "moment.lang is deprecated. Use moment.locale instead.",
            ya
        )),
        (M.langData = e(
            "moment.langData is deprecated. Use moment.localeData instead.",
            pa
        ));
    var kt = Math.abs;
    function Dt(e, a, t, s) {
        a = $a(a, t);
        return (
            (e._milliseconds += s * a._milliseconds),
            (e._days += s * a._days),
            (e._months += s * a._months),
            e._bubble()
        );
    }
    function Tt(e) {
        return e < 0 ? Math.floor(e) : Math.ceil(e);
    }
    function gt(e) {
        return (4800 * e) / 146097;
    }
    function wt(e) {
        return (146097 * e) / 4800;
    }
    function bt(e) {
        return function () {
            return this.as(e);
        };
    }
    (De = bt("ms")),
        (pe = bt("s")),
        (Ne = bt("m")),
        (L = bt("h")),
        (c = bt("d")),
        (ta = bt("w")),
        (f = bt("M")),
        (ke = bt("Q")),
        (y = bt("y"));
    function St(e) {
        return function () {
            return this.isValid() ? this._data[e] : NaN;
        };
    }
    var _ = St("milliseconds"),
        Y = St("seconds"),
        Ke = St("minutes"),
        r = St("hours"),
        Ht = St("days"),
        vt = St("months"),
        jt = St("years");
    var xt = Math.round,
        Pt = { ss: 44, s: 45, m: 45, h: 22, d: 26, w: null, M: 11 };
    function Ot(e, a, t, s) {
        var n = $a(e).abs(),
            r = xt(n.as("s")),
            d = xt(n.as("m")),
            i = xt(n.as("h")),
            _ = xt(n.as("d")),
            o = xt(n.as("M")),
            m = xt(n.as("w")),
            n = xt(n.as("y")),
            r =
                (r <= t.ss ? ["s", r] : r < t.s && ["ss", r]) ||
                (d <= 1 && ["m"]) ||
                (d < t.m && ["mm", d]) ||
                (i <= 1 && ["h"]) ||
                (i < t.h && ["hh", i]) ||
                (_ <= 1 && ["d"]) ||
                (_ < t.d && ["dd", _]);
        return (
            ((r = (r =
                null != t.w
                    ? r || (m <= 1 && ["w"]) || (m < t.w && ["ww", m])
                    : r) ||
                (o <= 1 && ["M"]) ||
                (o < t.M && ["MM", o]) ||
                (n <= 1 && ["y"]) || ["yy", n])[2] = a),
            (r[3] = 0 < +e),
            (r[4] = s),
            function (e, a, t, s, n) {
                return n.relativeTime(a || 1, !!t, e, s);
            }.apply(null, r)
        );
    }
    var Wt = Math.abs;
    function At(e) {
        return (0 < e) - (e < 0) || +e;
    }
    function Et() {
        if (!this.isValid()) return this.localeData().invalidDate();
        var e,
            a,
            t,
            s,
            n,
            r,
            d,
            i = Wt(this._milliseconds) / 1e3,
            _ = Wt(this._days),
            o = Wt(this._months),
            m = this.asSeconds();
        return m
            ? ((e = u(i / 60)),
              (a = u(e / 60)),
              (i %= 60),
              (e %= 60),
              (t = u(o / 12)),
              (o %= 12),
              (s = i ? i.toFixed(3).replace(/\.?0+$/, "") : ""),
              (n = At(this._months) !== At(m) ? "-" : ""),
              (r = At(this._days) !== At(m) ? "-" : ""),
              (d = At(this._milliseconds) !== At(m) ? "-" : ""),
              (m < 0 ? "-" : "") +
                  "P" +
                  (t ? n + t + "Y" : "") +
                  (o ? n + o + "M" : "") +
                  (_ ? r + _ + "D" : "") +
                  (a || e || i ? "T" : "") +
                  (a ? d + a + "H" : "") +
                  (e ? d + e + "M" : "") +
                  (i ? d + s + "S" : ""))
            : "P0D";
    }
    function Ft(e) {
        return 0 === e
            ? 0
            : 1 === e
            ? 1
            : 2 === e
            ? 2
            : 3 <= e % 100 && e % 100 <= 10
            ? 3
            : 11 <= e % 100
            ? 4
            : 5;
    }
    function H(d) {
        return function (e, a, t, s) {
            var n = Ft(e),
                r = Jt[d][Ft(e)];
            return (r = 2 === n ? r[a ? 0 : 1] : r).replace(/%d/i, e);
        };
    }
    function zt(e) {
        return 0 === e
            ? 0
            : 1 === e
            ? 1
            : 2 === e
            ? 2
            : 3 <= e % 100 && e % 100 <= 10
            ? 3
            : 11 <= e % 100
            ? 4
            : 5;
    }
    function v(d) {
        return function (e, a, t, s) {
            var n = zt(e),
                r = Ct[d][zt(e)];
            return (r = 2 === n ? r[a ? 0 : 1] : r).replace(/%d/i, e);
        };
    }
    function Nt(e) {
        return 0 === e
            ? 0
            : 1 === e
            ? 1
            : 2 === e
            ? 2
            : 3 <= e % 100 && e % 100 <= 10
            ? 3
            : 11 <= e % 100
            ? 4
            : 5;
    }
    function j(d) {
        return function (e, a, t, s) {
            var n = Nt(e),
                r = Bt[d][Nt(e)];
            return (r = 2 === n ? r[a ? 0 : 1] : r).replace(/%d/i, e);
        };
    }
    var x = Ja.prototype,
        Jt =
            ((x.isValid = function () {
                return this._isValid;
            }),
            (x.abs = function () {
                var e = this._data;
                return (
                    (this._milliseconds = kt(this._milliseconds)),
                    (this._days = kt(this._days)),
                    (this._months = kt(this._months)),
                    (e.milliseconds = kt(e.milliseconds)),
                    (e.seconds = kt(e.seconds)),
                    (e.minutes = kt(e.minutes)),
                    (e.hours = kt(e.hours)),
                    (e.months = kt(e.months)),
                    (e.years = kt(e.years)),
                    this
                );
            }),
            (x.add = function (e, a) {
                return Dt(this, e, a, 1);
            }),
            (x.subtract = function (e, a) {
                return Dt(this, e, a, -1);
            }),
            (x.as = function (e) {
                if (!this.isValid()) return NaN;
                var a,
                    t,
                    s = this._milliseconds;
                if ("month" === (e = i(e)) || "quarter" === e || "year" === e)
                    switch (
                        ((a = this._days + s / 864e5),
                        (t = this._months + gt(a)),
                        e)
                    ) {
                        case "month":
                            return t;
                        case "quarter":
                            return t / 3;
                        case "year":
                            return t / 12;
                    }
                else
                    switch (
                        ((a = this._days + Math.round(wt(this._months))), e)
                    ) {
                        case "week":
                            return a / 7 + s / 6048e5;
                        case "day":
                            return a + s / 864e5;
                        case "hour":
                            return 24 * a + s / 36e5;
                        case "minute":
                            return 1440 * a + s / 6e4;
                        case "second":
                            return 86400 * a + s / 1e3;
                        case "millisecond":
                            return Math.floor(864e5 * a) + s;
                        default:
                            throw new Error("Unknown unit " + e);
                    }
            }),
            (x.asMilliseconds = De),
            (x.asSeconds = pe),
            (x.asMinutes = Ne),
            (x.asHours = L),
            (x.asDays = c),
            (x.asWeeks = ta),
            (x.asMonths = f),
            (x.asQuarters = ke),
            (x.asYears = y),
            (x.valueOf = function () {
                return this.isValid()
                    ? this._milliseconds +
                          864e5 * this._days +
                          (this._months % 12) * 2592e6 +
                          31536e6 * m(this._months / 12)
                    : NaN;
            }),
            (x._bubble = function () {
                var e = this._milliseconds,
                    a = this._days,
                    t = this._months,
                    s = this._data;
                return (
                    (0 <= e && 0 <= a && 0 <= t) ||
                        (e <= 0 && a <= 0 && t <= 0) ||
                        ((e += 864e5 * Tt(wt(t) + a)), (t = a = 0)),
                    (s.milliseconds = e % 1e3),
                    (e = u(e / 1e3)),
                    (s.seconds = e % 60),
                    (e = u(e / 60)),
                    (s.minutes = e % 60),
                    (e = u(e / 60)),
                    (s.hours = e % 24),
                    (a += u(e / 24)),
                    (t += e = u(gt(a))),
                    (a -= Tt(wt(e))),
                    (e = u(t / 12)),
                    (t %= 12),
                    (s.days = a),
                    (s.months = t),
                    (s.years = e),
                    this
                );
            }),
            (x.clone = function () {
                return $a(this);
            }),
            (x.get = function (e) {
                return (e = i(e)), this.isValid() ? this[e + "s"]() : NaN;
            }),
            (x.milliseconds = _),
            (x.seconds = Y),
            (x.minutes = Ke),
            (x.hours = r),
            (x.days = Ht),
            (x.weeks = function () {
                return u(this.days() / 7);
            }),
            (x.months = vt),
            (x.years = jt),
            (x.humanize = function (e, a) {
                if (!this.isValid()) return this.localeData().invalidDate();
                var t = !1,
                    s = Pt;
                return (
                    "object" == typeof e && ((a = e), (e = !1)),
                    "boolean" == typeof e && (t = e),
                    "object" == typeof a &&
                        ((s = Object.assign({}, Pt, a)),
                        null != a.s && null == a.ss && (s.ss = a.s - 1)),
                    (e = this.localeData()),
                    (a = Ot(this, !t, s, e)),
                    t && (a = e.pastFuture(+this, a)),
                    e.postformat(a)
                );
            }),
            (x.toISOString = Et),
            (x.toString = Et),
            (x.toJSON = Et),
            (x.locale = rt),
            (x.localeData = dt),
            (x.toIsoString = e(
                "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
                Et
            )),
            (x.lang = na),
            s("X", 0, 0, "unix"),
            s("x", 0, 0, "valueOf"),
            p("x", ge),
            p("X", /[+-]?\d+(\.\d{1,3})?/),
            D("X", function (e, a, t) {
                t._d = new Date(1e3 * parseFloat(e));
            }),
            D("x", function (e, a, t) {
                t._d = new Date(m(e));
            }),
            (M.version = "2.29.4"),
            (E = S),
            (M.fn = n),
            (M.min = function () {
                return za("isBefore", [].slice.call(arguments, 0));
            }),
            (M.max = function () {
                return za("isAfter", [].slice.call(arguments, 0));
            }),
            (M.now = function () {
                return Date.now ? Date.now() : +new Date();
            }),
            (M.utc = U),
            (M.unix = function (e) {
                return S(1e3 * e);
            }),
            (M.months = function (e, a) {
                return ft(e, a, "months");
            }),
            (M.isDate = R),
            (M.locale = ya),
            (M.invalid = V),
            (M.duration = $a),
            (M.isMoment = Q),
            (M.weekdays = function (e, a, t) {
                return pt(e, a, t, "weekdays");
            }),
            (M.parseZone = function () {
                return S.apply(null, arguments).parseZone();
            }),
            (M.localeData = pa),
            (M.isDuration = Ra),
            (M.monthsShort = function (e, a) {
                return ft(e, a, "monthsShort");
            }),
            (M.weekdaysMin = function (e, a, t) {
                return pt(e, a, t, "weekdaysMin");
            }),
            (M.defineLocale = fa),
            (M.updateLocale = function (e, a) {
                var t, s;
                return (
                    null != a
                        ? ((s = Ma),
                          null != b[e] && null != b[e].parentLocale
                              ? b[e].set(se(b[e]._config, a))
                              : ((a = se(
                                    (s = null != (t = Ya(e)) ? t._config : s),
                                    a
                                )),
                                null == t && (a.abbr = e),
                                ((s = new ne(a)).parentLocale = b[e]),
                                (b[e] = s)),
                          ya(e))
                        : null != b[e] &&
                          (null != b[e].parentLocale
                              ? ((b[e] = b[e].parentLocale),
                                e === ya() && ya(e))
                              : null != b[e] && delete b[e]),
                    b[e]
                );
            }),
            (M.locales = function () {
                return re(b);
            }),
            (M.weekdaysShort = function (e, a, t) {
                return pt(e, a, t, "weekdaysShort");
            }),
            (M.normalizeUnits = i),
            (M.relativeTimeRounding = function (e) {
                return void 0 === e
                    ? xt
                    : "function" == typeof e && ((xt = e), !0);
            }),
            (M.relativeTimeThreshold = function (e, a) {
                return (
                    void 0 !== Pt[e] &&
                    (void 0 === a
                        ? Pt[e]
                        : ((Pt[e] = a), "s" === e && (Pt.ss = a - 1), !0))
                );
            }),
            (M.calendarFormat = function (e, a) {
                return (e = e.diff(a, "days", !0)) < -6
                    ? "sameElse"
                    : e < -1
                    ? "lastWeek"
                    : e < 0
                    ? "lastDay"
                    : e < 1
                    ? "sameDay"
                    : e < 2
                    ? "nextDay"
                    : e < 7
                    ? "nextWeek"
                    : "sameElse";
            }),
            (M.prototype = n),
            (M.HTML5_FMT = {
                DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
                DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
                DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
                DATE: "YYYY-MM-DD",
                TIME: "HH:mm",
                TIME_SECONDS: "HH:mm:ss",
                TIME_MS: "HH:mm:ss.SSS",
                WEEK: "GGGG-[W]WW",
                MONTH: "YYYY-MM",
            }),
            M.defineLocale("af", {
                months: "Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember".split(
                    "_"
                ),
                monthsShort:
                    "Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des".split(
                        "_"
                    ),
                weekdays:
                    "Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag".split(
                        "_"
                    ),
                weekdaysShort: "Son_Maa_Din_Woe_Don_Vry_Sat".split("_"),
                weekdaysMin: "So_Ma_Di_Wo_Do_Vr_Sa".split("_"),
                meridiemParse: /vm|nm/i,
                isPM: function (e) {
                    return /^nm$/i.test(e);
                },
                meridiem: function (e, a, t) {
                    return e < 12 ? (t ? "vm" : "VM") : t ? "nm" : "NM";
                },
                longDateFormat: {
                    LT: "HH:mm",
                    LTS: "HH:mm:ss",
                    L: "DD/MM/YYYY",
                    LL: "D MMMM YYYY",
                    LLL: "D MMMM YYYY HH:mm",
                    LLLL: "dddd, D MMMM YYYY HH:mm",
                },
                calendar: {
                    sameDay: "[Vandag om] LT",
                    nextDay: "[M\xf4re om] LT",
                    nextWeek: "dddd [om] LT",
                    lastDay: "[Gister om] LT",
                    lastWeek: "[Laas] dddd [om] LT",
                    sameElse: "L",
                },
                relativeTime: {
                    future: "oor %s",
                    past: "%s gelede",
                    s: "'n paar sekondes",
                    ss: "%d sekondes",
                    m: "'n minuut",
                    mm: "%d minute",
                    h: "'n uur",
                    hh: "%d ure",
                    d: "'n dag",
                    dd: "%d dae",
                    M: "'n maand",
                    MM: "%d maande",
                    y: "'n jaar",
                    yy: "%d jaar",
                },
                dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
                ordinal: function (e) {
                    return e + (1 === e || 8 === e || 20 <= e ? "ste" : "de");
                },
                week: { dow: 1, doy: 4 },
            }),
            {
                s: [
                    "\u0623\u0642\u0644 \u0645\u0646 \u062b\u0627\u0646\u064a\u0629",
                    "\u062b\u0627\u0646\u064a\u0629 \u0648\u0627\u062d\u062f\u0629",
                    [
                        "\u062b\u0627\u0646\u064a\u062a\u0627\u0646",
                        "\u062b\u0627\u0646\u064a\u062a\u064a\u0646",
                    ],
                    "%d \u062b\u0648\u0627\u0646",
                    "%d \u062b\u0627\u0646\u064a\u0629",
                    "%d \u062b\u0627\u0646\u064a\u0629",
                ],
                m: [
                    "\u0623\u0642\u0644 \u0645\u0646 \u062f\u0642\u064a\u0642\u0629",
                    "\u062f\u0642\u064a\u0642\u0629 \u0648\u0627\u062d\u062f\u0629",
                    [
                        "\u062f\u0642\u064a\u0642\u062a\u0627\u0646",
                        "\u062f\u0642\u064a\u0642\u062a\u064a\u0646",
                    ],
                    "%d \u062f\u0642\u0627\u0626\u0642",
                    "%d \u062f\u0642\u064a\u0642\u0629",
                    "%d \u062f\u0642\u064a\u0642\u0629",
                ],
                h: [
                    "\u0623\u0642\u0644 \u0645\u0646 \u0633\u0627\u0639\u0629",
                    "\u0633\u0627\u0639\u0629 \u0648\u0627\u062d\u062f\u0629",
                    [
                        "\u0633\u0627\u0639\u062a\u0627\u0646",
                        "\u0633\u0627\u0639\u062a\u064a\u0646",
                    ],
                    "%d \u0633\u0627\u0639\u0627\u062a",
                    "%d \u0633\u0627\u0639\u0629",
                    "%d \u0633\u0627\u0639\u0629",
                ],
                d: [
                    "\u0623\u0642\u0644 \u0645\u0646 \u064a\u0648\u0645",
                    "\u064a\u0648\u0645 \u0648\u0627\u062d\u062f",
                    [
                        "\u064a\u0648\u0645\u0627\u0646",
                        "\u064a\u0648\u0645\u064a\u0646",
                    ],
                    "%d \u0623\u064a\u0627\u0645",
                    "%d \u064a\u0648\u0645\u064b\u0627",
                    "%d \u064a\u0648\u0645",
                ],
                M: [
                    "\u0623\u0642\u0644 \u0645\u0646 \u0634\u0647\u0631",
                    "\u0634\u0647\u0631 \u0648\u0627\u062d\u062f",
                    [
                        "\u0634\u0647\u0631\u0627\u0646",
                        "\u0634\u0647\u0631\u064a\u0646",
                    ],
                    "%d \u0623\u0634\u0647\u0631",
                    "%d \u0634\u0647\u0631\u0627",
                    "%d \u0634\u0647\u0631",
                ],
                y: [
                    "\u0623\u0642\u0644 \u0645\u0646 \u0639\u0627\u0645",
                    "\u0639\u0627\u0645 \u0648\u0627\u062d\u062f",
                    [
                        "\u0639\u0627\u0645\u0627\u0646",
                        "\u0639\u0627\u0645\u064a\u0646",
                    ],
                    "%d \u0623\u0639\u0648\u0627\u0645",
                    "%d \u0639\u0627\u0645\u064b\u0627",
                    "%d \u0639\u0627\u0645",
                ],
            }),
        De = [
            "\u062c\u0627\u0646\u0641\u064a",
            "\u0641\u064a\u0641\u0631\u064a",
            "\u0645\u0627\u0631\u0633",
            "\u0623\u0641\u0631\u064a\u0644",
            "\u0645\u0627\u064a",
            "\u062c\u0648\u0627\u0646",
            "\u062c\u0648\u064a\u0644\u064a\u0629",
            "\u0623\u0648\u062a",
            "\u0633\u0628\u062a\u0645\u0628\u0631",
            "\u0623\u0643\u062a\u0648\u0628\u0631",
            "\u0646\u0648\u0641\u0645\u0628\u0631",
            "\u062f\u064a\u0633\u0645\u0628\u0631",
        ],
        Rt =
            (M.defineLocale("ar-dz", {
                months: De,
                monthsShort: De,
                weekdays:
                    "\u0627\u0644\u0623\u062d\u062f_\u0627\u0644\u0625\u062b\u0646\u064a\u0646_\u0627\u0644\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062e\u0645\u064a\u0633_\u0627\u0644\u062c\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062a".split(
                        "_"
                    ),
                weekdaysShort:
                    "\u0623\u062d\u062f_\u0625\u062b\u0646\u064a\u0646_\u062b\u0644\u0627\u062b\u0627\u0621_\u0623\u0631\u0628\u0639\u0627\u0621_\u062e\u0645\u064a\u0633_\u062c\u0645\u0639\u0629_\u0633\u0628\u062a".split(
                        "_"
                    ),
                weekdaysMin:
                    "\u062d_\u0646_\u062b_\u0631_\u062e_\u062c_\u0633".split(
                        "_"
                    ),
                weekdaysParseExact: !0,
                longDateFormat: {
                    LT: "HH:mm",
                    LTS: "HH:mm:ss",
                    L: "D/\u200fM/\u200fYYYY",
                    LL: "D MMMM YYYY",
                    LLL: "D MMMM YYYY HH:mm",
                    LLLL: "dddd D MMMM YYYY HH:mm",
                },
                meridiemParse: /\u0635|\u0645/,
                isPM: function (e) {
                    return "\u0645" === e;
                },
                meridiem: function (e, a, t) {
                    return e < 12 ? "\u0635" : "\u0645";
                },
                calendar: {
                    sameDay:
                        "[\u0627\u0644\u064a\u0648\u0645 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",
                    nextDay:
                        "[\u063a\u062f\u064b\u0627 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",
                    nextWeek:
                        "dddd [\u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",
                    lastDay:
                        "[\u0623\u0645\u0633 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",
                    lastWeek:
                        "dddd [\u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",
                    sameElse: "L",
                },
                relativeTime: {
                    future: "\u0628\u0639\u062f %s",
                    past: "\u0645\u0646\u0630 %s",
                    s: H("s"),
                    ss: H("s"),
                    m: H("m"),
                    mm: H("m"),
                    h: H("h"),
                    hh: H("h"),
                    d: H("d"),
                    dd: H("d"),
                    M: H("M"),
                    MM: H("M"),
                    y: H("y"),
                    yy: H("y"),
                },
                postformat: function (e) {
                    return e.replace(/,/g, "\u060c");
                },
                week: { dow: 0, doy: 4 },
            }),
            M.defineLocale("ar-kw", {
                months: "\u064a\u0646\u0627\u064a\u0631_\u0641\u0628\u0631\u0627\u064a\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064a\u0644_\u0645\u0627\u064a_\u064a\u0648\u0646\u064a\u0648_\u064a\u0648\u0644\u064a\u0648\u0632_\u063a\u0634\u062a_\u0634\u062a\u0646\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0646\u0628\u0631_\u062f\u062c\u0646\u0628\u0631".split(
                    "_"
                ),
                monthsShort:
                    "\u064a\u0646\u0627\u064a\u0631_\u0641\u0628\u0631\u0627\u064a\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064a\u0644_\u0645\u0627\u064a_\u064a\u0648\u0646\u064a\u0648_\u064a\u0648\u0644\u064a\u0648\u0632_\u063a\u0634\u062a_\u0634\u062a\u0646\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0646\u0628\u0631_\u062f\u062c\u0646\u0628\u0631".split(
                        "_"
                    ),
                weekdays:
                    "\u0627\u0644\u0623\u062d\u062f_\u0627\u0644\u0625\u062a\u0646\u064a\u0646_\u0627\u0644\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062e\u0645\u064a\u0633_\u0627\u0644\u062c\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062a".split(
                        "_"
                    ),
                weekdaysShort:
                    "\u0627\u062d\u062f_\u0627\u062a\u0646\u064a\u0646_\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0631\u0628\u0639\u0627\u0621_\u062e\u0645\u064a\u0633_\u062c\u0645\u0639\u0629_\u0633\u0628\u062a".split(
                        "_"
                    ),
                weekdaysMin:
                    "\u062d_\u0646_\u062b_\u0631_\u062e_\u062c_\u0633".split(
                        "_"
                    ),
                weekdaysParseExact: !0,
                longDateFormat: {
                    LT: "HH:mm",
                    LTS: "HH:mm:ss",
                    L: "DD/MM/YYYY",
                    LL: "D MMMM YYYY",
                    LLL: "D MMMM YYYY HH:mm",
                    LLLL: "dddd D MMMM YYYY HH:mm",
                },
                calendar: {
                    sameDay:
                        "[\u0627\u0644\u064a\u0648\u0645 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
                    nextDay:
                        "[\u063a\u062f\u0627 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
                    nextWeek:
                        "dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
                    lastDay:
                        "[\u0623\u0645\u0633 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
                    lastWeek:
                        "dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
                    sameElse: "L",
                },
                relativeTime: {
                    future: "\u0641\u064a %s",
                    past: "\u0645\u0646\u0630 %s",
                    s: "\u062b\u0648\u0627\u0646",
                    ss: "%d \u062b\u0627\u0646\u064a\u0629",
                    m: "\u062f\u0642\u064a\u0642\u0629",
                    mm: "%d \u062f\u0642\u0627\u0626\u0642",
                    h: "\u0633\u0627\u0639\u0629",
                    hh: "%d \u0633\u0627\u0639\u0627\u062a",
                    d: "\u064a\u0648\u0645",
                    dd: "%d \u0623\u064a\u0627\u0645",
                    M: "\u0634\u0647\u0631",
                    MM: "%d \u0623\u0634\u0647\u0631",
                    y: "\u0633\u0646\u0629",
                    yy: "%d \u0633\u0646\u0648\u0627\u062a",
                },
                week: { dow: 0, doy: 12 },
            }),
            {
                1: "1",
                2: "2",
                3: "3",
                4: "4",
                5: "5",
                6: "6",
                7: "7",
                8: "8",
                9: "9",
                0: "0",
            }),
        Ct = {
            s: [
                "\u0623\u0642\u0644 \u0645\u0646 \u062b\u0627\u0646\u064a\u0629",
                "\u062b\u0627\u0646\u064a\u0629 \u0648\u0627\u062d\u062f\u0629",
                [
                    "\u062b\u0627\u0646\u064a\u062a\u0627\u0646",
                    "\u062b\u0627\u0646\u064a\u062a\u064a\u0646",
                ],
                "%d \u062b\u0648\u0627\u0646",
                "%d \u062b\u0627\u0646\u064a\u0629",
                "%d \u062b\u0627\u0646\u064a\u0629",
            ],
            m: [
                "\u0623\u0642\u0644 \u0645\u0646 \u062f\u0642\u064a\u0642\u0629",
                "\u062f\u0642\u064a\u0642\u0629 \u0648\u0627\u062d\u062f\u0629",
                [
                    "\u062f\u0642\u064a\u0642\u062a\u0627\u0646",
                    "\u062f\u0642\u064a\u0642\u062a\u064a\u0646",
                ],
                "%d \u062f\u0642\u0627\u0626\u0642",
                "%d \u062f\u0642\u064a\u0642\u0629",
                "%d \u062f\u0642\u064a\u0642\u0629",
            ],
            h: [
                "\u0623\u0642\u0644 \u0645\u0646 \u0633\u0627\u0639\u0629",
                "\u0633\u0627\u0639\u0629 \u0648\u0627\u062d\u062f\u0629",
                [
                    "\u0633\u0627\u0639\u062a\u0627\u0646",
                    "\u0633\u0627\u0639\u062a\u064a\u0646",
                ],
                "%d \u0633\u0627\u0639\u0627\u062a",
                "%d \u0633\u0627\u0639\u0629",
                "%d \u0633\u0627\u0639\u0629",
            ],
            d: [
                "\u0623\u0642\u0644 \u0645\u0646 \u064a\u0648\u0645",
                "\u064a\u0648\u0645 \u0648\u0627\u062d\u062f",
                [
                    "\u064a\u0648\u0645\u0627\u0646",
                    "\u064a\u0648\u0645\u064a\u0646",
                ],
                "%d \u0623\u064a\u0627\u0645",
                "%d \u064a\u0648\u0645\u064b\u0627",
                "%d \u064a\u0648\u0645",
            ],
            M: [
                "\u0623\u0642\u0644 \u0645\u0646 \u0634\u0647\u0631",
                "\u0634\u0647\u0631 \u0648\u0627\u062d\u062f",
                [
                    "\u0634\u0647\u0631\u0627\u0646",
                    "\u0634\u0647\u0631\u064a\u0646",
                ],
                "%d \u0623\u0634\u0647\u0631",
                "%d \u0634\u0647\u0631\u0627",
                "%d \u0634\u0647\u0631",
            ],
            y: [
                "\u0623\u0642\u0644 \u0645\u0646 \u0639\u0627\u0645",
                "\u0639\u0627\u0645 \u0648\u0627\u062d\u062f",
                [
                    "\u0639\u0627\u0645\u0627\u0646",
                    "\u0639\u0627\u0645\u064a\u0646",
                ],
                "%d \u0623\u0639\u0648\u0627\u0645",
                "%d \u0639\u0627\u0645\u064b\u0627",
                "%d \u0639\u0627\u0645",
            ],
        },
        pe = [
            "\u064a\u0646\u0627\u064a\u0631",
            "\u0641\u0628\u0631\u0627\u064a\u0631",
            "\u0645\u0627\u0631\u0633",
            "\u0623\u0628\u0631\u064a\u0644",
            "\u0645\u0627\u064a\u0648",
            "\u064a\u0648\u0646\u064a\u0648",
            "\u064a\u0648\u0644\u064a\u0648",
            "\u0623\u063a\u0633\u0637\u0633",
            "\u0633\u0628\u062a\u0645\u0628\u0631",
            "\u0623\u0643\u062a\u0648\u0628\u0631",
            "\u0646\u0648\u0641\u0645\u0628\u0631",
            "\u062f\u064a\u0633\u0645\u0628\u0631",
        ],
        It =
            (M.defineLocale("ar-ly", {
                months: pe,
                monthsShort: pe,
                weekdays:
                    "\u0627\u0644\u0623\u062d\u062f_\u0627\u0644\u0625\u062b\u0646\u064a\u0646_\u0627\u0644\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062e\u0645\u064a\u0633_\u0627\u0644\u062c\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062a".split(
                        "_"
                    ),
                weekdaysShort:
                    "\u0623\u062d\u062f_\u0625\u062b\u0646\u064a\u0646_\u062b\u0644\u0627\u062b\u0627\u0621_\u0623\u0631\u0628\u0639\u0627\u0621_\u062e\u0645\u064a\u0633_\u062c\u0645\u0639\u0629_\u0633\u0628\u062a".split(
                        "_"
                    ),
                weekdaysMin:
                    "\u062d_\u0646_\u062b_\u0631_\u062e_\u062c_\u0633".split(
                        "_"
                    ),
                weekdaysParseExact: !0,
                longDateFormat: {
                    LT: "HH:mm",
                    LTS: "HH:mm:ss",
                    L: "D/\u200fM/\u200fYYYY",
                    LL: "D MMMM YYYY",
                    LLL: "D MMMM YYYY HH:mm",
                    LLLL: "dddd D MMMM YYYY HH:mm",
                },
                meridiemParse: /\u0635|\u0645/,
                isPM: function (e) {
                    return "\u0645" === e;
                },
                meridiem: function (e, a, t) {
                    return e < 12 ? "\u0635" : "\u0645";
                },
                calendar: {
                    sameDay:
                        "[\u0627\u0644\u064a\u0648\u0645 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",
                    nextDay:
                        "[\u063a\u062f\u064b\u0627 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",
                    nextWeek:
                        "dddd [\u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",
                    lastDay:
                        "[\u0623\u0645\u0633 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",
                    lastWeek:
                        "dddd [\u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",
                    sameElse: "L",
                },
                relativeTime: {
                    future: "\u0628\u0639\u062f %s",
                    past: "\u0645\u0646\u0630 %s",
                    s: v("s"),
                    ss: v("s"),
                    m: v("m"),
                    mm: v("m"),
                    h: v("h"),
                    hh: v("h"),
                    d: v("d"),
                    dd: v("d"),
                    M: v("M"),
                    MM: v("M"),
                    y: v("y"),
                    yy: v("y"),
                },
                preparse: function (e) {
                    return e.replace(/\u060c/g, ",");
                },
                postformat: function (e) {
                    return e
                        .replace(/\d/g, function (e) {
                            return Rt[e];
                        })
                        .replace(/,/g, "\u060c");
                },
                week: { dow: 6, doy: 12 },
            }),
            M.defineLocale("ar-ma", {
                months: "\u064a\u0646\u0627\u064a\u0631_\u0641\u0628\u0631\u0627\u064a\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064a\u0644_\u0645\u0627\u064a_\u064a\u0648\u0646\u064a\u0648_\u064a\u0648\u0644\u064a\u0648\u0632_\u063a\u0634\u062a_\u0634\u062a\u0646\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0646\u0628\u0631_\u062f\u062c\u0646\u0628\u0631".split(
                    "_"
                ),
                monthsShort:
                    "\u064a\u0646\u0627\u064a\u0631_\u0641\u0628\u0631\u0627\u064a\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064a\u0644_\u0645\u0627\u064a_\u064a\u0648\u0646\u064a\u0648_\u064a\u0648\u0644\u064a\u0648\u0632_\u063a\u0634\u062a_\u0634\u062a\u0646\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0646\u0628\u0631_\u062f\u062c\u0646\u0628\u0631".split(
                        "_"
                    ),
                weekdays:
                    "\u0627\u0644\u0623\u062d\u062f_\u0627\u0644\u0625\u062b\u0646\u064a\u0646_\u0627\u0644\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062e\u0645\u064a\u0633_\u0627\u0644\u062c\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062a".split(
                        "_"
                    ),
                weekdaysShort:
                    "\u0627\u062d\u062f_\u0627\u062b\u0646\u064a\u0646_\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0631\u0628\u0639\u0627\u0621_\u062e\u0645\u064a\u0633_\u062c\u0645\u0639\u0629_\u0633\u0628\u062a".split(
                        "_"
                    ),
                weekdaysMin:
                    "\u062d_\u0646_\u062b_\u0631_\u062e_\u062c_\u0633".split(
                        "_"
                    ),
                weekdaysParseExact: !0,
                longDateFormat: {
                    LT: "HH:mm",
                    LTS: "HH:mm:ss",
                    L: "DD/MM/YYYY",
                    LL: "D MMMM YYYY",
                    LLL: "D MMMM YYYY HH:mm",
                    LLLL: "dddd D MMMM YYYY HH:mm",
                },
                calendar: {
                    sameDay:
                        "[\u0627\u0644\u064a\u0648\u0645 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
                    nextDay:
                        "[\u063a\u062f\u0627 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
                    nextWeek:
                        "dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
                    lastDay:
                        "[\u0623\u0645\u0633 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
                    lastWeek:
                        "dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
                    sameElse: "L",
                },
                relativeTime: {
                    future: "\u0641\u064a %s",
                    past: "\u0645\u0646\u0630 %s",
                    s: "\u062b\u0648\u0627\u0646",
                    ss: "%d \u062b\u0627\u0646\u064a\u0629",
                    m: "\u062f\u0642\u064a\u0642\u0629",
                    mm: "%d \u062f\u0642\u0627\u0626\u0642",
                    h: "\u0633\u0627\u0639\u0629",
                    hh: "%d \u0633\u0627\u0639\u0627\u062a",
                    d: "\u064a\u0648\u0645",
                    dd: "%d \u0623\u064a\u0627\u0645",
                    M: "\u0634\u0647\u0631",
                    MM: "%d \u0623\u0634\u0647\u0631",
                    y: "\u0633\u0646\u0629",
                    yy: "%d \u0633\u0646\u0648\u0627\u062a",
                },
                week: { dow: 1, doy: 4 },
            }),
            {
                1: "\u0661",
                2: "\u0662",
                3: "\u0663",
                4: "\u0664",
                5: "\u0665",
                6: "\u0666",
                7: "\u0667",
                8: "\u0668",
                9: "\u0669",
                0: "\u0660",
            }),
        Ut = {
            "\u0661": "1",
            "\u0662": "2",
            "\u0663": "3",
            "\u0664": "4",
            "\u0665": "5",
            "\u0666": "6",
            "\u0667": "7",
            "\u0668": "8",
            "\u0669": "9",
            "\u0660": "0",
        },
        Gt =
            (M.defineLocale("ar-sa", {
                months: "\u064a\u0646\u0627\u064a\u0631_\u0641\u0628\u0631\u0627\u064a\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064a\u0644_\u0645\u0627\u064a\u0648_\u064a\u0648\u0646\u064a\u0648_\u064a\u0648\u0644\u064a\u0648_\u0623\u063a\u0633\u0637\u0633_\u0633\u0628\u062a\u0645\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0641\u0645\u0628\u0631_\u062f\u064a\u0633\u0645\u0628\u0631".split(
                    "_"
                ),
                monthsShort:
                    "\u064a\u0646\u0627\u064a\u0631_\u0641\u0628\u0631\u0627\u064a\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064a\u0644_\u0645\u0627\u064a\u0648_\u064a\u0648\u0646\u064a\u0648_\u064a\u0648\u0644\u064a\u0648_\u0623\u063a\u0633\u0637\u0633_\u0633\u0628\u062a\u0645\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0641\u0645\u0628\u0631_\u062f\u064a\u0633\u0645\u0628\u0631".split(
                        "_"
                    ),
                weekdays:
                    "\u0627\u0644\u0623\u062d\u062f_\u0627\u0644\u0625\u062b\u0646\u064a\u0646_\u0627\u0644\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062e\u0645\u064a\u0633_\u0627\u0644\u062c\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062a".split(
                        "_"
                    ),
                weekdaysShort:
                    "\u0623\u062d\u062f_\u0625\u062b\u0646\u064a\u0646_\u062b\u0644\u0627\u062b\u0627\u0621_\u0623\u0631\u0628\u0639\u0627\u0621_\u062e\u0645\u064a\u0633_\u062c\u0645\u0639\u0629_\u0633\u0628\u062a".split(
                        "_"
                    ),
                weekdaysMin:
                    "\u062d_\u0646_\u062b_\u0631_\u062e_\u062c_\u0633".split(
                        "_"
                    ),
                weekdaysParseExact: !0,
                longDateFormat: {
                    LT: "HH:mm",
                    LTS: "HH:mm:ss",
                    L: "DD/MM/YYYY",
                    LL: "D MMMM YYYY",
                    LLL: "D MMMM YYYY HH:mm",
                    LLLL: "dddd D MMMM YYYY HH:mm",
                },
                meridiemParse: /\u0635|\u0645/,
                isPM: function (e) {
                    return "\u0645" === e;
                },
                meridiem: function (e, a, t) {
                    return e < 12 ? "\u0635" : "\u0645";
                },
                calendar: {
                    sameDay:
                        "[\u0627\u0644\u064a\u0648\u0645 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
                    nextDay:
                        "[\u063a\u062f\u0627 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
                    nextWeek:
                        "dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
                    lastDay:
                        "[\u0623\u0645\u0633 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
                    lastWeek:
                        "dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
                    sameElse: "L",
                },
                relativeTime: {
                    future: "\u0641\u064a %s",
                    past: "\u0645\u0646\u0630 %s",
                    s: "\u062b\u0648\u0627\u0646",
                    ss: "%d \u062b\u0627\u0646\u064a\u0629",
                    m: "\u062f\u0642\u064a\u0642\u0629",
                    mm: "%d \u062f\u0642\u0627\u0626\u0642",
                    h: "\u0633\u0627\u0639\u0629",
                    hh: "%d \u0633\u0627\u0639\u0627\u062a",
                    d: "\u064a\u0648\u0645",
                    dd: "%d \u0623\u064a\u0627\u0645",
                    M: "\u0634\u0647\u0631",
                    MM: "%d \u0623\u0634\u0647\u0631",
                    y: "\u0633\u0646\u0629",
                    yy: "%d \u0633\u0646\u0648\u0627\u062a",
                },
                preparse: function (e) {
                    return e
                        .replace(
                            /[\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669\u0660]/g,
                            function (e) {
                                return Ut[e];
                            }
                        )
                        .replace(/\u060c/g, ",");
                },
                postformat: function (e) {
                    return e
                        .replace(/\d/g, function (e) {
                            return It[e];
                        })
                        .replace(/,/g, "\u060c");
                },
                week: { dow: 0, doy: 6 },
            }),
            M.defineLocale("ar-tn", {
                months: "\u062c\u0627\u0646\u0641\u064a_\u0641\u064a\u0641\u0631\u064a_\u0645\u0627\u0631\u0633_\u0623\u0641\u0631\u064a\u0644_\u0645\u0627\u064a_\u062c\u0648\u0627\u0646_\u062c\u0648\u064a\u0644\u064a\u0629_\u0623\u0648\u062a_\u0633\u0628\u062a\u0645\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0641\u0645\u0628\u0631_\u062f\u064a\u0633\u0645\u0628\u0631".split(
                    "_"
                ),
                monthsShort:
                    "\u062c\u0627\u0646\u0641\u064a_\u0641\u064a\u0641\u0631\u064a_\u0645\u0627\u0631\u0633_\u0623\u0641\u0631\u064a\u0644_\u0645\u0627\u064a_\u062c\u0648\u0627\u0646_\u062c\u0648\u064a\u0644\u064a\u0629_\u0623\u0648\u062a_\u0633\u0628\u062a\u0645\u0628\u0631_\u0623\u0643\u062a\u0648\u0628\u0631_\u0646\u0648\u0641\u0645\u0628\u0631_\u062f\u064a\u0633\u0645\u0628\u0631".split(
                        "_"
                    ),
                weekdays:
                    "\u0627\u0644\u0623\u062d\u062f_\u0627\u0644\u0625\u062b\u0646\u064a\u0646_\u0627\u0644\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062e\u0645\u064a\u0633_\u0627\u0644\u062c\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062a".split(
                        "_"
                    ),
                weekdaysShort:
                    "\u0623\u062d\u062f_\u0625\u062b\u0646\u064a\u0646_\u062b\u0644\u0627\u062b\u0627\u0621_\u0623\u0631\u0628\u0639\u0627\u0621_\u062e\u0645\u064a\u0633_\u062c\u0645\u0639\u0629_\u0633\u0628\u062a".split(
                        "_"
                    ),
                weekdaysMin:
                    "\u062d_\u0646_\u062b_\u0631_\u062e_\u062c_\u0633".split(
                        "_"
                    ),
                weekdaysParseExact: !0,
                longDateFormat: {
                    LT: "HH:mm",
                    LTS: "HH:mm:ss",
                    L: "DD/MM/YYYY",
                    LL: "D MMMM YYYY",
                    LLL: "D MMMM YYYY HH:mm",
                    LLLL: "dddd D MMMM YYYY HH:mm",
                },
                calendar: {
                    sameDay:
                        "[\u0627\u0644\u064a\u0648\u0645 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
                    nextDay:
                        "[\u063a\u062f\u0627 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
                    nextWeek:
                        "dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
                    lastDay:
                        "[\u0623\u0645\u0633 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
                    lastWeek:
                        "dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
                    sameElse: "L",
                },
                relativeTime: {
                    future: "\u0641\u064a %s",
                    past: "\u0645\u0646\u0630 %s",
                    s: "\u062b\u0648\u0627\u0646",
                    ss: "%d \u062b\u0627\u0646\u064a\u0629",
                    m: "\u062f\u0642\u064a\u0642\u0629",
                    mm: "%d \u062f\u0642\u0627\u0626\u0642",
                    h: "\u0633\u0627\u0639\u0629",
                    hh: "%d \u0633\u0627\u0639\u0627\u062a",
                    d: "\u064a\u0648\u0645",
                    dd: "%d \u0623\u064a\u0627\u0645",
                    M: "\u0634\u0647\u0631",
                    MM: "%d \u0623\u0634\u0647\u0631",
                    y: "\u0633\u0646\u0629",
                    yy: "%d \u0633\u0646\u0648\u0627\u062a",
                },
                week: { dow: 1, doy: 4 },
            }),
            {
                1: "\u0661",
                2: "\u0662",
                3: "\u0663",
                4: "\u0664",
                5: "\u0665",
                6: "\u0666",
                7: "\u0667",
                8: "\u0668",
                9: "\u0669",
                0: "\u0660",
            }),
        Vt = {
            "\u0661": "1",
            "\u0662": "2",
            "\u0663": "3",
            "\u0664": "4",
            "\u0665": "5",
            "\u0666": "6",
            "\u0667": "7",
            "\u0668": "8",
            "\u0669": "9",
            "\u0660": "0",
        },
        Bt = {
            s: [
                "\u0623\u0642\u0644 \u0645\u0646 \u062b\u0627\u0646\u064a\u0629",
                "\u062b\u0627\u0646\u064a\u0629 \u0648\u0627\u062d\u062f\u0629",
                [
                    "\u062b\u0627\u0646\u064a\u062a\u0627\u0646",
                    "\u062b\u0627\u0646\u064a\u062a\u064a\u0646",
                ],
                "%d \u062b\u0648\u0627\u0646",
                "%d \u062b\u0627\u0646\u064a\u0629",
                "%d \u062b\u0627\u0646\u064a\u0629",
            ],
            m: [
                "\u0623\u0642\u0644 \u0645\u0646 \u062f\u0642\u064a\u0642\u0629",
                "\u062f\u0642\u064a\u0642\u0629 \u0648\u0627\u062d\u062f\u0629",
                [
                    "\u062f\u0642\u064a\u0642\u062a\u0627\u0646",
                    "\u062f\u0642\u064a\u0642\u062a\u064a\u0646",
                ],
                "%d \u062f\u0642\u0627\u0626\u0642",
                "%d \u062f\u0642\u064a\u0642\u0629",
                "%d \u062f\u0642\u064a\u0642\u0629",
            ],
            h: [
                "\u0623\u0642\u0644 \u0645\u0646 \u0633\u0627\u0639\u0629",
                "\u0633\u0627\u0639\u0629 \u0648\u0627\u062d\u062f\u0629",
                [
                    "\u0633\u0627\u0639\u062a\u0627\u0646",
                    "\u0633\u0627\u0639\u062a\u064a\u0646",
                ],
                "%d \u0633\u0627\u0639\u0627\u062a",
                "%d \u0633\u0627\u0639\u0629",
                "%d \u0633\u0627\u0639\u0629",
            ],
            d: [
                "\u0623\u0642\u0644 \u0645\u0646 \u064a\u0648\u0645",
                "\u064a\u0648\u0645 \u0648\u0627\u062d\u062f",
                [
                    "\u064a\u0648\u0645\u0627\u0646",
                    "\u064a\u0648\u0645\u064a\u0646",
                ],
                "%d \u0623\u064a\u0627\u0645",
                "%d \u064a\u0648\u0645\u064b\u0627",
                "%d \u064a\u0648\u0645",
            ],
            M: [
                "\u0623\u0642\u0644 \u0645\u0646 \u0634\u0647\u0631",
                "\u0634\u0647\u0631 \u0648\u0627\u062d\u062f",
                [
                    "\u0634\u0647\u0631\u0627\u0646",
                    "\u0634\u0647\u0631\u064a\u0646",
                ],
                "%d \u0623\u0634\u0647\u0631",
                "%d \u0634\u0647\u0631\u0627",
                "%d \u0634\u0647\u0631",
            ],
            y: [
                "\u0623\u0642\u0644 \u0645\u0646 \u0639\u0627\u0645",
                "\u0639\u0627\u0645 \u0648\u0627\u062d\u062f",
                [
                    "\u0639\u0627\u0645\u0627\u0646",
                    "\u0639\u0627\u0645\u064a\u0646",
                ],
                "%d \u0623\u0639\u0648\u0627\u0645",
                "%d \u0639\u0627\u0645\u064b\u0627",
                "%d \u0639\u0627\u0645",
            ],
        },
        Ne = [
            "\u064a\u0646\u0627\u064a\u0631",
            "\u0641\u0628\u0631\u0627\u064a\u0631",
            "\u0645\u0627\u0631\u0633",
            "\u0623\u0628\u0631\u064a\u0644",
            "\u0645\u0627\u064a\u0648",
            "\u064a\u0648\u0646\u064a\u0648",
            "\u064a\u0648\u0644\u064a\u0648",
            "\u0623\u063a\u0633\u0637\u0633",
            "\u0633\u0628\u062a\u0645\u0628\u0631",
            "\u0623\u0643\u062a\u0648\u0628\u0631",
            "\u0646\u0648\u0641\u0645\u0628\u0631",
            "\u062f\u064a\u0633\u0645\u0628\u0631",
        ],
        Kt =
            (M.defineLocale("ar", {
                months: Ne,
                monthsShort: Ne,
                weekdays:
                    "\u0627\u0644\u0623\u062d\u062f_\u0627\u0644\u0625\u062b\u0646\u064a\u0646_\u0627\u0644\u062b\u0644\u0627\u062b\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062e\u0645\u064a\u0633_\u0627\u0644\u062c\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062a".split(
                        "_"
                    ),
                weekdaysShort:
                    "\u0623\u062d\u062f_\u0625\u062b\u0646\u064a\u0646_\u062b\u0644\u0627\u062b\u0627\u0621_\u0623\u0631\u0628\u0639\u0627\u0621_\u062e\u0645\u064a\u0633_\u062c\u0645\u0639\u0629_\u0633\u0628\u062a".split(
                        "_"
                    ),
                weekdaysMin:
                    "\u062d_\u0646_\u062b_\u0631_\u062e_\u062c_\u0633".split(
                        "_"
                    ),
                weekdaysParseExact: !0,
                longDateFormat: {
                    LT: "HH:mm",
                    LTS: "HH:mm:ss",
                    L: "D/\u200fM/\u200fYYYY",
                    LL: "D MMMM YYYY",
                    LLL: "D MMMM YYYY HH:mm",
                    LLLL: "dddd D MMMM YYYY HH:mm",
                },
                meridiemParse: /\u0635|\u0645/,
                isPM: function (e) {
                    return "\u0645" === e;
                },
                meridiem: function (e, a, t) {
                    return e < 12 ? "\u0635" : "\u0645";
                },
                calendar: {
                    sameDay:
                        "[\u0627\u0644\u064a\u0648\u0645 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",
                    nextDay:
                        "[\u063a\u062f\u064b\u0627 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",
                    nextWeek:
                        "dddd [\u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",
                    lastDay:
                        "[\u0623\u0645\u0633 \u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",
                    lastWeek:
                        "dddd [\u0639\u0646\u062f \u0627\u0644\u0633\u0627\u0639\u0629] LT",
                    sameElse: "L",
                },
                relativeTime: {
                    future: "\u0628\u0639\u062f %s",
                    past: "\u0645\u0646\u0630 %s",
                    s: j("s"),
                    ss: j("s"),
                    m: j("m"),
                    mm: j("m"),
                    h: j("h"),
                    hh: j("h"),
                    d: j("d"),
                    dd: j("d"),
                    M: j("M"),
                    MM: j("M"),
                    y: j("y"),
                    yy: j("y"),
                },
                preparse: function (e) {
                    return e
                        .replace(
                            /[\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669\u0660]/g,
                            function (e) {
                                return Vt[e];
                            }
                        )
                        .replace(/\u060c/g, ",");
                },
                postformat: function (e) {
                    return e
                        .replace(/\d/g, function (e) {
                            return Gt[e];
                        })
                        .replace(/,/g, "\u060c");
                },
                week: { dow: 6, doy: 12 },
            }),
            {
                1: "-inci",
                5: "-inci",
                8: "-inci",
                70: "-inci",
                80: "-inci",
                2: "-nci",
                7: "-nci",
                20: "-nci",
                50: "-nci",
                3: "-\xfcnc\xfc",
                4: "-\xfcnc\xfc",
                100: "-\xfcnc\xfc",
                6: "-nc\u0131",
                9: "-uncu",
                10: "-uncu",
                30: "-uncu",
                60: "-\u0131nc\u0131",
                90: "-\u0131nc\u0131",
            });
    function qt(e, a, t) {
        return "m" === t
            ? a
                ? "\u0445\u0432\u0456\u043b\u0456\u043d\u0430"
                : "\u0445\u0432\u0456\u043b\u0456\u043d\u0443"
            : "h" === t
            ? a
                ? "\u0433\u0430\u0434\u0437\u0456\u043d\u0430"
                : "\u0433\u0430\u0434\u0437\u0456\u043d\u0443"
            : e +
              " " +
              ((e = +e),
              (a = (a = {
                  ss: a
                      ? "\u0441\u0435\u043a\u0443\u043d\u0434\u0430_\u0441\u0435\u043a\u0443\u043d\u0434\u044b_\u0441\u0435\u043a\u0443\u043d\u0434"
                      : "\u0441\u0435\u043a\u0443\u043d\u0434\u0443_\u0441\u0435\u043a\u0443\u043d\u0434\u044b_\u0441\u0435\u043a\u0443\u043d\u0434",
                  mm: a
                      ? "\u0445\u0432\u0456\u043b\u0456\u043d\u0430_\u0445\u0432\u0456\u043b\u0456\u043d\u044b_\u0445\u0432\u0456\u043b\u0456\u043d"
                      : "\u0445\u0432\u0456\u043b\u0456\u043d\u0443_\u0445\u0432\u0456\u043b\u0456\u043d\u044b_\u0445\u0432\u0456\u043b\u0456\u043d",
                  hh: a
                      ? "\u0433\u0430\u0434\u0437\u0456\u043d\u0430_\u0433\u0430\u0434\u0437\u0456\u043d\u044b_\u0433\u0430\u0434\u0437\u0456\u043d"
                      : "\u0433\u0430\u0434\u0437\u0456\u043d\u0443_\u0433\u0430\u0434\u0437\u0456\u043d\u044b_\u0433\u0430\u0434\u0437\u0456\u043d",
                  dd: "\u0434\u0437\u0435\u043d\u044c_\u0434\u043d\u0456_\u0434\u0437\u0451\u043d",
                  MM: "\u043c\u0435\u0441\u044f\u0446_\u043c\u0435\u0441\u044f\u0446\u044b_\u043c\u0435\u0441\u044f\u0446\u0430\u045e",
                  yy: "\u0433\u043e\u0434_\u0433\u0430\u0434\u044b_\u0433\u0430\u0434\u043e\u045e",
              }[t]).split("_")),
              e % 10 == 1 && e % 100 != 11
                  ? a[0]
                  : 2 <= e % 10 &&
                    e % 10 <= 4 &&
                    (e % 100 < 10 || 20 <= e % 100)
                  ? a[1]
                  : a[2]);
    }
    M.defineLocale("az", {
        months: "yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr".split(
            "_"
        ),
        monthsShort: "yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek".split(
            "_"
        ),
        weekdays:
            "Bazar_Bazar ert\u0259si_\xc7\u0259r\u015f\u0259nb\u0259 ax\u015fam\u0131_\xc7\u0259r\u015f\u0259nb\u0259_C\xfcm\u0259 ax\u015fam\u0131_C\xfcm\u0259_\u015e\u0259nb\u0259".split(
                "_"
            ),
        weekdaysShort:
            "Baz_BzE_\xc7Ax_\xc7\u0259r_CAx_C\xfcm_\u015e\u0259n".split("_"),
        weekdaysMin: "Bz_BE_\xc7A_\xc7\u0259_CA_C\xfc_\u015e\u0259".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm",
        },
        calendar: {
            sameDay: "[bug\xfcn saat] LT",
            nextDay: "[sabah saat] LT",
            nextWeek: "[g\u0259l\u0259n h\u0259ft\u0259] dddd [saat] LT",
            lastDay: "[d\xfcn\u0259n] LT",
            lastWeek: "[ke\xe7\u0259n h\u0259ft\u0259] dddd [saat] LT",
            sameElse: "L",
        },
        relativeTime: {
            future: "%s sonra",
            past: "%s \u0259vv\u0259l",
            s: "bir ne\xe7\u0259 saniy\u0259",
            ss: "%d saniy\u0259",
            m: "bir d\u0259qiq\u0259",
            mm: "%d d\u0259qiq\u0259",
            h: "bir saat",
            hh: "%d saat",
            d: "bir g\xfcn",
            dd: "%d g\xfcn",
            M: "bir ay",
            MM: "%d ay",
            y: "bir il",
            yy: "%d il",
        },
        meridiemParse: /gec\u0259|s\u0259h\u0259r|g\xfcnd\xfcz|ax\u015fam/,
        isPM: function (e) {
            return /^(g\xfcnd\xfcz|ax\u015fam)$/.test(e);
        },
        meridiem: function (e, a, t) {
            return e < 4
                ? "gec\u0259"
                : e < 12
                ? "s\u0259h\u0259r"
                : e < 17
                ? "g\xfcnd\xfcz"
                : "ax\u015fam";
        },
        dayOfMonthOrdinalParse:
            /\d{1,2}-(\u0131nc\u0131|inci|nci|\xfcnc\xfc|nc\u0131|uncu)/,
        ordinal: function (e) {
            if (0 === e) return e + "-\u0131nc\u0131";
            var a = e % 10;
            return (
                e + (Kt[a] || Kt[(e % 100) - a] || Kt[100 <= e ? 100 : null])
            );
        },
        week: { dow: 1, doy: 7 },
    }),
        M.defineLocale("be", {
            months: {
                format: "\u0441\u0442\u0443\u0434\u0437\u0435\u043d\u044f_\u043b\u044e\u0442\u0430\u0433\u0430_\u0441\u0430\u043a\u0430\u0432\u0456\u043a\u0430_\u043a\u0440\u0430\u0441\u0430\u0432\u0456\u043a\u0430_\u0442\u0440\u0430\u045e\u043d\u044f_\u0447\u044d\u0440\u0432\u0435\u043d\u044f_\u043b\u0456\u043f\u0435\u043d\u044f_\u0436\u043d\u0456\u045e\u043d\u044f_\u0432\u0435\u0440\u0430\u0441\u043d\u044f_\u043a\u0430\u0441\u0442\u0440\u044b\u0447\u043d\u0456\u043a\u0430_\u043b\u0456\u0441\u0442\u0430\u043f\u0430\u0434\u0430_\u0441\u043d\u0435\u0436\u043d\u044f".split(
                    "_"
                ),
                standalone:
                    "\u0441\u0442\u0443\u0434\u0437\u0435\u043d\u044c_\u043b\u044e\u0442\u044b_\u0441\u0430\u043a\u0430\u0432\u0456\u043a_\u043a\u0440\u0430\u0441\u0430\u0432\u0456\u043a_\u0442\u0440\u0430\u0432\u0435\u043d\u044c_\u0447\u044d\u0440\u0432\u0435\u043d\u044c_\u043b\u0456\u043f\u0435\u043d\u044c_\u0436\u043d\u0456\u0432\u0435\u043d\u044c_\u0432\u0435\u0440\u0430\u0441\u0435\u043d\u044c_\u043a\u0430\u0441\u0442\u0440\u044b\u0447\u043d\u0456\u043a_\u043b\u0456\u0441\u0442\u0430\u043f\u0430\u0434_\u0441\u043d\u0435\u0436\u0430\u043d\u044c".split(
                        "_"
                    ),
            },
            monthsShort:
                "\u0441\u0442\u0443\u0434_\u043b\u044e\u0442_\u0441\u0430\u043a_\u043a\u0440\u0430\u0441_\u0442\u0440\u0430\u0432_\u0447\u044d\u0440\u0432_\u043b\u0456\u043f_\u0436\u043d\u0456\u0432_\u0432\u0435\u0440_\u043a\u0430\u0441\u0442_\u043b\u0456\u0441\u0442_\u0441\u043d\u0435\u0436".split(
                    "_"
                ),
            weekdays: {
                format: "\u043d\u044f\u0434\u0437\u0435\u043b\u044e_\u043f\u0430\u043d\u044f\u0434\u0437\u0435\u043b\u0430\u043a_\u0430\u045e\u0442\u043e\u0440\u0430\u043a_\u0441\u0435\u0440\u0430\u0434\u0443_\u0447\u0430\u0446\u0432\u0435\u0440_\u043f\u044f\u0442\u043d\u0456\u0446\u0443_\u0441\u0443\u0431\u043e\u0442\u0443".split(
                    "_"
                ),
                standalone:
                    "\u043d\u044f\u0434\u0437\u0435\u043b\u044f_\u043f\u0430\u043d\u044f\u0434\u0437\u0435\u043b\u0430\u043a_\u0430\u045e\u0442\u043e\u0440\u0430\u043a_\u0441\u0435\u0440\u0430\u0434\u0430_\u0447\u0430\u0446\u0432\u0435\u0440_\u043f\u044f\u0442\u043d\u0456\u0446\u0430_\u0441\u0443\u0431\u043e\u0442\u0430".split(
                        "_"
                    ),
                isFormat:
                    /\[ ?[\u0423\u0443\u045e] ?(?:\u043c\u0456\u043d\u0443\u043b\u0443\u044e|\u043d\u0430\u0441\u0442\u0443\u043f\u043d\u0443\u044e)? ?\] ?dddd/,
            },
            weekdaysShort:
                "\u043d\u0434_\u043f\u043d_\u0430\u0442_\u0441\u0440_\u0447\u0446_\u043f\u0442_\u0441\u0431".split(
                    "_"
                ),
            weekdaysMin:
                "\u043d\u0434_\u043f\u043d_\u0430\u0442_\u0441\u0440_\u0447\u0446_\u043f\u0442_\u0441\u0431".split(
                    "_"
                ),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD.MM.YYYY",
                LL: "D MMMM YYYY \u0433.",
                LLL: "D MMMM YYYY \u0433., HH:mm",
                LLLL: "dddd, D MMMM YYYY \u0433., HH:mm",
            },
            calendar: {
                sameDay: "[\u0421\u0451\u043d\u043d\u044f \u045e] LT",
                nextDay: "[\u0417\u0430\u045e\u0442\u0440\u0430 \u045e] LT",
                lastDay: "[\u0423\u0447\u043e\u0440\u0430 \u045e] LT",
                nextWeek: function () {
                    return "[\u0423] dddd [\u045e] LT";
                },
                lastWeek: function () {
                    switch (this.day()) {
                        case 0:
                        case 3:
                        case 5:
                        case 6:
                            return "[\u0423 \u043c\u0456\u043d\u0443\u043b\u0443\u044e] dddd [\u045e] LT";
                        case 1:
                        case 2:
                        case 4:
                            return "[\u0423 \u043c\u0456\u043d\u0443\u043b\u044b] dddd [\u045e] LT";
                    }
                },
                sameElse: "L",
            },
            relativeTime: {
                future: "\u043f\u0440\u0430\u0437 %s",
                past: "%s \u0442\u0430\u043c\u0443",
                s: "\u043d\u0435\u043a\u0430\u043b\u044c\u043a\u0456 \u0441\u0435\u043a\u0443\u043d\u0434",
                m: qt,
                mm: qt,
                h: qt,
                hh: qt,
                d: "\u0434\u0437\u0435\u043d\u044c",
                dd: qt,
                M: "\u043c\u0435\u0441\u044f\u0446",
                MM: qt,
                y: "\u0433\u043e\u0434",
                yy: qt,
            },
            meridiemParse:
                /\u043d\u043e\u0447\u044b|\u0440\u0430\u043d\u0456\u0446\u044b|\u0434\u043d\u044f|\u0432\u0435\u0447\u0430\u0440\u0430/,
            isPM: function (e) {
                return /^(\u0434\u043d\u044f|\u0432\u0435\u0447\u0430\u0440\u0430)$/.test(
                    e
                );
            },
            meridiem: function (e, a, t) {
                return e < 4
                    ? "\u043d\u043e\u0447\u044b"
                    : e < 12
                    ? "\u0440\u0430\u043d\u0456\u0446\u044b"
                    : e < 17
                    ? "\u0434\u043d\u044f"
                    : "\u0432\u0435\u0447\u0430\u0440\u0430";
            },
            dayOfMonthOrdinalParse: /\d{1,2}-(\u0456|\u044b|\u0433\u0430)/,
            ordinal: function (e, a) {
                switch (a) {
                    case "M":
                    case "d":
                    case "DDD":
                    case "w":
                    case "W":
                        return (e % 10 != 2 && e % 10 != 3) ||
                            e % 100 == 12 ||
                            e % 100 == 13
                            ? e + "-\u044b"
                            : e + "-\u0456";
                    case "D":
                        return e + "-\u0433\u0430";
                    default:
                        return e;
                }
            },
            week: { dow: 1, doy: 7 },
        }),
        M.defineLocale("bg", {
            months: "\u044f\u043d\u0443\u0430\u0440\u0438_\u0444\u0435\u0432\u0440\u0443\u0430\u0440\u0438_\u043c\u0430\u0440\u0442_\u0430\u043f\u0440\u0438\u043b_\u043c\u0430\u0439_\u044e\u043d\u0438_\u044e\u043b\u0438_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043f\u0442\u0435\u043c\u0432\u0440\u0438_\u043e\u043a\u0442\u043e\u043c\u0432\u0440\u0438_\u043d\u043e\u0435\u043c\u0432\u0440\u0438_\u0434\u0435\u043a\u0435\u043c\u0432\u0440\u0438".split(
                "_"
            ),
            monthsShort:
                "\u044f\u043d\u0443_\u0444\u0435\u0432_\u043c\u0430\u0440_\u0430\u043f\u0440_\u043c\u0430\u0439_\u044e\u043d\u0438_\u044e\u043b\u0438_\u0430\u0432\u0433_\u0441\u0435\u043f_\u043e\u043a\u0442_\u043d\u043e\u0435_\u0434\u0435\u043a".split(
                    "_"
                ),
            weekdays:
                "\u043d\u0435\u0434\u0435\u043b\u044f_\u043f\u043e\u043d\u0435\u0434\u0435\u043b\u043d\u0438\u043a_\u0432\u0442\u043e\u0440\u043d\u0438\u043a_\u0441\u0440\u044f\u0434\u0430_\u0447\u0435\u0442\u0432\u044a\u0440\u0442\u044a\u043a_\u043f\u0435\u0442\u044a\u043a_\u0441\u044a\u0431\u043e\u0442\u0430".split(
                    "_"
                ),
            weekdaysShort:
                "\u043d\u0435\u0434_\u043f\u043e\u043d_\u0432\u0442\u043e_\u0441\u0440\u044f_\u0447\u0435\u0442_\u043f\u0435\u0442_\u0441\u044a\u0431".split(
                    "_"
                ),
            weekdaysMin:
                "\u043d\u0434_\u043f\u043d_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043f\u0442_\u0441\u0431".split(
                    "_"
                ),
            longDateFormat: {
                LT: "H:mm",
                LTS: "H:mm:ss",
                L: "D.MM.YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY H:mm",
                LLLL: "dddd, D MMMM YYYY H:mm",
            },
            calendar: {
                sameDay: "[\u0414\u043d\u0435\u0441 \u0432] LT",
                nextDay: "[\u0423\u0442\u0440\u0435 \u0432] LT",
                nextWeek: "dddd [\u0432] LT",
                lastDay: "[\u0412\u0447\u0435\u0440\u0430 \u0432] LT",
                lastWeek: function () {
                    switch (this.day()) {
                        case 0:
                        case 3:
                        case 6:
                            return "[\u041c\u0438\u043d\u0430\u043b\u0430\u0442\u0430] dddd [\u0432] LT";
                        case 1:
                        case 2:
                        case 4:
                        case 5:
                            return "[\u041c\u0438\u043d\u0430\u043b\u0438\u044f] dddd [\u0432] LT";
                    }
                },
                sameElse: "L",
            },
            relativeTime: {
                future: "\u0441\u043b\u0435\u0434 %s",
                past: "\u043f\u0440\u0435\u0434\u0438 %s",
                s: "\u043d\u044f\u043a\u043e\u043b\u043a\u043e \u0441\u0435\u043a\u0443\u043d\u0434\u0438",
                ss: "%d \u0441\u0435\u043a\u0443\u043d\u0434\u0438",
                m: "\u043c\u0438\u043d\u0443\u0442\u0430",
                mm: "%d \u043c\u0438\u043d\u0443\u0442\u0438",
                h: "\u0447\u0430\u0441",
                hh: "%d \u0447\u0430\u0441\u0430",
                d: "\u0434\u0435\u043d",
                dd: "%d \u0434\u0435\u043d\u0430",
                w: "\u0441\u0435\u0434\u043c\u0438\u0446\u0430",
                ww: "%d \u0441\u0435\u0434\u043c\u0438\u0446\u0438",
                M: "\u043c\u0435\u0441\u0435\u0446",
                MM: "%d \u043c\u0435\u0441\u0435\u0446\u0430",
                y: "\u0433\u043e\u0434\u0438\u043d\u0430",
                yy: "%d \u0433\u043e\u0434\u0438\u043d\u0438",
            },
            dayOfMonthOrdinalParse:
                /\d{1,2}-(\u0435\u0432|\u0435\u043d|\u0442\u0438|\u0432\u0438|\u0440\u0438|\u043c\u0438)/,
            ordinal: function (e) {
                var a = e % 10,
                    t = e % 100;
                return 0 === e
                    ? e + "-\u0435\u0432"
                    : 0 == t
                    ? e + "-\u0435\u043d"
                    : 10 < t && t < 20
                    ? e + "-\u0442\u0438"
                    : 1 == a
                    ? e + "-\u0432\u0438"
                    : 2 == a
                    ? e + "-\u0440\u0438"
                    : 7 == a || 8 == a
                    ? e + "-\u043c\u0438"
                    : e + "-\u0442\u0438";
            },
            week: { dow: 1, doy: 7 },
        }),
        M.defineLocale("bm", {
            months: "Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_M\u025bkalo_Zuw\u025bnkalo_Zuluyekalo_Utikalo_S\u025btanburukalo_\u0254kut\u0254burukalo_Nowanburukalo_Desanburukalo".split(
                "_"
            ),
            monthsShort:
                "Zan_Few_Mar_Awi_M\u025b_Zuw_Zul_Uti_S\u025bt_\u0254ku_Now_Des".split(
                    "_"
                ),
            weekdays:
                "Kari_Nt\u025bn\u025bn_Tarata_Araba_Alamisa_Juma_Sibiri".split(
                    "_"
                ),
            weekdaysShort: "Kar_Nt\u025b_Tar_Ara_Ala_Jum_Sib".split("_"),
            weekdaysMin: "Ka_Nt_Ta_Ar_Al_Ju_Si".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "MMMM [tile] D [san] YYYY",
                LLL: "MMMM [tile] D [san] YYYY [l\u025br\u025b] HH:mm",
                LLLL: "dddd MMMM [tile] D [san] YYYY [l\u025br\u025b] HH:mm",
            },
            calendar: {
                sameDay: "[Bi l\u025br\u025b] LT",
                nextDay: "[Sini l\u025br\u025b] LT",
                nextWeek: "dddd [don l\u025br\u025b] LT",
                lastDay: "[Kunu l\u025br\u025b] LT",
                lastWeek: "dddd [t\u025bm\u025bnen l\u025br\u025b] LT",
                sameElse: "L",
            },
            relativeTime: {
                future: "%s k\u0254n\u0254",
                past: "a b\u025b %s b\u0254",
                s: "sanga dama dama",
                ss: "sekondi %d",
                m: "miniti kelen",
                mm: "miniti %d",
                h: "l\u025br\u025b kelen",
                hh: "l\u025br\u025b %d",
                d: "tile kelen",
                dd: "tile %d",
                M: "kalo kelen",
                MM: "kalo %d",
                y: "san kelen",
                yy: "san %d",
            },
            week: { dow: 1, doy: 4 },
        });
    var Zt = {
            1: "\u09e7",
            2: "\u09e8",
            3: "\u09e9",
            4: "\u09ea",
            5: "\u09eb",
            6: "\u09ec",
            7: "\u09ed",
            8: "\u09ee",
            9: "\u09ef",
            0: "\u09e6",
        },
        $t = {
            "\u09e7": "1",
            "\u09e8": "2",
            "\u09e9": "3",
            "\u09ea": "4",
            "\u09eb": "5",
            "\u09ec": "6",
            "\u09ed": "7",
            "\u09ee": "8",
            "\u09ef": "9",
            "\u09e6": "0",
        },
        Qt =
            (M.defineLocale("bn-bd", {
                months: "\u099c\u09be\u09a8\u09c1\u09df\u09be\u09b0\u09bf_\u09ab\u09c7\u09ac\u09cd\u09b0\u09c1\u09df\u09be\u09b0\u09bf_\u09ae\u09be\u09b0\u09cd\u099a_\u098f\u09aa\u09cd\u09b0\u09bf\u09b2_\u09ae\u09c7_\u099c\u09c1\u09a8_\u099c\u09c1\u09b2\u09be\u0987_\u0986\u0997\u09b8\u09cd\u099f_\u09b8\u09c7\u09aa\u09cd\u099f\u09c7\u09ae\u09cd\u09ac\u09b0_\u0985\u0995\u09cd\u099f\u09cb\u09ac\u09b0_\u09a8\u09ad\u09c7\u09ae\u09cd\u09ac\u09b0_\u09a1\u09bf\u09b8\u09c7\u09ae\u09cd\u09ac\u09b0".split(
                    "_"
                ),
                monthsShort:
                    "\u099c\u09be\u09a8\u09c1_\u09ab\u09c7\u09ac\u09cd\u09b0\u09c1_\u09ae\u09be\u09b0\u09cd\u099a_\u098f\u09aa\u09cd\u09b0\u09bf\u09b2_\u09ae\u09c7_\u099c\u09c1\u09a8_\u099c\u09c1\u09b2\u09be\u0987_\u0986\u0997\u09b8\u09cd\u099f_\u09b8\u09c7\u09aa\u09cd\u099f_\u0985\u0995\u09cd\u099f\u09cb_\u09a8\u09ad\u09c7_\u09a1\u09bf\u09b8\u09c7".split(
                        "_"
                    ),
                weekdays:
                    "\u09b0\u09ac\u09bf\u09ac\u09be\u09b0_\u09b8\u09cb\u09ae\u09ac\u09be\u09b0_\u09ae\u0999\u09cd\u0997\u09b2\u09ac\u09be\u09b0_\u09ac\u09c1\u09a7\u09ac\u09be\u09b0_\u09ac\u09c3\u09b9\u09b8\u09cd\u09aa\u09a4\u09bf\u09ac\u09be\u09b0_\u09b6\u09c1\u0995\u09cd\u09b0\u09ac\u09be\u09b0_\u09b6\u09a8\u09bf\u09ac\u09be\u09b0".split(
                        "_"
                    ),
                weekdaysShort:
                    "\u09b0\u09ac\u09bf_\u09b8\u09cb\u09ae_\u09ae\u0999\u09cd\u0997\u09b2_\u09ac\u09c1\u09a7_\u09ac\u09c3\u09b9\u09b8\u09cd\u09aa\u09a4\u09bf_\u09b6\u09c1\u0995\u09cd\u09b0_\u09b6\u09a8\u09bf".split(
                        "_"
                    ),
                weekdaysMin:
                    "\u09b0\u09ac\u09bf_\u09b8\u09cb\u09ae_\u09ae\u0999\u09cd\u0997\u09b2_\u09ac\u09c1\u09a7_\u09ac\u09c3\u09b9_\u09b6\u09c1\u0995\u09cd\u09b0_\u09b6\u09a8\u09bf".split(
                        "_"
                    ),
                longDateFormat: {
                    LT: "A h:mm \u09b8\u09ae\u09df",
                    LTS: "A h:mm:ss \u09b8\u09ae\u09df",
                    L: "DD/MM/YYYY",
                    LL: "D MMMM YYYY",
                    LLL: "D MMMM YYYY, A h:mm \u09b8\u09ae\u09df",
                    LLLL: "dddd, D MMMM YYYY, A h:mm \u09b8\u09ae\u09df",
                },
                calendar: {
                    sameDay: "[\u0986\u099c] LT",
                    nextDay:
                        "[\u0986\u0997\u09be\u09ae\u09c0\u0995\u09be\u09b2] LT",
                    nextWeek: "dddd, LT",
                    lastDay: "[\u0997\u09a4\u0995\u09be\u09b2] LT",
                    lastWeek: "[\u0997\u09a4] dddd, LT",
                    sameElse: "L",
                },
                relativeTime: {
                    future: "%s \u09aa\u09b0\u09c7",
                    past: "%s \u0986\u0997\u09c7",
                    s: "\u0995\u09df\u09c7\u0995 \u09b8\u09c7\u0995\u09c7\u09a8\u09cd\u09a1",
                    ss: "%d \u09b8\u09c7\u0995\u09c7\u09a8\u09cd\u09a1",
                    m: "\u098f\u0995 \u09ae\u09bf\u09a8\u09bf\u099f",
                    mm: "%d \u09ae\u09bf\u09a8\u09bf\u099f",
                    h: "\u098f\u0995 \u0998\u09a8\u09cd\u099f\u09be",
                    hh: "%d \u0998\u09a8\u09cd\u099f\u09be",
                    d: "\u098f\u0995 \u09a6\u09bf\u09a8",
                    dd: "%d \u09a6\u09bf\u09a8",
                    M: "\u098f\u0995 \u09ae\u09be\u09b8",
                    MM: "%d \u09ae\u09be\u09b8",
                    y: "\u098f\u0995 \u09ac\u099b\u09b0",
                    yy: "%d \u09ac\u099b\u09b0",
                },
                preparse: function (e) {
                    return e.replace(
                        /[\u09e7\u09e8\u09e9\u09ea\u09eb\u09ec\u09ed\u09ee\u09ef\u09e6]/g,
                        function (e) {
                            return $t[e];
                        }
                    );
                },
                postformat: function (e) {
                    return e.replace(/\d/g, function (e) {
                        return Zt[e];
                    });
                },
                meridiemParse:
                    /\u09b0\u09be\u09a4|\u09ad\u09cb\u09b0|\u09b8\u0995\u09be\u09b2|\u09a6\u09c1\u09aa\u09c1\u09b0|\u09ac\u09bf\u0995\u09be\u09b2|\u09b8\u09a8\u09cd\u09a7\u09cd\u09af\u09be|\u09b0\u09be\u09a4/,
                meridiemHour: function (e, a) {
                    return (
                        12 === e && (e = 0),
                        "\u09b0\u09be\u09a4" === a
                            ? e < 4
                                ? e
                                : e + 12
                            : "\u09ad\u09cb\u09b0" === a ||
                              "\u09b8\u0995\u09be\u09b2" === a
                            ? e
                            : "\u09a6\u09c1\u09aa\u09c1\u09b0" === a
                            ? 3 <= e
                                ? e
                                : e + 12
                            : "\u09ac\u09bf\u0995\u09be\u09b2" === a ||
                              "\u09b8\u09a8\u09cd\u09a7\u09cd\u09af\u09be" === a
                            ? e + 12
                            : void 0
                    );
                },
                meridiem: function (e, a, t) {
                    return e < 4
                        ? "\u09b0\u09be\u09a4"
                        : e < 6
                        ? "\u09ad\u09cb\u09b0"
                        : e < 12
                        ? "\u09b8\u0995\u09be\u09b2"
                        : e < 15
                        ? "\u09a6\u09c1\u09aa\u09c1\u09b0"
                        : e < 18
                        ? "\u09ac\u09bf\u0995\u09be\u09b2"
                        : e < 20
                        ? "\u09b8\u09a8\u09cd\u09a7\u09cd\u09af\u09be"
                        : "\u09b0\u09be\u09a4";
                },
                week: { dow: 0, doy: 6 },
            }),
            {
                1: "\u09e7",
                2: "\u09e8",
                3: "\u09e9",
                4: "\u09ea",
                5: "\u09eb",
                6: "\u09ec",
                7: "\u09ed",
                8: "\u09ee",
                9: "\u09ef",
                0: "\u09e6",
            }),
        Xt = {
            "\u09e7": "1",
            "\u09e8": "2",
            "\u09e9": "3",
            "\u09ea": "4",
            "\u09eb": "5",
            "\u09ec": "6",
            "\u09ed": "7",
            "\u09ee": "8",
            "\u09ef": "9",
            "\u09e6": "0",
        },
        es =
            (M.defineLocale("bn", {
                months: "\u099c\u09be\u09a8\u09c1\u09df\u09be\u09b0\u09bf_\u09ab\u09c7\u09ac\u09cd\u09b0\u09c1\u09df\u09be\u09b0\u09bf_\u09ae\u09be\u09b0\u09cd\u099a_\u098f\u09aa\u09cd\u09b0\u09bf\u09b2_\u09ae\u09c7_\u099c\u09c1\u09a8_\u099c\u09c1\u09b2\u09be\u0987_\u0986\u0997\u09b8\u09cd\u099f_\u09b8\u09c7\u09aa\u09cd\u099f\u09c7\u09ae\u09cd\u09ac\u09b0_\u0985\u0995\u09cd\u099f\u09cb\u09ac\u09b0_\u09a8\u09ad\u09c7\u09ae\u09cd\u09ac\u09b0_\u09a1\u09bf\u09b8\u09c7\u09ae\u09cd\u09ac\u09b0".split(
                    "_"
                ),
                monthsShort:
                    "\u099c\u09be\u09a8\u09c1_\u09ab\u09c7\u09ac\u09cd\u09b0\u09c1_\u09ae\u09be\u09b0\u09cd\u099a_\u098f\u09aa\u09cd\u09b0\u09bf\u09b2_\u09ae\u09c7_\u099c\u09c1\u09a8_\u099c\u09c1\u09b2\u09be\u0987_\u0986\u0997\u09b8\u09cd\u099f_\u09b8\u09c7\u09aa\u09cd\u099f_\u0985\u0995\u09cd\u099f\u09cb_\u09a8\u09ad\u09c7_\u09a1\u09bf\u09b8\u09c7".split(
                        "_"
                    ),
                weekdays:
                    "\u09b0\u09ac\u09bf\u09ac\u09be\u09b0_\u09b8\u09cb\u09ae\u09ac\u09be\u09b0_\u09ae\u0999\u09cd\u0997\u09b2\u09ac\u09be\u09b0_\u09ac\u09c1\u09a7\u09ac\u09be\u09b0_\u09ac\u09c3\u09b9\u09b8\u09cd\u09aa\u09a4\u09bf\u09ac\u09be\u09b0_\u09b6\u09c1\u0995\u09cd\u09b0\u09ac\u09be\u09b0_\u09b6\u09a8\u09bf\u09ac\u09be\u09b0".split(
                        "_"
                    ),
                weekdaysShort:
                    "\u09b0\u09ac\u09bf_\u09b8\u09cb\u09ae_\u09ae\u0999\u09cd\u0997\u09b2_\u09ac\u09c1\u09a7_\u09ac\u09c3\u09b9\u09b8\u09cd\u09aa\u09a4\u09bf_\u09b6\u09c1\u0995\u09cd\u09b0_\u09b6\u09a8\u09bf".split(
                        "_"
                    ),
                weekdaysMin:
                    "\u09b0\u09ac\u09bf_\u09b8\u09cb\u09ae_\u09ae\u0999\u09cd\u0997\u09b2_\u09ac\u09c1\u09a7_\u09ac\u09c3\u09b9_\u09b6\u09c1\u0995\u09cd\u09b0_\u09b6\u09a8\u09bf".split(
                        "_"
                    ),
                longDateFormat: {
                    LT: "A h:mm \u09b8\u09ae\u09df",
                    LTS: "A h:mm:ss \u09b8\u09ae\u09df",
                    L: "DD/MM/YYYY",
                    LL: "D MMMM YYYY",
                    LLL: "D MMMM YYYY, A h:mm \u09b8\u09ae\u09df",
                    LLLL: "dddd, D MMMM YYYY, A h:mm \u09b8\u09ae\u09df",
                },
                calendar: {
                    sameDay: "[\u0986\u099c] LT",
                    nextDay:
                        "[\u0986\u0997\u09be\u09ae\u09c0\u0995\u09be\u09b2] LT",
                    nextWeek: "dddd, LT",
                    lastDay: "[\u0997\u09a4\u0995\u09be\u09b2] LT",
                    lastWeek: "[\u0997\u09a4] dddd, LT",
                    sameElse: "L",
                },
                relativeTime: {
                    future: "%s \u09aa\u09b0\u09c7",
                    past: "%s \u0986\u0997\u09c7",
                    s: "\u0995\u09df\u09c7\u0995 \u09b8\u09c7\u0995\u09c7\u09a8\u09cd\u09a1",
                    ss: "%d \u09b8\u09c7\u0995\u09c7\u09a8\u09cd\u09a1",
                    m: "\u098f\u0995 \u09ae\u09bf\u09a8\u09bf\u099f",
                    mm: "%d \u09ae\u09bf\u09a8\u09bf\u099f",
                    h: "\u098f\u0995 \u0998\u09a8\u09cd\u099f\u09be",
                    hh: "%d \u0998\u09a8\u09cd\u099f\u09be",
                    d: "\u098f\u0995 \u09a6\u09bf\u09a8",
                    dd: "%d \u09a6\u09bf\u09a8",
                    M: "\u098f\u0995 \u09ae\u09be\u09b8",
                    MM: "%d \u09ae\u09be\u09b8",
                    y: "\u098f\u0995 \u09ac\u099b\u09b0",
                    yy: "%d \u09ac\u099b\u09b0",
                },
                preparse: function (e) {
                    return e.replace(
                        /[\u09e7\u09e8\u09e9\u09ea\u09eb\u09ec\u09ed\u09ee\u09ef\u09e6]/g,
                        function (e) {
                            return Xt[e];
                        }
                    );
                },
                postformat: function (e) {
                    return e.replace(/\d/g, function (e) {
                        return Qt[e];
                    });
                },
                meridiemParse:
                    /\u09b0\u09be\u09a4|\u09b8\u0995\u09be\u09b2|\u09a6\u09c1\u09aa\u09c1\u09b0|\u09ac\u09bf\u0995\u09be\u09b2|\u09b0\u09be\u09a4/,
                meridiemHour: function (e, a) {
                    return (
                        12 === e && (e = 0),
                        ("\u09b0\u09be\u09a4" === a && 4 <= e) ||
                        ("\u09a6\u09c1\u09aa\u09c1\u09b0" === a && e < 5) ||
                        "\u09ac\u09bf\u0995\u09be\u09b2" === a
                            ? e + 12
                            : e
                    );
                },
                meridiem: function (e, a, t) {
                    return e < 4
                        ? "\u09b0\u09be\u09a4"
                        : e < 10
                        ? "\u09b8\u0995\u09be\u09b2"
                        : e < 17
                        ? "\u09a6\u09c1\u09aa\u09c1\u09b0"
                        : e < 20
                        ? "\u09ac\u09bf\u0995\u09be\u09b2"
                        : "\u09b0\u09be\u09a4";
                },
                week: { dow: 0, doy: 6 },
            }),
            {
                1: "\u0f21",
                2: "\u0f22",
                3: "\u0f23",
                4: "\u0f24",
                5: "\u0f25",
                6: "\u0f26",
                7: "\u0f27",
                8: "\u0f28",
                9: "\u0f29",
                0: "\u0f20",
            }),
        as = {
            "\u0f21": "1",
            "\u0f22": "2",
            "\u0f23": "3",
            "\u0f24": "4",
            "\u0f25": "5",
            "\u0f26": "6",
            "\u0f27": "7",
            "\u0f28": "8",
            "\u0f29": "9",
            "\u0f20": "0",
        };
    function ts(e, a, t) {
        return (
            e +
            " " +
            ((t = { mm: "munutenn", MM: "miz", dd: "devezh" }[t]),
            2 !== (e = e)
                ? t
                : void 0 !== (e = { m: "v", b: "v", d: "z" })[(t = t).charAt(0)]
                ? e[t.charAt(0)] + t.substring(1)
                : t)
        );
    }
    M.defineLocale("bo", {
        months: "\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f51\u0f44\u0f0b\u0f54\u0f7c_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f42\u0f49\u0f72\u0f66\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f42\u0f66\u0f74\u0f58\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f56\u0f5e\u0f72\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f63\u0f94\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f51\u0fb2\u0f74\u0f42\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f56\u0f51\u0f74\u0f53\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f56\u0f62\u0f92\u0fb1\u0f51\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f51\u0f42\u0f74\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f56\u0f45\u0f74\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f56\u0f45\u0f74\u0f0b\u0f42\u0f45\u0f72\u0f42\u0f0b\u0f54_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f56\u0f45\u0f74\u0f0b\u0f42\u0f49\u0f72\u0f66\u0f0b\u0f54".split(
            "_"
        ),
        monthsShort:
            "\u0f5f\u0fb3\u0f0b1_\u0f5f\u0fb3\u0f0b2_\u0f5f\u0fb3\u0f0b3_\u0f5f\u0fb3\u0f0b4_\u0f5f\u0fb3\u0f0b5_\u0f5f\u0fb3\u0f0b6_\u0f5f\u0fb3\u0f0b7_\u0f5f\u0fb3\u0f0b8_\u0f5f\u0fb3\u0f0b9_\u0f5f\u0fb3\u0f0b10_\u0f5f\u0fb3\u0f0b11_\u0f5f\u0fb3\u0f0b12".split(
                "_"
            ),
        monthsShortRegex: /^(\u0f5f\u0fb3\u0f0b\d{1,2})/,
        monthsParseExact: !0,
        weekdays:
            "\u0f42\u0f5f\u0f60\u0f0b\u0f49\u0f72\u0f0b\u0f58\u0f0b_\u0f42\u0f5f\u0f60\u0f0b\u0f5f\u0fb3\u0f0b\u0f56\u0f0b_\u0f42\u0f5f\u0f60\u0f0b\u0f58\u0f72\u0f42\u0f0b\u0f51\u0f58\u0f62\u0f0b_\u0f42\u0f5f\u0f60\u0f0b\u0f63\u0fb7\u0f42\u0f0b\u0f54\u0f0b_\u0f42\u0f5f\u0f60\u0f0b\u0f55\u0f74\u0f62\u0f0b\u0f56\u0f74_\u0f42\u0f5f\u0f60\u0f0b\u0f54\u0f0b\u0f66\u0f44\u0f66\u0f0b_\u0f42\u0f5f\u0f60\u0f0b\u0f66\u0fa4\u0f7a\u0f53\u0f0b\u0f54\u0f0b".split(
                "_"
            ),
        weekdaysShort:
            "\u0f49\u0f72\u0f0b\u0f58\u0f0b_\u0f5f\u0fb3\u0f0b\u0f56\u0f0b_\u0f58\u0f72\u0f42\u0f0b\u0f51\u0f58\u0f62\u0f0b_\u0f63\u0fb7\u0f42\u0f0b\u0f54\u0f0b_\u0f55\u0f74\u0f62\u0f0b\u0f56\u0f74_\u0f54\u0f0b\u0f66\u0f44\u0f66\u0f0b_\u0f66\u0fa4\u0f7a\u0f53\u0f0b\u0f54\u0f0b".split(
                "_"
            ),
        weekdaysMin:
            "\u0f49\u0f72_\u0f5f\u0fb3_\u0f58\u0f72\u0f42_\u0f63\u0fb7\u0f42_\u0f55\u0f74\u0f62_\u0f66\u0f44\u0f66_\u0f66\u0fa4\u0f7a\u0f53".split(
                "_"
            ),
        longDateFormat: {
            LT: "A h:mm",
            LTS: "A h:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY, A h:mm",
            LLLL: "dddd, D MMMM YYYY, A h:mm",
        },
        calendar: {
            sameDay: "[\u0f51\u0f72\u0f0b\u0f62\u0f72\u0f44] LT",
            nextDay: "[\u0f66\u0f44\u0f0b\u0f49\u0f72\u0f53] LT",
            nextWeek:
                "[\u0f56\u0f51\u0f74\u0f53\u0f0b\u0f55\u0fb2\u0f42\u0f0b\u0f62\u0f97\u0f7a\u0f66\u0f0b\u0f58], LT",
            lastDay: "[\u0f41\u0f0b\u0f66\u0f44] LT",
            lastWeek:
                "[\u0f56\u0f51\u0f74\u0f53\u0f0b\u0f55\u0fb2\u0f42\u0f0b\u0f58\u0f50\u0f60\u0f0b\u0f58] dddd, LT",
            sameElse: "L",
        },
        relativeTime: {
            future: "%s \u0f63\u0f0b",
            past: "%s \u0f66\u0f94\u0f53\u0f0b\u0f63",
            s: "\u0f63\u0f58\u0f0b\u0f66\u0f44",
            ss: "%d \u0f66\u0f90\u0f62\u0f0b\u0f46\u0f0d",
            m: "\u0f66\u0f90\u0f62\u0f0b\u0f58\u0f0b\u0f42\u0f45\u0f72\u0f42",
            mm: "%d \u0f66\u0f90\u0f62\u0f0b\u0f58",
            h: "\u0f46\u0f74\u0f0b\u0f5a\u0f7c\u0f51\u0f0b\u0f42\u0f45\u0f72\u0f42",
            hh: "%d \u0f46\u0f74\u0f0b\u0f5a\u0f7c\u0f51",
            d: "\u0f49\u0f72\u0f53\u0f0b\u0f42\u0f45\u0f72\u0f42",
            dd: "%d \u0f49\u0f72\u0f53\u0f0b",
            M: "\u0f5f\u0fb3\u0f0b\u0f56\u0f0b\u0f42\u0f45\u0f72\u0f42",
            MM: "%d \u0f5f\u0fb3\u0f0b\u0f56",
            y: "\u0f63\u0f7c\u0f0b\u0f42\u0f45\u0f72\u0f42",
            yy: "%d \u0f63\u0f7c",
        },
        preparse: function (e) {
            return e.replace(
                /[\u0f21\u0f22\u0f23\u0f24\u0f25\u0f26\u0f27\u0f28\u0f29\u0f20]/g,
                function (e) {
                    return as[e];
                }
            );
        },
        postformat: function (e) {
            return e.replace(/\d/g, function (e) {
                return es[e];
            });
        },
        meridiemParse:
            /\u0f58\u0f5a\u0f53\u0f0b\u0f58\u0f7c|\u0f5e\u0f7c\u0f42\u0f66\u0f0b\u0f40\u0f66|\u0f49\u0f72\u0f53\u0f0b\u0f42\u0f74\u0f44|\u0f51\u0f42\u0f7c\u0f44\u0f0b\u0f51\u0f42|\u0f58\u0f5a\u0f53\u0f0b\u0f58\u0f7c/,
        meridiemHour: function (e, a) {
            return (
                12 === e && (e = 0),
                ("\u0f58\u0f5a\u0f53\u0f0b\u0f58\u0f7c" === a && 4 <= e) ||
                ("\u0f49\u0f72\u0f53\u0f0b\u0f42\u0f74\u0f44" === a && e < 5) ||
                "\u0f51\u0f42\u0f7c\u0f44\u0f0b\u0f51\u0f42" === a
                    ? e + 12
                    : e
            );
        },
        meridiem: function (e, a, t) {
            return e < 4
                ? "\u0f58\u0f5a\u0f53\u0f0b\u0f58\u0f7c"
                : e < 10
                ? "\u0f5e\u0f7c\u0f42\u0f66\u0f0b\u0f40\u0f66"
                : e < 17
                ? "\u0f49\u0f72\u0f53\u0f0b\u0f42\u0f74\u0f44"
                : e < 20
                ? "\u0f51\u0f42\u0f7c\u0f44\u0f0b\u0f51\u0f42"
                : "\u0f58\u0f5a\u0f53\u0f0b\u0f58\u0f7c";
        },
        week: { dow: 0, doy: 6 },
    });
    (L = [
        /^gen/i,
        /^c[\u02bc\']hwe/i,
        /^meu/i,
        /^ebr/i,
        /^mae/i,
        /^(mez|eve)/i,
        /^gou/i,
        /^eos/i,
        /^gwe/i,
        /^her/i,
        /^du/i,
        /^ker/i,
    ]),
        (c =
            /^(genver|c[\u02bc\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[\u02bc\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i),
        (ta = [
            /^Su/i,
            /^Lu/i,
            /^Me([^r]|$)/i,
            /^Mer/i,
            /^Ya/i,
            /^Gw/i,
            /^Sa/i,
        ]);
    function ss(e, a, t) {
        var s = e + " ";
        switch (t) {
            case "ss":
                return (s +=
                    1 === e
                        ? "sekunda"
                        : 2 === e || 3 === e || 4 === e
                        ? "sekunde"
                        : "sekundi");
            case "m":
                return a ? "jedna minuta" : "jedne minute";
            case "mm":
                return (s +=
                    1 !== e && (2 === e || 3 === e || 4 === e)
                        ? "minute"
                        : "minuta");
            case "h":
                return a ? "jedan sat" : "jednog sata";
            case "hh":
                return (s +=
                    1 === e
                        ? "sat"
                        : 2 === e || 3 === e || 4 === e
                        ? "sata"
                        : "sati");
            case "dd":
                return (s += 1 === e ? "dan" : "dana");
            case "MM":
                return (s +=
                    1 === e
                        ? "mjesec"
                        : 2 === e || 3 === e || 4 === e
                        ? "mjeseca"
                        : "mjeseci");
            case "yy":
                return (s +=
                    1 !== e && (2 === e || 3 === e || 4 === e)
                        ? "godine"
                        : "godina");
        }
    }
    M.defineLocale("br", {
        months: "Genver_C\u02bchwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu".split(
            "_"
        ),
        monthsShort:
            "Gen_C\u02bchwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker".split("_"),
        weekdays: "Sul_Lun_Meurzh_Merc\u02bcher_Yaou_Gwener_Sadorn".split("_"),
        weekdaysShort: "Sul_Lun_Meu_Mer_Yao_Gwe_Sad".split("_"),
        weekdaysMin: "Su_Lu_Me_Mer_Ya_Gw_Sa".split("_"),
        weekdaysParse: ta,
        fullWeekdaysParse: [
            /^sul/i,
            /^lun/i,
            /^meurzh/i,
            /^merc[\u02bc\']her/i,
            /^yaou/i,
            /^gwener/i,
            /^sadorn/i,
        ],
        shortWeekdaysParse: [
            /^Sul/i,
            /^Lun/i,
            /^Meu/i,
            /^Mer/i,
            /^Yao/i,
            /^Gwe/i,
            /^Sad/i,
        ],
        minWeekdaysParse: ta,
        monthsRegex: c,
        monthsShortRegex: c,
        monthsStrictRegex:
            /^(genver|c[\u02bc\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
        monthsShortStrictRegex:
            /^(gen|c[\u02bc\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
        monthsParse: L,
        longMonthsParse: L,
        shortMonthsParse: L,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D [a viz] MMMM YYYY",
            LLL: "D [a viz] MMMM YYYY HH:mm",
            LLLL: "dddd, D [a viz] MMMM YYYY HH:mm",
        },
        calendar: {
            sameDay: "[Hiziv da] LT",
            nextDay: "[Warc\u02bchoazh da] LT",
            nextWeek: "dddd [da] LT",
            lastDay: "[Dec\u02bch da] LT",
            lastWeek: "dddd [paset da] LT",
            sameElse: "L",
        },
        relativeTime: {
            future: "a-benn %s",
            past: "%s \u02bczo",
            s: "un nebeud segondenno\xf9",
            ss: "%d eilenn",
            m: "ur vunutenn",
            mm: ts,
            h: "un eur",
            hh: "%d eur",
            d: "un devezh",
            dd: ts,
            M: "ur miz",
            MM: ts,
            y: "ur bloaz",
            yy: function (e) {
                switch (
                    (function e(a) {
                        if (9 < a) return e(a % 10);
                        return a;
                    })(e)
                ) {
                    case 1:
                    case 3:
                    case 4:
                    case 5:
                    case 9:
                        return e + " bloaz";
                    default:
                        return e + " vloaz";
                }
            },
        },
        dayOfMonthOrdinalParse: /\d{1,2}(a\xf1|vet)/,
        ordinal: function (e) {
            return e + (1 === e ? "a\xf1" : "vet");
        },
        week: { dow: 1, doy: 4 },
        meridiemParse: /a.m.|g.m./,
        isPM: function (e) {
            return "g.m." === e;
        },
        meridiem: function (e, a, t) {
            return e < 12 ? "a.m." : "g.m.";
        },
    }),
        M.defineLocale("bs", {
            months: "januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar".split(
                "_"
            ),
            monthsShort:
                "jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.".split(
                    "_"
                ),
            monthsParseExact: !0,
            weekdays:
                "nedjelja_ponedjeljak_utorak_srijeda_\u010detvrtak_petak_subota".split(
                    "_"
                ),
            weekdaysShort: "ned._pon._uto._sri._\u010det._pet._sub.".split("_"),
            weekdaysMin: "ne_po_ut_sr_\u010de_pe_su".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "H:mm",
                LTS: "H:mm:ss",
                L: "DD.MM.YYYY",
                LL: "D. MMMM YYYY",
                LLL: "D. MMMM YYYY H:mm",
                LLLL: "dddd, D. MMMM YYYY H:mm",
            },
            calendar: {
                sameDay: "[danas u] LT",
                nextDay: "[sutra u] LT",
                nextWeek: function () {
                    switch (this.day()) {
                        case 0:
                            return "[u] [nedjelju] [u] LT";
                        case 3:
                            return "[u] [srijedu] [u] LT";
                        case 6:
                            return "[u] [subotu] [u] LT";
                        case 1:
                        case 2:
                        case 4:
                        case 5:
                            return "[u] dddd [u] LT";
                    }
                },
                lastDay: "[ju\u010der u] LT",
                lastWeek: function () {
                    switch (this.day()) {
                        case 0:
                        case 3:
                            return "[pro\u0161lu] dddd [u] LT";
                        case 6:
                            return "[pro\u0161le] [subote] [u] LT";
                        case 1:
                        case 2:
                        case 4:
                        case 5:
                            return "[pro\u0161li] dddd [u] LT";
                    }
                },
                sameElse: "L",
            },
            relativeTime: {
                future: "za %s",
                past: "prije %s",
                s: "par sekundi",
                ss: ss,
                m: ss,
                mm: ss,
                h: ss,
                hh: ss,
                d: "dan",
                dd: ss,
                M: "mjesec",
                MM: ss,
                y: "godinu",
                yy: ss,
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: { dow: 1, doy: 7 },
        }),
        M.defineLocale("ca", {
            months: {
                standalone:
                    "gener_febrer_mar\xe7_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre".split(
                        "_"
                    ),
                format: "de gener_de febrer_de mar\xe7_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
                    "_"
                ),
                isFormat: /D[oD]?(\s)+MMMM/,
            },
            monthsShort:
                "gen._febr._mar\xe7_abr._maig_juny_jul._ag._set._oct._nov._des.".split(
                    "_"
                ),
            monthsParseExact: !0,
            weekdays:
                "diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte".split(
                    "_"
                ),
            weekdaysShort: "dg._dl._dt._dc._dj._dv._ds.".split("_"),
            weekdaysMin: "dg_dl_dt_dc_dj_dv_ds".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "H:mm",
                LTS: "H:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM [de] YYYY",
                ll: "D MMM YYYY",
                LLL: "D MMMM [de] YYYY [a les] H:mm",
                lll: "D MMM YYYY, H:mm",
                LLLL: "dddd D MMMM [de] YYYY [a les] H:mm",
                llll: "ddd D MMM YYYY, H:mm",
            },
            calendar: {
                sameDay: function () {
                    return (
                        "[avui a " +
                        (1 !== this.hours() ? "les" : "la") +
                        "] LT"
                    );
                },
                nextDay: function () {
                    return (
                        "[dem\xe0 a " +
                        (1 !== this.hours() ? "les" : "la") +
                        "] LT"
                    );
                },
                nextWeek: function () {
                    return (
                        "dddd [a " +
                        (1 !== this.hours() ? "les" : "la") +
                        "] LT"
                    );
                },
                lastDay: function () {
                    return (
                        "[ahir a " +
                        (1 !== this.hours() ? "les" : "la") +
                        "] LT"
                    );
                },
                lastWeek: function () {
                    return (
                        "[el] dddd [passat a " +
                        (1 !== this.hours() ? "les" : "la") +
                        "] LT"
                    );
                },
                sameElse: "L",
            },
            relativeTime: {
                future: "d'aqu\xed %s",
                past: "fa %s",
                s: "uns segons",
                ss: "%d segons",
                m: "un minut",
                mm: "%d minuts",
                h: "una hora",
                hh: "%d hores",
                d: "un dia",
                dd: "%d dies",
                M: "un mes",
                MM: "%d mesos",
                y: "un any",
                yy: "%d anys",
            },
            dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|\xe8|a)/,
            ordinal: function (e, a) {
                return (
                    e +
                    ("w" !== a && "W" !== a
                        ? 1 === e
                            ? "r"
                            : 2 === e
                            ? "n"
                            : 3 === e
                            ? "r"
                            : 4 === e
                            ? "t"
                            : "\xe8"
                        : "a")
                );
            },
            week: { dow: 1, doy: 4 },
        });
    (f = {
        format: "leden_\xfanor_b\u0159ezen_duben_kv\u011bten_\u010derven_\u010dervenec_srpen_z\xe1\u0159\xed_\u0159\xedjen_listopad_prosinec".split(
            "_"
        ),
        standalone:
            "ledna_\xfanora_b\u0159ezna_dubna_kv\u011btna_\u010dervna_\u010dervence_srpna_z\xe1\u0159\xed_\u0159\xedjna_listopadu_prosince".split(
                "_"
            ),
    }),
        (ke =
            "led_\xfano_b\u0159e_dub_kv\u011b_\u010dvn_\u010dvc_srp_z\xe1\u0159_\u0159\xedj_lis_pro".split(
                "_"
            )),
        (y = [
            /^led/i,
            /^\xfano/i,
            /^b\u0159e/i,
            /^dub/i,
            /^kv\u011b/i,
            /^(\u010dvn|\u010derven$|\u010dervna)/i,
            /^(\u010dvc|\u010dervenec|\u010dervence)/i,
            /^srp/i,
            /^z\xe1\u0159/i,
            /^\u0159\xedj/i,
            /^lis/i,
            /^pro/i,
        ]),
        (_ =
            /^(leden|\xfanor|b\u0159ezen|duben|kv\u011bten|\u010dervenec|\u010dervence|\u010derven|\u010dervna|srpen|z\xe1\u0159\xed|\u0159\xedjen|listopad|prosinec|led|\xfano|b\u0159e|dub|kv\u011b|\u010dvn|\u010dvc|srp|z\xe1\u0159|\u0159\xedj|lis|pro)/i);
    function ns(e) {
        return 1 < e && e < 5 && 1 != ~~(e / 10);
    }
    function P(e, a, t, s) {
        var n = e + " ";
        switch (t) {
            case "s":
                return a || s ? "p\xe1r sekund" : "p\xe1r sekundami";
            case "ss":
                return a || s
                    ? n + (ns(e) ? "sekundy" : "sekund")
                    : n + "sekundami";
            case "m":
                return a ? "minuta" : s ? "minutu" : "minutou";
            case "mm":
                return a || s
                    ? n + (ns(e) ? "minuty" : "minut")
                    : n + "minutami";
            case "h":
                return a ? "hodina" : s ? "hodinu" : "hodinou";
            case "hh":
                return a || s
                    ? n + (ns(e) ? "hodiny" : "hodin")
                    : n + "hodinami";
            case "d":
                return a || s ? "den" : "dnem";
            case "dd":
                return a || s ? n + (ns(e) ? "dny" : "dn\xed") : n + "dny";
            case "M":
                return a || s ? "m\u011bs\xedc" : "m\u011bs\xedcem";
            case "MM":
                return a || s
                    ? n + (ns(e) ? "m\u011bs\xedce" : "m\u011bs\xedc\u016f")
                    : n + "m\u011bs\xedci";
            case "y":
                return a || s ? "rok" : "rokem";
            case "yy":
                return a || s ? n + (ns(e) ? "roky" : "let") : n + "lety";
        }
    }
    function rs(e, a, t, s) {
        e = {
            m: ["eine Minute", "einer Minute"],
            h: ["eine Stunde", "einer Stunde"],
            d: ["ein Tag", "einem Tag"],
            dd: [e + " Tage", e + " Tagen"],
            w: ["eine Woche", "einer Woche"],
            M: ["ein Monat", "einem Monat"],
            MM: [e + " Monate", e + " Monaten"],
            y: ["ein Jahr", "einem Jahr"],
            yy: [e + " Jahre", e + " Jahren"],
        };
        return a ? e[t][0] : e[t][1];
    }
    function ds(e, a, t, s) {
        e = {
            m: ["eine Minute", "einer Minute"],
            h: ["eine Stunde", "einer Stunde"],
            d: ["ein Tag", "einem Tag"],
            dd: [e + " Tage", e + " Tagen"],
            w: ["eine Woche", "einer Woche"],
            M: ["ein Monat", "einem Monat"],
            MM: [e + " Monate", e + " Monaten"],
            y: ["ein Jahr", "einem Jahr"],
            yy: [e + " Jahre", e + " Jahren"],
        };
        return a ? e[t][0] : e[t][1];
    }
    function is(e, a, t, s) {
        e = {
            m: ["eine Minute", "einer Minute"],
            h: ["eine Stunde", "einer Stunde"],
            d: ["ein Tag", "einem Tag"],
            dd: [e + " Tage", e + " Tagen"],
            w: ["eine Woche", "einer Woche"],
            M: ["ein Monat", "einem Monat"],
            MM: [e + " Monate", e + " Monaten"],
            y: ["ein Jahr", "einem Jahr"],
            yy: [e + " Jahre", e + " Jahren"],
        };
        return a ? e[t][0] : e[t][1];
    }
    M.defineLocale("cs", {
        months: f,
        monthsShort: ke,
        monthsRegex: _,
        monthsShortRegex: _,
        monthsStrictRegex:
            /^(leden|ledna|\xfanora|\xfanor|b\u0159ezen|b\u0159ezna|duben|dubna|kv\u011bten|kv\u011btna|\u010dervenec|\u010dervence|\u010derven|\u010dervna|srpen|srpna|z\xe1\u0159\xed|\u0159\xedjen|\u0159\xedjna|listopadu|listopad|prosinec|prosince)/i,
        monthsShortStrictRegex:
            /^(led|\xfano|b\u0159e|dub|kv\u011b|\u010dvn|\u010dvc|srp|z\xe1\u0159|\u0159\xedj|lis|pro)/i,
        monthsParse: y,
        longMonthsParse: y,
        shortMonthsParse: y,
        weekdays:
            "ned\u011ble_pond\u011bl\xed_\xfater\xfd_st\u0159eda_\u010dtvrtek_p\xe1tek_sobota".split(
                "_"
            ),
        weekdaysShort: "ne_po_\xfat_st_\u010dt_p\xe1_so".split("_"),
        weekdaysMin: "ne_po_\xfat_st_\u010dt_p\xe1_so".split("_"),
        longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D. MMMM YYYY",
            LLL: "D. MMMM YYYY H:mm",
            LLLL: "dddd D. MMMM YYYY H:mm",
            l: "D. M. YYYY",
        },
        calendar: {
            sameDay: "[dnes v] LT",
            nextDay: "[z\xedtra v] LT",
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return "[v ned\u011bli v] LT";
                    case 1:
                    case 2:
                        return "[v] dddd [v] LT";
                    case 3:
                        return "[ve st\u0159edu v] LT";
                    case 4:
                        return "[ve \u010dtvrtek v] LT";
                    case 5:
                        return "[v p\xe1tek v] LT";
                    case 6:
                        return "[v sobotu v] LT";
                }
            },
            lastDay: "[v\u010dera v] LT",
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return "[minulou ned\u011bli v] LT";
                    case 1:
                    case 2:
                        return "[minul\xe9] dddd [v] LT";
                    case 3:
                        return "[minulou st\u0159edu v] LT";
                    case 4:
                    case 5:
                        return "[minul\xfd] dddd [v] LT";
                    case 6:
                        return "[minulou sobotu v] LT";
                }
            },
            sameElse: "L",
        },
        relativeTime: {
            future: "za %s",
            past: "p\u0159ed %s",
            s: P,
            ss: P,
            m: P,
            mm: P,
            h: P,
            hh: P,
            d: P,
            dd: P,
            M: P,
            MM: P,
            y: P,
            yy: P,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: { dow: 1, doy: 4 },
    }),
        M.defineLocale("cv", {
            months: "\u043a\u04d1\u0440\u043b\u0430\u0447_\u043d\u0430\u0440\u04d1\u0441_\u043f\u0443\u0448_\u0430\u043a\u0430_\u043c\u0430\u0439_\u04ab\u04d7\u0440\u0442\u043c\u0435_\u0443\u0442\u04d1_\u04ab\u0443\u0440\u043b\u0430_\u0430\u0432\u04d1\u043d_\u044e\u043f\u0430_\u0447\u04f3\u043a_\u0440\u0430\u0448\u0442\u0430\u0432".split(
                "_"
            ),
            monthsShort:
                "\u043a\u04d1\u0440_\u043d\u0430\u0440_\u043f\u0443\u0448_\u0430\u043a\u0430_\u043c\u0430\u0439_\u04ab\u04d7\u0440_\u0443\u0442\u04d1_\u04ab\u0443\u0440_\u0430\u0432\u043d_\u044e\u043f\u0430_\u0447\u04f3\u043a_\u0440\u0430\u0448".split(
                    "_"
                ),
            weekdays:
                "\u0432\u044b\u0440\u0441\u0430\u0440\u043d\u0438\u043a\u0443\u043d_\u0442\u0443\u043d\u0442\u0438\u043a\u0443\u043d_\u044b\u0442\u043b\u0430\u0440\u0438\u043a\u0443\u043d_\u044e\u043d\u043a\u0443\u043d_\u043a\u04d7\u04ab\u043d\u0435\u0440\u043d\u0438\u043a\u0443\u043d_\u044d\u0440\u043d\u0435\u043a\u0443\u043d_\u0448\u04d1\u043c\u0430\u0442\u043a\u0443\u043d".split(
                    "_"
                ),
            weekdaysShort:
                "\u0432\u044b\u0440_\u0442\u0443\u043d_\u044b\u0442\u043b_\u044e\u043d_\u043a\u04d7\u04ab_\u044d\u0440\u043d_\u0448\u04d1\u043c".split(
                    "_"
                ),
            weekdaysMin:
                "\u0432\u0440_\u0442\u043d_\u044b\u0442_\u044e\u043d_\u043a\u04ab_\u044d\u0440_\u0448\u043c".split(
                    "_"
                ),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD-MM-YYYY",
                LL: "YYYY [\u04ab\u0443\u043b\u0445\u0438] MMMM [\u0443\u0439\u04d1\u0445\u04d7\u043d] D[-\u043c\u04d7\u0448\u04d7]",
                LLL: "YYYY [\u04ab\u0443\u043b\u0445\u0438] MMMM [\u0443\u0439\u04d1\u0445\u04d7\u043d] D[-\u043c\u04d7\u0448\u04d7], HH:mm",
                LLLL: "dddd, YYYY [\u04ab\u0443\u043b\u0445\u0438] MMMM [\u0443\u0439\u04d1\u0445\u04d7\u043d] D[-\u043c\u04d7\u0448\u04d7], HH:mm",
            },
            calendar: {
                sameDay:
                    "[\u041f\u0430\u044f\u043d] LT [\u0441\u0435\u0445\u0435\u0442\u0440\u0435]",
                nextDay:
                    "[\u042b\u0440\u0430\u043d] LT [\u0441\u0435\u0445\u0435\u0442\u0440\u0435]",
                lastDay:
                    "[\u04d6\u043d\u0435\u0440] LT [\u0441\u0435\u0445\u0435\u0442\u0440\u0435]",
                nextWeek:
                    "[\u04aa\u0438\u0442\u0435\u0441] dddd LT [\u0441\u0435\u0445\u0435\u0442\u0440\u0435]",
                lastWeek:
                    "[\u0418\u0440\u0442\u043d\u04d7] dddd LT [\u0441\u0435\u0445\u0435\u0442\u0440\u0435]",
                sameElse: "L",
            },
            relativeTime: {
                future: function (e) {
                    return (
                        e +
                        (/\u0441\u0435\u0445\u0435\u0442$/i.exec(e)
                            ? "\u0440\u0435\u043d"
                            : /\u04ab\u0443\u043b$/i.exec(e)
                            ? "\u0442\u0430\u043d"
                            : "\u0440\u0430\u043d")
                    );
                },
                past: "%s \u043a\u0430\u044f\u043b\u043b\u0430",
                s: "\u043f\u04d7\u0440-\u0438\u043a \u04ab\u0435\u043a\u043a\u0443\u043d\u0442",
                ss: "%d \u04ab\u0435\u043a\u043a\u0443\u043d\u0442",
                m: "\u043f\u04d7\u0440 \u043c\u0438\u043d\u0443\u0442",
                mm: "%d \u043c\u0438\u043d\u0443\u0442",
                h: "\u043f\u04d7\u0440 \u0441\u0435\u0445\u0435\u0442",
                hh: "%d \u0441\u0435\u0445\u0435\u0442",
                d: "\u043f\u04d7\u0440 \u043a\u0443\u043d",
                dd: "%d \u043a\u0443\u043d",
                M: "\u043f\u04d7\u0440 \u0443\u0439\u04d1\u0445",
                MM: "%d \u0443\u0439\u04d1\u0445",
                y: "\u043f\u04d7\u0440 \u04ab\u0443\u043b",
                yy: "%d \u04ab\u0443\u043b",
            },
            dayOfMonthOrdinalParse: /\d{1,2}-\u043c\u04d7\u0448/,
            ordinal: "%d-\u043c\u04d7\u0448",
            week: { dow: 1, doy: 7 },
        }),
        M.defineLocale("cy", {
            months: "Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr".split(
                "_"
            ),
            monthsShort:
                "Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag".split("_"),
            weekdays:
                "Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn".split(
                    "_"
                ),
            weekdaysShort: "Sul_Llun_Maw_Mer_Iau_Gwe_Sad".split("_"),
            weekdaysMin: "Su_Ll_Ma_Me_Ia_Gw_Sa".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd, D MMMM YYYY HH:mm",
            },
            calendar: {
                sameDay: "[Heddiw am] LT",
                nextDay: "[Yfory am] LT",
                nextWeek: "dddd [am] LT",
                lastDay: "[Ddoe am] LT",
                lastWeek: "dddd [diwethaf am] LT",
                sameElse: "L",
            },
            relativeTime: {
                future: "mewn %s",
                past: "%s yn \xf4l",
                s: "ychydig eiliadau",
                ss: "%d eiliad",
                m: "munud",
                mm: "%d munud",
                h: "awr",
                hh: "%d awr",
                d: "diwrnod",
                dd: "%d diwrnod",
                M: "mis",
                MM: "%d mis",
                y: "blwyddyn",
                yy: "%d flynedd",
            },
            dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
            ordinal: function (e) {
                var a = "";
                return (
                    20 < e
                        ? (a =
                              40 === e ||
                              50 === e ||
                              60 === e ||
                              80 === e ||
                              100 === e
                                  ? "fed"
                                  : "ain")
                        : 0 < e &&
                          (a = [
                              "",
                              "af",
                              "il",
                              "ydd",
                              "ydd",
                              "ed",
                              "ed",
                              "ed",
                              "fed",
                              "fed",
                              "fed",
                              "eg",
                              "fed",
                              "eg",
                              "eg",
                              "fed",
                              "eg",
                              "eg",
                              "fed",
                              "eg",
                              "fed",
                          ][e]),
                    e + a
                );
            },
            week: { dow: 1, doy: 4 },
        }),
        M.defineLocale("da", {
            months: "januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december".split(
                "_"
            ),
            monthsShort:
                "jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec".split("_"),
            weekdays:
                "s\xf8ndag_mandag_tirsdag_onsdag_torsdag_fredag_l\xf8rdag".split(
                    "_"
                ),
            weekdaysShort: "s\xf8n_man_tir_ons_tor_fre_l\xf8r".split("_"),
            weekdaysMin: "s\xf8_ma_ti_on_to_fr_l\xf8".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD.MM.YYYY",
                LL: "D. MMMM YYYY",
                LLL: "D. MMMM YYYY HH:mm",
                LLLL: "dddd [d.] D. MMMM YYYY [kl.] HH:mm",
            },
            calendar: {
                sameDay: "[i dag kl.] LT",
                nextDay: "[i morgen kl.] LT",
                nextWeek: "p\xe5 dddd [kl.] LT",
                lastDay: "[i g\xe5r kl.] LT",
                lastWeek: "[i] dddd[s kl.] LT",
                sameElse: "L",
            },
            relativeTime: {
                future: "om %s",
                past: "%s siden",
                s: "f\xe5 sekunder",
                ss: "%d sekunder",
                m: "et minut",
                mm: "%d minutter",
                h: "en time",
                hh: "%d timer",
                d: "en dag",
                dd: "%d dage",
                M: "en m\xe5ned",
                MM: "%d m\xe5neder",
                y: "et \xe5r",
                yy: "%d \xe5r",
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: { dow: 1, doy: 4 },
        }),
        M.defineLocale("de-at", {
            months: "J\xe4nner_Februar_M\xe4rz_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split(
                "_"
            ),
            monthsShort:
                "J\xe4n._Feb._M\xe4rz_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split(
                    "_"
                ),
            monthsParseExact: !0,
            weekdays:
                "Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split(
                    "_"
                ),
            weekdaysShort: "So._Mo._Di._Mi._Do._Fr._Sa.".split("_"),
            weekdaysMin: "So_Mo_Di_Mi_Do_Fr_Sa".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD.MM.YYYY",
                LL: "D. MMMM YYYY",
                LLL: "D. MMMM YYYY HH:mm",
                LLLL: "dddd, D. MMMM YYYY HH:mm",
            },
            calendar: {
                sameDay: "[heute um] LT [Uhr]",
                sameElse: "L",
                nextDay: "[morgen um] LT [Uhr]",
                nextWeek: "dddd [um] LT [Uhr]",
                lastDay: "[gestern um] LT [Uhr]",
                lastWeek: "[letzten] dddd [um] LT [Uhr]",
            },
            relativeTime: {
                future: "%s ago",
                past: "vor %s",
                s: "ein paar Sekunden",
                ss: "%d Sekunden",
                m: rs,
                mm: "%d Minuten",
                h: rs,
                hh: "%d Stunden",
                d: rs,
                dd: rs,
                w: rs,
                ww: "%d Wochen",
                M: rs,
                MM: rs,
                y: rs,
                yy: rs,
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: { dow: 1, doy: 4 },
        }),
        M.defineLocale("de-ch", {
            months: "Januar_Februar_M\xe4rz_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split(
                "_"
            ),
            monthsShort:
                "Jan._Feb._M\xe4rz_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split(
                    "_"
                ),
            monthsParseExact: !0,
            weekdays:
                "Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split(
                    "_"
                ),
            weekdaysShort: "So_Mo_Di_Mi_Do_Fr_Sa".split("_"),
            weekdaysMin: "So_Mo_Di_Mi_Do_Fr_Sa".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD.MM.YYYY",
                LL: "D. MMMM YYYY",
                LLL: "D. MMMM YYYY HH:mm",
                LLLL: "dddd, D. MMMM YYYY HH:mm",
            },
            calendar: {
                sameDay: "[heute um] LT [Uhr]",
                sameElse: "L",
                nextDay: "[morgen um] LT [Uhr]",
                nextWeek: "dddd [um] LT [Uhr]",
                lastDay: "[gestern um] LT [Uhr]",
                lastWeek: "[letzten] dddd [um] LT [Uhr]",
            },
            relativeTime: {
                future: "%s ago",
                past: "vor %s",
                s: "ein paar Sekunden",
                ss: "%d Sekunden",
                m: ds,
                mm: "%d Minuten",
                h: ds,
                hh: "%d Stunden",
                d: ds,
                dd: ds,
                w: ds,
                ww: "%d Wochen",
                M: ds,
                MM: ds,
                y: ds,
                yy: ds,
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: { dow: 1, doy: 4 },
        }),
        M.defineLocale("de", {
            months: "Januar_Februar_M\xe4rz_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split(
                "_"
            ),
            monthsShort:
                "Jan._Feb._M\xe4rz_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split(
                    "_"
                ),
            monthsParseExact: !0,
            weekdays:
                "Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split(
                    "_"
                ),
            weekdaysShort: "So._Mo._Di._Mi._Do._Fr._Sa.".split("_"),
            weekdaysMin: "So_Mo_Di_Mi_Do_Fr_Sa".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD.MM.YYYY",
                LL: "D. MMMM YYYY",
                LLL: "D. MMMM YYYY HH:mm",
                LLLL: "dddd, D. MMMM YYYY HH:mm",
            },
            calendar: {
                sameDay: "[heute um] LT [Uhr]",
                sameElse: "L",
                nextDay: "[morgen um] LT [Uhr]",
                nextWeek: "dddd [um] LT [Uhr]",
                lastDay: "[gestern um] LT [Uhr]",
                lastWeek: "[letzten] dddd [um] LT [Uhr]",
            },
            relativeTime: {
                future: "%s ago",
                past: "vor %s",
                s: "ein paar Sekunden",
                ss: "%d Sekunden",
                m: is,
                mm: "%d Minuten",
                h: is,
                hh: "%d Stunden",
                d: is,
                dd: is,
                w: is,
                ww: "%d Wochen",
                M: is,
                MM: is,
                y: is,
                yy: is,
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: { dow: 1, doy: 4 },
        });
    (Y = [
        "\u0796\u07ac\u0782\u07aa\u0787\u07a6\u0783\u07a9",
        "\u078a\u07ac\u0784\u07b0\u0783\u07aa\u0787\u07a6\u0783\u07a9",
        "\u0789\u07a7\u0783\u07a8\u0797\u07aa",
        "\u0787\u07ad\u0795\u07b0\u0783\u07a9\u078d\u07aa",
        "\u0789\u07ad",
        "\u0796\u07ab\u0782\u07b0",
        "\u0796\u07aa\u078d\u07a6\u0787\u07a8",
        "\u0787\u07af\u078e\u07a6\u0790\u07b0\u0793\u07aa",
        "\u0790\u07ac\u0795\u07b0\u0793\u07ac\u0789\u07b0\u0784\u07a6\u0783\u07aa",
        "\u0787\u07ae\u0786\u07b0\u0793\u07af\u0784\u07a6\u0783\u07aa",
        "\u0782\u07ae\u0788\u07ac\u0789\u07b0\u0784\u07a6\u0783\u07aa",
        "\u0791\u07a8\u0790\u07ac\u0789\u07b0\u0784\u07a6\u0783\u07aa",
    ]),
        (Ke = [
            "\u0787\u07a7\u078b\u07a8\u0787\u07b0\u078c\u07a6",
            "\u0780\u07af\u0789\u07a6",
            "\u0787\u07a6\u0782\u07b0\u078e\u07a7\u0783\u07a6",
            "\u0784\u07aa\u078b\u07a6",
            "\u0784\u07aa\u0783\u07a7\u0790\u07b0\u078a\u07a6\u078c\u07a8",
            "\u0780\u07aa\u0786\u07aa\u0783\u07aa",
            "\u0780\u07ae\u0782\u07a8\u0780\u07a8\u0783\u07aa",
        ]);
    M.defineLocale("dv", {
        months: Y,
        monthsShort: Y,
        weekdays: Ke,
        weekdaysShort: Ke,
        weekdaysMin:
            "\u0787\u07a7\u078b\u07a8_\u0780\u07af\u0789\u07a6_\u0787\u07a6\u0782\u07b0_\u0784\u07aa\u078b\u07a6_\u0784\u07aa\u0783\u07a7_\u0780\u07aa\u0786\u07aa_\u0780\u07ae\u0782\u07a8".split(
                "_"
            ),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "D/M/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm",
        },
        meridiemParse: /\u0789\u0786|\u0789\u078a/,
        isPM: function (e) {
            return "\u0789\u078a" === e;
        },
        meridiem: function (e, a, t) {
            return e < 12 ? "\u0789\u0786" : "\u0789\u078a";
        },
        calendar: {
            sameDay: "[\u0789\u07a8\u0787\u07a6\u078b\u07aa] LT",
            nextDay: "[\u0789\u07a7\u078b\u07a6\u0789\u07a7] LT",
            nextWeek: "dddd LT",
            lastDay: "[\u0787\u07a8\u0787\u07b0\u0794\u07ac] LT",
            lastWeek:
                "[\u078a\u07a7\u0787\u07a8\u078c\u07aa\u0788\u07a8] dddd LT",
            sameElse: "L",
        },
        relativeTime: {
            future: "\u078c\u07ac\u0783\u07ad\u078e\u07a6\u0787\u07a8 %s",
            past: "\u0786\u07aa\u0783\u07a8\u0782\u07b0 %s",
            s: "\u0790\u07a8\u0786\u07aa\u0782\u07b0\u078c\u07aa\u0786\u07ae\u0785\u07ac\u0787\u07b0",
            ss: "d% \u0790\u07a8\u0786\u07aa\u0782\u07b0\u078c\u07aa",
            m: "\u0789\u07a8\u0782\u07a8\u0793\u07ac\u0787\u07b0",
            mm: "\u0789\u07a8\u0782\u07a8\u0793\u07aa %d",
            h: "\u078e\u07a6\u0791\u07a8\u0787\u07a8\u0783\u07ac\u0787\u07b0",
            hh: "\u078e\u07a6\u0791\u07a8\u0787\u07a8\u0783\u07aa %d",
            d: "\u078b\u07aa\u0788\u07a6\u0780\u07ac\u0787\u07b0",
            dd: "\u078b\u07aa\u0788\u07a6\u0790\u07b0 %d",
            M: "\u0789\u07a6\u0780\u07ac\u0787\u07b0",
            MM: "\u0789\u07a6\u0790\u07b0 %d",
            y: "\u0787\u07a6\u0780\u07a6\u0783\u07ac\u0787\u07b0",
            yy: "\u0787\u07a6\u0780\u07a6\u0783\u07aa %d",
        },
        preparse: function (e) {
            return e.replace(/\u060c/g, ",");
        },
        postformat: function (e) {
            return e.replace(/,/g, "\u060c");
        },
        week: { dow: 7, doy: 12 },
    }),
        M.defineLocale("el", {
            monthsNominativeEl:
                "\u0399\u03b1\u03bd\u03bf\u03c5\u03ac\u03c1\u03b9\u03bf\u03c2_\u03a6\u03b5\u03b2\u03c1\u03bf\u03c5\u03ac\u03c1\u03b9\u03bf\u03c2_\u039c\u03ac\u03c1\u03c4\u03b9\u03bf\u03c2_\u0391\u03c0\u03c1\u03af\u03bb\u03b9\u03bf\u03c2_\u039c\u03ac\u03b9\u03bf\u03c2_\u0399\u03bf\u03cd\u03bd\u03b9\u03bf\u03c2_\u0399\u03bf\u03cd\u03bb\u03b9\u03bf\u03c2_\u0391\u03cd\u03b3\u03bf\u03c5\u03c3\u03c4\u03bf\u03c2_\u03a3\u03b5\u03c0\u03c4\u03ad\u03bc\u03b2\u03c1\u03b9\u03bf\u03c2_\u039f\u03ba\u03c4\u03ce\u03b2\u03c1\u03b9\u03bf\u03c2_\u039d\u03bf\u03ad\u03bc\u03b2\u03c1\u03b9\u03bf\u03c2_\u0394\u03b5\u03ba\u03ad\u03bc\u03b2\u03c1\u03b9\u03bf\u03c2".split(
                    "_"
                ),
            monthsGenitiveEl:
                "\u0399\u03b1\u03bd\u03bf\u03c5\u03b1\u03c1\u03af\u03bf\u03c5_\u03a6\u03b5\u03b2\u03c1\u03bf\u03c5\u03b1\u03c1\u03af\u03bf\u03c5_\u039c\u03b1\u03c1\u03c4\u03af\u03bf\u03c5_\u0391\u03c0\u03c1\u03b9\u03bb\u03af\u03bf\u03c5_\u039c\u03b1\u0390\u03bf\u03c5_\u0399\u03bf\u03c5\u03bd\u03af\u03bf\u03c5_\u0399\u03bf\u03c5\u03bb\u03af\u03bf\u03c5_\u0391\u03c5\u03b3\u03bf\u03cd\u03c3\u03c4\u03bf\u03c5_\u03a3\u03b5\u03c0\u03c4\u03b5\u03bc\u03b2\u03c1\u03af\u03bf\u03c5_\u039f\u03ba\u03c4\u03c9\u03b2\u03c1\u03af\u03bf\u03c5_\u039d\u03bf\u03b5\u03bc\u03b2\u03c1\u03af\u03bf\u03c5_\u0394\u03b5\u03ba\u03b5\u03bc\u03b2\u03c1\u03af\u03bf\u03c5".split(
                    "_"
                ),
            months: function (e, a) {
                return e
                    ? ("string" == typeof a &&
                      /D/.test(a.substring(0, a.indexOf("MMMM")))
                          ? this._monthsGenitiveEl
                          : this._monthsNominativeEl)[e.month()]
                    : this._monthsNominativeEl;
            },
            monthsShort:
                "\u0399\u03b1\u03bd_\u03a6\u03b5\u03b2_\u039c\u03b1\u03c1_\u0391\u03c0\u03c1_\u039c\u03b1\u03ca_\u0399\u03bf\u03c5\u03bd_\u0399\u03bf\u03c5\u03bb_\u0391\u03c5\u03b3_\u03a3\u03b5\u03c0_\u039f\u03ba\u03c4_\u039d\u03bf\u03b5_\u0394\u03b5\u03ba".split(
                    "_"
                ),
            weekdays:
                "\u039a\u03c5\u03c1\u03b9\u03b1\u03ba\u03ae_\u0394\u03b5\u03c5\u03c4\u03ad\u03c1\u03b1_\u03a4\u03c1\u03af\u03c4\u03b7_\u03a4\u03b5\u03c4\u03ac\u03c1\u03c4\u03b7_\u03a0\u03ad\u03bc\u03c0\u03c4\u03b7_\u03a0\u03b1\u03c1\u03b1\u03c3\u03ba\u03b5\u03c5\u03ae_\u03a3\u03ac\u03b2\u03b2\u03b1\u03c4\u03bf".split(
                    "_"
                ),
            weekdaysShort:
                "\u039a\u03c5\u03c1_\u0394\u03b5\u03c5_\u03a4\u03c1\u03b9_\u03a4\u03b5\u03c4_\u03a0\u03b5\u03bc_\u03a0\u03b1\u03c1_\u03a3\u03b1\u03b2".split(
                    "_"
                ),
            weekdaysMin:
                "\u039a\u03c5_\u0394\u03b5_\u03a4\u03c1_\u03a4\u03b5_\u03a0\u03b5_\u03a0\u03b1_\u03a3\u03b1".split(
                    "_"
                ),
            meridiem: function (e, a, t) {
                return 11 < e
                    ? t
                        ? "\u03bc\u03bc"
                        : "\u039c\u039c"
                    : t
                    ? "\u03c0\u03bc"
                    : "\u03a0\u039c";
            },
            isPM: function (e) {
                return "\u03bc" === (e + "").toLowerCase()[0];
            },
            meridiemParse: /[\u03a0\u039c]\.?\u039c?\.?/i,
            longDateFormat: {
                LT: "h:mm A",
                LTS: "h:mm:ss A",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY h:mm A",
                LLLL: "dddd, D MMMM YYYY h:mm A",
            },
            calendarEl: {
                sameDay: "[\u03a3\u03ae\u03bc\u03b5\u03c1\u03b1 {}] LT",
                nextDay: "[\u0391\u03cd\u03c1\u03b9\u03bf {}] LT",
                nextWeek: "dddd [{}] LT",
                lastDay: "[\u03a7\u03b8\u03b5\u03c2 {}] LT",
                lastWeek: function () {
                    switch (this.day()) {
                        case 6:
                            return "[\u03c4\u03bf \u03c0\u03c1\u03bf\u03b7\u03b3\u03bf\u03cd\u03bc\u03b5\u03bd\u03bf] dddd [{}] LT";
                        default:
                            return "[\u03c4\u03b7\u03bd \u03c0\u03c1\u03bf\u03b7\u03b3\u03bf\u03cd\u03bc\u03b5\u03bd\u03b7] dddd [{}] LT";
                    }
                },
                sameElse: "L",
            },
            calendar: function (e, a) {
                var t,
                    e = this._calendarEl[e],
                    s = a && a.hours();
                return (
                    (t = e),
                    (e =
                        ("undefined" != typeof Function &&
                            t instanceof Function) ||
                        "[object Function]" ===
                            Object.prototype.toString.call(t)
                            ? e.apply(a)
                            : e).replace(
                        "{}",
                        s % 12 == 1
                            ? "\u03c3\u03c4\u03b7"
                            : "\u03c3\u03c4\u03b9\u03c2"
                    )
                );
            },
            relativeTime: {
                future: "\u03c3\u03b5 %s",
                past: "%s \u03c0\u03c1\u03b9\u03bd",
                s: "\u03bb\u03af\u03b3\u03b1 \u03b4\u03b5\u03c5\u03c4\u03b5\u03c1\u03cc\u03bb\u03b5\u03c0\u03c4\u03b1",
                ss: "%d \u03b4\u03b5\u03c5\u03c4\u03b5\u03c1\u03cc\u03bb\u03b5\u03c0\u03c4\u03b1",
                m: "\u03ad\u03bd\u03b1 \u03bb\u03b5\u03c0\u03c4\u03cc",
                mm: "%d \u03bb\u03b5\u03c0\u03c4\u03ac",
                h: "\u03bc\u03af\u03b1 \u03ce\u03c1\u03b1",
                hh: "%d \u03ce\u03c1\u03b5\u03c2",
                d: "\u03bc\u03af\u03b1 \u03bc\u03ad\u03c1\u03b1",
                dd: "%d \u03bc\u03ad\u03c1\u03b5\u03c2",
                M: "\u03ad\u03bd\u03b1\u03c2 \u03bc\u03ae\u03bd\u03b1\u03c2",
                MM: "%d \u03bc\u03ae\u03bd\u03b5\u03c2",
                y: "\u03ad\u03bd\u03b1\u03c2 \u03c7\u03c1\u03cc\u03bd\u03bf\u03c2",
                yy: "%d \u03c7\u03c1\u03cc\u03bd\u03b9\u03b1",
            },
            dayOfMonthOrdinalParse: /\d{1,2}\u03b7/,
            ordinal: "%d\u03b7",
            week: { dow: 1, doy: 4 },
        }),
        M.defineLocale("en-au", {
            months: "January_February_March_April_May_June_July_August_September_October_November_December".split(
                "_"
            ),
            monthsShort:
                "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
            weekdays:
                "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split(
                    "_"
                ),
            weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
            weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
            longDateFormat: {
                LT: "h:mm A",
                LTS: "h:mm:ss A",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY h:mm A",
                LLLL: "dddd, D MMMM YYYY h:mm A",
            },
            calendar: {
                sameDay: "[Today at] LT",
                nextDay: "[Tomorrow at] LT",
                nextWeek: "dddd [at] LT",
                lastDay: "[Yesterday at] LT",
                lastWeek: "[Last] dddd [at] LT",
                sameElse: "L",
            },
            relativeTime: {
                future: "%s ago",
                past: "%s ago",
                s: "a few seconds",
                ss: "%d seconds",
                m: "a minute",
                mm: "%d minutes",
                h: "an hour",
                hh: "%d hours",
                d: "a day",
                dd: "%d days",
                M: "a month",
                MM: "%d months",
                y: "a year",
                yy: "%d years",
            },
            dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
            ordinal: function (e) {
                var a = e % 10;
                return (
                    e +
                    (1 == ~~((e % 100) / 10)
                        ? "th"
                        : 1 == a
                        ? "st"
                        : 2 == a
                        ? "nd"
                        : 3 == a
                        ? "rd"
                        : "th")
                );
            },
            week: { dow: 0, doy: 4 },
        }),
        M.defineLocale("en-ca", {
            months: "January_February_March_April_May_June_July_August_September_October_November_December".split(
                "_"
            ),
            monthsShort:
                "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
            weekdays:
                "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split(
                    "_"
                ),
            weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
            weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
            longDateFormat: {
                LT: "h:mm A",
                LTS: "h:mm:ss A",
                L: "YYYY-MM-DD",
                LL: "MMMM D, YYYY",
                LLL: "MMMM D, YYYY h:mm A",
                LLLL: "dddd, MMMM D, YYYY h:mm A",
            },
            calendar: {
                sameDay: "[Today at] LT",
                nextDay: "[Tomorrow at] LT",
                nextWeek: "dddd [at] LT",
                lastDay: "[Yesterday at] LT",
                lastWeek: "[Last] dddd [at] LT",
                sameElse: "L",
            },
            relativeTime: {
                future: "%s ago",
                past: "%s ago",
                s: "a few seconds",
                ss: "%d seconds",
                m: "a minute",
                mm: "%d minutes",
                h: "an hour",
                hh: "%d hours",
                d: "a day",
                dd: "%d days",
                M: "a month",
                MM: "%d months",
                y: "a year",
                yy: "%d years",
            },
            dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
            ordinal: function (e) {
                var a = e % 10;
                return (
                    e +
                    (1 == ~~((e % 100) / 10)
                        ? "th"
                        : 1 == a
                        ? "st"
                        : 2 == a
                        ? "nd"
                        : 3 == a
                        ? "rd"
                        : "th")
                );
            },
        }),
        M.defineLocale("en-gb", {
            months: "January_February_March_April_May_June_July_August_September_October_November_December".split(
                "_"
            ),
            monthsShort:
                "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
            weekdays:
                "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split(
                    "_"
                ),
            weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
            weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd, D MMMM YYYY HH:mm",
            },
            calendar: {
                sameDay: "[Today at] LT",
                nextDay: "[Tomorrow at] LT",
                nextWeek: "dddd [at] LT",
                lastDay: "[Yesterday at] LT",
                lastWeek: "[Last] dddd [at] LT",
                sameElse: "L",
            },
            relativeTime: {
                future: "%s ago",
                past: "%s ago",
                s: "a few seconds",
                ss: "%d seconds",
                m: "a minute",
                mm: "%d minutes",
                h: "an hour",
                hh: "%d hours",
                d: "a day",
                dd: "%d days",
                M: "a month",
                MM: "%d months",
                y: "a year",
                yy: "%d years",
            },
            dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
            ordinal: function (e) {
                var a = e % 10;
                return (
                    e +
                    (1 == ~~((e % 100) / 10)
                        ? "th"
                        : 1 == a
                        ? "st"
                        : 2 == a
                        ? "nd"
                        : 3 == a
                        ? "rd"
                        : "th")
                );
            },
            week: { dow: 1, doy: 4 },
        }),
        M.defineLocale("en-ie", {
            months: "January_February_March_April_May_June_July_August_September_October_November_December".split(
                "_"
            ),
            monthsShort:
                "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
            weekdays:
                "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split(
                    "_"
                ),
            weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
            weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd D MMMM YYYY HH:mm",
            },
            calendar: {
                sameDay: "[Today at] LT",
                nextDay: "[Tomorrow at] LT",
                nextWeek: "dddd [at] LT",
                lastDay: "[Yesterday at] LT",
                lastWeek: "[Last] dddd [at] LT",
                sameElse: "L",
            },
            relativeTime: {
                future: "%s ago",
                past: "%s ago",
                s: "a few seconds",
                ss: "%d seconds",
                m: "a minute",
                mm: "%d minutes",
                h: "an hour",
                hh: "%d hours",
                d: "a day",
                dd: "%d days",
                M: "a month",
                MM: "%d months",
                y: "a year",
                yy: "%d years",
            },
            dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
            ordinal: function (e) {
                var a = e % 10;
                return (
                    e +
                    (1 == ~~((e % 100) / 10)
                        ? "th"
                        : 1 == a
                        ? "st"
                        : 2 == a
                        ? "nd"
                        : 3 == a
                        ? "rd"
                        : "th")
                );
            },
            week: { dow: 1, doy: 4 },
        }),
        M.defineLocale("en-il", {
            months: "January_February_March_April_May_June_July_August_September_October_November_December".split(
                "_"
            ),
            monthsShort:
                "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
            weekdays:
                "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split(
                    "_"
                ),
            weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
            weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd, D MMMM YYYY HH:mm",
            },
            calendar: {
                sameDay: "[Today at] LT",
                nextDay: "[Tomorrow at] LT",
                nextWeek: "dddd [at] LT",
                lastDay: "[Yesterday at] LT",
                lastWeek: "[Last] dddd [at] LT",
                sameElse: "L",
            },
            relativeTime: {
                future: "%s ago",
                past: "%s ago",
                s: "a few seconds",
                ss: "%d seconds",
                m: "a minute",
                mm: "%d minutes",
                h: "an hour",
                hh: "%d hours",
                d: "a day",
                dd: "%d days",
                M: "a month",
                MM: "%d months",
                y: "a year",
                yy: "%d years",
            },
            dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
            ordinal: function (e) {
                var a = e % 10;
                return (
                    e +
                    (1 == ~~((e % 100) / 10)
                        ? "th"
                        : 1 == a
                        ? "st"
                        : 2 == a
                        ? "nd"
                        : 3 == a
                        ? "rd"
                        : "th")
                );
            },
        }),
        M.defineLocale("en-in", {
            months: "January_February_March_April_May_June_July_August_September_October_November_December".split(
                "_"
            ),
            monthsShort:
                "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
            weekdays:
                "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split(
                    "_"
                ),
            weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
            weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
            longDateFormat: {
                LT: "h:mm A",
                LTS: "h:mm:ss A",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY h:mm A",
                LLLL: "dddd, D MMMM YYYY h:mm A",
            },
            calendar: {
                sameDay: "[Today at] LT",
                nextDay: "[Tomorrow at] LT",
                nextWeek: "dddd [at] LT",
                lastDay: "[Yesterday at] LT",
                lastWeek: "[Last] dddd [at] LT",
                sameElse: "L",
            },
            relativeTime: {
                future: "%s ago",
                past: "%s ago",
                s: "a few seconds",
                ss: "%d seconds",
                m: "a minute",
                mm: "%d minutes",
                h: "an hour",
                hh: "%d hours",
                d: "a day",
                dd: "%d days",
                M: "a month",
                MM: "%d months",
                y: "a year",
                yy: "%d years",
            },
            dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
            ordinal: function (e) {
                var a = e % 10;
                return (
                    e +
                    (1 == ~~((e % 100) / 10)
                        ? "th"
                        : 1 == a
                        ? "st"
                        : 2 == a
                        ? "nd"
                        : 3 == a
                        ? "rd"
                        : "th")
                );
            },
            week: { dow: 0, doy: 6 },
        }),
        M.defineLocale("en-nz", {
            months: "January_February_March_April_May_June_July_August_September_October_November_December".split(
                "_"
            ),
            monthsShort:
                "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
            weekdays:
                "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split(
                    "_"
                ),
            weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
            weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
            longDateFormat: {
                LT: "h:mm A",
                LTS: "h:mm:ss A",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY h:mm A",
                LLLL: "dddd, D MMMM YYYY h:mm A",
            },
            calendar: {
                sameDay: "[Today at] LT",
                nextDay: "[Tomorrow at] LT",
                nextWeek: "dddd [at] LT",
                lastDay: "[Yesterday at] LT",
                lastWeek: "[Last] dddd [at] LT",
                sameElse: "L",
            },
            relativeTime: {
                future: "%s ago",
                past: "%s ago",
                s: "a few seconds",
                ss: "%d seconds",
                m: "a minute",
                mm: "%d minutes",
                h: "an hour",
                hh: "%d hours",
                d: "a day",
                dd: "%d days",
                M: "a month",
                MM: "%d months",
                y: "a year",
                yy: "%d years",
            },
            dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
            ordinal: function (e) {
                var a = e % 10;
                return (
                    e +
                    (1 == ~~((e % 100) / 10)
                        ? "th"
                        : 1 == a
                        ? "st"
                        : 2 == a
                        ? "nd"
                        : 3 == a
                        ? "rd"
                        : "th")
                );
            },
            week: { dow: 1, doy: 4 },
        }),
        M.defineLocale("en-sg", {
            months: "January_February_March_April_May_June_July_August_September_October_November_December".split(
                "_"
            ),
            monthsShort:
                "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
            weekdays:
                "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split(
                    "_"
                ),
            weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
            weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd, D MMMM YYYY HH:mm",
            },
            calendar: {
                sameDay: "[Today at] LT",
                nextDay: "[Tomorrow at] LT",
                nextWeek: "dddd [at] LT",
                lastDay: "[Yesterday at] LT",
                lastWeek: "[Last] dddd [at] LT",
                sameElse: "L",
            },
            relativeTime: {
                future: "%s ago",
                past: "%s ago",
                s: "a few seconds",
                ss: "%d seconds",
                m: "a minute",
                mm: "%d minutes",
                h: "an hour",
                hh: "%d hours",
                d: "a day",
                dd: "%d days",
                M: "a month",
                MM: "%d months",
                y: "a year",
                yy: "%d years",
            },
            dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
            ordinal: function (e) {
                var a = e % 10;
                return (
                    e +
                    (1 == ~~((e % 100) / 10)
                        ? "th"
                        : 1 == a
                        ? "st"
                        : 2 == a
                        ? "nd"
                        : 3 == a
                        ? "rd"
                        : "th")
                );
            },
            week: { dow: 1, doy: 4 },
        }),
        M.defineLocale("eo", {
            months: "januaro_februaro_marto_aprilo_majo_junio_julio_a\u016dgusto_septembro_oktobro_novembro_decembro".split(
                "_"
            ),
            monthsShort:
                "jan_feb_mart_apr_maj_jun_jul_a\u016dg_sept_okt_nov_dec".split(
                    "_"
                ),
            weekdays:
                "diman\u0109o_lundo_mardo_merkredo_\u0135a\u016ddo_vendredo_sabato".split(
                    "_"
                ),
            weekdaysShort: "dim_lun_mard_merk_\u0135a\u016d_ven_sab".split("_"),
            weekdaysMin: "di_lu_ma_me_\u0135a_ve_sa".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "YYYY-MM-DD",
                LL: "[la] D[-an de] MMMM, YYYY",
                LLL: "[la] D[-an de] MMMM, YYYY HH:mm",
                LLLL: "dddd[n], [la] D[-an de] MMMM, YYYY HH:mm",
                llll: "ddd, [la] D[-an de] MMM, YYYY HH:mm",
            },
            meridiemParse: /[ap]\.t\.m/i,
            isPM: function (e) {
                return "p" === e.charAt(0).toLowerCase();
            },
            meridiem: function (e, a, t) {
                return 11 < e
                    ? t
                        ? "p.t.m."
                        : "P.T.M."
                    : t
                    ? "a.t.m."
                    : "A.T.M.";
            },
            calendar: {
                sameDay: "[Hodia\u016d je] LT",
                nextDay: "[Morga\u016d je] LT",
                nextWeek: "dddd[n je] LT",
                lastDay: "[Hiera\u016d je] LT",
                lastWeek: "[pasintan] dddd[n je] LT",
                sameElse: "L",
            },
            relativeTime: {
                future: "post %s",
                past: "anta\u016d %s",
                s: "kelkaj sekundoj",
                ss: "%d sekundoj",
                m: "unu minuto",
                mm: "%d minutoj",
                h: "unu horo",
                hh: "%d horoj",
                d: "unu tago",
                dd: "%d tagoj",
                M: "unu monato",
                MM: "%d monatoj",
                y: "unu jaro",
                yy: "%d jaroj",
            },
            dayOfMonthOrdinalParse: /\d{1,2}a/,
            ordinal: "%da",
            week: { dow: 1, doy: 7 },
        });
    var _s =
            "ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split(
                "_"
            ),
        os = "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),
        r = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        Ht =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        ms =
            (M.defineLocale("es-do", {
                months: "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split(
                    "_"
                ),
                monthsShort: function (e, a) {
                    return e ? (/-MMM-/.test(a) ? os : _s)[e.month()] : _s;
                },
                monthsRegex: Ht,
                monthsShortRegex: Ht,
                monthsStrictRegex:
                    /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
                monthsShortStrictRegex:
                    /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
                monthsParse: r,
                longMonthsParse: r,
                shortMonthsParse: r,
                weekdays:
                    "domingo_lunes_martes_mi\xe9rcoles_jueves_viernes_s\xe1bado".split(
                        "_"
                    ),
                weekdaysShort: "dom._lun._mar._mi\xe9._jue._vie._s\xe1b.".split(
                    "_"
                ),
                weekdaysMin: "do_lu_ma_mi_ju_vi_s\xe1".split("_"),
                weekdaysParseExact: !0,
                longDateFormat: {
                    LT: "h:mm A",
                    LTS: "h:mm:ss A",
                    L: "DD/MM/YYYY",
                    LL: "D [de] MMMM [de] YYYY",
                    LLL: "D [de] MMMM [de] YYYY h:mm A",
                    LLLL: "dddd, D [de] MMMM [de] YYYY h:mm A",
                },
                calendar: {
                    sameDay: function () {
                        return (
                            "[hoy a la" +
                            (1 !== this.hours() ? "s" : "") +
                            "] LT"
                        );
                    },
                    nextDay: function () {
                        return (
                            "[ma\xf1ana a la" +
                            (1 !== this.hours() ? "s" : "") +
                            "] LT"
                        );
                    },
                    nextWeek: function () {
                        return (
                            "dddd [a la" +
                            (1 !== this.hours() ? "s" : "") +
                            "] LT"
                        );
                    },
                    lastDay: function () {
                        return (
                            "[ayer a la" +
                            (1 !== this.hours() ? "s" : "") +
                            "] LT"
                        );
                    },
                    lastWeek: function () {
                        return (
                            "[el] dddd [pasado a la" +
                            (1 !== this.hours() ? "s" : "") +
                            "] LT"
                        );
                    },
                    sameElse: "L",
                },
                relativeTime: {
                    future: "hace %s",
                    past: "hace %s",
                    s: "unos segundos",
                    ss: "%d segundos",
                    m: "un minuto",
                    mm: "%d minutos",
                    h: "una hora",
                    hh: "%d horas",
                    d: "un d\xeda",
                    dd: "%d d\xedas",
                    w: "una semana",
                    ww: "%d semanas",
                    M: "un mes",
                    MM: "%d meses",
                    y: "un a\xf1o",
                    yy: "%d a\xf1os",
                },
                dayOfMonthOrdinalParse: /\d{1,2}\xba/,
                ordinal: "%d\xba",
                week: { dow: 1, doy: 4 },
            }),
            "ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split(
                "_"
            )),
        us = "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),
        vt = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        jt =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        ls =
            (M.defineLocale("es-mx", {
                months: "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split(
                    "_"
                ),
                monthsShort: function (e, a) {
                    return e ? (/-MMM-/.test(a) ? us : ms)[e.month()] : ms;
                },
                monthsRegex: jt,
                monthsShortRegex: jt,
                monthsStrictRegex:
                    /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
                monthsShortStrictRegex:
                    /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
                monthsParse: vt,
                longMonthsParse: vt,
                shortMonthsParse: vt,
                weekdays:
                    "domingo_lunes_martes_mi\xe9rcoles_jueves_viernes_s\xe1bado".split(
                        "_"
                    ),
                weekdaysShort: "dom._lun._mar._mi\xe9._jue._vie._s\xe1b.".split(
                    "_"
                ),
                weekdaysMin: "do_lu_ma_mi_ju_vi_s\xe1".split("_"),
                weekdaysParseExact: !0,
                longDateFormat: {
                    LT: "H:mm",
                    LTS: "H:mm:ss",
                    L: "DD/MM/YYYY",
                    LL: "D [de] MMMM [de] YYYY",
                    LLL: "D [de] MMMM [de] YYYY H:mm",
                    LLLL: "dddd, D [de] MMMM [de] YYYY H:mm",
                },
                calendar: {
                    sameDay: function () {
                        return (
                            "[hoy a la" +
                            (1 !== this.hours() ? "s" : "") +
                            "] LT"
                        );
                    },
                    nextDay: function () {
                        return (
                            "[ma\xf1ana a la" +
                            (1 !== this.hours() ? "s" : "") +
                            "] LT"
                        );
                    },
                    nextWeek: function () {
                        return (
                            "dddd [a la" +
                            (1 !== this.hours() ? "s" : "") +
                            "] LT"
                        );
                    },
                    lastDay: function () {
                        return (
                            "[ayer a la" +
                            (1 !== this.hours() ? "s" : "") +
                            "] LT"
                        );
                    },
                    lastWeek: function () {
                        return (
                            "[el] dddd [pasado a la" +
                            (1 !== this.hours() ? "s" : "") +
                            "] LT"
                        );
                    },
                    sameElse: "L",
                },
                relativeTime: {
                    future: "hace %s",
                    past: "hace %s",
                    s: "unos segundos",
                    ss: "%d segundos",
                    m: "un minuto",
                    mm: "%d minutos",
                    h: "una hora",
                    hh: "%d horas",
                    d: "un d\xeda",
                    dd: "%d d\xedas",
                    w: "una semana",
                    ww: "%d semanas",
                    M: "un mes",
                    MM: "%d meses",
                    y: "un a\xf1o",
                    yy: "%d a\xf1os",
                },
                dayOfMonthOrdinalParse: /\d{1,2}\xba/,
                ordinal: "%d\xba",
                week: { dow: 0, doy: 4 },
                invalidDate: "Fecha inv\xe1lida",
            }),
            "ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split(
                "_"
            )),
        Ms = "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),
        x = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        na =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        hs =
            (M.defineLocale("es-us", {
                months: "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split(
                    "_"
                ),
                monthsShort: function (e, a) {
                    return e ? (/-MMM-/.test(a) ? Ms : ls)[e.month()] : ls;
                },
                monthsRegex: na,
                monthsShortRegex: na,
                monthsStrictRegex:
                    /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
                monthsShortStrictRegex:
                    /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
                monthsParse: x,
                longMonthsParse: x,
                shortMonthsParse: x,
                weekdays:
                    "domingo_lunes_martes_mi\xe9rcoles_jueves_viernes_s\xe1bado".split(
                        "_"
                    ),
                weekdaysShort: "dom._lun._mar._mi\xe9._jue._vie._s\xe1b.".split(
                    "_"
                ),
                weekdaysMin: "do_lu_ma_mi_ju_vi_s\xe1".split("_"),
                weekdaysParseExact: !0,
                longDateFormat: {
                    LT: "h:mm A",
                    LTS: "h:mm:ss A",
                    L: "MM/DD/YYYY",
                    LL: "D [de] MMMM [de] YYYY",
                    LLL: "D [de] MMMM [de] YYYY h:mm A",
                    LLLL: "dddd, D [de] MMMM [de] YYYY h:mm A",
                },
                calendar: {
                    sameDay: function () {
                        return (
                            "[hoy a la" +
                            (1 !== this.hours() ? "s" : "") +
                            "] LT"
                        );
                    },
                    nextDay: function () {
                        return (
                            "[ma\xf1ana a la" +
                            (1 !== this.hours() ? "s" : "") +
                            "] LT"
                        );
                    },
                    nextWeek: function () {
                        return (
                            "dddd [a la" +
                            (1 !== this.hours() ? "s" : "") +
                            "] LT"
                        );
                    },
                    lastDay: function () {
                        return (
                            "[ayer a la" +
                            (1 !== this.hours() ? "s" : "") +
                            "] LT"
                        );
                    },
                    lastWeek: function () {
                        return (
                            "[el] dddd [pasado a la" +
                            (1 !== this.hours() ? "s" : "") +
                            "] LT"
                        );
                    },
                    sameElse: "L",
                },
                relativeTime: {
                    future: "hace %s",
                    past: "hace %s",
                    s: "unos segundos",
                    ss: "%d segundos",
                    m: "un minuto",
                    mm: "%d minutos",
                    h: "una hora",
                    hh: "%d horas",
                    d: "un d\xeda",
                    dd: "%d d\xedas",
                    w: "una semana",
                    ww: "%d semanas",
                    M: "un mes",
                    MM: "%d meses",
                    y: "un a\xf1o",
                    yy: "%d a\xf1os",
                },
                dayOfMonthOrdinalParse: /\d{1,2}\xba/,
                ordinal: "%d\xba",
                week: { dow: 0, doy: 6 },
            }),
            "ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split(
                "_"
            )),
        cs = "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),
        ge = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        n =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
    function Ls(e, a, t, s) {
        e = {
            s: ["m\xf5ne sekundi", "m\xf5ni sekund", "paar sekundit"],
            ss: [e + "sekundi", e + "sekundit"],
            m: ["\xfche minuti", "\xfcks minut"],
            mm: [e + " minuti", e + " minutit"],
            h: ["\xfche tunni", "tund aega", "\xfcks tund"],
            hh: [e + " tunni", e + " tundi"],
            d: ["\xfche p\xe4eva", "\xfcks p\xe4ev"],
            M: ["kuu aja", "kuu aega", "\xfcks kuu"],
            MM: [e + " kuu", e + " kuud"],
            y: ["\xfche aasta", "aasta", "\xfcks aasta"],
            yy: [e + " aasta", e + " aastat"],
        };
        return a ? e[t][2] || e[t][1] : s ? e[t][0] : e[t][1];
    }
    M.defineLocale("es", {
        months: "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split(
            "_"
        ),
        monthsShort: function (e, a) {
            return e ? (/-MMM-/.test(a) ? cs : hs)[e.month()] : hs;
        },
        monthsRegex: n,
        monthsShortRegex: n,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: ge,
        longMonthsParse: ge,
        shortMonthsParse: ge,
        weekdays:
            "domingo_lunes_martes_mi\xe9rcoles_jueves_viernes_s\xe1bado".split(
                "_"
            ),
        weekdaysShort: "dom._lun._mar._mi\xe9._jue._vie._s\xe1b.".split("_"),
        weekdaysMin: "do_lu_ma_mi_ju_vi_s\xe1".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D [de] MMMM [de] YYYY",
            LLL: "D [de] MMMM [de] YYYY H:mm",
            LLLL: "dddd, D [de] MMMM [de] YYYY H:mm",
        },
        calendar: {
            sameDay: function () {
                return "[hoy a la" + (1 !== this.hours() ? "s" : "") + "] LT";
            },
            nextDay: function () {
                return (
                    "[ma\xf1ana a la" + (1 !== this.hours() ? "s" : "") + "] LT"
                );
            },
            nextWeek: function () {
                return "dddd [a la" + (1 !== this.hours() ? "s" : "") + "] LT";
            },
            lastDay: function () {
                return "[ayer a la" + (1 !== this.hours() ? "s" : "") + "] LT";
            },
            lastWeek: function () {
                return (
                    "[el] dddd [pasado a la" +
                    (1 !== this.hours() ? "s" : "") +
                    "] LT"
                );
            },
            sameElse: "L",
        },
        relativeTime: {
            future: "hace %s",
            past: "hace %s",
            s: "unos segundos",
            ss: "%d segundos",
            m: "un minuto",
            mm: "%d minutos",
            h: "una hora",
            hh: "%d horas",
            d: "un d\xeda",
            dd: "%d d\xedas",
            w: "una semana",
            ww: "%d semanas",
            M: "un mes",
            MM: "%d meses",
            y: "un a\xf1o",
            yy: "%d a\xf1os",
        },
        dayOfMonthOrdinalParse: /\d{1,2}\xba/,
        ordinal: "%d\xba",
        week: { dow: 1, doy: 4 },
        invalidDate: "Fecha inv\xe1lida",
    }),
        M.defineLocale("et", {
            months: "jaanuar_veebruar_m\xe4rts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember".split(
                "_"
            ),
            monthsShort:
                "jaan_veebr_m\xe4rts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets".split(
                    "_"
                ),
            weekdays:
                "p\xfchap\xe4ev_esmasp\xe4ev_teisip\xe4ev_kolmap\xe4ev_neljap\xe4ev_reede_laup\xe4ev".split(
                    "_"
                ),
            weekdaysShort: "P_E_T_K_N_R_L".split("_"),
            weekdaysMin: "P_E_T_K_N_R_L".split("_"),
            longDateFormat: {
                LT: "H:mm",
                LTS: "H:mm:ss",
                L: "DD.MM.YYYY",
                LL: "D. MMMM YYYY",
                LLL: "D. MMMM YYYY H:mm",
                LLLL: "dddd, D. MMMM YYYY H:mm",
            },
            calendar: {
                sameDay: "[T\xe4na,] LT",
                nextDay: "[Homme,] LT",
                nextWeek: "[J\xe4rgmine] dddd LT",
                lastDay: "[Eile,] LT",
                lastWeek: "[Eelmine] dddd LT",
                sameElse: "L",
            },
            relativeTime: {
                future: "%s p\xe4rast",
                past: "%s tagasi",
                s: Ls,
                ss: Ls,
                m: Ls,
                mm: Ls,
                h: Ls,
                hh: Ls,
                d: Ls,
                dd: "%d p\xe4eva",
                M: Ls,
                MM: Ls,
                y: Ls,
                yy: Ls,
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: { dow: 1, doy: 4 },
        }),
        M.defineLocale("eu", {
            months: "urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua".split(
                "_"
            ),
            monthsShort:
                "urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.".split(
                    "_"
                ),
            monthsParseExact: !0,
            weekdays:
                "igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata".split(
                    "_"
                ),
            weekdaysShort: "ig._al._ar._az._og._ol._lr.".split("_"),
            weekdaysMin: "ig_al_ar_az_og_ol_lr".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "YYYY-MM-DD",
                LL: "YYYY[ko] MMMM[ren] D[a]",
                LLL: "YYYY[ko] MMMM[ren] D[a] HH:mm",
                LLLL: "dddd, YYYY[ko] MMMM[ren] D[a] HH:mm",
                l: "YYYY-M-D",
                ll: "YYYY[ko] MMM D[a]",
                lll: "YYYY[ko] MMM D[a] HH:mm",
                llll: "ddd, YYYY[ko] MMM D[a] HH:mm",
            },
            calendar: {
                sameDay: "[gaur] LT[etan]",
                nextDay: "[bihar] LT[etan]",
                nextWeek: "dddd LT[etan]",
                lastDay: "[atzo] LT[etan]",
                lastWeek: "[aurreko] dddd LT[etan]",
                sameElse: "L",
            },
            relativeTime: {
                future: "%s barru",
                past: "duela %s",
                s: "segundo batzuk",
                ss: "%d segundo",
                m: "minutu bat",
                mm: "%d minutu",
                h: "ordu bat",
                hh: "%d ordu",
                d: "egun bat",
                dd: "%d egun",
                M: "hilabete bat",
                MM: "%d hilabete",
                y: "urte bat",
                yy: "%d urte",
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: { dow: 1, doy: 7 },
        });
    var Ys = {
            1: "\u06f1",
            2: "\u06f2",
            3: "\u06f3",
            4: "\u06f4",
            5: "\u06f5",
            6: "\u06f6",
            7: "\u06f7",
            8: "\u06f8",
            9: "\u06f9",
            0: "\u06f0",
        },
        ys = {
            "\u06f1": "1",
            "\u06f2": "2",
            "\u06f3": "3",
            "\u06f4": "4",
            "\u06f5": "5",
            "\u06f6": "6",
            "\u06f7": "7",
            "\u06f8": "8",
            "\u06f9": "9",
            "\u06f0": "0",
        },
        fs =
            (M.defineLocale("fa", {
                months: "\u0698\u0627\u0646\u0648\u06cc\u0647_\u0641\u0648\u0631\u06cc\u0647_\u0645\u0627\u0631\u0633_\u0622\u0648\u0631\u06cc\u0644_\u0645\u0647_\u0698\u0648\u0626\u0646_\u0698\u0648\u0626\u06cc\u0647_\u0627\u0648\u062a_\u0633\u067e\u062a\u0627\u0645\u0628\u0631_\u0627\u06a9\u062a\u0628\u0631_\u0646\u0648\u0627\u0645\u0628\u0631_\u062f\u0633\u0627\u0645\u0628\u0631".split(
                    "_"
                ),
                monthsShort:
                    "\u0698\u0627\u0646\u0648\u06cc\u0647_\u0641\u0648\u0631\u06cc\u0647_\u0645\u0627\u0631\u0633_\u0622\u0648\u0631\u06cc\u0644_\u0645\u0647_\u0698\u0648\u0626\u0646_\u0698\u0648\u0626\u06cc\u0647_\u0627\u0648\u062a_\u0633\u067e\u062a\u0627\u0645\u0628\u0631_\u0627\u06a9\u062a\u0628\u0631_\u0646\u0648\u0627\u0645\u0628\u0631_\u062f\u0633\u0627\u0645\u0628\u0631".split(
                        "_"
                    ),
                weekdays:
                    "\u06cc\u06a9\u200c\u0634\u0646\u0628\u0647_\u062f\u0648\u0634\u0646\u0628\u0647_\u0633\u0647\u200c\u0634\u0646\u0628\u0647_\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647_\u067e\u0646\u062c\u200c\u0634\u0646\u0628\u0647_\u062c\u0645\u0639\u0647_\u0634\u0646\u0628\u0647".split(
                        "_"
                    ),
                weekdaysShort:
                    "\u06cc\u06a9\u200c\u0634\u0646\u0628\u0647_\u062f\u0648\u0634\u0646\u0628\u0647_\u0633\u0647\u200c\u0634\u0646\u0628\u0647_\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647_\u067e\u0646\u062c\u200c\u0634\u0646\u0628\u0647_\u062c\u0645\u0639\u0647_\u0634\u0646\u0628\u0647".split(
                        "_"
                    ),
                weekdaysMin:
                    "\u06cc_\u062f_\u0633_\u0686_\u067e_\u062c_\u0634".split(
                        "_"
                    ),
                weekdaysParseExact: !0,
                longDateFormat: {
                    LT: "HH:mm",
                    LTS: "HH:mm:ss",
                    L: "DD/MM/YYYY",
                    LL: "D MMMM YYYY",
                    LLL: "D MMMM YYYY HH:mm",
                    LLLL: "dddd, D MMMM YYYY HH:mm",
                },
                meridiemParse:
                    /\u0642\u0628\u0644 \u0627\u0632 \u0638\u0647\u0631|\u0628\u0639\u062f \u0627\u0632 \u0638\u0647\u0631/,
                isPM: function (e) {
                    return /\u0628\u0639\u062f \u0627\u0632 \u0638\u0647\u0631/.test(
                        e
                    );
                },
                meridiem: function (e, a, t) {
                    return e < 12
                        ? "\u0642\u0628\u0644 \u0627\u0632 \u0638\u0647\u0631"
                        : "\u0628\u0639\u062f \u0627\u0632 \u0638\u0647\u0631";
                },
                calendar: {
                    sameDay:
                        "[\u0627\u0645\u0631\u0648\u0632 \u0633\u0627\u0639\u062a] LT",
                    nextDay:
                        "[\u0641\u0631\u062f\u0627 \u0633\u0627\u0639\u062a] LT",
                    nextWeek: "dddd [\u0633\u0627\u0639\u062a] LT",
                    lastDay:
                        "[\u062f\u06cc\u0631\u0648\u0632 \u0633\u0627\u0639\u062a] LT",
                    lastWeek:
                        "dddd [\u067e\u06cc\u0634] [\u0633\u0627\u0639\u062a] LT",
                    sameElse: "L",
                },
                relativeTime: {
                    future: "\u062f\u0631 %s",
                    past: "%s \u067e\u06cc\u0634",
                    s: "\u0686\u0646\u062f \u062b\u0627\u0646\u06cc\u0647",
                    ss: "%d \u062b\u0627\u0646\u06cc\u0647",
                    m: "\u06cc\u06a9 \u062f\u0642\u06cc\u0642\u0647",
                    mm: "%d \u062f\u0642\u06cc\u0642\u0647",
                    h: "\u06cc\u06a9 \u0633\u0627\u0639\u062a",
                    hh: "%d \u0633\u0627\u0639\u062a",
                    d: "\u06cc\u06a9 \u0631\u0648\u0632",
                    dd: "%d \u0631\u0648\u0632",
                    M: "\u06cc\u06a9 \u0645\u0627\u0647",
                    MM: "%d \u0645\u0627\u0647",
                    y: "\u06cc\u06a9 \u0633\u0627\u0644",
                    yy: "%d \u0633\u0627\u0644",
                },
                preparse: function (e) {
                    return e
                        .replace(/[\u06f0-\u06f9]/g, function (e) {
                            return ys[e];
                        })
                        .replace(/\u060c/g, ",");
                },
                postformat: function (e) {
                    return e
                        .replace(/\d/g, function (e) {
                            return Ys[e];
                        })
                        .replace(/,/g, "\u060c");
                },
                dayOfMonthOrdinalParse: /\d{1,2}\u0645/,
                ordinal: "%d\u0645",
                week: { dow: 6, doy: 12 },
            }),
            "nolla yksi kaksi kolme nelj\xe4 viisi kuusi seitsem\xe4n kahdeksan yhdeks\xe4n".split(
                " "
            )),
        ps = [
            "nolla",
            "yhden",
            "kahden",
            "kolmen",
            "nelj\xe4n",
            "viiden",
            "kuuden",
            fs[7],
            fs[8],
            fs[9],
        ];
    function O(e, a, t, s) {
        var n = "";
        switch (t) {
            case "s":
                return s ? "muutaman sekunnin" : "muutama sekunti";
            case "ss":
                n = s ? "sekunnin" : "sekuntia";
                break;
            case "m":
                return s ? "minuutin" : "minuutti";
            case "mm":
                n = s ? "minuutin" : "minuuttia";
                break;
            case "h":
                return s ? "tunnin" : "tunti";
            case "hh":
                n = s ? "tunnin" : "tuntia";
                break;
            case "d":
                return s ? "p\xe4iv\xe4n" : "p\xe4iv\xe4";
            case "dd":
                n = s ? "p\xe4iv\xe4n" : "p\xe4iv\xe4\xe4";
                break;
            case "M":
                return s ? "kuukauden" : "kuukausi";
            case "MM":
                n = s ? "kuukauden" : "kuukautta";
                break;
            case "y":
                return s ? "vuoden" : "vuosi";
            case "yy":
                n = s ? "vuoden" : "vuotta";
                break;
        }
        return (t = s), (n = ((e = e) < 10 ? (t ? ps : fs)[e] : e) + " " + n);
    }
    M.defineLocale("fi", {
        months: "tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kes\xe4kuu_hein\xe4kuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu".split(
            "_"
        ),
        monthsShort:
            "tammi_helmi_maalis_huhti_touko_kes\xe4_hein\xe4_elo_syys_loka_marras_joulu".split(
                "_"
            ),
        weekdays:
            "sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai".split(
                "_"
            ),
        weekdaysShort: "su_ma_ti_ke_to_pe_la".split("_"),
        weekdaysMin: "su_ma_ti_ke_to_pe_la".split("_"),
        longDateFormat: {
            LT: "HH.mm",
            LTS: "HH.mm.ss",
            L: "DD.MM.YYYY",
            LL: "Do MMMM[ta] YYYY",
            LLL: "Do MMMM[ta] YYYY, [klo] HH.mm",
            LLLL: "dddd, Do MMMM[ta] YYYY, [klo] HH.mm",
            l: "D.M.YYYY",
            ll: "Do MMM YYYY",
            lll: "Do MMM YYYY, [klo] HH.mm",
            llll: "ddd, Do MMM YYYY, [klo] HH.mm",
        },
        calendar: {
            sameDay: "[t\xe4n\xe4\xe4n] [klo] LT",
            nextDay: "[huomenna] [klo] LT",
            nextWeek: "dddd [klo] LT",
            lastDay: "[eilen] [klo] LT",
            lastWeek: "[viime] dddd[na] [klo] LT",
            sameElse: "L",
        },
        relativeTime: {
            future: "%s p\xe4\xe4st\xe4",
            past: "%s sitten",
            s: O,
            ss: O,
            m: O,
            mm: O,
            h: O,
            hh: O,
            d: O,
            dd: O,
            M: O,
            MM: O,
            y: O,
            yy: O,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: { dow: 1, doy: 4 },
    }),
        M.defineLocale("fil", {
            months: "Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre".split(
                "_"
            ),
            monthsShort:
                "Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis".split("_"),
            weekdays:
                "Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado".split(
                    "_"
                ),
            weekdaysShort: "Lin_Lun_Mar_Miy_Huw_Biy_Sab".split("_"),
            weekdaysMin: "Li_Lu_Ma_Mi_Hu_Bi_Sab".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "MM/D/YYYY",
                LL: "MMMM D, YYYY",
                LLL: "MMMM D, YYYY HH:mm",
                LLLL: "dddd, MMMM DD, YYYY HH:mm",
            },
            calendar: {
                sameDay: "LT [ngayong araw]",
                nextDay: "[Bukas ng] LT",
                nextWeek: "LT [sa susunod na] dddd",
                lastDay: "LT [kahapon]",
                lastWeek: "LT [noong nakaraang] dddd",
                sameElse: "L",
            },
            relativeTime: {
                future: "sa loob ng %s",
                past: "%s ang nakalipas",
                s: "ilang segundo",
                ss: "%d segundo",
                m: "isang minuto",
                mm: "%d minuto",
                h: "isang oras",
                hh: "%d oras",
                d: "isang araw",
                dd: "%d araw",
                M: "isang buwan",
                MM: "%d buwan",
                y: "isang taon",
                yy: "%d taon",
            },
            dayOfMonthOrdinalParse: /\d{1,2}/,
            ordinal: function (e) {
                return e;
            },
            week: { dow: 1, doy: 4 },
        }),
        M.defineLocale("fo", {
            months: "januar_februar_mars_apr\xedl_mai_juni_juli_august_september_oktober_november_desember".split(
                "_"
            ),
            monthsShort:
                "jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des".split("_"),
            weekdays:
                "sunnudagur_m\xe1nadagur_t\xfdsdagur_mikudagur_h\xf3sdagur_fr\xedggjadagur_leygardagur".split(
                    "_"
                ),
            weekdaysShort: "sun_m\xe1n_t\xfds_mik_h\xf3s_fr\xed_ley".split("_"),
            weekdaysMin: "su_m\xe1_t\xfd_mi_h\xf3_fr_le".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd D. MMMM, YYYY HH:mm",
            },
            calendar: {
                sameDay: "[\xcd dag kl.] LT",
                nextDay: "[\xcd morgin kl.] LT",
                nextWeek: "dddd [kl.] LT",
                lastDay: "[\xcd gj\xe1r kl.] LT",
                lastWeek: "[s\xed\xf0stu] dddd [kl] LT",
                sameElse: "L",
            },
            relativeTime: {
                future: "um %s",
                past: "%s s\xed\xf0ani",
                s: "f\xe1 sekund",
                ss: "%d sekundir",
                m: "ein minuttur",
                mm: "%d minuttir",
                h: "ein t\xedmi",
                hh: "%d t\xedmar",
                d: "ein dagur",
                dd: "%d dagar",
                M: "ein m\xe1na\xf0ur",
                MM: "%d m\xe1na\xf0ir",
                y: "eitt \xe1r",
                yy: "%d \xe1r",
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: { dow: 1, doy: 4 },
        }),
        M.defineLocale("fr-ca", {
            months: "janvier_f\xe9vrier_mars_avril_mai_juin_juillet_ao\xfbt_septembre_octobre_novembre_d\xe9cembre".split(
                "_"
            ),
            monthsShort:
                "janv._f\xe9vr._mars_avr._mai_juin_juil._ao\xfbt_sept._oct._nov._d\xe9c.".split(
                    "_"
                ),
            monthsParseExact: !0,
            weekdays:
                "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split(
                    "_"
                ),
            weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
            weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "YYYY-MM-DD",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd D MMMM YYYY HH:mm",
            },
            calendar: {
                sameDay: "[Aujourd\u2019hui \xe0] LT",
                nextDay: "[Demain \xe0] LT",
                nextWeek: "dddd [\xe0] LT",
                lastDay: "[Hier \xe0] LT",
                lastWeek: "dddd [dernier \xe0] LT",
                sameElse: "L",
            },
            relativeTime: {
                future: "dans %s",
                past: "il y a %s",
                s: "quelques secondes",
                ss: "%d secondes",
                m: "une minute",
                mm: "%d minutes",
                h: "une heure",
                hh: "%d heures",
                d: "un jour",
                dd: "%d jours",
                M: "un mois",
                MM: "%d mois",
                y: "un an",
                yy: "%d ans",
            },
            dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
            ordinal: function (e, a) {
                switch (a) {
                    default:
                    case "M":
                    case "Q":
                    case "D":
                    case "DDD":
                    case "d":
                        return e + (1 === e ? "er" : "e");
                    case "w":
                    case "W":
                        return e + (1 === e ? "re" : "e");
                }
            },
        }),
        M.defineLocale("fr-ch", {
            months: "janvier_f\xe9vrier_mars_avril_mai_juin_juillet_ao\xfbt_septembre_octobre_novembre_d\xe9cembre".split(
                "_"
            ),
            monthsShort:
                "janv._f\xe9vr._mars_avr._mai_juin_juil._ao\xfbt_sept._oct._nov._d\xe9c.".split(
                    "_"
                ),
            monthsParseExact: !0,
            weekdays:
                "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split(
                    "_"
                ),
            weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
            weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD.MM.YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd D MMMM YYYY HH:mm",
            },
            calendar: {
                sameDay: "[Aujourd\u2019hui \xe0] LT",
                nextDay: "[Demain \xe0] LT",
                nextWeek: "dddd [\xe0] LT",
                lastDay: "[Hier \xe0] LT",
                lastWeek: "dddd [dernier \xe0] LT",
                sameElse: "L",
            },
            relativeTime: {
                future: "dans %s",
                past: "il y a %s",
                s: "quelques secondes",
                ss: "%d secondes",
                m: "une minute",
                mm: "%d minutes",
                h: "une heure",
                hh: "%d heures",
                d: "un jour",
                dd: "%d jours",
                M: "un mois",
                MM: "%d mois",
                y: "un an",
                yy: "%d ans",
            },
            dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
            ordinal: function (e, a) {
                switch (a) {
                    default:
                    case "M":
                    case "Q":
                    case "D":
                    case "DDD":
                    case "d":
                        return e + (1 === e ? "er" : "e");
                    case "w":
                    case "W":
                        return e + (1 === e ? "re" : "e");
                }
            },
            week: { dow: 1, doy: 4 },
        });
    var De =
            /(janv\.?|f\xe9vr\.?|mars|avr\.?|mai|juin|juil\.?|ao\xfbt|sept\.?|oct\.?|nov\.?|d\xe9c\.?|janvier|f\xe9vrier|mars|avril|mai|juin|juillet|ao\xfbt|septembre|octobre|novembre|d\xe9cembre)/i,
        pe = [
            /^janv/i,
            /^f\xe9vr/i,
            /^mars/i,
            /^avr/i,
            /^mai/i,
            /^juin/i,
            /^juil/i,
            /^ao\xfbt/i,
            /^sept/i,
            /^oct/i,
            /^nov/i,
            /^d\xe9c/i,
        ],
        ks =
            (M.defineLocale("fr", {
                months: "janvier_f\xe9vrier_mars_avril_mai_juin_juillet_ao\xfbt_septembre_octobre_novembre_d\xe9cembre".split(
                    "_"
                ),
                monthsShort:
                    "janv._f\xe9vr._mars_avr._mai_juin_juil._ao\xfbt_sept._oct._nov._d\xe9c.".split(
                        "_"
                    ),
                monthsRegex: De,
                monthsShortRegex: De,
                monthsStrictRegex:
                    /^(janvier|f\xe9vrier|mars|avril|mai|juin|juillet|ao\xfbt|septembre|octobre|novembre|d\xe9cembre)/i,
                monthsShortStrictRegex:
                    /(janv\.?|f\xe9vr\.?|mars|avr\.?|mai|juin|juil\.?|ao\xfbt|sept\.?|oct\.?|nov\.?|d\xe9c\.?)/i,
                monthsParse: pe,
                longMonthsParse: pe,
                shortMonthsParse: pe,
                weekdays:
                    "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split(
                        "_"
                    ),
                weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
                weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"),
                weekdaysParseExact: !0,
                longDateFormat: {
                    LT: "HH:mm",
                    LTS: "HH:mm:ss",
                    L: "DD/MM/YYYY",
                    LL: "D MMMM YYYY",
                    LLL: "D MMMM YYYY HH:mm",
                    LLLL: "dddd D MMMM YYYY HH:mm",
                },
                calendar: {
                    sameDay: "[Aujourd\u2019hui \xe0] LT",
                    nextDay: "[Demain \xe0] LT",
                    nextWeek: "dddd [\xe0] LT",
                    lastDay: "[Hier \xe0] LT",
                    lastWeek: "dddd [dernier \xe0] LT",
                    sameElse: "L",
                },
                relativeTime: {
                    future: "dans %s",
                    past: "il y a %s",
                    s: "quelques secondes",
                    ss: "%d secondes",
                    m: "une minute",
                    mm: "%d minutes",
                    h: "une heure",
                    hh: "%d heures",
                    d: "un jour",
                    dd: "%d jours",
                    w: "une semaine",
                    ww: "%d semaines",
                    M: "un mois",
                    MM: "%d mois",
                    y: "un an",
                    yy: "%d ans",
                },
                dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
                ordinal: function (e, a) {
                    switch (a) {
                        case "D":
                            return e + (1 === e ? "er" : "");
                        default:
                        case "M":
                        case "Q":
                        case "DDD":
                        case "d":
                            return e + (1 === e ? "er" : "e");
                        case "w":
                        case "W":
                            return e + (1 === e ? "re" : "e");
                    }
                },
                week: { dow: 1, doy: 4 },
            }),
            "jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.".split(
                "_"
            )),
        Ds = "jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des".split("_");
    M.defineLocale("fy", {
        months: "jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber".split(
            "_"
        ),
        monthsShort: function (e, a) {
            return e ? (/-MMM-/.test(a) ? Ds : ks)[e.month()] : ks;
        },
        monthsParseExact: !0,
        weekdays: "snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon".split(
            "_"
        ),
        weekdaysShort: "si._mo._ti._wo._to._fr._so.".split("_"),
        weekdaysMin: "Si_Mo_Ti_Wo_To_Fr_So".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD-MM-YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd D MMMM YYYY HH:mm",
        },
        calendar: {
            sameDay: "[hjoed om] LT",
            nextDay: "[moarn om] LT",
            nextWeek: "dddd [om] LT",
            lastDay: "[juster om] LT",
            lastWeek: "[\xf4fr\xfbne] dddd [om] LT",
            sameElse: "L",
        },
        relativeTime: {
            future: "oer %s",
            past: "%s lyn",
            s: "in pear sekonden",
            ss: "%d sekonden",
            m: "ien min\xfat",
            mm: "%d minuten",
            h: "ien oere",
            hh: "%d oeren",
            d: "ien dei",
            dd: "%d dagen",
            M: "ien moanne",
            MM: "%d moannen",
            y: "ien jier",
            yy: "%d jierren",
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (e) {
            return e + (1 === e || 8 === e || 20 <= e ? "ste" : "de");
        },
        week: { dow: 1, doy: 4 },
    }),
        M.defineLocale("ga", {
            months: [
                "Ean\xe1ir",
                "Feabhra",
                "M\xe1rta",
                "Aibre\xe1n",
                "Bealtaine",
                "Meitheamh",
                "I\xfail",
                "L\xfanasa",
                "Me\xe1n F\xf3mhair",
                "Deireadh F\xf3mhair",
                "Samhain",
                "Nollaig",
            ],
            monthsShort: [
                "Ean",
                "Feabh",
                "M\xe1rt",
                "Aib",
                "Beal",
                "Meith",
                "I\xfail",
                "L\xfan",
                "M.F.",
                "D.F.",
                "Samh",
                "Noll",
            ],
            monthsParseExact: !0,
            weekdays: [
                "D\xe9 Domhnaigh",
                "D\xe9 Luain",
                "D\xe9 M\xe1irt",
                "D\xe9 C\xe9adaoin",
                "D\xe9ardaoin",
                "D\xe9 hAoine",
                "D\xe9 Sathairn",
            ],
            weekdaysShort: [
                "Domh",
                "Luan",
                "M\xe1irt",
                "C\xe9ad",
                "D\xe9ar",
                "Aoine",
                "Sath",
            ],
            weekdaysMin: ["Do", "Lu", "M\xe1", "C\xe9", "D\xe9", "A", "Sa"],
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd, D MMMM YYYY HH:mm",
            },
            calendar: {
                sameDay: "[Inniu ag] LT",
                nextDay: "[Am\xe1rach ag] LT",
                nextWeek: "dddd [ag] LT",
                lastDay: "[Inn\xe9 ag] LT",
                lastWeek: "dddd [seo caite] [ag] LT",
                sameElse: "L",
            },
            relativeTime: {
                future: "i %s",
                past: "%s \xf3 shin",
                s: "c\xfapla soicind",
                ss: "%d soicind",
                m: "n\xf3im\xe9ad",
                mm: "%d n\xf3im\xe9ad",
                h: "uair an chloig",
                hh: "%d uair an chloig",
                d: "l\xe1",
                dd: "%d l\xe1",
                M: "m\xed",
                MM: "%d m\xedonna",
                y: "bliain",
                yy: "%d bliain",
            },
            dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
            ordinal: function (e) {
                return e + (1 === e ? "d" : e % 10 == 2 ? "na" : "mh");
            },
            week: { dow: 1, doy: 4 },
        });
    function Ts(e, a, t, s) {
        e = {
            s: [
                "\u0925\u094b\u0921\u092f\u093e \u0938\u0945\u0915\u0902\u0921\u093e\u0902\u0928\u0940",
                "\u0925\u094b\u0921\u0947 \u0938\u0945\u0915\u0902\u0921",
            ],
            ss: [
                e + " \u0938\u0945\u0915\u0902\u0921\u093e\u0902\u0928\u0940",
                e + " \u0938\u0945\u0915\u0902\u0921",
            ],
            m: [
                "\u090f\u0915\u093e \u092e\u093f\u0923\u091f\u093e\u0928",
                "\u090f\u0915 \u092e\u093f\u0928\u0942\u091f",
            ],
            mm: [
                e + " \u092e\u093f\u0923\u091f\u093e\u0902\u0928\u0940",
                e + " \u092e\u093f\u0923\u091f\u093e\u0902",
            ],
            h: [
                "\u090f\u0915\u093e \u0935\u0930\u093e\u0928",
                "\u090f\u0915 \u0935\u0930",
            ],
            hh: [
                e + " \u0935\u0930\u093e\u0902\u0928\u0940",
                e + " \u0935\u0930\u093e\u0902",
            ],
            d: [
                "\u090f\u0915\u093e \u0926\u093f\u0938\u093e\u0928",
                "\u090f\u0915 \u0926\u0940\u0938",
            ],
            dd: [
                e + " \u0926\u093f\u0938\u093e\u0902\u0928\u0940",
                e + " \u0926\u0940\u0938",
            ],
            M: [
                "\u090f\u0915\u093e \u092e\u094d\u0939\u092f\u0928\u094d\u092f\u093e\u0928",
                "\u090f\u0915 \u092e\u094d\u0939\u092f\u0928\u094b",
            ],
            MM: [
                e +
                    " \u092e\u094d\u0939\u092f\u0928\u094d\u092f\u093e\u0928\u0940",
                e + " \u092e\u094d\u0939\u092f\u0928\u0947",
            ],
            y: [
                "\u090f\u0915\u093e \u0935\u0930\u094d\u0938\u093e\u0928",
                "\u090f\u0915 \u0935\u0930\u094d\u0938",
            ],
            yy: [
                e + " \u0935\u0930\u094d\u0938\u093e\u0902\u0928\u0940",
                e + " \u0935\u0930\u094d\u0938\u093e\u0902",
            ],
        };
        return s ? e[t][0] : e[t][1];
    }
    function gs(e, a, t, s) {
        e = {
            s: ["thoddea sekondamni", "thodde sekond"],
            ss: [e + " sekondamni", e + " sekond"],
            m: ["eka mintan", "ek minut"],
            mm: [e + " mintamni", e + " mintam"],
            h: ["eka voran", "ek vor"],
            hh: [e + " voramni", e + " voram"],
            d: ["eka disan", "ek dis"],
            dd: [e + " disamni", e + " dis"],
            M: ["eka mhoinean", "ek mhoino"],
            MM: [e + " mhoineamni", e + " mhoine"],
            y: ["eka vorsan", "ek voros"],
            yy: [e + " vorsamni", e + " vorsam"],
        };
        return s ? e[t][0] : e[t][1];
    }
    M.defineLocale("gd", {
        months: [
            "Am Faoilleach",
            "An Gearran",
            "Am M\xe0rt",
            "An Giblean",
            "An C\xe8itean",
            "An t-\xd2gmhios",
            "An t-Iuchar",
            "An L\xf9nastal",
            "An t-Sultain",
            "An D\xe0mhair",
            "An t-Samhain",
            "An D\xf9bhlachd",
        ],
        monthsShort: [
            "Faoi",
            "Gear",
            "M\xe0rt",
            "Gibl",
            "C\xe8it",
            "\xd2gmh",
            "Iuch",
            "L\xf9n",
            "Sult",
            "D\xe0mh",
            "Samh",
            "D\xf9bh",
        ],
        monthsParseExact: !0,
        weekdays: [
            "Did\xf2mhnaich",
            "Diluain",
            "Dim\xe0irt",
            "Diciadain",
            "Diardaoin",
            "Dihaoine",
            "Disathairne",
        ],
        weekdaysShort: ["Did", "Dil", "Dim", "Dic", "Dia", "Dih", "Dis"],
        weekdaysMin: ["D\xf2", "Lu", "M\xe0", "Ci", "Ar", "Ha", "Sa"],
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm",
        },
        calendar: {
            sameDay: "[An-diugh aig] LT",
            nextDay: "[A-m\xe0ireach aig] LT",
            nextWeek: "dddd [aig] LT",
            lastDay: "[An-d\xe8 aig] LT",
            lastWeek: "dddd [seo chaidh] [aig] LT",
            sameElse: "L",
        },
        relativeTime: {
            future: "ann an %s",
            past: "bho chionn %s",
            s: "beagan diogan",
            ss: "%d diogan",
            m: "mionaid",
            mm: "%d mionaidean",
            h: "uair",
            hh: "%d uairean",
            d: "latha",
            dd: "%d latha",
            M: "m\xecos",
            MM: "%d m\xecosan",
            y: "bliadhna",
            yy: "%d bliadhna",
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function (e) {
            return e + (1 === e ? "d" : e % 10 == 2 ? "na" : "mh");
        },
        week: { dow: 1, doy: 4 },
    }),
        M.defineLocale("gl", {
            months: "xaneiro_febreiro_marzo_abril_maio_xu\xf1o_xullo_agosto_setembro_outubro_novembro_decembro".split(
                "_"
            ),
            monthsShort:
                "xan._feb._mar._abr._mai._xu\xf1._xul._ago._set._out._nov._dec.".split(
                    "_"
                ),
            monthsParseExact: !0,
            weekdays:
                "domingo_luns_martes_m\xe9rcores_xoves_venres_s\xe1bado".split(
                    "_"
                ),
            weekdaysShort: "dom._lun._mar._m\xe9r._xov._ven._s\xe1b.".split(
                "_"
            ),
            weekdaysMin: "do_lu_ma_m\xe9_xo_ve_s\xe1".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "H:mm",
                LTS: "H:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D [de] MMMM [de] YYYY",
                LLL: "D [de] MMMM [de] YYYY H:mm",
                LLLL: "dddd, D [de] MMMM [de] YYYY H:mm",
            },
            calendar: {
                sameDay: function () {
                    return (
                        "[hoxe " +
                        (1 !== this.hours() ? "\xe1s" : "\xe1") +
                        "] LT"
                    );
                },
                nextDay: function () {
                    return (
                        "[ma\xf1\xe1 " +
                        (1 !== this.hours() ? "\xe1s" : "\xe1") +
                        "] LT"
                    );
                },
                nextWeek: function () {
                    return (
                        "dddd [" + (1 !== this.hours() ? "\xe1s" : "a") + "] LT"
                    );
                },
                lastDay: function () {
                    return (
                        "[onte " + (1 !== this.hours() ? "\xe1" : "a") + "] LT"
                    );
                },
                lastWeek: function () {
                    return (
                        "[o] dddd [pasado " +
                        (1 !== this.hours() ? "\xe1s" : "a") +
                        "] LT"
                    );
                },
                sameElse: "L",
            },
            relativeTime: {
                future: function (e) {
                    return 0 === e.indexOf("un") ? "n" + e : "en " + e;
                },
                past: "hai %s",
                s: "uns segundos",
                ss: "%d segundos",
                m: "un minuto",
                mm: "%d minutos",
                h: "unha hora",
                hh: "%d horas",
                d: "un d\xeda",
                dd: "%d d\xedas",
                M: "un mes",
                MM: "%d meses",
                y: "un ano",
                yy: "%d anos",
            },
            dayOfMonthOrdinalParse: /\d{1,2}\xba/,
            ordinal: "%d\xba",
            week: { dow: 1, doy: 4 },
        }),
        M.defineLocale("gom-deva", {
            months: {
                standalone:
                    "\u091c\u093e\u0928\u0947\u0935\u093e\u0930\u0940_\u092b\u0947\u092c\u094d\u0930\u0941\u0935\u093e\u0930\u0940_\u092e\u093e\u0930\u094d\u091a_\u090f\u092a\u094d\u0930\u0940\u0932_\u092e\u0947_\u091c\u0942\u0928_\u091c\u0941\u0932\u092f_\u0911\u0917\u0938\u094d\u091f_\u0938\u092a\u094d\u091f\u0947\u0902\u092c\u0930_\u0911\u0915\u094d\u091f\u094b\u092c\u0930_\u0928\u094b\u0935\u094d\u0939\u0947\u0902\u092c\u0930_\u0921\u093f\u0938\u0947\u0902\u092c\u0930".split(
                        "_"
                    ),
                format: "\u091c\u093e\u0928\u0947\u0935\u093e\u0930\u0940\u091a\u094d\u092f\u093e_\u092b\u0947\u092c\u094d\u0930\u0941\u0935\u093e\u0930\u0940\u091a\u094d\u092f\u093e_\u092e\u093e\u0930\u094d\u091a\u093e\u091a\u094d\u092f\u093e_\u090f\u092a\u094d\u0930\u0940\u0932\u093e\u091a\u094d\u092f\u093e_\u092e\u0947\u092f\u093e\u091a\u094d\u092f\u093e_\u091c\u0942\u0928\u093e\u091a\u094d\u092f\u093e_\u091c\u0941\u0932\u092f\u093e\u091a\u094d\u092f\u093e_\u0911\u0917\u0938\u094d\u091f\u093e\u091a\u094d\u092f\u093e_\u0938\u092a\u094d\u091f\u0947\u0902\u092c\u0930\u093e\u091a\u094d\u092f\u093e_\u0911\u0915\u094d\u091f\u094b\u092c\u0930\u093e\u091a\u094d\u092f\u093e_\u0928\u094b\u0935\u094d\u0939\u0947\u0902\u092c\u0930\u093e\u091a\u094d\u092f\u093e_\u0921\u093f\u0938\u0947\u0902\u092c\u0930\u093e\u091a\u094d\u092f\u093e".split(
                    "_"
                ),
                isFormat: /MMMM(\s)+D[oD]?/,
            },
            monthsShort:
                "\u091c\u093e\u0928\u0947._\u092b\u0947\u092c\u094d\u0930\u0941._\u092e\u093e\u0930\u094d\u091a_\u090f\u092a\u094d\u0930\u0940._\u092e\u0947_\u091c\u0942\u0928_\u091c\u0941\u0932._\u0911\u0917._\u0938\u092a\u094d\u091f\u0947\u0902._\u0911\u0915\u094d\u091f\u094b._\u0928\u094b\u0935\u094d\u0939\u0947\u0902._\u0921\u093f\u0938\u0947\u0902.".split(
                    "_"
                ),
            monthsParseExact: !0,
            weekdays:
                "\u0906\u092f\u0924\u093e\u0930_\u0938\u094b\u092e\u093e\u0930_\u092e\u0902\u0917\u0933\u093e\u0930_\u092c\u0941\u0927\u0935\u093e\u0930_\u092c\u093f\u0930\u0947\u0938\u094d\u0924\u093e\u0930_\u0938\u0941\u0915\u094d\u0930\u093e\u0930_\u0936\u0947\u0928\u0935\u093e\u0930".split(
                    "_"
                ),
            weekdaysShort:
                "\u0906\u092f\u0924._\u0938\u094b\u092e._\u092e\u0902\u0917\u0933._\u092c\u0941\u0927._\u092c\u094d\u0930\u0947\u0938\u094d\u0924._\u0938\u0941\u0915\u094d\u0930._\u0936\u0947\u0928.".split(
                    "_"
                ),
            weekdaysMin:
                "\u0906_\u0938\u094b_\u092e\u0902_\u092c\u0941_\u092c\u094d\u0930\u0947_\u0938\u0941_\u0936\u0947".split(
                    "_"
                ),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "A h:mm [\u0935\u093e\u091c\u0924\u093e\u0902]",
                LTS: "A h:mm:ss [\u0935\u093e\u091c\u0924\u093e\u0902]",
                L: "DD-MM-YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY A h:mm [\u0935\u093e\u091c\u0924\u093e\u0902]",
                LLLL: "dddd, MMMM Do, YYYY, A h:mm [\u0935\u093e\u091c\u0924\u093e\u0902]",
                llll: "ddd, D MMM YYYY, A h:mm [\u0935\u093e\u091c\u0924\u093e\u0902]",
            },
            calendar: {
                sameDay: "[\u0906\u092f\u091c] LT",
                nextDay: "[\u092b\u093e\u0932\u094d\u092f\u093e\u0902] LT",
                nextWeek: "[\u092b\u0941\u0921\u0932\u094b] dddd[,] LT",
                lastDay: "[\u0915\u093e\u0932] LT",
                lastWeek: "[\u092b\u093e\u091f\u0932\u094b] dddd[,] LT",
                sameElse: "L",
            },
            relativeTime: {
                future: "%s",
                past: "%s \u0906\u0926\u0940\u0902",
                s: Ts,
                ss: Ts,
                m: Ts,
                mm: Ts,
                h: Ts,
                hh: Ts,
                d: Ts,
                dd: Ts,
                M: Ts,
                MM: Ts,
                y: Ts,
                yy: Ts,
            },
            dayOfMonthOrdinalParse: /\d{1,2}(\u0935\u0947\u0930)/,
            ordinal: function (e, a) {
                switch (a) {
                    case "D":
                        return e + "\u0935\u0947\u0930";
                    default:
                    case "M":
                    case "Q":
                    case "DDD":
                    case "d":
                    case "w":
                    case "W":
                        return e;
                }
            },
            week: { dow: 0, doy: 3 },
            meridiemParse:
                /\u0930\u093e\u0924\u0940|\u0938\u0915\u093e\u0933\u0940\u0902|\u0926\u0928\u092a\u093e\u0930\u093e\u0902|\u0938\u093e\u0902\u091c\u0947/,
            meridiemHour: function (e, a) {
                return (
                    12 === e && (e = 0),
                    "\u0930\u093e\u0924\u0940" === a
                        ? e < 4
                            ? e
                            : e + 12
                        : "\u0938\u0915\u093e\u0933\u0940\u0902" === a
                        ? e
                        : "\u0926\u0928\u092a\u093e\u0930\u093e\u0902" === a
                        ? 12 < e
                            ? e
                            : e + 12
                        : "\u0938\u093e\u0902\u091c\u0947" === a
                        ? e + 12
                        : void 0
                );
            },
            meridiem: function (e, a, t) {
                return e < 4
                    ? "\u0930\u093e\u0924\u0940"
                    : e < 12
                    ? "\u0938\u0915\u093e\u0933\u0940\u0902"
                    : e < 16
                    ? "\u0926\u0928\u092a\u093e\u0930\u093e\u0902"
                    : e < 20
                    ? "\u0938\u093e\u0902\u091c\u0947"
                    : "\u0930\u093e\u0924\u0940";
            },
        }),
        M.defineLocale("gom-latn", {
            months: {
                standalone:
                    "Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr".split(
                        "_"
                    ),
                format: "Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea".split(
                    "_"
                ),
                isFormat: /MMMM(\s)+D[oD]?/,
            },
            monthsShort:
                "Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.".split(
                    "_"
                ),
            monthsParseExact: !0,
            weekdays:
                "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split(
                    "_"
                ),
            weekdaysShort: "Ait._Som._Mon._Bud._Bre._Suk._Son.".split("_"),
            weekdaysMin: "Ai_Sm_Mo_Bu_Br_Su_Sn".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "A h:mm [vazta]",
                LTS: "A h:mm:ss [vazta]",
                L: "DD-MM-YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY A h:mm [vazta]",
                LLLL: "dddd, MMMM Do, YYYY, A h:mm [vazta]",
                llll: "ddd, D MMM YYYY, A h:mm [vazta]",
            },
            calendar: {
                sameDay: "[Aiz] LT",
                nextDay: "[Faleam] LT",
                nextWeek: "[Fuddlo] dddd[,] LT",
                lastDay: "[Kal] LT",
                lastWeek: "[Fattlo] dddd[,] LT",
                sameElse: "L",
            },
            relativeTime: {
                future: "%s",
                past: "%s adim",
                s: gs,
                ss: gs,
                m: gs,
                mm: gs,
                h: gs,
                hh: gs,
                d: gs,
                dd: gs,
                M: gs,
                MM: gs,
                y: gs,
                yy: gs,
            },
            dayOfMonthOrdinalParse: /\d{1,2}(er)/,
            ordinal: function (e, a) {
                switch (a) {
                    case "D":
                        return e + "er";
                    default:
                    case "M":
                    case "Q":
                    case "DDD":
                    case "d":
                    case "w":
                    case "W":
                        return e;
                }
            },
            week: { dow: 0, doy: 3 },
            meridiemParse: /rati|sokallim|donparam|sanje/,
            meridiemHour: function (e, a) {
                return (
                    12 === e && (e = 0),
                    "rati" === a
                        ? e < 4
                            ? e
                            : e + 12
                        : "sokallim" === a
                        ? e
                        : "donparam" === a
                        ? 12 < e
                            ? e
                            : e + 12
                        : "sanje" === a
                        ? e + 12
                        : void 0
                );
            },
            meridiem: function (e, a, t) {
                return e < 4
                    ? "rati"
                    : e < 12
                    ? "sokallim"
                    : e < 16
                    ? "donparam"
                    : e < 20
                    ? "sanje"
                    : "rati";
            },
        });
    var ws = {
            1: "\u0ae7",
            2: "\u0ae8",
            3: "\u0ae9",
            4: "\u0aea",
            5: "\u0aeb",
            6: "\u0aec",
            7: "\u0aed",
            8: "\u0aee",
            9: "\u0aef",
            0: "\u0ae6",
        },
        bs = {
            "\u0ae7": "1",
            "\u0ae8": "2",
            "\u0ae9": "3",
            "\u0aea": "4",
            "\u0aeb": "5",
            "\u0aec": "6",
            "\u0aed": "7",
            "\u0aee": "8",
            "\u0aef": "9",
            "\u0ae6": "0",
        },
        Ss =
            (M.defineLocale("gu", {
                months: "\u0a9c\u0abe\u0aa8\u0acd\u0aaf\u0ac1\u0a86\u0ab0\u0ac0_\u0aab\u0ac7\u0aac\u0acd\u0ab0\u0ac1\u0a86\u0ab0\u0ac0_\u0aae\u0abe\u0ab0\u0acd\u0a9a_\u0a8f\u0aaa\u0acd\u0ab0\u0abf\u0ab2_\u0aae\u0ac7_\u0a9c\u0ac2\u0aa8_\u0a9c\u0ac1\u0ab2\u0abe\u0a88_\u0a91\u0a97\u0ab8\u0acd\u0a9f_\u0ab8\u0aaa\u0acd\u0a9f\u0ac7\u0aae\u0acd\u0aac\u0ab0_\u0a91\u0a95\u0acd\u0a9f\u0acd\u0aac\u0ab0_\u0aa8\u0ab5\u0ac7\u0aae\u0acd\u0aac\u0ab0_\u0aa1\u0abf\u0ab8\u0ac7\u0aae\u0acd\u0aac\u0ab0".split(
                    "_"
                ),
                monthsShort:
                    "\u0a9c\u0abe\u0aa8\u0acd\u0aaf\u0ac1._\u0aab\u0ac7\u0aac\u0acd\u0ab0\u0ac1._\u0aae\u0abe\u0ab0\u0acd\u0a9a_\u0a8f\u0aaa\u0acd\u0ab0\u0abf._\u0aae\u0ac7_\u0a9c\u0ac2\u0aa8_\u0a9c\u0ac1\u0ab2\u0abe._\u0a91\u0a97._\u0ab8\u0aaa\u0acd\u0a9f\u0ac7._\u0a91\u0a95\u0acd\u0a9f\u0acd._\u0aa8\u0ab5\u0ac7._\u0aa1\u0abf\u0ab8\u0ac7.".split(
                        "_"
                    ),
                monthsParseExact: !0,
                weekdays:
                    "\u0ab0\u0ab5\u0abf\u0ab5\u0abe\u0ab0_\u0ab8\u0acb\u0aae\u0ab5\u0abe\u0ab0_\u0aae\u0a82\u0a97\u0ab3\u0ab5\u0abe\u0ab0_\u0aac\u0ac1\u0aa7\u0acd\u0ab5\u0abe\u0ab0_\u0a97\u0ac1\u0ab0\u0ac1\u0ab5\u0abe\u0ab0_\u0ab6\u0ac1\u0a95\u0acd\u0ab0\u0ab5\u0abe\u0ab0_\u0ab6\u0aa8\u0abf\u0ab5\u0abe\u0ab0".split(
                        "_"
                    ),
                weekdaysShort:
                    "\u0ab0\u0ab5\u0abf_\u0ab8\u0acb\u0aae_\u0aae\u0a82\u0a97\u0ab3_\u0aac\u0ac1\u0aa7\u0acd_\u0a97\u0ac1\u0ab0\u0ac1_\u0ab6\u0ac1\u0a95\u0acd\u0ab0_\u0ab6\u0aa8\u0abf".split(
                        "_"
                    ),
                weekdaysMin:
                    "\u0ab0_\u0ab8\u0acb_\u0aae\u0a82_\u0aac\u0ac1_\u0a97\u0ac1_\u0ab6\u0ac1_\u0ab6".split(
                        "_"
                    ),
                longDateFormat: {
                    LT: "A h:mm \u0ab5\u0abe\u0a97\u0acd\u0aaf\u0ac7",
                    LTS: "A h:mm:ss \u0ab5\u0abe\u0a97\u0acd\u0aaf\u0ac7",
                    L: "DD/MM/YYYY",
                    LL: "D MMMM YYYY",
                    LLL: "D MMMM YYYY, A h:mm \u0ab5\u0abe\u0a97\u0acd\u0aaf\u0ac7",
                    LLLL: "dddd, D MMMM YYYY, A h:mm \u0ab5\u0abe\u0a97\u0acd\u0aaf\u0ac7",
                },
                calendar: {
                    sameDay: "[\u0a86\u0a9c] LT",
                    nextDay: "[\u0a95\u0abe\u0ab2\u0ac7] LT",
                    nextWeek: "dddd, LT",
                    lastDay: "[\u0a97\u0a87\u0a95\u0abe\u0ab2\u0ac7] LT",
                    lastWeek: "[\u0aaa\u0abe\u0a9b\u0ab2\u0abe] dddd, LT",
                    sameElse: "L",
                },
                relativeTime: {
                    future: "%s \u0aae\u0abe",
                    past: "%s \u0aaa\u0ab9\u0ac7\u0ab2\u0abe",
                    s: "\u0a85\u0aae\u0ac1\u0a95 \u0aaa\u0ab3\u0acb",
                    ss: "%d \u0ab8\u0ac7\u0a95\u0a82\u0aa1",
                    m: "\u0a8f\u0a95 \u0aae\u0abf\u0aa8\u0abf\u0a9f",
                    mm: "%d \u0aae\u0abf\u0aa8\u0abf\u0a9f",
                    h: "\u0a8f\u0a95 \u0a95\u0ab2\u0abe\u0a95",
                    hh: "%d \u0a95\u0ab2\u0abe\u0a95",
                    d: "\u0a8f\u0a95 \u0aa6\u0abf\u0ab5\u0ab8",
                    dd: "%d \u0aa6\u0abf\u0ab5\u0ab8",
                    M: "\u0a8f\u0a95 \u0aae\u0ab9\u0abf\u0aa8\u0acb",
                    MM: "%d \u0aae\u0ab9\u0abf\u0aa8\u0acb",
                    y: "\u0a8f\u0a95 \u0ab5\u0ab0\u0acd\u0ab7",
                    yy: "%d \u0ab5\u0ab0\u0acd\u0ab7",
                },
                preparse: function (e) {
                    return e.replace(
                        /[\u0ae7\u0ae8\u0ae9\u0aea\u0aeb\u0aec\u0aed\u0aee\u0aef\u0ae6]/g,
                        function (e) {
                            return bs[e];
                        }
                    );
                },
                postformat: function (e) {
                    return e.replace(/\d/g, function (e) {
                        return ws[e];
                    });
                },
                meridiemParse:
                    /\u0ab0\u0abe\u0aa4|\u0aac\u0aaa\u0acb\u0ab0|\u0ab8\u0ab5\u0abe\u0ab0|\u0ab8\u0abe\u0a82\u0a9c/,
                meridiemHour: function (e, a) {
                    return (
                        12 === e && (e = 0),
                        "\u0ab0\u0abe\u0aa4" === a
                            ? e < 4
                                ? e
                                : e + 12
                            : "\u0ab8\u0ab5\u0abe\u0ab0" === a
                            ? e
                            : "\u0aac\u0aaa\u0acb\u0ab0" === a
                            ? 10 <= e
                                ? e
                                : e + 12
                            : "\u0ab8\u0abe\u0a82\u0a9c" === a
                            ? e + 12
                            : void 0
                    );
                },
                meridiem: function (e, a, t) {
                    return e < 4
                        ? "\u0ab0\u0abe\u0aa4"
                        : e < 10
                        ? "\u0ab8\u0ab5\u0abe\u0ab0"
                        : e < 17
                        ? "\u0aac\u0aaa\u0acb\u0ab0"
                        : e < 20
                        ? "\u0ab8\u0abe\u0a82\u0a9c"
                        : "\u0ab0\u0abe\u0aa4";
                },
                week: { dow: 0, doy: 6 },
            }),
            M.defineLocale("he", {
                months: "\u05d9\u05e0\u05d5\u05d0\u05e8_\u05e4\u05d1\u05e8\u05d5\u05d0\u05e8_\u05de\u05e8\u05e5_\u05d0\u05e4\u05e8\u05d9\u05dc_\u05de\u05d0\u05d9_\u05d9\u05d5\u05e0\u05d9_\u05d9\u05d5\u05dc\u05d9_\u05d0\u05d5\u05d2\u05d5\u05e1\u05d8_\u05e1\u05e4\u05d8\u05de\u05d1\u05e8_\u05d0\u05d5\u05e7\u05d8\u05d5\u05d1\u05e8_\u05e0\u05d5\u05d1\u05de\u05d1\u05e8_\u05d3\u05e6\u05de\u05d1\u05e8".split(
                    "_"
                ),
                monthsShort:
                    "\u05d9\u05e0\u05d5\u05f3_\u05e4\u05d1\u05e8\u05f3_\u05de\u05e8\u05e5_\u05d0\u05e4\u05e8\u05f3_\u05de\u05d0\u05d9_\u05d9\u05d5\u05e0\u05d9_\u05d9\u05d5\u05dc\u05d9_\u05d0\u05d5\u05d2\u05f3_\u05e1\u05e4\u05d8\u05f3_\u05d0\u05d5\u05e7\u05f3_\u05e0\u05d5\u05d1\u05f3_\u05d3\u05e6\u05de\u05f3".split(
                        "_"
                    ),
                weekdays:
                    "\u05e8\u05d0\u05e9\u05d5\u05df_\u05e9\u05e0\u05d9_\u05e9\u05dc\u05d9\u05e9\u05d9_\u05e8\u05d1\u05d9\u05e2\u05d9_\u05d7\u05de\u05d9\u05e9\u05d9_\u05e9\u05d9\u05e9\u05d9_\u05e9\u05d1\u05ea".split(
                        "_"
                    ),
                weekdaysShort:
                    "\u05d0\u05f3_\u05d1\u05f3_\u05d2\u05f3_\u05d3\u05f3_\u05d4\u05f3_\u05d5\u05f3_\u05e9\u05f3".split(
                        "_"
                    ),
                weekdaysMin:
                    "\u05d0_\u05d1_\u05d2_\u05d3_\u05d4_\u05d5_\u05e9".split(
                        "_"
                    ),
                longDateFormat: {
                    LT: "HH:mm",
                    LTS: "HH:mm:ss",
                    L: "DD/MM/YYYY",
                    LL: "D [\u05d1]MMMM YYYY",
                    LLL: "D [\u05d1]MMMM YYYY HH:mm",
                    LLLL: "dddd, D [\u05d1]MMMM YYYY HH:mm",
                    l: "D/M/YYYY",
                    ll: "D MMM YYYY",
                    lll: "D MMM YYYY HH:mm",
                    llll: "ddd, D MMM YYYY HH:mm",
                },
                calendar: {
                    sameDay: "[\u05d4\u05d9\u05d5\u05dd \u05d1\u05be]LT",
                    nextDay: "[\u05de\u05d7\u05e8 \u05d1\u05be]LT",
                    nextWeek: "dddd [\u05d1\u05e9\u05e2\u05d4] LT",
                    lastDay: "[\u05d0\u05ea\u05de\u05d5\u05dc \u05d1\u05be]LT",
                    lastWeek:
                        "[\u05d1\u05d9\u05d5\u05dd] dddd [\u05d4\u05d0\u05d7\u05e8\u05d5\u05df \u05d1\u05e9\u05e2\u05d4] LT",
                    sameElse: "L",
                },
                relativeTime: {
                    future: "\u05d1\u05e2\u05d5\u05d3 %s",
                    past: "\u05dc\u05e4\u05e0\u05d9 %s",
                    s: "\u05de\u05e1\u05e4\u05e8 \u05e9\u05e0\u05d9\u05d5\u05ea",
                    ss: "%d \u05e9\u05e0\u05d9\u05d5\u05ea",
                    m: "\u05d3\u05e7\u05d4",
                    mm: "%d \u05d3\u05e7\u05d5\u05ea",
                    h: "\u05e9\u05e2\u05d4",
                    hh: function (e) {
                        return 2 === e
                            ? "\u05e9\u05e2\u05ea\u05d9\u05d9\u05dd"
                            : e + " \u05e9\u05e2\u05d5\u05ea";
                    },
                    d: "\u05d9\u05d5\u05dd",
                    dd: function (e) {
                        return 2 === e
                            ? "\u05d9\u05d5\u05de\u05d9\u05d9\u05dd"
                            : e + " \u05d9\u05de\u05d9\u05dd";
                    },
                    M: "\u05d7\u05d5\u05d3\u05e9",
                    MM: function (e) {
                        return 2 === e
                            ? "\u05d7\u05d5\u05d3\u05e9\u05d9\u05d9\u05dd"
                            : e + " \u05d7\u05d5\u05d3\u05e9\u05d9\u05dd";
                    },
                    y: "\u05e9\u05e0\u05d4",
                    yy: function (e) {
                        return 2 === e
                            ? "\u05e9\u05e0\u05ea\u05d9\u05d9\u05dd"
                            : e % 10 == 0 && 10 !== e
                            ? e + " \u05e9\u05e0\u05d4"
                            : e + " \u05e9\u05e0\u05d9\u05dd";
                    },
                },
                meridiemParse:
                    /\u05d0\u05d7\u05d4"\u05e6|\u05dc\u05e4\u05e0\u05d4"\u05e6|\u05d0\u05d7\u05e8\u05d9 \u05d4\u05e6\u05d4\u05e8\u05d9\u05d9\u05dd|\u05dc\u05e4\u05e0\u05d9 \u05d4\u05e6\u05d4\u05e8\u05d9\u05d9\u05dd|\u05dc\u05e4\u05e0\u05d5\u05ea \u05d1\u05d5\u05e7\u05e8|\u05d1\u05d1\u05d5\u05e7\u05e8|\u05d1\u05e2\u05e8\u05d1/i,
                isPM: function (e) {
                    return /^(\u05d0\u05d7\u05d4"\u05e6|\u05d0\u05d7\u05e8\u05d9 \u05d4\u05e6\u05d4\u05e8\u05d9\u05d9\u05dd|\u05d1\u05e2\u05e8\u05d1)$/.test(
                        e
                    );
                },
                meridiem: function (e, a, t) {
                    return e < 5
                        ? "\u05dc\u05e4\u05e0\u05d5\u05ea \u05d1\u05d5\u05e7\u05e8"
                        : e < 10
                        ? "\u05d1\u05d1\u05d5\u05e7\u05e8"
                        : e < 12
                        ? t
                            ? '\u05dc\u05e4\u05e0\u05d4"\u05e6'
                            : "\u05dc\u05e4\u05e0\u05d9 \u05d4\u05e6\u05d4\u05e8\u05d9\u05d9\u05dd"
                        : e < 18
                        ? t
                            ? '\u05d0\u05d7\u05d4"\u05e6'
                            : "\u05d0\u05d7\u05e8\u05d9 \u05d4\u05e6\u05d4\u05e8\u05d9\u05d9\u05dd"
                        : "\u05d1\u05e2\u05e8\u05d1";
                },
            }),
            {
                1: "\u0967",
                2: "\u0968",
                3: "\u0969",
                4: "\u096a",
                5: "\u096b",
                6: "\u096c",
                7: "\u096d",
                8: "\u096e",
                9: "\u096f",
                0: "\u0966",
            }),
        Hs = {
            "\u0967": "1",
            "\u0968": "2",
            "\u0969": "3",
            "\u096a": "4",
            "\u096b": "5",
            "\u096c": "6",
            "\u096d": "7",
            "\u096e": "8",
            "\u096f": "9",
            "\u0966": "0",
        },
        Ne = [
            /^\u091c\u0928/i,
            /^\u092b\u093c\u0930|\u092b\u0930/i,
            /^\u092e\u093e\u0930\u094d\u091a/i,
            /^\u0905\u092a\u094d\u0930\u0948/i,
            /^\u092e\u0908/i,
            /^\u091c\u0942\u0928/i,
            /^\u091c\u0941\u0932/i,
            /^\u0905\u0917/i,
            /^\u0938\u093f\u0924\u0902|\u0938\u093f\u0924/i,
            /^\u0905\u0915\u094d\u091f\u0942/i,
            /^\u0928\u0935|\u0928\u0935\u0902/i,
            /^\u0926\u093f\u0938\u0902|\u0926\u093f\u0938/i,
        ];
    function vs(e, a, t) {
        var s = e + " ";
        switch (t) {
            case "ss":
                return (s +=
                    1 === e
                        ? "sekunda"
                        : 2 === e || 3 === e || 4 === e
                        ? "sekunde"
                        : "sekundi");
            case "m":
                return a ? "jedna minuta" : "jedne minute";
            case "mm":
                return (s +=
                    1 !== e && (2 === e || 3 === e || 4 === e)
                        ? "minute"
                        : "minuta");
            case "h":
                return a ? "jedan sat" : "jednog sata";
            case "hh":
                return (s +=
                    1 === e
                        ? "sat"
                        : 2 === e || 3 === e || 4 === e
                        ? "sata"
                        : "sati");
            case "dd":
                return (s += 1 === e ? "dan" : "dana");
            case "MM":
                return (s +=
                    1 === e
                        ? "mjesec"
                        : 2 === e || 3 === e || 4 === e
                        ? "mjeseca"
                        : "mjeseci");
            case "yy":
                return (s +=
                    1 !== e && (2 === e || 3 === e || 4 === e)
                        ? "godine"
                        : "godina");
        }
    }
    M.defineLocale("hi", {
        months: {
            format: "\u091c\u0928\u0935\u0930\u0940_\u092b\u093c\u0930\u0935\u0930\u0940_\u092e\u093e\u0930\u094d\u091a_\u0905\u092a\u094d\u0930\u0948\u0932_\u092e\u0908_\u091c\u0942\u0928_\u091c\u0941\u0932\u093e\u0908_\u0905\u0917\u0938\u094d\u0924_\u0938\u093f\u0924\u092e\u094d\u092c\u0930_\u0905\u0915\u094d\u091f\u0942\u092c\u0930_\u0928\u0935\u092e\u094d\u092c\u0930_\u0926\u093f\u0938\u092e\u094d\u092c\u0930".split(
                "_"
            ),
            standalone:
                "\u091c\u0928\u0935\u0930\u0940_\u092b\u0930\u0935\u0930\u0940_\u092e\u093e\u0930\u094d\u091a_\u0905\u092a\u094d\u0930\u0948\u0932_\u092e\u0908_\u091c\u0942\u0928_\u091c\u0941\u0932\u093e\u0908_\u0905\u0917\u0938\u094d\u0924_\u0938\u093f\u0924\u0902\u092c\u0930_\u0905\u0915\u094d\u091f\u0942\u092c\u0930_\u0928\u0935\u0902\u092c\u0930_\u0926\u093f\u0938\u0902\u092c\u0930".split(
                    "_"
                ),
        },
        monthsShort:
            "\u091c\u0928._\u092b\u093c\u0930._\u092e\u093e\u0930\u094d\u091a_\u0905\u092a\u094d\u0930\u0948._\u092e\u0908_\u091c\u0942\u0928_\u091c\u0941\u0932._\u0905\u0917._\u0938\u093f\u0924._\u0905\u0915\u094d\u091f\u0942._\u0928\u0935._\u0926\u093f\u0938.".split(
                "_"
            ),
        weekdays:
            "\u0930\u0935\u093f\u0935\u093e\u0930_\u0938\u094b\u092e\u0935\u093e\u0930_\u092e\u0902\u0917\u0932\u0935\u093e\u0930_\u092c\u0941\u0927\u0935\u093e\u0930_\u0917\u0941\u0930\u0942\u0935\u093e\u0930_\u0936\u0941\u0915\u094d\u0930\u0935\u093e\u0930_\u0936\u0928\u093f\u0935\u093e\u0930".split(
                "_"
            ),
        weekdaysShort:
            "\u0930\u0935\u093f_\u0938\u094b\u092e_\u092e\u0902\u0917\u0932_\u092c\u0941\u0927_\u0917\u0941\u0930\u0942_\u0936\u0941\u0915\u094d\u0930_\u0936\u0928\u093f".split(
                "_"
            ),
        weekdaysMin:
            "\u0930_\u0938\u094b_\u092e\u0902_\u092c\u0941_\u0917\u0941_\u0936\u0941_\u0936".split(
                "_"
            ),
        longDateFormat: {
            LT: "A h:mm \u092c\u091c\u0947",
            LTS: "A h:mm:ss \u092c\u091c\u0947",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY, A h:mm \u092c\u091c\u0947",
            LLLL: "dddd, D MMMM YYYY, A h:mm \u092c\u091c\u0947",
        },
        monthsParse: Ne,
        longMonthsParse: Ne,
        shortMonthsParse: [
            /^\u091c\u0928/i,
            /^\u092b\u093c\u0930/i,
            /^\u092e\u093e\u0930\u094d\u091a/i,
            /^\u0905\u092a\u094d\u0930\u0948/i,
            /^\u092e\u0908/i,
            /^\u091c\u0942\u0928/i,
            /^\u091c\u0941\u0932/i,
            /^\u0905\u0917/i,
            /^\u0938\u093f\u0924/i,
            /^\u0905\u0915\u094d\u091f\u0942/i,
            /^\u0928\u0935/i,
            /^\u0926\u093f\u0938/i,
        ],
        monthsRegex:
            /^(\u091c\u0928\u0935\u0930\u0940|\u091c\u0928\.?|\u092b\u093c\u0930\u0935\u0930\u0940|\u092b\u0930\u0935\u0930\u0940|\u092b\u093c\u0930\.?|\u092e\u093e\u0930\u094d\u091a?|\u0905\u092a\u094d\u0930\u0948\u0932|\u0905\u092a\u094d\u0930\u0948\.?|\u092e\u0908?|\u091c\u0942\u0928?|\u091c\u0941\u0932\u093e\u0908|\u091c\u0941\u0932\.?|\u0905\u0917\u0938\u094d\u0924|\u0905\u0917\.?|\u0938\u093f\u0924\u092e\u094d\u092c\u0930|\u0938\u093f\u0924\u0902\u092c\u0930|\u0938\u093f\u0924\.?|\u0905\u0915\u094d\u091f\u0942\u092c\u0930|\u0905\u0915\u094d\u091f\u0942\.?|\u0928\u0935\u092e\u094d\u092c\u0930|\u0928\u0935\u0902\u092c\u0930|\u0928\u0935\.?|\u0926\u093f\u0938\u092e\u094d\u092c\u0930|\u0926\u093f\u0938\u0902\u092c\u0930|\u0926\u093f\u0938\.?)/i,
        monthsShortRegex:
            /^(\u091c\u0928\u0935\u0930\u0940|\u091c\u0928\.?|\u092b\u093c\u0930\u0935\u0930\u0940|\u092b\u0930\u0935\u0930\u0940|\u092b\u093c\u0930\.?|\u092e\u093e\u0930\u094d\u091a?|\u0905\u092a\u094d\u0930\u0948\u0932|\u0905\u092a\u094d\u0930\u0948\.?|\u092e\u0908?|\u091c\u0942\u0928?|\u091c\u0941\u0932\u093e\u0908|\u091c\u0941\u0932\.?|\u0905\u0917\u0938\u094d\u0924|\u0905\u0917\.?|\u0938\u093f\u0924\u092e\u094d\u092c\u0930|\u0938\u093f\u0924\u0902\u092c\u0930|\u0938\u093f\u0924\.?|\u0905\u0915\u094d\u091f\u0942\u092c\u0930|\u0905\u0915\u094d\u091f\u0942\.?|\u0928\u0935\u092e\u094d\u092c\u0930|\u0928\u0935\u0902\u092c\u0930|\u0928\u0935\.?|\u0926\u093f\u0938\u092e\u094d\u092c\u0930|\u0926\u093f\u0938\u0902\u092c\u0930|\u0926\u093f\u0938\.?)/i,
        monthsStrictRegex:
            /^(\u091c\u0928\u0935\u0930\u0940?|\u092b\u093c\u0930\u0935\u0930\u0940|\u092b\u0930\u0935\u0930\u0940?|\u092e\u093e\u0930\u094d\u091a?|\u0905\u092a\u094d\u0930\u0948\u0932?|\u092e\u0908?|\u091c\u0942\u0928?|\u091c\u0941\u0932\u093e\u0908?|\u0905\u0917\u0938\u094d\u0924?|\u0938\u093f\u0924\u092e\u094d\u092c\u0930|\u0938\u093f\u0924\u0902\u092c\u0930|\u0938\u093f\u0924?\.?|\u0905\u0915\u094d\u091f\u0942\u092c\u0930|\u0905\u0915\u094d\u091f\u0942\.?|\u0928\u0935\u092e\u094d\u092c\u0930|\u0928\u0935\u0902\u092c\u0930?|\u0926\u093f\u0938\u092e\u094d\u092c\u0930|\u0926\u093f\u0938\u0902\u092c\u0930?)/i,
        monthsShortStrictRegex:
            /^(\u091c\u0928\.?|\u092b\u093c\u0930\.?|\u092e\u093e\u0930\u094d\u091a?|\u0905\u092a\u094d\u0930\u0948\.?|\u092e\u0908?|\u091c\u0942\u0928?|\u091c\u0941\u0932\.?|\u0905\u0917\.?|\u0938\u093f\u0924\.?|\u0905\u0915\u094d\u091f\u0942\.?|\u0928\u0935\.?|\u0926\u093f\u0938\.?)/i,
        calendar: {
            sameDay: "[\u0906\u091c] LT",
            nextDay: "[\u0915\u0932] LT",
            nextWeek: "dddd, LT",
            lastDay: "[\u0915\u0932] LT",
            lastWeek: "[\u092a\u093f\u091b\u0932\u0947] dddd, LT",
            sameElse: "L",
        },
        relativeTime: {
            future: "%s \u092e\u0947\u0902",
            past: "%s \u092a\u0939\u0932\u0947",
            s: "\u0915\u0941\u091b \u0939\u0940 \u0915\u094d\u0937\u0923",
            ss: "%d \u0938\u0947\u0915\u0902\u0921",
            m: "\u090f\u0915 \u092e\u093f\u0928\u091f",
            mm: "%d \u092e\u093f\u0928\u091f",
            h: "\u090f\u0915 \u0918\u0902\u091f\u093e",
            hh: "%d \u0918\u0902\u091f\u0947",
            d: "\u090f\u0915 \u0926\u093f\u0928",
            dd: "%d \u0926\u093f\u0928",
            M: "\u090f\u0915 \u092e\u0939\u0940\u0928\u0947",
            MM: "%d \u092e\u0939\u0940\u0928\u0947",
            y: "\u090f\u0915 \u0935\u0930\u094d\u0937",
            yy: "%d \u0935\u0930\u094d\u0937",
        },
        preparse: function (e) {
            return e.replace(
                /[\u0967\u0968\u0969\u096a\u096b\u096c\u096d\u096e\u096f\u0966]/g,
                function (e) {
                    return Hs[e];
                }
            );
        },
        postformat: function (e) {
            return e.replace(/\d/g, function (e) {
                return Ss[e];
            });
        },
        meridiemParse:
            /\u0930\u093e\u0924|\u0938\u0941\u092c\u0939|\u0926\u094b\u092a\u0939\u0930|\u0936\u093e\u092e/,
        meridiemHour: function (e, a) {
            return (
                12 === e && (e = 0),
                "\u0930\u093e\u0924" === a
                    ? e < 4
                        ? e
                        : e + 12
                    : "\u0938\u0941\u092c\u0939" === a
                    ? e
                    : "\u0926\u094b\u092a\u0939\u0930" === a
                    ? 10 <= e
                        ? e
                        : e + 12
                    : "\u0936\u093e\u092e" === a
                    ? e + 12
                    : void 0
            );
        },
        meridiem: function (e, a, t) {
            return e < 4
                ? "\u0930\u093e\u0924"
                : e < 10
                ? "\u0938\u0941\u092c\u0939"
                : e < 17
                ? "\u0926\u094b\u092a\u0939\u0930"
                : e < 20
                ? "\u0936\u093e\u092e"
                : "\u0930\u093e\u0924";
        },
        week: { dow: 0, doy: 6 },
    }),
        M.defineLocale("hr", {
            months: {
                format: "sije\u010dnja_velja\u010de_o\u017eujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca".split(
                    "_"
                ),
                standalone:
                    "sije\u010danj_velja\u010da_o\u017eujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac".split(
                        "_"
                    ),
            },
            monthsShort:
                "sij._velj._o\u017eu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.".split(
                    "_"
                ),
            monthsParseExact: !0,
            weekdays:
                "nedjelja_ponedjeljak_utorak_srijeda_\u010detvrtak_petak_subota".split(
                    "_"
                ),
            weekdaysShort: "ned._pon._uto._sri._\u010det._pet._sub.".split("_"),
            weekdaysMin: "ne_po_ut_sr_\u010de_pe_su".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "H:mm",
                LTS: "H:mm:ss",
                L: "DD.MM.YYYY",
                LL: "Do MMMM YYYY",
                LLL: "Do MMMM YYYY H:mm",
                LLLL: "dddd, Do MMMM YYYY H:mm",
            },
            calendar: {
                sameDay: "[danas u] LT",
                nextDay: "[sutra u] LT",
                nextWeek: function () {
                    switch (this.day()) {
                        case 0:
                            return "[u] [nedjelju] [u] LT";
                        case 3:
                            return "[u] [srijedu] [u] LT";
                        case 6:
                            return "[u] [subotu] [u] LT";
                        case 1:
                        case 2:
                        case 4:
                        case 5:
                            return "[u] dddd [u] LT";
                    }
                },
                lastDay: "[ju\u010der u] LT",
                lastWeek: function () {
                    switch (this.day()) {
                        case 0:
                            return "[pro\u0161lu] [nedjelju] [u] LT";
                        case 3:
                            return "[pro\u0161lu] [srijedu] [u] LT";
                        case 6:
                            return "[pro\u0161le] [subote] [u] LT";
                        case 1:
                        case 2:
                        case 4:
                        case 5:
                            return "[pro\u0161li] dddd [u] LT";
                    }
                },
                sameElse: "L",
            },
            relativeTime: {
                future: "za %s",
                past: "prije %s",
                s: "par sekundi",
                ss: vs,
                m: vs,
                mm: vs,
                h: vs,
                hh: vs,
                d: "dan",
                dd: vs,
                M: "mjesec",
                MM: vs,
                y: "godinu",
                yy: vs,
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: { dow: 1, doy: 7 },
        });
    var js =
        "vas\xe1rnap h\xe9tf\u0151n kedden szerd\xe1n cs\xfct\xf6rt\xf6k\xf6n p\xe9nteken szombaton".split(
            " "
        );
    function xs(e, a, t, s) {
        var n = e;
        switch (t) {
            case "s":
                return s || a
                    ? "n\xe9h\xe1ny m\xe1sodperc"
                    : "n\xe9h\xe1ny m\xe1sodperce";
            case "ss":
                return n + (s || a) ? " m\xe1sodperc" : " m\xe1sodperce";
            case "m":
                return "egy" + (s || a ? " perc" : " perce");
            case "mm":
                return n + (s || a ? " perc" : " perce");
            case "h":
                return "egy" + (s || a ? " \xf3ra" : " \xf3r\xe1ja");
            case "hh":
                return n + (s || a ? " \xf3ra" : " \xf3r\xe1ja");
            case "d":
                return "egy" + (s || a ? " nap" : " napja");
            case "dd":
                return n + (s || a ? " nap" : " napja");
            case "M":
                return "egy" + (s || a ? " h\xf3nap" : " h\xf3napja");
            case "MM":
                return n + (s || a ? " h\xf3nap" : " h\xf3napja");
            case "y":
                return "egy" + (s || a ? " \xe9v" : " \xe9ve");
            case "yy":
                return n + (s || a ? " \xe9v" : " \xe9ve");
        }
        return "";
    }
    function Ps(e) {
        return (e ? "" : "[m\xfalt] ") + "[" + js[this.day()] + "] LT[-kor]";
    }
    function Os(e) {
        return e % 100 == 11 || e % 10 != 1;
    }
    function Ws(e, a, t, s) {
        var n = e + " ";
        switch (t) {
            case "s":
                return a || s ? "nokkrar sek\xfandur" : "nokkrum sek\xfandum";
            case "ss":
                return Os(e)
                    ? n + (a || s ? "sek\xfandur" : "sek\xfandum")
                    : n + "sek\xfanda";
            case "m":
                return a ? "m\xedn\xfata" : "m\xedn\xfatu";
            case "mm":
                return Os(e)
                    ? n + (a || s ? "m\xedn\xfatur" : "m\xedn\xfatum")
                    : a
                    ? n + "m\xedn\xfata"
                    : n + "m\xedn\xfatu";
            case "hh":
                return Os(e)
                    ? n + (a || s ? "klukkustundir" : "klukkustundum")
                    : n + "klukkustund";
            case "d":
                return a ? "dagur" : s ? "dag" : "degi";
            case "dd":
                return Os(e)
                    ? a
                        ? n + "dagar"
                        : n + (s ? "daga" : "d\xf6gum")
                    : a
                    ? n + "dagur"
                    : n + (s ? "dag" : "degi");
            case "M":
                return a ? "m\xe1nu\xf0ur" : s ? "m\xe1nu\xf0" : "m\xe1nu\xf0i";
            case "MM":
                return Os(e)
                    ? a
                        ? n + "m\xe1nu\xf0ir"
                        : n + (s ? "m\xe1nu\xf0i" : "m\xe1nu\xf0um")
                    : a
                    ? n + "m\xe1nu\xf0ur"
                    : n + (s ? "m\xe1nu\xf0" : "m\xe1nu\xf0i");
            case "y":
                return a || s ? "\xe1r" : "\xe1ri";
            case "yy":
                return Os(e)
                    ? n + (a || s ? "\xe1r" : "\xe1rum")
                    : n + (a || s ? "\xe1r" : "\xe1ri");
        }
    }
    M.defineLocale("hu", {
        months: "janu\xe1r_febru\xe1r_m\xe1rcius_\xe1prilis_m\xe1jus_j\xfanius_j\xfalius_augusztus_szeptember_okt\xf3ber_november_december".split(
            "_"
        ),
        monthsShort:
            "jan._feb._m\xe1rc._\xe1pr._m\xe1j._j\xfan._j\xfal._aug._szept._okt._nov._dec.".split(
                "_"
            ),
        monthsParseExact: !0,
        weekdays:
            "vas\xe1rnap_h\xe9tf\u0151_kedd_szerda_cs\xfct\xf6rt\xf6k_p\xe9ntek_szombat".split(
                "_"
            ),
        weekdaysShort: "vas_h\xe9t_kedd_sze_cs\xfct_p\xe9n_szo".split("_"),
        weekdaysMin: "v_h_k_sze_cs_p_szo".split("_"),
        longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "YYYY.MM.DD.",
            LL: "YYYY. MMMM D.",
            LLL: "YYYY. MMMM D. H:mm",
            LLLL: "YYYY. MMMM D., dddd H:mm",
        },
        meridiemParse: /de|du/i,
        isPM: function (e) {
            return "u" === e.charAt(1).toLowerCase();
        },
        meridiem: function (e, a, t) {
            return e < 12 ? (!0 === t ? "de" : "DE") : !0 === t ? "du" : "DU";
        },
        calendar: {
            sameDay: "[ma] LT[-kor]",
            nextDay: "[holnap] LT[-kor]",
            nextWeek: function () {
                return Ps.call(this, !0);
            },
            lastDay: "[tegnap] LT[-kor]",
            lastWeek: function () {
                return Ps.call(this, !1);
            },
            sameElse: "L",
        },
        relativeTime: {
            future: "%s m\xfalva",
            past: "%s",
            s: xs,
            ss: xs,
            m: xs,
            mm: xs,
            h: xs,
            hh: xs,
            d: xs,
            dd: xs,
            M: xs,
            MM: xs,
            y: xs,
            yy: xs,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: { dow: 1, doy: 4 },
    }),
        M.defineLocale("hy-am", {
            months: {
                format: "\u0570\u0578\u0582\u0576\u057e\u0561\u0580\u056b_\u0583\u0565\u057f\u0580\u057e\u0561\u0580\u056b_\u0574\u0561\u0580\u057f\u056b_\u0561\u057a\u0580\u056b\u056c\u056b_\u0574\u0561\u0575\u056b\u057d\u056b_\u0570\u0578\u0582\u0576\u056b\u057d\u056b_\u0570\u0578\u0582\u056c\u056b\u057d\u056b_\u0585\u0563\u0578\u057d\u057f\u0578\u057d\u056b_\u057d\u0565\u057a\u057f\u0565\u0574\u0562\u0565\u0580\u056b_\u0570\u0578\u056f\u057f\u0565\u0574\u0562\u0565\u0580\u056b_\u0576\u0578\u0575\u0565\u0574\u0562\u0565\u0580\u056b_\u0564\u0565\u056f\u057f\u0565\u0574\u0562\u0565\u0580\u056b".split(
                    "_"
                ),
                standalone:
                    "\u0570\u0578\u0582\u0576\u057e\u0561\u0580_\u0583\u0565\u057f\u0580\u057e\u0561\u0580_\u0574\u0561\u0580\u057f_\u0561\u057a\u0580\u056b\u056c_\u0574\u0561\u0575\u056b\u057d_\u0570\u0578\u0582\u0576\u056b\u057d_\u0570\u0578\u0582\u056c\u056b\u057d_\u0585\u0563\u0578\u057d\u057f\u0578\u057d_\u057d\u0565\u057a\u057f\u0565\u0574\u0562\u0565\u0580_\u0570\u0578\u056f\u057f\u0565\u0574\u0562\u0565\u0580_\u0576\u0578\u0575\u0565\u0574\u0562\u0565\u0580_\u0564\u0565\u056f\u057f\u0565\u0574\u0562\u0565\u0580".split(
                        "_"
                    ),
            },
            monthsShort:
                "\u0570\u0576\u057e_\u0583\u057f\u0580_\u0574\u0580\u057f_\u0561\u057a\u0580_\u0574\u0575\u057d_\u0570\u0576\u057d_\u0570\u056c\u057d_\u0585\u0563\u057d_\u057d\u057a\u057f_\u0570\u056f\u057f_\u0576\u0574\u0562_\u0564\u056f\u057f".split(
                    "_"
                ),
            weekdays:
                "\u056f\u056b\u0580\u0561\u056f\u056b_\u0565\u0580\u056f\u0578\u0582\u0577\u0561\u0562\u0569\u056b_\u0565\u0580\u0565\u0584\u0577\u0561\u0562\u0569\u056b_\u0579\u0578\u0580\u0565\u0584\u0577\u0561\u0562\u0569\u056b_\u0570\u056b\u0576\u0563\u0577\u0561\u0562\u0569\u056b_\u0578\u0582\u0580\u0562\u0561\u0569_\u0577\u0561\u0562\u0561\u0569".split(
                    "_"
                ),
            weekdaysShort:
                "\u056f\u0580\u056f_\u0565\u0580\u056f_\u0565\u0580\u0584_\u0579\u0580\u0584_\u0570\u0576\u0563_\u0578\u0582\u0580\u0562_\u0577\u0562\u0569".split(
                    "_"
                ),
            weekdaysMin:
                "\u056f\u0580\u056f_\u0565\u0580\u056f_\u0565\u0580\u0584_\u0579\u0580\u0584_\u0570\u0576\u0563_\u0578\u0582\u0580\u0562_\u0577\u0562\u0569".split(
                    "_"
                ),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD.MM.YYYY",
                LL: "D MMMM YYYY \u0569.",
                LLL: "D MMMM YYYY \u0569., HH:mm",
                LLLL: "dddd, D MMMM YYYY \u0569., HH:mm",
            },
            calendar: {
                sameDay: "[\u0561\u0575\u057d\u0585\u0580] LT",
                nextDay: "[\u057e\u0561\u0572\u0568] LT",
                lastDay: "[\u0565\u0580\u0565\u056f] LT",
                nextWeek: function () {
                    return "dddd [\u0585\u0580\u0568 \u056a\u0561\u0574\u0568] LT";
                },
                lastWeek: function () {
                    return "[\u0561\u0576\u0581\u0561\u056e] dddd [\u0585\u0580\u0568 \u056a\u0561\u0574\u0568] LT";
                },
                sameElse: "L",
            },
            relativeTime: {
                future: "%s \u0570\u0565\u057f\u0578",
                past: "%s \u0561\u057c\u0561\u057b",
                s: "\u0574\u056b \u0584\u0561\u0576\u056b \u057e\u0561\u0575\u0580\u056f\u0575\u0561\u0576",
                ss: "%d \u057e\u0561\u0575\u0580\u056f\u0575\u0561\u0576",
                m: "\u0580\u0578\u057a\u0565",
                mm: "%d \u0580\u0578\u057a\u0565",
                h: "\u056a\u0561\u0574",
                hh: "%d \u056a\u0561\u0574",
                d: "\u0585\u0580",
                dd: "%d \u0585\u0580",
                M: "\u0561\u0574\u056b\u057d",
                MM: "%d \u0561\u0574\u056b\u057d",
                y: "\u057f\u0561\u0580\u056b",
                yy: "%d \u057f\u0561\u0580\u056b",
            },
            meridiemParse:
                /\u0563\u056b\u0577\u0565\u0580\u057e\u0561|\u0561\u057c\u0561\u057e\u0578\u057f\u057e\u0561|\u0581\u0565\u0580\u0565\u056f\u057e\u0561|\u0565\u0580\u0565\u056f\u0578\u0575\u0561\u0576/,
            isPM: function (e) {
                return /^(\u0581\u0565\u0580\u0565\u056f\u057e\u0561|\u0565\u0580\u0565\u056f\u0578\u0575\u0561\u0576)$/.test(
                    e
                );
            },
            meridiem: function (e) {
                return e < 4
                    ? "\u0563\u056b\u0577\u0565\u0580\u057e\u0561"
                    : e < 12
                    ? "\u0561\u057c\u0561\u057e\u0578\u057f\u057e\u0561"
                    : e < 17
                    ? "\u0581\u0565\u0580\u0565\u056f\u057e\u0561"
                    : "\u0565\u0580\u0565\u056f\u0578\u0575\u0561\u0576";
            },
            dayOfMonthOrdinalParse:
                /\d{1,2}|\d{1,2}-(\u056b\u0576|\u0580\u0564)/,
            ordinal: function (e, a) {
                switch (a) {
                    case "DDD":
                    case "w":
                    case "W":
                    case "DDDo":
                        return 1 === e
                            ? e + "-\u056b\u0576"
                            : e + "-\u0580\u0564";
                    default:
                        return e;
                }
            },
            week: { dow: 1, doy: 7 },
        }),
        M.defineLocale("id", {
            months: "Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember".split(
                "_"
            ),
            monthsShort:
                "Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des".split("_"),
            weekdays: "Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu".split("_"),
            weekdaysShort: "Min_Sen_Sel_Rab_Kam_Jum_Sab".split("_"),
            weekdaysMin: "Mg_Sn_Sl_Rb_Km_Jm_Sb".split("_"),
            longDateFormat: {
                LT: "HH.mm",
                LTS: "HH.mm.ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY [pukul] HH.mm",
                LLLL: "dddd, D MMMM YYYY [pukul] HH.mm",
            },
            meridiemParse: /pagi|siang|sore|malam/,
            meridiemHour: function (e, a) {
                return (
                    12 === e && (e = 0),
                    "pagi" === a
                        ? e
                        : "siang" === a
                        ? 11 <= e
                            ? e
                            : e + 12
                        : "sore" === a || "malam" === a
                        ? e + 12
                        : void 0
                );
            },
            meridiem: function (e, a, t) {
                return e < 11
                    ? "pagi"
                    : e < 15
                    ? "siang"
                    : e < 19
                    ? "sore"
                    : "malam";
            },
            calendar: {
                sameDay: "[Hari ini pukul] LT",
                nextDay: "[Besok pukul] LT",
                nextWeek: "dddd [pukul] LT",
                lastDay: "[Kemarin pukul] LT",
                lastWeek: "dddd [lalu pukul] LT",
                sameElse: "L",
            },
            relativeTime: {
                future: "dalam %s",
                past: "%s yang lalu",
                s: "beberapa detik",
                ss: "%d detik",
                m: "semenit",
                mm: "%d menit",
                h: "sejam",
                hh: "%d jam",
                d: "sehari",
                dd: "%d hari",
                M: "sebulan",
                MM: "%d bulan",
                y: "setahun",
                yy: "%d tahun",
            },
            week: { dow: 0, doy: 6 },
        }),
        M.defineLocale("is", {
            months: "jan\xfaar_febr\xfaar_mars_apr\xedl_ma\xed_j\xfan\xed_j\xfal\xed_\xe1g\xfast_september_okt\xf3ber_n\xf3vember_desember".split(
                "_"
            ),
            monthsShort:
                "jan_feb_mar_apr_ma\xed_j\xfan_j\xfal_\xe1g\xfa_sep_okt_n\xf3v_des".split(
                    "_"
                ),
            weekdays:
                "sunnudagur_m\xe1nudagur_\xferi\xf0judagur_mi\xf0vikudagur_fimmtudagur_f\xf6studagur_laugardagur".split(
                    "_"
                ),
            weekdaysShort: "sun_m\xe1n_\xferi_mi\xf0_fim_f\xf6s_lau".split("_"),
            weekdaysMin: "Su_M\xe1_\xder_Mi_Fi_F\xf6_La".split("_"),
            longDateFormat: {
                LT: "H:mm",
                LTS: "H:mm:ss",
                L: "DD.MM.YYYY",
                LL: "D. MMMM YYYY",
                LLL: "D. MMMM YYYY [kl.] H:mm",
                LLLL: "dddd, D. MMMM YYYY [kl.] H:mm",
            },
            calendar: {
                sameDay: "[\xed dag kl.] LT",
                nextDay: "[\xe1 morgun kl.] LT",
                nextWeek: "dddd [kl.] LT",
                lastDay: "[\xed g\xe6r kl.] LT",
                lastWeek: "[s\xed\xf0asta] dddd [kl.] LT",
                sameElse: "L",
            },
            relativeTime: {
                future: "eftir %s",
                past: "fyrir %s s\xed\xf0an",
                s: Ws,
                ss: Ws,
                m: Ws,
                mm: Ws,
                h: "klukkustund",
                hh: Ws,
                d: Ws,
                dd: Ws,
                M: Ws,
                MM: Ws,
                y: Ws,
                yy: Ws,
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: { dow: 1, doy: 4 },
        }),
        M.defineLocale("it-ch", {
            months: "gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split(
                "_"
            ),
            monthsShort:
                "gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"),
            weekdays:
                "domenica_luned\xec_marted\xec_mercoled\xec_gioved\xec_venerd\xec_sabato".split(
                    "_"
                ),
            weekdaysShort: "dom_lun_mar_mer_gio_ven_sab".split("_"),
            weekdaysMin: "do_lu_ma_me_gi_ve_sa".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD.MM.YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd D MMMM YYYY HH:mm",
            },
            calendar: {
                sameDay: "[Oggi alle] LT",
                nextDay: "[Domani alle] LT",
                nextWeek: "dddd [alle] LT",
                lastDay: "[Ieri alle] LT",
                lastWeek: function () {
                    switch (this.day()) {
                        case 0:
                            return "[la scorsa] dddd [alle] LT";
                        default:
                            return "[lo scorso] dddd [alle] LT";
                    }
                },
                sameElse: "L",
            },
            relativeTime: {
                future: function (e) {
                    return (/^[0-9].+$/.test(e) ? "tra" : "in") + " " + e;
                },
                past: "%s fa",
                s: "alcuni secondi",
                ss: "%d secondi",
                m: "un minuto",
                mm: "%d minuti",
                h: "un'ora",
                hh: "%d ore",
                d: "un giorno",
                dd: "%d giorni",
                M: "un mese",
                MM: "%d mesi",
                y: "un anno",
                yy: "%d anni",
            },
            dayOfMonthOrdinalParse: /\d{1,2}\xba/,
            ordinal: "%d\xba",
            week: { dow: 1, doy: 4 },
        }),
        M.defineLocale("it", {
            months: "gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split(
                "_"
            ),
            monthsShort:
                "gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"),
            weekdays:
                "domenica_luned\xec_marted\xec_mercoled\xec_gioved\xec_venerd\xec_sabato".split(
                    "_"
                ),
            weekdaysShort: "dom_lun_mar_mer_gio_ven_sab".split("_"),
            weekdaysMin: "do_lu_ma_me_gi_ve_sa".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd D MMMM YYYY HH:mm",
            },
            calendar: {
                sameDay: function () {
                    return (
                        "[Oggi a" +
                        (1 < this.hours()
                            ? "lle "
                            : 0 === this.hours()
                            ? " "
                            : "ll'") +
                        "]LT"
                    );
                },
                nextDay: function () {
                    return (
                        "[Domani a" +
                        (1 < this.hours()
                            ? "lle "
                            : 0 === this.hours()
                            ? " "
                            : "ll'") +
                        "]LT"
                    );
                },
                nextWeek: function () {
                    return (
                        "dddd [a" +
                        (1 < this.hours()
                            ? "lle "
                            : 0 === this.hours()
                            ? " "
                            : "ll'") +
                        "]LT"
                    );
                },
                lastDay: function () {
                    return (
                        "[Ieri a" +
                        (1 < this.hours()
                            ? "lle "
                            : 0 === this.hours()
                            ? " "
                            : "ll'") +
                        "]LT"
                    );
                },
                lastWeek: function () {
                    switch (this.day()) {
                        case 0:
                            return (
                                "[La scorsa] dddd [a" +
                                (1 < this.hours()
                                    ? "lle "
                                    : 0 === this.hours()
                                    ? " "
                                    : "ll'") +
                                "]LT"
                            );
                        default:
                            return (
                                "[Lo scorso] dddd [a" +
                                (1 < this.hours()
                                    ? "lle "
                                    : 0 === this.hours()
                                    ? " "
                                    : "ll'") +
                                "]LT"
                            );
                    }
                },
                sameElse: "L",
            },
            relativeTime: {
                future: "tra %s",
                past: "%s fa",
                s: "alcuni secondi",
                ss: "%d secondi",
                m: "un minuto",
                mm: "%d minuti",
                h: "un'ora",
                hh: "%d ore",
                d: "un giorno",
                dd: "%d giorni",
                w: "una settimana",
                ww: "%d settimane",
                M: "un mese",
                MM: "%d mesi",
                y: "un anno",
                yy: "%d anni",
            },
            dayOfMonthOrdinalParse: /\d{1,2}\xba/,
            ordinal: "%d\xba",
            week: { dow: 1, doy: 4 },
        }),
        M.defineLocale("ja", {
            eras: [
                {
                    since: "2019-05-01",
                    offset: 1,
                    name: "\u4ee4\u548c",
                    narrow: "\u32ff",
                    abbr: "R",
                },
                {
                    since: "1989-01-08",
                    until: "2019-04-30",
                    offset: 1,
                    name: "\u5e73\u6210",
                    narrow: "\u337b",
                    abbr: "H",
                },
                {
                    since: "1926-12-25",
                    until: "1989-01-07",
                    offset: 1,
                    name: "\u662d\u548c",
                    narrow: "\u337c",
                    abbr: "S",
                },
                {
                    since: "1912-07-30",
                    until: "1926-12-24",
                    offset: 1,
                    name: "\u5927\u6b63",
                    narrow: "\u337d",
                    abbr: "T",
                },
                {
                    since: "1873-01-01",
                    until: "1912-07-29",
                    offset: 6,
                    name: "\u660e\u6cbb",
                    narrow: "\u337e",
                    abbr: "M",
                },
                {
                    since: "0001-01-01",
                    until: "1873-12-31",
                    offset: 1,
                    name: "\u897f\u66a6",
                    narrow: "AD",
                    abbr: "AD",
                },
                {
                    since: "0000-12-31",
                    until: -1 / 0,
                    offset: 1,
                    name: "\u7d00\u5143\u524d",
                    narrow: "BC",
                    abbr: "BC",
                },
            ],
            eraYearOrdinalRegex: /(\u5143|\d+)\u5e74/,
            eraYearOrdinalParse: function (e, a) {
                return "\u5143" === a[1] ? 1 : parseInt(a[1] || e, 10);
            },
            months: "1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split(
                "_"
            ),
            monthsShort:
                "1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split(
                    "_"
                ),
            weekdays:
                "\u65e5\u66dc\u65e5_\u6708\u66dc\u65e5_\u706b\u66dc\u65e5_\u6c34\u66dc\u65e5_\u6728\u66dc\u65e5_\u91d1\u66dc\u65e5_\u571f\u66dc\u65e5".split(
                    "_"
                ),
            weekdaysShort:
                "\u65e5_\u6708_\u706b_\u6c34_\u6728_\u91d1_\u571f".split("_"),
            weekdaysMin:
                "\u65e5_\u6708_\u706b_\u6c34_\u6728_\u91d1_\u571f".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "YYYY/MM/DD",
                LL: "YYYY\u5e74M\u6708D\u65e5",
                LLL: "YYYY\u5e74M\u6708D\u65e5 HH:mm",
                LLLL: "YYYY\u5e74M\u6708D\u65e5 dddd HH:mm",
                l: "YYYY/MM/DD",
                ll: "YYYY\u5e74M\u6708D\u65e5",
                lll: "YYYY\u5e74M\u6708D\u65e5 HH:mm",
                llll: "YYYY\u5e74M\u6708D\u65e5(ddd) HH:mm",
            },
            meridiemParse: /\u5348\u524d|\u5348\u5f8c/i,
            isPM: function (e) {
                return "\u5348\u5f8c" === e;
            },
            meridiem: function (e, a, t) {
                return e < 12 ? "\u5348\u524d" : "\u5348\u5f8c";
            },
            calendar: {
                sameDay: "[\u4eca\u65e5] LT",
                nextDay: "[\u660e\u65e5] LT",
                nextWeek: function (e) {
                    return e.week() !== this.week()
                        ? "[\u6765\u9031]dddd LT"
                        : "dddd LT";
                },
                lastDay: "[\u6628\u65e5] LT",
                lastWeek: function (e) {
                    return this.week() !== e.week()
                        ? "[\u5148\u9031]dddd LT"
                        : "dddd LT";
                },
                sameElse: "L",
            },
            dayOfMonthOrdinalParse: /\d{1,2}\u65e5/,
            ordinal: function (e, a) {
                switch (a) {
                    case "y":
                        return 1 === e ? "\u5143\u5e74" : e + "\u5e74";
                    case "d":
                    case "D":
                    case "DDD":
                        return e + "\u65e5";
                    default:
                        return e;
                }
            },
            relativeTime: {
                future: "%s\u5f8c",
                past: "%s\u524d",
                s: "\u6570\u79d2",
                ss: "%d\u79d2",
                m: "1\u5206",
                mm: "%d\u5206",
                h: "1\u6642\u9593",
                hh: "%d\u6642\u9593",
                d: "1\u65e5",
                dd: "%d\u65e5",
                M: "1\u30f6\u6708",
                MM: "%d\u30f6\u6708",
                y: "1\u5e74",
                yy: "%d\u5e74",
            },
        }),
        M.defineLocale("jv", {
            months: "Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember".split(
                "_"
            ),
            monthsShort:
                "Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des".split("_"),
            weekdays: "Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu".split("_"),
            weekdaysShort: "Min_Sen_Sel_Reb_Kem_Jem_Sep".split("_"),
            weekdaysMin: "Mg_Sn_Sl_Rb_Km_Jm_Sp".split("_"),
            longDateFormat: {
                LT: "HH.mm",
                LTS: "HH.mm.ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY [pukul] HH.mm",
                LLLL: "dddd, D MMMM YYYY [pukul] HH.mm",
            },
            meridiemParse: /enjing|siyang|sonten|ndalu/,
            meridiemHour: function (e, a) {
                return (
                    12 === e && (e = 0),
                    "enjing" === a
                        ? e
                        : "siyang" === a
                        ? 11 <= e
                            ? e
                            : e + 12
                        : "sonten" === a || "ndalu" === a
                        ? e + 12
                        : void 0
                );
            },
            meridiem: function (e, a, t) {
                return e < 11
                    ? "enjing"
                    : e < 15
                    ? "siyang"
                    : e < 19
                    ? "sonten"
                    : "ndalu";
            },
            calendar: {
                sameDay: "[Dinten puniko pukul] LT",
                nextDay: "[Mbenjang pukul] LT",
                nextWeek: "dddd [pukul] LT",
                lastDay: "[Kala wingi pukul] LT",
                lastWeek: "dddd [kepengker pukul] LT",
                sameElse: "L",
            },
            relativeTime: {
                future: "wonten ing %s",
                past: "%s ingkang kepengker",
                s: "sawetawis detik",
                ss: "%d detik",
                m: "setunggal menit",
                mm: "%d menit",
                h: "setunggal jam",
                hh: "%d jam",
                d: "sedinten",
                dd: "%d dinten",
                M: "sewulan",
                MM: "%d wulan",
                y: "setaun",
                yy: "%d taun",
            },
            week: { dow: 1, doy: 7 },
        }),
        M.defineLocale("ka", {
            months: "\u10d8\u10d0\u10dc\u10d5\u10d0\u10e0\u10d8_\u10d7\u10d4\u10d1\u10d4\u10e0\u10d5\u10d0\u10da\u10d8_\u10db\u10d0\u10e0\u10e2\u10d8_\u10d0\u10de\u10e0\u10d8\u10da\u10d8_\u10db\u10d0\u10d8\u10e1\u10d8_\u10d8\u10d5\u10dc\u10d8\u10e1\u10d8_\u10d8\u10d5\u10da\u10d8\u10e1\u10d8_\u10d0\u10d2\u10d5\u10d8\u10e1\u10e2\u10dd_\u10e1\u10d4\u10e5\u10e2\u10d4\u10db\u10d1\u10d4\u10e0\u10d8_\u10dd\u10e5\u10e2\u10dd\u10db\u10d1\u10d4\u10e0\u10d8_\u10dc\u10dd\u10d4\u10db\u10d1\u10d4\u10e0\u10d8_\u10d3\u10d4\u10d9\u10d4\u10db\u10d1\u10d4\u10e0\u10d8".split(
                "_"
            ),
            monthsShort:
                "\u10d8\u10d0\u10dc_\u10d7\u10d4\u10d1_\u10db\u10d0\u10e0_\u10d0\u10de\u10e0_\u10db\u10d0\u10d8_\u10d8\u10d5\u10dc_\u10d8\u10d5\u10da_\u10d0\u10d2\u10d5_\u10e1\u10d4\u10e5_\u10dd\u10e5\u10e2_\u10dc\u10dd\u10d4_\u10d3\u10d4\u10d9".split(
                    "_"
                ),
            weekdays: {
                standalone:
                    "\u10d9\u10d5\u10d8\u10e0\u10d0_\u10dd\u10e0\u10e8\u10d0\u10d1\u10d0\u10d7\u10d8_\u10e1\u10d0\u10db\u10e8\u10d0\u10d1\u10d0\u10d7\u10d8_\u10dd\u10d7\u10ee\u10e8\u10d0\u10d1\u10d0\u10d7\u10d8_\u10ee\u10e3\u10d7\u10e8\u10d0\u10d1\u10d0\u10d7\u10d8_\u10de\u10d0\u10e0\u10d0\u10e1\u10d9\u10d4\u10d5\u10d8_\u10e8\u10d0\u10d1\u10d0\u10d7\u10d8".split(
                        "_"
                    ),
                format: "\u10d9\u10d5\u10d8\u10e0\u10d0\u10e1_\u10dd\u10e0\u10e8\u10d0\u10d1\u10d0\u10d7\u10e1_\u10e1\u10d0\u10db\u10e8\u10d0\u10d1\u10d0\u10d7\u10e1_\u10dd\u10d7\u10ee\u10e8\u10d0\u10d1\u10d0\u10d7\u10e1_\u10ee\u10e3\u10d7\u10e8\u10d0\u10d1\u10d0\u10d7\u10e1_\u10de\u10d0\u10e0\u10d0\u10e1\u10d9\u10d4\u10d5\u10e1_\u10e8\u10d0\u10d1\u10d0\u10d7\u10e1".split(
                    "_"
                ),
                isFormat:
                    /(\u10ec\u10d8\u10dc\u10d0|\u10e8\u10d4\u10db\u10d3\u10d4\u10d2)/,
            },
            weekdaysShort:
                "\u10d9\u10d5\u10d8_\u10dd\u10e0\u10e8_\u10e1\u10d0\u10db_\u10dd\u10d7\u10ee_\u10ee\u10e3\u10d7_\u10de\u10d0\u10e0_\u10e8\u10d0\u10d1".split(
                    "_"
                ),
            weekdaysMin:
                "\u10d9\u10d5_\u10dd\u10e0_\u10e1\u10d0_\u10dd\u10d7_\u10ee\u10e3_\u10de\u10d0_\u10e8\u10d0".split(
                    "_"
                ),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd, D MMMM YYYY HH:mm",
            },
            calendar: {
                sameDay: "[\u10d3\u10e6\u10d4\u10e1] LT[-\u10d6\u10d4]",
                nextDay: "[\u10ee\u10d5\u10d0\u10da] LT[-\u10d6\u10d4]",
                lastDay: "[\u10d2\u10e3\u10e8\u10d8\u10dc] LT[-\u10d6\u10d4]",
                nextWeek:
                    "[\u10e8\u10d4\u10db\u10d3\u10d4\u10d2] dddd LT[-\u10d6\u10d4]",
                lastWeek: "[\u10ec\u10d8\u10dc\u10d0] dddd LT-\u10d6\u10d4",
                sameElse: "L",
            },
            relativeTime: {
                future: function (e) {
                    return e.replace(
                        /(\u10ec\u10d0\u10db|\u10ec\u10e3\u10d7|\u10e1\u10d0\u10d0\u10d7|\u10ec\u10d4\u10da|\u10d3\u10e6|\u10d7\u10d5)(\u10d8|\u10d4)/,
                        function (e, a, t) {
                            return "\u10d8" === t
                                ? a + "\u10e8\u10d8"
                                : a + t + "\u10e8\u10d8";
                        }
                    );
                },
                past: function (e) {
                    return /(\u10ec\u10d0\u10db\u10d8|\u10ec\u10e3\u10d7\u10d8|\u10e1\u10d0\u10d0\u10d7\u10d8|\u10d3\u10e6\u10d4|\u10d7\u10d5\u10d4)/.test(
                        e
                    )
                        ? e.replace(
                              /(\u10d8|\u10d4)$/,
                              "\u10d8\u10e1 \u10ec\u10d8\u10dc"
                          )
                        : /\u10ec\u10d4\u10da\u10d8/.test(e)
                        ? e.replace(
                              /\u10ec\u10d4\u10da\u10d8$/,
                              "\u10ec\u10da\u10d8\u10e1 \u10ec\u10d8\u10dc"
                          )
                        : e;
                },
                s: "\u10e0\u10d0\u10db\u10d3\u10d4\u10dc\u10d8\u10db\u10d4 \u10ec\u10d0\u10db\u10d8",
                ss: "%d \u10ec\u10d0\u10db\u10d8",
                m: "\u10ec\u10e3\u10d7\u10d8",
                mm: "%d \u10ec\u10e3\u10d7\u10d8",
                h: "\u10e1\u10d0\u10d0\u10d7\u10d8",
                hh: "%d \u10e1\u10d0\u10d0\u10d7\u10d8",
                d: "\u10d3\u10e6\u10d4",
                dd: "%d \u10d3\u10e6\u10d4",
                M: "\u10d7\u10d5\u10d4",
                MM: "%d \u10d7\u10d5\u10d4",
                y: "\u10ec\u10d4\u10da\u10d8",
                yy: "%d \u10ec\u10d4\u10da\u10d8",
            },
            dayOfMonthOrdinalParse:
                /0|1-\u10da\u10d8|\u10db\u10d4-\d{1,2}|\d{1,2}-\u10d4/,
            ordinal: function (e) {
                return 0 === e
                    ? e
                    : 1 === e
                    ? e + "-\u10da\u10d8"
                    : e < 20 || (e <= 100 && e % 20 == 0) || e % 100 == 0
                    ? "\u10db\u10d4-" + e
                    : e + "-\u10d4";
            },
            week: { dow: 1, doy: 7 },
        });
    var As = {
            0: "-\u0448\u0456",
            1: "-\u0448\u0456",
            2: "-\u0448\u0456",
            3: "-\u0448\u0456",
            4: "-\u0448\u0456",
            5: "-\u0448\u0456",
            6: "-\u0448\u044b",
            7: "-\u0448\u0456",
            8: "-\u0448\u0456",
            9: "-\u0448\u044b",
            10: "-\u0448\u044b",
            20: "-\u0448\u044b",
            30: "-\u0448\u044b",
            40: "-\u0448\u044b",
            50: "-\u0448\u0456",
            60: "-\u0448\u044b",
            70: "-\u0448\u0456",
            80: "-\u0448\u0456",
            90: "-\u0448\u044b",
            100: "-\u0448\u0456",
        },
        Es =
            (M.defineLocale("kk", {
                months: "\u049b\u0430\u04a3\u0442\u0430\u0440_\u0430\u049b\u043f\u0430\u043d_\u043d\u0430\u0443\u0440\u044b\u0437_\u0441\u04d9\u0443\u0456\u0440_\u043c\u0430\u043c\u044b\u0440_\u043c\u0430\u0443\u0441\u044b\u043c_\u0448\u0456\u043b\u0434\u0435_\u0442\u0430\u043c\u044b\u0437_\u049b\u044b\u0440\u043a\u04af\u0439\u0435\u043a_\u049b\u0430\u0437\u0430\u043d_\u049b\u0430\u0440\u0430\u0448\u0430_\u0436\u0435\u043b\u0442\u043e\u049b\u0441\u0430\u043d".split(
                    "_"
                ),
                monthsShort:
                    "\u049b\u0430\u04a3_\u0430\u049b\u043f_\u043d\u0430\u0443_\u0441\u04d9\u0443_\u043c\u0430\u043c_\u043c\u0430\u0443_\u0448\u0456\u043b_\u0442\u0430\u043c_\u049b\u044b\u0440_\u049b\u0430\u0437_\u049b\u0430\u0440_\u0436\u0435\u043b".split(
                        "_"
                    ),
                weekdays:
                    "\u0436\u0435\u043a\u0441\u0435\u043d\u0431\u0456_\u0434\u04af\u0439\u0441\u0435\u043d\u0431\u0456_\u0441\u0435\u0439\u0441\u0435\u043d\u0431\u0456_\u0441\u04d9\u0440\u0441\u0435\u043d\u0431\u0456_\u0431\u0435\u0439\u0441\u0435\u043d\u0431\u0456_\u0436\u04b1\u043c\u0430_\u0441\u0435\u043d\u0431\u0456".split(
                        "_"
                    ),
                weekdaysShort:
                    "\u0436\u0435\u043a_\u0434\u04af\u0439_\u0441\u0435\u0439_\u0441\u04d9\u0440_\u0431\u0435\u0439_\u0436\u04b1\u043c_\u0441\u0435\u043d".split(
                        "_"
                    ),
                weekdaysMin:
                    "\u0436\u043a_\u0434\u0439_\u0441\u0439_\u0441\u0440_\u0431\u0439_\u0436\u043c_\u0441\u043d".split(
                        "_"
                    ),
                longDateFormat: {
                    LT: "HH:mm",
                    LTS: "HH:mm:ss",
                    L: "DD.MM.YYYY",
                    LL: "D MMMM YYYY",
                    LLL: "D MMMM YYYY HH:mm",
                    LLLL: "dddd, D MMMM YYYY HH:mm",
                },
                calendar: {
                    sameDay:
                        "[\u0411\u04af\u0433\u0456\u043d \u0441\u0430\u0493\u0430\u0442] LT",
                    nextDay:
                        "[\u0415\u0440\u0442\u0435\u04a3 \u0441\u0430\u0493\u0430\u0442] LT",
                    nextWeek: "dddd [\u0441\u0430\u0493\u0430\u0442] LT",
                    lastDay:
                        "[\u041a\u0435\u0448\u0435 \u0441\u0430\u0493\u0430\u0442] LT",
                    lastWeek:
                        "[\u04e8\u0442\u043a\u0435\u043d \u0430\u043f\u0442\u0430\u043d\u044b\u04a3] dddd [\u0441\u0430\u0493\u0430\u0442] LT",
                    sameElse: "L",
                },
                relativeTime: {
                    future: "%s \u0456\u0448\u0456\u043d\u0434\u0435",
                    past: "%s \u0431\u04b1\u0440\u044b\u043d",
                    s: "\u0431\u0456\u0440\u043d\u0435\u0448\u0435 \u0441\u0435\u043a\u0443\u043d\u0434",
                    ss: "%d \u0441\u0435\u043a\u0443\u043d\u0434",
                    m: "\u0431\u0456\u0440 \u043c\u0438\u043d\u0443\u0442",
                    mm: "%d \u043c\u0438\u043d\u0443\u0442",
                    h: "\u0431\u0456\u0440 \u0441\u0430\u0493\u0430\u0442",
                    hh: "%d \u0441\u0430\u0493\u0430\u0442",
                    d: "\u0431\u0456\u0440 \u043a\u04af\u043d",
                    dd: "%d \u043a\u04af\u043d",
                    M: "\u0431\u0456\u0440 \u0430\u0439",
                    MM: "%d \u0430\u0439",
                    y: "\u0431\u0456\u0440 \u0436\u044b\u043b",
                    yy: "%d \u0436\u044b\u043b",
                },
                dayOfMonthOrdinalParse: /\d{1,2}-(\u0448\u0456|\u0448\u044b)/,
                ordinal: function (e) {
                    return (
                        e + (As[e] || As[e % 10] || As[100 <= e ? 100 : null])
                    );
                },
                week: { dow: 1, doy: 7 },
            }),
            {
                1: "\u17e1",
                2: "\u17e2",
                3: "\u17e3",
                4: "\u17e4",
                5: "\u17e5",
                6: "\u17e6",
                7: "\u17e7",
                8: "\u17e8",
                9: "\u17e9",
                0: "\u17e0",
            }),
        Fs = {
            "\u17e1": "1",
            "\u17e2": "2",
            "\u17e3": "3",
            "\u17e4": "4",
            "\u17e5": "5",
            "\u17e6": "6",
            "\u17e7": "7",
            "\u17e8": "8",
            "\u17e9": "9",
            "\u17e0": "0",
        },
        zs =
            (M.defineLocale("km", {
                months: "\u1798\u1780\u179a\u17b6_\u1780\u17bb\u1798\u17d2\u1797\u17c8_\u1798\u17b8\u1793\u17b6_\u1798\u17c1\u179f\u17b6_\u17a7\u179f\u1797\u17b6_\u1798\u17b7\u1790\u17bb\u1793\u17b6_\u1780\u1780\u17d2\u1780\u178a\u17b6_\u179f\u17b8\u17a0\u17b6_\u1780\u1789\u17d2\u1789\u17b6_\u178f\u17bb\u179b\u17b6_\u179c\u17b7\u1785\u17d2\u1786\u17b7\u1780\u17b6_\u1792\u17d2\u1793\u17bc".split(
                    "_"
                ),
                monthsShort:
                    "\u1798\u1780\u179a\u17b6_\u1780\u17bb\u1798\u17d2\u1797\u17c8_\u1798\u17b8\u1793\u17b6_\u1798\u17c1\u179f\u17b6_\u17a7\u179f\u1797\u17b6_\u1798\u17b7\u1790\u17bb\u1793\u17b6_\u1780\u1780\u17d2\u1780\u178a\u17b6_\u179f\u17b8\u17a0\u17b6_\u1780\u1789\u17d2\u1789\u17b6_\u178f\u17bb\u179b\u17b6_\u179c\u17b7\u1785\u17d2\u1786\u17b7\u1780\u17b6_\u1792\u17d2\u1793\u17bc".split(
                        "_"
                    ),
                weekdays:
                    "\u17a2\u17b6\u1791\u17b7\u178f\u17d2\u1799_\u1785\u17d0\u1793\u17d2\u1791_\u17a2\u1784\u17d2\u1782\u17b6\u179a_\u1796\u17bb\u1792_\u1796\u17d2\u179a\u17a0\u179f\u17d2\u1794\u178f\u17b7\u17cd_\u179f\u17bb\u1780\u17d2\u179a_\u179f\u17c5\u179a\u17cd".split(
                        "_"
                    ),
                weekdaysShort:
                    "\u17a2\u17b6_\u1785_\u17a2_\u1796_\u1796\u17d2\u179a_\u179f\u17bb_\u179f".split(
                        "_"
                    ),
                weekdaysMin:
                    "\u17a2\u17b6_\u1785_\u17a2_\u1796_\u1796\u17d2\u179a_\u179f\u17bb_\u179f".split(
                        "_"
                    ),
                weekdaysParseExact: !0,
                longDateFormat: {
                    LT: "HH:mm",
                    LTS: "HH:mm:ss",
                    L: "DD/MM/YYYY",
                    LL: "D MMMM YYYY",
                    LLL: "D MMMM YYYY HH:mm",
                    LLLL: "dddd, D MMMM YYYY HH:mm",
                },
                meridiemParse:
                    /\u1796\u17d2\u179a\u17b9\u1780|\u179b\u17d2\u1784\u17b6\u1785/,
                isPM: function (e) {
                    return "\u179b\u17d2\u1784\u17b6\u1785" === e;
                },
                meridiem: function (e, a, t) {
                    return e < 12
                        ? "\u1796\u17d2\u179a\u17b9\u1780"
                        : "\u179b\u17d2\u1784\u17b6\u1785";
                },
                calendar: {
                    sameDay:
                        "[\u1790\u17d2\u1784\u17c3\u1793\u17c1\u17c7 \u1798\u17c9\u17c4\u1784] LT",
                    nextDay:
                        "[\u179f\u17d2\u17a2\u17c2\u1780 \u1798\u17c9\u17c4\u1784] LT",
                    nextWeek: "dddd [\u1798\u17c9\u17c4\u1784] LT",
                    lastDay:
                        "[\u1798\u17d2\u179f\u17b7\u179b\u1798\u17b7\u1789 \u1798\u17c9\u17c4\u1784] LT",
                    lastWeek:
                        "dddd [\u179f\u1794\u17d2\u178f\u17b6\u17a0\u17cd\u1798\u17bb\u1793] [\u1798\u17c9\u17c4\u1784] LT",
                    sameElse: "L",
                },
                relativeTime: {
                    future: "%s\u1791\u17c0\u178f",
                    past: "%s\u1798\u17bb\u1793",
                    s: "\u1794\u17c9\u17bb\u1793\u17d2\u1798\u17b6\u1793\u179c\u17b7\u1793\u17b6\u1791\u17b8",
                    ss: "%d \u179c\u17b7\u1793\u17b6\u1791\u17b8",
                    m: "\u1798\u17bd\u1799\u1793\u17b6\u1791\u17b8",
                    mm: "%d \u1793\u17b6\u1791\u17b8",
                    h: "\u1798\u17bd\u1799\u1798\u17c9\u17c4\u1784",
                    hh: "%d \u1798\u17c9\u17c4\u1784",
                    d: "\u1798\u17bd\u1799\u1790\u17d2\u1784\u17c3",
                    dd: "%d \u1790\u17d2\u1784\u17c3",
                    M: "\u1798\u17bd\u1799\u1781\u17c2",
                    MM: "%d \u1781\u17c2",
                    y: "\u1798\u17bd\u1799\u1786\u17d2\u1793\u17b6\u17c6",
                    yy: "%d \u1786\u17d2\u1793\u17b6\u17c6",
                },
                dayOfMonthOrdinalParse: /\u1791\u17b8\d{1,2}/,
                ordinal: "\u1791\u17b8%d",
                preparse: function (e) {
                    return e.replace(
                        /[\u17e1\u17e2\u17e3\u17e4\u17e5\u17e6\u17e7\u17e8\u17e9\u17e0]/g,
                        function (e) {
                            return Fs[e];
                        }
                    );
                },
                postformat: function (e) {
                    return e.replace(/\d/g, function (e) {
                        return Es[e];
                    });
                },
                week: { dow: 1, doy: 4 },
            }),
            {
                1: "\u0ce7",
                2: "\u0ce8",
                3: "\u0ce9",
                4: "\u0cea",
                5: "\u0ceb",
                6: "\u0cec",
                7: "\u0ced",
                8: "\u0cee",
                9: "\u0cef",
                0: "\u0ce6",
            }),
        Ns = {
            "\u0ce7": "1",
            "\u0ce8": "2",
            "\u0ce9": "3",
            "\u0cea": "4",
            "\u0ceb": "5",
            "\u0cec": "6",
            "\u0ced": "7",
            "\u0cee": "8",
            "\u0cef": "9",
            "\u0ce6": "0",
        },
        Js =
            (M.defineLocale("kn", {
                months: "\u0c9c\u0ca8\u0cb5\u0cb0\u0cbf_\u0cab\u0cc6\u0cac\u0ccd\u0cb0\u0cb5\u0cb0\u0cbf_\u0cae\u0cbe\u0cb0\u0ccd\u0c9a\u0ccd_\u0c8f\u0caa\u0ccd\u0cb0\u0cbf\u0cb2\u0ccd_\u0cae\u0cc6\u0cd5_\u0c9c\u0cc2\u0ca8\u0ccd_\u0c9c\u0cc1\u0cb2\u0cc6\u0cd6_\u0c86\u0c97\u0cb8\u0ccd\u0c9f\u0ccd_\u0cb8\u0cc6\u0caa\u0ccd\u0c9f\u0cc6\u0c82\u0cac\u0cb0\u0ccd_\u0c85\u0c95\u0ccd\u0c9f\u0cc6\u0cc2\u0cd5\u0cac\u0cb0\u0ccd_\u0ca8\u0cb5\u0cc6\u0c82\u0cac\u0cb0\u0ccd_\u0ca1\u0cbf\u0cb8\u0cc6\u0c82\u0cac\u0cb0\u0ccd".split(
                    "_"
                ),
                monthsShort:
                    "\u0c9c\u0ca8_\u0cab\u0cc6\u0cac\u0ccd\u0cb0_\u0cae\u0cbe\u0cb0\u0ccd\u0c9a\u0ccd_\u0c8f\u0caa\u0ccd\u0cb0\u0cbf\u0cb2\u0ccd_\u0cae\u0cc6\u0cd5_\u0c9c\u0cc2\u0ca8\u0ccd_\u0c9c\u0cc1\u0cb2\u0cc6\u0cd6_\u0c86\u0c97\u0cb8\u0ccd\u0c9f\u0ccd_\u0cb8\u0cc6\u0caa\u0ccd\u0c9f\u0cc6\u0c82_\u0c85\u0c95\u0ccd\u0c9f\u0cc6\u0cc2\u0cd5_\u0ca8\u0cb5\u0cc6\u0c82_\u0ca1\u0cbf\u0cb8\u0cc6\u0c82".split(
                        "_"
                    ),
                monthsParseExact: !0,
                weekdays:
                    "\u0cad\u0cbe\u0ca8\u0cc1\u0cb5\u0cbe\u0cb0_\u0cb8\u0cc6\u0cc2\u0cd5\u0cae\u0cb5\u0cbe\u0cb0_\u0cae\u0c82\u0c97\u0cb3\u0cb5\u0cbe\u0cb0_\u0cac\u0cc1\u0ca7\u0cb5\u0cbe\u0cb0_\u0c97\u0cc1\u0cb0\u0cc1\u0cb5\u0cbe\u0cb0_\u0cb6\u0cc1\u0c95\u0ccd\u0cb0\u0cb5\u0cbe\u0cb0_\u0cb6\u0ca8\u0cbf\u0cb5\u0cbe\u0cb0".split(
                        "_"
                    ),
                weekdaysShort:
                    "\u0cad\u0cbe\u0ca8\u0cc1_\u0cb8\u0cc6\u0cc2\u0cd5\u0cae_\u0cae\u0c82\u0c97\u0cb3_\u0cac\u0cc1\u0ca7_\u0c97\u0cc1\u0cb0\u0cc1_\u0cb6\u0cc1\u0c95\u0ccd\u0cb0_\u0cb6\u0ca8\u0cbf".split(
                        "_"
                    ),
                weekdaysMin:
                    "\u0cad\u0cbe_\u0cb8\u0cc6\u0cc2\u0cd5_\u0cae\u0c82_\u0cac\u0cc1_\u0c97\u0cc1_\u0cb6\u0cc1_\u0cb6".split(
                        "_"
                    ),
                longDateFormat: {
                    LT: "A h:mm",
                    LTS: "A h:mm:ss",
                    L: "DD/MM/YYYY",
                    LL: "D MMMM YYYY",
                    LLL: "D MMMM YYYY, A h:mm",
                    LLLL: "dddd, D MMMM YYYY, A h:mm",
                },
                calendar: {
                    sameDay: "[\u0c87\u0c82\u0ca6\u0cc1] LT",
                    nextDay: "[\u0ca8\u0cbe\u0cb3\u0cc6] LT",
                    nextWeek: "dddd, LT",
                    lastDay: "[\u0ca8\u0cbf\u0ca8\u0ccd\u0ca8\u0cc6] LT",
                    lastWeek: "[\u0c95\u0cc6\u0cc2\u0ca8\u0cc6\u0caf] dddd, LT",
                    sameElse: "L",
                },
                relativeTime: {
                    future: "%s \u0ca8\u0c82\u0ca4\u0cb0",
                    past: "%s \u0cb9\u0cbf\u0c82\u0ca6\u0cc6",
                    s: "\u0c95\u0cc6\u0cb2\u0cb5\u0cc1 \u0c95\u0ccd\u0cb7\u0ca3\u0c97\u0cb3\u0cc1",
                    ss: "%d \u0cb8\u0cc6\u0c95\u0cc6\u0c82\u0ca1\u0cc1\u0c97\u0cb3\u0cc1",
                    m: "\u0c92\u0c82\u0ca6\u0cc1 \u0ca8\u0cbf\u0cae\u0cbf\u0cb7",
                    mm: "%d \u0ca8\u0cbf\u0cae\u0cbf\u0cb7",
                    h: "\u0c92\u0c82\u0ca6\u0cc1 \u0c97\u0c82\u0c9f\u0cc6",
                    hh: "%d \u0c97\u0c82\u0c9f\u0cc6",
                    d: "\u0c92\u0c82\u0ca6\u0cc1 \u0ca6\u0cbf\u0ca8",
                    dd: "%d \u0ca6\u0cbf\u0ca8",
                    M: "\u0c92\u0c82\u0ca6\u0cc1 \u0ca4\u0cbf\u0c82\u0c97\u0cb3\u0cc1",
                    MM: "%d \u0ca4\u0cbf\u0c82\u0c97\u0cb3\u0cc1",
                    y: "\u0c92\u0c82\u0ca6\u0cc1 \u0cb5\u0cb0\u0ccd\u0cb7",
                    yy: "%d \u0cb5\u0cb0\u0ccd\u0cb7",
                },
                preparse: function (e) {
                    return e.replace(
                        /[\u0ce7\u0ce8\u0ce9\u0cea\u0ceb\u0cec\u0ced\u0cee\u0cef\u0ce6]/g,
                        function (e) {
                            return Ns[e];
                        }
                    );
                },
                postformat: function (e) {
                    return e.replace(/\d/g, function (e) {
                        return zs[e];
                    });
                },
                meridiemParse:
                    /\u0cb0\u0cbe\u0ca4\u0ccd\u0cb0\u0cbf|\u0cac\u0cc6\u0cb3\u0cbf\u0c97\u0ccd\u0c97\u0cc6|\u0cae\u0ca7\u0ccd\u0caf\u0cbe\u0cb9\u0ccd\u0ca8|\u0cb8\u0c82\u0c9c\u0cc6/,
                meridiemHour: function (e, a) {
                    return (
                        12 === e && (e = 0),
                        "\u0cb0\u0cbe\u0ca4\u0ccd\u0cb0\u0cbf" === a
                            ? e < 4
                                ? e
                                : e + 12
                            : "\u0cac\u0cc6\u0cb3\u0cbf\u0c97\u0ccd\u0c97\u0cc6" ===
                              a
                            ? e
                            : "\u0cae\u0ca7\u0ccd\u0caf\u0cbe\u0cb9\u0ccd\u0ca8" ===
                              a
                            ? 10 <= e
                                ? e
                                : e + 12
                            : "\u0cb8\u0c82\u0c9c\u0cc6" === a
                            ? e + 12
                            : void 0
                    );
                },
                meridiem: function (e, a, t) {
                    return e < 4
                        ? "\u0cb0\u0cbe\u0ca4\u0ccd\u0cb0\u0cbf"
                        : e < 10
                        ? "\u0cac\u0cc6\u0cb3\u0cbf\u0c97\u0ccd\u0c97\u0cc6"
                        : e < 17
                        ? "\u0cae\u0ca7\u0ccd\u0caf\u0cbe\u0cb9\u0ccd\u0ca8"
                        : e < 20
                        ? "\u0cb8\u0c82\u0c9c\u0cc6"
                        : "\u0cb0\u0cbe\u0ca4\u0ccd\u0cb0\u0cbf";
                },
                dayOfMonthOrdinalParse: /\d{1,2}(\u0ca8\u0cc6\u0cd5)/,
                ordinal: function (e) {
                    return e + "\u0ca8\u0cc6\u0cd5";
                },
                week: { dow: 0, doy: 6 },
            }),
            M.defineLocale("ko", {
                months: "1\uc6d4_2\uc6d4_3\uc6d4_4\uc6d4_5\uc6d4_6\uc6d4_7\uc6d4_8\uc6d4_9\uc6d4_10\uc6d4_11\uc6d4_12\uc6d4".split(
                    "_"
                ),
                monthsShort:
                    "1\uc6d4_2\uc6d4_3\uc6d4_4\uc6d4_5\uc6d4_6\uc6d4_7\uc6d4_8\uc6d4_9\uc6d4_10\uc6d4_11\uc6d4_12\uc6d4".split(
                        "_"
                    ),
                weekdays:
                    "\uc77c\uc694\uc77c_\uc6d4\uc694\uc77c_\ud654\uc694\uc77c_\uc218\uc694\uc77c_\ubaa9\uc694\uc77c_\uae08\uc694\uc77c_\ud1a0\uc694\uc77c".split(
                        "_"
                    ),
                weekdaysShort:
                    "\uc77c_\uc6d4_\ud654_\uc218_\ubaa9_\uae08_\ud1a0".split(
                        "_"
                    ),
                weekdaysMin:
                    "\uc77c_\uc6d4_\ud654_\uc218_\ubaa9_\uae08_\ud1a0".split(
                        "_"
                    ),
                longDateFormat: {
                    LT: "A h:mm",
                    LTS: "A h:mm:ss",
                    L: "YYYY.MM.DD.",
                    LL: "YYYY\ub144 MMMM D\uc77c",
                    LLL: "YYYY\ub144 MMMM D\uc77c A h:mm",
                    LLLL: "YYYY\ub144 MMMM D\uc77c dddd A h:mm",
                    l: "YYYY.MM.DD.",
                    ll: "YYYY\ub144 MMMM D\uc77c",
                    lll: "YYYY\ub144 MMMM D\uc77c A h:mm",
                    llll: "YYYY\ub144 MMMM D\uc77c dddd A h:mm",
                },
                calendar: {
                    sameDay: "\uc624\ub298 LT",
                    nextDay: "\ub0b4\uc77c LT",
                    nextWeek: "dddd LT",
                    lastDay: "\uc5b4\uc81c LT",
                    lastWeek: "\uc9c0\ub09c\uc8fc dddd LT",
                    sameElse: "L",
                },
                relativeTime: {
                    future: "%s \ud6c4",
                    past: "%s \uc804",
                    s: "\uba87 \ucd08",
                    ss: "%d\ucd08",
                    m: "1\ubd84",
                    mm: "%d\ubd84",
                    h: "\ud55c \uc2dc\uac04",
                    hh: "%d\uc2dc\uac04",
                    d: "\ud558\ub8e8",
                    dd: "%d\uc77c",
                    M: "\ud55c \ub2ec",
                    MM: "%d\ub2ec",
                    y: "\uc77c \ub144",
                    yy: "%d\ub144",
                },
                dayOfMonthOrdinalParse: /\d{1,2}(\uc77c|\uc6d4|\uc8fc)/,
                ordinal: function (e, a) {
                    switch (a) {
                        case "d":
                        case "D":
                        case "DDD":
                            return e + "\uc77c";
                        case "M":
                            return e + "\uc6d4";
                        case "w":
                        case "W":
                            return e + "\uc8fc";
                        default:
                            return e;
                    }
                },
                meridiemParse: /\uc624\uc804|\uc624\ud6c4/,
                isPM: function (e) {
                    return "\uc624\ud6c4" === e;
                },
                meridiem: function (e, a, t) {
                    return e < 12 ? "\uc624\uc804" : "\uc624\ud6c4";
                },
            }),
            {
                1: "\u0661",
                2: "\u0662",
                3: "\u0663",
                4: "\u0664",
                5: "\u0665",
                6: "\u0666",
                7: "\u0667",
                8: "\u0668",
                9: "\u0669",
                0: "\u0660",
            }),
        Rs = {
            "\u0661": "1",
            "\u0662": "2",
            "\u0663": "3",
            "\u0664": "4",
            "\u0665": "5",
            "\u0666": "6",
            "\u0667": "7",
            "\u0668": "8",
            "\u0669": "9",
            "\u0660": "0",
        },
        ta = [
            "\u06a9\u0627\u0646\u0648\u0646\u06cc \u062f\u0648\u0648\u06d5\u0645",
            "\u0634\u0648\u0628\u0627\u062a",
            "\u0626\u0627\u0632\u0627\u0631",
            "\u0646\u06cc\u0633\u0627\u0646",
            "\u0626\u0627\u06cc\u0627\u0631",
            "\u062d\u0648\u0632\u06d5\u06cc\u0631\u0627\u0646",
            "\u062a\u06d5\u0645\u0645\u0648\u0632",
            "\u0626\u0627\u0628",
            "\u0626\u06d5\u06cc\u0644\u0648\u0648\u0644",
            "\u062a\u0634\u0631\u06cc\u0646\u06cc \u06cc\u06d5\u0643\u06d5\u0645",
            "\u062a\u0634\u0631\u06cc\u0646\u06cc \u062f\u0648\u0648\u06d5\u0645",
            "\u0643\u0627\u0646\u0648\u0646\u06cc \u06cc\u06d5\u06a9\u06d5\u0645",
        ],
        Cs =
            (M.defineLocale("ku", {
                months: ta,
                monthsShort: ta,
                weekdays:
                    "\u06cc\u0647\u200c\u0643\u0634\u0647\u200c\u0645\u0645\u0647\u200c_\u062f\u0648\u0648\u0634\u0647\u200c\u0645\u0645\u0647\u200c_\u0633\u06ce\u0634\u0647\u200c\u0645\u0645\u0647\u200c_\u0686\u0648\u0627\u0631\u0634\u0647\u200c\u0645\u0645\u0647\u200c_\u067e\u06ce\u0646\u062c\u0634\u0647\u200c\u0645\u0645\u0647\u200c_\u0647\u0647\u200c\u06cc\u0646\u06cc_\u0634\u0647\u200c\u0645\u0645\u0647\u200c".split(
                        "_"
                    ),
                weekdaysShort:
                    "\u06cc\u0647\u200c\u0643\u0634\u0647\u200c\u0645_\u062f\u0648\u0648\u0634\u0647\u200c\u0645_\u0633\u06ce\u0634\u0647\u200c\u0645_\u0686\u0648\u0627\u0631\u0634\u0647\u200c\u0645_\u067e\u06ce\u0646\u062c\u0634\u0647\u200c\u0645_\u0647\u0647\u200c\u06cc\u0646\u06cc_\u0634\u0647\u200c\u0645\u0645\u0647\u200c".split(
                        "_"
                    ),
                weekdaysMin:
                    "\u06cc_\u062f_\u0633_\u0686_\u067e_\u0647_\u0634".split(
                        "_"
                    ),
                weekdaysParseExact: !0,
                longDateFormat: {
                    LT: "HH:mm",
                    LTS: "HH:mm:ss",
                    L: "DD/MM/YYYY",
                    LL: "D MMMM YYYY",
                    LLL: "D MMMM YYYY HH:mm",
                    LLLL: "dddd, D MMMM YYYY HH:mm",
                },
                meridiemParse:
                    /\u0626\u06ce\u0648\u0627\u0631\u0647\u200c|\u0628\u0647\u200c\u06cc\u0627\u0646\u06cc/,
                isPM: function (e) {
                    return /\u0626\u06ce\u0648\u0627\u0631\u0647\u200c/.test(e);
                },
                meridiem: function (e, a, t) {
                    return e < 12
                        ? "\u0628\u0647\u200c\u06cc\u0627\u0646\u06cc"
                        : "\u0626\u06ce\u0648\u0627\u0631\u0647\u200c";
                },
                calendar: {
                    sameDay:
                        "[\u0626\u0647\u200c\u0645\u0631\u06c6 \u0643\u0627\u062a\u0698\u0645\u06ce\u0631] LT",
                    nextDay:
                        "[\u0628\u0647\u200c\u06cc\u0627\u0646\u06cc \u0643\u0627\u062a\u0698\u0645\u06ce\u0631] LT",
                    nextWeek:
                        "dddd [\u0643\u0627\u062a\u0698\u0645\u06ce\u0631] LT",
                    lastDay:
                        "[\u062f\u0648\u06ce\u0646\u06ce \u0643\u0627\u062a\u0698\u0645\u06ce\u0631] LT",
                    lastWeek:
                        "dddd [\u0643\u0627\u062a\u0698\u0645\u06ce\u0631] LT",
                    sameElse: "L",
                },
                relativeTime: {
                    future: "\u0644\u0647\u200c %s",
                    past: "%s",
                    s: "\u0686\u0647\u200c\u0646\u062f \u0686\u0631\u0643\u0647\u200c\u06cc\u0647\u200c\u0643",
                    ss: "\u0686\u0631\u0643\u0647\u200c %d",
                    m: "\u06cc\u0647\u200c\u0643 \u062e\u0648\u0644\u0647\u200c\u0643",
                    mm: "%d \u062e\u0648\u0644\u0647\u200c\u0643",
                    h: "\u06cc\u0647\u200c\u0643 \u0643\u0627\u062a\u0698\u0645\u06ce\u0631",
                    hh: "%d \u0643\u0627\u062a\u0698\u0645\u06ce\u0631",
                    d: "\u06cc\u0647\u200c\u0643 \u0695\u06c6\u0698",
                    dd: "%d \u0695\u06c6\u0698",
                    M: "\u06cc\u0647\u200c\u0643 \u0645\u0627\u0646\u06af",
                    MM: "%d \u0645\u0627\u0646\u06af",
                    y: "\u06cc\u0647\u200c\u0643 \u0633\u0627\u06b5",
                    yy: "%d \u0633\u0627\u06b5",
                },
                preparse: function (e) {
                    return e
                        .replace(
                            /[\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669\u0660]/g,
                            function (e) {
                                return Rs[e];
                            }
                        )
                        .replace(/\u060c/g, ",");
                },
                postformat: function (e) {
                    return e
                        .replace(/\d/g, function (e) {
                            return Js[e];
                        })
                        .replace(/,/g, "\u060c");
                },
                week: { dow: 6, doy: 12 },
            }),
            {
                0: "-\u0447\u04af",
                1: "-\u0447\u0438",
                2: "-\u0447\u0438",
                3: "-\u0447\u04af",
                4: "-\u0447\u04af",
                5: "-\u0447\u0438",
                6: "-\u0447\u044b",
                7: "-\u0447\u0438",
                8: "-\u0447\u0438",
                9: "-\u0447\u0443",
                10: "-\u0447\u0443",
                20: "-\u0447\u044b",
                30: "-\u0447\u0443",
                40: "-\u0447\u044b",
                50: "-\u0447\u04af",
                60: "-\u0447\u044b",
                70: "-\u0447\u0438",
                80: "-\u0447\u0438",
                90: "-\u0447\u0443",
                100: "-\u0447\u04af",
            });
    function Is(e, a, t, s) {
        var n = {
            m: ["eng Minutt", "enger Minutt"],
            h: ["eng Stonn", "enger Stonn"],
            d: ["een Dag", "engem Dag"],
            M: ["ee Mount", "engem Mount"],
            y: ["ee Joer", "engem Joer"],
        };
        return a ? n[t][0] : n[t][1];
    }
    function Us(e) {
        if (((e = parseInt(e, 10)), isNaN(e))) return !1;
        if (e < 0) return !0;
        if (e < 10) return 4 <= e && e <= 7;
        var a;
        if (e < 100) return Us(0 == (a = e % 10) ? e / 10 : a);
        if (e < 1e4) {
            for (; 10 <= e; ) e /= 10;
            return Us(e);
        }
        return Us((e /= 1e3));
    }
    M.defineLocale("ky", {
        months: "\u044f\u043d\u0432\u0430\u0440\u044c_\u0444\u0435\u0432\u0440\u0430\u043b\u044c_\u043c\u0430\u0440\u0442_\u0430\u043f\u0440\u0435\u043b\u044c_\u043c\u0430\u0439_\u0438\u044e\u043d\u044c_\u0438\u044e\u043b\u044c_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043d\u0442\u044f\u0431\u0440\u044c_\u043e\u043a\u0442\u044f\u0431\u0440\u044c_\u043d\u043e\u044f\u0431\u0440\u044c_\u0434\u0435\u043a\u0430\u0431\u0440\u044c".split(
            "_"
        ),
        monthsShort:
            "\u044f\u043d\u0432_\u0444\u0435\u0432_\u043c\u0430\u0440\u0442_\u0430\u043f\u0440_\u043c\u0430\u0439_\u0438\u044e\u043d\u044c_\u0438\u044e\u043b\u044c_\u0430\u0432\u0433_\u0441\u0435\u043d_\u043e\u043a\u0442_\u043d\u043e\u044f_\u0434\u0435\u043a".split(
                "_"
            ),
        weekdays:
            "\u0416\u0435\u043a\u0448\u0435\u043c\u0431\u0438_\u0414\u04af\u0439\u0448\u04e9\u043c\u0431\u04af_\u0428\u0435\u0439\u0448\u0435\u043c\u0431\u0438_\u0428\u0430\u0440\u0448\u0435\u043c\u0431\u0438_\u0411\u0435\u0439\u0448\u0435\u043c\u0431\u0438_\u0416\u0443\u043c\u0430_\u0418\u0448\u0435\u043c\u0431\u0438".split(
                "_"
            ),
        weekdaysShort:
            "\u0416\u0435\u043a_\u0414\u04af\u0439_\u0428\u0435\u0439_\u0428\u0430\u0440_\u0411\u0435\u0439_\u0416\u0443\u043c_\u0418\u0448\u0435".split(
                "_"
            ),
        weekdaysMin:
            "\u0416\u043a_\u0414\u0439_\u0428\u0439_\u0428\u0440_\u0411\u0439_\u0416\u043c_\u0418\u0448".split(
                "_"
            ),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm",
        },
        calendar: {
            sameDay:
                "[\u0411\u04af\u0433\u04af\u043d \u0441\u0430\u0430\u0442] LT",
            nextDay:
                "[\u042d\u0440\u0442\u0435\u04a3 \u0441\u0430\u0430\u0442] LT",
            nextWeek: "dddd [\u0441\u0430\u0430\u0442] LT",
            lastDay:
                "[\u041a\u0435\u0447\u044d\u044d \u0441\u0430\u0430\u0442] LT",
            lastWeek:
                "[\u04e8\u0442\u043a\u04e9\u043d \u0430\u043f\u0442\u0430\u043d\u044b\u043d] dddd [\u043a\u04af\u043d\u04af] [\u0441\u0430\u0430\u0442] LT",
            sameElse: "L",
        },
        relativeTime: {
            future: "%s \u0438\u0447\u0438\u043d\u0434\u0435",
            past: "%s \u043c\u0443\u0440\u0443\u043d",
            s: "\u0431\u0438\u0440\u043d\u0435\u0447\u0435 \u0441\u0435\u043a\u0443\u043d\u0434",
            ss: "%d \u0441\u0435\u043a\u0443\u043d\u0434",
            m: "\u0431\u0438\u0440 \u043c\u04af\u043d\u04e9\u0442",
            mm: "%d \u043c\u04af\u043d\u04e9\u0442",
            h: "\u0431\u0438\u0440 \u0441\u0430\u0430\u0442",
            hh: "%d \u0441\u0430\u0430\u0442",
            d: "\u0431\u0438\u0440 \u043a\u04af\u043d",
            dd: "%d \u043a\u04af\u043d",
            M: "\u0431\u0438\u0440 \u0430\u0439",
            MM: "%d \u0430\u0439",
            y: "\u0431\u0438\u0440 \u0436\u044b\u043b",
            yy: "%d \u0436\u044b\u043b",
        },
        dayOfMonthOrdinalParse:
            /\d{1,2}-(\u0447\u0438|\u0447\u044b|\u0447\u04af|\u0447\u0443)/,
        ordinal: function (e) {
            return e + (Cs[e] || Cs[e % 10] || Cs[100 <= e ? 100 : null]);
        },
        week: { dow: 1, doy: 7 },
    }),
        M.defineLocale("lb", {
            months: "Januar_Februar_M\xe4erz_Abr\xebll_Mee_Juni_Juli_August_September_Oktober_November_Dezember".split(
                "_"
            ),
            monthsShort:
                "Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.".split(
                    "_"
                ),
            monthsParseExact: !0,
            weekdays:
                "Sonndeg_M\xe9indeg_D\xebnschdeg_M\xebttwoch_Donneschdeg_Freideg_Samschdeg".split(
                    "_"
                ),
            weekdaysShort: "So._M\xe9._D\xeb._M\xeb._Do._Fr._Sa.".split("_"),
            weekdaysMin: "So_M\xe9_D\xeb_M\xeb_Do_Fr_Sa".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "H:mm [Auer]",
                LTS: "H:mm:ss [Auer]",
                L: "DD.MM.YYYY",
                LL: "D. MMMM YYYY",
                LLL: "D. MMMM YYYY H:mm [Auer]",
                LLLL: "dddd, D. MMMM YYYY H:mm [Auer]",
            },
            calendar: {
                sameDay: "[Haut um] LT",
                sameElse: "L",
                nextDay: "[Muer um] LT",
                nextWeek: "dddd [um] LT",
                lastDay: "[G\xebschter um] LT",
                lastWeek: function () {
                    switch (this.day()) {
                        case 2:
                        case 4:
                            return "[Leschten] dddd [um] LT";
                        default:
                            return "[Leschte] dddd [um] LT";
                    }
                },
            },
            relativeTime: {
                future: function (e) {
                    return Us(e.substr(0, e.indexOf(" ")))
                        ? "a " + e
                        : "an " + e;
                },
                past: function (e) {
                    return Us(e.substr(0, e.indexOf(" ")))
                        ? "viru " + e
                        : "virun " + e;
                },
                s: "e puer Sekonnen",
                ss: "%d Sekonnen",
                m: Is,
                mm: "%d Minutten",
                h: Is,
                hh: "%d Stonnen",
                d: Is,
                dd: "%d Deeg",
                M: Is,
                MM: "%d M\xe9int",
                y: Is,
                yy: "%d Joer",
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: { dow: 1, doy: 4 },
        }),
        M.defineLocale("lo", {
            months: "\u0ea1\u0eb1\u0e87\u0e81\u0ead\u0e99_\u0e81\u0eb8\u0ea1\u0e9e\u0eb2_\u0ea1\u0eb5\u0e99\u0eb2_\u0ec0\u0ea1\u0eaa\u0eb2_\u0e9e\u0eb6\u0e94\u0eaa\u0eb0\u0e9e\u0eb2_\u0ea1\u0eb4\u0e96\u0eb8\u0e99\u0eb2_\u0e81\u0ecd\u0ea5\u0eb0\u0e81\u0ebb\u0e94_\u0eaa\u0eb4\u0e87\u0eab\u0eb2_\u0e81\u0eb1\u0e99\u0e8d\u0eb2_\u0e95\u0eb8\u0ea5\u0eb2_\u0e9e\u0eb0\u0e88\u0eb4\u0e81_\u0e97\u0eb1\u0e99\u0ea7\u0eb2".split(
                "_"
            ),
            monthsShort:
                "\u0ea1\u0eb1\u0e87\u0e81\u0ead\u0e99_\u0e81\u0eb8\u0ea1\u0e9e\u0eb2_\u0ea1\u0eb5\u0e99\u0eb2_\u0ec0\u0ea1\u0eaa\u0eb2_\u0e9e\u0eb6\u0e94\u0eaa\u0eb0\u0e9e\u0eb2_\u0ea1\u0eb4\u0e96\u0eb8\u0e99\u0eb2_\u0e81\u0ecd\u0ea5\u0eb0\u0e81\u0ebb\u0e94_\u0eaa\u0eb4\u0e87\u0eab\u0eb2_\u0e81\u0eb1\u0e99\u0e8d\u0eb2_\u0e95\u0eb8\u0ea5\u0eb2_\u0e9e\u0eb0\u0e88\u0eb4\u0e81_\u0e97\u0eb1\u0e99\u0ea7\u0eb2".split(
                    "_"
                ),
            weekdays:
                "\u0ead\u0eb2\u0e97\u0eb4\u0e94_\u0e88\u0eb1\u0e99_\u0ead\u0eb1\u0e87\u0e84\u0eb2\u0e99_\u0e9e\u0eb8\u0e94_\u0e9e\u0eb0\u0eab\u0eb1\u0e94_\u0eaa\u0eb8\u0e81_\u0ec0\u0eaa\u0ebb\u0eb2".split(
                    "_"
                ),
            weekdaysShort:
                "\u0e97\u0eb4\u0e94_\u0e88\u0eb1\u0e99_\u0ead\u0eb1\u0e87\u0e84\u0eb2\u0e99_\u0e9e\u0eb8\u0e94_\u0e9e\u0eb0\u0eab\u0eb1\u0e94_\u0eaa\u0eb8\u0e81_\u0ec0\u0eaa\u0ebb\u0eb2".split(
                    "_"
                ),
            weekdaysMin:
                "\u0e97_\u0e88_\u0ead\u0e84_\u0e9e_\u0e9e\u0eab_\u0eaa\u0e81_\u0eaa".split(
                    "_"
                ),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "\u0ea7\u0eb1\u0e99dddd D MMMM YYYY HH:mm",
            },
            meridiemParse:
                /\u0e95\u0ead\u0e99\u0ec0\u0e8a\u0ebb\u0ec9\u0eb2|\u0e95\u0ead\u0e99\u0ec1\u0ea5\u0e87/,
            isPM: function (e) {
                return "\u0e95\u0ead\u0e99\u0ec1\u0ea5\u0e87" === e;
            },
            meridiem: function (e, a, t) {
                return e < 12
                    ? "\u0e95\u0ead\u0e99\u0ec0\u0e8a\u0ebb\u0ec9\u0eb2"
                    : "\u0e95\u0ead\u0e99\u0ec1\u0ea5\u0e87";
            },
            calendar: {
                sameDay:
                    "[\u0ea1\u0eb7\u0ec9\u0e99\u0eb5\u0ec9\u0ec0\u0ea7\u0ea5\u0eb2] LT",
                nextDay:
                    "[\u0ea1\u0eb7\u0ec9\u0ead\u0eb7\u0ec8\u0e99\u0ec0\u0ea7\u0ea5\u0eb2] LT",
                nextWeek:
                    "[\u0ea7\u0eb1\u0e99]dddd[\u0edc\u0ec9\u0eb2\u0ec0\u0ea7\u0ea5\u0eb2] LT",
                lastDay:
                    "[\u0ea1\u0eb7\u0ec9\u0ea7\u0eb2\u0e99\u0e99\u0eb5\u0ec9\u0ec0\u0ea7\u0ea5\u0eb2] LT",
                lastWeek:
                    "[\u0ea7\u0eb1\u0e99]dddd[\u0ec1\u0ea5\u0ec9\u0ea7\u0e99\u0eb5\u0ec9\u0ec0\u0ea7\u0ea5\u0eb2] LT",
                sameElse: "L",
            },
            relativeTime: {
                future: "\u0ead\u0eb5\u0e81 %s",
                past: "%s\u0e9c\u0ec8\u0eb2\u0e99\u0ea1\u0eb2",
                s: "\u0e9a\u0ecd\u0ec8\u0ec0\u0e97\u0ebb\u0ec8\u0eb2\u0ec3\u0e94\u0ea7\u0eb4\u0e99\u0eb2\u0e97\u0eb5",
                ss: "%d \u0ea7\u0eb4\u0e99\u0eb2\u0e97\u0eb5",
                m: "1 \u0e99\u0eb2\u0e97\u0eb5",
                mm: "%d \u0e99\u0eb2\u0e97\u0eb5",
                h: "1 \u0e8a\u0ebb\u0ec8\u0ea7\u0ec2\u0ea1\u0e87",
                hh: "%d \u0e8a\u0ebb\u0ec8\u0ea7\u0ec2\u0ea1\u0e87",
                d: "1 \u0ea1\u0eb7\u0ec9",
                dd: "%d \u0ea1\u0eb7\u0ec9",
                M: "1 \u0ec0\u0e94\u0eb7\u0ead\u0e99",
                MM: "%d \u0ec0\u0e94\u0eb7\u0ead\u0e99",
                y: "1 \u0e9b\u0eb5",
                yy: "%d \u0e9b\u0eb5",
            },
            dayOfMonthOrdinalParse: /(\u0e97\u0eb5\u0ec8)\d{1,2}/,
            ordinal: function (e) {
                return "\u0e97\u0eb5\u0ec8" + e;
            },
        });
    var Gs = {
        ss: "sekund\u0117_sekund\u017ei\u0173_sekundes",
        m: "minut\u0117_minut\u0117s_minut\u0119",
        mm: "minut\u0117s_minu\u010di\u0173_minutes",
        h: "valanda_valandos_valand\u0105",
        hh: "valandos_valand\u0173_valandas",
        d: "diena_dienos_dien\u0105",
        dd: "dienos_dien\u0173_dienas",
        M: "m\u0117nuo_m\u0117nesio_m\u0117nes\u012f",
        MM: "m\u0117nesiai_m\u0117nesi\u0173_m\u0117nesius",
        y: "metai_met\u0173_metus",
        yy: "metai_met\u0173_metus",
    };
    function Vs(e, a, t, s) {
        return a ? Ks(t)[0] : s ? Ks(t)[1] : Ks(t)[2];
    }
    function Bs(e) {
        return e % 10 == 0 || (10 < e && e < 20);
    }
    function Ks(e) {
        return Gs[e].split("_");
    }
    function qs(e, a, t, s) {
        var n = e + " ";
        return 1 === e
            ? n + Vs(0, a, t[0], s)
            : a
            ? n + (Bs(e) ? Ks(t)[1] : Ks(t)[0])
            : s
            ? n + Ks(t)[1]
            : n + (Bs(e) ? Ks(t)[1] : Ks(t)[2]);
    }
    M.defineLocale("lt", {
        months: {
            format: "sausio_vasario_kovo_baland\u017eio_gegu\u017e\u0117s_bir\u017eelio_liepos_rugpj\u016b\u010dio_rugs\u0117jo_spalio_lapkri\u010dio_gruod\u017eio".split(
                "_"
            ),
            standalone:
                "sausis_vasaris_kovas_balandis_gegu\u017e\u0117_bir\u017eelis_liepa_rugpj\u016btis_rugs\u0117jis_spalis_lapkritis_gruodis".split(
                    "_"
                ),
            isFormat:
                /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
        },
        monthsShort: "sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd".split(
            "_"
        ),
        weekdays: {
            format: "sekmadien\u012f_pirmadien\u012f_antradien\u012f_tre\u010diadien\u012f_ketvirtadien\u012f_penktadien\u012f_\u0161e\u0161tadien\u012f".split(
                "_"
            ),
            standalone:
                "sekmadienis_pirmadienis_antradienis_tre\u010diadienis_ketvirtadienis_penktadienis_\u0161e\u0161tadienis".split(
                    "_"
                ),
            isFormat: /dddd HH:mm/,
        },
        weekdaysShort: "Sek_Pir_Ant_Tre_Ket_Pen_\u0160e\u0161".split("_"),
        weekdaysMin: "S_P_A_T_K_Pn_\u0160".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "YYYY-MM-DD",
            LL: "YYYY [m.] MMMM D [d.]",
            LLL: "YYYY [m.] MMMM D [d.], HH:mm [val.]",
            LLLL: "YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]",
            l: "YYYY-MM-DD",
            ll: "YYYY [m.] MMMM D [d.]",
            lll: "YYYY [m.] MMMM D [d.], HH:mm [val.]",
            llll: "YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]",
        },
        calendar: {
            sameDay: "[\u0160iandien] LT",
            nextDay: "[Rytoj] LT",
            nextWeek: "dddd LT",
            lastDay: "[Vakar] LT",
            lastWeek: "[Pra\u0117jus\u012f] dddd LT",
            sameElse: "L",
        },
        relativeTime: {
            future: "po %s",
            past: "prie\u0161 %s",
            s: function (e, a, t, s) {
                return a
                    ? "kelios sekund\u0117s"
                    : s
                    ? "keli\u0173 sekund\u017ei\u0173"
                    : "kelias sekundes";
            },
            ss: qs,
            m: Vs,
            mm: qs,
            h: Vs,
            hh: qs,
            d: Vs,
            dd: qs,
            M: Vs,
            MM: qs,
            y: Vs,
            yy: qs,
        },
        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
        ordinal: function (e) {
            return e + "-oji";
        },
        week: { dow: 1, doy: 4 },
    });
    var Zs = {
        ss: "sekundes_sekund\u0113m_sekunde_sekundes".split("_"),
        m: "min\u016btes_min\u016bt\u0113m_min\u016bte_min\u016btes".split("_"),
        mm: "min\u016btes_min\u016bt\u0113m_min\u016bte_min\u016btes".split(
            "_"
        ),
        h: "stundas_stund\u0101m_stunda_stundas".split("_"),
        hh: "stundas_stund\u0101m_stunda_stundas".split("_"),
        d: "dienas_dien\u0101m_diena_dienas".split("_"),
        dd: "dienas_dien\u0101m_diena_dienas".split("_"),
        M: "m\u0113ne\u0161a_m\u0113ne\u0161iem_m\u0113nesis_m\u0113ne\u0161i".split(
            "_"
        ),
        MM: "m\u0113ne\u0161a_m\u0113ne\u0161iem_m\u0113nesis_m\u0113ne\u0161i".split(
            "_"
        ),
        y: "gada_gadiem_gads_gadi".split("_"),
        yy: "gada_gadiem_gads_gadi".split("_"),
    };
    function $s(e, a, t) {
        return t
            ? a % 10 == 1 && a % 100 != 11
                ? e[2]
                : e[3]
            : a % 10 == 1 && a % 100 != 11
            ? e[0]
            : e[1];
    }
    function Qs(e, a, t) {
        return e + " " + $s(Zs[t], e, a);
    }
    function Xs(e, a, t) {
        return $s(Zs[t], e, a);
    }
    M.defineLocale("lv", {
        months: "janv\u0101ris_febru\u0101ris_marts_apr\u012blis_maijs_j\u016bnijs_j\u016blijs_augusts_septembris_oktobris_novembris_decembris".split(
            "_"
        ),
        monthsShort:
            "jan_feb_mar_apr_mai_j\u016bn_j\u016bl_aug_sep_okt_nov_dec".split(
                "_"
            ),
        weekdays:
            "sv\u0113tdiena_pirmdiena_otrdiena_tre\u0161diena_ceturtdiena_piektdiena_sestdiena".split(
                "_"
            ),
        weekdaysShort: "Sv_P_O_T_C_Pk_S".split("_"),
        weekdaysMin: "Sv_P_O_T_C_Pk_S".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY.",
            LL: "YYYY. [gada] D. MMMM",
            LLL: "YYYY. [gada] D. MMMM, HH:mm",
            LLLL: "YYYY. [gada] D. MMMM, dddd, HH:mm",
        },
        calendar: {
            sameDay: "[\u0160odien pulksten] LT",
            nextDay: "[R\u012bt pulksten] LT",
            nextWeek: "dddd [pulksten] LT",
            lastDay: "[Vakar pulksten] LT",
            lastWeek: "[Pag\u0101ju\u0161\u0101] dddd [pulksten] LT",
            sameElse: "L",
        },
        relativeTime: {
            future: "p\u0113c %s",
            past: "pirms %s",
            s: function (e, a) {
                return a
                    ? "da\u017eas sekundes"
                    : "da\u017e\u0101m sekund\u0113m";
            },
            ss: Qs,
            m: Xs,
            mm: Qs,
            h: Xs,
            hh: Qs,
            d: Xs,
            dd: Qs,
            M: Xs,
            MM: Qs,
            y: Xs,
            yy: Qs,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: { dow: 1, doy: 4 },
    });
    var en = {
        words: {
            ss: ["sekund", "sekunda", "sekundi"],
            m: ["jedan minut", "jednog minuta"],
            mm: ["minut", "minuta", "minuta"],
            h: ["jedan sat", "jednog sata"],
            hh: ["sat", "sata", "sati"],
            dd: ["dan", "dana", "dana"],
            MM: ["mjesec", "mjeseca", "mjeseci"],
            yy: ["godina", "godine", "godina"],
        },
        correctGrammaticalCase: function (e, a) {
            return 1 === e ? a[0] : 2 <= e && e <= 4 ? a[1] : a[2];
        },
        translate: function (e, a, t) {
            var s = en.words[t];
            return 1 === t.length
                ? a
                    ? s[0]
                    : s[1]
                : e + " " + en.correctGrammaticalCase(e, s);
        },
    };
    function an(e, a, t, s) {
        switch (t) {
            case "s":
                return a
                    ? "\u0445\u044d\u0434\u0445\u044d\u043d \u0441\u0435\u043a\u0443\u043d\u0434"
                    : "\u0445\u044d\u0434\u0445\u044d\u043d \u0441\u0435\u043a\u0443\u043d\u0434\u044b\u043d";
            case "ss":
                return (
                    e +
                    (a
                        ? " \u0441\u0435\u043a\u0443\u043d\u0434"
                        : " \u0441\u0435\u043a\u0443\u043d\u0434\u044b\u043d")
                );
            case "m":
            case "mm":
                return (
                    e +
                    (a
                        ? " \u043c\u0438\u043d\u0443\u0442"
                        : " \u043c\u0438\u043d\u0443\u0442\u044b\u043d")
                );
            case "h":
            case "hh":
                return (
                    e +
                    (a
                        ? " \u0446\u0430\u0433"
                        : " \u0446\u0430\u0433\u0438\u0439\u043d")
                );
            case "d":
            case "dd":
                return (
                    e +
                    (a
                        ? " \u04e9\u0434\u04e9\u0440"
                        : " \u04e9\u0434\u0440\u0438\u0439\u043d")
                );
            case "M":
            case "MM":
                return (
                    e +
                    (a
                        ? " \u0441\u0430\u0440"
                        : " \u0441\u0430\u0440\u044b\u043d")
                );
            case "y":
            case "yy":
                return (
                    e +
                    (a
                        ? " \u0436\u0438\u043b"
                        : " \u0436\u0438\u043b\u0438\u0439\u043d")
                );
            default:
                return e;
        }
    }
    M.defineLocale("me", {
        months: "januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar".split(
            "_"
        ),
        monthsShort:
            "jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.".split(
                "_"
            ),
        monthsParseExact: !0,
        weekdays:
            "nedjelja_ponedjeljak_utorak_srijeda_\u010detvrtak_petak_subota".split(
                "_"
            ),
        weekdaysShort: "ned._pon._uto._sri._\u010det._pet._sub.".split("_"),
        weekdaysMin: "ne_po_ut_sr_\u010de_pe_su".split("_"),
        weekdaysParseExact: !0,
        longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D. MMMM YYYY",
            LLL: "D. MMMM YYYY H:mm",
            LLLL: "dddd, D. MMMM YYYY H:mm",
        },
        calendar: {
            sameDay: "[danas u] LT",
            nextDay: "[sjutra u] LT",
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return "[u] [nedjelju] [u] LT";
                    case 3:
                        return "[u] [srijedu] [u] LT";
                    case 6:
                        return "[u] [subotu] [u] LT";
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return "[u] dddd [u] LT";
                }
            },
            lastDay: "[ju\u010de u] LT",
            lastWeek: function () {
                return [
                    "[pro\u0161le] [nedjelje] [u] LT",
                    "[pro\u0161log] [ponedjeljka] [u] LT",
                    "[pro\u0161log] [utorka] [u] LT",
                    "[pro\u0161le] [srijede] [u] LT",
                    "[pro\u0161log] [\u010detvrtka] [u] LT",
                    "[pro\u0161log] [petka] [u] LT",
                    "[pro\u0161le] [subote] [u] LT",
                ][this.day()];
            },
            sameElse: "L",
        },
        relativeTime: {
            future: "za %s",
            past: "prije %s",
            s: "nekoliko sekundi",
            ss: en.translate,
            m: en.translate,
            mm: en.translate,
            h: en.translate,
            hh: en.translate,
            d: "dan",
            dd: en.translate,
            M: "mjesec",
            MM: en.translate,
            y: "godinu",
            yy: en.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: { dow: 1, doy: 7 },
    }),
        M.defineLocale("mi", {
            months: "Kohi-t\u0101te_Hui-tanguru_Pout\u016b-te-rangi_Paenga-wh\u0101wh\u0101_Haratua_Pipiri_H\u014dngoingoi_Here-turi-k\u014dk\u0101_Mahuru_Whiringa-\u0101-nuku_Whiringa-\u0101-rangi_Hakihea".split(
                "_"
            ),
            monthsShort:
                "Kohi_Hui_Pou_Pae_Hara_Pipi_H\u014dngoi_Here_Mahu_Whi-nu_Whi-ra_Haki".split(
                    "_"
                ),
            monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
            monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
            monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
            monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
            weekdays:
                "R\u0101tapu_Mane_T\u016brei_Wenerei_T\u0101ite_Paraire_H\u0101tarei".split(
                    "_"
                ),
            weekdaysShort: "Ta_Ma_T\u016b_We_T\u0101i_Pa_H\u0101".split("_"),
            weekdaysMin: "Ta_Ma_T\u016b_We_T\u0101i_Pa_H\u0101".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY [i] HH:mm",
                LLLL: "dddd, D MMMM YYYY [i] HH:mm",
            },
            calendar: {
                sameDay: "[i teie mahana, i] LT",
                nextDay: "[apopo i] LT",
                nextWeek: "dddd [i] LT",
                lastDay: "[inanahi i] LT",
                lastWeek: "dddd [whakamutunga i] LT",
                sameElse: "L",
            },
            relativeTime: {
                future: "i roto i %s",
                past: "%s i mua",
                s: "te h\u0113kona ruarua",
                ss: "%d h\u0113kona",
                m: "he meneti",
                mm: "%d meneti",
                h: "te haora",
                hh: "%d haora",
                d: "he ra",
                dd: "%d ra",
                M: "he marama",
                MM: "%d marama",
                y: "he tau",
                yy: "%d tau",
            },
            dayOfMonthOrdinalParse: /\d{1,2}\xba/,
            ordinal: "%d\xba",
            week: { dow: 1, doy: 4 },
        }),
        M.defineLocale("mk", {
            months: "\u0458\u0430\u043d\u0443\u0430\u0440\u0438_\u0444\u0435\u0432\u0440\u0443\u0430\u0440\u0438_\u043c\u0430\u0440\u0442_\u0430\u043f\u0440\u0438\u043b_\u043c\u0430\u0458_\u0458\u0443\u043d\u0438_\u0458\u0443\u043b\u0438_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043f\u0442\u0435\u043c\u0432\u0440\u0438_\u043e\u043a\u0442\u043e\u043c\u0432\u0440\u0438_\u043d\u043e\u0435\u043c\u0432\u0440\u0438_\u0434\u0435\u043a\u0435\u043c\u0432\u0440\u0438".split(
                "_"
            ),
            monthsShort:
                "\u0458\u0430\u043d_\u0444\u0435\u0432_\u043c\u0430\u0440_\u0430\u043f\u0440_\u043c\u0430\u0458_\u0458\u0443\u043d_\u0458\u0443\u043b_\u0430\u0432\u0433_\u0441\u0435\u043f_\u043e\u043a\u0442_\u043d\u043e\u0435_\u0434\u0435\u043a".split(
                    "_"
                ),
            weekdays:
                "\u043d\u0435\u0434\u0435\u043b\u0430_\u043f\u043e\u043d\u0435\u0434\u0435\u043b\u043d\u0438\u043a_\u0432\u0442\u043e\u0440\u043d\u0438\u043a_\u0441\u0440\u0435\u0434\u0430_\u0447\u0435\u0442\u0432\u0440\u0442\u043e\u043a_\u043f\u0435\u0442\u043e\u043a_\u0441\u0430\u0431\u043e\u0442\u0430".split(
                    "_"
                ),
            weekdaysShort:
                "\u043d\u0435\u0434_\u043f\u043e\u043d_\u0432\u0442\u043e_\u0441\u0440\u0435_\u0447\u0435\u0442_\u043f\u0435\u0442_\u0441\u0430\u0431".split(
                    "_"
                ),
            weekdaysMin:
                "\u043de_\u043fo_\u0432\u0442_\u0441\u0440_\u0447\u0435_\u043f\u0435_\u0441a".split(
                    "_"
                ),
            longDateFormat: {
                LT: "H:mm",
                LTS: "H:mm:ss",
                L: "D.MM.YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY H:mm",
                LLLL: "dddd, D MMMM YYYY H:mm",
            },
            calendar: {
                sameDay: "[\u0414\u0435\u043d\u0435\u0441 \u0432\u043e] LT",
                nextDay: "[\u0423\u0442\u0440\u0435 \u0432\u043e] LT",
                nextWeek: "[\u0412\u043e] dddd [\u0432\u043e] LT",
                lastDay: "[\u0412\u0447\u0435\u0440\u0430 \u0432\u043e] LT",
                lastWeek: function () {
                    switch (this.day()) {
                        case 0:
                        case 3:
                        case 6:
                            return "[\u0418\u0437\u043c\u0438\u043d\u0430\u0442\u0430\u0442\u0430] dddd [\u0432\u043e] LT";
                        case 1:
                        case 2:
                        case 4:
                        case 5:
                            return "[\u0418\u0437\u043c\u0438\u043d\u0430\u0442\u0438\u043e\u0442] dddd [\u0432\u043e] LT";
                    }
                },
                sameElse: "L",
            },
            relativeTime: {
                future: "\u0437\u0430 %s",
                past: "\u043f\u0440\u0435\u0434 %s",
                s: "\u043d\u0435\u043a\u043e\u043b\u043a\u0443 \u0441\u0435\u043a\u0443\u043d\u0434\u0438",
                ss: "%d \u0441\u0435\u043a\u0443\u043d\u0434\u0438",
                m: "\u0435\u0434\u043d\u0430 \u043c\u0438\u043d\u0443\u0442\u0430",
                mm: "%d \u043c\u0438\u043d\u0443\u0442\u0438",
                h: "\u0435\u0434\u0435\u043d \u0447\u0430\u0441",
                hh: "%d \u0447\u0430\u0441\u0430",
                d: "\u0435\u0434\u0435\u043d \u0434\u0435\u043d",
                dd: "%d \u0434\u0435\u043d\u0430",
                M: "\u0435\u0434\u0435\u043d \u043c\u0435\u0441\u0435\u0446",
                MM: "%d \u043c\u0435\u0441\u0435\u0446\u0438",
                y: "\u0435\u0434\u043d\u0430 \u0433\u043e\u0434\u0438\u043d\u0430",
                yy: "%d \u0433\u043e\u0434\u0438\u043d\u0438",
            },
            dayOfMonthOrdinalParse:
                /\d{1,2}-(\u0435\u0432|\u0435\u043d|\u0442\u0438|\u0432\u0438|\u0440\u0438|\u043c\u0438)/,
            ordinal: function (e) {
                var a = e % 10,
                    t = e % 100;
                return 0 === e
                    ? e + "-\u0435\u0432"
                    : 0 == t
                    ? e + "-\u0435\u043d"
                    : 10 < t && t < 20
                    ? e + "-\u0442\u0438"
                    : 1 == a
                    ? e + "-\u0432\u0438"
                    : 2 == a
                    ? e + "-\u0440\u0438"
                    : 7 == a || 8 == a
                    ? e + "-\u043c\u0438"
                    : e + "-\u0442\u0438";
            },
            week: { dow: 1, doy: 7 },
        }),
        M.defineLocale("ml", {
            months: "\u0d1c\u0d28\u0d41\u0d35\u0d30\u0d3f_\u0d2b\u0d46\u0d2c\u0d4d\u0d30\u0d41\u0d35\u0d30\u0d3f_\u0d2e\u0d3e\u0d7c\u0d1a\u0d4d\u0d1a\u0d4d_\u0d0f\u0d2a\u0d4d\u0d30\u0d3f\u0d7d_\u0d2e\u0d47\u0d2f\u0d4d_\u0d1c\u0d42\u0d7a_\u0d1c\u0d42\u0d32\u0d48_\u0d13\u0d17\u0d38\u0d4d\u0d31\u0d4d\u0d31\u0d4d_\u0d38\u0d46\u0d2a\u0d4d\u0d31\u0d4d\u0d31\u0d02\u0d2c\u0d7c_\u0d12\u0d15\u0d4d\u0d1f\u0d4b\u0d2c\u0d7c_\u0d28\u0d35\u0d02\u0d2c\u0d7c_\u0d21\u0d3f\u0d38\u0d02\u0d2c\u0d7c".split(
                "_"
            ),
            monthsShort:
                "\u0d1c\u0d28\u0d41._\u0d2b\u0d46\u0d2c\u0d4d\u0d30\u0d41._\u0d2e\u0d3e\u0d7c._\u0d0f\u0d2a\u0d4d\u0d30\u0d3f._\u0d2e\u0d47\u0d2f\u0d4d_\u0d1c\u0d42\u0d7a_\u0d1c\u0d42\u0d32\u0d48._\u0d13\u0d17._\u0d38\u0d46\u0d2a\u0d4d\u0d31\u0d4d\u0d31._\u0d12\u0d15\u0d4d\u0d1f\u0d4b._\u0d28\u0d35\u0d02._\u0d21\u0d3f\u0d38\u0d02.".split(
                    "_"
                ),
            monthsParseExact: !0,
            weekdays:
                "\u0d1e\u0d3e\u0d2f\u0d31\u0d3e\u0d34\u0d4d\u0d1a_\u0d24\u0d3f\u0d19\u0d4d\u0d15\u0d33\u0d3e\u0d34\u0d4d\u0d1a_\u0d1a\u0d4a\u0d35\u0d4d\u0d35\u0d3e\u0d34\u0d4d\u0d1a_\u0d2c\u0d41\u0d27\u0d28\u0d3e\u0d34\u0d4d\u0d1a_\u0d35\u0d4d\u0d2f\u0d3e\u0d34\u0d3e\u0d34\u0d4d\u0d1a_\u0d35\u0d46\u0d33\u0d4d\u0d33\u0d3f\u0d2f\u0d3e\u0d34\u0d4d\u0d1a_\u0d36\u0d28\u0d3f\u0d2f\u0d3e\u0d34\u0d4d\u0d1a".split(
                    "_"
                ),
            weekdaysShort:
                "\u0d1e\u0d3e\u0d2f\u0d7c_\u0d24\u0d3f\u0d19\u0d4d\u0d15\u0d7e_\u0d1a\u0d4a\u0d35\u0d4d\u0d35_\u0d2c\u0d41\u0d27\u0d7b_\u0d35\u0d4d\u0d2f\u0d3e\u0d34\u0d02_\u0d35\u0d46\u0d33\u0d4d\u0d33\u0d3f_\u0d36\u0d28\u0d3f".split(
                    "_"
                ),
            weekdaysMin:
                "\u0d1e\u0d3e_\u0d24\u0d3f_\u0d1a\u0d4a_\u0d2c\u0d41_\u0d35\u0d4d\u0d2f\u0d3e_\u0d35\u0d46_\u0d36".split(
                    "_"
                ),
            longDateFormat: {
                LT: "A h:mm -\u0d28\u0d41",
                LTS: "A h:mm:ss -\u0d28\u0d41",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY, A h:mm -\u0d28\u0d41",
                LLLL: "dddd, D MMMM YYYY, A h:mm -\u0d28\u0d41",
            },
            calendar: {
                sameDay: "[\u0d07\u0d28\u0d4d\u0d28\u0d4d] LT",
                nextDay: "[\u0d28\u0d3e\u0d33\u0d46] LT",
                nextWeek: "dddd, LT",
                lastDay: "[\u0d07\u0d28\u0d4d\u0d28\u0d32\u0d46] LT",
                lastWeek: "[\u0d15\u0d34\u0d3f\u0d1e\u0d4d\u0d1e] dddd, LT",
                sameElse: "L",
            },
            relativeTime: {
                future: "%s \u0d15\u0d34\u0d3f\u0d1e\u0d4d\u0d1e\u0d4d",
                past: "%s \u0d2e\u0d41\u0d7b\u0d2a\u0d4d",
                s: "\u0d05\u0d7d\u0d2a \u0d28\u0d3f\u0d2e\u0d3f\u0d37\u0d19\u0d4d\u0d19\u0d7e",
                ss: "%d \u0d38\u0d46\u0d15\u0d4d\u0d15\u0d7b\u0d21\u0d4d",
                m: "\u0d12\u0d30\u0d41 \u0d2e\u0d3f\u0d28\u0d3f\u0d31\u0d4d\u0d31\u0d4d",
                mm: "%d \u0d2e\u0d3f\u0d28\u0d3f\u0d31\u0d4d\u0d31\u0d4d",
                h: "\u0d12\u0d30\u0d41 \u0d2e\u0d23\u0d3f\u0d15\u0d4d\u0d15\u0d42\u0d7c",
                hh: "%d \u0d2e\u0d23\u0d3f\u0d15\u0d4d\u0d15\u0d42\u0d7c",
                d: "\u0d12\u0d30\u0d41 \u0d26\u0d3f\u0d35\u0d38\u0d02",
                dd: "%d \u0d26\u0d3f\u0d35\u0d38\u0d02",
                M: "\u0d12\u0d30\u0d41 \u0d2e\u0d3e\u0d38\u0d02",
                MM: "%d \u0d2e\u0d3e\u0d38\u0d02",
                y: "\u0d12\u0d30\u0d41 \u0d35\u0d7c\u0d37\u0d02",
                yy: "%d \u0d35\u0d7c\u0d37\u0d02",
            },
            meridiemParse:
                /\u0d30\u0d3e\u0d24\u0d4d\u0d30\u0d3f|\u0d30\u0d3e\u0d35\u0d3f\u0d32\u0d46|\u0d09\u0d1a\u0d4d\u0d1a \u0d15\u0d34\u0d3f\u0d1e\u0d4d\u0d1e\u0d4d|\u0d35\u0d48\u0d15\u0d41\u0d28\u0d4d\u0d28\u0d47\u0d30\u0d02|\u0d30\u0d3e\u0d24\u0d4d\u0d30\u0d3f/i,
            meridiemHour: function (e, a) {
                return (
                    12 === e && (e = 0),
                    ("\u0d30\u0d3e\u0d24\u0d4d\u0d30\u0d3f" === a && 4 <= e) ||
                    "\u0d09\u0d1a\u0d4d\u0d1a \u0d15\u0d34\u0d3f\u0d1e\u0d4d\u0d1e\u0d4d" ===
                        a ||
                    "\u0d35\u0d48\u0d15\u0d41\u0d28\u0d4d\u0d28\u0d47\u0d30\u0d02" ===
                        a
                        ? e + 12
                        : e
                );
            },
            meridiem: function (e, a, t) {
                return e < 4
                    ? "\u0d30\u0d3e\u0d24\u0d4d\u0d30\u0d3f"
                    : e < 12
                    ? "\u0d30\u0d3e\u0d35\u0d3f\u0d32\u0d46"
                    : e < 17
                    ? "\u0d09\u0d1a\u0d4d\u0d1a \u0d15\u0d34\u0d3f\u0d1e\u0d4d\u0d1e\u0d4d"
                    : e < 20
                    ? "\u0d35\u0d48\u0d15\u0d41\u0d28\u0d4d\u0d28\u0d47\u0d30\u0d02"
                    : "\u0d30\u0d3e\u0d24\u0d4d\u0d30\u0d3f";
            },
        }),
        M.defineLocale("mn", {
            months: "\u041d\u044d\u0433\u0434\u04af\u0433\u044d\u044d\u0440 \u0441\u0430\u0440_\u0425\u043e\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u0413\u0443\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u0414\u04e9\u0440\u04e9\u0432\u0434\u04af\u0433\u044d\u044d\u0440 \u0441\u0430\u0440_\u0422\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u0417\u0443\u0440\u0433\u0430\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u0414\u043e\u043b\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u041d\u0430\u0439\u043c\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u0415\u0441\u0434\u04af\u0433\u044d\u044d\u0440 \u0441\u0430\u0440_\u0410\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u0410\u0440\u0432\u0430\u043d \u043d\u044d\u0433\u0434\u04af\u0433\u044d\u044d\u0440 \u0441\u0430\u0440_\u0410\u0440\u0432\u0430\u043d \u0445\u043e\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440".split(
                "_"
            ),
            monthsShort:
                "1 \u0441\u0430\u0440_2 \u0441\u0430\u0440_3 \u0441\u0430\u0440_4 \u0441\u0430\u0440_5 \u0441\u0430\u0440_6 \u0441\u0430\u0440_7 \u0441\u0430\u0440_8 \u0441\u0430\u0440_9 \u0441\u0430\u0440_10 \u0441\u0430\u0440_11 \u0441\u0430\u0440_12 \u0441\u0430\u0440".split(
                    "_"
                ),
            monthsParseExact: !0,
            weekdays:
                "\u041d\u044f\u043c_\u0414\u0430\u0432\u0430\u0430_\u041c\u044f\u0433\u043c\u0430\u0440_\u041b\u0445\u0430\u0433\u0432\u0430_\u041f\u04af\u0440\u044d\u0432_\u0411\u0430\u0430\u0441\u0430\u043d_\u0411\u044f\u043c\u0431\u0430".split(
                    "_"
                ),
            weekdaysShort:
                "\u041d\u044f\u043c_\u0414\u0430\u0432_\u041c\u044f\u0433_\u041b\u0445\u0430_\u041f\u04af\u0440_\u0411\u0430\u0430_\u0411\u044f\u043c".split(
                    "_"
                ),
            weekdaysMin:
                "\u041d\u044f_\u0414\u0430_\u041c\u044f_\u041b\u0445_\u041f\u04af_\u0411\u0430_\u0411\u044f".split(
                    "_"
                ),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "YYYY-MM-DD",
                LL: "YYYY \u043e\u043d\u044b MMMM\u044b\u043d D",
                LLL: "YYYY \u043e\u043d\u044b MMMM\u044b\u043d D HH:mm",
                LLLL: "dddd, YYYY \u043e\u043d\u044b MMMM\u044b\u043d D HH:mm",
            },
            meridiemParse: /\u04ae\u04e8|\u04ae\u0425/i,
            isPM: function (e) {
                return "\u04ae\u0425" === e;
            },
            meridiem: function (e, a, t) {
                return e < 12 ? "\u04ae\u04e8" : "\u04ae\u0425";
            },
            calendar: {
                sameDay: "[\u04e8\u043d\u04e9\u04e9\u0434\u04e9\u0440] LT",
                nextDay: "[\u041c\u0430\u0440\u0433\u0430\u0430\u0448] LT",
                nextWeek: "[\u0418\u0440\u044d\u0445] dddd LT",
                lastDay: "[\u04e8\u0447\u0438\u0433\u0434\u04e9\u0440] LT",
                lastWeek:
                    "[\u04e8\u043d\u0433\u04e9\u0440\u0441\u04e9\u043d] dddd LT",
                sameElse: "L",
            },
            relativeTime: {
                future: "%s \u0434\u0430\u0440\u0430\u0430",
                past: "%s \u04e9\u043c\u043d\u04e9",
                s: an,
                ss: an,
                m: an,
                mm: an,
                h: an,
                hh: an,
                d: an,
                dd: an,
                M: an,
                MM: an,
                y: an,
                yy: an,
            },
            dayOfMonthOrdinalParse: /\d{1,2} \u04e9\u0434\u04e9\u0440/,
            ordinal: function (e, a) {
                switch (a) {
                    case "d":
                    case "D":
                    case "DDD":
                        return e + " \u04e9\u0434\u04e9\u0440";
                    default:
                        return e;
                }
            },
        });
    var tn = {
            1: "\u0967",
            2: "\u0968",
            3: "\u0969",
            4: "\u096a",
            5: "\u096b",
            6: "\u096c",
            7: "\u096d",
            8: "\u096e",
            9: "\u096f",
            0: "\u0966",
        },
        sn = {
            "\u0967": "1",
            "\u0968": "2",
            "\u0969": "3",
            "\u096a": "4",
            "\u096b": "5",
            "\u096c": "6",
            "\u096d": "7",
            "\u096e": "8",
            "\u096f": "9",
            "\u0966": "0",
        };
    function nn(e, a, t, s) {
        var n = "";
        if (a)
            switch (t) {
                case "s":
                    n =
                        "\u0915\u093e\u0939\u0940 \u0938\u0947\u0915\u0902\u0926";
                    break;
                case "ss":
                    n = "%d \u0938\u0947\u0915\u0902\u0926";
                    break;
                case "m":
                    n = "\u090f\u0915 \u092e\u093f\u0928\u093f\u091f";
                    break;
                case "mm":
                    n = "%d \u092e\u093f\u0928\u093f\u091f\u0947";
                    break;
                case "h":
                    n = "\u090f\u0915 \u0924\u093e\u0938";
                    break;
                case "hh":
                    n = "%d \u0924\u093e\u0938";
                    break;
                case "d":
                    n = "\u090f\u0915 \u0926\u093f\u0935\u0938";
                    break;
                case "dd":
                    n = "%d \u0926\u093f\u0935\u0938";
                    break;
                case "M":
                    n = "\u090f\u0915 \u092e\u0939\u093f\u0928\u093e";
                    break;
                case "MM":
                    n = "%d \u092e\u0939\u093f\u0928\u0947";
                    break;
                case "y":
                    n = "\u090f\u0915 \u0935\u0930\u094d\u0937";
                    break;
                case "yy":
                    n = "%d \u0935\u0930\u094d\u0937\u0947";
                    break;
            }
        else
            switch (t) {
                case "s":
                    n =
                        "\u0915\u093e\u0939\u0940 \u0938\u0947\u0915\u0902\u0926\u093e\u0902";
                    break;
                case "ss":
                    n = "%d \u0938\u0947\u0915\u0902\u0926\u093e\u0902";
                    break;
                case "m":
                    n =
                        "\u090f\u0915\u093e \u092e\u093f\u0928\u093f\u091f\u093e";
                    break;
                case "mm":
                    n = "%d \u092e\u093f\u0928\u093f\u091f\u093e\u0902";
                    break;
                case "h":
                    n = "\u090f\u0915\u093e \u0924\u093e\u0938\u093e";
                    break;
                case "hh":
                    n = "%d \u0924\u093e\u0938\u093e\u0902";
                    break;
                case "d":
                    n = "\u090f\u0915\u093e \u0926\u093f\u0935\u0938\u093e";
                    break;
                case "dd":
                    n = "%d \u0926\u093f\u0935\u0938\u093e\u0902";
                    break;
                case "M":
                    n =
                        "\u090f\u0915\u093e \u092e\u0939\u093f\u0928\u094d\u092f\u093e";
                    break;
                case "MM":
                    n = "%d \u092e\u0939\u093f\u0928\u094d\u092f\u093e\u0902";
                    break;
                case "y":
                    n = "\u090f\u0915\u093e \u0935\u0930\u094d\u0937\u093e";
                    break;
                case "yy":
                    n = "%d \u0935\u0930\u094d\u0937\u093e\u0902";
                    break;
            }
        return n.replace(/%d/i, e);
    }
    M.defineLocale("mr", {
        months: "\u091c\u093e\u0928\u0947\u0935\u093e\u0930\u0940_\u092b\u0947\u092c\u094d\u0930\u0941\u0935\u093e\u0930\u0940_\u092e\u093e\u0930\u094d\u091a_\u090f\u092a\u094d\u0930\u093f\u0932_\u092e\u0947_\u091c\u0942\u0928_\u091c\u0941\u0932\u0948_\u0911\u0917\u0938\u094d\u091f_\u0938\u092a\u094d\u091f\u0947\u0902\u092c\u0930_\u0911\u0915\u094d\u091f\u094b\u092c\u0930_\u0928\u094b\u0935\u094d\u0939\u0947\u0902\u092c\u0930_\u0921\u093f\u0938\u0947\u0902\u092c\u0930".split(
            "_"
        ),
        monthsShort:
            "\u091c\u093e\u0928\u0947._\u092b\u0947\u092c\u094d\u0930\u0941._\u092e\u093e\u0930\u094d\u091a._\u090f\u092a\u094d\u0930\u093f._\u092e\u0947._\u091c\u0942\u0928._\u091c\u0941\u0932\u0948._\u0911\u0917._\u0938\u092a\u094d\u091f\u0947\u0902._\u0911\u0915\u094d\u091f\u094b._\u0928\u094b\u0935\u094d\u0939\u0947\u0902._\u0921\u093f\u0938\u0947\u0902.".split(
                "_"
            ),
        monthsParseExact: !0,
        weekdays:
            "\u0930\u0935\u093f\u0935\u093e\u0930_\u0938\u094b\u092e\u0935\u093e\u0930_\u092e\u0902\u0917\u0933\u0935\u093e\u0930_\u092c\u0941\u0927\u0935\u093e\u0930_\u0917\u0941\u0930\u0942\u0935\u093e\u0930_\u0936\u0941\u0915\u094d\u0930\u0935\u093e\u0930_\u0936\u0928\u093f\u0935\u093e\u0930".split(
                "_"
            ),
        weekdaysShort:
            "\u0930\u0935\u093f_\u0938\u094b\u092e_\u092e\u0902\u0917\u0933_\u092c\u0941\u0927_\u0917\u0941\u0930\u0942_\u0936\u0941\u0915\u094d\u0930_\u0936\u0928\u093f".split(
                "_"
            ),
        weekdaysMin:
            "\u0930_\u0938\u094b_\u092e\u0902_\u092c\u0941_\u0917\u0941_\u0936\u0941_\u0936".split(
                "_"
            ),
        longDateFormat: {
            LT: "A h:mm \u0935\u093e\u091c\u0924\u093e",
            LTS: "A h:mm:ss \u0935\u093e\u091c\u0924\u093e",
            L: "DD/MM/YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY, A h:mm \u0935\u093e\u091c\u0924\u093e",
            LLLL: "dddd, D MMMM YYYY, A h:mm \u0935\u093e\u091c\u0924\u093e",
        },
        calendar: {
            sameDay: "[\u0906\u091c] LT",
            nextDay: "[\u0909\u0926\u094d\u092f\u093e] LT",
            nextWeek: "dddd, LT",
            lastDay: "[\u0915\u093e\u0932] LT",
            lastWeek: "[\u092e\u093e\u0917\u0940\u0932] dddd, LT",
            sameElse: "L",
        },
        relativeTime: {
            future: "%s\u092e\u0927\u094d\u092f\u0947",
            past: "%s\u092a\u0942\u0930\u094d\u0935\u0940",
            s: nn,
            ss: nn,
            m: nn,
            mm: nn,
            h: nn,
            hh: nn,
            d: nn,
            dd: nn,
            M: nn,
            MM: nn,
            y: nn,
            yy: nn,
        },
        preparse: function (e) {
            return e.replace(
                /[\u0967\u0968\u0969\u096a\u096b\u096c\u096d\u096e\u096f\u0966]/g,
                function (e) {
                    return sn[e];
                }
            );
        },
        postformat: function (e) {
            return e.replace(/\d/g, function (e) {
                return tn[e];
            });
        },
        meridiemParse:
            /\u092a\u0939\u093e\u091f\u0947|\u0938\u0915\u093e\u0933\u0940|\u0926\u0941\u092a\u093e\u0930\u0940|\u0938\u093e\u092f\u0902\u0915\u093e\u0933\u0940|\u0930\u093e\u0924\u094d\u0930\u0940/,
        meridiemHour: function (e, a) {
            return (
                12 === e && (e = 0),
                "\u092a\u0939\u093e\u091f\u0947" === a ||
                "\u0938\u0915\u093e\u0933\u0940" === a
                    ? e
                    : "\u0926\u0941\u092a\u093e\u0930\u0940" === a ||
                      "\u0938\u093e\u092f\u0902\u0915\u093e\u0933\u0940" ===
                          a ||
                      "\u0930\u093e\u0924\u094d\u0930\u0940" === a
                    ? 12 <= e
                        ? e
                        : e + 12
                    : void 0
            );
        },
        meridiem: function (e, a, t) {
            return 0 <= e && e < 6
                ? "\u092a\u0939\u093e\u091f\u0947"
                : e < 12
                ? "\u0938\u0915\u093e\u0933\u0940"
                : e < 17
                ? "\u0926\u0941\u092a\u093e\u0930\u0940"
                : e < 20
                ? "\u0938\u093e\u092f\u0902\u0915\u093e\u0933\u0940"
                : "\u0930\u093e\u0924\u094d\u0930\u0940";
        },
        week: { dow: 0, doy: 6 },
    }),
        M.defineLocale("ms-my", {
            months: "Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember".split(
                "_"
            ),
            monthsShort:
                "Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis".split("_"),
            weekdays: "Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu".split("_"),
            weekdaysShort: "Ahd_Isn_Sel_Rab_Kha_Jum_Sab".split("_"),
            weekdaysMin: "Ah_Is_Sl_Rb_Km_Jm_Sb".split("_"),
            longDateFormat: {
                LT: "HH.mm",
                LTS: "HH.mm.ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY [pukul] HH.mm",
                LLLL: "dddd, D MMMM YYYY [pukul] HH.mm",
            },
            meridiemParse: /pagi|tengahari|petang|malam/,
            meridiemHour: function (e, a) {
                return (
                    12 === e && (e = 0),
                    "pagi" === a
                        ? e
                        : "tengahari" === a
                        ? 11 <= e
                            ? e
                            : e + 12
                        : "petang" === a || "malam" === a
                        ? e + 12
                        : void 0
                );
            },
            meridiem: function (e, a, t) {
                return e < 11
                    ? "pagi"
                    : e < 15
                    ? "tengahari"
                    : e < 19
                    ? "petang"
                    : "malam";
            },
            calendar: {
                sameDay: "[Hari ini pukul] LT",
                nextDay: "[Esok pukul] LT",
                nextWeek: "dddd [pukul] LT",
                lastDay: "[Kelmarin pukul] LT",
                lastWeek: "dddd [lepas pukul] LT",
                sameElse: "L",
            },
            relativeTime: {
                future: "dalam %s",
                past: "%s yang lepas",
                s: "beberapa saat",
                ss: "%d saat",
                m: "seminit",
                mm: "%d minit",
                h: "sejam",
                hh: "%d jam",
                d: "sehari",
                dd: "%d hari",
                M: "sebulan",
                MM: "%d bulan",
                y: "setahun",
                yy: "%d tahun",
            },
            week: { dow: 1, doy: 7 },
        }),
        M.defineLocale("ms", {
            months: "Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember".split(
                "_"
            ),
            monthsShort:
                "Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis".split("_"),
            weekdays: "Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu".split("_"),
            weekdaysShort: "Ahd_Isn_Sel_Rab_Kha_Jum_Sab".split("_"),
            weekdaysMin: "Ah_Is_Sl_Rb_Km_Jm_Sb".split("_"),
            longDateFormat: {
                LT: "HH.mm",
                LTS: "HH.mm.ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY [pukul] HH.mm",
                LLLL: "dddd, D MMMM YYYY [pukul] HH.mm",
            },
            meridiemParse: /pagi|tengahari|petang|malam/,
            meridiemHour: function (e, a) {
                return (
                    12 === e && (e = 0),
                    "pagi" === a
                        ? e
                        : "tengahari" === a
                        ? 11 <= e
                            ? e
                            : e + 12
                        : "petang" === a || "malam" === a
                        ? e + 12
                        : void 0
                );
            },
            meridiem: function (e, a, t) {
                return e < 11
                    ? "pagi"
                    : e < 15
                    ? "tengahari"
                    : e < 19
                    ? "petang"
                    : "malam";
            },
            calendar: {
                sameDay: "[Hari ini pukul] LT",
                nextDay: "[Esok pukul] LT",
                nextWeek: "dddd [pukul] LT",
                lastDay: "[Kelmarin pukul] LT",
                lastWeek: "dddd [lepas pukul] LT",
                sameElse: "L",
            },
            relativeTime: {
                future: "dalam %s",
                past: "%s yang lepas",
                s: "beberapa saat",
                ss: "%d saat",
                m: "seminit",
                mm: "%d minit",
                h: "sejam",
                hh: "%d jam",
                d: "sehari",
                dd: "%d hari",
                M: "sebulan",
                MM: "%d bulan",
                y: "setahun",
                yy: "%d tahun",
            },
            week: { dow: 1, doy: 7 },
        }),
        M.defineLocale("mt", {
            months: "Jannar_Frar_Marzu_April_Mejju_\u0120unju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Di\u010bembru".split(
                "_"
            ),
            monthsShort:
                "Jan_Fra_Mar_Apr_Mej_\u0120un_Lul_Aww_Set_Ott_Nov_Di\u010b".split(
                    "_"
                ),
            weekdays:
                "Il-\u0126add_It-Tnejn_It-Tlieta_L-Erbg\u0127a_Il-\u0126amis_Il-\u0120img\u0127a_Is-Sibt".split(
                    "_"
                ),
            weekdaysShort: "\u0126ad_Tne_Tli_Erb_\u0126am_\u0120im_Sib".split(
                "_"
            ),
            weekdaysMin: "\u0126a_Tn_Tl_Er_\u0126a_\u0120i_Si".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd, D MMMM YYYY HH:mm",
            },
            calendar: {
                sameDay: "[Illum fil-]LT",
                nextDay: "[G\u0127ada fil-]LT",
                nextWeek: "dddd [fil-]LT",
                lastDay: "[Il-biera\u0127 fil-]LT",
                lastWeek: "dddd [li g\u0127adda] [fil-]LT",
                sameElse: "L",
            },
            relativeTime: {
                future: "f\u2019 %s",
                past: "%s ilu",
                s: "ftit sekondi",
                ss: "%d sekondi",
                m: "minuta",
                mm: "%d minuti",
                h: "sieg\u0127a",
                hh: "%d sieg\u0127at",
                d: "\u0121urnata",
                dd: "%d \u0121ranet",
                M: "xahar",
                MM: "%d xhur",
                y: "sena",
                yy: "%d sni",
            },
            dayOfMonthOrdinalParse: /\d{1,2}\xba/,
            ordinal: "%d\xba",
            week: { dow: 1, doy: 4 },
        });
    var rn = {
            1: "\u1041",
            2: "\u1042",
            3: "\u1043",
            4: "\u1044",
            5: "\u1045",
            6: "\u1046",
            7: "\u1047",
            8: "\u1048",
            9: "\u1049",
            0: "\u1040",
        },
        dn = {
            "\u1041": "1",
            "\u1042": "2",
            "\u1043": "3",
            "\u1044": "4",
            "\u1045": "5",
            "\u1046": "6",
            "\u1047": "7",
            "\u1048": "8",
            "\u1049": "9",
            "\u1040": "0",
        },
        _n =
            (M.defineLocale("my", {
                months: "\u1007\u1014\u103a\u1014\u101d\u102b\u101b\u102e_\u1016\u1031\u1016\u1031\u102c\u103a\u101d\u102b\u101b\u102e_\u1019\u1010\u103a_\u1027\u1015\u103c\u102e_\u1019\u1031_\u1007\u103d\u1014\u103a_\u1007\u1030\u101c\u102d\u102f\u1004\u103a_\u101e\u103c\u1002\u102f\u1010\u103a_\u1005\u1000\u103a\u1010\u1004\u103a\u1018\u102c_\u1021\u1031\u102c\u1000\u103a\u1010\u102d\u102f\u1018\u102c_\u1014\u102d\u102f\u101d\u1004\u103a\u1018\u102c_\u1012\u102e\u1007\u1004\u103a\u1018\u102c".split(
                    "_"
                ),
                monthsShort:
                    "\u1007\u1014\u103a_\u1016\u1031_\u1019\u1010\u103a_\u1015\u103c\u102e_\u1019\u1031_\u1007\u103d\u1014\u103a_\u101c\u102d\u102f\u1004\u103a_\u101e\u103c_\u1005\u1000\u103a_\u1021\u1031\u102c\u1000\u103a_\u1014\u102d\u102f_\u1012\u102e".split(
                        "_"
                    ),
                weekdays:
                    "\u1010\u1014\u1004\u103a\u1039\u1002\u1014\u103d\u1031_\u1010\u1014\u1004\u103a\u1039\u101c\u102c_\u1021\u1004\u103a\u1039\u1002\u102b_\u1017\u102f\u1012\u1039\u1013\u101f\u1030\u1038_\u1000\u103c\u102c\u101e\u1015\u1010\u1031\u1038_\u101e\u1031\u102c\u1000\u103c\u102c_\u1005\u1014\u1031".split(
                        "_"
                    ),
                weekdaysShort:
                    "\u1014\u103d\u1031_\u101c\u102c_\u1002\u102b_\u101f\u1030\u1038_\u1000\u103c\u102c_\u101e\u1031\u102c_\u1014\u1031".split(
                        "_"
                    ),
                weekdaysMin:
                    "\u1014\u103d\u1031_\u101c\u102c_\u1002\u102b_\u101f\u1030\u1038_\u1000\u103c\u102c_\u101e\u1031\u102c_\u1014\u1031".split(
                        "_"
                    ),
                longDateFormat: {
                    LT: "HH:mm",
                    LTS: "HH:mm:ss",
                    L: "DD/MM/YYYY",
                    LL: "D MMMM YYYY",
                    LLL: "D MMMM YYYY HH:mm",
                    LLLL: "dddd D MMMM YYYY HH:mm",
                },
                calendar: {
                    sameDay: "[\u101a\u1014\u1031.] LT [\u1019\u103e\u102c]",
                    nextDay:
                        "[\u1019\u1014\u1000\u103a\u1016\u103c\u1014\u103a] LT [\u1019\u103e\u102c]",
                    nextWeek: "dddd LT [\u1019\u103e\u102c]",
                    lastDay:
                        "[\u1019\u1014\u1031.\u1000] LT [\u1019\u103e\u102c]",
                    lastWeek:
                        "[\u1015\u103c\u102e\u1038\u1001\u1032\u1037\u101e\u1031\u102c] dddd LT [\u1019\u103e\u102c]",
                    sameElse: "L",
                },
                relativeTime: {
                    future: "\u101c\u102c\u1019\u100a\u103a\u1037 %s \u1019\u103e\u102c",
                    past: "\u101c\u103d\u1014\u103a\u1001\u1032\u1037\u101e\u1031\u102c %s \u1000",
                    s: "\u1005\u1000\u1039\u1000\u1014\u103a.\u1021\u1014\u100a\u103a\u1038\u1004\u101a\u103a",
                    ss: "%d \u1005\u1000\u1039\u1000\u1014\u1037\u103a",
                    m: "\u1010\u1005\u103a\u1019\u102d\u1014\u1005\u103a",
                    mm: "%d \u1019\u102d\u1014\u1005\u103a",
                    h: "\u1010\u1005\u103a\u1014\u102c\u101b\u102e",
                    hh: "%d \u1014\u102c\u101b\u102e",
                    d: "\u1010\u1005\u103a\u101b\u1000\u103a",
                    dd: "%d \u101b\u1000\u103a",
                    M: "\u1010\u1005\u103a\u101c",
                    MM: "%d \u101c",
                    y: "\u1010\u1005\u103a\u1014\u103e\u1005\u103a",
                    yy: "%d \u1014\u103e\u1005\u103a",
                },
                preparse: function (e) {
                    return e.replace(
                        /[\u1041\u1042\u1043\u1044\u1045\u1046\u1047\u1048\u1049\u1040]/g,
                        function (e) {
                            return dn[e];
                        }
                    );
                },
                postformat: function (e) {
                    return e.replace(/\d/g, function (e) {
                        return rn[e];
                    });
                },
                week: { dow: 1, doy: 4 },
            }),
            M.defineLocale("nb", {
                months: "januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember".split(
                    "_"
                ),
                monthsShort:
                    "jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.".split(
                        "_"
                    ),
                monthsParseExact: !0,
                weekdays:
                    "s\xf8ndag_mandag_tirsdag_onsdag_torsdag_fredag_l\xf8rdag".split(
                        "_"
                    ),
                weekdaysShort: "s\xf8._ma._ti._on._to._fr._l\xf8.".split("_"),
                weekdaysMin: "s\xf8_ma_ti_on_to_fr_l\xf8".split("_"),
                weekdaysParseExact: !0,
                longDateFormat: {
                    LT: "HH:mm",
                    LTS: "HH:mm:ss",
                    L: "DD.MM.YYYY",
                    LL: "D. MMMM YYYY",
                    LLL: "D. MMMM YYYY [kl.] HH:mm",
                    LLLL: "dddd D. MMMM YYYY [kl.] HH:mm",
                },
                calendar: {
                    sameDay: "[i dag kl.] LT",
                    nextDay: "[i morgen kl.] LT",
                    nextWeek: "dddd [kl.] LT",
                    lastDay: "[i g\xe5r kl.] LT",
                    lastWeek: "[forrige] dddd [kl.] LT",
                    sameElse: "L",
                },
                relativeTime: {
                    future: "om %s",
                    past: "%s siden",
                    s: "noen sekunder",
                    ss: "%d sekunder",
                    m: "ett minutt",
                    mm: "%d minutter",
                    h: "en time",
                    hh: "%d timer",
                    d: "en dag",
                    dd: "%d dager",
                    w: "en uke",
                    ww: "%d uker",
                    M: "en m\xe5ned",
                    MM: "%d m\xe5neder",
                    y: "ett \xe5r",
                    yy: "%d \xe5r",
                },
                dayOfMonthOrdinalParse: /\d{1,2}\./,
                ordinal: "%d.",
                week: { dow: 1, doy: 4 },
            }),
            {
                1: "\u0967",
                2: "\u0968",
                3: "\u0969",
                4: "\u096a",
                5: "\u096b",
                6: "\u096c",
                7: "\u096d",
                8: "\u096e",
                9: "\u096f",
                0: "\u0966",
            }),
        on = {
            "\u0967": "1",
            "\u0968": "2",
            "\u0969": "3",
            "\u096a": "4",
            "\u096b": "5",
            "\u096c": "6",
            "\u096d": "7",
            "\u096e": "8",
            "\u096f": "9",
            "\u0966": "0",
        },
        mn =
            (M.defineLocale("ne", {
                months: "\u091c\u0928\u0935\u0930\u0940_\u092b\u0947\u092c\u094d\u0930\u0941\u0935\u0930\u0940_\u092e\u093e\u0930\u094d\u091a_\u0905\u092a\u094d\u0930\u093f\u0932_\u092e\u0908_\u091c\u0941\u0928_\u091c\u0941\u0932\u093e\u0908_\u0905\u0917\u0937\u094d\u091f_\u0938\u0947\u092a\u094d\u091f\u0947\u092e\u094d\u092c\u0930_\u0905\u0915\u094d\u091f\u094b\u092c\u0930_\u0928\u094b\u092d\u0947\u092e\u094d\u092c\u0930_\u0921\u093f\u0938\u0947\u092e\u094d\u092c\u0930".split(
                    "_"
                ),
                monthsShort:
                    "\u091c\u0928._\u092b\u0947\u092c\u094d\u0930\u0941._\u092e\u093e\u0930\u094d\u091a_\u0905\u092a\u094d\u0930\u093f._\u092e\u0908_\u091c\u0941\u0928_\u091c\u0941\u0932\u093e\u0908._\u0905\u0917._\u0938\u0947\u092a\u094d\u091f._\u0905\u0915\u094d\u091f\u094b._\u0928\u094b\u092d\u0947._\u0921\u093f\u0938\u0947.".split(
                        "_"
                    ),
                monthsParseExact: !0,
                weekdays:
                    "\u0906\u0907\u0924\u092c\u093e\u0930_\u0938\u094b\u092e\u092c\u093e\u0930_\u092e\u0919\u094d\u0917\u0932\u092c\u093e\u0930_\u092c\u0941\u0927\u092c\u093e\u0930_\u092c\u093f\u0939\u093f\u092c\u093e\u0930_\u0936\u0941\u0915\u094d\u0930\u092c\u093e\u0930_\u0936\u0928\u093f\u092c\u093e\u0930".split(
                        "_"
                    ),
                weekdaysShort:
                    "\u0906\u0907\u0924._\u0938\u094b\u092e._\u092e\u0919\u094d\u0917\u0932._\u092c\u0941\u0927._\u092c\u093f\u0939\u093f._\u0936\u0941\u0915\u094d\u0930._\u0936\u0928\u093f.".split(
                        "_"
                    ),
                weekdaysMin:
                    "\u0906._\u0938\u094b._\u092e\u0902._\u092c\u0941._\u092c\u093f._\u0936\u0941._\u0936.".split(
                        "_"
                    ),
                weekdaysParseExact: !0,
                longDateFormat: {
                    LT: "A\u0915\u094b h:mm \u092c\u091c\u0947",
                    LTS: "A\u0915\u094b h:mm:ss \u092c\u091c\u0947",
                    L: "DD/MM/YYYY",
                    LL: "D MMMM YYYY",
                    LLL: "D MMMM YYYY, A\u0915\u094b h:mm \u092c\u091c\u0947",
                    LLLL: "dddd, D MMMM YYYY, A\u0915\u094b h:mm \u092c\u091c\u0947",
                },
                preparse: function (e) {
                    return e.replace(
                        /[\u0967\u0968\u0969\u096a\u096b\u096c\u096d\u096e\u096f\u0966]/g,
                        function (e) {
                            return on[e];
                        }
                    );
                },
                postformat: function (e) {
                    return e.replace(/\d/g, function (e) {
                        return _n[e];
                    });
                },
                meridiemParse:
                    /\u0930\u093e\u0924\u093f|\u092c\u093f\u0939\u093e\u0928|\u0926\u093f\u0909\u0901\u0938\u094b|\u0938\u093e\u0901\u091d/,
                meridiemHour: function (e, a) {
                    return (
                        12 === e && (e = 0),
                        "\u0930\u093e\u0924\u093f" === a
                            ? e < 4
                                ? e
                                : e + 12
                            : "\u092c\u093f\u0939\u093e\u0928" === a
                            ? e
                            : "\u0926\u093f\u0909\u0901\u0938\u094b" === a
                            ? 10 <= e
                                ? e
                                : e + 12
                            : "\u0938\u093e\u0901\u091d" === a
                            ? e + 12
                            : void 0
                    );
                },
                meridiem: function (e, a, t) {
                    return e < 3
                        ? "\u0930\u093e\u0924\u093f"
                        : e < 12
                        ? "\u092c\u093f\u0939\u093e\u0928"
                        : e < 16
                        ? "\u0926\u093f\u0909\u0901\u0938\u094b"
                        : e < 20
                        ? "\u0938\u093e\u0901\u091d"
                        : "\u0930\u093e\u0924\u093f";
                },
                calendar: {
                    sameDay: "[\u0906\u091c] LT",
                    nextDay: "[\u092d\u094b\u0932\u093f] LT",
                    nextWeek: "[\u0906\u0909\u0901\u0926\u094b] dddd[,] LT",
                    lastDay: "[\u0939\u093f\u091c\u094b] LT",
                    lastWeek: "[\u0917\u090f\u0915\u094b] dddd[,] LT",
                    sameElse: "L",
                },
                relativeTime: {
                    future: "%s\u092e\u093e",
                    past: "%s \u0905\u0917\u093e\u0921\u093f",
                    s: "\u0915\u0947\u0939\u0940 \u0915\u094d\u0937\u0923",
                    ss: "%d \u0938\u0947\u0915\u0947\u0923\u094d\u0921",
                    m: "\u090f\u0915 \u092e\u093f\u0928\u0947\u091f",
                    mm: "%d \u092e\u093f\u0928\u0947\u091f",
                    h: "\u090f\u0915 \u0918\u0923\u094d\u091f\u093e",
                    hh: "%d \u0918\u0923\u094d\u091f\u093e",
                    d: "\u090f\u0915 \u0926\u093f\u0928",
                    dd: "%d \u0926\u093f\u0928",
                    M: "\u090f\u0915 \u092e\u0939\u093f\u0928\u093e",
                    MM: "%d \u092e\u0939\u093f\u0928\u093e",
                    y: "\u090f\u0915 \u092c\u0930\u094d\u0937",
                    yy: "%d \u092c\u0930\u094d\u0937",
                },
                week: { dow: 0, doy: 6 },
            }),
            "jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.".split(
                "_"
            )),
        un = "jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"),
        c = [
            /^jan/i,
            /^feb/i,
            /^maart|mrt.?$/i,
            /^apr/i,
            /^mei$/i,
            /^jun[i.]?$/i,
            /^jul[i.]?$/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dec/i,
        ],
        L =
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
        ln =
            (M.defineLocale("nl-be", {
                months: "januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split(
                    "_"
                ),
                monthsShort: function (e, a) {
                    return e ? (/-MMM-/.test(a) ? un : mn)[e.month()] : mn;
                },
                monthsRegex: L,
                monthsShortRegex: L,
                monthsStrictRegex:
                    /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
                monthsShortStrictRegex:
                    /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
                monthsParse: c,
                longMonthsParse: c,
                shortMonthsParse: c,
                weekdays:
                    "zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split(
                        "_"
                    ),
                weekdaysShort: "zo._ma._di._wo._do._vr._za.".split("_"),
                weekdaysMin: "zo_ma_di_wo_do_vr_za".split("_"),
                weekdaysParseExact: !0,
                longDateFormat: {
                    LT: "HH:mm",
                    LTS: "HH:mm:ss",
                    L: "DD/MM/YYYY",
                    LL: "D MMMM YYYY",
                    LLL: "D MMMM YYYY HH:mm",
                    LLLL: "dddd D MMMM YYYY HH:mm",
                },
                calendar: {
                    sameDay: "[vandaag om] LT",
                    nextDay: "[morgen om] LT",
                    nextWeek: "dddd [om] LT",
                    lastDay: "[gisteren om] LT",
                    lastWeek: "[afgelopen] dddd [om] LT",
                    sameElse: "L",
                },
                relativeTime: {
                    future: "over %s",
                    past: "%s geleden",
                    s: "een paar seconden",
                    ss: "%d seconden",
                    m: "\xe9\xe9n minuut",
                    mm: "%d minuten",
                    h: "\xe9\xe9n uur",
                    hh: "%d uur",
                    d: "\xe9\xe9n dag",
                    dd: "%d dagen",
                    M: "\xe9\xe9n maand",
                    MM: "%d maanden",
                    y: "\xe9\xe9n jaar",
                    yy: "%d jaar",
                },
                dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
                ordinal: function (e) {
                    return e + (1 === e || 8 === e || 20 <= e ? "ste" : "de");
                },
                week: { dow: 1, doy: 4 },
            }),
            "jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.".split(
                "_"
            )),
        Mn = "jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"),
        f = [
            /^jan/i,
            /^feb/i,
            /^maart|mrt.?$/i,
            /^apr/i,
            /^mei$/i,
            /^jun[i.]?$/i,
            /^jul[i.]?$/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dec/i,
        ],
        ke =
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
        hn =
            (M.defineLocale("nl", {
                months: "januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split(
                    "_"
                ),
                monthsShort: function (e, a) {
                    return e ? (/-MMM-/.test(a) ? Mn : ln)[e.month()] : ln;
                },
                monthsRegex: ke,
                monthsShortRegex: ke,
                monthsStrictRegex:
                    /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
                monthsShortStrictRegex:
                    /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
                monthsParse: f,
                longMonthsParse: f,
                shortMonthsParse: f,
                weekdays:
                    "zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split(
                        "_"
                    ),
                weekdaysShort: "zo._ma._di._wo._do._vr._za.".split("_"),
                weekdaysMin: "zo_ma_di_wo_do_vr_za".split("_"),
                weekdaysParseExact: !0,
                longDateFormat: {
                    LT: "HH:mm",
                    LTS: "HH:mm:ss",
                    L: "DD-MM-YYYY",
                    LL: "D MMMM YYYY",
                    LLL: "D MMMM YYYY HH:mm",
                    LLLL: "dddd D MMMM YYYY HH:mm",
                },
                calendar: {
                    sameDay: "[vandaag om] LT",
                    nextDay: "[morgen om] LT",
                    nextWeek: "dddd [om] LT",
                    lastDay: "[gisteren om] LT",
                    lastWeek: "[afgelopen] dddd [om] LT",
                    sameElse: "L",
                },
                relativeTime: {
                    future: "over %s",
                    past: "%s geleden",
                    s: "een paar seconden",
                    ss: "%d seconden",
                    m: "\xe9\xe9n minuut",
                    mm: "%d minuten",
                    h: "\xe9\xe9n uur",
                    hh: "%d uur",
                    d: "\xe9\xe9n dag",
                    dd: "%d dagen",
                    w: "\xe9\xe9n week",
                    ww: "%d weken",
                    M: "\xe9\xe9n maand",
                    MM: "%d maanden",
                    y: "\xe9\xe9n jaar",
                    yy: "%d jaar",
                },
                dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
                ordinal: function (e) {
                    return e + (1 === e || 8 === e || 20 <= e ? "ste" : "de");
                },
                week: { dow: 1, doy: 4 },
            }),
            M.defineLocale("nn", {
                months: "januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember".split(
                    "_"
                ),
                monthsShort:
                    "jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.".split(
                        "_"
                    ),
                monthsParseExact: !0,
                weekdays:
                    "sundag_m\xe5ndag_tysdag_onsdag_torsdag_fredag_laurdag".split(
                        "_"
                    ),
                weekdaysShort: "su._m\xe5._ty._on._to._fr._lau.".split("_"),
                weekdaysMin: "su_m\xe5_ty_on_to_fr_la".split("_"),
                weekdaysParseExact: !0,
                longDateFormat: {
                    LT: "HH:mm",
                    LTS: "HH:mm:ss",
                    L: "DD.MM.YYYY",
                    LL: "D. MMMM YYYY",
                    LLL: "D. MMMM YYYY [kl.] H:mm",
                    LLLL: "dddd D. MMMM YYYY [kl.] HH:mm",
                },
                calendar: {
                    sameDay: "[I dag klokka] LT",
                    nextDay: "[I morgon klokka] LT",
                    nextWeek: "dddd [klokka] LT",
                    lastDay: "[I g\xe5r klokka] LT",
                    lastWeek: "[F\xf8reg\xe5ande] dddd [klokka] LT",
                    sameElse: "L",
                },
                relativeTime: {
                    future: "om %s",
                    past: "%s sidan",
                    s: "nokre sekund",
                    ss: "%d sekund",
                    m: "eit minutt",
                    mm: "%d minutt",
                    h: "ein time",
                    hh: "%d timar",
                    d: "ein dag",
                    dd: "%d dagar",
                    w: "ei veke",
                    ww: "%d veker",
                    M: "ein m\xe5nad",
                    MM: "%d m\xe5nader",
                    y: "eit \xe5r",
                    yy: "%d \xe5r",
                },
                dayOfMonthOrdinalParse: /\d{1,2}\./,
                ordinal: "%d.",
                week: { dow: 1, doy: 4 },
            }),
            M.defineLocale("oc-lnc", {
                months: {
                    standalone:
                        "geni\xe8r_febri\xe8r_mar\xe7_abril_mai_junh_julhet_agost_setembre_oct\xf2bre_novembre_decembre".split(
                            "_"
                        ),
                    format: "de geni\xe8r_de febri\xe8r_de mar\xe7_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'oct\xf2bre_de novembre_de decembre".split(
                        "_"
                    ),
                    isFormat: /D[oD]?(\s)+MMMM/,
                },
                monthsShort:
                    "gen._febr._mar\xe7_abr._mai_junh_julh._ago._set._oct._nov._dec.".split(
                        "_"
                    ),
                monthsParseExact: !0,
                weekdays:
                    "dimenge_diluns_dimars_dim\xe8cres_dij\xf2us_divendres_dissabte".split(
                        "_"
                    ),
                weekdaysShort: "dg._dl._dm._dc._dj._dv._ds.".split("_"),
                weekdaysMin: "dg_dl_dm_dc_dj_dv_ds".split("_"),
                weekdaysParseExact: !0,
                longDateFormat: {
                    LT: "H:mm",
                    LTS: "H:mm:ss",
                    L: "DD/MM/YYYY",
                    LL: "D MMMM [de] YYYY",
                    ll: "D MMM YYYY",
                    LLL: "D MMMM [de] YYYY [a] H:mm",
                    lll: "D MMM YYYY, H:mm",
                    LLLL: "dddd D MMMM [de] YYYY [a] H:mm",
                    llll: "ddd D MMM YYYY, H:mm",
                },
                calendar: {
                    sameDay: "[u\xe8i a] LT",
                    nextDay: "[deman a] LT",
                    nextWeek: "dddd [a] LT",
                    lastDay: "[i\xe8r a] LT",
                    lastWeek: "dddd [passat a] LT",
                    sameElse: "L",
                },
                relativeTime: {
                    future: "d'aqu\xed %s",
                    past: "fa %s",
                    s: "unas segondas",
                    ss: "%d segondas",
                    m: "una minuta",
                    mm: "%d minutas",
                    h: "una ora",
                    hh: "%d oras",
                    d: "un jorn",
                    dd: "%d jorns",
                    M: "un mes",
                    MM: "%d meses",
                    y: "un an",
                    yy: "%d ans",
                },
                dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|\xe8|a)/,
                ordinal: function (e, a) {
                    return (
                        e +
                        ("w" !== a && "W" !== a
                            ? 1 === e
                                ? "r"
                                : 2 === e
                                ? "n"
                                : 3 === e
                                ? "r"
                                : 4 === e
                                ? "t"
                                : "\xe8"
                            : "a")
                    );
                },
                week: { dow: 1, doy: 4 },
            }),
            {
                1: "\u0a67",
                2: "\u0a68",
                3: "\u0a69",
                4: "\u0a6a",
                5: "\u0a6b",
                6: "\u0a6c",
                7: "\u0a6d",
                8: "\u0a6e",
                9: "\u0a6f",
                0: "\u0a66",
            }),
        cn = {
            "\u0a67": "1",
            "\u0a68": "2",
            "\u0a69": "3",
            "\u0a6a": "4",
            "\u0a6b": "5",
            "\u0a6c": "6",
            "\u0a6d": "7",
            "\u0a6e": "8",
            "\u0a6f": "9",
            "\u0a66": "0",
        },
        Ln =
            (M.defineLocale("pa-in", {
                months: "\u0a1c\u0a28\u0a35\u0a30\u0a40_\u0a2b\u0a3c\u0a30\u0a35\u0a30\u0a40_\u0a2e\u0a3e\u0a30\u0a1a_\u0a05\u0a2a\u0a4d\u0a30\u0a48\u0a32_\u0a2e\u0a08_\u0a1c\u0a42\u0a28_\u0a1c\u0a41\u0a32\u0a3e\u0a08_\u0a05\u0a17\u0a38\u0a24_\u0a38\u0a24\u0a70\u0a2c\u0a30_\u0a05\u0a15\u0a24\u0a42\u0a2c\u0a30_\u0a28\u0a35\u0a70\u0a2c\u0a30_\u0a26\u0a38\u0a70\u0a2c\u0a30".split(
                    "_"
                ),
                monthsShort:
                    "\u0a1c\u0a28\u0a35\u0a30\u0a40_\u0a2b\u0a3c\u0a30\u0a35\u0a30\u0a40_\u0a2e\u0a3e\u0a30\u0a1a_\u0a05\u0a2a\u0a4d\u0a30\u0a48\u0a32_\u0a2e\u0a08_\u0a1c\u0a42\u0a28_\u0a1c\u0a41\u0a32\u0a3e\u0a08_\u0a05\u0a17\u0a38\u0a24_\u0a38\u0a24\u0a70\u0a2c\u0a30_\u0a05\u0a15\u0a24\u0a42\u0a2c\u0a30_\u0a28\u0a35\u0a70\u0a2c\u0a30_\u0a26\u0a38\u0a70\u0a2c\u0a30".split(
                        "_"
                    ),
                weekdays:
                    "\u0a10\u0a24\u0a35\u0a3e\u0a30_\u0a38\u0a4b\u0a2e\u0a35\u0a3e\u0a30_\u0a2e\u0a70\u0a17\u0a32\u0a35\u0a3e\u0a30_\u0a2c\u0a41\u0a27\u0a35\u0a3e\u0a30_\u0a35\u0a40\u0a30\u0a35\u0a3e\u0a30_\u0a38\u0a3c\u0a41\u0a71\u0a15\u0a30\u0a35\u0a3e\u0a30_\u0a38\u0a3c\u0a28\u0a40\u0a1a\u0a30\u0a35\u0a3e\u0a30".split(
                        "_"
                    ),
                weekdaysShort:
                    "\u0a10\u0a24_\u0a38\u0a4b\u0a2e_\u0a2e\u0a70\u0a17\u0a32_\u0a2c\u0a41\u0a27_\u0a35\u0a40\u0a30_\u0a38\u0a3c\u0a41\u0a15\u0a30_\u0a38\u0a3c\u0a28\u0a40".split(
                        "_"
                    ),
                weekdaysMin:
                    "\u0a10\u0a24_\u0a38\u0a4b\u0a2e_\u0a2e\u0a70\u0a17\u0a32_\u0a2c\u0a41\u0a27_\u0a35\u0a40\u0a30_\u0a38\u0a3c\u0a41\u0a15\u0a30_\u0a38\u0a3c\u0a28\u0a40".split(
                        "_"
                    ),
                longDateFormat: {
                    LT: "A h:mm \u0a35\u0a1c\u0a47",
                    LTS: "A h:mm:ss \u0a35\u0a1c\u0a47",
                    L: "DD/MM/YYYY",
                    LL: "D MMMM YYYY",
                    LLL: "D MMMM YYYY, A h:mm \u0a35\u0a1c\u0a47",
                    LLLL: "dddd, D MMMM YYYY, A h:mm \u0a35\u0a1c\u0a47",
                },
                calendar: {
                    sameDay: "[\u0a05\u0a1c] LT",
                    nextDay: "[\u0a15\u0a32] LT",
                    nextWeek: "[\u0a05\u0a17\u0a32\u0a3e] dddd, LT",
                    lastDay: "[\u0a15\u0a32] LT",
                    lastWeek: "[\u0a2a\u0a3f\u0a1b\u0a32\u0a47] dddd, LT",
                    sameElse: "L",
                },
                relativeTime: {
                    future: "%s \u0a35\u0a3f\u0a71\u0a1a",
                    past: "%s \u0a2a\u0a3f\u0a1b\u0a32\u0a47",
                    s: "\u0a15\u0a41\u0a1d \u0a38\u0a15\u0a3f\u0a70\u0a1f",
                    ss: "%d \u0a38\u0a15\u0a3f\u0a70\u0a1f",
                    m: "\u0a07\u0a15 \u0a2e\u0a3f\u0a70\u0a1f",
                    mm: "%d \u0a2e\u0a3f\u0a70\u0a1f",
                    h: "\u0a07\u0a71\u0a15 \u0a18\u0a70\u0a1f\u0a3e",
                    hh: "%d \u0a18\u0a70\u0a1f\u0a47",
                    d: "\u0a07\u0a71\u0a15 \u0a26\u0a3f\u0a28",
                    dd: "%d \u0a26\u0a3f\u0a28",
                    M: "\u0a07\u0a71\u0a15 \u0a2e\u0a39\u0a40\u0a28\u0a3e",
                    MM: "%d \u0a2e\u0a39\u0a40\u0a28\u0a47",
                    y: "\u0a07\u0a71\u0a15 \u0a38\u0a3e\u0a32",
                    yy: "%d \u0a38\u0a3e\u0a32",
                },
                preparse: function (e) {
                    return e.replace(
                        /[\u0a67\u0a68\u0a69\u0a6a\u0a6b\u0a6c\u0a6d\u0a6e\u0a6f\u0a66]/g,
                        function (e) {
                            return cn[e];
                        }
                    );
                },
                postformat: function (e) {
                    return e.replace(/\d/g, function (e) {
                        return hn[e];
                    });
                },
                meridiemParse:
                    /\u0a30\u0a3e\u0a24|\u0a38\u0a35\u0a47\u0a30|\u0a26\u0a41\u0a2a\u0a39\u0a3f\u0a30|\u0a38\u0a3c\u0a3e\u0a2e/,
                meridiemHour: function (e, a) {
                    return (
                        12 === e && (e = 0),
                        "\u0a30\u0a3e\u0a24" === a
                            ? e < 4
                                ? e
                                : e + 12
                            : "\u0a38\u0a35\u0a47\u0a30" === a
                            ? e
                            : "\u0a26\u0a41\u0a2a\u0a39\u0a3f\u0a30" === a
                            ? 10 <= e
                                ? e
                                : e + 12
                            : "\u0a38\u0a3c\u0a3e\u0a2e" === a
                            ? e + 12
                            : void 0
                    );
                },
                meridiem: function (e, a, t) {
                    return e < 4
                        ? "\u0a30\u0a3e\u0a24"
                        : e < 10
                        ? "\u0a38\u0a35\u0a47\u0a30"
                        : e < 17
                        ? "\u0a26\u0a41\u0a2a\u0a39\u0a3f\u0a30"
                        : e < 20
                        ? "\u0a38\u0a3c\u0a3e\u0a2e"
                        : "\u0a30\u0a3e\u0a24";
                },
                week: { dow: 0, doy: 6 },
            }),
            "stycze\u0144_luty_marzec_kwiecie\u0144_maj_czerwiec_lipiec_sierpie\u0144_wrzesie\u0144_pa\u017adziernik_listopad_grudzie\u0144".split(
                "_"
            )),
        Yn =
            "stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_wrze\u015bnia_pa\u017adziernika_listopada_grudnia".split(
                "_"
            ),
        _ = [
            /^sty/i,
            /^lut/i,
            /^mar/i,
            /^kwi/i,
            /^maj/i,
            /^cze/i,
            /^lip/i,
            /^sie/i,
            /^wrz/i,
            /^pa\u017a/i,
            /^lis/i,
            /^gru/i,
        ];
    function yn(e) {
        return e % 10 < 5 && 1 < e % 10 && ~~(e / 10) % 10 != 1;
    }
    function fn(e, a, t) {
        var s = e + " ";
        switch (t) {
            case "ss":
                return s + (yn(e) ? "sekundy" : "sekund");
            case "m":
                return a ? "minuta" : "minut\u0119";
            case "mm":
                return s + (yn(e) ? "minuty" : "minut");
            case "h":
                return a ? "godzina" : "godzin\u0119";
            case "hh":
                return s + (yn(e) ? "godziny" : "godzin");
            case "ww":
                return s + (yn(e) ? "tygodnie" : "tygodni");
            case "MM":
                return s + (yn(e) ? "miesi\u0105ce" : "miesi\u0119cy");
            case "yy":
                return s + (yn(e) ? "lata" : "lat");
        }
    }
    function pn(e, a, t) {
        return (
            e +
            (20 <= e % 100 || (100 <= e && e % 100 == 0) ? " de " : " ") +
            {
                ss: "secunde",
                mm: "minute",
                hh: "ore",
                dd: "zile",
                ww: "s\u0103pt\u0103m\xe2ni",
                MM: "luni",
                yy: "ani",
            }[t]
        );
    }
    function kn(e, a, t) {
        return "m" === t
            ? a
                ? "\u043c\u0438\u043d\u0443\u0442\u0430"
                : "\u043c\u0438\u043d\u0443\u0442\u0443"
            : e +
                  " " +
                  ((e = +e),
                  (a = (a = {
                      ss: a
                          ? "\u0441\u0435\u043a\u0443\u043d\u0434\u0430_\u0441\u0435\u043a\u0443\u043d\u0434\u044b_\u0441\u0435\u043a\u0443\u043d\u0434"
                          : "\u0441\u0435\u043a\u0443\u043d\u0434\u0443_\u0441\u0435\u043a\u0443\u043d\u0434\u044b_\u0441\u0435\u043a\u0443\u043d\u0434",
                      mm: a
                          ? "\u043c\u0438\u043d\u0443\u0442\u0430_\u043c\u0438\u043d\u0443\u0442\u044b_\u043c\u0438\u043d\u0443\u0442"
                          : "\u043c\u0438\u043d\u0443\u0442\u0443_\u043c\u0438\u043d\u0443\u0442\u044b_\u043c\u0438\u043d\u0443\u0442",
                      hh: "\u0447\u0430\u0441_\u0447\u0430\u0441\u0430_\u0447\u0430\u0441\u043e\u0432",
                      dd: "\u0434\u0435\u043d\u044c_\u0434\u043d\u044f_\u0434\u043d\u0435\u0439",
                      ww: "\u043d\u0435\u0434\u0435\u043b\u044f_\u043d\u0435\u0434\u0435\u043b\u0438_\u043d\u0435\u0434\u0435\u043b\u044c",
                      MM: "\u043c\u0435\u0441\u044f\u0446_\u043c\u0435\u0441\u044f\u0446\u0430_\u043c\u0435\u0441\u044f\u0446\u0435\u0432",
                      yy: "\u0433\u043e\u0434_\u0433\u043e\u0434\u0430_\u043b\u0435\u0442",
                  }[t]).split("_")),
                  e % 10 == 1 && e % 100 != 11
                      ? a[0]
                      : 2 <= e % 10 &&
                        e % 10 <= 4 &&
                        (e % 100 < 10 || 20 <= e % 100)
                      ? a[1]
                      : a[2]);
    }
    M.defineLocale("pl", {
        months: function (e, a) {
            return e ? (/D MMMM/.test(a) ? Yn : Ln)[e.month()] : Ln;
        },
        monthsShort:
            "sty_lut_mar_kwi_maj_cze_lip_sie_wrz_pa\u017a_lis_gru".split("_"),
        monthsParse: _,
        longMonthsParse: _,
        shortMonthsParse: _,
        weekdays:
            "niedziela_poniedzia\u0142ek_wtorek_\u015broda_czwartek_pi\u0105tek_sobota".split(
                "_"
            ),
        weekdaysShort: "ndz_pon_wt_\u015br_czw_pt_sob".split("_"),
        weekdaysMin: "Nd_Pn_Wt_\u015ar_Cz_Pt_So".split("_"),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm",
        },
        calendar: {
            sameDay: "[Dzi\u015b o] LT",
            nextDay: "[Jutro o] LT",
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return "[W niedziel\u0119 o] LT";
                    case 2:
                        return "[We wtorek o] LT";
                    case 3:
                        return "[W \u015brod\u0119 o] LT";
                    case 6:
                        return "[W sobot\u0119 o] LT";
                    default:
                        return "[W] dddd [o] LT";
                }
            },
            lastDay: "[Wczoraj o] LT",
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return "[W zesz\u0142\u0105 niedziel\u0119 o] LT";
                    case 3:
                        return "[W zesz\u0142\u0105 \u015brod\u0119 o] LT";
                    case 6:
                        return "[W zesz\u0142\u0105 sobot\u0119 o] LT";
                    default:
                        return "[W zesz\u0142y] dddd [o] LT";
                }
            },
            sameElse: "L",
        },
        relativeTime: {
            future: "za %s",
            past: "%s temu",
            s: "kilka sekund",
            ss: fn,
            m: fn,
            mm: fn,
            h: fn,
            hh: fn,
            d: "1 dzie\u0144",
            dd: "%d dni",
            w: "tydzie\u0144",
            ww: fn,
            M: "miesi\u0105c",
            MM: fn,
            y: "rok",
            yy: fn,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: { dow: 1, doy: 4 },
    }),
        M.defineLocale("pt-br", {
            months: "janeiro_fevereiro_mar\xe7o_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro".split(
                "_"
            ),
            monthsShort:
                "jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez".split("_"),
            weekdays:
                "domingo_segunda-feira_ter\xe7a-feira_quarta-feira_quinta-feira_sexta-feira_s\xe1bado".split(
                    "_"
                ),
            weekdaysShort: "dom_seg_ter_qua_qui_sex_s\xe1b".split("_"),
            weekdaysMin: "do_2\xaa_3\xaa_4\xaa_5\xaa_6\xaa_s\xe1".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D [de] MMMM [de] YYYY",
                LLL: "D [de] MMMM [de] YYYY [\xe0s] HH:mm",
                LLLL: "dddd, D [de] MMMM [de] YYYY [\xe0s] HH:mm",
            },
            calendar: {
                sameDay: "[Hoje \xe0s] LT",
                nextDay: "[Amanh\xe3 \xe0s] LT",
                nextWeek: "dddd [\xe0s] LT",
                lastDay: "[Ontem \xe0s] LT",
                lastWeek: function () {
                    return 0 === this.day() || 6 === this.day()
                        ? "[\xdaltimo] dddd [\xe0s] LT"
                        : "[\xdaltima] dddd [\xe0s] LT";
                },
                sameElse: "L",
            },
            relativeTime: {
                future: "em %s",
                past: "h\xe1 %s",
                s: "poucos segundos",
                ss: "%d segundos",
                m: "um minuto",
                mm: "%d minutos",
                h: "uma hora",
                hh: "%d horas",
                d: "um dia",
                dd: "%d dias",
                M: "um m\xeas",
                MM: "%d meses",
                y: "um ano",
                yy: "%d anos",
            },
            dayOfMonthOrdinalParse: /\d{1,2}\xba/,
            ordinal: "%d\xba",
            invalidDate: "Data inv\xe1lida",
        }),
        M.defineLocale("pt", {
            months: "janeiro_fevereiro_mar\xe7o_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro".split(
                "_"
            ),
            monthsShort:
                "jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez".split("_"),
            weekdays:
                "Domingo_Segunda-feira_Ter\xe7a-feira_Quarta-feira_Quinta-feira_Sexta-feira_S\xe1bado".split(
                    "_"
                ),
            weekdaysShort: "Dom_Seg_Ter_Qua_Qui_Sex_S\xe1b".split("_"),
            weekdaysMin: "Do_2\xaa_3\xaa_4\xaa_5\xaa_6\xaa_S\xe1".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D [de] MMMM [de] YYYY",
                LLL: "D [de] MMMM [de] YYYY HH:mm",
                LLLL: "dddd, D [de] MMMM [de] YYYY HH:mm",
            },
            calendar: {
                sameDay: "[Hoje \xe0s] LT",
                nextDay: "[Amanh\xe3 \xe0s] LT",
                nextWeek: "dddd [\xe0s] LT",
                lastDay: "[Ontem \xe0s] LT",
                lastWeek: function () {
                    return 0 === this.day() || 6 === this.day()
                        ? "[\xdaltimo] dddd [\xe0s] LT"
                        : "[\xdaltima] dddd [\xe0s] LT";
                },
                sameElse: "L",
            },
            relativeTime: {
                future: "em %s",
                past: "h\xe1 %s",
                s: "segundos",
                ss: "%d segundos",
                m: "um minuto",
                mm: "%d minutos",
                h: "uma hora",
                hh: "%d horas",
                d: "um dia",
                dd: "%d dias",
                w: "uma semana",
                ww: "%d semanas",
                M: "um m\xeas",
                MM: "%d meses",
                y: "um ano",
                yy: "%d anos",
            },
            dayOfMonthOrdinalParse: /\d{1,2}\xba/,
            ordinal: "%d\xba",
            week: { dow: 1, doy: 4 },
        }),
        M.defineLocale("ro", {
            months: "ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie".split(
                "_"
            ),
            monthsShort:
                "ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.".split(
                    "_"
                ),
            monthsParseExact: !0,
            weekdays:
                "duminic\u0103_luni_mar\u021bi_miercuri_joi_vineri_s\xe2mb\u0103t\u0103".split(
                    "_"
                ),
            weekdaysShort: "Dum_Lun_Mar_Mie_Joi_Vin_S\xe2m".split("_"),
            weekdaysMin: "Du_Lu_Ma_Mi_Jo_Vi_S\xe2".split("_"),
            longDateFormat: {
                LT: "H:mm",
                LTS: "H:mm:ss",
                L: "DD.MM.YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY H:mm",
                LLLL: "dddd, D MMMM YYYY H:mm",
            },
            calendar: {
                sameDay: "[azi la] LT",
                nextDay: "[m\xe2ine la] LT",
                nextWeek: "dddd [la] LT",
                lastDay: "[ieri la] LT",
                lastWeek: "[fosta] dddd [la] LT",
                sameElse: "L",
            },
            relativeTime: {
                future: "peste %s",
                past: "%s \xeen urm\u0103",
                s: "c\xe2teva secunde",
                ss: pn,
                m: "un minut",
                mm: pn,
                h: "o or\u0103",
                hh: pn,
                d: "o zi",
                dd: pn,
                w: "o s\u0103pt\u0103m\xe2n\u0103",
                ww: pn,
                M: "o lun\u0103",
                MM: pn,
                y: "un an",
                yy: pn,
            },
            week: { dow: 1, doy: 7 },
        });
    (y = [
        /^\u044f\u043d\u0432/i,
        /^\u0444\u0435\u0432/i,
        /^\u043c\u0430\u0440/i,
        /^\u0430\u043f\u0440/i,
        /^\u043c\u0430[\u0439\u044f]/i,
        /^\u0438\u044e\u043d/i,
        /^\u0438\u044e\u043b/i,
        /^\u0430\u0432\u0433/i,
        /^\u0441\u0435\u043d/i,
        /^\u043e\u043a\u0442/i,
        /^\u043d\u043e\u044f/i,
        /^\u0434\u0435\u043a/i,
    ]),
        M.defineLocale("ru", {
            months: {
                format: "\u044f\u043d\u0432\u0430\u0440\u044f_\u0444\u0435\u0432\u0440\u0430\u043b\u044f_\u043c\u0430\u0440\u0442\u0430_\u0430\u043f\u0440\u0435\u043b\u044f_\u043c\u0430\u044f_\u0438\u044e\u043d\u044f_\u0438\u044e\u043b\u044f_\u0430\u0432\u0433\u0443\u0441\u0442\u0430_\u0441\u0435\u043d\u0442\u044f\u0431\u0440\u044f_\u043e\u043a\u0442\u044f\u0431\u0440\u044f_\u043d\u043e\u044f\u0431\u0440\u044f_\u0434\u0435\u043a\u0430\u0431\u0440\u044f".split(
                    "_"
                ),
                standalone:
                    "\u044f\u043d\u0432\u0430\u0440\u044c_\u0444\u0435\u0432\u0440\u0430\u043b\u044c_\u043c\u0430\u0440\u0442_\u0430\u043f\u0440\u0435\u043b\u044c_\u043c\u0430\u0439_\u0438\u044e\u043d\u044c_\u0438\u044e\u043b\u044c_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043d\u0442\u044f\u0431\u0440\u044c_\u043e\u043a\u0442\u044f\u0431\u0440\u044c_\u043d\u043e\u044f\u0431\u0440\u044c_\u0434\u0435\u043a\u0430\u0431\u0440\u044c".split(
                        "_"
                    ),
            },
            monthsShort: {
                format: "\u044f\u043d\u0432._\u0444\u0435\u0432\u0440._\u043c\u0430\u0440._\u0430\u043f\u0440._\u043c\u0430\u044f_\u0438\u044e\u043d\u044f_\u0438\u044e\u043b\u044f_\u0430\u0432\u0433._\u0441\u0435\u043d\u0442._\u043e\u043a\u0442._\u043d\u043e\u044f\u0431._\u0434\u0435\u043a.".split(
                    "_"
                ),
                standalone:
                    "\u044f\u043d\u0432._\u0444\u0435\u0432\u0440._\u043c\u0430\u0440\u0442_\u0430\u043f\u0440._\u043c\u0430\u0439_\u0438\u044e\u043d\u044c_\u0438\u044e\u043b\u044c_\u0430\u0432\u0433._\u0441\u0435\u043d\u0442._\u043e\u043a\u0442._\u043d\u043e\u044f\u0431._\u0434\u0435\u043a.".split(
                        "_"
                    ),
            },
            weekdays: {
                standalone:
                    "\u0432\u043e\u0441\u043a\u0440\u0435\u0441\u0435\u043d\u044c\u0435_\u043f\u043e\u043d\u0435\u0434\u0435\u043b\u044c\u043d\u0438\u043a_\u0432\u0442\u043e\u0440\u043d\u0438\u043a_\u0441\u0440\u0435\u0434\u0430_\u0447\u0435\u0442\u0432\u0435\u0440\u0433_\u043f\u044f\u0442\u043d\u0438\u0446\u0430_\u0441\u0443\u0431\u0431\u043e\u0442\u0430".split(
                        "_"
                    ),
                format: "\u0432\u043e\u0441\u043a\u0440\u0435\u0441\u0435\u043d\u044c\u0435_\u043f\u043e\u043d\u0435\u0434\u0435\u043b\u044c\u043d\u0438\u043a_\u0432\u0442\u043e\u0440\u043d\u0438\u043a_\u0441\u0440\u0435\u0434\u0443_\u0447\u0435\u0442\u0432\u0435\u0440\u0433_\u043f\u044f\u0442\u043d\u0438\u0446\u0443_\u0441\u0443\u0431\u0431\u043e\u0442\u0443".split(
                    "_"
                ),
                isFormat:
                    /\[ ?[\u0412\u0432] ?(?:\u043f\u0440\u043e\u0448\u043b\u0443\u044e|\u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0443\u044e|\u044d\u0442\u0443)? ?] ?dddd/,
            },
            weekdaysShort:
                "\u0432\u0441_\u043f\u043d_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043f\u0442_\u0441\u0431".split(
                    "_"
                ),
            weekdaysMin:
                "\u0432\u0441_\u043f\u043d_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043f\u0442_\u0441\u0431".split(
                    "_"
                ),
            monthsParse: y,
            longMonthsParse: y,
            shortMonthsParse: y,
            monthsRegex:
                /^(\u044f\u043d\u0432\u0430\u0440[\u044c\u044f]|\u044f\u043d\u0432\.?|\u0444\u0435\u0432\u0440\u0430\u043b[\u044c\u044f]|\u0444\u0435\u0432\u0440?\.?|\u043c\u0430\u0440\u0442\u0430?|\u043c\u0430\u0440\.?|\u0430\u043f\u0440\u0435\u043b[\u044c\u044f]|\u0430\u043f\u0440\.?|\u043c\u0430[\u0439\u044f]|\u0438\u044e\u043d[\u044c\u044f]|\u0438\u044e\u043d\.?|\u0438\u044e\u043b[\u044c\u044f]|\u0438\u044e\u043b\.?|\u0430\u0432\u0433\u0443\u0441\u0442\u0430?|\u0430\u0432\u0433\.?|\u0441\u0435\u043d\u0442\u044f\u0431\u0440[\u044c\u044f]|\u0441\u0435\u043d\u0442?\.?|\u043e\u043a\u0442\u044f\u0431\u0440[\u044c\u044f]|\u043e\u043a\u0442\.?|\u043d\u043e\u044f\u0431\u0440[\u044c\u044f]|\u043d\u043e\u044f\u0431?\.?|\u0434\u0435\u043a\u0430\u0431\u0440[\u044c\u044f]|\u0434\u0435\u043a\.?)/i,
            monthsShortRegex:
                /^(\u044f\u043d\u0432\u0430\u0440[\u044c\u044f]|\u044f\u043d\u0432\.?|\u0444\u0435\u0432\u0440\u0430\u043b[\u044c\u044f]|\u0444\u0435\u0432\u0440?\.?|\u043c\u0430\u0440\u0442\u0430?|\u043c\u0430\u0440\.?|\u0430\u043f\u0440\u0435\u043b[\u044c\u044f]|\u0430\u043f\u0440\.?|\u043c\u0430[\u0439\u044f]|\u0438\u044e\u043d[\u044c\u044f]|\u0438\u044e\u043d\.?|\u0438\u044e\u043b[\u044c\u044f]|\u0438\u044e\u043b\.?|\u0430\u0432\u0433\u0443\u0441\u0442\u0430?|\u0430\u0432\u0433\.?|\u0441\u0435\u043d\u0442\u044f\u0431\u0440[\u044c\u044f]|\u0441\u0435\u043d\u0442?\.?|\u043e\u043a\u0442\u044f\u0431\u0440[\u044c\u044f]|\u043e\u043a\u0442\.?|\u043d\u043e\u044f\u0431\u0440[\u044c\u044f]|\u043d\u043e\u044f\u0431?\.?|\u0434\u0435\u043a\u0430\u0431\u0440[\u044c\u044f]|\u0434\u0435\u043a\.?)/i,
            monthsStrictRegex:
                /^(\u044f\u043d\u0432\u0430\u0440[\u044f\u044c]|\u0444\u0435\u0432\u0440\u0430\u043b[\u044f\u044c]|\u043c\u0430\u0440\u0442\u0430?|\u0430\u043f\u0440\u0435\u043b[\u044f\u044c]|\u043c\u0430[\u044f\u0439]|\u0438\u044e\u043d[\u044f\u044c]|\u0438\u044e\u043b[\u044f\u044c]|\u0430\u0432\u0433\u0443\u0441\u0442\u0430?|\u0441\u0435\u043d\u0442\u044f\u0431\u0440[\u044f\u044c]|\u043e\u043a\u0442\u044f\u0431\u0440[\u044f\u044c]|\u043d\u043e\u044f\u0431\u0440[\u044f\u044c]|\u0434\u0435\u043a\u0430\u0431\u0440[\u044f\u044c])/i,
            monthsShortStrictRegex:
                /^(\u044f\u043d\u0432\.|\u0444\u0435\u0432\u0440?\.|\u043c\u0430\u0440[\u0442.]|\u0430\u043f\u0440\.|\u043c\u0430[\u044f\u0439]|\u0438\u044e\u043d[\u044c\u044f.]|\u0438\u044e\u043b[\u044c\u044f.]|\u0430\u0432\u0433\.|\u0441\u0435\u043d\u0442?\.|\u043e\u043a\u0442\.|\u043d\u043e\u044f\u0431?\.|\u0434\u0435\u043a\.)/i,
            longDateFormat: {
                LT: "H:mm",
                LTS: "H:mm:ss",
                L: "DD.MM.YYYY",
                LL: "D MMMM YYYY \u0433.",
                LLL: "D MMMM YYYY \u0433., H:mm",
                LLLL: "dddd, D MMMM YYYY \u0433., H:mm",
            },
            calendar: {
                sameDay:
                    "[\u0421\u0435\u0433\u043e\u0434\u043d\u044f, \u0432] LT",
                nextDay: "[\u0417\u0430\u0432\u0442\u0440\u0430, \u0432] LT",
                lastDay: "[\u0412\u0447\u0435\u0440\u0430, \u0432] LT",
                nextWeek: function (e) {
                    if (e.week() === this.week())
                        return 2 === this.day()
                            ? "[\u0412\u043e] dddd, [\u0432] LT"
                            : "[\u0412] dddd, [\u0432] LT";
                    switch (this.day()) {
                        case 0:
                            return "[\u0412 \u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0435\u0435] dddd, [\u0432] LT";
                        case 1:
                        case 2:
                        case 4:
                            return "[\u0412 \u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0438\u0439] dddd, [\u0432] LT";
                        case 3:
                        case 5:
                        case 6:
                            return "[\u0412 \u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0443\u044e] dddd, [\u0432] LT";
                    }
                },
                lastWeek: function (e) {
                    if (e.week() === this.week())
                        return 2 === this.day()
                            ? "[\u0412\u043e] dddd, [\u0432] LT"
                            : "[\u0412] dddd, [\u0432] LT";
                    switch (this.day()) {
                        case 0:
                            return "[\u0412 \u043f\u0440\u043e\u0448\u043b\u043e\u0435] dddd, [\u0432] LT";
                        case 1:
                        case 2:
                        case 4:
                            return "[\u0412 \u043f\u0440\u043e\u0448\u043b\u044b\u0439] dddd, [\u0432] LT";
                        case 3:
                        case 5:
                        case 6:
                            return "[\u0412 \u043f\u0440\u043e\u0448\u043b\u0443\u044e] dddd, [\u0432] LT";
                    }
                },
                sameElse: "L",
            },
            relativeTime: {
                future: "\u0447\u0435\u0440\u0435\u0437 %s",
                past: "%s \u043d\u0430\u0437\u0430\u0434",
                s: "\u043d\u0435\u0441\u043a\u043e\u043b\u044c\u043a\u043e \u0441\u0435\u043a\u0443\u043d\u0434",
                ss: kn,
                m: kn,
                mm: kn,
                h: "\u0447\u0430\u0441",
                hh: kn,
                d: "\u0434\u0435\u043d\u044c",
                dd: kn,
                w: "\u043d\u0435\u0434\u0435\u043b\u044f",
                ww: kn,
                M: "\u043c\u0435\u0441\u044f\u0446",
                MM: kn,
                y: "\u0433\u043e\u0434",
                yy: kn,
            },
            meridiemParse:
                /\u043d\u043e\u0447\u0438|\u0443\u0442\u0440\u0430|\u0434\u043d\u044f|\u0432\u0435\u0447\u0435\u0440\u0430/i,
            isPM: function (e) {
                return /^(\u0434\u043d\u044f|\u0432\u0435\u0447\u0435\u0440\u0430)$/.test(
                    e
                );
            },
            meridiem: function (e, a, t) {
                return e < 4
                    ? "\u043d\u043e\u0447\u0438"
                    : e < 12
                    ? "\u0443\u0442\u0440\u0430"
                    : e < 17
                    ? "\u0434\u043d\u044f"
                    : "\u0432\u0435\u0447\u0435\u0440\u0430";
            },
            dayOfMonthOrdinalParse: /\d{1,2}-(\u0439|\u0433\u043e|\u044f)/,
            ordinal: function (e, a) {
                switch (a) {
                    case "M":
                    case "d":
                    case "DDD":
                        return e + "-\u0439";
                    case "D":
                        return e + "-\u0433\u043e";
                    case "w":
                    case "W":
                        return e + "-\u044f";
                    default:
                        return e;
                }
            },
            week: { dow: 1, doy: 4 },
        }),
        (Y = [
            "\u062c\u0646\u0648\u0631\u064a",
            "\u0641\u064a\u0628\u0631\u0648\u0631\u064a",
            "\u0645\u0627\u0631\u0686",
            "\u0627\u067e\u0631\u064a\u0644",
            "\u0645\u0626\u064a",
            "\u062c\u0648\u0646",
            "\u062c\u0648\u0644\u0627\u0621\u0650",
            "\u0622\u06af\u0633\u067d",
            "\u0633\u064a\u067e\u067d\u0645\u0628\u0631",
            "\u0622\u06aa\u067d\u0648\u0628\u0631",
            "\u0646\u0648\u0645\u0628\u0631",
            "\u068a\u0633\u0645\u0628\u0631",
        ]),
        (Ke = [
            "\u0622\u0686\u0631",
            "\u0633\u0648\u0645\u0631",
            "\u0627\u06b1\u0627\u0631\u0648",
            "\u0627\u0631\u0628\u0639",
            "\u062e\u0645\u064a\u0633",
            "\u062c\u0645\u0639",
            "\u0687\u0646\u0687\u0631",
        ]),
        M.defineLocale("sd", {
            months: Y,
            monthsShort: Y,
            weekdays: Ke,
            weekdaysShort: Ke,
            weekdaysMin: Ke,
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd\u060c D MMMM YYYY HH:mm",
            },
            meridiemParse: /\u0635\u0628\u062d|\u0634\u0627\u0645/,
            isPM: function (e) {
                return "\u0634\u0627\u0645" === e;
            },
            meridiem: function (e, a, t) {
                return e < 12 ? "\u0635\u0628\u062d" : "\u0634\u0627\u0645";
            },
            calendar: {
                sameDay: "[\u0627\u0684] LT",
                nextDay: "[\u0633\u0680\u0627\u06bb\u064a] LT",
                nextWeek:
                    "dddd [\u0627\u06b3\u064a\u0646 \u0647\u0641\u062a\u064a \u062a\u064a] LT",
                lastDay: "[\u06aa\u0627\u0644\u0647\u0647] LT",
                lastWeek:
                    "[\u06af\u0632\u0631\u064a\u0644 \u0647\u0641\u062a\u064a] dddd [\u062a\u064a] LT",
                sameElse: "L",
            },
            relativeTime: {
                future: "%s \u067e\u0648\u0621",
                past: "%s \u0627\u06b3",
                s: "\u0686\u0646\u062f \u0633\u064a\u06aa\u0646\u068a",
                ss: "%d \u0633\u064a\u06aa\u0646\u068a",
                m: "\u0647\u06aa \u0645\u0646\u067d",
                mm: "%d \u0645\u0646\u067d",
                h: "\u0647\u06aa \u06aa\u0644\u0627\u06aa",
                hh: "%d \u06aa\u0644\u0627\u06aa",
                d: "\u0647\u06aa \u068f\u064a\u0646\u0647\u0646",
                dd: "%d \u068f\u064a\u0646\u0647\u0646",
                M: "\u0647\u06aa \u0645\u0647\u064a\u0646\u0648",
                MM: "%d \u0645\u0647\u064a\u0646\u0627",
                y: "\u0647\u06aa \u0633\u0627\u0644",
                yy: "%d \u0633\u0627\u0644",
            },
            preparse: function (e) {
                return e.replace(/\u060c/g, ",");
            },
            postformat: function (e) {
                return e.replace(/,/g, "\u060c");
            },
            week: { dow: 1, doy: 4 },
        }),
        M.defineLocale("se", {
            months: "o\u0111\u0111ajagem\xe1nnu_guovvam\xe1nnu_njuk\u010dam\xe1nnu_cuo\u014bom\xe1nnu_miessem\xe1nnu_geassem\xe1nnu_suoidnem\xe1nnu_borgem\xe1nnu_\u010dak\u010dam\xe1nnu_golggotm\xe1nnu_sk\xe1bmam\xe1nnu_juovlam\xe1nnu".split(
                "_"
            ),
            monthsShort:
                "o\u0111\u0111j_guov_njuk_cuo_mies_geas_suoi_borg_\u010dak\u010d_golg_sk\xe1b_juov".split(
                    "_"
                ),
            weekdays:
                "sotnabeaivi_vuoss\xe1rga_ma\u014b\u014beb\xe1rga_gaskavahkku_duorastat_bearjadat_l\xe1vvardat".split(
                    "_"
                ),
            weekdaysShort: "sotn_vuos_ma\u014b_gask_duor_bear_l\xe1v".split(
                "_"
            ),
            weekdaysMin: "s_v_m_g_d_b_L".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD.MM.YYYY",
                LL: "MMMM D. [b.] YYYY",
                LLL: "MMMM D. [b.] YYYY [ti.] HH:mm",
                LLLL: "dddd, MMMM D. [b.] YYYY [ti.] HH:mm",
            },
            calendar: {
                sameDay: "[otne ti] LT",
                nextDay: "[ihttin ti] LT",
                nextWeek: "dddd [ti] LT",
                lastDay: "[ikte ti] LT",
                lastWeek: "[ovddit] dddd [ti] LT",
                sameElse: "L",
            },
            relativeTime: {
                future: "%s gea\u017ees",
                past: "ma\u014bit %s",
                s: "moadde sekunddat",
                ss: "%d sekunddat",
                m: "okta minuhta",
                mm: "%d minuhtat",
                h: "okta diimmu",
                hh: "%d diimmut",
                d: "okta beaivi",
                dd: "%d beaivvit",
                M: "okta m\xe1nnu",
                MM: "%d m\xe1nut",
                y: "okta jahki",
                yy: "%d jagit",
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: { dow: 1, doy: 4 },
        }),
        M.defineLocale("si", {
            months: "\u0da2\u0db1\u0dc0\u0dcf\u0dbb\u0dd2_\u0db4\u0dd9\u0db6\u0dbb\u0dc0\u0dcf\u0dbb\u0dd2_\u0db8\u0dcf\u0dbb\u0dca\u0dad\u0dd4_\u0d85\u0db4\u0dca\u200d\u0dbb\u0dda\u0dbd\u0dca_\u0db8\u0dd0\u0dba\u0dd2_\u0da2\u0dd6\u0db1\u0dd2_\u0da2\u0dd6\u0dbd\u0dd2_\u0d85\u0d9c\u0ddd\u0dc3\u0dca\u0dad\u0dd4_\u0dc3\u0dd0\u0db4\u0dca\u0dad\u0dd0\u0db8\u0dca\u0db6\u0dbb\u0dca_\u0d94\u0d9a\u0dca\u0dad\u0ddd\u0db6\u0dbb\u0dca_\u0db1\u0ddc\u0dc0\u0dd0\u0db8\u0dca\u0db6\u0dbb\u0dca_\u0daf\u0dd9\u0dc3\u0dd0\u0db8\u0dca\u0db6\u0dbb\u0dca".split(
                "_"
            ),
            monthsShort:
                "\u0da2\u0db1_\u0db4\u0dd9\u0db6_\u0db8\u0dcf\u0dbb\u0dca_\u0d85\u0db4\u0dca_\u0db8\u0dd0\u0dba\u0dd2_\u0da2\u0dd6\u0db1\u0dd2_\u0da2\u0dd6\u0dbd\u0dd2_\u0d85\u0d9c\u0ddd_\u0dc3\u0dd0\u0db4\u0dca_\u0d94\u0d9a\u0dca_\u0db1\u0ddc\u0dc0\u0dd0_\u0daf\u0dd9\u0dc3\u0dd0".split(
                    "_"
                ),
            weekdays:
                "\u0d89\u0dbb\u0dd2\u0daf\u0dcf_\u0dc3\u0db3\u0dd4\u0daf\u0dcf_\u0d85\u0d9f\u0dc4\u0dbb\u0dd4\u0dc0\u0dcf\u0daf\u0dcf_\u0db6\u0daf\u0dcf\u0daf\u0dcf_\u0db6\u0dca\u200d\u0dbb\u0dc4\u0dc3\u0dca\u0db4\u0dad\u0dd2\u0db1\u0dca\u0daf\u0dcf_\u0dc3\u0dd2\u0d9a\u0dd4\u0dbb\u0dcf\u0daf\u0dcf_\u0dc3\u0dd9\u0db1\u0dc3\u0dd4\u0dbb\u0dcf\u0daf\u0dcf".split(
                    "_"
                ),
            weekdaysShort:
                "\u0d89\u0dbb\u0dd2_\u0dc3\u0db3\u0dd4_\u0d85\u0d9f_\u0db6\u0daf\u0dcf_\u0db6\u0dca\u200d\u0dbb\u0dc4_\u0dc3\u0dd2\u0d9a\u0dd4_\u0dc3\u0dd9\u0db1".split(
                    "_"
                ),
            weekdaysMin:
                "\u0d89_\u0dc3_\u0d85_\u0db6_\u0db6\u0dca\u200d\u0dbb_\u0dc3\u0dd2_\u0dc3\u0dd9".split(
                    "_"
                ),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "a h:mm",
                LTS: "a h:mm:ss",
                L: "YYYY/MM/DD",
                LL: "YYYY MMMM D",
                LLL: "YYYY MMMM D, a h:mm",
                LLLL: "YYYY MMMM D [\u0dc0\u0dd0\u0db1\u0dd2] dddd, a h:mm:ss",
            },
            calendar: {
                sameDay: "[\u0d85\u0daf] LT[\u0da7]",
                nextDay: "[\u0dc4\u0dd9\u0da7] LT[\u0da7]",
                nextWeek: "dddd LT[\u0da7]",
                lastDay: "[\u0d8a\u0dba\u0dda] LT[\u0da7]",
                lastWeek:
                    "[\u0db4\u0dc3\u0dd4\u0d9c\u0dd2\u0dba] dddd LT[\u0da7]",
                sameElse: "L",
            },
            relativeTime: {
                future: "%s\u0d9a\u0dd2\u0db1\u0dca",
                past: "%s\u0d9a\u0da7 \u0db4\u0dd9\u0dbb",
                s: "\u0dad\u0dad\u0dca\u0db4\u0dbb \u0d9a\u0dd2\u0dc4\u0dd2\u0db4\u0dba",
                ss: "\u0dad\u0dad\u0dca\u0db4\u0dbb %d",
                m: "\u0db8\u0dd2\u0db1\u0dd2\u0dad\u0dca\u0dad\u0dd4\u0dc0",
                mm: "\u0db8\u0dd2\u0db1\u0dd2\u0dad\u0dca\u0dad\u0dd4 %d",
                h: "\u0db4\u0dd0\u0dba",
                hh: "\u0db4\u0dd0\u0dba %d",
                d: "\u0daf\u0dd2\u0db1\u0dba",
                dd: "\u0daf\u0dd2\u0db1 %d",
                M: "\u0db8\u0dcf\u0dc3\u0dba",
                MM: "\u0db8\u0dcf\u0dc3 %d",
                y: "\u0dc0\u0dc3\u0dbb",
                yy: "\u0dc0\u0dc3\u0dbb %d",
            },
            dayOfMonthOrdinalParse: /\d{1,2} \u0dc0\u0dd0\u0db1\u0dd2/,
            ordinal: function (e) {
                return e + " \u0dc0\u0dd0\u0db1\u0dd2";
            },
            meridiemParse:
                /\u0db4\u0dd9\u0dbb \u0dc0\u0dbb\u0dd4|\u0db4\u0dc3\u0dca \u0dc0\u0dbb\u0dd4|\u0db4\u0dd9.\u0dc0|\u0db4.\u0dc0./,
            isPM: function (e) {
                return (
                    "\u0db4.\u0dc0." === e ||
                    "\u0db4\u0dc3\u0dca \u0dc0\u0dbb\u0dd4" === e
                );
            },
            meridiem: function (e, a, t) {
                return 11 < e
                    ? t
                        ? "\u0db4.\u0dc0."
                        : "\u0db4\u0dc3\u0dca \u0dc0\u0dbb\u0dd4"
                    : t
                    ? "\u0db4\u0dd9.\u0dc0."
                    : "\u0db4\u0dd9\u0dbb \u0dc0\u0dbb\u0dd4";
            },
        }),
        (Ht =
            "janu\xe1r_febru\xe1r_marec_apr\xedl_m\xe1j_j\xfan_j\xfal_august_september_okt\xf3ber_november_december".split(
                "_"
            )),
        (r = "jan_feb_mar_apr_m\xe1j_j\xfan_j\xfal_aug_sep_okt_nov_dec".split(
            "_"
        ));
    function Dn(e) {
        return 1 < e && e < 5;
    }
    function Tn(e, a, t, s) {
        var n = e + " ";
        switch (t) {
            case "s":
                return a || s ? "p\xe1r sek\xfand" : "p\xe1r sekundami";
            case "ss":
                return a || s
                    ? n + (Dn(e) ? "sekundy" : "sek\xfand")
                    : n + "sekundami";
            case "m":
                return a ? "min\xfata" : s ? "min\xfatu" : "min\xfatou";
            case "mm":
                return a || s
                    ? n + (Dn(e) ? "min\xfaty" : "min\xfat")
                    : n + "min\xfatami";
            case "h":
                return a ? "hodina" : s ? "hodinu" : "hodinou";
            case "hh":
                return a || s
                    ? n + (Dn(e) ? "hodiny" : "hod\xedn")
                    : n + "hodinami";
            case "d":
                return a || s ? "de\u0148" : "d\u0148om";
            case "dd":
                return a || s
                    ? n + (Dn(e) ? "dni" : "dn\xed")
                    : n + "d\u0148ami";
            case "M":
                return a || s ? "mesiac" : "mesiacom";
            case "MM":
                return a || s
                    ? n + (Dn(e) ? "mesiace" : "mesiacov")
                    : n + "mesiacmi";
            case "y":
                return a || s ? "rok" : "rokom";
            case "yy":
                return a || s ? n + (Dn(e) ? "roky" : "rokov") : n + "rokmi";
        }
    }
    function gn(e, a, t, s) {
        var n = e + " ";
        switch (t) {
            case "s":
                return a || s ? "nekaj sekund" : "nekaj sekundami";
            case "ss":
                return (n +=
                    1 === e
                        ? a
                            ? "sekundo"
                            : "sekundi"
                        : 2 === e
                        ? a || s
                            ? "sekundi"
                            : "sekundah"
                        : e < 5
                        ? a || s
                            ? "sekunde"
                            : "sekundah"
                        : "sekund");
            case "m":
                return a ? "ena minuta" : "eno minuto";
            case "mm":
                return (n +=
                    1 === e
                        ? a
                            ? "minuta"
                            : "minuto"
                        : 2 === e
                        ? a || s
                            ? "minuti"
                            : "minutama"
                        : e < 5
                        ? a || s
                            ? "minute"
                            : "minutami"
                        : a || s
                        ? "minut"
                        : "minutami");
            case "h":
                return a ? "ena ura" : "eno uro";
            case "hh":
                return (n +=
                    1 === e
                        ? a
                            ? "ura"
                            : "uro"
                        : 2 === e
                        ? a || s
                            ? "uri"
                            : "urama"
                        : e < 5
                        ? a || s
                            ? "ure"
                            : "urami"
                        : a || s
                        ? "ur"
                        : "urami");
            case "d":
                return a || s ? "en dan" : "enim dnem";
            case "dd":
                return (n +=
                    1 === e
                        ? a || s
                            ? "dan"
                            : "dnem"
                        : 2 === e
                        ? a || s
                            ? "dni"
                            : "dnevoma"
                        : a || s
                        ? "dni"
                        : "dnevi");
            case "M":
                return a || s ? "en mesec" : "enim mesecem";
            case "MM":
                return (n +=
                    1 === e
                        ? a || s
                            ? "mesec"
                            : "mesecem"
                        : 2 === e
                        ? a || s
                            ? "meseca"
                            : "mesecema"
                        : e < 5
                        ? a || s
                            ? "mesece"
                            : "meseci"
                        : a || s
                        ? "mesecev"
                        : "meseci");
            case "y":
                return a || s ? "eno leto" : "enim letom";
            case "yy":
                return (n +=
                    1 === e
                        ? a || s
                            ? "leto"
                            : "letom"
                        : 2 === e
                        ? a || s
                            ? "leti"
                            : "letoma"
                        : e < 5
                        ? a || s
                            ? "leta"
                            : "leti"
                        : a || s
                        ? "let"
                        : "leti");
        }
    }
    M.defineLocale("sk", {
        months: Ht,
        monthsShort: r,
        weekdays:
            "nede\u013ea_pondelok_utorok_streda_\u0161tvrtok_piatok_sobota".split(
                "_"
            ),
        weekdaysShort: "ne_po_ut_st_\u0161t_pi_so".split("_"),
        weekdaysMin: "ne_po_ut_st_\u0161t_pi_so".split("_"),
        longDateFormat: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D. MMMM YYYY",
            LLL: "D. MMMM YYYY H:mm",
            LLLL: "dddd D. MMMM YYYY H:mm",
        },
        calendar: {
            sameDay: "[dnes o] LT",
            nextDay: "[zajtra o] LT",
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return "[v nede\u013eu o] LT";
                    case 1:
                    case 2:
                        return "[v] dddd [o] LT";
                    case 3:
                        return "[v stredu o] LT";
                    case 4:
                        return "[vo \u0161tvrtok o] LT";
                    case 5:
                        return "[v piatok o] LT";
                    case 6:
                        return "[v sobotu o] LT";
                }
            },
            lastDay: "[v\u010dera o] LT",
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return "[minul\xfa nede\u013eu o] LT";
                    case 1:
                    case 2:
                        return "[minul\xfd] dddd [o] LT";
                    case 3:
                        return "[minul\xfa stredu o] LT";
                    case 4:
                    case 5:
                        return "[minul\xfd] dddd [o] LT";
                    case 6:
                        return "[minul\xfa sobotu o] LT";
                }
            },
            sameElse: "L",
        },
        relativeTime: {
            future: "za %s",
            past: "pred %s",
            s: Tn,
            ss: Tn,
            m: Tn,
            mm: Tn,
            h: Tn,
            hh: Tn,
            d: Tn,
            dd: Tn,
            M: Tn,
            MM: Tn,
            y: Tn,
            yy: Tn,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: { dow: 1, doy: 4 },
    }),
        M.defineLocale("sl", {
            months: "januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december".split(
                "_"
            ),
            monthsShort:
                "jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.".split(
                    "_"
                ),
            monthsParseExact: !0,
            weekdays:
                "nedelja_ponedeljek_torek_sreda_\u010detrtek_petek_sobota".split(
                    "_"
                ),
            weekdaysShort: "ned._pon._tor._sre._\u010det._pet._sob.".split("_"),
            weekdaysMin: "ne_po_to_sr_\u010de_pe_so".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "H:mm",
                LTS: "H:mm:ss",
                L: "DD. MM. YYYY",
                LL: "D. MMMM YYYY",
                LLL: "D. MMMM YYYY H:mm",
                LLLL: "dddd, D. MMMM YYYY H:mm",
            },
            calendar: {
                sameDay: "[danes ob] LT",
                nextDay: "[jutri ob] LT",
                nextWeek: function () {
                    switch (this.day()) {
                        case 0:
                            return "[v] [nedeljo] [ob] LT";
                        case 3:
                            return "[v] [sredo] [ob] LT";
                        case 6:
                            return "[v] [soboto] [ob] LT";
                        case 1:
                        case 2:
                        case 4:
                        case 5:
                            return "[v] dddd [ob] LT";
                    }
                },
                lastDay: "[v\u010deraj ob] LT",
                lastWeek: function () {
                    switch (this.day()) {
                        case 0:
                            return "[prej\u0161njo] [nedeljo] [ob] LT";
                        case 3:
                            return "[prej\u0161njo] [sredo] [ob] LT";
                        case 6:
                            return "[prej\u0161njo] [soboto] [ob] LT";
                        case 1:
                        case 2:
                        case 4:
                        case 5:
                            return "[prej\u0161nji] dddd [ob] LT";
                    }
                },
                sameElse: "L",
            },
            relativeTime: {
                future: "\u010dez %s",
                past: "pred %s",
                s: gn,
                ss: gn,
                m: gn,
                mm: gn,
                h: gn,
                hh: gn,
                d: gn,
                dd: gn,
                M: gn,
                MM: gn,
                y: gn,
                yy: gn,
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: { dow: 1, doy: 7 },
        }),
        M.defineLocale("sq", {
            months: "Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_N\xebntor_Dhjetor".split(
                "_"
            ),
            monthsShort:
                "Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_N\xebn_Dhj".split("_"),
            weekdays:
                "E Diel_E H\xebn\xeb_E Mart\xeb_E M\xebrkur\xeb_E Enjte_E Premte_E Shtun\xeb".split(
                    "_"
                ),
            weekdaysShort: "Die_H\xebn_Mar_M\xebr_Enj_Pre_Sht".split("_"),
            weekdaysMin: "D_H_Ma_M\xeb_E_P_Sh".split("_"),
            weekdaysParseExact: !0,
            meridiemParse: /PD|MD/,
            isPM: function (e) {
                return "M" === e.charAt(0);
            },
            meridiem: function (e, a, t) {
                return e < 12 ? "PD" : "MD";
            },
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd, D MMMM YYYY HH:mm",
            },
            calendar: {
                sameDay: "[Sot n\xeb] LT",
                nextDay: "[Nes\xebr n\xeb] LT",
                nextWeek: "dddd [n\xeb] LT",
                lastDay: "[Dje n\xeb] LT",
                lastWeek: "dddd [e kaluar n\xeb] LT",
                sameElse: "L",
            },
            relativeTime: {
                future: "n\xeb %s",
                past: "%s m\xeb par\xeb",
                s: "disa sekonda",
                ss: "%d sekonda",
                m: "nj\xeb minut\xeb",
                mm: "%d minuta",
                h: "nj\xeb or\xeb",
                hh: "%d or\xeb",
                d: "nj\xeb dit\xeb",
                dd: "%d dit\xeb",
                M: "nj\xeb muaj",
                MM: "%d muaj",
                y: "nj\xeb vit",
                yy: "%d vite",
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: { dow: 1, doy: 4 },
        });
    var W = {
            words: {
                ss: [
                    "\u0441\u0435\u043a\u0443\u043d\u0434\u0430",
                    "\u0441\u0435\u043a\u0443\u043d\u0434\u0435",
                    "\u0441\u0435\u043a\u0443\u043d\u0434\u0438",
                ],
                m: [
                    "\u0458\u0435\u0434\u0430\u043d \u043c\u0438\u043d\u0443\u0442",
                    "\u0458\u0435\u0434\u043d\u043e\u0433 \u043c\u0438\u043d\u0443\u0442\u0430",
                ],
                mm: [
                    "\u043c\u0438\u043d\u0443\u0442",
                    "\u043c\u0438\u043d\u0443\u0442\u0430",
                    "\u043c\u0438\u043d\u0443\u0442\u0430",
                ],
                h: [
                    "\u0458\u0435\u0434\u0430\u043d \u0441\u0430\u0442",
                    "\u0458\u0435\u0434\u043d\u043e\u0433 \u0441\u0430\u0442\u0430",
                ],
                hh: [
                    "\u0441\u0430\u0442",
                    "\u0441\u0430\u0442\u0430",
                    "\u0441\u0430\u0442\u0438",
                ],
                d: [
                    "\u0458\u0435\u0434\u0430\u043d \u0434\u0430\u043d",
                    "\u0458\u0435\u0434\u043d\u043e\u0433 \u0434\u0430\u043d\u0430",
                ],
                dd: [
                    "\u0434\u0430\u043d",
                    "\u0434\u0430\u043d\u0430",
                    "\u0434\u0430\u043d\u0430",
                ],
                M: [
                    "\u0458\u0435\u0434\u0430\u043d \u043c\u0435\u0441\u0435\u0446",
                    "\u0458\u0435\u0434\u043d\u043e\u0433 \u043c\u0435\u0441\u0435\u0446\u0430",
                ],
                MM: [
                    "\u043c\u0435\u0441\u0435\u0446",
                    "\u043c\u0435\u0441\u0435\u0446\u0430",
                    "\u043c\u0435\u0441\u0435\u0446\u0438",
                ],
                y: [
                    "\u0458\u0435\u0434\u043d\u0443 \u0433\u043e\u0434\u0438\u043d\u0443",
                    "\u0458\u0435\u0434\u043d\u0435 \u0433\u043e\u0434\u0438\u043d\u0435",
                ],
                yy: [
                    "\u0433\u043e\u0434\u0438\u043d\u0443",
                    "\u0433\u043e\u0434\u0438\u043d\u0435",
                    "\u0433\u043e\u0434\u0438\u043d\u0430",
                ],
            },
            correctGrammaticalCase: function (e, a) {
                return 1 <= e % 10 &&
                    e % 10 <= 4 &&
                    (e % 100 < 10 || 20 <= e % 100)
                    ? e % 10 == 1
                        ? a[0]
                        : a[1]
                    : a[2];
            },
            translate: function (e, a, t, s) {
                var n = W.words[t];
                return 1 === t.length
                    ? "y" === t && a
                        ? "\u0458\u0435\u0434\u043d\u0430 \u0433\u043e\u0434\u0438\u043d\u0430"
                        : s || a
                        ? n[0]
                        : n[1]
                    : ((s = W.correctGrammaticalCase(e, n)),
                      "yy" === t &&
                      a &&
                      "\u0433\u043e\u0434\u0438\u043d\u0443" === s
                          ? e + " \u0433\u043e\u0434\u0438\u043d\u0430"
                          : e + " " + s);
            },
        },
        A =
            (M.defineLocale("sr-cyrl", {
                months: "\u0458\u0430\u043d\u0443\u0430\u0440_\u0444\u0435\u0431\u0440\u0443\u0430\u0440_\u043c\u0430\u0440\u0442_\u0430\u043f\u0440\u0438\u043b_\u043c\u0430\u0458_\u0458\u0443\u043d_\u0458\u0443\u043b_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043f\u0442\u0435\u043c\u0431\u0430\u0440_\u043e\u043a\u0442\u043e\u0431\u0430\u0440_\u043d\u043e\u0432\u0435\u043c\u0431\u0430\u0440_\u0434\u0435\u0446\u0435\u043c\u0431\u0430\u0440".split(
                    "_"
                ),
                monthsShort:
                    "\u0458\u0430\u043d._\u0444\u0435\u0431._\u043c\u0430\u0440._\u0430\u043f\u0440._\u043c\u0430\u0458_\u0458\u0443\u043d_\u0458\u0443\u043b_\u0430\u0432\u0433._\u0441\u0435\u043f._\u043e\u043a\u0442._\u043d\u043e\u0432._\u0434\u0435\u0446.".split(
                        "_"
                    ),
                monthsParseExact: !0,
                weekdays:
                    "\u043d\u0435\u0434\u0435\u0459\u0430_\u043f\u043e\u043d\u0435\u0434\u0435\u0459\u0430\u043a_\u0443\u0442\u043e\u0440\u0430\u043a_\u0441\u0440\u0435\u0434\u0430_\u0447\u0435\u0442\u0432\u0440\u0442\u0430\u043a_\u043f\u0435\u0442\u0430\u043a_\u0441\u0443\u0431\u043e\u0442\u0430".split(
                        "_"
                    ),
                weekdaysShort:
                    "\u043d\u0435\u0434._\u043f\u043e\u043d._\u0443\u0442\u043e._\u0441\u0440\u0435._\u0447\u0435\u0442._\u043f\u0435\u0442._\u0441\u0443\u0431.".split(
                        "_"
                    ),
                weekdaysMin:
                    "\u043d\u0435_\u043f\u043e_\u0443\u0442_\u0441\u0440_\u0447\u0435_\u043f\u0435_\u0441\u0443".split(
                        "_"
                    ),
                weekdaysParseExact: !0,
                longDateFormat: {
                    LT: "H:mm",
                    LTS: "H:mm:ss",
                    L: "D. M. YYYY.",
                    LL: "D. MMMM YYYY.",
                    LLL: "D. MMMM YYYY. H:mm",
                    LLLL: "dddd, D. MMMM YYYY. H:mm",
                },
                calendar: {
                    sameDay: "[\u0434\u0430\u043d\u0430\u0441 \u0443] LT",
                    nextDay: "[\u0441\u0443\u0442\u0440\u0430 \u0443] LT",
                    nextWeek: function () {
                        switch (this.day()) {
                            case 0:
                                return "[\u0443] [\u043d\u0435\u0434\u0435\u0459\u0443] [\u0443] LT";
                            case 3:
                                return "[\u0443] [\u0441\u0440\u0435\u0434\u0443] [\u0443] LT";
                            case 6:
                                return "[\u0443] [\u0441\u0443\u0431\u043e\u0442\u0443] [\u0443] LT";
                            case 1:
                            case 2:
                            case 4:
                            case 5:
                                return "[\u0443] dddd [\u0443] LT";
                        }
                    },
                    lastDay: "[\u0458\u0443\u0447\u0435 \u0443] LT",
                    lastWeek: function () {
                        return [
                            "[\u043f\u0440\u043e\u0448\u043b\u0435] [\u043d\u0435\u0434\u0435\u0459\u0435] [\u0443] LT",
                            "[\u043f\u0440\u043e\u0448\u043b\u043e\u0433] [\u043f\u043e\u043d\u0435\u0434\u0435\u0459\u043a\u0430] [\u0443] LT",
                            "[\u043f\u0440\u043e\u0448\u043b\u043e\u0433] [\u0443\u0442\u043e\u0440\u043a\u0430] [\u0443] LT",
                            "[\u043f\u0440\u043e\u0448\u043b\u0435] [\u0441\u0440\u0435\u0434\u0435] [\u0443] LT",
                            "[\u043f\u0440\u043e\u0448\u043b\u043e\u0433] [\u0447\u0435\u0442\u0432\u0440\u0442\u043a\u0430] [\u0443] LT",
                            "[\u043f\u0440\u043e\u0448\u043b\u043e\u0433] [\u043f\u0435\u0442\u043a\u0430] [\u0443] LT",
                            "[\u043f\u0440\u043e\u0448\u043b\u0435] [\u0441\u0443\u0431\u043e\u0442\u0435] [\u0443] LT",
                        ][this.day()];
                    },
                    sameElse: "L",
                },
                relativeTime: {
                    future: "\u0437\u0430 %s",
                    past: "\u043f\u0440\u0435 %s",
                    s: "\u043d\u0435\u043a\u043e\u043b\u0438\u043a\u043e \u0441\u0435\u043a\u0443\u043d\u0434\u0438",
                    ss: W.translate,
                    m: W.translate,
                    mm: W.translate,
                    h: W.translate,
                    hh: W.translate,
                    d: W.translate,
                    dd: W.translate,
                    M: W.translate,
                    MM: W.translate,
                    y: W.translate,
                    yy: W.translate,
                },
                dayOfMonthOrdinalParse: /\d{1,2}\./,
                ordinal: "%d.",
                week: { dow: 1, doy: 7 },
            }),
            {
                words: {
                    ss: ["sekunda", "sekunde", "sekundi"],
                    m: ["jedan minut", "jednog minuta"],
                    mm: ["minut", "minuta", "minuta"],
                    h: ["jedan sat", "jednog sata"],
                    hh: ["sat", "sata", "sati"],
                    d: ["jedan dan", "jednog dana"],
                    dd: ["dan", "dana", "dana"],
                    M: ["jedan mesec", "jednog meseca"],
                    MM: ["mesec", "meseca", "meseci"],
                    y: ["jednu godinu", "jedne godine"],
                    yy: ["godinu", "godine", "godina"],
                },
                correctGrammaticalCase: function (e, a) {
                    return 1 <= e % 10 &&
                        e % 10 <= 4 &&
                        (e % 100 < 10 || 20 <= e % 100)
                        ? e % 10 == 1
                            ? a[0]
                            : a[1]
                        : a[2];
                },
                translate: function (e, a, t, s) {
                    var n = A.words[t];
                    return 1 === t.length
                        ? "y" === t && a
                            ? "jedna godina"
                            : s || a
                            ? n[0]
                            : n[1]
                        : ((s = A.correctGrammaticalCase(e, n)),
                          "yy" === t && a && "godinu" === s
                              ? e + " godina"
                              : e + " " + s);
                },
            }),
        wn =
            (M.defineLocale("sr", {
                months: "januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar".split(
                    "_"
                ),
                monthsShort:
                    "jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.".split(
                        "_"
                    ),
                monthsParseExact: !0,
                weekdays:
                    "nedelja_ponedeljak_utorak_sreda_\u010detvrtak_petak_subota".split(
                        "_"
                    ),
                weekdaysShort: "ned._pon._uto._sre._\u010det._pet._sub.".split(
                    "_"
                ),
                weekdaysMin: "ne_po_ut_sr_\u010de_pe_su".split("_"),
                weekdaysParseExact: !0,
                longDateFormat: {
                    LT: "H:mm",
                    LTS: "H:mm:ss",
                    L: "D. M. YYYY.",
                    LL: "D. MMMM YYYY.",
                    LLL: "D. MMMM YYYY. H:mm",
                    LLLL: "dddd, D. MMMM YYYY. H:mm",
                },
                calendar: {
                    sameDay: "[danas u] LT",
                    nextDay: "[sutra u] LT",
                    nextWeek: function () {
                        switch (this.day()) {
                            case 0:
                                return "[u] [nedelju] [u] LT";
                            case 3:
                                return "[u] [sredu] [u] LT";
                            case 6:
                                return "[u] [subotu] [u] LT";
                            case 1:
                            case 2:
                            case 4:
                            case 5:
                                return "[u] dddd [u] LT";
                        }
                    },
                    lastDay: "[ju\u010de u] LT",
                    lastWeek: function () {
                        return [
                            "[pro\u0161le] [nedelje] [u] LT",
                            "[pro\u0161log] [ponedeljka] [u] LT",
                            "[pro\u0161log] [utorka] [u] LT",
                            "[pro\u0161le] [srede] [u] LT",
                            "[pro\u0161log] [\u010detvrtka] [u] LT",
                            "[pro\u0161log] [petka] [u] LT",
                            "[pro\u0161le] [subote] [u] LT",
                        ][this.day()];
                    },
                    sameElse: "L",
                },
                relativeTime: {
                    future: "za %s",
                    past: "pre %s",
                    s: "nekoliko sekundi",
                    ss: A.translate,
                    m: A.translate,
                    mm: A.translate,
                    h: A.translate,
                    hh: A.translate,
                    d: A.translate,
                    dd: A.translate,
                    M: A.translate,
                    MM: A.translate,
                    y: A.translate,
                    yy: A.translate,
                },
                dayOfMonthOrdinalParse: /\d{1,2}\./,
                ordinal: "%d.",
                week: { dow: 1, doy: 7 },
            }),
            M.defineLocale("ss", {
                months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
                    "_"
                ),
                monthsShort:
                    "Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo".split(
                        "_"
                    ),
                weekdays:
                    "Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo".split(
                        "_"
                    ),
                weekdaysShort: "Lis_Umb_Lsb_Les_Lsi_Lsh_Umg".split("_"),
                weekdaysMin: "Li_Us_Lb_Lt_Ls_Lh_Ug".split("_"),
                weekdaysParseExact: !0,
                longDateFormat: {
                    LT: "h:mm A",
                    LTS: "h:mm:ss A",
                    L: "DD/MM/YYYY",
                    LL: "D MMMM YYYY",
                    LLL: "D MMMM YYYY h:mm A",
                    LLLL: "dddd, D MMMM YYYY h:mm A",
                },
                calendar: {
                    sameDay: "[Namuhla nga] LT",
                    nextDay: "[Kusasa nga] LT",
                    nextWeek: "dddd [nga] LT",
                    lastDay: "[Itolo nga] LT",
                    lastWeek: "dddd [leliphelile] [nga] LT",
                    sameElse: "L",
                },
                relativeTime: {
                    future: "nga %s",
                    past: "wenteka nga %s",
                    s: "emizuzwana lomcane",
                    ss: "%d mzuzwana",
                    m: "umzuzu",
                    mm: "%d emizuzu",
                    h: "lihora",
                    hh: "%d emahora",
                    d: "lilanga",
                    dd: "%d emalanga",
                    M: "inyanga",
                    MM: "%d tinyanga",
                    y: "umnyaka",
                    yy: "%d iminyaka",
                },
                meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
                meridiem: function (e, a, t) {
                    return e < 11
                        ? "ekuseni"
                        : e < 15
                        ? "emini"
                        : e < 19
                        ? "entsambama"
                        : "ebusuku";
                },
                meridiemHour: function (e, a) {
                    return (
                        12 === e && (e = 0),
                        "ekuseni" === a
                            ? e
                            : "emini" === a
                            ? 11 <= e
                                ? e
                                : e + 12
                            : "entsambama" === a || "ebusuku" === a
                            ? 0 === e
                                ? 0
                                : e + 12
                            : void 0
                    );
                },
                dayOfMonthOrdinalParse: /\d{1,2}/,
                ordinal: "%d",
                week: { dow: 1, doy: 4 },
            }),
            M.defineLocale("sv", {
                months: "januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december".split(
                    "_"
                ),
                monthsShort:
                    "jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec".split(
                        "_"
                    ),
                weekdays:
                    "s\xf6ndag_m\xe5ndag_tisdag_onsdag_torsdag_fredag_l\xf6rdag".split(
                        "_"
                    ),
                weekdaysShort: "s\xf6n_m\xe5n_tis_ons_tor_fre_l\xf6r".split(
                    "_"
                ),
                weekdaysMin: "s\xf6_m\xe5_ti_on_to_fr_l\xf6".split("_"),
                longDateFormat: {
                    LT: "HH:mm",
                    LTS: "HH:mm:ss",
                    L: "YYYY-MM-DD",
                    LL: "D MMMM YYYY",
                    LLL: "D MMMM YYYY [kl.] HH:mm",
                    LLLL: "dddd D MMMM YYYY [kl.] HH:mm",
                    lll: "D MMM YYYY HH:mm",
                    llll: "ddd D MMM YYYY HH:mm",
                },
                calendar: {
                    sameDay: "[Idag] LT",
                    nextDay: "[Imorgon] LT",
                    lastDay: "[Ig\xe5r] LT",
                    nextWeek: "[P\xe5] dddd LT",
                    lastWeek: "[I] dddd[s] LT",
                    sameElse: "L",
                },
                relativeTime: {
                    future: "om %s",
                    past: "f\xf6r %s sedan",
                    s: "n\xe5gra sekunder",
                    ss: "%d sekunder",
                    m: "en minut",
                    mm: "%d minuter",
                    h: "en timme",
                    hh: "%d timmar",
                    d: "en dag",
                    dd: "%d dagar",
                    M: "en m\xe5nad",
                    MM: "%d m\xe5nader",
                    y: "ett \xe5r",
                    yy: "%d \xe5r",
                },
                dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
                ordinal: function (e) {
                    var a = e % 10;
                    return (
                        e +
                        (1 != ~~((e % 100) / 10) && (1 == a || 2 == a)
                            ? ":a"
                            : ":e")
                    );
                },
                week: { dow: 1, doy: 4 },
            }),
            M.defineLocale("sw", {
                months: "Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba".split(
                    "_"
                ),
                monthsShort:
                    "Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des".split(
                        "_"
                    ),
                weekdays:
                    "Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi".split(
                        "_"
                    ),
                weekdaysShort: "Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos".split("_"),
                weekdaysMin: "J2_J3_J4_J5_Al_Ij_J1".split("_"),
                weekdaysParseExact: !0,
                longDateFormat: {
                    LT: "hh:mm A",
                    LTS: "HH:mm:ss",
                    L: "DD.MM.YYYY",
                    LL: "D MMMM YYYY",
                    LLL: "D MMMM YYYY HH:mm",
                    LLLL: "dddd, D MMMM YYYY HH:mm",
                },
                calendar: {
                    sameDay: "[leo saa] LT",
                    nextDay: "[kesho saa] LT",
                    nextWeek: "[wiki ijayo] dddd [saat] LT",
                    lastDay: "[jana] LT",
                    lastWeek: "[wiki iliyopita] dddd [saat] LT",
                    sameElse: "L",
                },
                relativeTime: {
                    future: "%s baadaye",
                    past: "tokea %s",
                    s: "hivi punde",
                    ss: "sekunde %d",
                    m: "dakika moja",
                    mm: "dakika %d",
                    h: "saa limoja",
                    hh: "masaa %d",
                    d: "siku moja",
                    dd: "siku %d",
                    M: "mwezi mmoja",
                    MM: "miezi %d",
                    y: "mwaka mmoja",
                    yy: "miaka %d",
                },
                week: { dow: 1, doy: 7 },
            }),
            {
                1: "\u0be7",
                2: "\u0be8",
                3: "\u0be9",
                4: "\u0bea",
                5: "\u0beb",
                6: "\u0bec",
                7: "\u0bed",
                8: "\u0bee",
                9: "\u0bef",
                0: "\u0be6",
            }),
        bn = {
            "\u0be7": "1",
            "\u0be8": "2",
            "\u0be9": "3",
            "\u0bea": "4",
            "\u0beb": "5",
            "\u0bec": "6",
            "\u0bed": "7",
            "\u0bee": "8",
            "\u0bef": "9",
            "\u0be6": "0",
        },
        Sn =
            (M.defineLocale("ta", {
                months: "\u0b9c\u0ba9\u0bb5\u0bb0\u0bbf_\u0baa\u0bbf\u0baa\u0bcd\u0bb0\u0bb5\u0bb0\u0bbf_\u0bae\u0bbe\u0bb0\u0bcd\u0b9a\u0bcd_\u0b8f\u0baa\u0bcd\u0bb0\u0bb2\u0bcd_\u0bae\u0bc7_\u0b9c\u0bc2\u0ba9\u0bcd_\u0b9c\u0bc2\u0bb2\u0bc8_\u0b86\u0b95\u0bb8\u0bcd\u0b9f\u0bcd_\u0b9a\u0bc6\u0baa\u0bcd\u0b9f\u0bc6\u0bae\u0bcd\u0baa\u0bb0\u0bcd_\u0b85\u0b95\u0bcd\u0b9f\u0bc7\u0bbe\u0baa\u0bb0\u0bcd_\u0ba8\u0bb5\u0bae\u0bcd\u0baa\u0bb0\u0bcd_\u0b9f\u0bbf\u0b9a\u0bae\u0bcd\u0baa\u0bb0\u0bcd".split(
                    "_"
                ),
                monthsShort:
                    "\u0b9c\u0ba9\u0bb5\u0bb0\u0bbf_\u0baa\u0bbf\u0baa\u0bcd\u0bb0\u0bb5\u0bb0\u0bbf_\u0bae\u0bbe\u0bb0\u0bcd\u0b9a\u0bcd_\u0b8f\u0baa\u0bcd\u0bb0\u0bb2\u0bcd_\u0bae\u0bc7_\u0b9c\u0bc2\u0ba9\u0bcd_\u0b9c\u0bc2\u0bb2\u0bc8_\u0b86\u0b95\u0bb8\u0bcd\u0b9f\u0bcd_\u0b9a\u0bc6\u0baa\u0bcd\u0b9f\u0bc6\u0bae\u0bcd\u0baa\u0bb0\u0bcd_\u0b85\u0b95\u0bcd\u0b9f\u0bc7\u0bbe\u0baa\u0bb0\u0bcd_\u0ba8\u0bb5\u0bae\u0bcd\u0baa\u0bb0\u0bcd_\u0b9f\u0bbf\u0b9a\u0bae\u0bcd\u0baa\u0bb0\u0bcd".split(
                        "_"
                    ),
                weekdays:
                    "\u0b9e\u0bbe\u0baf\u0bbf\u0bb1\u0bcd\u0bb1\u0bc1\u0b95\u0bcd\u0b95\u0bbf\u0bb4\u0bae\u0bc8_\u0ba4\u0bbf\u0b99\u0bcd\u0b95\u0b9f\u0bcd\u0b95\u0bbf\u0bb4\u0bae\u0bc8_\u0b9a\u0bc6\u0bb5\u0bcd\u0bb5\u0bbe\u0baf\u0bcd\u0b95\u0bbf\u0bb4\u0bae\u0bc8_\u0baa\u0bc1\u0ba4\u0ba9\u0bcd\u0b95\u0bbf\u0bb4\u0bae\u0bc8_\u0bb5\u0bbf\u0baf\u0bbe\u0bb4\u0b95\u0bcd\u0b95\u0bbf\u0bb4\u0bae\u0bc8_\u0bb5\u0bc6\u0bb3\u0bcd\u0bb3\u0bbf\u0b95\u0bcd\u0b95\u0bbf\u0bb4\u0bae\u0bc8_\u0b9a\u0ba9\u0bbf\u0b95\u0bcd\u0b95\u0bbf\u0bb4\u0bae\u0bc8".split(
                        "_"
                    ),
                weekdaysShort:
                    "\u0b9e\u0bbe\u0baf\u0bbf\u0bb1\u0bc1_\u0ba4\u0bbf\u0b99\u0bcd\u0b95\u0bb3\u0bcd_\u0b9a\u0bc6\u0bb5\u0bcd\u0bb5\u0bbe\u0baf\u0bcd_\u0baa\u0bc1\u0ba4\u0ba9\u0bcd_\u0bb5\u0bbf\u0baf\u0bbe\u0bb4\u0ba9\u0bcd_\u0bb5\u0bc6\u0bb3\u0bcd\u0bb3\u0bbf_\u0b9a\u0ba9\u0bbf".split(
                        "_"
                    ),
                weekdaysMin:
                    "\u0b9e\u0bbe_\u0ba4\u0bbf_\u0b9a\u0bc6_\u0baa\u0bc1_\u0bb5\u0bbf_\u0bb5\u0bc6_\u0b9a".split(
                        "_"
                    ),
                longDateFormat: {
                    LT: "HH:mm",
                    LTS: "HH:mm:ss",
                    L: "DD/MM/YYYY",
                    LL: "D MMMM YYYY",
                    LLL: "D MMMM YYYY, HH:mm",
                    LLLL: "dddd, D MMMM YYYY, HH:mm",
                },
                calendar: {
                    sameDay: "[\u0b87\u0ba9\u0bcd\u0bb1\u0bc1] LT",
                    nextDay: "[\u0ba8\u0bbe\u0bb3\u0bc8] LT",
                    nextWeek: "dddd, LT",
                    lastDay: "[\u0ba8\u0bc7\u0bb1\u0bcd\u0bb1\u0bc1] LT",
                    lastWeek:
                        "[\u0b95\u0b9f\u0ba8\u0bcd\u0ba4 \u0bb5\u0bbe\u0bb0\u0bae\u0bcd] dddd, LT",
                    sameElse: "L",
                },
                relativeTime: {
                    future: "%s \u0b87\u0bb2\u0bcd",
                    past: "%s \u0bae\u0bc1\u0ba9\u0bcd",
                    s: "\u0b92\u0bb0\u0bc1 \u0b9a\u0bbf\u0bb2 \u0bb5\u0bbf\u0ba8\u0bbe\u0b9f\u0bbf\u0b95\u0bb3\u0bcd",
                    ss: "%d \u0bb5\u0bbf\u0ba8\u0bbe\u0b9f\u0bbf\u0b95\u0bb3\u0bcd",
                    m: "\u0b92\u0bb0\u0bc1 \u0ba8\u0bbf\u0bae\u0bbf\u0b9f\u0bae\u0bcd",
                    mm: "%d \u0ba8\u0bbf\u0bae\u0bbf\u0b9f\u0b99\u0bcd\u0b95\u0bb3\u0bcd",
                    h: "\u0b92\u0bb0\u0bc1 \u0bae\u0ba3\u0bbf \u0ba8\u0bc7\u0bb0\u0bae\u0bcd",
                    hh: "%d \u0bae\u0ba3\u0bbf \u0ba8\u0bc7\u0bb0\u0bae\u0bcd",
                    d: "\u0b92\u0bb0\u0bc1 \u0ba8\u0bbe\u0bb3\u0bcd",
                    dd: "%d \u0ba8\u0bbe\u0b9f\u0bcd\u0b95\u0bb3\u0bcd",
                    M: "\u0b92\u0bb0\u0bc1 \u0bae\u0bbe\u0ba4\u0bae\u0bcd",
                    MM: "%d \u0bae\u0bbe\u0ba4\u0b99\u0bcd\u0b95\u0bb3\u0bcd",
                    y: "\u0b92\u0bb0\u0bc1 \u0bb5\u0bb0\u0bc1\u0b9f\u0bae\u0bcd",
                    yy: "%d \u0b86\u0ba3\u0bcd\u0b9f\u0bc1\u0b95\u0bb3\u0bcd",
                },
                dayOfMonthOrdinalParse: /\d{1,2}\u0bb5\u0ba4\u0bc1/,
                ordinal: function (e) {
                    return e + "\u0bb5\u0ba4\u0bc1";
                },
                preparse: function (e) {
                    return e.replace(
                        /[\u0be7\u0be8\u0be9\u0bea\u0beb\u0bec\u0bed\u0bee\u0bef\u0be6]/g,
                        function (e) {
                            return bn[e];
                        }
                    );
                },
                postformat: function (e) {
                    return e.replace(/\d/g, function (e) {
                        return wn[e];
                    });
                },
                meridiemParse:
                    /\u0baf\u0bbe\u0bae\u0bae\u0bcd|\u0bb5\u0bc8\u0b95\u0bb1\u0bc8|\u0b95\u0bbe\u0bb2\u0bc8|\u0ba8\u0ba3\u0bcd\u0baa\u0b95\u0bb2\u0bcd|\u0b8e\u0bb1\u0bcd\u0baa\u0bbe\u0b9f\u0bc1|\u0bae\u0bbe\u0bb2\u0bc8/,
                meridiem: function (e, a, t) {
                    return e < 2
                        ? " \u0baf\u0bbe\u0bae\u0bae\u0bcd"
                        : e < 6
                        ? " \u0bb5\u0bc8\u0b95\u0bb1\u0bc8"
                        : e < 10
                        ? " \u0b95\u0bbe\u0bb2\u0bc8"
                        : e < 14
                        ? " \u0ba8\u0ba3\u0bcd\u0baa\u0b95\u0bb2\u0bcd"
                        : e < 18
                        ? " \u0b8e\u0bb1\u0bcd\u0baa\u0bbe\u0b9f\u0bc1"
                        : e < 22
                        ? " \u0bae\u0bbe\u0bb2\u0bc8"
                        : " \u0baf\u0bbe\u0bae\u0bae\u0bcd";
                },
                meridiemHour: function (e, a) {
                    return (
                        12 === e && (e = 0),
                        "\u0baf\u0bbe\u0bae\u0bae\u0bcd" === a
                            ? e < 2
                                ? e
                                : e + 12
                            : "\u0bb5\u0bc8\u0b95\u0bb1\u0bc8" === a ||
                              "\u0b95\u0bbe\u0bb2\u0bc8" === a ||
                              ("\u0ba8\u0ba3\u0bcd\u0baa\u0b95\u0bb2\u0bcd" ===
                                  a &&
                                  10 <= e)
                            ? e
                            : e + 12
                    );
                },
                week: { dow: 0, doy: 6 },
            }),
            M.defineLocale("te", {
                months: "\u0c1c\u0c28\u0c35\u0c30\u0c3f_\u0c2b\u0c3f\u0c2c\u0c4d\u0c30\u0c35\u0c30\u0c3f_\u0c2e\u0c3e\u0c30\u0c4d\u0c1a\u0c3f_\u0c0f\u0c2a\u0c4d\u0c30\u0c3f\u0c32\u0c4d_\u0c2e\u0c47_\u0c1c\u0c42\u0c28\u0c4d_\u0c1c\u0c41\u0c32\u0c48_\u0c06\u0c17\u0c38\u0c4d\u0c1f\u0c41_\u0c38\u0c46\u0c2a\u0c4d\u0c1f\u0c46\u0c02\u0c2c\u0c30\u0c4d_\u0c05\u0c15\u0c4d\u0c1f\u0c4b\u0c2c\u0c30\u0c4d_\u0c28\u0c35\u0c02\u0c2c\u0c30\u0c4d_\u0c21\u0c3f\u0c38\u0c46\u0c02\u0c2c\u0c30\u0c4d".split(
                    "_"
                ),
                monthsShort:
                    "\u0c1c\u0c28._\u0c2b\u0c3f\u0c2c\u0c4d\u0c30._\u0c2e\u0c3e\u0c30\u0c4d\u0c1a\u0c3f_\u0c0f\u0c2a\u0c4d\u0c30\u0c3f._\u0c2e\u0c47_\u0c1c\u0c42\u0c28\u0c4d_\u0c1c\u0c41\u0c32\u0c48_\u0c06\u0c17._\u0c38\u0c46\u0c2a\u0c4d._\u0c05\u0c15\u0c4d\u0c1f\u0c4b._\u0c28\u0c35._\u0c21\u0c3f\u0c38\u0c46.".split(
                        "_"
                    ),
                monthsParseExact: !0,
                weekdays:
                    "\u0c06\u0c26\u0c3f\u0c35\u0c3e\u0c30\u0c02_\u0c38\u0c4b\u0c2e\u0c35\u0c3e\u0c30\u0c02_\u0c2e\u0c02\u0c17\u0c33\u0c35\u0c3e\u0c30\u0c02_\u0c2c\u0c41\u0c27\u0c35\u0c3e\u0c30\u0c02_\u0c17\u0c41\u0c30\u0c41\u0c35\u0c3e\u0c30\u0c02_\u0c36\u0c41\u0c15\u0c4d\u0c30\u0c35\u0c3e\u0c30\u0c02_\u0c36\u0c28\u0c3f\u0c35\u0c3e\u0c30\u0c02".split(
                        "_"
                    ),
                weekdaysShort:
                    "\u0c06\u0c26\u0c3f_\u0c38\u0c4b\u0c2e_\u0c2e\u0c02\u0c17\u0c33_\u0c2c\u0c41\u0c27_\u0c17\u0c41\u0c30\u0c41_\u0c36\u0c41\u0c15\u0c4d\u0c30_\u0c36\u0c28\u0c3f".split(
                        "_"
                    ),
                weekdaysMin:
                    "\u0c06_\u0c38\u0c4b_\u0c2e\u0c02_\u0c2c\u0c41_\u0c17\u0c41_\u0c36\u0c41_\u0c36".split(
                        "_"
                    ),
                longDateFormat: {
                    LT: "A h:mm",
                    LTS: "A h:mm:ss",
                    L: "DD/MM/YYYY",
                    LL: "D MMMM YYYY",
                    LLL: "D MMMM YYYY, A h:mm",
                    LLLL: "dddd, D MMMM YYYY, A h:mm",
                },
                calendar: {
                    sameDay: "[\u0c28\u0c47\u0c21\u0c41] LT",
                    nextDay: "[\u0c30\u0c47\u0c2a\u0c41] LT",
                    nextWeek: "dddd, LT",
                    lastDay: "[\u0c28\u0c3f\u0c28\u0c4d\u0c28] LT",
                    lastWeek: "[\u0c17\u0c24] dddd, LT",
                    sameElse: "L",
                },
                relativeTime: {
                    future: "%s \u0c32\u0c4b",
                    past: "%s \u0c15\u0c4d\u0c30\u0c3f\u0c24\u0c02",
                    s: "\u0c15\u0c4a\u0c28\u0c4d\u0c28\u0c3f \u0c15\u0c4d\u0c37\u0c23\u0c3e\u0c32\u0c41",
                    ss: "%d \u0c38\u0c46\u0c15\u0c28\u0c4d\u0c32\u0c41",
                    m: "\u0c12\u0c15 \u0c28\u0c3f\u0c2e\u0c3f\u0c37\u0c02",
                    mm: "%d \u0c28\u0c3f\u0c2e\u0c3f\u0c37\u0c3e\u0c32\u0c41",
                    h: "\u0c12\u0c15 \u0c17\u0c02\u0c1f",
                    hh: "%d \u0c17\u0c02\u0c1f\u0c32\u0c41",
                    d: "\u0c12\u0c15 \u0c30\u0c4b\u0c1c\u0c41",
                    dd: "%d \u0c30\u0c4b\u0c1c\u0c41\u0c32\u0c41",
                    M: "\u0c12\u0c15 \u0c28\u0c46\u0c32",
                    MM: "%d \u0c28\u0c46\u0c32\u0c32\u0c41",
                    y: "\u0c12\u0c15 \u0c38\u0c02\u0c35\u0c24\u0c4d\u0c38\u0c30\u0c02",
                    yy: "%d \u0c38\u0c02\u0c35\u0c24\u0c4d\u0c38\u0c30\u0c3e\u0c32\u0c41",
                },
                dayOfMonthOrdinalParse: /\d{1,2}\u0c35/,
                ordinal: "%d\u0c35",
                meridiemParse:
                    /\u0c30\u0c3e\u0c24\u0c4d\u0c30\u0c3f|\u0c09\u0c26\u0c2f\u0c02|\u0c2e\u0c27\u0c4d\u0c2f\u0c3e\u0c39\u0c4d\u0c28\u0c02|\u0c38\u0c3e\u0c2f\u0c02\u0c24\u0c4d\u0c30\u0c02/,
                meridiemHour: function (e, a) {
                    return (
                        12 === e && (e = 0),
                        "\u0c30\u0c3e\u0c24\u0c4d\u0c30\u0c3f" === a
                            ? e < 4
                                ? e
                                : e + 12
                            : "\u0c09\u0c26\u0c2f\u0c02" === a
                            ? e
                            : "\u0c2e\u0c27\u0c4d\u0c2f\u0c3e\u0c39\u0c4d\u0c28\u0c02" ===
                              a
                            ? 10 <= e
                                ? e
                                : e + 12
                            : "\u0c38\u0c3e\u0c2f\u0c02\u0c24\u0c4d\u0c30\u0c02" ===
                              a
                            ? e + 12
                            : void 0
                    );
                },
                meridiem: function (e, a, t) {
                    return e < 4
                        ? "\u0c30\u0c3e\u0c24\u0c4d\u0c30\u0c3f"
                        : e < 10
                        ? "\u0c09\u0c26\u0c2f\u0c02"
                        : e < 17
                        ? "\u0c2e\u0c27\u0c4d\u0c2f\u0c3e\u0c39\u0c4d\u0c28\u0c02"
                        : e < 20
                        ? "\u0c38\u0c3e\u0c2f\u0c02\u0c24\u0c4d\u0c30\u0c02"
                        : "\u0c30\u0c3e\u0c24\u0c4d\u0c30\u0c3f";
                },
                week: { dow: 0, doy: 6 },
            }),
            M.defineLocale("tet", {
                months: "Janeiru_Fevereiru_Marsu_Abril_Maiu_Ju\xf1u_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru".split(
                    "_"
                ),
                monthsShort:
                    "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
                        "_"
                    ),
                weekdays:
                    "Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu".split(
                        "_"
                    ),
                weekdaysShort: "Dom_Seg_Ters_Kua_Kint_Sest_Sab".split("_"),
                weekdaysMin: "Do_Seg_Te_Ku_Ki_Ses_Sa".split("_"),
                longDateFormat: {
                    LT: "HH:mm",
                    LTS: "HH:mm:ss",
                    L: "DD/MM/YYYY",
                    LL: "D MMMM YYYY",
                    LLL: "D MMMM YYYY HH:mm",
                    LLLL: "dddd, D MMMM YYYY HH:mm",
                },
                calendar: {
                    sameDay: "[Ohin iha] LT",
                    nextDay: "[Aban iha] LT",
                    nextWeek: "dddd [iha] LT",
                    lastDay: "[Horiseik iha] LT",
                    lastWeek: "dddd [semana kotuk] [iha] LT",
                    sameElse: "L",
                },
                relativeTime: {
                    future: "iha %s",
                    past: "%s liuba",
                    s: "segundu balun",
                    ss: "segundu %d",
                    m: "minutu ida",
                    mm: "minutu %d",
                    h: "oras ida",
                    hh: "oras %d",
                    d: "loron ida",
                    dd: "loron %d",
                    M: "fulan ida",
                    MM: "fulan %d",
                    y: "tinan ida",
                    yy: "tinan %d",
                },
                dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
                ordinal: function (e) {
                    var a = e % 10;
                    return (
                        e +
                        (1 == ~~((e % 100) / 10)
                            ? "th"
                            : 1 == a
                            ? "st"
                            : 2 == a
                            ? "nd"
                            : 3 == a
                            ? "rd"
                            : "th")
                    );
                },
                week: { dow: 1, doy: 4 },
            }),
            {
                0: "-\u0443\u043c",
                1: "-\u0443\u043c",
                2: "-\u044e\u043c",
                3: "-\u044e\u043c",
                4: "-\u0443\u043c",
                5: "-\u0443\u043c",
                6: "-\u0443\u043c",
                7: "-\u0443\u043c",
                8: "-\u0443\u043c",
                9: "-\u0443\u043c",
                10: "-\u0443\u043c",
                12: "-\u0443\u043c",
                13: "-\u0443\u043c",
                20: "-\u0443\u043c",
                30: "-\u044e\u043c",
                40: "-\u0443\u043c",
                50: "-\u0443\u043c",
                60: "-\u0443\u043c",
                70: "-\u0443\u043c",
                80: "-\u0443\u043c",
                90: "-\u0443\u043c",
                100: "-\u0443\u043c",
            }),
        Hn =
            (M.defineLocale("tg", {
                months: {
                    format: "\u044f\u043d\u0432\u0430\u0440\u0438_\u0444\u0435\u0432\u0440\u0430\u043b\u0438_\u043c\u0430\u0440\u0442\u0438_\u0430\u043f\u0440\u0435\u043b\u0438_\u043c\u0430\u0439\u0438_\u0438\u044e\u043d\u0438_\u0438\u044e\u043b\u0438_\u0430\u0432\u0433\u0443\u0441\u0442\u0438_\u0441\u0435\u043d\u0442\u044f\u0431\u0440\u0438_\u043e\u043a\u0442\u044f\u0431\u0440\u0438_\u043d\u043e\u044f\u0431\u0440\u0438_\u0434\u0435\u043a\u0430\u0431\u0440\u0438".split(
                        "_"
                    ),
                    standalone:
                        "\u044f\u043d\u0432\u0430\u0440_\u0444\u0435\u0432\u0440\u0430\u043b_\u043c\u0430\u0440\u0442_\u0430\u043f\u0440\u0435\u043b_\u043c\u0430\u0439_\u0438\u044e\u043d_\u0438\u044e\u043b_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043d\u0442\u044f\u0431\u0440_\u043e\u043a\u0442\u044f\u0431\u0440_\u043d\u043e\u044f\u0431\u0440_\u0434\u0435\u043a\u0430\u0431\u0440".split(
                            "_"
                        ),
                },
                monthsShort:
                    "\u044f\u043d\u0432_\u0444\u0435\u0432_\u043c\u0430\u0440_\u0430\u043f\u0440_\u043c\u0430\u0439_\u0438\u044e\u043d_\u0438\u044e\u043b_\u0430\u0432\u0433_\u0441\u0435\u043d_\u043e\u043a\u0442_\u043d\u043e\u044f_\u0434\u0435\u043a".split(
                        "_"
                    ),
                weekdays:
                    "\u044f\u043a\u0448\u0430\u043d\u0431\u0435_\u0434\u0443\u0448\u0430\u043d\u0431\u0435_\u0441\u0435\u0448\u0430\u043d\u0431\u0435_\u0447\u043e\u0440\u0448\u0430\u043d\u0431\u0435_\u043f\u0430\u043d\u04b7\u0448\u0430\u043d\u0431\u0435_\u04b7\u0443\u043c\u044a\u0430_\u0448\u0430\u043d\u0431\u0435".split(
                        "_"
                    ),
                weekdaysShort:
                    "\u044f\u0448\u0431_\u0434\u0448\u0431_\u0441\u0448\u0431_\u0447\u0448\u0431_\u043f\u0448\u0431_\u04b7\u0443\u043c_\u0448\u043d\u0431".split(
                        "_"
                    ),
                weekdaysMin:
                    "\u044f\u0448_\u0434\u0448_\u0441\u0448_\u0447\u0448_\u043f\u0448_\u04b7\u043c_\u0448\u0431".split(
                        "_"
                    ),
                longDateFormat: {
                    LT: "HH:mm",
                    LTS: "HH:mm:ss",
                    L: "DD.MM.YYYY",
                    LL: "D MMMM YYYY",
                    LLL: "D MMMM YYYY HH:mm",
                    LLLL: "dddd, D MMMM YYYY HH:mm",
                },
                calendar: {
                    sameDay:
                        "[\u0418\u043c\u0440\u04ef\u0437 \u0441\u043e\u0430\u0442\u0438] LT",
                    nextDay:
                        "[\u0424\u0430\u0440\u0434\u043e \u0441\u043e\u0430\u0442\u0438] LT",
                    lastDay:
                        "[\u0414\u0438\u0440\u04ef\u0437 \u0441\u043e\u0430\u0442\u0438] LT",
                    nextWeek:
                        "dddd[\u0438] [\u04b3\u0430\u0444\u0442\u0430\u0438 \u043e\u044f\u043d\u0434\u0430 \u0441\u043e\u0430\u0442\u0438] LT",
                    lastWeek:
                        "dddd[\u0438] [\u04b3\u0430\u0444\u0442\u0430\u0438 \u0433\u0443\u0437\u0430\u0448\u0442\u0430 \u0441\u043e\u0430\u0442\u0438] LT",
                    sameElse: "L",
                },
                relativeTime: {
                    future: "\u0431\u0430\u044a\u0434\u0438 %s",
                    past: "%s \u043f\u0435\u0448",
                    s: "\u044f\u043a\u0447\u0430\u043d\u0434 \u0441\u043e\u043d\u0438\u044f",
                    m: "\u044f\u043a \u0434\u0430\u049b\u0438\u049b\u0430",
                    mm: "%d \u0434\u0430\u049b\u0438\u049b\u0430",
                    h: "\u044f\u043a \u0441\u043e\u0430\u0442",
                    hh: "%d \u0441\u043e\u0430\u0442",
                    d: "\u044f\u043a \u0440\u04ef\u0437",
                    dd: "%d \u0440\u04ef\u0437",
                    M: "\u044f\u043a \u043c\u043e\u04b3",
                    MM: "%d \u043c\u043e\u04b3",
                    y: "\u044f\u043a \u0441\u043e\u043b",
                    yy: "%d \u0441\u043e\u043b",
                },
                meridiemParse:
                    /\u0448\u0430\u0431|\u0441\u0443\u0431\u04b3|\u0440\u04ef\u0437|\u0431\u0435\u0433\u043e\u04b3/,
                meridiemHour: function (e, a) {
                    return (
                        12 === e && (e = 0),
                        "\u0448\u0430\u0431" === a
                            ? e < 4
                                ? e
                                : e + 12
                            : "\u0441\u0443\u0431\u04b3" === a
                            ? e
                            : "\u0440\u04ef\u0437" === a
                            ? 11 <= e
                                ? e
                                : e + 12
                            : "\u0431\u0435\u0433\u043e\u04b3" === a
                            ? e + 12
                            : void 0
                    );
                },
                meridiem: function (e, a, t) {
                    return e < 4
                        ? "\u0448\u0430\u0431"
                        : e < 11
                        ? "\u0441\u0443\u0431\u04b3"
                        : e < 16
                        ? "\u0440\u04ef\u0437"
                        : e < 19
                        ? "\u0431\u0435\u0433\u043e\u04b3"
                        : "\u0448\u0430\u0431";
                },
                dayOfMonthOrdinalParse: /\d{1,2}-(\u0443\u043c|\u044e\u043c)/,
                ordinal: function (e) {
                    return (
                        e + (Sn[e] || Sn[e % 10] || Sn[100 <= e ? 100 : null])
                    );
                },
                week: { dow: 1, doy: 7 },
            }),
            M.defineLocale("th", {
                months: "\u0e21\u0e01\u0e23\u0e32\u0e04\u0e21_\u0e01\u0e38\u0e21\u0e20\u0e32\u0e1e\u0e31\u0e19\u0e18\u0e4c_\u0e21\u0e35\u0e19\u0e32\u0e04\u0e21_\u0e40\u0e21\u0e29\u0e32\u0e22\u0e19_\u0e1e\u0e24\u0e29\u0e20\u0e32\u0e04\u0e21_\u0e21\u0e34\u0e16\u0e38\u0e19\u0e32\u0e22\u0e19_\u0e01\u0e23\u0e01\u0e0e\u0e32\u0e04\u0e21_\u0e2a\u0e34\u0e07\u0e2b\u0e32\u0e04\u0e21_\u0e01\u0e31\u0e19\u0e22\u0e32\u0e22\u0e19_\u0e15\u0e38\u0e25\u0e32\u0e04\u0e21_\u0e1e\u0e24\u0e28\u0e08\u0e34\u0e01\u0e32\u0e22\u0e19_\u0e18\u0e31\u0e19\u0e27\u0e32\u0e04\u0e21".split(
                    "_"
                ),
                monthsShort:
                    "\u0e21.\u0e04._\u0e01.\u0e1e._\u0e21\u0e35.\u0e04._\u0e40\u0e21.\u0e22._\u0e1e.\u0e04._\u0e21\u0e34.\u0e22._\u0e01.\u0e04._\u0e2a.\u0e04._\u0e01.\u0e22._\u0e15.\u0e04._\u0e1e.\u0e22._\u0e18.\u0e04.".split(
                        "_"
                    ),
                monthsParseExact: !0,
                weekdays:
                    "\u0e2d\u0e32\u0e17\u0e34\u0e15\u0e22\u0e4c_\u0e08\u0e31\u0e19\u0e17\u0e23\u0e4c_\u0e2d\u0e31\u0e07\u0e04\u0e32\u0e23_\u0e1e\u0e38\u0e18_\u0e1e\u0e24\u0e2b\u0e31\u0e2a\u0e1a\u0e14\u0e35_\u0e28\u0e38\u0e01\u0e23\u0e4c_\u0e40\u0e2a\u0e32\u0e23\u0e4c".split(
                        "_"
                    ),
                weekdaysShort:
                    "\u0e2d\u0e32\u0e17\u0e34\u0e15\u0e22\u0e4c_\u0e08\u0e31\u0e19\u0e17\u0e23\u0e4c_\u0e2d\u0e31\u0e07\u0e04\u0e32\u0e23_\u0e1e\u0e38\u0e18_\u0e1e\u0e24\u0e2b\u0e31\u0e2a_\u0e28\u0e38\u0e01\u0e23\u0e4c_\u0e40\u0e2a\u0e32\u0e23\u0e4c".split(
                        "_"
                    ),
                weekdaysMin:
                    "\u0e2d\u0e32._\u0e08._\u0e2d._\u0e1e._\u0e1e\u0e24._\u0e28._\u0e2a.".split(
                        "_"
                    ),
                weekdaysParseExact: !0,
                longDateFormat: {
                    LT: "H:mm",
                    LTS: "H:mm:ss",
                    L: "DD/MM/YYYY",
                    LL: "D MMMM YYYY",
                    LLL: "D MMMM YYYY \u0e40\u0e27\u0e25\u0e32 H:mm",
                    LLLL: "\u0e27\u0e31\u0e19dddd\u0e17\u0e35\u0e48 D MMMM YYYY \u0e40\u0e27\u0e25\u0e32 H:mm",
                },
                meridiemParse:
                    /\u0e01\u0e48\u0e2d\u0e19\u0e40\u0e17\u0e35\u0e48\u0e22\u0e07|\u0e2b\u0e25\u0e31\u0e07\u0e40\u0e17\u0e35\u0e48\u0e22\u0e07/,
                isPM: function (e) {
                    return (
                        "\u0e2b\u0e25\u0e31\u0e07\u0e40\u0e17\u0e35\u0e48\u0e22\u0e07" ===
                        e
                    );
                },
                meridiem: function (e, a, t) {
                    return e < 12
                        ? "\u0e01\u0e48\u0e2d\u0e19\u0e40\u0e17\u0e35\u0e48\u0e22\u0e07"
                        : "\u0e2b\u0e25\u0e31\u0e07\u0e40\u0e17\u0e35\u0e48\u0e22\u0e07";
                },
                calendar: {
                    sameDay:
                        "[\u0e27\u0e31\u0e19\u0e19\u0e35\u0e49 \u0e40\u0e27\u0e25\u0e32] LT",
                    nextDay:
                        "[\u0e1e\u0e23\u0e38\u0e48\u0e07\u0e19\u0e35\u0e49 \u0e40\u0e27\u0e25\u0e32] LT",
                    nextWeek:
                        "dddd[\u0e2b\u0e19\u0e49\u0e32 \u0e40\u0e27\u0e25\u0e32] LT",
                    lastDay:
                        "[\u0e40\u0e21\u0e37\u0e48\u0e2d\u0e27\u0e32\u0e19\u0e19\u0e35\u0e49 \u0e40\u0e27\u0e25\u0e32] LT",
                    lastWeek:
                        "[\u0e27\u0e31\u0e19]dddd[\u0e17\u0e35\u0e48\u0e41\u0e25\u0e49\u0e27 \u0e40\u0e27\u0e25\u0e32] LT",
                    sameElse: "L",
                },
                relativeTime: {
                    future: "\u0e2d\u0e35\u0e01 %s",
                    past: "%s\u0e17\u0e35\u0e48\u0e41\u0e25\u0e49\u0e27",
                    s: "\u0e44\u0e21\u0e48\u0e01\u0e35\u0e48\u0e27\u0e34\u0e19\u0e32\u0e17\u0e35",
                    ss: "%d \u0e27\u0e34\u0e19\u0e32\u0e17\u0e35",
                    m: "1 \u0e19\u0e32\u0e17\u0e35",
                    mm: "%d \u0e19\u0e32\u0e17\u0e35",
                    h: "1 \u0e0a\u0e31\u0e48\u0e27\u0e42\u0e21\u0e07",
                    hh: "%d \u0e0a\u0e31\u0e48\u0e27\u0e42\u0e21\u0e07",
                    d: "1 \u0e27\u0e31\u0e19",
                    dd: "%d \u0e27\u0e31\u0e19",
                    w: "1 \u0e2a\u0e31\u0e1b\u0e14\u0e32\u0e2b\u0e4c",
                    ww: "%d \u0e2a\u0e31\u0e1b\u0e14\u0e32\u0e2b\u0e4c",
                    M: "1 \u0e40\u0e14\u0e37\u0e2d\u0e19",
                    MM: "%d \u0e40\u0e14\u0e37\u0e2d\u0e19",
                    y: "1 \u0e1b\u0e35",
                    yy: "%d \u0e1b\u0e35",
                },
            }),
            {
                1: "'inji",
                5: "'inji",
                8: "'inji",
                70: "'inji",
                80: "'inji",
                2: "'nji",
                7: "'nji",
                20: "'nji",
                50: "'nji",
                3: "'\xfcnji",
                4: "'\xfcnji",
                100: "'\xfcnji",
                6: "'njy",
                9: "'unjy",
                10: "'unjy",
                30: "'unjy",
                60: "'ynjy",
                90: "'ynjy",
            }),
        vn =
            (M.defineLocale("tk", {
                months: "\xddanwar_Fewral_Mart_Aprel_Ma\xfd_I\xfdun_I\xfdul_Awgust_Sent\xfdabr_Okt\xfdabr_No\xfdabr_Dekabr".split(
                    "_"
                ),
                monthsShort:
                    "\xddan_Few_Mar_Apr_Ma\xfd_I\xfdn_I\xfdl_Awg_Sen_Okt_No\xfd_Dek".split(
                        "_"
                    ),
                weekdays:
                    "\xddek\u015fenbe_Du\u015fenbe_Si\u015fenbe_\xc7ar\u015fenbe_Pen\u015fenbe_Anna_\u015eenbe".split(
                        "_"
                    ),
                weekdaysShort:
                    "\xddek_Du\u015f_Si\u015f_\xc7ar_Pen_Ann_\u015een".split(
                        "_"
                    ),
                weekdaysMin: "\xddk_D\u015f_S\u015f_\xc7r_Pn_An_\u015en".split(
                    "_"
                ),
                longDateFormat: {
                    LT: "HH:mm",
                    LTS: "HH:mm:ss",
                    L: "DD.MM.YYYY",
                    LL: "D MMMM YYYY",
                    LLL: "D MMMM YYYY HH:mm",
                    LLLL: "dddd, D MMMM YYYY HH:mm",
                },
                calendar: {
                    sameDay: "[bug\xfcn sagat] LT",
                    nextDay: "[ertir sagat] LT",
                    nextWeek: "[indiki] dddd [sagat] LT",
                    lastDay: "[d\xfc\xfdn] LT",
                    lastWeek: "[ge\xe7en] dddd [sagat] LT",
                    sameElse: "L",
                },
                relativeTime: {
                    future: "%s so\u0148",
                    past: "%s \xf6\u0148",
                    s: "birn\xe4\xe7e sekunt",
                    m: "bir minut",
                    mm: "%d minut",
                    h: "bir sagat",
                    hh: "%d sagat",
                    d: "bir g\xfcn",
                    dd: "%d g\xfcn",
                    M: "bir a\xfd",
                    MM: "%d a\xfd",
                    y: "bir \xfdyl",
                    yy: "%d \xfdyl",
                },
                ordinal: function (e, a) {
                    switch (a) {
                        case "d":
                        case "D":
                        case "Do":
                        case "DD":
                            return e;
                        default:
                            if (0 === e) return e + "'unjy";
                            var t = e % 10;
                            return (
                                e +
                                (Hn[t] ||
                                    Hn[(e % 100) - t] ||
                                    Hn[100 <= e ? 100 : null])
                            );
                    }
                },
                week: { dow: 1, doy: 7 },
            }),
            M.defineLocale("tl-ph", {
                months: "Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre".split(
                    "_"
                ),
                monthsShort:
                    "Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis".split(
                        "_"
                    ),
                weekdays:
                    "Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado".split(
                        "_"
                    ),
                weekdaysShort: "Lin_Lun_Mar_Miy_Huw_Biy_Sab".split("_"),
                weekdaysMin: "Li_Lu_Ma_Mi_Hu_Bi_Sab".split("_"),
                longDateFormat: {
                    LT: "HH:mm",
                    LTS: "HH:mm:ss",
                    L: "MM/D/YYYY",
                    LL: "MMMM D, YYYY",
                    LLL: "MMMM D, YYYY HH:mm",
                    LLLL: "dddd, MMMM DD, YYYY HH:mm",
                },
                calendar: {
                    sameDay: "LT [ngayong araw]",
                    nextDay: "[Bukas ng] LT",
                    nextWeek: "LT [sa susunod na] dddd",
                    lastDay: "LT [kahapon]",
                    lastWeek: "LT [noong nakaraang] dddd",
                    sameElse: "L",
                },
                relativeTime: {
                    future: "sa loob ng %s",
                    past: "%s ang nakalipas",
                    s: "ilang segundo",
                    ss: "%d segundo",
                    m: "isang minuto",
                    mm: "%d minuto",
                    h: "isang oras",
                    hh: "%d oras",
                    d: "isang araw",
                    dd: "%d araw",
                    M: "isang buwan",
                    MM: "%d buwan",
                    y: "isang taon",
                    yy: "%d taon",
                },
                dayOfMonthOrdinalParse: /\d{1,2}/,
                ordinal: function (e) {
                    return e;
                },
                week: { dow: 1, doy: 4 },
            }),
            "pagh_wa\u2019_cha\u2019_wej_loS_vagh_jav_Soch_chorgh_Hut".split(
                "_"
            ));
    function jn(e, a, t, s) {
        var n = (function (e) {
            var a = Math.floor((e % 1e3) / 100),
                t = Math.floor((e % 100) / 10),
                e = e % 10,
                s = "";
            0 < a && (s += vn[a] + "vatlh");
            0 < t && (s += ("" !== s ? " " : "") + vn[t] + "maH");
            0 < e && (s += ("" !== s ? " " : "") + vn[e]);
            return "" === s ? "pagh" : s;
        })(e);
        switch (t) {
            case "ss":
                return n + " lup";
            case "mm":
                return n + " tup";
            case "hh":
                return n + " rep";
            case "dd":
                return n + " jaj";
            case "MM":
                return n + " jar";
            case "yy":
                return n + " DIS";
        }
    }
    M.defineLocale("tlh", {
        months: "tera\u2019 jar wa\u2019_tera\u2019 jar cha\u2019_tera\u2019 jar wej_tera\u2019 jar loS_tera\u2019 jar vagh_tera\u2019 jar jav_tera\u2019 jar Soch_tera\u2019 jar chorgh_tera\u2019 jar Hut_tera\u2019 jar wa\u2019maH_tera\u2019 jar wa\u2019maH wa\u2019_tera\u2019 jar wa\u2019maH cha\u2019".split(
            "_"
        ),
        monthsShort:
            "jar wa\u2019_jar cha\u2019_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa\u2019maH_jar wa\u2019maH wa\u2019_jar wa\u2019maH cha\u2019".split(
                "_"
            ),
        monthsParseExact: !0,
        weekdays:
            "lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj".split(
                "_"
            ),
        weekdaysShort:
            "lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj".split(
                "_"
            ),
        weekdaysMin:
            "lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj".split(
                "_"
            ),
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm",
        },
        calendar: {
            sameDay: "[DaHjaj] LT",
            nextDay: "[wa\u2019leS] LT",
            nextWeek: "LLL",
            lastDay: "[wa\u2019Hu\u2019] LT",
            lastWeek: "LLL",
            sameElse: "L",
        },
        relativeTime: {
            future: function (e) {
                var a = e;
                return (a =
                    -1 !== e.indexOf("jaj")
                        ? a.slice(0, -3) + "leS"
                        : -1 !== e.indexOf("jar")
                        ? a.slice(0, -3) + "waQ"
                        : -1 !== e.indexOf("DIS")
                        ? a.slice(0, -3) + "nem"
                        : a + " pIq");
            },
            past: function (e) {
                var a = e;
                return (a =
                    -1 !== e.indexOf("jaj")
                        ? a.slice(0, -3) + "Hu\u2019"
                        : -1 !== e.indexOf("jar")
                        ? a.slice(0, -3) + "wen"
                        : -1 !== e.indexOf("DIS")
                        ? a.slice(0, -3) + "ben"
                        : a + " ret");
            },
            s: "puS lup",
            ss: jn,
            m: "wa\u2019 tup",
            mm: jn,
            h: "wa\u2019 rep",
            hh: jn,
            d: "wa\u2019 jaj",
            dd: jn,
            M: "wa\u2019 jar",
            MM: jn,
            y: "wa\u2019 DIS",
            yy: jn,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: "%d.",
        week: { dow: 1, doy: 4 },
    });
    var xn = {
        1: "'inci",
        5: "'inci",
        8: "'inci",
        70: "'inci",
        80: "'inci",
        2: "'nci",
        7: "'nci",
        20: "'nci",
        50: "'nci",
        3: "'\xfcnc\xfc",
        4: "'\xfcnc\xfc",
        100: "'\xfcnc\xfc",
        6: "'nc\u0131",
        9: "'uncu",
        10: "'uncu",
        30: "'uncu",
        60: "'\u0131nc\u0131",
        90: "'\u0131nc\u0131",
    };
    function Pn(e, a, t, s) {
        e = {
            s: ["viensas secunds", "'iensas secunds"],
            ss: [e + " secunds", e + " secunds"],
            m: ["'n m\xedut", "'iens m\xedut"],
            mm: [e + " m\xeduts", e + " m\xeduts"],
            h: ["'n \xfeora", "'iensa \xfeora"],
            hh: [e + " \xfeoras", e + " \xfeoras"],
            d: ["'n ziua", "'iensa ziua"],
            dd: [e + " ziuas", e + " ziuas"],
            M: ["'n mes", "'iens mes"],
            MM: [e + " mesen", e + " mesen"],
            y: ["'n ar", "'iens ar"],
            yy: [e + " ars", e + " ars"],
        };
        return s || a ? e[t][0] : e[t][1];
    }
    function On(e, a, t) {
        return "m" === t
            ? a
                ? "\u0445\u0432\u0438\u043b\u0438\u043d\u0430"
                : "\u0445\u0432\u0438\u043b\u0438\u043d\u0443"
            : "h" === t
            ? a
                ? "\u0433\u043e\u0434\u0438\u043d\u0430"
                : "\u0433\u043e\u0434\u0438\u043d\u0443"
            : e +
              " " +
              ((e = +e),
              (a = (a = {
                  ss: a
                      ? "\u0441\u0435\u043a\u0443\u043d\u0434\u0430_\u0441\u0435\u043a\u0443\u043d\u0434\u0438_\u0441\u0435\u043a\u0443\u043d\u0434"
                      : "\u0441\u0435\u043a\u0443\u043d\u0434\u0443_\u0441\u0435\u043a\u0443\u043d\u0434\u0438_\u0441\u0435\u043a\u0443\u043d\u0434",
                  mm: a
                      ? "\u0445\u0432\u0438\u043b\u0438\u043d\u0430_\u0445\u0432\u0438\u043b\u0438\u043d\u0438_\u0445\u0432\u0438\u043b\u0438\u043d"
                      : "\u0445\u0432\u0438\u043b\u0438\u043d\u0443_\u0445\u0432\u0438\u043b\u0438\u043d\u0438_\u0445\u0432\u0438\u043b\u0438\u043d",
                  hh: a
                      ? "\u0433\u043e\u0434\u0438\u043d\u0430_\u0433\u043e\u0434\u0438\u043d\u0438_\u0433\u043e\u0434\u0438\u043d"
                      : "\u0433\u043e\u0434\u0438\u043d\u0443_\u0433\u043e\u0434\u0438\u043d\u0438_\u0433\u043e\u0434\u0438\u043d",
                  dd: "\u0434\u0435\u043d\u044c_\u0434\u043d\u0456_\u0434\u043d\u0456\u0432",
                  MM: "\u043c\u0456\u0441\u044f\u0446\u044c_\u043c\u0456\u0441\u044f\u0446\u0456_\u043c\u0456\u0441\u044f\u0446\u0456\u0432",
                  yy: "\u0440\u0456\u043a_\u0440\u043e\u043a\u0438_\u0440\u043e\u043a\u0456\u0432",
              }[t]).split("_")),
              e % 10 == 1 && e % 100 != 11
                  ? a[0]
                  : 2 <= e % 10 &&
                    e % 10 <= 4 &&
                    (e % 100 < 10 || 20 <= e % 100)
                  ? a[1]
                  : a[2]);
    }
    function Wn(e) {
        return function () {
            return (
                e + "\u043e" + (11 === this.hours() ? "\u0431" : "") + "] LT"
            );
        };
    }
    M.defineLocale("tr", {
        months: "Ocak_\u015eubat_Mart_Nisan_May\u0131s_Haziran_Temmuz_A\u011fustos_Eyl\xfcl_Ekim_Kas\u0131m_Aral\u0131k".split(
            "_"
        ),
        monthsShort:
            "Oca_\u015eub_Mar_Nis_May_Haz_Tem_A\u011fu_Eyl_Eki_Kas_Ara".split(
                "_"
            ),
        weekdays:
            "Pazar_Pazartesi_Sal\u0131_\xc7ar\u015famba_Per\u015fembe_Cuma_Cumartesi".split(
                "_"
            ),
        weekdaysShort: "Paz_Pzt_Sal_\xc7ar_Per_Cum_Cmt".split("_"),
        weekdaysMin: "Pz_Pt_Sa_\xc7a_Pe_Cu_Ct".split("_"),
        meridiem: function (e, a, t) {
            return e < 12
                ? t
                    ? "\xf6\xf6"
                    : "\xd6\xd6"
                : t
                ? "\xf6s"
                : "\xd6S";
        },
        meridiemParse: /\xf6\xf6|\xd6\xd6|\xf6s|\xd6S/,
        isPM: function (e) {
            return "\xf6s" === e || "\xd6S" === e;
        },
        longDateFormat: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm",
        },
        calendar: {
            sameDay: "[bug\xfcn saat] LT",
            nextDay: "[yar\u0131n saat] LT",
            nextWeek: "[gelecek] dddd [saat] LT",
            lastDay: "[d\xfcn] LT",
            lastWeek: "[ge\xe7en] dddd [saat] LT",
            sameElse: "L",
        },
        relativeTime: {
            future: "%s sonra",
            past: "%s \xf6nce",
            s: "birka\xe7 saniye",
            ss: "%d saniye",
            m: "bir dakika",
            mm: "%d dakika",
            h: "bir saat",
            hh: "%d saat",
            d: "bir g\xfcn",
            dd: "%d g\xfcn",
            w: "bir hafta",
            ww: "%d hafta",
            M: "bir ay",
            MM: "%d ay",
            y: "bir y\u0131l",
            yy: "%d y\u0131l",
        },
        ordinal: function (e, a) {
            switch (a) {
                case "d":
                case "D":
                case "Do":
                case "DD":
                    return e;
                default:
                    if (0 === e) return e + "'\u0131nc\u0131";
                    var t = e % 10;
                    return (
                        e +
                        (xn[t] ||
                            xn[(e % 100) - t] ||
                            xn[100 <= e ? 100 : null])
                    );
            }
        },
        week: { dow: 1, doy: 7 },
    }),
        M.defineLocale("tzl", {
            months: "Januar_Fevraglh_Mar\xe7_Avr\xefu_Mai_G\xfcn_Julia_Guscht_Setemvar_Listop\xe4ts_Noemvar_Zecemvar".split(
                "_"
            ),
            monthsShort:
                "Jan_Fev_Mar_Avr_Mai_G\xfcn_Jul_Gus_Set_Lis_Noe_Zec".split("_"),
            weekdays:
                "S\xfaladi_L\xfane\xe7i_Maitzi_M\xe1rcuri_Xh\xfaadi_Vi\xe9ner\xe7i_S\xe1turi".split(
                    "_"
                ),
            weekdaysShort:
                "S\xfal_L\xfan_Mai_M\xe1r_Xh\xfa_Vi\xe9_S\xe1t".split("_"),
            weekdaysMin: "S\xfa_L\xfa_Ma_M\xe1_Xh_Vi_S\xe1".split("_"),
            longDateFormat: {
                LT: "HH.mm",
                LTS: "HH.mm.ss",
                L: "DD.MM.YYYY",
                LL: "D. MMMM [dallas] YYYY",
                LLL: "D. MMMM [dallas] YYYY HH.mm",
                LLLL: "dddd, [li] D. MMMM [dallas] YYYY HH.mm",
            },
            meridiemParse: /d\'o|d\'a/i,
            isPM: function (e) {
                return "d'o" === e.toLowerCase();
            },
            meridiem: function (e, a, t) {
                return 11 < e ? (t ? "d'o" : "D'O") : t ? "d'a" : "D'A";
            },
            calendar: {
                sameDay: "[oxhi \xe0] LT",
                nextDay: "[dem\xe0 \xe0] LT",
                nextWeek: "dddd [\xe0] LT",
                lastDay: "[ieiri \xe0] LT",
                lastWeek: "[s\xfcr el] dddd [lasteu \xe0] LT",
                sameElse: "L",
            },
            relativeTime: {
                future: "osprei %s",
                past: "ja%s",
                s: Pn,
                ss: Pn,
                m: Pn,
                mm: Pn,
                h: Pn,
                hh: Pn,
                d: Pn,
                dd: Pn,
                M: Pn,
                MM: Pn,
                y: Pn,
                yy: Pn,
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: { dow: 1, doy: 4 },
        }),
        M.defineLocale("tzm-latn", {
            months: "innayr_br\u02e4ayr\u02e4_mar\u02e4s\u02e4_ibrir_mayyw_ywnyw_ywlywz_\u0263w\u0161t_\u0161wtanbir_kt\u02e4wbr\u02e4_nwwanbir_dwjnbir".split(
                "_"
            ),
            monthsShort:
                "innayr_br\u02e4ayr\u02e4_mar\u02e4s\u02e4_ibrir_mayyw_ywnyw_ywlywz_\u0263w\u0161t_\u0161wtanbir_kt\u02e4wbr\u02e4_nwwanbir_dwjnbir".split(
                    "_"
                ),
            weekdays:
                "asamas_aynas_asinas_akras_akwas_asimwas_asi\u1e0dyas".split(
                    "_"
                ),
            weekdaysShort:
                "asamas_aynas_asinas_akras_akwas_asimwas_asi\u1e0dyas".split(
                    "_"
                ),
            weekdaysMin:
                "asamas_aynas_asinas_akras_akwas_asimwas_asi\u1e0dyas".split(
                    "_"
                ),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd D MMMM YYYY HH:mm",
            },
            calendar: {
                sameDay: "[asdkh g] LT",
                nextDay: "[aska g] LT",
                nextWeek: "dddd [g] LT",
                lastDay: "[assant g] LT",
                lastWeek: "dddd [g] LT",
                sameElse: "L",
            },
            relativeTime: {
                future: "dadkh s yan %s",
                past: "yan %s",
                s: "imik",
                ss: "%d imik",
                m: "minu\u1e0d",
                mm: "%d minu\u1e0d",
                h: "sa\u025ba",
                hh: "%d tassa\u025bin",
                d: "ass",
                dd: "%d ossan",
                M: "ayowr",
                MM: "%d iyyirn",
                y: "asgas",
                yy: "%d isgasn",
            },
            week: { dow: 6, doy: 12 },
        }),
        M.defineLocale("tzm", {
            months: "\u2d49\u2d4f\u2d4f\u2d30\u2d62\u2d54_\u2d31\u2d55\u2d30\u2d62\u2d55_\u2d4e\u2d30\u2d55\u2d5a_\u2d49\u2d31\u2d54\u2d49\u2d54_\u2d4e\u2d30\u2d62\u2d62\u2d53_\u2d62\u2d53\u2d4f\u2d62\u2d53_\u2d62\u2d53\u2d4d\u2d62\u2d53\u2d63_\u2d56\u2d53\u2d5b\u2d5c_\u2d5b\u2d53\u2d5c\u2d30\u2d4f\u2d31\u2d49\u2d54_\u2d3d\u2d5f\u2d53\u2d31\u2d55_\u2d4f\u2d53\u2d61\u2d30\u2d4f\u2d31\u2d49\u2d54_\u2d37\u2d53\u2d4a\u2d4f\u2d31\u2d49\u2d54".split(
                "_"
            ),
            monthsShort:
                "\u2d49\u2d4f\u2d4f\u2d30\u2d62\u2d54_\u2d31\u2d55\u2d30\u2d62\u2d55_\u2d4e\u2d30\u2d55\u2d5a_\u2d49\u2d31\u2d54\u2d49\u2d54_\u2d4e\u2d30\u2d62\u2d62\u2d53_\u2d62\u2d53\u2d4f\u2d62\u2d53_\u2d62\u2d53\u2d4d\u2d62\u2d53\u2d63_\u2d56\u2d53\u2d5b\u2d5c_\u2d5b\u2d53\u2d5c\u2d30\u2d4f\u2d31\u2d49\u2d54_\u2d3d\u2d5f\u2d53\u2d31\u2d55_\u2d4f\u2d53\u2d61\u2d30\u2d4f\u2d31\u2d49\u2d54_\u2d37\u2d53\u2d4a\u2d4f\u2d31\u2d49\u2d54".split(
                    "_"
                ),
            weekdays:
                "\u2d30\u2d59\u2d30\u2d4e\u2d30\u2d59_\u2d30\u2d62\u2d4f\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d4f\u2d30\u2d59_\u2d30\u2d3d\u2d54\u2d30\u2d59_\u2d30\u2d3d\u2d61\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d4e\u2d61\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d39\u2d62\u2d30\u2d59".split(
                    "_"
                ),
            weekdaysShort:
                "\u2d30\u2d59\u2d30\u2d4e\u2d30\u2d59_\u2d30\u2d62\u2d4f\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d4f\u2d30\u2d59_\u2d30\u2d3d\u2d54\u2d30\u2d59_\u2d30\u2d3d\u2d61\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d4e\u2d61\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d39\u2d62\u2d30\u2d59".split(
                    "_"
                ),
            weekdaysMin:
                "\u2d30\u2d59\u2d30\u2d4e\u2d30\u2d59_\u2d30\u2d62\u2d4f\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d4f\u2d30\u2d59_\u2d30\u2d3d\u2d54\u2d30\u2d59_\u2d30\u2d3d\u2d61\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d4e\u2d61\u2d30\u2d59_\u2d30\u2d59\u2d49\u2d39\u2d62\u2d30\u2d59".split(
                    "_"
                ),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd D MMMM YYYY HH:mm",
            },
            calendar: {
                sameDay: "[\u2d30\u2d59\u2d37\u2d45 \u2d34] LT",
                nextDay: "[\u2d30\u2d59\u2d3d\u2d30 \u2d34] LT",
                nextWeek: "dddd [\u2d34] LT",
                lastDay: "[\u2d30\u2d5a\u2d30\u2d4f\u2d5c \u2d34] LT",
                lastWeek: "dddd [\u2d34] LT",
                sameElse: "L",
            },
            relativeTime: {
                future: "\u2d37\u2d30\u2d37\u2d45 \u2d59 \u2d62\u2d30\u2d4f %s",
                past: "\u2d62\u2d30\u2d4f %s",
                s: "\u2d49\u2d4e\u2d49\u2d3d",
                ss: "%d \u2d49\u2d4e\u2d49\u2d3d",
                m: "\u2d4e\u2d49\u2d4f\u2d53\u2d3a",
                mm: "%d \u2d4e\u2d49\u2d4f\u2d53\u2d3a",
                h: "\u2d59\u2d30\u2d44\u2d30",
                hh: "%d \u2d5c\u2d30\u2d59\u2d59\u2d30\u2d44\u2d49\u2d4f",
                d: "\u2d30\u2d59\u2d59",
                dd: "%d o\u2d59\u2d59\u2d30\u2d4f",
                M: "\u2d30\u2d62o\u2d53\u2d54",
                MM: "%d \u2d49\u2d62\u2d62\u2d49\u2d54\u2d4f",
                y: "\u2d30\u2d59\u2d33\u2d30\u2d59",
                yy: "%d \u2d49\u2d59\u2d33\u2d30\u2d59\u2d4f",
            },
            week: { dow: 6, doy: 12 },
        }),
        M.defineLocale("ug-cn", {
            months: "\u064a\u0627\u0646\u06cb\u0627\u0631_\u0641\u06d0\u06cb\u0631\u0627\u0644_\u0645\u0627\u0631\u062a_\u0626\u0627\u067e\u0631\u06d0\u0644_\u0645\u0627\u064a_\u0626\u0649\u064a\u06c7\u0646_\u0626\u0649\u064a\u06c7\u0644_\u0626\u0627\u06cb\u063a\u06c7\u0633\u062a_\u0633\u06d0\u0646\u062a\u06d5\u0628\u0649\u0631_\u0626\u06c6\u0643\u062a\u06d5\u0628\u0649\u0631_\u0646\u0648\u064a\u0627\u0628\u0649\u0631_\u062f\u06d0\u0643\u0627\u0628\u0649\u0631".split(
                "_"
            ),
            monthsShort:
                "\u064a\u0627\u0646\u06cb\u0627\u0631_\u0641\u06d0\u06cb\u0631\u0627\u0644_\u0645\u0627\u0631\u062a_\u0626\u0627\u067e\u0631\u06d0\u0644_\u0645\u0627\u064a_\u0626\u0649\u064a\u06c7\u0646_\u0626\u0649\u064a\u06c7\u0644_\u0626\u0627\u06cb\u063a\u06c7\u0633\u062a_\u0633\u06d0\u0646\u062a\u06d5\u0628\u0649\u0631_\u0626\u06c6\u0643\u062a\u06d5\u0628\u0649\u0631_\u0646\u0648\u064a\u0627\u0628\u0649\u0631_\u062f\u06d0\u0643\u0627\u0628\u0649\u0631".split(
                    "_"
                ),
            weekdays:
                "\u064a\u06d5\u0643\u0634\u06d5\u0646\u0628\u06d5_\u062f\u06c8\u0634\u06d5\u0646\u0628\u06d5_\u0633\u06d5\u064a\u0634\u06d5\u0646\u0628\u06d5_\u0686\u0627\u0631\u0634\u06d5\u0646\u0628\u06d5_\u067e\u06d5\u064a\u0634\u06d5\u0646\u0628\u06d5_\u062c\u06c8\u0645\u06d5_\u0634\u06d5\u0646\u0628\u06d5".split(
                    "_"
                ),
            weekdaysShort:
                "\u064a\u06d5_\u062f\u06c8_\u0633\u06d5_\u0686\u0627_\u067e\u06d5_\u062c\u06c8_\u0634\u06d5".split(
                    "_"
                ),
            weekdaysMin:
                "\u064a\u06d5_\u062f\u06c8_\u0633\u06d5_\u0686\u0627_\u067e\u06d5_\u062c\u06c8_\u0634\u06d5".split(
                    "_"
                ),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "YYYY-MM-DD",
                LL: "YYYY-\u064a\u0649\u0644\u0649M-\u0626\u0627\u064a\u0646\u0649\u06adD-\u0643\u06c8\u0646\u0649",
                LLL: "YYYY-\u064a\u0649\u0644\u0649M-\u0626\u0627\u064a\u0646\u0649\u06adD-\u0643\u06c8\u0646\u0649\u060c HH:mm",
                LLLL: "dddd\u060c YYYY-\u064a\u0649\u0644\u0649M-\u0626\u0627\u064a\u0646\u0649\u06adD-\u0643\u06c8\u0646\u0649\u060c HH:mm",
            },
            meridiemParse:
                /\u064a\u06d0\u0631\u0649\u0645 \u0643\u06d0\u0686\u06d5|\u0633\u06d5\u06be\u06d5\u0631|\u0686\u06c8\u0634\u062a\u0649\u0646 \u0628\u06c7\u0631\u06c7\u0646|\u0686\u06c8\u0634|\u0686\u06c8\u0634\u062a\u0649\u0646 \u0643\u06d0\u064a\u0649\u0646|\u0643\u06d5\u0686/,
            meridiemHour: function (e, a) {
                return (
                    12 === e && (e = 0),
                    "\u064a\u06d0\u0631\u0649\u0645 \u0643\u06d0\u0686\u06d5" ===
                        a ||
                    "\u0633\u06d5\u06be\u06d5\u0631" === a ||
                    "\u0686\u06c8\u0634\u062a\u0649\u0646 \u0628\u06c7\u0631\u06c7\u0646" ===
                        a ||
                    ("\u0686\u06c8\u0634\u062a\u0649\u0646 \u0643\u06d0\u064a\u0649\u0646" !==
                        a &&
                        "\u0643\u06d5\u0686" !== a &&
                        11 <= e)
                        ? e
                        : e + 12
                );
            },
            meridiem: function (e, a, t) {
                e = 100 * e + a;
                return e < 600
                    ? "\u064a\u06d0\u0631\u0649\u0645 \u0643\u06d0\u0686\u06d5"
                    : e < 900
                    ? "\u0633\u06d5\u06be\u06d5\u0631"
                    : e < 1130
                    ? "\u0686\u06c8\u0634\u062a\u0649\u0646 \u0628\u06c7\u0631\u06c7\u0646"
                    : e < 1230
                    ? "\u0686\u06c8\u0634"
                    : e < 1800
                    ? "\u0686\u06c8\u0634\u062a\u0649\u0646 \u0643\u06d0\u064a\u0649\u0646"
                    : "\u0643\u06d5\u0686";
            },
            calendar: {
                sameDay:
                    "[\u0628\u06c8\u06af\u06c8\u0646 \u0633\u0627\u0626\u06d5\u062a] LT",
                nextDay:
                    "[\u0626\u06d5\u062a\u06d5 \u0633\u0627\u0626\u06d5\u062a] LT",
                nextWeek:
                    "[\u0643\u06d0\u0644\u06d5\u0631\u0643\u0649] dddd [\u0633\u0627\u0626\u06d5\u062a] LT",
                lastDay: "[\u062a\u06c6\u0646\u06c8\u06af\u06c8\u0646] LT",
                lastWeek:
                    "[\u0626\u0627\u0644\u062f\u0649\u0646\u0642\u0649] dddd [\u0633\u0627\u0626\u06d5\u062a] LT",
                sameElse: "L",
            },
            relativeTime: {
                future: "%s \u0643\u06d0\u064a\u0649\u0646",
                past: "%s \u0628\u06c7\u0631\u06c7\u0646",
                s: "\u0646\u06d5\u0686\u0686\u06d5 \u0633\u06d0\u0643\u0648\u0646\u062a",
                ss: "%d \u0633\u06d0\u0643\u0648\u0646\u062a",
                m: "\u0628\u0649\u0631 \u0645\u0649\u0646\u06c7\u062a",
                mm: "%d \u0645\u0649\u0646\u06c7\u062a",
                h: "\u0628\u0649\u0631 \u0633\u0627\u0626\u06d5\u062a",
                hh: "%d \u0633\u0627\u0626\u06d5\u062a",
                d: "\u0628\u0649\u0631 \u0643\u06c8\u0646",
                dd: "%d \u0643\u06c8\u0646",
                M: "\u0628\u0649\u0631 \u0626\u0627\u064a",
                MM: "%d \u0626\u0627\u064a",
                y: "\u0628\u0649\u0631 \u064a\u0649\u0644",
                yy: "%d \u064a\u0649\u0644",
            },
            dayOfMonthOrdinalParse:
                /\d{1,2}(-\u0643\u06c8\u0646\u0649|-\u0626\u0627\u064a|-\u06be\u06d5\u067e\u062a\u06d5)/,
            ordinal: function (e, a) {
                switch (a) {
                    case "d":
                    case "D":
                    case "DDD":
                        return e + "-\u0643\u06c8\u0646\u0649";
                    case "w":
                    case "W":
                        return e + "-\u06be\u06d5\u067e\u062a\u06d5";
                    default:
                        return e;
                }
            },
            preparse: function (e) {
                return e.replace(/\u060c/g, ",");
            },
            postformat: function (e) {
                return e.replace(/,/g, "\u060c");
            },
            week: { dow: 1, doy: 7 },
        }),
        M.defineLocale("uk", {
            months: {
                format: "\u0441\u0456\u0447\u043d\u044f_\u043b\u044e\u0442\u043e\u0433\u043e_\u0431\u0435\u0440\u0435\u0437\u043d\u044f_\u043a\u0432\u0456\u0442\u043d\u044f_\u0442\u0440\u0430\u0432\u043d\u044f_\u0447\u0435\u0440\u0432\u043d\u044f_\u043b\u0438\u043f\u043d\u044f_\u0441\u0435\u0440\u043f\u043d\u044f_\u0432\u0435\u0440\u0435\u0441\u043d\u044f_\u0436\u043e\u0432\u0442\u043d\u044f_\u043b\u0438\u0441\u0442\u043e\u043f\u0430\u0434\u0430_\u0433\u0440\u0443\u0434\u043d\u044f".split(
                    "_"
                ),
                standalone:
                    "\u0441\u0456\u0447\u0435\u043d\u044c_\u043b\u044e\u0442\u0438\u0439_\u0431\u0435\u0440\u0435\u0437\u0435\u043d\u044c_\u043a\u0432\u0456\u0442\u0435\u043d\u044c_\u0442\u0440\u0430\u0432\u0435\u043d\u044c_\u0447\u0435\u0440\u0432\u0435\u043d\u044c_\u043b\u0438\u043f\u0435\u043d\u044c_\u0441\u0435\u0440\u043f\u0435\u043d\u044c_\u0432\u0435\u0440\u0435\u0441\u0435\u043d\u044c_\u0436\u043e\u0432\u0442\u0435\u043d\u044c_\u043b\u0438\u0441\u0442\u043e\u043f\u0430\u0434_\u0433\u0440\u0443\u0434\u0435\u043d\u044c".split(
                        "_"
                    ),
            },
            monthsShort:
                "\u0441\u0456\u0447_\u043b\u044e\u0442_\u0431\u0435\u0440_\u043a\u0432\u0456\u0442_\u0442\u0440\u0430\u0432_\u0447\u0435\u0440\u0432_\u043b\u0438\u043f_\u0441\u0435\u0440\u043f_\u0432\u0435\u0440_\u0436\u043e\u0432\u0442_\u043b\u0438\u0441\u0442_\u0433\u0440\u0443\u0434".split(
                    "_"
                ),
            weekdays: function (e, a) {
                var t = {
                    nominative:
                        "\u043d\u0435\u0434\u0456\u043b\u044f_\u043f\u043e\u043d\u0435\u0434\u0456\u043b\u043e\u043a_\u0432\u0456\u0432\u0442\u043e\u0440\u043e\u043a_\u0441\u0435\u0440\u0435\u0434\u0430_\u0447\u0435\u0442\u0432\u0435\u0440_\u043f\u2019\u044f\u0442\u043d\u0438\u0446\u044f_\u0441\u0443\u0431\u043e\u0442\u0430".split(
                            "_"
                        ),
                    accusative:
                        "\u043d\u0435\u0434\u0456\u043b\u044e_\u043f\u043e\u043d\u0435\u0434\u0456\u043b\u043e\u043a_\u0432\u0456\u0432\u0442\u043e\u0440\u043e\u043a_\u0441\u0435\u0440\u0435\u0434\u0443_\u0447\u0435\u0442\u0432\u0435\u0440_\u043f\u2019\u044f\u0442\u043d\u0438\u0446\u044e_\u0441\u0443\u0431\u043e\u0442\u0443".split(
                            "_"
                        ),
                    genitive:
                        "\u043d\u0435\u0434\u0456\u043b\u0456_\u043f\u043e\u043d\u0435\u0434\u0456\u043b\u043a\u0430_\u0432\u0456\u0432\u0442\u043e\u0440\u043a\u0430_\u0441\u0435\u0440\u0435\u0434\u0438_\u0447\u0435\u0442\u0432\u0435\u0440\u0433\u0430_\u043f\u2019\u044f\u0442\u043d\u0438\u0446\u0456_\u0441\u0443\u0431\u043e\u0442\u0438".split(
                            "_"
                        ),
                };
                return !0 === e
                    ? t.nominative.slice(1, 7).concat(t.nominative.slice(0, 1))
                    : e
                    ? t[
                          /(\[[\u0412\u0432\u0423\u0443]\]) ?dddd/.test(a)
                              ? "accusative"
                              : /\[?(?:\u043c\u0438\u043d\u0443\u043b\u043e\u0457|\u043d\u0430\u0441\u0442\u0443\u043f\u043d\u043e\u0457)? ?\] ?dddd/.test(
                                    a
                                )
                              ? "genitive"
                              : "nominative"
                      ][e.day()]
                    : t.nominative;
            },
            weekdaysShort:
                "\u043d\u0434_\u043f\u043d_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043f\u0442_\u0441\u0431".split(
                    "_"
                ),
            weekdaysMin:
                "\u043d\u0434_\u043f\u043d_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043f\u0442_\u0441\u0431".split(
                    "_"
                ),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD.MM.YYYY",
                LL: "D MMMM YYYY \u0440.",
                LLL: "D MMMM YYYY \u0440., HH:mm",
                LLLL: "dddd, D MMMM YYYY \u0440., HH:mm",
            },
            calendar: {
                sameDay: Wn(
                    "[\u0421\u044c\u043e\u0433\u043e\u0434\u043d\u0456 "
                ),
                nextDay: Wn("[\u0417\u0430\u0432\u0442\u0440\u0430 "),
                lastDay: Wn("[\u0412\u0447\u043e\u0440\u0430 "),
                nextWeek: Wn("[\u0423] dddd ["),
                lastWeek: function () {
                    switch (this.day()) {
                        case 0:
                        case 3:
                        case 5:
                        case 6:
                            return Wn(
                                "[\u041c\u0438\u043d\u0443\u043b\u043e\u0457] dddd ["
                            ).call(this);
                        case 1:
                        case 2:
                        case 4:
                            return Wn(
                                "[\u041c\u0438\u043d\u0443\u043b\u043e\u0433\u043e] dddd ["
                            ).call(this);
                    }
                },
                sameElse: "L",
            },
            relativeTime: {
                future: "\u0437\u0430 %s",
                past: "%s \u0442\u043e\u043c\u0443",
                s: "\u0434\u0435\u043a\u0456\u043b\u044c\u043a\u0430 \u0441\u0435\u043a\u0443\u043d\u0434",
                ss: On,
                m: On,
                mm: On,
                h: "\u0433\u043e\u0434\u0438\u043d\u0443",
                hh: On,
                d: "\u0434\u0435\u043d\u044c",
                dd: On,
                M: "\u043c\u0456\u0441\u044f\u0446\u044c",
                MM: On,
                y: "\u0440\u0456\u043a",
                yy: On,
            },
            meridiemParse:
                /\u043d\u043e\u0447\u0456|\u0440\u0430\u043d\u043a\u0443|\u0434\u043d\u044f|\u0432\u0435\u0447\u043e\u0440\u0430/,
            isPM: function (e) {
                return /^(\u0434\u043d\u044f|\u0432\u0435\u0447\u043e\u0440\u0430)$/.test(
                    e
                );
            },
            meridiem: function (e, a, t) {
                return e < 4
                    ? "\u043d\u043e\u0447\u0456"
                    : e < 12
                    ? "\u0440\u0430\u043d\u043a\u0443"
                    : e < 17
                    ? "\u0434\u043d\u044f"
                    : "\u0432\u0435\u0447\u043e\u0440\u0430";
            },
            dayOfMonthOrdinalParse: /\d{1,2}-(\u0439|\u0433\u043e)/,
            ordinal: function (e, a) {
                switch (a) {
                    case "M":
                    case "d":
                    case "DDD":
                    case "w":
                    case "W":
                        return e + "-\u0439";
                    case "D":
                        return e + "-\u0433\u043e";
                    default:
                        return e;
                }
            },
            week: { dow: 1, doy: 7 },
        });
    (jt = [
        "\u062c\u0646\u0648\u0631\u06cc",
        "\u0641\u0631\u0648\u0631\u06cc",
        "\u0645\u0627\u0631\u0686",
        "\u0627\u067e\u0631\u06cc\u0644",
        "\u0645\u0626\u06cc",
        "\u062c\u0648\u0646",
        "\u062c\u0648\u0644\u0627\u0626\u06cc",
        "\u0627\u06af\u0633\u062a",
        "\u0633\u062a\u0645\u0628\u0631",
        "\u0627\u06a9\u062a\u0648\u0628\u0631",
        "\u0646\u0648\u0645\u0628\u0631",
        "\u062f\u0633\u0645\u0628\u0631",
    ]),
        (vt = [
            "\u0627\u062a\u0648\u0627\u0631",
            "\u067e\u06cc\u0631",
            "\u0645\u0646\u06af\u0644",
            "\u0628\u062f\u06be",
            "\u062c\u0645\u0639\u0631\u0627\u062a",
            "\u062c\u0645\u0639\u06c1",
            "\u06c1\u0641\u062a\u06c1",
        ]);
    return (
        M.defineLocale("ur", {
            months: jt,
            monthsShort: jt,
            weekdays: vt,
            weekdaysShort: vt,
            weekdaysMin: vt,
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd\u060c D MMMM YYYY HH:mm",
            },
            meridiemParse: /\u0635\u0628\u062d|\u0634\u0627\u0645/,
            isPM: function (e) {
                return "\u0634\u0627\u0645" === e;
            },
            meridiem: function (e, a, t) {
                return e < 12 ? "\u0635\u0628\u062d" : "\u0634\u0627\u0645";
            },
            calendar: {
                sameDay: "[\u0622\u062c \u0628\u0648\u0642\u062a] LT",
                nextDay: "[\u06a9\u0644 \u0628\u0648\u0642\u062a] LT",
                nextWeek: "dddd [\u0628\u0648\u0642\u062a] LT",
                lastDay:
                    "[\u06af\u0630\u0634\u062a\u06c1 \u0631\u0648\u0632 \u0628\u0648\u0642\u062a] LT",
                lastWeek:
                    "[\u06af\u0630\u0634\u062a\u06c1] dddd [\u0628\u0648\u0642\u062a] LT",
                sameElse: "L",
            },
            relativeTime: {
                future: "%s \u0628\u0639\u062f",
                past: "%s \u0642\u0628\u0644",
                s: "\u0686\u0646\u062f \u0633\u06cc\u06a9\u0646\u0688",
                ss: "%d \u0633\u06cc\u06a9\u0646\u0688",
                m: "\u0627\u06cc\u06a9 \u0645\u0646\u0679",
                mm: "%d \u0645\u0646\u0679",
                h: "\u0627\u06cc\u06a9 \u06af\u06be\u0646\u0679\u06c1",
                hh: "%d \u06af\u06be\u0646\u0679\u06d2",
                d: "\u0627\u06cc\u06a9 \u062f\u0646",
                dd: "%d \u062f\u0646",
                M: "\u0627\u06cc\u06a9 \u0645\u0627\u06c1",
                MM: "%d \u0645\u0627\u06c1",
                y: "\u0627\u06cc\u06a9 \u0633\u0627\u0644",
                yy: "%d \u0633\u0627\u0644",
            },
            preparse: function (e) {
                return e.replace(/\u060c/g, ",");
            },
            postformat: function (e) {
                return e.replace(/,/g, "\u060c");
            },
            week: { dow: 1, doy: 4 },
        }),
        M.defineLocale("uz-latn", {
            months: "Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr".split(
                "_"
            ),
            monthsShort:
                "Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek".split("_"),
            weekdays:
                "Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba".split(
                    "_"
                ),
            weekdaysShort: "Yak_Dush_Sesh_Chor_Pay_Jum_Shan".split("_"),
            weekdaysMin: "Ya_Du_Se_Cho_Pa_Ju_Sha".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "D MMMM YYYY, dddd HH:mm",
            },
            calendar: {
                sameDay: "[Bugun soat] LT [da]",
                nextDay: "[Ertaga] LT [da]",
                nextWeek: "dddd [kuni soat] LT [da]",
                lastDay: "[Kecha soat] LT [da]",
                lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
                sameElse: "L",
            },
            relativeTime: {
                future: "Yaq%s ago ichida",
                past: "Bir necha %s oldin",
                s: "soniya",
                ss: "%d soniya",
                m: "bir daqiqa",
                mm: "%d daqiqa",
                h: "bir soat",
                hh: "%d soat",
                d: "bir kun",
                dd: "%d kun",
                M: "bir oy",
                MM: "%d oy",
                y: "bir yil",
                yy: "%d yil",
            },
            week: { dow: 1, doy: 7 },
        }),
        M.defineLocale("uz", {
            months: "\u044f\u043d\u0432\u0430\u0440_\u0444\u0435\u0432\u0440\u0430\u043b_\u043c\u0430\u0440\u0442_\u0430\u043f\u0440\u0435\u043b_\u043c\u0430\u0439_\u0438\u044e\u043d_\u0438\u044e\u043b_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043d\u0442\u044f\u0431\u0440_\u043e\u043a\u0442\u044f\u0431\u0440_\u043d\u043e\u044f\u0431\u0440_\u0434\u0435\u043a\u0430\u0431\u0440".split(
                "_"
            ),
            monthsShort:
                "\u044f\u043d\u0432_\u0444\u0435\u0432_\u043c\u0430\u0440_\u0430\u043f\u0440_\u043c\u0430\u0439_\u0438\u044e\u043d_\u0438\u044e\u043b_\u0430\u0432\u0433_\u0441\u0435\u043d_\u043e\u043a\u0442_\u043d\u043e\u044f_\u0434\u0435\u043a".split(
                    "_"
                ),
            weekdays:
                "\u042f\u043a\u0448\u0430\u043d\u0431\u0430_\u0414\u0443\u0448\u0430\u043d\u0431\u0430_\u0421\u0435\u0448\u0430\u043d\u0431\u0430_\u0427\u043e\u0440\u0448\u0430\u043d\u0431\u0430_\u041f\u0430\u0439\u0448\u0430\u043d\u0431\u0430_\u0416\u0443\u043c\u0430_\u0428\u0430\u043d\u0431\u0430".split(
                    "_"
                ),
            weekdaysShort:
                "\u042f\u043a\u0448_\u0414\u0443\u0448_\u0421\u0435\u0448_\u0427\u043e\u0440_\u041f\u0430\u0439_\u0416\u0443\u043c_\u0428\u0430\u043d".split(
                    "_"
                ),
            weekdaysMin:
                "\u042f\u043a_\u0414\u0443_\u0421\u0435_\u0427\u043e_\u041f\u0430_\u0416\u0443_\u0428\u0430".split(
                    "_"
                ),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "D MMMM YYYY, dddd HH:mm",
            },
            calendar: {
                sameDay:
                    "[\u0411\u0443\u0433\u0443\u043d \u0441\u043e\u0430\u0442] LT [\u0434\u0430]",
                nextDay:
                    "[\u042d\u0440\u0442\u0430\u0433\u0430] LT [\u0434\u0430]",
                nextWeek:
                    "dddd [\u043a\u0443\u043d\u0438 \u0441\u043e\u0430\u0442] LT [\u0434\u0430]",
                lastDay:
                    "[\u041a\u0435\u0447\u0430 \u0441\u043e\u0430\u0442] LT [\u0434\u0430]",
                lastWeek:
                    "[\u0423\u0442\u0433\u0430\u043d] dddd [\u043a\u0443\u043d\u0438 \u0441\u043e\u0430\u0442] LT [\u0434\u0430]",
                sameElse: "L",
            },
            relativeTime: {
                future: "\u042f\u043a\u0438\u043d %s \u0438\u0447\u0438\u0434\u0430",
                past: "\u0411\u0438\u0440 \u043d\u0435\u0447\u0430 %s \u043e\u043b\u0434\u0438\u043d",
                s: "\u0444\u0443\u0440\u0441\u0430\u0442",
                ss: "%d \u0444\u0443\u0440\u0441\u0430\u0442",
                m: "\u0431\u0438\u0440 \u0434\u0430\u043a\u0438\u043a\u0430",
                mm: "%d \u0434\u0430\u043a\u0438\u043a\u0430",
                h: "\u0431\u0438\u0440 \u0441\u043e\u0430\u0442",
                hh: "%d \u0441\u043e\u0430\u0442",
                d: "\u0431\u0438\u0440 \u043a\u0443\u043d",
                dd: "%d \u043a\u0443\u043d",
                M: "\u0431\u0438\u0440 \u043e\u0439",
                MM: "%d \u043e\u0439",
                y: "\u0431\u0438\u0440 \u0439\u0438\u043b",
                yy: "%d \u0439\u0438\u043b",
            },
            week: { dow: 1, doy: 7 },
        }),
        M.defineLocale("vi", {
            months: "th\xe1ng 1_th\xe1ng 2_th\xe1ng 3_th\xe1ng 4_th\xe1ng 5_th\xe1ng 6_th\xe1ng 7_th\xe1ng 8_th\xe1ng 9_th\xe1ng 10_th\xe1ng 11_th\xe1ng 12".split(
                "_"
            ),
            monthsShort:
                "Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12".split(
                    "_"
                ),
            monthsParseExact: !0,
            weekdays:
                "ch\u1ee7 nh\u1eadt_th\u1ee9 hai_th\u1ee9 ba_th\u1ee9 t\u01b0_th\u1ee9 n\u0103m_th\u1ee9 s\xe1u_th\u1ee9 b\u1ea3y".split(
                    "_"
                ),
            weekdaysShort: "CN_T2_T3_T4_T5_T6_T7".split("_"),
            weekdaysMin: "CN_T2_T3_T4_T5_T6_T7".split("_"),
            weekdaysParseExact: !0,
            meridiemParse: /sa|ch/i,
            isPM: function (e) {
                return /^ch$/i.test(e);
            },
            meridiem: function (e, a, t) {
                return e < 12 ? (t ? "sa" : "SA") : t ? "ch" : "CH";
            },
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "D MMMM [n\u0103m] YYYY",
                LLL: "D MMMM [n\u0103m] YYYY HH:mm",
                LLLL: "dddd, D MMMM [n\u0103m] YYYY HH:mm",
                l: "DD/M/YYYY",
                ll: "D MMM YYYY",
                lll: "D MMM YYYY HH:mm",
                llll: "ddd, D MMM YYYY HH:mm",
            },
            calendar: {
                sameDay: "[H\xf4m nay l\xfac] LT",
                nextDay: "[Ng\xe0y mai l\xfac] LT",
                nextWeek: "dddd [tu\u1ea7n t\u1edbi l\xfac] LT",
                lastDay: "[H\xf4m qua l\xfac] LT",
                lastWeek: "dddd [tu\u1ea7n tr\u01b0\u1edbc l\xfac] LT",
                sameElse: "L",
            },
            relativeTime: {
                future: "%s t\u1edbi",
                past: "%s tr\u01b0\u1edbc",
                s: "v\xe0i gi\xe2y",
                ss: "%d gi\xe2y",
                m: "m\u1ed9t ph\xfat",
                mm: "%d ph\xfat",
                h: "m\u1ed9t gi\u1edd",
                hh: "%d gi\u1edd",
                d: "m\u1ed9t ng\xe0y",
                dd: "%d ng\xe0y",
                w: "m\u1ed9t tu\u1ea7n",
                ww: "%d tu\u1ea7n",
                M: "m\u1ed9t th\xe1ng",
                MM: "%d th\xe1ng",
                y: "m\u1ed9t n\u0103m",
                yy: "%d n\u0103m",
            },
            dayOfMonthOrdinalParse: /\d{1,2}/,
            ordinal: function (e) {
                return e;
            },
            week: { dow: 1, doy: 4 },
        }),
        M.defineLocale("x-pseudo", {
            months: "J~\xe1\xf1\xfa\xe1~r\xfd_F~\xe9br\xfa~\xe1r\xfd_~M\xe1rc~h_\xc1p~r\xedl_~M\xe1\xfd_~J\xfa\xf1\xe9~_J\xfal~\xfd_\xc1\xfa~g\xfast~_S\xe9p~t\xe9mb~\xe9r_\xd3~ct\xf3b~\xe9r_\xd1~\xf3v\xe9m~b\xe9r_~D\xe9c\xe9~mb\xe9r".split(
                "_"
            ),
            monthsShort:
                "J~\xe1\xf1_~F\xe9b_~M\xe1r_~\xc1pr_~M\xe1\xfd_~J\xfa\xf1_~J\xfal_~\xc1\xfag_~S\xe9p_~\xd3ct_~\xd1\xf3v_~D\xe9c".split(
                    "_"
                ),
            monthsParseExact: !0,
            weekdays:
                "S~\xfa\xf1d\xe1~\xfd_M\xf3~\xf1d\xe1\xfd~_T\xfa\xe9~sd\xe1\xfd~_W\xe9d~\xf1\xe9sd~\xe1\xfd_T~h\xfars~d\xe1\xfd_~Fr\xedd~\xe1\xfd_S~\xe1t\xfar~d\xe1\xfd".split(
                    "_"
                ),
            weekdaysShort:
                "S~\xfa\xf1_~M\xf3\xf1_~T\xfa\xe9_~W\xe9d_~Th\xfa_~Fr\xed_~S\xe1t".split(
                    "_"
                ),
            weekdaysMin: "S~\xfa_M\xf3~_T\xfa_~W\xe9_T~h_Fr~_S\xe1".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
                LT: "HH:mm",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY HH:mm",
                LLLL: "dddd, D MMMM YYYY HH:mm",
            },
            calendar: {
                sameDay: "[T~\xf3d\xe1~\xfd \xe1t] LT",
                nextDay: "[T~\xf3m\xf3~rr\xf3~w \xe1t] LT",
                nextWeek: "dddd [\xe1t] LT",
                lastDay: "[\xdd~\xe9st~\xe9rd\xe1~\xfd \xe1t] LT",
                lastWeek: "[L~\xe1st] dddd [\xe1t] LT",
                sameElse: "L",
            },
            relativeTime: {
                future: "\xed~\xf1 %s",
                past: "%s \xe1~g\xf3",
                s: "\xe1 ~f\xe9w ~s\xe9c\xf3~\xf1ds",
                ss: "%d s~\xe9c\xf3\xf1~ds",
                m: "\xe1 ~m\xed\xf1~\xfat\xe9",
                mm: "%d m~\xed\xf1\xfa~t\xe9s",
                h: "\xe1~\xf1 h\xf3~\xfar",
                hh: "%d h~\xf3\xfars",
                d: "\xe1 ~d\xe1\xfd",
                dd: "%d d~\xe1\xfds",
                M: "\xe1 ~m\xf3\xf1~th",
                MM: "%d m~\xf3\xf1t~hs",
                y: "\xe1 ~\xfd\xe9\xe1r",
                yy: "%d \xfd~\xe9\xe1rs",
            },
            dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
            ordinal: function (e) {
                var a = e % 10;
                return (
                    e +
                    (1 == ~~((e % 100) / 10)
                        ? "th"
                        : 1 == a
                        ? "st"
                        : 2 == a
                        ? "nd"
                        : 3 == a
                        ? "rd"
                        : "th")
                );
            },
            week: { dow: 1, doy: 4 },
        }),
        M.defineLocale("yo", {
            months: "S\u1eb9\u0301r\u1eb9\u0301_E\u0300re\u0300le\u0300_\u1eb8r\u1eb9\u0300na\u0300_I\u0300gbe\u0301_E\u0300bibi_O\u0300ku\u0300du_Ag\u1eb9mo_O\u0300gu\u0301n_Owewe_\u1ecc\u0300wa\u0300ra\u0300_Be\u0301lu\u0301_\u1ecc\u0300p\u1eb9\u0300\u0300".split(
                "_"
            ),
            monthsShort:
                "S\u1eb9\u0301r_E\u0300rl_\u1eb8rn_I\u0300gb_E\u0300bi_O\u0300ku\u0300_Ag\u1eb9_O\u0300gu\u0301_Owe_\u1ecc\u0300wa\u0300_Be\u0301l_\u1ecc\u0300p\u1eb9\u0300\u0300".split(
                    "_"
                ),
            weekdays:
                "A\u0300i\u0300ku\u0301_Aje\u0301_I\u0300s\u1eb9\u0301gun_\u1eccj\u1ecd\u0301ru\u0301_\u1eccj\u1ecd\u0301b\u1ecd_\u1eb8ti\u0300_A\u0300ba\u0301m\u1eb9\u0301ta".split(
                    "_"
                ),
            weekdaysShort:
                "A\u0300i\u0300k_Aje\u0301_I\u0300s\u1eb9\u0301_\u1eccjr_\u1eccjb_\u1eb8ti\u0300_A\u0300ba\u0301".split(
                    "_"
                ),
            weekdaysMin:
                "A\u0300i\u0300_Aj_I\u0300s_\u1eccr_\u1eccb_\u1eb8t_A\u0300b".split(
                    "_"
                ),
            longDateFormat: {
                LT: "h:mm A",
                LTS: "h:mm:ss A",
                L: "DD/MM/YYYY",
                LL: "D MMMM YYYY",
                LLL: "D MMMM YYYY h:mm A",
                LLLL: "dddd, D MMMM YYYY h:mm A",
            },
            calendar: {
                sameDay: "[O\u0300ni\u0300 ni] LT",
                nextDay: "[\u1ecc\u0300la ni] LT",
                nextWeek:
                    "dddd [\u1eccs\u1eb9\u0300 to\u0301n'b\u1ecd] [ni] LT",
                lastDay: "[A\u0300na ni] LT",
                lastWeek:
                    "dddd [\u1eccs\u1eb9\u0300 to\u0301l\u1ecd\u0301] [ni] LT",
                sameElse: "L",
            },
            relativeTime: {
                future: "ni\u0301 %s",
                past: "%s k\u1ecdja\u0301",
                s: "i\u0300s\u1eb9ju\u0301 aaya\u0301 die",
                ss: "aaya\u0301 %d",
                m: "i\u0300s\u1eb9ju\u0301 kan",
                mm: "i\u0300s\u1eb9ju\u0301 %d",
                h: "wa\u0301kati kan",
                hh: "wa\u0301kati %d",
                d: "\u1ecdj\u1ecd\u0301 kan",
                dd: "\u1ecdj\u1ecd\u0301 %d",
                M: "osu\u0300 kan",
                MM: "osu\u0300 %d",
                y: "\u1ecddu\u0301n kan",
                yy: "\u1ecddu\u0301n %d",
            },
            dayOfMonthOrdinalParse: /\u1ecdj\u1ecd\u0301\s\d{1,2}/,
            ordinal: "\u1ecdj\u1ecd\u0301 %d",
            week: { dow: 1, doy: 4 },
        }),
        M.defineLocale("zh-cn", {
            months: "\u4e00\u6708_\u4e8c\u6708_\u4e09\u6708_\u56db\u6708_\u4e94\u6708_\u516d\u6708_\u4e03\u6708_\u516b\u6708_\u4e5d\u6708_\u5341\u6708_\u5341\u4e00\u6708_\u5341\u4e8c\u6708".split(
                "_"
            ),
            monthsShort:
                "1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split(
                    "_"
                ),
            weekdays:
                "\u661f\u671f\u65e5_\u661f\u671f\u4e00_\u661f\u671f\u4e8c_\u661f\u671f\u4e09_\u661f\u671f\u56db_\u661f\u671f\u4e94_\u661f\u671f\u516d".split(
                    "_"
                ),
            weekdaysShort:
                "\u5468\u65e5_\u5468\u4e00_\u5468\u4e8c_\u5468\u4e09_\u5468\u56db_\u5468\u4e94_\u5468\u516d".split(
                    "_"
                ),
            weekdaysMin:
                "\u65e5_\u4e00_\u4e8c_\u4e09_\u56db_\u4e94_\u516d".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "YYYY/MM/DD",
                LL: "YYYY\u5e74M\u6708D\u65e5",
                LLL: "YYYY\u5e74M\u6708D\u65e5Ah\u70b9mm\u5206",
                LLLL: "YYYY\u5e74M\u6708D\u65e5ddddAh\u70b9mm\u5206",
                l: "YYYY/M/D",
                ll: "YYYY\u5e74M\u6708D\u65e5",
                lll: "YYYY\u5e74M\u6708D\u65e5 HH:mm",
                llll: "YYYY\u5e74M\u6708D\u65e5dddd HH:mm",
            },
            meridiemParse:
                /\u51cc\u6668|\u65e9\u4e0a|\u4e0a\u5348|\u4e2d\u5348|\u4e0b\u5348|\u665a\u4e0a/,
            meridiemHour: function (e, a) {
                return (
                    12 === e && (e = 0),
                    "\u51cc\u6668" === a ||
                    "\u65e9\u4e0a" === a ||
                    "\u4e0a\u5348" === a ||
                    ("\u4e0b\u5348" !== a && "\u665a\u4e0a" !== a && 11 <= e)
                        ? e
                        : e + 12
                );
            },
            meridiem: function (e, a, t) {
                e = 100 * e + a;
                return e < 600
                    ? "\u51cc\u6668"
                    : e < 900
                    ? "\u65e9\u4e0a"
                    : e < 1130
                    ? "\u4e0a\u5348"
                    : e < 1230
                    ? "\u4e2d\u5348"
                    : e < 1800
                    ? "\u4e0b\u5348"
                    : "\u665a\u4e0a";
            },
            calendar: {
                sameDay: "[\u4eca\u5929]LT",
                nextDay: "[\u660e\u5929]LT",
                nextWeek: function (e) {
                    return e.week() !== this.week()
                        ? "[\u4e0b]dddLT"
                        : "[\u672c]dddLT";
                },
                lastDay: "[\u6628\u5929]LT",
                lastWeek: function (e) {
                    return this.week() !== e.week()
                        ? "[\u4e0a]dddLT"
                        : "[\u672c]dddLT";
                },
                sameElse: "L",
            },
            dayOfMonthOrdinalParse: /\d{1,2}(\u65e5|\u6708|\u5468)/,
            ordinal: function (e, a) {
                switch (a) {
                    case "d":
                    case "D":
                    case "DDD":
                        return e + "\u65e5";
                    case "M":
                        return e + "\u6708";
                    case "w":
                    case "W":
                        return e + "\u5468";
                    default:
                        return e;
                }
            },
            relativeTime: {
                future: "%s\u540e",
                past: "%s\u524d",
                s: "\u51e0\u79d2",
                ss: "%d \u79d2",
                m: "1 \u5206\u949f",
                mm: "%d \u5206\u949f",
                h: "1 \u5c0f\u65f6",
                hh: "%d \u5c0f\u65f6",
                d: "1 \u5929",
                dd: "%d \u5929",
                w: "1 \u5468",
                ww: "%d \u5468",
                M: "1 \u4e2a\u6708",
                MM: "%d \u4e2a\u6708",
                y: "1 \u5e74",
                yy: "%d \u5e74",
            },
            week: { dow: 1, doy: 4 },
        }),
        M.defineLocale("zh-hk", {
            months: "\u4e00\u6708_\u4e8c\u6708_\u4e09\u6708_\u56db\u6708_\u4e94\u6708_\u516d\u6708_\u4e03\u6708_\u516b\u6708_\u4e5d\u6708_\u5341\u6708_\u5341\u4e00\u6708_\u5341\u4e8c\u6708".split(
                "_"
            ),
            monthsShort:
                "1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split(
                    "_"
                ),
            weekdays:
                "\u661f\u671f\u65e5_\u661f\u671f\u4e00_\u661f\u671f\u4e8c_\u661f\u671f\u4e09_\u661f\u671f\u56db_\u661f\u671f\u4e94_\u661f\u671f\u516d".split(
                    "_"
                ),
            weekdaysShort:
                "\u9031\u65e5_\u9031\u4e00_\u9031\u4e8c_\u9031\u4e09_\u9031\u56db_\u9031\u4e94_\u9031\u516d".split(
                    "_"
                ),
            weekdaysMin:
                "\u65e5_\u4e00_\u4e8c_\u4e09_\u56db_\u4e94_\u516d".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "YYYY/MM/DD",
                LL: "YYYY\u5e74M\u6708D\u65e5",
                LLL: "YYYY\u5e74M\u6708D\u65e5 HH:mm",
                LLLL: "YYYY\u5e74M\u6708D\u65e5dddd HH:mm",
                l: "YYYY/M/D",
                ll: "YYYY\u5e74M\u6708D\u65e5",
                lll: "YYYY\u5e74M\u6708D\u65e5 HH:mm",
                llll: "YYYY\u5e74M\u6708D\u65e5dddd HH:mm",
            },
            meridiemParse:
                /\u51cc\u6668|\u65e9\u4e0a|\u4e0a\u5348|\u4e2d\u5348|\u4e0b\u5348|\u665a\u4e0a/,
            meridiemHour: function (e, a) {
                return (
                    12 === e && (e = 0),
                    "\u51cc\u6668" === a ||
                    "\u65e9\u4e0a" === a ||
                    "\u4e0a\u5348" === a
                        ? e
                        : "\u4e2d\u5348" === a
                        ? 11 <= e
                            ? e
                            : e + 12
                        : "\u4e0b\u5348" === a || "\u665a\u4e0a" === a
                        ? e + 12
                        : void 0
                );
            },
            meridiem: function (e, a, t) {
                e = 100 * e + a;
                return e < 600
                    ? "\u51cc\u6668"
                    : e < 900
                    ? "\u65e9\u4e0a"
                    : e < 1200
                    ? "\u4e0a\u5348"
                    : 1200 === e
                    ? "\u4e2d\u5348"
                    : e < 1800
                    ? "\u4e0b\u5348"
                    : "\u665a\u4e0a";
            },
            calendar: {
                sameDay: "[\u4eca\u5929]LT",
                nextDay: "[\u660e\u5929]LT",
                nextWeek: "[\u4e0b]ddddLT",
                lastDay: "[\u6628\u5929]LT",
                lastWeek: "[\u4e0a]ddddLT",
                sameElse: "L",
            },
            dayOfMonthOrdinalParse: /\d{1,2}(\u65e5|\u6708|\u9031)/,
            ordinal: function (e, a) {
                switch (a) {
                    case "d":
                    case "D":
                    case "DDD":
                        return e + "\u65e5";
                    case "M":
                        return e + "\u6708";
                    case "w":
                    case "W":
                        return e + "\u9031";
                    default:
                        return e;
                }
            },
            relativeTime: {
                future: "%s\u5f8c",
                past: "%s\u524d",
                s: "\u5e7e\u79d2",
                ss: "%d \u79d2",
                m: "1 \u5206\u9418",
                mm: "%d \u5206\u9418",
                h: "1 \u5c0f\u6642",
                hh: "%d \u5c0f\u6642",
                d: "1 \u5929",
                dd: "%d \u5929",
                M: "1 \u500b\u6708",
                MM: "%d \u500b\u6708",
                y: "1 \u5e74",
                yy: "%d \u5e74",
            },
        }),
        M.defineLocale("zh-mo", {
            months: "\u4e00\u6708_\u4e8c\u6708_\u4e09\u6708_\u56db\u6708_\u4e94\u6708_\u516d\u6708_\u4e03\u6708_\u516b\u6708_\u4e5d\u6708_\u5341\u6708_\u5341\u4e00\u6708_\u5341\u4e8c\u6708".split(
                "_"
            ),
            monthsShort:
                "1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split(
                    "_"
                ),
            weekdays:
                "\u661f\u671f\u65e5_\u661f\u671f\u4e00_\u661f\u671f\u4e8c_\u661f\u671f\u4e09_\u661f\u671f\u56db_\u661f\u671f\u4e94_\u661f\u671f\u516d".split(
                    "_"
                ),
            weekdaysShort:
                "\u9031\u65e5_\u9031\u4e00_\u9031\u4e8c_\u9031\u4e09_\u9031\u56db_\u9031\u4e94_\u9031\u516d".split(
                    "_"
                ),
            weekdaysMin:
                "\u65e5_\u4e00_\u4e8c_\u4e09_\u56db_\u4e94_\u516d".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "DD/MM/YYYY",
                LL: "YYYY\u5e74M\u6708D\u65e5",
                LLL: "YYYY\u5e74M\u6708D\u65e5 HH:mm",
                LLLL: "YYYY\u5e74M\u6708D\u65e5dddd HH:mm",
                l: "D/M/YYYY",
                ll: "YYYY\u5e74M\u6708D\u65e5",
                lll: "YYYY\u5e74M\u6708D\u65e5 HH:mm",
                llll: "YYYY\u5e74M\u6708D\u65e5dddd HH:mm",
            },
            meridiemParse:
                /\u51cc\u6668|\u65e9\u4e0a|\u4e0a\u5348|\u4e2d\u5348|\u4e0b\u5348|\u665a\u4e0a/,
            meridiemHour: function (e, a) {
                return (
                    12 === e && (e = 0),
                    "\u51cc\u6668" === a ||
                    "\u65e9\u4e0a" === a ||
                    "\u4e0a\u5348" === a
                        ? e
                        : "\u4e2d\u5348" === a
                        ? 11 <= e
                            ? e
                            : e + 12
                        : "\u4e0b\u5348" === a || "\u665a\u4e0a" === a
                        ? e + 12
                        : void 0
                );
            },
            meridiem: function (e, a, t) {
                e = 100 * e + a;
                return e < 600
                    ? "\u51cc\u6668"
                    : e < 900
                    ? "\u65e9\u4e0a"
                    : e < 1130
                    ? "\u4e0a\u5348"
                    : e < 1230
                    ? "\u4e2d\u5348"
                    : e < 1800
                    ? "\u4e0b\u5348"
                    : "\u665a\u4e0a";
            },
            calendar: {
                sameDay: "[\u4eca\u5929] LT",
                nextDay: "[\u660e\u5929] LT",
                nextWeek: "[\u4e0b]dddd LT",
                lastDay: "[\u6628\u5929] LT",
                lastWeek: "[\u4e0a]dddd LT",
                sameElse: "L",
            },
            dayOfMonthOrdinalParse: /\d{1,2}(\u65e5|\u6708|\u9031)/,
            ordinal: function (e, a) {
                switch (a) {
                    case "d":
                    case "D":
                    case "DDD":
                        return e + "\u65e5";
                    case "M":
                        return e + "\u6708";
                    case "w":
                    case "W":
                        return e + "\u9031";
                    default:
                        return e;
                }
            },
            relativeTime: {
                future: "%s\u5167",
                past: "%s\u524d",
                s: "\u5e7e\u79d2",
                ss: "%d \u79d2",
                m: "1 \u5206\u9418",
                mm: "%d \u5206\u9418",
                h: "1 \u5c0f\u6642",
                hh: "%d \u5c0f\u6642",
                d: "1 \u5929",
                dd: "%d \u5929",
                M: "1 \u500b\u6708",
                MM: "%d \u500b\u6708",
                y: "1 \u5e74",
                yy: "%d \u5e74",
            },
        }),
        M.defineLocale("zh-tw", {
            months: "\u4e00\u6708_\u4e8c\u6708_\u4e09\u6708_\u56db\u6708_\u4e94\u6708_\u516d\u6708_\u4e03\u6708_\u516b\u6708_\u4e5d\u6708_\u5341\u6708_\u5341\u4e00\u6708_\u5341\u4e8c\u6708".split(
                "_"
            ),
            monthsShort:
                "1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split(
                    "_"
                ),
            weekdays:
                "\u661f\u671f\u65e5_\u661f\u671f\u4e00_\u661f\u671f\u4e8c_\u661f\u671f\u4e09_\u661f\u671f\u56db_\u661f\u671f\u4e94_\u661f\u671f\u516d".split(
                    "_"
                ),
            weekdaysShort:
                "\u9031\u65e5_\u9031\u4e00_\u9031\u4e8c_\u9031\u4e09_\u9031\u56db_\u9031\u4e94_\u9031\u516d".split(
                    "_"
                ),
            weekdaysMin:
                "\u65e5_\u4e00_\u4e8c_\u4e09_\u56db_\u4e94_\u516d".split("_"),
            longDateFormat: {
                LT: "HH:mm",
                LTS: "HH:mm:ss",
                L: "YYYY/MM/DD",
                LL: "YYYY\u5e74M\u6708D\u65e5",
                LLL: "YYYY\u5e74M\u6708D\u65e5 HH:mm",
                LLLL: "YYYY\u5e74M\u6708D\u65e5dddd HH:mm",
                l: "YYYY/M/D",
                ll: "YYYY\u5e74M\u6708D\u65e5",
                lll: "YYYY\u5e74M\u6708D\u65e5 HH:mm",
                llll: "YYYY\u5e74M\u6708D\u65e5dddd HH:mm",
            },
            meridiemParse:
                /\u51cc\u6668|\u65e9\u4e0a|\u4e0a\u5348|\u4e2d\u5348|\u4e0b\u5348|\u665a\u4e0a/,
            meridiemHour: function (e, a) {
                return (
                    12 === e && (e = 0),
                    "\u51cc\u6668" === a ||
                    "\u65e9\u4e0a" === a ||
                    "\u4e0a\u5348" === a
                        ? e
                        : "\u4e2d\u5348" === a
                        ? 11 <= e
                            ? e
                            : e + 12
                        : "\u4e0b\u5348" === a || "\u665a\u4e0a" === a
                        ? e + 12
                        : void 0
                );
            },
            meridiem: function (e, a, t) {
                e = 100 * e + a;
                return e < 600
                    ? "\u51cc\u6668"
                    : e < 900
                    ? "\u65e9\u4e0a"
                    : e < 1130
                    ? "\u4e0a\u5348"
                    : e < 1230
                    ? "\u4e2d\u5348"
                    : e < 1800
                    ? "\u4e0b\u5348"
                    : "\u665a\u4e0a";
            },
            calendar: {
                sameDay: "[\u4eca\u5929] LT",
                nextDay: "[\u660e\u5929] LT",
                nextWeek: "[\u4e0b]dddd LT",
                lastDay: "[\u6628\u5929] LT",
                lastWeek: "[\u4e0a]dddd LT",
                sameElse: "L",
            },
            dayOfMonthOrdinalParse: /\d{1,2}(\u65e5|\u6708|\u9031)/,
            ordinal: function (e, a) {
                switch (a) {
                    case "d":
                    case "D":
                    case "DDD":
                        return e + "\u65e5";
                    case "M":
                        return e + "\u6708";
                    case "w":
                    case "W":
                        return e + "\u9031";
                    default:
                        return e;
                }
            },
            relativeTime: {
                future: "%s\u5f8c",
                past: "%s\u524d",
                s: "\u5e7e\u79d2",
                ss: "%d \u79d2",
                m: "1 \u5206\u9418",
                mm: "%d \u5206\u9418",
                h: "1 \u5c0f\u6642",
                hh: "%d \u5c0f\u6642",
                d: "1 \u5929",
                dd: "%d \u5929",
                M: "1 \u500b\u6708",
                MM: "%d \u500b\u6708",
                y: "1 \u5e74",
                yy: "%d \u5e74",
            },
        }),
        M.locale("en"),
        M
    );
});
//# sourceMappingURL=moment-with-locales.min.js.map

!function(a,i){"use strict";"object"==typeof module&&module.exports?module.exports=i(require("moment")):"function"==typeof define&&define.amd?define(["moment"],i):i(a.moment)}(this,function(o){"use strict";void 0===o.version&&o.default&&(o=o.default);var i,s={},c={},A={},u={},m={},a=(o&&"string"==typeof o.version||D("Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/"),o.version.split(".")),r=+a[0],e=+a[1];function n(a){return 96<a?a-87:64<a?a-29:a-48}function t(a){var i=0,r=a.split("."),e=r[0],o=r[1]||"",c=1,A=0,r=1;for(45===a.charCodeAt(0)&&(r=-(i=1));i<e.length;i++)A=60*A+n(e.charCodeAt(i));for(i=0;i<o.length;i++)c/=60,A+=n(o.charCodeAt(i))*c;return A*r}function l(a){for(var i=0;i<a.length;i++)a[i]=t(a[i])}function f(a,i){for(var r=[],e=0;e<i.length;e++)r[e]=a[i[e]];return r}function p(a){for(var a=a.split("|"),i=a[2].split(" "),r=a[3].split(""),e=a[4].split(" "),o=(l(i),l(r),l(e),e),c=r.length,A=0;A<c;A++)o[A]=Math.round((o[A-1]||0)+6e4*o[A]);return o[c-1]=1/0,{name:a[0],abbrs:f(a[1].split(" "),r),offsets:f(i,r),untils:e,population:0|a[5]}}function M(a){a&&this._set(p(a))}function b(a,i){this.name=a,this.zones=i}function h(a){var i=a.toTimeString(),r=i.match(/\([a-z ]+\)/i);"GMT"===(r=r&&r[0]?(r=r[0].match(/[A-Z]/g))?r.join(""):void 0:(r=i.match(/[A-Z]{3,5}/g))?r[0]:void 0)&&(r=void 0),this.at=+a,this.abbr=r,this.offset=a.getTimezoneOffset()}function d(a){this.zone=a,this.offsetScore=0,this.abbrScore=0}function E(){for(var a,i,r,e=(new Date).getFullYear()-2,o=new h(new Date(e,0,1)),c=o.offset,A=[o],n=1;n<48;n++)(r=new Date(e,n,1).getTimezoneOffset())!==c&&(a=function(a,i){for(var r;r=6e4*((i.at-a.at)/12e4|0);)(r=new h(new Date(a.at+r))).offset===a.offset?a=r:i=r;return a}(o,i=new h(new Date(e,n,1))),A.push(a),A.push(new h(new Date(a.at+6e4))),o=i,c=r);for(n=0;n<4;n++)A.push(new h(new Date(e+n,0,1))),A.push(new h(new Date(e+n,6,1)));return A}function g(a,i){return a.offsetScore!==i.offsetScore?a.offsetScore-i.offsetScore:a.abbrScore!==i.abbrScore?a.abbrScore-i.abbrScore:a.zone.population!==i.zone.population?i.zone.population-a.zone.population:i.zone.name.localeCompare(a.zone.name)}function z(){try{var a=Intl.DateTimeFormat().resolvedOptions().timeZone;if(a&&3<a.length){var i=u[P(a)];if(i)return i;D("Moment Timezone found "+a+" from the Intl api, but did not have that data loaded.")}}catch(a){}for(var r,e,o=E(),c=o.length,A=function(a){for(var i,r,e,o=a.length,c={},A=[],n={},t=0;t<o;t++)if(r=a[t].offset,!n.hasOwnProperty(r)){for(i in e=m[r]||{})e.hasOwnProperty(i)&&(c[i]=!0);n[r]=!0}for(t in c)c.hasOwnProperty(t)&&A.push(u[t]);return A}(o),n=[],t=0;t<A.length;t++){for(r=new d(T(A[t])),e=0;e<c;e++)r.scoreOffsetAt(o[e]);n.push(r)}return n.sort(g),0<n.length?n[0].zone.name:void 0}function P(a){return(a||"").toLowerCase().replace(/\//g,"_")}function k(a){var i,r,e,o;for("string"==typeof a&&(a=[a]),i=0;i<a.length;i++){o=P(r=(e=a[i].split("|"))[0]),s[o]=a[i],u[o]=r,A=c=t=n=void 0;var c,A,n=o,t=e[2].split(" ");for(l(t),c=0;c<t.length;c++)A=t[c],m[A]=m[A]||{},m[A][n]=!0}}function T(a,i){a=P(a);var r=s[a];return r instanceof M?r:"string"==typeof r?(r=new M(r),s[a]=r):c[a]&&i!==T&&(i=T(c[a],T))?((r=s[a]=new M)._set(i),r.name=u[a],r):null}function S(a){var i,r,e,o;for("string"==typeof a&&(a=[a]),i=0;i<a.length;i++)e=P((r=a[i].split("|"))[0]),o=P(r[1]),c[e]=o,u[e]=r[0],c[o]=e,u[o]=r[1]}function _(a){k(a.zones),S(a.links);var i,r,e,o=a.countries;if(o&&o.length)for(i=0;i<o.length;i++)r=(e=o[i].split("|"))[0].toUpperCase(),e=e[1].split(" "),A[r]=new b(r,e);y.dataVersion=a.version}function C(a){return C.didShowError||(C.didShowError=!0,D("moment.tz.zoneExists('"+a+"') has been deprecated in favor of !moment.tz.zone('"+a+"')")),!!T(a)}function B(a){var i="X"===a._f||"x"===a._f;return!(!a._a||void 0!==a._tzm||i)}function D(a){"undefined"!=typeof console&&"function"==typeof console.error&&console.error(a)}function y(a){var i=Array.prototype.slice.call(arguments,0,-1),r=arguments[arguments.length-1],i=o.utc.apply(null,i);return!o.isMoment(a)&&B(i)&&(a=T(r))&&i.add(a.parse(i),"minutes"),i.tz(r),i}(r<2||2==r&&e<6)&&D("Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js "+o.version+". See momentjs.com"),M.prototype={_set:function(a){this.name=a.name,this.abbrs=a.abbrs,this.untils=a.untils,this.offsets=a.offsets,this.population=a.population},_index:function(a){a=function(a,i){var r,e=i.length;if(a<i[0])return 0;if(1<e&&i[e-1]===1/0&&a>=i[e-2])return e-1;if(a>=i[e-1])return-1;for(var o=0,c=e-1;1<c-o;)i[r=Math.floor((o+c)/2)]<=a?o=r:c=r;return c}(+a,this.untils);if(0<=a)return a},countries:function(){var i=this.name;return Object.keys(A).filter(function(a){return-1!==A[a].zones.indexOf(i)})},parse:function(a){for(var i,r,e,o=+a,c=this.offsets,A=this.untils,n=A.length-1,t=0;t<n;t++)if(i=c[t],r=c[t+1],e=c[t&&t-1],i<r&&y.moveAmbiguousForward?i=r:e<i&&y.moveInvalidForward&&(i=e),o<A[t]-6e4*i)return c[t];return c[n]},abbr:function(a){return this.abbrs[this._index(a)]},offset:function(a){return D("zone.offset has been deprecated in favor of zone.utcOffset"),this.offsets[this._index(a)]},utcOffset:function(a){return this.offsets[this._index(a)]}},d.prototype.scoreOffsetAt=function(a){this.offsetScore+=Math.abs(this.zone.utcOffset(a.at)-a.offset),this.zone.abbr(a.at).replace(/[^A-Z]/g,"")!==a.abbr&&this.abbrScore++},y.version="0.5.44",y.dataVersion="",y._zones=s,y._links=c,y._names=u,y._countries=A,y.add=k,y.link=S,y.load=_,y.zone=T,y.zoneExists=C,y.guess=function(a){return i=i&&!a?i:z()},y.names=function(){var a,i=[];for(a in u)u.hasOwnProperty(a)&&(s[a]||s[c[a]])&&u[a]&&i.push(u[a]);return i.sort()},y.Zone=M,y.unpack=p,y.unpackBase60=t,y.needsOffset=B,y.moveInvalidForward=!0,y.moveAmbiguousForward=!1,y.countries=function(){return Object.keys(A)},y.zonesForCountry=function(a,i){var r;return r=(r=a).toUpperCase(),(a=A[r]||null)?(r=a.zones.sort(),i?r.map(function(a){return{name:a,offset:T(a).utcOffset(new Date)}}):r):null};var L,a=o.fn;function O(a){return function(){return this._z?this._z.abbr(this):a.call(this)}}function N(a){return function(){return this._z=null,a.apply(this,arguments)}}o.tz=y,o.defaultZone=null,o.updateOffset=function(a,i){var r,e=o.defaultZone;void 0===a._z&&(e&&B(a)&&!a._isUTC&&a.isValid()&&(a._d=o.utc(a._a)._d,a.utc().add(e.parse(a),"minutes")),a._z=e),a._z&&(e=a._z.utcOffset(a),Math.abs(e)<16&&(e/=60),void 0!==a.utcOffset?(r=a._z,a.utcOffset(-e,i),a._z=r):a.zone(e,i))},a.tz=function(a,i){if(a){if("string"!=typeof a)throw new Error("Time zone name must be a string, got "+a+" ["+typeof a+"]");return this._z=T(a),this._z?o.updateOffset(this,i):D("Moment Timezone has no data for "+a+". See http://momentjs.com/timezone/docs/#/data-loading/."),this}if(this._z)return this._z.name},a.zoneName=O(a.zoneName),a.zoneAbbr=O(a.zoneAbbr),a.utc=N(a.utc),a.local=N(a.local),a.utcOffset=(L=a.utcOffset,function(){return 0<arguments.length&&(this._z=null),L.apply(this,arguments)}),o.tz.setDefault=function(a){return(r<2||2==r&&e<9)&&D("Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js "+o.version+"."),o.defaultZone=a?T(a):null,o};a=o.momentProperties;return"[object Array]"===Object.prototype.toString.call(a)?(a.push("_z"),a.push("_a")):a&&(a._z=null),_({version:"2023d",zones:["Africa/Abidjan|GMT|0|0||48e5","Africa/Nairobi|EAT|-30|0||47e5","Africa/Algiers|CET|-10|0||26e5","Africa/Lagos|WAT|-10|0||17e6","Africa/Khartoum|CAT|-20|0||51e5","Africa/Cairo|EET EEST|-20 -30|0101010101010|29NW0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0|15e6","Africa/Casablanca|+00 +01|0 -10|010101010101010101010101|1Vq20 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|32e5","Europe/Paris|CET CEST|-10 -20|01010101010101010101010|1Vq10 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|11e6","Africa/Johannesburg|SAST|-20|0||84e5","Africa/Juba|EAT CAT|-30 -20|01|24nx0|","Africa/Sao_Tome|GMT WAT|0 -10|010|1UQN0 2q00|","Africa/Tripoli|EET|-20|0||11e5","America/Adak|HST HDT|a0 90|01010101010101010101010|1VkA0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|326","America/Anchorage|AKST AKDT|90 80|01010101010101010101010|1Vkz0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|30e4","America/Santo_Domingo|AST|40|0||29e5","America/Fortaleza|-03|30|0||34e5","America/Asuncion|-03 -04|30 40|01010101010101010101010|1Vq30 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0|28e5","America/Panama|EST|50|0||15e5","America/Mexico_City|CST CDT|60 50|01010101010|1VsU0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|20e6","America/Managua|CST|60|0||22e5","America/Caracas|-04|40|0||29e5","America/Lima|-05|50|0||11e6","America/Denver|MST MDT|70 60|01010101010101010101010|1Vkx0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|26e5","America/Campo_Grande|-03 -04|30 40|0101|1Vc30 1HB0 FX0|77e4","America/Chicago|CST CDT|60 50|01010101010101010101010|1Vkw0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|92e5","America/Chihuahua|MST MDT CST|70 60 60|01010101012|1VsV0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|81e4","America/Ciudad_Juarez|MST MDT CST|70 60 60|010101010120101010101010|1Vkx0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0 cm0 EP0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|","America/Phoenix|MST|70|0||42e5","America/Whitehorse|PST PDT MST|80 70 70|0101012|1Vky0 1zb0 Op0 1zb0 Op0 1z90|23e3","America/New_York|EST EDT|50 40|01010101010101010101010|1Vkv0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|21e6","America/Los_Angeles|PST PDT|80 70|01010101010101010101010|1Vky0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|15e6","America/Halifax|AST ADT|40 30|01010101010101010101010|1Vku0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|39e4","America/Godthab|-03 -02 -01|30 20 10|0101010101012121212121|1Vq10 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 2so0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|17e3","America/Grand_Turk|AST EDT EST|40 40 50|01212121212121212121212|1Vkv0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|37e2","America/Havana|CST CDT|50 40|01010101010101010101010|1Vkt0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0|21e5","America/Mazatlan|MST MDT|70 60|01010101010|1VsV0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|44e4","America/Metlakatla|AKST AKDT PST|90 80 80|012010101010101010101010|1Vkz0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|14e2","America/Miquelon|-03 -02|30 20|01010101010101010101010|1Vkt0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|61e2","America/Noronha|-02|20|0||30e2","America/Ojinaga|MST MDT CST CDT|70 60 60 50|01010101012323232323232|1Vkx0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0 Rc0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|23e3","America/Santiago|-03 -04|30 40|01010101010101010101010|1VJD0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|62e5","America/Sao_Paulo|-02 -03|20 30|0101|1Vc20 1HB0 FX0|20e6","America/Scoresbysund|-01 +00 -02|10 0 20|0101010101010202020202|1Vq10 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 2pA0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|452","America/St_Johns|NST NDT|3u 2u|01010101010101010101010|1Vktu 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|11e4","Antarctica/Casey|+11 +08|-b0 -80|010101010101|1Vkh0 1o30 14k0 1kr0 12l0 1o01 14kX 1lf1 14kX 1lf1 13bX|10","Asia/Bangkok|+07|-70|0||15e6","Asia/Vladivostok|+10|-a0|0||60e4","Australia/Sydney|AEDT AEST|-b0 -a0|01010101010101010101010|1VsE0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|40e5","Asia/Tashkent|+05|-50|0||23e5","Pacific/Auckland|NZDT NZST|-d0 -c0|01010101010101010101010|1VsC0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00|14e5","Europe/Istanbul|+03|-30|0||13e6","Antarctica/Troll|+00 +02|0 -20|01010101010101010101010|1Vq10 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|40","Antarctica/Vostok|+07 +05|-70 -50|01|2bnv0|25","Asia/Dhaka|+06|-60|0||16e6","Asia/Amman|EET EEST +03|-20 -30 -30|01010101012|1VrW0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 LA0 1C00|25e5","Asia/Kamchatka|+12|-c0|0||18e4","Asia/Dubai|+04|-40|0||39e5","Asia/Beirut|EET EEST|-20 -30|01010101010101010101010|1VpW0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|22e5","Asia/Kuala_Lumpur|+08|-80|0||71e5","Asia/Kolkata|IST|-5u|0||15e6","Asia/Chita|+09|-90|0||33e4","Asia/Shanghai|CST|-80|0||23e6","Asia/Colombo|+0530|-5u|0||22e5","Asia/Damascus|EET EEST +03|-20 -30 -30|01010101012|1VrW0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0|26e5","Europe/Athens|EET EEST|-20 -30|01010101010101010101010|1Vq10 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|35e5","Asia/Gaza|EET EEST|-20 -30|01010101010101010101010|1Vpz0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 XA0 1qp0 1cN0 1cL0 17d0 1in0 14p0 1lb0 11B0 1nX0 11B0 1qL0 WN0 1qL0|18e5","Asia/Hong_Kong|HKT|-80|0||73e5","Asia/Jakarta|WIB|-70|0||31e6","Asia/Jayapura|WIT|-90|0||26e4","Asia/Jerusalem|IST IDT|-20 -30|01010101010101010101010|1Vpc0 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0|81e4","Asia/Kabul|+0430|-4u|0||46e5","Asia/Karachi|PKT|-50|0||24e6","Asia/Kathmandu|+0545|-5J|0||12e5","Asia/Sakhalin|+11|-b0|0||58e4","Asia/Makassar|WITA|-80|0||15e5","Asia/Manila|PST|-80|0||24e6","Asia/Pyongyang|KST KST|-8u -90|01|1VGf0|29e5","Asia/Qyzylorda|+06 +05|-60 -50|01|1Xei0|73e4","Asia/Rangoon|+0630|-6u|0||48e5","Asia/Seoul|KST|-90|0||23e6","Asia/Tehran|+0330 +0430|-3u -4u|01010101010|1VoIu 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0|14e6","Asia/Tokyo|JST|-90|0||38e6","Atlantic/Azores|-01 +00|10 0|01010101010101010101010|1Vq10 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e4","Europe/Lisbon|WET WEST|0 -10|01010101010101010101010|1Vq10 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|27e5","Atlantic/Cape_Verde|-01|10|0||50e4","Australia/Adelaide|ACDT ACST|-au -9u|01010101010101010101010|1VsEu 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|AEST|-a0|0||20e5","Australia/Darwin|ACST|-9u|0||12e4","Australia/Eucla|+0845|-8J|0||368","Australia/Lord_Howe|+11 +1030|-b0 -au|01010101010101010101010|1VsD0 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu|347","Australia/Perth|AWST|-80|0||18e5","Pacific/Easter|-05 -06|50 60|01010101010101010101010|1VJD0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|30e2","Europe/Dublin|GMT IST|0 -10|01010101010101010101010|1Vq10 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|12e5","Etc/GMT-1|+01|-10|0||","Pacific/Tongatapu|+13|-d0|0||75e3","Pacific/Kiritimati|+14|-e0|0||51e2","Etc/GMT-2|+02|-20|0||","Pacific/Tahiti|-10|a0|0||18e4","Pacific/Niue|-11|b0|0||12e2","Etc/GMT+12|-12|c0|0||","Pacific/Galapagos|-06|60|0||25e3","Etc/GMT+7|-07|70|0||","Pacific/Pitcairn|-08|80|0||56","Pacific/Gambier|-09|90|0||125","Etc/UTC|UTC|0|0||","Europe/London|GMT BST|0 -10|01010101010101010101010|1Vq10 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|10e6","Europe/Chisinau|EET EEST|-20 -30|01010101010101010101010|1Vq00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|67e4","Europe/Moscow|MSK|-30|0||16e6","Europe/Volgograd|MSK +04|-30 -40|010|1WQL0 5gn0|10e5","Pacific/Honolulu|HST|a0|0||37e4","MET|MET MEST|-10 -20|01010101010101010101010|1Vq10 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|","Pacific/Chatham|+1345 +1245|-dJ -cJ|01010101010101010101010|1VsC0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00|600","Pacific/Apia|+14 +13|-e0 -d0|01010101|1VsC0 1cM0 1fA0 1a00 1fA0 1a00 1fA0|37e3","Pacific/Fiji|+13 +12|-d0 -c0|01010101|1UVO0 1VA0 s00 20o0 pc0 2hc0 bc0|88e4","Pacific/Guam|ChST|-a0|0||17e4","Pacific/Marquesas|-0930|9u|0||86e2","Pacific/Pago_Pago|SST|b0|0||37e2","Pacific/Norfolk|+11 +12|-b0 -c0|01010101010101010101|219P0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|25e4"],links:["Africa/Abidjan|Africa/Accra","Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Bissau","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Monrovia","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|America/Danmarkshavn","Africa/Abidjan|Atlantic/Reykjavik","Africa/Abidjan|Atlantic/St_Helena","Africa/Abidjan|Etc/GMT","Africa/Abidjan|Etc/GMT+0","Africa/Abidjan|Etc/GMT-0","Africa/Abidjan|Etc/GMT0","Africa/Abidjan|Etc/Greenwich","Africa/Abidjan|GMT","Africa/Abidjan|GMT+0","Africa/Abidjan|GMT-0","Africa/Abidjan|GMT0","Africa/Abidjan|Greenwich","Africa/Abidjan|Iceland","Africa/Algiers|Africa/Tunis","Africa/Cairo|Egypt","Africa/Casablanca|Africa/El_Aaiun","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Khartoum|Africa/Blantyre","Africa/Khartoum|Africa/Bujumbura","Africa/Khartoum|Africa/Gaborone","Africa/Khartoum|Africa/Harare","Africa/Khartoum|Africa/Kigali","Africa/Khartoum|Africa/Lubumbashi","Africa/Khartoum|Africa/Lusaka","Africa/Khartoum|Africa/Maputo","Africa/Khartoum|Africa/Windhoek","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Ndjamena","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Europe/Kaliningrad","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|America/Juneau","America/Anchorage|America/Nome","America/Anchorage|America/Sitka","America/Anchorage|America/Yakutat","America/Anchorage|US/Alaska","America/Campo_Grande|America/Cuiaba","America/Caracas|America/Boa_Vista","America/Caracas|America/Guyana","America/Caracas|America/La_Paz","America/Caracas|America/Manaus","America/Caracas|America/Porto_Velho","America/Caracas|Brazil/West","America/Caracas|Etc/GMT+4","America/Chicago|America/Indiana/Knox","America/Chicago|America/Indiana/Tell_City","America/Chicago|America/Knox_IN","America/Chicago|America/Matamoros","America/Chicago|America/Menominee","America/Chicago|America/North_Dakota/Beulah","America/Chicago|America/North_Dakota/Center","America/Chicago|America/North_Dakota/New_Salem","America/Chicago|America/Rainy_River","America/Chicago|America/Rankin_Inlet","America/Chicago|America/Resolute","America/Chicago|America/Winnipeg","America/Chicago|CST6CDT","America/Chicago|Canada/Central","America/Chicago|US/Central","America/Chicago|US/Indiana-Starke","America/Denver|America/Boise","America/Denver|America/Cambridge_Bay","America/Denver|America/Edmonton","America/Denver|America/Inuvik","America/Denver|America/Shiprock","America/Denver|America/Yellowknife","America/Denver|Canada/Mountain","America/Denver|MST7MDT","America/Denver|Navajo","America/Denver|US/Mountain","America/Fortaleza|America/Araguaina","America/Fortaleza|America/Argentina/Buenos_Aires","America/Fortaleza|America/Argentina/Catamarca","America/Fortaleza|America/Argentina/ComodRivadavia","America/Fortaleza|America/Argentina/Cordoba","America/Fortaleza|America/Argentina/Jujuy","America/Fortaleza|America/Argentina/La_Rioja","America/Fortaleza|America/Argentina/Mendoza","America/Fortaleza|America/Argentina/Rio_Gallegos","America/Fortaleza|America/Argentina/Salta","America/Fortaleza|America/Argentina/San_Juan","America/Fortaleza|America/Argentina/San_Luis","America/Fortaleza|America/Argentina/Tucuman","America/Fortaleza|America/Argentina/Ushuaia","America/Fortaleza|America/Bahia","America/Fortaleza|America/Belem","America/Fortaleza|America/Buenos_Aires","America/Fortaleza|America/Catamarca","America/Fortaleza|America/Cayenne","America/Fortaleza|America/Cordoba","America/Fortaleza|America/Jujuy","America/Fortaleza|America/Maceio","America/Fortaleza|America/Mendoza","America/Fortaleza|America/Montevideo","America/Fortaleza|America/Paramaribo","America/Fortaleza|America/Punta_Arenas","America/Fortaleza|America/Recife","America/Fortaleza|America/Rosario","America/Fortaleza|America/Santarem","America/Fortaleza|Antarctica/Palmer","America/Fortaleza|Antarctica/Rothera","America/Fortaleza|Atlantic/Stanley","America/Fortaleza|Etc/GMT+3","America/Godthab|America/Nuuk","America/Halifax|America/Glace_Bay","America/Halifax|America/Goose_Bay","America/Halifax|America/Moncton","America/Halifax|America/Thule","America/Halifax|Atlantic/Bermuda","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Lima|America/Bogota","America/Lima|America/Eirunepe","America/Lima|America/Guayaquil","America/Lima|America/Porto_Acre","America/Lima|America/Rio_Branco","America/Lima|Brazil/Acre","America/Lima|Etc/GMT+5","America/Los_Angeles|America/Ensenada","America/Los_Angeles|America/Santa_Isabel","America/Los_Angeles|America/Tijuana","America/Los_Angeles|America/Vancouver","America/Los_Angeles|Canada/Pacific","America/Los_Angeles|Mexico/BajaNorte","America/Los_Angeles|PST8PDT","America/Los_Angeles|US/Pacific","America/Managua|America/Belize","America/Managua|America/Costa_Rica","America/Managua|America/El_Salvador","America/Managua|America/Guatemala","America/Managua|America/Regina","America/Managua|America/Swift_Current","America/Managua|America/Tegucigalpa","America/Managua|Canada/Saskatchewan","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|America/Bahia_Banderas","America/Mexico_City|America/Merida","America/Mexico_City|America/Monterrey","America/Mexico_City|Mexico/General","America/New_York|America/Detroit","America/New_York|America/Fort_Wayne","America/New_York|America/Indiana/Indianapolis","America/New_York|America/Indiana/Marengo","America/New_York|America/Indiana/Petersburg","America/New_York|America/Indiana/Vevay","America/New_York|America/Indiana/Vincennes","America/New_York|America/Indiana/Winamac","America/New_York|America/Indianapolis","America/New_York|America/Iqaluit","America/New_York|America/Kentucky/Louisville","America/New_York|America/Kentucky/Monticello","America/New_York|America/Louisville","America/New_York|America/Montreal","America/New_York|America/Nassau","America/New_York|America/Nipigon","America/New_York|America/Pangnirtung","America/New_York|America/Port-au-Prince","America/New_York|America/Thunder_Bay","America/New_York|America/Toronto","America/New_York|Canada/Eastern","America/New_York|EST5EDT","America/New_York|US/East-Indiana","America/New_York|US/Eastern","America/New_York|US/Michigan","America/Noronha|Atlantic/South_Georgia","America/Noronha|Brazil/DeNoronha","America/Noronha|Etc/GMT+2","America/Panama|America/Atikokan","America/Panama|America/Cancun","America/Panama|America/Cayman","America/Panama|America/Coral_Harbour","America/Panama|America/Jamaica","America/Panama|EST","America/Panama|Jamaica","America/Phoenix|America/Creston","America/Phoenix|America/Dawson_Creek","America/Phoenix|America/Fort_Nelson","America/Phoenix|America/Hermosillo","America/Phoenix|MST","America/Phoenix|US/Arizona","America/Santiago|Chile/Continental","America/Santo_Domingo|America/Anguilla","America/Santo_Domingo|America/Antigua","America/Santo_Domingo|America/Aruba","America/Santo_Domingo|America/Barbados","America/Santo_Domingo|America/Blanc-Sablon","America/Santo_Domingo|America/Curacao","America/Santo_Domingo|America/Dominica","America/Santo_Domingo|America/Grenada","America/Santo_Domingo|America/Guadeloupe","America/Santo_Domingo|America/Kralendijk","America/Santo_Domingo|America/Lower_Princes","America/Santo_Domingo|America/Marigot","America/Santo_Domingo|America/Martinique","America/Santo_Domingo|America/Montserrat","America/Santo_Domingo|America/Port_of_Spain","America/Santo_Domingo|America/Puerto_Rico","America/Santo_Domingo|America/St_Barthelemy","America/Santo_Domingo|America/St_Kitts","America/Santo_Domingo|America/St_Lucia","America/Santo_Domingo|America/St_Thomas","America/Santo_Domingo|America/St_Vincent","America/Santo_Domingo|America/Tortola","America/Santo_Domingo|America/Virgin","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Whitehorse|America/Dawson","America/Whitehorse|Canada/Yukon","Asia/Bangkok|Antarctica/Davis","Asia/Bangkok|Asia/Barnaul","Asia/Bangkok|Asia/Ho_Chi_Minh","Asia/Bangkok|Asia/Hovd","Asia/Bangkok|Asia/Krasnoyarsk","Asia/Bangkok|Asia/Novokuznetsk","Asia/Bangkok|Asia/Novosibirsk","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Saigon","Asia/Bangkok|Asia/Tomsk","Asia/Bangkok|Asia/Vientiane","Asia/Bangkok|Etc/GMT-7","Asia/Bangkok|Indian/Christmas","Asia/Chita|Asia/Dili","Asia/Chita|Asia/Khandyga","Asia/Chita|Asia/Yakutsk","Asia/Chita|Etc/GMT-9","Asia/Chita|Pacific/Palau","Asia/Dhaka|Asia/Almaty","Asia/Dhaka|Asia/Bishkek","Asia/Dhaka|Asia/Dacca","Asia/Dhaka|Asia/Kashgar","Asia/Dhaka|Asia/Omsk","Asia/Dhaka|Asia/Qostanay","Asia/Dhaka|Asia/Thimbu","Asia/Dhaka|Asia/Thimphu","Asia/Dhaka|Asia/Urumqi","Asia/Dhaka|Etc/GMT-6","Asia/Dhaka|Indian/Chagos","Asia/Dubai|Asia/Baku","Asia/Dubai|Asia/Muscat","Asia/Dubai|Asia/Tbilisi","Asia/Dubai|Asia/Yerevan","Asia/Dubai|Etc/GMT-4","Asia/Dubai|Europe/Astrakhan","Asia/Dubai|Europe/Samara","Asia/Dubai|Europe/Saratov","Asia/Dubai|Europe/Ulyanovsk","Asia/Dubai|Indian/Mahe","Asia/Dubai|Indian/Mauritius","Asia/Dubai|Indian/Reunion","Asia/Gaza|Asia/Hebron","Asia/Hong_Kong|Hongkong","Asia/Jakarta|Asia/Pontianak","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kamchatka|Asia/Anadyr","Asia/Kamchatka|Etc/GMT-12","Asia/Kamchatka|Kwajalein","Asia/Kamchatka|Pacific/Funafuti","Asia/Kamchatka|Pacific/Kwajalein","Asia/Kamchatka|Pacific/Majuro","Asia/Kamchatka|Pacific/Nauru","Asia/Kamchatka|Pacific/Tarawa","Asia/Kamchatka|Pacific/Wake","Asia/Kamchatka|Pacific/Wallis","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Brunei","Asia/Kuala_Lumpur|Asia/Choibalsan","Asia/Kuala_Lumpur|Asia/Irkutsk","Asia/Kuala_Lumpur|Asia/Kuching","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Asia/Ulaanbaatar","Asia/Kuala_Lumpur|Asia/Ulan_Bator","Asia/Kuala_Lumpur|Etc/GMT-8","Asia/Kuala_Lumpur|Singapore","Asia/Makassar|Asia/Ujung_Pandang","Asia/Rangoon|Asia/Yangon","Asia/Rangoon|Indian/Cocos","Asia/Sakhalin|Asia/Magadan","Asia/Sakhalin|Asia/Srednekolymsk","Asia/Sakhalin|Etc/GMT-11","Asia/Sakhalin|Pacific/Bougainville","Asia/Sakhalin|Pacific/Efate","Asia/Sakhalin|Pacific/Guadalcanal","Asia/Sakhalin|Pacific/Kosrae","Asia/Sakhalin|Pacific/Noumea","Asia/Sakhalin|Pacific/Pohnpei","Asia/Sakhalin|Pacific/Ponape","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|Asia/Macao","Asia/Shanghai|Asia/Macau","Asia/Shanghai|Asia/Taipei","Asia/Shanghai|PRC","Asia/Shanghai|ROC","Asia/Tashkent|Antarctica/Mawson","Asia/Tashkent|Asia/Aqtau","Asia/Tashkent|Asia/Aqtobe","Asia/Tashkent|Asia/Ashgabat","Asia/Tashkent|Asia/Ashkhabad","Asia/Tashkent|Asia/Atyrau","Asia/Tashkent|Asia/Dushanbe","Asia/Tashkent|Asia/Oral","Asia/Tashkent|Asia/Samarkand","Asia/Tashkent|Asia/Yekaterinburg","Asia/Tashkent|Etc/GMT-5","Asia/Tashkent|Indian/Kerguelen","Asia/Tashkent|Indian/Maldives","Asia/Tehran|Iran","Asia/Tokyo|Japan","Asia/Vladivostok|Antarctica/DumontDUrville","Asia/Vladivostok|Asia/Ust-Nera","Asia/Vladivostok|Etc/GMT-10","Asia/Vladivostok|Pacific/Chuuk","Asia/Vladivostok|Pacific/Port_Moresby","Asia/Vladivostok|Pacific/Truk","Asia/Vladivostok|Pacific/Yap","Atlantic/Cape_Verde|Etc/GMT+1","Australia/Adelaide|Australia/Broken_Hill","Australia/Adelaide|Australia/South","Australia/Adelaide|Australia/Yancowinna","Australia/Brisbane|Australia/Lindeman","Australia/Brisbane|Australia/Queensland","Australia/Darwin|Australia/North","Australia/Lord_Howe|Australia/LHI","Australia/Perth|Australia/West","Australia/Sydney|Antarctica/Macquarie","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/Currie","Australia/Sydney|Australia/Hobart","Australia/Sydney|Australia/Melbourne","Australia/Sydney|Australia/NSW","Australia/Sydney|Australia/Tasmania","Australia/Sydney|Australia/Victoria","Etc/UTC|Etc/UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UCT","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Athens|Asia/Famagusta","Europe/Athens|Asia/Nicosia","Europe/Athens|EET","Europe/Athens|Europe/Bucharest","Europe/Athens|Europe/Helsinki","Europe/Athens|Europe/Kiev","Europe/Athens|Europe/Kyiv","Europe/Athens|Europe/Mariehamn","Europe/Athens|Europe/Nicosia","Europe/Athens|Europe/Riga","Europe/Athens|Europe/Sofia","Europe/Athens|Europe/Tallinn","Europe/Athens|Europe/Uzhgorod","Europe/Athens|Europe/Vilnius","Europe/Athens|Europe/Zaporozhye","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Istanbul|Antarctica/Syowa","Europe/Istanbul|Asia/Aden","Europe/Istanbul|Asia/Baghdad","Europe/Istanbul|Asia/Bahrain","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Asia/Kuwait","Europe/Istanbul|Asia/Qatar","Europe/Istanbul|Asia/Riyadh","Europe/Istanbul|Etc/GMT-3","Europe/Istanbul|Europe/Minsk","Europe/Istanbul|Turkey","Europe/Lisbon|Atlantic/Canary","Europe/Lisbon|Atlantic/Faeroe","Europe/Lisbon|Atlantic/Faroe","Europe/Lisbon|Atlantic/Madeira","Europe/Lisbon|Portugal","Europe/Lisbon|WET","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|Europe/Kirov","Europe/Moscow|Europe/Simferopol","Europe/Moscow|W-SU","Europe/Paris|Africa/Ceuta","Europe/Paris|Arctic/Longyearbyen","Europe/Paris|Atlantic/Jan_Mayen","Europe/Paris|CET","Europe/Paris|Europe/Amsterdam","Europe/Paris|Europe/Andorra","Europe/Paris|Europe/Belgrade","Europe/Paris|Europe/Berlin","Europe/Paris|Europe/Bratislava","Europe/Paris|Europe/Brussels","Europe/Paris|Europe/Budapest","Europe/Paris|Europe/Busingen","Europe/Paris|Europe/Copenhagen","Europe/Paris|Europe/Gibraltar","Europe/Paris|Europe/Ljubljana","Europe/Paris|Europe/Luxembourg","Europe/Paris|Europe/Madrid","Europe/Paris|Europe/Malta","Europe/Paris|Europe/Monaco","Europe/Paris|Europe/Oslo","Europe/Paris|Europe/Podgorica","Europe/Paris|Europe/Prague","Europe/Paris|Europe/Rome","Europe/Paris|Europe/San_Marino","Europe/Paris|Europe/Sarajevo","Europe/Paris|Europe/Skopje","Europe/Paris|Europe/Stockholm","Europe/Paris|Europe/Tirane","Europe/Paris|Europe/Vaduz","Europe/Paris|Europe/Vatican","Europe/Paris|Europe/Vienna","Europe/Paris|Europe/Warsaw","Europe/Paris|Europe/Zagreb","Europe/Paris|Europe/Zurich","Europe/Paris|Poland","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Easter|Chile/EasterIsland","Pacific/Galapagos|Etc/GMT+6","Pacific/Gambier|Etc/GMT+9","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|HST","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kiritimati|Etc/GMT-14","Pacific/Niue|Etc/GMT+11","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Pitcairn|Etc/GMT+8","Pacific/Tahiti|Etc/GMT+10","Pacific/Tahiti|Pacific/Rarotonga","Pacific/Tongatapu|Etc/GMT-13","Pacific/Tongatapu|Pacific/Enderbury","Pacific/Tongatapu|Pacific/Fakaofo","Pacific/Tongatapu|Pacific/Kanton"],countries:["AD|Europe/Andorra","AE|Asia/Dubai","AF|Asia/Kabul","AG|America/Puerto_Rico America/Antigua","AI|America/Puerto_Rico America/Anguilla","AL|Europe/Tirane","AM|Asia/Yerevan","AO|Africa/Lagos Africa/Luanda","AQ|Antarctica/Casey Antarctica/Davis Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Troll Antarctica/Vostok Pacific/Auckland Pacific/Port_Moresby Asia/Riyadh Antarctica/McMurdo Antarctica/DumontDUrville Antarctica/Syowa","AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia","AS|Pacific/Pago_Pago","AT|Europe/Vienna","AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla","AW|America/Puerto_Rico America/Aruba","AX|Europe/Helsinki Europe/Mariehamn","AZ|Asia/Baku","BA|Europe/Belgrade Europe/Sarajevo","BB|America/Barbados","BD|Asia/Dhaka","BE|Europe/Brussels","BF|Africa/Abidjan Africa/Ouagadougou","BG|Europe/Sofia","BH|Asia/Qatar Asia/Bahrain","BI|Africa/Maputo Africa/Bujumbura","BJ|Africa/Lagos Africa/Porto-Novo","BL|America/Puerto_Rico America/St_Barthelemy","BM|Atlantic/Bermuda","BN|Asia/Kuching Asia/Brunei","BO|America/La_Paz","BQ|America/Puerto_Rico America/Kralendijk","BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco","BS|America/Toronto America/Nassau","BT|Asia/Thimphu","BW|Africa/Maputo Africa/Gaborone","BY|Europe/Minsk","BZ|America/Belize","CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Toronto America/Iqaluit America/Winnipeg America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Inuvik America/Dawson_Creek America/Fort_Nelson America/Whitehorse America/Dawson America/Vancouver America/Panama America/Puerto_Rico America/Phoenix America/Blanc-Sablon America/Atikokan America/Creston","CC|Asia/Yangon Indian/Cocos","CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi","CF|Africa/Lagos Africa/Bangui","CG|Africa/Lagos Africa/Brazzaville","CH|Europe/Zurich","CI|Africa/Abidjan","CK|Pacific/Rarotonga","CL|America/Santiago America/Punta_Arenas Pacific/Easter","CM|Africa/Lagos Africa/Douala","CN|Asia/Shanghai Asia/Urumqi","CO|America/Bogota","CR|America/Costa_Rica","CU|America/Havana","CV|Atlantic/Cape_Verde","CW|America/Puerto_Rico America/Curacao","CX|Asia/Bangkok Indian/Christmas","CY|Asia/Nicosia Asia/Famagusta","CZ|Europe/Prague","DE|Europe/Zurich Europe/Berlin Europe/Busingen","DJ|Africa/Nairobi Africa/Djibouti","DK|Europe/Berlin Europe/Copenhagen","DM|America/Puerto_Rico America/Dominica","DO|America/Santo_Domingo","DZ|Africa/Algiers","EC|America/Guayaquil Pacific/Galapagos","EE|Europe/Tallinn","EG|Africa/Cairo","EH|Africa/El_Aaiun","ER|Africa/Nairobi Africa/Asmara","ES|Europe/Madrid Africa/Ceuta Atlantic/Canary","ET|Africa/Nairobi Africa/Addis_Ababa","FI|Europe/Helsinki","FJ|Pacific/Fiji","FK|Atlantic/Stanley","FM|Pacific/Kosrae Pacific/Port_Moresby Pacific/Guadalcanal Pacific/Chuuk Pacific/Pohnpei","FO|Atlantic/Faroe","FR|Europe/Paris","GA|Africa/Lagos Africa/Libreville","GB|Europe/London","GD|America/Puerto_Rico America/Grenada","GE|Asia/Tbilisi","GF|America/Cayenne","GG|Europe/London Europe/Guernsey","GH|Africa/Abidjan Africa/Accra","GI|Europe/Gibraltar","GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule","GM|Africa/Abidjan Africa/Banjul","GN|Africa/Abidjan Africa/Conakry","GP|America/Puerto_Rico America/Guadeloupe","GQ|Africa/Lagos Africa/Malabo","GR|Europe/Athens","GS|Atlantic/South_Georgia","GT|America/Guatemala","GU|Pacific/Guam","GW|Africa/Bissau","GY|America/Guyana","HK|Asia/Hong_Kong","HN|America/Tegucigalpa","HR|Europe/Belgrade Europe/Zagreb","HT|America/Port-au-Prince","HU|Europe/Budapest","ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura","IE|Europe/Dublin","IL|Asia/Jerusalem","IM|Europe/London Europe/Isle_of_Man","IN|Asia/Kolkata","IO|Indian/Chagos","IQ|Asia/Baghdad","IR|Asia/Tehran","IS|Africa/Abidjan Atlantic/Reykjavik","IT|Europe/Rome","JE|Europe/London Europe/Jersey","JM|America/Jamaica","JO|Asia/Amman","JP|Asia/Tokyo","KE|Africa/Nairobi","KG|Asia/Bishkek","KH|Asia/Bangkok Asia/Phnom_Penh","KI|Pacific/Tarawa Pacific/Kanton Pacific/Kiritimati","KM|Africa/Nairobi Indian/Comoro","KN|America/Puerto_Rico America/St_Kitts","KP|Asia/Pyongyang","KR|Asia/Seoul","KW|Asia/Riyadh Asia/Kuwait","KY|America/Panama America/Cayman","KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral","LA|Asia/Bangkok Asia/Vientiane","LB|Asia/Beirut","LC|America/Puerto_Rico America/St_Lucia","LI|Europe/Zurich Europe/Vaduz","LK|Asia/Colombo","LR|Africa/Monrovia","LS|Africa/Johannesburg Africa/Maseru","LT|Europe/Vilnius","LU|Europe/Brussels Europe/Luxembourg","LV|Europe/Riga","LY|Africa/Tripoli","MA|Africa/Casablanca","MC|Europe/Paris Europe/Monaco","MD|Europe/Chisinau","ME|Europe/Belgrade Europe/Podgorica","MF|America/Puerto_Rico America/Marigot","MG|Africa/Nairobi Indian/Antananarivo","MH|Pacific/Tarawa Pacific/Kwajalein Pacific/Majuro","MK|Europe/Belgrade Europe/Skopje","ML|Africa/Abidjan Africa/Bamako","MM|Asia/Yangon","MN|Asia/Ulaanbaatar Asia/Hovd Asia/Choibalsan","MO|Asia/Macau","MP|Pacific/Guam Pacific/Saipan","MQ|America/Martinique","MR|Africa/Abidjan Africa/Nouakchott","MS|America/Puerto_Rico America/Montserrat","MT|Europe/Malta","MU|Indian/Mauritius","MV|Indian/Maldives","MW|Africa/Maputo Africa/Blantyre","MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Chihuahua America/Ciudad_Juarez America/Ojinaga America/Mazatlan America/Bahia_Banderas America/Hermosillo America/Tijuana","MY|Asia/Kuching Asia/Singapore Asia/Kuala_Lumpur","MZ|Africa/Maputo","NA|Africa/Windhoek","NC|Pacific/Noumea","NE|Africa/Lagos Africa/Niamey","NF|Pacific/Norfolk","NG|Africa/Lagos","NI|America/Managua","NL|Europe/Brussels Europe/Amsterdam","NO|Europe/Berlin Europe/Oslo","NP|Asia/Kathmandu","NR|Pacific/Nauru","NU|Pacific/Niue","NZ|Pacific/Auckland Pacific/Chatham","OM|Asia/Dubai Asia/Muscat","PA|America/Panama","PE|America/Lima","PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier","PG|Pacific/Port_Moresby Pacific/Bougainville","PH|Asia/Manila","PK|Asia/Karachi","PL|Europe/Warsaw","PM|America/Miquelon","PN|Pacific/Pitcairn","PR|America/Puerto_Rico","PS|Asia/Gaza Asia/Hebron","PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores","PW|Pacific/Palau","PY|America/Asuncion","QA|Asia/Qatar","RE|Asia/Dubai Indian/Reunion","RO|Europe/Bucharest","RS|Europe/Belgrade","RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Volgograd Europe/Astrakhan Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr","RW|Africa/Maputo Africa/Kigali","SA|Asia/Riyadh","SB|Pacific/Guadalcanal","SC|Asia/Dubai Indian/Mahe","SD|Africa/Khartoum","SE|Europe/Berlin Europe/Stockholm","SG|Asia/Singapore","SH|Africa/Abidjan Atlantic/St_Helena","SI|Europe/Belgrade Europe/Ljubljana","SJ|Europe/Berlin Arctic/Longyearbyen","SK|Europe/Prague Europe/Bratislava","SL|Africa/Abidjan Africa/Freetown","SM|Europe/Rome Europe/San_Marino","SN|Africa/Abidjan Africa/Dakar","SO|Africa/Nairobi Africa/Mogadishu","SR|America/Paramaribo","SS|Africa/Juba","ST|Africa/Sao_Tome","SV|America/El_Salvador","SX|America/Puerto_Rico America/Lower_Princes","SY|Asia/Damascus","SZ|Africa/Johannesburg Africa/Mbabane","TC|America/Grand_Turk","TD|Africa/Ndjamena","TF|Asia/Dubai Indian/Maldives Indian/Kerguelen","TG|Africa/Abidjan Africa/Lome","TH|Asia/Bangkok","TJ|Asia/Dushanbe","TK|Pacific/Fakaofo","TL|Asia/Dili","TM|Asia/Ashgabat","TN|Africa/Tunis","TO|Pacific/Tongatapu","TR|Europe/Istanbul","TT|America/Puerto_Rico America/Port_of_Spain","TV|Pacific/Tarawa Pacific/Funafuti","TW|Asia/Taipei","TZ|Africa/Nairobi Africa/Dar_es_Salaam","UA|Europe/Simferopol Europe/Kyiv","UG|Africa/Nairobi Africa/Kampala","UM|Pacific/Pago_Pago Pacific/Tarawa Pacific/Midway Pacific/Wake","US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu","UY|America/Montevideo","UZ|Asia/Samarkand Asia/Tashkent","VA|Europe/Rome Europe/Vatican","VC|America/Puerto_Rico America/St_Vincent","VE|America/Caracas","VG|America/Puerto_Rico America/Tortola","VI|America/Puerto_Rico America/St_Thomas","VN|Asia/Bangkok Asia/Ho_Chi_Minh","VU|Pacific/Efate","WF|Pacific/Tarawa Pacific/Wallis","WS|Pacific/Apia","YE|Asia/Riyadh Asia/Aden","YT|Africa/Nairobi Indian/Mayotte","ZA|Africa/Johannesburg","ZM|Africa/Maputo Africa/Lusaka","ZW|Africa/Maputo Africa/Harare"]}),o});
!function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.AOS=t():e.AOS=t()}(this,function(){return function(e){function t(o){if(n[o])return n[o].exports;var i=n[o]={exports:{},id:o,loaded:!1};return e[o].call(i.exports,i,i.exports,t),i.loaded=!0,i.exports}var n={};return t.m=e,t.c=n,t.p="dist/",t(0)}([function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}var i=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o])}return e},r=n(1),a=(o(r),n(6)),u=o(a),c=n(7),s=o(c),f=n(8),d=o(f),l=n(9),p=o(l),m=n(10),b=o(m),v=n(11),y=o(v),g=n(14),h=o(g),w=[],k=!1,x={offset:120,delay:0,easing:"ease",duration:400,disable:!1,once:!1,startEvent:"DOMContentLoaded",throttleDelay:99,debounceDelay:50,disableMutationObserver:!1},j=function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(e&&(k=!0),k)return w=(0,y.default)(w,x),(0,b.default)(w,x.once),w},O=function(){w=(0,h.default)(),j()},M=function(){w.forEach(function(e,t){e.node.removeAttribute("data-aos"),e.node.removeAttribute("data-aos-easing"),e.node.removeAttribute("data-aos-duration"),e.node.removeAttribute("data-aos-delay")})},S=function(e){return e===!0||"mobile"===e&&p.default.mobile()||"phone"===e&&p.default.phone()||"tablet"===e&&p.default.tablet()||"function"==typeof e&&e()===!0},_=function(e){x=i(x,e),w=(0,h.default)();var t=document.all&&!window.atob;return S(x.disable)||t?M():(x.disableMutationObserver||d.default.isSupported()||(console.info('\n      aos: MutationObserver is not supported on this browser,\n      code mutations observing has been disabled.\n      You may have to call "refreshHard()" by yourself.\n    '),x.disableMutationObserver=!0),document.querySelector("body").setAttribute("data-aos-easing",x.easing),document.querySelector("body").setAttribute("data-aos-duration",x.duration),document.querySelector("body").setAttribute("data-aos-delay",x.delay),"DOMContentLoaded"===x.startEvent&&["complete","interactive"].indexOf(document.readyState)>-1?j(!0):"load"===x.startEvent?window.addEventListener(x.startEvent,function(){j(!0)}):document.addEventListener(x.startEvent,function(){j(!0)}),window.addEventListener("resize",(0,s.default)(j,x.debounceDelay,!0)),window.addEventListener("orientationchange",(0,s.default)(j,x.debounceDelay,!0)),window.addEventListener("scroll",(0,u.default)(function(){(0,b.default)(w,x.once)},x.throttleDelay)),x.disableMutationObserver||d.default.ready("[data-aos]",O),w)};e.exports={init:_,refresh:j,refreshHard:O}},function(e,t){},,,,,function(e,t){(function(t){"use strict";function n(e,t,n){function o(t){var n=b,o=v;return b=v=void 0,k=t,g=e.apply(o,n)}function r(e){return k=e,h=setTimeout(f,t),M?o(e):g}function a(e){var n=e-w,o=e-k,i=t-n;return S?j(i,y-o):i}function c(e){var n=e-w,o=e-k;return void 0===w||n>=t||n<0||S&&o>=y}function f(){var e=O();return c(e)?d(e):void(h=setTimeout(f,a(e)))}function d(e){return h=void 0,_&&b?o(e):(b=v=void 0,g)}function l(){void 0!==h&&clearTimeout(h),k=0,b=w=v=h=void 0}function p(){return void 0===h?g:d(O())}function m(){var e=O(),n=c(e);if(b=arguments,v=this,w=e,n){if(void 0===h)return r(w);if(S)return h=setTimeout(f,t),o(w)}return void 0===h&&(h=setTimeout(f,t)),g}var b,v,y,g,h,w,k=0,M=!1,S=!1,_=!0;if("function"!=typeof e)throw new TypeError(s);return t=u(t)||0,i(n)&&(M=!!n.leading,S="maxWait"in n,y=S?x(u(n.maxWait)||0,t):y,_="trailing"in n?!!n.trailing:_),m.cancel=l,m.flush=p,m}function o(e,t,o){var r=!0,a=!0;if("function"!=typeof e)throw new TypeError(s);return i(o)&&(r="leading"in o?!!o.leading:r,a="trailing"in o?!!o.trailing:a),n(e,t,{leading:r,maxWait:t,trailing:a})}function i(e){var t="undefined"==typeof e?"undefined":c(e);return!!e&&("object"==t||"function"==t)}function r(e){return!!e&&"object"==("undefined"==typeof e?"undefined":c(e))}function a(e){return"symbol"==("undefined"==typeof e?"undefined":c(e))||r(e)&&k.call(e)==d}function u(e){if("number"==typeof e)return e;if(a(e))return f;if(i(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=i(t)?t+"":t}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(l,"");var n=m.test(e);return n||b.test(e)?v(e.slice(2),n?2:8):p.test(e)?f:+e}var c="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},s="Expected a function",f=NaN,d="[object Symbol]",l=/^\s+|\s+$/g,p=/^[-+]0x[0-9a-f]+$/i,m=/^0b[01]+$/i,b=/^0o[0-7]+$/i,v=parseInt,y="object"==("undefined"==typeof t?"undefined":c(t))&&t&&t.Object===Object&&t,g="object"==("undefined"==typeof self?"undefined":c(self))&&self&&self.Object===Object&&self,h=y||g||Function("return this")(),w=Object.prototype,k=w.toString,x=Math.max,j=Math.min,O=function(){return h.Date.now()};e.exports=o}).call(t,function(){return this}())},function(e,t){(function(t){"use strict";function n(e,t,n){function i(t){var n=b,o=v;return b=v=void 0,O=t,g=e.apply(o,n)}function r(e){return O=e,h=setTimeout(f,t),M?i(e):g}function u(e){var n=e-w,o=e-O,i=t-n;return S?x(i,y-o):i}function s(e){var n=e-w,o=e-O;return void 0===w||n>=t||n<0||S&&o>=y}function f(){var e=j();return s(e)?d(e):void(h=setTimeout(f,u(e)))}function d(e){return h=void 0,_&&b?i(e):(b=v=void 0,g)}function l(){void 0!==h&&clearTimeout(h),O=0,b=w=v=h=void 0}function p(){return void 0===h?g:d(j())}function m(){var e=j(),n=s(e);if(b=arguments,v=this,w=e,n){if(void 0===h)return r(w);if(S)return h=setTimeout(f,t),i(w)}return void 0===h&&(h=setTimeout(f,t)),g}var b,v,y,g,h,w,O=0,M=!1,S=!1,_=!0;if("function"!=typeof e)throw new TypeError(c);return t=a(t)||0,o(n)&&(M=!!n.leading,S="maxWait"in n,y=S?k(a(n.maxWait)||0,t):y,_="trailing"in n?!!n.trailing:_),m.cancel=l,m.flush=p,m}function o(e){var t="undefined"==typeof e?"undefined":u(e);return!!e&&("object"==t||"function"==t)}function i(e){return!!e&&"object"==("undefined"==typeof e?"undefined":u(e))}function r(e){return"symbol"==("undefined"==typeof e?"undefined":u(e))||i(e)&&w.call(e)==f}function a(e){if("number"==typeof e)return e;if(r(e))return s;if(o(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=o(t)?t+"":t}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(d,"");var n=p.test(e);return n||m.test(e)?b(e.slice(2),n?2:8):l.test(e)?s:+e}var u="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},c="Expected a function",s=NaN,f="[object Symbol]",d=/^\s+|\s+$/g,l=/^[-+]0x[0-9a-f]+$/i,p=/^0b[01]+$/i,m=/^0o[0-7]+$/i,b=parseInt,v="object"==("undefined"==typeof t?"undefined":u(t))&&t&&t.Object===Object&&t,y="object"==("undefined"==typeof self?"undefined":u(self))&&self&&self.Object===Object&&self,g=v||y||Function("return this")(),h=Object.prototype,w=h.toString,k=Math.max,x=Math.min,j=function(){return g.Date.now()};e.exports=n}).call(t,function(){return this}())},function(e,t){"use strict";function n(e){var t=void 0,o=void 0,i=void 0;for(t=0;t<e.length;t+=1){if(o=e[t],o.dataset&&o.dataset.aos)return!0;if(i=o.children&&n(o.children))return!0}return!1}function o(){return window.MutationObserver||window.WebKitMutationObserver||window.MozMutationObserver}function i(){return!!o()}function r(e,t){var n=window.document,i=o(),r=new i(a);u=t,r.observe(n.documentElement,{childList:!0,subtree:!0,removedNodes:!0})}function a(e){e&&e.forEach(function(e){var t=Array.prototype.slice.call(e.addedNodes),o=Array.prototype.slice.call(e.removedNodes),i=t.concat(o);if(n(i))return u()})}Object.defineProperty(t,"__esModule",{value:!0});var u=function(){};t.default={isSupported:i,ready:r}},function(e,t){"use strict";function n(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(){return navigator.userAgent||navigator.vendor||window.opera||""}Object.defineProperty(t,"__esModule",{value:!0});var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}return function(t,n,o){return n&&e(t.prototype,n),o&&e(t,o),t}}(),r=/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,a=/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,u=/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i,c=/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,s=function(){function e(){n(this,e)}return i(e,[{key:"phone",value:function(){var e=o();return!(!r.test(e)&&!a.test(e.substr(0,4)))}},{key:"mobile",value:function(){var e=o();return!(!u.test(e)&&!c.test(e.substr(0,4)))}},{key:"tablet",value:function(){return this.mobile()&&!this.phone()}}]),e}();t.default=new s},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n=function(e,t,n){var o=e.node.getAttribute("data-aos-once");t>e.position?e.node.classList.add("aos-animate"):"undefined"!=typeof o&&("false"===o||!n&&"true"!==o)&&e.node.classList.remove("aos-animate")},o=function(e,t){var o=window.pageYOffset,i=window.innerHeight;e.forEach(function(e,r){n(e,i+o,t)})};t.default=o},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(12),r=o(i),a=function(e,t){return e.forEach(function(e,n){e.node.classList.add("aos-init"),e.position=(0,r.default)(e.node,t.offset)}),e};t.default=a},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(13),r=o(i),a=function(e,t){var n=0,o=0,i=window.innerHeight,a={offset:e.getAttribute("data-aos-offset"),anchor:e.getAttribute("data-aos-anchor"),anchorPlacement:e.getAttribute("data-aos-anchor-placement")};switch(a.offset&&!isNaN(a.offset)&&(o=parseInt(a.offset)),a.anchor&&document.querySelectorAll(a.anchor)&&(e=document.querySelectorAll(a.anchor)[0]),n=(0,r.default)(e).top,a.anchorPlacement){case"top-bottom":break;case"center-bottom":n+=e.offsetHeight/2;break;case"bottom-bottom":n+=e.offsetHeight;break;case"top-center":n+=i/2;break;case"bottom-center":n+=i/2+e.offsetHeight;break;case"center-center":n+=i/2+e.offsetHeight/2;break;case"top-top":n+=i;break;case"bottom-top":n+=e.offsetHeight+i;break;case"center-top":n+=e.offsetHeight/2+i}return a.anchorPlacement||a.offset||isNaN(t)||(o=t),n+o};t.default=a},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n=function(e){for(var t=0,n=0;e&&!isNaN(e.offsetLeft)&&!isNaN(e.offsetTop);)t+=e.offsetLeft-("BODY"!=e.tagName?e.scrollLeft:0),n+=e.offsetTop-("BODY"!=e.tagName?e.scrollTop:0),e=e.offsetParent;return{top:n,left:t}};t.default=n},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n=function(e){return e=e||document.querySelectorAll("[data-aos]"),Array.prototype.map.call(e,function(e){return{node:e}})};t.default=n}])});
/*!
 * Route 1.0.2 - Router for JavaScript applications
 * Copyright 2021 - Cristian Pineda <cristian.pineda.1997@outlook.com>
 * Licensed under MIT
 */

"use strict";

class Router {
    constructor() {
        this.params = this.getParams();
        this.hash = this.Hash();
    }

    params = {};
    home = location.origin;
    actualPage = location.href;
    path = location.pathname;
    hash = {};

    Reload() {
        location.reload(true);
    }

    GoTo(path) {
        location.replace(path);
    }

    GoToWith(path, data) {
        if (this.actualPage != `${this.home}/${path}`) {
            localStorage.setItem(
                "RouteGoToWith",
                JSON.stringify({ data, path })
            );
            this.GoTo(path);
        }
    }

    GetData() {
        let res = "";
        res = JSON.parse(localStorage.getItem("RouteGoToWith"));
        if (this.actualPage == `${this.home}/${res.path}`) {
            localStorage.removeItem("RouteGoToWith");
        }
        return res.data;
    }

    Hash() {
        let a = location.hash,
            size = 0;
        a = a.substr(1, a.length).replace(/[?&=]/g, ":").split(":");
        const b = {};
        for (let i = 0; i < a.length - 1; i++) {
            b[a[i]] = a[i + 1];
            i++;
            size++;
        }
        return { ...b, size };
    }

    getParams() {
        let a = location.search,
            size = 0;
        a = a.substr(1, a.length).replace(/[?&=]/g, ":").split(":");
        const b = {};
        for (let i = 0; i < a.length - 1; i++) {
            b[a[i]] = a[i + 1];
            i++;
            size++;
        }
        return { ...b, size };
    }
}

/*
 * International Telephone Input v21.2.7
 * https://github.com/jackocnr/intl-tel-input.git
 * Licensed under the MIT license
 */

// UMD
(function (factory) {
    if (typeof module === "object" && module.exports) {
        module.exports = factory();
    } else {
        window.intlTelInput = factory();
    }
})(() => {
    var factoryOutput = (() => {
        var v = Object.defineProperty;
        var k = Object.getOwnPropertyDescriptor;
        var A = Object.getOwnPropertyNames;
        var N = Object.prototype.hasOwnProperty;
        var M = (o, t) => {
                for (var e in t) v(o, e, { get: t[e], enumerable: !0 });
            },
            x = (o, t, e, i) => {
                if ((t && typeof t == "object") || typeof t == "function")
                    for (let n of A(t))
                        !N.call(o, n) &&
                            n !== e &&
                            v(o, n, {
                                get: () => t[n],
                                enumerable: !(i = k(t, n)) || i.enumerable,
                            });
                return o;
            };
        var P = (o) => x(v({}, "__esModule", { value: !0 }), o);
        var G = {};
        M(G, { Iti: () => b, default: () => $ });
        var w = [
                ["af", "93"],
                ["al", "355"],
                ["dz", "213"],
                ["as", "1", 5, ["684"]],
                ["ad", "376"],
                ["ao", "244"],
                ["ai", "1", 6, ["264"]],
                ["ag", "1", 7, ["268"]],
                ["ar", "54"],
                ["am", "374"],
                ["aw", "297"],
                ["ac", "247"],
                ["au", "61", 0],
                ["at", "43"],
                ["az", "994"],
                ["bs", "1", 8, ["242"]],
                ["bh", "973"],
                ["bd", "880"],
                ["bb", "1", 9, ["246"]],
                ["by", "375"],
                ["be", "32"],
                ["bz", "501"],
                ["bj", "229"],
                ["bm", "1", 10, ["441"]],
                ["bt", "975"],
                ["bo", "591"],
                ["ba", "387"],
                ["bw", "267"],
                ["br", "55"],
                ["io", "246"],
                ["vg", "1", 11, ["284"]],
                ["bn", "673"],
                ["bg", "359"],
                ["bf", "226"],
                ["bi", "257"],
                ["kh", "855"],
                ["cm", "237"],
                [
                    "ca",
                    "1",
                    1,
                    [
                        "204",
                        "226",
                        "236",
                        "249",
                        "250",
                        "263",
                        "289",
                        "306",
                        "343",
                        "354",
                        "365",
                        "367",
                        "368",
                        "382",
                        "387",
                        "403",
                        "416",
                        "418",
                        "428",
                        "431",
                        "437",
                        "438",
                        "450",
                        "584",
                        "468",
                        "474",
                        "506",
                        "514",
                        "519",
                        "548",
                        "579",
                        "581",
                        "584",
                        "587",
                        "604",
                        "613",
                        "639",
                        "647",
                        "672",
                        "683",
                        "705",
                        "709",
                        "742",
                        "753",
                        "778",
                        "780",
                        "782",
                        "807",
                        "819",
                        "825",
                        "867",
                        "873",
                        "879",
                        "902",
                        "905",
                    ],
                ],
                ["cv", "238"],
                ["bq", "599", 1, ["3", "4", "7"]],
                ["ky", "1", 12, ["345"]],
                ["cf", "236"],
                ["td", "235"],
                ["cl", "56"],
                ["cn", "86"],
                ["cx", "61", 2, ["89164"]],
                ["cc", "61", 1, ["89162"]],
                ["co", "57"],
                ["km", "269"],
                ["cg", "242"],
                ["cd", "243"],
                ["ck", "682"],
                ["cr", "506"],
                ["ci", "225"],
                ["hr", "385"],
                ["cu", "53"],
                ["cw", "599", 0],
                ["cy", "357"],
                ["cz", "420"],
                ["dk", "45"],
                ["dj", "253"],
                ["dm", "1", 13, ["767"]],
                ["do", "1", 2, ["809", "829", "849"]],
                ["ec", "593"],
                ["eg", "20"],
                ["sv", "503"],
                ["gq", "240"],
                ["er", "291"],
                ["ee", "372"],
                ["sz", "268"],
                ["et", "251"],
                ["fk", "500"],
                ["fo", "298"],
                ["fj", "679"],
                ["fi", "358", 0],
                ["fr", "33"],
                ["gf", "594"],
                ["pf", "689"],
                ["ga", "241"],
                ["gm", "220"],
                ["ge", "995"],
                ["de", "49"],
                ["gh", "233"],
                ["gi", "350"],
                ["gr", "30"],
                ["gl", "299"],
                ["gd", "1", 14, ["473"]],
                ["gp", "590", 0],
                ["gu", "1", 15, ["671"]],
                ["gt", "502"],
                ["gg", "44", 1, ["1481", "7781", "7839", "7911"]],
                ["gn", "224"],
                ["gw", "245"],
                ["gy", "592"],
                ["ht", "509"],
                ["hn", "504"],
                ["hk", "852"],
                ["hu", "36"],
                ["is", "354"],
                ["in", "91"],
                ["id", "62"],
                ["ir", "98"],
                ["iq", "964"],
                ["ie", "353"],
                ["im", "44", 2, ["1624", "74576", "7524", "7924", "7624"]],
                ["il", "972"],
                ["it", "39", 0],
                ["jm", "1", 4, ["876", "658"]],
                ["jp", "81"],
                [
                    "je",
                    "44",
                    3,
                    ["1534", "7509", "7700", "7797", "7829", "7937"],
                ],
                ["jo", "962"],
                ["kz", "7", 1, ["33", "7"]],
                ["ke", "254"],
                ["ki", "686"],
                ["xk", "383"],
                ["kw", "965"],
                ["kg", "996"],
                ["la", "856"],
                ["lv", "371"],
                ["lb", "961"],
                ["ls", "266"],
                ["lr", "231"],
                ["ly", "218"],
                ["li", "423"],
                ["lt", "370"],
                ["lu", "352"],
                ["mo", "853"],
                ["mg", "261"],
                ["mw", "265"],
                ["my", "60"],
                ["mv", "960"],
                ["ml", "223"],
                ["mt", "356"],
                ["mh", "692"],
                ["mq", "596"],
                ["mr", "222"],
                ["mu", "230"],
                ["yt", "262", 1, ["269", "639"]],
                ["mx", "52"],
                ["fm", "691"],
                ["md", "373"],
                ["mc", "377"],
                ["mn", "976"],
                ["me", "382"],
                ["ms", "1", 16, ["664"]],
                ["ma", "212", 0],
                ["mz", "258"],
                ["mm", "95"],
                ["na", "264"],
                ["nr", "674"],
                ["np", "977"],
                ["nl", "31"],
                ["nc", "687"],
                ["nz", "64"],
                ["ni", "505"],
                ["ne", "227"],
                ["ng", "234"],
                ["nu", "683"],
                ["nf", "672"],
                ["kp", "850"],
                ["mk", "389"],
                ["mp", "1", 17, ["670"]],
                ["no", "47", 0],
                ["om", "968"],
                ["pk", "92"],
                ["pw", "680"],
                ["ps", "970"],
                ["pa", "507"],
                ["pg", "675"],
                ["py", "595"],
                ["pe", "51"],
                ["ph", "63"],
                ["pl", "48"],
                ["pt", "351"],
                ["pr", "1", 3, ["787", "939"]],
                ["qa", "974"],
                ["re", "262", 0],
                ["ro", "40"],
                ["ru", "7", 0],
                ["rw", "250"],
                ["ws", "685"],
                ["sm", "378"],
                ["st", "239"],
                ["sa", "966"],
                ["sn", "221"],
                ["rs", "381"],
                ["sc", "248"],
                ["sl", "232"],
                ["sg", "65"],
                ["sx", "1", 21, ["721"]],
                ["sk", "421"],
                ["si", "386"],
                ["sb", "677"],
                ["so", "252"],
                ["za", "27"],
                ["kr", "82"],
                ["ss", "211"],
                ["es", "34"],
                ["lk", "94"],
                ["bl", "590", 1],
                ["sh", "290"],
                ["kn", "1", 18, ["869"]],
                ["lc", "1", 19, ["758"]],
                ["mf", "590", 2],
                ["pm", "508"],
                ["vc", "1", 20, ["784"]],
                ["sd", "249"],
                ["sr", "597"],
                ["sj", "47", 1, ["79"]],
                ["se", "46"],
                ["ch", "41"],
                ["sy", "963"],
                ["tw", "886"],
                ["tj", "992"],
                ["tz", "255"],
                ["th", "66"],
                ["tl", "670"],
                ["tg", "228"],
                ["tk", "690"],
                ["to", "676"],
                ["tt", "1", 22, ["868"]],
                ["tn", "216"],
                ["tr", "90"],
                ["tm", "993"],
                ["tc", "1", 23, ["649"]],
                ["tv", "688"],
                ["ug", "256"],
                ["ua", "380"],
                ["ae", "971"],
                ["gb", "44", 0],
                ["us", "1", 0],
                ["uy", "598"],
                ["vi", "1", 24, ["340"]],
                ["uz", "998"],
                ["vu", "678"],
                ["va", "39", 1, ["06698"]],
                ["ve", "58"],
                ["vn", "84"],
                ["wf", "681"],
                ["eh", "212", 1, ["5288", "5289"]],
                ["ye", "967"],
                ["zm", "260"],
                ["zw", "263"],
                ["ax", "358", 1, ["18"]],
            ],
            I = [];
        for (let o = 0; o < w.length; o++) {
            let t = w[o];
            I[o] = {
                name: "",
                iso2: t[0],
                dialCode: t[1],
                priority: t[2] || 0,
                areaCodes: t[3] || null,
                nodeById: {},
            };
        }
        var C = I;
        var _ = {
            af: "Afghanistan",
            ax: "\xC5land Islands",
            al: "Albania",
            dz: "Algeria",
            as: "American Samoa",
            ad: "Andorra",
            ao: "Angola",
            ai: "Anguilla",
            aq: "Antarctica",
            ag: "Antigua & Barbuda",
            ar: "Argentina",
            am: "Armenia",
            aw: "Aruba",
            au: "Australia",
            at: "Austria",
            az: "Azerbaijan",
            bs: "Bahamas",
            bh: "Bahrain",
            bd: "Bangladesh",
            bb: "Barbados",
            by: "Belarus",
            be: "Belgium",
            bz: "Belize",
            bj: "Benin",
            bm: "Bermuda",
            bt: "Bhutan",
            bo: "Bolivia",
            ba: "Bosnia & Herzegovina",
            bw: "Botswana",
            bv: "Bouvet Island",
            br: "Brazil",
            io: "British Indian Ocean Territory",
            vg: "British Virgin Islands",
            bn: "Brunei",
            bg: "Bulgaria",
            bf: "Burkina Faso",
            bi: "Burundi",
            kh: "Cambodia",
            cm: "Cameroon",
            ca: "Canada",
            cv: "Cape Verde",
            bq: "Caribbean Netherlands",
            ky: "Cayman Islands",
            cf: "Central African Republic",
            td: "Chad",
            cl: "Chile",
            cn: "China",
            cx: "Christmas Island",
            cc: "Cocos (Keeling) Islands",
            co: "Colombia",
            km: "Comoros",
            cg: "Congo - Brazzaville",
            cd: "Congo - Kinshasa",
            ck: "Cook Islands",
            cr: "Costa Rica",
            ci: "C\xF4te d\u2019Ivoire",
            hr: "Croatia",
            cu: "Cuba",
            cw: "Cura\xE7ao",
            cy: "Cyprus",
            cz: "Czechia",
            dk: "Denmark",
            dj: "Djibouti",
            dm: "Dominica",
            do: "Dominican Republic",
            ec: "Ecuador",
            eg: "Egypt",
            sv: "El Salvador",
            gq: "Equatorial Guinea",
            er: "Eritrea",
            ee: "Estonia",
            sz: "Eswatini",
            et: "Ethiopia",
            fk: "Falkland Islands",
            fo: "Faroe Islands",
            fj: "Fiji",
            fi: "Finland",
            fr: "France",
            gf: "French Guiana",
            pf: "French Polynesia",
            tf: "French Southern Territories",
            ga: "Gabon",
            gm: "Gambia",
            ge: "Georgia",
            de: "Germany",
            gh: "Ghana",
            gi: "Gibraltar",
            gr: "Greece",
            gl: "Greenland",
            gd: "Grenada",
            gp: "Guadeloupe",
            gu: "Guam",
            gt: "Guatemala",
            gg: "Guernsey",
            gn: "Guinea",
            gw: "Guinea-Bissau",
            gy: "Guyana",
            ht: "Haiti",
            hm: "Heard & McDonald Islands",
            hn: "Honduras",
            hk: "Hong Kong SAR China",
            hu: "Hungary",
            is: "Iceland",
            in: "India",
            id: "Indonesia",
            ir: "Iran",
            iq: "Iraq",
            ie: "Ireland",
            im: "Isle of Man",
            il: "Israel",
            it: "Italy",
            jm: "Jamaica",
            jp: "Japan",
            je: "Jersey",
            jo: "Jordan",
            kz: "Kazakhstan",
            ke: "Kenya",
            ki: "Kiribati",
            kw: "Kuwait",
            kg: "Kyrgyzstan",
            la: "Laos",
            lv: "Latvia",
            lb: "Lebanon",
            ls: "Lesotho",
            lr: "Liberia",
            ly: "Libya",
            li: "Liechtenstein",
            lt: "Lithuania",
            lu: "Luxembourg",
            mo: "Macao SAR China",
            mg: "Madagascar",
            mw: "Malawi",
            my: "Malaysia",
            mv: "Maldives",
            ml: "Mali",
            mt: "Malta",
            mh: "Marshall Islands",
            mq: "Martinique",
            mr: "Mauritania",
            mu: "Mauritius",
            yt: "Mayotte",
            mx: "Mexico",
            fm: "Micronesia",
            md: "Moldova",
            mc: "Monaco",
            mn: "Mongolia",
            me: "Montenegro",
            ms: "Montserrat",
            ma: "Morocco",
            mz: "Mozambique",
            mm: "Myanmar (Burma)",
            na: "Namibia",
            nr: "Nauru",
            np: "Nepal",
            nl: "Netherlands",
            nc: "New Caledonia",
            nz: "New Zealand",
            ni: "Nicaragua",
            ne: "Niger",
            ng: "Nigeria",
            nu: "Niue",
            nf: "Norfolk Island",
            kp: "North Korea",
            mk: "North Macedonia",
            mp: "Northern Mariana Islands",
            no: "Norway",
            om: "Oman",
            pk: "Pakistan",
            pw: "Palau",
            ps: "Palestinian Territories",
            pa: "Panama",
            pg: "Papua New Guinea",
            py: "Paraguay",
            pe: "Peru",
            ph: "Philippines",
            pn: "Pitcairn Islands",
            pl: "Poland",
            pt: "Portugal",
            pr: "Puerto Rico",
            qa: "Qatar",
            re: "R\xE9union",
            ro: "Romania",
            ru: "Russia",
            rw: "Rwanda",
            ws: "Samoa",
            sm: "San Marino",
            st: "S\xE3o Tom\xE9 & Pr\xEDncipe",
            sa: "Saudi Arabia",
            sn: "Senegal",
            rs: "Serbia",
            sc: "Seychelles",
            sl: "Sierra Leone",
            sg: "Singapore",
            sx: "Sint Maarten",
            sk: "Slovakia",
            si: "Slovenia",
            sb: "Solomon Islands",
            so: "Somalia",
            za: "South Africa",
            gs: "South Georgia & South Sandwich Islands",
            kr: "South Korea",
            ss: "South Sudan",
            es: "Spain",
            lk: "Sri Lanka",
            bl: "St. Barth\xE9lemy",
            sh: "St. Helena",
            kn: "St. Kitts & Nevis",
            lc: "St. Lucia",
            mf: "St. Martin",
            pm: "St. Pierre & Miquelon",
            vc: "St. Vincent & Grenadines",
            sd: "Sudan",
            sr: "Suriname",
            sj: "Svalbard & Jan Mayen",
            se: "Sweden",
            ch: "Switzerland",
            sy: "Syria",
            tw: "Taiwan",
            tj: "Tajikistan",
            tz: "Tanzania",
            th: "Thailand",
            tl: "Timor-Leste",
            tg: "Togo",
            tk: "Tokelau",
            to: "Tonga",
            tt: "Trinidad & Tobago",
            tn: "Tunisia",
            tr: "Turkey",
            tm: "Turkmenistan",
            tc: "Turks & Caicos Islands",
            tv: "Tuvalu",
            um: "U.S. Outlying Islands",
            vi: "U.S. Virgin Islands",
            ug: "Uganda",
            ua: "Ukraine",
            ae: "United Arab Emirates",
            gb: "United Kingdom",
            us: "United States",
            uy: "Uruguay",
            uz: "Uzbekistan",
            vu: "Vanuatu",
            va: "Vatican City",
            ve: "Venezuela",
            vn: "Vietnam",
            wf: "Wallis & Futuna",
            eh: "Western Sahara",
            ye: "Yemen",
            zm: "Zambia",
            zw: "Zimbabwe",
        };
        var L = {
            selectedCountryAriaLabel: "Selected country",
            noCountrySelected: "No country selected",
            countryListAriaLabel: "List of countries",
            searchPlaceholder: "Search",
            zeroSearchResults: "No results found",
            oneSearchResult: "1 result found",
            multipleSearchResults: "${count} results found",
            ac: "Ascension Island",
            xk: "Kosovo",
        };
        var T = { ..._, ...L };
        var H = 0,
            D = {
                allowDropdown: !0,
                autoPlaceholder: "polite",
                countrySearch: !0,
                containerClass: "",
                customPlaceholder: null,
                dropdownContainer: null,
                excludeCountries: [],
                fixDropdownWidth: !0,
                formatAsYouType: !0,
                formatOnDisplay: !0,
                geoIpLookup: null,
                hiddenInput: null,
                i18n: {},
                initialCountry: "",
                nationalMode: !0,
                onlyCountries: [],
                placeholderNumberType: "MOBILE",
                preferredCountries: [],
                showFlags: !0,
                showSelectedDialCode: !1,
                strictMode: !1,
                useFullscreenPopup:
                    typeof navigator < "u" && typeof window < "u"
                        ? /Android.+Mobile|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                              navigator.userAgent
                          ) || window.innerWidth <= 500
                        : !1,
                utilsScript: "",
            },
            U = [
                "800",
                "822",
                "833",
                "844",
                "855",
                "866",
                "877",
                "880",
                "881",
                "882",
                "883",
                "884",
                "885",
                "886",
                "887",
                "888",
                "889",
            ],
            f = (o) => o.replace(/\D/g, ""),
            E = (o = "") =>
                o
                    .normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "")
                    .toLowerCase(),
            F = (o, t, e) => {
                e && !o.classList.contains(t)
                    ? o.classList.add(t)
                    : !e && o.classList.contains(t) && o.classList.remove(t);
            },
            S = (o) => {
                let t = f(o);
                if (t.charAt(0) === "1") {
                    let e = t.substr(1, 3);
                    return U.indexOf(e) !== -1;
                }
                return !1;
            },
            z = (o, t) => (o.name < t.name ? -1 : o.name > t.name ? 1 : 0),
            R = (o, t, e, i) => {
                if (e === 0 && !i) return 0;
                let n = 0;
                for (let s = 0; s < t.length; s++) {
                    if ((/[+0-9]/.test(t[s]) && n++, n === o && !i))
                        return s + 1;
                    if (i && n === o + 1) return s;
                }
                return t.length;
            },
            h = (o, t, e) => {
                let i = document.createElement(o);
                return (
                    t &&
                        Object.entries(t).forEach(([n, s]) =>
                            i.setAttribute(n, s)
                        ),
                    e && e.appendChild(i),
                    i
                );
            },
            y = (o) => {
                let { instances: t } = window.intlTelInputGlobals;
                Object.values(t).forEach((e) => e[o]());
            },
            b = class {
                id;
                promise;
                telInput;
                activeItem;
                highlightedItem;
                options;
                hadInitialPlaceholder;
                isRTL;
                selectedCountryData;
                countries;
                dialCodeMaxLen;
                dialCodeToIso2Map;
                dialCodes;
                preferredCountries;
                countryContainer;
                selectedCountry;
                selectedCountryInner;
                selectedCountryA11yText;
                selectedDialCode;
                dropdownArrow;
                dropdownContent;
                searchInput;
                searchResultsA11yText;
                countryList;
                dropdown;
                hiddenInput;
                hiddenInputCountry;
                maxCoreNumberLength;
                defaultCountry;
                _a14;
                _a9;
                _a10;
                _a11;
                _a12;
                _handleKeydownEvent;
                _a4;
                _a0;
                _a1;
                _a2;
                _a3;
                _a7;
                resolveAutoCountryPromise;
                rejectAutoCountryPromise;
                resolveUtilsScriptPromise;
                rejectUtilsScriptPromise;
                constructor(t, e = {}) {
                    (this.id = H++),
                        (this.a = t),
                        (this.b = null),
                        (this.c = null),
                        (this.d = Object.assign({}, D, e)),
                        (this.e = !!t.getAttribute("placeholder"));
                }
                _init() {
                    this.d.useFullscreenPopup && (this.d.fixDropdownWidth = !1),
                        this.d.countrySearch &&
                            !this.d.useFullscreenPopup &&
                            (this.d.fixDropdownWidth = !0);
                    let t =
                        this.d.allowDropdown && !this.d.showSelectedDialCode;
                    !this.d.showFlags && t && (this.d.showFlags = !0),
                        this.d.useFullscreenPopup &&
                            !this.d.dropdownContainer &&
                            (this.d.dropdownContainer = document.body),
                        (this.isRTL = !!this.a.closest("[dir=rtl]")),
                        (this.d.i18n = { ...T, ...this.d.i18n });
                    let e = new Promise((n, s) => {
                            (this.h = n), (this.i = s);
                        }),
                        i = new Promise((n, s) => {
                            (this.i0 = n), (this.i1 = s);
                        });
                    (this.promise = Promise.all([e, i])),
                        (this.s = {}),
                        this._b(),
                        this._f(),
                        this._h(),
                        this._i(),
                        this._i3();
                }
                _b() {
                    this._d(),
                        this._d2(),
                        this._e(),
                        this._d0(),
                        (this.d.onlyCountries.length || this.d.i18n) &&
                            this.p.sort(z);
                }
                _c(t, e, i) {
                    e.length > this.dialCodeMaxLen &&
                        (this.dialCodeMaxLen = e.length),
                        this.q.hasOwnProperty(e) || (this.q[e] = []);
                    for (let s = 0; s < this.q[e].length; s++)
                        if (this.q[e][s] === t) return;
                    let n = i !== void 0 ? i : this.q[e].length;
                    this.q[e][n] = t;
                }
                _d() {
                    let { onlyCountries: t, excludeCountries: e } = this.d;
                    if (t.length) {
                        let i = t.map((n) => n.toLowerCase());
                        this.p = C.filter((n) => i.indexOf(n.iso2) > -1);
                    } else if (e.length) {
                        let i = e.map((n) => n.toLowerCase());
                        this.p = C.filter((n) => i.indexOf(n.iso2) === -1);
                    } else this.p = C;
                }
                _d0() {
                    for (let t = 0; t < this.p.length; t++) {
                        let e = this.p[t].iso2.toLowerCase();
                        this.d.i18n.hasOwnProperty(e) &&
                            (this.p[t].name = this.d.i18n[e]);
                    }
                }
                _d2() {
                    (this.dialCodes = {}),
                        (this.dialCodeMaxLen = 0),
                        (this.q = {});
                    for (let t = 0; t < this.p.length; t++) {
                        let e = this.p[t];
                        this.dialCodes[e.dialCode] ||
                            (this.dialCodes[e.dialCode] = !0),
                            this._c(e.iso2, e.dialCode, e.priority);
                    }
                    for (let t = 0; t < this.p.length; t++) {
                        let e = this.p[t];
                        if (e.areaCodes) {
                            let i = this.q[e.dialCode][0];
                            for (let n = 0; n < e.areaCodes.length; n++) {
                                let s = e.areaCodes[n];
                                for (let r = 1; r < s.length; r++) {
                                    let d = e.dialCode + s.substr(0, r);
                                    this._c(i, d), this._c(e.iso2, d);
                                }
                                this._c(e.iso2, e.dialCode + s);
                            }
                        }
                    }
                }
                _e() {
                    this.preferredCountries = [];
                    for (let t = 0; t < this.d.preferredCountries.length; t++) {
                        let e = this.d.preferredCountries[t].toLowerCase(),
                            i = this._y(e, !0);
                        i && this.preferredCountries.push(i);
                    }
                }
                _f() {
                    this.a.classList.add("iti__tel-input"),
                        !this.a.hasAttribute("autocomplete") &&
                            !(
                                this.a.form &&
                                this.a.form.hasAttribute("autocomplete")
                            ) &&
                            this.a.setAttribute("autocomplete", "off");
                    let {
                            allowDropdown: t,
                            showSelectedDialCode: e,
                            showFlags: i,
                            containerClass: n,
                            hiddenInput: s,
                            dropdownContainer: r,
                            fixDropdownWidth: d,
                            useFullscreenPopup: l,
                            countrySearch: a,
                            i18n: p,
                        } = this.d,
                        c = "iti";
                    t && (c += " iti--allow-dropdown"),
                        e && (c += " iti--show-selected-dial-code"),
                        i && (c += " iti--show-flags"),
                        n && (c += ` ${n}`),
                        l || (c += " iti--inline-dropdown");
                    let u = h("div", { class: c });
                    if (
                        (this.a.parentNode?.insertBefore(u, this.a),
                        (i || e) &&
                            ((this.k = h(
                                "div",
                                { class: "iti__country-container" },
                                u
                            )),
                            (this.selectedCountry = h(
                                "button",
                                {
                                    type: "button",
                                    class: "iti__selected-country",
                                    ...(t && {
                                        "aria-expanded": "false",
                                        "aria-label":
                                            this.d.i18n
                                                .selectedCountryAriaLabel,
                                        "aria-haspopup": a ? "true" : "listbox",
                                        "aria-controls": a
                                            ? `iti-${this.id}__dropdown-content`
                                            : `iti-${this.id}__country-listbox`,
                                        ...(a ? { role: "combobox" } : {}),
                                    }),
                                },
                                this.k
                            )),
                            (this.l = h("div", null, this.selectedCountry)),
                            (this.selectedCountryA11yText = h(
                                "span",
                                { class: "iti__a11y-text" },
                                this.l
                            ))),
                        u.appendChild(this.a),
                        this.selectedCountry &&
                            this.a.disabled &&
                            this.selectedCountry.setAttribute(
                                "aria-disabled",
                                "true"
                            ),
                        e &&
                            (this.t = h(
                                "div",
                                { class: "iti__selected-dial-code" },
                                this.selectedCountry
                            )),
                        t)
                    ) {
                        this.a.disabled ||
                            this.selectedCountry.setAttribute("tabindex", "0"),
                            (this.u = h(
                                "div",
                                { class: "iti__arrow", "aria-hidden": "true" },
                                this.selectedCountry
                            ));
                        let m = d ? "" : "iti--flexible-dropdown-width";
                        if (
                            ((this.dropdownContent = h("div", {
                                id: `iti-${this.id}__dropdown-content`,
                                class: `iti__dropdown-content iti__hide ${m}`,
                            })),
                            a &&
                                ((this.searchInput = h(
                                    "input",
                                    {
                                        type: "text",
                                        class: "iti__search-input",
                                        placeholder: p.searchPlaceholder,
                                        role: "combobox",
                                        "aria-expanded": "true",
                                        "aria-label": p.searchPlaceholder,
                                        "aria-controls": `iti-${this.id}__country-listbox`,
                                        "aria-autocomplete": "list",
                                        autocomplete: "off",
                                    },
                                    this.dropdownContent
                                )),
                                (this.searchResultsA11yText = h(
                                    "span",
                                    { class: "iti__a11y-text" },
                                    this.dropdownContent
                                ))),
                            (this.countryList = h(
                                "ul",
                                {
                                    class: "iti__country-list",
                                    id: `iti-${this.id}__country-listbox`,
                                    role: "listbox",
                                    "aria-label": p.countryListAriaLabel,
                                },
                                this.dropdownContent
                            )),
                            this.preferredCountries.length &&
                                !a &&
                                (this._g(
                                    this.preferredCountries,
                                    "iti__preferred",
                                    !0
                                ),
                                h(
                                    "li",
                                    {
                                        class: "iti__divider",
                                        "aria-hidden": "true",
                                    },
                                    this.countryList
                                )),
                            this._g(this.p, "iti__standard"),
                            a && this._p4(),
                            r)
                        ) {
                            let g = "iti iti--container";
                            l
                                ? (g += " iti--fullscreen-popup")
                                : (g += " iti--inline-dropdown"),
                                a && (g += " iti--country-search"),
                                (this.dropdown = h("div", { class: g })),
                                this.dropdown.appendChild(this.dropdownContent);
                        } else this.k.appendChild(this.dropdownContent);
                    }
                    if (s) {
                        let m = this.a.getAttribute("name") || "",
                            g = s(m);
                        g.phone &&
                            ((this.hiddenInput = h("input", {
                                type: "hidden",
                                name: g.phone,
                            })),
                            u.appendChild(this.hiddenInput)),
                            g.country &&
                                ((this.hiddenInputCountry = h("input", {
                                    type: "hidden",
                                    name: g.country,
                                })),
                                u.appendChild(this.hiddenInputCountry));
                    }
                }
                _g(t, e, i) {
                    for (let n = 0; n < t.length; n++) {
                        let s = t[n],
                            r = i ? "-preferred" : "",
                            d = h(
                                "li",
                                {
                                    id: `iti-${this.id}__item-${s.iso2}${r}`,
                                    class: `iti__country ${e}`,
                                    tabindex: "-1",
                                    role: "option",
                                    "data-dial-code": s.dialCode,
                                    "data-country-code": s.iso2,
                                    "aria-selected": "false",
                                },
                                this.countryList
                            );
                        s.nodeById[this.id] = d;
                        let l = "";
                        this.d.showFlags &&
                            (l += `<div class='iti__flag-box'><div class='iti__flag iti__${s.iso2}'></div></div>`),
                            (l += `<span class='iti__country-name'>${s.name}</span>`),
                            (l += `<span class='iti__dial-code'>+${s.dialCode}</span>`),
                            d.insertAdjacentHTML("beforeend", l);
                    }
                }
                _h(t = !1) {
                    let e = this.a.getAttribute("value"),
                        i = this.a.value,
                        s =
                            e &&
                            e.charAt(0) === "+" &&
                            (!i || i.charAt(0) !== "+")
                                ? e
                                : i,
                        r = this._5(s),
                        d = S(s),
                        { initialCountry: l } = this.d;
                    if (r && !d) this._v(s);
                    else if (l !== "auto" || t) {
                        let a = l ? l.toLowerCase() : "";
                        a && this._y(a, !0)
                            ? this._z(a)
                            : r && d
                            ? this._z("us")
                            : this._z();
                    }
                    s && this._u(s);
                }
                _i() {
                    this._j(),
                        this.d.allowDropdown && this._i2(),
                        (this.hiddenInput || this.hiddenInputCountry) &&
                            this.a.form &&
                            this._i0();
                }
                _i0() {
                    (this._a14 = () => {
                        this.hiddenInput &&
                            (this.hiddenInput.value = this.getNumber()),
                            this.hiddenInputCountry &&
                                (this.hiddenInputCountry.value =
                                    this.getSelectedCountryData().iso2 || "");
                    }),
                        this.a.form?.addEventListener("submit", this._a14);
                }
                _i2() {
                    this._a9 = (e) => {
                        this.dropdownContent.classList.contains("iti__hide")
                            ? this.a.focus()
                            : e.preventDefault();
                    };
                    let t = this.a.closest("label");
                    t && t.addEventListener("click", this._a9),
                        (this._a10 = () => {
                            this.dropdownContent.classList.contains(
                                "iti__hide"
                            ) &&
                                !this.a.disabled &&
                                !this.a.readOnly &&
                                this._n();
                        }),
                        this.selectedCountry.addEventListener(
                            "click",
                            this._a10
                        ),
                        (this._a11 = (e) => {
                            this.dropdownContent.classList.contains(
                                "iti__hide"
                            ) &&
                                ["ArrowUp", "ArrowDown", " ", "Enter"].includes(
                                    e.key
                                ) &&
                                (e.preventDefault(),
                                e.stopPropagation(),
                                this._n()),
                                e.key === "Tab" && this._2();
                        }),
                        this.k.addEventListener("keydown", this._a11);
                }
                _i3() {
                    this.d.utilsScript && !window.intlTelInputUtils
                        ? window.intlTelInputGlobals.documentReady()
                            ? window.intlTelInputGlobals.loadUtils(
                                  this.d.utilsScript
                              )
                            : window.addEventListener("load", () => {
                                  window.intlTelInputGlobals.loadUtils(
                                      this.d.utilsScript
                                  );
                              })
                        : this.i0(),
                        this.d.initialCountry === "auto" && !this.s.iso2
                            ? this._i4()
                            : this.h();
                }
                _i4() {
                    window.intlTelInputGlobals.autoCountry
                        ? this.handleAutoCountry()
                        : window.intlTelInputGlobals
                              .startedLoadingAutoCountry ||
                          ((window.intlTelInputGlobals.startedLoadingAutoCountry =
                              !0),
                          typeof this.d.geoIpLookup == "function" &&
                              this.d.geoIpLookup(
                                  (t = "") => {
                                      let e = t.toLowerCase();
                                      e && this._y(e, !0)
                                          ? ((window.intlTelInputGlobals.autoCountry =
                                                e),
                                            setTimeout(() =>
                                                y("handleAutoCountry")
                                            ))
                                          : (this._h(!0),
                                            y("rejectAutoCountryPromise"));
                                  },
                                  () => {
                                      this._h(!0),
                                          y("rejectAutoCountryPromise");
                                  }
                              ));
                }
                _j() {
                    let { strictMode: t, formatAsYouType: e } = this.d,
                        i = !1;
                    (this._a12 = (n) => {
                        this._v(this.a.value) && this._8();
                        let s = n && n.data && /[^+0-9]/.test(n.data),
                            r =
                                n &&
                                n.inputType === "insertFromPaste" &&
                                this.a.value;
                        if (
                            (s || (r && !t)
                                ? (i = !0)
                                : /[^+0-9]/.test(this.a.value) || (i = !1),
                            e && !i)
                        ) {
                            let d = this.a.selectionStart || 0,
                                a = this.a.value
                                    .substring(0, d)
                                    .replace(/[^+0-9]/g, "").length,
                                p = n && n.inputType === "deleteContentForward",
                                c = this._9(),
                                u = R(a, c, d, p);
                            (this.a.value = c), this.a.setSelectionRange(u, u);
                        }
                    }),
                        this.a.addEventListener("input", this._a12),
                        t &&
                            ((this._handleKeydownEvent = (n) => {
                                if (
                                    n.key &&
                                    n.key.length === 1 &&
                                    !n.altKey &&
                                    !n.ctrlKey &&
                                    !n.metaKey
                                ) {
                                    let s =
                                            this.a.selectionStart === 0 &&
                                            n.key === "+",
                                        r = /^[0-9]$/.test(n.key),
                                        d = s || r,
                                        l = this._6(),
                                        a =
                                            window.intlTelInputUtils.getCoreNumber(
                                                l,
                                                this.s.iso2
                                            ),
                                        p =
                                            this.maxCoreNumberLength &&
                                            a.length >=
                                                this.maxCoreNumberLength;
                                    (!d || p) && n.preventDefault();
                                }
                            }),
                            this.a.addEventListener(
                                "keydown",
                                this._handleKeydownEvent
                            ));
                }
                _j2(t) {
                    let e = parseInt(
                        this.a.getAttribute("maxlength") || "",
                        10
                    );
                    return e && t.length > e ? t.substr(0, e) : t;
                }
                _trigger(t) {
                    let e = new Event(t, { bubbles: !0, cancelable: !0 });
                    this.a.dispatchEvent(e);
                }
                _n() {
                    let { fixDropdownWidth: t, countrySearch: e } = this.d;
                    if (
                        (t &&
                            (this.dropdownContent.style.width = `${this.a.offsetWidth}px`),
                        this.dropdownContent.classList.remove("iti__hide"),
                        this.selectedCountry.setAttribute(
                            "aria-expanded",
                            "true"
                        ),
                        this._o(),
                        this.b && !e)
                    )
                        this._x(this.b, !1), this._3(this.b, !0);
                    else {
                        let i = this.countryList.firstElementChild;
                        i && (this._x(i, !1), (this.countryList.scrollTop = 0)),
                            e && this.searchInput.focus();
                    }
                    this._p(),
                        this.u.classList.add("iti__arrow--up"),
                        this._trigger("open:countrydropdown");
                }
                _o() {
                    if (
                        (this.d.dropdownContainer &&
                            this.d.dropdownContainer.appendChild(this.dropdown),
                        !this.d.useFullscreenPopup)
                    ) {
                        let t = this.a.getBoundingClientRect(),
                            e = document.documentElement.scrollTop,
                            i = t.top + e,
                            n = this.a.offsetHeight,
                            s = this.dropdownContent.offsetHeight,
                            r = i + n + s < e + window.innerHeight,
                            d = i - s > e,
                            l = !this.d.countrySearch && !r && d;
                        if (
                            (F(
                                this.dropdownContent,
                                "iti__dropdown-content--dropup",
                                l
                            ),
                            this.d.dropdownContainer)
                        ) {
                            let a = l ? 0 : n;
                            (this.dropdown.style.top = `${t.top + a}px`),
                                (this.dropdown.style.left = `${t.left}px`),
                                (this._a4 = () => this._2()),
                                window.addEventListener("scroll", this._a4);
                        }
                    }
                }
                _p() {
                    (this._a0 = (n) => {
                        let s = n.target?.closest(".iti__country");
                        s && this._x(s, !1);
                    }),
                        this.countryList.addEventListener(
                            "mouseover",
                            this._a0
                        ),
                        (this._a1 = (n) => {
                            let s = n.target?.closest(".iti__country");
                            s && this._1(s);
                        }),
                        this.countryList.addEventListener("click", this._a1);
                    let t = !0;
                    (this._a2 = () => {
                        t || this._2(), (t = !1);
                    }),
                        document.documentElement.addEventListener(
                            "click",
                            this._a2
                        );
                    let e = "",
                        i = null;
                    if (
                        ((this._a3 = (n) => {
                            [
                                "ArrowUp",
                                "ArrowDown",
                                "Enter",
                                "Escape",
                            ].includes(n.key) &&
                                (n.preventDefault(),
                                n.stopPropagation(),
                                n.key === "ArrowUp" || n.key === "ArrowDown"
                                    ? this._q(n.key)
                                    : n.key === "Enter"
                                    ? this._r()
                                    : n.key === "Escape" && this._2()),
                                !this.d.countrySearch &&
                                    /^[a-zA-ZÀ-ÿа-яА-Я ]$/.test(n.key) &&
                                    (n.stopPropagation(),
                                    i && clearTimeout(i),
                                    (e += n.key.toLowerCase()),
                                    this._s(e),
                                    (i = setTimeout(() => {
                                        e = "";
                                    }, 1e3)));
                        }),
                        document.addEventListener("keydown", this._a3),
                        this.d.countrySearch)
                    ) {
                        let n = () => {
                                let r = this.searchInput.value.trim();
                                r ? this._p3(r) : this._p3("", !0);
                            },
                            s = null;
                        (this._a7 = () => {
                            s && clearTimeout(s),
                                (s = setTimeout(() => {
                                    n(), (s = null);
                                }, 100));
                        }),
                            this.searchInput.addEventListener(
                                "input",
                                this._a7
                            ),
                            this.searchInput.addEventListener("click", (r) =>
                                r.stopPropagation()
                            );
                    }
                }
                _p3(t, e = !1) {
                    let i = !0;
                    this.countryList.innerHTML = "";
                    let n = E(t);
                    for (let s = 0; s < this.p.length; s++) {
                        let r = this.p[s],
                            d = E(r.name),
                            l = `+${r.dialCode}`;
                        if (
                            e ||
                            d.includes(n) ||
                            l.includes(n) ||
                            r.iso2.includes(n)
                        ) {
                            let a = r.nodeById[this.id];
                            a && this.countryList.appendChild(a),
                                i && (this._x(a, !1), (i = !1));
                        }
                    }
                    (this.countryList.scrollTop = 0), this._p4();
                }
                _p4() {
                    let { i18n: t } = this.d,
                        e = this.countryList.childElementCount,
                        i;
                    e === 0
                        ? (i = t.zeroSearchResults)
                        : e === 1
                        ? (i = t.oneSearchResult)
                        : (i = t.multipleSearchResults.replace(
                              "${count}",
                              e.toString()
                          )),
                        (this.searchResultsA11yText.textContent = i);
                }
                _q(t) {
                    let e =
                        t === "ArrowUp"
                            ? this.c?.previousElementSibling
                            : this.c?.nextElementSibling;
                    if (
                        (e
                            ? e.classList.contains("iti__divider") &&
                              (e =
                                  t === "ArrowUp"
                                      ? e.previousElementSibling
                                      : e.nextElementSibling)
                            : this.countryList.childElementCount > 1 &&
                              (e =
                                  t === "ArrowUp"
                                      ? this.countryList.lastElementChild
                                      : this.countryList.firstElementChild),
                        e)
                    ) {
                        this._3(e, !1);
                        let i = !this.d.countrySearch;
                        this._x(e, i);
                    }
                }
                _r() {
                    this.c && this._1(this.c);
                }
                _s(t) {
                    for (let e = 0; e < this.p.length; e++) {
                        let i = this.p[e];
                        if (i.name.substr(0, t.length).toLowerCase() === t) {
                            let s = i.nodeById[this.id];
                            this._x(s, !1), this._3(s, !0);
                            break;
                        }
                    }
                }
                _u(t) {
                    let e = t;
                    if (
                        this.d.formatOnDisplay &&
                        window.intlTelInputUtils &&
                        this.s
                    ) {
                        let i =
                                this.d.nationalMode ||
                                (e.charAt(0) !== "+" &&
                                    !this.d.showSelectedDialCode),
                            { NATIONAL: n, INTERNATIONAL: s } =
                                window.intlTelInputUtils.numberFormat,
                            r = i ? n : s;
                        e = window.intlTelInputUtils.formatNumber(
                            e,
                            this.s.iso2,
                            r
                        );
                    }
                    (e = this._7(e)), (this.a.value = e);
                }
                _v(t) {
                    let e = t.indexOf("+"),
                        i = e ? t.substring(e) : t,
                        n = this.s.dialCode;
                    i &&
                        n === "1" &&
                        i.charAt(0) !== "+" &&
                        (i.charAt(0) !== "1" && (i = `1${i}`), (i = `+${i}`)),
                        this.d.showSelectedDialCode &&
                            n &&
                            i.charAt(0) !== "+" &&
                            (i = `+${n}${i}`);
                    let r = this._5(i, !0),
                        d = f(i),
                        l = null;
                    if (r) {
                        let a = this.q[f(r)],
                            p =
                                a.indexOf(this.s.iso2) !== -1 &&
                                d.length <= r.length - 1;
                        if (!(n === "1" && S(d)) && !p) {
                            for (let u = 0; u < a.length; u++)
                                if (a[u]) {
                                    l = a[u];
                                    break;
                                }
                        }
                    } else
                        i.charAt(0) === "+" && d.length
                            ? (l = "")
                            : (!i || i === "+") && !this.s.iso2 && (l = this.j);
                    return l !== null ? this._z(l) : !1;
                }
                _x(t, e) {
                    let i = this.c;
                    i &&
                        (i.classList.remove("iti__highlight"),
                        i.setAttribute("aria-selected", "false")),
                        (this.c = t),
                        this.c.classList.add("iti__highlight"),
                        this.c.setAttribute("aria-selected", "true"),
                        this.selectedCountry.setAttribute(
                            "aria-activedescendant",
                            t.getAttribute("id") || ""
                        ),
                        this.d.countrySearch &&
                            this.searchInput.setAttribute(
                                "aria-activedescendant",
                                t.getAttribute("id") || ""
                            ),
                        e && this.c.focus();
                }
                _y(t, e) {
                    for (let i = 0; i < this.p.length; i++)
                        if (this.p[i].iso2 === t) return this.p[i];
                    if (e) return null;
                    throw new Error(`No country data for '${t}'`);
                }
                _z(t) {
                    let {
                            allowDropdown: e,
                            showSelectedDialCode: i,
                            showFlags: n,
                            countrySearch: s,
                            i18n: r,
                        } = this.d,
                        d = this.s.iso2 ? this.s : {};
                    if (
                        ((this.s = t ? this._y(t, !1) || {} : {}),
                        this.s.iso2 && (this.j = this.s.iso2),
                        this.l)
                    ) {
                        let l = "",
                            a = "";
                        t
                            ? n &&
                              ((l = `iti__flag iti__${t}`),
                              (a = `${this.s.name} +${this.s.dialCode}`))
                            : ((l = "iti__flag iti__globe"),
                              (a = r.noCountrySelected)),
                            (this.l.className = l),
                            (this.selectedCountryA11yText.textContent = a);
                    }
                    if ((this._z3(t, i), i)) {
                        let l = this.s.dialCode ? `+${this.s.dialCode}` : "";
                        this.t.innerHTML = l;
                        let a = this.selectedCountry.offsetWidth || this._z2();
                        this.isRTL
                            ? (this.a.style.paddingRight = `${a + 6}px`)
                            : (this.a.style.paddingLeft = `${a + 6}px`);
                    }
                    if ((this._0(), this._updateMaxLength(), e && !s)) {
                        let l = this.b;
                        if (
                            (l &&
                                (l.classList.remove("iti__active"),
                                l.setAttribute("aria-selected", "false")),
                            t)
                        ) {
                            let a =
                                this.countryList.querySelector(
                                    `#iti-${this.id}__item-${t}-preferred`
                                ) ||
                                this.countryList.querySelector(
                                    `#iti-${this.id}__item-${t}`
                                );
                            a &&
                                (a.setAttribute("aria-selected", "true"),
                                a.classList.add("iti__active"),
                                (this.b = a));
                        }
                    }
                    return d.iso2 !== t;
                }
                _updateMaxLength() {
                    if (this.d.strictMode && window.intlTelInputUtils)
                        if (this.s.iso2) {
                            let t =
                                    window.intlTelInputUtils.numberType[
                                        this.d.placeholderNumberType
                                    ],
                                e = window.intlTelInputUtils.getExampleNumber(
                                    this.s.iso2,
                                    !1,
                                    t,
                                    !0
                                ),
                                i = e;
                            for (
                                ;
                                window.intlTelInputUtils.isPossibleNumber(
                                    e,
                                    this.s.iso2
                                );

                            )
                                (i = e), (e += "0");
                            let n = window.intlTelInputUtils.getCoreNumber(
                                i,
                                this.s.iso2
                            );
                            this.maxCoreNumberLength = n.length;
                        } else this.maxCoreNumberLength = null;
                }
                _z3(t = null, e) {
                    if (!this.selectedCountry) return;
                    let i;
                    t && !e
                        ? (i = `${this.s.name}: +${this.s.dialCode}`)
                        : t
                        ? (i = this.s.name)
                        : (i = "Unknown"),
                        this.selectedCountry.setAttribute("title", i);
                }
                _z2() {
                    if (this.a.parentNode) {
                        let t = this.a.parentNode.cloneNode(!1);
                        (t.style.visibility = "hidden"),
                            document.body.appendChild(t);
                        let e = this.k.cloneNode();
                        t.appendChild(e);
                        let i = this.selectedCountry.cloneNode(!0);
                        e.appendChild(i);
                        let n = i.offsetWidth;
                        return document.body.removeChild(t), n;
                    }
                    return 0;
                }
                _0() {
                    let {
                            autoPlaceholder: t,
                            placeholderNumberType: e,
                            nationalMode: i,
                            customPlaceholder: n,
                        } = this.d,
                        s = t === "aggressive" || (!this.e && t === "polite");
                    if (window.intlTelInputUtils && s) {
                        let r = window.intlTelInputUtils.numberType[e],
                            d = this.s.iso2
                                ? window.intlTelInputUtils.getExampleNumber(
                                      this.s.iso2,
                                      i,
                                      r
                                  )
                                : "";
                        (d = this._7(d)),
                            typeof n == "function" && (d = n(d, this.s)),
                            this.a.setAttribute("placeholder", d);
                    }
                }
                _1(t) {
                    let e = this._z(t.getAttribute("data-country-code"));
                    this._2(),
                        this._4(t.getAttribute("data-dial-code")),
                        this.a.focus(),
                        e && this._8();
                }
                _2() {
                    this.dropdownContent.classList.add("iti__hide"),
                        this.selectedCountry.setAttribute(
                            "aria-expanded",
                            "false"
                        ),
                        this.selectedCountry.removeAttribute(
                            "aria-activedescendant"
                        ),
                        this.c && this.c.setAttribute("aria-selected", "false"),
                        this.d.countrySearch &&
                            this.searchInput.removeAttribute(
                                "aria-activedescendant"
                            ),
                        this.u.classList.remove("iti__arrow--up"),
                        document.removeEventListener("keydown", this._a3),
                        this.d.countrySearch &&
                            this.searchInput.removeEventListener(
                                "input",
                                this._a7
                            ),
                        document.documentElement.removeEventListener(
                            "click",
                            this._a2
                        ),
                        this.countryList.removeEventListener(
                            "mouseover",
                            this._a0
                        ),
                        this.countryList.removeEventListener("click", this._a1),
                        this.d.dropdownContainer &&
                            (this.d.useFullscreenPopup ||
                                window.removeEventListener("scroll", this._a4),
                            this.dropdown.parentNode &&
                                this.dropdown.parentNode.removeChild(
                                    this.dropdown
                                )),
                        this._trigger("close:countrydropdown");
                }
                _3(t, e) {
                    let i = this.countryList,
                        n = document.documentElement.scrollTop,
                        s = i.offsetHeight,
                        r = i.getBoundingClientRect().top + n,
                        d = r + s,
                        l = t.offsetHeight,
                        a = t.getBoundingClientRect().top + n,
                        p = a + l,
                        c = a - r + i.scrollTop,
                        u = s / 2 - l / 2;
                    if (a < r) e && (c -= u), (i.scrollTop = c);
                    else if (p > d) {
                        e && (c += u);
                        let m = s - l;
                        i.scrollTop = c - m;
                    }
                }
                _4(t) {
                    let e = this.a.value,
                        i = `+${t}`,
                        n;
                    if (e.charAt(0) === "+") {
                        let s = this._5(e);
                        s ? (n = e.replace(s, i)) : (n = i), (this.a.value = n);
                    }
                }
                _5(t, e) {
                    let i = "";
                    if (t.charAt(0) === "+") {
                        let n = "";
                        for (let s = 0; s < t.length; s++) {
                            let r = t.charAt(s);
                            if (!isNaN(parseInt(r, 10))) {
                                if (((n += r), e))
                                    this.q[n] && (i = t.substr(0, s + 1));
                                else if (this.dialCodes[n]) {
                                    i = t.substr(0, s + 1);
                                    break;
                                }
                                if (n.length === this.dialCodeMaxLen) break;
                            }
                        }
                    }
                    return i;
                }
                _6() {
                    let t = this.a.value.trim(),
                        { dialCode: e } = this.s,
                        i,
                        n = f(t);
                    return (
                        this.d.showSelectedDialCode &&
                        !this.d.nationalMode &&
                        t.charAt(0) !== "+" &&
                        e &&
                        n
                            ? (i = `+${e}`)
                            : (i = ""),
                        i + t
                    );
                }
                _7(t) {
                    let e = t;
                    if (this.d.showSelectedDialCode) {
                        let i = this._5(e);
                        if (i) {
                            i = `+${this.s.dialCode}`;
                            let n =
                                e[i.length] === " " || e[i.length] === "-"
                                    ? i.length + 1
                                    : i.length;
                            e = e.substr(n);
                        }
                    }
                    return this._j2(e);
                }
                _8() {
                    this._trigger("countrychange");
                }
                _9() {
                    let t = this._6(),
                        e = window.intlTelInputUtils
                            ? window.intlTelInputUtils.formatNumberAsYouType(
                                  t,
                                  this.s.iso2
                              )
                            : t,
                        { dialCode: i } = this.s;
                    return this.d.showSelectedDialCode &&
                        !this.d.nationalMode &&
                        this.a.value.charAt(0) !== "+" &&
                        e.includes(`+${i}`)
                        ? (e.split(`+${i}`)[1] || "").trim()
                        : e;
                }
                handleAutoCountry() {
                    this.d.initialCountry === "auto" &&
                        window.intlTelInputGlobals.autoCountry &&
                        ((this.j = window.intlTelInputGlobals.autoCountry),
                        this.a.value || this.setCountry(this.j),
                        this.h());
                }
                handleUtils() {
                    window.intlTelInputUtils &&
                        (this.a.value && this._u(this.a.value),
                        this.s.iso2 && (this._0(), this._updateMaxLength())),
                        this.i0();
                }
                destroy() {
                    if (this.d.allowDropdown) {
                        this._2(),
                            this.selectedCountry.removeEventListener(
                                "click",
                                this._a10
                            ),
                            this.k.removeEventListener("keydown", this._a11);
                        let i = this.a.closest("label");
                        i && i.removeEventListener("click", this._a9);
                    }
                    let { form: t } = this.a;
                    this._a14 &&
                        t &&
                        t.removeEventListener("submit", this._a14),
                        this.a.removeEventListener("input", this._a12),
                        this._handleKeydownEvent &&
                            this.a.removeEventListener(
                                "keydown",
                                this._handleKeydownEvent
                            ),
                        this.a.removeAttribute("data-intl-tel-input-id");
                    let e = this.a.parentNode;
                    e?.parentNode?.insertBefore(this.a, e),
                        e?.parentNode?.removeChild(e),
                        delete window.intlTelInputGlobals.instances[this.id];
                }
                getExtension() {
                    return window.intlTelInputUtils
                        ? window.intlTelInputUtils.getExtension(
                              this._6(),
                              this.s.iso2
                          )
                        : "";
                }
                getNumber(t) {
                    if (window.intlTelInputUtils) {
                        let { iso2: e } = this.s;
                        return window.intlTelInputUtils.formatNumber(
                            this._6(),
                            e,
                            t
                        );
                    }
                    return "";
                }
                getNumberType() {
                    return window.intlTelInputUtils
                        ? window.intlTelInputUtils.getNumberType(
                              this._6(),
                              this.s.iso2
                          )
                        : -99;
                }
                getSelectedCountryData() {
                    return this.s;
                }
                getValidationError() {
                    if (window.intlTelInputUtils) {
                        let { iso2: t } = this.s;
                        return window.intlTelInputUtils.getValidationError(
                            this._6(),
                            t
                        );
                    }
                    return -99;
                }
                isValidNumber(t = !0) {
                    let e = this._6();
                    return /\p{L}/u.test(e)
                        ? !1
                        : window.intlTelInputUtils
                        ? window.intlTelInputUtils.isPossibleNumber(
                              e,
                              this.s.iso2,
                              t
                          )
                        : null;
                }
                isValidNumberPrecise() {
                    let t = this._6();
                    return /\p{L}/u.test(t)
                        ? !1
                        : window.intlTelInputUtils
                        ? window.intlTelInputUtils.isValidNumber(t, this.s.iso2)
                        : null;
                }
                setCountry(t) {
                    let e = t.toLowerCase();
                    this.s.iso2 !== e &&
                        (this._z(e), this._4(this.s.dialCode), this._8());
                }
                setNumber(t) {
                    let e = this._v(t);
                    this._u(t), e && this._8();
                }
                setPlaceholderNumberType(t) {
                    (this.d.placeholderNumberType = t), this._0();
                }
            },
            O = (o, t, e) => {
                let i = document.createElement("script");
                (i.onload = () => {
                    y("handleUtils"), t && t();
                }),
                    (i.onerror = () => {
                        y("rejectUtilsScriptPromise"), e && e();
                    }),
                    (i.className = "iti-load-utils"),
                    (i.async = !0),
                    (i.src = o),
                    document.body.appendChild(i);
            },
            j = (o) =>
                !window.intlTelInputUtils &&
                !window.intlTelInputGlobals.startedLoadingUtilsScript
                    ? ((window.intlTelInputGlobals.startedLoadingUtilsScript =
                          !0),
                      new Promise((t, e) => O(o, t, e)))
                    : null;
        if (typeof window == "object" && !window.intlTelInputGlobals) {
            let o = {
                defaults: D,
                documentReady: () => document.readyState === "complete",
                getCountryData: () => C,
                getInstance: (t) => {
                    let e = t.getAttribute("data-intl-tel-input-id");
                    return e ? o.instances[e] : null;
                },
                instances: {},
                loadUtils: j,
                version: "21.2.7",
            };
            window.intlTelInputGlobals = o;
        }
        var B = (o, t) => {
                let e = new b(o, t);
                return (
                    e._init(),
                    o.setAttribute("data-intl-tel-input-id", e.id.toString()),
                    (window.intlTelInputGlobals.instances[e.id] = e),
                    e
                );
            },
            $ = B;
        return P(G);
    })();

    // UMD
    return factoryOutput.default;
});

const countries = [
    {
        name: "Argentina",
        nameESmx: "Argentina",
        states: [
            { name: "Buenos Aires", nameESmx: "Buenos Aires" },
            { name: "Catamarca", nameESmx: "Catamarca" },
            { name: "Chaco", nameESmx: "Chaco" },
            { name: "Chubut", nameESmx: "Chubut" },
            { name: "Córdoba", nameESmx: "Córdoba" },
            { name: "Corrientes", nameESmx: "Corrientes" },
            { name: "Entre Ríos", nameESmx: "Entre Ríos" },
            { name: "Formosa", nameESmx: "Formosa" },
            { name: "Jujuy", nameESmx: "Jujuy" },
            { name: "La Pampa", nameESmx: "La Pampa" },
            { name: "La Rioja", nameESmx: "La Rioja" },
            { name: "Mendoza", nameESmx: "Mendoza" },
            { name: "Misiones", nameESmx: "Misiones" },
            { name: "Neuquén", nameESmx: "Neuquén" },
            { name: "Río Negro", nameESmx: "Río Negro" },
            { name: "Salta", nameESmx: "Salta" },
            { name: "San Juan", nameESmx: "San Juan" },
            { name: "San Luis", nameESmx: "San Luis" },
            { name: "Santa Cruz", nameESmx: "Santa Cruz" },
            { name: "Santa Fe", nameESmx: "Santa Fe" },
            { name: "Santiago del Estero", nameESmx: "Santiago del Estero" },
            { name: "Tierra del Fuego", nameESmx: "Tierra del Fuego" },
            { name: "Tucumán", nameESmx: "Tucumán" },
        ],
    },
    {
        name: "Brazil",
        nameESmx: "Brasil",
        states: [
            { name: "Acre", nameESmx: "Acre" },
            { name: "Alagoas", nameESmx: "Alagoas" },
            { name: "Amapá", nameESmx: "Amapá" },
            { name: "Amazonas", nameESmx: "Amazonas" },
            { name: "Bahia", nameESmx: "Bahía" },
            { name: "Ceará", nameESmx: "Ceará" },
            { name: "Distrito Federal", nameESmx: "Distrito Federal" },
            { name: "Espírito Santo", nameESmx: "Espírito Santo" },
            { name: "Goiás", nameESmx: "Goiás" },
            { name: "Maranhão", nameESmx: "Maranhão" },
            { name: "Mato Grosso", nameESmx: "Mato Grosso" },
            { name: "Mato Grosso do Sul", nameESmx: "Mato Grosso del Sur" },
            { name: "Minas Gerais", nameESmx: "Minas Gerais" },
            { name: "Pará", nameESmx: "Pará" },
            { name: "Paraíba", nameESmx: "Paraíba" },
            { name: "Paraná", nameESmx: "Paraná" },
            { name: "Pernambuco", nameESmx: "Pernambuco" },
            { name: "Piauí", nameESmx: "Piauí" },
            { name: "Rio de Janeiro", nameESmx: "Río de Janeiro" },
            { name: "Rio Grande do Norte", nameESmx: "Río Grande del Norte" },
            { name: "Rio Grande do Sul", nameESmx: "Río Grande del Sur" },
            { name: "Rondônia", nameESmx: "Rondonia" },
            { name: "Roraima", nameESmx: "Roraima" },
            { name: "Santa Catarina", nameESmx: "Santa Catarina" },
            { name: "São Paulo", nameESmx: "São Paulo" },
            { name: "Sergipe", nameESmx: "Sergipe" },
            { name: "Tocantins", nameESmx: "Tocantins" },
        ],
    },
    {
        name: "Canada",
        nameESmx: "Canadá",
        states: [
            { name: "Alberta", nameESmx: "Alberta" },
            { name: "British Columbia", nameESmx: "Columbia Británica" },
            { name: "Manitoba", nameESmx: "Manitoba" },
            { name: "New Brunswick", nameESmx: "Nuevo Brunswick" },
            {
                name: "Newfoundland and Labrador",
                nameESmx: "Terranova y Labrador",
            },
            { name: "Nova Scotia", nameESmx: "Nueva Escocia" },
            { name: "Ontario", nameESmx: "Ontario" },
            {
                name: "Prince Edward Island",
                nameESmx: "Isla del Príncipe Eduardo",
            },
            { name: "Quebec", nameESmx: "Quebec" },
            { name: "Saskatchewan", nameESmx: "Saskatchewan" },
        ],
    },
    {
        name: "Mexico",
        nameESmx: "México",
        states: [
            { name: "Aguascalientes", nameESmx: "Aguascalientes" },
            { name: "Baja California", nameESmx: "Baja California" },
            { name: "Baja California Sur", nameESmx: "Baja California Sur" },
            { name: "Campeche", nameESmx: "Campeche" },
            { name: "Chiapas", nameESmx: "Chiapas" },
            { name: "Chihuahua", nameESmx: "Chihuahua" },
            { name: "Coahuila", nameESmx: "Coahuila" },
            { name: "Colima", nameESmx: "Colima" },
            { name: "Durango", nameESmx: "Durango" },
            { name: "Guanajuato", nameESmx: "Guanajuato" },
            { name: "Guerrero", nameESmx: "Guerrero" },
            { name: "Hidalgo", nameESmx: "Hidalgo" },
            { name: "Jalisco", nameESmx: "Jalisco" },
            { name: "Mexico City", nameESmx: "Ciudad de México" },
            { name: "Michoacán", nameESmx: "Michoacán" },
            { name: "Morelos", nameESmx: "Morelos" },
            { name: "Nayarit", nameESmx: "Nayarit" },
            { name: "Nuevo León", nameESmx: "Nuevo León" },
            { name: "Oaxaca", nameESmx: "Oaxaca" },
            { name: "Puebla", nameESmx: "Puebla" },
            { name: "Querétaro", nameESmx: "Querétaro" },
            { name: "Quintana Roo", nameESmx: "Quintana Roo" },
            { name: "San Luis Potosí", nameESmx: "San Luis Potosí" },
            { name: "Sinaloa", nameESmx: "Sinaloa" },
            { name: "Sonora", nameESmx: "Sonora" },
            { name: "State of Mexico", nameESmx: "Estado de Mexico" },
            { name: "Tabasco", nameESmx: "Tabasco" },
            { name: "Tamaulipas", nameESmx: "Tamaulipas" },
            { name: "Tlaxcala", nameESmx: "Tlaxcala" },
            { name: "Veracruz", nameESmx: "Veracruz" },
            { name: "Yucatán", nameESmx: "Yucatán" },
            { name: "Zacatecas", nameESmx: "Zacatecas" },
        ],
    },
    {
        name: "United States",
        nameESmx: "Estados Unidos",
        states: [
            { name: "Alabama", nameESmx: "Alabama" },
            { name: "Alaska", nameESmx: "Alaska" },
            { name: "Arizona", nameESmx: "Arizona" },
            { name: "Arkansas", nameESmx: "Arkansas" },
            { name: "California", nameESmx: "California" },
            { name: "Colorado", nameESmx: "Colorado" },
            { name: "Connecticut", nameESmx: "Connecticut" },
            { name: "Delaware", nameESmx: "Delaware" },
            { name: "Dist. of Columbia", nameESmx: "Distrito de Columbia" },
            { name: "Florida", nameESmx: "Florida" },
            { name: "Georgia", nameESmx: "Georgia" },
            { name: "Hawaii", nameESmx: "Hawái" },
            { name: "Idaho", nameESmx: "Idaho" },
            { name: "Illinois", nameESmx: "Illinois" },
            { name: "Indiana", nameESmx: "Indiana" },
            { name: "Iowa", nameESmx: "Iowa" },
            { name: "Kansas", nameESmx: "Kansas" },
            { name: "Kentucky", nameESmx: "Kentucky" },
            { name: "Louisiana", nameESmx: "Luisiana" },
            { name: "Maine", nameESmx: "Maine" },
            { name: "Maryland", nameESmx: "Maryland" },
            { name: "Massachusetts", nameESmx: "Massachusetts" },
            { name: "Michigan", nameESmx: "Michigan" },
            { name: "Minnesota", nameESmx: "Minnesota" },
            { name: "Mississippi", nameESmx: "Misisipi" },
            { name: "Missouri", nameESmx: "Misuri" },
            { name: "Montana", nameESmx: "Montana" },
            { name: "Nebraska", nameESmx: "Nebraska" },
            { name: "Nevada", nameESmx: "Nevada" },
            { name: "New Hampshire", nameESmx: "New Hampshire" },
            { name: "New Jersey", nameESmx: "Nueva Jersey" },
            { name: "New Mexico", nameESmx: "Nuevo México" },
            { name: "New York", nameESmx: "Nueva York" },
            { name: "North Carolina", nameESmx: "Carolina del Norte" },
            { name: "North Dakota", nameESmx: "Dakota del Norte" },
            { name: "Ohio", nameESmx: "Ohio" },
            { name: "Oklahoma", nameESmx: "Oklahoma" },
            { name: "Oregon", nameESmx: "Oregón" },
            { name: "Pennsylvania", nameESmx: "Pensilvania" },
            { name: "Rhode Island", nameESmx: "Rhode Island" },
            { name: "South Carolina", nameESmx: "Carolina del Sur" },
            { name: "South Dakota", nameESmx: "Dakota del Sur" },
            { name: "Tennessee", nameESmx: "Tennessee" },
            { name: "Texas", nameESmx: "Texas" },
            { name: "Utah", nameESmx: "Utah" },
            { name: "Vermont", nameESmx: "Vermont" },
            { name: "Virginia", nameESmx: "Virginia" },
            { name: "Washington", nameESmx: "Washington" },
            { name: "West Virginia", nameESmx: "Virginia Occidental" },
            { name: "Wisconsin", nameESmx: "Wisconsin" },
            { name: "Wyoming", nameESmx: "Wyoming" },
        ],
    },
    {
        name: "Colombia",
        nameESmx: "Colombia",
        states: [
            { name: "Amazonas", nameESmx: "Amazonas" },
            { name: "Antioquia", nameESmx: "Antioquia" },
            { name: "Arauca", nameESmx: "Arauca" },
            { name: "Atlántico", nameESmx: "Atlántico" },
            { name: "Bolívar", nameESmx: "Bolívar" },
            { name: "Boyacá", nameESmx: "Boyacá" },
            { name: "Caldas", nameESmx: "Caldas" },
            { name: "Caquetá", nameESmx: "Caquetá" },
            { name: "Casanare", nameESmx: "Casanare" },
            { name: "Cauca", nameESmx: "Cauca" },
            { name: "Cesar", nameESmx: "Cesar" },
            { name: "Chocó", nameESmx: "Chocó" },
            { name: "Córdoba", nameESmx: "Córdoba" },
            { name: "Cundinamarca", nameESmx: "Cundinamarca" },
            { name: "Guainía", nameESmx: "Guainía" },
            { name: "Guaviare", nameESmx: "Guaviare" },
            { name: "Huila", nameESmx: "Huila" },
            { name: "La Guajira", nameESmx: "La Guajira" },
            { name: "Magdalena", nameESmx: "Magdalena" },
            { name: "Meta", nameESmx: "Meta" },
            { name: "Nariño", nameESmx: "Nariño" },
            { name: "Norte de Santander", nameESmx: "Norte de Santander" },
            { name: "Putumayo", nameESmx: "Putumayo" },
            { name: "Quindío", nameESmx: "Quindío" },
            { name: "Risaralda", nameESmx: "Risaralda" },
            {
                name: "San Andrés y Providencia",
                nameESmx: "San Andrés y Providencia",
            },
            { name: "Santander", nameESmx: "Santander" },
            { name: "Sucre", nameESmx: "Sucre" },
            { name: "Tolima", nameESmx: "Tolima" },
            { name: "Valle del Cauca", nameESmx: "Valle del Cauca" },
            { name: "Vaupés", nameESmx: "Vaupés" },
            { name: "Vichada", nameESmx: "Vichada" },
        ],
    },
    {
        name: "Chile",
        nameESmx: "Chile",
        states: [
            { name: "Arica y Parinacota", nameESmx: "Arica y Parinacota" },
            { name: "Aysén", nameESmx: "Aysén" },
            { name: "Antofagasta", nameESmx: "Antofagasta" },
            { name: "Atacama", nameESmx: "Atacama" },
            { name: "Biobío", nameESmx: "Biobío" },
            { name: "Coquimbo", nameESmx: "Coquimbo" },
            { name: "La Araucanía", nameESmx: "La Araucanía" },
            { name: "Los Lagos", nameESmx: "Los Lagos" },
            { name: "Los Ríos", nameESmx: "Los Ríos" },
            { name: "Magallanes", nameESmx: "Magallanes" },
            { name: "Maule", nameESmx: "Maule" },
            { name: "Ñuble", nameESmx: "Ñuble" },
            { name: "O’Higgins", nameESmx: "O’Higgins" },
            {
                name: "Región Metropolitana de Santiago",
                nameESmx: "Región Metropolitana de Santiago",
            },
            { name: "Tarapacá", nameESmx: "Tarapacá" },
            { name: "Valparaíso", nameESmx: "Valparaíso" },
        ],
    },
    {
        name: "Peru",
        nameESmx: "Perú",
        states: [
            { name: "Amazonas", nameESmx: "Amazonas" },
            { name: "Áncash", nameESmx: "Áncash" },
            { name: "Apurímac", nameESmx: "Apurímac" },
            { name: "Arequipa", nameESmx: "Arequipa" },
            { name: "Ayacucho", nameESmx: "Ayacucho" },
            { name: "Cajamarca", nameESmx: "Cajamarca" },
            { name: "Callao", nameESmx: "Callao" },
            { name: "Cusco", nameESmx: "Cusco" },
            { name: "Huancavelica", nameESmx: "Huancavelica" },
            { name: "Huánuco", nameESmx: "Huánuco" },
            { name: "Ica", nameESmx: "Ica" },
            { name: "Junín", nameESmx: "Junín" },
            { name: "La Libertad", nameESmx: "La Libertad" },
            { name: "Lambayeque", nameESmx: "Lambayeque" },
            { name: "Lima", nameESmx: "Lima" },
            { name: "Loreto", nameESmx: "Loreto" },
            { name: "Madre de Dios", nameESmx: "Madre de Dios" },
            { name: "Moquegua", nameESmx: "Moquegua" },
            { name: "Pasco", nameESmx: "Pasco" },
            { name: "Piura", nameESmx: "Piura" },
            { name: "Puno", nameESmx: "Puno" },
            { name: "San Martín", nameESmx: "San Martín" },
            { name: "Tacna", nameESmx: "Tacna" },
            { name: "Tumbes", nameESmx: "Tumbes" },
            { name: "Ucayali", nameESmx: "Ucayali" },
        ],
    },
    {
        name: "Venezuela",
        nameESmx: "Venezuela",
        states: [
            { name: "Amazonas", nameESmx: "Amazonas" },
            { name: "Anzoátegui", nameESmx: "Anzoátegui" },
            { name: "Apure", nameESmx: "Apure" },
            { name: "Aragua", nameESmx: "Aragua" },
            { name: "Barinas", nameESmx: "Barinas" },
            { name: "Bolívar", nameESmx: "Bolívar" },
            { name: "Carabobo", nameESmx: "Carabobo" },
            { name: "Cojedes", nameESmx: "Cojedes" },
            { name: "Delta Amacuro", nameESmx: "Delta Amacuro" },
            { name: "Falcón", nameESmx: "Falcón" },
            { name: "Guárico", nameESmx: "Guárico" },
            { name: "Lara", nameESmx: "Lara" },
            { name: "Mérida", nameESmx: "Mérida" },
            { name: "Miranda", nameESmx: "Miranda" },
            { name: "Monagas", nameESmx: "Monagas" },
            { name: "Nueva Esparta", nameESmx: "Nueva Esparta" },
            { name: "Portuguesa", nameESmx: "Portuguesa" },
            { name: "Sucre", nameESmx: "Sucre" },
            { name: "Táchira", nameESmx: "Táchira" },
            { name: "Trujillo", nameESmx: "Trujillo" },
            { name: "Vargas", nameESmx: "Vargas" },
            { name: "Yaracuy", nameESmx: "Yaracuy" },
            { name: "Zulia", nameESmx: "Zulia" },
        ],
    },
    {
        name: "Uruguay",
        nameESmx: "Uruguay",
        states: [
            { name: "Artigas", nameESmx: "Artigas" },
            { name: "Canelones", nameESmx: "Canelones" },
            { name: "Cerro Largo", nameESmx: "Cerro Largo" },
            { name: "Colonia", nameESmx: "Colonia" },
            { name: "Durazno", nameESmx: "Durazno" },
            { name: "Flores", nameESmx: "Flores" },
            { name: "Florida", nameESmx: "Florida" },
            { name: "Lavalleja", nameESmx: "Lavalleja" },
            { name: "Maldonado", nameESmx: "Maldonado" },
            { name: "Montevideo", nameESmx: "Montevideo" },
            { name: "Paysandú", nameESmx: "Paysandú" },
            { name: "Río Negro", nameESmx: "Río Negro" },
            { name: "Rivera", nameESmx: "Rivera" },
            { name: "Rocha", nameESmx: "Rocha" },
            { name: "Salto", nameESmx: "Salto" },
            { name: "San José", nameESmx: "San José" },
            { name: "Soriano", nameESmx: "Soriano" },
            { name: "Tacuarembó", nameESmx: "Tacuarembó" },
            { name: "Treinta y Tres", nameESmx: "Treinta y Tres" },
        ],
    },
    {
        name: "Bolivia",
        nameESmx: "Bolivia",
        states: [
            { name: "Chuquisaca", nameESmx: "Chuquisaca" },
            { name: "Cochabamba", nameESmx: "Cochabamba" },
            { name: "Beni", nameESmx: "Beni" },
            { name: "La Paz", nameESmx: "La Paz" },
            { name: "Oruro", nameESmx: "Oruro" },
            { name: "Pando", nameESmx: "Pando" },
            { name: "Potosí", nameESmx: "Potosí" },
            { name: "Santa Cruz", nameESmx: "Santa Cruz" },
            { name: "Tarija", nameESmx: "Tarija" },
        ],
    },
    {
        name: "Ecuador",
        nameESmx: "Ecuador",
        states: [
            { name: "Azuay", nameESmx: "Azuay" },
            { name: "Bolívar", nameESmx: "Bolívar" },
            { name: "Cañar", nameESmx: "Cañar" },
            { name: "Carchi", nameESmx: "Carchi" },
            { name: "Chimborazo", nameESmx: "Chimborazo" },
            { name: "Cotopaxi", nameESmx: "Cotopaxi" },
            { name: "El Oro", nameESmx: "El Oro" },
            { name: "Esmeraldas", nameESmx: "Esmeraldas" },
            { name: "Galápagos", nameESmx: "Galápagos" },
            { name: "Guayas", nameESmx: "Guayas" },
            { name: "Imbabura", nameESmx: "Imbabura" },
            { name: "Loja", nameESmx: "Loja" },
            { name: "Los Ríos", nameESmx: "Los Ríos" },
            { name: "Manabí", nameESmx: "Manabí" },
            { name: "Morona Santiago", nameESmx: "Morona Santiago" },
            { name: "Napo", nameESmx: "Napo" },
            { name: "Orellana", nameESmx: "Orellana" },
            { name: "Pastaza", nameESmx: "Pastaza" },
            { name: "Pichincha", nameESmx: "Pichincha" },
            { name: "Santa Elena", nameESmx: "Santa Elena" },
            {
                name: "Santo Domingo de los Tsáchilas",
                nameESmx: "Santo Domingo de los Tsáchilas",
            },
            { name: "Sucumbíos", nameESmx: "Sucumbíos" },
            { name: "Tungurahua", nameESmx: "Tungurahua" },
            { name: "Zamora Chinchipe", nameESmx: "Zamora Chinchipe" },
        ],
    },
    {
        name: "Paraguay",
        nameESmx: "Paraguay",
        states: [
            { name: "Alto Paraguay", nameESmx: "Alto Paraguay" },
            { name: "Alto Paraná", nameESmx: "Alto Paraná" },
            { name: "Amambay", nameESmx: "Amambay" },
            { name: "Asunción", nameESmx: "Asunción" },
            { name: "Boquerón", nameESmx: "Boquerón" },
            { name: "Caaguazú", nameESmx: "Caaguazú" },
            { name: "Caazapá", nameESmx: "Caazapá" },
            { name: "Canindeyú", nameESmx: "Canindeyú" },
            { name: "Central", nameESmx: "Central" },
            { name: "Concepción", nameESmx: "Concepción" },
            { name: "Cordillera", nameESmx: "Cordillera" },
            { name: "Guairá", nameESmx: "Guairá" },
            { name: "Itapúa", nameESmx: "Itapúa" },
            { name: "Misiones", nameESmx: "Misiones" },
            { name: "Ñeembucú", nameESmx: "Ñeembucú" },
            { name: "Paraguarí", nameESmx: "Paraguarí" },
            { name: "Presidente Hayes", nameESmx: "Presidente Hayes" },
            { name: "San Pedro", nameESmx: "San Pedro" },
        ],
    },
    {
        name: "Guyana",
        nameESmx: "Guyana",
        states: [
            { name: "Barima-Waini", nameESmx: "Barima-Waini" },
            { name: "Cuyuni-Mazaruni", nameESmx: "Cuyuni-Mazaruni" },
            { name: "Demerara-Mahaica", nameESmx: "Demerara-Mahaica" },
            {
                name: "East Berbice-Corentyne",
                nameESmx: "East Berbice-Corentyne",
            },
            {
                name: "Essequibo Islands-West Demerara",
                nameESmx: "Essequibo Islands-West Demerara",
            },
            { name: "Mahaica-Berbice", nameESmx: "Mahaica-Berbice" },
            { name: "Pomeroon-Supenaam", nameESmx: "Pomeroon-Supenaam" },
            { name: "Potaro-Siparuni", nameESmx: "Potaro-Siparuni" },
            {
                name: "Upper Demerara-Berbice",
                nameESmx: "Upper Demerara-Berbice",
            },
            {
                name: "Upper Takutu-Upper Essequibo",
                nameESmx: "Upper Takutu-Upper Essequibo",
            },
        ],
    },
    {
        name: "Suriname",
        nameESmx: "Surinam",
        states: [
            { name: "Brokopondo", nameESmx: "Brokopondo" },
            { name: "Commewijne", nameESmx: "Commewijne" },
            { name: "Coronie", nameESmx: "Coronie" },
            { name: "Marowijne", nameESmx: "Marowijne" },
            { name: "Nickerie", nameESmx: "Nickerie" },
            { name: "Para", nameESmx: "Para" },
            { name: "Paramaribo", nameESmx: "Paramaribo" },
            { name: "Saramacca", nameESmx: "Saramacca" },
            { name: "Sipaliwini", nameESmx: "Sipaliwini" },
            { name: "Wanica", nameESmx: "Wanica" },
        ],
    },
    {
        name: "Panama",
        nameESmx: "Panamá",
        states: [
            { name: "Bocas del Toro", nameESmx: "Bocas del Toro" },
            { name: "Coclé", nameESmx: "Coclé" },
            { name: "Colón", nameESmx: "Colón" },
            { name: "Chiriquí", nameESmx: "Chiriquí" },
            { name: "Darién", nameESmx: "Darién" },
            { name: "Herrera", nameESmx: "Herrera" },
            { name: "Los Santos", nameESmx: "Los Santos" },
            { name: "Panamá", nameESmx: "Panamá" },
            { name: "Veraguas", nameESmx: "Veraguas" },
        ],
    },
    {
        name: "Costa Rica",
        nameESmx: "Costa Rica",
        states: [
            { name: "Alajuela", nameESmx: "Alajuela" },
            { name: "Cartago", nameESmx: "Cartago" },
            { name: "Guanacaste", nameESmx: "Guanacaste" },
            { name: "Heredia", nameESmx: "Heredia" },
            { name: "Limón", nameESmx: "Limón" },
            { name: "Puntarenas", nameESmx: "Puntarenas" },
            { name: "San José", nameESmx: "San José" },
        ],
    },
    {
        name: "Nicaragua",
        nameESmx: "Nicaragua",
        states: [
            { name: "Boaco", nameESmx: "Boaco" },
            { name: "Carazo", nameESmx: "Carazo" },
            { name: "Chinandega", nameESmx: "Chinandega" },
            { name: "Chontales", nameESmx: "Chontales" },
            { name: "Estelí", nameESmx: "Estelí" },
            { name: "Granada", nameESmx: "Granada" },
            { name: "Jinotega", nameESmx: "Jinotega" },
            { name: "León", nameESmx: "León" },
            { name: "Madriz", nameESmx: "Madriz" },
            { name: "Managua", nameESmx: "Managua" },
            { name: "Masaya", nameESmx: "Masaya" },
            { name: "Matagalpa", nameESmx: "Matagalpa" },
            { name: "Nueva Segovia", nameESmx: "Nueva Segovia" },
            { name: "Rivas", nameESmx: "Rivas" },
            { name: "Río San Juan", nameESmx: "Río San Juan" },
            { name: "Caribe Norte", nameESmx: "Caribe Norte" },
            { name: "Caribe Sur", nameESmx: "Caribe Sur" },
        ],
    },
    {
        name: "Honduras",
        nameESmx: "Honduras",
        states: [
            { name: "Atlántida", nameESmx: "Atlántida" },
            { name: "Colón", nameESmx: "Colón" },
            { name: "Comayagua", nameESmx: "Comayagua" },
            { name: "Copán", nameESmx: "Copán" },
            { name: "Cortés", nameESmx: "Cortés" },
            { name: "Choluteca", nameESmx: "Choluteca" },
            { name: "El Paraíso", nameESmx: "El Paraíso" },
            { name: "Francisco Morazán", nameESmx: "Francisco Morazán" },
            { name: "Gracias a Dios", nameESmx: "Gracias a Dios" },
            { name: "Intibucá", nameESmx: "Intibucá" },
            { name: "Islas de la Bahía", nameESmx: "Islas de la Bahía" },
            { name: "La Paz", nameESmx: "La Paz" },
            { name: "Lempira", nameESmx: "Lempira" },
            { name: "Ocotepeque", nameESmx: "Ocotepeque" },
            { name: "Olancho", nameESmx: "Olancho" },
            { name: "Santa Bárbara", nameESmx: "Santa Bárbara" },
            { name: "Valle", nameESmx: "Valle" },
            { name: "Yoro", nameESmx: "Yoro" },
        ],
    },
    {
        name: "El Salvador",
        nameESmx: "El Salvador",
        states: [
            { name: "Ahuachapán", nameESmx: "Ahuachapán" },
            { name: "Cabañas", nameESmx: "Cabañas" },
            { name: "Chalatenango", nameESmx: "Chalatenango" },
            { name: "Cuscatlán", nameESmx: "Cuscatlán" },
            { name: "La Libertad", nameESmx: "La Libertad" },
            { name: "La Paz", nameESmx: "La Paz" },
            { name: "La Unión", nameESmx: "La Unión" },
            { name: "Morazán", nameESmx: "Morazán" },
            { name: "San Miguel", nameESmx: "San Miguel" },
            { name: "San Salvador", nameESmx: "San Salvador" },
            { name: "Santa Ana", nameESmx: "Santa Ana" },
            { name: "San Vicente", nameESmx: "San Vicente" },
            { name: "Sonsonate", nameESmx: "Sonsonate" },
            { name: "Usulután", nameESmx: "Usulután" },
        ],
    },
    {
        name: "Guatemala",
        nameESmx: "Guatemala",
        states: [
            { name: "Alta Verapaz", nameESmx: "Alta Verapaz" },
            { name: "Baja Verapaz", nameESmx: "Baja Verapaz" },
            { name: "Chimaltenango", nameESmx: "Chimaltenango" },
            { name: "Chiquimula", nameESmx: "Chiquimula" },
            { name: "Guatemala", nameESmx: "Guatemala" },
            { name: "El Progreso", nameESmx: "El Progreso" },
            { name: "Escuintla", nameESmx: "Escuintla" },
            { name: "Huehuetenango", nameESmx: "Huehuetenango" },
            { name: "Izabal", nameESmx: "Izabal" },
            { name: "Jalapa", nameESmx: "Jalapa" },
            { name: "Jutiapa", nameESmx: "Jutiapa" },
            { name: "Petén", nameESmx: "Petén" },
            { name: "Quetzaltenango", nameESmx: "Quetzaltenango" },
            { name: "Quiché", nameESmx: "Quiché" },
            { name: "Retalhuleu", nameESmx: "Retalhuleu" },
            { name: "Sacatepéquez", nameESmx: "Sacatepéquez" },
            { name: "San Marcos", nameESmx: "San Marcos" },
            { name: "Santa Rosa", nameESmx: "Santa Rosa" },
            { name: "Sololá", nameESmx: "Sololá" },
            { name: "Suchitepéquez", nameESmx: "Suchitepéquez" },
            { name: "Totonicapán", nameESmx: "Totonicapán" },
            { name: "Zacapa", nameESmx: "Zacapa" },
        ],
    },
    {
        name: "Belize",
        nameESmx: "Belice",
        states: [
            { name: "Belize", nameESmx: "Belice" },
            { name: "Cayo", nameESmx: "Cayo" },
            { name: "Corozal", nameESmx: "Corozal" },
            { name: "Orange Walk", nameESmx: "Orange Walk" },
            { name: "Stann Creek", nameESmx: "Stann Creek" },
            { name: "Toledo", nameESmx: "Toledo" },
        ],
    },
    {
        name: "Cuba",
        nameESmx: "Cuba",
        states: [
            { name: "Artemisa", nameESmx: "Artemisa" },
            { name: "Camagüey", nameESmx: "Camagüey" },
            { name: "Ciego de Ávila", nameESmx: "Ciego de Ávila" },
            { name: "Cienfuegos", nameESmx: "Cienfuegos" },
            { name: "Granma", nameESmx: "Granma" },
            { name: "Guantánamo", nameESmx: "Guantánamo" },
            { name: "Holguín", nameESmx: "Holguín" },
            { name: "La Habana", nameESmx: "La Habana" },
            { name: "Las Tunas", nameESmx: "Las Tunas" },
            { name: "Matanzas", nameESmx: "Matanzas" },
            { name: "Mayabeque", nameESmx: "Mayabeque" },
            { name: "Pinar del Río", nameESmx: "Pinar del Río" },
            { name: "Sancti Spíritus", nameESmx: "Sancti Spíritus" },
            { name: "Santiago de Cuba", nameESmx: "Santiago de Cuba" },
            { name: "Villa Clara", nameESmx: "Villa Clara" },
            { name: "Isla de la Juventud", nameESmx: "Isla de la Juventud" },
        ],
    },
    {
        name: "Haiti",
        nameESmx: "Haití",
        states: [
            { name: "Artibonite", nameESmx: "Artibonite" },
            { name: "Centre", nameESmx: "Centre" },
            { name: "Grand'Anse", nameESmx: "Grand'Anse" },
            { name: "Nippes", nameESmx: "Nippes" },
            { name: "Nord", nameESmx: "Nord" },
            { name: "Nord-Est", nameESmx: "Nord-Est" },
            { name: "Nord-Ouest", nameESmx: "Nord-Ouest" },
            { name: "Ouest", nameESmx: "Ouest" },
            { name: "Sud", nameESmx: "Sud" },
            { name: "Sud-Est", nameESmx: "Sud-Est" },
        ],
    },
    {
        name: "Dominican Republic",
        nameESmx: "República Dominicana",
        states: [
            { name: "Azua", nameESmx: "Azua" },
            { name: "Baoruco", nameESmx: "Baoruco" },
            { name: "Barahona", nameESmx: "Barahona" },
            { name: "Dajabón", nameESmx: "Dajabón" },
            { name: "Distrito Nacional", nameESmx: "Distrito Nacional" },
            { name: "Duarte", nameESmx: "Duarte" },
            { name: "El Seibo", nameESmx: "El Seibo" },
            { name: "Elías Piña", nameESmx: "Elías Piña" },
            { name: "Espaillat", nameESmx: "Espaillat" },
            { name: "Hato Mayor", nameESmx: "Hato Mayor" },
            { name: "Hermanas Mirabal", nameESmx: "Hermanas Mirabal" },
            { name: "Independencia", nameESmx: "Independencia" },
            { name: "La Altagracia", nameESmx: "La Altagracia" },
            { name: "La Romana", nameESmx: "La Romana" },
            { name: "La Vega", nameESmx: "La Vega" },
            {
                name: "María Trinidad Sánchez",
                nameESmx: "María Trinidad Sánchez",
            },
            { name: "Monseñor Nouel", nameESmx: "Monseñor Nouel" },
            { name: "Monte Cristi", nameESmx: "Monte Cristi" },
            { name: "Monte Plata", nameESmx: "Monte Plata" },
            { name: "Pedernales", nameESmx: "Pedernales" },
            { name: "Peravia", nameESmx: "Peravia" },
            { name: "Puerto Plata", nameESmx: "Puerto Plata" },
            { name: "Samaná", nameESmx: "Samaná" },
            { name: "San Cristóbal", nameESmx: "San Cristóbal" },
            { name: "San José de Ocoa", nameESmx: "San José de Ocoa" },
            { name: "San Juan", nameESmx: "San Juan" },
            { name: "San Pedro de Macorís", nameESmx: "San Pedro de Macorís" },
            { name: "Sánchez Ramírez", nameESmx: "Sánchez Ramírez" },
            { name: "Santiago", nameESmx: "Santiago" },
            { name: "Santiago Rodríguez", nameESmx: "Santiago Rodríguez" },
            { name: "Santo Domingo", nameESmx: "Santo Domingo" },
            { name: "Valverde", nameESmx: "Valverde" },
        ],
    },
    {
        name: "Jamaica",
        nameESmx: "Jamaica",
        states: [
            { name: "Clarendon", nameESmx: "Clarendon" },
            { name: "Hanover", nameESmx: "Hanover" },
            { name: "Kingston", nameESmx: "Kingston" },
            { name: "Manchester", nameESmx: "Manchester" },
            { name: "Portland", nameESmx: "Portland" },
            { name: "Saint Andrew", nameESmx: "Saint Andrew" },
            { name: "Saint Ann", nameESmx: "Saint Ann" },
            { name: "Saint Catherine", nameESmx: "Saint Catherine" },
            { name: "Saint Elizabeth", nameESmx: "Saint Elizabeth" },
            { name: "Saint James", nameESmx: "Saint James" },
            { name: "Saint Mary", nameESmx: "Saint Mary" },
            { name: "Saint Thomas", nameESmx: "Saint Thomas" },
            { name: "Trelawny", nameESmx: "Trelawny" },
            { name: "Westmoreland", nameESmx: "Westmoreland" },
        ],
    },
    {
        name: "Trinidad and Tobago",
        nameESmx: "Trinidad y Tobago",
        states: [
            { name: "Arima", nameESmx: "Arima" },
            { name: "Chaguanas", nameESmx: "Chaguanas" },
            {
                name: "Couva-Tabaquite-Talparo",
                nameESmx: "Couva-Tabaquite-Talparo",
            },
            { name: "Diego Martin", nameESmx: "Diego Martin" },
            { name: "Mayaro-Rio Claro", nameESmx: "Mayaro-Rio Claro" },
            { name: "Penal-Debe", nameESmx: "Penal-Debe" },
            { name: "Point Fortin", nameESmx: "Point Fortin" },
            { name: "Port of Spain", nameESmx: "Port of Spain" },
            { name: "Princes Town", nameESmx: "Princes Town" },
            { name: "San Fernando", nameESmx: "San Fernando" },
            { name: "San Juan-Laventille", nameESmx: "San Juan-Laventille" },
            { name: "Sangre Grande", nameESmx: "Sangre Grande" },
            { name: "Siparia", nameESmx: "Siparia" },
            { name: "Tobago", nameESmx: "Tobago" },
            { name: "Tunapuna-Piarco", nameESmx: "Tunapuna-Piarco" },
        ],
    },
    {
        name: "Bahamas",
        nameESmx: "Bahamas",
        states: [
            { name: "Acklins", nameESmx: "Acklins" },
            { name: "Berry Islands", nameESmx: "Berry Islands" },
            { name: "Bimini", nameESmx: "Bimini" },
            { name: "Black Point", nameESmx: "Black Point" },
            { name: "Cat Island", nameESmx: "Cat Island" },
            { name: "Central Abaco", nameESmx: "Central Abaco" },
            { name: "Central Andros", nameESmx: "Central Andros" },
            { name: "Central Eleuthera", nameESmx: "Central Eleuthera" },
            { name: "City of Freeport", nameESmx: "City of Freeport" },
            { name: "Crooked Island", nameESmx: "Crooked Island" },
            { name: "East Grand Bahama", nameESmx: "East Grand Bahama" },
            { name: "Exuma", nameESmx: "Exuma" },
            { name: "Grand Cay", nameESmx: "Grand Cay" },
            { name: "Harbour Island", nameESmx: "Harbour Island" },
            { name: "Hope Town", nameESmx: "Hope Town" },
            { name: "Inagua", nameESmx: "Inagua" },
            { name: "Long Island", nameESmx: "Long Island" },
            { name: "Mangrove Cay", nameESmx: "Mangrove Cay" },
            { name: "Mayaguana", nameESmx: "Mayaguana" },
            { name: "Moore's Island", nameESmx: "Moore's Island" },
            { name: "North Abaco", nameESmx: "North Abaco" },
            { name: "North Andros", nameESmx: "North Andros" },
            { name: "North Eleuthera", nameESmx: "North Eleuthera" },
            { name: "Ragged Island", nameESmx: "Ragged Island" },
            { name: "Rum Cay", nameESmx: "Rum Cay" },
            { name: "San Salvador", nameESmx: "San Salvador" },
            { name: "South Abaco", nameESmx: "South Abaco" },
            { name: "South Andros", nameESmx: "South Andros" },
            { name: "South Eleuthera", nameESmx: "South Eleuthera" },
            { name: "Spanish Wells", nameESmx: "Spanish Wells" },
            { name: "West Grand Bahama", nameESmx: "West Grand Bahama" },
        ],
    },
    {
        name: "Barbados",
        nameESmx: "Barbados",
        states: [
            { name: "Christ Church", nameESmx: "Christ Church" },
            { name: "Saint Andrew", nameESmx: "Saint Andrew" },
            { name: "Saint George", nameESmx: "Saint George" },
            { name: "Saint James", nameESmx: "Saint James" },
            { name: "Saint John", nameESmx: "Saint John" },
            { name: "Saint Joseph", nameESmx: "Saint Joseph" },
            { name: "Saint Lucy", nameESmx: "Saint Lucy" },
            { name: "Saint Michael", nameESmx: "Saint Michael" },
            { name: "Saint Peter", nameESmx: "Saint Peter" },
            { name: "Saint Philip", nameESmx: "Saint Philip" },
            { name: "Saint Thomas", nameESmx: "Saint Thomas" },
        ],
    },
    {
        name: "Saint Lucia",
        nameESmx: "Santa Lucía",
        states: [
            { name: "Anse la Raye", nameESmx: "Anse la Raye" },
            { name: "Canaries", nameESmx: "Canaries" },
            { name: "Castries", nameESmx: "Castries" },
            { name: "Choiseul", nameESmx: "Choiseul" },
            { name: "Dennery", nameESmx: "Dennery" },
            { name: "Gros Islet", nameESmx: "Gros Islet" },
            { name: "Laborie", nameESmx: "Laborie" },
            { name: "Micoud", nameESmx: "Micoud" },
            { name: "Soufrière", nameESmx: "Soufrière" },
            { name: "Vieux Fort", nameESmx: "Vieux Fort" },
        ],
    },
    {
        name: "Grenada",
        nameESmx: "Granada",
        states: [
            {
                name: "Carriacou and Petite Martinique",
                nameESmx: "Carriacou y Petite Martinique",
            },
            { name: "Saint Andrew", nameESmx: "Saint Andrew" },
            { name: "Saint David", nameESmx: "Saint David" },
            { name: "Saint George", nameESmx: "Saint George" },
            { name: "Saint John", nameESmx: "Saint John" },
            { name: "Saint Mark", nameESmx: "Saint Mark" },
            { name: "Saint Patrick", nameESmx: "Saint Patrick" },
        ],
    },
    {
        name: "Saint Vincent and the Grenadines",
        nameESmx: "San Vicente y las Granadinas",
        states: [
            { name: "Charlotte", nameESmx: "Charlotte" },
            { name: "Grenadines", nameESmx: "Granadinas" },
            { name: "Saint Andrew", nameESmx: "Saint Andrew" },
            { name: "Saint David", nameESmx: "Saint David" },
            { name: "Saint George", nameESmx: "Saint George" },
            { name: "Saint Patrick", nameESmx: "Saint Patrick" },
        ],
    },
    {
        name: "Antigua and Barbuda",
        nameESmx: "Antigua y Barbuda",
        states: [
            { name: "Barbuda", nameESmx: "Barbuda" },
            { name: "Redonda", nameESmx: "Redonda" },
            { name: "Saint George", nameESmx: "Saint George" },
            { name: "Saint John", nameESmx: "Saint John" },
            { name: "Saint Mary", nameESmx: "Saint Mary" },
            { name: "Saint Paul", nameESmx: "Saint Paul" },
            { name: "Saint Peter", nameESmx: "Saint Peter" },
            { name: "Saint Philip", nameESmx: "Saint Philip" },
        ],
    },
    {
        name: "Dominica",
        nameESmx: "Dominica",
        states: [
            { name: "Saint Andrew", nameESmx: "Saint Andrew" },
            { name: "Saint David", nameESmx: "Saint David" },
            { name: "Saint George", nameESmx: "Saint George" },
            { name: "Saint John", nameESmx: "Saint John" },
            { name: "Saint Joseph", nameESmx: "Saint Joseph" },
            { name: "Saint Luke", nameESmx: "Saint Luke" },
            { name: "Saint Mark", nameESmx: "Saint Mark" },
            { name: "Saint Patrick", nameESmx: "Saint Patrick" },
            { name: "Saint Paul", nameESmx: "Saint Paul" },
            { name: "Saint Peter", nameESmx: "Saint Peter" },
        ],
    },
    {
        name: "Saint Kitts and Nevis",
        nameESmx: "San Cristóbal y Nieves",
        states: [
            {
                name: "Christ Church Nichola Town",
                nameESmx: "Christ Church Nichola Town",
            },
            {
                name: "Saint Anne Sandy Point",
                nameESmx: "Saint Anne Sandy Point",
            },
            {
                name: "Saint George Basseterre",
                nameESmx: "Saint George Basseterre",
            },
            {
                name: "Saint George Gingerland",
                nameESmx: "Saint George Gingerland",
            },
            { name: "Saint James Windward", nameESmx: "Saint James Windward" },
            {
                name: "Saint John Capisterre",
                nameESmx: "Saint John Capisterre",
            },
            { name: "Saint John Figtree", nameESmx: "Saint John Figtree" },
            { name: "Saint Mary Cayon", nameESmx: "Saint Mary Cayon" },
            {
                name: "Saint Paul Capisterre",
                nameESmx: "Saint Paul Capisterre",
            },
            {
                name: "Saint Paul Charlestown",
                nameESmx: "Saint Paul Charlestown",
            },
            {
                name: "Saint Peter Basseterre",
                nameESmx: "Saint Peter Basseterre",
            },
            { name: "Saint Thomas Lowland", nameESmx: "Saint Thomas Lowland" },
            {
                name: "Saint Thomas Middle Island",
                nameESmx: "Saint Thomas Middle Island",
            },
            {
                name: "Trinity Palmetto Point",
                nameESmx: "Trinity Palmetto Point",
            },
        ],
    },
    {
        name: "Spain",
        nameESmx: "España",
        states: [
            { name: "Álava", nameESmx: "Álava" },
            { name: "Albacete", nameESmx: "Albacete" },
            { name: "Alicante", nameESmx: "Alicante" },
            { name: "Almería", nameESmx: "Almería" },
            { name: "Asturias", nameESmx: "Asturias" },
            { name: "Ávila", nameESmx: "Ávila" },
            { name: "Badajoz", nameESmx: "Badajoz" },
            { name: "Baleares", nameESmx: "Baleares" },
            { name: "Barcelona", nameESmx: "Barcelona" },
            { name: "Burgos", nameESmx: "Burgos" },
            { name: "Cáceres", nameESmx: "Cáceres" },
            { name: "Cádiz", nameESmx: "Cádiz" },
            { name: "Cantabria", nameESmx: "Cantabria" },
            { name: "Castellón", nameESmx: "Castellón" },
            { name: "Ceuta", nameESmx: "Ceuta" },
            { name: "Ciudad Real", nameESmx: "Ciudad Real" },
            { name: "Córdoba", nameESmx: "Córdoba" },
            { name: "Cuenca", nameESmx: "Cuenca" },
            { name: "Gerona", nameESmx: "Gerona" },
            { name: "Granada", nameESmx: "Granada" },
            { name: "Guadalajara", nameESmx: "Guadalajara" },
            { name: "Guipúzcoa", nameESmx: "Guipúzcoa" },
            { name: "Huelva", nameESmx: "Huelva" },
            { name: "Huesca", nameESmx: "Huesca" },
            { name: "Jaén", nameESmx: "Jaén" },
            { name: "La Coruña", nameESmx: "La Coruña" },
            { name: "La Rioja", nameESmx: "La Rioja" },
            { name: "Las Palmas", nameESmx: "Las Palmas" },
            { name: "León", nameESmx: "León" },
            { name: "Lérida", nameESmx: "Lérida" },
            { name: "Lugo", nameESmx: "Lugo" },
            { name: "Madrid", nameESmx: "Madrid" },
            { name: "Málaga", nameESmx: "Málaga" },
            { name: "Melilla", nameESmx: "Melilla" },
            { name: "Murcia", nameESmx: "Murcia" },
            { name: "Navarra", nameESmx: "Navarra" },
            { name: "Orense", nameESmx: "Orense" },
            { name: "Palencia", nameESmx: "Palencia" },
            { name: "Pontevedra", nameESmx: "Pontevedra" },
            { name: "Salamanca", nameESmx: "Salamanca" },
            {
                name: "Santa Cruz de Tenerife",
                nameESmx: "Santa Cruz de Tenerife",
            },
            { name: "Segovia", nameESmx: "Segovia" },
            { name: "Sevilla", nameESmx: "Sevilla" },
            { name: "Soria", nameESmx: "Soria" },
            { name: "Tarragona", nameESmx: "Tarragona" },
            { name: "Teruel", nameESmx: "Teruel" },
            { name: "Toledo", nameESmx: "Toledo" },
            { name: "Valencia", nameESmx: "Valencia" },
            { name: "Valladolid", nameESmx: "Valladolid" },
            { name: "Vizcaya", nameESmx: "Vizcaya" },
            { name: "Zamora", nameESmx: "Zamora" },
            { name: "Zaragoza", nameESmx: "Zaragoza" },
        ],
    },
];

function getStateAndCountry(state = "", country = "", lang = "en") {
    const isSpanish = lang !== "en";
    if (!country && state) {
        for (const { name, nameESmx, states } of countries) {
            const foundState = states.find(
                ({ name, nameESmx }) => name === state || nameESmx === state
            );
            if (foundState) {
                return isSpanish ? foundState[`name${lang}`] : foundState.name;
            }
        }
        return state;
    }
    const foundCountry = country
        ? countries.find(
              ({ name, nameESmx }) => name === country || nameESmx === country
          )
        : null;
    const foundState = foundCountry
        ? foundCountry.states.find(
              ({ name, nameESmx }) => name === state || nameESmx === state
          )
        : null;
    const countryName = foundCountry
        ? isSpanish
            ? foundCountry[`name${lang}`]
            : foundCountry.name
        : country;
    const stateName = foundState
        ? isSpanish
            ? foundState[`name${lang}`]
            : foundState.name
        : state;
    if (stateName && !countryName) return stateName;
    if (!stateName && countryName) return countryName;
    let res =
        stateName && countryName
            ? [stateName, countryName].join(", ")
            : (state !== "" ? state + ", " : "") + country;
    return res == "null, null"
        ? lang != "en"
            ? lang == "pt"
                ? "Desconhecido"
                : "Desconocido"
            : "Unknown"
        : res;
}

async function initModalSteps(modalSelector, stepActionCallback) {
    const styles = `<style>.modal { display: none; position: fixed; z-index: 9999; left: 0; top: 0; width: 100%; height: 100%; overflow: auto; background-color: rgba(0, 0, 0, 0.4); animation: fadeIn 0.5s;overflow-x: hidden;overflow-y: auto; } .modal.show { display: flex; justify-content: center; align-items: center; } .modal .m-content { max-width: 600px; width: 100%; margin: 10% auto; background: #fff; padding: 20px; border-radius: 15px; } .modal .m-content h4 { font-size: 1.25rem; font-weight: bold; color: #000; text-align: center; margin: 0.75rem 0 1.5rem; } .modal .m-content .steps { display: flex; justify-content: space-around; align-items: center; margin-top: 1rem; } .modal .m-content .steps .step { width: 2.5rem; height: 2.5rem; border-radius: 50%; background: #8f8f8f; display: flex; justify-content: center; align-items: center; font-size: 1rem; font-weight: bold; color: #000; } .modal .m-content .steps .separe { width: 20%; height: 2px; background: #535353; margin: 0 -10rem; } .modal .m-content .steps .step.active, .modal .m-content .steps .step.ready { background: #ffc200; } .modal .m-content .tabs { padding: 1rem 4rem 1rem; } .modal .m-content .tabs .tab { display: none; } .modal .m-content .tabs .tab.active { display: flex; } .modal .m-content .tabs .tab .form-group { margin-bottom: 1.5rem; } .modal .m-content .tabs .tab .form-group label { font-size: 0.85rem; font-weight: bold; color: #000; margin-bottom: 0.5rem; } .modal .m-content .btns { display: flex; justify-content: center; align-items: center; } .modal .m-content .btns:not(:has(.d-none)) { justify-content: space-between; } .modal .m-content .btns .btn { display: flex; justify-content: center; align-items: center; gap: 0.5rem; }.modal .m-content .close-modal{background: #181818;color: #fff;border-radius: 50%;display: flex;justify-content: center;align-items: center;width: 2rem;height: 2rem;position: relative;left: 2rem;bottom: 2rem;float: right;transition: all 500ms ease-in-out;border: none;cursor: pointer;}.modal .m-content .close-modal:hover{background: #e20f0f;}.modal .m-content .loading {background: #00000050;top: 0;right: 0;bottom: 0;left: 0;position: absolute;z-index: 99;justify-content: center;align-items: center;display: none;animation: fadeIn 0.5s;}.modal .m-content .loading.show{display: flex;}@media (max-width: 768px) {.modal .m-content {width: 90%;}.modal .m-content .steps .separe {margin: 0;}.modal .m-content .tabs {padding: 2.5rem 0.5rem 1rem;}}</style>`;
    document.head.insertAdjacentHTML("beforeend", styles);
    const modal = document.querySelector(modalSelector);
    const steps = modal.querySelectorAll(".step");
    const tabs = modal.querySelectorAll(".tab");
    const btnNext = modal.querySelector(".next-step");
    const btnBack = modal.querySelector(".back-step");
    const btnReset = modal.querySelector(".reset-modal");
    const btnClose = modal.querySelector(".close-modal");

    let currentStep = 1;
    let interruptTabChange = false;

    if (btnNext) {
        btnNext.addEventListener("click", async function () {
            await handleStepChange();
        });
    }

    if (btnBack) {
        btnBack.addEventListener("click", async function () {
            modal
                .querySelectorAll(".error, [class*='-error']")
                .forEach((element) => {
                    element.innerHTML = "";
                    element.classList.remove("d-none");
                    element.classList.add("d-block");
                });
            if (currentStep > 1) {
                if (typeof stepActionCallback === "function") {
                    interruptTabChange = await stepActionCallback(
                        currentStep - 1,
                        () => {}
                    );
                    if (interruptTabChange) return;
                }
                currentStep--;
                await updateStep();
            }
        });
    }

    if (btnReset) {
        btnReset.addEventListener("click", async function () {
            resetModal();
        });
    }

    if (btnClose) {
        btnClose.addEventListener("click", async function () {
            resetModal();
            modal.classList.remove("show");
        });
    }

    async function handleStepChange() {
        modal
            .querySelectorAll(".error, [class*='-error']")
            .forEach((element) => {
                element.innerHTML = "";
                element.classList.remove("d-none");
                element.classList.add("d-block");
            });
        if (typeof stepActionCallback === "function") {
            interruptTabChange = await stepActionCallback(currentStep, () => {
                currentStep++; // Incrementa el paso actual
                updateStep(); // Actualiza el paso después de ejecutar la lógica del paso actual
            });
            if (interruptTabChange) return;
        } else {
            currentStep++; // Incrementa el paso actual
            updateStep(); // Actualiza el paso después de ejecutar la lógica del paso actual
        }
    }

    async function updateStep() {
        steps.forEach((step) => {
            step.classList.remove("active");
            step.classList.remove("ready");
        });

        tabs.forEach((tab) => {
            tab.classList.remove("active");
        });

        for (let i = 0; i < currentStep; i++) {
            steps[i].classList.add("ready");
        }

        steps[currentStep - 1].classList.add("active");
        modal.querySelector(`.tab-${currentStep}`).classList.add("active");

        if (currentStep === 1) {
            if (btnBack) {
                btnBack.classList.add("d-none");
            }
        } else {
            if (btnBack) {
                btnBack.classList.remove("d-none");
            }
        }

        if (currentStep !== 1 && currentStep !== steps.length) {
            if (btnNext) {
                btnNext.classList.remove("d-none");
            }
            if (btnBack) {
                btnBack.classList.remove("d-none");
            }
        }

        if (currentStep === steps.length) {
            if (btnNext) {
                btnNext.classList.add("d-none");
            }
            if (btnBack) {
                btnBack.classList.add("d-none");
            }
        } else {
            if (btnNext) {
                btnNext.classList.remove("d-none");
            }
        }
    }

    async function resetModal() {
        currentStep = 1;
        interruptTabChange = false;
        if (steps.length > 0) {
            await updateStep();
        }

        modal.querySelectorAll("input, select, textarea").forEach((element) => {
            element.value = "";
        });

        modal.querySelectorAll("input[type=checkbox]").forEach((element) => {
            element.checked = false;
        });

        modal.querySelectorAll("input[type=radio]").forEach((element) => {
            element.checked = false;
        });

        modal
            .querySelectorAll(".error, [class*='-error']")
            .forEach((element) => {
                element.innerHTML = "";
                element.classList.remove("d-none");
                element.classList.add("d-block");
            });
    }

    // Método para reiniciar el modal desde fuera
    modal.resetModal = resetModal;

    // show loading y hidden loading
    modal.showLoading = function () {
        modal.querySelector(".loading").classList.add("show");
    };

    modal.hiddenLoading = function () {
        modal.querySelector(".loading").classList.remove("show");
    };

    // Inicializar el primer paso
    if (steps.length > 0) {
        await updateStep();
    }
}

var Shareon = (function (r) {
    "use strict";
    const o = {
            bluesky: (t) => {
                const url = t.url.includes("?")
                    ? `${t.url}&utm_source=bluesky`
                    : `${t.url}?utm_source=bluesky`;
                return `https://bsky.app/intent/compose?text=${
                    t.text || t.title
                }%0A%0A${url}`;
            },
            facebook: (t) => {
                const url = t.url.includes("?")
                    ? `${t.url}&utm_source=facebook`
                    : `${t.url}?utm_source=facebook`;
                return `https://www.facebook.com/sharer/sharer.php?u=${url}${
                    t.hashtags
                        ? `&hashtag=%23${t.hashtags.split("%2C")[0]}`
                        : ""
                }`;
            },
            fediverse: (t) => {
                const url = t.url.includes("?")
                    ? `${t.url}&utm_source=fediverse`
                    : `${t.url}?utm_source=fediverse`;
                return `https://${t.s2fInstance}/?text=${t.title}%0D%0A${url}${
                    t.text ? `%0D%0A%0D%0A${t.text}` : ""
                }${t.via ? `%0D%0A%0D%0A${t.via}` : ""}`;
            },
            email: (t) => {
                const url = t.url.includes("?")
                    ? `${t.url}&utm_source=email`
                    : `${t.url}?utm_source=email`;
                return `mailto:?subject=${t.title}&body=${url}`;
            },
            hackernews: (t) => {
                const url = t.url.includes("?")
                    ? `${t.url}&utm_source=hackernews`
                    : `${t.url}?utm_source=hackernews`;
                return `https://news.ycombinator.com/submitlink?u=${url}&t=${t.title}`;
            },
            linkedin: (t) => {
                const url = t.url.includes("?")
                    ? `${t.url}&utm_source=linkedin`
                    : `${t.url}?utm_source=linkedin`;
                return `https://www.linkedin.com/sharing/share-offsite/?url=${url}`;
            },
            mastodon: (t) => {
                const url = t.url.includes("?")
                    ? `${t.url}&utm_source=mastodon`
                    : `${t.url}?utm_source=mastodon`;
                return `https://toot.kytta.dev/?text=${t.title}%0D%0A${url}${
                    t.text ? `%0D%0A%0D%0A${t.text}` : ""
                }${t.via ? `%0D%0A%0D%0A${t.via}` : ""}`;
            },
            messenger: (t) => {
                const url = t.url.includes("?")
                    ? `${t.url}&utm_source=messenger`
                    : `${t.url}?utm_source=messenger`;
                return `https://www.facebook.com/dialog/send?app_id=${t.fbAppId}&link=${url}&redirect_uri=${url}`;
            },
            odnoklassniki: (t) => {
                const url = t.url.includes("?")
                    ? `${t.url}&utm_source=odnoklassniki`
                    : `${t.url}?utm_source=odnoklassniki`;
                return `https://connect.ok.ru/offer?url=${url}&title=${
                    t.title
                }${t.media ? `&imageUrl=${t.media}` : ""}`;
            },
            pinterest: (t) => {
                const url = t.url.includes("?")
                    ? `${t.url}&utm_source=pinterest`
                    : `${t.url}?utm_source=pinterest`;
                return `https://pinterest.com/pin/create/button/?url=${url}&description=${
                    t.title
                }${t.media ? `&media=${t.media}` : ""}`;
            },
            pocket: (t) => {
                const url = t.url.includes("?")
                    ? `${t.url}&utm_source=pocket`
                    : `${t.url}?utm_source=pocket`;
                return `https://getpocket.com/edit.php?url=${url}`;
            },
            reddit: (t) => {
                const url = t.url.includes("?")
                    ? `${t.url}&utm_source=reddit`
                    : `${t.url}?utm_source=reddit`;
                return `https://www.reddit.com/submit?title=${t.title}&url=${url}`;
            },
            teams: (t) => {
                const url = t.url.includes("?")
                    ? `${t.url}&utm_source=teams`
                    : `${t.url}?utm_source=teams`;
                return `https://teams.microsoft.com/share?href=${url}${
                    t.text ? `&msgText=${t.text}` : ""
                }`;
            },
            telegram: (t) => {
                const url = t.url.includes("?")
                    ? `${t.url}&utm_source=telegram`
                    : `${t.url}?utm_source=telegram`;
                return `https://telegram.me/share/url?url=${url}${
                    t.text ? `&text=${t.text}` : ""
                }`;
            },
            tumblr: (t) => {
                const url = t.url.includes("?")
                    ? `${t.url}&utm_source=tumblr`
                    : `${t.url}?utm_source=tumblr`;
                return `https://www.tumblr.com/widgets/share/tool?posttype=link${
                    t.hashtags ? `&tags=${t.hashtags}` : ""
                }&title=${t.title}&content=${url}&canonicalUrl=${url}${
                    t.text ? `&caption=${t.text}` : ""
                }${t.via ? `&show-via=${t.via}` : ""}`;
            },
            twitter: (t) => {
                const url = t.url.includes("?")
                    ? `${t.url}&utm_source=x`
                    : `${t.url}?utm_source=x`;
                return `https://x.com/intent/tweet?url=${url}&text=${t.title}${
                    t.via ? `&via=${t.via}` : ""
                }${t.hashtags ? `&hashtags=${t.hashtags}` : ""}`;
            },
            viber: (t) => {
                const url = t.url.includes("?")
                    ? `${t.url}&utm_source=viber`
                    : `${t.url}?utm_source=viber`;
                return `viber://forward?text=${t.title}%0D%0A${url}${
                    t.text ? `%0D%0A%0D%0A${t.text}` : ""
                }`;
            },
            vkontakte: (t) => {
                const url = t.url.includes("?")
                    ? `${t.url}&utm_source=vkontakte`
                    : `${t.url}?utm_source=vkontakte`;
                return `https://vk.com/share.php?url=${url}&title=${t.title}${
                    t.media ? `&image=${t.media}` : ""
                }`;
            },
            whatsapp: (t) => {
                const url = t.url.includes("?")
                    ? `${t.url}&utm_source=whatsapp`
                    : `${t.url}?utm_source=whatsapp`;
                return `https://wa.me/?text=${t.title}%0D%0A${url}${
                    t.text ? `%0D%0A%0D%0A${t.text}` : ""
                }`;
            },
        },
        p = (t) => () => {
            window.open(t, "_blank", "noopener,noreferrer");
        },
        l = () => {
            const t = document.querySelectorAll(".shareon");
            for (const a of t)
                for (const e of a.children)
                    if (e) {
                        const u = e.classList.length;
                        for (let n = 0; n < u; n += 1) {
                            const i = e.classList.item(n);
                            if (
                                (i === "copy-url" &&
                                    e.addEventListener("click", () => {
                                        const s =
                                            e.dataset.url ||
                                            a.dataset.url ||
                                            window.location.href;
                                        navigator.clipboard.writeText(s),
                                            e.classList.add("done"),
                                            setTimeout(() => {
                                                e.classList.remove("done");
                                            }, 1e3);
                                    }),
                                i === "print" &&
                                    e.addEventListener("click", () => {
                                        window.print();
                                    }),
                                i === "web-share")
                            ) {
                                const s = {
                                    title:
                                        e.dataset.title ||
                                        a.dataset.title ||
                                        document.title,
                                    text:
                                        e.dataset.text || a.dataset.text || "",
                                    url:
                                        e.dataset.url ||
                                        a.dataset.url ||
                                        window.location.href,
                                };
                                navigator.canShare && navigator.canShare(s)
                                    ? e.addEventListener("click", () => {
                                          navigator.share(s);
                                      })
                                    : (e.style.display = "none");
                            }
                            if (Object.prototype.hasOwnProperty.call(o, i)) {
                                const s = {
                                        url: encodeURIComponent(
                                            e.dataset.url ||
                                                a.dataset.url ||
                                                window.location.href
                                        ),
                                        title: encodeURIComponent(
                                            e.dataset.title ||
                                                a.dataset.title ||
                                                document.title
                                        ),
                                        media: encodeURIComponent(
                                            e.dataset.media ||
                                                a.dataset.media ||
                                                ""
                                        ),
                                        text: encodeURIComponent(
                                            e.dataset.text ||
                                                a.dataset.text ||
                                                ""
                                        ),
                                        via: encodeURIComponent(
                                            e.dataset.via || a.dataset.via || ""
                                        ),
                                        hashtags: encodeURIComponent(
                                            e.dataset.hashtags ||
                                                a.dataset.hashtags ||
                                                ""
                                        ),
                                        fbAppId: encodeURIComponent(
                                            e.dataset.fbAppId ||
                                                a.dataset.fbAppId ||
                                                ""
                                        ),
                                        s2fInstance: encodeURIComponent(
                                            e.dataset.s2fInstance ||
                                                a.dataset.s2fInstance ||
                                                "s2f.kytta.dev"
                                        ),
                                    },
                                    h = o[i](s);
                                e.tagName.toLowerCase() === "a"
                                    ? (e.setAttribute("href", h),
                                      e.setAttribute(
                                          "rel",
                                          "noopener noreferrer"
                                      ),
                                      e.setAttribute("target", "_blank"))
                                    : e.addEventListener("click", p(h));
                                break;
                            }
                        }
                    }
        },
        c = document.currentScript;
    return (
        c && c.hasAttribute("init") && l(),
        (r.init = l),
        Object.defineProperty(r, Symbol.toStringTag, { value: "Module" }),
        r
    );
})({});

class SocialMediaSharedPopup {
    constructor(buttonSelector, language) {
        this.buttonSelector = buttonSelector;
        this.language = language;
        this.init();
    }

    init() {
        this.insertHTML();
        this.insertCSS();
        this.initializeEvent();

        // Verificar si la librería Shareon está disponible
        if (
            typeof Shareon !== "undefined" &&
            typeof Shareon.init === "function"
        ) {
            Shareon.init();
        } else {
            console.warn(
                "Shareon library is not loaded. Please include it before using this popup."
            );
        }
    }

    insertHTML() {
        const html = `
      <div class="overlay social-media-popup">
        <div class="popup">
          <header>
            <span>${
                this.language != "en"
                    ? this.language == "pt"
                        ? "Compartilhar"
                        : "Compartir"
                    : "Share"
            }</span>
            <div class="close"><i class="fas fa-times-circle"></i></div>
          </header>
          <div class="content">
            <p>${
                this.language != "en"
                    ? this.language == "pt"
                        ? "Compartilhar este link através de"
                        : "Compartir este enlace a través de"
                    : "Share this link via"
            }</p>
            <ul class="icons shareon">
              <a class="facebook"></a>
              <a class="linkedin"></a>
              <a class="reddit"></a>
              <a class="telegram"></a>
              <a class="twitter"></a>
              <a class="vkontakte"></a>
              <a class="whatsapp"></a>
              <a class="email"></a>
            </ul>
            <p>${
                this.language != "en"
                    ? this.language == "pt"
                        ? "O copiar o enlace"
                        : "O copiar el enlace"
                    : "Or copy link"
            }</p>
            <div class="field">
              <i class="url-icon uil uil-link"></i>
              <input type="text" readonly value="${window.location.href}" />
              <button>${
                  this.language != "en"
                      ? this.language == "pt"
                          ? "Copiar"
                          : "Copiar"
                      : "Copy"
              }</button>
            </div>
          </div>
        </div>
      </div>`;
        document.body.insertAdjacentHTML("beforeend", html);
    }

    insertCSS() {
        const css = `
      .social-media-popup * { margin: 0; padding: 0; box-sizing: border-box;}
      .social-media-popup.overlay { position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.5); display: flex; justify-content: center; align-items: center; z-index: 9999; visibility: hidden; opacity: 0; transition: all 0.3s ease-in-out; }
      .social-media-popup.overlay.show { visibility: visible; opacity: 1; }
      .social-media-popup .popup { background: rgb(255, 254, 254); padding: 25px; border-radius: 15px; max-width: 550px; width: 90%; box-shadow: 0px 10px 15px rgba(0,0,0,0.1); position: relative; }
      .social-media-popup .popup header { padding-bottom: 15px; border-bottom: 1px solid #ebedf9; }
      .social-media-popup .popup header span { font-size: 21px; font-weight: 600; }
      .social-media-popup .popup header .close { color: #252525FF; font-size: 17px; height: 33px; width: 33px; cursor: pointer; display: flex; align-items: center; border-radius: 50%; justify-content: center; transition: all 0.3s ease-in-out; }
      .social-media-popup .popup header .close:hover { color: #841111FF; }
      .social-media-popup .popup .content { margin: 20px 0; }
      .social-media-popup .popup .icons { display: flex; flex-wrap: wrap; gap: 10px; justify-content: center; margin-bottom: 15px; margin-top: 10px; }
      .social-media-popup .popup .icons a { height: 50px; width: 50px; font-size: 20px; text-decoration: none; border: 1px solid transparent; display: flex; align-items: center; justify-content: center; border-radius: 50%; transition: background 0.3s ease-in-out; }
      .social-media-popup .popup .field { margin: 12px 0 -5px 0; height: 45px; border-radius: 4px; padding: 0 5px; border: 1px solid #757171; display: flex; align-items: center; }
      .social-media-popup .popup .field input { width: 100%; height: 100%; border: none; outline: none; font-size: 15px; }
      .social-media-popup .popup .field button { color: #fff; padding: 5px 18px; background: #f0c900; border: none;cursor: pointer;}
      .social-media-popup .popup .field button:hover { background: #ffc200; }
      .shareon>:before {top: auto !important; left: auto !important;}
    `;

        const style = document.createElement("style");
        style.textContent = css;
        document.head.appendChild(style);
    }

    initializeEvent() {
        const button = document.querySelector(this.buttonSelector);
        const overlay = document.querySelector(".overlay");
        const popup = document.querySelector(".popup");
        const close = popup.querySelector(".close");
        const field = popup.querySelector(".field");
        const input = field.querySelector("input");
        const copy = field.querySelector("button");

        button.onclick = () => {
            // Reiniciar los enlaces de redes sociales y actualizar el input
            this.resetSocialMediaLinks();

            // Mostrar el popup
            overlay.classList.add("show");
        };

        close.onclick = () => overlay.classList.remove("show");

        overlay.onclick = (e) => {
            if (e.target === overlay) {
                overlay.classList.remove("show");
            }
        };

        copy.onclick = () => {
            input.select();
            if (document.execCommand("copy")) {
                field.classList.add("active");
                copy.innerText =
                    this.language != "en"
                        ? this.language == "pt"
                            ? "Copiado"
                            : "Copiado"
                        : "Copied";
                setTimeout(() => {
                    window.getSelection().removeAllRanges();
                    field.classList.remove("active");
                    copy.innerText =
                        this.language != "en"
                            ? this.language == "pt"
                                ? "Copiar"
                                : "Copiar"
                            : "Copy";
                }, 3000);
            }
        };
    }

    resetSocialMediaLinks() {
        const socialLinks = document.querySelectorAll(".shareon a");

        socialLinks.forEach((link) => {
            // Reiniciar los enlaces de redes sociales, por ejemplo, poniéndolos a una URL base o vacía
            link.setAttribute("href", "#");
            link.setAttribute("target", "_blank");
        });

        // Actualizar el input con el enlace correcto
        const input = document.querySelector(".popup .field input");
        input.value = window.location.href;

        // Si estás usando Shareon para generar los enlaces, puedes reiniciarlos aquí
        if (
            typeof Shareon !== "undefined" &&
            typeof Shareon.init === "function"
        ) {
            Shareon.init();
        }
    }
}

/*!
* CookieConsent 3.1.0
* https://github.com/orestbida/cookieconsent
* Author Orest Bida
* Released under the MIT License
*/
var e,t;e=this,t=function(e){'use strict';const t='opt-in',o='opt-out',n='show--consent',s='show--preferences',a='disable--interaction',c='data-category',r='div',i='button',l='aria-hidden',d='btn-group',f='click',_='data-role',u='consentModal',p='preferencesModal';class g{constructor(){this.t={mode:t,revision:0,autoShow:!0,lazyHtmlGeneration:!0,autoClearCookies:!0,manageScriptTags:!0,hideFromBots:!0,cookie:{name:'cc_cookie',expiresAfterDays:182,domain:'',path:'/',secure:!0,sameSite:'Lax'}},this.o={i:{},l:'',_:{},u:{},p:{},m:[],v:!1,h:null,C:null,S:null,M:'',T:!0,D:!1,k:!1,A:!1,N:!1,H:[],V:!1,j:!0,I:[],L:!1,F:'',P:!1,O:[],R:[],B:[],$:[],G:!1,J:!1,U:!1,q:[],K:[],W:[],X:{},Y:{},Z:{},ee:{},te:{},oe:[]},this.ne={se:{},ae:{}},this.ce={},this.re={ie:'cc:onFirstConsent',le:'cc:onConsent',de:'cc:onChange',fe:'cc:onModalShow',_e:'cc:onModalHide',ue:'cc:onModalReady'}}}const m=new g,b=(e,t)=>e.indexOf(t),v=(e,t)=>-1!==b(e,t),y=e=>Array.isArray(e),h=e=>'string'==typeof e,C=e=>!!e&&'object'==typeof e&&!y(e),w=e=>'function'==typeof e,S=e=>Object.keys(e),x=e=>Array.from(new Set(e)),M=()=>document.activeElement,T=e=>e.preventDefault(),D=(e,t)=>e.querySelectorAll(t),k=e=>e.dispatchEvent(new Event('change')),E=e=>{const t=document.createElement(e);return e===i&&(t.type=e),t},A=(e,t,o)=>e.setAttribute(t,o),N=(e,t,o)=>{e.removeAttribute(o?'data-'+t:t)},H=(e,t,o)=>e.getAttribute(o?'data-'+t:t),V=(e,t)=>e.appendChild(t),j=(e,t)=>e.classList.add(t),I=(e,t)=>j(e,'cm__'+t),L=(e,t)=>j(e,'pm__'+t),F=(e,t)=>e.classList.remove(t),P=e=>{if('object'!=typeof e)return e;if(e instanceof Date)return new Date(e.getTime());let t=Array.isArray(e)?[]:{};for(let o in e){let n=e[o];t[o]=P(n)}return t},O=()=>{const e={},{O:t,X:o,Y:n}=m.o;for(const s of t)e[s]=G(n[s],S(o[s]));return e},R=(e,t)=>dispatchEvent(new CustomEvent(e,{detail:t})),B=(e,t,o,n)=>{e.addEventListener(t,o),n&&m.o.m.push({pe:e,ge:t,me:o})},$=()=>{const e=m.t.cookie.expiresAfterDays;return w(e)?e(m.o.F):e},G=(e,t)=>{const o=e||[],n=t||[];return o.filter((e=>!v(n,e))).concat(n.filter((e=>!v(o,e))))},J=e=>{m.o.R=x(e),m.o.F=(()=>{let e='custom';const{R:t,O:o,B:n}=m.o,s=t.length;return s===o.length?e='all':s===n.length&&(e='necessary'),e})()},U=(e,t,o,n)=>{const s='accept-',{show:a,showPreferences:c,hide:r,hidePreferences:i,acceptCategory:l}=t,d=e||document,_=e=>D(d,`[data-cc="${e}"]`),u=(e,t)=>{T(e),l(t),i(),r()},p=_('show-preferencesModal'),g=_('show-consentModal'),b=_(s+'all'),v=_(s+'necessary'),y=_(s+'custom'),h=m.t.lazyHtmlGeneration;for(const e of p)A(e,'aria-haspopup','dialog'),B(e,f,(e=>{T(e),c()})),h&&(B(e,'mouseenter',(e=>{T(e),m.o.N||o(t,n)}),!0),B(e,'focus',(()=>{m.o.N||o(t,n)})));for(let e of g)A(e,'aria-haspopup','dialog'),B(e,f,(e=>{T(e),a(!0)}),!0);for(let e of b)B(e,f,(e=>{u(e,'all')}),!0);for(let e of y)B(e,f,(e=>{u(e)}),!0);for(let e of v)B(e,f,(e=>{u(e,[])}),!0)},z=(e,t)=>{e&&(t&&(e.tabIndex=-1),e.focus(),t&&e.removeAttribute('tabindex'))},q=(e,t)=>{const o=n=>{n.target.removeEventListener('transitionend',o),'opacity'===n.propertyName&&'1'===getComputedStyle(e).opacity&&z((e=>1===e?m.ne.be:m.ne.ve)(t))};B(e,'transitionend',o)};let K;const Q=e=>{clearTimeout(K),e?j(m.ne.ye,a):K=setTimeout((()=>{F(m.ne.ye,a)}),500)},W=['M 19.5 4.5 L 4.5 19.5 M 4.5 4.501 L 19.5 19.5','M 3.572 13.406 L 8.281 18.115 L 20.428 5.885','M 21.999 6.94 L 11.639 17.18 L 2.001 6.82 '],X=(e=0,t=1.5)=>`<svg viewBox="0 0 24 24" stroke-width="${t}"><path d="${W[e]}"/></svg>`,Y=e=>{const t=m.ne,o=m.o;(e=>{const n=e===t.he,s=o.i.disablePageInteraction?t.ye:n?t.Ce:t.ye;B(s,'keydown',(t=>{if('Tab'!==t.key||!(n?o.k&&!o.A:o.A))return;const s=M(),a=n?o.q:o.K;0!==a.length&&(t.shiftKey?s!==a[0]&&e.contains(s)||(T(t),z(a[1])):s!==a[1]&&e.contains(s)||(T(t),z(a[0])))}),!0)})(e)},Z=['[href]',i,'input','details','[tabindex]'].map((e=>e+':not([tabindex="-1"])')).join(','),ee=e=>{const{o:t,ne:o}=m,n=(e,t)=>{const o=D(e,Z);t[0]=o[0],t[1]=o[o.length-1]};1===e&&t.D&&n(o.he,t.q),2===e&&t.N&&n(o.we,t.K)},te=(e,t,o)=>{const{de:n,le:s,ie:a,_e:c,ue:r,fe:i}=m.ce,l=m.re;if(t){const n={modalName:t};return e===l.fe?w(i)&&i(n):e===l._e?w(c)&&c(n):(n.modal=o,w(r)&&r(n)),R(e,n)}const d={cookie:m.o.p};e===l.ie?w(a)&&a(P(d)):e===l.le?w(s)&&s(P(d)):(d.changedCategories=m.o.I,d.changedServices=m.o.ee,w(n)&&n(P(d))),R(e,P(d))},oe=(e,t)=>{try{return e()}catch(e){return!t&&console.warn('CookieConsent:',e),!1}},ne=e=>{const{Y:t,ee:o,O:n,X:s,oe:a,p:r,I:i}=m.o;for(const e of n){const n=o[e]||t[e]||[];for(const o of n){const n=s[e][o];if(!n)continue;const{onAccept:a,onReject:c}=n;!n.Se&&v(t[e],o)?(n.Se=!0,w(a)&&a()):n.Se&&!v(t[e],o)&&(n.Se=!1,w(c)&&c())}}if(!m.t.manageScriptTags)return;const l=a,d=e||r.categories||[],f=(e,n)=>{if(n>=e.length)return;const s=a[n];if(s.xe)return f(e,n+1);const r=s.Me,l=s.Te,_=s.De,u=v(d,l),p=!!_&&v(t[l],_);if(!_&&!s.ke&&u||!_&&s.ke&&!u&&v(i,l)||_&&!s.ke&&p||_&&s.ke&&!p&&v(o[l]||[],_)){s.xe=!0;const t=H(r,'type',!0);N(r,'type',!!t),N(r,c);let o=H(r,'src',!0);o&&N(r,'src',!0);const a=E('script');a.textContent=r.innerHTML;for(const{nodeName:e}of r.attributes)A(a,e,r[e]||H(r,e));t&&(a.type=t),o?a.src=o:o=r.src;const i=!!o&&(!t||['text/javascript','module'].includes(t));if(i&&(a.onload=a.onerror=()=>{f(e,++n)}),r.replaceWith(a),i)return}f(e,++n)};f(l,0)},se='bottom',ae='left',ce='center',re='right',ie='inline',le='wide',de='pm--',fe=['middle','top',se],_e=[ae,ce,re],ue={box:{Ee:[le,ie],Ae:fe,Ne:_e,He:se,Ve:re},cloud:{Ee:[ie],Ae:fe,Ne:_e,He:se,Ve:ce},bar:{Ee:[ie],Ae:fe.slice(1),Ne:[],He:se,Ve:''}},pe={box:{Ee:[],Ae:[],Ne:[],He:'',Ve:''},bar:{Ee:[le],Ae:[],Ne:[ae,re],He:'',Ve:ae}},ge=e=>{const t=m.o.i.guiOptions,o=t&&t.consentModal,n=t&&t.preferencesModal;0===e&&me(m.ne.he,ue,o,'cm--','box','cm'),1===e&&me(m.ne.we,pe,n,de,'box','pm')},me=(e,t,o,n,s,a)=>{e.className=a;const c=o&&o.layout,r=o&&o.position,i=o&&o.flipButtons,l=!o||!1!==o.equalWeightButtons,d=c&&c.split(' ')||[],f=d[0],_=d[1],u=f in t?f:s,p=t[u],g=v(p.Ee,_)&&_,b=r&&r.split(' ')||[],y=b[0],h=n===de?b[0]:b[1],C=v(p.Ae,y)?y:p.He,w=v(p.Ne,h)?h:p.Ve,S=t=>{t&&j(e,n+t)};S(u),S(g),S(C),S(w),i&&S('flip');const x=a+'__btn--secondary';if('cm'===a){const{je:e,Ie:t}=m.ne;e&&(l?F(e,x):j(e,x)),t&&(l?F(t,x):j(t,x))}else{const{Le:e}=m.ne;e&&(l?F(e,x):j(e,x))}},be=(e,t)=>{const o=m.o,n=m.ne,{hide:s,hidePreferences:a,acceptCategory:c}=e,u=e=>{c(e),a(),s()},g=o.u&&o.u.preferencesModal;if(!g)return;const b=g.title,v=g.closeIconLabel,y=g.acceptAllBtn,w=g.acceptNecessaryBtn,x=g.savePreferencesBtn,M=g.sections||[],T=y||w||x;if(n.Fe)n.Pe=E(r),L(n.Pe,'body');else{n.Fe=E(r),j(n.Fe,'pm-wrapper');const e=E('div');j(e,'pm-overlay'),V(n.Fe,e),B(e,f,a),n.we=E(r),j(n.we,'pm'),A(n.we,'role','dialog'),A(n.we,l,!0),A(n.we,'aria-modal',!0),A(n.we,'aria-labelledby','pm__title'),B(n.ye,'keydown',(e=>{27===e.keyCode&&a()}),!0),n.Oe=E(r),L(n.Oe,'header'),n.Re=E('h2'),L(n.Re,'title'),n.Re.id='pm__title',n.Be=E(i),L(n.Be,'close-btn'),A(n.Be,'aria-label',g.closeIconLabel||''),B(n.Be,f,a),n.$e=E('span'),n.$e.innerHTML=X(),V(n.Be,n.$e),n.Ge=E(r),L(n.Ge,'body'),n.Je=E(r),L(n.Je,'footer');var D=E(r);j(D,'btns');var k=E(r),N=E(r);L(k,d),L(N,d),V(n.Je,k),V(n.Je,N),V(n.Oe,n.Re),V(n.Oe,n.Be),n.ve=E(r),A(n.ve,'tabIndex',-1),V(n.we,n.ve),V(n.we,n.Oe),V(n.we,n.Ge),T&&V(n.we,n.Je),V(n.Fe,n.we)}let H;b&&(n.Re.innerHTML=b,v&&A(n.Be,'aria-label',v)),M.forEach(((e,t)=>{const s=e.title,a=e.description,c=e.linkedCategory,d=c&&o.P[c],_=e.cookieTable,u=_&&_.body,p=_&&_.caption,m=u&&u.length>0,b=!!d,v=b&&o.X[c],y=C(v)&&S(v)||[],w=b&&(!!a||!!m||S(v).length>0);var x=E(r);if(L(x,'section'),w||a){var M=E(r);L(M,'section-desc-wrapper')}let T=y.length;if(w&&T>0){const e=E(r);L(e,'section-services');for(const t of y){const o=v[t],n=o&&o.label||t,s=E(r),a=E(r),i=E(r),l=E(r);L(s,'service'),L(l,'service-title'),L(a,'service-header'),L(i,'service-icon');const f=ve(n,t,d,!0,c);l.innerHTML=n,V(a,i),V(a,l),V(s,a),V(s,f),V(e,s)}V(M,e)}if(s){var D=E(r),k=E(b?i:r);if(L(D,'section-title-wrapper'),L(k,'section-title'),k.innerHTML=s,V(D,k),b){const e=E('span');e.innerHTML=X(2,3.5),L(e,'section-arrow'),V(D,e),x.className+='--toggle';const t=ve(s,c,d);let o=g.serviceCounterLabel;if(T>0&&h(o)){let e=E('span');L(e,'badge'),L(e,'service-counter'),A(e,l,!0),A(e,'data-servicecounter',T),o&&(o=o.split('|'),o=o.length>1&&T>1?o[1]:o[0],A(e,'data-counterlabel',o)),e.innerHTML=T+(o?' '+o:''),V(k,e)}if(w){L(x,'section--expandable');var N=c+'-desc';A(k,'aria-expanded',!1),A(k,'aria-controls',N)}V(D,t)}else A(k,'role','heading'),A(k,'aria-level','3');V(x,D)}if(a){var I=E('p');L(I,'section-desc'),I.innerHTML=a,V(M,I)}if(w&&(A(M,l,'true'),M.id=N,((e,t,o)=>{B(k,f,(()=>{t.classList.contains('is-expanded')?(F(t,'is-expanded'),A(o,'aria-expanded','false'),A(e,l,'true')):(j(t,'is-expanded'),A(o,'aria-expanded','true'),A(e,l,'false'))}))})(M,x,k),m)){const e=E('table'),o=E('thead'),s=E('tbody');if(p){const t=E('caption');L(t,'table-caption'),t.innerHTML=p,e.appendChild(t)}L(e,'section-table'),L(o,'table-head'),L(s,'table-body');const a=_.headers,c=S(a),i=n.Ue.createDocumentFragment(),l=E('tr');for(const e of c){const o=a[e],n=E('th');n.id='cc__row-'+o+t,A(n,'scope','col'),L(n,'table-th'),n.innerHTML=o,V(i,n)}V(l,i),V(o,l);const d=n.Ue.createDocumentFragment();for(const e of u){const o=E('tr');L(o,'table-tr');for(const n of c){const s=a[n],c=e[n],i=E('td'),l=E(r);L(i,'table-td'),A(i,'data-column',s),A(i,'headers','cc__row-'+s+t),l.insertAdjacentHTML('beforeend',c),V(i,l),V(o,i)}V(d,o)}V(s,d),V(e,o),V(e,s),V(M,e)}(w||a)&&V(x,M);const P=n.Pe||n.Ge;b?(H||(H=E(r),L(H,'section-toggles')),H.appendChild(x)):H=null,V(P,H||x)})),y&&(n.ze||(n.ze=E(i),L(n.ze,'btn'),A(n.ze,_,'all'),V(k,n.ze),B(n.ze,f,(()=>u('all')))),n.ze.innerHTML=y),w&&(n.Le||(n.Le=E(i),L(n.Le,'btn'),A(n.Le,_,'necessary'),V(k,n.Le),B(n.Le,f,(()=>u([])))),n.Le.innerHTML=w),x&&(n.qe||(n.qe=E(i),L(n.qe,'btn'),L(n.qe,'btn--secondary'),A(n.qe,_,'save'),V(N,n.qe),B(n.qe,f,(()=>u()))),n.qe.innerHTML=x),n.Pe&&(n.we.replaceChild(n.Pe,n.Ge),n.Ge=n.Pe),ge(1),o.N||(o.N=!0,te(m.re.ue,p,n.we),t(e),V(n.Ce,n.Fe),Y(n.we),setTimeout((()=>j(n.Fe,'cc--anim')),100)),ee(2)};function ve(e,t,o,n,s){const a=m.o,r=m.ne,i=E('label'),d=E('input'),_=E('span'),u=E('span'),p=E('span'),g=E('span'),b=E('span');if(g.innerHTML=X(1,3),b.innerHTML=X(0,3),d.type='checkbox',j(i,'section__toggle-wrapper'),j(d,'section__toggle'),j(g,'toggle__icon-on'),j(b,'toggle__icon-off'),j(_,'toggle__icon'),j(u,'toggle__icon-circle'),j(p,'toggle__label'),A(_,l,'true'),n?(j(i,'toggle-service'),A(d,c,s),r.ae[s][t]=d):r.se[t]=d,n?(e=>{B(d,'change',(()=>{const t=r.ae[e],o=r.se[e];a.Z[e]=[];for(let o in t){const n=t[o];n.checked&&a.Z[e].push(n.value)}o.checked=a.Z[e].length>0}))})(s):(e=>{B(d,f,(()=>{const t=r.ae[e],o=d.checked;a.Z[e]=[];for(let n in t)t[n].checked=o,o&&a.Z[e].push(n)}))})(t),d.value=t,p.textContent=e.replace(/<.*>.*<\/.*>/gm,''),V(u,b),V(u,g),V(_,u),a.T)(o.readOnly||o.enabled)&&(d.checked=!0);else if(n){const e=a.Y[s];d.checked=o.readOnly||v(e,t)}else v(a.R,t)&&(d.checked=!0);return o.readOnly&&(d.disabled=!0),V(i,d),V(i,_),V(i,p),i}const ye=()=>{const e=E('span');return m.ne.Ke||(m.ne.Ke=e),e},he=(e,t)=>{const o=m.o,n=m.ne,{hide:s,showPreferences:a,acceptCategory:c}=e,p=o.u&&o.u.consentModal;if(!p)return;const g=p.acceptAllBtn,b=p.acceptNecessaryBtn,v=p.showPreferencesBtn,y=p.closeIconLabel,h=p.footer,C=p.label,w=p.title,S=e=>{s(),c(e)};if(!n.Qe){n.Qe=E(r),n.he=E(r),n.We=E(r),n.Xe=E(r),n.Ye=E(r),j(n.Qe,'cm-wrapper'),j(n.he,'cm'),I(n.We,'body'),I(n.Xe,'texts'),I(n.Ye,'btns'),A(n.he,'role','dialog'),A(n.he,'aria-modal','true'),A(n.he,l,'false'),A(n.he,'aria-describedby','cm__desc'),C?A(n.he,'aria-label',C):w&&A(n.he,'aria-labelledby','cm__title');const e='box',t=o.i.guiOptions,s=t&&t.consentModal,a=(s&&s.layout||e).split(' ')[0]===e;w&&y&&a&&(n.Ie||(n.Ie=E(i),n.Ie.innerHTML=X(),I(n.Ie,'btn'),I(n.Ie,'btn--close'),B(n.Ie,f,(()=>{S([])})),V(n.We,n.Ie)),A(n.Ie,'aria-label',y)),V(n.We,n.Xe),(g||b||v)&&V(n.We,n.Ye),n.be=E(r),A(n.be,'tabIndex',-1),V(n.he,n.be),V(n.he,n.We),V(n.Qe,n.he)}w&&(n.Ze||(n.Ze=E('h2'),n.Ze.className=n.Ze.id='cm__title',V(n.Xe,n.Ze)),n.Ze.innerHTML=w);let x=p.description;if(x&&(o.V&&(x=x.replace('{{revisionMessage}}',o.j?'':p.revisionMessage||'')),n.et||(n.et=E('p'),n.et.className=n.et.id='cm__desc',V(n.Xe,n.et)),n.et.innerHTML=x),g&&(n.tt||(n.tt=E(i),V(n.tt,ye()),I(n.tt,'btn'),A(n.tt,_,'all'),B(n.tt,f,(()=>{S('all')}))),n.tt.firstElementChild.innerHTML=g),b&&(n.je||(n.je=E(i),V(n.je,ye()),I(n.je,'btn'),A(n.je,_,'necessary'),B(n.je,f,(()=>{S([])}))),n.je.firstElementChild.innerHTML=b),v&&(n.ot||(n.ot=E(i),V(n.ot,ye()),I(n.ot,'btn'),I(n.ot,'btn--secondary'),A(n.ot,_,'show'),B(n.ot,'mouseenter',(()=>{o.N||be(e,t)})),B(n.ot,f,a)),n.ot.firstElementChild.innerHTML=v),n.nt||(n.nt=E(r),I(n.nt,d),g&&V(n.nt,n.tt),b&&V(n.nt,n.je),(g||b)&&V(n.We,n.nt),V(n.Ye,n.nt)),n.ot&&!n.st&&(n.st=E(r),n.je&&n.tt?(I(n.st,d),V(n.st,n.ot),V(n.Ye,n.st)):(V(n.nt,n.ot),I(n.nt,d+'--uneven'))),h){if(!n.ct){let e=E(r),t=E(r);n.ct=E(r),I(e,'footer'),I(t,'links'),I(n.ct,'link-group'),V(t,n.ct),V(e,t),V(n.he,e)}n.ct.innerHTML=h}ge(0),o.D||(o.D=!0,te(m.re.ue,u,n.he),t(e),V(n.Ce,n.Qe),Y(n.he),setTimeout((()=>j(n.Qe,'cc--anim')),100)),ee(1),U(n.We,e,be,t)},Ce=e=>{if(!h(e))return null;if(e in m.o._)return e;let t=e.slice(0,2);return t in m.o._?t:null},we=()=>m.o.l||m.o.i.language.default,Se=e=>{e&&(m.o.l=e)},xe=async e=>{const t=m.o;let o=Ce(e)?e:we(),n=t._[o];if(h(n)?n=await(async e=>{try{const t=await fetch(e);return await t.json()}catch(e){return console.error(e),!1}})(n):w(n)&&(n=await n()),!n)throw`Could not load translation for the '${o}' language`;return t.u=n,Se(o),!0},Me=()=>{let e=m.o.i.language.rtl,t=m.ne.Ce;e&&t&&(y(e)||(e=[e]),v(e,m.o.l)?j(t,'cc--rtl'):F(t,'cc--rtl'))},Te=()=>{const e=m.ne;if(e.Ce)return;e.Ce=E(r),e.Ce.id='cc-main',e.Ce.setAttribute('data-nosnippet',''),Me();let t=m.o.i.root;t&&h(t)&&(t=document.querySelector(t)),(t||e.Ue.body).appendChild(e.Ce)},De=e=>oe((()=>localStorage.removeItem(e))),ke=(e,t)=>{if(t instanceof RegExp)return e.filter((e=>t.test(e)));{const o=b(e,t);return o>-1?[e[o]]:[]}},Ee=e=>{const{hostname:t,protocol:o}=location,{name:n,path:s,domain:a,sameSite:c,useLocalStorage:r,secure:i}=m.t.cookie,l=e?(()=>{const e=m.o.S,t=e?new Date-e:0;return 864e5*$()-t})():864e5*$(),d=new Date;d.setTime(d.getTime()+l),m.o.p.expirationTime=d.getTime();const f=JSON.stringify(m.o.p);let _=n+'='+encodeURIComponent(f)+(0!==l?'; expires='+d.toUTCString():'')+'; Path='+s+'; SameSite='+c;v(t,'.')&&(_+='; Domain='+a),i&&'https:'===o&&(_+='; Secure'),r?((e,t)=>{oe((()=>localStorage.setItem(e,t)))})(n,f):document.cookie=_,m.o.p},Ae=(e,t,o)=>{if(0===e.length)return;const n=o||m.t.cookie.domain,s=t||m.t.cookie.path,a='www.'===n.slice(0,4),c=a&&n.substring(4),r=(e,t)=>{t&&'.'!==t.slice(0,1)&&(t='.'+t),document.cookie=e+'=; path='+s+(t?'; domain='+t:'')+'; expires=Thu, 01 Jan 1970 00:00:01 GMT;'};for(const t of e)r(t,o),o||r(t,n),a&&r(t,c)},Ne=e=>{const t=e||m.t.cookie.name,o=m.t.cookie.useLocalStorage;return((e,t)=>{let o;return o=oe((()=>JSON.parse(t?e:decodeURIComponent(e))),!0)||{},o})(o?(n=t,oe((()=>localStorage.getItem(n)))||''):He(t,!0),o);var n},He=(e,t)=>{const o=document.cookie.match('(^|;)\\s*'+e+'\\s*=\\s*([^;]+)');return o?t?o.pop():e:''},Ve=e=>{const t=document.cookie.split(/;\s*/),o=[];for(const n of t){let t=n.split('=')[0];e?oe((()=>{e.test(t)&&o.push(t)})):o.push(t)}return o},je=(e,n=[])=>{((e,t)=>{const{O:o,R:n,B:s,N:a,Z:c,$:r,X:i}=m.o;let l=[];if(e){y(e)?l.push(...e):h(e)&&(l='all'===e?o:[e]);for(const e of o)c[e]=v(l,e)?S(i[e]):[]}else l=[...n,...r],a&&(l=(()=>{const e=m.ne.se;if(!e)return[];let t=[];for(let o in e)e[o].checked&&t.push(o);return t})());l=l.filter((e=>!v(o,e)||!v(t,e))),l.push(...s),J(l)})(e,n),(()=>{const e=m.o,{Z:t,B:o,Y:n,X:s,O:a}=e,c=a;e.te=P(n);for(const a of c){const c=s[a],r=S(c),i=t[a]&&t[a].length>0,l=v(o,a);if(0!==r.length){if(n[a]=[],l)n[a].push(...r);else if(i){const e=t[a];n[a].push(...e)}else n[a]=e.Z[a];n[a]=x(n[a])}}})(),(()=>{const e=m.o;e.I=m.t.mode===o&&e.T?G(e.$,e.R):G(e.R,e.p.categories);let n=e.I.length>0,s=!1;for(const t of e.O)e.ee[t]=G(e.Y[t],e.te[t]),e.ee[t].length>0&&(s=!0);const a=m.ne.se;for(const t in a)a[t].checked=v(e.R,t);for(const t of e.O){const o=m.ne.ae[t],n=e.Y[t];for(const e in o)o[e].checked=v(n,e)}e.C||(e.C=new Date),e.M||(e.M=([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g,(e=>(e^crypto.getRandomValues(new Uint8Array(1))[0]&15>>e/4).toString(16)))),e.p={categories:P(e.R),revision:m.t.revision,data:e.h,consentTimestamp:e.C.toISOString(),consentId:e.M,services:P(e.Y),languageCode:m.o.l},e.S&&(e.p.lastConsentTimestamp=e.S.toISOString());let c=!1;const r=n||s;(e.T||r)&&(e.T&&(e.T=!1,c=!0),e.S=e.S?new Date:e.C,e.p.lastConsentTimestamp=e.S.toISOString(),Ee(),m.t.autoClearCookies&&(c||r)&&(e=>{const t=m.o,o=Ve(),n=(e=>{const t=m.o;return(e?t.O:t.I).filter((e=>{const o=t.P[e];return!!o&&!o.readOnly&&!!o.autoClear}))})(e);for(const e in t.ee)for(const n of t.ee[e]){const s=t.X[e][n].cookies;if(!v(t.Y[e],n)&&s)for(const e of s){const t=ke(o,e.name);Ae(t,e.path,e.domain)}}for(const s of n){const n=t.P[s].autoClear,a=n&&n.cookies||[],c=v(t.I,s),r=!v(t.R,s),i=c&&r;if(e?r:i){n.reloadPage&&i&&(t.L=!0);for(const e of a){const t=ke(o,e.name);Ae(t,e.path,e.domain)}}}})(c),ne()),c&&(te(m.re.ie),te(m.re.le),m.t.mode===t)||(r&&te(m.re.de),e.L&&(e.L=!1,location.reload()))})()},Ie=e=>{const t=m.o.T?[]:m.o.R;return v(t,e)},Le=(e,t)=>{const o=m.o.T?[]:m.o.Y[t]||[];return v(o,e)},Fe=(e,t,o)=>{let n=[];const s=e=>{if(h(e)){let t=He(e);''!==t&&n.push(t)}else n.push(...Ve(e))};if(y(e))for(let t of e)s(t);else s(e);Ae(n,t,o)},Pe=e=>{const{ne:t,o:o}=m;if(!o.k){if(!o.D){if(!e)return;he($e,Te)}o.k=!0,o.J=M(),o.v&&Q(!0),q(t.he,1),j(t.ye,n),A(t.he,l,'false'),setTimeout((()=>{z(m.ne.be)}),100),te(m.re.fe,u)}},Oe=()=>{const{ne:e,o:t,re:o}=m;t.k&&(t.k=!1,t.v&&Q(),z(e.Ke,!0),F(e.ye,n),A(e.he,l,'true'),z(t.J),t.J=null,te(o._e,u))},Re=()=>{const e=m.o;e.A||(e.N||be($e,Te),e.A=!0,e.k?e.U=M():e.J=M(),q(m.ne.we,2),j(m.ne.ye,s),A(m.ne.we,l,'false'),setTimeout((()=>{z(m.ne.ve)}),100),te(m.re.fe,p))},Be=()=>{const e=m.o;e.A&&(e.A=!1,(()=>{const e=Je(),t=m.o.P,o=m.ne.se,n=m.ne.ae,s=e=>v(m.o.$,e);for(const a in o){const c=!!t[a].readOnly;o[a].checked=c||(e?Ie(a):s(a));for(const t in n[a])n[a][t].checked=c||(e?Le(t,a):s(a))}})(),z(m.ne.$e,!0),F(m.ne.ye,s),A(m.ne.we,l,'true'),e.k?(z(e.U),e.U=null):(z(e.J),e.J=null),te(m.re._e,p))};var $e={show:Pe,hide:Oe,showPreferences:Re,hidePreferences:Be,acceptCategory:je};const Ge=(e,t)=>{const o=Ne(t);return e?o[e]:o},Je=()=>!m.o.T;e.acceptCategory=je,e.acceptService=(e,t)=>{const{O:o,X:n}=m.o;if(!(e&&t&&h(t)&&v(o,t)&&0!==S(n[t]).length))return!1;((e,t)=>{const o=m.o,{X:n,Z:s,N:a}=o,c=m.ne.ae[t]||{},r=m.ne.se[t]||{},i=S(n[t]);if(s[t]=[],h(e)){if('all'===e){if(s[t].push(...i),a)for(let e in c)c[e].checked=!0,k(c[e])}else if(v(i,e)&&s[t].push(e),a)for(let t in c)c[t].checked=e===t,k(c[t])}else if(y(e))for(let o of i){const n=v(e,o);n&&s[t].push(o),a&&(c[o].checked=n,k(c[o]))}const l=0===s[t].length;o.R=l?o.R.filter((e=>e!==t)):x([...o.R,t]),a&&(r.checked=!l,k(r))})(e,t),je()},e.acceptedCategory=Ie,e.acceptedService=Le,e.eraseCookies=Fe,e.getConfig=e=>{const t=m.t,o=m.o.i;return e?t[e]||o[e]:{...t,...o,cookie:{...t.cookie}}},e.getCookie=Ge,e.getUserPreferences=()=>{const{F:e,Y:t}=m.o,{accepted:o,rejected:n}=(()=>{const{T:e,R:t,O:o}=m.o;return{accepted:t,rejected:e?[]:o.filter((e=>!v(t,e)))}})();return P({acceptType:e,acceptedCategories:o,rejectedCategories:n,acceptedServices:t,rejectedServices:O()})},e.hide=Oe,e.hidePreferences=Be,e.loadScript=(e,t)=>{let o=document.querySelector('script[src="'+e+'"]');return new Promise((n=>{if(o)return n(!0);if(o=E('script'),C(t))for(const e in t)A(o,e,t[e]);o.onload=()=>n(!0),o.onerror=()=>{o.remove(),n(!1)},o.src=e,V(document.head,o)}))},e.reset=e=>{const{Ce:t,ye:o}=m.ne,{name:c,path:r,domain:i,useLocalStorage:l}=m.t.cookie;e&&(l?De(c):Fe(c,r,i));for(const{pe:e,ge:t,me:o}of m.o.m)e.removeEventListener(t,o);t&&t.remove(),o&&o.classList.remove(a,s,n);const d=new g;for(const e in m)m[e]=d[e];window._ccRun=!1},e.run=async e=>{const{o:t,t:n,re:s}=m,a=window;if(!a._ccRun){if(a._ccRun=!0,(e=>{const{ne:t,t:n,o:s}=m,a=n,r=s,{cookie:i}=a,l=m.ce,d=e.cookie,f=e.categories,_=S(f)||[],u=navigator,p=document;t.Ue=p,t.ye=p.documentElement,i.domain=location.hostname,r.i=e,r.P=f,r.O=_,r._=e.language.translations,r.v=!!e.disablePageInteraction,l.ie=e.onFirstConsent,l.le=e.onConsent,l.de=e.onChange,l._e=e.onModalHide,l.fe=e.onModalShow,l.ue=e.onModalReady;const{mode:g,autoShow:b,lazyHtmlGeneration:y,autoClearCookies:h,revision:w,manageScriptTags:x,hideFromBots:M}=e;g===o&&(a.mode=g),'boolean'==typeof h&&(a.autoClearCookies=h),'boolean'==typeof x&&(a.manageScriptTags=x),'number'==typeof w&&w>=0&&(a.revision=w,r.V=!0),'boolean'==typeof b&&(a.autoShow=b),'boolean'==typeof y&&(a.lazyHtmlGeneration=y),!1===M&&(a.hideFromBots=!1),!0===a.hideFromBots&&u&&(r.G=u.userAgent&&/bot|crawl|spider|slurp|teoma/i.test(u.userAgent)||u.webdriver),C(d)&&(a.cookie={...i,...d}),a.autoClearCookies,r.V,a.manageScriptTags,(e=>{const{P:t,X:o,Y:n,Z:s,B:a}=m.o;for(let c of e){const e=t[c],r=e.services||{},i=C(r)&&S(r)||[];o[c]={},n[c]=[],s[c]=[],e.readOnly&&(a.push(c),n[c]=i),m.ne.ae[c]={};for(let e of i){const t=r[e];t.Se=!1,o[c][e]=t}}})(_),(()=>{if(!m.t.manageScriptTags)return;const e=m.o,t=D(document,'script['+c+']');for(const o of t){let t=H(o,c),n=o.dataset.service||'',s=!1;if(t&&'!'===t.charAt(0)&&(t=t.slice(1),s=!0),'!'===n.charAt(0)&&(n=n.slice(1),s=!0),v(e.O,t)&&(e.oe.push({Me:o,xe:!1,ke:s,Te:t,De:n}),n)){const o=e.X[t];o[n]||(o[n]={Se:!1})}}})(),Se((()=>{const e=m.o.i.language.autoDetect;if(e){const t={browser:navigator.language,document:document.documentElement.lang},o=Ce(t[e]);if(o)return o}return we()})())})(e),t.G)return;(()=>{const e=m.o,t=m.t,n=Ne(),{categories:s,services:a,consentId:c,consentTimestamp:r,lastConsentTimestamp:i,data:l,revision:d}=n,f=y(s);e.p=n,e.M=c;const _=!!c&&h(c);e.C=r,e.C&&(e.C=new Date(r)),e.S=i,e.S&&(e.S=new Date(i)),e.h=void 0!==l?l:null,e.V&&_&&d!==t.revision&&(e.j=!1),e.T=!(_&&e.j&&e.C&&e.S&&f),t.cookie.useLocalStorage&&!e.T&&(e.T=(new Date).getTime()>(n.expirationTime||0),e.T&&De(t.cookie.name)),e.T,(()=>{const e=m.o;for(const t of e.O){const n=e.P[t];if(n.readOnly||n.enabled){e.$.push(t);const n=e.X[t]||{};for(let s in n)e.Z[t].push(s),e.i.mode===o&&e.Y[t].push(s)}}})(),e.T?t.mode===o&&(e.R=[...e.$]):(e.Y={...e.Y,...a},e.Z={...e.Y},J([...e.B,...s]))})();const i=Je();if(!await xe())return!1;if(U(null,r=$e,be,Te),m.o.T&&he(r,Te),m.t.lazyHtmlGeneration||be(r,Te),n.autoShow&&!i&&Pe(!0),i)return ne(),te(s.le);n.mode===o&&ne(t.$)}var r},e.setCookieData=e=>{let t,o=e.value,n=e.mode,s=!1;const a=m.o;if('update'===n){a.h=t=Ge('data');const e=typeof t==typeof o;if(e&&'object'==typeof t){!t&&(t={});for(let e in o)t[e]!==o[e]&&(t[e]=o[e],s=!0)}else!e&&t||t===o||(t=o,s=!0)}else t=o,s=!0;return s&&(a.h=t,a.p.data=t,Ee(!0)),s},e.setLanguage=async(e,t)=>{if(!Ce(e))return!1;const o=m.o;return!(e===we()&&!0!==t||!await xe(e)||(Se(e),o.D&&he($e,Te),o.N&&be($e,Te),Me(),0))},e.show=Pe,e.showPreferences=Re,e.validConsent=Je,e.validCookie=e=>''!==He(e,!0)},'object'==typeof exports&&'undefined'!=typeof module?t(exports):'function'==typeof define&&define.amd?define(['exports'],t):t((e='undefined'!=typeof globalThis?globalThis:e||self).CookieConsent={});

﻿if (localStorage.getItem("lang") !== null) {
    document.documentElement.lang = localStorage.getItem("lang");
}
const lang =
    document.documentElement.lang == "es"
        ? "ESmx"
        : document.documentElement.lang;
moment.locale(document.documentElement.lang);
moment.defaultTimezone = moment.tz.guess();
moment.tz.setDefault(moment.defaultTimezone);

(function ($) {
    "use strict";

    let form2 = document.querySelector(".form-2");
    if (form2 !== null) {
        let url = form2.dataset.action;
        form2.removeAttribute("data-action");
        form2.parentElement.innerHTML = `
                 <form action="${url}" method="get">${form2.parentElement.innerHTML}</form>
            `;
    }

    $("input,textarea").attr("autocomplete", "off");
    $("input,textarea").attr("maxlength", "250");

    /* ----- Preloader ----- */
    function preloaderLoad() {
        if ($(".preloader").length) {
            // $(".preloader").delay(200).fadeOut(300);
        }
        $(".preloader_disabler").on("click", function () {
            $("#preloader").hide();
        });
    }

    /* ----- Navbar Scroll To Fixed ----- */
    function navbarScrollfixed() {
        $(".navbar-scrolltofixed").scrollToFixed();
        var summaries = $(".summary");
        summaries.each(function (i) {
            var summary = $(summaries[i]);
            var next = summaries[i + 1];
            summary.scrollToFixed({
                marginTop: $(".navbar-scrolltofixed").outerHeight(true) + 10,
                limit: function () {
                    var limit = 0;
                    if (next) {
                        limit =
                            $(next).offset().top -
                            $(this).outerHeight(true) -
                            10;
                    } else {
                        limit =
                            $(".footer").offset().top -
                            $(this).outerHeight(true) -
                            10;
                    }
                    return limit;
                },
                zIndex: 999,
            });
        });
    }

    /** Main Menu Custom Script Start **/
    $(document).on("ready", function () {
        $("#respMenu").aceResponsiveMenu({
            resizeWidth: "768", // Set the same in Media query
            animationSpeed: "fast", //slow, medium, fast
            accoridonExpAll: false, //Expands all the accordion menu on click
        });
    });

    function mobileNavToggle() {
        if ($("#main-nav-bar .navbar-nav .sub-menu").length) {
            var subMenu = $("#main-nav-bar .navbar-nav .sub-menu");
            subMenu
                .parent("li")
                .children("a")
                .append(function () {
                    return '<button class="sub-nav-toggler"> <span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span> </button>';
                });
            var subNavToggler = $("#main-nav-bar .navbar-nav .sub-nav-toggler");
            subNavToggler.on("click", function () {
                var Self = $(this);
                Self.parent().parent().children(".sub-menu").slideToggle();
                return false;
            });
        }
    }

    /* ----- Tags Bar Code for job list 1 page ----- */
    $(".tags-bar > span i").on("click", function () {
        $(this).parent().fadeOut();
    });

    $(".thumb2").on("click", function () {
        var link = $(this).attr("link") || null;
        if (link != null) location.href = link;
    });

    /* ----- This code for menu ----- */
    $(window).on("scroll", function () {
        if ($(".scroll-to-top").length) {
            var strickyScrollPos = 100;
            if ($(window).scrollTop() > strickyScrollPos) {
                $(".scroll-to-top").fadeIn(500);
            } else if ($(this).scrollTop() <= strickyScrollPos) {
                $(".scroll-to-top").fadeOut(500);
            }
        }
        if ($(".stricky").length) {
            var headerScrollPos = $(".header-navigation").next().offset().top;
            var stricky = $(".stricky");
            if ($(window).scrollTop() > headerScrollPos) {
                stricky.removeClass("slideIn animated");
                stricky.addClass("stricky-fixed slideInDown animated");
            } else if ($(this).scrollTop() <= headerScrollPos) {
                stricky.removeClass("stricky-fixed slideInDown animated");
                stricky.addClass("slideIn animated");
            }
        }
    });

    /* $(".mouse_scroll, .mouse_scroll.home8").on("click", function () {
        $("html, body").animate(
            {
                scrollTop: $("#feature-property, #property-city").offset().top,
            },
            1000
        );
    }); */
    /** Main Menu Custom Script End **/

    /* ----- Blog innerpage sidebar according ----- */
    $(document).on("ready", function () {
        $(".collapse").on("show.bs.collapse", function () {
            $(this).siblings(".card-header").addClass("active");
        });
        $(".collapse").on("hide.bs.collapse", function () {
            $(this).siblings(".card-header").removeClass("active");
        });

        $(function () {
            $('[data-toggle="tooltip"]').tooltip();
        });
    });

    /* ----- Menu Cart Button Dropdown ----- */
    $(document).on("ready", function () {
        // Loop through each nav item
        $(".cart_btn")
            .children("ul.cart")
            .children("li")
            .each(function (indexCount) {
                // loop through each dropdown, count children and apply a animation delay based on their index value
                $(this)
                    .children("ul.dropdown_content")
                    .children("li")
                    .each(function (index) {
                        // Turn the index value into a reasonable animation delay
                        var delay = 0.1 + index * 0.03;
                        // Apply the animation delay
                        $(this).css("animation-delay", delay + "s");
                    });
            });
    });

    /* Menu Search Popup */
    jQuery(document).ready(function ($) {
        var wHeight = window.innerHeight;
        /* search bar middle alignment */
        $("#mk-fullscreen-searchform").css("top", wHeight / 2);
        /* reform search bar */
        jQuery(window).resize(function () {
            wHeight = window.innerHeight;
            $("#mk-fullscreen-searchform").css("top", wHeight / 2);
        });

        /* Search */
        $("#search-button, #search-button2").on("click", function () {
            $("div.mk-fullscreen-search-overlay").addClass(
                "mk-fullscreen-search-overlay-show"
            );
        });
        $("button.mk-fullscreen-close").on("click", function () {
            $("div.mk-fullscreen-search-overlay").removeClass(
                "mk-fullscreen-search-overlay-show"
            );
        });
    });

    /* ----- fact-counter ----- */
    /* function counterNumber() {
        $("div.timer").counterUp({
            delay: 5,
            time: 2000,
        });
        // const cd = new Date().getFullYear() + 1
        // $('#countdown').countdown({
        //     year: cd
        // });
    } */

    /* ----- Mobile Nav ----- */
    $(function () {
        $("nav#menu").mmenu();
    });

    /* ----- Candidate SIngle Page Price Slider ----- */
    $(function () {
        $("#slider-range").slider({
            range: true,
            min: 50,
            max: 150,
            values: [50, 120],
            slide: function (event, ui) {
                $("#amount").val("$" + ui.values[0] + " - $" + ui.values[1]);
            },
        });
        $("#amount").val(
            "$" +
                $("#slider-range").slider("values", 0) +
                " - $" +
                $("#slider-range").slider("values", 1)
        );
    });

    /* ----- Employee List v1 page range slider widget ----- */
    $(document).on("ready", function () {
        $(".slider-range").slider({
            range: true,
            min: 0,
            max: 999999,
            values: [0, 999999],
            slide: function (event, ui) {
                $(".amount").val(ui.values[0]);
                $(".amount2").val(ui.values[1]);
            },
        });
        $(".amount").change(function () {
            $(".slider-range").slider("values", 0, $(this).val());
        });
        $(".amount2").change(function () {
            $(".slider-range").slider("values", 1, $(this).val());
        });
    });

    /* ----- Progress Bar ----- */
    if ($(".progress-levels .progress-box .bar-fill").length) {
        $(".progress-box .bar-fill").each(function () {
            var progressWidth = $(this).attr("data-percent");
            $(this).css("width", progressWidth + "%");
            $(this)
                .children(".percent")
                .html(progressWidth + "%");
        });
    }

    /* ----- Background Parallax ----- */
    var isMobile = {
        Android: function () {
            return navigator.userAgent.match(/Android/i);
        },
        BlackBerry: function () {
            return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS: function () {
            return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        },
        Opera: function () {
            return navigator.userAgent.match(/Opera Mini/i);
        },
        Windows: function () {
            return navigator.userAgent.match(/IEMobile/i);
        },
        any: function () {
            return (
                isMobile.Android() ||
                isMobile.BlackBerry() ||
                isMobile.iOS() ||
                isMobile.Opera() ||
                isMobile.Windows()
            );
        },
    };

    /* jQuery(document).on("ready", function () {
        jQuery(window).stellar({
            horizontalScrolling: false,
            hideDistantElements: true,
            verticalScrolling: !isMobile.any(),  
            scrollProperty: "scroll",
            responsive: true,
        });
    }); */

    /* ----- MagnificPopup ----- */
    if (
        $(".popup-img").length > 0 ||
        $(".popup-iframe").length > 0 ||
        $(".popup-img-single").length > 0
    ) {
        $(".popup-img").magnificPopup({
            type: "image",
            gallery: {
                enabled: true,
            },
        });
        $(".popup-img-single").magnificPopup({
            type: "image",
            gallery: {
                enabled: false,
            },
        });
        $(".popup-iframe").magnificPopup({
            disableOn: 700,
            type: "iframe",
            preloader: false,
            fixedContentPos: false,
        });
        $(".popup-youtube, .popup-vimeo, .popup-gmaps").magnificPopup({
            disableOn: 700,
            type: "iframe",
            mainClass: "mfp-fade",
            removalDelay: 160,
            preloader: false,
            fixedContentPos: false,
        });
    }

    $("#myTab a").on("click", function (e) {
        e.preventDefault();
        $(this).tab("show");
    });

    /* ----- Wow animation ----- */
    /* function wowAnimation() {
        var wow = new WOW({
            animateClass: "animated",
            mobile: true, // trigger animations on mobile devices (default is true)
            offset: 0,
        });
        wow.init();
    } */

    /* ----- Date & time Picker ----- */
    if ($(".datepicker").length) {
        $(".datepicker").datetimepicker();
    }

    /* ----- Home Maximage Slider ----- */
    if ($("#maximage").length) {
        $("#maximage").maximage({
            cycleOptions: {
                fx: "fade",
                speed: 500,
                timeout: 20000,
                prev: "#arrow_left",
                next: "#arrow_right",
            },
            onFirstImageLoaded: function () {
                jQuery("#cycle-loader").hide();
                jQuery("#maximage").fadeIn("fast");
            },
        });
        // Helper function to Fill and Center the HTML5 Video
        jQuery("#html5video").maximage("maxcover");

        // To show it is dynamic html text
        jQuery(".in-slide-content").delay(2000).fadeIn();
    }

    /* ----- Slick Slider For Testimonial ----- */
    if ($(".tes-for").length) {
        $(".tes-for").slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: false,
            autoplay: false,
            autoplaySpeed: 2000,
            asNavFor: ".tes-nav",
        });
        $(".tes-nav").slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            asNavFor: ".tes-for",
            dots: false,
            arrows: false,
            centerPadding: "1px",
            centerMode: true,
            focusOnSelect: true,
        });
    }

    /*  Testimonial-Slider-Owl-carousel  */
    if ($(".feature_property_slider").length) {
        $(".feature_property_slider").owlCarousel({
            loop: true,
            margin: 30,
            dots: true,
            nav: false,
            rtl: false,
            autoplayHoverPause: false,
            autoplay: false,
            singleItem: true,
            smartSpeed: 1200,
            navText: [
                '<i class="fa fa-arrow-left"></i>',
                '<i class="fa fa-arrow-right"></i>',
            ],
            responsive: {
                0: {
                    items: 1,
                    center: false,
                },
                480: {
                    items: 1,
                    center: false,
                },
                600: {
                    items: 1,
                    center: false,
                },
                768: {
                    items: 2,
                },
                992: {
                    items: 2,
                },
                1200: {
                    items: 2,
                },
                1280: {
                    items: 3,
                },
            },
        });
    }

    /*  Testimonial-Slider-Owl-carousel  */
    if ($(".testimonial_grid_slider").length) {
        $(".testimonial_grid_slider").owlCarousel({
            loop: true,
            margin: 15,
            dots: true,
            nav: false,
            rtl: false,
            autoplayHoverPause: false,
            autoplay: false,
            singleItem: true,
            smartSpeed: 1200,
            navText: [
                '<i class="fa fa-arrow-left"></i>',
                '<i class="fa fa-arrow-right"></i>',
            ],
            responsive: {
                0: {
                    items: 1,
                    center: false,
                },
                480: {
                    items: 1,
                    center: false,
                },
                600: {
                    items: 1,
                    center: false,
                },
                768: {
                    items: 1,
                },
                992: {
                    items: 1,
                },
                1200: {
                    items: 1,
                },
            },
        });
    }

    /*  Team-Slider-Owl-carousel  */
    if ($(".team_slider").length) {
        $(".team_slider").owlCarousel({
            loop: true,
            margin: 30,
            dots: false,
            nav: true,
            rtl: false,
            autoplayHoverPause: false,
            autoplay: false,
            singleItem: true,
            smartSpeed: 1200,
            navText: [
                '<i class="flaticon-left-arrow"></i>',
                '<i class="flaticon-right-arrow"></i>',
            ],
            responsive: {
                0: {
                    items: 1,
                    center: false,
                },
                480: {
                    items: 1,
                    center: false,
                },
                520: {
                    items: 2,
                    center: false,
                },
                600: {
                    items: 2,
                    center: false,
                },
                768: {
                    items: 2,
                },
                992: {
                    items: 3,
                },
                1200: {
                    items: 4,
                },
                1366: {
                    items: 4,
                },
                1400: {
                    items: 4,
                },
            },
        });
    }

    /*  Best-Property-Slider-Owl-carousel  */
    if ($(".best_property_slider").length) {
        $(".best_property_slider").owlCarousel({
            loop: true,
            margin: 30,
            dots: true,
            nav: false,
            rtl: false,
            autoplayHoverPause: false,
            autoplay: false,
            singleItem: true,
            smartSpeed: 1200,
            navText: [
                '<i class="flaticon-left-arrow"></i>',
                '<i class="flaticon-right-arrow"></i>',
            ],
            responsive: {
                0: {
                    items: 1,
                    center: false,
                },
                480: {
                    items: 1,
                    center: false,
                },
                520: {
                    items: 1,
                    center: false,
                },
                600: {
                    items: 2,
                    center: false,
                },
                768: {
                    items: 2,
                },
                992: {
                    items: 3,
                },
                1200: {
                    items: 3,
                },
                1366: {
                    items: 4,
                },
                1400: {
                    items: 4,
                },
            },
        });
    }

    /*  Team-Slider-Owl-carousel  */
    if ($(".feature_property_home3_slider").length) {
        $(".feature_property_home3_slider").owlCarousel({
            loop: true,
            margin: 30,
            dots: false,
            nav: true,
            rtl: false,
            autoplayHoverPause: false,
            autoplay: false,
            singleItem: true,
            smartSpeed: 1200,
            navText: [
                '<i class="flaticon-left-arrow"></i>',
                '<i class="flaticon-right-arrow"></i>',
            ],
            responsive: {
                0: {
                    items: 1,
                    center: false,
                },
                480: {
                    items: 1,
                    center: false,
                },
                520: {
                    items: 2,
                    center: false,
                },
                600: {
                    items: 2,
                    center: false,
                },
                768: {
                    items: 2,
                },
                992: {
                    items: 3,
                },
                1200: {
                    items: 4,
                },
                1366: {
                    items: 4,
                },
                1400: {
                    items: 4,
                },
            },
        });
    }

    /*  Team-Slider-Owl-carousel  */
    if ($(".feature_property_home6_slider").length) {
        $(".feature_property_home6_slider").owlCarousel({
            loop: true,
            margin: 30,
            dots: false,
            nav: true,
            rtl: false,
            autoplayHoverPause: false,
            autoplay: false,
            singleItem: true,
            smartSpeed: 1200,
            navText: [
                '<i class="flaticon-left-arrow"></i>',
                '<i class="flaticon-right-arrow"></i>',
            ],
            responsive: {
                0: {
                    items: 1,
                    center: false,
                },
                480: {
                    items: 1,
                    center: false,
                },
                520: {
                    items: 2,
                    center: false,
                },
                600: {
                    items: 2,
                    center: false,
                },
                768: {
                    items: 2,
                },
                992: {
                    items: 3,
                },
                1200: {
                    items: 4,
                },
                1366: {
                    items: 4,
                },
                1400: {
                    items: 4,
                },
            },
        });
    }

    /*  Team-Slider-Owl-carousel  */
    if ($(".our_agents_home6_slider").length) {
        $(".our_agents_home6_slider").owlCarousel({
            loop: true,
            margin: 30,
            dots: false,
            nav: true,
            rtl: false,
            autoplayHoverPause: false,
            autoplay: false,
            singleItem: true,
            smartSpeed: 1200,
            navText: [
                '<i class="flaticon-left-arrow"></i>',
                '<i class="flaticon-right-arrow"></i>',
            ],
            responsive: {
                0: {
                    items: 1,
                    center: false,
                },
                480: {
                    items: 1,
                    center: false,
                },
                520: {
                    items: 2,
                    center: false,
                },
                600: {
                    items: 2,
                    center: false,
                },
                768: {
                    items: 2,
                },
                992: {
                    items: 3,
                },
                1200: {
                    items: 4,
                },
                1366: {
                    items: 4,
                },
                1400: {
                    items: 5,
                },
            },
        });
    }

    /*  Testimonial-Slider-Owl-carousel  */
    if ($(".testimonial_slider_home9").length) {
        $(".testimonial_slider_home9").owlCarousel({
            loop: true,
            margin: 30,
            dots: true,
            nav: false,
            rtl: false,
            autoplayHoverPause: false,
            autoplay: false,
            singleItem: true,
            smartSpeed: 1200,
            navText: [
                '<i class="fa fa-arrow-left"></i>',
                '<i class="fa fa-arrow-right"></i>',
            ],
            responsive: {
                0: {
                    items: 1,
                    center: false,
                },
                480: {
                    items: 1,
                    center: false,
                },
                600: {
                    items: 1,
                    center: false,
                },
                768: {
                    items: 2,
                },
                992: {
                    items: 2,
                },
                1200: {
                    items: 2,
                },
                1280: {
                    items: 2,
                },
            },
        });
    }

    /*  One-Grid-Owl-carousel  */
    if ($(".sidebar_feature_property_slider").length) {
        $(".sidebar_feature_property_slider").owlCarousel({
            animateIn: "fadeIn",
            loop: true,
            margin: 15,
            dots: true,
            nav: true,
            rtl: false,
            autoplayHoverPause: false,
            autoplay: false,
            smartSpeed: 2000,
            singleItem: true,
            navText: [
                '<i class="flaticon-left-arrow-1"></i>',
                '<i class="flaticon-right-arrow"></i>',
            ],
            responsive: {
                320: {
                    items: 1,
                    center: false,
                },
                480: {
                    items: 1,
                    center: false,
                },
                600: {
                    items: 1,
                    center: false,
                },
                768: {
                    items: 1,
                },
                992: {
                    items: 1,
                },
                1200: {
                    items: 1,
                },
            },
        });
    }

    /*  One-Grid-Owl-carousel  */
    if ($(".listing_single_property_slider").length) {
        let item = $(".listing_single_property_slider .item").length;
        item = item < 3 ? item : 3;
        $(".listing_single_property_slider").owlCarousel({
            animateIn: "fadeIn",
            loop: true,
            margin: 2,
            dots: false,
            nav: true,
            rtl: false,
            autoplayHoverPause: false,
            autoplay: false,
            smartSpeed: 2000,
            singleItem: true,
            navText: [
                '<i class="flaticon-left-arrow-1"></i>',
                '<i class="flaticon-right-arrow"></i>',
            ],
            responsive: {
                320: {
                    items: 1,
                    center: false,
                },
                480: {
                    items: 1,
                    center: false,
                },
                600: {
                    items: 1,
                    center: false,
                },
                768: {
                    items: item,
                },
                992: {
                    items: item,
                },
                1200: {
                    items: item,
                },
            },
        });
    }

    /*  One-Grid-Owl-carousel  */
    if ($(".fp_single_item_slider").length) {
        $(".fp_single_item_slider").owlCarousel({
            loop: true,
            margin: 15,
            dots: false,
            nav: true,
            rtl: false,
            autoplayHoverPause: false,
            autoplay: false,
            smartSpeed: 2000,
            singleItem: true,
            navText: [
                '<i class="flaticon-left-arrow-1"></i>',
                '<i class="flaticon-right-arrow"></i>',
            ],
            responsive: {
                320: {
                    items: 1,
                    center: false,
                },
                480: {
                    items: 1,
                    center: false,
                },
                600: {
                    items: 1,
                    center: false,
                },
                768: {
                    items: 1,
                },
                992: {
                    items: 1,
                },
                1200: {
                    items: 1,
                },
            },
        });
    }

    /*  Expert-Freelancer-Owl-carousel  */
    if ($(".banner-style-one").length) {
        $(".banner-style-one").owlCarousel({
            loop: true,
            items: 1,
            margin: 0,
            dots: true,
            nav: true,
            animateOut: "slideOutDown",
            animateIn: "fadeIn",
            active: true,
            smartSpeed: 1000,
            autoplay: false,
        });
        $(".banner-carousel-btn .left-btn").on("click", function () {
            $(".banner-style-one").trigger("next.owl.carousel");
            return false;
        });
        $(".banner-carousel-btn .right-btn").on("click", function () {
            $(".banner-style-one").trigger("prev.owl.carousel");
            return false;
        });
    }

    /*  Team-Slider-Owl-carousel  */
    if ($(".single_product_slider").length) {
        $(".single_product_slider").owlCarousel({
            loop: true,
            margin: 30,
            dots: true,
            nav: false,
            rtl: false,
            autoplayHoverPause: false,
            autoplay: false,
            singleItem: true,
            smartSpeed: 1200,
            navText: [
                '<i class="flaticon-left-arrow"></i>',
                '<i class="flaticon-right-arrow"></i>',
            ],
            responsive: {
                0: {
                    items: 1,
                    center: false,
                },
                480: {
                    items: 1,
                    center: false,
                },
                520: {
                    items: 1,
                    center: false,
                },
                600: {
                    items: 1,
                    center: false,
                },
                768: {
                    items: 1,
                },
                992: {
                    items: 1,
                },
                1200: {
                    items: 1,
                },
                1366: {
                    items: 1,
                },
                1400: {
                    items: 1,
                },
            },
        });
    }

    /* ----- Scroll To top ----- */
    function scrollToTop() {
        $("html, body").animate({ scrollTop: 0 }, 800);
        /* $(window).scroll(function () {
            if ($(this).scrollTop() > 600) {
                $(".scrollToHome").fadeIn();
            } else {
                $(".scrollToHome").fadeOut();
            }
        });

        //Click event to scroll to top
        $(".scrollToHome").on("click", function () {
            $("html, body").animate({ scrollTop: 0 }, 800);
            return false;
        }); */
    }

    /* ----- Mega Dropdown Content ----- */
    $(document).on("ready", function () {
        $("#show_advbtn, #show_advbtn2").on("click", function () {
            $(".dropdown-content").show();
        });
        $("#hide_advbtn, #hide_advbtn2").on("click", function () {
            $(".dropdown-content").hide();
        });
        $("#show_advbtn, #show_advbtn2").on("click", function () {
            $("body").addClass("mobile_ovyh");
        });
        $("#show_advbtn, #show_advbtn2").on("click", function () {
            $("body").removeClass("mobile_ovyh");
        });
        $("#prncgs").on("click", function () {
            $(".dd_content2").toggle();
        });
        $("#prncgs2").on("click", function () {
            $(".dd_content2").toggle();
        });

        $(".filter_open_btn").on("click", function () {
            $(".sidebar_content_details.style3").addClass("sidebar_ml0");
        });

        $(".filter_closed_btn").on("click", function () {
            $(".sidebar_content_details.style3").removeClass("sidebar_ml0");
        });

        $(".filter_open_btn").on("click", function () {
            $("body").addClass("body_overlay");
        });

        $(".filter_closed_btn").on("click", function () {
            $("body").removeClass("body_overlay");
        });

        $(".overlay_close").on("click", function () {
            $(".white_goverlay").toggle(500);
        });

        $(".sticky-nav-tabs-container li").on("click", function () {
            $(".sticky-nav-tabs-container li").removeClass("active");
            $(this).addClass("active");
        });
    });

    /* ======
   When document is ready, do
   ====== */
    $(document).on("ready", function () {
        // add your functions
        navbarScrollfixed();
        scrollToTop();
        /*  wowAnimation(); */
        mobileNavToggle();

        // extending for text toggle
        $.fn.extend({
            toggleText: function (a, b) {
                return this.text(this.text() == b ? a : b);
            },
        });
        if ($(".showFilter").length) {
            $(".showFilter").on("click", function () {
                $(this).toggleText("Show Filter", "Hide Filter");
                $(this).toggleClass(
                    "flaticon-close flaticon-filter-results-button sidebarOpended sidebarClosed"
                );
                $(".listing_toogle_sidebar.sidenav").toggleClass("opened");
                $(".body_content").toggleClass("translated");
            });
        }

        $.fn.extend({
            toggleText2: function (a, b) {
                return this.text(this.text() == b ? a : b);
            },
        });

        if ($(".showBtns").length) {
            $(".showBtns").on("click", function () {
                $(this).toggleText2("Show Filter", "Hide Filter");
                $(this).toggleClass(
                    "flaticon-close flaticon-filter-results-button sidebarOpended2 sidebarClosed2"
                );
                $(".sidebar_content_details").toggleClass("is-full-width");
            });
        }
    });

    /* ======
   When document is loading, do
   ====== */
    // window on Load function
    $(window).on("load", function () {
        // add your functions
        /* counterNumber(); */
        preloaderLoad();
    });
    // window on Scroll function
    $(window).on("scroll", function () {
        // add your functions
    });
})(window.jQuery);

function number_format(number, decimals, dec_point, thousands_sep) {
    // Strip all characters but numerical ones.
    number = (number + "").replace(/[^0-9+\-Ee.]/g, "");
    var n = !isFinite(+number) ? 0 : +number,
        prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep = typeof thousands_sep === "undefined" ? "," : thousands_sep,
        dec = typeof dec_point === "undefined" ? "." : dec_point,
        s = "",
        toFixedFix = function (n, prec) {
            var k = Math.pow(10, prec);
            return "" + Math.round(n * k) / k;
        };
    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec) : "" + Math.round(n)).split(".");
    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || "").length < prec) {
        s[1] = s[1] || "";
        s[1] += new Array(prec - s[1].length + 1).join("0");
    }
    return s.join(dec);
}

const dateFormat = (date) => {
    date = moment(date.split("T")[0]).format("MMMM DD");
    return date.charAt(0).toUpperCase() + date.slice(1);
};

const textTrad = (ob, key) => {
    let traduction = ob[key];
    if (lang != "en") {
        if (ob[`${key}${lang}`] != null && ob[`${key}${lang}`] != "") {
            traduction = ob[`${key}${lang}`];
        } else {
            traduction = ob[key];
        }
    }
    return traduction;
};

const getKeyValues = (dataFields) => {
    let keyValues = "";
    dataFields?.forEach((datafield) => {
        const input = textTrad(datafield, "input");
        let value =
            (!isNaN(datafield.value)
                ? number_format(datafield.value, 0, ".", ",")
                : datafield.value) +
            (datafield.unit ? ` ${datafield.unit}` : "");
        if (datafield.input_type === "boolean") {
            if (parseInt(value) === 0) {
                return "";
            }
            value =
                parseInt(value) === 1
                    ? lang != "en"
                        ? lang == "pt"
                            ? "Incluindo"
                            : "Incluido"
                        : "Included"
                    : lang != "en"
                    ? lang == "pt"
                        ? "Não incluído"
                        : "No incluido"
                    : "Not included";
        }
        if (datafield.input_type === "select") {
            value = textTrad(datafield, "value");
        }
        keyValues += `<li class="list-inline-item">
                            <a>
                                <span class="fas fa-circle-check"></span><item>
                                <strong>${input}: </strong>
                                ${value}</item>
                            </a>
                        </li>`;
    });
    return keyValues;
};

const setUrl = (url, parametro, valor) => {
    const urlObj = new URL(url);

    // Borrar todos los parámetros de la URL
    urlObj.searchParams.forEach((_, key) => urlObj.searchParams.delete(key));

    // Establecer el parámetro 'page' y el parámetro pasado
    urlObj.searchParams.set("page", "1");
    urlObj.searchParams.set(parametro, valor);

    return urlObj.toString();
};

const clearDuplicador = (arr) => {
    const titulos = new Set();
    return arr.reduce((resultado, item) => {
        if (
            !titulos.has(item.title) &&
            item.title != "" &&
            item.title != null &&
            item.id != "" &&
            item.id != null
        ) {
            titulos.add(item.title);
            resultado.push(item);
        }
        return resultado;
    }, []);
};

const firstLetterUppercase = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
};

const slugify = (text, separator = "-") => {
    return text
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .replace(/[^a-z0-9\s-]/g, "")
        .trim()
        .replace(/\s+/g, separator);
};

const itemOffers = (
    el,
    logo,
    link,
    system_columns = "col-md-6 col-lg-4",
    isLoadingEdger = false
) => {
    const url = new URL(window.location.href);
    let rent_by = url.searchParams.get("rent_by");
    rent_by = rent_by != null && rent_by != "" ? rent_by : "month";
    let span = lang != "en" ? (lang == "pt" ? "Mês" : "Mes") : "Month";

    switch (rent_by) {
        case "month":
            rent_by = "day3_price";
            span = lang != "en" ? (lang == "pt" ? "Mês" : "Mes") : "Month";
            break;
        case "week":
            rent_by = "day2_price";
            span = lang != "en" ? (lang == "pt" ? "Semana" : "Semana") : "Week";
            break;
        case "day":
            rent_by = "day1_price";
            span = lang != "en" ? (lang == "pt" ? "Dia" : "Día") : "Day";
            break;
        case "hour":
            rent_by = "day0_price";
            span = lang != "en" ? (lang == "pt" ? "Hora" : "Hora") : "Hour";
            break;
        default:
            rent_by = "day3_price";
            span = lang != "en" ? (lang == "pt" ? "Mês" : "Mes") : "Month";
            break;
    }

    let featured = {
        color: "",
        text: "",
    };
    if (
        el.hasOwnProperty("featured") &&
        el.featured != null &&
        el.featured != "" &&
        el.featured != "0"
    ) {
        switch (el.featured) {
            case "featured":
                featured.color = "danger";
                featured.text =
                    lang != "en"
                        ? lang == "pt"
                            ? "Destaque"
                            : "Destacado"
                        : "Featured";
                break;
            case "latest":
                featured.color = "primary";
                featured.text =
                    lang != "en"
                        ? lang == "pt"
                            ? "Última Oferta"
                            : "Última Oferta"
                        : "Latest Offer";
                break;
            case "state":
                /* Cerca de ti */
                featured.color = "success";
                featured.text =
                    lang != "en"
                        ? lang == "pt"
                            ? "Perto de Você"
                            : "Cerca de Ti"
                        : "Near You";
                break;
            default:
                /* En {country} */
                featured.color = "info";
                featured.text =
                    lang != "en"
                        ? lang == "pt"
                            ? "Em {country}"
                            : "En {country}"
                        : "In {country}";
                let pais = getStateAndCountry(null, el.country, lang);
                featured.text = featured.text.replace("{country}", pais);
                break;
        }
    }

    return `
                    <div class="${system_columns}">
                        <div class="feat_property home7"
                            ${
                                Boolean(el.published) != true &&
                                Boolean(el.active) != true
                                    ? ` style="cursor: not-allowed !important;opacity: 0.85;filter: grayscale(60%);max-width: 380px;margin-left: auto; margin-right: auto;"`
                                    : ' style="max-width: 380px;margin-left: auto; margin-right: auto;"'
                            } ${
        Boolean(el.published) == true && Boolean(el.active) == true
            ? ` link="${link.replace(":id", el.slugOffer)}"`
            : ""
    }
                        >
                            <div class="thumb" 
                            ${
                                Boolean(el.published) == true &&
                                Boolean(el.active) == true
                                    ? `link="${link.replace(
                                          ":id",
                                          el.slugOffer
                                      )}"`
                                    : ""
                            }
                            >
                                <img loading="${
                                    isLoadingEdger
                                        ? 'eager" fetchpriority="high'
                                        : "lazy"
                                }" class="img-whp list-img"
                                    src="${
                                        el.images["0"] && el.images["0"]["url"]
                                            ? el.images["0"]["url"]
                                            : `${location.origin}/images/header-logo.svg`
                                    }"
                                    ${
                                        el.images["0"] && el.images["0"]["url"]
                                            ? ""
                                            : ` style="object-fit: contain !important;"`
                                    }
                                    alt="${textTrad(
                                        el,
                                        "category"
                                    ).toUpperCase()} ${
        el.titleOffer
    }" title="${textTrad(el, "category").toUpperCase()} ${el.titleOffer}">

                                <div class="thmb_cntnt">
                                    ${
                                        el.hasOwnProperty("featured") &&
                                        el.featured != null &&
                                        el.featured != "" &&
                                        el.featured != "0"
                                            ? `<div class="featured featured-${featured.color}">${featured.text}</div>`
                                            : ""
                                    }
                                    <ul class="tag mb0">
                                        ${
                                            el.type != "service" &&
                                            el.offer_type == "for-sale"
                                                ? `<li class="list-inline-item for-sale"><a href="#"><b>${
                                                      lang != "en"
                                                          ? lang == "pt"
                                                              ? "Venda"
                                                              : "Venta"
                                                          : "Sale"
                                                  }</b></a></li>`
                                                : ""
                                        }
                                        ${
                                            el.type != "service" &&
                                            el.offer_type == "for-rent"
                                                ? `<li class="list-inline-item for-rent"><a href="#"><b>${
                                                      lang != "en"
                                                          ? lang == "pt"
                                                              ? "Aluguel"
                                                              : "Renta"
                                                          : "Rent"
                                                  }</b></a></li>`
                                                : ""
                                        }

                                        ${
                                            el.type != "service" &&
                                            el.offer_type == "for-sale-or-rent"
                                                ? `<li class="list-inline-item for-sale"><a href="#"><b>${
                                                      lang != "en"
                                                          ? lang == "pt"
                                                              ? "Venda"
                                                              : "Venta"
                                                          : "Sale"
                                                  }</b></a></li>
                                        <li class="list-inline-item for-rent"><a href="#"><b>${
                                            lang != "en"
                                                ? lang == "pt"
                                                    ? "Aluguel"
                                                    : "Renta"
                                                : "Rent"
                                        }</b></a></li>`
                                                : ""
                                        }

                                        ${
                                            el.type != "service" &&
                                            el.offer_type == "for-bidding"
                                                ? `<li class="list-inline-item for-bidding"><a href="#"><b>${
                                                      lang != "en"
                                                          ? lang == "pt"
                                                              ? "Leilão"
                                                              : "Subasta"
                                                          : "Auction"
                                                  }</b></a></li>` +
                                                  (el.sale_price != null &&
                                                  el.sale_price != "NULL" &&
                                                  el.sale_price != "" &&
                                                  el.sale_price != 0
                                                      ? `<li class="list-inline-item for-bidding"><a href="#"><b>${
                                                            lang != "en"
                                                                ? lang == "pt"
                                                                    ? "Comprar Agora"
                                                                    : "Compra Ahora"
                                                                : "Buy Now"
                                                        }</b></a></li>`
                                                      : "")
                                                : ""
                                        }

                                        ${
                                            el.type == "service"
                                                ? `<li class="list-inline-item for-service"><a href="#"><b>
                                                        ${
                                                            lang != "en"
                                                                ? lang == "pt"
                                                                    ? "Serviço"
                                                                    : "Servicio"
                                                                : "Service"
                                                        }
                                                    </b></a></li>`
                                                : ""
                                        }
                                    </ul>
                                    <div class="fp_price">
                                        ${
                                            el.offer_type == "for-sale" &&
                                            el.sale_price != null &&
                                            el.sale_price != "NULL" &&
                                            el.sale_price != "" &&
                                            el.sale_price != 0 &&
                                            (el.contact_us === false ||
                                                el.contact_us === 0) &&
                                            (el.make_an_offer === false ||
                                                el.make_an_offer === 0)
                                                ? `<span class="amount">$${number_format(
                                                      el.sale_price,
                                                      0,
                                                      ".",
                                                      ","
                                                  )}</span>`
                                                : ""
                                        }
                                        ${
                                            ((el.contact_us === true ||
                                                el.contact_us === 1) &&
                                                el.offer_type !=
                                                    "for-bidding") ||
                                            ((el.contact_us === true ||
                                                el.contact_us === 1) &&
                                                el.offer_type != "for-bidding")
                                                ? `<span>${
                                                      lang != "en"
                                                          ? lang == "pt"
                                                              ? "Contate-nos"
                                                              : "Contáctanos"
                                                          : "Contact us"
                                                  }</span>`
                                                : ""
                                        }
                                         ${
                                             ((el.make_an_offer === true ||
                                                 el.make_an_offer === 1) &&
                                                 el.offer_type !=
                                                     "for-bidding") ||
                                             ((el.make_an_offer === true ||
                                                 el.make_an_offer === 1) &&
                                                 el.offer_type != "for-bidding")
                                                 ? `<span>${
                                                       lang != "en"
                                                           ? lang == "pt"
                                                               ? "Haz uma Oferta"
                                                               : "Haz una Oferta"
                                                           : "Make an Offer"
                                                   }</span>`
                                                 : ""
                                         }

                                        ${
                                            el.offer_type == "for-rent" &&
                                            el[rent_by] != null &&
                                            el[rent_by] != "NULL" &&
                                            el[rent_by] != "" &&
                                            el[rent_by] != 0 &&
                                            (el.contact_us === false ||
                                                el.contact_us === 0) &&
                                            (el.make_an_offer === false ||
                                                el.make_an_offer === 0)
                                                ? `<span class="amount">$${number_format(
                                                      el[rent_by],
                                                      0,
                                                      ".",
                                                      ","
                                                  )}<small> / ${span}</small></span>`
                                                : ""
                                        }
                                        ${
                                            el.offer_type == "for-bidding"
                                                ? el.sale_price != null &&
                                                  el.sale_price != "NULL" &&
                                                  el.sale_price != "" &&
                                                  el.sale_price != 0
                                                    ? `<div style="display: flex;flex-direction: column;"><span><i class="far fa-calendar"></i>
                                            ${dateFormat(el.bidding_date)}
                                        </span><span class="amount">$${number_format(
                                            el.sale_price,
                                            0,
                                            ".",
                                            ","
                                        )}</span></div>`
                                                    : `<span><i class="far fa-calendar"></i>
                                            ${dateFormat(el.bidding_date)}
                                        </span>`
                                                : ""
                                        }


                                        ${
                                            el.offer_type ==
                                                "for-sale-or-rent" &&
                                            el.sale_price != null &&
                                            el.sale_price != "NULL" &&
                                            el.sale_price != "" &&
                                            el.sale_price != 0 &&
                                            (el.contact_us === false ||
                                                el.contact_us === 0) &&
                                            (el.make_an_offer === false ||
                                                el.make_an_offer === 0)
                                                ? `<div style="display: flex;flex-direction: column;"><span class="amount">$${number_format(
                                                      el.sale_price,
                                                      0,
                                                      ".",
                                                      ","
                                                  )}</span>` +
                                                  (el[rent_by] != null &&
                                                  el[rent_by] != "NULL" &&
                                                  el[rent_by] != "" &&
                                                  el[rent_by] != 0
                                                      ? `<span class="amount">$${number_format(
                                                            el[rent_by],
                                                            0,
                                                            ".",
                                                            ","
                                                        )}<small> / ${span}</small></span></div>`
                                                      : "</div>")
                                                : ""
                                        }



                                        ${
                                            ((el.contact_us === false ||
                                                el.contact_us === 0) &&
                                                (el.make_an_offer === false ||
                                                    el.make_an_offer === 0) &&
                                                el.sale_price != null &&
                                                el.sale_price != "NULL" &&
                                                el.sale_price != "" &&
                                                el.sale_price != 0) ||
                                            ((el.contact_us === false ||
                                                el.contact_us === 0) &&
                                                (el.make_an_offer === false ||
                                                    el.make_an_offer === 0) &&
                                                el[rent_by] != null &&
                                                el[rent_by] != "NULL" &&
                                                el[rent_by] != "" &&
                                                el[rent_by] != 0)
                                                ? el.currency_id == 1
                                                    ? `<span class="currency"> USD</span>`
                                                    : ""
                                                : ""
                                        }

                                        ${
                                            ((el.contact_us === false ||
                                                el.contact_us === 0) &&
                                                (el.make_an_offer === false ||
                                                    el.make_an_offer === 0) &&
                                                el.sale_price != null &&
                                                el.sale_price != "NULL" &&
                                                el.sale_price != "" &&
                                                el.sale_price != 0) ||
                                            ((el.contact_us === false ||
                                                el.contact_us === 0) &&
                                                (el.make_an_offer === false ||
                                                    el.make_an_offer === 0) &&
                                                el[rent_by] != null &&
                                                el[rent_by] != "NULL" &&
                                                el[rent_by] != "" &&
                                                el[rent_by] != 0)
                                                ? el.currency_id == 2
                                                    ? `<span class="currency"> CAD</span>`
                                                    : ""
                                                : ""
                                        }

                                        ${
                                            ((el.contact_us === false ||
                                                el.contact_us === 0) &&
                                                (el.make_an_offer === false ||
                                                    el.make_an_offer === 0) &&
                                                el.sale_price != null &&
                                                el.sale_price != "NULL" &&
                                                el.sale_price != "" &&
                                                el.sale_price != 0) ||
                                            ((el.contact_us === false ||
                                                el.contact_us === 0) &&
                                                (el.make_an_offer === false ||
                                                    el.make_an_offer === 0) &&
                                                el[rent_by] != null &&
                                                el[rent_by] != "NULL" &&
                                                el[rent_by] != "" &&
                                                el[rent_by] != 0)
                                                ? el.currency_id == 3
                                                    ? `<span class="currency"> MXN</span>`
                                                    : ""
                                                : ""
                                        }

                                    </div>
                                </div>
                            </div>
                    <div class="details">
                        <div class="tc_content">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                        <div class="text-thm flex-offers">
                            ${textTrad(el, "category")}
                        </div>
                        <div class="fp_pdate p-moment" style="font-size: 0.8rem;text-align: right;white-space: nowrap">
                            ${moment.utc(el.created_at).local().fromNow()}
                        </div>
                    </div>
                    <h4>
                        <a ${
                            Boolean(el.published) == true &&
                            Boolean(el.active) == true
                                ? `href="${link.replace(":id", el.slugOffer)}"`
                                : ""
                        }
                         style="font-weight: bold;">
                        ${el.titleOffer}
                        </a>
                    </h4>
		    <h6>${el.code}</h6>
                    <p style="text-transform: capitalize;">
                        <span class="flaticon-placeholder"></span>
                        ${el.city ? el.city + ", " : ""}
                        ${getStateAndCountry(el.state, el.country, lang)}
                    </p>
                    ${
                        el.auctioneer
                            ? `<a href="${
                                  el.url.includes("https://") !== true
                                      ? "https://" + el.url
                                      : el.url
                              }"
                        rel="noopener" target="_blank" class="mt-40">
                        <p>
                            <span class="fa fa-gavel"></span>
                            <strong>${
                                lang != "en"
                                    ? lang == "pt"
                                        ? "Leiloeiro"
                                        : "Subastador"
                                    : "Auctioneer"
                            }: </strong>
                            ${el.auctioneer}
                        </p>
                    </a>`
                            : ""
                    }
                    <ul class="prop_details mb0">
                        ${getKeyValues(el.offer_keyfield)}
                    </ul>
                </div>
                        <div class="fp_footer">
                                    <ul class="fp_meta float-left mb0 flex-offers flex-no-wrap">
                                        <li class="list-inline-item">
                                            ${
                                                el.user.role == "admin" ||
                                                el.user.role == "staff"
                                                    ? el.auctioneer !== null &&
                                                      el.auctioneer !== "" &&
                                                      el.bidding_date !==
                                                          null &&
                                                      el.bidding_date !== "" &&
                                                      el.offer_type ===
                                                          "for-bidding"
                                                        ? `<div
                                                style="width: 3rem;height: 3rem;background: #ffc200;font-size: 1.25rem;padding: 1rem;border-radius: 50%;color: #000;display: flex;justify-content: center;align-items: center;">
                                                <i class="fa fa-gavel"></i>
                                            </div>`
                                                        : el.origin ===
                                                          "scrapper"
                                                        ? `<div
                                                                style="width: 3rem;height: 3rem;background: #ffc200;font-size: 1.25rem;padding: 1rem;border-radius: 50%;color: #000;display: flex;justify-content: center;align-items: center;">
                                                                <i class="fa fa-building"></i>
                                                            </div>`
                                                        : `<img loading="${
                                                              isLoadingEdger
                                                                  ? 'eager" fetchpriority="high'
                                                                  : "lazy"
                                                          }" src="${logo}" alt="${
                                                              el.auctioneer
                                                          }" style="width: 3rem;">`
                                                    : (el.user
                                                          .business_profile ==
                                                          true ||
                                                          el.user
                                                              .business_profile ==
                                                              1) &&
                                                      el.user.factory &&
                                                      el.user.factory
                                                          .images[0] != null &&
                                                      el.user.factory.images[0]
                                                          .url != null
                                                    ? `<img loading="${
                                                          isLoadingEdger
                                                              ? 'eager" fetchpriority="high'
                                                              : "lazy"
                                                      }" src="${
                                                          el.user.factory
                                                              .images[0].url
                                                      }" alt="${
                                                          el.user.factory.name
                                                      }" style="width: 3rem;height: 3rem;border-radius: 50%;">`
                                                    : el.user.images[0] !=
                                                          null &&
                                                      el.user.images[0].url !=
                                                          null
                                                    ? `<img loading="${
                                                          isLoadingEdger
                                                              ? 'eager" fetchpriority="high'
                                                              : "lazy"
                                                      }" src="${
                                                          el.user.images[0].url
                                                      }" alt="${
                                                          el.user.name +
                                                          " " +
                                                          el.user.last_name
                                                      }"
                                                style="width: 3rem;height: 3rem;border-radius: 50%;">`
                                                    : `<div
                                                style="width: 3rem;height: 3rem;background: #ffc200;font-size: 1.25rem;padding: 1rem;border-radius: 50%;color: #000;display: flex;justify-content: center;align-items: center;">
                                                <i class="fas fa-user"></i>
                                            </div>`
                                            }
                                        </li>
                                        <li class="list-inline-item">
                                            ${
                                                el.user.role == "admin" ||
                                                el.user.role == "staff"
                                                    ? el.auctioneer !== null &&
                                                      el.auctioneer !== "" &&
                                                      el.bidding_date !==
                                                          null &&
                                                      el.bidding_date !== "" &&
                                                      el.offer_type ===
                                                          "for-bidding"
                                                        ? el.auctioneer
                                                        : el.origin ===
                                                          "scrapper"
                                                        ? el.auctioneer &&
                                                          el.auctioneer != ""
                                                            ? el.auctioneer
                                                            : new URL(
                                                                  el.url.includes(
                                                                      "https://"
                                                                  ) !== true
                                                                      ? "https://" +
                                                                        el.url
                                                                      : el.url
                                                              ).hostname
                                                                  .split(".")
                                                                  .filter(
                                                                      (_, i) =>
                                                                          i !==
                                                                          0
                                                                  )[0]
                                                                  .toUpperCase()
                                                        : "Busca Maquinaria"
                                                    : Boolean(
                                                          el.user
                                                              .business_profile
                                                      ) == true &&
                                                      el.user.factory &&
                                                      el.user.factory.name !=
                                                          null &&
                                                      el.user.factory.name != ""
                                                    ? el.user.factory.name
                                                    : el.user.name +
                                                      " " +
                                                      el.user.last_name
                                            }
                                        </li>
                                    </ul>
                                </div>
                    </div>
                        </div >
                    </div >`;
};

function itemOffersAuction(offer, linkShow, linkOffer) {
    const placeholderImage = `${location.origin}/images/header-logo.svg`;
    const imageUrl = offer.images?.[0]?.url || placeholderImage;
    const styles =
        imageUrl == placeholderImage
            ? ` style="object-fit: contain;background: #000;"`
            : "";
    const auctioneer = offer.url
        ? /* btoa( */
          (() => {
              const host = new URL(offer.url).hostname;
              const parts = host.split(".");
              return parts[0] === "www" ? parts[1] : parts[0];
          })().toUpperCase()
        : /*  ) */
          slugify(offer.auctioneer);

    const countryName =
        offer.country === "United States"
            ? lang !== "en"
                ? "EE.UU."
                : "USA"
            : offer.country === "Canada"
            ? lang !== "en"
                ? "Canadá"
                : "Canada"
            : offer.country || "";

    let stateAndCountry = getStateAndCountry(offer.state, "", lang);

    stateAndCountry =
        (stateAndCountry != "" ? stateAndCountry + ", " : "") + countryName;

    /* const offerLink = `${linkOffer}/?offer_type=${btoa(
        "for-bidding"
    )}&auctioneer=${auctioneer}&country=${btoa(offer.country)}&state=${btoa(
        offer.state
    )}`; */

    let slug =
        lang != "en"
            ? lang == "pt"
                ? ":auctioneer Leilões em :stateAndCountry"
                : "Subastas de :auctioneer en :stateAndCountry"
            : "Auctions from :auctioneer in :stateAndCountry";

    slug = slug
        .replace(":auctioneer", auctioneer)
        .replace(
            ":stateAndCountry",
            getStateAndCountry(offer.state, offer.country, lang)
        );

    const offerLink = `${linkOffer.replace("/offer", "")}/${slugify(slug)}`;

    return `
    <div class="col-lg-4 col-xl-4">
      <div class="properti_city home5">
        <div class="thumb aspect_ratio" link="${linkShow.replace(
            ":id",
            offer.slugOffer
        )}">
          <img loading="lazy" class="img-fluid w100" src="${imageUrl}" ${styles} alt="${textTrad(
        offer,
        "category"
    ).toUpperCase()} ${offer.titleOffer}" title="${textTrad(
        offer,
        "category"
    ).toUpperCase()} ${offer.titleOffer}" />
          <div class="overlay">
            <div class="details">
              <a class="left btn-header" href="${offerLink}">
                <h4>${
                    offer.auctioneer && offer.auctioneer != ""
                        ? offer.auctioneer
                        : new URL(
                              offer.url.includes("https://") !== true
                                  ? "https://" + offer.url
                                  : offer.url
                          ).hostname
                              .split(".")
                              .filter((_, i) => i !== 0)[0]
                              .toUpperCase()
                } ${firstLetterUppercase(
        moment(String(offer.bidding_date).split("T")[0]).format("MMMM DD")
    )}</h4>
              </a>
              <p style="text-transform: capitalize;">${stateAndCountry}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  `;
}

function itemSellers(seller, link, system_columns = "col-md-6 col-lg-4") {
    let Imagen =
        seller.role == "admin" || seller.role == "staff"
            ? `${location.origin}/images/header-logo.svg`
            : Boolean(seller.business_profile) == true &&
              seller.factory &&
              seller.factory.images[0] != null &&
              seller.factory.images[0].url != null
            ? seller.factory.images[0].url
            : seller.images[0] != null && seller.images[0].url != null
            ? seller.images[0].url
            : null;

    let Name =
        seller.role == "admin" || seller.role == "staff"
            ? "Busca Maquinaria"
            : Boolean(seller.business_profile) == true &&
              seller.factory &&
              seller.factory.name != null &&
              seller.factory.name != ""
            ? seller.factory.name
            : seller.name + " " + seller.last_name;

    let Slug =
        seller?.role === "admin" || seller?.role === "staff"
            ? "buscamaquinaria"
            : Boolean(seller?.business_profile)
            ? seller?.factory
                ? String(seller?.factory?.name).replace(
                      / /g,
                      "-"
                  ) /* + `-${el?.factory?.id}` */
                : seller?.user_name
            : seller?.user_name;

    let Type =
        seller.role == "admin" || seller.role == "staff"
            ? "Business"
            : Boolean(seller.business_profile) == true &&
              seller.factory &&
              seller.factory.name != null &&
              seller.factory.name != ""
            ? "Business"
            : "Seller";

    Type =
        Type == "Business"
            ? lang != "en"
                ? lang == "pt"
                    ? "Negócio"
                    : "Negocio"
                : "Business"
            : lang != "en"
            ? lang == "pt"
                ? "Vendedor"
                : "Vendedor"
            : "Seller";

    link = `${link.replace(":id", String(Slug).toLowerCase())}`;

    const getSocialMedia = (el) => {
        let arraySocial = Boolean(el?.business_profile)
            ? el?.factory && el?.factory?.socials
                ? el?.factory?.socials
                : []
            : el?.socials
            ? el?.socials
            : [];

        const Icons = {
            facebook: "fa-facebook-f",
            twitter: "fa-x-twitter",
            instagram: "fa-instagram",
        };

        let frag = "";
        arraySocial.forEach((e) => {
            frag += `<li class="list-inline-item icon-redes"><a href="${
                e.url
            }" target="_blank"><i class="fab ${Icons[e.name]}"></i></a></li>`;
        });
        return frag;
    };

    let avatar =
        Imagen != null
            ? `<img loading="lazy" class="img-whp" style="width:100%;height: 300px;object-fit: contain;" src="${Imagen}" alt="${Name}" title="${Name}">`
            : `<div
                    style="width: 100%;height: 300px;background: #000;font-size: 1.25rem;padding: 1rem;color: #000;display: flex;justify-content: center;align-items: center;border-radius: 6px;">
                    <i class="fas fa-user" style="background-color: #ffc200;padding: 2rem;font-size: 6rem;border-radius: 50%;width: 10rem;height: 10rem;display: flex;justify-content: center;align-items: center;"></i>
                </div>`;

    return `<div class="${system_columns}">
                <div class="feat_property home7 agent" link="${link}">
                    <div class="thumb" link="${link}">
                        ${avatar}
                        <div class="thmb_cntnt">
                            <ul class="tag mb0">
                                <li class="list-inline-item dn"></li>
                                ${
                                    seller.count_offers &&
                                    Number(seller.count_offers) > 0
                                        ? `<li class="list-inline-item for-offers"><b style="font-size: 14px;font-weight: 700;">${number_format(
                                              seller.count_offers,
                                              0,
                                              ".",
                                              ","
                                          )} ${
                                              seller.count_offers <= 1
                                                  ? lang !== "en"
                                                      ? "Oferta"
                                                      : "Offer"
                                                  : lang !== "en"
                                                  ? "Ofertas"
                                                  : "Offers"
                                          }</b></li>`
                                        : ""
                                }
                                ${
                                    seller.count_services &&
                                    Number(seller.count_services) > 0
                                        ? `<li class="list-inline-item for-bidding"><b style="font-size: 14px;font-weight: 700;">${number_format(
                                              seller.count_services,
                                              0,
                                              ".",
                                              ","
                                          )} ${
                                              seller.count_services <= 1
                                                  ? lang !== "en"
                                                      ? lang == "pt"
                                                          ? "Serviço"
                                                          : "Servicio"
                                                      : "Service"
                                                  : lang !== "en"
                                                  ? lang == "pt"
                                                      ? "Serviços"
                                                      : "Servicios"
                                                  : "Services"
                                          }</b></li>`
                                        : ""
                                }
                            </ul>
                        </div>
                    </div>
                    <div class="details">
                        <div class="tc_content">
                            <a href="${link}"><h4>${Name}</h4></a>
                            <p class="text-thm">${Type}</p>
                            <p style="text-transform: capitalize;">
                                <span class="flaticon-placeholder"></span>
                                ${seller.city ? seller.city + ", " : ""}
                                ${getStateAndCountry(
                                    seller.state,
                                    seller.country,
                                    lang
                                )}
                            </p>
                        </div>
                        <div class="fp_footer" style="display: inline-flex;justify-content: space-between;align-items: center;">
                            <ul class="fp_meta float-left mb0">
                                ${getSocialMedia(seller)}
                            </ul>
                            <a class="fp_pdate float-right text-thm" href="${link}">
                                ${
                                    lang !== "en"
                                        ? lang == "pt"
                                            ? "Ver Inventário"
                                            : "Ver Inventario"
                                        : "View Inventory"
                                }
                                <i class="fa fa-angle-right"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>`;
}

document.addEventListener("DOMContentLoaded", function () {
    let p_moment = document.querySelectorAll(".p-moment");
    if (p_moment.length > 0) {
        p_moment.forEach(function (element) {
            let value = element.innerHTML
                .trim()
                .replace("T", " ")
                .substr(0, 19);
            element.innerHTML = moment.utc(value).local().fromNow();
        });
    }

    $(".lang_switch,.currency_switch").on("change", function () {
        let preloader = document.querySelector(".preloader");
        preloader.style.display = "flex";
    });

    $('[name="phone"]').on("keydown", function (event) {
        // Obtener el código de la tecla presionada
        let keyCode = event.keyCode || event.which;

        // Permitir números (teclado alfanumérico y numérico), espacio, y teclas de navegación (flechas y backspace)
        if (
            (keyCode >= 48 && keyCode <= 57) ||
            (keyCode >= 96 && keyCode <= 105) ||
            keyCode === 32 ||
            (keyCode >= 37 && keyCode <= 40) ||
            keyCode === 8
        ) {
            // Permitir la acción por defecto (escribir o borrar)
            return true;
        } else {
            // Prevenir la acción por defecto (no escribir o borrar)
            event.preventDefault();
            return false;
        }
    });

    document.addEventListener("click", function (e) {
        if (
            e.target.matches(".feat_property") ||
            e.target.matches(".feat_property *") ||
            e.target.matches(".thumb") ||
            e.target.matches(".thumb *")
        ) {
            let link =
                e.target.parentElement.getAttribute("link") ||
                e.target.parentElement.parentElement.getAttribute("link") ||
                e.target.parentElement.parentElement.parentElement.getAttribute(
                    "link"
                ) ||
                null;
            if (link != null) window.open(link, "_blank");
        }

        if (
            e.target.matches("[data-dropdown]") ||
            e.target.matches("[data-dropdown] *") ||
            e.target.matches("[data-dropdown] .btn") ||
            e.target.matches("[data-dropdown] .btn *")
        ) {
            let dropdown =
                e.target.closest("[data-dropdown]") ||
                e.target.parentElement.closest("[data-dropdown]");
            dropdown.querySelector(".dd_content2").classList.toggle("d-block");
        }
    });

    CookieConsent.run({
        guiOptions: {
            consentModal: {
                layout: "cloud",
                position: "bottom center",
                flipButtons: false,
                equalWeightButtons: true,
            },
        },
        categories: {
            necessary: {
                enabled: true,
                readOnly: true,
            },
            analytics: {},
        },
        language: {
            default: lang,
            translations: {
                en: {
                    consentModal: {
                        title: "We use cookies",
                        description:
                            "We use cookies to enhance your experience and analyze traffic on buscamaquinaria.com.",
                        acceptAllBtn: "Accept all",
                        acceptNecessaryBtn: "Reject non-essential",
                        showPreferencesBtn: "Manage cookie settings",
                    },
                    preferencesModal: {
                        title: "Cookie preferences",
                        acceptAllBtn: "Accept all",
                        acceptNecessaryBtn: "Reject non-essential",
                        savePreferencesBtn: "Save selection",
                        closeIconLabel: "Close",
                        sections: [
                            {
                                title: "Did someone say cookies?",
                                description:
                                    "Yes, the digital kind – to make this site work better for you.",
                            },
                            {
                                title: "Essential cookies",
                                description:
                                    "These cookies are required for buscamaquinaria.com to function properly and cannot be disabled.",
                                linkedCategory: "necessary",
                            },
                            {
                                title: "Analytics cookies",
                                description:
                                    "These cookies help us understand how users interact with buscamaquinaria.com so we can improve the site. All data is anonymized.",
                                linkedCategory: "analytics",
                            },
                            {
                                title: "Need more info?",
                                description:
                                    'For questions about how we use cookies, please <a href="https://wa.me/528135552662?text=I%20want%20to%20know%20more%20about%20cookies%20on%20buscamaquinaria.com" target="_blank">contact us on WhatsApp</a>.',
                            },
                        ],
                    },
                },
                ESmx: {
                    consentModal: {
                        title: "Usamos cookies",
                        description:
                            "En buscamaquinaria.com usamos cookies para mejorar tu experiencia y analizar el tráfico del sitio.",
                        acceptAllBtn: "Aceptar todas",
                        acceptNecessaryBtn: "Rechazar no esenciales",
                        showPreferencesBtn: "Configurar cookies",
                    },
                    preferencesModal: {
                        title: "Preferencias de cookies",
                        acceptAllBtn: "Aceptar todas",
                        acceptNecessaryBtn: "Rechazar no esenciales",
                        savePreferencesBtn: "Guardar selección",
                        closeIconLabel: "Cerrar",
                        sections: [
                            {
                                title: "¿Alguien dijo cookies?",
                                description:
                                    "Sí, las digitales. Nos ayudan a ofrecerte una mejor experiencia.",
                            },
                            {
                                title: "Cookies esenciales",
                                description:
                                    "Estas cookies son necesarias para el correcto funcionamiento de buscamaquinaria.com y no se pueden desactivar.",
                                linkedCategory: "necessary",
                            },
                            {
                                title: "Cookies de análisis",
                                description:
                                    "Estas cookies nos ayudan a entender cómo usas buscamaquinaria.com y mejorar el sitio. Los datos son anónimos.",
                                linkedCategory: "analytics",
                            },
                            {
                                title: "¿Tienes dudas?",
                                description:
                                    'Si tienes preguntas sobre el uso de cookies, por favor <a href="https://wa.me/528135552662?text=Hola,%20quisiera%20m%C3%A1s%20informaci%C3%B3n%20sobre%20cookies%20en%20buscamaquinaria.com">contáctanos por WhatsApp</a>.',
                            },
                        ],
                    },
                },
                pt: {
                    consentModal: {
                        title: "Utilizamos cookies",
                        description:
                            "Na buscamaquinaria.com usamos cookies para melhorar sua experiência e analisar o tráfego do site.",
                        acceptAllBtn: "Aceitar todas",
                        acceptNecessaryBtn: "Rejeitar não essenciais",
                        showPreferencesBtn: "Configurar cookies",
                    },
                    preferencesModal: {
                        title: "Preferências de cookies",
                        acceptAllBtn: "Aceitar todas",
                        acceptNecessaryBtn: "Rejeitar não essenciais",
                        savePreferencesBtn: "Salvar seleção",
                        closeIconLabel: "Fechar",
                        sections: [
                            {
                                title: "Alguém falou em cookies?",
                                description:
                                    "Sim, cookies digitais que ajudam a melhorar o site.",
                            },
                            {
                                title: "Cookies essenciais",
                                description:
                                    "Esses cookies são necessários para o funcionamento adequado do buscamaquinaria.com e não podem ser desativados.",
                                linkedCategory: "necessary",
                            },
                            {
                                title: "Cookies de análise",
                                description:
                                    "Esses cookies nos ajudam a entender como você usa buscamaquinaria.com. Todos os dados são anônimos.",
                                linkedCategory: "analytics",
                            },
                            {
                                title: "Quer saber mais?",
                                description:
                                    'Se tiver dúvidas sobre como usamos cookies, por favor <a href="https://wa.me/528135552662?text=Ol%C3%A1,%20gostaria%20de%20mais%20informa%C3%A7%C3%B5es%20sobre%20cookies%20em%20buscamaquinaria.com">contate-nos pelo WhatsApp</a>.',
                            },
                        ],
                    },
                },
            },
        },
    });
});

const renderPagination = (
    length,
    allOffers,
    currentPage,
    withCardLastOffer = true
) => {
    const botonesPaginacion = document.createElement("div");
    if (length > parseInt(allOffers.per_page) - 1) {
        const totalPages = allOffers.last_page;
        let maxPagesToShow = 10;
        const edgePagesToShow = 2;

        let startPage = Math.max(
            1,
            currentPage - Math.floor(maxPagesToShow / 2)
        );
        let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

        // Ajusta el inicio si el rango es insuficiente
        startPage = Math.max(1, endPage - maxPagesToShow + 1);
        if (Math.min(edgePagesToShow, totalPages) == 1) {
            return "";
        }
        // Agrega las dos primeras páginas
        for (let i = 1; i <= Math.min(edgePagesToShow, totalPages); i++) {
            let currentUrl = new URLSearchParams(window.location.search);
            currentUrl.set("page", i);
            const boton = document.createElement("li");
            boton.classList.add("page-item");
            boton.innerHTML = `<a href="${window.location.pathname}?${currentUrl}" class="page-link nuevos">
                                 ${i}
                               </a>`;
            if (i == currentPage) {
                boton.classList.add("active");
            }
            botonesPaginacion.appendChild(boton);
        }

        // Agrega el botón "..." si hay más páginas antes
        if (startPage > edgePagesToShow) {
            const botonEllipsis = document.createElement("li");
            botonEllipsis.classList.add("page-item", "disabled");
            botonEllipsis.setAttribute("aria-disabled", true);
            botonEllipsis.innerHTML = `<span class="page-link nuevos">...</span>`;
            botonesPaginacion.appendChild(botonEllipsis);
            maxPagesToShow = 8;

            startPage = Math.max(1, endPage - maxPagesToShow);
            endPage = Math.min(totalPages, startPage + maxPagesToShow - 2);
        } else {
            startPage = Math.max(1, endPage - maxPagesToShow + 1);
            endPage = Math.min(totalPages, startPage + maxPagesToShow - 2);
        }

        if (endPage < totalPages - edgePagesToShow) {
            startPage += 1;
            endPage += 1;
        }

        if (endPage > totalPages - edgePagesToShow) {
            endPage = Math.max(totalPages, endPage);
        }

        // Agrega las páginas en el rango actual
        for (let i = startPage; i <= endPage; i++) {
            if (i == 1 || i == 2) continue;
            let currentUrl = new URLSearchParams(window.location.search);
            currentUrl.set("page", i);
            const boton = document.createElement("li");
            boton.classList.add("page-item");
            boton.innerHTML = `<a href="${window.location.pathname}?${currentUrl}" class="page-link nuevos">
                                 ${i}
                               </a>`;
            if (i == currentPage) {
                boton.classList.add("active");
            }
            botonesPaginacion.appendChild(boton);
        }

        // Agrega el botón "..." si hay más páginas después
        if (endPage < totalPages - edgePagesToShow) {
            const botonEllipsis = document.createElement("li");
            botonEllipsis.classList.add("page-item", "disabled");
            botonEllipsis.innerHTML = `<span class="page-link nuevos">...</span>`;
            botonEllipsis.setAttribute("aria-disabled", true);
            botonesPaginacion.appendChild(botonEllipsis);
        }

        // Agrega las dos últimas páginas
        for (
            let i = Math.max(totalPages - edgePagesToShow + 1, endPage + 1);
            i <= totalPages;
            i++
        ) {
            if (i == 1 || i == 2) continue;
            let currentUrl = new URLSearchParams(window.location.search);
            currentUrl.set("page", i);
            const boton = document.createElement("li");
            boton.classList.add("page-item");
            boton.innerHTML = `<a href="${window.location.pathname}?${currentUrl}" class="page-link nuevos">
                                 ${i}
                               </a>`;
            if (i == currentPage) {
                boton.classList.add("active");
            }
            botonesPaginacion.appendChild(boton);
        }
    }
    let frag =
        botonesPaginacion.innerHTML != ""
            ? `
                <div class="col-lg-12 mt20 ">
                    <div class="row justify-content-center ">
                        <nav>
                            <div class="mbp_pagination">
                                <ul class="page_navigation">
                                    ${botonesPaginacion.innerHTML}
                                </ul>
                            </div>
                        </nav>
                    </div>
                </div>
            `
            : "";
    return frag;
};

const ImagenSearch = (
    ob,
    alt,
    className = ["img-fluid"],
    props = {
        style: {
            width: "50px",
            height: "40px",
            "border-radius": "5px",
            background: "#e6e6e6",
            "margin-right": "0.5rem",
            "object-fit": "contain",
        },
    }
) => {
    let img = "";
    if (ob != null && ob != "") {
        src =
            ob.images != null && ob.images.length > 0
                ? ob.images[0].url != null
                    ? ob.images[0].url
                    : ""
                : "";

        img = `<img loading="lazy" src="${src}" alt="${alt}" class="${className.join(
            " "
        )}" ${Object.keys(props)
            .map(
                (key) =>
                    `${key}="${Object.keys(props[key])
                        .map((k) => `${k}:${props[key][k]}`)
                        .join(";")}"`
            )
            .join(" ")}/>`;
    }
    return src != "" ? img : "";
};

const validateEmail = (email) => {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
};

function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min) + min);
}

document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener("click", function (e) {
        e.preventDefault();

        const targetId = this.getAttribute("href");
        if (!targetId || targetId === "#") {
            return;
        }
        const targetElement = document.querySelector(targetId);

        if (targetElement != null) {
            // Calcular la posición del desplazamiento
            const headerOffset = 120; // Ajusta esto según la altura de tu encabezado
            const elementPosition = targetElement.getBoundingClientRect().top;
            const offsetPosition =
                elementPosition + window.scrollY - headerOffset;
            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth", // Desplazamiento suave
            });
        }
    });
});
